var RS = Object.defineProperty;
var NS = (e, a, t) => a in e ? RS(e, a, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[a] = t;
var Aa = (e, a, t) => NS(e, typeof a != "symbol" ? a + "" : a, t);
import { ref as b, watch as Qe, computed as x, getCurrentInstance as hi, inject as On, onMounted as Kt, onBeforeUnmount as Mt, shallowReactive as BS, toRaw as FS, defineComponent as rt, openBlock as u, createElementBlock as d, normalizeStyle as Vt, normalizeClass as Re, Fragment as he, createTextVNode as $t, toDisplayString as f, createCommentVNode as T, renderList as We, createVNode as ot, createElementVNode as i, createBlock as nt, unref as r, Teleport as Hs, Transition as us, withCtx as yt, withModifiers as ft, withKeys as ya, nextTick as Jt, shallowRef as Dn, renderSlot as wa, withDirectives as dt, vModelText as St, provide as yr, mergeProps as Xc, resolveComponent as US, vModelCheckbox as Ja, vModelSelect as Xa, createStaticVNode as vk, resolveDynamicComponent as oh, getCurrentScope as HS, onScopeDispose as hk, reactive as KS, watchEffect as VS, createSlots as qS, isRef as xg } from "vue";
import { Popover as jS, PopoverButton as WS, PopoverPanel as YS, Menu as GS, MenuButton as XS, MenuItems as JS, MenuItem as ZS } from "@headlessui/vue";
import { X as QS, User as eT, SlidersHorizontal as tT, Bell as aT, ShieldCheck as nT, Sparkles as $g } from "lucide-vue-next";
function Sg(e) {
  return !!e && e.enabled && e.state === "ok";
}
const fr = {
  "toolbar.new_folder": "New folder",
  "toolbar.upload": "Upload",
  "toolbar.search": "Search",
  "toolbar.search.placeholder": "Search by name or tag:…",
  "toolbar.view.list": "List",
  "toolbar.view.grid": "Grid",
  "toolbar.refresh": "Refresh",
  "toolbar.go_up": "Up one level",
  "ctx.open": "Open",
  "ctx.preview": "Preview",
  "ctx.download": "Download",
  "ctx.archive_create": "Create archive…",
  "ctx.archive_extract": "Extract archive…",
  "ctx.rename": "Rename",
  "ctx.delete": "Delete",
  "ctx.delete_perm": "Delete permanently",
  "ctx.restore": "Restore",
  "ctx.share": "Share",
  "ctx.move": "Move",
  "ctx.copy": "Copy",
  "ctx.cut": "Cut",
  "ctx.show_hidden": "Show hidden files",
  "ctx.hide_hidden": "Hide hidden files",
  "ctx.keep_local": "Keep on this computer",
  "ctx.keep_online": "Keep online only",
  "ctx.keep_reveal": "Open local folder",
  "ctx.keep_inherited": "Kept on this computer with its parent",
  "keep.started": "Will be kept on this computer — sync started",
  "keep.failed": "Could not keep on this computer",
  "keep.badge_kept": "On this computer",
  "keep.badge_syncing": "Syncing…",
  "keep.badge_cloud": "Online only",
  "keep.badge_partial": "Contains items kept on this computer",
  "keep.strip_transfer": "Syncing {name} — {done}/{total} ({pct}%)",
  "keep.strip_inventory": "Syncing {name} — scanning the server…",
  "keep.strip_settling": "Syncing {name} — settling…",
  "ctx.paste": "Paste",
  "ctx.info": "Info",
  "ctx.duplicate": "Duplicate",
  "ctx.new_file": "New file",
  "modal.delete.title": "Delete?",
  "modal.delete.message": "{count} items will be moved to trash.",
  "modal.delete.message_one": "{count} item will be moved to trash.",
  "modal.delete.confirm": "Move to Trash",
  "modal.delete.working": "Moving to Trash…",
  "modal.delete.cancel": "Cancel",
  "modal.delete.permanent_title": "Delete permanently?",
  "modal.delete.permanent_message": "{count} items will be deleted for good. This cannot be undone.",
  "modal.delete.permanent_message_one": "{count} item will be deleted for good. This cannot be undone.",
  "modal.delete.permanent_confirm": "Delete permanently",
  "modal.delete.permanent_working": "Deleting…",
  "modal.rename.title": "Rename",
  "modal.rename.save": "Save",
  "modal.rename.saving": "Renaming…",
  "modal.rename.cancel": "Cancel",
  "modal.newfolder.title": "New folder",
  "modal.newfolder.placeholder": "Folder name",
  "modal.newfolder.create": "Create",
  "modal.newfolder.creating": "Creating…",
  "modal.newfolder.cancel": "Cancel",
  "modal.share.title": "Share link",
  "archive.create_title": "Create archive",
  "archive.extract_title": "Extract archive",
  "archive.create_count": "{count} selected items",
  "archive.create_count_one": "{count} selected item",
  "archive.filename": "Archive name",
  "archive.format": "Format",
  "archive.password_optional": "Password (optional)",
  "archive.password_confirm": "Confirm password",
  "archive.password_mismatch": "Passwords do not match.",
  "archive.encrypt_names": "Encrypt file names",
  "archive.compression": "Compression",
  "archive.solid": "Create solid archive",
  "archive.dictionary_size": "Dictionary size",
  "archive.dictionary_size_value": "{n} MiB",
  "archive.dictionary_hint": "Larger dictionaries can improve compression but use more memory while creating and extracting.",
  "archive.destination_folder": "Extract to folder",
  "archive.create": "Create",
  "archive.creating": "Creating…",
  "archive.extract": "Extract",
  "archive.extract_here": "Extract here",
  "archive.extract_to_folder": "Extract to folder",
  "archive.extracting": "Extracting…",
  "archive.cancel": "Cancel",
  "archive.invalid_name": "Enter a file name without slashes.",
  "archive.invalid_extension": "Archive name must use one of the available format extensions.",
  "archive.invalid_folder": "Enter a folder name without slashes.",
  "archive.password_required": "This archive requires a password.",
  "archive.password_title": "Archive password",
  "archive.continue": "Continue",
  "archive.opening": "Opening…",
  "archive.bad_password": "The archive password is incorrect.",
  "archive.target_exists": "An item with that name already exists. Choose another name or remove it first.",
  "archive.password_charset": "A ZIP password can use only ASCII characters: unaccented letters, digits and ordinary punctuation. Choose 7z to use any characters.",
  "archive.error_unsupported": "This archive cannot be extracted: this server cannot read its format, or it holds something filex does not extract (a link, a special file, or a file whose size it does not state).",
  "archive.error_limit": "This archive is larger than the server allows to extract.",
  "archive.error_unavailable": "This server cannot open this kind of archive right now.",
  "archive.created": "Archive created",
  "archive.queued": "Archive creation is running in the background",
  "archive.extracted": "Extracted {count} files",
  "archive.extracted_one": "Extracted {count} file",
  "archive.extraction_queued": "Archive extraction is running in the background",
  "archive.preparing_extract": "Reading {name}… the whole archive is read before it can be extracted.",
  "archive.already_preparing": "Still reading {name} — it is extracted once that is done",
  "archive.extraction_completed": "Extraction completed",
  "archive.extraction_cancelled": "Extraction cancelled after {count} files",
  "archive.extraction_cancelled_one": "Extraction cancelled after {count} file",
  "modal.share.pin": "PIN protected",
  "modal.share.expires": "Expires at",
  "modal.share.max_downloads": "Download limit",
  "modal.share.create": "Share",
  "modal.share.cancel": "Cancel",
  "modal.share.close": "Close",
  "modal.share.limit_applied": "(server limit applied)",
  "modal.share.copy": "Copy",
  "modal.share.url_copied": "Link copied",
  "modal.share.pin_copied": "PIN copied",
  "modal.share.cli_copied": "CLI command copied",
  "upload.progress": "Uploading",
  "upload.done": "Done",
  "upload.error": "Error",
  "upload.failed": "Could not upload “{name}”",
  "upload.aborted": "Aborted",
  "upload.cancel": "Cancel",
  "upload.resuming": "Resuming “{name}” from {percent}%",
  "upload.saving": "Saving to the storage…",
  "empty.folder": "This folder is empty",
  "empty.search": "No results",
  loading: "Loading…",
  "notFound.title": "Folder not found",
  "notFound.desc": "This folder does not exist, was moved, or you do not have access to it.",
  "notFound.goRoot": "Go to root folder",
  "col.name": "Name",
  "col.size": "Size",
  "col.modified": "Modified",
  "col.type": "Type",
  "unit.bytes": "B",
  "unit.kb": "KB",
  "unit.mb": "MB",
  "unit.gb": "GB",
  "unit.tb": "TB",
  "unit.pb": "PB",
  "breadcrumb.root": "Root",
  "breadcrumb.copy_path": "Copy path",
  "breadcrumb.go_to_path": "Go to path",
  "breadcrumb.path_placeholder": "fileman/foo/bar",
  "ops.copy": "Copying",
  "ops.move": "Moving",
  "ops.delete": "Deleting",
  "ops.queued": "queued",
  "ops.done": "done",
  "ops.error": "error",
  "node.trash": "Trash",
  /* gorunum:v1 — the singular kind, printed under a folder's name on a card
   * and beside it in the list. The plural section heading is a different
   * string on purpose. */
  "node.folder": "Folder",
  // ——— Rich viewer chrome ———
  "viewer.open_in_new_tab": "Open in new tab",
  "viewer.loading": "Loading…",
  "viewer.failed_to_load": "Failed to load file",
  /* ⚠ Said to a PERSON: it used to tell them to "install the peer dependency". */
  "viewer.peer_not_installed": "This kind of file cannot be shown here. Download it to open it on your device.",
  "viewer.format_unsupported_3d": "The preview shows 3D models in .glb, .gltf and .usdz only. Download the file to open it in a 3D program.",
  "viewer.zoom_in": "Zoom in",
  "viewer.zoom_out": "Zoom out",
  "viewer.fit_width": "Fit width",
  "viewer.next_page": "Next page",
  "viewer.prev_page": "Previous page",
  "viewer.page_n_of_m": "Page {n} of {m}",
  "viewer.tags": "Tags",
  "viewer.layers": "Layers",
  "viewer.toc": "Contents",
  "viewer.font_smaller": "Smaller text",
  "viewer.font_larger": "Larger text",
  "viewer.search": "Search",
  "viewer.download": "Download",
  "viewer.saving": "Saving…",
  "viewer.save": "Save (Ctrl+S)",
  "viewer.saved": "Saved",
  "viewer.save_error": "Error",
  "viewer.editor_loading": "Loading editor…",
  "viewer.no_preview": "No preview for this file type yet.",
  "viewer.edit": "Edit",
  "viewer.close": "Close",
  "presence.expand": "Show names",
  "presence.collapse": "Collapse",
  "viewer.save_annotations": "Save annotations",
  "viewer.annotations_on": "Annotations: on",
  "viewer.annotations_off": "Annotations: off",
  "viewer.read_only": "Read only",
  "viewer.csv_first_row_header": "First row as header",
  "viewer.csv_filter": "Filter rows…",
  "viewer.epub_prev": "Previous",
  "viewer.epub_next": "Next",
  /* ⚠ The old sentence named an ENVIRONMENT VARIABLE to every reader
     ("operator must wire FILEX_DRAWIO_URL"). A person who only wanted to look
     at a diagram is told what they can do; `_admin` — someone who can fix it —
     is told where. */
  "viewer.drawio.disabled": "Diagrams cannot be opened here: this server has no draw.io. Download the file to open it elsewhere.",
  "viewer.drawio.disabled_admin": "draw.io is not set up on this server. Set it up in the admin panel under External services.",
  "viewer.drawio.load_failed": "This diagram could not be read. Download it to open it elsewhere.",
  "viewer.drawio.save_failed": "The diagram could not be saved. Your changes are still in the editor — try again.",
  "viewer.archive.entries": "{n} files",
  "viewer.archive.entries_one": "{n} file",
  "viewer.archive.empty": "Archive is empty.",
  "viewer.archive.error": "Could not read archive contents.",
  "viewer.archive.unsupported": "This kind of archive cannot be listed here. Download it to see what is inside.",
  "viewer.archive.too_large": "This archive is too large to list here. Download it to see what is inside.",
  "viewer.archive.open": "Open archive",
  "viewer.archive.root": "Archive",
  "viewer.archive.location": "Archive location",
  "viewer.archive.reading": "Still reading… the whole archive is read before its contents can be listed, which takes a while for a large one.",
  "viewer.name": "Name",
  "viewer.size": "Size",
  // ——— cila:a — sorting / date groups / density ———
  "col.sort": "Sort",
  "group.today": "Today",
  "group.yesterday": "Yesterday",
  "group.this_week": "This week",
  "group.this_month": "This month",
  "group.no_date": "No date",
  "toolbar.density.compact": "Compact view",
  "toolbar.density.comfortable": "Comfortable view",
  // ——— cila:c — command palette + shortcuts help + breadcrumb ———
  "palette.placeholder": "Search files, folders or commands…",
  "palette.files": "Files",
  "palette.commands": "Commands",
  "palette.goto": "Go to path",
  "palette.empty": "No results",
  "palette.hint": "↑↓ navigate · Enter select · Esc close",
  "cmd.view_toggle": "Toggle view (list ⇄ grid)",
  "cmd.trash": "Open trash",
  "shortcuts.title": "Keyboard shortcuts",
  "shortcuts.group.nav": "Navigation",
  "shortcuts.group.selection": "Selection",
  "shortcuts.group.file": "File operations",
  "shortcuts.palette": "Command palette",
  "shortcuts.search": "Focus search",
  "shortcuts.go_up": "Go up one level",
  "shortcuts.open": "Open selected item",
  "shortcuts.close": "Close / cancel",
  "shortcuts.toggle_hidden": "Show/hide hidden files",
  "shortcuts.help": "This help dialog",
  "shortcuts.select_all": "Select all",
  "shortcuts.star": "Star / unstar",
  "shortcuts.rename": "Rename",
  "shortcuts.delete": "Delete",
  "shortcuts.cut": "Cut",
  "shortcuts.copy": "Copy",
  "shortcuts.paste": "Paste",
  "breadcrumb.more": "Folders in between",
  // ——— State screens + undo snackbar + connection badge (cila:b) ———
  "empty.hint": "Drag and drop files here",
  "empty.upload": "Upload files",
  "empty.search.title": "No files match your search",
  "empty.search.hint": "Try a different search term",
  "empty.trash.title": "Trash is empty",
  "error.title": "Could not load this folder",
  "error.retry": "Try again",
  "toast.undo": "Undo",
  "toast.undone": "Undone",
  "toast.undoing": "Undoing…",
  "toast.undo_queued": "The undo is queued — the operations panel shows when it is done",
  "toast.undo_partial": "Undone in part: {done} of {total}",
  "toast.undo_failed": "Could not undo",
  "toast.renamed": "Renamed",
  "toast.rename_queued": "Renaming to “{name}”…",
  "toast.moved": "Moved",
  "toast.trashed": "Moved to trash",
  /* i18n:hardcoded — toast copy that used to be Turkish string literals in
     FileExplorer.vue, unreachable by any locale. */
  "toast.failed": "Operation failed",
  /* ── errorWords (lib/errorWords): how a failure is SAID. ⚠ No status code,
     no JSON, no environment variable ever reaches these; an administrator
     sees the raw words on a second line, nobody else does. ── */
  "err.status.400": "Bad request",
  "err.status.401": "Sign-in required",
  "err.status.403": "You are not allowed to do this",
  "err.status.404": "Not found",
  "err.status.409": "Already exists / conflict",
  "err.status.413": "File too large",
  "err.status.415": "Unsupported file type",
  "err.status.422": "Invalid data",
  "err.status.429": "Too many requests",
  "err.status.500": "Server error",
  "err.status.501": "Not supported",
  "err.status.502": "A connected service reported an error",
  "err.status.503": "Service unavailable",
  "err.status.504": "A connected service took too long to answer",
  "err.status.other": "The server refused this request.",
  "err.upload_stalled": "The upload stopped making progress. Try again — it continues where it stopped.",
  "err.network": "The server could not be reached. Check your connection and try again.",
  "err.read_only": "This storage is read-only",
  "err.no_secret_key": "This server has no encryption key set, so it cannot issue an access key. Ask an administrator to configure one.",
  "err.quota": "Your storage quota is full.",
  "err.bad_kind": "The server does not queue that kind of job this way.",
  "err.not_cancellable": "This job cannot be stopped once it has started — it finishes on its own.",
  "err.finished": "This job has already finished.",
  "err.too_many": "At most {max} items can be restored at once. Restore them in smaller groups.",
  "err.name_taken": "Something with that name is already there. Rename what is there, then try again.",
  "err.not_in_trash": "It is no longer in the trash — it was restored or removed meanwhile, and nothing was deleted.",
  "err.save_failed": "Your changes could not be saved.",
  "err.load_failed": "This file could not be loaded.",
  "err.viewer_failed": "The viewer for this file could not be started. Download the file to open it.",
  "err.detail": "Details",
  "opc.err.timeout": "The app took too long and was stopped.",
  "opc.err.out_of_memory": "The app ran out of memory on this file.",
  "opc.err.crashed": "The app stopped unexpectedly.",
  "opc.err.app_removed": "The app was removed before this job could run.",
  "opc.err.action_removed": "This action no longer exists — the app was updated.",
  "opc.err.engine_missing": "This needs a program the server does not have ({engine}). Ask your administrator.",
  "opc.err.engine_missing_admin": "This needs {engine}, which is not installed on the server that runs filex. Install it there and try again.",
  "toast.copied": "Copied",
  "toast.deleted": "Deleted",
  "toast.cut": "Cut",
  "toast.cut_ready": "Cut — ready to paste",
  "toast.copy_ready": "Copied — ready to paste",
  "toast.same_folder_cut": "Cannot cut into the same folder",
  "toast.restored": "{n} items restored",
  "toast.restoring": "Restoring {n} items…",
  "toast.restoring_one": "Restoring {n} item…",
  "toast.restore_partial": "{n} items restored; {failed} could not be restored: {reason}",
  "toast.restore_partial_one": "{n} item restored; {failed} could not be restored: {reason}",
  "toast.restored_one": "{n} item restored",
  "toast.restore_taken": "{n} items were not restored: something already has their names. Rename what is there, then restore again.",
  "toast.restore_taken_one": "“{name}” was not restored: something already has that name. Rename what is there, then restore again.",
  "toast.delete_queued": "Delete queued",
  "toast.trash_retention": "Items in the trash are removed automatically once the retention window ends. Permanent deletion is done from the admin panel.",
  "toast.purging": "Deleting {n} items permanently…",
  "toast.purging_one": "Deleting {n} item permanently…",
  "toast.purging_partly": "Deleting {n} items permanently; {failed} could not be deleted: {reason}",
  "toast.purging_partly_one": "Deleting {n} item permanently; {failed} could not be deleted: {reason}",
  "toast.purged": "{n} items deleted permanently",
  "toast.purged_one": "{n} item deleted permanently",
  "toast.purged_partly": "{n} items deleted permanently; {failed} could not be deleted: {reason}",
  "toast.purged_partly_one": "{n} item deleted permanently; {failed} could not be deleted: {reason}",
  /* The Trash row a permanent delete is on its way for (the admin Trash
     page's words: one sentence, both catalogues — lesson #447). */
  "trash.purging": "Deleting permanently…",
  "trash.row_busy": "Something is already being done to this item",
  "dropzone.hint": "Drop files here",
  "modal.newfolder.invalid": "Invalid character",
  "names.reserved": "“{name}” is reserved for filex’s own use. Choose another name.",
  /* ⚠ A missing or broken document server is said in words, never as the
     HTTP layer (it used to read `Config fetch 503: {"error":"onlyoffice not
     configured"}`). `_admin` is what someone who can fix it reads — where to
     fix it; everybody else reads how to get the file anyway. */
  "viewer.office_unconfigured": "Office documents cannot be opened here: this server has no ONLYOFFICE document server. Download the file to open it on your computer.",
  "viewer.office_unconfigured_admin": "ONLYOFFICE is not set up on this server, so office documents cannot be opened here. Set it up in the admin panel under External services.",
  "viewer.office_unreachable": "The document server is not answering right now. Try again later, or download the file.",
  "viewer.office_unreachable_admin": "The ONLYOFFICE document server is not answering. Check it in the admin panel under External services.",
  "viewer.office_failed": "This document could not be opened in ONLYOFFICE. Download it to open it on your computer.",
  "viewer.office_forbidden": "You do not have permission to open this document in ONLYOFFICE.",
  /* The explorer's Open on a document the document server would open, when
     there is none — shown to an administrator only (everyone else is not
     offered the entry at all; lib/serviceGate). */
  "ctx.needs_onlyoffice": "ONLYOFFICE is not set up — set it up in the admin panel under External services.",
  "ctx.needs_drawio": "draw.io is not set up — set it up in the admin panel under External services.",
  "viewer.pdf_inline_failed": "Your browser could not display this PDF inline.",
  "viewer.too_large": "File is too large (>1 MB).",
  "viewer.csv_rows": "{n} rows",
  "viewer.csv_rows_one": "{n} row",
  "presence.others": "{n} people",
  "presence.others_one": "{n} person",
  "conn.offline": "No live connection — changes may be delayed",
  "conn.tooltip": "Live connection to the server is unavailable; the list refreshes periodically. This notice disappears once the connection is back.",
  /* === bul:s3 === */
  "palette.everywhere": "Everywhere",
  "palette.searching": "Searching…",
  "palette.everywhere_failed": "The search could not be done. Try again.",
  "palette.saved": "Saved searches",
  "palette.save": "Save search",
  "palette.saved.delete": "Delete saved search",
  "search.in_content": "In content",
  "search.truncated": "More results than shown — narrow your search",
  /* Catalog coverage (docs/LAZY-CATALOGUE.md, lib/catalogCoverage). One
     sentence per reason; the banner sits over a listing and over search
     results, and says what is left out and why. */
  "coverage.first_scan": "This storage’s first sync has not finished. Until it does, search, folder sizes and usage leave part of it out.",
  "coverage.lazy_filling": "filex is still cataloging this storage ({pct}% of the folders found so far). Until it finishes, search, folder sizes and usage leave part of it out.",
  "coverage.lazy_on_open": "Only the folders people open on this storage are cataloged. Search, folder sizes and usage cover those folders only.",
  "coverage.search_some": "Not everything on these storages is cataloged yet: {names}. This search may miss files there.",
  "coverage.catalog_all": "Catalog everything",
  "coverage.catalog_started": "Sync started — the whole storage is being cataloged.",
  "coverage.catalog_running": "Cataloging…",
  "coverage.cataloging": "Cataloging {storage}… this runs in the background, and this page says when it is done.",
  "coverage.catalog_done": "{storage} is cataloged in full",
  "coverage.catalog_failed": "Cataloging {storage} failed. The admin panel shows why, under the storage’s sync runs.",
  "coverage.catalog_stopped": "Cataloging {storage} was stopped before it finished",
  "coverage.catalog_joined": "A scan of {storage} was already running — this page says when it is done.",
  "coverage.catalog_gone": "{storage} was removed while it was being cataloged",
  "coverage.catalog_unfollowed": "Cataloging {storage} goes on in the background; the admin panel shows how it ends, under the storage’s sync runs",
  "size.at_least": "≥ {size}",
  "size.partial_hint": "Part of this folder is not cataloged yet, so its size is at least this.",
  "size.unknown_hint": "This folder is not cataloged yet, so its size is not known.",
  /* === bag:b4 === */
  "toolbar.more": "More actions",
  "toolbar.search.close": "Close search",
  "sheet.menu": "Actions",
  "sheet.close": "Close",
  /* === koru:k1 === */
  "toolbar.inspector": "Details",
  "ctx.details": "Details",
  /* yildiz:s1 — starring is an action, so it has a verb in the menu. */
  "ctx.star": "Star",
  "ctx.unstar": "Unstar",
  "star.failed": "Could not change the star",
  "shortcuts.inspector": "Toggle details panel",
  "inspector.title": "Details",
  "inspector.copy_name": "Copy name",
  "inspector.items": "{n} items",
  "inspector.items_one": "{n} item",
  "inspector.type": "Type",
  "inspector.select_hint": "Select an item to see its details.",
  /* pane:p1 — the panel HOLDS the last selected thing (owner's ruling,
     2026-09-13), so it can be describing an item in the half of a split
     window nobody is looking at. This line says which one and where. */
  "inspector.held": "Last selected — in {where}",
  "inspector.close": "Close",
  "inspector.section.general": "General",
  "inspector.section.tags": "Tags",
  /* etiket:t1 — TagPicker's own chrome. It printed these three in English
     regardless of the catalogue until 2026-09-13; `tags.open` is the chip's new
     "show me everything with this tag". */
  "tags.open": "Open tag: {tag}",
  "tags.add": "+ Add tag",
  "tags.name": "Tag name",
  "tags.remove": "Remove tag",
  /* etiket:k2 (v0.43.0) — the two KINDS of tag. Every place a tag is drawn
     says which kind it is, in words as well as the icon, because until this
     release a tag was silently shared with every account on the server. */
  "tags.kind.label": "Who sees this tag",
  "tags.kind.personal": "Personal",
  "tags.kind.team": "Team",
  "tags.kind.personal_help": "Only you see it",
  "tags.kind.team_help": "Everyone on your team who can see this file",
  "tags.kind.team_locked": "Adding or removing a team tag needs edit permission on this file.",
  "tags.chip.personal": "Personal tag “{tag}” — only you see it",
  "tags.chip.team": "Team tag “{tag}” — everyone on your team who can see this file sees it",
  "tags.add_submit": "Add",
  "inspector.section.versions": "Versions",
  "inspector.section.permissions": "Permissions",
  "inspector.section.shares": "Shares",
  "inspector.path": "Path",
  "inspector.size": "Size",
  "inspector.modified": "Modified",
  "inspector.mime": "MIME type",
  "inspector.etag": "ETag",
  "inspector.nodeId": "Node ID",
  "inspector.copy": "Copy",
  "inspector.copied": "Copied",
  "inspector.error": "Could not load",
  "inspector.items_summary": "{n} items, {size} total",
  "inspector.items_summary_one": "{n} item, {size} total",
  "inspector.folder_items": "{n} items",
  "inspector.folder_items_one": "{n} item",
  "inspector.versions.empty": "No version history",
  "inspector.versions.v": "Version {n}",
  "inspector.versions.restore": "Restore",
  "inspector.versions.restore_confirm": "Restore this version?",
  "inspector.versions.snapshot_current": "Snapshot the current state first",
  "inspector.versions.confirm": "Confirm",
  "inspector.versions.restoring": "Restoring…",
  "inspector.versions.cancel": "Cancel",
  "inspector.versions.take_snapshot": "Snapshot current state",
  "inspector.versions.snapshotting": "Taking a snapshot…",
  "inspector.versions.restored": "Version restored",
  "inspector.versions.snapshotted": "Snapshot taken",
  "inspector.versions.unsupported": "The server does not support this operation",
  "inspector.perm.none": "No access",
  "inspector.perm.viewer": "Viewer",
  "inspector.perm.editor": "Editor",
  "inspector.perm.owner": "Owner",
  "inspector.perm.manage": "Manage permissions",
  "inspector.shares.empty": "No share links",
  "inspector.shares.copy": "Copy link",
  /* wiring:c1 — theme gallery */
  "theme.menu": "Theme",
  "theme.title": "Theme gallery",
  "theme.hint": "A theme only changes the color palette — day or night is the choice above.",
  "theme.mode.label": "Appearance",
  "theme.mode.light": "Day",
  "theme.mode.dark": "Night",
  "theme.mode.auto": "Automatic",
  "theme.reset": "Reset to default",
  "theme.close": "Close",
  "theme.selected": "Selected",
  "theme.name.default": "Default",
  "theme.name.night": "Night blue",
  "theme.name.forest": "Forest",
  "theme.name.amber": "Amber",
  "theme.name.lilac": "Lilac",
  "theme.name.contrast": "High contrast",
  "theme.name.gray": "Soft gray",
  "theme.name.terminal": "Terminal green",
  /* === zaman:z3 — the time-zone picker (embed dialog + web settings) === */
  "tz.menu": "Time zone",
  "tz.title": "Time zone",
  "tz.label": "Show dates in",
  "tz.search": 'Search a city, country or offset — try "Istanbul" or "GMT+3"',
  "tz.default.device": "Use this device's zone ({zone})",
  "tz.default.account": "Use the account's zone ({zone})",
  "tz.default.host": "Use this site's default ({zone})",
  "tz.no_match": "No zone matches “{query}”. Try a city, a country, or an offset like GMT+3.",
  "tz.more": "{n} more — keep typing to narrow the list.",
  "tz.hint": "Saved in this browser only. Every date is stored as one moment in time and shown on the clock you pick here.",
  "tz.now": "Right now in {zone}: {time}",
  /* === wiring:c2 — customizable shortcuts + quick look === */
  "shortcuts.quicklook": "Quick look",
  "shortcuts.customize": "Customize",
  "shortcuts.settings.menu": "Shortcuts",
  "shortcuts.settings.title": "Shortcut settings",
  "shortcuts.settings.hint": 'To remap a shortcut, press "Change" and then the new key combination. Changes are stored in this browser only.',
  "shortcuts.settings.change": "Change",
  "shortcuts.settings.capture": "Press keys… (Esc cancels)",
  "shortcuts.settings.reset": "Reset to default",
  "shortcuts.settings.reset_all": "Reset all",
  "shortcuts.settings.unbound": "Not set",
  "shortcuts.settings.fixed": "Fixed",
  "shortcuts.settings.customized": "Customized",
  "shortcuts.settings.conflict": 'is already used by "{name}".',
  "shortcuts.settings.conflict_fixed": 'is reserved by the fixed shortcut "{name}" — it cannot be used.',
  "shortcuts.settings.conflict_take": "Unassign old and use here",
  "shortcuts.settings.conflict_cancel": "Cancel",
  "quicklook.hint_close": "close",
  "quicklook.hint_nav": "previous/next",
  "quicklook.hint_open": "open",
  /* === /wiring:c2 === */
  /* === wiring:c3 — operations center === */
  "opc.title": "Operations",
  "opc.aria_badge": "{n} operations — toggle operations center",
  "opc.aria_badge_one": "{n} operation — toggle operations center",
  "opc.close": "Close",
  "opc.active": "In progress",
  "opc.history": "History",
  "opc.clear": "Clear",
  "opc.empty": "No operations",
  "opc.cancel": "Cancel",
  "opc.retry": "Retry",
  "opc.dismiss": "Dismiss",
  "opc.queued": "Queued",
  "opc.cancelling": "Cancel requested…",
  "opc.percent": "{n}%",
  "opc.items": "{done} of {total} items",
  "opc.trash_items": "{n} items from the trash",
  "opc.trash_items_one": "{n} item from the trash",
  "opc.status.running": "In progress",
  "opc.status.done": "Done",
  "opc.status.error": "Failed",
  "opc.status.aborted": "Cancelled",
  "opc.kind.upload": "Upload",
  "opc.kind.copy": "Copy",
  "opc.kind.move": "Move",
  "opc.kind.delete": "Delete",
  "opc.kind.rename": "Rename",
  "opc.kind.restore": "Restore",
  "opc.kind.purge": "Delete permanently",
  "opc.kind.convert": "Convert",
  "opc.kind.archive": "Archive",
  "opc.kind.plugin": "App",
  "opc.kind.trash": "Empty trash",
  "opc.open": "Open",
  /* App plugins — rows a WebAssembly plugin adds to the file menu, and the
     jobs they queue (docs/APP-PLUGINS-API.md). "App" is what the feature is
     called on every surface; "plugin" is the wire word. */
  "plugin.queued": "{label} queued",
  "plugin.done": "{label} finished",
  "plugin.failed": "{label} failed",
  "plugin.cancel_failed": "Could not cancel the job",
  "plugin.not_applicable": "This action does not apply to the selection",
  "plugin.read_only": "This storage is read-only",
  "plugin.needs_engine": "{name} is not installed on this server — install it and restart filex.",
  "plugin.needs_other": "{name} is not available on this server.",
  "plugin.confirm.title": "Confirm",
  "plugin.confirm.cancel": "Cancel",
  "plugin.confirm.run": "Run",
  "plugin.view.close": "Close",
  "appframe.confirm_title": "Confirm",
  "appframe.consent_clipboard": "{app} wants to copy text to your clipboard.",
  "appframe.consent_download": "{app} wants to save “{name}” to your computer.",
  "appframe.consent_job": "{app} wants to start “{action}”.",
  "appframe.consent_allow": "Allow",
  "appframe.consent_deny": "Don’t allow",
  "appframe.unsaved_title": "Unsaved changes",
  "appframe.unsaved_text": "{app} has changes that are not saved. Close it anyway?",
  "appframe.discard": "Close without saving",
  "appframe.keep_open": "Keep editing",
  "appframe.save_close": "Save and close",
  "appframe.updated": "{app} was updated to {version}.",
  "appframe.updated_reload": "An administrator approved a new version of {app}. Reload it to use the new version — save your work first.",
  "appframe.reload": "Reload",
  "appframe.dismiss": "Dismiss",
  "appframe.not_connected": "{app} did not start. Close it and open it again; if it keeps happening, tell your administrator.",
  "plugin.view.busy": "Working…",
  "plugin.view.unsupported": "This screen uses a component this version cannot draw ({type})",
  "plugin.view.error": "The app answered with an error",
  "plugin.output_missing": "The output is no longer where it was",
  /* M2 — surface components (components/plugin/nodes/*) */
  "plugin.view.loading": "Loading…",
  "plugin.view.preview_failed": "The preview could not be loaded",
  "plugin.steps.label": "Steps",
  "plugin.list.empty": "Nothing here yet",
  "plugin.list.actions": "Actions",
  /* The label on a table row's ONE action control (core RowActions.vue).
     The explorer's handle is the ⋮ glyph; a panel row's says what it is.
     Owner, 2026-09-20: "adminde 'Aksiyon' diye yazmalı". */
  "row.actions": "Actions",
  "plugin.people.placeholder": "Name or email",
  "plugin.people.placeholder_email": "Email address",
  "plugin.people.add": "Add",
  "plugin.people.remove": "Remove {name}",
  "plugin.people.invalid_email": "Enter a valid email address",
  "plugin.people.external_off": "Only people with an account can be added",
  "plugin.pin.label": "PIN",
  "plugin.file.choose": "Choose…",
  "plugin.file.clear": "Clear",
  "plugin.file.none": "Nothing chosen",
  /* M3 — the sign track: signature-pad + pdf-fields nodes, and the outside
     participant's public page (views/PublicSurface.vue via usePublicPage). */
  "plugin.sig.mode_draw": "Draw",
  "plugin.sig.mode_type": "Type",
  "plugin.sig.mode_upload": "Upload",
  "plugin.sig.draw_hint": "Sign here with your finger or mouse",
  "plugin.sig.type_placeholder": "Type your name",
  "plugin.sig.upload_pick": "Choose a picture…",
  "plugin.sig.upload_hint": "PNG or JPEG, at most {kb} KB",
  "plugin.sig.upload_too_big": "The picture is larger than {kb} KB",
  "plugin.sig.upload_bad_type": "Only PNG or JPEG pictures can be used",
  "plugin.sig.upload_unreadable": "The picture could not be read",
  "plugin.sig.clear": "Clear signature",
  "plugin.sig.signed": "Signature captured",
  "plugin.pdf.load_failed": "The document could not be loaded",
  "plugin.pdf.palette": "Field types",
  "plugin.pdf.pending": "Boxes waiting for a place",
  "plugin.pdf.place_box_hint": "Tap the page where “{name}” goes, or drag to size it",
  "plugin.pdf.all_placed": "Every box has a place",
  "plugin.pdf.place_idle": "Choose one of the boxes above, then tap the page where it goes.",
  "plugin.pdf.place_idle_done": "Tap a box on the page to take it off or copy it; drag it to move it.",
  "plugin.pdf.no_boxes": "No boxes yet. Add one below: give it a name, say whose it is, and place it on the document in the next step.",
  "plugin.pdf.add_box": "Add a box",
  "plugin.pdf.unplace": "Take off the page",
  "plugin.pdf.place_hint": "Tap the page where the {type} field goes, or drag to size it",
  "plugin.pdf.type_signature": "Signature",
  "plugin.pdf.type_initials": "Initials",
  "plugin.pdf.type_date": "Date",
  "plugin.pdf.type_text": "Text",
  "plugin.pdf.type_checkbox": "Checkbox",
  "plugin.pdf.tap_signature": "Tap to sign",
  "plugin.pdf.tap_initials": "Tap to initial",
  "plugin.pdf.tap_date": "Tap for today",
  "plugin.pdf.tap_text": "Text",
  "plugin.pdf.tap_checkbox": "Tap to tick",
  "plugin.pdf.label": "Name",
  "plugin.pdf.assignee": "Signer",
  "plugin.pdf.unassigned": "Anyone",
  "plugin.pdf.filled_by": "Filled by",
  "plugin.pdf.style": "How it is signed",
  "plugin.pdf.style_drawn": "Drawn",
  "plugin.pdf.style_typed": "Typed",
  "plugin.pdf.lines": "Printed under it",
  "plugin.pdf.lines_preview": "Under the signature:",
  "plugin.pdf.lines_none": "Nothing is printed under this signature.",
  "plugin.pdf.required": "Required",
  "plugin.pdf.copy_to_page": "Copy to page",
  "plugin.pdf.copy": "Copy",
  "plugin.pdf.delete": "Delete field",
  "plugin.pdf.zoom_in": "Zoom in",
  "plugin.pdf.zoom_out": "Zoom out",
  "plugin.pdf.zoom_fit": "Fit to width",
  "plugin.pdf.zoom_fit_page": "Fit the page to the screen",
  "plugin.pdf.pad_for": "Your {type}",
  "plugin.pdf.pad_done": "Done",
  "plugin.page.loading": "Loading…",
  "plugin.page.pin_title": "This page is protected",
  "plugin.page.pin_hint": "Enter the PIN you were given to continue",
  "plugin.page.pin_submit": "Continue",
  "plugin.page.pin_wrong": "That PIN is not right",
  "plugin.page.pin_locked": "Too many wrong PINs — wait a few minutes and try again",
  "plugin.page.unavailable_title": "This link is not available",
  "plugin.page.unavailable_text": "It may have expired, been used up or been withdrawn. Ask the person who sent it for a new one.",
  "plugin.page.accepted_title": "Received, thank you",
  "plugin.page.accepted_text": "Your answer has been recorded. You can close this page.",
  "plugin.page.done_title": "All done",
  "plugin.page.done_text": "There is nothing more to do here. You can close this page.",
  "plugin.page.error_title": "Something went wrong",
  "plugin.page.retry": "Try again",
  "plugin.page.files": "Documents",
  "plugin.page.open_file": "Open {name} in a new tab",
  "plugin.page.footer": "Served by filex",
  /* === v3 — the ONE public shell: a share, a file request and an app's page
     are one page with three bodies. These are the words the shell itself
     says, so they are the same words whichever link was followed. === */
  "public.served_by": "Served by {name}",
  "public.expires": "The link stops working on {when}",
  "public.visits_left": "{n} visits left",
  "public.visits_left_one": "{n} visit left",
  "public.language_from": "Added by the {app} app",
  "public.up": "Up one level",
  "public.download_all": "Download everything",
  "public.browse": "Look inside",
  "public.folder_empty": "There is nothing in this folder",
  "public.drop_sub": "Drop your files below, or pick them. You can only add to this folder — what is already in it stays hidden from you.",
  "public.drop_here": "Drop the files here",
  "public.or_choose": "or click to choose them",
  "public.max_size": "At most {size} per file",
  "public.accepts": "Accepted: {list}",
  "public.files_left": "{n} more files can be sent",
  "public.files_left_one": "{n} more file can be sent",
  "public.request_full": "Everything that was asked for has arrived",
  "public.upload_done": "Sent",
  "public.upload_failed": "Could not be sent",
  "public.upload_saving": "Saving…",
  "public.upload_unanswered": "Sent, but the server did not confirm it in time. It may still be saving it: check with whoever sent you this link before sending it again.",
  "public.your_name": "Your name (optional)",
  "public.your_name_ph": "e.g. Alex Smith",
  "public.refused_ext": "Not sent — this link does not accept this type of file.",
  "public.refused_too_large": "Not sent — larger than {size}.",
  "public.refused_too_many": "Not sent — at most {count} files can be sent now.",
  "public.refused_too_many_one": "Not sent — only {count} file can be sent now.",
  /* === App plugins v2 — a `page` view, an app's lock on a file, the output
     mode a job wrote in, and the faces + rules a signature field carries. === */
  "plugin.page_view.back": "Back to the files",
  "plugin.page_view.queued_title": "The job is queued",
  "plugin.page_view.queued_text": "filex is working on it. Its progress is in the operations tray, and you will be told when it lands.",
  "plugin.page_view.open_ops": "Open the operations tray",
  "plugin.page_view.done_title": "All done",
  "plugin.page_view.done_text": "There is nothing more to do here. You can close this tab.",
  "plugin.page_view.error_title": "This screen could not be opened",
  "plugin.page_view.retry": "Try again",
  "plugin.page_view.blocked": "The new tab was blocked — allow pop-ups for this site, or the screen will open in a dialog",
  "plugin.output.sibling": "new file",
  "plugin.output.version": "new version",
  "plugin.output.sibling_title": "The result lands as a new file beside the original",
  "plugin.output.version_title": "The result replaces the file as a new version of it",
  "plugin.sign.font_label": "Handwriting",
  "plugin.pdf.font": "Font",
  "plugin.pdf.rule_number": "Numbers only",
  "plugin.pdf.rule_email": "Email address",
  "plugin.pdf.rule_length": "Between {min} and {max} characters",
  "plugin.pdf.rule_min": "At least {min} characters",
  "plugin.pdf.rule_max": "At most {max} characters",
  "plugin.pdf.err_number": "Enter a number",
  "plugin.pdf.err_email": "Enter a valid email address",
  "plugin.pdf.err_min": "Too short — at least {min} characters",
  "plugin.pdf.err_max": "Too long — at most {max} characters",
  "applock.badge": "Locked",
  "applock.some_app": "an app",
  "applock.held": "{app} locked this file",
  "applock.held_reason": "{app} locked this file: {reason}",
  "applock.until": "— until {date}",
  "applock.inspector": "Held by an app",
  /* issue #34 — a symlink the server will NOT follow (lib/symlink). The badge
     is the short word on the row; `why` is the sentence behind it, shown on
     hover, in the details panel and in the toast when somebody tries to open
     one. ⚠ Broken and outside-of-root are DIFFERENT states and must read
     differently: only one has an administrator remedy, and offering that
     remedy for a target that has been deleted sends the person to a settings
     screen that cannot help them. */
  "symlink.badge.outside_root": "Outside storage",
  "symlink.badge.broken": "Broken link",
  "symlink.badge.unresolved": "Remote link",
  "symlink.badge.unknown": "Link",
  "symlink.why.outside_root": `A link whose target lies outside this storage, which is why it cannot be opened. An administrator can allow it with "Follow symlinks that leave this folder" in the storage's settings.`,
  "symlink.why.broken": "A link whose target no longer exists, so there is nothing to open. It has to be repaired or removed on the server — no setting can bring the target back.",
  "symlink.why.unresolved": "A link on a remote server. filex cannot tell whether its target is inside this storage, so it does not follow it and cannot open it.",
  "symlink.why.unknown": "A link filex will not follow, so it cannot be opened. Its target is either outside this storage, missing, or on a remote server filex cannot resolve.",
  "symlink.inspector": "A link that cannot be opened",
  "plugin.pdf.rule": "Accepts",
  "plugin.pdf.rule_kind_any": "Any text",
  "plugin.pdf.rule_kind_number": "Numbers only",
  "plugin.pdf.rule_kind_email": "Email address",
  "plugin.pdf.rule_min_label": "Min length",
  "plugin.pdf.rule_max_label": "Max length",
  "plugin.pdf.format": "Date layout",
  "plugin.pdf.date_order": "Date order",
  "plugin.pdf.date_separator": "Separator",
  "plugin.pdf.date_example": "Example",
  "opc.kind.archive-create": "Creating archive",
  "opc.kind.archive-extract": "Extracting archive",
  /* === wiring:c4 — onboarding tour + accessibility + error card === */
  "tour.aria": "Onboarding tour",
  "tour.restart": "Restart the tour",
  "tour.skip": "Skip tour",
  "tour.back": "Back",
  "tour.next": "Next",
  "tour.done": "Done",
  "tour.progress": "{n} / {m}",
  "tour.step.nav.title": "Storages & views",
  "tour.step.nav.desc": "Home, Shared with me, Recent, Starred and Trash are always in this panel, with your storages and connections underneath. The button in the top-left corner collapses it to a rail and brings it back.",
  "tour.step.nav.desc_closed": "This button opens the navigation panel: Home, Shared with me, Recent, Starred and Trash, with your storages and connections underneath.",
  "tour.step.new.title": "Add something",
  "tour.step.new.desc": "Everything new starts here — upload from this device, create a folder, or ask somebody else for a file. Dropping files onto the window uploads them as well.",
  "tour.step.new.desc_fab": "This button uploads files from this device. Dropping files onto the window works as well.",
  "tour.step.search.title": "Search",
  "tour.step.search.desc": 'This field searches the whole storage by name — separators and one typo are forgiven, so "invoice 2026" finds invoice_2026.pdf. Add tag:invoice to filter by tag. The sliders button opens advanced search, and {palette} opens the command palette, which runs commands too.',
  "tour.step.crumb.title": "Where you are",
  "tour.step.crumb.desc": "This trail is the address of the folder on screen. Click any step to go back up, and the chevron beside the last one lists the folders inside it.",
  "tour.step.filters.title": "Narrow the list",
  "tour.step.filters.desc": "Type, Owner, Modified and Size filter the folder you are in, the box beside them matches names as you type, and the control at the end of the row sorts.",
  "tour.step.view.title": "Switch views",
  "tour.step.view.desc": "Change how this folder is drawn; your choice is remembered.",
  "tour.step.details.title": "Details & sharing",
  "tour.step.details.desc": 'Select a file and open this panel for its details, its activity and its share links. For the full menu, right-click the file or use the button at the end of its row — "Share" there creates a link with an optional PIN and expiry.',
  "tour.step.help.title": "Shortcuts",
  "tour.step.help.desc": 'Press {help} for the shortcut cheat-sheet and {palette} for the command palette. Theme and "Restart the tour" are in the "More actions" menu at the top right; your account and sign-out are behind the avatar beside it.',
  "error.hint": "This may be a temporary network or server problem. Please try again.",
  "error.details": "Technical details",
  "col.star": "Star",
  "toolbar.view_label": "View",
  "list.aria": "File list",
  "grid.aria": "File grid",
  /* === wiring:d1 — tabs + split pane === */
  "tabs.strip": "Tabs",
  "tabs.new": "New tab",
  "tabs.close": "Close tab",
  "tabs.split": "Split view",
  "tabs.split_off": "Close split",
  "ctx.open_new_tab": "Open in new tab",
  "ctx.open_with": "Open with {app}",
  "shortcuts.group.tabs": "Tabs",
  "shortcuts.tab_new": "New tab",
  "shortcuts.tab_close": "Close tab",
  "shortcuts.tab_next": "Next tab",
  "shortcuts.tab_prev": "Previous tab",
  /* tus:t1 — the menu verbs */
  "shortcuts.new_folder": "New folder",
  "shortcuts.upload": "Upload files",
  "shortcuts.refresh": "Refresh the listing",
  "shortcuts.download": "Download",
  "shortcuts.preview": "Preview",
  "shortcuts.share": "Share",
  "shortcuts.tags": "Tags",
  "shortcuts.open_tab": "Open in a new tab",
  "shortcuts.copy_path": "Copy path",
  "shortcuts.copy_id": "Copy id",
  "shortcuts.restore": "Restore from trash",
  "shortcuts.settings.reserved": "is taken by the browser before the page sees it, so it would do nothing here. Pick another key.",
  "shortcuts.settings.reserved_badge": "Desktop app only",
  "shortcuts.settings.reserved_title": "The browser handles this combination itself. It fires in the desktop app and in an installed PWA, not in a browser tab.",
  "cmd.tab_new": "Open a new tab",
  "cmd.split_toggle": "Toggle split view",
  "split.pane": "Secondary pane",
  "split.close": "Close the side pane",
  "split.error": "Could not load the listing",
  "split.retry": "Retry",
  "split.copy_queued": "Copy queued",
  "split.move_queued": "Move queued",
  "toast.move_kept_both": "Move queued. A name was already taken there, so that item will be kept beside the existing one with “-copy” added. This move cannot be undone.",
  "split.cross_copy": "Different storages — copy queued instead",
  "dragout.downloading": "Downloading into the folder you dropped on…",
  "dragout.downloading_n": "Downloading into the folder you dropped on — {n} files so far…",
  "dragout.downloading_n_one": "Downloading into the folder you dropped on — {n} file so far…",
  "dragout.stop": "Stop",
  "dragout.stopping": "Stopping…",
  "dragout.stopped": "Stopped — what had arrived stays in the folder",
  "dragout.not_found": "Could not find where it was dropped — a drop onto an application (rather than a folder) cannot be filled in",
  "dragout.done": "Download finished",
  "dragout.ready": "Files are ready — drag them to your desktop",
  "dragout.preparing": "Getting them ready to drag…",
  "split.cross_move": "Different storages — move queued (bytes travel, then the original is removed)",
  /* === /wiring:d1 === */
  /* wiring:d2 — gallery view */
  "toolbar.view.gallery": "Gallery",
  "gallery.aria": "File gallery",
  /* /wiring:d2 */
  /* wiring:d3 — inspector node comments */
  "inspector.section.comments": "Comments",
  "inspector.comments.empty": "No comments yet.",
  "inspector.comments.placeholder": "Write a comment…",
  "inspector.comments.send": "Send",
  "inspector.comments.delete": "Delete comment",
  /* wiring:e2 — end-to-end encrypted folders */
  "e2e.create.title": "Create encrypted folder",
  "e2e.create.option": "Create encrypted folder…",
  "e2e.create.pw_label": "Folder password",
  "e2e.create.pw_placeholder": "At least 8 characters",
  "e2e.create.pw2_label": "Repeat the password",
  "e2e.create.warn_title": "NO WAY BACK",
  "e2e.create.warn_body": "Files in this folder can only be opened with this password or the recovery key shown once when the folder is created. The password is NEVER stored on the server, and filex keeps no copy of the recovery key either. Lose both and the contents are gone for good.",
  "e2e.create.ack": "I understand: if I lose both the password and the recovery key, my data cannot be recovered.",
  "e2e.create.ack_required": "Please confirm the warning to continue.",
  "e2e.create.pw_short": "Password must be at least 8 characters.",
  "e2e.create.pw_mismatch": "Passwords do not match.",
  "e2e.create.bad_name": "Invalid folder name.",
  "e2e.create.create": "Create encrypted folder",
  "e2e.create.busy": "Creating…",
  "e2e.create.done": "Encrypted folder created",
  "e2e.create.failed": "Could not create the encrypted folder",
  "e2e.create.nested": "You cannot create an encrypted folder inside another one.",
  "e2e.locked.title": "This folder is end-to-end encrypted",
  "e2e.locked.hint": "Enter the folder password to see its contents. The password stays in this tab’s memory only.",
  "e2e.locked.pw_placeholder": "Folder password",
  "e2e.locked.unlock": "Unlock",
  "e2e.locked.busy": "Verifying…",
  "e2e.unlock.wrong": "Wrong password.",
  "e2e.unlock.damaged": "The password is right, but the folder key in the key file (.filex-e2e.json) does not open: the file is damaged. Try the recovery key.",
  "e2e.unlock.marker_missing": "Could not read the key file (.filex-e2e.json).",
  /* ikon:emoji — the listing marker's accessible name. The row used to print
     a 🔒 and nothing else; the padlock that replaced it is aria-hidden inside
     the tile, so the span that carries it says this instead. */
  "e2e.badge": "Encrypted folder",
  "e2e.strip.label": "Encrypted folder — unlocked",
  "e2e.strip.lock": "Lock",
  /* wiring:e2 password — changing a folder's password */
  "e2e.password.strip_action": "Change password…",
  "e2e.password.title": "Change the folder password",
  "e2e.password.reset_title": "Set a new password for this folder",
  "e2e.password.reset_lead": "You opened this folder with its recovery key, so its password was lost or may be known to someone. Set a new one now. Closing this dialog locks the folder again.",
  "e2e.password.current": "Current password",
  "e2e.password.recovery": "Recovery key",
  "e2e.password.use_recovery": "I do not remember it — use the recovery key",
  "e2e.password.use_current": "Use the current password instead",
  "e2e.password.new": "New password",
  "e2e.password.current_required": "Enter the current password, or use the recovery key.",
  "e2e.password.bad_recovery": "That is not a recovery key (32 characters, in groups of four).",
  "e2e.password.same": "The new password is the same as the current one.",
  "e2e.password.cheap_note": "Only the folder’s key file changes. No file is re-encrypted, and the recovery key and any escrow key keep working.",
  "e2e.password.old_copies": "Someone who knows the old password and has an old copy of the key file (a version, a backup) can still open the folder with it. If that is a risk, tick “Also replace the folder key”.",
  "e2e.password.rotate_label": "Also replace the folder key (re-wraps every file’s key; use this if the old password may be known)",
  "e2e.password.rekey_title": "This folder is from before v0.31: its key comes from its password",
  "e2e.password.rekey_body": "A new password therefore needs a new folder key, and the key of every file in the folder is re-wrapped under it. The contents are not re-encrypted. It can take a while, and if it is interrupted it continues where it stopped; the files open throughout.",
  "e2e.password.rotate_title": "The folder key is replaced too",
  "e2e.password.rotate_body": "Every file’s key is re-wrapped under a new folder key. The contents are not re-encrypted. If it is interrupted it continues where it stopped; the files open throughout.",
  "e2e.password.rekey_rk_new": "You get a new recovery key, shown once; the old one stops working.",
  "e2e.password.rekey_rk_kept": "The recovery key you used keeps working.",
  "e2e.password.rekey_escrow": "The operator’s escrow key keeps working: its slot is sealed to the new folder key.",
  "e2e.password.rekey_ack": "I understand: this re-wraps the key of every file in the folder.",
  "e2e.password.submit": "Change password",
  "e2e.password.busy": "Changing…",
  "e2e.password.lock_instead": "Lock the folder instead",
  "e2e.password.wrong_current": "Wrong password.",
  "e2e.password.wrong_recovery": "Wrong recovery key.",
  "e2e.password.escrow_blocked": "This folder has an escrow slot for a key this installation does not have, and replacing the folder key would lose it. Nothing was changed.",
  "e2e.password.failed": "Could not change the password. Nothing was changed.",
  "e2e.password.done": "Password changed. The old password no longer opens this folder.",
  "e2e.password.announce_failed": "The password was changed, but the server could not record it; the folder’s owner was not told.",
  "e2e.password.resume_title": "File keys are still being re-wrapped",
  "e2e.password.resume_body": "The password was changed and a new folder key issued. Some files still have their key under the previous one; they open either way. Continue to finish.",
  "e2e.password.progress": "{n} files re-wrapped so far · {failed} failed",
  "e2e.password.progress_one": "{n} file re-wrapped so far · {failed} failed",
  "e2e.password.rekey_partial": "{n} files could not be re-wrapped. They still open with the previous key; continue to try again.",
  "e2e.password.rekey_partial_one": "{n} file could not be re-wrapped. It still opens with the previous key; continue to try again.",
  "e2e.password.rekey_done": "New folder key in place ({n} files re-wrapped). The old password opens nothing here any more.",
  "e2e.password.rekey_done_one": "New folder key in place ({n} file re-wrapped). The old password opens nothing here any more.",
  "e2e.recovery.lead_replaced": "The folder has a new key, so it has a new recovery key too — the old one no longer opens it. Shown once; filex keeps no copy.",
  /* wiring:e2 names — encrypted file and folder names */
  "e2e.unlock.unsupported": "This folder needs a newer filex: it uses {features}, which this version does not understand. Nothing was changed.",
  "e2e.settings.open": "Encryption settings…",
  "e2e.settings.title": "Encryption settings",
  "e2e.settings.level": "Encryption level",
  "e2e.settings.password": "Password",
  "e2e.settings.escrow": "Escrow key",
  "e2e.settings.close": "Close",
  "e2e.level.content": "Contents only",
  "e2e.level.names": "Contents and names",
  "e2e.level.content_hint": "File contents are encrypted. File and folder names stay readable to the server, so WebDAV, the command line and desktop sync keep working with them, and every filex since 0.31 opens the folder.",
  "e2e.level.names_hint": "Contents and file and folder names are encrypted: the server sees only scrambled names. WebDAV, the command line and desktop sync see them scrambled too, and filex 0.47 and older will not open the folder.",
  "e2e.level.pending": "the change of level has not finished",
  "e2e.level.change": "Change level…",
  "e2e.level.raise_title": "Move this folder to “Contents and names”?",
  "e2e.level.raise_body": "filex gives every file and folder in here an encrypted name, in this browser. The contents are not touched, and if it is interrupted it continues where it stopped. filex does not offer the way back to readable names.",
  "e2e.level.raise_ack": "I understand what changes",
  "e2e.level.raise_go": "Encrypt the names",
  "e2e.names.move_unreadable": "Not moved: the name of one of the items cannot be read.",
  "e2e.names.move_taken": "Not moved: “{name}” is already taken in that folder. Rename one of the two first.",
  "e2e.convert.ctx": "Encrypt with E2EE…",
  "e2e.convert.title": "Encrypt “{name}”",
  "e2e.convert.lead": "Every file in this folder is encrypted where it is, in this browser, with the password below. Nothing moves; at level 1 the names stay as they are. If it is interrupted, opening the folder again continues it.",
  "e2e.convert.past_title": "What the server already has",
  "e2e.convert.past_body": "Encrypting protects these files from now on. Until now the server has had them in the clear, and some copies remain: filex drops its thumbnails and the text it extracted for search, and can delete older versions and trash entries from this folder.",
  "e2e.convert.drop_versions": "Delete the older versions of these files (they are plaintext)",
  "e2e.convert.drop_trash": "Delete the trash entries that came from this folder",
  "e2e.convert.past_outside": "Backups, replicas and copies anyone already made are outside filex and stay as they are.",
  "e2e.convert.submit": "Encrypt folder",
  "e2e.convert.nested": "This folder holds an encrypted folder. Encrypted folders cannot be nested, so nothing was changed.",
  "e2e.convert.failed": "The folder could not be encrypted. Files already encrypted stay so; open the folder to continue.",
  "e2e.convert.stopped": "Stopped after {n} files. Continue from the strip above the folder.",
  "e2e.convert.stopped_one": "Stopped after {n} file. Continue from the strip above the folder.",
  "e2e.convert.partial": "{n} files could not be encrypted (changed meanwhile, too large, or not writable). They are still plaintext; try again to continue.",
  "e2e.convert.partial_one": "{n} file could not be encrypted (changed meanwhile, too large, or not writable). It is still plaintext; try again to continue.",
  "e2e.convert.busy": "Encrypting the folder…",
  "e2e.convert.resume_title": "Finish encrypting this folder",
  "e2e.convert.resume_body": "Encrypting this folder started and did not finish. Files it has not reached yet are still plaintext on the server. Continuing picks up where it stopped.",
  "e2e.convert.progress": "{n} of {total} files encrypted · {failed} not done",
  "e2e.convert.progress_one": "{n} of {total} files encrypted · {failed} not done",
  "e2e.convert.done": "Folder encrypted ({n} files). Old versions deleted: {versions}; trash entries deleted: {trash}.",
  "e2e.convert.done_one": "Folder encrypted ({n} file). Old versions deleted: {versions}; trash entries deleted: {trash}.",
  "e2e.convert.cleanup_failed": "The folder is encrypted, but its old versions and trash entries could not be deleted — only the folder’s owner or an administrator can.",
  "e2e.names.locked_item": "🔒 Encrypted item",
  "e2e.names.unreadable_item": "🔒 Unreadable name",
  "e2e.names.key_failed": "The key file says the names in this folder are encrypted, but their key does not open with this one. Nothing was changed.",
  "e2e.names.write_failed": "Could not write the name file of a long name, so nothing was uploaded.",
  "e2e.names.bad_name": "“{name}” cannot be used in an encrypted folder: a name must be 1–255 bytes, with no slash, backslash or control character.",
  "e2e.names.offer_cost": "What changes: WebDAV, the command line and desktop sync will see scrambled names, and filex 0.47 and older will refuse to open this folder. The server still sees how many items there are and how big they are.",
  "e2e.names.resume_title": "Finish encrypting the names",
  "e2e.names.resume_body": "Encrypting the names in this folder started and did not finish. Items it has not reached yet still have readable names. Continuing picks up where it stopped.",
  "e2e.names.resume": "Continue",
  "e2e.names.stop": "Stop",
  "e2e.names.busy": "Encrypting names…",
  "e2e.names.progress": "{n} names encrypted so far · {failed} could not be renamed",
  "e2e.names.progress_one": "{n} name encrypted so far · {failed} could not be renamed",
  "e2e.names.done": "Names encrypted ({n} items renamed). The server no longer sees them.",
  "e2e.names.done_one": "Names encrypted ({n} item renamed). The server no longer sees them.",
  "e2e.names.stopped": "Stopped after {n} names. The rest keep their readable names until you continue.",
  "e2e.names.stopped_one": "Stopped after {n} name. The rest keep their readable names until you continue.",
  "e2e.names.partial": "{n} items could not be renamed (no permission, or a name a disk cannot hold). Their names stay readable; try again to continue.",
  "e2e.names.partial_one": "{n} item could not be renamed (no permission, or a name a disk cannot hold). Its name stays readable; try again to continue.",
  "e2e.names.failed": "Could not encrypt the names. Nothing already renamed is lost; try again to continue.",
  "e2e.names.strip_fix": "Fix {n} names (readable, or moved in from outside filex)",
  "e2e.names.strip_fix_one": "Fix {n} name (readable, or moved in from outside filex)",
  "e2e.create.names_root_hint": "The folder’s own name stays readable either way — it sits in a folder that is not encrypted. Pick a name that gives nothing away.",
  "e2e.locked_toast": "Folder locked",
  "e2e.upload.too_big": "Files over 200 MB cannot be uploaded to an encrypted folder (MVP limit)",
  "e2e.upload.locked": "Unlock the folder first",
  "e2e.decrypting": "Decrypting…",
  "e2e.decrypt_failed": "Could not decrypt the file (password changed or file corrupted).",
  /* wiring:e2 recovery — recovery keys + operator escrow */
  "e2e.create.escrow_title": "This server holds a second key",
  "e2e.create.escrow_body": "Key escrow is enabled on this installation, so its operator can open this folder without your password. Using that key notifies you. Escrow is fixed when the server is installed and cannot be turned off for a folder.",
  "e2e.locked.use_recovery": "Lost the password? Use a recovery key",
  "e2e.recovery.title": "Save your recovery key",
  "e2e.recovery.title_upgraded": "Your recovery key",
  "e2e.recovery.lead": "This key opens the folder without its password. It is shown once — filex does not store it and cannot show it again.",
  "e2e.recovery.lead_upgraded": "This folder now has a recovery key. It opens the folder without its password, is shown once, and is not stored by filex.",
  "e2e.recovery.copy": "Copy",
  "e2e.recovery.copied": "Copied",
  "e2e.recovery.download": "Download as a file",
  "e2e.recovery.warn_title": "TREAT THIS LIKE A PASSWORD",
  "e2e.recovery.warn_body": "Anyone holding this key can read the folder. Keep it somewhere separate from the password — a key stored next to the password protects you from forgetting, not from anyone else.",
  "e2e.recovery.escrow_title": "This server also holds a key",
  "e2e.recovery.escrow_body": "Key escrow is enabled here, so the operator of this installation can open this folder without your password. You are notified when that key is used.",
  "e2e.recovery.escrow_kid": "Escrow key",
  "e2e.recovery.ack": "I have saved this key somewhere safe.",
  "e2e.recovery.done": "Done",
  "e2e.recover.title": "Unlock without the password",
  "e2e.recover.none": "This folder was created before recovery keys existed, so it has none. Its password is the only way in. Unlock it with the password once and filex will offer to add a recovery key.",
  "e2e.recover.tab_recovery": "Recovery key",
  "e2e.recover.tab_escrow": "Escrow key",
  "e2e.recover.recovery_hint": "The key shown once when this folder was created.",
  "e2e.recover.recovery_placeholder": "XXXX-XXXX-XXXX-XXXX-XXXX-XXXX-XXXX-XXXX",
  "e2e.recover.escrow_warn_title": "The owner will be told",
  "e2e.recover.escrow_warn_body": "Opening a folder with the escrow key notifies its owner. Use it only when you are entitled to.",
  "e2e.recover.escrow_kid": "Escrow key",
  "e2e.recover.escrow_predates": "This installation has an escrow key, but this folder does not. It was created before escrow was turned on here, so its master key was never wrapped to the escrow identity. The escrow key will not open it. Nothing the operator can do changes that — adding a slot needs this folder’s password, which the server has never had. The folder’s owner can grant it: unlock with the password, then choose to give the operator a key. Until they do, use the password or the recovery key.",
  "e2e.recover.escrow_other_key": "This folder carries an escrow key from a DIFFERENT installation. It was created elsewhere and restored here, so this installation’s escrow key does not open it. Only the private key belonging to the escrow key it was sealed to can.",
  "e2e.recover.escrow_placeholder": "Paste the escrow private key (PKCS#8, base64 or PEM)",
  "e2e.recover.bad_format": "That does not look like a recovery key. It is 32 characters in eight groups of four.",
  "e2e.recover.escrow_required": "Paste the escrow private key.",
  "e2e.recover.wrong_recovery": "That recovery key does not open this folder.",
  "e2e.recover.wrong_escrow": "That escrow key does not open this folder. A folder created before escrow was turned on has no escrow slot until its owner grants one — until then, use the password or the recovery key.",
  "e2e.recover.bad_escrow_key": "That is not a readable private key (expected PKCS#8, base64 or PEM).",
  "e2e.recover.notify_failed": "Could not notify the folder owner, so the folder was not unlocked. Escrow use is always announced.",
  "e2e.recover.recovery_done": "Unlocked with the recovery key",
  "e2e.recover.escrow_done": "Unlocked with the escrow key — the owner has been notified",
  "e2e.recover.unlock": "Unlock",
  "e2e.recover.busy": "Unlocking…",
  "e2e.escrowoffer.title": "Give the operator a key to this folder?",
  "e2e.escrowoffer.body": "This folder was created before key escrow was turned on here, so the operator of this installation cannot open it. Right now — while your password is in memory — filex can seal this folder to the escrow key. Your files are not re-encrypted or moved; only the key file changes.",
  "e2e.escrowoffer.consequence": "What this means: the operator gains a second, permanent way into this folder, without your password. You are notified when that key is used, but that notification is an announcement rather than a control.",
  "e2e.escrowoffer.learn_more": "What escrow can and cannot do",
  "e2e.escrowoffer.password_label": "Folder password",
  "e2e.escrowoffer.password_required": "Enter the folder password.",
  "e2e.escrowoffer.wrong_password": "That is not this folder’s password.",
  "e2e.escrowoffer.accept": "Give the operator a key",
  "e2e.escrowoffer.decline": "No, keep it to myself",
  "e2e.escrowoffer.cancel": "Cancel",
  "e2e.escrowoffer.busy": "Sealing…",
  "e2e.escrowoffer.done": "The operator can now open this folder with the escrow key",
  "e2e.escrowoffer.declined_toast": "Kept to yourself. filex will not ask again for this folder.",
  "e2e.escrowoffer.decline_failed": "Could not record your answer, so filex will ask again next time. Nothing about the folder changed.",
  "e2e.escrowoffer.failed": "Could not give the operator a key to this folder",
  "e2e.escrowoffer.strip_action": "Escrow key…",
  "e2e.upgrade.title": "This folder has no recovery key",
  "e2e.upgrade.body": "It was created before recovery keys existed, so its password is the only way in. Right now — and only right now, while the password is in memory — filex can add one. Your files are not re-encrypted or moved.",
  "e2e.upgrade.escrow_note": "Note: this installation has key escrow enabled, so adding a recovery key also lets its operator open this folder without your password.",
  "e2e.upgrade.accept": "Create a recovery key",
  "e2e.upgrade.decline": "Not now",
  "e2e.upgrade.busy": "Creating…",
  "e2e.upgrade.failed": "Could not add a recovery key to this folder",
  "e2e.download.failed": "Could not download the encrypted file.",
  /* /wiring:e2 */
  /* ── connections: storage config + "how to connect" ──────────────
     `storages.*` keys are the ones the BACKEND's driver descriptors
     name (each driver package declares one next to its Init). They are
     kept identical to web/src/locales/*.json on purpose: the same
     descriptor is rendered on both surfaces, so a field that reads
     "Base path" in the admin panel and something else in the desktop
     app would be the same drift this whole mechanism exists to stop. */
  "conn.title": "Storage connections",
  "conn.subtitle": "How to reach {host} from your own computer: mount it, or point a client at it.",
  "conn.close": "Close",
  "conn.list.disabled": "Disabled",
  "conn.form.required": "Required",
  "conn.form.advanced": "Advanced settings",
  /* A two-button decision's own words, when the declaration did not name them. */
  "conn.form.yes": "Yes",
  "conn.form.no": "No",
  "conn.form.noFields": "This server did not describe any settings for this driver.",
  "conn.form.reveal": "Show",
  "conn.form.hide": "Hide",
  "conn.guide.protocol": "Protocol",
  "conn.guide.storage": "Storage",
  "conn.guide.allStorages": "All storages",
  "conn.guide.copy": "Copy",
  "conn.guide.copied": "Copied",
  "conn.guide.goodToKnow": "Good to know",
  "conn.guide.userPlaceholder": "your-email@example.com",
  "conn.guide.secretPlaceholder": "your-password-or-api-key",
  "conn.guide.fact.url": "Address",
  "conn.guide.fact.urlRootHint": "Every storage you can see appears as a folder under this address.",
  "conn.guide.fact.urlStorageHint": "Mounts “{storage}” directly. Drop the last segment to see every storage.",
  "conn.guide.fact.user": "Username",
  "conn.guide.fact.password": "Password",
  "conn.guide.webdav.summary": "WebDAV mounts filex as a drive: Windows Explorer, macOS Finder, Linux, rclone and Cyberduck all speak it, and every change is mirrored back into filex.",
  "conn.guide.webdav.userHint": "Your username or your email — not your display name.",
  "conn.guide.webdav.passwordHint": "Your account password, or an API key (API keys, in the navigation panel). An account with two-factor authentication MUST use an API key: Basic auth has no second-factor slot.",
  "conn.guide.webdav.win.s1": "Open File Explorer, right-click This PC and choose “Map network drive…”.",
  "conn.guide.webdav.win.s2": "Pick a drive letter and enter {url} as the folder.",
  "conn.guide.webdav.win.s3": "Tick “Connect using different credentials” and sign in with the username and password above.",
  "conn.guide.webdav.win.cmdCaption": "Command Prompt (same thing, without the wizard)",
  "conn.guide.webdav.win.limits": "Windows has three built-in limits that look exactly like filex bugs: transfers stop at ~47.7 MB, folders with about a thousand files refuse to open (“Disk is not formatted”), and the WebClient service must be restarted after changing either.",
  "conn.guide.webdav.win.regCaption": "Run as administrator, then reconnect the drive",
  "conn.guide.webdav.win.https": "HTTPS is mandatory. Windows sends Basic credentials over TLS only, and over plain http:// it silently refuses with no useful message. Do not set BasicAuthLevel to 2 — use TLS.",
  "conn.guide.webdav.win.persist": "The mapped drive does not survive a sign-out: since Windows 7 Basic credentials cannot be stored in Credential Manager, and /persistent:yes does not change that. Re-run the command from a logon script if you need it back automatically.",
  "conn.guide.webdav.win.service": "If nothing mounts at all, make sure the WebClient service is running: sc config WebClient start= auto && net start WebClient.",
  "conn.guide.webdav.mac.s1": "In Finder choose Go → Connect to Server… (⌘K).",
  "conn.guide.webdav.mac.s2": "Enter {url} and connect.",
  "conn.guide.webdav.mac.s3": "Authenticate with the username and password above.",
  "conn.guide.webdav.mac.note": "The drive appears under Locations; each storage is a top-level folder.",
  "conn.guide.webdav.linux.mountCaption": "davfs2, or the desktop file manager (GNOME Files, Dolphin)",
  "conn.guide.webdav.linux.gvfsComment": "or paste this address into GNOME Files / Dolphin",
  "conn.guide.webdav.linux.locks": "davfs2 needs locking turned off. filex keeps WebDAV locks in process memory, so they do not survive a restart and are not shared between replicas — davfs2 assumes otherwise and hangs.",
  "conn.guide.webdav.rclone.obscureCaption": "rclone stores an obscured password — run this first and paste the output below",
  "conn.guide.webdav.rclone.passPlaceholder": "<output of rclone obscure>",
  "conn.guide.webdav.rclone.useCaption": "Using it",
  "conn.guide.webdav.duck.s1": "New Bookmark → WebDAV (HTTPS).",
  "conn.guide.webdav.duck.s2": "Server {host}, port 443.",
  "conn.guide.webdav.duck.s3": "Path {path}.",
  "conn.guide.webdav.duck.s4": "Username {user}, password as above.",
  "conn.guide.webdav.note.delete": "A WebDAV delete is permanent. The web UI moves files to the filex trash; a client delete removes the object from the backing storage directly.",
  "conn.guide.webdav.note.locks": "Locks live in server memory: they do not survive a restart and are not shared between replicas. They exist to satisfy Windows and Office, not to arbitrate concurrent edits.",
  "conn.guide.webdav.note.permissions": "You see exactly what you see in the web UI. The root lists only the storages you may open, and a path outside your grants answers 404 rather than 403, so the tree never leaks what exists.",
  "conn.guide.webdav.note.http": "This server is reachable over plain http://. Windows will refuse to send your credentials at all, and every other client sends your password in the clear. Put filex behind TLS before mounting it.",
  // ── S3 endpoint: keys and the guide ──────────────────────────────
  "conn.s3keys.title": "S3 access keys",
  "conn.s3keys.lead": "An access key lets any S3 client — rclone, restic, the AWS CLI, mc, s3fs, Cyberduck — connect to filex. It carries your own permissions and nothing more.",
  "conn.s3keys.disabled": "The S3 endpoint is switched off on this server (FILEX_S3). A key minted here will not connect until an operator turns it back on.",
  "conn.s3keys.cannotMint": "You are not signed in with an account that can mint access keys. The instructions below still apply — ask for a key and paste it in.",
  "conn.s3keys.label": "What is it for? (laptop backup, CI, …)",
  "conn.s3keys.defaultLabel": "access key",
  "conn.s3keys.everyBucket": "Every bucket I can see",
  "conn.s3keys.prefix": "Folder inside the bucket (optional)",
  "conn.s3keys.mint": "Create key",
  "conn.s3keys.inheritNote": "A key can only ever narrow what you already have: your grants, your tenant, your role. Confining it to one bucket or folder is the difference between a laptop backup and a credential that can read everything.",
  "conn.s3keys.once": "Copy the secret now — this is the only time it is shown.",
  "conn.s3keys.accessKeyID": "Access key ID",
  "conn.s3keys.secret": "Secret key",
  "conn.s3keys.dismiss": "I have copied it",
  "conn.s3keys.col.label": "Label",
  "conn.s3keys.col.key": "Access key ID",
  "conn.s3keys.col.scope": "Limited to",
  "conn.s3keys.col.lastUsed": "Last used",
  "conn.s3keys.scopeAll": "everything you can see",
  "conn.s3keys.noLabel": "(no label)",
  "conn.s3keys.neverUsed": "never",
  "conn.s3keys.enable": "Enable",
  "conn.s3keys.disable": "Disable",
  "conn.s3keys.revoke": "Revoke",
  "conn.s3keys.confirm": "Sure?",
  "conn.s3keys.empty": "No access keys yet.",
  "conn.guide.s3.summary": "The S3 endpoint makes filex the destination for anything that speaks S3 — backups, sync tools, SDKs — using the storages you already have.",
  "conn.guide.s3.keyPlaceholder": "create a key above",
  "conn.guide.s3.secretPlaceholder": "shown once, when you create the key",
  "conn.guide.s3.fact.endpoint": "Endpoint",
  "conn.guide.s3.fact.endpointHint": "Point the client here, not at the web address of filex.",
  "conn.guide.s3.fact.bucket": "Bucket",
  "conn.guide.s3.fact.bucketHint": "A bucket is a filex storage. Buckets are created by an administrator, not by the client.",
  "conn.guide.s3.fact.key": "Access key ID",
  "conn.guide.s3.fact.keyHint": "The public half. It travels in every request.",
  "conn.guide.s3.fact.secret": "Secret key",
  "conn.guide.s3.fact.secretHint": "Shown once, when the key is created. filex cannot show it again — create a new key if it is lost.",
  "conn.guide.s3.fact.region": "Region",
  "conn.guide.s3.fact.regionHint": "filex has no regions; any value works and is echoed back. Clients still insist on one.",
  "conn.guide.s3.fact.addressing": "Addressing",
  "conn.guide.s3.fact.pathStyle": "path-style (required)",
  "conn.guide.s3.fact.pathStyleHint": "There is no dedicated S3 host on this install, so bucket.host does not resolve.",
  "conn.guide.s3.fact.virtualHosted": "virtual-hosted or path-style",
  "conn.guide.s3.fact.virtualHostedHint": "This install has its own S3 host, so both styles work.",
  "conn.guide.s3.rclone.useCaption": "Use it",
  "conn.guide.s3.rclone.mtime": "filex carries the file modification time (x-amz-meta-mtime), so rclone sync settles after the first run instead of re-uploading everything.",
  "conn.guide.s3.aws.configureCaption": "Configure once",
  "conn.guide.s3.aws.useCaption": "Use it",
  "conn.guide.s3.aws.pathStyle": "Add path addressing to your AWS config, or every command fails at DNS.",
  "conn.guide.s3.restic.envCaption": "Environment",
  "conn.guide.s3.restic.useCaption": "Back up, verify, prune",
  "conn.guide.s3.restic.verified": "Verified against this endpoint: restic check --read-data reads every pack byte for byte and reports no errors.",
  "conn.guide.s3.mc.aliasCaption": "Add the alias",
  "conn.guide.s3.mc.useCaption": "Use it",
  "conn.guide.s3.s3fs.credsCaption": "Credentials file",
  "conn.guide.s3.s3fs.mountCaption": "Mount it",
  "conn.guide.s3.s3fs.note": "Editing a file over s3fs rewrites the whole object, and a delete goes to the filex trash. Good for a shared folder, not for a database.",
  "conn.guide.s3.duck.s1": "New bookmark → Amazon S3.",
  "conn.guide.s3.duck.s2": "Server: {host}.",
  "conn.guide.s3.duck.s3": "Access key ID: {key}, secret as above.",
  "conn.guide.s3.duck.s4": "Open the bookmark; the buckets are your filex storages.",
  "conn.guide.s3.duck.pathStyle": 'In Preferences → S3, turn OFF "Use virtual host style" — this install has no wildcard S3 host.',
  "conn.guide.s3.sdk.note": "Any SigV4 client works the same way: endpoint, key, secret, and path addressing when this install has no S3 host of its own.",
  "conn.guide.s3.note.buckets": "A bucket is a filex storage. A client can create folders and objects inside one, but not the bucket itself — that needs a driver and a path, which an S3 request cannot express.",
  "conn.guide.s3.note.permissions": 'The key sees exactly what you see. A bucket you may not open answers "no such bucket" rather than "forbidden", so the endpoint never reveals what exists.',
  "conn.guide.s3.note.trash": "A delete goes to the filex trash, the same as everywhere else, and is recoverable until the retention policy sweeps it.",
  "conn.guide.s3.note.mtime": "Uploads carry their modification time, and the checksums clients send (Content-MD5, x-amz-checksum-*) are verified — a corrupted upload is refused rather than stored.",
  "conn.guide.s3.note.pathStyle": "This install has no dedicated S3 host, so clients must be told to use path-style addressing. Without it a current SDK fails at DNS with an error that names neither filex nor the cause.",
  "conn.guide.s3.note.http": "This endpoint is plain http://. Signatures still protect the request, but the objects travel in the clear. Put filex behind TLS before pointing a backup at it.",
  // ── SFTP endpoint: keys and the guide ────────────────────────────
  "conn.sshkeys.title": "SSH keys",
  "conn.sshkeys.lead": "Register a public key and every SSH client — sftp, scp, WinSCP, FileZilla, rclone, sshfs — can connect without sending your password.",
  "conn.sshkeys.disabled": "The SFTP endpoint is switched off on this server (FILEX_SFTP). A key registered here will not connect until an operator turns it back on.",
  "conn.sshkeys.cannotAdd": "You are not signed in with an account that can register keys.",
  "conn.sshkeys.paste": "Paste the contents of ~/.ssh/id_ed25519.pub",
  "conn.sshkeys.name": "Name (optional — the key comment is used otherwise)",
  "conn.sshkeys.add": "Add key",
  "conn.sshkeys.noCopyId": "ssh-copy-id cannot work here: it appends to ~/.ssh/authorized_keys over a shell, and filex has none. This box is the way in.",
  "conn.sshkeys.col.name": "Name",
  "conn.sshkeys.col.fingerprint": "Fingerprint",
  "conn.sshkeys.col.added": "Added",
  "conn.sshkeys.col.lastUsed": "Last used",
  "conn.sshkeys.noName": "(no name)",
  "conn.sshkeys.neverUsed": "never",
  "conn.sshkeys.enable": "Enable",
  "conn.sshkeys.disable": "Disable",
  "conn.sshkeys.remove": "Remove",
  "conn.sshkeys.confirm": "Sure?",
  "conn.sshkeys.empty": "No keys yet. Without one, clients sign in with your account password.",
  "conn.guide.sftp.summary": "SFTP makes filex reachable by anything that already speaks SSH — a backup job, a scanner, WinSCP, rclone, or a mounted folder.",
  "conn.guide.sftp.fact.host": "Host",
  "conn.guide.sftp.fact.hostHint": "The same machine as the web app, on a port of its own.",
  "conn.guide.sftp.fact.port": "Port",
  "conn.guide.sftp.fact.portHint": "Not 22 and not 443: SFTP is raw TCP and cannot go through the web proxy.",
  "conn.guide.sftp.fact.userHint": "Your username. An @ in it would have to be quoted in most client config files, which is what the username avoids.",
  "conn.guide.sftp.fact.auth": "Sign in with",
  "conn.guide.sftp.fact.authKey": "your registered SSH key (or your password)",
  "conn.guide.sftp.fact.authPassword": "your account password — or register a key above",
  "conn.guide.sftp.fact.authHint": "An API key works as a password too, and is revocable on its own. An account with two-factor sign-in must use an SSH key or an API key.",
  "conn.guide.sftp.fact.path": "Path",
  "conn.guide.sftp.fact.pathHint": "The first folder is a storage; the root lists the ones you may open.",
  "conn.guide.sftp.openssh.connectCaption": "Connect, put, get",
  "conn.guide.sftp.openssh.noShell": "There is no shell here — only the SFTP subsystem. `ssh host command` is refused on purpose, and scp works because OpenSSH 9 speaks SFTP for it.",
  "conn.guide.sftp.key.tab": "Set up a key",
  "conn.guide.sftp.key.s1": "Generate a key pair on the machine that will connect (skip if you already have one).",
  "conn.guide.sftp.key.s2": "Copy the PUBLIC half — the .pub file, never the other one.",
  "conn.guide.sftp.key.s3": "Paste it into the box above and connect; no password is sent from then on.",
  "conn.guide.sftp.key.genCaption": "On your own machine",
  "conn.guide.sftp.key.noCopyId": "ssh-copy-id will NOT work against filex: it needs a shell to append to ~/.ssh/authorized_keys, and there is none. Paste the key above instead.",
  "conn.guide.sftp.winscp.s1": "New site → File protocol: SFTP.",
  "conn.guide.sftp.winscp.s2": "Host name: {host}, port: {port}.",
  "conn.guide.sftp.winscp.s3": "User name: {user}. For a key: Advanced → SSH → Authentication → private key file.",
  "conn.guide.sftp.winscp.s4": "WinSCP needs a .ppk private key — use its own tool (Tools → PuTTYgen) to convert an OpenSSH key once.",
  "conn.guide.sftp.filezilla.s1": "File → Site Manager → New site, Protocol: SFTP.",
  "conn.guide.sftp.filezilla.s2": "Host: {host}, port: {port}.",
  "conn.guide.sftp.filezilla.s3": "User: {user}. Logon type: Normal for a password, or Key file for a key.",
  "conn.guide.sftp.rclone.useCaption": "Use it",
  "conn.guide.sftp.sshfs.mountCaption": "Mount and unmount",
  "conn.guide.sftp.sshfs.note": "A mounted folder rewrites the whole file on every save. Good for documents, not for a database or a video you are editing in place.",
  "conn.guide.sftp.note.storages": "The root is not a home directory: it lists the storages you may open, and the first path segment names one.",
  "conn.guide.sftp.note.permissions": "The permission bits your client draws come from your access level here, so a file shown as read-only really is one for you.",
  "conn.guide.sftp.note.trash": "A delete goes to the filex trash, the same as everywhere else, and is recoverable until the retention policy sweeps it.",
  "conn.guide.sftp.note.totp": "If your account has two-factor sign-in, the password will not work here — SSH has no way to ask for the code. Register an SSH key, or use an API key as the password.",
  "conn.guide.sftp.note.disabled": "The SFTP endpoint is switched off on this server. These instructions will work once an operator enables it.",
  // ── FTPS ─────────────────────────────────────────────────────────
  "conn.guide.ftps.summary": "FTPS is here for the equipment that only ever learned FTP — scan-to-folder printers, EDI counterparties, older lab and industrial software. Always over TLS.",
  "conn.guide.ftps.fact.host": "Host",
  "conn.guide.ftps.fact.hostHint": "The same machine as the web app, on a port of its own.",
  "conn.guide.ftps.fact.port": "Port",
  "conn.guide.ftps.fact.portHint": "The control channel. Data moves on a separate port from the passive range below.",
  "conn.guide.ftps.fact.mode": "Encryption",
  "conn.guide.ftps.fact.modeValue": "FTPS — explicit TLS (AUTH TLS), required",
  "conn.guide.ftps.fact.modeHint": 'Plain FTP is refused before the password is read. Choose "Require explicit FTP over TLS", never "plain FTP" and never "implicit".',
  "conn.guide.ftps.fact.userHint": "Your username, or your email. An API key works as the password too and can be revoked on its own.",
  "conn.guide.ftps.fact.passwordHint": "Your account password, or an API key. An account with two-factor sign-in must use an API key — FTP has no way to ask for the code.",
  "conn.guide.ftps.fact.pasv": "Passive ports",
  "conn.guide.ftps.fact.pasvHint": "Data connections land here. If your firewall blocks this range the transfer HANGS with no error on either side — that is the classic FTP failure.",
  "conn.guide.ftps.filezilla.s1": "File → Site Manager → New site, Protocol: FTP.",
  "conn.guide.ftps.filezilla.s2": "Host: {host}, port: {port}.",
  "conn.guide.ftps.filezilla.s3": 'Encryption: "Require explicit FTP over TLS". Logon type: Normal, user: {user}.',
  "conn.guide.ftps.filezilla.s4": "Transfer settings → Passive. Active mode is refused by this server.",
  "conn.guide.ftps.winscp.s1": "New site → File protocol: FTP, Encryption: TLS/SSL Explicit encryption.",
  "conn.guide.ftps.winscp.s2": "Host name: {host}, port: {port}.",
  "conn.guide.ftps.winscp.s3": "User name: {user}, password as above.",
  "conn.guide.ftps.curl.caption": "Upload and download",
  "conn.guide.ftps.curl.sslReqd": "--ssl-reqd is not optional: it makes curl REQUIRE TLS instead of falling back to plaintext. This server refuses plaintext anyway, but the habit protects you against the servers that do not.",
  "conn.guide.ftps.lftp.caption": "Connect",
  "conn.guide.ftps.lftp.protectData": "ssl-protect-data encrypts the FILE as well as the sign-in. Without it lftp signs in over TLS and then sends your file in the clear — which is the FTPS misconfiguration people actually ship.",
  "conn.guide.ftps.rclone.useCaption": "Use it",
  "conn.guide.ftps.printer.tab": "Scanner / printer",
  "conn.guide.ftps.printer.s1": "In the device's scan-to-FTP settings: server {host}, port {port}.",
  "conn.guide.ftps.printer.s2": "User: {user}, password as above. Create an API key for the device rather than using your own password — it can be revoked without changing anything else.",
  "conn.guide.ftps.printer.s3": "Path: {path} — or a folder inside it that you created first. The device cannot create a storage.",
  "conn.guide.ftps.printer.s4": 'Turn ON "SSL/TLS" or "FTPS explicit", and PASSIVE mode.',
  "conn.guide.ftps.printer.noTLS": "Plenty of scan-to-FTP firmware cannot do TLS at all. This server will not talk to such a device, and that is deliberate — the alternative is your documents and your password crossing the office network in the clear.",
  "conn.guide.ftps.note.tls": "TLS is mandatory and there is no switch to turn it off. Plain FTP sends your password in the clear and your file after it.",
  "conn.guide.ftps.note.passive": "Passive mode only. Active mode has the server dial back to the client, which does not survive NAT and is blocked by most firewalls.",
  "conn.guide.ftps.note.storages": "The root is not a home directory: it lists the storages you may open, and the first path segment names one.",
  "conn.guide.ftps.note.trash": "A delete goes to the filex trash, the same as everywhere else, and is recoverable until the retention policy sweeps it.",
  "conn.guide.ftps.note.prefer": "If the client can speak SFTP, prefer it: one connection, one port, no passive-mode surprises.",
  "conn.guide.ftps.note.selfSigned": "This server is using a self-signed certificate. It encrypts the channel but proves nothing about who is on the other end — most clients will ask you to accept it once. Supply a real certificate for anything that matters.",
  "conn.guide.ftps.note.disabled": "The FTPS endpoint is switched off on this server. These instructions will work once an operator enables it.",
  // ── NFS ──────────────────────────────────────────────────────────
  "conn.nfs.title": "NFS exports",
  "conn.nfs.lead": "An export lets a machine on your network mount filex as a drive — a media player, a build server, a backup box.",
  "conn.nfs.pathIsSecret": "⚠ The export path IS the password. NFS cannot ask a client who it is without Kerberos, so filex puts 32 random bytes in the path instead: whoever knows it can mount as you. Treat the mount line like a credential — /etc/fstab is world-readable on most systems.",
  "conn.nfs.disabled": "The NFS endpoint is switched off on this server (FILEX_NFS). An export created here will not mount until an operator turns it back on.",
  "conn.nfs.cannotMint": "You are not signed in with an account that can create exports.",
  "conn.nfs.label": "What is it for? (media player, backup box, …)",
  "conn.nfs.defaultLabel": "nfs export",
  "conn.nfs.everyStorage": "Every storage I can see",
  "conn.nfs.prefix": "Folder inside the storage (optional)",
  "conn.nfs.allowCidrs": "Allowed addresses, e.g. 192.168.1.0/24 (optional)",
  "conn.nfs.readOnly": "Read-only",
  "conn.nfs.readOnlyHint": "Read-only is the safer default for a machine: it refuses every write through this mount whatever your own permissions are. An address list narrows it further — outside it, the mount is refused.",
  "conn.nfs.mint": "Create export",
  "conn.nfs.once": "Copy this now — the path is shown only once and cannot be recovered.",
  "conn.nfs.dismiss": "I have copied it",
  "conn.nfs.col.label": "Label",
  "conn.nfs.col.scope": "Limited to",
  "conn.nfs.col.mode": "Mode",
  "conn.nfs.col.lastUsed": "Last mounted",
  "conn.nfs.scopeAll": "everything you can see",
  "conn.nfs.modeRead": "read-only",
  "conn.nfs.modeWrite": "read/write",
  "conn.nfs.noLabel": "(no label)",
  "conn.nfs.neverUsed": "never",
  "conn.nfs.enable": "Enable",
  "conn.nfs.disable": "Disable",
  "conn.nfs.revoke": "Revoke",
  "conn.nfs.confirm": "Sure?",
  "conn.nfs.empty": "No exports yet.",
  "conn.guide.nfs.summary": "NFS mounts filex as a drive on a machine in your own network — the NAS protocol, for the devices that expect one.",
  "conn.guide.nfs.pathPlaceholder": "create an export above",
  "conn.guide.nfs.fact.host": "Host",
  "conn.guide.nfs.fact.hostHint": "The same machine as the web app, on a port of its own.",
  "conn.guide.nfs.fact.port": "Port",
  "conn.guide.nfs.fact.portHint": "Both port= and mountport= must be set to this; filex serves the mount and NFS services on one port.",
  "conn.guide.nfs.fact.export": "Export path",
  "conn.guide.nfs.fact.exportHint": "This is the credential. It is shown once, when you create the export, and is stored hashed — filex cannot show it again.",
  "conn.guide.nfs.fact.options": "Mount options",
  "conn.guide.nfs.fact.optionsHint": "nolock because filex does not run the NFS lock manager; nfsvers=3 because that is what this server speaks.",
  "conn.guide.nfs.linux.mountCaption": "Mount it",
  "conn.guide.nfs.linux.fstabSecret": "An /etc/fstab line containing this path is a password in a world-readable file. Use a credentials-protected automount, or keep the mount in a root-only unit, if that matters where you are.",
  "conn.guide.nfs.mac.mountCaption": "Mount it",
  "conn.guide.nfs.mac.resvport": "macOS needs resvport: its client insists on a privileged source port and refuses the mount without it.",
  "conn.guide.nfs.win.s1": 'Turn on "Services for NFS" → "Client for NFS" in Windows Features (Pro and Enterprise only; Home does not have it).',
  "conn.guide.nfs.win.s2": "Open a Command Prompt as administrator.",
  "conn.guide.nfs.win.s3": "Map the export to a drive letter with the command below.",
  "conn.guide.nfs.win.cmdCaption": "Map it to Z:",
  "conn.guide.nfs.win.port": "Windows has no way to say which port the mount service is on, so it can only reach an NFS server on the standard port 2049. If this server is on another port, use SFTP or the filex desktop app instead.",
  "conn.guide.nfs.nas.tab": "NAS / media player",
  "conn.guide.nfs.nas.s1": "In the device's NFS settings: server {host}, port {port} (set both the NFS and the mount port if it asks for them separately).",
  "conn.guide.nfs.nas.s2": "Remote path: the export path above, exactly as shown.",
  "conn.guide.nfs.nas.s3": "NFS version 3, no locking. Create the export read-only unless the device genuinely needs to write.",
  "conn.guide.nfs.note.unencrypted": "NFSv3 is not encrypted. Anyone who can read the traffic sees your files, and anyone who learns the path can mount them. Use it on a home or office network, or over a VPN — never across the internet.",
  "conn.guide.nfs.note.pathIsSecret": "The export path is the whole credential. Revoke it from the list above if it leaks; there is nothing else to change.",
  "conn.guide.nfs.note.noPortmapper": "There is no portmapper on port 111, so a client that is not told the port cannot find the server. That is why every command here carries port= and mountport=.",
  "conn.guide.nfs.note.uid": "The user and group ids your client sends are ignored: the mount already knows whose it is. The permissions you see come from your access in filex.",
  "conn.guide.nfs.note.trash": "A delete goes to the filex trash, the same as everywhere else, and is recoverable until the retention policy sweeps it.",
  "conn.guide.nfs.note.revoke": "Revoking takes effect on the next request, not instantly: NFS has no session to end, so a client with the mount open sees its next operation fail.",
  "conn.guide.nfs.note.disabled": "The NFS endpoint is switched off on this server. These instructions will work once an operator enables it.",
  "conn.tokens.title": "API keys",
  "conn.tokens.lead": "FTPS, WebDAV and filex mount all sign in with an API key instead of your account password. Create one here — it can be revoked on its own, and an account with two-factor sign-in cannot use its password on these at all.",
  "conn.tokens.mint": "Create API key",
  "conn.tokens.once": "Copy it now — this is the only time it is shown. Only a hash is stored, so it cannot be shown again.",
  "conn.tokens.dismiss": "I have copied it",
  "conn.tokens.cannotMint": "This session cannot create API keys. Sign in with your own account to create one.",
  "conn.tokens.empty": "No API keys yet.",
  "conn.tokens.neverUsed": "never",
  "conn.tokens.revoke": "Revoke",
  "conn.tokens.confirm": "Sure?",
  "conn.tokens.col.label": "Name",
  "conn.tokens.col.scopes": "Permissions",
  "conn.tokens.col.used": "Last used",
  "conn.tokens.revokeHint": "Revoking stops a connection that is already open, not just the next sign-in: an SFTP or FTPS session is cut and a mount stops working within about half a minute.",
  "conn.guide.mount.summary": "filex mount attaches a remote filex server to a folder on this machine, over the same HTTPS the browser uses. It is the only one of these that works from anywhere — no LAN, no extra server, no third-party client.",
  "conn.guide.mount.fact.url": "Server URL",
  "conn.guide.mount.fact.urlHint": "The same address you use in the browser. Nothing else has to be reachable.",
  "conn.guide.mount.fact.token": "API key",
  "conn.guide.mount.fact.tokenPlaceholder": "create one under API keys",
  "conn.guide.mount.fact.tokenHint": "An API key, not your password — it can be revoked on its own, and an account with 2FA cannot use its password here at all.",
  "conn.guide.mount.fact.remote": "What to mount",
  "conn.guide.mount.fact.remoteHint": "Leave --remote off to see every storage as a folder, or name one storage — or a folder inside it — to mount just that.",
  "conn.guide.mount.linux.mountCaption": "Mount it",
  "conn.guide.mount.linux.umountCaption": "Unmount it",
  "conn.guide.mount.linux.umountWarn": "Unmount with fusermount, not by killing the process. A mount whose process died without detaching leaves a folder where every ls hangs until somebody runs fusermount by hand.",
  "conn.guide.mount.linux.systemdCaption": "Mount it at sign-in (systemd user unit)",
  "conn.guide.mount.win.winfsp": "Windows needs WinFsp installed once — it is free and open source: https://winfsp.dev. Nothing else, and no administrator rights after that.",
  "conn.guide.mount.win.mountCaption": "Mount it as a drive",
  "conn.guide.mount.win.freeLetter": "Pick a drive letter that is FREE. The letter is created by the mount, not attached to something that already exists, and pointing it at one that is in use fails with a message that does not say so.",
  "conn.guide.mount.win.stop": "Stop it with Ctrl-C in that window. The drive disappears and nothing is left behind on this machine.",
  "conn.guide.mount.mac.unsupported": "filex mount does not work on macOS. It needs macFUSE, whose license does not allow a program like filex to install it for you, and whose Go binding needs a C compiler filex deliberately does not require. The command refuses here rather than appearing to work and doing nothing.",
  "conn.guide.mount.mac.alternatives": "On macOS, use the filex desktop app with folder sync (keeps the files on disk), or SFTP with a client that mounts drives.",
  "conn.guide.mount.note.notASync": "This is not a sync. Nothing is copied to this machine except a small read cache, so a mount opens one file out of a hundred thousand without downloading the rest. If you want the files when you are offline, use folder sync instead.",
  "conn.guide.mount.note.reachable": "It reaches the server through whatever proxy or tunnel the browser goes through, because underneath it is the same API. Your permissions, your storages and — on a multi-tenant server — your tenant come with it.",
  "conn.guide.mount.note.wholeFileWrites": "A file you write through the mount is uploaded when the program closes it, not while it is being written. Editing a very large file in place is slower here than a local disk; copying it in and out is not.",
  "conn.guide.mount.note.trash": "A delete goes to the filex trash, the same as everywhere else, and is recoverable until the retention policy sweeps it.",
  "conn.guide.mount.note.revoke": "Revoke the API key to stop a mount. It stops serving within half a minute, even if the mount is still attached.",
  "storages.driver.ftp": "FTP / FTPS",
  "storages.driver.local": "Local filesystem",
  "storages.driver.s3": "S3 / Hetzner / MinIO",
  "storages.driver.sftp": "SFTP",
  "storages.driver.smb": "SMB / CIFS (NAS)",
  "storages.driver.webdav": "WebDAV",
  "storages.fieldHelp.smbShare": "The share name alone, without the server: `media`, not `\\\\nas\\media`.",
  "storages.fieldHelp.smbDomain": "Only for a Windows domain account. Leave empty for a NAS.",
  "storages.fieldHelp.smbRoot": "Sub-folder inside the share. Leave empty for the whole share.",
  "storages.fields.share": "Share",
  "storages.fields.domain": "Domain / workgroup",
  "storages.fields.dialTimeout": "Connect timeout (seconds)",
  "storages.fieldHelp.disablePresign": "On by default: uploads and the downloads behind public share links stream through filex, so the bucket endpoint never has to be reachable from a browser (a LAN-only MinIO just works). Turn it off only when the endpoint is reachable from your users' browsers (AWS, a public MinIO) and you want them to talk to the bucket directly — faster for very large files, and the store must accept SDK-signed URLs (Ceph RGW / some Hetzner setups answer SignatureDoesNotMatch).",
  "storages.fieldHelp.endpoint": "Leave empty for AWS S3. Any S3-compatible store needs its endpoint.",
  "storages.fieldHelp.hostKey": "A single public key in authorized_keys / known_hosts line form.",
  "storages.fieldHelp.insecureSkipHostKey": "Accepts any host key. Only for throwaway hosts.",
  "storages.fieldHelp.keyPath": "Path to a key file on the server, read when the storage starts. Used when the PEM field is empty.",
  "storages.fieldHelp.knownHosts": "OpenSSH known_hosts path for strict host-key checking. Default is trust-on-first-use in ~/.filex/known_hosts.",
  "storages.fieldHelp.passive": "Off switches to active mode, which needs the server to dial back into this host.",
  "storages.fieldHelp.path": "Directory on the server. It is created if missing; filex never mounts /.",
  "storages.fieldHelp.pathStyle": "On for every non-AWS store. It is turned on automatically when an endpoint is set and this was never touched.",
  "storages.fieldHelp.prefix": "Sub-folder inside the bucket. Required: filex never takes ownership of the bucket root.",
  "storages.fieldHelp.region": 'Defaults to "auto" when left empty.',
  "storages.fieldHelp.root": "Sub-folder on the backend. Required: filex never mounts the account root.",
  "storages.fieldHelp.sftpAuth": "Either a password or a private key is required.",
  "storages.fieldHelp.tls": "Plain FTP sends credentials in the clear — turn this on whenever the server supports it.",
  "storages.fields.accessKey": "Access key",
  "storages.fields.basePath": "Base path",
  "storages.fields.bucket": "Bucket",
  "storages.fields.disablePresign": "Stream transfers through filex",
  "storages.fields.endpoint": "Endpoint",
  "storages.fields.host": "Host",
  "storages.fields.hostKey": "Pinned host key",
  "storages.fields.insecureSkipHostKey": "Skip host-key verification (insecure)",
  "storages.fields.keyPath": "Private key file",
  "storages.fields.knownHosts": "known_hosts file",
  "storages.fields.name": "Display name",
  "storages.fields.namePlaceholder": "Personal photos",
  "storages.fields.passive": "Passive mode (PASV)",
  "storages.fields.password": "Password",
  "storages.fields.path": "Filesystem path",
  "storages.fields.pathStyle": "Use path-style URLs (Hetzner, MinIO)",
  "storages.fields.port": "Port",
  "storages.fields.prefix": "Prefix",
  "storages.fields.privateKey": "Private key (PEM)",
  "storages.fields.rbac": "Per-item access control (RBAC)",
  "storages.fields.rbacHint": "When on, non-admins see only the files and folders granted to them (listed under Folder access). When off, everyone opens the storage according to their role.",
  "storages.fields.readOnly": "Read-only mount",
  "storages.fields.region": "Region",
  "storages.fields.root": "Base path",
  "storages.fields.secretKey": "Secret key",
  "storages.fields.tls": "FTPS (explicit AUTH TLS)",
  "storages.fields.url": "Base URL",
  "storages.fields.user": "User",
  "storages.fields.s3AttemptTimeout": "Attempt timeout (seconds)",
  "storages.fields.s3MaxAttempts": "Attempts per request",
  "storages.fields.s3TotalTimeout": "Give up after (seconds)",
  "storages.fieldHelp.s3AttemptTimeout": "How long one attempt may wait for a sign of life from the store: connecting, the TLS handshake, the answer after the request is sent, and each next piece of the answer. A transfer that keeps moving is never cut, however long it takes; an upload the store stops taking is cut after 60 seconds, or after this if it is longer. Copies and renames wait up to 10 minutes for the answer, because the store answers them only when the copy is done.",
  "storages.fieldHelp.s3MaxAttempts": "How many times a request is tried in all when the failure can pass: a network error, a timeout, a 5xx answer, throttling. 1 turns retrying off. A refusal (403, a missing bucket, a host name that does not resolve) is never retried.",
  "storages.fieldHelp.s3TotalTimeout": "No new attempt starts unless it could finish within this many seconds of the first, so an upload or a listing on a store that is down reports the outage within this time. A transfer that is under way is not cut. A request that timed out is tried again only when this is at least twice the attempt timeout.",
  "storages.fields.attemptTimeout": "Attempt timeout (seconds)",
  "storages.fields.maxAttempts": "Attempts per request",
  "storages.fields.totalTimeout": "Give up after (seconds)",
  "storages.fieldHelp.attemptTimeout": "How long one attempt may wait for a sign of life from the server: connecting, logging in, the answer to each request, and each next piece of a transfer. A transfer that keeps moving is never cut, however long it takes; an upload the server stops taking is cut after 60 seconds, or after this if it is longer.",
  "storages.fieldHelp.webdavAttemptTimeout": "How long one attempt may wait for a sign of life from the server: connecting, logging in, the answer to each request, and each next piece of a transfer. A transfer that keeps moving is never cut, however long it takes; an upload the server stops taking is cut after 60 seconds, or after this if it is longer. Copies, moves and deletes wait up to 10 minutes for the answer, because the server answers them only when the work is done.",
  "storages.fieldHelp.maxAttempts": "How many times a request is tried in all when the failure can pass: the connection is refused or drops, no answer comes in time, the server answers that it is unavailable (5xx). 1 turns retrying off. A refusal (a wrong password, a missing folder, a certificate that does not verify) is never retried, and neither is an upload that has started sending.",
  "storages.fieldHelp.totalTimeout": "No new attempt starts unless it could finish within this many seconds of the first, so a server that is down is reported within this time. A transfer that is under way is not cut. A request that timed out is tried again only when this is at least twice the attempt timeout.",
  /* === gezinti:g1 — navigation panel (SideNav) === */
  "sidenav.title": "Navigation",
  "sidenav.views": "Views",
  "sidenav.storages": "Storages",
  "sidenav.home": "Home",
  "sidenav.myfiles": "My files",
  "sidenav.recent": "Recent",
  "sidenav.starred": "Starred",
  "sidenav.shared": "Shared with me",
  // The mirror of the row above, and it sits right under it: what came in,
  // and what went out. ⚠ "My shares", not "Shared by me" — the page lists
  // LINKS the person minted, not files they granted somebody access to.
  "sidenav.myshares": "My shares",
  "sidenav.trash": "Trash",
  "sidenav.collapse": "Collapse navigation",
  "sidenav.expand": "Expand navigation",
  "sidenav.close": "Close navigation",
  // ⚠ `open`/`close` are the DRAWER's pair, `expand`/`collapse` the docked
  // panel's, and they are not interchangeable — see the note on
  // `navToggleLabel` in Toolbar.vue. Below 560px the panel is a drawer over
  // the listing: it is not narrowed to a rail, it is not on screen at all, so
  // "expand" would promise a width change to something that has no width.
  "sidenav.open": "Open navigation",
  "sidenav.storage.shared": "Shared",
  "sidenav.storage.readOnly": "Read-only",
  // #57 — a storage row's order menu (right click, a long press, Shift+F10).
  // "Sort by name" writes an order the person can keep adjusting; it is not a
  // mode. "Use default order" lets the person's own order go: the panel then
  // follows the administrator's order (or, with none, the server's). The two
  // `.done`/`.none` lines are the reason a greyed row gives.
  "sidenav.storage.moveUp": "Move up",
  "sidenav.storage.moveDown": "Move down",
  "sidenav.storage.sortName": "Sort by name",
  "sidenav.storage.sortName.done": "Already sorted by name",
  "sidenav.storage.defaultOrder": "Use default order",
  "sidenav.storage.defaultOrder.none": "Already in the default order",
  // ⚠ `toolbar.nav` is GONE, and nothing replaced it. It was the one label on
  // the panel's collapse control, first as the noun "Navigation" — which names
  // the panel and never says the button does anything to it, so the owner
  // could not find how to collapse the panel (2026-09-13: "yan menüyü kısıp
  // açabilir olalım ya bence") — and then as the static stopgap "Show or hide
  // navigation". The four `sidenav.*` verbs above are the real fix: the label
  // is bound to `navOpen`, so it says *collapse* when it will collapse and
  // *expand* when it will expand.
  "node.home": "Home",
  "node.recent": "Recent",
  "node.starred": "Starred",
  "node.shared": "Shared with me",
  "empty.recent.title": "Nothing opened yet",
  "empty.recent.hint": "Files you open show up here",
  "empty.starred.title": "Nothing starred yet",
  "empty.starred.hint": "Star a file to find it here",
  "empty.shared.title": "Nothing has been shared with you",
  "empty.shared.hint": "Folders and files other people share appear here",
  /* etiket:t1 */
  "sidenav.tags": "Tags",
  "sidenav.tags.empty": "No tags yet — add one from a file’s right-click menu.",
  "sidenav.tags.more": "Show {count} more",
  "sidenav.tags.less": "Show fewer",
  "sidenav.tags.personal": "Personal",
  "sidenav.tags.team": "Team",
  "empty.tag.title": "Nothing is tagged “{tag}”",
  "empty.tag.hint": "Right-click a file and choose Tags to put it here",
  "sidenav.connections": "Connections",
  "sidenav.apps": "Apps",
  "sidenav.connect": "How to connect",
  "sidenav.apikeys": "API keys",
  "overlay.close": "Close",
  "conn.tokens.scopes": "Permissions",
  "conn.tokens.root": "Limit to one folder (optional)",
  "conn.tokens.rootPlaceholder": "storage://folder",
  "conn.tokens.expiry": "Expires in (days)",
  "conn.tokens.expiryNever": "never",
  "conn.tokens.defaultName": "API key {date}",
  "conn.tokens.namePlaceholder": "Name — e.g. backup script",
  "conn.tokens.capNote": "Your own access is the ceiling — a permission you do not have is refused, not granted.",
  "conn.tokens.scopesRequired": "Choose at least one permission — an API key is never issued with none.",
  /* === /gezinti:g1 === */
  /* === surucu:d1 — the shell (GitHub #14); every profile, no longer a
     `uiProfile: 'drive'` opt-in === */
  "drive.new": "New",
  "drive.new.upload": "Upload files",
  "drive.new.folder": "New folder",
  "drive.new.request": "Request files",
  "drive.new.document": "New document",
  /* === belge:n1 — "New document": the picker under + New =================
     Type names are NOT listed here. A tile reads its words from
     lib/fileIcons `typeLabelFor`, the same table the listing's Type column
     uses, so ".docx" is called the same thing in both places and a new type
     needs no string at all. Only this dialog's own chrome lives below. */
  "newdoc.title": "New document",
  "newdoc.type.label": "Document type",
  "newdoc.group.document": "Documents",
  "newdoc.group.text": "Text and code",
  "newdoc.group.diagram": "Diagrams",
  "newdoc.group.app": "Apps",
  /* ⚠ One name per service, the name its own project uses: draw.io (not
     "drawio", not "diagrams.net") and ONLYOFFICE — the QA sweep of
     2026-09-21 found draw.io called three things on three screens. */
  "newdoc.withheld.onlyoffice": "Office documents need a document server (ONLYOFFICE), which is not set up here.",
  "newdoc.withheld.drawio": "Diagrams need draw.io, which is not set up here.",
  "newdoc.withheld_admin": "Set them up in the admin panel under External services.",
  "newdoc.empty.title": "No document types are available",
  "newdoc.empty.body": "This server did not offer any type this app can create.",
  "newdoc.empty.blocked": "Every type this server can create needs an editor service that is not configured here.",
  "newdoc.name": "Name",
  "newdoc.name.placeholder": "File name, e.g. notes.txt or LICENSE",
  "newdoc.untitled": "Untitled",
  "newdoc.err.slash": "A name cannot contain a slash.",
  "newdoc.err.exists": "{name} is already here. Choose another name.",
  "newdoc.err.bare_ext": "Give the file a name, not only an extension.",
  "newdoc.err.ext_needs_type": "A .{ext} file has to be created as its own type — an empty one would not open. Choose that type, or another extension.",
  "newdoc.hint.ext_added": "This type keeps its extension, so the file will be created as {name}.",
  // Drafts (issue #71): a new document is a draft until its first save.
  "sidenav.drafts": "Drafts",
  "sidenav.drafts.count": "{n} drafts",
  "sidenav.drafts.count_one": "{n} draft",
  "node.drafts": "Drafts",
  "empty.drafts.title": "No drafts",
  "empty.drafts.hint": "A new document waits here until you save it where it belongs.",
  "drafts.lead": "New documents that have not been saved yet. Only you can see them.",
  "drafts.count_of": "{n} of {limit} drafts",
  "drafts.col.target": "Save to",
  "drafts.col.storage": "Storage",
  "drafts.action.save": "Save to disk",
  "drafts.open_hint": "Open {name}",
  "drafts.no_match": "No draft matches the filter.",
  "draft.badge": "Draft",
  "draft.bar.target": "will be saved to {folder}",
  "draft.save": "Save",
  "draft.saved_to": "{name} was saved to {folder}.",
  "draft.discarded": "{name} was moved to the trash.",
  "draft.kept": "Kept in Drafts",
  "draft.editing": "Editing…",
  "draft.close.title": "Close this draft?",
  "draft.close.body": "{name} is a draft for {folder} and has not been saved there yet.",
  "draft.close.hint": "A kept draft waits in Drafts. Discard moves it to the trash.",
  "draft.close.save": "Save to disk",
  "draft.close.keep": "Keep in Drafts",
  "draft.close.discard": "Discard",
  "draft.taken.title": "A file with this name is already there",
  "draft.taken.body": "{folder} already has a file called {name}. Save the draft as {suggested} instead?",
  "draft.taken.confirm": "Save as {name}",
  "newdoc.hint.draft": "It opens as a draft: nothing is created in the folder until you save it.",
  "newdoc.err.draft_limit": "You already keep as many drafts as this server allows ({limit}). Save or delete some in Drafts first.",
  "newdoc.err.draft_limit_any": "You already keep as many drafts as this server allows. Save or delete some in Drafts first.",
  "newdoc.open_drafts": "Open Drafts",
  "err.draft_limit": "You already keep as many drafts as this server allows ({limit}). Save or delete some in Drafts.",
  "err.draft_folder_gone": "The folder this draft was meant for is not there any more.",
  "err.drafts_unavailable": "Drafts are not available here.",
  "newdoc.location": "Location",
  "newdoc.location.none": "Choose a folder",
  "newdoc.location.change": "Change",
  "newdoc.location.noaccess": "You cannot save into this folder.",
  "newdoc.create": "Create",
  "newdoc.creating": "Creating…",
  "newdoc.cancel": "Cancel",
  // ⚠ The top search field searches the WHOLE storage (and every storage at
  // the root) — never only the open folder. The scope named here is therefore
  // the storage, not the folder; "Filter in this folder…" (FilterBar) is the
  // folder-scoped one. It used to say "Search in Photos" for a folder called
  // Photos, which was a lie (2026-09-19).
  "drive.search.placeholder": "Search in {scope}",
  "drive.search.placeholder_all": "Search all storages",
  "drive.search.hint_title": "Search everywhere and run commands ({combo})",
  "drive.storage.used": "{used} of {total} used",
  "drive.storage.used_unlimited": "{used} used",
  "drive.storage.used_partial": "at least {used} used",
  "drive.storage.label": "Storage",
  /* === gorunum:v3-shell — the Home view (the overview, inside the shell) ==
   * The section headings are `sidenav.storages` / `sidenav.recent` /
   * `sidenav.starred` and the two empty states are `empty.recent.*` /
   * `empty.starred.*`, on purpose: the block headed "Recent" on Home and the
   * panel row labelled "Recent" beside it are the same thing, and a second
   * string for it is how the two drift apart one translation at a time. Only
   * what exists nowhere else is below. */
  "home.title": "Home",
  "home.storages.empty": "No storages yet",
  "home.storages.hint": "A storage is a place filex reads and writes — an administrator adds them.",
  "drive.section.folders": "Folders",
  "drive.section.files": "Files",
  "filter.aria": "Filters",
  "filter.type": "Type",
  "filter.type.any": "Any type",
  "filter.type.folder": "Folders",
  "filter.type.document": "Documents",
  "filter.type.spreadsheet": "Spreadsheets",
  "filter.type.presentation": "Presentations",
  "filter.type.pdf": "PDFs",
  "filter.type.image": "Images",
  "filter.type.video": "Videos",
  "filter.type.audio": "Audio",
  "filter.type.archive": "Archives",
  "filter.type.code": "Code",
  "filter.modified": "Modified",
  "filter.modified.any": "Any time",
  "filter.modified.today": "Today",
  "filter.modified.7d": "Last 7 days",
  "filter.modified.30d": "Last 30 days",
  "filter.modified.year": "This year",
  "filter.size": "Size",
  "filter.size.any": "Any size",
  "filter.size.lt1": "Under 1 MB",
  "filter.size.1to10": "1 - 10 MB",
  "filter.size.10to100": "10 - 100 MB",
  "filter.size.gt100": "Over 100 MB",
  /* surucu:d1-actions — the ⋮ menu at the end of the filter row. Only its own
     NAME is new: every row inside it reuses the string that verb already has
     (`toolbar.new_folder`, `toolbar.upload`, `ctx.paste`, `shortcuts.select_all`,
     `selection.clear`), because a menu that renames a command is a menu the
     reader has to learn twice. */
  "filter.actions": "Listing actions",
  "filter.clear": "Clear filters",
  "filter.empty.title": "Nothing here matches those filters",
  "filter.empty.hint": "Clear a filter, or search everywhere with the field above.",
  "filter.count": "{shown} of {total}",
  "inspector.tab.details": "Details",
  "inspector.tab.activity": "Activity",
  "inspector.people": "People with access",
  "inspector.people.you": "You",
  "inspector.people.inherited": "from a parent folder",
  "inspector.people.empty": "Only you, and anyone with a link below.",
  "inspector.people.manage": "Manage access",
  "inspector.link": "Shared link",
  "inspector.link.none": "Not shared",
  "inspector.link.create": "Create link",
  "inspector.link.copy": "Copy link",
  "inspector.activity.empty": "No activity recorded for this item yet.",
  "inspector.activity.hint": "Versions are written when a file changes; comments are written by people.",
  "inspector.activity.version": "Version {n} saved",
  "inspector.activity.comment": "Comment by {who}",
  "inspector.activity.select": "Select a file or folder to see its activity.",
  /* === /surucu:d1 === */
  /* === gorunum:v1-chrome — the filter row's name box === */
  "filter.find": "Filter in this folder…",
  /* surucu:d1-scope — the same box where the rows are not a folder's contents.
     It has to say what it narrows: at the drive list "this folder" names
     nothing, and on Home it would name three blocks at once. */
  "filter.find.storages": "Filter storages…",
  "filter.find.home": "Filter Home…",
  /* === gorunum:v1-viewer — the full-bleed overlay's own chrome === */
  "viewer.share": "Share",
  "viewer.nav_prev": "Previous file",
  "viewer.nav_next": "Next file",
  /* The counter in the top bar's meta line: "246.3 KB • Sep 9, 2026 • 1 of 9". */
  "viewer.counter": "{i} of {n}",
  "viewer.zoom_reset": "Reset zoom",
  "viewer.fullscreen": "Full screen",
  "viewer.exit_fullscreen": "Exit full screen",
  "viewer.md_placeholder": "# Markdown here…",
  /* === gorunum:v1-selbar — the selection bar that replaces the filter row === */
  "selection.count": "{n} selected",
  "selection.clear": "Clear selection",
  /* === gorunum:v1-preview — the kind, said in words ======================
     The Type column used to print the extension in caps. These are what it
     prints instead; the table that picks one is in `lib/fileIcons.ts`
     (`typeLabelKey`), so this list and that one are the only two places a
     kind is named. Anything unmapped still falls back to the uppercased
     extension — these names improve on that fallback, they do not replace
     it. `Folder` is NOT here: it is `node.folder`, which the grid card's
     caption already prints. */
  "ftype.typescript": "TypeScript",
  "ftype.javascript": "JavaScript",
  "ftype.vue": "Vue component",
  "ftype.python": "Python",
  "ftype.go": "Go",
  "ftype.rust": "Rust",
  "ftype.php": "PHP",
  "ftype.ruby": "Ruby",
  "ftype.java": "Java",
  "ftype.kotlin": "Kotlin",
  "ftype.swift": "Swift",
  "ftype.c": "C source",
  "ftype.cpp": "C++ source",
  "ftype.csharp": "C# source",
  "ftype.stylesheet": "Stylesheet",
  "ftype.html": "HTML document",
  "ftype.json": "JSON data",
  "ftype.yaml": "YAML",
  "ftype.xml": "XML",
  "ftype.toml": "TOML",
  "ftype.sql": "SQL",
  "ftype.shell": "Shell script",
  "ftype.powershell": "PowerShell script",
  "ftype.markdown": "Markdown",
  "ftype.plaintext": "Plain text",
  "ftype.log": "Log file",
  "ftype.config": "Configuration",
  "ftype.sheet": "Spreadsheet",
  "ftype.figma": "Figma design",
  "ftype.drawio": "draw.io diagram",
  "ftype.design": "Design file",
  "ftype.image": "Image",
  "ftype.video": "Video",
  "ftype.audio": "Audio",
  "ftype.pdf": "PDF document",
  "ftype.document": "Document",
  "ftype.slides": "Presentation",
  "ftype.archive": "Archive",
  "ftype.code": "Code",
  /* === gorunum:v1-advsearch — the Advanced search dialog ==================
   * Two `filter.*` keys are added here rather than beside their siblings
   * because they are new members of shared unions the dialog introduced
   * (`modified: 'around'`, `size: 'range'`); the filter row never selects
   * them, but `chipLabel` would print the raw key if one ever reached it. */
  "filter.modified.around": "Around a date",
  "filter.size.range": "Custom range",
  "advsearch.open": "Advanced search",
  "advsearch.title": "Advanced search",
  "advsearch.subtitle": "Find files by name, content, path, or tags.",
  "advsearch.close": "Close",
  "advsearch.content.heading": "Content search",
  "advsearch.viewall": "View all results",
  "advsearch.where.any_short": "Anywhere",
  "advsearch.where.here_short": "Only here",
  "advsearch.where.skip_short": "Skip this",
  "advsearch.server.legend": "What the server searches",
  "advsearch.client.legend": "Narrow the results that come back",
  "advsearch.query.label": "Words",
  "advsearch.query.placeholder": "Part of a name, or words inside a file",
  "advsearch.scope.label": "Look in",
  "advsearch.scope.name": "Names and paths",
  "advsearch.scope.content": "File contents",
  "advsearch.scope.all": "Both",
  "advsearch.scope.hint": "Contents are searched from the index, which covers text-like files up to 200 KB.",
  "advsearch.people.name_only": "Owner is read off the rows that come back, and only a name search returns rows that carry one.",
  "advsearch.scope.name_only": "Only names and paths here: a content hit reaches the explorer without the storage it came from, so content search is offered on single-storage deployments only.",
  "advsearch.tags.label": "Tags",
  "advsearch.tags.placeholder": "invoice, quarterly report",
  "advsearch.tags.exclude": "Without tags",
  "advsearch.tags.exclude_placeholder": "archive",
  "advsearch.tags.hint": "Separate with commas. Tags narrow: several tags means files carrying all of them, and a tag nobody has applied returns nothing. A name matches your personal tag and your team’s tag of that name alike.",
  "advsearch.where.label": "Folder",
  "advsearch.where.any": "Anywhere in this storage",
  "advsearch.where.here": "Only in {folder}",
  "advsearch.where.skip": "Everywhere except {folder}",
  "advsearch.around.label": "Within",
  "advsearch.around.date": "Date and time",
  "advsearch.around.h1": "1 hour",
  "advsearch.around.d1": "1 day",
  "advsearch.around.w1": "1 week",
  "advsearch.size.range_label": "Between",
  "advsearch.size.from": "From",
  "advsearch.size.to": "To",
  "advsearch.count.idle": "Type something, or pick a tag.",
  "advsearch.count.counting": "Counting…",
  "advsearch.count.result": "{n} matching items",
  "advsearch.count.capped": "{n} matching items in the first page of hits",
  "advsearch.count.result_one": "{n} matching item",
  "advsearch.count.capped_one": "{n} matching item in the first page of hits",
  "advsearch.count.error": "The count could not be run.",
  "advsearch.count.cost": "The count runs this search. Type, owner, date, size and folder narrow the results it finds.",
  "advsearch.wire": "Type this in the search box next time:",
  "advsearch.reset": "Reset",
  "advsearch.cancel": "Cancel",
  "advsearch.submit": "Search",
  /* === gorunum:v2-topbar — the page bar is gone; the explorer's own header
     and breadcrumb row carry what it used to. === */
  "breadcrumb.subfolders": "Subfolders",
  "breadcrumb.subfolders.empty": "No subfolders here",
  "header.admin": "Admin panel",
  "header.settings": "Settings",
  "header.signout": "Sign out",
  "ai.assistant": "AI assistant",
  "ai.soon": "Coming soon",
  "ai.assistant.soon": "AI assistant — coming soon",
  /* gorunum:v2-share — the Share / Permissions dialog's own chrome. The
     controls inside it keep the strings they already had; these are the new
     shell: the title, the one switch, the sentence that says who can open the
     item right now, and the three named sections it all folds into. */
  "access.title": 'Share "{name}"',
  "access.close": "Close",
  "access.done": "Done",
  "access.copy": "Copy",
  "access.copied": "Copied",
  "access.link.switch": "Link sharing",
  "access.who.private": "Only people with access can open it.",
  "access.who.link": "Anyone with the link can open it.",
  "access.who.pin": "Anyone with the link and the PIN can open it.",
  "access.who.existing": "Link sharing is on — {n} links already exist.",
  "access.who.existing_one": "Link sharing is on — {n} link already exists.",
  "access.section.link": "Link options",
  "access.section.people": "People with access",
  "access.section.drop": "Request files",
  "access.sum.pin_on": "PIN on",
  "access.sum.pin_off": "No PIN",
  "access.sum.people": "{n} people",
  "access.sum.people_one": "{n} person",
  "access.sum.people_none": "No one yet",
  "access.sum.drop": "{n} upload links",
  "access.sum.drop_one": "{n} upload link",
  "access.sum.drop_none": "No upload link",
  /* Ownership — the Owner column and the People chip. "System" is the honest
     word for a row nobody put here through filex (the scanner found it, or it
     was written straight into the bucket); it is a real answer, not a blank. */
  "col.owner": "Owner",
  "owner.you": "You",
  "owner.system": "System",
  "owner.unknown": "Unknown",
  "owner.external": "Uploaded through an upload link",
  "owner.last_actor": "Last changed by {who}",
  "filter.people": "Owner",
  "filter.people.any": "Anyone",
  "filter.people.me": "You",
  "filter.people.system": "System",
  "filter.people.someone": "Someone else",
  /* surucu:d1-sort — the listing sort control at the trailing edge of the
     filter row. The four key names are `col.*`: the menu offers exactly the
     words the list view's own column headers carry, so the two controls that
     drive one sort cannot name it differently. */
  "sort.by": "Sort by",
  "sort.asc": "Ascending",
  "sort.desc": "Descending",
  /* The order a SEARCH RESULT is in. It is not a fifth sort key — it is what
     the control prints instead of a key while the rows on screen were ranked
     by the server, so the button stops claiming a sort it is not performing.
     `_why` is the reason the control is closed, and the owner asked for the
     reason to be written rather than for the control to go quietly inert. */
  "sort.relevance": "Relevance",
  "sort.relevance_why": "Search results are listed by how well they match. Your sort comes back when you leave the search.",
  /* === tablo:t1 — the table's own configuration ==========================
     Since v0.43 everything about how a folder looks — view, sort AND columns —
     belongs to the folder it was changed in; a folder nobody changed opens
     with the person's default (their settings), else the instance's.
     `folder_hint` is that rule in one sentence, written where the person who
     is about to be surprised by it can read it. */
  "col.location": "Location",
  "col.deleted": "Deleted",
  "col.deleted_from": "Deleted from",
  "col.deleted_by": "Deleted by",
  "col.remaining": "Time left",
  "cols.menu": "Column options",
  "cols.title": "Columns",
  "cols.resize": "Resize {col}",
  "cols.move_left": "Move {col} left",
  "cols.move_right": "Move {col} right",
  "cols.reset": "Reset columns",
  "cols.folder_title": "Folder view",
  "cols.folder_hint": "A change you make here stays in this folder. Folders you have never changed open with your default view (Settings → Default folder view).",
  "cols.forget_folder": "Forget this folder's view",
  "cols.apply_all": "Make this my default for all folders ({count} remembered)",
  /* === tablo:t3 — THE ONE TABLE (components/DataTable.vue) ================
     Every table in the product speaks these, so a column menu or a pager is
     never the one English thing on a Turkish page. */
  "table.empty": "Nothing here yet",
  "table.prev": "Previous page",
  "table.next": "Next page",
  "table.sort_paged": "This list is split into pages. Sorting would only re-order the page on screen, so it is off here — narrow the list with the search or filters instead.",
  /* === tablo:t1 — the trash banner ======================================
     ⚠ `retention` is only used when the deployment has TOLD us the number
     (GET /api/admin/protection). Everywhere else `retention_unknown` says the
     same thing without naming a period we cannot verify: a banner that states
     the wrong retention is worse than no banner, because people act on it. */
  "trash.retention": "Items in the trash are permanently deleted after {days} days.",
  "trash.retention_one": "Items in the trash are permanently deleted after {days} day.",
  "trash.retention_unknown": "Items in the trash are permanently deleted after a retention period set by your administrator.",
  "trash.empty_action": "Empty trash",
  "trash.empty_confirm_title": "Empty the trash?",
  "trash.empty_confirm_body_one": "This permanently deletes {count} item ({size}). It cannot be undone.",
  "trash.empty_confirm_body": "This permanently deletes {count} items ({size}). It cannot be undone.",
  "trash.empty_confirm_body_nosize_one": "This permanently deletes {count} item. It cannot be undone.",
  "trash.empty_confirm_body_nosize": "This permanently deletes {count} items. It cannot be undone.",
  "trash.emptied": "Trash emptied",
  "trash.days_remaining": "{n} days",
  "trash.days_remaining_one": "{n} day",
  "trash.days_remaining_due": "Due for deletion",
  "trash.deleted_by_nobody": "Not recorded: removed outside filex, or deleted before filex kept this",
  "trash.emptying": "Emptying the trash… {done} of {total}",
  "trash.empty_busy": "The trash is already being emptied.",
  "trash.emptied_partly": "Trash emptied, but {count} items could not be purged — see the server log.",
  "trash.emptied_partly_one": "Trash emptied, but {count} item could not be purged — see the server log.",
  "trash.empty_stopped": "Emptying the trash stopped: {error}",
  "trash.emptying_queued": "Emptying the trash… waiting for another purge to finish",
  "trash.empty_cancelled": "Emptying the trash was stopped after {count} items; the rest is still in the trash.",
  "trash.empty_cancelled_one": "Emptying the trash was stopped after {count} item; the rest is still in the trash.",
  "empty.trash.hint": "Files you delete land here first, so you can put them back.",
  /* tasi:m1 — the destination picker (modals/DestinationPickerModal.vue) and
     the two selection verbs built on it. */
  "destpicker.title.move": "Move to",
  "destpicker.title.copy": "Copy to",
  "destpicker.title.choose": "Choose a folder",
  "destpicker.confirm.move": "Move here",
  "destpicker.confirm.copy": "Copy here",
  "destpicker.confirm.choose": "Choose this folder",
  "destpicker.title.choose_file": "Choose a file",
  "destpicker.confirm.choose_file": "Choose this file",
  "destpicker.pick_a_file": "Select a file from the list.",
  "destpicker.empty_files": "This folder is empty",
  "destpicker.cancel": "Cancel",
  "destpicker.up": "Up one level",
  "destpicker.crumbs": "Location",
  "destpicker.drives": "Storages",
  "destpicker.loading": "Loading…",
  "destpicker.empty": "No subfolders here",
  "destpicker.unreadable": "This folder cannot be opened.",
  "destpicker.readonly": "Read-only",
  "destpicker.readonly_here": "You cannot write into this folder.",
  "destpicker.pick_a_drive": "Open a storage to choose a folder inside it.",
  "destpicker.target": "Destination: {name}",
  "destpicker.tag.blocked": "Not allowed",
  "destpicker.blocked.self": "A folder cannot be moved into itself.",
  "destpicker.blocked.descendant": "A folder cannot be moved into one of its own subfolders.",
  "ctx.move_to": "Move to…",
  "ctx.copy_to": "Copy to…",
  "ctx.access.one_only": "Sharing works on one item at a time.",
  "toast.archive.preparing": "Preparing the archive…",
  "toast.archive.started": "Downloading {name} ({count} files)",
  "toast.archive.started_one": "Downloading {name} ({count} file)",
  "toast.archive.empty": "Nothing to download — the selection contains no readable file.",
  "toast.moved_to": "Move to {name} queued",
  "toast.copied_to": "Copy to {name} queued",
  "toast.already_there": "The selected items are already in {name} — nothing was sent",
  /* ── dil:paket — strings that used to be inline `en ? … : …` pairs in
     FileExplorer / RecentlyOpened, where no language pack could reach them
     (and where a pack's language fell through to TURKISH). */
  "ctx.tags_menu": "Tags…",
  "toast.node_id_copied": "Node id {id} copied",
  "toast.read_only_here": "Read-only here",
  "recents.title": "Recently opened",
  "recents.refresh": "Refresh",
  "recents.empty": "Nothing here yet.",
  "recents.loading": "Loading…",
  "recents.close": "Close",
  "tags.title": "Tags",
  "tags.close": "Close",
  "share.ttl.never": "This link does not expire.",
  "share.ttl.until": "This link is valid until {when}.",
  "share.ttl.ceiling": "Links can be valid for at most {days} days (server setting).",
  "share.ttl.ceiling_one": "Links can be valid for at most {days} day (server setting).",
  /* ── dil:paket — the share / access dialog (modals/PermissionsModal.vue). These were ~90 inline (tr, en) pairs: no language pack could reach them, and under any third language the dialog spoke TURKISH. access.ui.emails_comma_separated / access.ui.send / access.ui.mail_not_set_up are the mail-row lines another branch rewrote in the same release, converted at the v0.43.0 merge. */
  "access.ui.level_viewer": "Viewer",
  "access.ui.level_viewer_desc": "view + download",
  "access.ui.level_editor": "Editor",
  "access.ui.level_editor_desc": "read + write + delete",
  "access.ui.level_owner": "Owner",
  "access.ui.level_owner_desc": "edit + manage access",
  "access.ui.never": "Never",
  "access.ui.days": "{days} days",
  "access.ui.days_one": "{days} day",
  "access.ui.unlimited": "Unlimited",
  "access.ui.downloads": "{count} downloads",
  "access.ui.downloads_one": "{count} download",
  "access.ui.mail_sent": "Email sent ✓ ({sent})",
  "access.ui.mail_partial": "{sent} sent, {failed} failed",
  "access.ui.valid_for": "This link is valid for {days} days.",
  "access.ui.valid_for_one": "This link is valid for {days} day.",
  "access.ui.mail_title_file": "{name} has been shared with you",
  "access.ui.mail_title_folder": "{name} has been shared with you",
  "access.ui.mail_hello": "Hello,",
  "access.ui.mail_shared_file": "A file has been shared with you:",
  "access.ui.mail_shared_folder": "A folder has been shared with you:",
  "access.ui.mail_folder": "Folder: {name}",
  "access.ui.mail_file": "File: {name}",
  "access.ui.mail_size": "Size: {size}",
  "access.ui.mail_download_here": "Download it here:",
  "access.ui.mail_pin": "PIN: {pin}",
  "access.ui.drop_title": "You've been asked to add files to {folder}",
  "access.ui.drop_invited": "You've been invited to upload files.",
  "access.ui.drop_limit": "Limit: up to {files} file(s), {mb} MB per file.",
  "access.ui.drop_types": "Allowed types: {types}",
  "access.ui.drop_types_all": "Allowed types: all",
  "access.ui.drop_upload_here": "Upload your files here:",
  "access.ui.inherited_from": "Inherited from",
  "access.ui.access_granted": "Access granted.",
  "access.ui.enter_a_valid_email": "Enter a valid email.",
  "access.ui.user_created_invite_emailed": "User created, invite emailed.",
  "access.ui.user_created_share_the_temp_password": "User created. Share the temp password.",
  "access.ui.smtp_not_set_up_verified_share_the_link": "SMTP not set up/verified — share the link manually.",
  "access.ui.send_failed_temporary_please_retry": "Send failed (temporary) — please retry.",
  "access.ui.server_limit_applied": "(server limit applied)",
  "access.ui.protect_with_a_pin": "Protect with a PIN",
  "access.ui.expiry": "Expiry",
  "access.ui.download_limit": "Download limit",
  "access.ui.create_link": "Create link",
  "access.ui.replace_link": "Replace the link with these settings",
  "access.ui.replace_link_hint": "The address changes: the current link stops working.",
  "access.ui.create_then_send": "Create a link, then it will be sent to {email}.",
  "access.ui.command_line": "Command line",
  "access.ui.share": "Share",
  "access.ui.existing_links": "Existing links",
  "access.ui.rbac_off_here": "Per-item access control is off on this storage — everyone opens it according to their role, so people added here would change nothing. Turn it on in the admin panel under Storages (this storage → Per-item access control).",
  "access.ui.other_links": "Other links",
  "access.ui.revoke": "Revoke",
  "access.ui.loading": "Loading…",
  "access.ui.name_or_email": "Name or email",
  "access.ui.add": "Add",
  "access.ui.no_account_for_this_email_what_next": "No account for this email — what next?",
  "access.ui.user": "User",
  "access.ui.viewer": "Viewer",
  "access.ui.create_user_grant": "Create user + grant",
  "access.ui.just_send_a_share_link": "Just send a share link →",
  "access.ui.temp_password": "Temp password:",
  "access.ui.people_with_access": "People with access",
  "access.ui.not_shared_with_anyone_yet": "Not shared with anyone yet.",
  "access.ui.remove": "Remove",
  "access.ui.a_public_link_that_lets_anyone_upload_fi": "A public link that lets anyone UPLOAD files into this folder. Uploaders never see the folder's existing files.",
  "access.ui.hide_upload_limits": "Hide upload limits",
  "access.ui.upload_limits": "Upload limits",
  "access.ui.max_files": "Max files",
  "access.ui.mb_file": "MB / file",
  "access.ui.allowed_types": "Allowed types",
  "access.ui.all_e_g_pdf_jpg": "all (e.g. pdf, jpg)",
  "access.ui.ask_uploader_name": "Ask uploader name",
  "access.ui.emails_comma_separated": "email(s) — comma separated",
  "access.ui.send": "Send",
  "access.ui.mail_not_set_up": "Email is not set up — set it up in the admin panel under Settings (Email / SMTP).",
  /* ── wiring:e2 fxe — single encrypted files (.fxe), streamed downloads ── */
  "e2e.fxe.type": "Encrypted file",
  "e2e.fxe.ctx_encrypt": "Encrypt with E2EE…",
  "e2e.fxe.ctx_download_raw": "Download encrypted file",
  "e2e.fxe.ctx_password": "Change password…",
  "e2e.fxe.ctx_remove": "Remove encryption…",
  "e2e.fxe.encrypt_title": "Encrypt this file",
  "e2e.fxe.encrypt_lead": "“{name}” is encrypted in this browser with a password of its own. The server keeps only ciphertext. The password or the recovery key opens it — here, or offline with filex decrypt.",
  "e2e.fxe.pw_label": "File password",
  "e2e.fxe.hide_label": "Hide the file name too",
  "e2e.fxe.hide_on_hint": "Stored as “{stored}”: the server sees neither the name nor the type. The real name is sealed inside the file and shown once you open it here.",
  "e2e.fxe.hide_off_hint": "Stored as “{stored}”: the name stays readable to the server; the content does not.",
  "e2e.fxe.seen_title": "What the server has already seen",
  "e2e.fxe.seen_lead": "Until now this file was stored in the clear, and encrypting it cannot take that back:",
  "e2e.fxe.seen_trash": "The original goes to the trash and stays there until the trash retention period ends or an administrator empties it. You cannot delete it for good yourself.",
  "e2e.fxe.seen_versions": "Its earlier versions stay in its version history; only an administrator can delete them.",
  "e2e.fxe.seen_thumb": "A thumbnail made from it stays on the server until the original is deleted for good. Its search-index entry is removed when it goes to the trash.",
  "e2e.fxe.seen_backups": "Backups, copies and downloads made before now still hold it.",
  "e2e.fxe.warn_body": "This file opens only with this password or the recovery key shown once after it is encrypted. filex keeps neither. Lose both and the contents are gone for good.",
  "e2e.fxe.escrow_body": "Key escrow is enabled on this installation: its operator holds a key that opens this file without your password.",
  "e2e.fxe.encrypt_submit": "Encrypt",
  "e2e.fxe.encrypt_busy": "Encrypting and uploading… {percent}%",
  "e2e.fxe.size_unknown": "The size of this file is not known yet. Refresh the folder and try again.",
  "e2e.fxe.bad_name": "This name cannot be sealed into an encrypted file (it is over 255 bytes, or holds a slash or a control character). Rename the file first.",
  "e2e.fxe.name_too_long": "The name is too long to add “.fxe” to it. Tick “Hide the file name too”, or rename the file first.",
  "e2e.fxe.encrypted": "“{name}” is encrypted. The original is in the trash.",
  "e2e.fxe.original_kept": "The encrypted copy is saved, but “{name}” could not be moved to the trash. Delete the original yourself.",
  "e2e.fxe.upload_too_big": "This server has no chunked upload, and the file is too large to send in one piece from this browser.",
  "e2e.fxe.unlock_title_open": "Open an encrypted file",
  "e2e.fxe.unlock_title_download": "Download decrypted",
  "e2e.fxe.unlock_title_remove": "Remove encryption",
  "e2e.fxe.unlock_lead": "“{name}” is encrypted. Its password is checked here, in this browser, and is never sent to the server.",
  "e2e.fxe.known_note": "Already opened in this tab — no password needed.",
  "e2e.fxe.use_password": "Use the password instead",
  "e2e.fxe.remove_warn_title": "The plaintext goes back to the server",
  "e2e.fxe.remove_warn_body": "The file is decrypted here and uploaded as a plain file under its original name: the server, its administrators, thumbnails, search and backups can read it again. The encrypted file goes to the trash.",
  "e2e.fxe.unlock_open": "Open",
  "e2e.fxe.unlock_download": "Download",
  "e2e.fxe.unlock_remove": "Remove encryption",
  "e2e.fxe.unlock_busy": "Working…",
  "e2e.fxe.save_again": "Unlocked. Your browser wants one more click before it asks where to save the file.",
  "e2e.fxe.save_button": "Save…",
  "e2e.fxe.progress": "{percent}% done",
  "e2e.fxe.wrong_password": "Wrong password.",
  "e2e.fxe.wrong_recovery": "That recovery key does not open this file.",
  "e2e.fxe.damaged": "This file is damaged or was tampered with (or it changed since it was opened). Nothing was saved.",
  "e2e.fxe.not_readable": "This is not a filex encrypted file, or its header is damaged.",
  "e2e.fxe.unsupported": "This file needs a newer filex (it requires: {features}).",
  "e2e.fxe.downloaded": "“{name}” saved.",
  "e2e.fxe.removed": "Encryption removed: “{name}” is a plain file again. The encrypted file is in the trash.",
  "e2e.fxe.password_title": "Change the file password",
  "e2e.fxe.password_cost": "Only the file’s header changes: the content is sent back byte for byte, and the recovery key keeps working.",
  "e2e.fxe.password_old_copies": "An earlier version of this file — its version history, a backup, a copy someone downloaded — still opens with the OLD password.",
  "e2e.fxe.password_done": "Password changed. The old password no longer opens this file.",
  "e2e.recovery.warn_body_file": "Anyone holding this key can read the file. Keep it somewhere separate from the password — a key stored next to the password protects you from forgetting, not from anyone else.",
  "e2e.recovery.lead_file": "This key opens the file without its password. It is shown once — filex does not store it and cannot show it again.",
  "e2e.dl.ctx_encrypted_copy": "Download encrypted copy",
  "e2e.dl.too_big": "This browser can save at most {limit} of decrypted data at once, and this is {size}. Use Chrome or Edge (they save straight to disk), the filex desktop app, or download the encrypted file and run filex decrypt.",
  "e2e.dl.click_again": "Click Download again to choose where to save it.",
  "e2e.dl.zip_started": "Decrypting into “{name}”…",
  "e2e.dl.zip_done": "“{name}” saved — decrypted, with the real names.",
  "e2e.dl.zip_done_plain": "“{name}” saved. {n} files in it were never encrypted and are in it as they were.",
  "e2e.dl.zip_done_plain_one": "“{name}” saved. {n} file in it was never encrypted and is in it as it was.",
  "e2e.dl.zip_damaged": "A file in the folder is damaged or was tampered with. The download stopped and nothing was saved.",
  "e2e.upload.streaming_unsupported": "This file is over 200 MB, and this server has no chunked upload to send it encrypted piece by piece.",
  /* wiring:e2 fxe escrow — the escrow key opens a single file, and its owner is told */
  "e2e.fxe.use_escrow": "Use the escrow key",
  "e2e.fxe.escrow_warn_title": "The file’s owner will be told",
  "e2e.fxe.escrow_warn_body": "Opening a file with the escrow key notifies its owner, before the file is opened. Use it only when you are entitled to.",
  "e2e.fxe.escrow_predates": "This installation has an escrow key, but this file was encrypted without it (before escrow was turned on here), so the escrow key does not open it. Use the password or the recovery key.",
  "e2e.fxe.escrow_other_key": "This file is sealed to the escrow key of a DIFFERENT installation, so this installation’s escrow key does not open it.",
  "e2e.fxe.wrong_escrow": "That escrow key does not open this file.",
  "e2e.fxe.escrow_notify_failed": "Could not notify the file’s owner, so the file was not opened. Escrow use is always announced.",
  "e2e.fxe.escrow_done": "Opened with the escrow key — the owner has been notified",
  /* wiring:e2 fxe purge — an administrator deletes the original for good */
  "e2e.fxe.seen_trash_admin": "The original goes to the trash and stays there until the trash retention period ends — unless you delete it for good below.",
  "e2e.fxe.seen_versions_admin": "Its earlier versions stay in its version history — unless you delete them for good below.",
  "e2e.fxe.purge_label": "Delete the original for good (administrator)",
  "e2e.fxe.purge_hint": "Its earlier versions and its trash entry are deleted as soon as the encrypted copy is saved, so no plaintext of it stays on this server. There is no undo. Backups and copies made before now are not reached.",
  "e2e.fxe.purge_others": "This file belongs to {owner}, not to you. Delete their original and its versions for good.",
  "e2e.fxe.purge_others_unknown": "This file has no recorded owner — it is not yours. Delete the original and its versions for good.",
  "e2e.fxe.purge_others_required": "Confirm that you are deleting someone else’s file for good.",
  "e2e.fxe.purge_no_id": "This file is not in the catalog yet, so it cannot be deleted for good. Refresh the folder and try again.",
  "e2e.fxe.purged": "“{name}” is encrypted. The original, its versions and its trash entry are deleted for good.",
  "e2e.fxe.purge_failed": "The encrypted copy of “{name}” is saved, but the original could not be deleted for good ({reason}). Delete it from the trash and its version history.",
  /* wiring:e2 fxe big — a decrypted download too large for this browser's memory */
  "e2e.big.title": "Too large to decrypt in this browser",
  "e2e.big.lead": "“{name}” is {size} once decrypted. This browser decrypts a download in its memory and can hold at most {limit} of it, so nothing was downloaded.",
  "e2e.big.lead_grew": "“{name}” grew past {limit} while it was being decrypted. This browser decrypts a download in its memory and cannot hold more, so nothing was saved.",
  "e2e.big.instead": "Decrypt it on your own computer instead:",
  "e2e.big.step_file": "Download the encrypted file, as it is (the button below).",
  "e2e.big.step_folder": "Download the encrypted folder as a zip (the button below) — it carries the folder’s key file.",
  "e2e.big.step_run": "In the folder you saved it to, run filex decrypt and give it the password:",
  "e2e.big.copy": "Copy",
  "e2e.big.copied": "Copied",
  "e2e.big.other_ways": "Chrome, Edge and the filex desktop app decrypt straight to disk, whatever the size.",
  "e2e.big.close": "Close",
  "e2e.big.download_file": "Download encrypted file",
  "e2e.big.download_folder": "Download encrypted folder (zip)",
  /* /wiring:e2 fxe */
  /* ── dil:paket — accessible names that were English literals */
  "breadcrumb.aria": "Breadcrumb",
  "e2e.recovery_key_aria": "Recovery key",
  "modal.close": "Close",
  "modal.busy_close.keep": "Keep going",
  "modal.busy_close.confirm": "Stop and close",
  /* ── the bell and the account menu (2026-09-27: moved here from the admin
     app so the desktop app's explorer draws the same ones). ⚠ SHARED keys:
     the admin app's catalogue has every one of them under the same name, with
     the same English and Turkish (web/tests/i18n/langPackCatalogue.test.ts),
     so a language pack translates each once for both screens. */
  "notifications.bell": "Notifications",
  "notifications.unreadCount": "{n} unread",
  "notifications.title": "Notifications",
  "notifications.markAllRead": "Mark all read",
  "notifications.markRead": "Mark read",
  "notifications.empty": "No notifications yet",
  "notifications.viewAll": "View all",
  "notifications.manageAdmin": "Manage notifications",
  "notifications.openTarget": "Open what this is about",
  "notifications.unreadOnly": "Unread only",
  "notifications.pageOf": "Page {page} of {pages} · {total} in total",
  "notifications.severity.info": "Info",
  "notifications.severity.warning": "Warning",
  "notifications.severity.error": "Error",
  "notifications.severity.critical": "Critical",
  "common.prev": "Previous",
  "common.next": "Next",
  "explore.account": "Account",
  /* ── the user settings dialog (2026-09-27: moved here from the admin app
     so the desktop app opens the same dialog inside its window). ⚠ SHARED
     keys: the admin app's catalogue has each under the same name with the same
     English and Turkish (web/tests/i18n/langPackCatalogue.test.ts). The five
     after them are this table's own: the admin catalogue writes those strings
     in vue-i18n-only syntax (an escaped @, a | plural), which a shared key
     may not use. */
  "account.errors.emailRequired": "Enter an email address.",
  "account.errors.usernameChar": "“{char}” cannot be used in a username. Use a–z, 0–9, dot, dash or underscore.",
  "account.errors.usernameDigit": "A username cannot start with a digit.",
  "account.errors.usernameEmpty": "Enter a username.",
  "account.errors.usernameLong": "A username can be at most {max} characters.",
  "account.errors.usernameReserved": "“{name}” is reserved; choose another username.",
  "account.errors.usernameShort": "A username needs at least {min} characters.",
  "account.errors.usernameSpace": "A username cannot contain spaces. Use a–z, 0–9, dot, dash or underscore.",
  "common.cancel": "Cancel",
  "common.close": "Close",
  "common.confirm": "Confirm",
  "common.currentPassword": "Current password",
  "common.email": "Email",
  "common.loading": "Loading…",
  "common.newPassword": "New password",
  "common.remove": "Remove",
  "common.save": "Save",
  "common.saving": "Saving…",
  "errors.generic": "Something went wrong",
  "errors.validationFailed": "Please check the highlighted fields",
  "install.desktopAllDownloads": "All downloads and release notes",
  "install.desktopSubtitle": "Sync folders to this computer and keep them up to date in the background. Available for {platform}.",
  "nav.themeAuto": "Auto",
  "nav.themeDark": "Dark",
  "nav.themeLight": "Light",
  "notifications.prefs.browser": "Browser notifications",
  "notifications.prefs.browserHint": "Raise a notification outside the tab when something new arrives. Clicking it opens the file, folder or share it is about.",
  "notifications.prefs.desktopHandled": "The desktop app shows these itself",
  "notifications.prefs.enableBrowser": "Allow notifications",
  "notifications.prefs.inApp": "In-app bell",
  "notifications.prefs.inAppHint": "Turning this off empties your bell. Nothing stops being recorded — an admin still sees every event.",
  "notifications.prefs.movedToSettings": "Your own notification settings — the bell, browser pop-ups, which events — are in your user settings.",
  "notifications.prefs.openSettings": "Open my notification settings",
  "notifications.prefs.permDefault": "Permission not asked yet",
  "notifications.prefs.permDenied": "Blocked by this browser",
  "notifications.prefs.permDeniedHint": "Re-allow notifications for this site in your browser settings.",
  "notifications.prefs.permGranted": "Allowed by this browser",
  "notifications.prefs.permUnsupported": "This browser cannot show notifications",
  "notifications.prefs.saved": "Preference saved",
  "notifications.prefs.title": "Your notifications",
  "profile.avatar.change": "Change photo",
  "profile.avatar.failed": "That image could not be processed — try another one.",
  "profile.avatar.help": "Shown next to your name, and in the file explorer's collaboration bar — on every client signed in as you. Resized to 160px automatically.",
  "profile.avatar.label": "Profile picture",
  "profile.avatar.notImage": "Please choose an image file.",
  "profile.locale": "Language",
  "profile.passwordChanged": "Password changed",
  "profile.saved": "Profile saved",
  "profile.totp.code": "Verification code",
  "profile.totp.disable": "Disable 2FA",
  "profile.totp.disabled": "Disabled",
  "profile.totp.enable": "Enable 2FA",
  "profile.totp.enabled": "Enabled",
  "profile.totp.recoveryHint": "Save these now — each one signs you in once if you lose your authenticator. They are shown only this time.",
  "profile.totp.recoveryTitle": "Recovery codes",
  "profile.totp.scanHint": "Scan this QR code with your authenticator app, then enter the 6-digit code.",
  "profile.totp.title": "Two-factor authentication",
  "profile.username.label": "Username",
  "quota.title": "Storage quota",
  "quota.tooltip": "{used} of {limit} used ({percent})",
  "quota.unlimitedTooltip": "{used} used · unlimited",
  "userSettings.adminBadge": "Admin",
  "userSettings.ai.body": "This release has no per-user assistant settings. The AI features filex does ship are configured for the whole instance by an administrator, so there is nothing here for you to turn on or off yet.",
  "userSettings.ai.soon": "Coming soon",
  "userSettings.demoReadOnly": "This is a shared demo account, so its profile, password and second factor cannot be changed.",
  "userSettings.footNote.ai": "There is nothing on this tab to save.",
  "userSettings.footNote.notifications": "Saved as you change them.",
  "userSettings.footNote.preferences": "Saved as you change them.",
  "userSettings.footNote.profile": "Changes on this tab are saved when you press Save.",
  "userSettings.footNote.security": "Each action here applies on its own.",
  "userSettings.heading": "User settings",
  "userSettings.headingSub": "Manage your profile, preferences, and security.",
  "userSettings.notifications.events.archive_created": "An archive finishes being created",
  "userSettings.notifications.events.archive_extracted": "An archive finishes extracting",
  "userSettings.notifications.events.comment_added": "Someone comments on a file",
  "userSettings.notifications.events.drop_received": "A file arrives through a request link",
  "userSettings.notifications.events.e2e_escrow_used": "An encrypted folder is opened with the escrow key",
  "userSettings.notifications.events.file_deleted": "A file is deleted for good",
  "userSettings.notifications.events.file_infected": "A virus is found in a file",
  "userSettings.notifications.events.file_moved": "A file is moved or renamed",
  "userSettings.notifications.events.file_trashed": "A file goes to the trash",
  "userSettings.notifications.events.file_updated": "A file is changed",
  "userSettings.notifications.events.file_upload_failed": "An upload does not finish",
  "userSettings.notifications.events.file_uploaded": "A new file arrives",
  "userSettings.notifications.events.plugin_notice": "An installed app sends you a message",
  "userSettings.notifications.events.share_created": "Someone creates a share link",
  "userSettings.notifications.eventsHint": "Turning one off keeps it out of your bell. Nothing stops being recorded — an administrator still sees every event.",
  "userSettings.notifications.eventsTitle": "What to tell me about",
  "userSettings.open": "User settings",
  "userSettings.prefs.appearance": "Appearance",
  "userSettings.prefs.compact": "Use compact file list",
  "userSettings.prefs.compactHint": "Tighter rows in the file explorer.",
  "userSettings.prefs.desktopApp": "Desktop app",
  "userSettings.prefs.desktopAppHint": "The reminder in the corner of the app can be closed for good — these downloads stay here.",
  "userSettings.prefs.folderView": "Default folder view",
  "userSettings.prefs.folderViewHint": "How a folder you have never changed opens. A folder you have changed keeps its own view — changing this does not touch it.",
  "userSettings.prefs.fvColumns": "Your default columns are customized (set with “Make this my default for all folders”).",
  "userSettings.prefs.fvColumnsReset": "Reset them",
  "userSettings.prefs.fvDir": "Direction",
  "userSettings.prefs.fvDir_asc": "Ascending",
  "userSettings.prefs.fvDir_desc": "Descending",
  "userSettings.prefs.fvForget": "Forget them all",
  "userSettings.prefs.fvInherit": "Server default ({value})",
  "userSettings.prefs.fvMode": "View",
  "userSettings.prefs.fvSort": "Sort by",
  "userSettings.prefs.fvSort_modified": "Modified",
  "userSettings.prefs.fvSort_name": "Name",
  "userSettings.prefs.fvSort_size": "Size",
  "userSettings.prefs.fvSort_type": "Type",
  "userSettings.prefs.fvView_gallery": "Gallery",
  "userSettings.prefs.fvView_grid": "Grid",
  "userSettings.prefs.fvView_list": "List",
  "userSettings.prefs.languageHint": "Applies here right away, and is saved on your account for the next browser you sign in from.",
  "userSettings.prefs.mode": "Light or dark",
  "userSettings.prefs.modeHint": "Which variant is painted. Auto follows your operating system.",
  "userSettings.prefs.openTrigger": "Open files with",
  "userSettings.prefs.openTriggerDouble": "Double-click",
  "userSettings.prefs.openTriggerHint": "How a mouse opens a file. On a touchscreen a tap always opens, and the checkbox always selects.",
  "userSettings.prefs.openTriggerSingle": "Single-click",
  "userSettings.prefs.palette": "Color palette",
  "userSettings.prefs.paletteHint": "Which colors that variant is made of. Every palette has a light and a dark version, so this and the setting above work together.",
  "userSettings.prefs.startPage": "Start page",
  "userSettings.prefs.startPageHint": "Where filex opens when you sign in or go to the front door. Following a link straight to a page still takes you there.",
  "userSettings.prefs.startPage_admin": "Admin panel",
  "userSettings.prefs.startPage_files": "Files",
  "userSettings.prefs.startPage_home": "Home",
  "userSettings.prefs.timezone": "Time zone",
  "userSettings.prefs.timezoneHint": "Dates are stored as a moment in time and shown on the clock you pick here, so everyone sees the same instant on their own clock. Saved to your account, so it follows you to another browser.",
  "userSettings.prefs.timezoneNow": "Right now in {zone}: {time}",
  "userSettings.saveChanges": "Save changes",
  "userSettings.security.passwordTitle": "Change password",
  "userSettings.security.totpDisabled": "Two-factor authentication is off",
  "userSettings.security.totpEnabled": "Two-factor authentication is on",
  "userSettings.subtitle.ai": "Nothing for you to set here yet.",
  "userSettings.subtitle.notifications": "What reaches your bell, and what reaches your desktop.",
  "userSettings.subtitle.preferences": "How this app looks and reads on your devices.",
  "userSettings.subtitle.profile": "Your name, email and picture — what other people see.",
  "userSettings.subtitle.security": "Your password and second factor.",
  "userSettings.tabs.ai": "AI assistant",
  "userSettings.tabs.notifications": "Notifications",
  "userSettings.tabs.preferences": "Preferences",
  "userSettings.tabs.profile": "Profile",
  "userSettings.tabs.security": "Security",
  "userSettings.title": "Settings",
  "users.fields.displayName": "Display name",
  "webhooks.offReason.antivirus": "Virus scanning is off (Protection).",
  "webhooks.offReason.appPlugins": "Apps are switched off on this server.",
  "webhooks.offReason.escrow": "No escrow key is set up for encrypted folders.",
  "account.problem.emailInvalid": "This is not an email address. Write it as name@example.com.",
  "account.problem.usernameAt": "A username cannot contain @ — that belongs to an email address.",
  "profile.username.helpText": "Your username. You can sign in with it or with your email — and connection clients (SFTP, FTP) need it, because an @ in the name they sign in with has to be escaped in their config files.",
  "userSettings.prefs.fvKeptCount": "{count} folders keep a view of their own.",
  "userSettings.prefs.fvKeptCount_one": "{count} folder keeps a view of its own."
}, mk = {
  "toolbar.new_folder": "Yeni klasör",
  "toolbar.upload": "Yükle",
  "toolbar.search": "Ara",
  "toolbar.search.placeholder": "Ada ya da tag: ile ara…",
  "toolbar.view.list": "Liste",
  "toolbar.view.grid": "Izgara",
  "toolbar.refresh": "Yenile",
  "toolbar.go_up": "Üst klasör",
  "ctx.open": "Aç",
  "ctx.preview": "Önizle",
  "ctx.download": "İndir",
  "ctx.archive_create": "Arşiv oluştur…",
  "ctx.archive_extract": "Arşivi çıkar…",
  "ctx.rename": "Yeniden adlandır",
  "ctx.delete": "Sil",
  "ctx.delete_perm": "Kalıcı olarak sil",
  "ctx.restore": "Geri getir",
  "ctx.share": "Paylaş",
  "ctx.move": "Taşı",
  "ctx.copy": "Kopyala",
  "ctx.cut": "Kes",
  "ctx.show_hidden": "Gizli dosyaları göster",
  "ctx.hide_hidden": "Gizli dosyaları gizle",
  "ctx.keep_local": "Bilgisayarda tut",
  "ctx.keep_online": "Yalnızca çevrimiçi tut",
  "ctx.keep_reveal": "Yerel klasörü aç",
  "ctx.keep_inherited": "Üst klasörle bilgisayarda tutuluyor",
  "keep.started": "Bilgisayarda tutulacak — eşitleme başladı",
  "keep.failed": "Bilgisayarda tutulamadı",
  "keep.badge_kept": "Bilgisayarda",
  "keep.badge_syncing": "Eşitleniyor…",
  "keep.badge_cloud": "Yalnızca çevrimiçi",
  "keep.badge_partial": "İçinde bilgisayarda tutulanlar var",
  "keep.strip_transfer": "{name} eşitleniyor — {done}/{total} (%{pct})",
  "keep.strip_inventory": "{name} eşitleniyor — sunucu taranıyor…",
  "keep.strip_settling": "{name} eşitleniyor — son durum kaydediliyor…",
  "ctx.paste": "Yapıştır",
  "ctx.info": "Bilgi",
  "ctx.duplicate": "Kopyasını oluştur",
  "ctx.new_file": "Yeni dosya",
  "modal.delete.title": "Silinsin mi?",
  "modal.delete.message": "{count} öğe çöpe atılacak.",
  "modal.delete.message_one": "{count} öğe çöpe atılacak.",
  "modal.delete.confirm": "Çöpe at",
  "modal.delete.working": "Çöpe taşınıyor…",
  "modal.delete.cancel": "Vazgeç",
  "modal.delete.permanent_title": "Kalıcı olarak silinsin mi?",
  "modal.delete.permanent_message": "{count} öğe kalıcı olarak silinecek. Bu geri alınamaz.",
  "modal.delete.permanent_message_one": "{count} öğe kalıcı olarak silinecek. Bu geri alınamaz.",
  "modal.delete.permanent_confirm": "Kalıcı olarak sil",
  "modal.delete.permanent_working": "Siliniyor…",
  "modal.rename.title": "Yeniden adlandır",
  "modal.rename.save": "Kaydet",
  "modal.rename.saving": "Yeniden adlandırılıyor…",
  "modal.rename.cancel": "Vazgeç",
  "modal.newfolder.title": "Yeni klasör",
  "modal.newfolder.placeholder": "Klasör adı",
  "modal.newfolder.create": "Oluştur",
  "modal.newfolder.creating": "Oluşturuluyor…",
  "modal.newfolder.cancel": "Vazgeç",
  "modal.share.title": "Paylaşım bağlantısı",
  "archive.create_title": "Arşiv oluştur",
  "archive.extract_title": "Arşivi çıkar",
  "archive.create_count": "{count} öğe seçildi",
  "archive.create_count_one": "{count} öğe seçildi",
  "archive.filename": "Arşiv adı",
  "archive.format": "Biçim",
  "archive.password_optional": "Parola (isteğe bağlı)",
  "archive.password_confirm": "Parolayı doğrula",
  "archive.password_mismatch": "Parolalar birbiriyle eşleşmiyor.",
  "archive.encrypt_names": "Dosya adlarını şifrele",
  "archive.compression": "Sıkıştırma",
  "archive.solid": "Katı arşiv oluştur",
  "archive.dictionary_size": "Sözlük boyutu",
  "archive.dictionary_size_value": "{n} MiB",
  "archive.dictionary_hint": "Daha büyük sözlükler sıkıştırmayı iyileştirebilir ancak oluşturma ve çıkarma sırasında daha fazla bellek kullanır.",
  "archive.destination_folder": "Çıkarılacak klasör",
  "archive.create": "Oluştur",
  "archive.creating": "Oluşturuluyor…",
  "archive.extract": "Çıkar",
  "archive.extract_here": "Buraya çıkar",
  "archive.extract_to_folder": "Klasöre çıkar",
  "archive.extracting": "Çıkarılıyor…",
  "archive.cancel": "Vazgeç",
  "archive.invalid_name": "Eğik çizgi içermeyen bir dosya adı girin.",
  "archive.invalid_extension": "Arşiv adı kullanılabilir biçim uzantılarından biriyle bitmelidir.",
  "archive.invalid_folder": "Eğik çizgi içermeyen bir klasör adı girin.",
  "archive.password_required": "Bu arşiv için parola gerekiyor.",
  "archive.password_title": "Arşiv parolası",
  "archive.continue": "Devam et",
  "archive.opening": "Açılıyor…",
  "archive.bad_password": "Arşiv parolası yanlış.",
  "archive.target_exists": "Bu ada sahip bir öğe zaten var. Başka bir ad seçin veya önce mevcut öğeyi kaldırın.",
  "archive.password_charset": "ZIP parolasında yalnızca ASCII karakterler kullanılabilir; ç, ğ, ı, İ, ö, ş, ü gibi harfler kullanılamaz. Her karakteri kullanmak için 7z biçimini seçin.",
  "archive.error_unsupported": "Bu arşiv çıkarılamıyor: bu sunucu biçimini okuyamıyor ya da içinde filex’in çıkarmadığı bir şey var (bağlantı, özel dosya ya da boyutunu belirtmeyen bir dosya).",
  "archive.error_limit": "Bu arşiv, sunucunun çıkarmaya izin verdiği boyutu aşıyor.",
  "archive.error_unavailable": "Bu sunucu şu anda bu tür bir arşivi açamıyor.",
  "archive.created": "Arşiv oluşturuldu",
  "archive.queued": "Arşiv oluşturma arka planda çalışıyor",
  "archive.extracted": "{count} dosya çıkarıldı",
  "archive.extracted_one": "{count} dosya çıkarıldı",
  "archive.extraction_queued": "Arşiv çıkarma arka planda çalışıyor",
  "archive.preparing_extract": "{name} okunuyor… çıkarılmadan önce arşivin tamamı okunur.",
  "archive.already_preparing": "{name} hâlâ okunuyor — okuma bitince bir kez çıkarılacak",
  "archive.extraction_completed": "Çıkarma tamamlandı",
  "archive.extraction_cancelled": "Çıkarma {count} dosyadan sonra iptal edildi",
  "archive.extraction_cancelled_one": "Çıkarma {count} dosyadan sonra iptal edildi",
  "modal.share.pin": "PIN koruması",
  "modal.share.expires": "Son kullanma",
  "modal.share.max_downloads": "İndirme limiti",
  "modal.share.create": "Paylaş",
  "modal.share.cancel": "Vazgeç",
  "modal.share.close": "Kapat",
  "modal.share.limit_applied": "(sunucu sınırı uygulandı)",
  "modal.share.copy": "Kopyala",
  "modal.share.url_copied": "Bağlantı kopyalandı",
  "modal.share.pin_copied": "PIN kopyalandı",
  "modal.share.cli_copied": "CLI komutu kopyalandı",
  "upload.progress": "Yükleniyor",
  "upload.done": "Tamamlandı",
  "upload.error": "Hata",
  "upload.failed": "“{name}” yüklenemedi",
  "upload.aborted": "İptal edildi",
  "upload.cancel": "İptal",
  "upload.resuming": "“{name}” %{percent} noktasından devam ediyor",
  "upload.saving": "Depoya kaydediliyor…",
  "empty.folder": "Bu klasör boş",
  "empty.search": "Sonuç bulunamadı",
  loading: "Yükleniyor…",
  "notFound.title": "Klasör bulunamadı",
  "notFound.desc": "Bu klasör mevcut değil, taşınmış ya da erişim yetkiniz yok.",
  "notFound.goRoot": "Kök klasöre dön",
  "col.name": "Ad",
  "col.size": "Boyut",
  "col.modified": "Değiştirilme",
  "col.type": "Tür",
  "unit.bytes": "B",
  "unit.kb": "KB",
  "unit.mb": "MB",
  "unit.gb": "GB",
  "unit.tb": "TB",
  "unit.pb": "PB",
  "breadcrumb.root": "Kök",
  "breadcrumb.copy_path": "Yolu kopyala",
  "breadcrumb.go_to_path": "Yola git",
  "breadcrumb.path_placeholder": "fileman/foo/bar",
  "ops.copy": "Kopyalanıyor",
  "ops.move": "Taşınıyor",
  "ops.delete": "Siliniyor",
  "ops.queued": "sırada",
  "ops.done": "tamamlandı",
  "ops.error": "hata",
  "node.trash": "Çöp kutusu",
  "node.folder": "Klasör",
  // ——— Zengin önizleyici chrome ———
  "viewer.open_in_new_tab": "Yeni sekmede aç",
  "viewer.loading": "Yükleniyor…",
  "viewer.failed_to_load": "Dosya yüklenemedi",
  "viewer.peer_not_installed": "Bu tür bir dosya burada gösterilemiyor. Cihazınızda açmak için indirin.",
  "viewer.format_unsupported_3d": "Önizleme yalnızca .glb, .gltf ve .usdz biçimindeki 3B modelleri gösterir. Dosyayı indirip bir 3B programında açın.",
  "viewer.zoom_in": "Yakınlaştır",
  "viewer.zoom_out": "Uzaklaştır",
  "viewer.fit_width": "Sayfa genişliğine sığdır",
  "viewer.next_page": "Sonraki sayfa",
  "viewer.prev_page": "Önceki sayfa",
  "viewer.page_n_of_m": "Sayfa {n} / {m}",
  "viewer.tags": "Etiketler",
  "viewer.layers": "Katmanlar",
  "viewer.toc": "İçindekiler",
  "viewer.font_smaller": "Yazıyı küçült",
  "viewer.font_larger": "Yazıyı büyüt",
  "viewer.search": "Ara",
  "viewer.download": "İndir",
  "viewer.saving": "Kaydediliyor…",
  "viewer.save": "Kaydet (Ctrl+S)",
  "viewer.saved": "Kaydedildi",
  "viewer.save_error": "Hata",
  "viewer.editor_loading": "Editör yükleniyor…",
  "viewer.no_preview": "Bu dosya tipi için önizleme henüz yok.",
  "viewer.edit": "Düzenle",
  "viewer.close": "Kapat",
  "presence.expand": "Adları göster",
  "presence.collapse": "Küçült",
  "viewer.save_annotations": "Açıklamaları kaydet",
  "viewer.annotations_on": "Açıklamalar: açık",
  "viewer.annotations_off": "Açıklamalar: kapalı",
  "viewer.read_only": "Salt okunur",
  "viewer.csv_first_row_header": "İlk satır başlık olsun",
  "viewer.csv_filter": "Satır filtrele…",
  "viewer.epub_prev": "Önceki",
  "viewer.epub_next": "Sonraki",
  /* ⚠ Eski cümle her okuyucuya bir ORTAM DEĞİŞKENİ söylüyordu ("yönetici
     FILEX_DRAWIO_URL'yi ayarlamalı"). Yalnızca bir diyagrama bakmak isteyen
     kişiye ne yapabileceği; `_admin` — düzeltebilecek kişiye — nereden
     düzelteceği söylenir. */
  "viewer.drawio.disabled": "Diyagramlar burada açılamıyor: bu sunucuda draw.io yok. Başka bir yerde açmak için dosyayı indirin.",
  "viewer.drawio.disabled_admin": "Bu sunucuda draw.io kurulu değil. Yönetim panelinde Dış servisler altından kurabilirsiniz.",
  "viewer.drawio.load_failed": "Bu diyagram okunamadı. Başka bir yerde açmak için indirin.",
  "viewer.drawio.save_failed": "Diyagram kaydedilemedi. Değişiklikleriniz hâlâ düzenleyicide — yeniden deneyin.",
  "viewer.archive.entries": "{n} dosya",
  "viewer.archive.entries_one": "{n} dosya",
  "viewer.archive.empty": "Arşiv boş.",
  "viewer.archive.error": "Arşiv okunamadı.",
  "viewer.archive.unsupported": "Bu tür bir arşiv burada listelenemiyor. İçinde ne olduğunu görmek için indirin.",
  "viewer.archive.too_large": "Bu arşiv burada listelenemeyecek kadar büyük. İçinde ne olduğunu görmek için indirin.",
  "viewer.archive.open": "Arşivi aç",
  "viewer.archive.root": "Arşiv",
  "viewer.archive.location": "Arşiv konumu",
  "viewer.archive.reading": "Hâlâ okunuyor… İçeriği listelenmeden önce arşivin tamamı okunur; büyük bir arşivde bu biraz sürer.",
  "viewer.name": "Ad",
  "viewer.size": "Boyut",
  // ——— cila:a — sıralama / tarih grupları / yoğunluk ———
  "col.sort": "Sırala",
  "group.today": "Bugün",
  "group.yesterday": "Dün",
  "group.this_week": "Bu hafta",
  "group.this_month": "Bu ay",
  "group.no_date": "Tarihsiz",
  "toolbar.density.compact": "Sıkışık görünüm",
  "toolbar.density.comfortable": "Rahat görünüm",
  // ——— cila:c — komut paleti + kısayol yardımı + breadcrumb ———
  "palette.placeholder": "Dosya, klasör veya komut ara…",
  "palette.files": "Dosyalar",
  "palette.commands": "Komutlar",
  "palette.goto": "Yola git",
  "palette.empty": "Sonuç bulunamadı",
  "palette.hint": "↑↓ gezin · Enter seç · Esc kapat",
  "cmd.view_toggle": "Görünümü değiştir (liste ⇄ ızgara)",
  "cmd.trash": "Çöp kutusunu aç",
  "shortcuts.title": "Klavye kısayolları",
  "shortcuts.group.nav": "Gezinme",
  "shortcuts.group.selection": "Seçim",
  "shortcuts.group.file": "Dosya işlemleri",
  "shortcuts.palette": "Komut paleti",
  "shortcuts.search": "Aramaya odaklan",
  "shortcuts.go_up": "Üst klasöre çık",
  "shortcuts.open": "Seçili öğeyi aç",
  "shortcuts.close": "Kapat / vazgeç",
  "shortcuts.toggle_hidden": "Gizli dosyaları göster/gizle",
  "shortcuts.help": "Bu yardım penceresi",
  "shortcuts.select_all": "Tümünü seç",
  "shortcuts.star": "Yıldızla / yıldızı kaldır",
  "shortcuts.rename": "Yeniden adlandır",
  "shortcuts.delete": "Sil",
  "shortcuts.cut": "Kes",
  "shortcuts.copy": "Kopyala",
  "shortcuts.paste": "Yapıştır",
  "breadcrumb.more": "Aradaki klasörler",
  // ——— State screens + undo snackbar + connection badge (cila:b) ———
  "empty.hint": "Dosyaları buraya sürükleyip bırakın",
  "empty.upload": "Dosya yükle",
  "empty.search.title": "Aramanızla eşleşen dosya yok",
  "empty.search.hint": "Farklı bir arama terimi deneyin",
  "empty.trash.title": "Çöp kutusu boş",
  "error.title": "Liste yüklenemedi",
  "error.retry": "Yeniden dene",
  "toast.undo": "Geri al",
  "toast.undone": "Geri alındı",
  "toast.undoing": "Geri alınıyor…",
  "toast.undo_queued": "Geri alma kuyruğa alındı — bittiğini işlemler paneli gösterecek",
  "toast.undo_partial": "Kısmen geri alındı: {total} öğeden {done}",
  "toast.undo_failed": "Geri alınamadı",
  "toast.renamed": "Yeniden adlandırıldı",
  "toast.rename_queued": "“{name}” olarak yeniden adlandırılıyor…",
  "toast.moved": "Taşındı",
  "toast.trashed": "Çöpe taşındı",
  /* i18n:hardcoded — FileExplorer.vue'da düz string olarak duran, hiçbir dilin
     değiştiremediği bildirim metinleri. */
  "toast.failed": "İşlem başarısız",
  "err.status.400": "Geçersiz istek",
  "err.status.401": "Oturum açmanız gerekiyor",
  "err.status.403": "Bu işlem için yetkiniz yok",
  "err.status.404": "Bulunamadı",
  "err.status.409": "Zaten var / çakışma",
  "err.status.413": "Dosya çok büyük",
  "err.status.415": "Bu dosya türü desteklenmiyor",
  "err.status.422": "Geçersiz veri",
  "err.status.429": "Çok fazla istek, biraz bekleyin",
  "err.status.500": "Sunucu hatası",
  "err.status.501": "Bu işlem desteklenmiyor",
  "err.status.502": "Bağlı bir servis hata verdi",
  "err.status.503": "Servis şu an kullanılamıyor",
  "err.status.504": "Bağlı bir servis zamanında yanıt vermedi",
  "err.status.other": "Sunucu bu isteği kabul etmedi.",
  "err.upload_stalled": "Yükleme ilerlemeyi bıraktı. Yeniden deneyin — kaldığı yerden devam eder.",
  "err.network": "Sunucuya ulaşılamadı. Bağlantınızı kontrol edip yeniden deneyin.",
  "err.read_only": "Bu depo salt okunur",
  "err.no_secret_key": "Bu sunucuda şifreleme anahtarı tanımlı değil, bu yüzden erişim anahtarı verilemiyor. Yöneticinizden tanımlamasını isteyin.",
  "err.quota": "Depolama kotanız dolu.",
  "err.bad_kind": "Sunucu bu türde bir işi bu yoldan kuyruğa almıyor.",
  "err.not_cancellable": "Bu iş başladıktan sonra durdurulamaz — kendiliğinden tamamlanır.",
  "err.finished": "Bu iş zaten bitti.",
  "err.too_many": "Tek seferde en fazla {max} öğe geri getirilebilir. Daha küçük gruplar hâlinde geri getirin.",
  "err.name_taken": "Aynı adla bir şey zaten var. Oradakinin adını değiştirip yeniden deneyin.",
  "err.not_in_trash": "Artık çöpte değil — bu arada geri getirilmiş ya da kaldırılmış; hiçbir şey silinmedi.",
  "err.save_failed": "Değişiklikleriniz kaydedilemedi.",
  "err.load_failed": "Bu dosya yüklenemedi.",
  "err.viewer_failed": "Bu dosyanın görüntüleyicisi başlatılamadı. Açmak için dosyayı indirin.",
  "err.detail": "Ayrıntı",
  "opc.err.timeout": "Uygulama çok uzun sürdü ve durduruldu.",
  "opc.err.out_of_memory": "Uygulamanın bu dosyada belleği yetmedi.",
  "opc.err.crashed": "Uygulama beklenmedik biçimde durdu.",
  "opc.err.app_removed": "Bu iş çalışamadan uygulama kaldırıldı.",
  "opc.err.action_removed": "Bu eylem artık yok — uygulama güncellendi.",
  "opc.err.engine_missing": "Bunun için sunucuda olmayan bir program gerekiyor ({engine}). Yöneticinize başvurun.",
  "opc.err.engine_missing_admin": "Bunun için {engine} gerekiyor ve filex'i çalıştıran sunucuda kurulu değil. Oraya kurup yeniden deneyin.",
  "toast.copied": "Kopyalandı",
  "toast.deleted": "Silindi",
  "toast.cut": "Kesildi",
  "toast.cut_ready": "Kes → Yapıştır hazır",
  "toast.copy_ready": "Kopyala → Yapıştır hazır",
  "toast.same_folder_cut": "Aynı klasöre kesilemez",
  "toast.restored": "{n} öğe geri getirildi",
  "toast.restoring": "{n} öğe geri getiriliyor…",
  "toast.restoring_one": "{n} öğe geri getiriliyor…",
  "toast.restore_partial": "{n} öğe geri getirildi, {failed} öğe getirilemedi: {reason}",
  "toast.restore_partial_one": "{n} öğe geri getirildi, {failed} öğe getirilemedi: {reason}",
  "toast.restored_one": "{n} öğe geri getirildi",
  "toast.restore_taken": "{n} öğe geri getirilmedi: aynı adla bir şey zaten var. Oradakinin adını değiştirip yeniden deneyin.",
  "toast.restore_taken_one": "“{name}” geri getirilmedi: aynı adla bir şey zaten var. Oradakinin adını değiştirip yeniden deneyin.",
  "toast.delete_queued": "Silme kuyruğa alındı",
  "toast.trash_retention": "Çöpteki öğeler saklama süresi sonunda otomatik silinir. Kalıcı silme yönetici panelinden yapılır.",
  "toast.purging": "{n} öğe kalıcı olarak siliniyor…",
  "toast.purging_one": "{n} öğe kalıcı olarak siliniyor…",
  "toast.purging_partly": "{n} öğe kalıcı olarak siliniyor; {failed} öğe silinemedi: {reason}",
  "toast.purging_partly_one": "{n} öğe kalıcı olarak siliniyor; {failed} öğe silinemedi: {reason}",
  "toast.purged": "{n} öğe kalıcı olarak silindi",
  "toast.purged_one": "{n} öğe kalıcı olarak silindi",
  "toast.purged_partly": "{n} öğe kalıcı olarak silindi; {failed} öğe silinemedi: {reason}",
  "toast.purged_partly_one": "{n} öğe kalıcı olarak silindi; {failed} öğe silinemedi: {reason}",
  /* Kalıcı silinmesi yolda olan çöp satırı (yönetici Çöp sayfasının sözleri:
     iki katalogda tek cümle — ders #447). */
  "trash.purging": "Kalıcı olarak siliniyor…",
  "trash.row_busy": "Bu öğe üzerinde zaten bir iş sürüyor",
  "dropzone.hint": "Dosyaları buraya bırak",
  "modal.newfolder.invalid": "Geçersiz karakter",
  "names.reserved": "“{name}” adı filex’in kendi kullanımına ayrılmış. Başka bir ad seçin.",
  /* ⚠ Eksik ya da bozuk belge sunucusu kelimelerle söylenir, asla HTTP
     katmanıyla değil (eskiden `Config fetch 503: {"error":"onlyoffice not
     configured"}` yazıyordu). `_admin`, düzeltebilecek kişinin okuduğu —
     nereden düzelteceği; diğer herkes dosyayı yine de nasıl alacağını okur. */
  "viewer.office_unconfigured": "Ofis belgeleri burada açılamıyor: bu sunucuda ONLYOFFICE belge sunucusu yok. Dosyayı bilgisayarınızda açmak için indirin.",
  "viewer.office_unconfigured_admin": "Bu sunucuda ONLYOFFICE kurulu değil, bu yüzden ofis belgeleri burada açılamıyor. Yönetim panelinde Dış servisler altından kurabilirsiniz.",
  "viewer.office_unreachable": "Belge sunucusu şu anda yanıt vermiyor. Daha sonra yeniden deneyin ya da dosyayı indirin.",
  "viewer.office_unreachable_admin": "ONLYOFFICE belge sunucusu yanıt vermiyor. Yönetim panelinde Dış servisler altından kontrol edin.",
  "viewer.office_failed": "Bu belge ONLYOFFICE ile açılamadı. Bilgisayarınızda açmak için indirin.",
  "viewer.office_forbidden": "Bu belgeyi ONLYOFFICE ile açma izniniz yok.",
  /* Gezginin "Aç" girdisi, belge sunucusu yokken — yalnızca yöneticiye
     gösterilir (diğer herkese girdi hiç sunulmaz; lib/serviceGate). */
  "ctx.needs_onlyoffice": "ONLYOFFICE kurulu değil — yönetim panelinde Dış servisler altından kurun.",
  "ctx.needs_drawio": "draw.io kurulu değil — yönetim panelinde Dış servisler altından kurun.",
  "viewer.pdf_inline_failed": "Tarayıcı PDF'i inline açamadı.",
  "viewer.too_large": "Dosya çok büyük (>1 MB).",
  "viewer.csv_rows": "{n} satır",
  "viewer.csv_rows_one": "{n} satır",
  "presence.others": "{n} kişi",
  "presence.others_one": "{n} kişi",
  "conn.offline": "Canlı bağlantı yok — değişiklikler gecikebilir",
  "conn.tooltip": "Sunucuyla canlı bağlantı kurulamadı; liste belirli aralıklarla otomatik yenilenir. Bağlantı geri gelince bu uyarı kaybolur.",
  /* === bul:s3 === */
  "palette.everywhere": "Her yerde",
  "palette.searching": "Aranıyor…",
  "palette.everywhere_failed": "Arama yapılamadı. Yeniden deneyin.",
  "palette.saved": "Kayıtlı aramalar",
  "palette.save": "Aramayı kaydet",
  "palette.saved.delete": "Kayıtlı aramayı sil",
  "search.in_content": "İçerikte",
  "search.truncated": "Gösterilenden daha fazla sonuç var — aramanızı daraltın",
  /* Katalog kapsamı (docs/LAZY-CATALOGUE.md, lib/catalogCoverage). */
  "coverage.first_scan": "Bu deponun ilk senkronu henüz bitmedi. Bitene kadar arama, klasör boyutları ve kullanım deponun bir kısmını kapsamaz.",
  "coverage.lazy_filling": "filex bu depoyu hâlâ kataloglıyor (şimdiye kadar bulunan klasörlerin %{pct} kadarı tamam). Bitene kadar arama, klasör boyutları ve kullanım deponun bir kısmını kapsamaz.",
  "coverage.lazy_on_open": "Bu depoda yalnız açılan klasörler kataloglanır. Arama, klasör boyutları ve kullanım yalnız bu klasörleri kapsar.",
  "coverage.search_some": "Şu depoların tamamı henüz kataloglanmadı: {names}. Bu arama oradaki bazı dosyaları bulamayabilir.",
  "coverage.catalog_all": "Tümünü katalogla",
  "coverage.catalog_started": "Senkron başladı — deponun tamamı kataloglanıyor.",
  "coverage.catalog_running": "Kataloglanıyor…",
  "coverage.cataloging": "{storage} kataloglanıyor… arka planda sürüyor, bittiğinde bu sayfa söyleyecek.",
  "coverage.catalog_done": "{storage} baştan sona kataloglandı",
  "coverage.catalog_failed": "{storage} kataloglanamadı. Nedenini yönetim panelinde, deponun senkron geçmişinde görebilirsiniz.",
  "coverage.catalog_stopped": "{storage} kataloglaması bitmeden durduruldu",
  "coverage.catalog_joined": "{storage} zaten taranıyordu — bittiğinde bu sayfa haber verecek.",
  "coverage.catalog_gone": "{storage} kataloglanırken kaldırıldı",
  "coverage.catalog_unfollowed": "{storage} arka planda kataloglanmaya devam ediyor; nasıl bittiğini yönetim panelinde deponun senkron geçmişi gösterir",
  "size.at_least": "≥ {size}",
  "size.partial_hint": "Bu klasörün bir kısmı henüz kataloglanmadı; boyutu en az bu kadar.",
  "size.unknown_hint": "Bu klasör henüz kataloglanmadı; boyutu bilinmiyor.",
  /* === bag:b4 === */
  "toolbar.more": "Diğer işlemler",
  "toolbar.search.close": "Aramayı kapat",
  "sheet.menu": "İşlemler",
  "sheet.close": "Kapat",
  /* === koru:k1 === */
  "toolbar.inspector": "Ayrıntılar",
  "ctx.details": "Ayrıntılar",
  /* yildiz:s1 — yıldızlamak bir eylem, menüde de öyle görünür. */
  "ctx.star": "Yıldızla",
  "ctx.unstar": "Yıldızı kaldır",
  "star.failed": "Yıldız değiştirilemedi",
  "shortcuts.inspector": "Ayrıntılar panelini aç/kapat",
  "inspector.title": "Ayrıntılar",
  "inspector.copy_name": "Adı kopyala",
  "inspector.items": "{n} öğe",
  "inspector.items_one": "{n} öğe",
  "inspector.type": "Tür",
  "inspector.select_hint": "Ayrıntılarını görmek için bir öğe seçin.",
  /* pane:p1 — panel SON seçilen şeyi tutar (Burak'ın kararı, 2026-09-13);
     dolayısıyla bölünmüş pencerenin bakılmayan yarısındaki bir öğeyi
     anlatıyor olabilir. Bu satır hangisi olduğunu ve nerede durduğunu söyler. */
  "inspector.held": "Son seçilen — {where} içinde",
  "inspector.close": "Kapat",
  "inspector.section.general": "Genel",
  "inspector.section.tags": "Etiketler",
  /* etiket:t1 — TagPicker'ın kendi çerçevesi. 2026-09-13'e kadar bu üçü
     katalogdan bağımsız olarak İngilizce basılıyordu; `tags.open` ise çipin
     yeni "bu etiketi taşıyan her şeyi göster" kapısı. */
  "tags.open": "Etiketi aç: {tag}",
  "tags.add": "+ Etiket ekle",
  "tags.name": "Etiket adı",
  "tags.remove": "Etiketi kaldır",
  /* etiket:k2 (v0.43.0) — etiketin iki TÜRÜ. Etiket nerede çiziliyorsa türünü
     simgeyle birlikte sözcükle de söyler: bu sürüme kadar her etiket sessizce
     sunucudaki herkesle paylaşılıyordu. */
  "tags.kind.label": "Bu etiketi kim görür",
  "tags.kind.personal": "Kişisel",
  "tags.kind.team": "Ekip",
  "tags.kind.personal_help": "Yalnızca siz görürsünüz",
  "tags.kind.team_help": "Bu dosyayı görebilen ekibindeki herkes görür",
  "tags.kind.team_locked": "Ekip etiketi eklemek ya da kaldırmak için bu dosyada düzenleme yetkiniz olmalı.",
  "tags.chip.personal": "Kişisel etiket “{tag}” — yalnızca siz görürsünüz",
  "tags.chip.team": "Ekip etiketi “{tag}” — bu dosyayı görebilen ekibindeki herkes görür",
  "tags.add_submit": "Ekle",
  "inspector.section.versions": "Sürümler",
  "inspector.section.permissions": "İzinler",
  "inspector.section.shares": "Paylaşımlar",
  "inspector.path": "Yol",
  "inspector.size": "Boyut",
  "inspector.modified": "Değiştirilme",
  "inspector.mime": "MIME türü",
  "inspector.etag": "ETag",
  "inspector.nodeId": "Düğüm kimliği",
  "inspector.copy": "Kopyala",
  "inspector.copied": "Kopyalandı",
  "inspector.error": "Yüklenemedi",
  "inspector.items_summary": "{n} öğe, toplam {size}",
  "inspector.items_summary_one": "{n} öğe, toplam {size}",
  "inspector.folder_items": "{n} öğe",
  "inspector.folder_items_one": "{n} öğe",
  "inspector.versions.empty": "Sürüm geçmişi yok",
  "inspector.versions.v": "Sürüm {n}",
  "inspector.versions.restore": "Geri yükle",
  "inspector.versions.restore_confirm": "Bu sürüm geri yüklensin mi?",
  "inspector.versions.snapshot_current": "Önce şimdiki halin sürümünü al",
  "inspector.versions.confirm": "Onayla",
  "inspector.versions.restoring": "Geri yükleniyor…",
  "inspector.versions.cancel": "Vazgeç",
  "inspector.versions.take_snapshot": "Şimdiki halin sürümünü al",
  "inspector.versions.snapshotting": "Sürüm alınıyor…",
  "inspector.versions.restored": "Sürüm geri yüklendi",
  "inspector.versions.snapshotted": "Sürüm alındı",
  "inspector.versions.unsupported": "Sunucu bu işlemi desteklemiyor",
  "inspector.perm.none": "Erişim yok",
  "inspector.perm.viewer": "Görüntüleyen",
  "inspector.perm.editor": "Düzenleyen",
  "inspector.perm.owner": "Sahip",
  "inspector.perm.manage": "İzinleri yönet",
  "inspector.shares.empty": "Paylaşım bağlantısı yok",
  "inspector.shares.copy": "Bağlantıyı kopyala",
  /* wiring:c1 — tema galerisi */
  "theme.menu": "Tema",
  "theme.title": "Tema galerisi",
  "theme.hint": "Tema yalnız renk paletini değiştirir; gündüz mü gece mi olduğu yukarıdaki seçim.",
  "theme.mode.label": "Görünüm",
  "theme.mode.light": "Gündüz",
  "theme.mode.dark": "Gece",
  "theme.mode.auto": "Otomatik",
  "theme.reset": "Varsayılana dön",
  "theme.close": "Kapat",
  "theme.selected": "Seçili",
  "theme.name.default": "Varsayılan",
  "theme.name.night": "Gece mavisi",
  "theme.name.forest": "Orman",
  "theme.name.amber": "Kehribar",
  "theme.name.lilac": "Leylak",
  "theme.name.contrast": "Yüksek kontrast",
  "theme.name.gray": "Yumuşak gri",
  "theme.name.terminal": "Terminal yeşili",
  /* === zaman:z3 — saat dilimi seçici (gömme penceresi + web ayarları) === */
  "tz.menu": "Saat dilimi",
  "tz.title": "Saat dilimi",
  "tz.label": "Tarihleri şu saatle göster",
  "tz.search": "Şehir, ülke ya da saat farkı arayın — “İstanbul” veya “GMT+3” deneyin",
  "tz.default.device": "Bu cihazın saat dilimini kullan ({zone})",
  "tz.default.account": "Hesabınızın saat dilimini kullan ({zone})",
  "tz.default.host": "Bu sitenin varsayılanını kullan ({zone})",
  "tz.no_match": "“{query}” ile eşleşen saat dilimi yok. Bir şehir, bir ülke ya da GMT+3 gibi bir fark deneyin.",
  "tz.more": "{n} kayıt daha var — listeyi daraltmak için yazmayı sürdürün.",
  "tz.hint": "Yalnızca bu tarayıcıda saklanır. Her tarih tek bir an olarak saklanır ve burada seçtiğiniz saatle gösterilir.",
  "tz.now": "{zone} bölgesinde şu an: {time}",
  /* === wiring:c2 — özelleştirilebilir kısayollar + hızlı bakış === */
  "shortcuts.quicklook": "Hızlı bakış",
  "shortcuts.customize": "Özelleştir",
  "shortcuts.settings.menu": "Kısayollar",
  "shortcuts.settings.title": "Kısayol ayarları",
  "shortcuts.settings.hint": 'Bir kısayolu değiştirmek için "Değiştir"e basıp yeni tuş kombinasyonuna basın. Değişiklikler yalnızca bu tarayıcıda saklanır.',
  "shortcuts.settings.change": "Değiştir",
  "shortcuts.settings.capture": "Tuşlara basın… (Esc iptal)",
  "shortcuts.settings.reset": "Varsayılana dön",
  "shortcuts.settings.reset_all": "Tümünü sıfırla",
  "shortcuts.settings.unbound": "Atanmadı",
  "shortcuts.settings.fixed": "Sabit",
  "shortcuts.settings.customized": "Özelleştirildi",
  "shortcuts.settings.conflict": 'kombinasyonu "{name}" kısayolunda kullanılıyor.',
  "shortcuts.settings.conflict_fixed": 'kombinasyonu "{name}" sabit kısayoluna ayrılmış — kullanılamaz.',
  "shortcuts.settings.conflict_take": "Eskisini boşa çıkar ve ata",
  "shortcuts.settings.conflict_cancel": "Vazgeç",
  "quicklook.hint_close": "kapat",
  "quicklook.hint_nav": "önceki/sonraki",
  "quicklook.hint_open": "aç",
  /* === /wiring:c2 === */
  /* === wiring:c3 — işlem merkezi === */
  "opc.title": "İşlemler",
  "opc.aria_badge": "{n} işlem — işlem merkezini aç/kapat",
  "opc.aria_badge_one": "{n} işlem — işlem merkezini aç/kapat",
  "opc.close": "Kapat",
  "opc.active": "Sürüyor",
  "opc.history": "Geçmiş",
  "opc.clear": "Temizle",
  "opc.empty": "İşlem yok",
  "opc.cancel": "İptal",
  "opc.retry": "Yeniden dene",
  "opc.dismiss": "Kapat",
  "opc.queued": "Sırada",
  "opc.cancelling": "İptal isteniyor…",
  "opc.percent": "%{n}",
  "opc.items": "{total} öğeden {done}",
  "opc.trash_items": "Çöpten {n} öğe",
  "opc.trash_items_one": "Çöpten {n} öğe",
  "opc.status.running": "Sürüyor",
  "opc.status.done": "Bitti",
  "opc.status.error": "Hata",
  "opc.status.aborted": "İptal edildi",
  "opc.kind.upload": "Yükleme",
  "opc.kind.copy": "Kopyalama",
  "opc.kind.move": "Taşıma",
  "opc.kind.delete": "Silme",
  "opc.kind.rename": "Yeniden adlandırma",
  "opc.kind.restore": "Geri getirme",
  "opc.kind.purge": "Kalıcı silme",
  "opc.kind.convert": "Dönüştürme",
  "opc.kind.archive": "Arşiv",
  "opc.kind.plugin": "Uygulama",
  "opc.kind.trash": "Çöp kutusunu boşaltma",
  "opc.open": "Aç",
  /* Uygulama eklentileri — dosya menüsüne eklenen satırlar ve kuyruğa
     aldıkları işler (docs/APP-PLUGINS-API.md). */
  "plugin.queued": "{label} kuyruğa alındı",
  "plugin.done": "{label} tamamlandı",
  "plugin.failed": "{label} başarısız",
  "plugin.cancel_failed": "İş iptal edilemedi",
  "plugin.not_applicable": "Bu işlem seçime uygulanamaz",
  "plugin.read_only": "Bu depo salt okunur",
  "plugin.needs_engine": "{name} bu sunucuda kurulu değil — sunucuya kurup filex'i yeniden başlatın.",
  "plugin.needs_other": "{name} bu sunucuda kullanılamıyor.",
  "plugin.confirm.title": "Onayla",
  "plugin.confirm.cancel": "Vazgeç",
  "plugin.confirm.run": "Çalıştır",
  "plugin.view.close": "Kapat",
  "appframe.confirm_title": "Onay",
  "appframe.consent_clipboard": "{app} panonuza metin kopyalamak istiyor.",
  "appframe.consent_download": "{app}, “{name}” dosyasını bilgisayarınıza kaydetmek istiyor.",
  "appframe.consent_job": "{app} “{action}” işini başlatmak istiyor.",
  "appframe.consent_allow": "İzin ver",
  "appframe.consent_deny": "İzin verme",
  "appframe.unsaved_title": "Kaydedilmemiş değişiklikler",
  "appframe.unsaved_text": "{app} içinde kaydedilmemiş değişiklikler var. Yine de kapatılsın mı?",
  "appframe.discard": "Kaydetmeden kapat",
  "appframe.keep_open": "Düzenlemeye devam et",
  "appframe.save_close": "Kaydet ve kapat",
  "appframe.updated": "{app}, {version} sürümüne güncellendi.",
  "appframe.updated_reload": "Bir yönetici {app} uygulamasının yeni sürümünü onayladı. Yeni sürümü kullanmak için yeniden yükleyin — önce çalışmanızı kaydedin.",
  "appframe.reload": "Yeniden yükle",
  "appframe.dismiss": "Kapat",
  "appframe.not_connected": "{app} başlamadı. Kapatıp yeniden açın; tekrar ederse yöneticinize haber verin.",
  "plugin.view.busy": "Çalışıyor…",
  "plugin.view.unsupported": "Bu ekran, bu sürümün çizemediği bir bileşen kullanıyor ({type})",
  "plugin.view.error": "Uygulama hata döndürdü",
  "plugin.output_missing": "Çıktı artık eski yerinde değil",
  /* M2 — surface components (components/plugin/nodes/*) */
  "plugin.view.loading": "Yükleniyor…",
  "plugin.view.preview_failed": "Önizleme yüklenemedi",
  "plugin.steps.label": "Adımlar",
  "plugin.list.empty": "Henüz bir şey yok",
  "plugin.list.actions": "İşlemler",
  /* The label on a table row's ONE action control (core RowActions.vue).
     The explorer's handle is the ⋮ glyph; a panel row's says what it is.
     Owner, 2026-09-20: "adminde 'Aksiyon' diye yazmalı". */
  "row.actions": "Aksiyon",
  "plugin.people.placeholder": "Ad veya e-posta",
  "plugin.people.placeholder_email": "E-posta adresi",
  "plugin.people.add": "Ekle",
  "plugin.people.remove": "{name} kişisini kaldır",
  "plugin.people.invalid_email": "Geçerli bir e-posta adresi girin",
  "plugin.people.external_off": "Yalnızca hesabı olan kişiler eklenebilir",
  "plugin.pin.label": "PIN",
  "plugin.file.choose": "Seç…",
  "plugin.file.clear": "Temizle",
  "plugin.file.none": "Seçim yok",
  /* M3 — imza yolu: signature-pad + pdf-fields düğümleri ve dış katılımcının
     herkese açık sayfası (views/PublicSurface.vue, usePublicPage). */
  "plugin.sig.mode_draw": "Çiz",
  "plugin.sig.mode_type": "Yaz",
  "plugin.sig.mode_upload": "Yükle",
  "plugin.sig.draw_hint": "Parmağınızla ya da fareyle buraya imzalayın",
  "plugin.sig.type_placeholder": "Adınızı yazın",
  "plugin.sig.upload_pick": "Görsel seç…",
  "plugin.sig.upload_hint": "PNG ya da JPEG, en çok {kb} KB",
  "plugin.sig.upload_too_big": "Görsel {kb} KB sınırından büyük",
  "plugin.sig.upload_bad_type": "Yalnızca PNG ya da JPEG görsel kullanılabilir",
  "plugin.sig.upload_unreadable": "Görsel okunamadı",
  "plugin.sig.clear": "İmzayı temizle",
  "plugin.sig.signed": "İmza alındı",
  "plugin.pdf.load_failed": "Belge yüklenemedi",
  "plugin.pdf.palette": "Alan türleri",
  "plugin.pdf.pending": "Yeri bekleyen kutular",
  "plugin.pdf.place_box_hint": "“{name}” kutusunun gideceği yere dokunun ya da boyutlandırmak için sürükleyin",
  "plugin.pdf.all_placed": "Her kutunun bir yeri var",
  "plugin.pdf.place_idle": "Yukarıdaki kutulardan birini seçin, sonra sayfada gideceği yere dokunun.",
  "plugin.pdf.place_idle_done": "Kaldırmak ya da kopyalamak için sayfadaki bir kutuya dokunun; taşımak için sürükleyin.",
  "plugin.pdf.no_boxes": "Henüz kutu yok. Aşağıdan ekleyin: adını verin, kimin olduğunu söyleyin; yerini bir sonraki adımda belgede seçeceksiniz.",
  "plugin.pdf.add_box": "Kutu ekle",
  "plugin.pdf.unplace": "Sayfadan kaldır",
  "plugin.pdf.place_hint": "{type} alanının gideceği yere dokunun ya da boyutlandırmak için sürükleyin",
  "plugin.pdf.type_signature": "İmza",
  "plugin.pdf.type_initials": "Paraf",
  "plugin.pdf.type_date": "Tarih",
  "plugin.pdf.type_text": "Metin",
  "plugin.pdf.type_checkbox": "Onay kutusu",
  "plugin.pdf.tap_signature": "İmzalamak için dokunun",
  "plugin.pdf.tap_initials": "Paraflamak için dokunun",
  "plugin.pdf.tap_date": "Bugünün tarihi için dokunun",
  "plugin.pdf.tap_text": "Metin",
  "plugin.pdf.tap_checkbox": "İşaretlemek için dokunun",
  "plugin.pdf.label": "Ad",
  "plugin.pdf.assignee": "İmzacı",
  "plugin.pdf.unassigned": "Herkes",
  "plugin.pdf.filled_by": "Dolduran",
  "plugin.pdf.style": "Nasıl imzalanır",
  "plugin.pdf.style_drawn": "Çizerek",
  "plugin.pdf.style_typed": "Yazarak",
  "plugin.pdf.lines": "Altına yazılanlar",
  "plugin.pdf.lines_preview": "İmzanın altında:",
  "plugin.pdf.lines_none": "Bu imzanın altına bir şey yazılmaz.",
  "plugin.pdf.required": "Zorunlu",
  "plugin.pdf.copy_to_page": "Sayfaya kopyala",
  "plugin.pdf.copy": "Kopyala",
  "plugin.pdf.delete": "Alanı sil",
  "plugin.pdf.zoom_in": "Yakınlaştır",
  "plugin.pdf.zoom_out": "Uzaklaştır",
  "plugin.pdf.zoom_fit": "Genişliğe sığdır",
  "plugin.pdf.zoom_fit_page": "Sayfayı ekrana sığdır",
  "plugin.pdf.pad_for": "{type} alanınız",
  "plugin.pdf.pad_done": "Tamam",
  "plugin.page.loading": "Yükleniyor…",
  "plugin.page.pin_title": "Bu sayfa korumalı",
  "plugin.page.pin_hint": "Devam etmek için size verilen PIN'i girin",
  "plugin.page.pin_submit": "Devam et",
  "plugin.page.pin_wrong": "Bu PIN doğru değil",
  "plugin.page.pin_locked": "Çok fazla yanlış PIN girildi — birkaç dakika bekleyip yeniden deneyin",
  "plugin.page.unavailable_title": "Bu bağlantı kullanılamıyor",
  "plugin.page.unavailable_text": "Süresi dolmuş, hakkı tükenmiş ya da geri çekilmiş olabilir. Gönderen kişiden yeni bir bağlantı isteyin.",
  "plugin.page.accepted_title": "Alındı, teşekkürler",
  "plugin.page.accepted_text": "Yanıtınız kaydedildi. Bu sayfayı kapatabilirsiniz.",
  "plugin.page.done_title": "Tamamlandı",
  "plugin.page.done_text": "Burada yapılacak başka bir şey kalmadı. Bu sayfayı kapatabilirsiniz.",
  "plugin.page.error_title": "Bir sorun oluştu",
  "plugin.page.retry": "Yeniden dene",
  "plugin.page.files": "Belgeler",
  "plugin.page.open_file": "{name} dosyasını yeni sekmede aç",
  "plugin.page.footer": "filex ile sunuldu",
  /* === v3 — tek public kabuk: paylaşım, dosya isteği ve bir uygulamanın
     sayfası tek sayfanın üç gövdesi. Aşağıdakiler kabuğun kendi sözleri;
     hangi bağlantı açılmış olursa olsun aynı cümleler görünür. === */
  "public.served_by": "{name} ile paylaşıldı",
  "public.expires": "Bağlantı {when} tarihinde çalışmayı bırakıyor",
  "public.visits_left": "{n} ziyaret kaldı",
  "public.visits_left_one": "{n} ziyaret kaldı",
  "public.language_from": "{app} uygulamasından geldi",
  "public.up": "Bir üst klasör",
  "public.download_all": "Hepsini indir",
  "public.browse": "İçine bak",
  "public.folder_empty": "Bu klasörde bir şey yok",
  "public.drop_sub": "Dosyalarınızı aşağıya bırakın ya da seçin. Bu klasöre yalnızca ekleyebilirsiniz; içinde hâlihazırda ne olduğu size görünmez.",
  "public.drop_here": "Dosyaları buraya bırakın",
  "public.or_choose": "ya da seçmek için tıklayın",
  "public.max_size": "Dosya başına en çok {size}",
  "public.accepts": "Kabul edilenler: {list}",
  "public.files_left": "{n} dosya daha gönderilebilir",
  "public.files_left_one": "{n} dosya daha gönderilebilir",
  "public.request_full": "İstenen her şey ulaştı",
  "public.upload_done": "Gönderildi",
  "public.upload_failed": "Gönderilemedi",
  "public.upload_saving": "Kaydediliyor…",
  "public.upload_unanswered": "Gönderildi ama sunucu zamanında onaylamadı. Hâlâ kaydediyor olabilir: yeniden göndermeden önce bu bağlantıyı size gönderen kişiye sorun.",
  "public.your_name": "Adınız (isteğe bağlı)",
  "public.your_name_ph": "Örn. Ahmet Yılmaz",
  "public.refused_ext": "Gönderilmedi — bu bağlantı bu türde dosya kabul etmiyor.",
  "public.refused_too_large": "Gönderilmedi — {size} sınırından büyük.",
  "public.refused_too_many": "Gönderilmedi — şu an en fazla {count} dosya gönderilebilir.",
  "public.refused_too_many_one": "Gönderilmedi — şu an en fazla {count} dosya gönderilebilir.",
  /* === Uygulama eklentileri v2 — `page` görünümü, uygulamanın dosya kilidi,
     işin yazdığı çıktı kipi, imza alanının yazı tipleri ve kuralları. === */
  "plugin.page_view.back": "Dosyalara dön",
  "plugin.page_view.queued_title": "İş kuyruğa alındı",
  "plugin.page_view.queued_text": "filex işi yürütüyor. İlerleyişi işlemler tepsisinde; bittiğinde haber verilecek.",
  "plugin.page_view.open_ops": "İşlemler tepsisini aç",
  "plugin.page_view.done_title": "Tamamlandı",
  "plugin.page_view.done_text": "Burada yapılacak başka bir şey kalmadı. Bu sekmeyi kapatabilirsiniz.",
  "plugin.page_view.error_title": "Bu ekran açılamadı",
  "plugin.page_view.retry": "Yeniden dene",
  "plugin.page_view.blocked": "Yeni sekme engellendi — bu site için açılır pencerelere izin verin, yoksa ekran pencere içinde açılır",
  "plugin.output.sibling": "yeni dosya",
  "plugin.output.version": "yeni sürüm",
  "plugin.output.sibling_title": "Sonuç, aslının yanına yeni bir dosya olarak iner",
  "plugin.output.version_title": "Sonuç, dosyanın yerine yeni bir sürümü olarak geçer",
  "plugin.sign.font_label": "El yazısı",
  "plugin.pdf.font": "Yazı tipi",
  "plugin.pdf.rule_number": "Yalnızca sayı",
  "plugin.pdf.rule_email": "E-posta adresi",
  "plugin.pdf.rule_length": "{min} ile {max} karakter arasında",
  "plugin.pdf.rule_min": "En az {min} karakter",
  "plugin.pdf.rule_max": "En çok {max} karakter",
  "plugin.pdf.err_number": "Bir sayı girin",
  "plugin.pdf.err_email": "Geçerli bir e-posta adresi girin",
  "plugin.pdf.err_min": "Çok kısa — en az {min} karakter",
  "plugin.pdf.err_max": "Çok uzun — en çok {max} karakter",
  "applock.badge": "Kilitli",
  "applock.some_app": "bir uygulama",
  "applock.held": "{app} bu dosyayı kilitledi",
  "applock.held_reason": "{app} bu dosyayı kilitledi: {reason}",
  "applock.until": "— {date} tarihine kadar",
  "applock.inspector": "Uygulama kilidi",
  /* issue #34 — sunucunun İZLEMEDİĞİ sembolik bağ (lib/symlink). Rozet satırdaki
     kısa söz; `why` ise arkasındaki cümle — üzerine gelince, ayrıntılar panelinde
     ve biri açmaya kalkıştığında çıkan bildirimde. ⚠ Kırık bağ ile depo dışına
     çıkan bağ AYRI durumlardır ve ayrı okunmalıdır: yalnızca birinin yönetici
     çaresi vardır; silinmiş bir hedef için o çareyi önermek insanı işe yaramayacak
     bir ayar ekranına yollar. */
  "symlink.badge.outside_root": "Depo dışında",
  "symlink.badge.broken": "Kırık bağ",
  "symlink.badge.unresolved": "Uzak bağ",
  "symlink.badge.unknown": "Bağlantı",
  "symlink.why.outside_root": 'Hedefi bu deponun dışında kalan bir bağ; bu yüzden açılamıyor. Bir yönetici, deponun ayarlarındaki "Bu klasörün dışına çıkan sembolik bağları izle" seçeneğiyle buna izin verebilir.',
  "symlink.why.broken": "Hedefi artık var olmayan bir bağ; açılacak bir şey yok. Sunucuda onarılması ya da kaldırılması gerekir — hiçbir ayar silinmiş hedefi geri getirmez.",
  "symlink.why.unresolved": "Uzak sunucudaki bir bağ. filex hedefinin bu deponun içinde olup olmadığını bilemediği için bağı izlemez ve açamaz.",
  "symlink.why.unknown": "filex'in izlemediği bir bağ, bu yüzden açılamıyor. Hedefi ya bu deponun dışında, ya kayıp, ya da filex'in çözümleyemediği uzak bir sunucuda.",
  "symlink.inspector": "Açılamayan bir bağ",
  "plugin.pdf.rule": "Kabul ettiği",
  "plugin.pdf.rule_kind_any": "Serbest metin",
  "plugin.pdf.rule_kind_number": "Yalnızca sayı",
  "plugin.pdf.rule_kind_email": "E-posta adresi",
  "plugin.pdf.rule_min_label": "En az uzunluk",
  "plugin.pdf.rule_max_label": "En çok uzunluk",
  "plugin.pdf.format": "Tarih biçimi",
  "plugin.pdf.date_order": "Tarih sırası",
  "plugin.pdf.date_separator": "Ayraç",
  "plugin.pdf.date_example": "Örnek",
  "opc.kind.archive-create": "Arşiv oluşturuluyor",
  "opc.kind.archive-extract": "Arşiv çıkarılıyor",
  /* === wiring:c4 — onboarding turu + erişilebilirlik + hata kartı === */
  "tour.aria": "Tanıtım turu",
  "tour.restart": "Turu tekrar başlat",
  "tour.skip": "Turu atla",
  "tour.back": "Geri",
  "tour.next": "İleri",
  "tour.done": "Bitti",
  "tour.progress": "{n} / {m}",
  "tour.step.nav.title": "Depolar ve görünümler",
  "tour.step.nav.desc": "Ana sayfa, Benimle paylaşılanlar, Son kullanılanlar, Yıldızlılar ve Çöp kutusu hep bu panelde durur; altında da depolarınız ve bağlantılarınız. Sol üst köşedeki düğme paneli ince bir şeride indirir ve geri açar.",
  "tour.step.nav.desc_closed": "Bu düğme gezinti panelini açar: Ana sayfa, Benimle paylaşılanlar, Son kullanılanlar, Yıldızlılar ve Çöp kutusu; altında da depolarınız ve bağlantılarınız.",
  "tour.step.new.title": "Yeni bir şey ekle",
  "tour.step.new.desc": "Yeni olan her şey buradan başlar: bu cihazdan dosya yükleyebilir, klasör oluşturabilir ya da birinden dosya isteyebilirsiniz. Dosyaları pencereye sürükleyip bırakmak da yükler.",
  "tour.step.new.desc_fab": "Bu düğme bu cihazdan dosya yükler. Dosyaları pencereye sürükleyip bırakmak da çalışır.",
  "tour.step.search.title": "Arama",
  "tour.step.search.desc": 'Bu alan deponun tamamında ada göre arar; ayraçları ve bir harflik yazım hatasını affeder, yani "fatura 2026" yazdığınızda fatura_2026.pdf gelir. tag:fatura yazarak etikete göre filtreleyebilirsiniz. Yanındaki sürgü düğmesi gelişmiş aramayı, {palette} ise komut paletini açar; palet komut da çalıştırır.',
  "tour.step.crumb.title": "Bulunduğunuz yer",
  "tour.step.crumb.desc": "Bu iz, ekrandaki klasörün adresidir. Adımlardan birine tıklayarak üste çıkabilir, sonuncusunun yanındaki oktan içindeki klasörleri görebilirsiniz.",
  "tour.step.filters.title": "Listeyi daralt",
  "tour.step.filters.desc": "Tür, Sahibi, Değiştirilme ve Boyut bulunduğunuz klasörü filtreler; yanındaki kutu siz yazdıkça adlara göre eşleşir, satırın sonundaki denetim ise sıralar.",
  "tour.step.view.title": "Görünümü değiştir",
  "tour.step.view.desc": "Bu klasörün nasıl çizildiğini değiştirir; seçiminiz hatırlanır.",
  "tour.step.details.title": "Ayrıntılar ve paylaşım",
  "tour.step.details.desc": 'Bir dosyayı seçip bu paneli açtığınızda ayrıntılarını, hareketlerini ve paylaşım bağlantılarını görürsünüz. Tam menü için dosyaya sağ tıklayın ya da satırının sonundaki düğmeyi kullanın: oradaki "Paylaş" ile PIN ve son kullanma süresi verilebilen bir bağlantı oluşturulur.',
  "tour.step.help.title": "Kısayollar",
  "tour.step.help.desc": '{help} tuşu kısayol kartını, {palette} komut paletini açar. Tema ve "Turu tekrar başlat" sağ üstteki "Diğer işlemler" menüsünde; hesabınız ve oturumu kapatma ise yanındaki avatarın arkasında.',
  "error.hint": "Bağlantı ya da sunucu kaynaklı geçici bir sorun olabilir. Yeniden deneyin.",
  "error.details": "Teknik ayrıntılar",
  "col.star": "Yıldız",
  "toolbar.view_label": "Görünüm",
  "list.aria": "Dosya listesi",
  "grid.aria": "Dosya ızgarası",
  /* === wiring:d1 — sekmeler + split panel === */
  "tabs.strip": "Sekmeler",
  "tabs.new": "Yeni sekme",
  "tabs.close": "Sekmeyi kapat",
  "tabs.split": "Görünümü böl",
  "tabs.split_off": "Bölmeyi kapat",
  "ctx.open_new_tab": "Yeni sekmede aç",
  "ctx.open_with": "{app} ile aç",
  "shortcuts.group.tabs": "Sekmeler",
  "shortcuts.tab_new": "Yeni sekme",
  "shortcuts.tab_close": "Sekmeyi kapat",
  "shortcuts.tab_next": "Sonraki sekme",
  "shortcuts.tab_prev": "Önceki sekme",
  /* tus:t1 — menü fiilleri */
  "shortcuts.new_folder": "Yeni klasör",
  "shortcuts.upload": "Dosya yükle",
  "shortcuts.refresh": "Listeyi yenile",
  "shortcuts.download": "İndir",
  "shortcuts.preview": "Önizle",
  "shortcuts.share": "Paylaş",
  "shortcuts.tags": "Etiketler",
  "shortcuts.open_tab": "Yeni sekmede aç",
  "shortcuts.copy_path": "Yolu kopyala",
  "shortcuts.copy_id": "Kimliği kopyala",
  "shortcuts.restore": "Çöp kutusundan geri al",
  "shortcuts.settings.reserved": "tarayıcı tarafından sayfaya ulaşmadan yakalanıyor, burada hiçbir şey yapmaz. Başka bir tuş seçin.",
  "shortcuts.settings.reserved_badge": "Yalnız masaüstü uygulamasında",
  "shortcuts.settings.reserved_title": "Bu kombinasyonu tarayıcının kendisi işliyor. Masaüstü uygulamasında ve kurulu PWA’da çalışır, tarayıcı sekmesinde çalışmaz.",
  "cmd.tab_new": "Yeni sekme aç",
  "cmd.split_toggle": "Görünümü böl / birleştir",
  "split.pane": "İkincil panel",
  "split.close": "Yan paneli kapat",
  "split.error": "Liste yüklenemedi",
  "split.retry": "Yeniden dene",
  "split.copy_queued": "Kopyalama kuyruğa alındı",
  "split.move_queued": "Taşıma kuyruğa alındı",
  "toast.move_kept_both": "Taşıma kuyruğa alındı. Hedefte aynı adla bir öğe vardı, taşınan öğe onun yanına “-copy” ekiyle konacak. Bu taşıma geri alınamaz.",
  "split.cross_copy": "Depolar farklı — kopyalama kuyruğa alındı",
  "dragout.downloading": "Bırakılan klasöre indiriliyor…",
  "dragout.downloading_n": "Bırakılan klasöre indiriliyor — şimdiye dek {n} dosya…",
  "dragout.downloading_n_one": "Bırakılan klasöre indiriliyor — şimdiye dek {n} dosya…",
  "dragout.stop": "Durdur",
  "dragout.stopping": "Durduruluyor…",
  "dragout.stopped": "Durduruldu — gelenler klasörde kalıyor",
  "dragout.not_found": "Bırakılan yer bulunamadı — dosya bir klasöre değil bir uygulamaya bırakıldıysa indirme yapılamaz",
  "dragout.done": "İndirme tamamlandı",
  "dragout.ready": "Dosyalar hazır — masaüstüne sürükleyebilirsiniz",
  "dragout.preparing": "Sürükleme için hazırlanıyor…",
  "split.cross_move": "Depolar farklı — taşıma kuyruğa alındı (baytlar aktarılıp kaynak silinir)",
  /* === /wiring:d1 === */
  /* wiring:d2 — galeri görünümü */
  "toolbar.view.gallery": "Galeri",
  "gallery.aria": "Dosya galerisi",
  /* /wiring:d2 */
  /* wiring:d3 — Yorumlar (inspector node comments) */
  "inspector.section.comments": "Yorumlar",
  "inspector.comments.empty": "Henüz yorum yok.",
  "inspector.comments.placeholder": "Yorum yaz…",
  "inspector.comments.send": "Gönder",
  "inspector.comments.delete": "Yorumu sil",
  /* wiring:e2 — uçtan uca şifreli klasörler */
  "e2e.create.title": "Şifreli klasör oluştur",
  "e2e.create.option": "Şifreli klasör oluştur…",
  "e2e.create.pw_label": "Klasör parolası",
  "e2e.create.pw_placeholder": "En az 8 karakter",
  "e2e.create.pw2_label": "Parolayı tekrar girin",
  "e2e.create.warn_title": "GERİ DÖNÜŞÜ YOK",
  "e2e.create.warn_body": "Bu klasördeki dosyalar yalnız bu parolayla ya da klasör oluşturulurken bir kez gösterilen kurtarma anahtarıyla açılır. Parola sunucuda TUTULMAZ; kurtarma anahtarının da filex'te kopyası kalmaz. İkisini de kaybederseniz içerik sonsuza dek gider.",
  "e2e.create.ack": "Anladım: parolayı da kurtarma anahtarını da kaybedersem verilerim kurtarılamaz.",
  "e2e.create.ack_required": "Devam etmek için uyarıyı onaylayın.",
  "e2e.create.pw_short": "Parola en az 8 karakter olmalı.",
  "e2e.create.pw_mismatch": "Parolalar birbirini tutmuyor.",
  "e2e.create.bad_name": "Geçersiz klasör adı.",
  "e2e.create.create": "Şifreli klasörü oluştur",
  "e2e.create.busy": "Oluşturuluyor…",
  "e2e.create.done": "Şifreli klasör oluşturuldu",
  "e2e.create.failed": "Şifreli klasör oluşturulamadı",
  "e2e.create.nested": "Şifreli klasörün içine ikinci bir şifreli klasör açılamaz.",
  "e2e.locked.title": "Bu klasör uçtan uca şifreli",
  "e2e.locked.hint": "İçeriği görmek için klasör parolasını girin. Parola yalnız bu sekmede, bellekte tutulur.",
  "e2e.locked.pw_placeholder": "Klasör parolası",
  "e2e.locked.unlock": "Kilidi aç",
  "e2e.locked.busy": "Doğrulanıyor…",
  "e2e.unlock.wrong": "Parola yanlış.",
  "e2e.unlock.damaged": "Parola doğru ama anahtar dosyasındaki (.filex-e2e.json) klasör anahtarı açılmıyor: dosya bozulmuş. Kurtarma anahtarını deneyin.",
  "e2e.unlock.marker_missing": "Anahtar dosyası (.filex-e2e.json) okunamadı.",
  /* ikon:emoji — listedeki işaretin erişilebilir adı. Satır eskiden yalnız
     bir 🔒 basıyordu; onun yerini alan asma kilit kutunun içinde
     aria-hidden, dolayısıyla adı taşıyan yer bu. */
  "e2e.badge": "Şifreli klasör",
  "e2e.strip.label": "Şifreli klasör — kilit açık",
  "e2e.strip.lock": "Kilitle",
  /* wiring:e2 password — klasör parolasını değiştirme */
  "e2e.password.strip_action": "Parolayı değiştir…",
  "e2e.password.title": "Klasör parolasını değiştir",
  "e2e.password.reset_title": "Bu klasör için yeni bir parola belirleyin",
  "e2e.password.reset_lead": "Bu klasörü kurtarma anahtarıyla açtınız; parolası kaybolmuş ya da başkası tarafından biliniyor olabilir. Şimdi yeni bir parola belirleyin. Bu pencereyi kapatmak klasörü yeniden kilitler.",
  "e2e.password.current": "Mevcut parola",
  "e2e.password.recovery": "Kurtarma anahtarı",
  "e2e.password.use_recovery": "Hatırlamıyorum — kurtarma anahtarını kullan",
  "e2e.password.use_current": "Bunun yerine mevcut parolayı kullan",
  "e2e.password.new": "Yeni parola",
  "e2e.password.current_required": "Mevcut parolayı girin ya da kurtarma anahtarını kullanın.",
  "e2e.password.bad_recovery": "Bu bir kurtarma anahtarı değil (dörderli gruplar hâlinde 32 karakter).",
  "e2e.password.same": "Yeni parola mevcut parolayla aynı.",
  "e2e.password.cheap_note": "Yalnız klasörün anahtar dosyası değişir. Hiçbir dosya yeniden şifrelenmez; kurtarma anahtarı ve varsa emanet anahtarı çalışmaya devam eder.",
  "e2e.password.old_copies": "Eski parolayı bilen ve anahtar dosyasının eski bir kopyasına (bir sürüm, bir yedek) sahip olan biri klasörü onunla hâlâ açabilir. Bu bir risk ise “Klasör anahtarını da değiştir”i işaretleyin.",
  "e2e.password.rotate_label": "Klasör anahtarını da değiştir (her dosyanın anahtarı yeniden sarılır; eski parola başkasınca biliniyor olabilirse kullanın)",
  "e2e.password.rekey_title": "Bu klasör v0.31 öncesinden: anahtarı parolasından türetiliyor",
  "e2e.password.rekey_body": "Bu yüzden yeni bir parola yeni bir klasör anahtarı gerektirir ve klasördeki her dosyanın anahtarı onunla yeniden sarılır. İçerik yeniden şifrelenmez. Biraz sürebilir; yarıda kalırsa kaldığı yerden devam eder, dosyalar bu sırada da açılır.",
  "e2e.password.rotate_title": "Klasör anahtarı da değişir",
  "e2e.password.rotate_body": "Her dosyanın anahtarı yeni bir klasör anahtarıyla yeniden sarılır. İçerik yeniden şifrelenmez. Yarıda kalırsa kaldığı yerden devam eder; dosyalar bu sırada da açılır.",
  "e2e.password.rekey_rk_new": "Yeni bir kurtarma anahtarı alırsınız, bir kez gösterilir; eskisi artık çalışmaz.",
  "e2e.password.rekey_rk_kept": "Kullandığınız kurtarma anahtarı çalışmaya devam eder.",
  "e2e.password.rekey_escrow": "İşletmecinin emanet anahtarı çalışmaya devam eder: yuvası yeni klasör anahtarına mühürlenir.",
  "e2e.password.rekey_ack": "Anlıyorum: bu, klasördeki her dosyanın anahtarını yeniden sarar.",
  "e2e.password.submit": "Parolayı değiştir",
  "e2e.password.busy": "Değiştiriliyor…",
  "e2e.password.lock_instead": "Bunun yerine klasörü kilitle",
  "e2e.password.wrong_current": "Parola yanlış.",
  "e2e.password.wrong_recovery": "Kurtarma anahtarı yanlış.",
  "e2e.password.escrow_blocked": "Bu klasörün, bu kurulumda bulunmayan bir anahtar için emanet yuvası var; klasör anahtarını değiştirmek onu kaybettirir. Hiçbir şey değiştirilmedi.",
  "e2e.password.failed": "Parola değiştirilemedi. Hiçbir şey değiştirilmedi.",
  "e2e.password.done": "Parola değişti. Eski parola bu klasörü artık açmıyor.",
  "e2e.password.announce_failed": "Parola değişti ama sunucu bunu kaydedemedi; klasörün sahibine haber verilmedi.",
  "e2e.password.resume_title": "Dosya anahtarları hâlâ yeniden sarılıyor",
  "e2e.password.resume_body": "Parola değişti ve yeni bir klasör anahtarı verildi. Bazı dosyaların anahtarı hâlâ öncekinin altında; her iki durumda da açılırlar. Bitirmek için devam edin.",
  "e2e.password.progress": "Şu ana kadar {n} dosya yeniden sarıldı · {failed} başarısız",
  "e2e.password.progress_one": "Şu ana kadar {n} dosya yeniden sarıldı · {failed} başarısız",
  "e2e.password.rekey_partial": "{n} dosya yeniden sarılamadı. Önceki anahtarla hâlâ açılıyorlar; yeniden denemek için devam edin.",
  "e2e.password.rekey_partial_one": "{n} dosya yeniden sarılamadı. Önceki anahtarla hâlâ açılıyor; yeniden denemek için devam edin.",
  "e2e.password.rekey_done": "Yeni klasör anahtarı yerinde ({n} dosya yeniden sarıldı). Eski parola burada artık hiçbir şey açmıyor.",
  "e2e.password.rekey_done_one": "Yeni klasör anahtarı yerinde ({n} dosya yeniden sarıldı). Eski parola burada artık hiçbir şey açmıyor.",
  "e2e.recovery.lead_replaced": "Klasörün yeni bir anahtarı var, bu yüzden yeni bir kurtarma anahtarı da var — eskisi artık açmıyor. Bir kez gösterilir; filex kopyasını tutmaz.",
  /* wiring:e2 names — şifreli dosya ve klasör adları */
  "e2e.unlock.unsupported": "Bu klasör daha yeni bir filex istiyor: bu sürümün tanımadığı bir özellik kullanıyor ({features}). Hiçbir şey değiştirilmedi.",
  "e2e.settings.open": "Şifreleme ayarları…",
  "e2e.settings.title": "Şifreleme ayarları",
  "e2e.settings.level": "Şifreleme seviyesi",
  "e2e.settings.password": "Parola",
  "e2e.settings.escrow": "Emanet anahtarı",
  "e2e.settings.close": "Kapat",
  "e2e.level.content": "Yalnız içerik",
  "e2e.level.names": "İçerik ve adlar",
  "e2e.level.content_hint": "Dosya içerikleri şifrelenir. Dosya ve klasör adları sunucuya açık kalır; böylece WebDAV, komut satırı ve masaüstü senkronu adlarla çalışmayı sürdürür ve 0.31'den beri her filex klasörü açar.",
  "e2e.level.names_hint": "İçerik de dosya ve klasör adları da şifrelenir: sunucu yalnız karıştırılmış adlar görür. WebDAV, komut satırı ve masaüstü senkronu da adları karıştırılmış görür; filex 0.47 ve öncesi klasörü açmaz.",
  "e2e.level.pending": "seviye değişikliği bitmedi",
  "e2e.level.change": "Seviyeyi değiştir…",
  "e2e.level.raise_title": "Bu klasör “İçerik ve adlar” seviyesine geçsin mi?",
  "e2e.level.raise_body": "filex buradaki her dosya ve klasöre bu tarayıcıda şifreli bir ad verir. İçeriğe dokunulmaz; yarıda kalırsa kaldığı yerden devam eder. filex açık adlara geri dönüş yolu sunmaz.",
  "e2e.level.raise_ack": "Neyin değiştiğini anladım",
  "e2e.level.raise_go": "Adları şifrele",
  "e2e.names.move_unreadable": "Taşınmadı: öğelerden birinin adı okunamıyor.",
  "e2e.names.move_taken": "Taşınmadı: o klasörde “{name}” adı zaten var. Önce ikisinden birinin adını değiştirin.",
  "e2e.convert.ctx": "E2EE ile şifrele…",
  "e2e.convert.title": "“{name}” klasörünü şifrele",
  "e2e.convert.lead": "Bu klasördeki her dosya bulunduğu yerde, bu tarayıcıda, aşağıdaki parolayla şifrelenir. Hiçbir şey yer değiştirmez; 1. seviyede adlar olduğu gibi kalır. Yarıda kalırsa klasörü yeniden açınca devam eder.",
  "e2e.convert.past_title": "Sunucuda zaten olanlar",
  "e2e.convert.past_body": "Şifreleme bu dosyaları bundan sonrası için korur. Şimdiye kadar sunucu onları açık hâlde tuttu ve bazı kopyalar kalır: filex küçük resimlerini ve arama için çıkardığı metni siler; bu klasörün eski sürümlerini ve çöp kutusundaki kayıtlarını da silebilir.",
  "e2e.convert.drop_versions": "Bu dosyaların eski sürümlerini sil (şifresizdirler)",
  "e2e.convert.drop_trash": "Bu klasörden çöp kutusuna gidenleri sil",
  "e2e.convert.past_outside": "Yedekler, kopya sunucular ve birinin önceden aldığı kopyalar filex'in dışındadır ve olduğu gibi kalır.",
  "e2e.convert.submit": "Klasörü şifrele",
  "e2e.convert.nested": "Bu klasörün içinde şifreli bir klasör var. Şifreli klasörler iç içe olamaz; hiçbir şey değiştirilmedi.",
  "e2e.convert.failed": "Klasör şifrelenemedi. Şifrelenmiş dosyalar öyle kalır; devam etmek için klasörü açın.",
  "e2e.convert.stopped": "{n} dosyadan sonra durduruldu. Klasörün üstündeki şeritten devam edebilirsiniz.",
  "e2e.convert.stopped_one": "{n} dosyadan sonra durduruldu. Klasörün üstündeki şeritten devam edebilirsiniz.",
  "e2e.convert.partial": "{n} dosya şifrelenemedi (bu arada değişti, çok büyük ya da yazılamıyor). Hâlâ şifresizler; devam etmek için yeniden deneyin.",
  "e2e.convert.partial_one": "{n} dosya şifrelenemedi (bu arada değişti, çok büyük ya da yazılamıyor). Hâlâ şifresiz; devam etmek için yeniden deneyin.",
  "e2e.convert.busy": "Klasör şifreleniyor…",
  "e2e.convert.resume_title": "Bu klasörü şifrelemeyi bitirin",
  "e2e.convert.resume_body": "Bu klasörü şifreleme işi başladı ama bitmedi. Henüz ulaşılmayan dosyalar sunucuda hâlâ şifresiz. Devam ederseniz kaldığı yerden sürer.",
  "e2e.convert.progress": "{total} dosyanın {n} tanesi şifrelendi · {failed} dosya kaldı",
  "e2e.convert.progress_one": "{total} dosyanın {n} tanesi şifrelendi · {failed} dosya kaldı",
  "e2e.convert.done": "Klasör şifrelendi ({n} dosya). Silinen eski sürüm: {versions}; silinen çöp kaydı: {trash}.",
  "e2e.convert.done_one": "Klasör şifrelendi ({n} dosya). Silinen eski sürüm: {versions}; silinen çöp kaydı: {trash}.",
  "e2e.convert.cleanup_failed": "Klasör şifrelendi ama eski sürümleri ve çöp kayıtları silinemedi — bunu yalnız klasörün sahibi ya da bir yönetici yapabilir.",
  "e2e.names.locked_item": "🔒 Şifreli öğe",
  "e2e.names.unreadable_item": "🔒 Adı okunamıyor",
  "e2e.names.key_failed": "Anahtar dosyası bu klasördeki adların şifreli olduğunu söylüyor ama ad anahtarı bu anahtarla açılmıyor. Hiçbir şey değiştirilmedi.",
  "e2e.names.write_failed": "Uzun bir adın ad dosyası yazılamadı, bu yüzden hiçbir şey yüklenmedi.",
  "e2e.names.bad_name": "“{name}” şifreli klasörde kullanılamaz: ad 1–255 bayt olmalı; bölü, ters bölü ya da kontrol karakteri içeremez.",
  "e2e.names.offer_cost": "Ne değişir: WebDAV, komut satırı ve masaüstü senkronu adları karıştırılmış görür; filex 0.47 ve öncesi bu klasörü açmayı reddeder. Sunucu kaç öğe olduğunu ve boyutlarını hâlâ görür.",
  "e2e.names.resume_title": "Adları şifrelemeyi bitirin",
  "e2e.names.resume_body": "Bu klasördeki adları şifreleme işi başladı ama bitmedi. Henüz ulaşılmayan öğelerin adları hâlâ açık. Devam ederseniz kaldığı yerden sürer.",
  "e2e.names.resume": "Devam et",
  "e2e.names.stop": "Durdur",
  "e2e.names.busy": "Adlar şifreleniyor…",
  "e2e.names.progress": "Şu ana kadar {n} ad şifrelendi · {failed} öğe yeniden adlandırılamadı",
  "e2e.names.progress_one": "Şu ana kadar {n} ad şifrelendi · {failed} öğe yeniden adlandırılamadı",
  "e2e.names.done": "Adlar şifrelendi ({n} öğe yeniden adlandırıldı). Sunucu artık adları göremiyor.",
  "e2e.names.done_one": "Adlar şifrelendi ({n} öğe yeniden adlandırıldı). Sunucu artık adları göremiyor.",
  "e2e.names.stopped": "{n} addan sonra durduruldu. Kalanlar siz devam edene kadar açık adlarını korur.",
  "e2e.names.stopped_one": "{n} addan sonra durduruldu. Kalanlar siz devam edene kadar açık adlarını korur.",
  "e2e.names.partial": "{n} öğe yeniden adlandırılamadı (izin yok ya da ad bir diskte tutulamıyor). Adları açık kalıyor; devam etmek için yeniden deneyin.",
  "e2e.names.partial_one": "{n} öğe yeniden adlandırılamadı (izin yok ya da ad bir diskte tutulamıyor). Adı açık kalıyor; devam etmek için yeniden deneyin.",
  "e2e.names.failed": "Adlar şifrelenemedi. Zaten yeniden adlandırılanlar kaybolmaz; devam etmek için yeniden deneyin.",
  "e2e.names.strip_fix": "{n} adı düzelt (açık kalmış ya da filex dışından taşınmış)",
  "e2e.names.strip_fix_one": "{n} adı düzelt (açık kalmış ya da filex dışından taşınmış)",
  "e2e.create.names_root_hint": "Klasörün kendi adı her durumda açık kalır — şifresiz bir klasörün içinde durur. Hiçbir şey ele vermeyen bir ad seçin.",
  "e2e.locked_toast": "Klasör kilitlendi",
  "e2e.upload.too_big": "200 MB üstü dosyalar şifreli klasöre yüklenemez (MVP sınırı)",
  "e2e.upload.locked": "Önce klasörün kilidini açın",
  "e2e.decrypting": "Çözülüyor…",
  "e2e.decrypt_failed": "Dosya çözülemedi (parola değişmiş ya da dosya bozulmuş olabilir).",
  /* wiring:e2 recovery — kurtarma anahtarı + yönetici escrow'u */
  "e2e.create.escrow_title": "Bu sunucunun da bir anahtarı var",
  "e2e.create.escrow_body": "Bu kurulumda anahtar emaneti (escrow) açık: sunucunun işletmecisi bu klasörü parolanız olmadan açabilir. O anahtar kullanıldığında size bildirim gelir. Escrow sunucu kurulurken sabitlenir; bir klasör için kapatılamaz.",
  "e2e.locked.use_recovery": "Parolayı mı kaybettiniz? Kurtarma anahtarı kullanın",
  "e2e.recovery.title": "Kurtarma anahtarınızı saklayın",
  "e2e.recovery.title_upgraded": "Kurtarma anahtarınız",
  "e2e.recovery.lead": "Bu anahtar klasörü parolasız açar. Yalnız bir kez gösterilir — filex bu anahtarı saklamaz ve bir daha gösteremez.",
  "e2e.recovery.lead_upgraded": "Bu klasörün artık bir kurtarma anahtarı var. Klasörü parolasız açar, yalnız bir kez gösterilir ve filex'te kopyası kalmaz.",
  "e2e.recovery.copy": "Kopyala",
  "e2e.recovery.copied": "Kopyalandı",
  "e2e.recovery.download": "Dosya olarak indir",
  "e2e.recovery.warn_title": "BUNU PAROLA GİBİ SAKLAYIN",
  "e2e.recovery.warn_body": "Bu anahtarı eline geçiren herkes klasörü okuyabilir. Parolanızdan ayrı bir yerde tutun — parolanın yanında duran bir anahtar sizi unutmaya karşı korur, başkasına karşı değil.",
  "e2e.recovery.escrow_title": "Bu sunucunun da bir anahtarı var",
  "e2e.recovery.escrow_body": "Bu kurulumda anahtar emaneti açık: sunucunun işletmecisi bu klasörü parolanız olmadan açabilir. O anahtar kullanıldığında size bildirim gelir.",
  "e2e.recovery.escrow_kid": "Emanet anahtarı",
  "e2e.recovery.ack": "Bu anahtarı güvenli bir yere kaydettim.",
  "e2e.recovery.done": "Tamam",
  "e2e.recover.title": "Parolasız kilit açma",
  "e2e.recover.none": "Bu klasör kurtarma anahtarları eklenmeden önce oluşturulmuş, bu yüzden anahtarı yok. Tek giriş yolu parolası. Bir kez parolayla açın, filex kurtarma anahtarı eklemeyi önerecek.",
  "e2e.recover.tab_recovery": "Kurtarma anahtarı",
  "e2e.recover.tab_escrow": "Emanet anahtarı",
  "e2e.recover.recovery_hint": "Klasör oluşturulurken bir kez gösterilen anahtar.",
  "e2e.recover.recovery_placeholder": "XXXX-XXXX-XXXX-XXXX-XXXX-XXXX-XXXX-XXXX",
  "e2e.recover.escrow_warn_title": "Klasörün sahibine haber gidecek",
  "e2e.recover.escrow_warn_body": "Emanet anahtarıyla açılan klasörün sahibine bildirim gönderilir. Yalnız yetkiniz olduğunda kullanın.",
  "e2e.recover.escrow_kid": "Emanet anahtarı",
  "e2e.recover.escrow_predates": "Bu kurulumun emanet anahtarı var ama bu klasörün yok. Klasör, emanet burada açılmadan önce oluşturulmuş; ana anahtarı emanet kimliğine hiç sarmalanmadı. Emanet anahtarı bu klasörü açmaz. İşletmecinin yapabileceği hiçbir şey bunu değiştirmez — sarmalama için klasörün parolası gerekir ve sunucu onu hiçbir zaman görmedi. Klasörün sahibi verebilir: parolayla kilidi açıp işletmeciye anahtar vermeyi seçebilir. O yapılana kadar parolayı ya da kurtarma anahtarını kullanın.",
  "e2e.recover.escrow_other_key": "Bu klasör BAŞKA bir kurulumun emanet anahtarını taşıyor. Başka yerde oluşturulup buraya geri yüklenmiş, bu yüzden bu kurulumun emanet anahtarı onu açmaz. Yalnızca sarmalandığı emanet anahtarının özel yarısı açabilir.",
  "e2e.recover.escrow_placeholder": "Emanet özel anahtarını yapıştırın (PKCS#8, base64 ya da PEM)",
  "e2e.recover.bad_format": "Bu bir kurtarma anahtarına benzemiyor. Dörtlü sekiz grup, toplam 32 karakter olmalı.",
  "e2e.recover.escrow_required": "Emanet özel anahtarını yapıştırın.",
  "e2e.recover.wrong_recovery": "Bu kurtarma anahtarı bu klasörü açmıyor.",
  "e2e.recover.wrong_escrow": "Bu emanet anahtarı bu klasörü açmıyor. Emanet açılmadan önce oluşturulmuş bir klasörün, sahibi izin verene kadar emanet anahtarı yoktur — o zamana kadar parolayı ya da kurtarma anahtarını kullanın.",
  "e2e.recover.bad_escrow_key": "Bu okunabilir bir özel anahtar değil (PKCS#8, base64 ya da PEM bekleniyor).",
  "e2e.recover.notify_failed": "Klasör sahibine bildirim gönderilemedi, bu yüzden kilit açılmadı. Emanet anahtarının kullanımı her zaman duyurulur.",
  "e2e.recover.recovery_done": "Kurtarma anahtarıyla açıldı",
  "e2e.recover.escrow_done": "Emanet anahtarıyla açıldı — klasör sahibine bildirildi",
  "e2e.recover.unlock": "Kilidi aç",
  "e2e.recover.busy": "Açılıyor…",
  "e2e.escrowoffer.title": "İşletmeciye bu klasörün anahtarı verilsin mi?",
  "e2e.escrowoffer.body": "Bu klasör, burada anahtar emaneti açılmadan önce oluşturulmuş; bu yüzden kurulumun işletmecisi onu açamıyor. Şu anda — parolanız bellekteyken — filex bu klasörü emanet anahtarına sarmalayabilir. Dosyalarınız yeniden şifrelenmez, hiçbir yere taşınmaz; yalnızca anahtar dosyası değişir.",
  "e2e.escrowoffer.consequence": "Bunun anlamı: işletmeci, parolanız olmadan bu klasöre giren ikinci ve kalıcı bir yol kazanır. O anahtar kullanıldığında size bildirim gelir, ama bu bildirim bir denetim değil yalnızca bir duyurudur.",
  "e2e.escrowoffer.learn_more": "Emanet anahtarı neyi yapar, neyi yapamaz",
  "e2e.escrowoffer.password_label": "Klasör parolası",
  "e2e.escrowoffer.password_required": "Klasör parolasını girin.",
  "e2e.escrowoffer.wrong_password": "Bu, bu klasörün parolası değil.",
  "e2e.escrowoffer.accept": "İşletmeciye anahtar ver",
  "e2e.escrowoffer.decline": "Hayır, bende kalsın",
  "e2e.escrowoffer.cancel": "Vazgeç",
  "e2e.escrowoffer.busy": "Sarmalanıyor…",
  "e2e.escrowoffer.done": "İşletmeci artık bu klasörü emanet anahtarıyla açabilir",
  "e2e.escrowoffer.declined_toast": "Sizde kaldı. filex bu klasör için bir daha sormayacak.",
  "e2e.escrowoffer.decline_failed": "Cevabınız kaydedilemedi, bu yüzden filex bir dahakine yine soracak. Klasörde hiçbir şey değişmedi.",
  "e2e.escrowoffer.failed": "İşletmeciye bu klasörün anahtarı verilemedi",
  "e2e.escrowoffer.strip_action": "Emanet anahtarı…",
  "e2e.upgrade.title": "Bu klasörün kurtarma anahtarı yok",
  "e2e.upgrade.body": "Kurtarma anahtarları eklenmeden önce oluşturulmuş, bu yüzden tek giriş yolu parolası. Şu anda — ve yalnız şu anda, parola bellekteyken — filex bir tane ekleyebilir. Dosyalarınız yeniden şifrelenmez, hiçbir yere taşınmaz.",
  "e2e.upgrade.escrow_note": "Not: bu kurulumda anahtar emaneti açık; kurtarma anahtarı eklemek aynı zamanda işletmecinin bu klasörü parolanız olmadan açabilmesi demektir.",
  "e2e.upgrade.accept": "Kurtarma anahtarı oluştur",
  "e2e.upgrade.decline": "Şimdi değil",
  "e2e.upgrade.busy": "Oluşturuluyor…",
  "e2e.upgrade.failed": "Bu klasöre kurtarma anahtarı eklenemedi",
  "e2e.download.failed": "Şifreli dosya indirilemedi.",
  /* /wiring:e2 */
  /* ── connections: storage config + "how to connect" ──────────────
     `storages.*` keys are the ones the BACKEND's driver descriptors
     name (each driver package declares one next to its Init). They are
     kept identical to web/src/locales/*.json on purpose: the same
     descriptor is rendered on both surfaces, so a field that reads
     "Base path" in the admin panel and something else in the desktop
     app would be the same drift this whole mechanism exists to stop. */
  "conn.title": "Depo bağlantıları",
  "conn.subtitle": "{host} sunucusuna kendi bilgisayarınızdan nasıl erişilir: bağlayın ya da bir istemciyi buraya yönlendirin.",
  "conn.close": "Kapat",
  "conn.list.disabled": "Kapalı",
  "conn.form.required": "Zorunlu",
  "conn.form.advanced": "Gelişmiş ayarlar",
  "conn.form.yes": "Evet",
  "conn.form.no": "Hayır",
  "conn.form.noFields": "Bu sunucu bu sürücü için hiçbir ayar tanımlamadı.",
  "conn.form.reveal": "Göster",
  "conn.form.hide": "Gizle",
  "conn.guide.protocol": "Protokol",
  "conn.guide.storage": "Depo",
  "conn.guide.allStorages": "Tüm depolar",
  "conn.guide.copy": "Kopyala",
  "conn.guide.copied": "Kopyalandı",
  "conn.guide.goodToKnow": "Bilmekte fayda var",
  "conn.guide.userPlaceholder": "eposta@ornek.com",
  "conn.guide.secretPlaceholder": "parolanız-ya-da-api-anahtarınız",
  "conn.guide.fact.url": "Adres",
  "conn.guide.fact.urlRootHint": "Görebildiğiniz her depo bu adresin altında bir klasör olarak görünür.",
  "conn.guide.fact.urlStorageHint": "Doğrudan “{storage}” deposunu bağlar. Son parçayı silerseniz tüm depoları görürsünüz.",
  "conn.guide.fact.user": "Kullanıcı adı",
  "conn.guide.fact.password": "Parola",
  "conn.guide.webdav.summary": "WebDAV, filex’i bir sürücü gibi bağlar: Windows Gezgini, macOS Finder, Linux, rclone ve Cyberduck bu protokolü konuşur ve yapılan her değişiklik filex’e yansır.",
  "conn.guide.webdav.userHint": "Kullanıcı adınız ya da e-postanız — görünen adınız değil.",
  "conn.guide.webdav.passwordHint": "Hesap parolanız ya da bir API anahtarı (gezinti panelindeki API anahtarları bölümü). İki adımlı doğrulaması açık bir hesap ZORUNLU olarak API anahtarı kullanır: Basic kimlik doğrulamasında ikinci adım için yer yoktur.",
  "conn.guide.webdav.win.s1": "Dosya Gezgini’ni açın, Bu bilgisayar’a sağ tıklayın ve “Ağ sürücüsü bağla…” deyin.",
  "conn.guide.webdav.win.s2": "Bir sürücü harfi seçin ve klasör olarak {url} adresini girin.",
  "conn.guide.webdav.win.s3": "“Farklı kimlik bilgileri kullanarak bağlan” kutusunu işaretleyin ve yukarıdaki kullanıcı adı/parola ile girin.",
  "conn.guide.webdav.win.cmdCaption": "Komut İstemi (sihirbaz olmadan aynı iş)",
  "conn.guide.webdav.win.limits": "Windows’un tam olarak filex hatası gibi görünen üç yerleşik sınırı vardır: aktarımlar ~47,7 MB’ta durur, yaklaşık bin dosyalı klasörler açılmaz (“Disk biçimlendirilmemiş”) ve her iki ayarı değiştirdikten sonra WebClient hizmeti yeniden başlatılmalıdır.",
  "conn.guide.webdav.win.regCaption": "Yönetici olarak çalıştırın, sonra sürücüyü yeniden bağlayın",
  "conn.guide.webdav.win.https": "HTTPS zorunludur. Windows Basic kimlik bilgilerini yalnızca TLS üzerinden gönderir; düz http:// üzerinde hiçbir açıklama vermeden reddeder. BasicAuthLevel değerini 2 yapmayın — TLS kullanın.",
  "conn.guide.webdav.win.persist": "Bağlanan sürücü oturum kapatmayı atlatamaz: Windows 7’den beri Basic kimlik bilgileri Kimlik Bilgisi Yöneticisi’nde saklanamaz ve /persistent:yes bunu değiştirmez. Kendiliğinden geri gelsin istiyorsanız komutu bir oturum açma betiğinden yeniden çalıştırın.",
  "conn.guide.webdav.win.service": "Hiç bağlanamıyorsa WebClient hizmetinin çalıştığından emin olun: sc config WebClient start= auto && net start WebClient.",
  "conn.guide.webdav.mac.s1": "Finder’da Git → Sunucuya Bağlan… (⌘K) yolunu izleyin.",
  "conn.guide.webdav.mac.s2": "{url} adresini girip bağlanın.",
  "conn.guide.webdav.mac.s3": "Yukarıdaki kullanıcı adı ve parolayla kimliğinizi doğrulayın.",
  "conn.guide.webdav.mac.note": "Sürücü Konumlar altında görünür; her depo en üst düzeyde bir klasördür.",
  "conn.guide.webdav.linux.mountCaption": "davfs2 ya da masaüstü dosya yöneticisi (GNOME Dosyalar, Dolphin)",
  "conn.guide.webdav.linux.gvfsComment": "ya da bu adresi GNOME Dosyalar / Dolphin icine yapistirin",
  "conn.guide.webdav.linux.locks": "davfs2 için kilitler kapatılmalıdır. filex WebDAV kilitlerini süreç belleğinde tutar; yeniden başlatmayı atlatamazlar ve kopyalar arasında paylaşılmazlar — davfs2 tersini varsayar ve takılır.",
  "conn.guide.webdav.rclone.obscureCaption": "rclone parolayı gizlenmiş biçimde saklar — önce bunu çalıştırıp çıktısını aşağıya yapıştırın",
  "conn.guide.webdav.rclone.passPlaceholder": "<rclone obscure çıktısı>",
  "conn.guide.webdav.rclone.useCaption": "Kullanımı",
  "conn.guide.webdav.duck.s1": "Yeni Yer İmi → WebDAV (HTTPS).",
  "conn.guide.webdav.duck.s2": "Sunucu {host}, port 443.",
  "conn.guide.webdav.duck.s3": "Yol {path}.",
  "conn.guide.webdav.duck.s4": "Kullanıcı adı {user}, parola yukarıdaki gibi.",
  "conn.guide.webdav.note.delete": "WebDAV üzerinden silme kalıcıdır. Web arayüzü dosyaları filex çöp kutusuna taşır; istemciden silme ise nesneyi doğrudan arka uçtan kaldırır.",
  "conn.guide.webdav.note.locks": "Kilitler sunucu belleğinde durur: yeniden başlatmayı atlatamazlar ve kopyalar arasında paylaşılmazlar. Windows ile Office’i memnun etmek için varlar, eşzamanlı düzenlemeyi hakemlemek için değil.",
  "conn.guide.webdav.note.permissions": "Web arayüzünde ne görüyorsanız burada da onu görürsünüz. Kök yalnızca açabildiğiniz depoları listeler; yetkiniz dışındaki bir yol 403 değil 404 döner, böylece ağaç neyin var olduğunu sızdırmaz.",
  "conn.guide.webdav.note.http": "Bu sunucuya düz http:// ile erişiliyor. Windows kimlik bilgilerinizi hiç göndermez, diğer tüm istemciler ise parolanızı açık metin olarak yollar. Bağlamadan önce filex’i TLS arkasına alın.",
  // ── S3 ucu: anahtarlar ve rehber ─────────────────────────────────
  "conn.s3keys.title": "S3 erişim anahtarları",
  "conn.s3keys.lead": "Bir erişim anahtarı, S3 konuşan her istemcinin — rclone, restic, AWS CLI, mc, s3fs, Cyberduck — filex’e bağlanmasını sağlar. Anahtar sizin yetkinizi taşır, bir fazlasını değil.",
  "conn.s3keys.disabled": "Bu sunucuda S3 ucu kapalı (FILEX_S3). Burada üretilen anahtar, yönetici ucu tekrar açana kadar bağlanmaz.",
  "conn.s3keys.cannotMint": "Erişim anahtarı üretebilecek bir hesapla oturum açmış değilsiniz. Aşağıdaki talimatlar yine geçerli — bir anahtar isteyip yapıştırmanız yeter.",
  "conn.s3keys.label": "Ne için? (dizüstü yedeği, CI, …)",
  "conn.s3keys.defaultLabel": "erişim anahtarı",
  "conn.s3keys.everyBucket": "Görebildiğim tüm kovalar",
  "conn.s3keys.prefix": "Kova içindeki klasör (isteğe bağlı)",
  "conn.s3keys.mint": "Anahtar oluştur",
  "conn.s3keys.inheritNote": "Bir anahtar sahip olduğunuz yetkiyi yalnızca DARALTABİLİR: yetkileriniz, kiracınız, rolünüz. Anahtarı tek bir kovaya ya da klasöre kısıtlamak, bir dizüstü yedeği ile her şeyi okuyabilen bir kimlik arasındaki farktır.",
  "conn.s3keys.once": "Gizli anahtarı şimdi kopyalayın — bir daha gösterilmeyecek.",
  "conn.s3keys.accessKeyID": "Erişim anahtarı kimliği",
  "conn.s3keys.secret": "Gizli anahtar",
  "conn.s3keys.dismiss": "Kopyaladım",
  "conn.s3keys.col.label": "Etiket",
  "conn.s3keys.col.key": "Erişim anahtarı kimliği",
  "conn.s3keys.col.scope": "Kapsam",
  "conn.s3keys.col.lastUsed": "Son kullanım",
  "conn.s3keys.scopeAll": "görebildiğiniz her şey",
  "conn.s3keys.noLabel": "(etiketsiz)",
  "conn.s3keys.neverUsed": "hiç",
  "conn.s3keys.enable": "Aç",
  "conn.s3keys.disable": "Kapat",
  "conn.s3keys.revoke": "İptal et",
  "conn.s3keys.confirm": "Emin misiniz?",
  "conn.s3keys.empty": "Henüz erişim anahtarı yok.",
  "conn.guide.s3.summary": "S3 ucu, S3 konuşan her şeyin — yedekleme, eşitleme araçları, SDK’lar — hedefi olarak filex’i kullanmanızı sağlar; hem de zaten sahip olduğunuz depolarla.",
  "conn.guide.s3.keyPlaceholder": "yukarıdan bir anahtar oluşturun",
  "conn.guide.s3.secretPlaceholder": "anahtarı oluştururken bir kez gösterilir",
  "conn.guide.s3.fact.endpoint": "Uç adresi",
  "conn.guide.s3.fact.endpointHint": "İstemciyi buraya yöneltin, filex’in web adresine değil.",
  "conn.guide.s3.fact.bucket": "Kova",
  "conn.guide.s3.fact.bucketHint": "Kova = filex deposu. Kovaları istemci değil yönetici oluşturur.",
  "conn.guide.s3.fact.key": "Erişim anahtarı kimliği",
  "conn.guide.s3.fact.keyHint": "Genel yarısı; her istekte gider.",
  "conn.guide.s3.fact.secret": "Gizli anahtar",
  "conn.guide.s3.fact.secretHint": "Yalnızca anahtar oluşturulurken bir kez gösterilir. filex bir daha gösteremez — kaybolduysa yeni anahtar üretin.",
  "conn.guide.s3.fact.region": "Bölge",
  "conn.guide.s3.fact.regionHint": "filex’te bölge yok; hangi değeri verirseniz aynen geri döner. Yine de istemciler bir değer ister.",
  "conn.guide.s3.fact.addressing": "Adresleme",
  "conn.guide.s3.fact.pathStyle": "yol tabanlı (zorunlu)",
  "conn.guide.s3.fact.pathStyleHint": "Bu kurulumda S3’e ayrılmış bir alan adı yok, yani kova.host çözülmez.",
  "conn.guide.s3.fact.virtualHosted": "sanal-host ya da yol tabanlı",
  "conn.guide.s3.fact.virtualHostedHint": "Bu kurulumun kendi S3 alan adı var, iki adresleme de çalışır.",
  "conn.guide.s3.rclone.useCaption": "Kullanımı",
  "conn.guide.s3.rclone.mtime": "filex dosyanın değişiklik zamanını taşır (x-amz-meta-mtime); böylece rclone sync ilk turdan sonra oturur, her seferinde her şeyi yeniden yüklemez.",
  "conn.guide.s3.aws.configureCaption": "Bir kez ayarlayın",
  "conn.guide.s3.aws.useCaption": "Kullanımı",
  "conn.guide.s3.aws.pathStyle": "AWS yapılandırmanıza yol tabanlı adreslemeyi ekleyin; yoksa her komut DNS aşamasında düşer.",
  "conn.guide.s3.restic.envCaption": "Ortam değişkenleri",
  "conn.guide.s3.restic.useCaption": "Yedekle, doğrula, buda",
  "conn.guide.s3.restic.verified": "Bu uca karşı ölçüldü: restic check --read-data her pack’i bayt bayt okuyor ve hata bulmuyor.",
  "conn.guide.s3.mc.aliasCaption": "Takma adı ekleyin",
  "conn.guide.s3.mc.useCaption": "Kullanımı",
  "conn.guide.s3.s3fs.credsCaption": "Kimlik dosyası",
  "conn.guide.s3.s3fs.mountCaption": "Bağlayın",
  "conn.guide.s3.s3fs.note": "s3fs üzerinden bir dosyayı düzenlemek nesnenin tamamını yeniden yazar; silme ise filex çöp kutusuna gider. Paylaşılan bir klasör için iyi, veritabanı için değil.",
  "conn.guide.s3.duck.s1": "Yeni yer imi → Amazon S3.",
  "conn.guide.s3.duck.s2": "Sunucu: {host}.",
  "conn.guide.s3.duck.s3": "Erişim anahtarı kimliği: {key}, gizli anahtar yukarıdaki.",
  "conn.guide.s3.duck.s4": "Yer imini açın; kovalar sizin filex depolarınızdır.",
  "conn.guide.s3.duck.pathStyle": 'Tercihler → S3 altında "Use virtual host style" seçeneğini KAPATIN — bu kurulumda joker S3 alan adı yok.',
  "conn.guide.s3.sdk.note": "SigV4 konuşan her istemci aynı şekilde çalışır: uç adresi, anahtar, gizli anahtar ve bu kurulumun kendi S3 alan adı yoksa yol tabanlı adresleme.",
  "conn.guide.s3.note.buckets": "Kova = filex deposu. İstemci kovanın İÇİNDE klasör ve nesne oluşturabilir, ama kovanın kendisini oluşturamaz: kova bir sürücü ve bir yol ister, bunu bir S3 isteği ifade edemez.",
  "conn.guide.s3.note.permissions": 'Anahtar tam olarak sizin gördüğünüzü görür. Açamayacağınız bir kova "yasak" değil "böyle bir kova yok" der; böylece uç, neyin var olduğunu sızdırmaz.',
  "conn.guide.s3.note.trash": "Silme her yerdeki gibi filex çöp kutusuna gider ve saklama politikası süpürene kadar geri alınabilir.",
  "conn.guide.s3.note.mtime": "Yüklemeler değişiklik zamanını taşır; istemcinin gönderdiği sağlama toplamları (Content-MD5, x-amz-checksum-*) doğrulanır — bozulmuş bir yükleme saklanmaz, reddedilir.",
  "conn.guide.s3.note.pathStyle": "Bu kurulumda S3’e ayrılmış alan adı yok; istemcilere yol tabanlı adresleme söylenmeli. Söylenmezse güncel bir SDK, ne filex’i ne de sebebi anan bir DNS hatasıyla düşer.",
  "conn.guide.s3.note.http": "Bu uç düz http://. İmzalar isteği yine korur ama nesneler açık metin gider. Bir yedeği buraya yöneltmeden önce filex’i TLS arkasına alın.",
  // ── SFTP ucu: anahtarlar ve rehber ───────────────────────────────
  "conn.sshkeys.title": "SSH anahtarları",
  "conn.sshkeys.lead": "Bir açık anahtar kaydedin; SSH konuşan her istemci — sftp, scp, WinSCP, FileZilla, rclone, sshfs — parolanızı göndermeden bağlansın.",
  "conn.sshkeys.disabled": "Bu sunucuda SFTP ucu kapalı (FILEX_SFTP). Burada kaydedilen anahtar, yönetici ucu açana kadar bağlanmaz.",
  "conn.sshkeys.cannotAdd": "Anahtar kaydedebilecek bir hesapla oturum açmış değilsiniz.",
  "conn.sshkeys.paste": "~/.ssh/id_ed25519.pub dosyasının içeriğini yapıştırın",
  "conn.sshkeys.name": "Ad (isteğe bağlı — boşsa anahtarın kendi yorumu kullanılır)",
  "conn.sshkeys.add": "Anahtar ekle",
  "conn.sshkeys.noCopyId": "ssh-copy-id burada çalışamaz: kabuk üzerinden ~/.ssh/authorized_keys dosyasına ekler, filex’in kabuğu yoktur. Anahtar eklemenin yolu bu kutudur.",
  "conn.sshkeys.col.name": "Ad",
  "conn.sshkeys.col.fingerprint": "Parmak izi",
  "conn.sshkeys.col.added": "Eklendi",
  "conn.sshkeys.col.lastUsed": "Son kullanım",
  "conn.sshkeys.noName": "(adsız)",
  "conn.sshkeys.neverUsed": "hiç",
  "conn.sshkeys.enable": "Aç",
  "conn.sshkeys.disable": "Kapat",
  "conn.sshkeys.remove": "Sil",
  "conn.sshkeys.confirm": "Emin misiniz?",
  "conn.sshkeys.empty": "Henüz anahtar yok. Anahtarsız istemciler hesap parolanızla oturum açar.",
  "conn.guide.sftp.summary": "SFTP, filex’i SSH konuşan her şeyin erişebileceği hâle getirir: bir yedekleme işi, bir tarayıcı, WinSCP, rclone ya da bağlanmış bir klasör.",
  "conn.guide.sftp.fact.host": "Sunucu",
  "conn.guide.sftp.fact.hostHint": "Web uygulamasıyla aynı makine, kendine ait bir portta.",
  "conn.guide.sftp.fact.port": "Port",
  "conn.guide.sftp.fact.portHint": "Ne 22 ne 443: SFTP ham TCP’dir, web vekilinin içinden geçemez.",
  "conn.guide.sftp.fact.userHint": "Kullanıcı adınız. İçinde @ işareti olsaydı çoğu istemcinin ayar dosyasında tırnaklanması gerekirdi; kullanıcı adı tam da bunu ortadan kaldırır.",
  "conn.guide.sftp.fact.auth": "Oturum açma yöntemi",
  "conn.guide.sftp.fact.authKey": "kayıtlı SSH anahtarınız (ya da parolanız)",
  "conn.guide.sftp.fact.authPassword": "hesap parolanız — ya da yukarıdan bir anahtar kaydedin",
  "conn.guide.sftp.fact.authHint": "API anahtarı da parola yerine geçer ve tek başına iptal edilebilir. İki adımlı doğrulaması açık bir hesap SSH anahtarı ya da API anahtarı kullanmalıdır.",
  "conn.guide.sftp.fact.path": "Yol",
  "conn.guide.sftp.fact.pathHint": "İlk klasör bir depodur; kök, açabildiğiniz depoları listeler.",
  "conn.guide.sftp.openssh.connectCaption": "Bağlan, gönder, al",
  "conn.guide.sftp.openssh.noShell": "Burada kabuk yok, yalnız SFTP alt sistemi var. `ssh sunucu komut` bilerek reddedilir; scp çalışır çünkü OpenSSH 9 onun için de SFTP konuşur.",
  "conn.guide.sftp.key.tab": "Anahtar kurulumu",
  "conn.guide.sftp.key.s1": "Bağlanacak makinede bir anahtar çifti üretin (zaten varsa atlayın).",
  "conn.guide.sftp.key.s2": "AÇIK yarısını kopyalayın — .pub dosyası, asla diğeri değil.",
  "conn.guide.sftp.key.s3": "Yukarıdaki kutuya yapıştırıp bağlanın; o andan sonra parola gönderilmez.",
  "conn.guide.sftp.key.genCaption": "Kendi makinenizde",
  "conn.guide.sftp.key.noCopyId": "ssh-copy-id filex’e karşı ÇALIŞMAZ: ~/.ssh/authorized_keys dosyasına eklemek için kabuğa ihtiyacı var, filex’te kabuk yok. Anahtarı yukarıdan yapıştırın.",
  "conn.guide.sftp.winscp.s1": "Yeni site → Dosya protokolü: SFTP.",
  "conn.guide.sftp.winscp.s2": "Sunucu adı: {host}, port: {port}.",
  "conn.guide.sftp.winscp.s3": "Kullanıcı adı: {user}. Anahtar için: Gelişmiş → SSH → Kimlik Doğrulama → özel anahtar dosyası.",
  "conn.guide.sftp.winscp.s4": "WinSCP .ppk biçiminde özel anahtar ister — OpenSSH anahtarını kendi aracıyla (Araçlar → PuTTYgen) bir kez dönüştürün.",
  "conn.guide.sftp.filezilla.s1": "Dosya → Site Yöneticisi → Yeni site, Protokol: SFTP.",
  "conn.guide.sftp.filezilla.s2": "Sunucu: {host}, port: {port}.",
  "conn.guide.sftp.filezilla.s3": "Kullanıcı: {user}. Giriş türü: parola için Normal, anahtar için Anahtar dosyası.",
  "conn.guide.sftp.rclone.useCaption": "Kullanımı",
  "conn.guide.sftp.sshfs.mountCaption": "Bağla ve çöz",
  "conn.guide.sftp.sshfs.note": "Bağlanmış bir klasörde her kayıt dosyanın tamamını yeniden yazar. Belgeler için iyi; veritabanı ya da yerinde düzenlediğiniz bir video için değil.",
  "conn.guide.sftp.note.storages": "Kök bir ev dizini değildir: açabildiğiniz depoları listeler ve yolun ilk parçası bir depoyu adlandırır.",
  "conn.guide.sftp.note.permissions": "İstemcinizin çizdiği izin bitleri buradaki erişim seviyenizden gelir; yani salt-okunur görünen bir dosya sizin için gerçekten öyledir.",
  "conn.guide.sftp.note.trash": "Silme her yerdeki gibi filex çöp kutusuna gider ve saklama politikası süpürene kadar geri alınabilir.",
  "conn.guide.sftp.note.totp": "Hesabınızda iki adımlı doğrulama açıksa parola burada çalışmaz — SSH’ın kodu soracak bir kanalı yok. Bir SSH anahtarı kaydedin ya da parola yerine API anahtarı kullanın.",
  "conn.guide.sftp.note.disabled": "Bu sunucuda SFTP ucu kapalı. Yönetici açtığında bu talimatlar çalışacaktır.",
  // ── FTPS ─────────────────────────────────────────────────────────
  "conn.guide.ftps.summary": "FTPS, yalnızca FTP öğrenmiş ekipman için var: tarayıp-klasöre-atan yazıcılar, EDI muhatapları, eski laboratuvar ve endüstri yazılımları. Her zaman TLS üzerinden.",
  "conn.guide.ftps.fact.host": "Sunucu",
  "conn.guide.ftps.fact.hostHint": "Web uygulamasıyla aynı makine, kendine ait bir portta.",
  "conn.guide.ftps.fact.port": "Port",
  "conn.guide.ftps.fact.portHint": "Kontrol kanalı. Veri, aşağıdaki pasif aralıktan ayrı bir porttan akar.",
  "conn.guide.ftps.fact.mode": "Şifreleme",
  "conn.guide.ftps.fact.modeValue": "FTPS — açık (explicit) TLS, zorunlu",
  "conn.guide.ftps.fact.modeHint": 'Düz FTP, parola okunmadan reddedilir. "Require explicit FTP over TLS" seçin; "plain FTP" ya da "implicit" asla.',
  "conn.guide.ftps.fact.userHint": "Kullanıcı adınız ya da e-postanız. Parola yerine bir API anahtarı da kullanılabilir ve tek başına iptal edilebilir.",
  "conn.guide.ftps.fact.passwordHint": "Hesap parolanız ya da bir API anahtarı. İki adımlı doğrulaması açık bir hesap API anahtarı kullanmalıdır — FTP'nin kodu soracak bir yolu yok.",
  "conn.guide.ftps.fact.pasv": "Pasif portlar",
  "conn.guide.ftps.fact.pasvHint": "Veri bağlantıları buraya düşer. Güvenlik duvarınız bu aralığı kapatıyorsa aktarım iki tarafta da hata vermeden ASILI KALIR — FTP'nin klasik arızası budur.",
  "conn.guide.ftps.filezilla.s1": "Dosya → Site Yöneticisi → Yeni site, Protokol: FTP.",
  "conn.guide.ftps.filezilla.s2": "Sunucu: {host}, port: {port}.",
  "conn.guide.ftps.filezilla.s3": 'Şifreleme: "Require explicit FTP over TLS". Giriş türü: Normal, kullanıcı: {user}.',
  "conn.guide.ftps.filezilla.s4": "Aktarım ayarları → Pasif. Bu sunucu aktif modu reddeder.",
  "conn.guide.ftps.winscp.s1": "Yeni site → Dosya protokolü: FTP, Şifreleme: TLS/SSL Explicit encryption.",
  "conn.guide.ftps.winscp.s2": "Sunucu adı: {host}, port: {port}.",
  "conn.guide.ftps.winscp.s3": "Kullanıcı adı: {user}, parola yukarıdaki.",
  "conn.guide.ftps.curl.caption": "Gönder ve al",
  "conn.guide.ftps.curl.sslReqd": "--ssl-reqd isteğe bağlı değil: curl'ün düz metne geri düşmek yerine TLS'i ZORUNLU kılmasını sağlar. Bu sunucu zaten düz metni reddediyor, ama alışkanlık sizi reddetmeyen sunuculara karşı korur.",
  "conn.guide.ftps.lftp.caption": "Bağlan",
  "conn.guide.ftps.lftp.protectData": "ssl-protect-data yalnız oturum açmayı değil DOSYAYI da şifreler. Olmazsa lftp TLS ile oturum açar ve dosyayı açık metin gönderir — sahada en sık yapılan FTPS yanlışı budur.",
  "conn.guide.ftps.rclone.useCaption": "Kullanımı",
  "conn.guide.ftps.printer.tab": "Tarayıcı / yazıcı",
  "conn.guide.ftps.printer.s1": "Cihazın tara-ve-FTP'ye-gönder ayarlarında: sunucu {host}, port {port}.",
  "conn.guide.ftps.printer.s2": "Kullanıcı: {user}, parola yukarıdaki. Cihaz için kendi parolanız yerine bir API anahtarı oluşturun — başka hiçbir şeyi değiştirmeden iptal edilebilir.",
  "conn.guide.ftps.printer.s3": "Yol: {path} — ya da önceden oluşturduğunuz bir alt klasör. Cihaz depo oluşturamaz.",
  "conn.guide.ftps.printer.s4": '"SSL/TLS" ya da "FTPS explicit" seçeneğini AÇIN ve PASİF modu seçin.',
  "conn.guide.ftps.printer.noTLS": "Tara-ve-gönder yazılımlarının önemli bir kısmı TLS konuşamıyor. Bu sunucu öyle bir cihazla konuşmayacak ve bu bilinçli: alternatifi, belgelerinizin ve parolanızın ofis ağında açık metin dolaşması.",
  "conn.guide.ftps.note.tls": "TLS zorunludur ve kapatan bir düğme yoktur. Düz FTP parolanızı açık metin gönderir, ardından dosyanızı da.",
  "conn.guide.ftps.note.passive": "Yalnızca pasif mod. Aktif modda sunucu istemciyi geri arar; bu NAT arkasında çalışmaz ve çoğu güvenlik duvarı tarafından engellenir.",
  "conn.guide.ftps.note.storages": "Kök bir ev dizini değildir: açabildiğiniz depoları listeler ve yolun ilk parçası bir depoyu adlandırır.",
  "conn.guide.ftps.note.trash": "Silme her yerdeki gibi filex çöp kutusuna gider ve saklama politikası süpürene kadar geri alınabilir.",
  "conn.guide.ftps.note.prefer": "İstemci SFTP konuşabiliyorsa onu tercih edin: tek bağlantı, tek port, pasif mod sürprizi yok.",
  "conn.guide.ftps.note.selfSigned": "Bu sunucu kendinden imzalı bir sertifika kullanıyor. Kanalı şifreler ama karşı tarafın kim olduğunu kanıtlamaz; çoğu istemci bir kez onay ister. Önemli bir iş için gerçek sertifika koyun.",
  "conn.guide.ftps.note.disabled": "Bu sunucuda FTPS ucu kapalı. Yönetici açtığında bu talimatlar çalışacaktır.",
  // ── NFS ──────────────────────────────────────────────────────────
  "conn.nfs.title": "NFS export'ları",
  "conn.nfs.lead": "Bir export, ağınızdaki bir makinenin filex'i sürücü olarak bağlamasını sağlar — medya oynatıcı, derleme sunucusu, yedek kutusu.",
  "conn.nfs.pathIsSecret": "⚠ Export yolu PAROLANIN TA KENDİSİDİR. NFS, Kerberos olmadan istemciye kim olduğunu soramaz; bu yüzden filex yola 32 rastgele bayt koyar: yolu bilen sizin adınıza bağlanır. Bağlama satırını bir kimlik bilgisi gibi saklayın — /etc/fstab çoğu sistemde herkes tarafından okunabilir.",
  "conn.nfs.disabled": "Bu sunucuda NFS ucu kapalı (FILEX_NFS). Burada oluşturulan export, yönetici ucu açana kadar bağlanmaz.",
  "conn.nfs.cannotMint": "Export oluşturabilecek bir hesapla oturum açmış değilsiniz.",
  "conn.nfs.label": "Ne için? (medya oynatıcı, yedek kutusu, …)",
  "conn.nfs.defaultLabel": "nfs export",
  "conn.nfs.everyStorage": "Görebildiğim tüm depolar",
  "conn.nfs.prefix": "Depo içindeki klasör (isteğe bağlı)",
  "conn.nfs.allowCidrs": "İzinli adresler, örn. 192.168.1.0/24 (isteğe bağlı)",
  "conn.nfs.readOnly": "Salt okunur",
  "conn.nfs.readOnlyHint": "Bir makine için güvenli varsayılan salt okunurdur: sizin yetkiniz ne olursa olsun bu bağlantı üzerinden her yazmayı reddeder. Adres listesi daha da daraltır — listenin dışından gelen bağlanamaz.",
  "conn.nfs.mint": "Export oluştur",
  "conn.nfs.once": "Şimdi kopyalayın — yol yalnızca bir kez gösterilir ve geri alınamaz.",
  "conn.nfs.dismiss": "Kopyaladım",
  "conn.nfs.col.label": "Etiket",
  "conn.nfs.col.scope": "Kapsam",
  "conn.nfs.col.mode": "Mod",
  "conn.nfs.col.lastUsed": "Son bağlanma",
  "conn.nfs.scopeAll": "görebildiğiniz her şey",
  "conn.nfs.modeRead": "salt okunur",
  "conn.nfs.modeWrite": "okuma/yazma",
  "conn.nfs.noLabel": "(etiketsiz)",
  "conn.nfs.neverUsed": "hiç",
  "conn.nfs.enable": "Aç",
  "conn.nfs.disable": "Kapat",
  "conn.nfs.revoke": "İptal et",
  "conn.nfs.confirm": "Emin misiniz?",
  "conn.nfs.empty": "Henüz export yok.",
  "conn.guide.nfs.summary": "NFS, filex'i kendi ağınızdaki bir makinede sürücü olarak bağlar — NAS protokolü, onu bekleyen cihazlar için.",
  "conn.guide.nfs.pathPlaceholder": "yukarıdan bir export oluşturun",
  "conn.guide.nfs.fact.host": "Sunucu",
  "conn.guide.nfs.fact.hostHint": "Web uygulamasıyla aynı makine, kendine ait bir portta.",
  "conn.guide.nfs.fact.port": "Port",
  "conn.guide.nfs.fact.portHint": "Hem port= hem mountport= buna ayarlanmalı; filex mount ve NFS servislerini tek portta veriyor.",
  "conn.guide.nfs.fact.export": "Export yolu",
  "conn.guide.nfs.fact.exportHint": "Kimlik bilgisi budur. Export oluşturulurken bir kez gösterilir ve hash'li saklanır — filex bir daha gösteremez.",
  "conn.guide.nfs.fact.options": "Bağlama seçenekleri",
  "conn.guide.nfs.fact.optionsHint": "nolock, çünkü filex NFS kilit yöneticisini çalıştırmıyor; nfsvers=3, çünkü bu sunucunun konuştuğu sürüm bu.",
  "conn.guide.nfs.linux.mountCaption": "Bağla",
  "conn.guide.nfs.linux.fstabSecret": "Bu yolu içeren bir /etc/fstab satırı, herkesin okuyabildiği bir dosyadaki paroladır. Ortamınızda önemliyse kimlik korumalı automount kullanın ya da bağlamayı yalnız root'un okuyabildiği bir unit dosyasında tutun.",
  "conn.guide.nfs.mac.mountCaption": "Bağla",
  "conn.guide.nfs.mac.resvport": "macOS resvport ister: istemcisi ayrıcalıklı bir kaynak portta ısrar eder ve olmadan bağlantıyı reddeder.",
  "conn.guide.nfs.win.s1": `Windows Özellikleri'nden "Services for NFS" → "Client for NFS" bileşenini açın (yalnız Pro ve Enterprise; Home'da yok).`,
  "conn.guide.nfs.win.s2": "Komut İstemi'ni yönetici olarak açın.",
  "conn.guide.nfs.win.s3": "Aşağıdaki komutla export'u bir sürücü harfine bağlayın.",
  "conn.guide.nfs.win.cmdCaption": "Z: sürücüsüne bağla",
  "conn.guide.nfs.win.port": "Windows'un mount servisinin portunu söyleme imkânı yok; yalnızca standart 2049 portundaki bir NFS sunucusuna erişebilir. Bu sunucu başka bir porttaysa SFTP'yi ya da filex masaüstü uygulamasını kullanın.",
  "conn.guide.nfs.nas.tab": "NAS / medya oynatıcı",
  "conn.guide.nfs.nas.s1": "Cihazın NFS ayarlarında: sunucu {host}, port {port} (ayrı ayrı soruyorsa hem NFS hem mount portunu ayarlayın).",
  "conn.guide.nfs.nas.s2": "Uzak yol: yukarıdaki export yolu, birebir.",
  "conn.guide.nfs.nas.s3": "NFS sürüm 3, kilitleme kapalı. Cihazın gerçekten yazması gerekmiyorsa export'u salt okunur oluşturun.",
  "conn.guide.nfs.note.unencrypted": "NFSv3 şifreli değildir. Trafiği okuyabilen dosyalarınızı görür, yolu öğrenen bağlanabilir. Ev/ofis ağında ya da VPN üzerinden kullanın — internet üzerinden asla.",
  "conn.guide.nfs.note.pathIsSecret": "Export yolu kimlik bilgisinin tamamıdır. Sızarsa yukarıdaki listeden iptal edin; değiştirilecek başka bir şey yok.",
  "conn.guide.nfs.note.noPortmapper": "111 portunda portmapper yok; portu söylenmeyen istemci sunucuyu bulamaz. Buradaki her komutun port= ve mountport= taşımasının sebebi bu.",
  "conn.guide.nfs.note.uid": "İstemcinizin gönderdiği kullanıcı ve grup kimlikleri yok sayılır: bağlantı zaten kime ait olduğunu biliyor. Gördüğünüz izinler filex'teki erişiminizden gelir.",
  "conn.guide.nfs.note.trash": "Silme her yerdeki gibi filex çöp kutusuna gider ve saklama politikası süpürene kadar geri alınabilir.",
  "conn.guide.nfs.note.revoke": "İptal anında değil, bir sonraki istekte etkili olur: NFS'te sonlandırılacak bir oturum yok, bağlantısı açık olan istemci sıradaki işleminde hata alır.",
  "conn.guide.nfs.note.disabled": "Bu sunucuda NFS ucu kapalı. Yönetici açtığında bu talimatlar çalışacaktır.",
  "conn.tokens.title": "API anahtarları",
  "conn.tokens.lead": "FTPS, WebDAV ve filex mount hesap parolanız yerine bir API anahtarıyla oturum açar. Buradan oluşturun — tek başına iptal edilebilir, ayrıca iki adımlı doğrulaması açık bir hesap bunlarda parolasını zaten kullanamaz.",
  "conn.tokens.mint": "API anahtarı oluştur",
  "conn.tokens.once": "Şimdi kopyalayın — yalnızca bir kez gösterilir. Sunucuda yalnız özeti saklandığı için bir daha gösterilemez.",
  "conn.tokens.dismiss": "Kopyaladım",
  "conn.tokens.cannotMint": "Bu oturum API anahtarı oluşturamıyor. Kendi hesabınızla oturum açıp oluşturun.",
  "conn.tokens.empty": "Henüz API anahtarı yok.",
  "conn.tokens.neverUsed": "hiç",
  "conn.tokens.revoke": "İptal et",
  "conn.tokens.confirm": "Emin misiniz?",
  "conn.tokens.col.label": "Ad",
  "conn.tokens.col.scopes": "İzinler",
  "conn.tokens.col.used": "Son kullanım",
  "conn.tokens.revokeHint": "İptal, yalnız bir sonraki oturum açmayı değil AÇIK bağlantıyı da durdurur: SFTP ya da FTPS oturumu kesilir, bağlı bir sürücü yarım dakika içinde çalışmayı bırakır.",
  "conn.guide.mount.summary": "filex mount, uzaktaki bir filex sunucusunu bu makinede bir klasöre bağlar — tarayıcının kullandığı aynı HTTPS üzerinden. Buradakilerin her yerden çalışan tek yöntemi: yerel ağ da gerekmez, ek sunucu da, üçüncü parti bir istemci de.",
  "conn.guide.mount.fact.url": "Sunucu adresi",
  "conn.guide.mount.fact.urlHint": "Tarayıcıda kullandığınız adresin aynısı. Başka hiçbir şeye erişilebilir olması gerekmez.",
  "conn.guide.mount.fact.token": "API anahtarı",
  "conn.guide.mount.fact.tokenPlaceholder": "API anahtarları bölümünden oluşturun",
  "conn.guide.mount.fact.tokenHint": "Parolanız değil, bir API anahtarı — tek başına iptal edilebilir, ayrıca 2FA açık bir hesap burada parolasını zaten kullanamaz.",
  "conn.guide.mount.fact.remote": "Neyi bağlayacağınız",
  "conn.guide.mount.fact.remoteHint": "--remote vermezseniz her depo bir klasör olarak görünür; tek bir depoyu — ya da onun içindeki bir klasörü — adlandırırsanız yalnızca o bağlanır.",
  "conn.guide.mount.linux.mountCaption": "Bağlayın",
  "conn.guide.mount.linux.umountCaption": "Ayırın",
  "conn.guide.mount.linux.umountWarn": "Süreci öldürerek değil, fusermount ile ayırın. Ayrılmadan ölen bir bağlantı, birileri elle fusermount çalıştırana kadar her ls komutunun asılı kaldığı bir klasör bırakır.",
  "conn.guide.mount.linux.systemdCaption": "Oturum açılınca otomatik bağlansın (systemd kullanıcı birimi)",
  "conn.guide.mount.win.winfsp": "Windows'ta bir kez WinFsp kurulması gerekiyor — ücretsiz ve açık kaynak: https://winfsp.dev. Başka bir şey gerekmiyor, sonrasında yönetici hakkı da istemiyor.",
  "conn.guide.mount.win.mountCaption": "Sürücü olarak bağlayın",
  "conn.guide.mount.win.freeLetter": "BOŞ bir sürücü harfi seçin. Harf bağlama sırasında oluşturulur, var olan bir şeye eklenmez; kullanımdaki bir harfi verirseniz bunu söylemeyen bir hatayla başarısız olur.",
  "conn.guide.mount.win.stop": "O pencerede Ctrl-C ile durdurun. Sürücü kaybolur ve bu makinede hiçbir şey kalmaz.",
  "conn.guide.mount.mac.unsupported": "filex mount macOS'ta çalışmıyor. macFUSE gerekiyor; lisansı filex gibi bir programın onu sizin yerinize kurmasına izin vermiyor ve Go bağlaması filex'in bilinçli olarak kullanmadığı bir C derleyicisi istiyor. Komut burada çalışıyormuş gibi görünüp hiçbir şey yapmak yerine açıkça reddediyor.",
  "conn.guide.mount.mac.alternatives": "macOS'ta filex masaüstü uygulamasını klasör eşitlemesiyle kullanın (dosyalar diskte durur) ya da sürücü bağlayabilen bir istemciyle SFTP.",
  "conn.guide.mount.note.notASync": "Bu bir eşitleme değildir. Küçük bir okuma önbelleği dışında bu makineye hiçbir şey kopyalanmaz; yüz bin dosyanın içinden birini gerisini indirmeden açar. Dosyaları çevrimdışıyken istiyorsanız klasör eşitlemesini kullanın.",
  "conn.guide.mount.note.reachable": "Sunucuya, tarayıcının geçtiği hangi vekil ya da tünel varsa oradan ulaşır — çünkü altında aynı API vardır. İzinleriniz, depolarınız ve çok kiracılı bir sunucuda kiracınız da birlikte gelir.",
  "conn.guide.mount.note.wholeFileWrites": "Bağlantı üzerinden yazdığınız dosya, yazılırken değil, program onu kapattığında yüklenir. Çok büyük bir dosyayı yerinde düzenlemek burada yerel diskten yavaştır; içeri ve dışarı kopyalamak değildir.",
  "conn.guide.mount.note.trash": "Silme her yerdeki gibi filex çöp kutusuna gider ve saklama politikası süpürene kadar geri alınabilir.",
  "conn.guide.mount.note.revoke": "Bir bağlantıyı durdurmak için API anahtarını iptal edin. Bağlantı hâlâ takılı olsa bile yarım dakika içinde hizmet vermeyi bırakır.",
  "storages.driver.ftp": "FTP / FTPS",
  "storages.driver.local": "Yerel dosya sistemi",
  "storages.driver.s3": "S3 / Hetzner / MinIO",
  "storages.driver.sftp": "SFTP",
  "storages.driver.smb": "SMB / CIFS (NAS)",
  "storages.driver.webdav": "WebDAV",
  "storages.fieldHelp.smbShare": "Sunucu adı olmadan yalnızca paylaşım adı: `\\\\nas\\media` değil, `media`.",
  "storages.fieldHelp.smbDomain": "Yalnızca Windows etki alanı hesabı için. NAS kullanıyorsanız boş bırakın.",
  "storages.fieldHelp.smbRoot": "Paylaşımın içindeki alt klasör. Paylaşımın tamamı için boş bırakın.",
  "storages.fields.share": "Paylaşım",
  "storages.fields.domain": "Etki alanı / çalışma grubu",
  "storages.fields.dialTimeout": "Bağlanma zaman aşımı (saniye)",
  "storages.fieldHelp.disablePresign": "Varsayılan olarak açık: yüklemeler ve herkese açık paylaşım bağlantılarındaki indirmeler filex üzerinden akar; kova endpoint'inin tarayıcıdan erişilebilir olması gerekmez (yalnız yerel ağdaki MinIO doğrudan çalışır). Yalnızca endpoint kullanıcıların tarayıcısından erişilebiliyorsa (AWS, herkese açık MinIO) ve tarayıcının kovayla doğrudan konuşmasını istiyorsanız kapatın — çok büyük dosyalarda daha hızlıdır, ama depo SDK'nın imzaladığı URL'leri kabul etmelidir (Ceph RGW / bazı Hetzner kurulumları SignatureDoesNotMatch döner).",
  "storages.fieldHelp.endpoint": "AWS S3 için boş bırakın. S3 uyumlu diğer tüm depolar kendi endpoint'ini ister.",
  "storages.fieldHelp.hostKey": "authorized_keys / known_hosts satır biçiminde tek bir açık anahtar.",
  "storages.fieldHelp.insecureSkipHostKey": "Her sunucu anahtarını kabul eder. Yalnızca geçici sunucular için.",
  "storages.fieldHelp.keyPath": "Sunucudaki anahtar dosyasının yolu; depo başlarken okunur. PEM alanı boşken kullanılır.",
  "storages.fieldHelp.knownHosts": "Katı sunucu anahtarı denetimi için OpenSSH known_hosts yolu. Varsayılan, ~/.filex/known_hosts içinde ilk bağlantıda güven.",
  "storages.fieldHelp.passive": "Kapatmak aktif moda geçirir; bu, sunucunun bu makineye geri bağlanmasını gerektirir.",
  "storages.fieldHelp.path": "Sunucudaki dizin. Yoksa oluşturulur; filex asla / dizinini mount etmez.",
  "storages.fieldHelp.pathStyle": "AWS dışındaki tüm depolarda açık olmalı. Endpoint girildiyse ve bu alana hiç dokunulmadıysa kendiliğinden açılır.",
  "storages.fieldHelp.prefix": "Kova içindeki alt klasör. Zorunlu: filex kova kökünün sahipliğini asla almaz.",
  "storages.fieldHelp.region": 'Boş bırakılırsa "auto" kullanılır.',
  "storages.fieldHelp.root": "Arka uçtaki alt klasör. Zorunlu: filex hesabın kökünü asla mount etmez.",
  "storages.fieldHelp.sftpAuth": "Parola ya da özel anahtardan biri zorunludur.",
  "storages.fieldHelp.tls": "Düz FTP kimlik bilgilerini açık metin gönderir — sunucu destekliyorsa açın.",
  "storages.fields.accessKey": "Access key",
  "storages.fields.basePath": "Temel yol",
  "storages.fields.bucket": "Kova",
  "storages.fields.disablePresign": "Aktarımları filex üzerinden geçir",
  "storages.fields.endpoint": "Endpoint",
  "storages.fields.host": "Sunucu",
  "storages.fields.hostKey": "Sabitlenmiş sunucu anahtarı",
  "storages.fields.insecureSkipHostKey": "Sunucu anahtarı doğrulamasını atla (güvensiz)",
  "storages.fields.keyPath": "Özel anahtar dosyası",
  "storages.fields.knownHosts": "known_hosts dosyası",
  "storages.fields.name": "Görünen ad",
  "storages.fields.namePlaceholder": "Kişisel fotoğraflar",
  "storages.fields.passive": "Pasif mod (PASV)",
  "storages.fields.password": "Parola",
  "storages.fields.path": "Dizin yolu",
  "storages.fields.pathStyle": "Path-style URL kullan (Hetzner, MinIO)",
  "storages.fields.port": "Port",
  "storages.fields.prefix": "Önek (prefix)",
  "storages.fields.privateKey": "Özel anahtar (PEM)",
  "storages.fields.rbac": "Öğe bazlı erişim denetimi (RBAC)",
  "storages.fields.rbacHint": "Açıkken yönetici olmayanlar yalnızca kendilerine yetki verilen dosya ve klasörleri görür (Klasör erişimi sayfasında listelenir). Kapalıyken herkes depoyu rolüne göre açar.",
  "storages.fields.readOnly": "Salt okunur mount",
  "storages.fields.region": "Bölge",
  "storages.fields.root": "Temel yol",
  "storages.fields.secretKey": "Secret key",
  "storages.fields.tls": "FTPS (açık AUTH TLS)",
  "storages.fields.url": "Temel URL",
  "storages.fields.user": "Kullanıcı",
  "storages.fields.s3AttemptTimeout": "Deneme zaman aşımı (saniye)",
  "storages.fields.s3MaxAttempts": "İstek başına deneme sayısı",
  "storages.fields.s3TotalTimeout": "Vazgeçme süresi (saniye)",
  "storages.fieldHelp.s3AttemptTimeout": "Tek bir denemenin depodan bir yaşam belirtisi için bekleyebileceği süre: bağlanma, TLS el sıkışması, istek gönderildikten sonraki cevap ve cevabın her yeni parçası. İlerleyen bir aktarım, süresi ne olursa olsun hiçbir zaman kesilmez; deponun almayı bıraktığı bir yükleme 60 saniye sonra, bu değer daha uzunsa bu kadar sonra kesilir. Kopyalama ve yeniden adlandırma cevap için 10 dakikaya kadar bekler, çünkü depo bunları ancak kopya bittiğinde cevaplar.",
  "storages.fieldHelp.s3MaxAttempts": "Hata geçebilecek türdeyse bir isteğin toplamda kaç kez deneneceği: ağ hatası, zaman aşımı, 5xx cevabı, hız sınırlaması. 1 yeniden denemeyi kapatır. Bir ret (403, bulunmayan bir kova, çözümlenmeyen bir sunucu adı) hiçbir zaman yeniden denenmez.",
  "storages.fieldHelp.s3TotalTimeout": "İlk denemeden itibaren bu kadar saniye içinde bitemeyecek yeni bir deneme başlatılmaz; böylece çalışmayan bir depoya yükleme ya da listeleme, kesintiyi bu süre içinde bildirir. Sürmekte olan bir aktarım kesilmez. Zaman aşımına uğrayan bir istek ancak bu değer deneme zaman aşımının en az iki katıysa yeniden denenir.",
  "storages.fields.attemptTimeout": "Deneme zaman aşımı (saniye)",
  "storages.fields.maxAttempts": "İstek başına deneme sayısı",
  "storages.fields.totalTimeout": "Vazgeçme süresi (saniye)",
  "storages.fieldHelp.attemptTimeout": "Tek bir denemenin sunucudan bir yaşam belirtisi için bekleyebileceği süre: bağlanma, oturum açma, her isteğin cevabı ve bir aktarımın her yeni parçası. İlerleyen bir aktarım, süresi ne olursa olsun hiçbir zaman kesilmez; sunucunun almayı bıraktığı bir yükleme 60 saniye sonra, bu değer daha uzunsa bu kadar sonra kesilir.",
  "storages.fieldHelp.webdavAttemptTimeout": "Tek bir denemenin sunucudan bir yaşam belirtisi için bekleyebileceği süre: bağlanma, oturum açma, her isteğin cevabı ve bir aktarımın her yeni parçası. İlerleyen bir aktarım, süresi ne olursa olsun hiçbir zaman kesilmez; sunucunun almayı bıraktığı bir yükleme 60 saniye sonra, bu değer daha uzunsa bu kadar sonra kesilir. Kopyalama, taşıma ve silme cevap için 10 dakikaya kadar bekler, çünkü sunucu bunları ancak iş bittiğinde cevaplar.",
  "storages.fieldHelp.maxAttempts": "Hata geçebilecek türdeyse bir isteğin toplamda kaç kez deneneceği: bağlantı reddedilir ya da kopar, cevap zamanında gelmez, sunucu şu an hizmet veremediğini söyler (5xx). 1 yeniden denemeyi kapatır. Bir ret (yanlış parola, bulunmayan bir klasör, doğrulanamayan bir sertifika) hiçbir zaman yeniden denenmez; gönderilmeye başlamış bir yükleme de yeniden denenmez.",
  "storages.fieldHelp.totalTimeout": "İlk denemeden itibaren bu kadar saniye içinde bitemeyecek yeni bir deneme başlatılmaz; böylece çalışmayan bir sunucu bu süre içinde bildirilir. Sürmekte olan bir aktarım kesilmez. Zaman aşımına uğrayan bir istek ancak bu değer deneme zaman aşımının en az iki katıysa yeniden denenir.",
  /* === gezinti:g1 — gezinti paneli (SideNav) === */
  "sidenav.title": "Gezinti",
  "sidenav.views": "Görünümler",
  "sidenav.storages": "Depolar",
  "sidenav.home": "Ana sayfa",
  "sidenav.myfiles": "Dosyalarım",
  "sidenav.recent": "Son kullanılanlar",
  "sidenav.starred": "Yıldızlılar",
  "sidenav.shared": "Benimle paylaşılanlar",
  // Üstteki satırın aynası ve tam altında durur: gelen ile giden.
  "sidenav.myshares": "Paylaştıklarım",
  "sidenav.trash": "Çöp kutusu",
  "sidenav.collapse": "Gezintiyi daralt",
  "sidenav.expand": "Gezintiyi genişlet",
  "sidenav.close": "Gezintiyi kapat",
  // ⚠ aç/kapat çifti ÇEKMECENİN, daralt/genişlet çifti yerleşik PANELİN —
  // ikisi birbirinin yerine kullanılamaz; bkz. en.ts'teki not ve Toolbar.vue
  // içindeki `navToggleLabel`. 560px altında panel listenin üzerine gelen bir
  // çekmecedir: raya inmez, hiç ekranda değildir; "genişlet" olmayan bir
  // genişliği büyütmeyi vaat ederdi.
  "sidenav.open": "Gezintiyi aç",
  "sidenav.storage.shared": "Paylaşılan",
  "sidenav.storage.readOnly": "Salt okunur",
  // #57 — depo satırının sıralama menüsü (sağ tık, uzun basış, Shift+F10).
  // "Ada göre sırala" bir mod değildir; kişinin elle düzeltmeye devam
  // edebileceği bir sıra yazar. "Varsayılan sırayı kullan" kişinin kendi
  // sırasını bırakır: panel yöneticinin sırasına (yoksa sunucununkine) döner.
  "sidenav.storage.moveUp": "Yukarı taşı",
  "sidenav.storage.moveDown": "Aşağı taşı",
  "sidenav.storage.sortName": "Ada göre sırala",
  "sidenav.storage.sortName.done": "Zaten ada göre sıralı",
  "sidenav.storage.defaultOrder": "Varsayılan sırayı kullan",
  "sidenav.storage.defaultOrder.none": "Zaten varsayılan sırada",
  // ⚠ `toolbar.nav` KALDIRILDI, yerine bir şey konmadı — bkz. en.ts'teki not.
  // Paneli daraltan tek denetimin etiketiydi; önce "Gezinti" (panelin adı,
  // düğmenin ne yaptığını söylemiyor), sonra "Gezintiyi göster/gizle" (sabit
  // geçici çözüm). Gerçek düzeltme yukarıdaki dört `sidenav.*` fiili:
  // etiket `navOpen`'a bağlı, daraltacaksa "daralt", genişletecekse
  // "genişlet" yazıyor.
  "node.home": "Ana sayfa",
  "node.recent": "Son kullanılanlar",
  "node.starred": "Yıldızlılar",
  "node.shared": "Benimle paylaşılanlar",
  "empty.recent.title": "Henüz hiçbir şey açılmadı",
  "empty.recent.hint": "Açtığınız dosyalar burada görünür",
  "empty.starred.title": "Henüz yıldızlı dosya yok",
  "empty.starred.hint": "Bir dosyayı yıldızlayın; burada bulursunuz",
  "empty.shared.title": "Sizinle henüz bir şey paylaşılmadı",
  "empty.shared.hint": "Başkalarının paylaştığı klasör ve dosyalar burada görünür",
  /* etiket:t1 */
  "sidenav.tags": "Etiketler",
  "sidenav.tags.empty": "Henüz etiket yok — bir dosyaya sağ tıklayıp Etiketler’den ekleyebilirsiniz.",
  "sidenav.tags.more": "{count} tane daha göster",
  "sidenav.tags.less": "Daha az göster",
  "sidenav.tags.personal": "Kişisel",
  "sidenav.tags.team": "Ekip",
  "empty.tag.title": "“{tag}” etiketli hiçbir şey yok",
  "empty.tag.hint": "Bir dosyaya sağ tıklayıp Etiketler’i seçin; dosya burada görünür",
  "sidenav.connections": "Bağlantılar",
  "sidenav.apps": "Uygulamalar",
  "sidenav.connect": "Nasıl bağlanılır",
  "sidenav.apikeys": "API anahtarları",
  "overlay.close": "Kapat",
  "conn.tokens.scopes": "İzinler",
  "conn.tokens.root": "Tek bir klasörle sınırla (isteğe bağlı)",
  "conn.tokens.rootPlaceholder": "depo://klasör",
  "conn.tokens.expiry": "Geçerlilik (gün)",
  "conn.tokens.expiryNever": "süresiz",
  "conn.tokens.defaultName": "API anahtarı {date}",
  "conn.tokens.namePlaceholder": "Ad — ör. yedekleme betiği",
  "conn.tokens.capNote": "Tavan kendi erişiminizdir — sahip olmadığınız bir izin reddedilir, verilmez.",
  "conn.tokens.scopesRequired": "En az bir izin seçin — hiçbir izni olmayan bir API anahtarı verilmez.",
  /* === /gezinti:g1 === */
  /* === surucu:d1 — kabuk (GitHub #14); artık `uiProfile: 'drive'` ile
     gelen bir seçenek değil, her profilde çizilir === */
  "drive.new": "Yeni",
  "drive.new.upload": "Dosya yükle",
  "drive.new.folder": "Yeni klasör",
  "drive.new.request": "Dosya iste",
  "drive.new.document": "Yeni belge",
  /* === belge:n1 — "Yeni belge": + Yeni altındaki seçici ==================
     Tür adları BURADA durmuyor. Her kutucuk sözcüklerini lib/fileIcons
     `typeLabelFor`den okur — listedeki Tür sütununun okuduğu tablonun
     aynısı — böylece ".docx" iki yerde de aynı adla anılır ve yeni bir tür
     için hiç dizge gerekmez. Aşağıda yalnız bu pencerenin kendi metni var. */
  "newdoc.title": "Yeni belge",
  "newdoc.type.label": "Belge türü",
  "newdoc.group.document": "Belgeler",
  "newdoc.group.text": "Metin ve kod",
  "newdoc.group.diagram": "Çizimler",
  "newdoc.group.app": "Uygulamalar",
  /* ⚠ Her servisin tek adı, kendi projesinin kullandığı ad: draw.io
     ("drawio" ya da "diagrams.net" değil) ve ONLYOFFICE. */
  "newdoc.withheld.onlyoffice": "Ofis belgeleri için bir belge sunucusu (ONLYOFFICE) gerekir; burada kurulu değil.",
  "newdoc.withheld.drawio": "Çizimler için draw.io gerekir; burada kurulu değil.",
  "newdoc.withheld_admin": "Yönetim panelinde Dış servisler altından kurabilirsiniz.",
  "newdoc.empty.title": "Kullanılabilir belge türü yok",
  "newdoc.empty.body": "Bu sunucu, bu uygulamanın oluşturabileceği bir tür sunmadı.",
  "newdoc.empty.blocked": "Bu sunucunun oluşturabildiği her tür, burada tanımlı olmayan bir düzenleyici servisine bağlı.",
  "newdoc.name": "Ad",
  "newdoc.name.placeholder": "Dosya adı, ör. notlar.txt ya da LICENSE",
  "newdoc.untitled": "Adsız",
  "newdoc.err.slash": "Ad eğik çizgi içeremez.",
  "newdoc.err.exists": "{name} burada zaten var. Başka bir ad seçin.",
  "newdoc.err.bare_ext": "Dosyaya yalnız bir uzantı değil, bir ad verin.",
  "newdoc.err.ext_needs_type": ".{ext} dosyası kendi türüyle oluşturulmalı — boş bir dosya açılmaz. O türü ya da başka bir uzantıyı seçin.",
  "newdoc.hint.ext_added": "Bu tür uzantısını korur; dosya {name} adıyla oluşturulacak.",
  // Drafts (issue #71): a new document is a draft until its first save.
  "sidenav.drafts": "Taslaklar",
  "sidenav.drafts.count": "{n} taslak",
  "sidenav.drafts.count_one": "{n} taslak",
  "node.drafts": "Taslaklar",
  "empty.drafts.title": "Taslak yok",
  "empty.drafts.hint": "Yeni bir belge, ait olduğu yere kaydedilene kadar burada bekler.",
  "drafts.lead": "Henüz kaydedilmemiş yeni belgeler. Bunları yalnızca siz görebilirsiniz.",
  "drafts.count_of": "{n} / {limit} taslak",
  "drafts.col.target": "Kaydedileceği yer",
  "drafts.col.storage": "Depo",
  "drafts.action.save": "Diske kaydet",
  "drafts.open_hint": "{name} dosyasını aç",
  "drafts.no_match": "Filtreye uyan taslak yok.",
  "draft.badge": "Taslak",
  "draft.bar.target": "{folder} konumuna kaydedilecek",
  "draft.save": "Kaydet",
  "draft.saved_to": "{name}, {folder} konumuna kaydedildi.",
  "draft.discarded": "{name} çöp kutusuna taşındı.",
  "draft.kept": "Taslaklarda tutuluyor",
  "draft.editing": "Düzenleniyor…",
  "draft.close.title": "Bu taslak kapatılsın mı?",
  "draft.close.body": "{name}, {folder} için bir taslak ve henüz oraya kaydedilmedi.",
  "draft.close.hint": "Tutulan taslak Taslaklar’da bekler. Çöpe at, taslağı çöp kutusuna taşır.",
  "draft.close.save": "Diske kaydet",
  "draft.close.keep": "Taslaklarda tut",
  "draft.close.discard": "Çöpe at",
  "draft.taken.title": "Bu adda bir dosya zaten var",
  "draft.taken.body": "{folder} konumunda {name} adında bir dosya zaten var. Taslak {suggested} olarak kaydedilsin mi?",
  "draft.taken.confirm": "{name} olarak kaydet",
  "newdoc.hint.draft": "Taslak olarak açılır: siz kaydedene kadar klasörde hiçbir şey oluşturulmaz.",
  "newdoc.err.draft_limit": "Bu sunucunun izin verdiği kadar taslağınız var ({limit}). Önce Taslaklar’da bazılarını kaydedin ya da silin.",
  "newdoc.err.draft_limit_any": "Bu sunucunun izin verdiği sayıda taslağınız var. Önce Taslaklar’da bazılarını kaydedin ya da silin.",
  "newdoc.open_drafts": "Taslakları aç",
  "err.draft_limit": "Bu sunucunun izin verdiği kadar taslağınız var ({limit}). Taslaklar’da bazılarını kaydedin ya da silin.",
  "err.draft_folder_gone": "Bu taslağın kaydedileceği klasör artık yok.",
  "err.drafts_unavailable": "Taslaklar burada kullanılamıyor.",
  "newdoc.location": "Konum",
  "newdoc.location.none": "Bir klasör seçin",
  "newdoc.location.change": "Değiştir",
  "newdoc.location.noaccess": "Bu klasöre kaydedemezsiniz.",
  "newdoc.create": "Oluştur",
  "newdoc.creating": "Oluşturuluyor…",
  "newdoc.cancel": "Vazgeç",
  "drive.search.placeholder": "{scope} deposunda ara",
  "drive.search.placeholder_all": "Tüm depolarda ara",
  "drive.search.hint_title": "Her yerde ara ve komut çalıştır ({combo})",
  "drive.storage.used": "{total} alanın {used} kadarı dolu",
  "drive.storage.used_unlimited": "{used} kullanılıyor",
  "drive.storage.used_partial": "en az {used} kullanılıyor",
  "drive.storage.label": "Depolama",
  /* === gorunum:v3-shell — Ana sayfa görünümü (kabuğun içindeki genel bakış)
   * Bölüm başlıkları `sidenav.storages` / `sidenav.recent` / `sidenav.starred`,
   * boş durumlar da `empty.recent.*` / `empty.starred.*` — bilerek: Ana
   * sayfadaki "Son kullanılanlar" başlığı ile yanındaki panel satırı aynı
   * şeydir, ikisine ayrı metin yazmak onları çeviri çeviri birbirinden
   * ayırmanın yoludur. Aşağıda yalnızca başka hiçbir yerde olmayanlar var. */
  "home.title": "Ana sayfa",
  "home.storages.empty": "Henüz depo yok",
  "home.storages.hint": "Depo, filex’in okuyup yazdığı yerdir — depoları yönetici ekler.",
  "drive.section.folders": "Klasörler",
  "drive.section.files": "Dosyalar",
  "filter.aria": "Filtreler",
  "filter.type": "Tür",
  "filter.type.any": "Her tür",
  "filter.type.folder": "Klasörler",
  "filter.type.document": "Belgeler",
  "filter.type.spreadsheet": "Hesap tabloları",
  "filter.type.presentation": "Sunumlar",
  "filter.type.pdf": "PDF’ler",
  "filter.type.image": "Görseller",
  "filter.type.video": "Videolar",
  "filter.type.audio": "Ses dosyaları",
  "filter.type.archive": "Arşivler",
  "filter.type.code": "Kod",
  "filter.modified": "Değiştirilme",
  "filter.modified.any": "Her zaman",
  "filter.modified.today": "Bugün",
  "filter.modified.7d": "Son 7 gün",
  "filter.modified.30d": "Son 30 gün",
  "filter.modified.year": "Bu yıl",
  "filter.size": "Boyut",
  "filter.size.any": "Her boyut",
  "filter.size.lt1": "1 MB altı",
  "filter.size.1to10": "1 - 10 MB",
  "filter.size.10to100": "10 - 100 MB",
  "filter.size.gt100": "100 MB üstü",
  /* surucu:d1-actions — filtre satırının sonundaki ⋮ menüsü. Yalnızca menünün
     KENDİ adı yeni: içindeki her satır o eylemin zaten sahip olduğu metni
     kullanır (`toolbar.new_folder`, `toolbar.upload`, `ctx.paste`,
     `shortcuts.select_all`, `selection.clear`) — bir komutu yeniden adlandıran
     menü, okuyucuya aynı şeyi iki kez öğretir. */
  "filter.actions": "Liste işlemleri",
  "filter.clear": "Filtreleri temizle",
  "filter.empty.title": "Bu filtrelere uyan bir şey yok",
  "filter.empty.hint": "Bir filtreyi kaldırın ya da yukarıdaki alandan her yerde arayın.",
  "filter.count": "{total} öğeden {shown} tanesi",
  "inspector.tab.details": "Ayrıntılar",
  "inspector.tab.activity": "Etkinlik",
  "inspector.people": "Erişimi olan kişiler",
  "inspector.people.you": "Siz",
  "inspector.people.inherited": "üst klasörden",
  "inspector.people.empty": "Yalnızca siz ve aşağıdaki bağlantıya sahip olanlar.",
  "inspector.people.manage": "Erişimi yönet",
  "inspector.link": "Paylaşım bağlantısı",
  "inspector.link.none": "Paylaşılmadı",
  "inspector.link.create": "Bağlantı oluştur",
  "inspector.link.copy": "Bağlantıyı kopyala",
  "inspector.activity.empty": "Bu öğe için henüz etkinlik kaydı yok.",
  "inspector.activity.hint": "Sürümler dosya değiştikçe, yorumlar ise insanlar yazdıkça birikir.",
  "inspector.activity.version": "{n}. sürüm kaydedildi",
  "inspector.activity.comment": "{who} yorum yaptı",
  "inspector.activity.select": "Etkinliğini görmek için bir dosya ya da klasör seçin.",
  /* === /surucu:d1 === */
  /* === gorunum:v1-chrome — filtre satırındaki ad kutusu === */
  "filter.find": "Bu klasörde filtrele…",
  /* surucu:d1-scope — satırların bir klasörün içeriği olmadığı yerlerde aynı
     kutu. Neyi daralttığını söylemek zorunda: depo listesinde "bu klasör" hiçbir
     şeyi adlandırmaz, Ana sayfada ise üç bloğu birden adlandırırdı. */
  "filter.find.storages": "Depolarda filtrele…",
  "filter.find.home": "Ana sayfada filtrele…",
  /* === gorunum:v1-viewer — tam ekran görüntüleyicinin kendi çerçevesi === */
  "viewer.share": "Paylaş",
  "viewer.nav_prev": "Önceki dosya",
  "viewer.nav_next": "Sonraki dosya",
  /* Üst çubuğun künye satırındaki sayaç: "246,3 KB • 9 Eyl 2026 • 1 / 9". */
  "viewer.counter": "{i} / {n}",
  "viewer.zoom_reset": "Yakınlaştırmayı sıfırla",
  "viewer.fullscreen": "Tam ekran",
  "viewer.exit_fullscreen": "Tam ekrandan çık",
  "viewer.md_placeholder": "# Markdown buraya…",
  /* === gorunum:v1-selbar — filtre satırının yerini alan seçim çubuğu === */
  "selection.count": "{n} seçildi",
  "selection.clear": "Seçimi temizle",
  /* === gorunum:v1-preview — türün adı, kelimeyle =======================
     Tür sütunu eskiden uzantıyı büyük harfle yazıyordu; artık bunları
     yazıyor. Hangisinin seçileceğine `lib/fileIcons.ts` karar verir
     (`typeLabelKey`) — bir türü adlandıran yalnız iki yer var: o tablo ve bu
     liste. Eşleşmeyen her şey yine büyük harfli uzantıya düşer. `Klasör`
     burada DEĞİL: o `node.folder`, grid kartının alt yazısı zaten onu basar. */
  "ftype.typescript": "TypeScript",
  "ftype.javascript": "JavaScript",
  "ftype.vue": "Vue bileşeni",
  "ftype.python": "Python",
  "ftype.go": "Go",
  "ftype.rust": "Rust",
  "ftype.php": "PHP",
  "ftype.ruby": "Ruby",
  "ftype.java": "Java",
  "ftype.kotlin": "Kotlin",
  "ftype.swift": "Swift",
  "ftype.c": "C kaynağı",
  "ftype.cpp": "C++ kaynağı",
  "ftype.csharp": "C# kaynağı",
  "ftype.stylesheet": "Stil dosyası",
  "ftype.html": "HTML belgesi",
  "ftype.json": "JSON verisi",
  "ftype.yaml": "YAML",
  "ftype.xml": "XML",
  "ftype.toml": "TOML",
  "ftype.sql": "SQL",
  "ftype.shell": "Kabuk betiği",
  "ftype.powershell": "PowerShell betiği",
  "ftype.markdown": "Markdown",
  "ftype.plaintext": "Düz metin",
  "ftype.log": "Günlük dosyası",
  "ftype.config": "Ayar dosyası",
  "ftype.sheet": "Hesap tablosu",
  "ftype.drawio": "draw.io diyagramı",
  "ftype.figma": "Figma tasarımı",
  "ftype.design": "Tasarım dosyası",
  "ftype.image": "Görsel",
  "ftype.video": "Video",
  "ftype.audio": "Ses",
  "ftype.pdf": "PDF belgesi",
  "ftype.document": "Belge",
  "ftype.slides": "Sunum",
  "ftype.archive": "Arşiv",
  "ftype.code": "Kod",
  /* === gorunum:v1-advsearch — Gelişmiş arama penceresi ===================
   * İki `filter.*` anahtarı kardeşlerinin yanında değil burada: paylaşılan
   * birleşimlere pencerenin eklediği yeni üyeler (`modified: 'around'`,
   * `size: 'range'`). Filtre satırı bunları hiç seçmez ama biri oraya
   * ulaşırsa `chipLabel` ham anahtarı yazardı. */
  "filter.modified.around": "Bir tarihin çevresinde",
  "filter.size.range": "Özel aralık",
  "advsearch.open": "Gelişmiş arama",
  "advsearch.title": "Gelişmiş arama",
  "advsearch.subtitle": "Dosyaları ada, içeriğe, yola ya da etikete göre bulun.",
  "advsearch.close": "Kapat",
  "advsearch.content.heading": "İçerik araması",
  "advsearch.viewall": "Tüm sonuçları gör",
  "advsearch.where.any_short": "Her yerde",
  "advsearch.where.here_short": "Yalnız burada",
  "advsearch.where.skip_short": "Burayı atla",
  "advsearch.server.legend": "Sunucunun aradığı",
  "advsearch.client.legend": "Gelen sonuçları daralt",
  "advsearch.query.label": "Kelimeler",
  "advsearch.query.placeholder": "Adın bir parçası ya da dosyanın içindeki kelimeler",
  "advsearch.scope.label": "Nerede arasın",
  "advsearch.scope.name": "Ad ve yol",
  "advsearch.scope.content": "Dosya içeriği",
  "advsearch.scope.all": "İkisi de",
  "advsearch.scope.hint": "İçerik, dizinden aranır; dizin metin türü dosyaların ilk 200 KB’ını kapsar.",
  "advsearch.people.name_only": "Sahip, gelen satırlardan okunur; sahip bilgisi taşıyan satırları da yalnız ad araması döndürür.",
  "advsearch.scope.name_only": "Burada yalnız ad ve yol: içerik sonucu gezgine hangi depodan geldiği bilgisi olmadan ulaşır, bu yüzden içerik araması yalnız tek depolu kurulumlarda sunulur.",
  "advsearch.tags.label": "Etiketler",
  "advsearch.tags.placeholder": "fatura, üç aylık rapor",
  "advsearch.tags.exclude": "Şu etiketler hariç",
  "advsearch.tags.exclude_placeholder": "arşiv",
  "advsearch.tags.hint": "Virgülle ayırın. Etiket daraltır: birden çok etiket hepsini birden taşıyan dosyalar demektir, hiç kullanılmamış bir etiket ise hiçbir şey döndürmez. Bir ad, o adı taşıyan kişisel etiketinizi de ekibinizin etiketini de bulur.",
  "advsearch.where.label": "Klasör",
  "advsearch.where.any": "Bu deponun her yerinde",
  "advsearch.where.here": "Yalnız {folder} içinde",
  "advsearch.where.skip": "{folder} dışındaki her yerde",
  "advsearch.around.label": "Şu kadar içinde",
  "advsearch.around.date": "Tarih ve saat",
  "advsearch.around.h1": "1 saat",
  "advsearch.around.d1": "1 gün",
  "advsearch.around.w1": "1 hafta",
  "advsearch.size.range_label": "Şunun arasında",
  "advsearch.size.from": "En az",
  "advsearch.size.to": "En çok",
  "advsearch.count.idle": "Bir şeyler yazın ya da etiket seçin.",
  "advsearch.count.counting": "Sayılıyor…",
  "advsearch.count.result": "{n} eşleşen öğe",
  "advsearch.count.capped": "Sonuçların ilk sayfasında {n} eşleşen öğe",
  "advsearch.count.result_one": "{n} eşleşen öğe",
  "advsearch.count.capped_one": "Sonuçların ilk sayfasında {n} eşleşen öğe",
  "advsearch.count.error": "Sayım çalıştırılamadı.",
  "advsearch.count.cost": "Sayım bu aramayı çalıştırır. Tür, sahip, tarih, boyut ve klasör bulduğu sonuçları daraltır.",
  "advsearch.wire": "Bir dahaki sefere arama kutusuna şunu yazabilirsiniz:",
  "advsearch.reset": "Sıfırla",
  "advsearch.cancel": "Vazgeç",
  "advsearch.submit": "Ara",
  /* === gorunum:v2-topbar — sayfanın üst barı kalktı; onun taşıdıklarını
     artık gezginin kendi başlığı ve kırıntı satırı taşıyor. === */
  "breadcrumb.subfolders": "Alt klasörler",
  "breadcrumb.subfolders.empty": "Burada alt klasör yok",
  "header.admin": "Yönetim paneli",
  "header.settings": "Ayarlar",
  "header.signout": "Oturumu kapat",
  "ai.assistant": "AI asistanı",
  "ai.soon": "Yakında",
  "ai.assistant.soon": "AI asistanı — yakında",
  /* gorunum:v2-share — Paylaş / İzinler penceresinin kendi çerçevesi. İçindeki
     denetimler eski metinlerini koruyor; buradakiler yeni kabuk: başlık, tek
     anahtar, "şu anda kim açabilir" cümlesi ve her şeyin katlandığı üç adlı
     bölüm. */
  "access.title": '"{name}" paylaşımı',
  "access.close": "Kapat",
  "access.done": "Bitti",
  "access.copy": "Kopyala",
  "access.copied": "Kopyalandı",
  "access.link.switch": "Bağlantı paylaşımı",
  "access.who.private": "Yalnızca erişimi olan kişiler açabilir.",
  "access.who.link": "Bağlantıyı bilen herkes açabilir.",
  "access.who.pin": "Bağlantıyı ve PIN'i bilen herkes açabilir.",
  "access.who.existing": "Bağlantı paylaşımı açık — {n} bağlantı var.",
  "access.who.existing_one": "Bağlantı paylaşımı açık — {n} bağlantı var.",
  "access.section.link": "Bağlantı seçenekleri",
  "access.section.people": "Erişimi olanlar",
  "access.section.drop": "Dosya iste",
  "access.sum.pin_on": "PIN var",
  "access.sum.pin_off": "PIN yok",
  "access.sum.people": "{n} kişi",
  "access.sum.people_one": "{n} kişi",
  "access.sum.people_none": "Henüz kimse yok",
  "access.sum.drop": "{n} yükleme bağlantısı",
  "access.sum.drop_one": "{n} yükleme bağlantısı",
  "access.sum.drop_none": "Yükleme bağlantısı yok",
  /* Sahiplik — Sahibi sütunu ve Kişiler çipi. "Sistem", filex üzerinden kimsenin
     koymadığı satırın dürüst karşılığıdır (tarayıcı buldu ya da doğrudan kovaya
     yazıldı); boşluk değil, gerçek bir cevaptır. */
  "col.owner": "Sahibi",
  "owner.you": "Siz",
  "owner.system": "Sistem",
  "owner.unknown": "Bilinmiyor",
  "owner.external": "Yükleme bağlantısıyla geldi",
  "owner.last_actor": "Son değiştiren: {who}",
  "filter.people": "Sahibi",
  "filter.people.any": "Herkes",
  "filter.people.me": "Siz",
  "filter.people.system": "Sistem",
  "filter.people.someone": "Başka biri",
  /* surucu:d1-sort — filtre satırının sağ ucundaki sıralama denetimi. Dört
     ölçütün adı `col.*`: menü, liste görünümünün sütun başlıklarındaki
     sözcüklerin aynısını sunar — tek bir sıralamayı süren iki denetim onu
     farklı adlarla anamaz. */
  "sort.by": "Sıralama ölçütü",
  "sort.asc": "Artan",
  "sort.desc": "Azalan",
  /* Bir ARAMA SONUCUNUN sırası. Beşinci bir sıralama ölçütü değildir —
     ekrandaki satırları sunucu sıraladığında denetim, ölçüt adı yerine bunu
     yazar; böylece yapmadığı bir sıralamayı üstlenmez. `_why` denetimin neden
     kapalı olduğudur: Burak, denetimin sessizce işlevsizleşmesini değil
     nedeninin yazılmasını istedi. */
  "sort.relevance": "Alaka",
  "sort.relevance_why": "Arama sonuçları eşleşme yakınlığına göre listelenir. Seçtiğiniz sıralama, aramadan çıkınca geri gelir.",
  /* === tablo:t1 — tablonun kendi yapılandırması ==========================
     v0.43'ten beri bir klasörün görünüşüne dair her şey — görünüm, sıralama VE
     sütunlar — değiştirildiği klasöre aittir; kimsenin değiştirmediği klasör
     kişinin varsayılanıyla (ayarlarından), o yoksa kurulumunkiyle açılır.
     `folder_hint` bu kuralı tek cümlede, tam da ona şaşıracak kişinin
     okuyabileceği yerde söyler. */
  "col.location": "Konum",
  "col.deleted": "Silinme",
  "col.deleted_from": "Silindiği yer",
  "col.deleted_by": "Silen",
  "col.remaining": "Kalan süre",
  "cols.menu": "Sütun seçenekleri",
  "cols.title": "Sütunlar",
  "cols.resize": "{col} sütununu yeniden boyutlandır",
  "cols.move_left": "{col} sütununu sola taşı",
  "cols.move_right": "{col} sütununu sağa taşı",
  "cols.reset": "Sütunları sıfırla",
  "cols.folder_title": "Klasör görünümü",
  "cols.folder_hint": "Burada yaptığınız değişiklik bu klasörde kalır. Hiç değiştirmediğiniz klasörler varsayılan görünümünüzle açılır (Ayarlar → Varsayılan klasör görünümü).",
  "cols.forget_folder": "Bu klasörün görünümünü unut",
  "cols.apply_all": "Bunu tüm klasörler için varsayılanım yap ({count} klasör hatırlanıyor)",
  /* === tablo:t3 — TEK TABLO (components/DataTable.vue) ====================
     Üründeki her tablo bunları konuşur; Türkçe bir sayfada sütun menüsü ya da
     sayfalayıcı İngilizce kalmasın. */
  "table.empty": "Henüz burada bir şey yok",
  "table.prev": "Önceki sayfa",
  "table.next": "Sonraki sayfa",
  "table.sort_paged": "Bu liste sayfalara bölünmüş. Sıralama yalnızca ekrandaki sayfayı yeniden dizerdi, bu yüzden burada kapalı — listeyi arama ya da filtrelerle daraltın.",
  /* === tablo:t1 — çöp kutusu bilgi şeridi ================================
     ⚠ `retention` yalnızca kurulum bize sayıyı SÖYLEDİĞİNDE kullanılır
     (GET /api/admin/protection). Diğer her durumda `retention_unknown` aynı
     şeyi, doğrulayamadığımız bir süreyi taahhüt etmeden söyler: yanlış saklama
     süresi yazan bir şerit, hiç şerit olmamasından kötüdür — insanlar ona
     bakıp karar verir. */
  "trash.retention": "Çöp kutusundaki öğeler {days} gün sonra kalıcı olarak silinir.",
  "trash.retention_one": "Çöp kutusundaki öğeler {days} gün sonra kalıcı olarak silinir.",
  "trash.retention_unknown": "Çöp kutusundaki öğeler, yöneticinizin belirlediği saklama süresi dolunca kalıcı olarak silinir.",
  "trash.empty_action": "Çöp kutusunu boşalt",
  "trash.empty_confirm_title": "Çöp kutusu boşaltılsın mı?",
  "trash.empty_confirm_body_one": "Bu işlem {count} öğeyi ({size}) kalıcı olarak siler. Geri alınamaz.",
  "trash.empty_confirm_body": "Bu işlem {count} öğeyi ({size}) kalıcı olarak siler. Geri alınamaz.",
  "trash.empty_confirm_body_nosize_one": "Bu işlem {count} öğeyi kalıcı olarak siler. Geri alınamaz.",
  "trash.empty_confirm_body_nosize": "Bu işlem {count} öğeyi kalıcı olarak siler. Geri alınamaz.",
  "trash.emptied": "Çöp kutusu boşaltıldı",
  "trash.days_remaining": "{n} gün",
  "trash.days_remaining_one": "{n} gün",
  "trash.days_remaining_due": "Silinmek üzere",
  "trash.deleted_by_nobody": "Kayıt yok: filex dışında kaldırılmış ya da filex bunu tutmaya başlamadan önce silinmiş",
  "trash.emptying": "Çöp kutusu boşaltılıyor… {done} / {total}",
  "trash.empty_busy": "Çöp kutusu zaten boşaltılıyor.",
  "trash.emptied_partly": "Çöp kutusu boşaltıldı, ama {count} öğe silinemedi — sunucu günlüğüne bakın.",
  "trash.emptied_partly_one": "Çöp kutusu boşaltıldı, ama {count} öğe silinemedi — sunucu günlüğüne bakın.",
  "trash.empty_stopped": "Çöp kutusunu boşaltma durdu: {error}",
  "trash.emptying_queued": "Çöp kutusu boşaltılıyor… başka bir temizliğin bitmesi bekleniyor",
  "trash.empty_cancelled": "Çöp kutusunu boşaltma {count} öğeden sonra durduruldu; kalanlar hâlâ çöp kutusunda.",
  "trash.empty_cancelled_one": "Çöp kutusunu boşaltma {count} öğeden sonra durduruldu; kalanlar hâlâ çöp kutusunda.",
  "empty.trash.hint": "Sildiğiniz dosyalar önce buraya düşer, böylece geri alabilirsiniz.",
  /* tasi:m1 — hedef klasör seçici (modals/DestinationPickerModal.vue) ve
     üzerine kurulan iki seçim eylemi. */
  "destpicker.title.move": "Şuraya taşı",
  "destpicker.title.copy": "Şuraya kopyala",
  "destpicker.title.choose": "Klasör seç",
  "destpicker.confirm.move": "Buraya taşı",
  "destpicker.confirm.copy": "Buraya kopyala",
  "destpicker.confirm.choose": "Bu klasörü seç",
  "destpicker.title.choose_file": "Dosya seç",
  "destpicker.confirm.choose_file": "Bu dosyayı seç",
  "destpicker.pick_a_file": "Listeden bir dosya seçin.",
  "destpicker.empty_files": "Bu klasör boş",
  "destpicker.cancel": "Vazgeç",
  "destpicker.up": "Bir üst klasör",
  "destpicker.crumbs": "Konum",
  "destpicker.drives": "Depolar",
  "destpicker.loading": "Yükleniyor…",
  "destpicker.empty": "Burada alt klasör yok",
  "destpicker.unreadable": "Bu klasör açılamıyor.",
  "destpicker.readonly": "Salt okunur",
  "destpicker.readonly_here": "Bu klasöre yazamazsınız.",
  "destpicker.pick_a_drive": "Bir klasör seçmek için önce bir depo açın.",
  "destpicker.target": "Hedef: {name}",
  "destpicker.tag.blocked": "Uygun değil",
  "destpicker.blocked.self": "Bir klasör kendi içine taşınamaz.",
  "destpicker.blocked.descendant": "Bir klasör kendi alt klasörlerinden birine taşınamaz.",
  "ctx.move_to": "Şuraya taşı…",
  "ctx.copy_to": "Şuraya kopyala…",
  "ctx.access.one_only": "Paylaşım aynı anda tek öğe için çalışır.",
  "toast.archive.preparing": "Arşiv hazırlanıyor…",
  "toast.archive.started": "{name} indiriliyor ({count} dosya)",
  "toast.archive.started_one": "{name} indiriliyor ({count} dosya)",
  "toast.archive.empty": "İndirilecek bir şey yok — seçimde okunabilir dosya bulunmuyor.",
  "toast.moved_to": "{name} klasörüne taşıma kuyruğa alındı",
  "toast.copied_to": "{name} klasörüne kopyalama kuyruğa alındı",
  "toast.already_there": "Seçilen öğeler zaten {name} içinde — hiçbir şey gönderilmedi",
  /* ── dil:paket — bkz. en.ts */
  "ctx.tags_menu": "Etiketler…",
  "toast.node_id_copied": "Node id {id} kopyalandı",
  "toast.read_only_here": "Burada yazma yetkiniz yok",
  "recents.title": "Son açılanlar",
  "recents.refresh": "Yenile",
  "recents.empty": "Henüz bir şey yok.",
  "recents.loading": "Yükleniyor…",
  "recents.close": "Kapat",
  "tags.title": "Etiketler",
  "tags.close": "Kapat",
  "share.ttl.never": "Bu bağlantının süresi yoktur.",
  "share.ttl.until": "Bu bağlantı {when} tarihine kadar geçerli.",
  "share.ttl.ceiling": "Bağlantılar en fazla {days} gün geçerli olabilir (sunucu ayarı).",
  "share.ttl.ceiling_one": "Bağlantılar en fazla {days} gün geçerli olabilir (sunucu ayarı).",
  /* ── dil:paket — paylaşım / erişim penceresi (bkz. en.ts) */
  "access.ui.level_viewer": "Görüntüleyen",
  "access.ui.level_viewer_desc": "görüntüle + indir",
  "access.ui.level_editor": "Düzenleyen",
  "access.ui.level_editor_desc": "oku + yaz + sil",
  "access.ui.level_owner": "Sahip",
  "access.ui.level_owner_desc": "düzenle + izin yönet",
  "access.ui.never": "Süresiz",
  "access.ui.days": "{days} gün",
  "access.ui.days_one": "{days} gün",
  "access.ui.unlimited": "Sınırsız",
  "access.ui.downloads": "{count} indirme",
  "access.ui.downloads_one": "{count} indirme",
  "access.ui.mail_sent": "E-posta gönderildi ✓ ({sent})",
  "access.ui.mail_partial": "{sent} gönderildi, {failed} başarısız",
  "access.ui.valid_for": "Bu bağlantı {days} gün geçerlidir.",
  "access.ui.valid_for_one": "Bu bağlantı {days} gün geçerlidir.",
  "access.ui.mail_title_file": "{name} dosyası sizinle paylaşıldı",
  "access.ui.mail_title_folder": "{name} klasörü sizinle paylaşıldı",
  "access.ui.mail_hello": "Merhaba,",
  "access.ui.mail_shared_file": "Sizinle bir dosya paylaşıldı:",
  "access.ui.mail_shared_folder": "Sizinle bir klasör paylaşıldı:",
  "access.ui.mail_folder": "Klasör: {name}",
  "access.ui.mail_file": "Dosya: {name}",
  "access.ui.mail_size": "Boyut: {size}",
  "access.ui.mail_download_here": "İndirmek için:",
  "access.ui.mail_pin": "PIN: {pin}",
  "access.ui.drop_title": "{folder} adlı klasöre dosya eklemeniz istendi",
  "access.ui.drop_invited": "Dosya yüklemeniz istendi.",
  "access.ui.drop_limit": "Sınır: en fazla {files} dosya, dosya başına {mb} MB.",
  "access.ui.drop_types": "İzinli türler: {types}",
  "access.ui.drop_types_all": "İzinli türler: tüm türler",
  "access.ui.drop_upload_here": "Dosyalarınızı buradan yükleyebilirsiniz:",
  "access.ui.inherited_from": "Üst klasörden gelir",
  "access.ui.access_granted": "Yetki verildi.",
  "access.ui.enter_a_valid_email": "Geçerli bir e-posta girin.",
  "access.ui.user_created_invite_emailed": "Kullanıcı açıldı, davet e-postası gönderildi.",
  "access.ui.user_created_share_the_temp_password": "Kullanıcı açıldı. Geçici parolayı iletin.",
  "access.ui.smtp_not_set_up_verified_share_the_link": "SMTP ayarlı/doğrulanmış değil — bağlantıyı elle iletin.",
  "access.ui.send_failed_temporary_please_retry": "Gönderilemedi (geçici hata) — tekrar deneyin.",
  "access.ui.server_limit_applied": "(sunucu sınırı uygulandı)",
  "access.ui.protect_with_a_pin": "PIN ile koru",
  "access.ui.expiry": "Süre",
  "access.ui.download_limit": "İndirme limiti",
  "access.ui.create_link": "Bağlantı oluştur",
  "access.ui.replace_link": "Bağlantıyı bu ayarlarla yenile",
  "access.ui.replace_link_hint": "Adres değişir: şu anki bağlantı çalışmayı bırakır.",
  "access.ui.create_then_send": "Bir bağlantı oluşturun, ardından {email} adresine gönderin.",
  "access.ui.command_line": "Komut satırı",
  "access.ui.share": "Paylaş",
  "access.ui.existing_links": "Mevcut bağlantılar",
  "access.ui.rbac_off_here": "Bu depoda öğe bazlı erişim denetimi kapalı — herkes depoyu rolüne göre açar, burada eklenen kişiler bir şey değiştirmez. Yönetim panelinde Depolar altından (bu depo → Öğe bazlı erişim denetimi) açın.",
  "access.ui.other_links": "Diğer bağlantılar",
  "access.ui.revoke": "İptal",
  "access.ui.loading": "Yükleniyor…",
  "access.ui.name_or_email": "Ad ya da e-posta",
  "access.ui.add": "Ekle",
  "access.ui.no_account_for_this_email_what_next": "Bu e-postada hesap yok. Ne yapmak istersiniz?",
  "access.ui.user": "Kullanıcı",
  "access.ui.viewer": "Görüntüleyen",
  "access.ui.create_user_grant": "Kullanıcı oluştur + yetki ver",
  "access.ui.just_send_a_share_link": "Yalnızca paylaşım bağlantısı gönder →",
  "access.ui.temp_password": "Geçici parola:",
  "access.ui.people_with_access": "Erişimi olanlar",
  "access.ui.not_shared_with_anyone_yet": "Henüz kimseyle paylaşılmadı.",
  "access.ui.remove": "Kaldır",
  "access.ui.a_public_link_that_lets_anyone_upload_fi": "Bu klasöre herkesin dosya YÜKLEYEBİLECEĞİ herkese açık bir bağlantı. Yükleyenler klasördeki mevcut dosyaları göremez.",
  "access.ui.hide_upload_limits": "Yükleme sınırlarını gizle",
  "access.ui.upload_limits": "Yükleme sınırları",
  "access.ui.max_files": "En fazla dosya",
  "access.ui.mb_file": "Dosya başı MB",
  "access.ui.allowed_types": "İzinli türler",
  "access.ui.all_e_g_pdf_jpg": "hepsi (örn. pdf, jpg)",
  "access.ui.ask_uploader_name": "Yükleyenin adını sor",
  "access.ui.emails_comma_separated": "e-posta(lar) — virgülle ayırın",
  "access.ui.send": "Gönder",
  "access.ui.mail_not_set_up": "E-posta kurulu değil — yönetim panelinde Ayarlar altından (E-posta / SMTP) kurun.",
  /* ── wiring:e2 fxe — tek şifreli dosyalar (.fxe), akışlı indirmeler ── */
  "e2e.fxe.type": "Şifreli dosya",
  "e2e.fxe.ctx_encrypt": "E2EE ile şifrele…",
  "e2e.fxe.ctx_download_raw": "Şifreli dosyayı indir",
  "e2e.fxe.ctx_password": "Parolayı değiştir…",
  "e2e.fxe.ctx_remove": "Şifrelemeyi kaldır…",
  "e2e.fxe.encrypt_title": "Bu dosyayı şifrele",
  "e2e.fxe.encrypt_lead": "“{name}” bu tarayıcıda, kendine ait bir parolayla şifrelenir. Sunucu yalnızca şifreli veriyi saklar. Dosyayı parola ya da kurtarma anahtarı açar — burada ya da çevrimdışı olarak filex decrypt ile.",
  "e2e.fxe.pw_label": "Dosya parolası",
  "e2e.fxe.hide_label": "Dosya adını da gizle",
  "e2e.fxe.hide_on_hint": "“{stored}” olarak saklanır: sunucu ne adı ne de türü görür. Gerçek ad dosyanın içinde mühürlüdür; dosyayı burada açınca görünür.",
  "e2e.fxe.hide_off_hint": "“{stored}” olarak saklanır: ad sunucu tarafından okunabilir kalır, içerik kalmaz.",
  "e2e.fxe.seen_title": "Sunucunun zaten gördükleri",
  "e2e.fxe.seen_lead": "Bu dosya şimdiye kadar şifresiz saklandı ve şifrelemek bunu geri almaz:",
  "e2e.fxe.seen_trash": "Asıl dosya çöp kutusuna gider ve çöp kutusunun saklama süresi dolana ya da bir yönetici boşaltana kadar orada kalır. Kalıcı olarak kendiniz silemezsiniz.",
  "e2e.fxe.seen_versions": "Önceki sürümleri sürüm geçmişinde kalır; onları yalnızca bir yönetici silebilir.",
  "e2e.fxe.seen_thumb": "Ondan üretilmiş bir küçük resim, asıl dosya kalıcı olarak silinene kadar sunucuda kalır. Arama dizinindeki kaydı, dosya çöp kutusuna gidince kaldırılır.",
  "e2e.fxe.seen_backups": "Bundan önce alınmış yedekler, kopyalar ve indirmeler onu hâlâ içerir.",
  "e2e.fxe.warn_body": "Bu dosya yalnızca bu parolayla ya da şifrelemeden sonra bir kez gösterilen kurtarma anahtarıyla açılır. filex ikisini de saklamaz. İkisini de kaybederseniz içerik kalıcı olarak kaybolur.",
  "e2e.fxe.escrow_body": "Bu kurulumda anahtar emaneti açık: işletmecisi, bu dosyayı parolanız olmadan açan bir anahtara sahip.",
  "e2e.fxe.encrypt_submit": "Şifrele",
  "e2e.fxe.encrypt_busy": "Şifreleniyor ve yükleniyor… %{percent}",
  "e2e.fxe.size_unknown": "Bu dosyanın boyutu henüz bilinmiyor. Klasörü yenileyip tekrar deneyin.",
  "e2e.fxe.bad_name": "Bu ad şifreli bir dosyanın içine mühürlenemez (255 baytı aşıyor ya da eğik çizgi veya denetim karakteri içeriyor). Önce dosyayı yeniden adlandırın.",
  "e2e.fxe.name_too_long": "Ad, sonuna “.fxe” eklenemeyecek kadar uzun. “Dosya adını da gizle” kutusunu işaretleyin ya da önce dosyayı yeniden adlandırın.",
  "e2e.fxe.encrypted": "“{name}” şifrelendi. Asıl dosya çöp kutusunda.",
  "e2e.fxe.original_kept": "Şifreli kopya kaydedildi, ancak “{name}” çöp kutusuna taşınamadı. Asıl dosyayı kendiniz silin.",
  "e2e.fxe.upload_too_big": "Bu sunucuda parçalı yükleme yok ve dosya bu tarayıcıdan tek parça gönderilemeyecek kadar büyük.",
  "e2e.fxe.unlock_title_open": "Şifreli dosyayı aç",
  "e2e.fxe.unlock_title_download": "Çözerek indir",
  "e2e.fxe.unlock_title_remove": "Şifrelemeyi kaldır",
  "e2e.fxe.unlock_lead": "“{name}” şifreli. Parolası burada, bu tarayıcıda denetlenir ve asla sunucuya gönderilmez.",
  "e2e.fxe.known_note": "Bu sekmede zaten açıldı — parola gerekmiyor.",
  "e2e.fxe.use_password": "Onun yerine parolayı kullan",
  "e2e.fxe.remove_warn_title": "Şifresiz içerik sunucuya geri döner",
  "e2e.fxe.remove_warn_body": "Dosya burada çözülür ve özgün adıyla şifresiz bir dosya olarak yüklenir: sunucu, yöneticileri, küçük resimler, arama ve yedekler onu yeniden okuyabilir. Şifreli dosya çöp kutusuna gider.",
  "e2e.fxe.unlock_open": "Aç",
  "e2e.fxe.unlock_download": "İndir",
  "e2e.fxe.unlock_remove": "Şifrelemeyi kaldır",
  "e2e.fxe.unlock_busy": "İşleniyor…",
  "e2e.fxe.save_again": "Kilit açıldı. Tarayıcınız, dosyanın nereye kaydedileceğini sormadan önce bir tıklama daha istiyor.",
  "e2e.fxe.save_button": "Kaydet…",
  "e2e.fxe.progress": "%{percent} tamamlandı",
  "e2e.fxe.wrong_password": "Parola yanlış.",
  "e2e.fxe.wrong_recovery": "Bu kurtarma anahtarı bu dosyayı açmıyor.",
  "e2e.fxe.damaged": "Bu dosya bozuk ya da kurcalanmış (veya açıldığından beri değişmiş). Hiçbir şey kaydedilmedi.",
  "e2e.fxe.not_readable": "Bu bir filex şifreli dosyası değil ya da başlığı bozuk.",
  "e2e.fxe.unsupported": "Bu dosya daha yeni bir filex gerektiriyor (gereken: {features}).",
  "e2e.fxe.downloaded": "“{name}” kaydedildi.",
  "e2e.fxe.removed": "Şifreleme kaldırıldı: “{name}” yeniden şifresiz bir dosya. Şifreli dosya çöp kutusunda.",
  "e2e.fxe.password_title": "Dosya parolasını değiştir",
  "e2e.fxe.password_cost": "Yalnızca dosyanın başlığı değişir: içerik bayt bayt aynen geri gönderilir ve kurtarma anahtarı çalışmaya devam eder.",
  "e2e.fxe.password_old_copies": "Bu dosyanın önceki bir sürümü — sürüm geçmişi, bir yedek, birinin indirdiği bir kopya — ESKİ parolayla açılmaya devam eder.",
  "e2e.fxe.password_done": "Parola değişti. Eski parola bu dosyayı artık açmıyor.",
  "e2e.recovery.warn_body_file": "Bu anahtara sahip olan herkes dosyayı okuyabilir. Onu paroladan ayrı bir yerde saklayın — parolanın yanında duran bir anahtar sizi unutmaktan korur, başkalarından değil.",
  "e2e.recovery.lead_file": "Bu anahtar dosyayı parolası olmadan açar. Yalnızca bir kez gösterilir — filex onu saklamaz ve bir daha gösteremez.",
  "e2e.dl.ctx_encrypted_copy": "Şifreli kopyayı indir",
  "e2e.dl.too_big": "Bu tarayıcı tek seferde en çok {limit} çözülmüş veri kaydedebilir, bu ise {size}. Chrome ya da Edge (doğrudan diske kaydeder), filex masaüstü uygulamasını kullanın ya da şifreli dosyayı indirip filex decrypt çalıştırın.",
  "e2e.dl.click_again": "Nereye kaydedileceğini seçmek için İndir’e bir kez daha tıklayın.",
  "e2e.dl.zip_started": "“{name}” içine çözülerek yazılıyor…",
  "e2e.dl.zip_done": "“{name}” kaydedildi — çözülmüş, gerçek adlarla.",
  "e2e.dl.zip_done_plain": "“{name}” kaydedildi. İçindeki {n} dosya hiç şifrelenmemişti ve olduğu gibi eklendi.",
  "e2e.dl.zip_done_plain_one": "“{name}” kaydedildi. İçindeki {n} dosya hiç şifrelenmemişti ve olduğu gibi eklendi.",
  "e2e.dl.zip_damaged": "Klasördeki bir dosya bozuk ya da kurcalanmış. İndirme durduruldu ve hiçbir şey kaydedilmedi.",
  "e2e.upload.streaming_unsupported": "Bu dosya 200 MB’tan büyük ve bu sunucuda onu parça parça şifreli göndermek için parçalı yükleme yok.",
  /* wiring:e2 fxe escrow — emanet anahtarı tek bir dosyayı açar, sahibine haber gider */
  "e2e.fxe.use_escrow": "Emanet anahtarını kullan",
  "e2e.fxe.escrow_warn_title": "Dosyanın sahibine haber gidecek",
  "e2e.fxe.escrow_warn_body": "Emanet anahtarıyla açılan dosyanın sahibine, dosya açılmadan önce bildirim gönderilir. Yalnız yetkiniz olduğunda kullanın.",
  "e2e.fxe.escrow_predates": "Bu kurulumun emanet anahtarı var, ama bu dosya onsuz şifrelenmiş (emanet burada açılmadan önce), bu yüzden emanet anahtarı onu açmaz. Parolayı ya da kurtarma anahtarını kullanın.",
  "e2e.fxe.escrow_other_key": "Bu dosya BAŞKA bir kurulumun emanet anahtarına mühürlenmiş, bu yüzden bu kurulumun emanet anahtarı onu açmaz.",
  "e2e.fxe.wrong_escrow": "Bu emanet anahtarı bu dosyayı açmıyor.",
  "e2e.fxe.escrow_notify_failed": "Dosyanın sahibine bildirim gönderilemedi, bu yüzden dosya açılmadı. Emanet anahtarının kullanımı her zaman duyurulur.",
  "e2e.fxe.escrow_done": "Emanet anahtarıyla açıldı — dosya sahibine bildirildi",
  /* wiring:e2 fxe purge — yönetici aslını kalıcı olarak siler */
  "e2e.fxe.seen_trash_admin": "Asıl dosya çöp kutusuna gider ve çöp kutusunun saklama süresi dolana kadar orada kalır — aşağıda kalıcı olarak silmediğiniz sürece.",
  "e2e.fxe.seen_versions_admin": "Önceki sürümleri sürüm geçmişinde kalır — aşağıda kalıcı olarak silmediğiniz sürece.",
  "e2e.fxe.purge_label": "Aslını kalıcı olarak sil (yönetici)",
  "e2e.fxe.purge_hint": "Şifreli kopya kaydedilir kaydedilmez önceki sürümleri ve çöp kutusundaki kaydı silinir; açık hâlinden bu sunucuda hiçbir şey kalmaz. Geri alınamaz. Daha önce alınmış yedeklere ve kopyalara ulaşılmaz.",
  "e2e.fxe.purge_others": "Bu dosya sizin değil, {owner} adlı kullanıcının. Onun aslını ve sürümlerini kalıcı olarak sil.",
  "e2e.fxe.purge_others_unknown": "Bu dosyanın kayıtlı bir sahibi yok — sizin değil. Aslını ve sürümlerini kalıcı olarak sil.",
  "e2e.fxe.purge_others_required": "Başkasının dosyasını kalıcı olarak sildiğinizi onaylayın.",
  "e2e.fxe.purge_no_id": "Bu dosya henüz katalogda değil, bu yüzden kalıcı olarak silinemez. Klasörü yenileyip tekrar deneyin.",
  "e2e.fxe.purged": "“{name}” şifrelendi. Aslı, sürümleri ve çöp kutusundaki kaydı kalıcı olarak silindi.",
  "e2e.fxe.purge_failed": "“{name}” dosyasının şifreli kopyası kaydedildi, ama aslı kalıcı olarak silinemedi ({reason}). Çöp kutusundan ve sürüm geçmişinden silin.",
  /* wiring:e2 fxe big — bu tarayıcının belleğine sığmayan çözülmüş indirme */
  "e2e.big.title": "Bu tarayıcıda çözülemeyecek kadar büyük",
  "e2e.big.lead": "“{name}” çözüldüğünde {size}. Bu tarayıcı indirmeyi belleğinde çözer ve en çok {limit} tutabilir, bu yüzden hiçbir şey indirilmedi.",
  "e2e.big.lead_grew": "“{name}” çözülürken {limit} sınırını aştı. Bu tarayıcı indirmeyi belleğinde çözer ve daha fazlasını tutamaz, bu yüzden hiçbir şey kaydedilmedi.",
  "e2e.big.instead": "Bunun yerine kendi bilgisayarınızda çözün:",
  "e2e.big.step_file": "Şifreli dosyayı olduğu gibi indirin (aşağıdaki düğme).",
  "e2e.big.step_folder": "Şifreli klasörü zip olarak indirin (aşağıdaki düğme) — klasörün anahtar dosyası da içindedir.",
  "e2e.big.step_run": "Kaydettiğiniz klasörde filex decrypt komutunu çalıştırıp parolayı girin:",
  "e2e.big.copy": "Kopyala",
  "e2e.big.copied": "Kopyalandı",
  "e2e.big.other_ways": "Chrome, Edge ve filex masaüstü uygulaması, boyutu ne olursa olsun doğrudan diske çözer.",
  "e2e.big.close": "Kapat",
  "e2e.big.download_file": "Şifreli dosyayı indir",
  "e2e.big.download_folder": "Şifreli klasörü indir (zip)",
  /* /wiring:e2 fxe */
  /* ── dil:paket — İngilizce sabit yazılmış erişilebilir adlar */
  "breadcrumb.aria": "Konum yolu",
  "e2e.recovery_key_aria": "Kurtarma anahtarı",
  "modal.close": "Kapat",
  "modal.busy_close.keep": "Devam etsin",
  "modal.busy_close.confirm": "Durdur ve kapat",
  /* ── zil ve hesap menüsü (2026-09-27: masaüstü uygulamasının gezgini de
     aynılarını çizsin diye yönetim uygulamasından buraya taşındı). ⚠ ORTAK
     anahtarlar: yönetim uygulamasının kataloğunda her biri aynı adla, aynı
     İngilizce ve Türkçeyle durur (web/tests/i18n/langPackCatalogue.test.ts),
     bir dil paketi her birini iki ekran için bir kez çevirir. */
  "notifications.bell": "Bildirim çanı",
  "notifications.unreadCount": "{n} okunmamış",
  "notifications.title": "Bildirimler",
  "notifications.markAllRead": "Tümünü okundu işaretle",
  "notifications.markRead": "Okundu işaretle",
  "notifications.empty": "Henüz bildirim yok",
  "notifications.viewAll": "Tüm bildirimleri gör",
  "notifications.manageAdmin": "Bildirim yönetimi",
  "notifications.openTarget": "Bildirimin konusunu aç",
  "notifications.unreadOnly": "Sadece okunmamış",
  "notifications.pageOf": "Sayfa {page} / {pages} · toplam {total}",
  "notifications.severity.info": "Bilgi",
  "notifications.severity.warning": "Uyarı",
  "notifications.severity.error": "Hata",
  "notifications.severity.critical": "Kritik",
  "common.prev": "Önceki",
  "common.next": "İleri",
  "explore.account": "Hesap",
  /* ── kullanıcı ayarları penceresi (2026-09-27: masaüstü uygulaması aynı
     pencereyi kendi içinde açsın diye yönetim uygulamasından buraya taşındı).
     ⚠ ORTAK anahtarlar; ardından gelenler bu tablonun kendisinin (yönetim
     kataloğu onları yalnız vue-i18n'in anladığı sözdizimiyle yazar). */
  "account.errors.emailRequired": "Bir e-posta adresi yazın.",
  "account.errors.usernameChar": "Kullanıcı adında “{char}” kullanılamaz. a–z, 0–9, nokta, tire ya da alt çizgi kullanın.",
  "account.errors.usernameDigit": "Kullanıcı adı rakamla başlayamaz.",
  "account.errors.usernameEmpty": "Bir kullanıcı adı yazın.",
  "account.errors.usernameLong": "Kullanıcı adı en çok {max} karakter olabilir.",
  "account.errors.usernameReserved": "“{name}” ayrılmış bir ad; başka bir kullanıcı adı seçin.",
  "account.errors.usernameShort": "Kullanıcı adı en az {min} karakter olmalı.",
  "account.errors.usernameSpace": "Kullanıcı adında boşluk olamaz. a–z, 0–9, nokta, tire ya da alt çizgi kullanın.",
  "common.cancel": "İptal",
  "common.close": "Kapat",
  "common.confirm": "Onayla",
  "common.currentPassword": "Mevcut parola",
  "common.email": "E-posta",
  "common.loading": "Yükleniyor…",
  "common.newPassword": "Yeni parola",
  "common.remove": "Kaldır",
  "common.save": "Kaydet",
  "common.saving": "Kaydediliyor…",
  "errors.generic": "Bir şeyler ters gitti",
  "errors.validationFailed": "Lütfen işaretli alanları kontrol edin",
  "install.desktopAllDownloads": "Tüm indirmeler ve sürüm notları",
  "install.desktopSubtitle": "Klasörleri bu bilgisayara eşitleyin, arka planda güncel kalsınlar. {platform} için mevcut.",
  "nav.themeAuto": "Otomatik",
  "nav.themeDark": "Karanlık",
  "nav.themeLight": "Aydınlık",
  "notifications.prefs.browser": "Tarayıcı bildirimleri",
  "notifications.prefs.browserHint": "Yeni bir şey geldiğinde sekmenin dışında bildirim göster. Bildirime tıklayınca konusu olan dosya, klasör ya da paylaşım açılır.",
  "notifications.prefs.desktopHandled": "Masaüstü uygulaması bunları kendisi gösteriyor",
  "notifications.prefs.enableBrowser": "Bildirimlere izin ver",
  "notifications.prefs.inApp": "Uygulama içi çan",
  "notifications.prefs.inAppHint": "Kapatırsanız çanınız boşalır. Hiçbir kayıt silinmez — yönetici tüm olayları görmeye devam eder.",
  "notifications.prefs.movedToSettings": "Kendi bildirim ayarlarınız — zil, tarayıcı bildirimleri, hangi olaylar — kullanıcı ayarlarınızda.",
  "notifications.prefs.openSettings": "Bildirim ayarlarımı aç",
  "notifications.prefs.permDefault": "İzin henüz istenmedi",
  "notifications.prefs.permDenied": "Bu tarayıcıda engellendi",
  "notifications.prefs.permDeniedHint": "Tarayıcı ayarlarından bu siteye bildirim iznini yeniden verin.",
  "notifications.prefs.permGranted": "Bu tarayıcıda izin verildi",
  "notifications.prefs.permUnsupported": "Bu tarayıcı bildirim gösteremiyor",
  "notifications.prefs.saved": "Tercih kaydedildi",
  "notifications.prefs.title": "Bildirimleriniz",
  "profile.avatar.change": "Fotoğrafı değiştir",
  "profile.avatar.failed": "Bu görsel işlenemedi — başka bir tane deneyin.",
  "profile.avatar.help": "Adınızın yanında ve dosya yöneticisinin işbirliği çubuğunda görünür — hesabınızla açılan her istemcide. Otomatik olarak 160 piksele küçültülür.",
  "profile.avatar.label": "Profil fotoğrafı",
  "profile.avatar.notImage": "Lütfen bir görsel dosyası seçin.",
  "profile.locale": "Dil",
  "profile.passwordChanged": "Parola değiştirildi",
  "profile.saved": "Profil kaydedildi",
  "profile.totp.code": "Doğrulama kodu",
  "profile.totp.disable": "2FA'yı kapat",
  "profile.totp.disabled": "Pasif",
  "profile.totp.enable": "2FA'yı aç",
  "profile.totp.enabled": "Aktif",
  "profile.totp.recoveryHint": "Bunları şimdi kaydedin — doğrulayıcınızı kaybederseniz her biri bir kez oturum açmanızı sağlar. Yalnızca bu sefer gösterilir.",
  "profile.totp.recoveryTitle": "Kurtarma kodları",
  "profile.totp.scanHint": "Bu QR kodu doğrulayıcı uygulamanızla tarayın, sonra 6 haneli kodu girin.",
  "profile.totp.title": "İki adımlı doğrulama",
  "profile.username.label": "Kullanıcı adı",
  "quota.title": "Depolama kotası",
  "quota.tooltip": "{used} / {limit} kullanıldı ({percent})",
  "quota.unlimitedTooltip": "{used} kullanıldı · sınırsız",
  "userSettings.adminBadge": "Yönetici",
  "userSettings.ai.body": "Bu sürümde kullanıcıya özel asistan ayarı yok. filex'in sunduğu AI özellikleri tüm kurulum için yönetici tarafından yapılandırılır; bu yüzden burada sizin açıp kapatacağınız bir şey henüz bulunmuyor.",
  "userSettings.ai.soon": "Yakında",
  "userSettings.demoReadOnly": "Bu ortak bir demo hesabı; profili, parolası ve ikinci faktörü değiştirilemez.",
  "userSettings.footNote.ai": "Bu sekmede kaydedilecek bir şey yok.",
  "userSettings.footNote.notifications": "Değiştirdiğiniz anda kaydedilir.",
  "userSettings.footNote.preferences": "Değiştirdiğiniz anda kaydedilir.",
  "userSettings.footNote.profile": "Bu sekmedeki değişiklikler Kaydet'e bastığınızda kaydedilir.",
  "userSettings.footNote.security": "Buradaki her işlem kendi başına uygulanır.",
  "userSettings.heading": "Kullanıcı ayarları",
  "userSettings.headingSub": "Profilinizi, tercihlerinizi ve güvenliğinizi yönetin.",
  "userSettings.notifications.events.archive_created": "Bir arşiv oluşturulduğunda",
  "userSettings.notifications.events.archive_extracted": "Bir arşiv çıkarıldığında",
  "userSettings.notifications.events.comment_added": "Biri bir dosyaya yorum yaptığında",
  "userSettings.notifications.events.drop_received": "İstek bağlantısıyla bir dosya geldiğinde",
  "userSettings.notifications.events.e2e_escrow_used": "Şifreli bir klasör emanet anahtarıyla açıldığında",
  "userSettings.notifications.events.file_deleted": "Bir dosya kalıcı olarak silindiğinde",
  "userSettings.notifications.events.file_infected": "Bir dosyada virüs bulunduğunda",
  "userSettings.notifications.events.file_moved": "Bir dosya taşındığında ya da adı değiştiğinde",
  "userSettings.notifications.events.file_trashed": "Bir dosya çöp kutusuna taşındığında",
  "userSettings.notifications.events.file_updated": "Bir dosya değiştiğinde",
  "userSettings.notifications.events.file_upload_failed": "Bir yükleme tamamlanmadığında",
  "userSettings.notifications.events.file_uploaded": "Yeni bir dosya geldiğinde",
  "userSettings.notifications.events.plugin_notice": "Kurulu bir uygulama size mesaj gönderdiğinde",
  "userSettings.notifications.events.share_created": "Biri paylaşım bağlantısı oluşturduğunda",
  "userSettings.notifications.eventsHint": "Birini kapatmak onu zilinizin dışında tutar. Hiçbir şey kaydedilmekten çıkmaz — yönetici her olayı görmeye devam eder.",
  "userSettings.notifications.eventsTitle": "Nelerden haberdar olayım",
  "userSettings.open": "Kullanıcı ayarları",
  "userSettings.prefs.appearance": "Görünüm",
  "userSettings.prefs.compact": "Sıkışık dosya listesi kullan",
  "userSettings.prefs.compactHint": "Dosya gezgininde daha dar satırlar.",
  "userSettings.prefs.desktopApp": "Masaüstü uygulaması",
  "userSettings.prefs.desktopAppHint": "Uygulamanın köşesindeki hatırlatmayı kapattığınızda bir daha çıkmaz — indirmeler burada kalır.",
  "userSettings.prefs.folderView": "Varsayılan klasör görünümü",
  "userSettings.prefs.folderViewHint": "Hiç değiştirmediğiniz bir klasörün nasıl açılacağı. Değiştirdiğiniz klasörler kendi görünümünü korur — bu ayar onlara dokunmaz.",
  "userSettings.prefs.fvColumns": "Varsayılan sütunlarınız özelleştirilmiş (“Bunu tüm klasörler için varsayılanım yap” ile ayarlandı).",
  "userSettings.prefs.fvColumnsReset": "Sıfırla",
  "userSettings.prefs.fvDir": "Yön",
  "userSettings.prefs.fvDir_asc": "Artan",
  "userSettings.prefs.fvDir_desc": "Azalan",
  "userSettings.prefs.fvForget": "Hepsini unut",
  "userSettings.prefs.fvInherit": "Sunucu varsayılanı ({value})",
  "userSettings.prefs.fvMode": "Görünüm",
  "userSettings.prefs.fvSort": "Sıralama",
  "userSettings.prefs.fvSort_modified": "Değiştirilme",
  "userSettings.prefs.fvSort_name": "Ad",
  "userSettings.prefs.fvSort_size": "Boyut",
  "userSettings.prefs.fvSort_type": "Tür",
  "userSettings.prefs.fvView_gallery": "Galeri",
  "userSettings.prefs.fvView_grid": "Izgara",
  "userSettings.prefs.fvView_list": "Liste",
  "userSettings.prefs.languageHint": "Burada hemen uygulanır; bir sonraki tarayıcıda da açılsın diye hesabınıza kaydedilir.",
  "userSettings.prefs.mode": "Aydınlık ya da karanlık",
  "userSettings.prefs.modeHint": "Hangi sürümün çizileceği. Otomatik, işletim sisteminizi izler.",
  "userSettings.prefs.openTrigger": "Dosyaları açma",
  "userSettings.prefs.openTriggerDouble": "Çift tık",
  "userSettings.prefs.openTriggerHint": "Farenin dosyayı nasıl açtığı. Dokunmatik ekranda tek dokunuş her zaman açar, kutucuk her zaman seçer.",
  "userSettings.prefs.openTriggerSingle": "Tek tık",
  "userSettings.prefs.palette": "Renk paleti",
  "userSettings.prefs.paletteHint": "O sürümün hangi renklerden oluştuğu. Her paletin aydınlık ve karanlık bir sürümü vardır; bu ayarla üstteki ayar birlikte çalışır.",
  "userSettings.prefs.startPage": "Açılış sayfası",
  "userSettings.prefs.startPageHint": "Oturum açtığınızda ya da ana adrese geldiğinizde filex burayı açar. Doğrudan bir sayfanın bağlantısına tıkladığınızda yine o sayfaya gidersiniz.",
  "userSettings.prefs.startPage_admin": "Yönetim paneli",
  "userSettings.prefs.startPage_files": "Dosyalar",
  "userSettings.prefs.startPage_home": "Ana sayfa",
  "userSettings.prefs.timezone": "Saat dilimi",
  "userSettings.prefs.timezoneHint": "Tarihler bir an olarak saklanır ve burada seçtiğiniz saatle gösterilir; böylece herkes aynı anı kendi saatiyle görür. Hesabınıza kaydedilir, başka bir tarayıcıda da geçerli olur.",
  "userSettings.prefs.timezoneNow": "{zone} bölgesinde şu an: {time}",
  "userSettings.saveChanges": "Değişiklikleri kaydet",
  "userSettings.security.passwordTitle": "Parolayı değiştir",
  "userSettings.security.totpDisabled": "İki adımlı doğrulama kapalı",
  "userSettings.security.totpEnabled": "İki adımlı doğrulama açık",
  "userSettings.subtitle.ai": "Burada henüz ayarlayabileceğiniz bir şey yok.",
  "userSettings.subtitle.notifications": "Zilinize ve masaüstünüze neyin ulaşacağı.",
  "userSettings.subtitle.preferences": "Uygulamanın cihazlarınızda nasıl göründüğü ve okunduğu.",
  "userSettings.subtitle.profile": "Adınız, e-postanız ve fotoğrafınız — başkalarının gördüğü bilgiler.",
  "userSettings.subtitle.security": "Parolanız ve ikinci faktörünüz.",
  "userSettings.tabs.ai": "AI asistanı",
  "userSettings.tabs.notifications": "Bildirimler",
  "userSettings.tabs.preferences": "Tercihler",
  "userSettings.tabs.profile": "Profil",
  "userSettings.tabs.security": "Güvenlik",
  "userSettings.title": "Ayarlar",
  "users.fields.displayName": "Görünen ad",
  "webhooks.offReason.antivirus": "Virüs taraması kapalı (Koruma).",
  "webhooks.offReason.appPlugins": "Bu sunucuda uygulamalar kapalı.",
  "webhooks.offReason.escrow": "Şifreli klasörler için emanet anahtarı kurulmamış.",
  "account.problem.emailInvalid": "Bu bir e-posta adresi değil. ad@ornek.com biçiminde yazın.",
  "account.problem.usernameAt": "Kullanıcı adında @ olamaz; @ e-posta adresine aittir.",
  "profile.username.helpText": "Kullanıcı adınız. Oturum açarken bunu da e-postanızı da kullanabilirsiniz — bağlantı istemcileri (SFTP, FTP) için ise bu ad gerekir, çünkü oturum açtıkları addaki @ işareti onların ayar dosyalarında kaçış gerektirir.",
  "userSettings.prefs.fvKeptCount": "{count} klasör kendi görünümünü koruyor.",
  "userSettings.prefs.fvKeptCount_one": "{count} klasör kendi görünümünü koruyor."
}, sT = "filex-base", oT = /^(\/[A-Za-z0-9_~.-]+)+$/;
function iT(e) {
  var s, n;
  const a = e ?? (typeof document < "u" ? document : null);
  if (!a) return "";
  let t = "";
  try {
    t = ((n = (s = a.querySelector(`meta[name="${sT}"]`)) == null ? void 0 : s.getAttribute("content")) == null ? void 0 : n.trim()) ?? "";
  } catch {
    return "";
  }
  return !t || !oT.test(t) || t.split("/").some((o) => o === "." || o === "..") ? "" : t;
}
function ih() {
  return iT();
}
function rT(e) {
  return ih() + e;
}
function rh(e, a) {
  if (/^[a-z][a-z0-9+.-]*:\/\//i.test(a)) return a;
  const t = String(e ?? "").replace(/\/+$/, "");
  return !t || !a.startsWith("/") ? a : t + a;
}
function Ad(e) {
  return String(e ?? ih()).replace(/\/+$/, "");
}
const wn = b(0), zd = b(!1), yk = ["en", "tr"], Tg = {
  en: "English",
  tr: "Türkçe",
  de: "Deutsch",
  fr: "Français",
  es: "Español",
  it: "Italiano",
  nl: "Nederlands",
  pt: "Português",
  pl: "Polski",
  ru: "Русский",
  uk: "Українська",
  ar: "العربية",
  fa: "فارسی",
  az: "Azərbaycanca",
  ja: "日本語",
  ko: "한국어",
  zh: "中文"
};
function gk(e) {
  if (Tg[e]) return Tg[e];
  try {
    const a = new Intl.DisplayNames([e], { type: "language" }).of(e);
    if (a && a.toLowerCase() !== e)
      return a.charAt(0).toLocaleUpperCase(e) + a.slice(1);
  } catch {
  }
  return e.toUpperCase();
}
const Hl = { en: fr, tr: mk }, nn = /* @__PURE__ */ new Map(), Kl = /* @__PURE__ */ new Map(), Md = /^[a-z]{2,3}(-[a-z0-9]{2,8})*$/;
function lT(e) {
  return Md.test(String(e ?? "").trim().toLowerCase().replace(/_/g, "-"));
}
function ps(e) {
  const a = String(e ?? "").trim().toLowerCase().replace(/_/g, "-");
  if (!Md.test(a)) return "";
  if (nn.has(a)) return a;
  const t = a.split("-")[0];
  if (Br(t) || nn.has(t)) return t;
  for (const s of nn.keys()) if (s.startsWith(`${t}-`)) return s;
  return a;
}
function Br(e) {
  return yk.includes(e);
}
function bk(e) {
  const a = {};
  for (const [t, s] of Object.entries(e ?? {}))
    typeof s != "string" || !s.trim() || !t || t.split(".").some((n) => n === "__proto__" || n === "constructor" || n === "prototype") || (a[t] = s);
  return a;
}
function uT(e) {
  const a = String((e == null ? void 0 : e.code) ?? "").trim().toLowerCase().replace(/_/g, "-"), t = Md.test(a) ? a : "";
  t && (nn.set(t, {
    code: t,
    label: String(e.label ?? "").trim() || gk(t),
    source: e.source === "plugin" ? "plugin" : e.source || "builtin",
    plugin: e.plugin,
    rtl: e.rtl === !0,
    strings: e.strings ? bk(e.strings) : null
  }), wn.value += 1);
}
function cT(e) {
  nn.clear(), Kl.clear();
  for (const a of e ?? []) uT(a);
  wn.value += 1;
}
function Uve(e) {
  let a = !1;
  for (const [t, s] of nn)
    s.source === "plugin" && s.plugin === e && (nn.delete(t), a = !0);
  a && (wn.value += 1);
}
function Hve() {
  nn.clear(), Kl.clear(), Go = {}, zd.value = !1, wn.value += 1;
}
function yo() {
  wn.value;
  const e = yk.map((a) => ({
    code: a,
    label: gk(a),
    source: "builtin"
  }));
  for (const [a, t] of nn)
    Br(a) || e.push({ code: a, label: t.label, source: t.source, plugin: t.plugin, rtl: t.rtl });
  return e;
}
function Jc(e) {
  wn.value;
  const a = ps(e);
  return !!a && (Br(a) || nn.has(a));
}
function dT(e) {
  return Jc(e) ? !0 : !zd.value && lT(e);
}
function fT(e) {
  const a = ps(e), t = Br(a) ? Hl[a] : void 0, s = nn.get(a);
  return s && s.strings === null && kk(a), !(s != null && s.strings) || !Object.keys(s.strings).length ? t ?? Hl.en : { ...Hl.en, ...t ?? {}, ...s.strings };
}
function _k(e) {
  const a = ps(e), t = Br(a) ? Hl[a] : void 0, s = nn.get(a);
  s && s.strings === null && kk(a);
  const n = s != null && s.strings && Object.keys(s.strings).length ? s.strings : null;
  return t ? { lang: a, strings: n ? { ...t, ...n } : t } : n ? { lang: a, strings: n } : { lang: "en", strings: Hl.en };
}
function pT(e) {
  var a;
  return { ...((a = nn.get(ps(e))) == null ? void 0 : a.strings) ?? {} };
}
let Go = {};
function kk(e) {
  const a = ps(e), t = nn.get(a);
  if (!t) return Promise.resolve(!1);
  if (t.strings !== null) return Promise.resolve(Object.keys(t.strings).length > 0);
  const s = Kl.get(a);
  if (s) return s;
  const n = Go.fetchImpl ?? (typeof fetch == "function" ? fetch : null);
  if (!n) return Promise.resolve(!1);
  const o = Ad(Go.base), p = (async () => {
    let h = {};
    try {
      const y = Go.headers ? await Go.headers() : {}, g = await n(`${o}/api/public/ui-locales/${encodeURIComponent(a)}`, {
        method: "GET",
        headers: { Accept: "application/json", ...y },
        credentials: "same-origin"
      });
      if (g.ok) {
        const m = await g.json();
        h = bk(m == null ? void 0 : m.strings);
      }
    } catch {
    }
    const v = nn.get(a);
    return v === t && (v.strings = h, wn.value += 1), Kl.delete(a), Object.keys(h).length > 0;
  })();
  return Kl.set(a, p), p;
}
function wk(e, a) {
  if (a && (Go = a), !e) return yo();
  const t = Array.isArray(e.ui_locales) ? e.ui_locales : [], s = new Set(t.map((o) => String((o == null ? void 0 : o.code) ?? "").toLowerCase())), n = (e.locales ?? []).map((o) => String(o ?? "").trim().toLowerCase()).filter((o) => Md.test(o) && !Br(o) && !s.has(o)).map((o) => ({ code: o, source: "plugin" }));
  return cT([...t, ...n]), zd.value = !0, yo();
}
async function Kve(e = {}) {
  Go = e;
  const a = e.fetchImpl ?? (typeof fetch == "function" ? fetch : null);
  if (!a) return yo();
  const t = Ad(e.base);
  try {
    const s = e.headers ? await e.headers() : {}, n = await a(`${t}/api/public/branding`, {
      method: "GET",
      headers: { Accept: "application/json", ...s },
      credentials: "same-origin"
    });
    if (n.ok)
      return wk(await n.json()), yo();
  } catch {
  }
  return zd.value = !0, wn.value += 1, yo();
}
const Cg = "en";
function Ha(e) {
  return e && dT(e) ? ps(e) : xk();
}
function xk() {
  try {
    const e = typeof navigator > "u" ? void 0 : navigator;
    if (!e) return Cg;
    const a = e.languages && e.languages.length ? e.languages : [e.language];
    for (const t of a)
      if (t && Jc(t))
        return ps(t);
  } catch {
  }
  return Cg;
}
const vT = [".filex-trash", ".versions", ".thumbs", ".filex-open", ".filex-drafts"], hT = ".filex-drafts", $k = ".keepdir", Sk = new Set(vT);
function Tk(e) {
  let a = String(e ?? "").trim().replace(/\\/g, "/");
  const t = a.indexOf("://");
  return t >= 0 && (a = a.slice(t + 3)), a.split("/").filter((s) => s && s !== ".");
}
function pu(e) {
  const a = String(e ?? "").trim();
  return Sk.has(a) || a === $k;
}
function Ck(e) {
  const a = Tk(e);
  return a.some((t) => Sk.has(t)) ? !0 : a.length > 0 && a[a.length - 1] === $k;
}
function Eg(e) {
  const a = String(e ?? "");
  if (!Ck(a)) return a;
  const t = a.indexOf("://");
  return t >= 0 ? a.slice(0, t + 3) : "";
}
function ov(e) {
  const a = Tk(e);
  return a.length !== 4 || a[0] !== hT || !/^[1-9][0-9]*$/.test(a[1]) || !/^[0-9a-f]{8,32}$/.test(a[2]) || pu(a[3]) ? "" : a[2];
}
const mT = x(() => {
  wn.value;
  const e = /* @__PURE__ */ new Set();
  for (const a of yo())
    a.rtl === !0 && e.add(a.code);
  return e;
});
function Tr(e) {
  const a = ps(e ?? "");
  return a && mT.value.has(a) ? "rtl" : "ltr";
}
function Vve(e = typeof document < "u" ? document.documentElement : null) {
  if (!e) return () => {
  };
  const a = () => {
    const n = Tr(e.getAttribute("lang"));
    e.getAttribute("dir") !== n && e.setAttribute("dir", n);
  };
  a();
  const t = typeof MutationObserver < "u" ? new MutationObserver(a) : null;
  t == null || t.observe(e, { attributes: !0, attributeFilter: ["lang"] });
  const s = Qe(wn, a);
  return () => {
    t == null || t.disconnect(), s();
  };
}
function Xo(e) {
  var t;
  const a = (t = e == null ? void 0 : e.closest) == null ? void 0 : t.call(e, '[dir="rtl"], [dir="ltr"]');
  return (a == null ? void 0 : a.getAttribute("dir")) === "rtl" ? "rtl" : "ltr";
}
function iv(e) {
  return e === "rtl" ? -1 : 1;
}
function ti(e, a) {
  const t = e === "ArrowRight" ? 1 : e === "ArrowLeft" ? -1 : 0;
  return t === 0 ? 0 : t * iv(a);
}
function Cr(e, a) {
  return a === "rtl" ? e.right : e.left;
}
function Ag(e, a) {
  return a === "rtl" ? e.left : e.right;
}
function zg(e, a, t, s, n = 8) {
  const o = s === "rtl" ? t - e : e;
  let p = o;
  if (o + a > t - n) {
    const h = o - a;
    p = h >= n ? h : Math.max(n, t - a - n);
  }
  return s === "rtl" ? t - p - a : p;
}
function Ek(e, a, t, s, n = 8) {
  const o = s === "rtl" ? t - e : e, p = o + a > t - n ? Math.max(n, t - n - a) : o;
  return s === "rtl" ? t - p - a : p;
}
const Zc = "⁦", Mg = "⁧", Qc = "⁨", Yl = "⁩", yT = new RegExp("[\\u2066-\\u2069]?\\d[\\d.,]*(?:\\s?[A-Za-z%]{1,3})?[\\u2066-\\u2069]?\\s*\\/\\s*[\\u2066-\\u2069]?\\d[\\d.,]*(?:\\s?[A-Za-z%]{1,3})?[\\u2066-\\u2069]?|[A-Za-z][\\w+.-]*:[^\\s,\\u060C)\\u2066-\\u2069]+|\\/(?:[A-Za-z0-9_.~%+-]+\\/)+[A-Za-z0-9_.~%+-]*|(?<![A-Za-z0-9_.~%+:\\/-])\\/(?=[A-Za-z0-9_.~%+-]*[A-Za-z0-9])[A-Za-z0-9_.~%+-]*[A-Za-z0-9_~%+-](?!\\.?[A-Za-z0-9_~%+:-])", "g");
function gT(e) {
  if (!(e[0] === Zc || e[0] === Qc || e[0] === Mg) || e[e.length - 1] !== Yl) return !1;
  let a = 0;
  for (let t = 0; t < e.length; t++) {
    const s = e[t];
    if (s === Zc || s === Qc || s === Mg ? a += 1 : s === Yl && (a -= 1), a === 0 && t < e.length - 1) return !1;
  }
  return a === 0;
}
function Ak(e) {
  return e.replace(yT, (a, t, s) => {
    if (gT(a)) return a;
    const n = s[t - 1], o = s[t + a.length];
    return (n === Zc || n === Qc) && o === Yl ? a : Zc + a + Yl;
  });
}
function go(e, a) {
  return Tr(e) === "rtl" ? Ak(a) : a;
}
function bT(e) {
  return Qc + e + Yl;
}
function zk(e) {
  if (e === "code") return "ltr";
  if (e === "text") return "auto";
}
function rv(e, a) {
  return typeof (e == null ? void 0 : e.foreign) == "function" ? e.foreign(a) : a;
}
function vu(e) {
  const a = (t, s = {}) => {
    const n = fT(e)[t] ?? t, o = Object.entries(s).reduce((p, [h, v]) => p.replaceAll(`{${h}}`, String(v)), n);
    return go(e, o);
  };
  return a.foreign = (t) => go(e, t), a;
}
const Mk = {
  400: "err.status.400",
  401: "err.status.401",
  403: "err.status.403",
  404: "err.status.404",
  409: "err.status.409",
  413: "err.status.413",
  415: "err.status.415",
  422: "err.status.422",
  429: "err.status.429",
  500: "err.status.500",
  501: "err.status.501",
  /* ⚠ 502 and 504 are what an APP answers with (handlers/app_plugins.go
     callFail: any plugin error, and a plugin that ran out of time). */
  502: "err.status.502",
  503: "err.status.503",
  504: "err.status.504"
};
function qve(e, a) {
  return Dk(e, vu(a));
}
function Dk(e, a) {
  return a(Mk[e] ?? (e >= 500 ? "err.status.500" : "err.status.other"));
}
function jve(e) {
  return e >= 400 && e < 500 && e in Mk;
}
const lh = [
  [/^read_only$|read-only/i, "err.read_only"],
  [/^no_secret_key$/, "err.no_secret_key"],
  [/^quota_exceeded$|quota exceeded|quota: exceeded/i, "err.quota"]
], _T = [
  [/^something with that name already exists here\b|^something already exists at this path: /, "err.name_taken"],
  // A queued purge of an entry restored (or taken) meanwhile: the server
  // leaves a live row alone (trash.ErrNotInTrash, handlers.Trash PurgeNode).
  [/^trash: the item is not in the trash\b|^trash entry not found\b/, "err.not_in_trash"]
], kT = {
  BAD_KIND: "err.bad_kind",
  READ_ONLY: "err.read_only",
  NOT_CANCELLABLE: "err.not_cancellable",
  FINISHED: "err.finished",
  TOO_MANY: "err.too_many",
  /* Drafts (issue #71, handlers/drafts.go). TARGET_TAKEN is not here: it is a
     question the client asks ("save as name (2).ext?"), never a refusal. */
  DRAFT_LIMIT: "err.draft_limit",
  FOLDER_GONE: "err.draft_folder_gone",
  DRAFTS_UNAVAILABLE: "err.drafts_unavailable"
};
function Pk(e, a) {
  const t = typeof e.code == "string" ? kT[e.code] : void 0;
  if (!t) return "";
  const s = {};
  for (const [n, o] of Object.entries(e)) typeof o == "number" && (s[n] = o);
  return a(t, s);
}
function Wve(e, a) {
  return !e || typeof e != "object" || Array.isArray(e) ? "" : Pk(e, vu(a));
}
function Dd(e) {
  try {
    const a = JSON.parse(e);
    return a && typeof a == "object" && !Array.isArray(a) ? a : {};
  } catch {
    return {};
  }
}
function Ok(e) {
  const a = Dd(e).error;
  return typeof a == "string" ? a : "";
}
function wT(e, a, t) {
  return Lk(e, a, vu(t));
}
function Lk(e, a, t) {
  const s = Pk(Dd(a), t);
  if (s) return s;
  const n = Ok(a);
  for (const [o, p] of lh) if (n && o.test(n)) return t(p);
  return Dk(e, t);
}
function tn(e, a, t) {
  const s = new Error(wT(e, a, t));
  s.status = e, s.code = Ok(a), s.detail = a.slice(0, 300), s.said = !0;
  const n = Dd(a).admin_hint;
  return typeof n == "string" && n && (s.hint = n), s;
}
function hu(e, a) {
  const t = (h) => go(a, h), s = e;
  if (!s || s.said !== !0) return t(s instanceof Error ? s.message : e ? String(e) : "");
  const n = s.code ?? "";
  if (n && lh.some(([h]) => h.test(n))) return t(s.message ?? "");
  const o = Dd(s.detail ?? ""), p = typeof o.message == "string" && o.message ? o.message : n;
  return p && !uh(p) && !/^[a-z0-9_]+$/.test(p) ? t(p) : t(s.message ?? "");
}
function lv(e, a) {
  const t = new Error(vu(e)("err.network"));
  return t.detail = a instanceof Error ? a.message : a ? String(a) : "", t.said = !0, t;
}
function uh(e) {
  const a = e.trim();
  return a ? /^[[{]/.test(a) || // a JSON body
  /\b[1-5]\d\d\b\s+[A-Z][a-z]+/.test(a) || // "500 Internal Server Error"
  /\b[A-Z][A-Z0-9]+_[A-Z0-9_]+\b/.test(a) || // FILEX_SECRET_KEY
  /\b(panic|goroutine|stack trace|Traceback|at [\w$.]+ \()/i.test(a) || /^[\w.-]+: [\w.-]+(: |$)/.test(a) || // "protocolauth: no secret key…"
  /(^|\s)\/(?:[\w.-]+\/){2,}/.test(a) || // /var/lib/filex/…
  /\b[a-z][\w.-]*: [^:()]{1,60}: [a-z][\w.-]*: /i.test(a) || // a Go error chain "a: b: c: d"
  /\b(ECONNREFUSED|ETIMEDOUT|EOF|nil pointer|dial tcp|x509|context deadline exceeded)\b/i.test(a) : !1;
}
function xT(e) {
  const a = /^(.*\S)\s*\(([^()]*)\)\s*$/.exec(e);
  return a && uh(a[2]) ? [a[1], a[2]] : [e, ""];
}
function ch(e, a, t = {}) {
  const s = e, n = (s == null ? void 0 : s.said) === !0, o = n ? (s == null ? void 0 : s.detail) ?? "" : s instanceof Error ? s.message : e ? String(e) : "", p = n ? t.t && typeof (s == null ? void 0 : s.status) == "number" ? Lk(s.status, s.detail ?? "", t.t) : (s == null ? void 0 : s.message) || a : a;
  !n && o && typeof console < "u" && console.warn("[filex]", o);
  const h = rv(t.t, p), v = rv(t.t, o);
  return t.callerAdmin && o && o !== p ? { text: h, detail: v } : { text: h };
}
function Ac(e, a, t = {}) {
  const n = e.op_type === "plugin" || e.op_type === "plugin-action" ? a("plugin.failed", { label: e.label || e.action || a("opc.kind.plugin") }) : a("toast.failed");
  return $T(
    { error: e.error_message, error_code: e.error_code, error_engine: e.error_engine },
    n,
    a,
    t
  );
}
function $T(e, a, t, s = {}) {
  const n = (e.error ?? "").trim(), o = s.callerAdmin === !0, p = (y) => rv(t, y), h = (y) => o && n && n !== y ? { text: p(y), detail: p(n) } : { text: p(y) }, v = e.error_engine || "";
  switch (e.error_code) {
    case "timeout":
      return h(t("opc.err.timeout"));
    case "out_of_memory":
      return h(t("opc.err.out_of_memory"));
    case "crashed":
      return h(t("opc.err.crashed"));
    case "app_removed":
      return h(t("opc.err.app_removed"));
    case "action_removed":
      return h(t("opc.err.action_removed"));
    case "cancelled":
      return { text: t("opc.status.aborted") };
    case "engine_missing":
      return h(t(o ? "opc.err.engine_missing_admin" : "opc.err.engine_missing", { engine: v }));
    case "app": {
      const [y, g] = xT(n);
      return y && !uh(y) ? g && o ? { text: p(y), detail: p(n) } : { text: p(y) } : h(a);
    }
  }
  for (const [y, g] of [..._T, ...lh]) if (n && y.test(n)) return h(t(g));
  return h(a);
}
const ST = "DRAFT_LIMIT", TT = "TARGET_TAKEN";
function Ik(e, a) {
  const t = e == null ? void 0 : e.detail;
  if (t)
    try {
      const s = JSON.parse(t);
      return s && typeof s == "object" ? s[a] : void 0;
    } catch {
      return;
    }
}
function CT(e) {
  return Ik(e, "code") === ST;
}
function ET(e) {
  const a = Ik(e, "limit");
  return typeof a == "number" && a > 0 ? a : null;
}
function Rk(e, a) {
  const t = e.replace(/\/+$/, ""), s = (p) => `${t}/${encodeURIComponent(p)}`;
  async function n(p, h = {}) {
    const v = await a.request(p, {
      ...h,
      headers: { "Content-Type": "application/json", ...h.headers ?? {} }
    }), y = await v.text().catch(() => "");
    let g = null;
    if (y)
      try {
        g = JSON.parse(y);
      } catch {
        g = null;
      }
    return { status: v.status, body: g, text: y };
  }
  function o(p, h) {
    throw tn(p, h, a.locale);
  }
  return {
    /**
     * New document, as a draft (the New document dialog's request): the same
     * body as `action=newfile`, answered with the same fields — `path` is the
     * draft's — plus the draft itself. A refusal throws; DRAFT_LIMIT is the
     * one the dialog says in its own words (isDraftLimit).
     */
    async create(p, h, v, y = {}) {
      var m;
      const g = await n(t, {
        method: "POST",
        body: JSON.stringify(y.exactName ? { path: p, name: h, type: v, exact_name: !0 } : { path: p, name: h, type: v })
      });
      return (g.status !== 201 || !((m = g.body) != null && m.draft)) && o(g.status, g.text), g.body;
    },
    /** Every draft of the caller's, across every storage they can see. */
    async list() {
      const p = await n(t);
      return (p.status !== 200 || !p.body) && o(p.status, p.text), { drafts: p.body.drafts ?? [], count: p.body.count ?? 0, limit: p.body.limit ?? 0 };
    },
    /** How many — the navigation panel's badge. */
    async count() {
      const p = await n(`${t}/count`);
      return (p.status !== 200 || !p.body) && o(p.status, p.text), { count: p.body.count ?? 0, limit: p.body.limit ?? 0 };
    },
    /** One draft — what an editor on a draft's path asks. */
    async get(p) {
      const h = await n(s(p));
      return (h.status !== 200 || !h.body) && o(h.status, h.text), h.body;
    },
    /**
     * Save the draft where it is meant to go — under `as` when given (only
     * ever the `suggested` name a taken answer offered).
     */
    async save(p, h) {
      var y, g;
      const v = await n(`${s(p)}/save`, { method: "POST", body: JSON.stringify(h ? { as: h } : {}) });
      if (v.status === 200 && ((y = v.body) != null && y.path))
        return { saved: !0, path: v.body.path, name: v.body.name ?? "", targetDir: v.body.target_dir ?? "" };
      if (v.status === 409 && ((g = v.body) == null ? void 0 : g.code) === TT && v.body.suggested)
        return {
          saved: !1,
          taken: !0,
          name: v.body.name ?? "",
          suggested: v.body.suggested,
          targetDir: v.body.target_dir ?? ""
        };
      o(v.status, v.text);
    },
    /** Discard it: the draft goes to the trash (restorable until it ages out). */
    async discard(p) {
      const h = await n(s(p), { method: "DELETE" });
      h.status !== 200 && o(h.status, h.text);
    }
  };
}
function ed(e) {
  const a = e.indexOf("://"), t = a >= 0 ? e.slice(0, a) : "", s = (a >= 0 ? e.slice(a + 3) : e).replace(/^\/+|\/+$/g, "");
  return [t, ...s.split("/").filter(Boolean)].filter(Boolean).join(" / ");
}
const AT = ["zero", "one", "two", "few", "many", "other"], Dg = ["one", "other"], Pg = /* @__PURE__ */ new Map();
function Nk(e) {
  const a = String(e ?? ""), t = Pg.get(a);
  if (t !== void 0) return t;
  let s = null;
  if (typeof Intl < "u" && typeof Intl.PluralRules == "function")
    try {
      s = new Intl.PluralRules(a || "en");
    } catch {
      try {
        s = new Intl.PluralRules("en");
      } catch {
        s = null;
      }
    }
  return Pg.set(a, s), s;
}
const Og = /* @__PURE__ */ new Map(), zT = 999;
function MT(e) {
  const a = String(e ?? ""), t = Og.get(a);
  if (t) return t;
  let s = Dg;
  const n = Nk(a);
  if (n)
    try {
      const o = /* @__PURE__ */ new Set(["other"]);
      for (let p = 0; p <= zT; p++) o.add(n.select(p));
      s = AT.filter((p) => o.has(p));
    } catch {
      s = Dg;
    }
  return Og.set(a, s), s;
}
function Bk(e, a) {
  if (!Number.isFinite(a)) return "other";
  const t = Math.abs(a), s = Nk(e);
  if (!s) return t === 1 ? "one" : "other";
  try {
    return s.select(t);
  } catch {
    return t === 1 ? "one" : "other";
  }
}
function Yve(e, a, t) {
  const s = Math.abs(a), n = MT(e), o = Bk(e, s);
  if (t === n.length && t > 1) {
    const p = n.indexOf(o);
    return p >= 0 ? p : t - 1;
  }
  return t === 1 ? 0 : t === 2 ? o === "one" ? 0 : 1 : t === 3 ? s === 0 ? 0 : o === "one" ? 1 : 2 : t - 1;
}
const DT = Object.freeze([
  "viewer",
  "host",
  "account",
  "device"
]);
function dh(e) {
  for (const a of DT) {
    if (a === "device") break;
    const t = e[a];
    if (typeof t == "string" && t && mi(t)) return { zone: t, tier: a };
  }
  return { zone: void 0, tier: "device" };
}
const Vl = "filex.timezone.viewer", td = "filex.timezone", PT = [
  "UTC",
  "Europe/Istanbul",
  "Europe/London",
  "Europe/Berlin",
  "Europe/Paris",
  "Europe/Madrid",
  "Europe/Moscow",
  "America/New_York",
  "America/Chicago",
  "America/Denver",
  "America/Los_Angeles",
  "America/Sao_Paulo",
  "Africa/Cairo",
  "Africa/Lagos",
  "Asia/Dubai",
  "Asia/Karachi",
  "Asia/Kolkata",
  "Asia/Shanghai",
  "Asia/Tokyo",
  "Asia/Seoul",
  "Asia/Singapore",
  "Australia/Sydney",
  "Pacific/Auckland"
];
function mu() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  } catch {
    return "UTC";
  }
}
function mi(e) {
  if (!e) return !1;
  try {
    return new Intl.DateTimeFormat("en-US", { timeZone: e }), !0;
  } catch {
    return !1;
  }
}
function OT() {
  try {
    const e = Intl.supportedValuesOf;
    if (typeof e == "function") {
      const a = e("timeZone");
      if (Array.isArray(a) && a.length)
        return a.includes("UTC") ? [...a] : ["UTC", ...a];
    }
  } catch {
  }
  return [...PT];
}
function Lg(e, a) {
  const t = a ?? LT();
  try {
    const s = new Intl.DateTimeFormat("en-CA", {
      timeZone: t,
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    }).formatToParts(e), n = (v) => {
      var y;
      return Number((y = s.find((g) => g.type === v)) == null ? void 0 : y.value);
    }, o = n("year"), p = n("month"), h = n("day");
    if (!Number.isFinite(o) || !Number.isFinite(p) || !Number.isFinite(h))
      throw new Error("unparsable");
    return Math.floor(Date.UTC(o, p - 1, h) / 864e5);
  } catch {
    return Math.floor(
      Date.UTC(e.getFullYear(), e.getMonth(), e.getDate()) / 864e5
    );
  }
}
function ql(e) {
  try {
    const a = localStorage.getItem(e);
    return a && mi(a) ? a : "";
  } catch {
    return "";
  }
}
function Fk(e, a) {
  try {
    a ? localStorage.setItem(e, a) : localStorage.removeItem(e);
  } catch {
  }
}
const fh = typeof window < "u", ai = b(fh ? ql(Vl) : "");
function Uk() {
  const e = b([]);
  return {
    set(a, t) {
      const s = e.value.find((n) => n.owner === a);
      if (t === null) {
        s && (e.value = e.value.filter((n) => n !== s));
        return;
      }
      s && s.zone === t || (e.value = [...e.value.filter((n) => n.owner !== a), { owner: a, zone: t }]);
    },
    of(a) {
      var t;
      return ((t = e.value.find((s) => s.owner === a)) == null ? void 0 : t.zone) ?? null;
    },
    current() {
      const a = e.value;
      return a.length ? a[a.length - 1].zone : "";
    },
    /** The newest answer among the owners `pick` accepts. */
    currentWhere(a) {
      const t = e.value.filter((s) => a(s.owner));
      return t.length ? t[t.length - 1].zone : "";
    }
  };
}
const yu = Uk(), Fs = Uk(), Pd = /* @__PURE__ */ new Set(), ph = x(
  () => dh({
    viewer: ai.value,
    host: yu.current(),
    account: Fs.current()
  })
);
function LT() {
  return ph.value.zone;
}
function IT() {
  return ph.value;
}
const Od = Symbol("filex-explorer-clock");
function Hk(e) {
  return e ? {
    viewer: ai.value,
    host: yu.of(e) ?? "",
    account: Fs.of(e) ?? Fs.currentWhere((a) => Pd.has(a))
  } : RT();
}
function Kk(e) {
  return e ? dh(Hk(e)) : ph.value;
}
function Vk(e) {
  return Kk(e).zone;
}
function RT() {
  return {
    viewer: ai.value,
    host: yu.current(),
    account: Fs.current()
  };
}
function NT() {
  return ai.value;
}
function qk(e) {
  const a = e && mi(e) ? e : "";
  ai.value = a, Fk(Vl, a);
  try {
    window.dispatchEvent(new CustomEvent("filex:timezone", { detail: a }));
  } catch {
  }
}
function BT(e, a) {
  yu.set(e, a && mi(a) ? a : null);
}
function zc(e, a, t = {}) {
  if (a == null) {
    Fs.set(e, null);
    return;
  }
  const s = a && mi(a) ? a : "";
  Fs.set(e, s), t.remember && (Pd.add(e), Fk(td, s));
}
function FT(e) {
  return Fs.of(e);
}
function UT(e) {
  return {
    get: () => FT(e) ?? "",
    set: (a) => {
      zc(e, a && mi(a) ? a : "", { remember: !0 }), qk("");
    }
  };
}
function Gve() {
  return fh ? ql(td) : "";
}
function HT(e) {
  yu.set(e, null), Fs.set(e, null), Pd.delete(e);
}
if (fh)
  try {
    window.addEventListener("storage", (e) => {
      if ((e.key === null || e.key === Vl) && (ai.value = ql(Vl)), e.key === null || e.key === td) {
        const a = ql(td);
        for (const t of Pd) Fs.set(t, a);
      }
    }), window.addEventListener("filex:timezone", (e) => {
      const a = e.detail;
      ai.value = typeof a == "string" ? a && mi(a) ? a : "" : ql(Vl);
    });
  } catch {
  }
const Ig = /* @__PURE__ */ new Map();
function kn(e) {
  if (!e || e === "en") return "en-US";
  if (e === "tr") return "tr-TR";
  let a = Ig.get(e);
  if (!a) {
    try {
      a = Intl.getCanonicalLocales(e)[0] || "en-US";
    } catch {
      a = "en-US";
    }
    Ig.set(e, a);
  }
  return a;
}
const Rg = [
  "unit.bytes",
  "unit.kb",
  "unit.mb",
  "unit.gb",
  "unit.tb",
  "unit.pb"
], KT = {
  "unit.bytes": "B",
  "unit.kb": "KB",
  "unit.mb": "MB",
  "unit.gb": "GB",
  "unit.tb": "TB",
  "unit.pb": "PB"
};
function VT(e, a = {}) {
  const t = a.empty ?? "—";
  if (e == null || !Number.isFinite(e) || e < 0) return t;
  const s = a.base ?? 1e3, n = a.unit ?? ((y) => KT[y]);
  let o = 0, p = e;
  for (; p >= s && o < Rg.length - 1; )
    p /= s, o += 1;
  const h = o === 0 ? 0 : a.digits === "fixed1" ? 1 : p < 10 ? 2 : 1;
  let v;
  if (a.numberLocale == null)
    v = p.toFixed(h);
  else {
    const y = qT(a.numberLocale, h, a.digits === "fixed1" ? h : 0);
    v = y ? y.format(p) : p.toFixed(h);
  }
  return `${v} ${n(Rg[o])}`;
}
const _c = /* @__PURE__ */ new Map();
function qT(e, a, t) {
  const s = `${e}|${a}|${t}`;
  if (!_c.has(s))
    try {
      _c.set(s, new Intl.NumberFormat(e, {
        maximumFractionDigits: a,
        minimumFractionDigits: t
      }));
    } catch {
      _c.set(s, null);
    }
  return _c.get(s) ?? null;
}
const Ng = /* @__PURE__ */ new Map();
function jk(e, a, t) {
  const s = Vk(t), n = `${e}|${s ?? `device:${mu()}`}|${JSON.stringify(a)}`;
  let o = Ng.get(n);
  return o || (o = new Intl.DateTimeFormat(e, { ...a, timeZone: s }), Ng.set(n, o)), o;
}
function Er(e, a, t, s) {
  try {
    return jk(kn(a), t, s).format(e);
  } catch {
    return e.toISOString();
  }
}
const jT = /^(\d{4})-(\d{2})-(\d{2})$/, Bg = /* @__PURE__ */ new Map();
function WT(e, a) {
  const t = jT.exec(e.trim());
  if (!t) return "";
  const s = new Date(Date.UTC(Number(t[1]), Number(t[2]) - 1, Number(t[3])));
  if (Number.isNaN(s.getTime())) return "";
  const n = kn(a);
  let o = Bg.get(n);
  try {
    return o || (o = new Intl.DateTimeFormat(n, { month: "short", day: "numeric", year: "numeric", timeZone: "UTC" }), Bg.set(n, o)), o.format(s);
  } catch {
    return "";
  }
}
function Mc(e) {
  if (!e) return null;
  const a = new Date(e * (e < 1e12 ? 1e3 : 1));
  return Number.isNaN(a.getTime()) ? null : a;
}
function Wk(e) {
  if (e == null || e === "") return null;
  if (e instanceof Date) return Number.isNaN(e.getTime()) ? null : e;
  if (typeof e == "number") return Mc(e);
  const a = new Date(e);
  return Number.isNaN(a.getTime()) ? null : a;
}
const YT = { month: "short", day: "numeric", year: "numeric" }, GT = { timeStyle: "short" };
function vh(e, a, t = {}, s) {
  const n = Wk(e);
  if (!n) return "";
  const o = Er(n, a, YT, s);
  return t.time ? `${o}, ${Er(n, a, GT, s)}` : o;
}
function XT(e, a, t) {
  const s = Wk(e);
  if (!s) return "";
  const n = Vk(t) ?? mu();
  return `${Er(s, a, { dateStyle: "full", timeStyle: "long" }, t)} (${n})`;
}
const Yk = Symbol("filex-explorer-locale"), JT = ["count", "n", "days"];
function Fg(e, a, t, s = "en") {
  const n = JT.find((h) => h in a);
  if (n === void 0) return e;
  const o = Bk(s, Number(a[n]));
  if (o === "other") return e;
  const p = `${e}_${o}`;
  return t(p) ? p : e;
}
function ar(e, a) {
  const t = e[a];
  return typeof t == "string" && t ? t : void 0;
}
function ZT(e, a, t = {}) {
  const s = e.strings, n = Fg(a, t, (h) => ar(s, h) !== void 0, e.lang), o = ar(s, n) ?? ar(s, a);
  if (o !== void 0) return o;
  if (s === fr) return a;
  const p = Fg(a, t, (h) => ar(fr, h) !== void 0, "en");
  return ar(fr, p) ?? ar(fr, a) ?? a;
}
function Ug(e, a) {
  return Object.entries(a).reduce(
    (t, [s, n]) => t.replaceAll(`{${s}}`, String(n)),
    e
  );
}
function Gk(e, a, t, s) {
  const n = ZT(e, a, t);
  if (!s) return Ug(n, t);
  const o = {};
  for (const [p, h] of Object.entries(t)) o[p] = typeof h == "string" ? bT(h) : h;
  return Ak(Ug(n, o));
}
function QT(e, a, t = {}) {
  return Gk(_k(e), a, t, Tr(e) === "rtl");
}
function gt(e) {
  const a = () => typeof e == "function" ? e() : e.value, t = x(() => (wn.value, _k(a()))), s = hi() ? On(Od, void 0) : void 0, n = x(() => Tr(a()));
  function o(w, $ = {}) {
    return Gk(t.value, w, $, n.value === "rtl");
  }
  o.foreign = (w) => go(a(), w);
  function p(w) {
    return VT(w, {
      unit: ($) => o($),
      numberLocale: kn(a())
    });
  }
  function h(w) {
    return w ? w.size_partial ? typeof w.size == "number" && w.size > 0 ? o("size.at_least", { size: p(w.size) }) : "—" : p(w.size) : p(null);
  }
  function v(w) {
    if (w != null && w.size_partial)
      return typeof w.size == "number" && w.size > 0 ? o("size.partial_hint") : o("size.unknown_hint");
  }
  function y(w) {
    if (w.basename === ".trash") return o("node.trash");
    if (typeof w.fxe_name == "string" && w.fxe_name) return w.fxe_name;
    const $ = w.basename.match(/^\d{8}-\d{6}-[A-Za-z0-9]+__(.+)$/);
    return $ ? $[1] : w.basename;
  }
  function g(w, $ = {}) {
    return vh(w, a(), $, s);
  }
  function m(w) {
    return XT(w, a(), s);
  }
  function k(w) {
    const $ = w instanceof Date ? w : Mc(w);
    return $ ? Er($, a(), { month: "long", year: "numeric" }, s) : "";
  }
  function _(w) {
    const $ = w instanceof Date ? w : Mc(w);
    if (!$) return "";
    try {
      return jk("en-CA", { year: "numeric", month: "2-digit" }, s).format($);
    } catch {
      return `${$.getFullYear()}-${String($.getMonth() + 1).padStart(2, "0")}`;
    }
  }
  return {
    t: o,
    formatSize: p,
    formatNodeSize: h,
    nodeSizeHint: v,
    formatDate: g,
    formatDateFull: m,
    formatMonthYear: k,
    zonedYearMonth: _,
    /**
     * zaman:z1 — the wire's `last_modified` as a `Date`, or null.
     *
     * Handed out because "seconds or milliseconds" is a fact about the WIRE,
     * not about formatting, and every caller that needs the instant itself
     * (rather than a string) was otherwise re-typing `v * (v < 1e12 ? 1000 :
     * 1)`. ListView had the third copy and used it to group rows by day — so
     * the grouping and the cell four pixels away were reading the same number
     * through two different converters.
     */
    toDate: Mc,
    nodeDisplayName: y,
    /**
     * ⚠ RTL — which way this surface's language is written (`lib/direction`,
     * the server's one list). Bind it as `dir` on anything Teleported out of
     * the explorer's root: under `<body>` a menu inherits the HOST page's
     * direction, not the language its own words are in.
     */
    dir: n
  };
}
const ni = b(0), Gl = b(0), eC = x(() => ni.value !== 0), Xve = x(() => ni.value), Jve = x(() => Gl.value);
function uv(e, a = Date.now()) {
  return ni.value === 0 && (ni.value = a || 1), e === "background" ? (Gl.value += 1, "folded") : "say";
}
function cv() {
  ni.value === 0 && Gl.value === 0 || (ni.value = 0, Gl.value = 0);
}
function Zve() {
  ni.value = 0, Gl.value = 0;
}
function tC(e) {
  const a = String(e ?? "get").toLowerCase();
  return a === "get" || a === "head" || a === "options" ? "background" : "action";
}
function Xk(e) {
  const a = e.apiBase != null ? e.apiBase.replace(/\/+$/, "") : null;
  function t(n, o) {
    return n || (a === null ? null : `${a}${o}`);
  }
  const s = e.endpoint ?? (a !== null ? `${a}/api/files/manager` : null);
  if (!s)
    throw new Error(
      "[@brftech/filex-core] config requires either `apiBase` or `endpoint`"
    );
  return {
    manager: s,
    // Staged (chunked + resumable) uploads — what useUploadChunked speaks on
    // every driver. The {id} routes are derived from this one.
    uploadBegin: t(e.uploadBegin, "/api/files/upload/begin"),
    uploadInit: t(e.uploadInit, "/api/files/upload/init"),
    uploadFinalize: t(e.uploadFinalize, "/api/files/upload/finalize"),
    uploadAbort: t(e.uploadAbort, "/api/files/upload/abort"),
    shareCreate: t(e.shareCreate, "/api/files/share"),
    shareList: t(e.shareList, "/api/files/share"),
    shareDelete: t(e.shareDelete, "/api/files/share/{uuid}"),
    limits: t(e.limits, "/api/files/limits"),
    capabilities: t(e.capabilities, "/api/files/capabilities"),
    me: t(e.me, "/api/auth/me"),
    archiveList: t(e.archiveList, "/api/files/archive/list"),
    archiveExtract: t(e.archiveExtract, "/api/files/archive/extract"),
    archiveCreate: t(e.archiveCreate, "/api/files/archive/create"),
    archiveAdd: t(e.archiveAdd, "/api/files/archive/add"),
    copy: t(e.copy, "/api/files/copy"),
    moveAsync: t(e.moveAsync, "/api/files/move"),
    deleteAsync: t(e.deleteAsync, "/api/files/delete"),
    opsList: t(e.opsList, "/api/files/ops"),
    opsShow: t(e.opsShow, "/api/files/ops/{id}"),
    onlyOfficeConfig: t(e.onlyOfficeConfig, "/api/files/onlyoffice/config"),
    saveText: t(e.saveText, "/api/files/save-text"),
    restore: t(e.restore, "/api/files/restore"),
    // filex trash: list soft-deleted nodes + restore one by node id.
    trashList: t(e.trashList, "/api/files/manager/trash"),
    trashRestore: t(e.trashRestore, "/api/files/manager/restore"),
    /* An operator's "Delete permanently" of one trash entry (`{id}`). */
    trashPurge: t(e.trashPurge, "/api/admin/trash/{id}"),
    /* An operator's hard delete of one version (`{id}`). */
    versionPurge: t(e.versionPurge, "/api/admin/versions/{id}"),
    /* wiring:e2 — escrow proof-of-possession, then the owner is told. */
    e2eEscrowChallenge: t(e.e2eEscrowChallenge, "/api/files/e2e/escrow/challenge"),
    e2eEscrowUsed: t(e.e2eEscrowUsed, "/api/files/e2e/escrow/used"),
    /* wiring:e2 password — a folder password was changed; its owner is told. */
    e2ePasswordChanged: t(e.e2ePasswordChanged, "/api/files/e2e/password-changed"),
    /* wiring:e2 convert — after a folder is encrypted in place. */
    e2eCleanup: t(e.e2eCleanup, "/api/files/e2e/cleanup"),
    /* App plugins — docs/APP-PLUGINS-API.md. */
    pluginActions: t(e.pluginActions, "/api/files/plugins/actions"),
    pluginActionRun: t(e.pluginActionRun, "/api/files/plugins/actions/{plugin}/{action}/run"),
    pluginView: t(e.pluginView, "/api/files/plugins/views/{plugin}/{view}"),
    pluginViewEvent: t(e.pluginViewEvent, "/api/files/plugins/views/{plugin}/{view}/event"),
    pluginUsers: t(e.pluginUsers, "/api/files/plugins/users"),
    opsCancel: t(e.opsCancel, "/api/files/ops/{id}/cancel"),
    /* v4 — an app's own interface (AppFrame): its module, and its saves. */
    pluginUICall: t(e.pluginUICall, "/api/files/plugins/ui/{plugin}/{view}/call"),
    pluginUISave: t(e.pluginUISave, "/api/files/plugins/ui/{plugin}/{view}/save")
  };
}
async function aC(e) {
  if (typeof e == "function") {
    const a = e();
    return a instanceof Promise ? await a : a;
  }
  return e;
}
function nC(e) {
  return e ? "kind" in e ? e : e.type === "bearer" ? { kind: "bearer", token: e.token } : e.type === "csrf" ? { kind: "csrf", csrf: e.csrf } : { kind: "none" } : { kind: "none" };
}
const jo = 8 << 20;
function Fr(e) {
  const a = Xk(e), t = nC(e.auth);
  let s = null;
  async function n(_e = {}) {
    const Ve = { Accept: "application/json", ..._e };
    if (t.kind === "bearer") {
      const Je = await aC(t.token);
      Je && (Ve.Authorization = `Bearer ${Je}`, s = Je);
    } else if (t.kind === "csrf")
      Ve["X-CSRF-TOKEN"] = t.csrf, Ve["X-Requested-With"] = "XMLHttpRequest";
    else if (t.kind === "basic") {
      const Je = btoa(`${t.user}:${t.pass}`);
      Ve.Authorization = `Basic ${Je}`;
    }
    return Ve;
  }
  function o(_e = {}) {
    const Ve = { Accept: "application/json", ..._e };
    if (t.kind === "bearer") {
      const Je = typeof t.token == "string" ? t.token : s;
      Je && (Ve.Authorization = `Bearer ${Je}`);
    } else if (t.kind === "csrf")
      Ve["X-CSRF-TOKEN"] = t.csrf, Ve["X-Requested-With"] = "XMLHttpRequest";
    else if (t.kind === "basic") {
      const Je = btoa(`${t.user}:${t.pass}`);
      Ve.Authorization = `Basic ${Je}`;
    }
    return Ve;
  }
  function p() {
    return t.kind === "csrf" ? "include" : "same-origin";
  }
  const h = () => Ha(e.locale);
  async function v(_e, Ve = {}) {
    const Je = await y(_e, Ve);
    if (!Je.ok) {
      const xt = await Je.text().catch(() => "");
      throw tn(Je.status, xt, h());
    }
    if (Je.status === 204 || Je.status === 205) return;
    const at = await Je.text();
    if (at)
      return JSON.parse(at);
  }
  async function y(_e, Ve = {}) {
    const Je = {
      // ⚠⚠ The language on SCREEN, not the one the browser was installed in.
      // Everything the server writes for a person — a plugin's surface, the
      // labels inside it, the message on a queued job — is rendered with the
      // request's `Accept-Language`. Chrome sends `en-US` whatever filex is
      // set to, so a Turkish window asked a signing wizard for its screens
      // and got "Identity" and an English help line in the middle of Turkish
      // ones. The window's own language is the only right answer here.
      "Accept-Language": kn(Ha(e.locale)),
      ...await n(),
      ...Ve.headers ?? {}
    };
    let at;
    try {
      at = await fetch(_e, {
        ...Ve,
        headers: Je,
        credentials: p()
      });
    } catch (xt) {
      throw (xt == null ? void 0 : xt.name) === "AbortError" ? xt : (uv(tC(Ve.method)), lv(h(), xt));
    }
    return cv(), at;
  }
  const g = a.manager.replace(/\/manager(\?.*)?$/, "/drafts"), m = Rk(g, {
    request: y,
    get locale() {
      return h();
    }
  });
  function k(_e = "") {
    return a.manager.replace(/\/manager(\?.*)?$/, "/permissions") + _e;
  }
  async function _(_e) {
    return v(k() + "?path=" + encodeURIComponent(_e));
  }
  async function w(_e) {
    return v(k("/resolve") + "?email=" + encodeURIComponent(_e));
  }
  async function $(_e) {
    return v(k("/users") + "?q=" + encodeURIComponent(_e));
  }
  async function C(_e) {
    return v(k(), { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(_e) });
  }
  async function E(_e, Ve) {
    return v(k("/" + _e), { method: "PATCH", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ level: Ve }) });
  }
  async function A(_e) {
    return v(k("/" + _e), { method: "DELETE" });
  }
  async function O(_e) {
    return v(k("/invite"), { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(_e) });
  }
  async function z(_e) {
    return v(k("/share-mail"), { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(_e) });
  }
  function P(_e) {
    const Ve = new URLSearchParams();
    for (const [Je, at] of Object.entries(_e))
      at != null && Ve.set(Je, String(at));
    return Ve.toString();
  }
  function I(_e, Ve = {}) {
    const Je = a.manager.includes("?") ? "&" : "?";
    return `${a.manager}${Je}${P({ q: _e, action: _e, ...Ve })}`;
  }
  async function F(_e) {
    return v(I("index", { path: Eg(_e) }));
  }
  async function W(_e, Ve) {
    return v(I("search", { path: Eg(_e), filter: Ve }));
  }
  async function N(_e, Ve = {}) {
    const Je = a.manager.replace(/\/manager(\?.*)?$/, "/search"), at = Je.includes("?") ? "&" : "?", xt = `${Je}${at}${P({ q: _e, limit: Ve.limit, scope: Ve.scope })}`, Bt = await v(xt);
    return Array.isArray(Bt == null ? void 0 : Bt.results) ? Bt.results : [];
  }
  async function K() {
    const _e = a.manager.replace(/\/manager(\?.*)?$/, "/quota/me");
    try {
      const Ve = await v(_e);
      return Ve && typeof Ve.used_bytes == "number" ? Ve : null;
    } catch {
      return null;
    }
  }
  async function M() {
    const _e = a.manager.replace(/\/manager(\?.*)?$/, "/quota/storages");
    try {
      const Ve = await v(_e);
      return Array.isArray(Ve == null ? void 0 : Ve.storages) ? Ve.storages : null;
    } catch {
      return null;
    }
  }
  async function j(_e) {
    return v(I("subfolders", { path: _e }));
  }
  async function U(_e, Ve) {
    return v(I("newfolder"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: _e, name: Ve })
    });
  }
  async function de(_e, Ve, Je, at = {}) {
    return v(I("newfile"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(at.exactName ? { path: _e, name: Ve, type: Je, exact_name: !0 } : { path: _e, name: Ve, type: Je })
    });
  }
  async function ke(_e, Ve, Je) {
    return v(I("rename"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: _e, item: Ve, name: Je })
    });
  }
  async function ie(_e, Ve, Je) {
    return v(I("rename", { queued: 1 }), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: _e, item: Ve, name: Je })
    });
  }
  async function ce(_e, Ve, Je) {
    return v(I("move"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: _e, item: Je, items: Ve.map((at) => ({ path: at })) })
    });
  }
  async function X(_e, Ve) {
    return v(I("delete"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: _e, items: Ve.map((Je) => ({ path: Je })) })
    });
  }
  async function Z(_e, Ve) {
    const Je = [];
    for (let at = 0; at < _e.length; at += 1e3) {
      const xt = _e.slice(at, at + 1e3), Bt = await v(I("allowed"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ permissions: Ve, items: xt.map((Ot) => ({ path: Ot })) })
      });
      xt.forEach((Ot, It) => {
        var Et;
        return Je.push(((Et = Bt.allowed) == null ? void 0 : Et[It]) ?? []);
      });
    }
    return Je;
  }
  async function Y(_e, Ve) {
    if (!a.copy) throw new Error("copy endpoint not configured");
    return v(a.copy, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ source: _e, target: Ve })
    });
  }
  async function G(_e, Ve, Je, at, xt) {
    const Bt = _e === "copy" ? a.copy : a.moveAsync;
    if (!Bt) throw new Error(`${_e} endpoint not configured`);
    return v(Bt, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ source: [Ve], target: Je, name: at, ...xt ? { sourceDir: xt } : {} })
    });
  }
  async function we(_e, Ve, Je) {
    if (!a.moveAsync) throw new Error("moveAsync endpoint not configured");
    return v(a.moveAsync, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ source: _e, target: Ve, sourceDir: Je })
    });
  }
  async function R(_e, Ve) {
    if (!a.deleteAsync) throw new Error("deleteAsync endpoint not configured");
    return v(a.deleteAsync, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ source: _e, sourceDir: Ve })
    });
  }
  async function pe(_e) {
    if (!a.restore) throw new Error("restore endpoint not configured");
    return v(a.restore, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ source: _e })
    });
  }
  async function Q(_e) {
    if (!a.trashRestore) throw new Error("trashRestore endpoint not configured");
    const Ve = a.trashRestore.includes("?") ? "&" : "?";
    return { ops: (await v(`${a.trashRestore}${Ve}queued=1`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ node_ids: _e })
    })).ops ?? [] };
  }
  async function q(_e) {
    if (!a.trashList) throw new Error("trashList endpoint not configured");
    const Ve = a.trashList, Je = Ve.includes("?") ? "&" : "?", at = _e ? `${Ve}${Je}storage=${encodeURIComponent(_e)}` : Ve;
    return v(at);
  }
  async function re(_e) {
    const Ve = a.trashRestore;
    if (!Ve) throw new Error("trashRestore endpoint not configured");
    let Je = 0, at = 0, xt;
    const Bt = [];
    for (const Ot of _e)
      try {
        await v(Ve, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ node_id: Ot })
        }), Je++;
      } catch (It) {
        const Et = It;
        if (Et.status === 409)
          try {
            const Dt = JSON.parse(Et.detail ?? "");
            if (Dt.code === "EXISTS") {
              Bt.push(Dt.name || String(Ot));
              continue;
            }
          } catch {
          }
        at++, xt === void 0 && (xt = It);
      }
    return xt === void 0 ? { restored: Je, taken: Bt, failed: at } : { restored: Je, taken: Bt, failed: at, failure: xt };
  }
  async function ae(_e, Ve = {}) {
    const Je = a.trashPurge;
    if (!Je) throw new Error("trashPurge endpoint not configured");
    let at = Je.replace("{id}", encodeURIComponent(String(_e)));
    Ve.queued && (at += `${at.includes("?") ? "&" : "?"}queued=1`);
    const xt = await v(at, { method: "DELETE" });
    return xt != null && xt.op ? { op: xt.op } : {};
  }
  async function Pe(_e) {
    const Ve = a.versionPurge;
    if (!Ve) throw new Error("versionPurge endpoint not configured");
    await v(Ve.replace("{id}", encodeURIComponent(String(_e))), { method: "DELETE" });
  }
  async function be(_e, Ve, Je, at) {
    const xt = new FormData();
    xt.append("path", _e);
    for (const [Ot, It] of Object.entries(at ?? {})) xt.append(Ot, It);
    for (const Ot of Ve)
      xt.append("file[]", Ot, Ot.name);
    const Bt = await n();
    return new Promise((Ot, It) => {
      const Et = new XMLHttpRequest();
      Et.open("POST", I("upload"));
      for (const [Dt, aa] of Object.entries(Bt))
        Dt !== "Content-Type" && Et.setRequestHeader(Dt, aa);
      Et.withCredentials = p() === "include", Et.upload.onprogress = (Dt) => {
        Je && Dt.lengthComputable && Je(Math.round(Dt.loaded / Dt.total * 100));
      }, Et.onload = () => {
        if (cv(), Et.status >= 200 && Et.status < 300)
          try {
            Ot(JSON.parse(Et.responseText));
          } catch (Dt) {
            It(Dt);
          }
        else
          It(tn(Et.status, Et.responseText || "", h()));
      }, Et.onerror = () => {
        uv("action"), It(lv(h()));
      }, Et.send(xt);
    });
  }
  function ze(_e) {
    return I("download", { path: _e });
  }
  function Ae(_e) {
    return I("preview", { path: _e });
  }
  async function Ce(_e, Ve = {}) {
    const Je = await n(), at = await fetch(Ae(_e), {
      headers: Je,
      credentials: p(),
      // ⚠ The preview endpoint answers `Cache-Control: private, max-age=60`,
      // which is right for the thing it was built for — a viewer re-opening
      // an image — and wrong for anything the client treats as CONTROL data.
      // `.filex-e2e.json` is control data: after the client rewrites it
      // (recovery upgrade, escrow slot, escrow refusal) the next read inside
      // that minute came back PRE-write, so the folder looked un-upgraded
      // and the question filex had just been answered was asked again.
      // Measured 2026-09-05 in a real browser: decline the escrow offer,
      // reopen the folder, and the offer was back.
      cache: Ve.fresh ? "no-store" : "default"
    });
    if (!at.ok) {
      const It = await at.text().catch(() => "");
      throw tn(at.status, It, h());
    }
    const xt = await at.blob(), Bt = xt.type || at.headers.get("content-type") || "";
    return { url: URL.createObjectURL(xt), blob: xt, mime: Bt };
  }
  async function He(_e) {
    const Ve = await n(), Je = await fetch(Ae(_e), {
      headers: Ve,
      credentials: p()
    });
    if (!Je.ok) {
      const at = await Je.text().catch(() => "");
      throw tn(Je.status, at, h());
    }
    return Je.arrayBuffer();
  }
  async function J() {
    return a.limits ? v(a.limits) : { max_upload_mb: 1024 };
  }
  async function me() {
    return a.capabilities ? v(a.capabilities) : {
      ffmpeg: !1,
      ghostscript: !1,
      libreoffice: !1,
      max_chunk_mb: 5,
      upload_limit_mb: 1024,
      onlyoffice_url: e.onlyOfficeBase ?? null,
      drawio_url: e.drawioBase ?? null
    };
  }
  async function fe() {
    var Ve;
    if (!a.me) return null;
    const _e = await v(a.me);
    return !_e || !Array.isArray(_e.permissions) ? null : {
      admin: ((Ve = _e.user) == null ? void 0 : Ve.role) === "admin",
      permissions: [..._e.permissions, ..._e.permissions_in_folders ?? []],
      byFolder: _e.permissions_by_folder ?? []
    };
  }
  function xe(_e, Ve) {
    return Object.entries(Ve).reduce(
      (Je, [at, xt]) => Je.replaceAll(`{${at}}`, encodeURIComponent(String(xt))),
      _e
    );
  }
  function ye(_e) {
    return `${_e}${_e.includes("?") ? "&" : "?"}lang=${encodeURIComponent(h())}`;
  }
  function qe(_e) {
    return /^https?:\/\//i.test(_e) ? _e : a.manager.replace(/\/api\/files\/manager(\?.*)?$/, "").replace(/\/$/, "") + (_e.startsWith("/") ? _e : `/${_e}`);
  }
  async function ut(_e, Ve, Je) {
    if (!a.pluginUICall) throw new Error("pluginUICall endpoint not configured");
    return v(ye(xe(a.pluginUICall, { plugin: _e, view: Ve })), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(Je)
    });
  }
  async function Ue(_e, Ve, Je, at) {
    if (!a.pluginUISave) throw new Error("pluginUISave endpoint not configured");
    const xt = "path" in Je ? `path=${encodeURIComponent(Je.path)}` : `dir=${encodeURIComponent(Je.dir)}&name=${encodeURIComponent(Je.name)}`, Bt = xe(a.pluginUISave, { plugin: _e, view: Ve }), Ot = `${Bt}${Bt.includes("?") ? "&" : "?"}${xt}`, It = (Ne, Ee) => v(Ne, { method: "PUT", headers: { "Content-Type": "application/octet-stream" }, body: Ee });
    if (at instanceof Blob && at.size <= jo)
      return v(Ot, {
        method: "PUT",
        headers: { "Content-Type": at.type || "application/octet-stream" },
        body: at
      });
    let Et = "", Dt = 0;
    const aa = async (Ne, Ee) => {
      const Ge = Et ? `${Ot}&session=${encodeURIComponent(Et)}&offset=${Dt}${Ee ? "&final=1" : ""}` : `${Ot}&chunk=start${Ee ? "&final=1" : ""}`, ue = await It(Ge, Ne);
      return Ee || (Et = ue.session ?? Et, Dt = ue.received ?? Dt + Ne.size), ue;
    };
    if (at instanceof Blob)
      for (let Ne = 0; ; Ne += jo) {
        const Ee = Math.min(Ne + jo, at.size), Ge = at.slice(Ne, Ee);
        if (Ee >= at.size) return await aa(Ge, !0);
        await aa(Ge, !1);
      }
    const V = at.getReader();
    let oe = [], Oe = 0;
    for (; ; ) {
      const { done: Ne, value: Ee } = await V.read();
      for (Ee && Ee.byteLength && (oe.push(Ee), Oe += Ee.byteLength); Oe >= jo && !Ne; ) {
        const Ge = new Blob(oe);
        await aa(Ge.slice(0, jo), !1);
        const ue = new Uint8Array(await Ge.slice(jo).arrayBuffer());
        oe = ue.byteLength ? [ue] : [], Oe = ue.byteLength;
      }
      if (Ne) {
        const Ge = new Blob(oe);
        return !Et && Ge.size <= jo ? v(Ot, { method: "PUT", headers: { "Content-Type": "application/octet-stream" }, body: Ge }) : await aa(Ge, !0);
      }
    }
  }
  async function Ye(_e) {
    const Ve = await n(), Je = await fetch(Ae(_e), { headers: Ve, credentials: p(), cache: "no-store" });
    if (!Je.ok) {
      const at = await Je.text().catch(() => "");
      throw tn(Je.status, at, h());
    }
    return Je;
  }
  async function st() {
    if (!a.pluginActions) return { actions: [], views: [] };
    const _e = await v(a.pluginActions);
    return { actions: (_e == null ? void 0 : _e.actions) ?? [], views: (_e == null ? void 0 : _e.views) ?? [] };
  }
  async function kt(_e, Ve, Je) {
    if (!a.pluginActionRun) throw new Error("pluginActionRun endpoint not configured");
    return v(ye(xe(a.pluginActionRun, { plugin: _e, action: Ve })), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(Je)
    });
  }
  async function At(_e, Ve, Je, at) {
    if (!a.pluginView) throw new Error("pluginView endpoint not configured");
    const xt = xe(a.pluginView, { plugin: _e, view: Ve }), Bt = [
      Je ? `path=${encodeURIComponent(Je)}` : "",
      at ? `section=${encodeURIComponent(at)}` : ""
    ].filter(Boolean);
    return v(ye(xt + (Bt.length ? `?${Bt.join("&")}` : "")));
  }
  async function _t(_e, Ve, Je) {
    if (!a.pluginViewEvent) throw new Error("pluginViewEvent endpoint not configured");
    return v(ye(xe(a.pluginViewEvent, { plugin: _e, view: Ve })), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(Je)
    });
  }
  async function Le(_e, Ve) {
    if (!a.pluginUsers) throw Object.assign(new Error("pluginUsers endpoint not configured"), { status: 404 });
    const Je = `${a.pluginUsers}?plugin=${encodeURIComponent(_e)}&q=${encodeURIComponent(Ve)}`, at = await v(Je);
    return { users: (at == null ? void 0 : at.users) ?? [] };
  }
  async function tt(_e) {
    if (!a.opsCancel) throw new Error("opsCancel endpoint not configured");
    await v(xe(a.opsCancel, { id: _e }), { method: "POST" });
  }
  async function ve(_e) {
    if (!a.e2eEscrowChallenge) throw new Error("e2e escrow endpoint not configured");
    return v(a.e2eEscrowChallenge, {
      method: "POST",
      body: JSON.stringify({ path: _e })
    });
  }
  async function H(_e) {
    if (!a.e2eEscrowUsed) throw new Error("e2e escrow endpoint not configured");
    return v(a.e2eEscrowUsed, {
      method: "POST",
      body: JSON.stringify(_e)
    });
  }
  async function te(_e, Ve = 16) {
    const Je = { ...await n(), Range: `bytes=0-${Ve - 1}` }, at = await fetch(Ae(_e), { headers: Je, credentials: p(), cache: "no-store" });
    if (!at.ok) {
      const It = await at.text().catch(() => "");
      throw tn(at.status, It, h());
    }
    if (!at.body) return new Uint8Array(await at.arrayBuffer()).slice(0, Ve);
    const xt = at.body.getReader(), Bt = new Uint8Array(Ve);
    let Ot = 0;
    try {
      for (; Ot < Ve; ) {
        const { done: It, value: Et } = await xt.read();
        if (It || !Et) break;
        const Dt = Math.min(Et.length, Ve - Ot);
        Bt.set(Et.subarray(0, Dt), Ot), Ot += Dt;
      }
    } finally {
      xt.cancel().catch(() => {
      });
    }
    return Bt.slice(0, Ot);
  }
  async function Te(_e) {
    if (!a.e2eCleanup) throw new Error("e2e cleanup endpoint not configured");
    return v(a.e2eCleanup, { method: "POST", body: JSON.stringify(_e) });
  }
  async function L(_e) {
    if (!a.e2ePasswordChanged) throw new Error("e2e password endpoint not configured");
    return v(a.e2ePasswordChanged, {
      method: "POST",
      body: JSON.stringify(_e)
    });
  }
  async function se(_e) {
    if (!a.shareCreate) throw new Error("shareCreate endpoint not configured");
    return v(a.shareCreate, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(_e)
    });
  }
  async function ne(_e) {
    if (!a.shareList) return { shares: [] };
    const Ve = a.shareList.includes("?") ? "&" : "?";
    return v(`${a.shareList}${Ve}path=${encodeURIComponent(_e)}`);
  }
  async function et(_e) {
    if (!a.shareDelete) throw new Error("shareDelete endpoint not configured");
    const Ve = a.shareDelete.replace("{uuid}", encodeURIComponent(_e));
    return v(Ve, { method: "DELETE" });
  }
  async function ht(_e, Ve) {
    if (!a.archiveList) throw new Error("archiveList endpoint not configured");
    return {
      entries: (await v(
        a.archiveList,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ path: _e, password: Ve })
        }
      )).entries.map((at) => ({
        name: at.name,
        size: at.size,
        isDir: at.is_dir,
        lastModified: at.mtime
      }))
    };
  }
  async function Tt(_e, Ve = {}) {
    if (!a.archiveExtract) throw new Error("archiveExtract endpoint not configured");
    return v(a.archiveExtract, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: _e, ...Ve })
    });
  }
  async function Ft(_e) {
    if (!a.archiveCreate) throw new Error("archiveCreate endpoint not configured");
    return v(a.archiveCreate, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(_e)
    });
  }
  async function Lt(_e, Ve) {
    if (!a.archiveAdd) throw new Error("archiveAdd endpoint not configured");
    return v(a.archiveAdd, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: _e, files: Ve })
    });
  }
  function ua(_e = "") {
    return a.manager.replace(/\/manager(\?.*)?$/, "/versions") + _e;
  }
  async function Ct(_e) {
    const Ve = await v(
      ua() + "?node_id=" + encodeURIComponent(String(_e))
    );
    return Array.isArray(Ve == null ? void 0 : Ve.versions) ? Ve.versions : [];
  }
  async function Qt(_e, Ve, Je = !0) {
    await v(ua("/restore"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        node_id: _e,
        version_id: Ve,
        snapshot_current: Je
      })
    });
  }
  async function ta(_e) {
    await v(ua("/snapshot"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ node_id: _e })
    });
  }
  function Rt(_e = "") {
    return a.manager.replace(/\/manager(\?.*)?$/, "/comments") + _e;
  }
  async function va(_e) {
    const Ve = await v(
      Rt() + "?node_id=" + encodeURIComponent(String(_e))
    );
    return Array.isArray(Ve == null ? void 0 : Ve.comments) ? Ve.comments : [];
  }
  async function ha(_e, Ve) {
    return (await v(Rt(), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ node_id: _e, body: Ve })
    })).comment;
  }
  async function _a(_e) {
    await v(Rt("/" + encodeURIComponent(String(_e))), {
      method: "DELETE"
    });
  }
  async function ia() {
    const _e = a.manager.replace(/\/manager(\?.*)?$/, "/ws-ticket");
    try {
      return await v(_e, { method: "POST" });
    } catch {
      return null;
    }
  }
  return {
    // Realtime
    wsTicket: ia,
    // Manager
    index: F,
    search: W,
    globalSearch: N,
    quotaMe: K,
    storageUsage: M,
    subfolders: j,
    newFolder: U,
    newFile: de,
    drafts: m,
    draftsBase: g,
    rename: ke,
    renameQueued: ie,
    move: ce,
    copy: Y,
    moveAsync: we,
    deleteAsync: R,
    deleteItems: X,
    allowedAt: Z,
    myPermissions: fe,
    restore: pe,
    listTrash: q,
    restoreIds: re,
    restoreQueued: Q,
    purgeTrash: ae,
    purgeVersion: Pe,
    uploadMultipart: be,
    downloadUrl: ze,
    previewUrl: Ae,
    fetchBlob: Ce,
    fetchArrayBuffer: He,
    // Peripheral
    limits: J,
    capabilities: me,
    /* wiring:e2 */
    e2eEscrowChallenge: ve,
    e2eEscrowUsed: H,
    e2ePasswordChanged: L,
    e2eCleanup: Te,
    fetchHead: te,
    transferNamed: G,
    /* App plugins */
    pluginActions: st,
    pluginActionRun: kt,
    pluginView: At,
    pluginViewEvent: _t,
    pluginUsers: Le,
    opsCancel: tt,
    appUIUrl: qe,
    pluginUICall: ut,
    pluginUISave: Ue,
    fetchResponse: Ye,
    createShare: se,
    listShares: ne,
    revokeShare: et,
    archiveList: ht,
    archiveExtract: Tt,
    archiveCreate: Ft,
    archiveAdd: Lt,
    // Version history (koru:k1 inspector)
    listVersions: Ct,
    restoreVersion: Qt,
    snapshotVersion: ta,
    // Node comments (calisma:d3 inspector)
    listComments: va,
    addComment: ha,
    deleteComment: _a,
    // Permissions (RBAC panel)
    listPermissions: _,
    resolveEmail: w,
    searchUsers: $,
    addPermission: C,
    updatePermission: E,
    deletePermission: A,
    invitePermission: O,
    shareMail: z,
    // Internals (exposed for useUploadChunked + PreviewModal)
    endpoints: a,
    authHeaders: n,
    authHeadersSync: o,
    credentialsMode: p,
    jsonFetch: v,
    withScreenLang: ye
  };
}
function gr() {
  const e = globalThis.crypto;
  if (typeof (e == null ? void 0 : e.randomUUID) == "function") return e.randomUUID();
  const a = new Uint8Array(16);
  if (typeof (e == null ? void 0 : e.getRandomValues) == "function") e.getRandomValues(a);
  else for (let s = 0; s < a.length; s++) a[s] = Math.floor(Math.random() * 256);
  a[6] = a[6] & 15 | 64, a[8] = a[8] & 63 | 128;
  const t = Array.from(a, (s) => s.toString(16).padStart(2, "0")).join("");
  return `${t.slice(0, 8)}-${t.slice(8, 12)}-${t.slice(12, 16)}-${t.slice(16, 20)}-${t.slice(20)}`;
}
const hh = "filex:uploads:v1", sC = 24 * 60 * 60 * 1e3;
function gp(e, a) {
  return [e, a.name, a.size, a.lastModified ?? 0].join("\0");
}
function oC() {
  try {
    return typeof localStorage > "u" ? null : (localStorage.getItem(hh), localStorage);
  } catch {
    return null;
  }
}
function mh(e) {
  if (!e) return {};
  try {
    const a = e.getItem(hh);
    if (!a) return {};
    const t = JSON.parse(a);
    return t && typeof t == "object" ? t : {};
  } catch {
    return {};
  }
}
function yh(e, a) {
  if (e)
    try {
      e.setItem(hh, JSON.stringify(a));
    } catch {
    }
}
function Jk(e, a = Date.now()) {
  const t = mh(e);
  let s = !1;
  for (const [n, o] of Object.entries(t))
    (!(o != null && o.uploadId) || a - (o.updatedAt ?? 0) > sC) && (delete t[n], s = !0);
  return s && yh(e, t), t;
}
function Hg(e, a, t = Date.now()) {
  return Jk(e, t)[a] ?? null;
}
function Kg(e, a, t, s = Date.now()) {
  const n = mh(e);
  n[a] = { ...t, updatedAt: s }, yh(e, n);
}
function Al(e, a) {
  const t = mh(e);
  a in t && (delete t[a], yh(e, t));
}
function iC(e, a = Date.now()) {
  return Object.values(Jk(e, a)).sort((t, s) => s.updatedAt - t.updatedAt);
}
function rC(e) {
  return !e || e === "staging";
}
function Vg(e) {
  return e.stagedUnsupported = !0, e;
}
function gh(e) {
  return !!(e != null && e.stagedUnsupported);
}
function lC(e, a, t = oC()) {
  const s = e.chunkSize ?? 8388608;
  function n() {
    const _ = a.endpoints.uploadBegin;
    return _ ? _.replace(/\/begin$/, "") : a.endpoints.manager.replace(/\/manager(\?.*)?$/, "/upload");
  }
  function o() {
    return !!n();
  }
  function p() {
    return s;
  }
  function h(_) {
    return o() && _.size > p();
  }
  function v(_, w) {
    return Hg(t, gp(_, w));
  }
  function y() {
    return iC(t);
  }
  async function g(_) {
    Al(t, gp(_.path, { name: _.name, size: _.size, lastModified: _.lastModified }));
    try {
      await a.jsonFetch(`${n()}/${encodeURIComponent(_.uploadId)}`, { method: "DELETE" });
    } catch {
    }
  }
  async function m(_) {
    return a.jsonFetch(`${n()}/${encodeURIComponent(_)}`);
  }
  async function k(_) {
    var N, K, M;
    const w = gp(_.path, _.file), $ = _.source ?? null, C = $ ? $.size : _.file.size, E = $ ? null : t, A = {
      id: gr(),
      file: _.file,
      path: _.path,
      totalBytes: C,
      uploadedBytes: 0,
      percent: 0,
      status: "initializing",
      cancel: () => {
      }
    };
    let O = !1, z = null;
    A.cancel = () => {
      var j;
      O = !0, z == null || z.abort(), (j = $ == null ? void 0 : $.cancel) == null || j.call($);
    };
    let P = 0;
    function I(j = 0) {
      var U;
      A.uploadedBytes = Math.min(A.totalBytes, P + j), A.percent = A.totalBytes > 0 ? Math.min(100, Math.round(A.uploadedBytes / A.totalBytes * 100)) : A.status === "done" ? 100 : 0, (U = _.onProgress) == null || U.call(_, A);
    }
    try {
      if (!o())
        throw Vg(new Error("staged upload endpoint not configured"));
      const j = n();
      let U = "", de = _.chunkSize ?? s;
      const ke = Hg(E, w);
      if (ke)
        try {
          const X = await m(ke.uploadId);
          rC(X.state) && (X.total_size ?? 0) === C ? (U = ke.uploadId, de = X.chunk_size ?? X.chunkSize ?? ke.chunkSize, P = X.offset ?? 0, A.resumedFrom = P) : Al(E, w);
        } catch {
          Al(E, w);
        }
      if (!U) {
        let X;
        try {
          X = await a.jsonFetch(`${j}/begin`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              path: _.path,
              name: _.file.name,
              size: C,
              mime: _.file.type || "application/octet-stream",
              // Asked for, not imposed: the server clamps this to its own
              // limits and its answer is what the loop below uses.
              chunk_size: _.chunkSize ?? s
            })
          });
        } catch (Z) {
          const Y = Z.status;
          throw (Y === 404 || Y === 501) && Vg(Z), Z;
        }
        if (!(X != null && X.id)) throw new Error("begin returned no upload id");
        U = X.id, de = X.chunk_size ?? X.chunkSize ?? de, P = X.offset ?? 0;
      }
      A.uploadId = U, A.status = "uploading", Kg(E, w, {
        uploadId: U,
        path: _.path,
        name: _.file.name,
        size: C,
        lastModified: _.file.lastModified,
        chunkSize: de,
        offset: P
      }), I();
      const ie = 4;
      for (; P < C; ) {
        if (O) throw new DOMException("Aborted by user", "AbortError");
        const X = Math.min(P + de, C), Z = $ ? await $.read(P, X) : _.file.slice(P, X);
        let Y = -1, G = null;
        for (let we = 0; we < ie; we++) {
          if (we > 0) {
            if (await jg(300 * we + Math.floor(Math.random() * 150)), O) throw new DOMException("Aborted by user", "AbortError");
            try {
              const R = await m(U);
              if ((R.offset ?? 0) >= X) {
                Y = R.offset ?? X;
                break;
              }
              if ((R.offset ?? 0) !== P) {
                P = R.offset ?? P, I(), Y = -2;
                break;
              }
            } catch {
            }
          }
          try {
            Y = await F(U, Z, P, X, C);
            break;
          } catch (R) {
            const pe = R instanceof Error ? R : new Error(String(R));
            if (O || pe.name === "AbortError") throw pe;
            const Q = pe.status;
            if (Q && Q !== 400 && Q !== 409 && Q < 500) throw pe;
            G = pe;
          }
        }
        if (Y !== -2) {
          if (Y < 0) throw G ?? new Error("chunk upload failed");
          if (Y <= P)
            throw console.warn("[filex] upload stalled at byte", P), new Error(vu(Ha(e.locale))("err.upload_stalled"));
          P = Y, I(), Kg(E, w, {
            uploadId: U,
            path: _.path,
            name: _.file.name,
            size: C,
            lastModified: _.file.lastModified,
            chunkSize: de,
            offset: P
          });
        }
      }
      if (O) throw new DOMException("Aborted by user", "AbortError");
      A.status = "committing", I();
      const ce = await a.jsonFetch(
        `${j}/${encodeURIComponent(U)}/commit`,
        { method: "POST" }
      );
      return Al(E, w), A.opId = ce == null ? void 0 : ce.op_id, A.nodeId = ce == null ? void 0 : ce.node_id, _.waitForTransfer !== !1 && (ce != null && ce.op_id) && a.endpoints.opsShow && (A.status = "transferring", I(), await W(ce.op_id)), A.status = "done", P = A.totalBytes, I(), (N = _.onDone) == null || N.call(_, A, ce), ce;
    } catch (j) {
      const U = j instanceof Error ? j : new Error(String(j));
      if (A.status = U.name === "AbortError" ? "aborted" : "error", A.error = U.message, I(), gh(U) || (K = $ == null ? void 0 : $.cancel) == null || K.call($), A.uploadId && (A.status === "aborted" || $)) {
        Al(E, w);
        try {
          await a.jsonFetch(`${n()}/${encodeURIComponent(A.uploadId)}`, {
            method: "DELETE"
          });
        } catch {
        }
      }
      throw (M = _.onError) == null || M.call(_, A, U), U;
    }
    function F(j, U, de, ke, ie) {
      return new Promise((ce, X) => {
        const Z = new XMLHttpRequest();
        z = Z, Z.open("PUT", `${n()}/${encodeURIComponent(j)}`);
        const Y = a.authHeadersSync({
          "Content-Type": "application/octet-stream",
          "Content-Range": `bytes ${de}-${ke - 1}/${ie}`
        });
        for (const [G, we] of Object.entries(Y)) Z.setRequestHeader(G, we);
        Z.withCredentials = a.credentialsMode() === "include", Z.upload.onprogress = (G) => {
          G.lengthComputable && I(G.loaded);
        }, Z.onload = () => {
          if (z = null, cv(), Z.status >= 200 && Z.status < 300) {
            try {
              const G = JSON.parse(Z.responseText);
              ce(G.offset ?? ke);
            } catch {
              ce(ke);
            }
            return;
          }
          X(tn(Z.status, Z.responseText || "", Ha(e.locale)));
        }, Z.onerror = () => {
          z = null, uv("action"), X(lv(Ha(e.locale)));
        }, Z.onabort = () => {
          z = null, X(new DOMException("Aborted", "AbortError"));
        }, Z.send(U);
      });
    }
    async function W(j) {
      const U = a.endpoints.opsShow;
      if (!U) return;
      const de = U.replace("{id}", String(j));
      let ke = 200, ie = 0;
      for (; ; ) {
        if (O) throw new DOMException("Aborted by user", "AbortError");
        try {
          const ce = await a.jsonFetch(de);
          if ((ce == null ? void 0 : ce.status) === "ok") return;
          if ((ce == null ? void 0 : ce.status) === "failed" || (ce == null ? void 0 : ce.status) === "partial")
            throw new qg(ce.error || "transfer failed");
          ie = 0;
        } catch (ce) {
          if (ce instanceof qg || ce.name === "AbortError") throw ce;
          if (++ie >= uC) return;
        }
        await jg(ke), ke = Math.min(ke * 2, 2e3);
      }
    }
  }
  return {
    uploadFile: k,
    /** True when this file is big enough (and the endpoints exist) to chunk. */
    shouldChunk: h,
    /** The size at which chunking kicks in. */
    threshold: p,
    resumableFor: v,
    listResumable: y,
    discardResumable: g
  };
}
const uC = 6;
class qg extends Error {
  constructor(a) {
    super(a), this.name = "TransferFailedError";
  }
}
function jg(e) {
  return new Promise((a) => setTimeout(a, e));
}
function Wg(e) {
  const a = b(/* @__PURE__ */ new Set()), t = b(null);
  function s(k, _ = {}) {
    if (_.shift && t.value) {
      const w = e(), $ = w.findIndex((z) => z.path === t.value), C = w.findIndex((z) => z.path === k);
      if ($ === -1 || C === -1) {
        a.value = /* @__PURE__ */ new Set([k]), t.value = k;
        return;
      }
      const [E, A] = $ < C ? [$, C] : [C, $], O = /* @__PURE__ */ new Set();
      for (let z = E; z <= A; z++) O.add(w[z].path);
      a.value = O;
      return;
    }
    if (_.ctrl) {
      const w = new Set(a.value);
      w.has(k) ? w.delete(k) : w.add(k), a.value = w, t.value = k;
      return;
    }
    a.value = /* @__PURE__ */ new Set([k]), t.value = k;
  }
  function n() {
    a.value = /* @__PURE__ */ new Set(), t.value = null;
  }
  function o() {
    a.value = new Set(e().map((k) => k.path));
  }
  function p(k) {
    return a.value.has(k);
  }
  function h(k) {
    const _ = new Set(a.value);
    _.add(k), a.value = _;
  }
  function v(k) {
    const _ = new Set(a.value);
    _.delete(k), a.value = _;
  }
  const y = x(() => a.value.size), g = x(() => a.value.size === 0), m = x(() => e().filter((_) => a.value.has(_.path)));
  return { selected: a, anchor: t, click: s, clear: n, selectAll: o, has: p, add: h, remove: v, size: y, isEmpty: g, nodes: m };
}
function Zk(e) {
  var t;
  const a = e;
  return !a || typeof a.tagName != "string" ? !1 : a.tagName === "INPUT" || a.tagName === "TEXTAREA" || a.tagName === "SELECT" || a.isContentEditable || ((t = a.getAttribute) == null ? void 0 : t.call(a, "role")) === "textbox" ? !0 : typeof a.closest == "function" && !!a.closest(".monaco-editor");
}
const cC = /* @__PURE__ */ new Set([
  "Ctrl+N",
  "Ctrl+Shift+N",
  "Ctrl+T",
  "Ctrl+Shift+T",
  "Ctrl+W",
  "Ctrl+Shift+W",
  "Ctrl+Tab",
  "Ctrl+Shift+Tab",
  "Ctrl+Q",
  "Ctrl+Shift+I",
  "Ctrl+Shift+J",
  "Ctrl+Shift+C",
  "F11",
  "F12"
]);
function Yg(e) {
  return cC.has(e);
}
const wo = [
  // Navigation
  { id: "palette", defaultCombo: "Ctrl+K", labelKey: "shortcuts.palette", groupKey: "shortcuts.group.nav" },
  { id: "search", defaultCombo: "/", labelKey: "shortcuts.search", groupKey: "shortcuts.group.nav" },
  { id: "go-up", defaultCombo: "Alt+↑", fixedCombos: ["Backspace"], labelKey: "shortcuts.go_up", groupKey: "shortcuts.group.nav" },
  { id: "open", defaultCombo: "Enter", prevent: !1, labelKey: "shortcuts.open", groupKey: "shortcuts.group.nav" },
  { id: "quicklook", defaultCombo: "Space", labelKey: "shortcuts.quicklook", groupKey: "shortcuts.group.nav" },
  { id: "close", defaultCombo: "Esc", customizable: !1, prevent: !1, inForms: !0, labelKey: "shortcuts.close", groupKey: "shortcuts.group.nav" },
  { id: "inspector", defaultCombo: "I", labelKey: "shortcuts.inspector", groupKey: "shortcuts.group.nav" },
  { id: "help", defaultCombo: "?", labelKey: "shortcuts.help", groupKey: "shortcuts.group.nav" },
  { id: "toggle-hidden", defaultCombo: "Ctrl+Shift+.", labelKey: "shortcuts.toggle_hidden", groupKey: "shortcuts.group.nav" },
  /* yildiz:s1 — starring is an action, so it belongs where the other verbs
   * are. A bare letter like the inspector's `I`; the handler ignores events
   * from form controls, so it never eats a keystroke meant for a filename. */
  { id: "star", defaultCombo: "S", labelKey: "shortcuts.star", groupKey: "shortcuts.group.file" },
  // Selection
  { id: "select-all", defaultCombo: "Ctrl+A", labelKey: "shortcuts.select_all", groupKey: "shortcuts.group.selection" },
  // File operations
  { id: "rename", defaultCombo: "F2", labelKey: "shortcuts.rename", groupKey: "shortcuts.group.file" },
  { id: "delete", defaultCombo: "Del", labelKey: "shortcuts.delete", groupKey: "shortcuts.group.file" },
  { id: "cut", defaultCombo: "Ctrl+X", labelKey: "shortcuts.cut", groupKey: "shortcuts.group.file" },
  { id: "copy", defaultCombo: "Ctrl+C", labelKey: "shortcuts.copy", groupKey: "shortcuts.group.file" },
  { id: "paste", defaultCombo: "Ctrl+V", labelKey: "shortcuts.paste", groupKey: "shortcuts.group.file" },
  /* wiring:d1 — tabs. Note: browsers reserve Ctrl+T/W/Tab in normal pages
   * (preventDefault can't stop them there); they work in webcomponent/PWA/
   * kiosk contexts and stay remappable through the settings modal. */
  { id: "tab-new", defaultCombo: "Ctrl+T", labelKey: "shortcuts.tab_new", groupKey: "shortcuts.group.tabs" },
  { id: "tab-close", defaultCombo: "Ctrl+W", labelKey: "shortcuts.tab_close", groupKey: "shortcuts.group.tabs" },
  { id: "tab-next", defaultCombo: "Ctrl+Tab", labelKey: "shortcuts.tab_next", groupKey: "shortcuts.group.tabs" },
  { id: "tab-prev", defaultCombo: "Ctrl+Shift+Tab", labelKey: "shortcuts.tab_prev", groupKey: "shortcuts.group.tabs" },
  /* /wiring:d1 */
  /* tus:t1 — the rest of the menu verbs. Until now these were reachable only
   * by right-clicking, and the right-click menu named no keys at all, so 16 of
   * the registry's actions were invisible unless somebody opened the `?` sheet
   * on their own. The ones with no default are deliberate: they are rare
   * enough that taking a key from the user by default is the wrong trade, and
   * they are in the registry so the user can take one. */
  { id: "new-folder", defaultCombo: "Shift+N", labelKey: "shortcuts.new_folder", groupKey: "shortcuts.group.file" },
  { id: "upload", defaultCombo: "U", labelKey: "shortcuts.upload", groupKey: "shortcuts.group.file" },
  { id: "refresh", defaultCombo: "R", labelKey: "shortcuts.refresh", groupKey: "shortcuts.group.nav" },
  { id: "download", defaultCombo: "D", labelKey: "shortcuts.download", groupKey: "shortcuts.group.file" },
  { id: "preview", defaultCombo: "P", labelKey: "shortcuts.preview", groupKey: "shortcuts.group.nav" },
  { id: "share", defaultCombo: "Shift+S", labelKey: "shortcuts.share", groupKey: "shortcuts.group.file" },
  { id: "tags", defaultCombo: "T", labelKey: "shortcuts.tags", groupKey: "shortcuts.group.file" },
  { id: "open-tab", defaultCombo: "", labelKey: "shortcuts.open_tab", groupKey: "shortcuts.group.tabs" },
  { id: "copy-path", defaultCombo: "", labelKey: "shortcuts.copy_path", groupKey: "shortcuts.group.file" },
  { id: "copy-id", defaultCombo: "", labelKey: "shortcuts.copy_id", groupKey: "shortcuts.group.file" },
  { id: "restore", defaultCombo: "", labelKey: "shortcuts.restore", groupKey: "shortcuts.group.file" }
  /* /tus:t1 */
], dC = {
  palette: "onPathJump",
  search: "onFocusSearch",
  "go-up": "onGoUp",
  open: "onOpen",
  quicklook: "onQuickLook",
  close: "onClose",
  inspector: "onToggleInspector",
  "toggle-hidden": "onToggleHidden",
  star: "onStar",
  help: "onShowHelp",
  "select-all": "onSelectAll",
  rename: "onRename",
  delete: "onDelete",
  cut: "onCut",
  copy: "onCopy",
  paste: "onPaste",
  /* wiring:d1 */
  "tab-new": "onTabNew",
  "tab-close": "onTabClose",
  "tab-next": "onTabNext",
  "tab-prev": "onTabPrev",
  /* tus:t1 */
  "new-folder": "onNewFolder",
  upload: "onUpload",
  refresh: "onRefresh",
  download: "onDownload",
  preview: "onPreview",
  share: "onShare",
  tags: "onTags",
  "open-tab": "onOpenTab",
  "copy-path": "onCopyPath",
  "copy-id": "onCopyId",
  restore: "onRestore"
}, dv = "filex.shortcuts";
function fC() {
  try {
    const e = localStorage.getItem(dv);
    if (!e) return {};
    const a = JSON.parse(e);
    if (!a || typeof a != "object") return {};
    const t = {};
    for (const [s, n] of Object.entries(a))
      typeof n == "string" && wo.some((o) => o.id === s) && (t[s] = n);
    return t;
  } catch {
    return {};
  }
}
const cs = b(fC());
function bh() {
  try {
    Object.keys(cs.value).length === 0 ? localStorage.removeItem(dv) : localStorage.setItem(dv, JSON.stringify(cs.value));
  } catch {
  }
}
function _h(e) {
  return wo.find((a) => a.id === e);
}
function Ur(e) {
  var t;
  const a = cs.value[e];
  return a !== void 0 ? a : ((t = _h(e)) == null ? void 0 : t.defaultCombo) ?? "";
}
function bp(e, a) {
  const t = _h(e);
  if (!t || t.customizable === !1) return;
  const s = { ...cs.value };
  a === t.defaultCombo ? delete s[e] : s[e] = a, cs.value = s, bh();
}
function pC(e) {
  if (!(e in cs.value)) return;
  const a = { ...cs.value };
  delete a[e], cs.value = a, bh();
}
function vC() {
  cs.value = {}, bh();
}
function hC(e, a) {
  var t;
  if (!e) return null;
  for (const s of wo)
    if (s.id !== a) {
      if ((t = s.fixedCombos) != null && t.includes(e)) return { id: s.id, fixed: !0 };
      if (Ur(s.id) === e) return { id: s.id, fixed: s.customizable === !1 };
    }
  return null;
}
const mC = {
  " ": "Space",
  Spacebar: "Space",
  Escape: "Esc",
  Delete: "Del",
  ArrowUp: "↑",
  ArrowDown: "↓",
  ArrowLeft: "←",
  ArrowRight: "→",
  PageUp: "PgUp",
  PageDown: "PgDn"
}, yC = /* @__PURE__ */ new Set(["Control", "Alt", "Shift", "Meta", "AltGraph", "CapsLock", "NumLock", "ScrollLock", "Fn", "Dead"]);
function gC(e) {
  const a = e.key;
  if (!a || yC.has(a)) return null;
  const t = mC[a];
  return t || (a.length === 1 ? a.toUpperCase() : a);
}
function kh(e) {
  const a = gC(e);
  if (!a) return null;
  const t = [];
  (e.ctrlKey || e.metaKey) && t.push("Ctrl"), e.altKey && t.push("Alt");
  const s = a.length === 1 && a.toUpperCase() === a.toLowerCase();
  return e.shiftKey && !s && t.push("Shift"), t.push(a), t.join("+");
}
function Qk() {
  return x(
    () => wo.map((e) => {
      const a = Ur(e.id), t = e.fixedCombos ?? [];
      return {
        id: e.id,
        combo: a,
        fixedCombos: t,
        keys: [a, ...t].filter((s) => !!s),
        labelKey: e.labelKey,
        groupKey: e.groupKey,
        customizable: e.customizable !== !1,
        overridden: cs.value[e.id] !== void 0
      };
    })
  );
}
function bC() {
  return typeof navigator < "u" && /mac|iphone|ipad|ipod/i.test(navigator.platform || navigator.userAgent || "");
}
function _C(e) {
  return e ? bC() ? e.replace(/\bCtrl\b/g, "⌘") : e : "";
}
const kC = {
  open: "open",
  "open-tab": "open-tab",
  preview: "preview",
  download: "download",
  access: "share",
  details: "inspector",
  "copy-id": "copy-id",
  "copy-path": "copy-path",
  rename: "rename",
  cut: "cut",
  copy: "copy",
  paste: "paste",
  star: "star",
  tags: "tags",
  delete: "delete",
  restore: "restore",
  "new-folder": "new-folder",
  "toggle-hidden": "toggle-hidden",
  upload: "upload",
  refresh: "refresh"
};
function ew(e) {
  const a = kC[e] ?? e;
  return wo.some((t) => t.id === a) ? Ar(a) : "";
}
function Ar(e) {
  return _C(Ur(e));
}
function fv(e, a) {
  var n, o;
  const t = Ur(a);
  if (!t) return !1;
  const s = kh(e);
  return s === t ? !0 : ((o = (n = _h(a)) == null ? void 0 : n.fixedCombos) == null ? void 0 : o.includes(s ?? "")) ?? !1;
}
wo.map((e) => ({
  keys: [e.defaultCombo, ...e.fixedCombos ?? []].filter((a) => !!a),
  labelKey: e.labelKey,
  groupKey: e.groupKey
}));
function wC(e, a) {
  const t = x(() => {
    const n = /* @__PURE__ */ new Map();
    for (const o of wo) {
      const p = Ur(o.id);
      p && n.set(p, o);
    }
    return n;
  });
  function s(n) {
    var m;
    if (!e.value || n.key !== "Escape" && document.querySelector(".fe-ctx-backdrop")) return;
    const p = n.target, h = Zk(p), v = kh(n);
    if (!v) return;
    if (v === "Backspace") {
      if (h) return;
      (m = a.hasSelection) != null && m.call(a) && a.onDelete ? (n.preventDefault(), a.onDelete()) : a.onGoUp && (n.preventDefault(), a.onGoUp());
      return;
    }
    const y = t.value.get(v);
    if (!y || h && !y.inForms || v === "Space" && p && typeof p.closest == "function" && p.closest('button, a, select, summary, [role="button"], [role="menuitem"]'))
      return;
    const g = a[dC[y.id]];
    g && (y.prevent !== !1 && n.preventDefault(), g());
  }
  Kt(() => window.addEventListener("keydown", s)), Mt(() => window.removeEventListener("keydown", s));
}
function Ld() {
  let e;
  try {
    e = typeof window < "u" && typeof window.matchMedia == "function" ? window.matchMedia("(prefers-color-scheme: dark)") : void 0;
  } catch {
    e = void 0;
  }
  const a = b(!!(e != null && e.matches)), t = (s) => {
    a.value = s.matches;
  };
  return Kt(() => {
    var s;
    return (s = e == null ? void 0 : e.addEventListener) == null ? void 0 : s.call(e, "change", t);
  }), Mt(() => {
    var s;
    return (s = e == null ? void 0 : e.removeEventListener) == null ? void 0 : s.call(e, "change", t);
  }), a;
}
const xC = 2e3, $C = 8e3;
function Gg(e) {
  const a = (...v) => {
    for (const y of v) if (typeof y == "number") return y;
    return 0;
  }, t = (...v) => {
    for (const y of v) if (typeof y == "string" && y !== "") return y;
    return null;
  }, s = String(e.status ?? "pending"), n = s === "ok" || s === "done" ? "done" : s === "failed" || s === "partial" || s === "error" ? "error" : s === "cancelled" ? "cancelled" : s === "cancelling" ? "cancelling" : s === "running" ? "running" : "pending", o = Array.isArray(e.sources) ? e.sources : [], p = t(e.op_type, e.kind) ?? "delete", h = Array.isArray(e.outputs) ? e.outputs.map((v) => v && typeof v == "object" ? t(v.path) : null).filter((v) => v !== null).map((v) => ({ path: v })) : void 0;
  return {
    id: a(e.id),
    op_type: p === "plugin-action" ? "plugin" : p,
    status: n,
    progress_total: a(e.progress_total, e.total, o.length),
    progress_done: a(e.progress_done, e.done),
    bytes_total: a(e.bytes_total),
    bytes_done: a(e.bytes_done),
    objects_total: a(e.objects_total),
    objects_done: a(e.objects_done),
    target_path: t(e.target_path, e.dest),
    source_dir: t(e.source_dir),
    source_count: a(e.source_count, o.length),
    error_message: t(e.error_message, e.error),
    error_code: t(e.error_code) ?? void 0,
    error_engine: t(e.error_engine) ?? void 0,
    cancellable: e.cancellable === !0,
    started_at: t(e.started_at),
    finished_at: t(e.finished_at),
    created_at: t(e.created_at),
    plugin: t(e.plugin) ?? void 0,
    action: t(e.action) ?? void 0,
    label: t(e.label) ?? void 0,
    message: t(e.message) ?? void 0,
    outputs: h
  };
}
function SC(e, a, t = {}) {
  const s = b([]), n = /* @__PURE__ */ new Set(), o = /* @__PURE__ */ new Set(), p = /* @__PURE__ */ new Map();
  let h = !1;
  const v = x(
    () => s.value.some(($) => $.status === "pending" || $.status === "running" || $.status === "cancelling")
  );
  let y;
  function g() {
    y || a.endpoints.opsList && (y = setInterval(() => {
      k();
    }, xC), k());
  }
  function m() {
    y && (clearInterval(y), y = void 0);
  }
  async function k() {
    var $;
    if (a.endpoints.opsList)
      try {
        const E = ((await a.jsonFetch(a.withScreenLang(a.endpoints.opsList))).ops || []).map(Gg);
        for (const N of E)
          (N.status === "done" || N.status === "error" || N.status === "cancelled") && !n.has(N.id) && (n.add(N.id), p.set(N.id, Date.now()), o.delete(N.id) && (($ = t.onSettled) == null || $.call(t, N)));
        const A = new Set(s.value.map((N) => N.id)), O = E.filter((N) => N.status === "pending" || N.status === "running" || N.status === "cancelling" ? !0 : h ? A.has(N.id) : !1), z = new Set(O.map((N) => N.id)), P = s.value.filter((N) => !z.has(N.id)), I = [...O, ...P];
        h = !0;
        const F = Date.now(), W = I.filter((N) => {
          if (N.status === "pending" || N.status === "running" || N.status === "cancelling") return !0;
          const K = p.get(N.id);
          return K !== void 0 && F - K < $C;
        });
        s.value = W, !v.value && W.length === 0 && m();
      } catch (C) {
        console.warn("[usePendingOps] poll failed:", C);
      }
  }
  function _($) {
    const C = Gg($);
    n.has(C.id) || o.add(C.id), s.value.some((A) => A.id === C.id) || (s.value = [C, ...s.value]), g();
  }
  function w($) {
    s.value = s.value.filter((C) => C.id !== $), p.delete($);
  }
  return Mt(() => {
    m();
  }), {
    ops: s,
    hasActive: v,
    register: _,
    dismiss: w,
    poll: k,
    startPolling: g,
    stopPolling: m
  };
}
function TC(e, a) {
  if (!a || !Array.isArray(e.app_state)) return [];
  const t = `${a}:`;
  return e.app_state.filter((s) => typeof s == "string" && s.startsWith(t)).map((s) => s.slice(t.length));
}
function tw(e, a) {
  let t = String(e.extension ?? "").toLowerCase();
  if (!t && e.basename) {
    const s = e.basename.lastIndexOf(".");
    s > 0 && (t = e.basename.slice(s + 1).toLowerCase());
  }
  return {
    kind: e.type === "dir" ? "dir" : "file",
    ext: t,
    mime: e.mime_type ?? "",
    state: TC(e, a)
  };
}
function CC(e, a) {
  return e === a ? !0 : e.endsWith("/*") ? a.startsWith(e.slice(0, -1)) : !1;
}
function aw(e, a) {
  const t = e ?? {}, s = a.length;
  if (s === 0 || s > 1 && !t.multi) return !1;
  const n = t.min ?? 0, o = t.max ?? 0;
  if (n > 0 && s < n || o > 0 && s > o) return !1;
  const p = t.kind || "file", h = (t.ext ?? []).map((m) => m.toLowerCase()), v = (t.mime ?? []).map((m) => m.toLowerCase()), y = t.state ?? [], g = t.no_state ?? [];
  for (const m of a) {
    if (p !== "any" && p !== m.kind) return !1;
    const k = m.state ?? [];
    if (y.length > 0 && !y.some(($) => k.includes($)) || g.some(($) => k.includes($))) return !1;
    if (h.length === 0 && v.length === 0) continue;
    const _ = String(m.ext ?? "").toLowerCase();
    let w = h.includes(_);
    if (!w) {
      const $ = String(m.mime ?? "").toLowerCase();
      w = v.some((C) => CC(C, $));
    }
    if (!w) return !1;
  }
  return !0;
}
function wh(e, a, t) {
  return aw(e, a.map((s) => tw(s, t)));
}
function jt(e, a) {
  if (!e) return "";
  if (typeof e == "string") return e;
  const t = String(a || "en").toLowerCase().split("-")[0], s = e[t];
  if (typeof s == "string" && s !== "") return s;
  const n = e.en;
  if (typeof n == "string" && n !== "") return n;
  for (const o of Object.values(e))
    if (typeof o == "string" && o !== "") return o;
  return "";
}
function EC(e, a) {
  if (!e) return "";
  if (typeof e == "string") return e;
  const t = String(a || "en").toLowerCase().split("-")[0], s = e[t];
  return typeof s == "string" && s !== "" ? s : "";
}
function xh(e, a, t) {
  const s = EC(e, a);
  if (s) return s;
  const n = t();
  return n || jt(e, a);
}
function $h(e) {
  return e.key || `plugin:${e.plugin}/${e.id}`;
}
function AC(e) {
  return e.startsWith("plugin:");
}
function nw(e) {
  var a;
  return e.output_mode === "sibling" || e.output_mode === "version" || ((a = e.applies) == null ? void 0 : a.writable) === !0;
}
function zC(e) {
  return nw(e) && e.output_elsewhere !== !0;
}
const _p = { none: 0, viewer: 1, editor: 2, owner: 3 };
function MC(e) {
  return e.min_role === "owner" ? "owner" : e.min_role === "editor" || nw(e) ? "editor" : "viewer";
}
function DC(e, a, t) {
  var n;
  if ((n = a.lock) != null && n.plugin && a.lock.plugin === e.plugin) return !0;
  const s = t(a);
  return s === void 0 || !(s in _p) ? !0 : _p[s] >= _p[MC(e)];
}
function sw(e, a) {
  return a.length === 0 ? [] : e.filter((t) => wh(t.applies, a, t.plugin));
}
function PC(e, a, t) {
  var k;
  if (t.trash || t.e2e) return [];
  if (a.some((_) => _.e2e === !0 || _.mime_type === "inode/storage")) return [];
  const s = t.permOf, n = (_) => !(t.readOnly && zC(_)) && (!s || a.every((w) => DC(_, w, s))), o = sw(e, a).filter(n), p = /* @__PURE__ */ new Map();
  if (t.needWords)
    for (const _ of e) {
      if (o.includes(_) || !((k = _.gated) != null && k.length) || !n(_)) continue;
      const w = _.gated.find(
        ($) => wh({ ..._.applies, ext: $.ext ?? [], mime: [] }, a, _.plugin)
      );
      w && p.set(_, t.needWords(w.needs));
    }
  const h = e.filter((_) => o.includes(_) || p.has(_));
  if (h.length === 0) return [];
  const v = t.hasIcon ?? (() => !1), y = /* @__PURE__ */ new Map();
  for (const _ of h) {
    const w = y.get(_.plugin);
    w ? w.push(_) : y.set(_.plugin, [_]);
  }
  const g = [];
  let m = !0;
  for (const [_, w] of y) {
    g.push({ divider: !0, key: m ? "sep-plugins" : `sep-plugin:${_}`, label: "" }), m = !1;
    for (const $ of w) {
      const C = p.get($);
      g.push({
        key: $h($),
        label: jt($.label, t.locale),
        icon: $.icon && v($.icon) ? $.icon : "plugin",
        danger: $.danger === !0,
        ...C ? { disabled: !0, title: C } : {}
      });
    }
  }
  return g;
}
const OC = 5 * 60 * 1e3, pv = /* @__PURE__ */ new Map();
function LC() {
  pv.clear();
}
function IC(e) {
  let a = pv.get(e);
  return a || (a = { at: 0, data: b({ actions: [], views: [] }), inflight: null }, pv.set(e, a)), a;
}
function RC(e, a) {
  const t = e.endpoints.pluginActions ?? "", s = IC(t || "(none)"), n = b(!1), o = b(null), p = x(() => a() && t !== ""), h = x(() => p.value ? s.data.value.actions : []), v = x(() => p.value ? s.data.value.views : []);
  async function y(_ = !1) {
    return p.value ? s.at > 0 && Date.now() - s.at < OC && !_ ? (n.value = !0, s.data.value) : (s.inflight || (s.inflight = e.pluginActions().then(($) => (s.data.value = { actions: $.actions ?? [], views: $.views ?? [] }, s.at = Date.now(), o.value = null, s.data.value)).catch(($) => (o.value = String(($ == null ? void 0 : $.message) ?? $), s.data.value)).finally(() => {
      s.inflight = null, n.value = !0;
    })), s.inflight) : { actions: [], views: [] };
  }
  Qe(
    p,
    (_) => {
      _ && y();
    },
    { immediate: !0 }
  );
  function g(_) {
    return sw(h.value, _);
  }
  function m(_) {
    return h.value.find((w) => $h(w) === _);
  }
  function k(_, w, $) {
    return e.pluginActionRun(_.plugin, _.id, {
      paths: w.map((C) => C.path),
      params: $
    });
  }
  return { enabled: p, actions: h, views: v, loaded: n, error: o, refresh: y, actionsFor: g, byKey: m, run: k };
}
const NC = 25e3, BC = 15e3, FC = 6;
class UC {
  constructor(a) {
    Aa(this, "ws", null);
    Aa(this, "opts");
    Aa(this, "closed", !1);
    Aa(this, "connecting", !1);
    Aa(this, "retries", 0);
    Aa(this, "fallback", !1);
    Aa(this, "pingTimer", null);
    Aa(this, "reconnectTimer", null);
    // Last-known intent, replayed on (re)connect.
    Aa(this, "currentPath", null);
    Aa(this, "currentFocus", null);
    this.opts = a, this.connect();
  }
  /** Subscribe to a folder ("<adapter>://<dir>"). Swaps the active room and
   *  resets focus. Passing null unsubscribes (drive list / trash have no room). */
  subscribe(a) {
    this.currentPath = a, this.currentFocus = null, a && this.send({ type: "subscribe", path: a });
  }
  /** Report the file the user is focused on (or null to clear). */
  setFocus(a) {
    this.currentFocus = a, this.send({ type: "focus", file: a });
  }
  /** Tear down permanently — call on unmount. */
  close() {
    this.closed = !0, this.clearTimers(), this.dropSocket();
  }
  async connect() {
    if (this.closed || this.connecting || this.ws) return;
    this.connecting = !0;
    let a = null;
    try {
      a = await this.opts.getTicket();
    } catch {
      a = null;
    }
    if (this.connecting = !1, this.closed) return;
    if (!a || !a.ticket || !a.ws_url) {
      this.fail();
      return;
    }
    const t = a.ws_url.includes("?") ? "&" : "?";
    let s;
    try {
      s = new WebSocket(`${a.ws_url}${t}ticket=${encodeURIComponent(a.ticket)}`);
    } catch {
      this.fail();
      return;
    }
    this.ws = s, s.onopen = () => {
      var n, o;
      this.retries = 0, this.setFallback(!1), (o = (n = this.opts.handlers).onStatus) == null || o.call(n, !0), this.currentPath && this.send({ type: "subscribe", path: this.currentPath }), this.currentFocus !== null && this.send({ type: "focus", file: this.currentFocus }), this.startPing();
    }, s.onmessage = (n) => {
      var h, v, y, g, m, k;
      let o;
      try {
        o = JSON.parse(typeof n.data == "string" ? n.data : "");
      } catch {
        return;
      }
      const p = o;
      if ((p == null ? void 0 : p.type) === "change") (v = (h = this.opts.handlers).onChange) == null || v.call(h, o);
      else if ((p == null ? void 0 : p.type) === "presence") (g = (y = this.opts.handlers).onPresence) == null || g.call(y, o);
      else if ((p == null ? void 0 : p.type) === "app.updated") {
        const _ = o;
        typeof _.app == "string" && typeof _.version == "string" && ((k = (m = this.opts.handlers).onAppUpdated) == null || k.call(m, _));
      }
    }, s.onerror = () => {
    }, s.onclose = () => {
      var n, o;
      this.stopPing(), this.ws = null, (o = (n = this.opts.handlers).onStatus) == null || o.call(n, !1), this.fail();
    };
  }
  // fail schedules a capped reconnect; after MAX_RETRIES it gives up on the live
  // socket and flips to fallback (polling) mode.
  fail() {
    if (this.closed || this.reconnectTimer) return;
    if (this.retries >= FC) {
      this.setFallback(!0);
      return;
    }
    const a = Math.min(1e3 * 2 ** this.retries, BC);
    this.retries += 1, this.reconnectTimer = setTimeout(() => {
      this.reconnectTimer = null, this.connect();
    }, a);
  }
  setFallback(a) {
    var t, s;
    this.fallback !== a && (this.fallback = a, (s = (t = this.opts.handlers).onFallback) == null || s.call(t, a));
  }
  send(a) {
    const t = this.ws;
    if (!(!t || t.readyState !== WebSocket.OPEN))
      try {
        t.send(JSON.stringify(a));
      } catch {
      }
  }
  startPing() {
    this.stopPing(), this.pingTimer = setInterval(() => this.send({ type: "ping" }), NC);
  }
  stopPing() {
    this.pingTimer && (clearInterval(this.pingTimer), this.pingTimer = null);
  }
  dropSocket() {
    if (this.ws) {
      try {
        this.ws.onclose = null, this.ws.close();
      } catch {
      }
      this.ws = null;
    }
  }
  clearTimers() {
    this.stopPing(), this.reconnectTimer && (clearTimeout(this.reconnectTimer), this.reconnectTimer = null);
  }
}
function HC(e, a) {
  const t = a.now ?? (() => Date.now());
  let s = null, n = null;
  const o = () => {
    const p = t();
    n === null && (n = p);
    const h = n + a.maxWait - p, v = Math.max(0, Math.min(a.wait, h));
    s && clearTimeout(s), s = setTimeout(() => {
      s = null, n = null, e();
    }, v);
  };
  return o.cancel = () => {
    s && clearTimeout(s), s = null, n = null;
  }, o;
}
const vv = /* @__PURE__ */ new Set();
function KC(e, a) {
  for (const t of [...vv])
    try {
      t(e, a);
    } catch {
    }
}
function VC(e) {
  return vv.add(e), () => {
    vv.delete(e);
  };
}
const qC = 200, jC = 2e3, WC = 12e3;
function YC(e, a) {
  const t = b([]), s = b(!1), n = b(!1);
  let o = null, p = null;
  const h = HC(() => a.reload(), {
    wait: qC,
    maxWait: jC
  });
  let v = null;
  function y(C) {
    p && C.path && C.path !== p || (t.value = Array.isArray(C.users) ? C.users : []);
  }
  function g(C) {
    LC(), KC(C.app, C.version);
  }
  function m(C) {
    n.value = C, C ? (t.value = [], v || (v = setInterval(() => a.reload(), WC))) : v && (clearInterval(v), v = null);
  }
  function k() {
    o || (o = new UC({
      getTicket: () => e.wsTicket(),
      handlers: {
        onChange: h,
        onPresence: y,
        onAppUpdated: g,
        onFallback: m,
        onStatus: (C) => {
          s.value = C;
        }
      }
    }));
  }
  function _(C) {
    t.value = [], p = C, o == null || o.subscribe(C);
  }
  function w(C) {
    o == null || o.setFocus(C);
  }
  function $() {
    h.cancel(), v && (clearInterval(v), v = null), o == null || o.close(), o = null, n.value = !1;
  }
  return { presenceUsers: t, connected: s, degraded: n, start: k, subscribe: _, setFocus: w, stop: $ };
}
const GC = 500;
function XC(e) {
  const a = e.thumb_url;
  if (!a) return null;
  const t = a.indexOf("?");
  return `${t === -1 ? a : a.slice(0, t)}|${e.last_modified ?? ""}`;
}
function JC(e, a) {
  const t = BS(/* @__PURE__ */ new Map()), s = [], n = /* @__PURE__ */ new Set(), o = /* @__PURE__ */ new Set(), p = (y) => rh(e, y);
  function h(y) {
    const g = y.thumb_url, m = XC(y);
    if (!g || !m) return null;
    const k = t.get(m);
    return k || (!n.has(g) && !o.has(m) && v(g, m), null);
  }
  async function v(y, g) {
    o.add(g);
    try {
      const m = await fetch(p(y), {
        headers: await a.authHeaders({ Accept: "*/*" }),
        credentials: a.credentialsMode()
      });
      if (!m.ok) throw new Error(String(m.status));
      const k = await m.blob();
      if (s.length >= GC) {
        const _ = s.shift(), w = FS(t), $ = _ ? w.get(_) : void 0;
        _ && $ && (URL.revokeObjectURL($), w.delete(_));
      }
      s.push(g), t.set(g, URL.createObjectURL(k));
    } catch {
      n.add(y);
    } finally {
      o.delete(g);
    }
  }
  return { src: h };
}
let ad = null, nd = null, Dc = null, Pc = null;
function Id() {
  ad || (ad = import(
    /* @vite-ignore */
    "monaco-editor"
  ).then((e) => (Dc = e.default ?? e, Dc)).catch(() => (Dc = null, null))), nd || (nd = import(
    /* @vite-ignore */
    "./common-xdTjul80.js"
  ).then((e) => (Pc = e.default ?? e, Pc)).catch(() => (Pc = null, null)));
}
async function hv() {
  return ad || Id(), ad;
}
async function ow() {
  return nd || Id(), nd;
}
function iw() {
  return Dc;
}
function ZC() {
  return Pc;
}
function Qve() {
  return Id(), {
    ensureMonaco: hv,
    ensureHighlight: ow,
    getMonaco: iw,
    getHighlight: ZC
  };
}
const QC = ["title"], eE = ["src", "alt"], tE = {
  key: 2,
  class: "fx-presence-dot",
  "aria-hidden": "true"
}, Xg = /* @__PURE__ */ rt({
  __name: "PresenceAvatar",
  props: {
    user: {},
    title: {}
  },
  setup(e) {
    const a = e, t = x(() => {
      const h = (a.user.avatar ?? "").trim();
      return /^(data:image\/|https?:\/\/|\/)/.test(h) ? h : "";
    }), s = b(!1), n = x(() => !!t.value && !s.value), o = x(() => {
      const h = a.user.name.trim().split(/\s+/).filter(Boolean);
      return h.length === 0 ? "?" : h.length === 1 ? h[0].slice(0, 2).toUpperCase() : (h[0][0] + h[h.length - 1][0]).toUpperCase();
    }), p = x(() => {
      const h = a.user.uid ?? String(a.user.id);
      let v = 0;
      for (let y = 0; y < h.length; y++) v = v * 31 + h.charCodeAt(y) >>> 0;
      return v % 360;
    });
    return (h, v) => (u(), d("span", {
      class: Re(["fx-presence-avatar", { "fx-presence-avatar--photo": n.value }]),
      style: Vt({ backgroundColor: `hsl(${p.value} 60% 45%)` }),
      title: e.title
    }, [
      n.value ? (u(), d("img", {
        key: 0,
        class: "fx-presence-photo",
        src: t.value,
        alt: e.user.name,
        onError: v[0] || (v[0] = (y) => s.value = !0)
      }, null, 40, eE)) : (u(), d(he, { key: 1 }, [
        $t(f(o.value), 1)
      ], 64)),
      e.user.file ? (u(), d("span", tE)) : T("", !0)
    ], 14, QC));
  }
}), aE = {
  key: 0,
  class: "fx-presence-chips"
}, nE = ["title"], sE = { class: "fx-presence-chip-name" }, oE = {
  key: 0,
  class: "fx-presence-chip-file"
}, iE = ["title"], rE = {
  key: 0,
  class: "fx-presence-more"
}, lE = ["title"], uE = { class: "fx-presence-file" }, cE = ["title", "aria-expanded"], Jg = "filex.presence.expanded", dE = /* @__PURE__ */ rt({
  __name: "PresenceBar",
  props: {
    users: {},
    selfId: {},
    locale: {}
  },
  setup(e) {
    const a = e, { t } = gt(() => Ha(a.locale)), s = x(
      () => (a.users ?? []).filter((v) => a.selfId == null || v.id !== a.selfId)
    ), n = b((() => {
      try {
        return localStorage.getItem(Jg) === "1";
      } catch {
        return !1;
      }
    })());
    function o() {
      n.value = !n.value;
      try {
        localStorage.setItem(Jg, n.value ? "1" : "0");
      } catch {
      }
    }
    function p(v) {
      return v.uid ?? String(v.id);
    }
    function h(v) {
      return v.file ? `${v.name} · ${v.file}` : v.name;
    }
    return (v, y) => s.value.length ? (u(), d("div", {
      key: 0,
      class: Re(["fx-presence", { "fx-presence--wide": n.value }])
    }, [
      n.value ? (u(), d("div", aE, [
        (u(!0), d(he, null, We(s.value, (g) => (u(), d("span", {
          key: p(g),
          class: "fx-presence-chip",
          title: h(g)
        }, [
          ot(Xg, { user: g }, null, 8, ["user"]),
          i("span", sE, [
            i("bdi", null, f(g.name), 1)
          ]),
          g.file ? (u(), d("span", oE, "· " + f(g.file), 1)) : T("", !0)
        ], 8, nE))), 128))
      ])) : (u(), d(he, { key: 1 }, [
        i("div", {
          class: "fx-presence-avatars",
          title: s.value.map(h).join(", ")
        }, [
          (u(!0), d(he, null, We(s.value.slice(0, 5), (g) => (u(), nt(Xg, {
            key: p(g),
            user: g,
            title: h(g)
          }, null, 8, ["user", "title"]))), 128)),
          s.value.length > 5 ? (u(), d("span", rE, "+" + f(s.value.length - 5), 1)) : T("", !0)
        ], 8, iE),
        i("span", {
          class: "fx-presence-text",
          title: s.value.map(h).join(", ")
        }, [
          $t(f(s.value.length === 1 ? s.value[0].name : r(t)("presence.others", { n: s.value.length })) + " ", 1),
          s.value.length === 1 && s.value[0].file ? (u(), d(he, { key: 0 }, [
            y[0] || (y[0] = $t(" · ", -1)),
            i("span", uE, f(s.value[0].file), 1)
          ], 64)) : T("", !0)
        ], 8, lE)
      ], 64)),
      i("button", {
        type: "button",
        class: "fx-presence-toggle",
        title: n.value ? r(t)("presence.collapse") : r(t)("presence.expand"),
        "aria-expanded": n.value,
        onClick: o
      }, f(n.value ? "‹" : "›"), 9, cE)
    ], 2)) : T("", !0);
  }
}), fE = '<path d="M4.5 15.5v3A2 2 0 0 0 6.5 20.5h11a2 2 0 0 0 2-2v-3"/>', pE = '<path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z"/><circle cx="12" cy="12" r="3"/>', Zg = "M12 3.6l2.6 5.3 5.85.85-4.23 4.12 1 5.83L12 16.97l-5.22 2.73 1-5.83L3.55 9.75l5.85-.85z", Qg = '<path d="M8 3.5h8"/><path d="M9.6 3.5v6.1L7.2 12.3v1.7h9.6v-1.7L14.4 9.6V3.5"/><path d="M12 14v6.5"/>', kp = '<rect x="3.5" y="4.5" width="17" height="15" rx="2"/>', eb = '<path d="M4 6.5h16"/><path d="M9.5 6.5V4.9a1.4 1.4 0 0 1 1.4-1.4h2.2a1.4 1.4 0 0 1 1.4 1.4v1.6"/><path d="M6.6 6.5l.85 12.1a2 2 0 0 0 2 1.9h5.1a2 2 0 0 0 2-1.9l.85-12.1"/><path d="M10.3 10.3v6.4"/><path d="M13.7 10.3v6.4"/>', tb = '<path d="M6.8 3.5h10.4a1.6 1.6 0 0 1 1.6 1.6v15.4l-6.8-3.9-6.8 3.9V5.1A1.6 1.6 0 0 1 6.8 3.5z"/>', rw = {
  /* ── opening ─────────────────────────────────────────────────────────── */
  open: '<path d="M14 3.5h6.5V10"/><path d="M20.5 3.5L12 12"/><path d="M18 13.5v5a2 2 0 0 1-2 2H5.5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h5"/>',
  "open-tab": '<rect x="3" y="4.5" width="18" height="15" rx="2"/><path d="M3 9.5h18"/><path d="M9.5 4.5v5"/>',
  preview: pE,
  download: fE + '<path d="M12 4v11.5"/><path d="M7.5 11L12 15.5 16.5 11"/>',
  "archive-create": '<path d="M5 8.5h14v11H5z"/><path d="M4 4h16v4.5H4z"/><path d="M12 11v5"/><path d="M9.5 13.5h5"/>',
  "archive-extract": '<path d="M5 8.5h14v11H5z"/><path d="M4 4h16v4.5H4z"/><path d="M12 10.5v6"/><path d="M9.5 14l2.5 2.5 2.5-2.5"/>',
  upload: '<path d="M4.5 15.5v3A2 2 0 0 0 6.5 20.5h11a2 2 0 0 0 2-2v-3"/><path d="M12 15.5V4"/><path d="M7.5 8.5L12 4l4.5 4.5"/>',
  convert: '<path d="M4 8.5h13"/><path d="M13.5 5L17 8.5 13.5 12"/><path d="M20 15.5H7"/><path d="M10.5 12L7 15.5 10.5 19"/>',
  /* "Paylaş / İzinler" — the three-node share, not a chain link: this row
     opens permissions as well as a link, and people are the subject. */
  access: '<circle cx="17.5" cy="6" r="2.5"/><circle cx="6.5" cy="12" r="2.5"/><circle cx="17.5" cy="18" r="2.5"/><path d="M8.75 10.8l6.5-3.6"/><path d="M8.75 13.2l6.5 3.6"/>',
  details: '<circle cx="12" cy="12" r="8.5"/><path d="M12 11.2v5.6"/><circle cx="12" cy="7.7" r="0.9" fill="currentColor" stroke="none"/>',
  /* ── identity / clipboard ────────────────────────────────────────────── */
  "copy-id": '<rect x="2.5" y="5" width="19" height="14" rx="2.5"/><circle cx="8.5" cy="10.8" r="2"/><path d="M5.3 16.2c.5-1.5 1.75-2.4 3.2-2.4s2.7.9 3.2 2.4"/><path d="M14.8 10h4.2"/><path d="M14.8 13.6h4.2"/>',
  /* A clipboard carrying a path separator — this copies the location, not the
     thing that lives at it. */
  "copy-path": '<path d="M9 4.5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-12a2 2 0 0 0-2-2h-2"/><rect x="9" y="2.8" width="6" height="3.6" rx="1.2"/><path d="M10 11.2l2.4 2.4-2.4 2.4"/>',
  rename: '<path d="M4 20l.9-4.1 11-11a2.05 2.05 0 0 1 2.9 2.9l-11 11z"/><path d="M14 7l3 3"/>',
  cut: '<circle cx="6.5" cy="17.5" r="2.5"/><circle cx="6.5" cy="6.5" r="2.5"/><path d="M8.6 8.3L19 19"/><path d="M8.6 15.7L19 5"/>',
  copy: '<rect x="9" y="9" width="11.5" height="11.5" rx="2"/><path d="M15 6v-.5a2 2 0 0 0-2-2H5.5a2 2 0 0 0-2 2V13a2 2 0 0 0 2 2H6"/>',
  paste: '<path d="M9 4.5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-12a2 2 0 0 0-2-2h-2"/><rect x="9" y="2.8" width="6" height="3.6" rx="1.2"/>',
  /* ── metadata ────────────────────────────────────────────────────────── */
  /* star = "not starred yet, do it" (outline); unstar = the state you are in
     (filled). The renderer picks between them by name, see FileExplorer. */
  star: `<path d="${Zg}"/>`,
  unstar: `<path d="${Zg}" fill="currentColor"/>`,
  tags: '<path d="M3.5 11.4V5.2a1.7 1.7 0 0 1 1.7-1.7h6.2a1.7 1.7 0 0 1 1.2.5l7.2 7.2a1.7 1.7 0 0 1 0 2.4l-6.2 6.2a1.7 1.7 0 0 1-2.4 0L4 12.6a1.7 1.7 0 0 1-.5-1.2z"/><circle cx="8" cy="8" r="1.3"/>',
  /* ── destructive / recovery ──────────────────────────────────────────── */
  delete: eb,
  "open-trash": eb,
  /* The undo arrow, not a rotating one: "Geri Yükle" puts a thing back where
     it was, and that is the gesture people already read as undo. */
  restore: '<path d="M9 6L5 10l4 4"/><path d="M5 10h9a5 5 0 0 1 0 10h-3.5"/>',
  /* ── folder-level ────────────────────────────────────────────────────── */
  "new-folder": '<path d="M3 7.5a2 2 0 0 1 2-2h4.2a2 2 0 0 1 1.4.6l1.4 1.4H19a2 2 0 0 1 2 2V17a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><path d="M12 11.3v5"/><path d="M9.5 13.8h5"/>',
  /* belge:n1 — a page with a plus: "make me a new document of some type".
     Keyed by the action's own key, so the menu row carries no icon of its
     own and no emoji enters the markup. */
  "new-document": '<path d="M13.5 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h5"/><path d="M13.5 3l5 5"/><path d="M13.5 3v5h5"/><path d="M17.5 14.5v6"/><path d="M14.5 17.5h6"/>',
  refresh: '<path d="M20.5 12a8.5 8.5 0 1 1-2.49-6.01"/><path d="M18 1.5V6h-4.5"/>',
  /* ── desktop sync ("keep on this device") ────────────────────────────── */
  "keep-local": Qg,
  "keep-online": '<path d="M7 18.5h10a3.5 3.5 0 0 0 0-7 5 5 0 0 0-9.6-1.2A4.2 4.2 0 0 0 7 18.5z"/>',
  /* Kept because a parent folder is kept — the pin, with the branch it came
     down. The row is disabled; the glyph says why. */
  "keep-inherited": Qg + '<path d="M2.5 20.5h3.6a1.6 1.6 0 0 0 1.6-1.6V17"/>',
  "keep-reveal": '<path d="M2.5 17.5V6.5a2 2 0 0 1 2-2h3.8a2 2 0 0 1 1.4.6l1.4 1.4h4.4a2 2 0 0 1 2 2v1.8"/><path d="M4 19.5h13.4a2 2 0 0 0 1.9-1.37l2-6A1.4 1.4 0 0 0 20 10.3H9.4a2 2 0 0 0-1.9 1.37L5.5 18"/>',
  /* ── view preferences ────────────────────────────────────────────────── */
  "toggle-hidden": '<path d="M3.5 3.5l17 17"/><path d="M9.9 6A9.6 9.6 0 0 1 12 5.5c6 0 9.5 6.5 9.5 6.5a17.3 17.3 0 0 1-3.35 4.15"/><path d="M6.55 7.7A17.4 17.4 0 0 0 2.5 12S6 18.5 12 18.5a9.7 9.7 0 0 0 3.95-.85"/><path d="M10.2 10.3a2.9 2.9 0 0 0 3.9 4.1"/>',
  density: '<path d="M8.5 8L12 4.5 15.5 8"/><path d="M8.5 16L12 19.5 15.5 16"/><path d="M12 4.5v15"/>',
  "view-list": '<path d="M8.5 6.5h12"/><path d="M8.5 12h12"/><path d="M8.5 17.5h12"/><path d="M4 6.5h.01"/><path d="M4 12h.01"/><path d="M4 17.5h.01"/>',
  "view-grid": '<rect x="3.5" y="3.5" width="7" height="7" rx="1.5"/><rect x="13.5" y="3.5" width="7" height="7" rx="1.5"/><rect x="3.5" y="13.5" width="7" height="7" rx="1.5"/><rect x="13.5" y="13.5" width="7" height="7" rx="1.5"/>',
  "view-gallery": '<rect x="3" y="4.5" width="18" height="15" rx="2"/><circle cx="8.3" cy="9.6" r="1.5"/><path d="M4.3 17l4.7-4.7 3 3 3-3 5 4.7"/>',
  nav: kp + '<path d="M9.5 4.5v15"/>',
  inspector: kp + '<path d="M14.5 4.5v15"/>',
  /* ── explorer settings ───────────────────────────────────────────────── */
  "shortcut-settings": '<rect x="2.5" y="6" width="19" height="12" rx="2.5"/><path d="M6.5 9.8h.01"/><path d="M10 9.8h.01"/><path d="M13.5 9.8h.01"/><path d="M17 9.8h.01"/><path d="M6.5 12.9h.01"/><path d="M10 12.9h.01"/><path d="M13.5 12.9h.01"/><path d="M17 12.9h.01"/><path d="M8.6 15.6h6.8"/>',
  /* Light/dark as the thing it actually switches: one disc, half of it inked. */
  theme: '<circle cx="12" cy="12" r="8.5"/><path d="M12 3.5a8.5 8.5 0 0 1 0 17z" fill="currentColor" stroke="none"/>',
  /* zaman:z3 — a clock face, for the Time zone row. */
  timezone: '<circle cx="12" cy="12" r="8.5"/><path d="M12 7.2V12l3.2 2"/>',
  tour: '<path d="M2.5 9L12 4.5 21.5 9 12 13.5z"/><path d="M6.6 11.1v4.4c0 1.6 2.4 2.9 5.4 2.9s5.4-1.3 5.4-2.9v-4.4"/>',
  /* "Dosya İste" — the public drop link. A chain, because what this makes is
     a URL to hand somebody. */
  "request-files": '<path d="M10.2 13.8a4.2 4.2 0 0 0 6.1 0l2.3-2.3a4.3 4.3 0 0 0-6.1-6.1l-1.35 1.35"/><path d="M13.8 10.2a4.2 4.2 0 0 0-6.1 0l-2.3 2.3a4.3 4.3 0 0 0 6.1 6.1l1.35-1.35"/>',
  /* ── toolbar chrome that is not a ContextAction ──────────────────────── */
  "go-up": '<path d="M12 20V5"/><path d="M5.5 11.5L12 5l6.5 6.5"/>',
  /* #57 — the storage row's order menu (SideNav). One step up or down is a
     SHORT arrow, so it does not read as `go-up`'s "to the parent folder";
     "Sort by name" is the A→Z mark every file manager uses; "Use default order" is
     the refresh circle turning back. All vertical or rotational, so none of
     them is mirrored in a right-to-left interface. */
  "move-up": '<path d="M12 18V7"/><path d="M7.5 11.5L12 7l4.5 4.5"/>',
  "move-down": '<path d="M12 6v11"/><path d="M7.5 12.5L12 17l4.5-4.5"/>',
  "sort-name": '<path d="M3.5 10.5L6.5 3.5l3 7"/><path d="M4.7 8h3.6"/><path d="M4 13.5h5l-5 7h5"/><path d="M17 4v16"/><path d="M13.5 16.5L17 20l3.5-3.5"/>',
  "reset-order": '<path d="M3.5 12a8.5 8.5 0 1 0 2.49-6.01"/><path d="M6 1.5V6h4.5"/>',
  /* === gorunum:v2-topbar — the breadcrumb row's own controls ============
     The crumb trail gained the reference shell's three affordances: a home
     crumb in place of the bare "/" root, a chevron on the last crumb that
     lists what is inside it, and the path editor we already had (its glyph
     moves here from Breadcrumb.vue so every mark in the row comes from one
     file). */
  home: '<path d="M3.5 10.6L12 3.5l8.5 7.1"/><path d="M5.6 9.4V19a1.5 1.5 0 0 0 1.5 1.5h9.8a1.5 1.5 0 0 0 1.5-1.5V9.4"/><path d="M9.9 20.5v-5.2h4.2v5.2"/>',
  subfolders: '<path d="M6.8 9.8L12 15l5.2-5.2"/>',
  "edit-path": '<path d="M4 20h4l10-10a2.1 2.1 0 0 0-3-3L5 17z"/><path d="M14.5 6.5l3 3"/>',
  /* === gorunum:v2-topbar — the header's trailing cluster ================
     The page chrome around the explorer is gone, so the account-level doors
     are drawn by the header itself (the host fills them through the
     `header-actions` slot). The glyphs live here so an embedder's cluster
     comes out the same weight and colour as everything beside it. */
  admin: '<rect x="3" y="3.5" width="7.4" height="7.4" rx="1.6"/><rect x="13.6" y="3.5" width="7.4" height="4.6" rx="1.6"/><rect x="13.6" y="10.7" width="7.4" height="9.8" rx="1.6"/><rect x="3" y="13.6" width="7.4" height="6.9" rx="1.6"/>',
  /* ⚠ A PERSON, not a cog. The first draft drew the gear as a ringed disc with
     eight spokes and at 16px it came out as a SUN — sitting in the very row
     the light/dark toggle had just been removed from, which is the one thing
     the mark must not be mistaken for (measured at 1440 and 390: it read as a
     theme switch in both). The account bust is what the reference hangs this
     menu on, and the tooltip says which settings. */
  account: '<circle cx="12" cy="8.2" r="3.6"/><path d="M4.9 20.3a7.35 7.35 0 0 1 14.2 0"/>',
  "sign-out": '<path d="M9.5 20.5H6a2 2 0 0 1-2-2v-13a2 2 0 0 1 2-2h3.5"/><path d="M15.5 16.5L20 12l-4.5-4.5"/><path d="M20 12H9"/>',
  /* The AI assistant, drawn but not yet wired — a spark, the mark every
     assistant in this class of product wears, so the day it does something
     the icon does not have to change under people's fingers. */
  ai: '<path d="M12 3.2l1.75 4.3 4.3 1.75-4.3 1.75L12 15.3l-1.75-4.3L5.95 9.25l4.3-1.75z"/><path d="M18.2 15.1l.8 1.95 1.95.8-1.95.8-.8 1.95-.8-1.95-1.95-.8 1.95-.8z"/>',
  /* The notification bell, for the host's header cluster (web/src
     NotificationBell.vue). ⚠ Drawn HERE, not taken from the app's icon
     library: it sits in the same row as refresh, the spark and the avatar,
     and a glyph at a foreign stroke weight in that row is the exact mismatch
     this set exists to prevent. A dome on a flared rim, the clapper below. */
  bell: '<path d="M6.2 16.6V11a5.8 5.8 0 0 1 11.6 0v5.6l1.7 1.9H4.5z"/><path d="M10.1 21a2.1 2.1 0 0 0 3.8 0"/>',
  /* === /gorunum:v2-topbar === */
  search: '<circle cx="10.8" cy="10.8" r="6.3"/><path d="M15.4 15.4l5.1 5.1"/>',
  /* gorunum:v1-advsearch — sliders, not a funnel. A funnel says "throw rows
     away"; this control opens a dialog where you SET things, and two of its
     three rows are exactly a slider's job (a size range, a time window). */
  filter: '<path d="M4 7.5h4"/><path d="M13 7.5h7"/><circle cx="10.5" cy="7.5" r="2.4"/><path d="M4 16.5h7"/><path d="M16 16.5h4"/><circle cx="13.5" cy="16.5" r="2.4"/>',
  more: '<circle cx="5.5" cy="12" r="1.2" fill="currentColor" stroke="none"/><circle cx="12" cy="12" r="1.2" fill="currentColor" stroke="none"/><circle cx="18.5" cy="12" r="1.2" fill="currentColor" stroke="none"/>',
  close: '<path d="M5.5 5.5l13 13"/><path d="M18.5 5.5l-13 13"/>',
  /* A share link. Two half-chains, which is what a link IS. The details
     panel's "Not shared / Create link" row used to draw a chain EMOJI
     there, i.e. whatever glyph the OS happened to ship, full-colour,
     beside a column of stroked grey ones. */
  link: '<path d="M10 13.5a4.5 4.5 0 0 0 6.8.5l2.7-2.7a4.5 4.5 0 0 0-6.36-6.36L11.6 6.5"/><path d="M14 10.5a4.5 4.5 0 0 0-6.8-.5l-2.7 2.7a4.5 4.5 0 0 0 6.36 6.36l1.53-1.53"/>',
  /* baglan:b1 — "How to connect". A PLUG, deliberately not the chain above:
     the empty screen's account menu draws both rows one under the other
     ("Paylaştıklarım", then "Bağlantılar"), and one mark on two adjacent rows
     is the misreading this set exists to stop. It is also the mark the admin
     panel's own Connections entry already wears (Sidebar.vue, lucide `Cable`),
     so the two ways into the same screen agree on what it looks like. */
  connect: '<path d="M9 8.5V3"/><path d="M15 8.5V3"/><path d="M6 8.5h12v4.5a4.5 4.5 0 0 1-4.5 4.5h-3A4.5 4.5 0 0 1 6 13z"/><path d="M12 17.5V21"/>',
  /* === ikon:emoji — the command palette's own rows =======================
   * The palette printed `{{ it.icon }}` as TEXT: `➜ 📁 ⬆ ▦ 🗑 ⟳ ↑ 🎨 ⌨ 🎓 ⧉ ◫
   * 💾 🔖`. Thirteen marks from four different type families, in a list whose
   * neighbours — the context menu it duplicates and the toolbar it launches —
   * had already moved here. Most of the keys it needed were drawn already
   * (`tour` is the mortarboard, `shortcut-settings` the keyboard, the three
   * `view-*` the mode chips); these six are what was genuinely missing. */
  /* "Go to path" — the arrow goes INTO the box, the mirror of `sign-out`.
     A bare arrow would have said "next", which this row is not. */
  goto: '<path d="M13.5 4.5h4a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2h-4"/><path d="M10 8.2L13.8 12 10 15.8"/><path d="M4.5 12h9.3"/>',
  /* A second pane opened beside the first — `nav`/`inspector`'s panel with the
     divider down the middle, because that is literally what split view is. */
  split: kp + '<path d="M12 4.5v15"/>',
  /* A new tab: `open-tab`'s window, with the plus in the body rather than on
     the tab strip (at 16px a plus up there merges into the tab). */
  "tab-new": '<rect x="3" y="4.5" width="18" height="15" rx="2"/><path d="M3 9.5h18"/><path d="M9.5 4.5v5"/><path d="M12 12.1v5"/><path d="M9.5 14.6h5"/>',
  bookmark: tb,
  "save-search": tb + '<path d="M12 7.2v5.2"/><path d="M9.4 9.8h5.2"/>',
  /* The padlock, for the rows and strips that talk ABOUT encryption ("create
     an encrypted folder", "this one is unlocked"). The listing marker is a
     different drawing on purpose — there the lock is cut out of the folder,
     because the row still has to read as a folder. */
  lock: '<rect x="4.5" y="10.3" width="15" height="10.2" rx="2.2"/><path d="M7.9 10.3V7.6a4.1 4.1 0 0 1 8.2 0v2.7"/><circle cx="12" cy="15.4" r="1.5"/>',
  /* === ikon:emoji — states the viewers and modals report ================
   * `✓ ✗ ⚠️ ⏳` in the viewer chrome. The first two are typographic and came
   * out at whatever weight the UI font had; the last two are colour emoji, so
   * a fallback screen's 48px mark was the only full-colour thing on a grey
   * page. `progress` is drawn as an open ring because it is SPUN by CSS
   * (`@keyframes fe-spin`) — an hourglass cannot say "still going". */
  /* An app plugin's row when its manifest names no glyph this set draws: a
     puzzle piece, the mark every extension surface already wears. Rows whose
     manifest icon IS a key here (`convert`, `lock`, …) get that glyph instead
     — lib/pluginMenu decides, this only draws. */
  plugin: '<path d="M9.5 4.5a2 2 0 1 1 4 0h3a1.5 1.5 0 0 1 1.5 1.5v3a2 2 0 1 1 0 4v3a1.5 1.5 0 0 1-1.5 1.5h-3a2 2 0 1 1-4 0h-3A1.5 1.5 0 0 1 5 16v-3a2 2 0 1 1 0-4V6a1.5 1.5 0 0 1 1.5-1.5z"/>',
  /* A pen signing on a line — the e-signature app's own icon (manifest
     `icon: "sign"`). ⚠ Drawn here because a key the catalogue does not know
     falls back to the generic plugin piece: the sidebar and every menu showed
     the Signatures app as "some app" until it was (2026-09-21, a tester). */
  sign: '<path d="M12.5 20.5h8"/><path d="M16.2 3.9a2.05 2.05 0 0 1 2.9 2.9L8 17.9l-3.9 1 1-3.9z"/><path d="M14.6 5.5l2.9 2.9"/>',
  check: '<path d="M4.8 12.6l4.7 4.7L19.2 6.9"/>',
  alert: '<path d="M10.7 4.6L2.9 18.2a1.5 1.5 0 0 0 1.3 2.25h15.6a1.5 1.5 0 0 0 1.3-2.25L13.3 4.6a1.5 1.5 0 0 0-2.6 0z"/><path d="M12 9.9v4.3"/><circle cx="12" cy="17.4" r="0.9" fill="currentColor" stroke="none"/>',
  progress: '<path d="M20.5 12a8.5 8.5 0 1 1-8.5-8.5"/>'
}, vE = /* @__PURE__ */ new Set(["restore", "goto", "sign-out", "copy-path", "nav", "inspector"]), ab = /* @__PURE__ */ new Map();
function wt(e) {
  if (!e) return "";
  const a = ab.get(e);
  if (a !== void 0) return a;
  const t = rw[e], s = t ? `<svg class="${vE.has(e) ? "fe-aicon fe-aicon--dir" : "fe-aicon"}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${t}</svg>` : "";
  return ab.set(e, s), s;
}
function ehe() {
  return Object.keys(rw);
}
const lw = 80;
function hE(e, a = lw) {
  var n;
  if (typeof window > "u" || typeof document > "u") return a;
  const t = Array.isArray(e) ? e : [e];
  let s = a;
  for (const o of t) {
    let p = o ?? null;
    for (let h = 0; p && h < 200 && !(p === document.body || p === document.documentElement); h++) {
      let v = Number.NaN, y = !1;
      try {
        const g = window.getComputedStyle(p);
        y = (g.position || "static") !== "static", v = Number.parseInt(g.zIndex, 10);
      } catch {
      }
      y && Number.isFinite(v) && v + 1 > s && (s = v + 1), p = p.parentElement ?? /* Out the top of a shadow tree, if the host put us in one. */
      ((n = p.getRootNode()) == null ? void 0 : n.host) ?? null;
    }
  }
  return s;
}
function mE(e, a) {
  if (typeof document > "u") return [];
  const t = [document.activeElement];
  if (typeof e == "number" && typeof a == "number" && document.elementFromPoint)
    try {
      t.push(document.elementFromPoint(e, a));
    } catch {
    }
  return t;
}
const yE = ["dir", "data-prefers-dark"], gE = ["aria-label"], bE = ["aria-label", "onKeydown"], _E = { class: "fe-sheet__items" }, kE = {
  key: 0,
  class: "fe-ctx__sep",
  role: "separator"
}, wE = ["disabled", "title", "data-testid", "onClick"], xE = ["innerHTML"], $E = {
  key: 1,
  class: "fe-ctx__icon",
  "aria-hidden": "true"
}, SE = { class: "fe-ctx__label" }, TE = {
  key: 2,
  class: "fe-ctx__key",
  "aria-hidden": "true"
}, CE = ["aria-label"], EE = {
  key: 0,
  class: "fe-ctx__sep",
  role: "separator"
}, AE = ["disabled", "title", "data-testid", "onClick"], zE = ["innerHTML"], ME = {
  key: 1,
  class: "fe-ctx__icon",
  "aria-hidden": "true"
}, DE = { class: "fe-ctx__label" }, PE = {
  key: 2,
  class: "fe-ctx__key",
  "aria-hidden": "true"
}, zr = /* @__PURE__ */ rt({
  __name: "ContextMenu",
  props: {
    locale: {},
    actions: {},
    theme: {},
    sheet: { type: Boolean }
  },
  emits: ["select"],
  setup(e, { expose: a, emit: t }) {
    const s = e, n = t, { t: o, dir: p } = gt(() => s.locale);
    function h(R) {
      return ew(R.shortcutId ?? R.key);
    }
    function v(R) {
      return wt(R.icon || R.key);
    }
    const y = b(!1), g = b(0), m = b(0), k = b(lw), _ = b([]), w = b(null);
    let $ = 0, C = 0, E = null;
    async function A(R, pe) {
      var Q;
      if (E = document.activeElement ?? null, k.value = hE(mE(R.clientX, R.clientY)), y.value = !0, g.value = R.clientX, m.value = R.clientY, $ = R.clientX, C = R.clientY, _.value = pe, await Jt(), s.sheet) {
        (Q = W.value) == null || Q.focus();
        return;
      }
      O(), I(0);
    }
    function O() {
      const R = w.value;
      if (!R || typeof window > "u") return;
      R.style.maxHeight = "", R.style.overflowY = "";
      const pe = R.getBoundingClientRect(), Q = 8, q = window.innerWidth, re = window.innerHeight, ae = re - 2 * Q;
      if (pe.height > ae) {
        R.style.maxHeight = ae + "px", R.style.overflowY = "auto", m.value = Q, g.value = zg($, pe.width, q, p.value, Q);
        return;
      }
      if (C + pe.height > re - Q) {
        const Pe = C - pe.height;
        m.value = Pe >= Q ? Pe : Math.max(Q, re - pe.height - Q);
      }
      g.value = zg($, pe.width, q, p.value, Q);
    }
    function z() {
      var R;
      y.value = !1, N.value = !1, K.value = 0, (R = E == null ? void 0 : E.focus) == null || R.call(E), E = null;
    }
    function P() {
      const R = s.sheet ? W.value : w.value;
      return R ? Array.from(
        R.querySelectorAll(".fe-ctx__item:not(:disabled)")
      ) : [];
    }
    function I(R) {
      var q;
      const pe = P();
      if (pe.length === 0) return;
      const Q = (R % pe.length + pe.length) % pe.length;
      (q = pe[Q]) == null || q.focus();
    }
    function F(R) {
      const pe = P();
      if (pe.length === 0) return;
      const Q = document.activeElement, q = Q ? pe.indexOf(Q) : -1;
      if (q === -1) {
        I(R > 0 ? 0 : pe.length - 1);
        return;
      }
      I(q + R);
    }
    const W = b(null), N = b(!1), K = b(0);
    let M = 0;
    function j(R) {
      const pe = R.touches[0];
      pe && (N.value = !0, M = pe.clientY, K.value = 0);
    }
    function U(R) {
      if (!N.value) return;
      const pe = R.touches[0];
      pe && (K.value = Math.max(0, pe.clientY - M));
    }
    function de() {
      if (!N.value) return;
      const R = K.value > 72;
      N.value = !1, R ? z() : K.value = 0;
    }
    const ke = x(
      () => K.value > 0 ? { transform: `translateY(${K.value}px)`, transition: "none" } : void 0
    );
    function ie(R) {
      R.disabled || (n("select", R, _.value), z());
    }
    function ce(R) {
      if (R.key === "Escape") {
        R.stopPropagation(), z();
        return;
      }
      if (R.key === "Enter" || R.key === " ") {
        R.stopPropagation();
        return;
      }
      R.key === "ArrowDown" ? (R.preventDefault(), R.stopPropagation(), F(1)) : R.key === "ArrowUp" ? (R.preventDefault(), R.stopPropagation(), F(-1)) : R.key === "Home" ? (R.preventDefault(), I(0)) : R.key === "End" ? (R.preventDefault(), I(-1)) : R.key === "Tab" && (R.preventDefault(), z());
    }
    const X = x(() => {
      const R = s.actions.filter((Q) => !Q.hidden), pe = [];
      for (const Q of R)
        Q.divider && (pe.length === 0 || pe[pe.length - 1].divider) || pe.push(Q);
      for (; pe.length > 0 && pe[pe.length - 1].divider; ) pe.pop();
      return pe;
    }), Z = b(!1);
    let Y;
    function G(R) {
      Z.value = !!(R && "matches" in R && R.matches);
    }
    Kt(() => {
      var R;
      typeof window > "u" || (Y = window.matchMedia("(prefers-color-scheme: dark)"), G(Y), (R = Y.addEventListener) == null || R.call(Y, "change", G));
    }), Mt(() => {
      var R;
      (R = Y == null ? void 0 : Y.removeEventListener) == null || R.call(Y, "change", G);
    });
    const we = x(() => `fe-ctx-backdrop--theme-${s.theme || "auto"}`);
    return a({ show: A, hide: z }), (R, pe) => (u(), nt(Hs, { to: "body" }, [
      ot(us, {
        name: e.sheet ? "fe-sheet" : "fe-ctx"
      }, {
        default: yt(() => [
          y.value ? (u(), d("div", {
            key: 0,
            class: Re(["fe-ctx-backdrop", [we.value, { "fe-ctx-backdrop--sheet": e.sheet }]]),
            dir: r(p),
            style: Vt({
              zIndex: k.value
              /* katman:z1 */
            }),
            "data-prefers-dark": Z.value ? "1" : "0",
            onClick: z,
            onContextmenu: ft(z, ["prevent"]),
            onKeydown: ce
          }, [
            e.sheet ? (u(), d("div", {
              key: 0,
              ref_key: "sheetEl",
              ref: W,
              class: "fe-sheet",
              role: "menu",
              "aria-label": r(o)("sheet.menu"),
              tabindex: "-1",
              style: Vt(ke.value),
              onClick: pe[0] || (pe[0] = ft(() => {
              }, ["stop"]))
            }, [
              i("div", {
                class: "fe-sheet__handle",
                role: "button",
                tabindex: "0",
                "aria-label": r(o)("sheet.close"),
                onClick: z,
                onKeydown: ya(ft(z, ["prevent"]), ["enter"]),
                onTouchstartPassive: j,
                onTouchmovePassive: U,
                onTouchend: de,
                onTouchcancel: de
              }, null, 40, bE),
              i("div", _E, [
                (u(!0), d(he, null, We(X.value, (Q, q) => (u(), d(he, {
                  key: Q.key || q
                }, [
                  Q.divider ? (u(), d("div", kE)) : (u(), d("button", {
                    key: 1,
                    type: "button",
                    class: Re(["fe-ctx__item fe-sheet__item", { "is-danger": Q.danger, "is-disabled": Q.disabled }]),
                    disabled: Q.disabled,
                    title: Q.title,
                    "data-testid": Q.testid,
                    role: "menuitem",
                    onClick: (re) => ie(Q)
                  }, [
                    v(Q) ? (u(), d("span", {
                      key: 0,
                      class: "fe-ctx__icon",
                      "aria-hidden": "true",
                      innerHTML: v(Q)
                    }, null, 8, xE)) : Q.icon ? (u(), d("span", $E, f(Q.icon), 1)) : T("", !0),
                    i("span", SE, f(Q.label), 1),
                    h(Q) ? (u(), d("span", TE, f(h(Q)), 1)) : T("", !0)
                  ], 10, wE))
                ], 64))), 128))
              ])
            ], 12, gE)) : (u(), d("div", {
              key: 1,
              ref_key: "menuEl",
              ref: w,
              class: "fe-ctx",
              role: "menu",
              "aria-orientation": "vertical",
              "aria-label": r(o)("sheet.menu"),
              style: Vt({ top: m.value + "px", left: g.value + "px" }),
              onClick: pe[1] || (pe[1] = ft(() => {
              }, ["stop"]))
            }, [
              (u(!0), d(he, null, We(X.value, (Q, q) => (u(), d(he, {
                key: Q.key || q
              }, [
                Q.divider ? (u(), d("div", EE)) : (u(), d("button", {
                  key: 1,
                  type: "button",
                  class: Re(["fe-ctx__item", { "is-danger": Q.danger, "is-disabled": Q.disabled }]),
                  disabled: Q.disabled,
                  title: Q.title,
                  "data-testid": Q.testid,
                  role: "menuitem",
                  onClick: (re) => ie(Q)
                }, [
                  v(Q) ? (u(), d("span", {
                    key: 0,
                    class: "fe-ctx__icon",
                    "aria-hidden": "true",
                    innerHTML: v(Q)
                  }, null, 8, zE)) : Q.icon ? (u(), d("span", ME, f(Q.icon), 1)) : T("", !0),
                  i("span", DE, f(Q.label), 1),
                  h(Q) ? (u(), d("span", PE, f(h(Q)), 1)) : T("", !0)
                ], 10, AE))
              ], 64))), 128))
            ], 12, CE))
          ], 46, yE)) : T("", !0)
        ]),
        _: 1
      }, 8, ["name"])
    ]));
  }
}), OE = ["aria-pressed", "title", "aria-label"], LE = {
  key: 1,
  class: "fe-toolbar__mark"
}, IE = ["src"], RE = { key: 1 }, NE = { class: "fe-toolbar__primary" }, BE = ["title"], FE = ["innerHTML"], UE = { class: "fe-btn__label" }, HE = ["title", "aria-label"], KE = ["innerHTML"], VE = ["title"], qE = ["innerHTML"], jE = { class: "fe-btn__label" }, WE = { class: "fe-toolbar__search-group fe-toolbar__search-group--drive" }, YE = {
  class: "fe-search fe-drivesearch",
  "data-testid": "drive-search"
}, GE = ["placeholder", "value", "aria-label"], XE = ["title", "aria-label"], JE = ["innerHTML"], ZE = ["title", "aria-label"], QE = { class: "fe-toolbar__tail" }, eA = ["title", "aria-label"], tA = ["innerHTML"], aA = { class: "fe-toolbar__soon-wrap" }, nA = ["aria-label"], sA = ["innerHTML"], oA = {
  class: "fe-toolbar__soon-tip",
  "aria-hidden": "true",
  "data-testid": "header-ai-tip"
}, iA = ["title", "aria-label"], rA = ["innerHTML"], lA = {
  class: "fe-drivesearch",
  "data-testid": "drive-search"
}, uA = ["placeholder", "value", "aria-label"], cA = ["title", "aria-label"], dA = ["innerHTML"], fA = ["title", "aria-label"], pA = { class: "fe-toolbar__tail" }, vA = { class: "fe-toolbar__soon-wrap" }, hA = ["aria-label"], mA = ["innerHTML"], yA = {
  class: "fe-toolbar__soon-tip",
  "aria-hidden": "true",
  "data-testid": "header-ai-tip"
}, gA = ["title", "aria-label"], bA = ["innerHTML"], _A = ["aria-label"], kA = {
  class: "fe-selbar__count",
  role: "status",
  "data-testid": "selection-count"
}, wA = ["disabled", "title", "aria-label", "data-key", "data-testid", "onClick"], xA = ["innerHTML"], $A = ["title", "aria-label"], SA = ["innerHTML"], TA = ["data-key"], CA = ["innerHTML"], EA = ["title", "aria-label"], AA = ["innerHTML"], kc = "filex.density", zA = 32, nb = "fe:header-menu", MA = /* @__PURE__ */ rt({
  __name: "Toolbar",
  props: {
    viewMode: {},
    searchQuery: {},
    trashActive: { type: Boolean },
    actions: {},
    selectionMode: {},
    selectionCount: {},
    selectionPane: {},
    pasteEnabled: { type: Boolean },
    canGoUp: { type: Boolean },
    atVirtualRoot: { type: Boolean },
    canWrite: { type: Boolean },
    locale: {},
    narrow: { type: Boolean },
    theme: {},
    inspectorOpen: { type: Boolean },
    navOpen: { type: Boolean },
    navEnabled: { type: Boolean },
    viewModes: {},
    scopeLabel: {},
    brandName: {},
    brandMarkUrl: {},
    searchEscalates: { type: Boolean }
  },
  emits: ["update:viewMode", "update:searchQuery", "open-advanced-search", "new-folder", "upload", "refresh", "go-up", "action", "open-recents", "update:density", "toggle-inspector", "toggle-nav", "open-theme", "open-shortcut-settings", "open-timezone", "open-palette"],
  setup(e, { expose: a, emit: t }) {
    function s(L) {
      return wt(L.icon || L.key);
    }
    const n = e, o = t, p = b(
      (() => {
        try {
          return localStorage.getItem(kc) === "compact" ? "compact" : "comfortable";
        } catch {
          return "comfortable";
        }
      })()
    );
    function h() {
      try {
        const L = localStorage.getItem(kc) === "compact" ? "compact" : "comfortable";
        L !== p.value && (p.value = L, o("update:density", L));
      } catch {
      }
    }
    function v(L) {
      (L.key === null || L.key === kc) && h();
    }
    Kt(() => {
      o("update:density", p.value), window.addEventListener("storage", v), window.addEventListener("filex:density", h);
    }), Mt(() => {
      window.removeEventListener("storage", v), window.removeEventListener("filex:density", h);
    });
    function y() {
      p.value = p.value === "compact" ? "comfortable" : "compact";
      try {
        localStorage.setItem(kc, p.value);
      } catch {
      }
      o("update:density", p.value);
    }
    const { t: g, dir: m } = gt(() => n.locale), k = b(null), _ = b(n.searchQuery);
    Qe(() => n.searchQuery, (L) => {
      _.value = L;
    });
    let w;
    function $(L) {
      const se = L.target.value;
      _.value = se, w && clearTimeout(w), w = setTimeout(() => o("update:searchQuery", se), 200);
    }
    async function C() {
      var L, se;
      await Jt(), (L = k.value) == null || L.focus(), (se = k.value) == null || se.select();
    }
    a({ focusSearch: C });
    const E = x(() => n.selectionMode ?? "none"), A = x(() => n.actions.filter((L) => !L.divider && !L.hidden)), O = /* @__PURE__ */ new Set(["download", "access", "cut", "copy", "star", "restore", "delete"]), z = x(() => E.value !== "none"), P = x(() => {
      const L = [], se = [];
      let ne = 0;
      for (const et of n.actions)
        if (!et.hidden) {
          if (et.divider) {
            se.push(et);
            continue;
          }
          O.has(et.key) && s(et) ? L.push(et) : (se.push(et), ne++);
        }
      return { icons: L, rest: ne ? se : [], restCount: ne };
    }), I = b(null), F = b(null), W = b(null), N = b(null), K = b(Number.MAX_SAFE_INTEGER), M = x(() => P.value.icons.slice(0, K.value)), j = x(() => P.value.icons.slice(K.value)), U = x(() => {
      const L = j.value, se = P.value.rest;
      return L.length && se.length ? [...L, { divider: !0, key: "selbar-sep", label: "" }, ...se] : [...L, ...se];
    });
    function de() {
      var Qt;
      const L = I.value, se = F.value, ne = P.value.icons.length;
      if (!L || !se) {
        K.value = ne;
        return;
      }
      const et = parseFloat(getComputedStyle(L).gap) || 4, ht = Array.from(se.children).map((ta) => ta.offsetWidth + et), Tt = ht.reduce((ta, Rt) => ta + Rt, 0), Ft = L.clientWidth, Lt = (((Qt = W.value) == null ? void 0 : Qt.offsetWidth) || zA) + et;
      if (Tt <= Ft - (P.value.rest.length ? Lt : 0)) {
        K.value = ht.length;
        return;
      }
      let ua = Lt, Ct = 0;
      for (const ta of ht) {
        if (ua + ta > Ft) break;
        ua += ta, Ct += 1;
      }
      K.value = Ct;
    }
    let ke;
    Qe(I, (L) => {
      ke == null || ke.disconnect(), ke = void 0, L && typeof ResizeObserver < "u" && (ke = new ResizeObserver(() => de()), ke.observe(L)), Jt(de);
    }), Mt(() => ke == null ? void 0 : ke.disconnect()), Qe(
      () => [A.value, n.narrow, n.trashActive, E.value],
      () => void Jt(de),
      { deep: !1 }
    );
    function ie() {
      var se, ne;
      const L = (se = W.value) == null ? void 0 : se.getBoundingClientRect();
      (ne = N.value) == null || ne.show({ clientX: L ? Ag(L, m.value) : 0, clientY: L ? L.bottom + 4 : 0 }, []);
    }
    const ce = b(null), X = Dn(null), Z = b(!1), Y = Dn(null), G = Dn(null);
    function we() {
      var ne;
      const L = (ne = ce.value) == null ? void 0 : ne.closest(".fe");
      if (!L) return null;
      const se = n.selectionPane;
      if (se && /^[A-Za-z][\w-]*$/.test(se)) {
        const et = L.querySelector(`.fe__primary[data-pane="${se}"]`);
        if (et) return et;
      }
      return L.querySelector(".fe__primary");
    }
    function R() {
      const L = X.value;
      L && (L.classList.remove("is-active"), Z.value && L.remove()), X.value = null, Z.value = !1;
    }
    function pe() {
      var ne;
      const L = we();
      if (!L) {
        R(), G.value = null, Y.value = null;
        return;
      }
      if (G.value === L && ((ne = X.value) != null && ne.isConnected)) return;
      R(), G.value = L, Y.value = L.querySelector(":scope > .fe__body");
      const se = L.querySelector(":scope > .fe-selbar-slot");
      if (se)
        X.value = se, Z.value = !1;
      else {
        const et = document.createElement("div");
        et.className = "fe-selbar-slot";
        const ht = L.querySelector(":scope > .fe-tabs") ?? L.querySelector(":scope > .fe-subhead, :scope > .fe-subhead--plain");
        ht ? ht.insertAdjacentElement("afterend", et) : L.prepend(et), X.value = et, Z.value = !0;
      }
      Q(), ze();
    }
    Kt(pe), Mt(R);
    function Q() {
      var L;
      (L = X.value) == null || L.classList.toggle("is-active", z.value);
    }
    Qe(z, Q, { immediate: !0 }), Qe([() => n.selectionPane, z], () => pe());
    const q = b(0);
    let re, ae = !1;
    function Pe() {
      const L = G.value;
      L && (q.value = L.querySelectorAll('[data-fe-path][aria-selected="true"]').length);
    }
    function be() {
      if (ae) return;
      ae = !0, ((se) => typeof requestAnimationFrame == "function" ? requestAnimationFrame(se) : setTimeout(se, 16))(() => {
        ae = !1, Pe();
      });
    }
    function ze() {
      if (re == null || re.disconnect(), re = void 0, !z.value) {
        q.value = 0;
        return;
      }
      Pe(), !(typeof MutationObserver > "u" || !G.value) && (re = new MutationObserver(be), re.observe(G.value, {
        subtree: !0,
        childList: !0,
        attributes: !0,
        attributeFilter: ["aria-selected"]
      }));
    }
    Qe(z, ze), Mt(() => re == null ? void 0 : re.disconnect());
    const Ae = x(() => typeof n.selectionCount == "number" ? n.selectionCount : E.value === "none" ? 0 : Math.max(q.value, E.value === "multi" ? 2 : 1)), Ce = x(() => g("selection.count", { n: String(Ae.value) }));
    function He() {
      var L;
      o("action", "clear-selection"), (L = Y.value) == null || L.dispatchEvent(new MouseEvent("click", { bubbles: !0 }));
    }
    function J(L) {
      o("action", L);
    }
    const me = b(!1);
    let fe;
    function xe(L) {
      me.value = !!(L && "matches" in L && L.matches);
    }
    Kt(() => {
      var L;
      typeof window > "u" || !window.matchMedia || (fe = window.matchMedia("(pointer: coarse)"), xe(fe), (L = fe.addEventListener) == null || L.call(fe, "change", xe));
    }), Mt(() => {
      var L;
      (L = fe == null ? void 0 : fe.removeEventListener) == null || L.call(fe, "change", xe);
    });
    const ye = b(null), qe = b(null);
    function ut(L) {
      return !n.viewModes || n.viewModes.includes(L);
    }
    const Ue = x(() => {
      const L = [];
      return n.narrow && L.push({ key: "refresh", label: g("toolbar.refresh") }), L.push({
        key: "density",
        label: p.value === "compact" ? g("toolbar.density.comfortable") : g("toolbar.density.compact")
      }), n.viewMode !== "list" && ut("list") && L.push({ key: "view-list", label: g("toolbar.view.list") }), n.viewMode !== "grid" && ut("grid") && L.push({ key: "view-grid", label: g("toolbar.view.grid") }), n.viewMode !== "gallery" && ut("gallery") && L.push({ key: "view-gallery", label: g("toolbar.view.gallery") }), L.push({ key: "inspector", label: g("toolbar.inspector") }), L.push({ key: "theme", label: g("theme.menu") }), L.push({ key: "timezone", label: g("tz.menu") }), L.push({ key: "shortcut-settings", label: g("shortcuts.settings.menu") }), L.push({ key: "tour", label: g("tour.restart") }), L;
    });
    function Ye(L) {
      const se = [], ne = !n.trashActive && !n.atVirtualRoot && n.canWrite !== !1;
      return E.value === "none" && ne && (se.push({ key: "new-folder", label: g("toolbar.new_folder") }), n.pasteEnabled && se.push({ key: "paste", label: g("ctx.paste") })), z.value || se.push(...A.value), L.length && (se.length && se.push({ divider: !0, key: "bag-sep", label: "" }), se.push(...L)), se;
    }
    const st = x(() => Ar("palette"));
    function kt(L, se) {
      const ne = ew(se);
      return ne ? `${L} (${ne})` : L;
    }
    const At = x(() => n.narrow ? n.navOpen ? g("sidenav.close") : g("sidenav.open") : n.navOpen ? g("sidenav.collapse") : g("sidenav.expand")), _t = x(
      () => n.scopeLabel ? g("drive.search.placeholder", { scope: n.scopeLabel }) : g("drive.search.placeholder_all")
    );
    function Le(L) {
      if (fv(L, "palette")) {
        L.preventDefault(), L.stopPropagation(), o("open-palette", _.value);
        return;
      }
      n.searchEscalates && L.key === "Enter" && _.value && (L.preventDefault(), L.stopPropagation(), o("open-palette", _.value));
    }
    const tt = b(!1);
    function ve() {
      const L = ce.value;
      if (!L) return;
      const se = {
        items: Ue.value.map((ne) => ({ ...ne })),
        run: (ne) => Te({ key: ne }),
        claimed: !1
      };
      L.dispatchEvent(
        new CustomEvent(nb, { detail: se, bubbles: !0, composed: !0 })
      ), tt.value = !!se.claimed;
    }
    Kt(() => void Jt(ve)), Qe(Ue, () => void Jt(ve), { deep: !1 }), Mt(() => {
      typeof document > "u" || document.dispatchEvent(
        new CustomEvent(nb, {
          detail: { items: [], run: () => {
          }, claimed: !1 }
        })
      );
    });
    const H = x(() => {
      const L = tt.value ? [] : Ue.value;
      return n.narrow ? Ye(L) : L;
    });
    function te() {
      var se, ne;
      const L = (se = ye.value) == null ? void 0 : se.getBoundingClientRect();
      (ne = qe.value) == null || ne.show({ clientX: L ? Ag(L, m.value) : 0, clientY: L ? L.bottom + 4 : 0 }, []);
    }
    function Te(L) {
      var se;
      switch (L.key) {
        case "new-folder":
          o("new-folder");
          break;
        case "refresh":
          o("refresh");
          break;
        case "density":
          y();
          break;
        case "view-list":
          o("update:viewMode", "list");
          break;
        case "view-grid":
          o("update:viewMode", "grid");
          break;
        case "view-gallery":
          o("update:viewMode", "gallery");
          break;
        case "inspector":
          o("toggle-inspector");
          break;
        case "nav":
          o("toggle-nav");
          break;
        case "theme":
          o("open-theme");
          break;
        case "shortcut-settings":
          o("open-shortcut-settings");
          break;
        case "timezone":
          o("open-timezone");
          break;
        case "tour":
          (se = ce.value) == null || se.dispatchEvent(new CustomEvent("fe:tour-restart", { bubbles: !0 }));
          break;
        default:
          J(L.key);
      }
    }
    return (L, se) => (u(), d("div", {
      ref_key: "rootEl",
      ref: ce,
      class: Re(["fe-toolbar", {
        "fe-toolbar--narrow": e.narrow,
        /* surucu:d1 — ALWAYS on. It is no longer a variant: this is the only
           header filex has, and the modifier survives as the hook the one
           visual definition in styles/base.css was written against. Dropping it
           would mean moving those rules, not deleting a state. */
        "fe-toolbar--drive": !0
      }])
    }, [
      e.navEnabled !== !1 || L.$slots.brand || e.brandName || e.brandMarkUrl ? (u(), d("div", {
        key: 0,
        class: Re(["fe-toolbar__brand", {
          "fe-toolbar__brand--gutter": e.navEnabled !== !1,
          /* gezinti:g3 — the panel collapsed to its rail, so this gutter has to
             collapse with it. `navOpen === false`, never `!navOpen`: the prop is
             optional, and an embedder that does not pass it must keep the
             expanded layout rather than lose its wordmark to a `undefined`. */
          "fe-toolbar__brand--rail": !e.narrow && e.navEnabled !== !1 && e.navOpen === !1
        }])
      }, [
        e.navEnabled !== !1 ? (u(), d("button", {
          key: 0,
          type: "button",
          class: "fe-btn fe-btn--icon-only fe-toolbar__nav",
          "aria-pressed": !!e.navOpen,
          title: At.value,
          "aria-label": At.value,
          "data-testid": "toolbar-nav",
          onClick: se[0] || (se[0] = (ne) => o("toggle-nav"))
        }, [...se[12] || (se[12] = [
          i("svg", {
            class: "fe-ficon",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "1.8",
            "stroke-linecap": "round",
            "aria-hidden": "true",
            focusable: "false"
          }, [
            i("path", { d: "M4 7h16M4 12h16M4 17h16" })
          ], -1)
        ])], 8, OE)) : T("", !0),
        !e.narrow && e.navOpen !== !1 ? (u(), d("div", LE, [
          wa(L.$slots, "brand", {}, () => [
            e.brandMarkUrl ? (u(), d("img", {
              key: 0,
              class: "fe-toolbar__markimg",
              src: e.brandMarkUrl,
              alt: ""
            }, null, 8, IE)) : T("", !0),
            e.brandName ? (u(), d("span", RE, f(e.brandName), 1)) : T("", !0)
          ])
        ])) : T("", !0)
      ], 2)) : T("", !0),
      e.narrow ? (u(), d(he, { key: 2 }, [
        i("div", lA, [
          se[14] || (se[14] = i("svg", {
            class: "fe-ficon fe-drivesearch__glass",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "1.9",
            "stroke-linecap": "round",
            "aria-hidden": "true",
            focusable: "false"
          }, [
            i("circle", {
              cx: "11",
              cy: "11",
              r: "6.5"
            }),
            i("path", { d: "M16 16l4.5 4.5" })
          ], -1)),
          i("input", {
            ref_key: "searchEl",
            ref: k,
            type: "search",
            class: "fe-drivesearch__input",
            placeholder: _t.value,
            value: _.value,
            "aria-label": r(g)("toolbar.search"),
            onInput: $,
            onKeydown: Le
          }, null, 40, uA),
          i("button", {
            type: "button",
            class: "fe-drivesearch__tune",
            title: r(g)("advsearch.open"),
            "aria-label": r(g)("advsearch.open"),
            "data-testid": "drive-search-advanced",
            onClick: se[8] || (se[8] = (ne) => o("open-advanced-search", _.value))
          }, [
            i("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: r(wt)("filter")
            }, null, 8, dA)
          ], 8, cA),
          i("button", {
            type: "button",
            class: "fe-drivesearch__kbd",
            title: r(g)("drive.search.hint_title", { combo: st.value }),
            "aria-label": r(g)("drive.search.hint_title", { combo: st.value }),
            "data-testid": "drive-search-palette",
            onClick: se[9] || (se[9] = (ne) => o("open-palette", _.value))
          }, f(st.value), 9, fA)
        ]),
        i("div", pA, [
          i("span", vA, [
            i("button", {
              type: "button",
              class: "fe-btn fe-btn--icon-only fe-toolbar__soon",
              disabled: "",
              "aria-label": r(g)("ai.assistant.soon"),
              "aria-disabled": "true",
              "data-testid": "header-ai",
              onClick: se[10] || (se[10] = ft(() => {
              }, ["prevent"]))
            }, [
              i("span", {
                class: "fe-icon",
                "aria-hidden": "true",
                innerHTML: r(wt)("ai")
              }, null, 8, mA)
            ], 8, hA),
            i("span", yA, f(r(g)("ai.assistant.soon")), 1)
          ]),
          H.value.length > 0 ? (u(), d("button", {
            key: 0,
            ref_key: "moreBtnEl",
            ref: ye,
            type: "button",
            class: "fe-btn fe-btn--icon-only",
            title: r(g)("toolbar.more"),
            "aria-label": r(g)("toolbar.more"),
            "aria-haspopup": "menu",
            "data-testid": "drive-more",
            onClick: te
          }, [
            i("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: r(wt)("more")
            }, null, 8, bA)
          ], 8, gA)) : T("", !0),
          wa(L.$slots, "header-actions")
        ])
      ], 64)) : (u(), d(he, { key: 1 }, [
        i("div", NE, [
          e.navEnabled === !1 && E.value === "none" && !e.trashActive && !e.atVirtualRoot && e.canWrite !== !1 ? (u(), d("button", {
            key: 0,
            type: "button",
            class: "fe-btn fe-btn--primary",
            title: kt(r(g)("toolbar.new_folder"), "new-folder"),
            onClick: se[1] || (se[1] = (ne) => o("new-folder"))
          }, [
            i("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: r(wt)("new-folder")
            }, null, 8, FE),
            i("span", UE, f(r(g)("toolbar.new_folder")), 1)
          ], 8, BE)) : T("", !0),
          e.navEnabled === !1 && !e.atVirtualRoot && e.canWrite !== !1 ? (u(), d("button", {
            key: 1,
            type: "button",
            class: "fe-btn fe-btn--icon-only",
            title: kt(r(g)("toolbar.upload"), "upload"),
            "aria-label": r(g)("toolbar.upload"),
            onClick: se[2] || (se[2] = (ne) => o("upload"))
          }, [
            i("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: r(wt)("upload")
            }, null, 8, KE)
          ], 8, HE)) : T("", !0),
          e.pasteEnabled && E.value === "none" && !e.trashActive && !e.atVirtualRoot && e.canWrite !== !1 ? (u(), d("button", {
            key: 2,
            type: "button",
            class: "fe-btn",
            title: kt(r(g)("ctx.paste"), "paste"),
            onClick: se[3] || (se[3] = (ne) => J("paste"))
          }, [
            i("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: r(wt)("paste")
            }, null, 8, qE),
            i("span", jE, f(r(g)("ctx.paste")), 1)
          ], 8, VE)) : T("", !0)
        ]),
        i("div", WE, [
          i("div", YE, [
            se[13] || (se[13] = i("svg", {
              class: "fe-ficon fe-drivesearch__glass",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "1.9",
              "stroke-linecap": "round",
              "aria-hidden": "true",
              focusable: "false"
            }, [
              i("circle", {
                cx: "11",
                cy: "11",
                r: "6.5"
              }),
              i("path", { d: "M16 16l4.5 4.5" })
            ], -1)),
            i("input", {
              ref_key: "searchEl",
              ref: k,
              type: "search",
              class: "fe-search__input fe-drivesearch__input",
              placeholder: _t.value,
              value: _.value,
              "aria-label": r(g)("toolbar.search"),
              onInput: $,
              onKeydown: Le
            }, null, 40, GE),
            i("button", {
              type: "button",
              class: "fe-drivesearch__tune",
              title: r(g)("advsearch.open"),
              "aria-label": r(g)("advsearch.open"),
              "data-testid": "drive-search-advanced",
              onClick: se[4] || (se[4] = (ne) => o("open-advanced-search", _.value))
            }, [
              i("span", {
                class: "fe-icon",
                "aria-hidden": "true",
                innerHTML: r(wt)("filter")
              }, null, 8, JE)
            ], 8, XE),
            i("button", {
              type: "button",
              class: "fe-drivesearch__kbd",
              title: r(g)("drive.search.hint_title", { combo: st.value }),
              "aria-label": r(g)("drive.search.hint_title", { combo: st.value }),
              "data-testid": "drive-search-palette",
              onClick: se[5] || (se[5] = (ne) => o("open-palette", _.value))
            }, f(st.value), 9, ZE)
          ])
        ]),
        i("div", QE, [
          i("button", {
            type: "button",
            class: "fe-btn fe-btn--icon-only",
            title: kt(r(g)("toolbar.refresh"), "refresh"),
            "aria-label": r(g)("toolbar.refresh"),
            onClick: se[6] || (se[6] = (ne) => o("refresh"))
          }, [
            i("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: r(wt)("refresh")
            }, null, 8, tA)
          ], 8, eA),
          i("span", aA, [
            i("button", {
              type: "button",
              class: "fe-btn fe-btn--icon-only fe-toolbar__soon",
              disabled: "",
              "aria-label": r(g)("ai.assistant.soon"),
              "aria-disabled": "true",
              "data-testid": "header-ai",
              onClick: se[7] || (se[7] = ft(() => {
              }, ["prevent"]))
            }, [
              i("span", {
                class: "fe-icon",
                "aria-hidden": "true",
                innerHTML: r(wt)("ai")
              }, null, 8, sA)
            ], 8, nA),
            i("span", oA, f(r(g)("ai.assistant.soon")), 1)
          ]),
          H.value.length > 0 ? (u(), d("button", {
            key: 0,
            ref_key: "moreBtnEl",
            ref: ye,
            type: "button",
            class: "fe-btn fe-btn--icon-only",
            title: r(g)("toolbar.more"),
            "aria-label": r(g)("toolbar.more"),
            "aria-haspopup": "menu",
            "data-testid": "drive-more",
            onClick: te
          }, [
            i("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: r(wt)("more")
            }, null, 8, rA)
          ], 8, iA)) : T("", !0),
          wa(L.$slots, "header-actions")
        ])
      ], 64)),
      ot(zr, {
        ref_key: "moreRef",
        ref: qe,
        locale: e.locale,
        theme: e.theme || "auto",
        sheet: me.value,
        actions: H.value,
        onSelect: Te
      }, null, 8, ["locale", "theme", "sheet", "actions"]),
      (u(), nt(Hs, {
        to: X.value || "body",
        disabled: !X.value
      }, [
        z.value ? (u(), d("div", {
          key: 0,
          class: Re(["fe-selbar", { "fe-selbar--inline": !X.value }]),
          role: "toolbar",
          "aria-label": Ce.value,
          "data-testid": "selection-bar"
        }, [
          i("span", kA, f(Ce.value), 1),
          i("div", {
            ref_key: "selBarEl",
            ref: I,
            class: "fe-selbar__actions"
          }, [
            (u(!0), d(he, null, We(M.value, (ne) => (u(), d("button", {
              key: ne.key,
              type: "button",
              class: Re(["fe-selbar__btn", { "fe-selbar__btn--danger": ne.danger, "is-disabled": ne.disabled }]),
              disabled: ne.disabled,
              title: ne.title || kt(ne.label, ne.key),
              "aria-label": ne.label,
              "data-key": ne.key,
              "data-testid": `selbar-${ne.key}`,
              onClick: (et) => J(ne.key)
            }, [
              i("span", {
                class: "fe-icon",
                "aria-hidden": "true",
                innerHTML: s(ne)
              }, null, 8, xA)
            ], 10, wA))), 128)),
            U.value.length > 0 ? (u(), d("button", {
              key: 0,
              ref_key: "selMoreBtnEl",
              ref: W,
              type: "button",
              class: "fe-selbar__btn",
              title: r(g)("toolbar.more"),
              "aria-label": r(g)("toolbar.more"),
              "aria-haspopup": "menu",
              "data-testid": "selbar-more",
              onClick: ie
            }, [
              i("span", {
                class: "fe-icon",
                "aria-hidden": "true",
                innerHTML: r(wt)("more")
              }, null, 8, SA)
            ], 8, $A)) : T("", !0),
            i("div", {
              ref_key: "measureEl",
              ref: F,
              class: "fe-selbar__measure",
              "aria-hidden": "true"
            }, [
              (u(!0), d(he, null, We(P.value.icons, (ne) => (u(), d("button", {
                key: "m-" + ne.key,
                type: "button",
                class: "fe-selbar__btn",
                "data-key": ne.key,
                tabindex: "-1"
              }, [
                i("span", {
                  class: "fe-icon",
                  "aria-hidden": "true",
                  innerHTML: s(ne)
                }, null, 8, CA)
              ], 8, TA))), 128))
            ], 512)
          ], 512),
          i("button", {
            type: "button",
            class: "fe-selbar__close",
            title: r(g)("selection.clear"),
            "aria-label": r(g)("selection.clear"),
            "data-testid": "selection-clear",
            onClick: He
          }, [
            i("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: r(wt)("close")
            }, null, 8, AA)
          ], 8, EA)
        ], 10, _A)) : T("", !0)
      ], 8, ["to", "disabled"])),
      ot(zr, {
        ref_key: "selMoreRef",
        ref: N,
        locale: e.locale,
        theme: e.theme || "auto",
        sheet: me.value,
        actions: U.value,
        onSelect: se[11] || (se[11] = (ne) => J(ne.key))
      }, null, 8, ["locale", "theme", "sheet", "actions"])
    ], 2));
  }
}), DA = 6e4;
function PA(e) {
  return e === "personal" || e === "team";
}
function sd(e) {
  return String(e ?? "").normalize("NFC").trim().replace(/\s+/g, " ").replace(/[Iıİ]/g, "i").toLowerCase();
}
function mv(e) {
  const a = e ?? {};
  return Array.isArray(a.items) ? a.items.filter(
    (t) => !!t && typeof t.name == "string" && t.name !== "" && PA(t.kind)
  ) : Array.isArray(a.tags) ? a.tags.filter((t) => typeof t == "string" && t !== "").map((t) => ({ name: t, kind: "team" })) : [];
}
const yv = /* @__PURE__ */ new Map(), Oc = /* @__PURE__ */ new Map();
function OA() {
  yv.clear(), Oc.clear();
}
const gv = /* @__PURE__ */ new Set();
function LA(e) {
  return gv.add(e), () => {
    gv.delete(e);
  };
}
function IA() {
  OA();
  for (const e of [...gv])
    try {
      e();
    } catch {
    }
}
async function sb(e = {}) {
  const a = e.apiBase ?? "", t = a || "(same-origin)";
  if (!e.force) {
    const n = yv.get(t);
    if (n && Date.now() - n.at < DA) return n.tags;
    const o = Oc.get(t);
    if (o) return o;
  }
  const s = (async () => {
    try {
      const n = await fetch(`${a}/api/files/manager/tags/all`, {
        headers: await (e.authHeaders ?? (() => ({})))(),
        credentials: e.authCredentials ?? "same-origin"
      });
      if (!n.ok) return [];
      const o = mv(await n.json());
      return yv.set(t, { at: Date.now(), tags: o }), o;
    } catch {
      return [];
    } finally {
      Oc.delete(t);
    }
  })();
  return Oc.set(t, s), s;
}
async function RA(e, a = {}, t = 200, s = "") {
  const n = a.apiBase ?? "", o = s ? `&kind=${s}` : "", p = await fetch(
    `${n}/api/files/manager/tagged?tag=${encodeURIComponent(e)}&limit=${t}${o}`,
    {
      headers: await (a.authHeaders ?? (() => ({})))(),
      credentials: a.authCredentials ?? "same-origin"
    }
  );
  if (!p.ok) throw new Error(String(p.status));
  const h = await p.json();
  return Array.isArray(h == null ? void 0 : h.nodes) ? h.nodes : [];
}
const NA = ["width", "height", "data-tag-kind"], Xl = /* @__PURE__ */ rt({
  __name: "TagKindIcon",
  props: {
    kind: {},
    size: {}
  },
  setup(e) {
    return (a, t) => (u(), d("svg", {
      class: Re(["fe-tagkind", `fe-tagkind--${e.kind}`]),
      width: e.size ?? 12,
      height: e.size ?? 12,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "aria-hidden": "true",
      focusable: "false",
      "data-tag-kind": e.kind
    }, [
      e.kind === "team" ? (u(), d(he, { key: 0 }, [
        t[0] || (t[0] = i("circle", {
          cx: "9",
          cy: "8",
          r: "3.2"
        }, null, -1)),
        t[1] || (t[1] = i("path", { d: "M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6" }, null, -1)),
        t[2] || (t[2] = i("circle", {
          cx: "17",
          cy: "9",
          r: "2.6"
        }, null, -1)),
        t[3] || (t[3] = i("path", { d: "M16.5 14.2c2.6.3 4.5 2.6 4.5 5.3" }, null, -1))
      ], 64)) : (u(), d(he, { key: 1 }, [
        t[4] || (t[4] = i("circle", {
          cx: "12",
          cy: "8",
          r: "3.6"
        }, null, -1)),
        t[5] || (t[5] = i("path", { d: "M5 20c0-3.9 3.1-7 7-7s7 3.1 7 7" }, null, -1))
      ], 64))
    ], 10, NA));
  }
}), BA = ["role", "aria-labelledby", "aria-label"], FA = ["role", "aria-checked", "aria-pressed", "tabindex", "disabled", "data-testid", "onClick", "onKeydown"], UA = { class: "fe-choice__label" }, HA = {
  key: 0,
  class: "fe-choice__help"
}, Ls = /* @__PURE__ */ rt({
  __name: "ChoiceButtons",
  props: {
    options: {},
    modelValue: {},
    multi: { type: Boolean },
    disabled: { type: Boolean },
    invalid: { type: Boolean },
    ariaLabelledby: {},
    ariaLabel: {},
    testidPrefix: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, s = a, n = x(() => {
      const g = t.modelValue;
      return Array.isArray(g) ? g.map((m) => String(m)) : g == null || g === "" ? [] : [String(g)];
    });
    function o(g) {
      return n.value.includes(g);
    }
    function p(g) {
      var m;
      return !!t.disabled || !!((m = t.options.find((k) => k.value === g)) != null && m.disabled);
    }
    function h(g) {
      if (!p(g)) {
        if (t.multi) {
          const m = o(g) ? n.value.filter((_) => _ !== g) : [...n.value, g], k = t.options.map((_) => _.value);
          s("update:modelValue", k.filter((_) => m.includes(_)));
          return;
        }
        s("update:modelValue", g);
      }
    }
    function v(g, m) {
      var O;
      if (t.multi || t.disabled || !["ArrowRight", "ArrowDown", "ArrowLeft", "ArrowUp"].includes(g.key)) return;
      g.preventDefault();
      const _ = g.key === "ArrowDown" ? 1 : g.key === "ArrowUp" ? -1 : ti(g.key, Xo(g.currentTarget)), w = t.options.length;
      if (!w) return;
      const $ = t.options[(m + _ + w) % w];
      if ($.disabled) return;
      h($.value);
      const E = g.currentTarget.parentElement, A = E == null ? void 0 : E.querySelectorAll("[data-choice]");
      (O = A == null ? void 0 : A[(m + _ + w) % w]) == null || O.focus();
    }
    function y(g, m) {
      return t.multi ? 0 : n.value.length ? o(g) ? 0 : -1 : m === 0 ? 0 : -1;
    }
    return (g, m) => (u(), d("div", {
      class: Re(["fe-choice", { "is-invalid": e.invalid, "is-disabled": e.disabled }]),
      role: e.multi ? "group" : "radiogroup",
      "aria-labelledby": e.ariaLabelledby,
      "aria-label": e.ariaLabel,
      "data-testid": "choice-buttons"
    }, [
      (u(!0), d(he, null, We(e.options, (k, _) => (u(), d("button", {
        key: k.value,
        type: "button",
        "data-choice": "",
        class: Re(["fe-choice__btn", { "is-on": o(k.value) }]),
        role: e.multi ? void 0 : "radio",
        "aria-checked": e.multi ? void 0 : o(k.value) ? "true" : "false",
        "aria-pressed": e.multi ? o(k.value) ? "true" : "false" : void 0,
        tabindex: y(k.value, _),
        disabled: e.disabled || k.disabled,
        "data-testid": e.testidPrefix ? `${e.testidPrefix}-${k.value}` : void 0,
        onClick: (w) => h(k.value),
        onKeydown: (w) => v(w, _)
      }, [
        i("span", UA, f(k.label), 1),
        k.help ? (u(), d("span", HA, f(k.help), 1)) : T("", !0)
      ], 42, FA))), 128))
    ], 10, BA));
  }
}), KA = ["data-tag-kind"], VA = ["title", "aria-label", "data-testid", "onClick"], qA = ["aria-label", "onClick"], jA = ["placeholder", "aria-label"], uw = /* @__PURE__ */ rt({
  __name: "TagPicker",
  props: {
    nodeId: {},
    locale: {},
    apiBase: {},
    authHeaders: { type: Function },
    authCredentials: {},
    palette: {}
  },
  emits: ["change", "error", "open"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n } = gt(() => t.locale ?? "en");
    function o(M) {
      return `${n("tags.open", { tag: M.name })} · ${n(`tags.chip.${M.kind}`, { tag: M.name })}`;
    }
    const p = b([]), h = b(!0), v = b(!1), y = b(!1), g = b(!1), m = b(""), k = b("personal"), _ = b(null), w = x(() => [
      ...p.value.filter((M) => M.kind === "personal"),
      ...p.value.filter((M) => M.kind === "team")
    ]), $ = x(() => [
      { value: "personal", label: n("tags.kind.personal"), help: n("tags.kind.personal_help") },
      {
        value: "team",
        label: n("tags.kind.team"),
        help: h.value ? n("tags.kind.team_help") : n("tags.kind.team_locked"),
        disabled: !h.value
      }
    ]), C = x(() => t.palette ?? [
      "#ef4444",
      "#f59e0b",
      "#10b981",
      "#3b82f6",
      "#8b5cf6",
      "#ec4899",
      "#14b8a6",
      "#f97316"
    ]);
    function E(M) {
      let j = 0;
      for (let de = 0; de < M.length; de++) j = j * 31 + M.charCodeAt(de) | 0;
      const U = C.value;
      return U[Math.abs(j) % U.length];
    }
    function A(M) {
      return M.kind === "personal" || h.value;
    }
    async function O(M = {}) {
      return { ...await (t.authHeaders ?? (() => ({})))(), ...M };
    }
    function z(M) {
      const j = M ?? {};
      v.value = !Array.isArray(j.items), p.value = mv(M), typeof j.can_edit_team == "boolean" && (h.value = j.can_edit_team);
    }
    async function P() {
      y.value = !0;
      try {
        const M = t.apiBase ?? "", j = await fetch(`${M}/api/files/manager/tags?node_id=${t.nodeId}`, {
          headers: await O(),
          credentials: t.authCredentials ?? "same-origin"
        });
        j.ok && z(await j.json());
      } catch (M) {
        s("error", M instanceof Error ? M.message : String(M));
      } finally {
        y.value = !1;
      }
    }
    async function I(M) {
      const j = [...p.value];
      p.value = M;
      try {
        const U = t.apiBase ?? "", de = v.value ? { node_id: t.nodeId, tags: M.map((ce) => ce.name) } : { node_id: t.nodeId, items: M }, ke = await fetch(`${U}/api/files/manager/tags`, {
          method: "POST",
          headers: await O({ "Content-Type": "application/json" }),
          credentials: t.authCredentials ?? "same-origin",
          body: JSON.stringify(de)
        });
        if (!ke.ok) throw tn(ke.status, await ke.text().catch(() => ""), t.locale);
        const ie = await ke.json().catch(() => null);
        !v.value && ie && Array.isArray(ie.items) && (p.value = mv(ie)), IA(), s("change", p.value.map((ce) => ce.name), p.value);
      } catch (U) {
        p.value = j, s("error", U instanceof Error ? U.message : String(U));
      }
    }
    function F() {
      m.value = "", k.value = "personal", g.value = !1;
    }
    function W() {
      const M = m.value.trim(), j = v.value ? "team" : k.value;
      if (!M || p.value.some((U) => U.kind === j && sd(U.name) === sd(M))) {
        F();
        return;
      }
      I([...p.value, { name: M, kind: j }]), F();
    }
    function N(M) {
      var U;
      if (v.value) {
        W();
        return;
      }
      const j = M.relatedTarget;
      j && ((U = _.value) != null && U.contains(j)) || m.value.trim() || F();
    }
    function K(M) {
      I(p.value.filter((j) => j !== M));
    }
    return Kt(P), Qe(() => t.nodeId, P), (M, j) => (u(), d("div", {
      class: Re(["filex-tag-picker", { "is-loading": y.value }])
    }, [
      (u(!0), d(he, null, We(w.value, (U) => (u(), d("span", {
        key: `${U.kind}:${U.name}`,
        class: Re(["filex-tag", `filex-tag--${U.kind}`]),
        "data-tag-kind": U.kind,
        style: Vt({ "--filex-tag-color": E(U.name) })
      }, [
        ot(Xl, {
          kind: U.kind
        }, null, 8, ["kind"]),
        i("button", {
          class: "filex-tag-open",
          type: "button",
          title: o(U),
          "aria-label": o(U),
          "data-testid": `tag-open-${U.name}`,
          onClick: (de) => s("open", U.name, U.kind)
        }, f(U.name), 9, VA),
        A(U) ? (u(), d("button", {
          key: 0,
          class: "filex-tag-x",
          type: "button",
          "aria-label": `${r(n)("tags.remove")}: ${U.name}`,
          onClick: (de) => K(U)
        }, "×", 8, qA)) : T("", !0)
      ], 14, KA))), 128)),
      g.value ? (u(), d("form", {
        key: 0,
        ref_key: "addForm",
        ref: _,
        class: "filex-tag-add",
        onSubmit: ft(W, ["prevent"])
      }, [
        dt(i("input", {
          "onUpdate:modelValue": j[0] || (j[0] = (U) => m.value = U),
          autofocus: "",
          maxlength: "64",
          placeholder: r(n)("tags.name"),
          "aria-label": r(n)("tags.name"),
          onBlur: N,
          onKeydown: ya(F, ["escape"])
        }, null, 40, jA), [
          [St, m.value]
        ]),
        v.value ? T("", !0) : (u(), d("div", {
          key: 0,
          class: "filex-tag-kindwrap",
          onMousedown: j[2] || (j[2] = ft(() => {
          }, ["prevent"]))
        }, [
          ot(Ls, {
            "model-value": k.value,
            options: $.value,
            "aria-label": r(n)("tags.kind.label"),
            "testid-prefix": "tag-kind",
            "onUpdate:modelValue": j[1] || (j[1] = (U) => k.value = U === "team" ? "team" : "personal")
          }, null, 8, ["model-value", "options", "aria-label"])
        ], 32)),
        i("button", {
          class: "filex-tag-add-submit",
          type: "submit",
          onMousedown: j[3] || (j[3] = ft(() => {
          }, ["prevent"]))
        }, f(r(n)("tags.add_submit")), 33)
      ], 544)) : (u(), d("button", {
        key: 1,
        class: "filex-tag-add-btn",
        type: "button",
        onClick: j[4] || (j[4] = (U) => g.value = !0)
      }, f(r(n)("tags.add")), 1))
    ], 2));
  }
}), ob = { tr: mk, en: fr }, WA = /* @__PURE__ */ new Set([
  "application/json",
  "application/xml",
  "application/yaml",
  "application/x-yaml",
  "application/javascript",
  "application/x-sh",
  "application/toml"
]);
function cw(e) {
  const a = String(e ?? "").split(";")[0].trim().toLowerCase();
  return a ? a.startsWith("text/") || WA.has(a) : !1;
}
const dw = {};
function bs(e, a) {
  for (const t of a) dw[t] = e;
}
bs("image", ["jpg", "jpeg", "png", "webp", "gif", "bmp", "avif", "heic", "svg", "ico", "tiff", "tif"]);
bs("video", ["mp4", "webm", "mov", "mkv", "avi", "ogv", "m4v"]);
bs("audio", ["mp3", "wav", "flac", "ogg", "m4a", "aac", "opus"]);
bs("pdf", ["pdf"]);
bs("doc", ["doc", "docx", "odt", "rtf"]);
bs("sheet", ["xls", "xlsx", "ods", "csv", "tsv"]);
bs("slides", ["ppt", "pptx", "odp"]);
bs("archive", ["zip", "tar", "gz", "bz2", "7z", "rar", "xz", "zst"]);
bs("code", [
  "js",
  "ts",
  "jsx",
  "tsx",
  "mjs",
  "cjs",
  "vue",
  "py",
  "go",
  "rs",
  "php",
  "rb",
  "java",
  "kt",
  "swift",
  "c",
  "cpp",
  "h",
  "hpp",
  "cs",
  "css",
  "scss",
  "less",
  "html",
  "htm",
  "json",
  "yml",
  "yaml",
  "xml",
  "sh",
  "bash",
  "ps1",
  "sql",
  "toml"
]);
bs("text", ["txt", "md", "markdown", "log", "ini", "conf", "cfg", "env"]);
function Rd(e) {
  return e.mime_type === "inode/storage";
}
function Ks(e) {
  if (Rd(e)) return "storage";
  if (e.basename === ".trash") return "trash";
  if (e.type === "dir") return "folder";
  const a = (e.extension || "").toLowerCase();
  return a ? dw[a] ?? "unknown" : cw(e.mime_type) ? "text" : "unknown";
}
const fo = '<path d="M6.5 3h7L18.5 8v11.5a1.5 1.5 0 0 1-1.5 1.5H6.5A1.5 1.5 0 0 1 5 19.5v-15A1.5 1.5 0 0 1 6.5 3z"/><path d="M13.5 3v5h5"/>', YA = {
  // Folder is the one "filled" member — a soft currentColor wash keeps it
  // visually anchored without breaking the line style.
  /**
   * gorunum:v1 — the folder is SOLID, and it is the one glyph that never
   * gets a tile. A folder is the most common thing in a listing; drawn as an
   * outline in the same weight as the file glyphs it disappears into them,
   * and the eye has to read the label to tell a folder from a document. Filled
   * and in its own colour it is recognisable before the name is read.
   */
  folder: '<path d="M2.5 6.5A2.5 2.5 0 0 1 5 4h4.6a2.5 2.5 0 0 1 1.77.73L13 6.4h6a2.5 2.5 0 0 1 2.5 2.5v8.6A2.5 2.5 0 0 1 19 20H5a2.5 2.5 0 0 1-2.5-2.5z" fill="currentColor" stroke="none"/>',
  image: '<rect x="3" y="5" width="18" height="14" rx="2"/><circle cx="8.6" cy="10" r="1.6"/><path d="M5.2 16.6l4.3-4.3 3 3 2.4-2.4 3.9 3.7"/>',
  video: '<rect x="3" y="5" width="18" height="14" rx="2"/><path d="M10.2 9.3v5.4l4.8-2.7z" fill="currentColor" stroke="none"/>',
  audio: '<path d="M9 17.5V7.2l9-2.2v10.4"/><circle cx="6.8" cy="17.6" r="2.2"/><circle cx="15.8" cy="15.5" r="2.2"/>',
  pdf: fo + '<rect x="7.5" y="12" width="9" height="5" rx="1" fill="currentColor" fill-opacity="0.14"/>',
  doc: fo + '<path d="M8.5 13h7M8.5 16h7"/>',
  sheet: fo + '<path d="M8 12.5h8M8 15.5h8M8 18h8M12 12.5V18"/>',
  slides: fo + '<rect x="8" y="12.5" width="8" height="5" rx="0.8"/>',
  archive: fo + '<path d="M10 3v1.6M10 6.6v1.6M10 10.2v1.6"/><rect x="8.6" y="14" width="2.8" height="3.4" rx="0.8"/>',
  code: fo + '<path d="M10.4 12.5L8.3 15l2.1 2.5M13.6 12.5l2.1 2.5-2.1 2.5"/>',
  text: fo + '<path d="M8.5 12h7M8.5 15h7M8.5 18h4.5"/>',
  // The two-bay drive the sidebar already draws for the same storages, so a
  // drive is one shape across the panel rather than one per surface.
  storage: '<rect x="3" y="5" width="18" height="6" rx="1.6"/><rect x="3" y="13" width="18" height="6" rx="1.6"/><path d="M6.5 8h.01M6.5 16h.01"/>',
  trash: '<path d="M4 7h16"/><path d="M9.5 7V5.6A1.6 1.6 0 0 1 11.1 4h1.8a1.6 1.6 0 0 1 1.6 1.6V7"/><path d="M6.2 7l.85 11.6A1.6 1.6 0 0 0 8.65 20h6.7a1.6 1.6 0 0 0 1.6-1.4L17.8 7"/><path d="M10.2 10.8v5.6M13.8 10.8v5.6"/>',
  unknown: fo + '<path d="M10.3 13.1a1.8 1.8 0 1 1 2.5 1.9c-.6.3-.8.7-.8 1.4"/><circle cx="12" cy="18.4" r="0.9" fill="currentColor" stroke="none"/>'
}, ib = /* @__PURE__ */ new Map();
function rb(e) {
  let a = ib.get(e);
  return a || (a = `<svg class="fe-ficon fe-ficon--${e}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${YA[e]}</svg>`, ib.set(e, a)), a;
}
const lb = /* @__PURE__ */ new Map();
function Sh(e) {
  if (e === "folder")
    return `<span class="fe-ftile fe-ftile--folder">${rb(e)}</span>`;
  let a = lb.get(e);
  return a || (a = `<span class="fe-ftile fe-ftile--${e}">${rb(e)}</span>`, lb.set(e, a)), a;
}
function sn(e) {
  return GA(e) ? JA() : Sh(Ks(e));
}
function GA(e) {
  return e.type === "dir" ? !1 : (e.extension || "").toLowerCase() === "fxe" ? !0 : typeof e.basename == "string" && e.basename.toLowerCase().endsWith(".fxe") && e.basename.length > 4;
}
const XA = '<path fill="currentColor" stroke="none" fill-rule="evenodd" d="M6.5 3h7L18.5 8v11.5a1.5 1.5 0 0 1-1.5 1.5H6.5A1.5 1.5 0 0 1 5 19.5v-15A1.5 1.5 0 0 1 6.5 3zM9.7 12.2a2.3 2.3 0 0 1 4.6 0h-1.05a1.25 1.25 0 0 0-2.5 0zM9.2 12.2h5.6a1 1 0 0 1 1 1v3.6a1 1 0 0 1-1 1H9.2a1 1 0 0 1-1-1v-3.6a1 1 0 0 1 1-1z"/>';
let wp = "";
function JA() {
  return wp || (wp = `<span class="fe-ftile fe-ftile--unknown fe-ftile--file-locked"><svg class="fe-ficon fe-ficon--file-locked" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${XA}</svg></span>`), wp;
}
function od(e) {
  return e.type === "dir" && e.e2e === !0;
}
const ZA = '<path fill="currentColor" stroke="none" fill-rule="evenodd" d="M2.5 6.5A2.5 2.5 0 0 1 5 4h4.6a2.5 2.5 0 0 1 1.77.73L13 6.4h6a2.5 2.5 0 0 1 2.5 2.5v8.6A2.5 2.5 0 0 1 19 20H5a2.5 2.5 0 0 1-2.5-2.5zM9.7 12a2.3 2.3 0 0 1 4.6 0h-1.05a1.25 1.25 0 0 0-2.5 0zM9.2 12h5.6a1 1 0 0 1 1 1v3.6a1 1 0 0 1-1 1H9.2a1 1 0 0 1-1-1V13a1 1 0 0 1 1-1z"/>';
let xp = "";
function id() {
  return xp || (xp = `<span class="fe-ftile fe-ftile--folder fe-ftile--folder-locked"><svg class="fe-ficon fe-ficon--folder" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${ZA}</svg></span>`), xp;
}
const QA = {
  // Languages the person reading the column thinks of by name.
  ts: "ftype.typescript",
  tsx: "ftype.typescript",
  mts: "ftype.typescript",
  cts: "ftype.typescript",
  js: "ftype.javascript",
  jsx: "ftype.javascript",
  mjs: "ftype.javascript",
  cjs: "ftype.javascript",
  vue: "ftype.vue",
  py: "ftype.python",
  go: "ftype.go",
  rs: "ftype.rust",
  php: "ftype.php",
  rb: "ftype.ruby",
  java: "ftype.java",
  kt: "ftype.kotlin",
  swift: "ftype.swift",
  c: "ftype.c",
  h: "ftype.c",
  cpp: "ftype.cpp",
  hpp: "ftype.cpp",
  cs: "ftype.csharp",
  // Structured text that is code by family but not a language.
  css: "ftype.stylesheet",
  scss: "ftype.stylesheet",
  less: "ftype.stylesheet",
  html: "ftype.html",
  htm: "ftype.html",
  json: "ftype.json",
  yml: "ftype.yaml",
  yaml: "ftype.yaml",
  xml: "ftype.xml",
  toml: "ftype.toml",
  sql: "ftype.sql",
  sh: "ftype.shell",
  bash: "ftype.shell",
  zsh: "ftype.shell",
  ps1: "ftype.powershell",
  // Plain-text family members that are each their own thing.
  md: "ftype.markdown",
  markdown: "ftype.markdown",
  txt: "ftype.plaintext",
  log: "ftype.log",
  ini: "ftype.config",
  conf: "ftype.config",
  cfg: "ftype.config",
  env: "ftype.config",
  // Tabular: a `.csv` IS a spreadsheet to the person looking at the column,
  // whatever the program that wrote it was.
  csv: "ftype.sheet",
  tsv: "ftype.sheet",
  // Design files. No icon family of their own (they fall to `unknown`, which
  // is a decision for the GLYPH, not for the word) — naming them still beats
  // printing "FIG".
  fig: "ftype.figma",
  // ⚠ Named, not "DRAWIO": the uppercased extension was a fourth spelling of
  // draw.io beside "Drawio", "drawio" and "diagrams.net" (QA, 2026-09-21).
  drawio: "ftype.drawio",
  dio: "ftype.drawio",
  sketch: "ftype.design",
  xd: "ftype.design",
  psd: "ftype.design",
  ai: "ftype.design"
}, ez = {
  folder: "node.folder",
  image: "ftype.image",
  video: "ftype.video",
  audio: "ftype.audio",
  pdf: "ftype.pdf",
  doc: "ftype.document",
  sheet: "ftype.sheet",
  slides: "ftype.slides",
  archive: "ftype.archive",
  code: "ftype.code",
  text: "ftype.plaintext"
};
function fw(e) {
  if (e.type === "dir") return "node.folder";
  const a = (e.extension || "").trim().toLowerCase();
  if (a === "fxe") return "e2e.fxe.type";
  const t = QA[a];
  return t || (ez[Ks(e)] ?? null);
}
function rd(e, a) {
  const t = fw(e);
  if (t) return a(t);
  const s = (e.extension || "").trim();
  return s ? s.toUpperCase() : "—";
}
const za = 16, Nd = new Uint8Array(za);
class ub extends Error {
  constructor(a = "aes-siv: authentication failed") {
    super(a), this.name = "SivAuthError";
  }
}
function bo(e) {
  return new Uint8Array(e).buffer;
}
function ld(e) {
  const a = new Uint8Array(za);
  let t = 0;
  for (let s = za - 1; s >= 0; s--) {
    const n = e[s];
    a[s] = (n << 1 | t) & 255, t = n >>> 7;
  }
  return e[0] & 128 && (a[za - 1] ^= 135), a;
}
function bv(e, a, t) {
  for (let s = 0; s < t.length; s++) e[a + s] ^= t[s];
}
function cb(e, a) {
  const t = new Uint8Array(za);
  for (let s = 0; s < za; s++) t[s] = e[s] ^ a[s];
  return t;
}
async function tz(e, a) {
  const t = await crypto.subtle.encrypt({ name: "AES-CBC", iv: bo(Nd) }, e, bo(a));
  return new Uint8Array(t).slice(0, za);
}
async function $p(e, a) {
  const t = Math.max(1, Math.ceil(a.length / za)), s = a.length > 0 && a.length % za === 0, n = new Uint8Array(t * za);
  n.set(a);
  const o = (t - 1) * za;
  return s ? bv(n, o, e.k1) : (n[a.length] = 128, bv(n, o, e.k2)), new Uint8Array(
    await crypto.subtle.encrypt({ name: "AES-CBC", iv: bo(Nd) }, e.mac, bo(n))
  ).slice(o, o + za);
}
async function pw(e, a, t) {
  let s = await $p(e, Nd);
  for (const o of a) s = cb(ld(s), await $p(e, o));
  let n;
  if (t.length >= za)
    n = t.slice(), bv(n, t.length - za, s);
  else {
    const o = new Uint8Array(za);
    o.set(t), o[t.length] = 128, n = cb(ld(s), o);
  }
  return $p(e, n);
}
function az(e) {
  const a = e.slice();
  return a[8] &= 127, a[12] &= 127, a;
}
async function vw(e, a, t) {
  if (t.length === 0) return new Uint8Array(0);
  const s = await crypto.subtle.encrypt(
    { name: "AES-CTR", counter: bo(az(a)), length: 32 },
    e.ctr,
    bo(t)
  );
  return new Uint8Array(s);
}
async function nz(e) {
  if (e.length !== 32 && e.length !== 64)
    throw new Error("aes-siv: key must be 32 or 64 bytes");
  const a = e.length / 2, t = await crypto.subtle.importKey("raw", bo(e.slice(0, a)), { name: "AES-CBC" }, !1, [
    "encrypt"
  ]), s = await crypto.subtle.importKey("raw", bo(e.slice(a)), { name: "AES-CTR" }, !1, [
    "encrypt",
    "decrypt"
  ]), n = await tz(t, Nd), o = ld(n), p = ld(o);
  return { mac: t, ctr: s, k1: o, k2: p };
}
async function hw(e, a, t = []) {
  const s = await pw(e, t, a), n = await vw(e, s, a), o = new Uint8Array(za + n.length);
  return o.set(s, 0), o.set(n, za), o;
}
async function sz(e, a, t = []) {
  if (a.length < za) throw new ub("aes-siv: ciphertext too short");
  const s = a.slice(0, za), n = await vw(e, s, a.slice(za)), o = await pw(e, t, n);
  let p = 0;
  for (let h = 0; h < za; h++) p |= o[h] ^ s[h];
  if (p !== 0)
    throw n.fill(0), new ub();
  return n;
}
const mw = "AES-SIV-512", yw = "b64url", oz = 220, iz = 255, gw = 64, Mr = 16, rz = ".fxl", bw = ".fxl.name", lz = new TextEncoder().encode("filex-e2e-dir-id"), uz = 16, _w = /^[A-Za-z0-9_-]+$/, Th = "[A-Za-z0-9_-]{43}", kw = "[A-Za-z0-9_-]{22}", cz = new RegExp(`^(${Th})\\.fxl\\.name$`), dz = new RegExp(`^(${Th})\\.fxl$`), fz = new RegExp(`^(${Th})\\.fxl\\.(${kw})$`), pz = new RegExp(`^([A-Za-z0-9_-]{23,})\\.(${kw})$`), vz = 23;
function Jl(e) {
  let a = "";
  for (let t = 0; t < e.length; t++) a += String.fromCharCode(e[t]);
  return btoa(a).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
function Dr(e) {
  if (!e || !_w.test(e) || e.length % 4 === 1) return null;
  const a = e.replace(/-/g, "+").replace(/_/g, "/"), t = a + "===".slice((a.length + 3) % 4);
  let s;
  try {
    s = atob(t);
  } catch {
    return null;
  }
  const n = new Uint8Array(s.length);
  for (let o = 0; o < s.length; o++) n[o] = s.charCodeAt(o);
  return Jl(n) !== e ? null : n;
}
function Ch(e) {
  return (e ?? "").normalize("NFC");
}
function vs(e) {
  const a = Ch(e);
  return a ? a === "." || a === ".." ? "dot" : a.includes("/") || a.includes("\\") ? "slash" : /[\u0000-\u001f\u007f]/.test(a) ? "control" : new TextEncoder().encode(a).length > iz ? "too_long" : null : "empty";
}
function hz() {
  return crypto.getRandomValues(new Uint8Array(gw));
}
function ww() {
  return crypto.getRandomValues(new Uint8Array(Mr));
}
const mz = ww;
async function Eh(e, a, t) {
  if (e.length !== gw) throw new Error("e2e: name key must be 64 bytes");
  if (t.length !== Mr) throw new Error("e2e: a folder id is 16 bytes");
  return { siv: await nz(e), long: a, rootId: t.slice() };
}
async function xw(e) {
  const a = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(e));
  return Jl(new Uint8Array(a));
}
async function yz(e, a, t) {
  return (await hw(e.siv, new TextEncoder().encode(Ch(t)), [
    a,
    lz
  ])).slice(0, Mr);
}
function Hr(e) {
  let a = cz.exec(e);
  if (a) return { kind: "sidecar", hash: a[1] };
  if (a = fz.exec(e), a) {
    const t = Dr(a[2]);
    if (t && t.length === Mr) return { kind: "longdir", hash: a[1], dirId: t };
  }
  if (a = dz.exec(e), a) return { kind: "long", hash: a[1] };
  if (a = pz.exec(e), a) {
    const t = Dr(a[2]);
    if (t && t.length === Mr) return { kind: "dir", encoded: a[1], dirId: t };
  }
  return e.length >= vz && _w.test(e) ? { kind: "file", encoded: e } : { kind: "plain" };
}
function gz(e) {
  return Hr(e).dirId ?? null;
}
async function _v(e, a, t) {
  return gz(t) ?? yz(e, a, t);
}
async function kv(e, a, t, s = {}) {
  const n = vs(a);
  if (n) throw new Error(`e2e: invalid name (${n})`);
  const o = new TextEncoder().encode(Ch(a)), p = Jl(await hw(e.siv, o, [t])), v = s.isDir || !!s.dirId ? s.dirId ?? ww() : void 0, y = v ? `.${Jl(v)}` : "";
  if (p.length + y.length <= e.long)
    return { stored: p + y, encoded: p, ...v ? { dirId: v } : {} };
  const g = await xw(p);
  return {
    stored: `${g}${rz}${y}`,
    encoded: p,
    ...v ? { dirId: v } : {},
    sidecar: { name: `${g}${bw}`, content: p }
  };
}
async function $w(e, a, t) {
  const s = Dr(a);
  if (!s || s.length <= uz) return null;
  try {
    const n = await sz(e.siv, s, [t]);
    return new TextDecoder("utf-8", { fatal: !0 }).decode(n);
  } catch {
    return null;
  }
}
async function db(e, a, t) {
  const s = await $w(e, a, t);
  return s === null ? null : vs(s) ? "unsafe" : s;
}
async function Sw(e, a, t, s) {
  const n = Hr(a);
  if (n.kind === "sidecar") return { name: null, state: "sidecar" };
  if (n.kind === "plain") return { name: a, state: "plain" };
  if (n.kind === "long" || n.kind === "longdir") {
    const h = ((s ? await s(`${n.hash}${bw}`) : null) ?? "").trim();
    if (!h || await xw(h) !== n.hash)
      return { name: null, state: "unreadable" };
    const v = await db(e, h, t);
    return v === null || v === "unsafe" ? { name: null, state: "unreadable" } : { name: v, state: "enc" };
  }
  const o = await db(e, n.encoded, t);
  return o === "unsafe" ? { name: null, state: "unreadable" } : o !== null ? { name: o, state: "enc" } : n.kind === "dir" ? { name: null, state: "unreadable" } : { name: a, state: "plain" };
}
function wv(e) {
  const a = e.lastIndexOf(".");
  return a <= 0 || a === e.length - 1 ? "" : e.slice(a + 1).toLowerCase();
}
const Vs = 20, bz = 10, _z = 24, si = 7, ls = 16, gu = 2, kz = 4294967295, Zl = 12, Wn = 97, xv = 9, $v = 21, Tw = 48, Sv = 69, Cw = 76, Ew = 32, ud = new TextEncoder().encode("filexe2e");
function bu(e) {
  return typeof e == "number" && Number.isInteger(e) && e >= bz && e <= _z;
}
function _u(e) {
  if (!bu(e)) throw new Error(`e2e: unsupported chunk size 2^${e}`);
  return 2 ** e;
}
function Aw(e, a, t) {
  if (e.length !== si) throw new Error("e2e: the nonce prefix must be 7 bytes");
  if (!Number.isInteger(a) || a < 0 || a > kz)
    throw new Error("e2e: too many chunks for one stream");
  const s = new Uint8Array(Zl);
  return s.set(e, 0), new DataView(s.buffer).setUint32(si, a, !1), s[Zl - 1] = t ? 1 : 0, s;
}
function zw(e, a = Vs) {
  if (!Number.isSafeInteger(e) || e < 0) throw new Error("e2e: bad plaintext size");
  return e === 0 ? 1 : Math.ceil(e / _u(a));
}
function Ah(e, a = Vs) {
  return e + ls * zw(e, a);
}
function wz(e, a = Vs) {
  if (!bu(a) || !Number.isSafeInteger(e) || e < ls) return null;
  const t = 2 ** a + ls, s = Math.ceil(e / t), n = e - (s - 1) * t;
  return n < ls || s > 1 && n === ls ? null : e - ls * s;
}
function Mw() {
  return crypto.getRandomValues(new Uint8Array(si));
}
class Bd {
  constructor() {
    Aa(this, "parts", []);
    Aa(this, "head", 0);
    Aa(this, "length", 0);
  }
  push(a) {
    a.length !== 0 && (this.parts.push(a), this.length += a.length);
  }
  /** The next `n` bytes (n ≤ length), as a fresh buffer. */
  take(a) {
    if (a > this.length) throw new Error("ByteQueue: not enough bytes");
    const t = new Uint8Array(a);
    let s = 0;
    for (; s < a; ) {
      const n = this.parts[0], o = Math.min(n.length - this.head, a - s);
      t.set(n.subarray(this.head, this.head + o), s), s += o, this.head += o, this.head === n.length && (this.parts.shift(), this.head = 0);
    }
    return this.length -= a, t;
  }
}
function Pr(e) {
  if (e instanceof Uint8Array) return e;
  if (e instanceof ArrayBuffer) return new Uint8Array(e);
  if (ArrayBuffer.isView(e)) return new Uint8Array(e.buffer, e.byteOffset, e.byteLength);
  throw new TypeError("e2e: a stream carried something that is not bytes");
}
class Fd {
  constructor(a) {
    Aa(this, "reader");
    Aa(this, "q", new Bd());
    Aa(this, "done", !1);
    this.reader = a.getReader();
  }
  /** Up to `n` bytes; fewer only when the stream ended. */
  async read(a) {
    for (; this.q.length < a && !this.done; ) {
      const { done: t, value: s } = await this.reader.read();
      t ? this.done = !0 : this.q.push(Pr(s));
    }
    return this.q.take(Math.min(a, this.q.length));
  }
  /** Everything not read yet, as a stream. The reader is spent afterwards. */
  rest() {
    const a = this.q.take(this.q.length), t = this.reader;
    let s = a.length > 0 ? a : null;
    const n = this.done;
    return new ReadableStream({
      async pull(o) {
        if (s) {
          o.enqueue(s), s = null;
          return;
        }
        if (n) {
          o.close();
          return;
        }
        const { done: p, value: h } = await t.read();
        p ? o.close() : o.enqueue(Pr(h));
      },
      cancel(o) {
        return t.cancel(o);
      }
    });
  }
  cancel(a) {
    return this.reader.cancel(a);
  }
}
function ku(e, a) {
  const t = a.getReader();
  let s = !1;
  return new ReadableStream({
    async pull(n) {
      if (!s && (s = !0, e.length > 0)) {
        n.enqueue(e);
        return;
      }
      const { done: o, value: p } = await t.read();
      o ? n.close() : n.enqueue(Pr(p));
    },
    cancel(n) {
      return t.cancel(n);
    }
  });
}
async function xz(e, a = Number.MAX_SAFE_INTEGER) {
  const t = new Bd(), s = e.getReader();
  for (; ; ) {
    const { done: n, value: o } = await s.read();
    if (n) break;
    if (t.push(Pr(o)), t.length > a)
      throw await s.cancel(), new Error("e2e: more data than expected");
  }
  return t.take(t.length);
}
async function fb(e, a, t, s, n) {
  return new Uint8Array(
    await crypto.subtle.encrypt({ name: "AES-GCM", iv: Aw(a, t, s) }, e, n)
  );
}
async function Tv(e, a, t, s, n) {
  try {
    return new Uint8Array(
      await crypto.subtle.decrypt({ name: "AES-GCM", iv: Aw(a, t, s) }, e, n)
    );
  } catch {
    throw new ea(
      s ? "e2e: the last chunk failed authentication (the file is truncated, extended or damaged)" : `e2e: chunk ${t} failed authentication (the file is damaged, reordered or truncated)`
    );
  }
}
function Dw(e, a, t = Vs, s = {}) {
  const n = _u(t);
  if (a.length !== si) throw new Error("e2e: the nonce prefix must be 7 bytes");
  const o = new Bd();
  let p = 0, h = 0;
  return new TransformStream({
    async transform(v, y) {
      var m;
      const g = Pr(v);
      if (h += g.length, s.expectSize !== void 0 && h > s.expectSize)
        throw new Error("e2e: the file is longer than it said it was");
      for (o.push(g); o.length > n; )
        y.enqueue(await fb(e, a, p++, !1, o.take(n))), (m = s.onProgress) == null || m.call(s, p * n);
    },
    async flush(v) {
      var y;
      if (s.expectSize !== void 0 && h !== s.expectSize)
        throw new Error("e2e: the file is shorter than it said it was");
      v.enqueue(await fb(e, a, p++, !0, o.take(o.length))), (y = s.onProgress) == null || y.call(s, h);
    }
  });
}
function Pw(e, a, t = Vs, s = {}) {
  const n = _u(t) + ls;
  if (a.length !== si) throw new Error("e2e: the nonce prefix must be 7 bytes");
  const o = new Bd();
  let p = 0, h = 0;
  const v = (y) => {
    if (h += y.length, s.expectSize !== void 0 && h > s.expectSize)
      throw new ea("e2e: the file holds more than its header says");
    return y;
  };
  return new TransformStream({
    async transform(y, g) {
      for (o.push(Pr(y)); o.length > n; ) g.enqueue(v(await Tv(e, a, p++, !1, o.take(n))));
    },
    async flush(y) {
      if (o.length < ls) throw new ea("e2e: the encrypted content is truncated");
      if (p > 0 && o.length === ls)
        throw new ea("e2e: the encrypted content ends in an empty chunk no writer produces");
      if (y.enqueue(v(await Tv(e, a, p++, !0, o.take(o.length)))), s.expectSize !== void 0 && h !== s.expectSize)
        throw new ea("e2e: the file holds less than its header says");
    }
  });
}
async function $z(e, a, t, s = Vs) {
  const n = _u(s), o = n + ls, p = wz(t.length, s);
  if (p === null) throw new ea("e2e: the encrypted content has an impossible length");
  const h = new Uint8Array(p), v = zw(p, s);
  for (let y = 0; y < v; y++) {
    const g = y === v - 1, m = t.slice(y * o, g ? t.length : (y + 1) * o);
    h.set(await Tv(e, a, y, g, m), y * n);
  }
  return h;
}
function Ow() {
  return crypto.getRandomValues(new Uint8Array(Ew));
}
async function Ud(e) {
  if (e.length !== Ew) throw new ea("e2e: a file key must be 32 bytes");
  return crypto.subtle.importKey("raw", e, { name: "AES-GCM" }, !1, ["encrypt", "decrypt"]);
}
function Sz(e) {
  if (e.wrapIV.length !== Zl || e.wrappedDek.length !== Tw)
    throw new Error("e2e: bad wrapped key");
  _u(e.log2);
  const a = new Uint8Array(Wn);
  return a.set(ud, 0), a[8] = gu, a.set(e.wrapIV, xv), a.set(e.wrappedDek, $v), a.set(e.prefix, Sv), a[Cw] = e.log2, a;
}
function Lw(e) {
  if (e.length < Wn) throw new Error("e2e: not an encrypted file");
  for (let t = 0; t < ud.length; t++)
    if (e[t] !== ud[t]) throw new Error("e2e: not an encrypted file");
  if (e[8] !== gu) throw new Error(`e2e: unsupported version ${e[8]}`);
  const a = e[Cw];
  if (!bu(a)) throw new Error(`e2e: unsupported chunk size 2^${a}`);
  return {
    wrapIV: e.slice(xv, xv + Zl),
    wrappedDek: e.slice($v, $v + Tw),
    prefix: e.slice(Sv, Sv + si),
    log2: a
  };
}
function Tz(e, a = Vs) {
  return Wn + Ah(e, a);
}
async function Iw(e, a, t, s) {
  for (const n of a ? [e, a] : [e]) {
    let o;
    try {
      o = new Uint8Array(await crypto.subtle.decrypt({ name: "AES-GCM", iv: t }, n, s));
    } catch {
      continue;
    }
    try {
      return await Ud(o);
    } finally {
      o.fill(0);
    }
  }
  throw new ea("e2e: DEK unwrap failed (wrong key?)");
}
async function Cz(e, a, t, s = {}) {
  const n = s.chunkLog2 ?? Vs, o = Ow(), p = crypto.getRandomValues(new Uint8Array(Zl));
  let h, v;
  try {
    v = new Uint8Array(await crypto.subtle.encrypt({ name: "AES-GCM", iv: p }, e, o)), h = await Ud(o);
  } finally {
    o.fill(0);
  }
  const y = Mw(), g = Sz({ wrapIV: p, wrappedDek: v, prefix: y, log2: n }), m = t.pipeThrough(
    Dw(h, y, n, { expectSize: a, onProgress: s.onProgress })
  );
  return { stream: ku(g, m), size: Tz(a, n) };
}
async function Ez(e, a, t) {
  const s = Lw(a), n = await Iw(e, t, s.wrapIV, s.wrappedDek);
  return (await $z(n, s.prefix, a.subarray(Wn), s.log2)).buffer;
}
const Az = 200 * 1024 * 1024 + Wn + 16;
function pb(e, a, t, s = {}) {
  const n = new Fd(t);
  let o = null;
  return new ReadableStream({
    async start(p) {
      var k;
      const h = await n.read(Wn);
      if (!(h.length >= 8 && ud.every((_, w) => h[w] === _))) {
        if (!s.passPlain) throw new Error("e2e: not an encrypted file");
        (k = s.onPlain) == null || k.call(s), o = ku(h, n.rest()).getReader();
        return;
      }
      if (h.length < Wn) throw new ea("e2e: the encrypted file is truncated");
      if (h[8] === gu) {
        const _ = Lw(h), w = await Iw(e, a, _.wrapIV, _.wrappedDek);
        o = n.rest().pipeThrough(Pw(w, _.prefix, _.log2)).getReader();
        return;
      }
      if (h[8] !== 1) throw new Error(`e2e: unsupported version ${h[8]}`);
      const y = await xz(n.rest(), Az - Wn), g = new Uint8Array(Wn + y.length);
      g.set(h, 0), g.set(y, Wn);
      let m;
      try {
        m = await dd(e, g.buffer);
      } catch (_) {
        if (!a || !(_ instanceof ea)) throw _;
        m = await dd(a, g.buffer);
      }
      p.enqueue(new Uint8Array(m)), p.close();
    },
    async pull(p) {
      if (!o) return;
      const { done: h, value: v } = await o.read();
      h ? p.close() : p.enqueue(v);
    },
    cancel(p) {
      return o ? o.cancel(p) : n.cancel(p);
    }
  });
}
const zz = Wn, en = ".filex-e2e.json", Mz = "filexe2e", zh = 1, Hd = 2, yi = 3, Dz = ["names", "rekey", "conv"], Mh = 6e5, Dh = 6e5, Rw = 1e8, Lc = 200 * 1024 * 1024, oi = 8, Ic = 20, Nw = "RSA-OAEP-256", gi = "filex-e2e-verify-v1", Rc = new TextEncoder().encode(Mz), Ql = 97, br = 9, _r = 21, Bw = 48, Cv = 69, ds = 12, hs = 32, Pz = "filex-e2e-recovery-v1", Oz = 16;
class ea extends Error {
  constructor(a = "e2e: decrypt failed") {
    super(a), this.name = "E2eDecryptError";
  }
}
function qs(e) {
  let a = "";
  for (let t = 0; t < e.length; t++) a += String.fromCharCode(e[t]);
  return btoa(a);
}
function rn(e) {
  const a = atob(e), t = new Uint8Array(a.length);
  for (let s = 0; s < a.length; s++) t[s] = a.charCodeAt(s);
  return t;
}
function da(e) {
  return new Uint8Array(e).buffer;
}
function Lz(e, a) {
  const t = new Uint8Array(e.length + a.length);
  return t.set(e, 0), t.set(a, e.length), qs(t);
}
async function ms(e, a) {
  const t = crypto.getRandomValues(new Uint8Array(ds)), s = new Uint8Array(
    await crypto.subtle.encrypt({ name: "AES-GCM", iv: da(t) }, e, da(a))
  );
  return Lz(t, s);
}
function vb(e, a) {
  return ms(e, a);
}
function hb(e, a) {
  return bn(e, a);
}
async function bn(e, a) {
  let t;
  try {
    t = rn(a);
  } catch {
    return null;
  }
  if (t.length <= ds) return null;
  try {
    const s = await crypto.subtle.decrypt(
      { name: "AES-GCM", iv: da(t.slice(0, ds)) },
      e,
      da(t.slice(ds))
    );
    return new Uint8Array(s);
  } catch {
    return null;
  }
}
async function bi(e, a, t) {
  const s = await crypto.subtle.importKey(
    "raw",
    new TextEncoder().encode(e),
    "PBKDF2",
    !1,
    ["deriveKey"]
  );
  return crypto.subtle.deriveKey(
    { name: "PBKDF2", salt: da(a), iterations: t, hash: "SHA-256" },
    s,
    { name: "AES-GCM", length: 256 },
    !1,
    // non-extractable
    ["encrypt", "decrypt"]
  );
}
async function Ph(e, a, t) {
  const s = await crypto.subtle.importKey(
    "raw",
    new TextEncoder().encode(e),
    "PBKDF2",
    !1,
    ["deriveBits"]
  ), n = await crypto.subtle.deriveBits(
    { name: "PBKDF2", salt: da(a), iterations: t, hash: "SHA-256" },
    s,
    hs * 8
  );
  return new Uint8Array(n);
}
async function ii(e) {
  return crypto.subtle.importKey("raw", da(e), { name: "AES-GCM" }, !1, [
    "encrypt",
    "decrypt"
  ]);
}
const Ev = "0123456789ABCDEFGHJKMNPQRSTVWXYZ";
function Iz(e) {
  let a = 0, t = 0, s = "";
  for (let n = 0; n < e.length; n++)
    for (t = t << 8 | e[n], a += 8; a >= 5; )
      s += Ev[t >>> a - 5 & 31], a -= 5;
  return a > 0 && (s += Ev[t << 5 - a & 31]), (s.match(/.{1,4}/g) || []).join("-");
}
function Oh() {
  return Iz(crypto.getRandomValues(new Uint8Array(Ic)));
}
function Kr(e) {
  const a = (e || "").toUpperCase().replace(/[\s-]/g, "").replace(/O/g, "0").replace(/[IL]/g, "1"), t = Math.ceil(Ic * 8 / 5);
  if (a.length !== t) return null;
  const s = new Uint8Array(Ic);
  let n = 0, o = 0, p = 0;
  for (const h of a) {
    const v = Ev.indexOf(h);
    if (v < 0) return null;
    n = n << 5 | v, o += 5, o >= 8 && (s[p++] = n >>> o - 8 & 255, o -= 8);
  }
  return p === Ic ? s : null;
}
async function Lh(e, a) {
  const t = await crypto.subtle.importKey("raw", da(e), "HKDF", !1, ["deriveKey"]);
  return crypto.subtle.deriveKey(
    {
      name: "HKDF",
      hash: "SHA-256",
      salt: da(a),
      info: da(new TextEncoder().encode(Pz))
    },
    t,
    { name: "AES-GCM", length: 256 },
    !1,
    ["encrypt", "decrypt"]
  );
}
async function Ih(e, a) {
  const t = Kr(a);
  if (!t) throw new Error("e2e: malformed recovery key");
  const s = crypto.getRandomValues(new Uint8Array(Oz)), n = await Lh(t, s), o = { salt: qs(s), blob: await ms(n, e) };
  return t.fill(0), o;
}
async function Rz(e) {
  return crypto.subtle.importKey(
    "spki",
    da(rn(e)),
    { name: "RSA-OAEP", hash: "SHA-256" },
    !0,
    ["encrypt"]
  );
}
async function Fw(e) {
  const a = (e || "").replace(/-----[A-Z ]+-----/g, "").replace(/\s+/g, "");
  return crypto.subtle.importKey(
    "pkcs8",
    da(rn(a)),
    { name: "RSA-OAEP", hash: "SHA-256" },
    !1,
    ["decrypt"]
  );
}
async function Uw(e) {
  const a = new Uint8Array(await crypto.subtle.digest("SHA-256", da(rn(e))));
  return Array.from(a.slice(0, 8)).map((t) => t.toString(16).padStart(2, "0")).join("");
}
async function Kd(e, a) {
  const t = await Rz(a), s = new Uint8Array(await crypto.subtle.encrypt({ name: "RSA-OAEP" }, t, da(e)));
  return { kid: await Uw(a), alg: Nw, blob: qs(s) };
}
async function the(e, a = Mh) {
  const t = Math.max(Dh, a), s = crypto.getRandomValues(new Uint8Array(16)), n = await bi(e, s, t), o = await ms(n, new TextEncoder().encode(gi));
  return { marker: { v: 1, salt: qs(s), iter: t, verify: o }, kek: n };
}
async function Hw(e, a) {
  const t = hz(), s = mz(), n = {
    alg: mw,
    enc: yw,
    long: oz,
    key: await ms(e, t),
    root_id: Jl(s)
  };
  a && (n.pending = !0);
  const o = await Eh(t, n.long, s);
  return t.fill(0), { slot: n, key: o };
}
async function Av(e, a = {}) {
  const t = Math.max(Dh, a.iterations ?? Mh), s = crypto.getRandomValues(new Uint8Array(16)), n = await bi(e, s, t), o = crypto.getRandomValues(new Uint8Array(hs)), p = Oh(), h = {
    v: Hd,
    salt: qs(s),
    iter: t,
    verify: await ms(n, new TextEncoder().encode(gi)),
    fmk: "wrapped",
    fmk_pw: await ms(n, o),
    rk: await Ih(o, p)
  };
  a.escrowPublicKey && (h.esc = await Kd(o, a.escrowPublicKey));
  const v = await ii(o);
  if (o.fill(0), !a.encryptNames) return { marker: h, fmk: v, recoveryKey: p };
  const y = await Hw(v, !1);
  return h.v = yi, h.req = ["names"], h.names = y.slot, { marker: h, fmk: v, recoveryKey: p, names: y.key };
}
async function Nz(e, a, t = {}) {
  if (e.v !== 1) throw new Error("e2e: not a v1 marker");
  const s = rn(e.salt), n = await bi(a, s, e.iter), o = await bn(n, e.verify);
  if (!o || new TextDecoder().decode(o) !== gi)
    throw new ea("e2e: wrong password");
  const p = await Ph(a, s, e.iter), h = Oh(), v = {
    v: Hd,
    salt: e.salt,
    iter: e.iter,
    verify: e.verify,
    fmk: "kek",
    rk: await Ih(p, h)
  };
  return t.escrowPublicKey && (v.esc = await Kd(p, t.escrowPublicKey)), p.fill(0), { marker: v, fmk: n, recoveryKey: h };
}
async function Bz(e, a, t) {
  if (!ys(e)) throw new Error("e2e: not a v2 marker");
  if (e.esc) throw new Error("e2e: this folder already has an escrow slot");
  if (!t) throw new Error("e2e: no escrow public key");
  const s = rn(e.salt), n = await bi(a, s, e.iter), o = await bn(n, e.verify);
  if (!o || new TextDecoder().decode(o) !== gi)
    throw new ea("e2e: wrong password");
  let p;
  if (e.fmk === "wrapped") {
    const y = e.fmk_pw ? await bn(n, e.fmk_pw) : null;
    if (!y || y.length !== hs)
      throw new ea("e2e: could not unwrap the folder master key");
    p = y;
  } else
    p = await Ph(a, s, e.iter);
  const h = await Kd(p, t);
  p.fill(0);
  const v = { ...e, esc: h };
  return delete v.esc_declined, v;
}
function Fz(e, a) {
  return { ...e, esc_declined: a };
}
function mb(e, a) {
  return !a || !e || !ys(e) || e.esc ? "n/a" : e.esc_declined ? "declined" : "offer";
}
function ys(e) {
  return e.v === 2 || e.v === yi;
}
function cd(e) {
  let a;
  try {
    a = JSON.parse(e);
  } catch {
    return null;
  }
  if (!a || typeof a != "object" || a.v !== 1 && !ys(a) || typeof a.salt != "string" || typeof a.verify != "string" || typeof a.iter != "number" || !Number.isInteger(a.iter) || a.iter < 1 || a.iter > Rw || ys(a) && (a.fmk !== "kek" && a.fmk !== "wrapped" || a.fmk === "wrapped" && typeof a.fmk_pw != "string"))
    return null;
  const t = [];
  if (a.v === yi) {
    if (!Array.isArray(a.req) || a.req.some((s) => typeof s != "string")) return null;
    for (const s of a.req) Dz.includes(s) || t.push(s);
    if (a.req.includes("names") && !Uz(a.names)) return null;
    if (a.req.includes("rekey")) {
      if (a.fmk !== "wrapped" || !a.rekey || typeof a.rekey.from != "string") return null;
    } else if (a.rekey !== void 0)
      return null;
    if (a.req.includes("conv")) {
      if (!a.conv || typeof a.conv != "object" || a.conv.pending !== !0) return null;
    } else if (a.conv !== void 0)
      return null;
  } else if (a.req !== void 0 || a.names !== void 0 || a.rekey !== void 0 || a.conv !== void 0)
    return null;
  return { marker: a, unsupported: t };
}
function Uz(e) {
  var a;
  return !!e && typeof e == "object" && e.alg === mw && e.enc === yw && typeof e.key == "string" && typeof e.long == "number" && Number.isInteger(e.long) && e.long >= 64 && e.long <= 255 && typeof e.root_id == "string" && ((a = Dr(e.root_id)) == null ? void 0 : a.length) === Mr;
}
function ahe(e) {
  const a = cd(e);
  return !a || a.unsupported.length > 0 ? null : a.marker;
}
function fs(e) {
  return !!e && e.v === yi && Array.isArray(e.req) && e.req.includes("names") && !!e.names;
}
async function Hz(e, a) {
  if (!fs(e)) return null;
  const t = await bn(a, e.names.key);
  if (!t || t.length !== 64) return null;
  const s = await Eh(t, e.names.long, Dr(e.names.root_id));
  return t.fill(0), s;
}
async function yb(e, a) {
  if (e.v !== 2) throw new Error("e2e: only a v2 folder can switch to encrypted names");
  const t = await Hw(a, !0);
  return { marker: {
    ...e,
    v: yi,
    req: ["names"],
    names: t.slot
  }, names: t.key };
}
function Kz(e) {
  if (!fs(e)) throw new Error("e2e: this folder has no encrypted names");
  const a = { ...e.names };
  return delete a.pending, { ...e, names: a };
}
const Vz = ["content", "names"], gb = "content";
function qz(e) {
  return e && fs(e) ? e.names.pending ? "pending" : "names" : "content";
}
function jz(e) {
  return !!e && e.v === 2 && !fs(e);
}
function bb(e) {
  return !!e && ys(e) && !!e.rk;
}
function Kw(e) {
  return !!e && ys(e) && !!e.esc;
}
function Vw(e, a) {
  return a ? Kw(e) ? e.esc.kid === a ? "available" : "other-key" : "predates" : "off";
}
async function qw(e, a) {
  const t = await bi(a, rn(e.salt), e.iter), s = await bn(t, e.verify);
  return !s || new TextDecoder().decode(s) !== gi ? null : t;
}
async function jw(e, a) {
  if (e.v === 1 || e.fmk === "kek") return a;
  if (!e.fmk_pw) return null;
  const t = await bn(a, e.fmk_pw);
  if (!t || t.length !== hs) return null;
  const s = await ii(t);
  return t.fill(0), s;
}
async function nhe(e, a) {
  const t = await qw(e, a);
  return t ? jw(e, t) : null;
}
async function Ww(e, a) {
  const t = await qw(e, a);
  if (!t) return { error: "wrong" };
  const s = await jw(e, t);
  return s ? { fmk: s } : { error: "damaged" };
}
async function Yw(e, a) {
  if (!ys(e) || !e.rk) return null;
  const t = Kr(a);
  if (!t) return null;
  let s;
  try {
    s = rn(e.rk.salt);
  } catch {
    return null;
  }
  const n = await Lh(t, s);
  t.fill(0);
  const o = await bn(n, e.rk.blob);
  if (!o || o.length !== hs) return null;
  const p = await ii(o);
  return o.fill(0), p;
}
async function Gw(e, a) {
  if (!ys(e) || !e.esc || e.esc.alg !== Nw) return null;
  let t;
  try {
    t = new Uint8Array(
      await crypto.subtle.decrypt(
        { name: "RSA-OAEP" },
        a,
        da(rn(e.esc.blob))
      )
    );
  } catch {
    return null;
  }
  if (t.length !== hs) return null;
  const s = await ii(t);
  return t.fill(0), s;
}
function Or(e) {
  const a = e instanceof Uint8Array ? e : new Uint8Array(e);
  if (a.length < Rc.length) return !1;
  for (let t = 0; t < Rc.length; t++)
    if (a[t] !== Rc[t]) return !1;
  return !0;
}
async function _b(e, a) {
  if (a.byteLength > Lc)
    throw new Error("e2e: file exceeds the 200MB single-shot limit");
  const t = crypto.getRandomValues(new Uint8Array(32)), s = await crypto.subtle.importKey("raw", da(t), { name: "AES-GCM" }, !1, [
    "encrypt"
  ]), n = crypto.getRandomValues(new Uint8Array(ds)), o = crypto.getRandomValues(new Uint8Array(ds)), p = new Uint8Array(
    await crypto.subtle.encrypt({ name: "AES-GCM", iv: da(n) }, e, da(t))
  ), h = new Uint8Array(
    await crypto.subtle.encrypt({ name: "AES-GCM", iv: da(o) }, s, a)
  );
  t.fill(0);
  const v = new Uint8Array(Ql + h.length);
  return v.set(Rc, 0), v[8] = zh, v.set(n, br), v.set(p, _r), v.set(o, Cv), v.set(h, Ql), v.buffer;
}
async function dd(e, a) {
  const t = new Uint8Array(a);
  if (!Or(t) || t.length < Ql)
    throw new Error("e2e: not an encrypted file");
  if (t[8] === gu) return Ez(e, t);
  if (t[8] !== zh)
    throw new Error(`e2e: unsupported version ${t[8]}`);
  const s = t.slice(br, br + ds), n = t.slice(_r, _r + Bw), o = t.slice(Cv, Cv + ds);
  let p;
  try {
    p = await crypto.subtle.decrypt({ name: "AES-GCM", iv: da(s) }, e, da(n));
  } catch {
    throw new ea("e2e: DEK unwrap failed (wrong key?)");
  }
  const h = await crypto.subtle.importKey("raw", p, { name: "AES-GCM" }, !1, ["decrypt"]);
  try {
    return await crypto.subtle.decrypt(
      { name: "AES-GCM", iv: da(o) },
      h,
      da(t.slice(Ql))
    );
  } catch {
    throw new ea("e2e: content decrypt failed");
  }
}
async function Xw(e, a) {
  if ("recoveryKey" in a) {
    if (!ys(e) || !e.rk) throw new ea("e2e: this folder has no recovery key");
    const p = Kr(a.recoveryKey);
    if (!p) throw new ea("e2e: wrong recovery key");
    let h;
    try {
      h = rn(e.rk.salt);
    } catch {
      throw new ea("e2e: damaged recovery slot");
    }
    const v = await Lh(p, h);
    p.fill(0);
    const y = await bn(v, e.rk.blob);
    if (!y || y.length !== hs) throw new ea("e2e: wrong recovery key");
    return y;
  }
  const t = rn(e.salt), s = await bi(a.password, t, e.iter), n = await bn(s, e.verify);
  if (!n || new TextDecoder().decode(n) !== gi)
    throw new ea("e2e: wrong password");
  if (e.v === 1 || e.fmk === "kek") return Ph(a.password, t, e.iter);
  const o = e.fmk_pw ? await bn(s, e.fmk_pw) : null;
  if (!o || o.length !== hs) throw new ea("e2e: could not unwrap the folder master key");
  return o;
}
async function Jw(e, a, t) {
  if ((e ?? "").length < oi)
    throw new Error(`e2e: the new password must be at least ${oi} characters`);
  const s = Math.max(Dh, t ?? Mh), n = crypto.getRandomValues(new Uint8Array(16)), o = await bi(e, n, s);
  return {
    salt: qs(n),
    iter: s,
    verify: await ms(o, new TextEncoder().encode(gi)),
    fmk: "wrapped",
    fmk_pw: await ms(o, a)
  };
}
function Zw(e) {
  return e.v === 1 || e.fmk === "kek";
}
function kr(e) {
  return !!e && Array.isArray(e.req) && e.req.includes("rekey") && !!e.rekey;
}
async function Qw(e, a, t, s = {}) {
  if (Zw(e))
    throw new Error("e2e: this folder needs its file keys re-wrapped to change its password (startRekey)");
  if (kr(e)) throw new Error("e2e: finish the re-key first");
  const n = await Xw(e, a);
  try {
    return { ...e, ...await Jw(t, n, s.iterations) };
  } finally {
    n.fill(0);
  }
}
class e1 extends Error {
  constructor(a = "e2e: the escrow slot cannot be carried over to the new folder key") {
    super(a), this.name = "E2eRekeyEscrowError";
  }
}
async function Wz(e, a, t, s = {}) {
  if (kr(e)) throw new Error("e2e: a re-key is already in progress; resume it");
  const n = await Xw(e, a), o = crypto.getRandomValues(new Uint8Array(hs));
  try {
    const p = await ii(n), h = await ii(o);
    let v;
    if (ys(e) && e.esc) {
      const $ = s.escrowPublicKey || null;
      if (!$ || await Uw($) !== e.esc.kid) throw new e1();
      v = await Kd(o, $);
    }
    const y = "recoveryKey" in a, g = y ? a.recoveryKey : Oh();
    let m, k;
    if (fs(e)) {
      const $ = await bn(p, e.names.key);
      if (!$ || $.length !== 64) throw new ea("e2e: could not open the name key");
      k = { ...e.names, key: await ms(h, $) }, m = await Eh($, e.names.long, Dr(e.names.root_id)), $.fill(0);
    }
    const _ = Array.from(/* @__PURE__ */ new Set([...e.req ?? [], "rekey"])), w = {
      ...e,
      v: yi,
      req: _,
      ...await Jw(t, o, s.iterations),
      rk: await Ih(o, g),
      rekey: { from: await ms(h, n), pending: !0 }
    };
    return v && (w.esc = v), k && (w.names = k), {
      marker: w,
      fmk: h,
      previous: p,
      recoveryKey: g,
      recoveryKeyIsNew: !y,
      ...m ? { names: m } : {}
    };
  } finally {
    n.fill(0), o.fill(0);
  }
}
async function Yz(e, a) {
  if (!kr(e)) return null;
  const t = await bn(a, e.rekey.from);
  if (!t || t.length !== hs) return null;
  const s = await ii(t);
  return t.fill(0), s;
}
async function t1(e, a, t) {
  const s = new Uint8Array(e);
  if (!Or(s) || s.length < Ql) throw new Error("e2e: not an encrypted file");
  if (s[8] !== zh && s[8] !== gu) throw new Error(`e2e: unsupported version ${s[8]}`);
  const n = s.slice(br, br + ds), o = s.slice(_r, _r + Bw);
  try {
    return await crypto.subtle.decrypt({ name: "AES-GCM", iv: da(n) }, t, da(o)), null;
  } catch {
  }
  let p;
  try {
    p = new Uint8Array(
      await crypto.subtle.decrypt({ name: "AES-GCM", iv: da(n) }, a, da(o))
    );
  } catch {
    throw new ea("e2e: this file opens under neither the new nor the previous folder key");
  }
  const h = crypto.getRandomValues(new Uint8Array(ds)), v = new Uint8Array(
    await crypto.subtle.encrypt({ name: "AES-GCM", iv: da(h) }, t, da(p))
  );
  p.fill(0);
  const y = s.slice();
  return y.set(h, br), y.set(v, _r), y.buffer;
}
function kb(e) {
  var a;
  return !!e && Array.isArray(e.req) && e.req.includes("conv") && ((a = e.conv) == null ? void 0 : a.pending) === !0;
}
function Gz(e, a = (/* @__PURE__ */ new Date()).toISOString(), t) {
  const s = Array.from(/* @__PURE__ */ new Set([...e.req ?? [], "conv"])), n = { pending: !0, started: a, ...t ? { cleanup: t } : {} };
  return { ...e, v: yi, req: s, conv: n };
}
function Xz(e) {
  const a = { ...e };
  delete a.conv;
  const t = (e.req ?? []).filter((s) => s !== "conv");
  return t.length > 0 ? a.req = t : (delete a.req, a.v = Hd), a;
}
function Jz(e) {
  const a = { ...e };
  delete a.rekey;
  const t = (e.req ?? []).filter((s) => s !== "rekey");
  return t.length > 0 ? a.req = t : (delete a.req, a.v = Hd), a;
}
async function Zz(e, a, t) {
  try {
    return await dd(e, t);
  } catch (s) {
    if (!a || !(s instanceof ea)) throw s;
    return dd(a, t);
  }
}
function Qz() {
  const e = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map();
  return {
    get(s) {
      return e.get(s);
    },
    set(s, n, o, p) {
      e.set(s, n), o ? a.set(s, o) : a.delete(s), p ? t.set(s, p) : t.delete(s);
    },
    /** The previous FMK of a folder mid re-key (files not re-wrapped yet). */
    previous(s) {
      return t.get(s);
    },
    /** A re-key finished: the previous FMK is no longer needed. */
    dropPrevious(s) {
      t.delete(s);
    },
    /** The folder's name key; undefined for a content-only folder or a locked one. */
    names(s) {
      return a.get(s);
    },
    setNames(s, n) {
      e.has(s) && a.set(s, n);
    },
    /** Every unlocked root, for resolving a path from any view. */
    roots() {
      return [...e.keys()];
    },
    /** Drop one folder's keys ("Lock"). */
    lock(s) {
      e.delete(s), a.delete(s), t.delete(s);
    },
    has(s) {
      return e.has(s);
    },
    clear() {
      e.clear(), a.clear(), t.clear();
    }
  };
}
function Rh(e) {
  const a = e.indexOf("://");
  return a === -1 ? e : e.slice(a + 3);
}
function eM(e) {
  const a = Rh(String(e ?? "")), t = a.lastIndexOf("/");
  return t === -1 ? "" : a.slice(0, t);
}
function Zo(e) {
  return typeof e.e2e_display_dir == "string" ? e.e2e_display_dir : eM(e.path);
}
function tM(e) {
  return (e || []).filter((a) => !(pu(a.basename) || Ck(a.path) || a.basename === ".trash" || a.basename === en));
}
const a1 = "filex.showHidden";
function aM() {
  try {
    return localStorage.getItem(a1) === "1";
  } catch {
    return !1;
  }
}
const fd = b(aM());
function nM(e) {
  fd.value = e;
  try {
    localStorage.setItem(a1, e ? "1" : "0");
  } catch {
  }
}
function sM(e, a) {
  return a ? e || [] : (e || []).filter((t) => !(t.basename || "").startsWith("."));
}
function Rl(e) {
  return sM(tM(e), fd.value);
}
function oM(e) {
  const a = Rh(e);
  return a === "fileman" || a === "";
}
function iM(e) {
  return Rh(e).startsWith("fileman/.trash");
}
function rM(e) {
  return {
    type: "dir",
    path: `${e}://fileman/.trash`,
    basename: ".trash",
    extension: "",
    storage: e,
    visibility: "private",
    size: 0,
    file_size: 0,
    mime_type: "inode/directory",
    extra_metadata: {}
  };
}
function n1(e, a, t, s, n = {}) {
  return !s || n.navOffersTrash || n.isSearchResult || iM(t) || !oM(t) ? !1 : (e.unshift(rM(a)), !0);
}
async function s1(e, a, t) {
  try {
    const { entries: s } = await t.listTrash(a), n = e.find((h) => h.basename === ".trash");
    if (!n) return;
    let o = 0, p = 0;
    for (const h of s) {
      o += h.size || 0;
      const v = Date.parse(h.deleted_at);
      !Number.isNaN(v) && v > p && (p = v);
    }
    n.size = o, p > 0 && (n.last_modified = p);
  } catch {
  }
}
const o1 = {
  /* gorunum:v3-shell — Home is a destination like the rest, so it gets a
     sentinel like the rest: a restored tab, a reload and a pasted `#.home`
     all have to reopen the overview instead of asking the backend for a
     folder called `.home` and landing on "not found". */
  ".home": "node.home",
  ".trash": "node.trash",
  ".recent": "node.recent",
  ".starred": "node.starred",
  ".shared": "node.shared",
  /* Drafts (issue #71): a view like the rest — a reload on `#.drafts` opens
     it, instead of asking the backend for a folder called `.drafts`. */
  ".drafts": "node.drafts"
}, i1 = ".tag~", r1 = [
  [".mytag~", "personal"],
  [".teamtag~", "team"],
  [i1, ""]
];
function lM(e, a = "") {
  var s;
  return `${((s = r1.find(([, n]) => n === a)) == null ? void 0 : s[0]) ?? i1}${e}`;
}
function Nh(e) {
  for (const [a, t] of r1)
    if (e.startsWith(a)) {
      const s = e.slice(a.length);
      return s ? { tag: s, kind: t } : null;
    }
  return null;
}
function l1(e) {
  var a;
  return ((a = Nh(e)) == null ? void 0 : a.tag) ?? "";
}
function uM(e) {
  var t;
  const a = (e || "").replace(/^\/+|\/+$/g, "");
  return ((t = Nh(a.split("/").pop() || a)) == null ? void 0 : t.kind) ?? "";
}
function cM(e) {
  const a = (e || "").replace(/^\/+|\/+$/g, "");
  return l1(a.split("/").pop() || a);
}
function pd(e, a) {
  const t = o1[e];
  if (t) return a(t);
  const s = Nh(e);
  return s ? s.kind ? `#${s.tag} · ${a(`tags.kind.${s.kind}`)}` : `#${s.tag}` : "";
}
function u1(e) {
  const a = String(e ?? "").replace(/^\/+|\/+$/g, "");
  return a ? !!o1[a] || !!l1(a) : !1;
}
function zv(e, a) {
  const t = e.type === "dir" ? 0 : 1, s = a.type === "dir" ? 0 : 1;
  return t - s;
}
function Vd() {
  return { w: {}, hidden: [] };
}
function qd(e, a) {
  const t = Vd();
  if (!e || typeof e != "object" || Array.isArray(e)) return t;
  const s = (v) => a.find((y) => y.id === v), n = e, o = {};
  if (n.w && typeof n.w == "object")
    for (const [v, y] of Object.entries(n.w)) {
      const g = s(v);
      !g || typeof y != "number" || !Number.isFinite(y) || (o[g.id] = Math.min(g.max, Math.max(g.min, Math.round(y))));
    }
  const p = Array.isArray(n.hidden) ? [...new Set(n.hidden.filter((v) => {
    var y;
    return (y = s(v)) == null ? void 0 : y.hideable;
  }))] : [], h = Array.isArray(n.o) ? [...new Set(n.o.filter((v) => !!s(v)))] : void 0;
  return h && h.length ? { w: o, hidden: p, o: h } : { w: o, hidden: p };
}
function c1(e, a, t) {
  const s = [...e];
  if (a < 0 || a >= s.length) return s;
  const n = Math.max(0, Math.min(s.length - 1, t));
  if (n === a) return s;
  const [o] = s.splice(a, 1);
  return s.splice(n, 0, o), s;
}
function d1(e, a) {
  const t = (o) => {
    var p;
    return ((p = a.find((h) => h.id === o)) == null ? void 0 : p.hideable) === !0;
  };
  let s = 0;
  for (; s < e.length && !t(e[s]); ) s++;
  let n = e.length - 1;
  for (; n >= 0 && !t(e[n]); ) n--;
  return { lo: s, hi: Math.max(s, n) };
}
function f1(e, a, t = {}) {
  var A;
  const s = t.lead ?? ((A = e()[0]) == null ? void 0 : A.id), n = x(() => qd(a.get(), e())), o = (O) => e().find((z) => z.id === O);
  function p(O) {
    a.set(O);
  }
  function h() {
    const O = e().map((I) => I.id), z = n.value.o;
    if (!z || z.length === 0)
      return [s, ...O.filter((I) => I !== s)];
    const P = z.filter((I) => O.includes(I) && I !== s);
    P.unshift(s);
    for (const I of O) P.includes(I) || P.push(I);
    return P;
  }
  function v(O) {
    const z = o(O);
    return z ? n.value.w[O] ?? z.width : 0;
  }
  function y(O, z) {
    const P = o(O);
    if (!P || !P.resizable) return;
    const I = Math.min(P.max, Math.max(P.min, Math.round(z)));
    n.value.w[O] !== I && p({ ...n.value, w: { ...n.value.w, [O]: I } });
  }
  function g() {
    return n.value.w[s] === void 0;
  }
  function m(O) {
    const z = { ...n.value.w };
    let P = !1;
    for (const [I, F] of Object.entries(O)) {
      if (typeof F != "number" || !Number.isFinite(F) || z[I] !== void 0) continue;
      const W = o(I);
      !W || !W.resizable || (z[I] = Math.min(W.max, Math.max(W.min, Math.round(F))), P = !0);
    }
    P && p({ ...n.value, w: z });
  }
  function k(O) {
    return n.value.hidden.includes(O);
  }
  function _(O, z) {
    const P = o(O);
    if (!P || !P.hideable || O === s || k(O) === z) return;
    const I = new Set(n.value.hidden);
    z ? I.add(O) : I.delete(O), p({ ...n.value, hidden: [...I] });
  }
  function w(O, z) {
    const P = o(O);
    if (!P || !P.hideable || O === s) return;
    const I = h(), F = I.indexOf(O);
    if (F === -1) return;
    const W = d1(I, e()), N = Math.max(W.lo, Math.min(W.hi, z)), K = c1(I, F, N);
    K.join() !== I.join() && p({ ...n.value, o: K });
  }
  function $() {
    p(Vd());
  }
  function C() {
    var O;
    return a.customised ? a.customised() : Object.keys(n.value.w).length > 0 || n.value.hidden.length > 0 || (((O = n.value.o) == null ? void 0 : O.length) ?? 0) > 0;
  }
  function E(O, z, P = {}) {
    var ce;
    const I = P.gap ?? 8, F = P.padding ?? 24, W = P.check ?? 0, N = P.menu ?? 28, K = o(s), M = h().filter((X) => X !== s && z.includes(X) && !k(X)), j = {};
    for (const X of M) j[X] = v(X);
    j[s] = v(s);
    const U = (W > 0 ? 1 : 0) + 1 + M.length + 1, de = W + N + F + I * (U - 1), ke = g();
    if (ke && O > 0 && K) {
      const X = P.leadAuto ?? K.width, Z = O - de;
      let Y = M.reduce((R, pe) => R + j[pe], 0);
      const G = Z - X;
      if (Y > G) {
        const R = M.reduce((pe, Q) => {
          var q;
          return pe + (j[Q] - (((q = o(Q)) == null ? void 0 : q.min) ?? j[Q]));
        }, 0);
        if (R > 0) {
          const pe = Math.min(1, (Y - G) / R);
          for (const Q of M) {
            const q = ((ce = o(Q)) == null ? void 0 : ce.min) ?? j[Q];
            j[Q] = Math.max(q, j[Q] - Math.ceil((j[Q] - q) * pe));
          }
          Y = M.reduce((Q, q) => Q + j[q], 0);
        }
      }
      const we = Math.min(X, K.min);
      j[s] = Math.round(Math.max(we, Math.min(K.max, Z - Y)));
    }
    const ie = de + j[s] + M.reduce((X, Z) => X + j[Z], 0);
    return { visible: M, widths: j, total: ie, auto: ke };
  }
  return {
    lead: s,
    specs: e,
    spec: o,
    order: h,
    width: v,
    setWidth: y,
    hidden: k,
    setHidden: _,
    move: w,
    widthsAreAuto: g,
    freeze: m,
    reset: $,
    customised: C,
    state: () => n.value,
    layout: E
  };
}
function dM(e = Vd()) {
  const a = Dn(e);
  return {
    get: () => a.value,
    set: (t) => {
      a.value = t;
    }
  };
}
let gs = null;
const _i = b(!1), wu = b(!1);
function lr() {
  return _i.value;
}
function she() {
  return !0;
}
function ohe(e) {
}
function p1() {
  return Math.floor(Date.now() / 1e3);
}
function Bh(e) {
  return e === "list" || e === "grid" || e === "gallery";
}
function Fh(e) {
  return e === "name" || e === "type" || e === "modified" || e === "size";
}
function Uh(e) {
  return e === "asc" || e === "desc";
}
function ri(e) {
  var a;
  return !!e && (Object.keys(e.w).length > 0 || e.hidden.length > 0 || (((a = e.o) == null ? void 0 : a.length) ?? 0) > 0);
}
const Ma = b({});
function fM(e) {
  if (!e || typeof e != "object" || Array.isArray(e)) return {};
  const a = {};
  for (const [t, s] of Object.entries(e)) {
    if (!s || typeof s != "object") continue;
    const n = s, p = { t: typeof n.t == "number" && Number.isFinite(n.t) ? n.t : 0 };
    if (Bh(n.v) && (p.v = n.v), Fh(n.k) && (p.k = n.k), Uh(n.d) && (p.d = n.d), n.c !== void 0) {
      const h = qd(n.c, xo);
      ri(h) && (p.c = h);
    }
    (p.v || p.k || p.c) && (a[t] = p);
  }
  return a;
}
const wb = 300;
function pM() {
  const e = Object.entries(Ma.value);
  if (e.length <= wb) return;
  e.sort((t, s) => s[1].t - t[1].t);
  const a = {};
  for (const [t, s] of e.slice(0, wb)) a[t] = s;
  Ma.value = a;
}
function xb(e, a) {
  const t = String(e ?? "").trim(), s = String(a ?? "").replace(/^[a-z][a-z0-9+.-]*:\/\//i, "").replace(/\/{2,}/g, "/").replace(/^\/+|\/+$/g, "");
  return t ? s ? `${t}/${s}` : t : s;
}
const vM = ".root", Sp = {
  ".recent": { k: "modified", d: "desc" }
};
function hM(e) {
  if (!e) return null;
  const a = Ma.value[e];
  if (a) {
    const { t, ...s } = a, n = Sp[e];
    return n && !s.k ? { ...n, ...s } : s;
  }
  return Sp[e] ? { ...Sp[e] } : null;
}
function v1(e) {
  return !!e && !!Ma.value[e];
}
function h1() {
  return Object.keys(Ma.value).length;
}
function m1(e, a) {
  if (!e) return;
  const t = Ma.value[e], s = { ...t ?? {}, ...a, t: p1() };
  if (a.c !== void 0 && !ri(a.c) && delete s.c, !s.v && !s.k && !s.c) {
    t && y1(e);
    return;
  }
  Ma.value = { ...Ma.value, [e]: s }, pM(), Us();
}
function mM(e) {
  if (!e) return;
  const a = Ma.value[e];
  if (!a) return;
  const t = p1();
  a.t !== t && (Ma.value = { ...Ma.value, [e]: { ...a, t } }, Us());
}
function y1(e) {
  if (!e || !Ma.value[e]) return;
  const a = { ...Ma.value };
  delete a[e], Ma.value = a, Us();
}
function yM() {
  Ma.value = {}, Us();
}
const hn = b({}), xu = b({});
function Hh(e) {
  if (!e || typeof e != "object" || Array.isArray(e)) return {};
  const a = e, t = {};
  if (Bh(a.v) && (t.v = a.v), Fh(a.k) && (t.k = a.k, Uh(a.d) && (t.d = a.d)), a.c !== void 0) {
    const s = qd(a.c, xo);
    ri(s) && (t.c = s);
  }
  return t;
}
function gM(e) {
  let a = e;
  if (typeof e == "string")
    try {
      a = JSON.parse(e);
    } catch {
      return {};
    }
  if (!a || typeof a != "object" || Array.isArray(a)) return {};
  const t = a, s = {};
  if (Bh(t.v) && (s.v = t.v), Fh(t.k) && (s.k = t.k, Uh(t.d) && (s.d = t.d)), Array.isArray(t.hidden)) {
    const n = t.hidden.filter(
      (o) => typeof o == "string" && xo.some((p) => p.id === o && p.hideable)
    );
    n.length && (s.hidden = [...new Set(n)]);
  }
  return s;
}
function bM() {
  return hn.value;
}
function pr(e) {
  const a = { ...hn.value };
  for (const [t, s] of Object.entries(e))
    s == null ? delete a[t] : a[t] = s;
  hn.value = Hh(a), eu(), Us();
}
function _M(e) {
  hn.value = Hh({ ...hn.value, ...e }), Ma.value = {}, eu(), Us();
}
function kM() {
  return xu.value;
}
function wM(e) {
  xu.value = gM(e), eu();
}
function jd() {
  const e = hn.value, a = xu.value, t = {}, s = e.v ?? a.v;
  return s && (t.v = s), e.k ? (t.k = e.k, e.d && (t.d = e.d)) : a.k && (t.k = a.k, a.d && (t.d = a.d)), t;
}
function xM(e) {
  const a = hM(e), t = jd(), s = {}, n = (a == null ? void 0 : a.v) ?? t.v;
  return n && (s.v = n), a != null && a.k ? (s.k = a.k, a.d && (s.d = a.d)) : t.k && (s.k = t.k, t.d && (s.d = t.d)), s;
}
const xo = [
  { id: "name", width: 260, min: 120, max: 900, hideable: !1, resizable: !0 },
  { id: "type", width: 88, min: 64, max: 220, hideable: !0, resizable: !0 },
  { id: "location", width: 160, min: 80, max: 420, hideable: !0, resizable: !0 },
  { id: "owner", width: 104, min: 72, max: 260, hideable: !0, resizable: !0 },
  { id: "modified", width: 160, min: 96, max: 300, hideable: !0, resizable: !0 },
  /* The Trash only: how long an item has left before it is purged. */
  { id: "remaining", width: 112, min: 80, max: 220, hideable: !0, resizable: !0 },
  { id: "size", width: 88, min: 64, max: 200, hideable: !0, resizable: !0 },
  { id: "star", width: 24, min: 24, max: 24, hideable: !1, resizable: !1 }
], $b = { check: 28, menu: 28 }, ihe = 120, $M = 220, g1 = {
  gap: 8,
  padding: 24,
  check: $b.check,
  menu: $b.menu,
  leadAuto: $M
};
function Sb() {
  if (hn.value.c) return hn.value.c;
  const e = xu.value.hidden;
  return e && e.length ? { w: {}, hidden: [...e] } : Vd();
}
function b1(e) {
  return f1(
    () => xo,
    {
      get: () => {
        var t;
        const a = e();
        return a ? ((t = Ma.value[a]) == null ? void 0 : t.c) ?? Sb() : Sb();
      },
      set: (a) => {
        const t = e();
        if (!t) {
          pr({ c: ri(a) ? a : void 0 });
          return;
        }
        m1(t, { c: a });
      },
      customised: () => {
        var t;
        const a = e();
        return a ? !!((t = Ma.value[a]) != null && t.c) : ri(hn.value.c);
      }
    },
    { lead: "name" }
  );
}
const In = b1(() => "");
function Mv() {
  return In.order();
}
const rhe = c1;
function lhe(e) {
  return d1(e, xo);
}
function uhe(e, a) {
  In.move(e, a);
}
function che(e, a) {
  const t = Mv().filter((p) => {
    var h;
    return (h = xo.find((v) => v.id === p)) == null ? void 0 : h.hideable;
  }), s = t.indexOf(e);
  if (s === -1) return;
  const n = s + a;
  if (n < 0 || n >= t.length) return;
  const o = t[n];
  In.move(e, Mv().indexOf(o));
}
function dhe(e, a) {
  const t = Mv().filter((n) => {
    var o;
    return (o = xo.find((p) => p.id === n)) == null ? void 0 : o.hideable;
  }), s = t.indexOf(e);
  return s === -1 ? !1 : s + a >= 0 && s + a < t.length;
}
function fhe(e) {
  return In.width(e);
}
function phe(e, a) {
  In.setWidth(e, a);
}
function vhe() {
  return In.widthsAreAuto();
}
function hhe(e) {
  In.freeze(e);
}
function mhe(e) {
  return In.hidden(e);
}
function yhe(e, a) {
  In.setHidden(e, a);
}
function ghe() {
  In.reset();
}
function bhe() {
  return In.customised();
}
function _he(e, a, t = {}) {
  return In.layout(e, a, { ...g1, ...t });
}
const wc = {
  sort: "filex.list-sort",
  view: "brf-file-explorer:view-mode"
};
function eu() {
  const e = jd();
  try {
    if (e.k) {
      const a = e.d ?? (e.k === "modified" ? "desc" : "asc");
      localStorage.setItem(wc.sort, JSON.stringify({ key: e.k, dir: a }));
    } else localStorage.removeItem(wc.sort);
    e.v ? localStorage.setItem(wc.view, e.v) : localStorage.removeItem(wc.view);
  } catch {
  }
}
const _1 = ["on", "f", "p", "c", "g", "u"], tu = b(0), Is = b({});
function SM(e) {
  const a = {};
  for (const [t, s] of Object.entries(e))
    _1.includes(t) || (a[t] = s);
  return a;
}
function TM() {
  const e = {
    ...Is.value,
    on: !0,
    f: Ma.value,
    u: tu.value
  };
  return Object.keys(hn.value).length && (e.p = hn.value), e;
}
function CM(e) {
  if (!e || _1.includes(e))
    throw new Error(`viewPrefsSlot: "${e}" is reserved by lib/viewPrefs`);
  return {
    get: () => Is.value[e],
    set(a) {
      Is.value = { ...Is.value, [e]: a }, Us();
    },
    clear() {
      if (!(e in Is.value)) return;
      const a = { ...Is.value };
      delete a[e], Is.value = a, Us();
    },
    ready: () => _i.value,
    persistable: () => wu.value
  };
}
const EM = 800;
let Bs, au = !1;
function Us() {
  !_i.value || !wu.value || !gs || (au = !0, Bs && clearTimeout(Bs), Bs = setTimeout(Lr, EM));
}
function Lr() {
  Bs && clearTimeout(Bs), Bs = void 0, !(!au || !gs || !wu.value) && (au = !1, tu.value = Date.now(), gs.save(TM()));
}
typeof window < "u" && (window.addEventListener("pagehide", Lr), window.addEventListener("visibilitychange", () => {
  typeof document < "u" && document.visibilityState === "hidden" && Lr();
}));
function AM(e) {
  gs || (gs = e, (async () => (await w1(!0), _i.value = !0, MM()))());
}
function khe() {
  Lr(), x1();
}
function whe() {
  return gs !== null;
}
const vd = /* @__PURE__ */ new Set();
function k1(e) {
  return vd.add(e), () => vd.delete(e);
}
function Tb() {
  for (const e of vd)
    try {
      e();
    } catch {
    }
}
async function w1(e) {
  if (!gs) return;
  let a = null;
  try {
    a = await gs.load();
  } catch {
    a = null;
  }
  if (!a || typeof a != "object" || Array.isArray(a)) {
    eu(), Tb();
    return;
  }
  const t = a, s = typeof t.u == "number" && Number.isFinite(t.u) ? t.u : 0;
  if (!e) {
    if (au) {
      Lr();
      return;
    }
    if (s <= tu.value) return;
  }
  Ma.value = fM(t.f);
  let n = !1;
  if (t.p !== void 0)
    hn.value = Hh(t.p);
  else {
    const o = qd(t.c, xo);
    hn.value = ri(o) ? { c: o } : {}, n = ri(o) || t.g !== void 0 || t.c !== void 0;
  }
  tu.value = s, Is.value = SM(t), wu.value = !0, eu(), n && (_i.value = !0, Us()), Tb();
}
const zM = 3e3;
let Dv = 0, Cb = !1;
function Eb(e = !1) {
  if (!gs || !_i.value) return;
  const a = Date.now();
  !e && a - Dv < zM || (Dv = a, w1(!1));
}
function MM() {
  Cb || typeof window > "u" || (Cb = !0, window.addEventListener("focus", () => Eb()), typeof document < "u" && document.addEventListener("visibilitychange", () => {
    document.visibilityState === "visible" && Eb();
  }));
}
function x1() {
  gs = null, _i.value = !1, wu.value = !1, Ma.value = {}, hn.value = {}, xu.value = {}, tu.value = 0, Dv = 0, Is.value = {}, au = !1, Bs && clearTimeout(Bs), Bs = void 0;
}
function xhe() {
  x1(), vd.clear();
}
function $he() {
  Lr();
}
const Kh = ["name", "type", "modified", "size"], DM = "filex.list-sort", jl = "name";
function Ir(e) {
  return e === "modified" ? "desc" : "asc";
}
function PM(e) {
  return typeof e == "string" && Kh.includes(e);
}
function OM() {
  const e = { key: jl, dir: Ir(jl) };
  if (typeof localStorage > "u") return e;
  try {
    const a = localStorage.getItem(DM);
    if (!a) return e;
    const t = JSON.parse(a), s = PM(t.key) ? t.key : jl, n = t.dir === "asc" || t.dir === "desc" ? t.dir : Ir(s);
    return { key: s, dir: n };
  } catch {
    return e;
  }
}
const $1 = b("en");
function Vh(e) {
  $1.value = e;
}
function Ab(e) {
  const a = e.last_modified;
  return a ? a * (a < 1e12 ? 1e3 : 1) : null;
}
function S1(e, a) {
  return (e || "").localeCompare(a || "", void 0, {
    numeric: !0,
    sensitivity: "base"
  });
}
function zb(e, a) {
  return S1(e.basename, a.basename);
}
function Mb(e) {
  const a = fw(e);
  if (a)
    return (ob[$1.value] ?? ob.en)[a] ?? a;
  const t = (e.extension || "").trim();
  return t ? t.toUpperCase() : "";
}
function LM(e, a, t, s) {
  const n = a === "asc" ? 1 : -1;
  switch (e) {
    case "name":
      return n * zb(t, s);
    case "size":
      return n * ((t.size ?? -1) - (s.size ?? -1));
    case "type": {
      const o = Mb(t).localeCompare(Mb(s), void 0, { sensitivity: "base" });
      return o !== 0 ? n * o : zb(t, s);
    }
    default: {
      const o = Ab(t), p = Ab(s);
      return o == null && p == null ? 0 : o == null ? 1 : p == null ? -1 : n * (o - p);
    }
  }
}
const T1 = /* @__PURE__ */ new Set(), Pv = /* @__PURE__ */ new WeakMap();
function C1() {
  const e = qh(), a = b(e.key), t = b(e.dir);
  function s(g, m) {
    a.value = g, t.value = m ?? Ir(g);
  }
  function n(g, m) {
    a.value = g, t.value = m;
  }
  function o() {
    t.value = t.value === "asc" ? "desc" : "asc";
  }
  function p(g) {
    a.value === g ? o() : s(g);
  }
  function h(g, m) {
    return zv(g, m) || LM(a.value, t.value, g, m);
  }
  function v(g) {
    return g === "relevance" ? zv : h;
  }
  const y = {
    key: a,
    dir: t,
    setSort: s,
    applySort: n,
    toggleSortDir: o,
    chooseSortKey: p,
    compareNodes: h,
    compareInOrder: v,
    sortListing: (g, m = "sort") => [...g || []].sort(v(m))
  };
  return T1.add(y), Pv.set(y, { ...e }), y;
}
const Wd = C1(), E1 = Symbol("fe-sort-store");
function $u() {
  return On(E1, Wd);
}
function Db() {
  return Wd.key.value;
}
function Pb() {
  return Wd.dir.value;
}
function Ob(e, a) {
  Wd.applySort(e, a);
}
function qh() {
  const e = jd();
  return e.k ? { key: e.k, dir: e.d ?? Ir(e.k) } : lr() ? { key: jl, dir: Ir(jl) } : OM();
}
k1(() => {
  const e = qh();
  for (const a of T1) {
    const t = Pv.get(a);
    !t || a.key.value !== t.key || a.dir.value !== t.dir || (a.applySort(e.key, e.dir), Pv.set(a, { ...e }));
  }
});
function IM(e) {
  const a = `${(e.apiBase ?? "").replace(/\/+$/, "")}/api/files/manager/view-prefs`, t = e.credentials ?? "same-origin";
  return {
    async load() {
      var o;
      const s = await fetch(a, {
        headers: { ...await ((o = e.headers) == null ? void 0 : o.call(e)) ?? {} },
        credentials: t
      });
      if (!s.ok) return null;
      const n = await s.json();
      return wM((n == null ? void 0 : n.instance_default) ?? null), (n == null ? void 0 : n.prefs) ?? null;
    },
    save(s) {
      (async () => {
        var n;
        try {
          const o = JSON.stringify({ prefs: s });
          await fetch(a, {
            method: "PUT",
            headers: {
              ...await ((n = e.headers) == null ? void 0 : n.call(e)) ?? {},
              "Content-Type": "application/json"
            },
            credentials: t,
            body: o,
            /* ⚠ `keepalive` is what lets the save fired on `pagehide` outlive
             * the page — but browsers reject a keepalive body over 64 KB
             * outright, so the flag goes only on documents that fit. */
            keepalive: o.length < 6e4
          });
        } catch {
        }
      })();
    }
  };
}
function RM(e) {
  AM(IM(e));
}
const A1 = Symbol("fe-table-env");
function NM(e) {
  yr(A1, e);
}
function BM() {
  return On(A1, null);
}
function hd(e, a, t) {
  return e ? {} : a ? { disabled: !0, title: t } : { hidden: !0 };
}
const z1 = [
  "docx",
  "doc",
  "xlsx",
  "xls",
  "pptx",
  "ppt",
  "odt",
  "ods",
  "odp",
  "rtf"
];
function FM(e) {
  return z1.includes(String(e ?? "").toLowerCase());
}
const Tp = {
  links: "share.links",
  uploadLinks: "share.upload_links",
  users: "share.users"
}, M1 = Object.freeze({ links: !0, uploadLinks: !0, users: !0 });
function UM(e) {
  return {
    links: e(Tp.links),
    uploadLinks: e(Tp.uploadLinks),
    users: e(Tp.users)
  };
}
function HM(e, a) {
  return e.links || e.users || a && e.uploadLinks;
}
const KM = ["standard", "simple"], Cp = "standard", Ov = /* @__PURE__ */ new Set();
function VM(e) {
  if (e === "simple") return "simple";
  if (e === "standard" || e === void 0 || e === null || e === "")
    return Cp;
  const a = typeof e == "string" ? e : String(e);
  return !Ov.has(a) && typeof console < "u" && (Ov.add(a), console.warn(
    `[filex] unknown uiProfile ${JSON.stringify(a)} — using "${Cp}". Valid values: ${KM.map((t) => `"${t}"`).join(", ")}. (The former "drive" profile was removed; pass "simple" for the reduced explorer.)`
  )), Cp;
}
function She() {
  Ov.clear();
}
function vr(e, a) {
  return e ? e.endsWith("://") || e.endsWith("/") ? e + a : `${e}/${a}` : a;
}
function zn(e) {
  const a = e.indexOf("://"), t = a === -1 ? "" : e.slice(0, a + 3), s = (a === -1 ? e : e.slice(a + 3)).replace(/\/+$/, ""), n = s.lastIndexOf("/");
  return n === -1 ? t : t + s.slice(0, n);
}
function wr(e) {
  const a = e.indexOf("://"), t = (a === -1 ? e : e.slice(a + 3)).replace(/\/+$/, ""), s = t.lastIndexOf("/");
  return s === -1 ? t : t.slice(s + 1);
}
function ka(e) {
  const a = e.indexOf("://");
  return a === -1 ? e.replace(/^\/+|\/+$/g, "") : e.slice(0, a + 3) + e.slice(a + 3).replace(/^\/+|\/+$/g, "");
}
function Ep(e) {
  const a = e.indexOf("://");
  return a === -1 ? e : e.slice(a + 3);
}
function xc(e, a) {
  const t = ka(e), s = ka(a);
  if (!s) return !1;
  const n = s.endsWith("://") ? s : `${s}/`;
  return t.length > n.length && t.startsWith(n);
}
function Lb(e, a) {
  const t = ka(e), s = ka(a), n = s.endsWith("://") ? s : `${s}/`;
  return t.slice(n.length).split("/").filter(Boolean);
}
function Nc(e) {
  return typeof e.e2e_stored == "string" ? e.e2e_stored : e.basename;
}
function qM(e) {
  const { api: a, ring: t } = e, s = b(0), n = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), p = /* @__PURE__ */ new Map(), h = /* @__PURE__ */ new Set();
  function v() {
    s.value++;
  }
  async function y(ie) {
    try {
      const { blob: ce, url: X } = await a.fetchBlob(vr(ie, en), { fresh: !0 });
      URL.revokeObjectURL(X);
      const Z = cd(await ce.text()), Y = Z ? { marker: Z.marker, unsupported: Z.unsupported } : { marker: null, unsupported: [] };
      return o.set(ie, Y.marker), Y;
    } catch {
      return o.set(ie, null), { marker: null, unsupported: [] };
    }
  }
  async function g(ie) {
    const ce = ka(ie);
    let X = n.get(ce);
    return X || (X = y(ce), n.set(ce, X)), (await X).marker;
  }
  function m(ie) {
    const ce = ka(ie);
    return o.has(ce) ? o.get(ce) : void 0;
  }
  function k(ie, ce) {
    const X = ka(ie);
    o.set(X, ce), n.set(X, Promise.resolve({ marker: ce, unsupported: [] })), v();
  }
  function _(ie) {
    const ce = ka(ie);
    n.delete(ce), o.delete(ce), p.delete(ce);
    for (const X of [...E.keys()]) X.startsWith(`${ce}|`) && E.delete(X);
    v();
  }
  function w(ie) {
    return fs(m(ie) ?? null);
  }
  function $(ie, ce) {
    if (ce && xc(ie, ce)) return ka(ce);
    let X = null;
    const Z = /* @__PURE__ */ new Set([...t.roots(), ...o.keys()]);
    for (const Y of Z)
      xc(ie, Y) && (!X || Y.length > X.length) && (X = ka(Y));
    return X;
  }
  function C(ie) {
    const ce = ka(ie);
    let X = p.get(ce);
    return X || (X = /* @__PURE__ */ new Map(), p.set(ce, X)), X;
  }
  const E = /* @__PURE__ */ new Map();
  function A(ie, ce, X) {
    const Z = ka(X), Y = ka(ce);
    if (Z === Y || !xc(Z, Y)) return Promise.resolve(ie.rootId);
    const G = `${Y}|${Z}`;
    let we = E.get(G);
    return we || (we = A(ie, ce, zn(Z)).then((R) => _v(ie, R, wr(Z))), E.set(G, we)), we;
  }
  const O = /* @__PURE__ */ new Map();
  function z(ie, ce, X, Z) {
    const Y = C(ce), G = `${ka(X)}/${Z}`, we = Y.get(G);
    if (we) return Promise.resolve(we);
    const R = `${ka(ce)}|${G}`, pe = O.get(R);
    if (pe) return pe;
    const Q = A(ie, ce, X).then((q) => Sw(ie, Z, q, async (re) => {
      try {
        const ae = await a.fetchArrayBuffer(vr(X, re));
        return new TextDecoder().decode(ae);
      } catch {
        return null;
      }
    })).then((q) => (q.state !== "unreadable" && Y.set(G, q), q)).finally(() => O.delete(R));
    return O.set(R, Q), Q;
  }
  function P(ie, ce, X, Z) {
    C(ie).set(`${ka(ce)}/${X.stored}`, { name: Z, state: "enc" }), v();
  }
  async function I(ie, ce) {
    const X = t.names(ie), Z = Lb(ce, ie);
    if (!X) return Z.map(() => null);
    const Y = [];
    let G = ka(ie);
    for (const we of Z) {
      const R = await z(X, ie, G, we);
      Y.push(R.name), G = vr(G, we);
    }
    return Y;
  }
  async function F(ie) {
    const ce = $(ie);
    if (!ce) return null;
    const X = t.names(ce);
    return X ? z(X, ce, zn(ie), wr(ie)) : null;
  }
  async function W(ie, ce) {
    const X = Ep(ka(ie)), Y = (await I(ie, zn(ce))).map((G) => G === null ? e.lockedLabel() : G);
    return [X, ...Y].filter(Boolean).join("/");
  }
  async function N(ie, ce = {}) {
    return ce.root && await g(ce.root), (await Promise.all(ie.map((Z) => K(Z, ce.root ?? null)))).filter((Z) => Z !== null);
  }
  async function K(ie, ce) {
    var ae;
    const X = ie.type === "file" ? (ae = e.fileName) == null ? void 0 : ae.call(e, ie.path) : void 0;
    X && (ie = { ...ie, fxe_name: X });
    const Z = typeof ie.e2e_root == "string" && ie.e2e_root || ce, Y = $(ie.path, Z);
    if (!Y) return ie;
    const G = await g(Y);
    if (!fs(G)) return ie;
    const we = Nc(ie);
    if (we === en || Hr(we).kind === "sidecar") return null;
    const pe = t.names(Y), Q = await W(Y, ie.path), q = { ...ie, e2e_stored: we, e2e_root: Y, e2e_display_dir: Q };
    if (!pe)
      return { ...q, basename: e.lockedLabel(), extension: "", e2e_name_state: "locked" };
    const re = await z(pe, Y, zn(ie.path), we);
    return re.state === "enc" && re.name !== null ? {
      ...q,
      basename: re.name,
      extension: ie.type === "dir" ? "" : wv(re.name),
      e2e_name_state: "enc"
    } : re.state === "plain" ? { ...q, basename: we, e2e_name_state: "plain" } : { ...q, basename: e.unreadableLabel(), extension: "", e2e_name_state: "unreadable" };
  }
  function M(ie) {
    s.value;
    const ce = $(ie);
    if (!ce) return null;
    const X = m(ce);
    if (X === void 0)
      return g(ce).then(v), null;
    if (!fs(X)) return null;
    const Z = t.names(ce);
    if (!Z) return e.lockedLabel();
    const Y = wr(ie), G = zn(ie), we = `${ka(G)}/${Y}`, R = C(ce).get(we);
    if (R) return R.name ?? e.unreadableLabel();
    const pe = `${ce}|${we}`;
    return h.has(pe) || (h.add(pe), z(Z, ce, G, Y).finally(() => {
      h.delete(pe), v();
    })), "…";
  }
  function j(ie) {
    s.value;
    const ce = $(ie);
    if (!ce || !w(ce)) return Ep(ka(ie));
    const X = Ep(ka(ce)), Z = Lb(ie, ce), Y = [];
    let G = ka(ce);
    for (const we of Z)
      G = vr(G, we), Y.push(M(G) ?? we);
    return [X, ...Y].filter(Boolean).join("/");
  }
  function U(ie) {
    const ce = ka(ie);
    for (const X of /* @__PURE__ */ new Set([...t.roots(), ...o.keys()])) {
      const Z = ka(X);
      if ((ce === Z || xc(ce, Z)) && w(Z)) return Z;
    }
    return null;
  }
  async function de(ie, ce, X = {}) {
    const Z = U(ie);
    if (!Z) return null;
    const Y = t.names(Z);
    if (!Y) throw new Error("e2e: the folder is locked");
    const G = await A(Y, Z, ie), we = X.keepIdOf ? await A(Y, Z, X.keepIdOf) : void 0, R = await kv(Y, ce, G, { isDir: X.isDir, dirId: we });
    return P(Z, ie, R, ce.normalize("NFC")), R;
  }
  async function ke(ie) {
    const ce = $(ie) ?? U(ie);
    if (!ce) return null;
    const X = t.names(ce);
    return X ? A(X, ce, ie) : null;
  }
  return {
    version: s,
    markerFor: g,
    markerCached: m,
    setMarker: k,
    forget: _,
    namesOn: w,
    rootOf: $,
    decorate: N,
    decodePath: I,
    plainNameOf: F,
    segmentLabel: M,
    displayPath: j,
    writesEncrypted: U,
    nameForWrite: de,
    dirIdFor: ke,
    remember: P,
    bump: v
  };
}
const Su = Symbol("filex.e2eNameView"), jM = { class: "filex-recent" }, WM = ["title", "aria-label", "disabled"], YM = ["innerHTML"], GM = { key: 0 }, XM = ["data-fe-path"], JM = ["onClick", "onContextmenu"], ZM = { class: "filex-recent-name" }, QM = { class: "filex-recent-meta" }, e3 = {
  key: 1,
  class: "filex-recent-empty"
}, t3 = {
  key: 2,
  class: "filex-recent-empty"
}, a3 = /* @__PURE__ */ rt({
  __name: "RecentlyOpened",
  props: {
    apiBase: {},
    authHeaders: { type: Function },
    authCredentials: {},
    limit: {},
    refreshKey: {},
    locale: {}
  },
  emits: ["open", "context", "error"],
  setup(e, { emit: a }) {
    const t = e, { t: s } = gt(() => t.locale ?? "en"), n = a, o = b([]), p = b(!1), h = On(Su, null), v = b({});
    async function y(k) {
      if (!h) return;
      const _ = k.map((E) => ({
        id: E.id,
        type: E.type === "dir" ? "dir" : "file",
        path: typeof E.storage == "string" && E.storage ? `${E.storage}://${String(E.path).replace(/^\/+/, "")}` : String(E.path),
        basename: E.name,
        ...typeof E.e2e_root == "string" && E.e2e_root ? { e2e_root: E.e2e_root } : {}
      })), w = await h.decorate(_), $ = new Set(w.map((E) => E.id)), C = {};
      for (const E of w) typeof E.id == "number" && E.e2e_stored && (C[E.id] = E.basename);
      v.value = C, $.size !== k.length && (o.value = k.filter((E) => $.has(E.id)));
    }
    h && Qe(h.version, () => void y(o.value));
    async function g() {
      p.value = !0;
      try {
        const k = await (t.authHeaders ?? (() => ({})))(), _ = t.apiBase ?? "", w = t.limit ?? 20, $ = await fetch(`${_}/api/files/manager/recent?limit=${w}`, {
          headers: k,
          credentials: t.authCredentials ?? "same-origin"
        });
        if ($.ok) {
          const C = await $.json();
          o.value = Array.isArray(C.nodes) ? C.nodes : Array.isArray(C.entries) ? C.entries : Array.isArray(C) ? C : [], await y(o.value);
        }
      } catch (k) {
        n("error", k instanceof Error ? k.message : String(k));
      } finally {
        p.value = !1;
      }
    }
    function m(k) {
      if (!k) return "";
      const _ = new Date(k).getTime();
      if (Number.isNaN(_)) return "";
      const w = Date.now() - _;
      try {
        const $ = new Intl.RelativeTimeFormat(kn(t.locale), { numeric: "auto", style: "short" });
        return w < 6e4 ? $.format(0, "second") : w < 36e5 ? $.format(-Math.floor(w / 6e4), "minute") : w < 864e5 ? $.format(-Math.floor(w / 36e5), "hour") : $.format(-Math.floor(w / 864e5), "day");
      } catch {
        return new Date(_).toISOString().slice(0, 16).replace("T", " ");
      }
    }
    return Kt(g), Qe(() => t.refreshKey, g), (k, _) => (u(), d("div", jM, [
      i("header", null, [
        i("h3", null, f(r(s)("recents.title")), 1),
        i("button", {
          class: "filex-recent-refresh",
          type: "button",
          title: r(s)("recents.refresh"),
          "aria-label": r(s)("recents.refresh"),
          onClick: g,
          disabled: p.value
        }, [
          i("span", {
            "aria-hidden": "true",
            innerHTML: r(wt)("refresh")
          }, null, 8, YM)
        ], 8, WM)
      ]),
      o.value.length ? (u(), d("ul", GM, [
        (u(!0), d(he, null, We(o.value, (w) => (u(), d("li", {
          key: w.id,
          "data-testid": "recent-tray-item",
          "data-fe-path": w.path
        }, [
          i("button", {
            type: "button",
            class: "filex-recent-item",
            onClick: ($) => n("open", w),
            onContextmenu: ft(($) => n("context", w, $), ["prevent"])
          }, [
            i("span", ZM, [
              i("bdi", null, f(v.value[w.id] ?? w.name), 1)
            ]),
            i("span", QM, f(m(w.last_opened)), 1)
          ], 40, JM)
        ], 8, XM))), 128))
      ])) : p.value ? (u(), d("p", t3, f(r(s)("recents.loading")), 1)) : (u(), d("p", e3, f(r(s)("recents.empty")), 1))
    ]));
  }
}), ho = {
  type: "any",
  modified: "any",
  size: "any",
  name: "",
  aroundDate: "",
  aroundSpan: "d1",
  sizeMin: null,
  sizeMax: null,
  pathMode: "any",
  pathBase: "",
  people: "any"
};
function Ib(e) {
  return e.normalize("NFD").replace(new RegExp("\\p{M}+", "gu"), "").toLowerCase().replace(/ı/g, "i");
}
function jh(e) {
  return (e.name ?? "").trim();
}
function D1(e) {
  return (e.pathMode ?? "any") !== "any" && !!(e.pathBase ?? "");
}
function Wh(e) {
  return e.people ?? "any";
}
function Wl(e) {
  return e.type !== "any" || e.modified !== "any" || e.size !== "any" || jh(e) !== "" || D1(e) || Wh(e) !== "any";
}
function n3(e) {
  return (e.type !== "any" ? 1 : 0) + (e.modified !== "any" ? 1 : 0) + (e.size !== "any" ? 1 : 0) + (jh(e) !== "" ? 1 : 0) + (D1(e) ? 1 : 0) + (Wh(e) !== "any" ? 1 : 0);
}
const s3 = {
  folder: ["folder"],
  document: ["doc", "text"],
  spreadsheet: ["sheet"],
  presentation: ["slides"],
  pdf: ["pdf"],
  image: ["image"],
  video: ["video"],
  audio: ["audio"],
  archive: ["archive"],
  code: ["code"]
}, o3 = {
  image: ["image/"],
  video: ["video/"],
  audio: ["audio/"],
  pdf: ["application/pdf"],
  document: ["text/plain", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessing"],
  spreadsheet: ["text/csv", "application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheet"],
  presentation: ["application/vnd.ms-powerpoint", "application/vnd.openxmlformats-officedocument.presentation"],
  archive: ["application/zip", "application/x-tar", "application/gzip", "application/x-7z"]
};
function i3(e, a) {
  if (a === "any") return !0;
  if (a === "folder") return e.type === "dir";
  if (e.type === "dir") return !1;
  if (s3[a].includes(Ks(e))) return !0;
  const t = (e.mime_type || "").toLowerCase();
  return !!t && (o3[a] ?? []).some((s) => t.startsWith(s));
}
const r3 = {
  h1: 36e5,
  d1: 864e5,
  w1: 7 * 864e5
};
function l3(e) {
  const a = (e ?? "").trim();
  if (!a) return null;
  const t = Date.parse(a.includes("T") ? a : `${a}T00:00`);
  return Number.isNaN(t) ? null : t;
}
function u3(e, a, t) {
  const s = a.modified;
  if (s === "any") return !0;
  const n = typeof e.last_modified == "number" ? e.last_modified : 0;
  if (!n) return !1;
  if (s === "around") {
    const p = l3(a.aroundDate);
    return p === null ? !0 : Math.abs(n - p) <= r3[a.aroundSpan ?? "d1"];
  }
  if (s === "year")
    return new Date(n).getFullYear() === new Date(t).getFullYear();
  if (s === "today") {
    const p = new Date(t);
    return p.setHours(0, 0, 0, 0), n >= p.getTime();
  }
  return n >= t - (s === "7d" ? 7 : 30) * 864e5;
}
const nr = 1024 * 1024;
function c3(e, a) {
  const t = a.size;
  if (t === "any") return !0;
  if (e.type === "dir") return !1;
  const s = typeof e.size == "number" ? e.size : 0;
  if (t === "range") {
    const n = typeof a.sizeMin == "number" ? a.sizeMin : null, o = typeof a.sizeMax == "number" ? a.sizeMax : null;
    return !(n !== null && s < n || o !== null && s > o);
  }
  return t === "lt1" ? s < nr : t === "1to10" ? s >= nr && s < 10 * nr : t === "10to100" ? s >= 10 * nr && s < 100 * nr : s >= 100 * nr;
}
function xr(e, a) {
  return a ? Ib(e || "").includes(Ib(a)) : !0;
}
function d3(e, a) {
  return xr(e.basename || "", a);
}
function f3(e, a) {
  const t = a.pathMode ?? "any", s = (a.pathBase ?? "").replace(/\/+$/, "");
  if (t === "any" || !s) return !0;
  const n = e.path || "", o = n === s || n.startsWith(`${s}/`);
  return t === "here" ? o : !o;
}
function nu(e) {
  const a = e.owner_id;
  return typeof a == "number" && a > 0 ? a : null;
}
function Yd(e) {
  return e.owner_self === !0;
}
function Yh(e) {
  const a = e.owner_name;
  return typeof a == "string" ? a : "";
}
function Rb(e) {
  const a = e.deleted_by_id;
  return typeof a == "number" && a > 0 ? a : null;
}
function Nb(e) {
  return e.deleted_by_self === !0;
}
function p3(e) {
  const a = e.deleted_by_name;
  return typeof a == "string" ? a : "";
}
function v3(e) {
  return e.external_upload === !0;
}
function h3(e) {
  const a = [{ value: "any" }, { value: "me" }, { value: "system" }], t = /* @__PURE__ */ new Set();
  for (const o of e) {
    const p = nu(o);
    p === null || Yd(o) || t.has(p) || (t.add(p), a.push({ value: `u:${p}`, name: Yh(o) }));
  }
  const s = a.slice(0, 3), n = a.slice(3).sort((o, p) => (o.name ?? "").localeCompare(p.name ?? "", void 0, { sensitivity: "base" }));
  return [...s, ...n];
}
function m3(e, a) {
  const t = Wh(a);
  if (t === "any") return !0;
  if (t === "me") return Yd(e);
  if (t === "system") return nu(e) === null;
  const s = Number(t.slice(2));
  return Number.isFinite(s) && nu(e) === s;
}
function Lv(e, a, t = Date.now()) {
  if (!Wl(a)) return e;
  const s = jh(a);
  return e.filter(
    (n) => i3(n, a.type) && u3(n, a, t) && c3(n, a) && d3(n, s) && f3(n, a) && m3(n, a)
  );
}
const y3 = /* @__PURE__ */ rt({
  __name: "UploadProgress",
  props: {
    jobs: {},
    locale: {},
    center: {}
  },
  emits: ["cancel", "dismiss", "retry"],
  setup(e, { emit: a }) {
    const t = e, { t: s } = gt(() => t.locale);
    function n(h) {
      return h === "committing" || h === "transferring";
    }
    const o = a;
    function p(h) {
      return h === "done" ? "done" : h === "error" ? "error" : h === "aborted" ? "aborted" : "running";
    }
    return Qe(
      () => t.jobs,
      (h) => {
        t.center.sync(
          "upload",
          h.map((v) => ({
            input: {
              id: v.id,
              kind: "upload",
              name: v.displayName ?? v.file.name,
              percent: n(v.status) ? null : v.totalBytes > 0 || v.status === "done" ? v.percent : null,
              message: n(v.status) ? s("upload.saving") : null,
              status: p(v.status),
              error: v.error ?? null,
              uploadedBytes: v.uploadedBytes,
              totalBytes: v.totalBytes,
              // Cancellable only while chunks are still moving: once the commit is
              // accepted the bytes are filex's and the ops worker owns the rest.
              cancellable: v.status === "uploading" || v.status === "initializing",
              retryable: v.status === "error"
            },
            actions: {
              cancel: () => o("cancel", v),
              dismiss: () => o("dismiss", v),
              retry: () => o("retry", v)
            }
          }))
        );
      },
      { immediate: !0 }
    ), (h, v) => T("", !0);
  }
});
function Ap(e) {
  return Math.max(0, Math.min(100, Math.round(e)));
}
function P1(e) {
  if (e.progress_total > 1) return null;
  const a = e.objects_total ?? 0;
  return a > 0 ? { done: e.objects_done ?? 0, total: a } : null;
}
function g3(e) {
  if (e.status === "done") return 100;
  const a = e.bytes_total ?? 0, t = e.bytes_done ?? 0;
  if (a > 0) return Ap(t / a * 100);
  if (t > 0) return null;
  if (e.progress_total <= 1) {
    const s = P1(e);
    return s ? Ap(s.done / s.total * 100) : null;
  }
  return Ap(e.progress_done / e.progress_total * 100);
}
const b3 = /* @__PURE__ */ rt({
  __name: "PendingOpsTray",
  props: {
    ops: {},
    locale: {},
    center: {},
    outputModeOf: { type: Function },
    callerAdmin: { type: Boolean }
  },
  emits: ["dismiss", "cancel", "open"],
  setup(e, { emit: a }) {
    const t = e, { t: s } = gt(() => t.locale);
    function n(w) {
      return Ac(w, s, { callerAdmin: t.callerAdmin === !0 });
    }
    const o = a;
    function p(w) {
      return w.status === "done" ? "done" : w.status === "cancelled" ? "aborted" : w.status === "error" ? "error" : "running";
    }
    const h = /* @__PURE__ */ new Set([
      "copy",
      "move",
      "delete",
      "rename",
      "restore",
      "purge",
      "plugin",
      "archive-create",
      "archive-extract"
    ]);
    function v(w) {
      return w.op_type === "trash-empty" ? "trash" : h.has(w.op_type) ? w.op_type : "plugin";
    }
    function y(w) {
      return w.op_type === "plugin";
    }
    function g(w) {
      return w.status !== "pending" && w.status !== "running" ? !1 : w.op_type === "archive-create" || w.op_type === "archive-extract" ? w.cancellable : y(w) ? !0 : w.op_type === "trash-empty" && t.callerAdmin === !0;
    }
    const m = (w) => g3(w);
    function k(w) {
      if (w.op_type === "trash-empty") return "";
      const $ = w.label || w.target_path || w.source_dir || "";
      return $ || (w.op_type === "restore" || w.op_type === "purge" ? s("opc.trash_items", { n: w.progress_total || w.source_count }) : "");
    }
    function _(w) {
      const $ = P1(w);
      return $ ? { itemsDone: $.done, itemsTotal: $.total } : {};
    }
    return Qe(
      () => t.ops,
      (w) => {
        t.center.sync(
          "ops",
          w.map(($) => {
            var C;
            return {
              input: {
                id: $.id,
                kind: v($),
                name: k($),
                percent: m($),
                status: p($),
                error: $.status === "error" ? n($).text : null,
                errorDetail: $.status === "error" ? n($).detail ?? null : null,
                queued: $.status === "pending",
                cancelling: $.status === "cancelling",
                doneCount: $.progress_done,
                totalCount: $.progress_total,
                ..._($),
                cancellable: g($),
                retryable: !1,
                message: $.message ?? null,
                outputs: ($.outputs ?? []).map((E) => E.path),
                outputMode: (y($) ? (C = t.outputModeOf) == null ? void 0 : C.call(t, $) : void 0) ?? null
              },
              actions: {
                cancel: () => o("cancel", $.id),
                dismiss: () => o("dismiss", $.id),
                open: (E) => o("open", $.id, E)
              }
            };
          })
        );
      },
      { immediate: !0 }
    ), (w, $) => T("", !0);
  }
});
function Tu(e) {
  if (!e || e.locked !== !0) return null;
  const a = e.lock;
  return !a || typeof a != "object" || typeof a.plugin != "string" || !a.plugin ? null : a;
}
function The(e) {
  return e.some((a) => Tu(a) !== null);
}
function Iv(e) {
  const a = e;
  if (!a || a.status !== 423) return null;
  const t = { plugin: "" };
  try {
    const s = JSON.parse(String(a.detail ?? ""));
    typeof s.plugin == "string" && (t.plugin = s.plugin), s.plugin_label && typeof s.plugin_label == "object" && (t.plugin_label = s.plugin_label), typeof s.path == "string" && (t.path = s.path), typeof s.reason == "string" && s.reason && (t.reason = s.reason), s.reason_text && typeof s.reason_text == "object" && (t.reason_text = s.reason_text), typeof s.until == "string" && s.until && (t.until = s.until);
  } catch {
  }
  return t;
}
function _3(e, a) {
  return e && (jt(e.reason_text, a || "en") || e.reason) || "";
}
function li(e, a) {
  if (!e) return "";
  const t = jt(e.plugin_label, a.locale || "en") || e.plugin || a.t("applock.some_app"), s = _3(e, a.locale), n = s ? a.t("applock.held_reason", { app: t, reason: s }) : a.t("applock.held", { app: t }), o = k3(e.until, a);
  return o ? `${n} ${o}` : n;
}
function k3(e, a) {
  if (!e) return "";
  const t = Date.parse(e);
  if (!Number.isFinite(t)) return "";
  const s = a.formatDate ? a.formatDate(t, { time: !0 }) : new Date(t).toISOString();
  return a.t("applock.until", { date: s });
}
const w3 = ["outside_root", "broken", "unresolved"];
function O1(e) {
  if (!e || e.symlink !== !0) return null;
  const a = e.link_state;
  return typeof a == "string" && w3.includes(a) ? a : "unknown";
}
function x3(e, a) {
  switch (e) {
    case "outside_root":
      return { state: e, badge: a.t("symlink.badge.outside_root"), why: a.t("symlink.why.outside_root") };
    case "broken":
      return { state: e, badge: a.t("symlink.badge.broken"), why: a.t("symlink.why.broken") };
    case "unresolved":
      return { state: e, badge: a.t("symlink.badge.unresolved"), why: a.t("symlink.why.unresolved") };
    case "unknown":
      return { state: e, badge: a.t("symlink.badge.unknown"), why: a.t("symlink.why.unknown") };
    default:
      return null;
  }
}
function Cu(e, a) {
  return x3(O1(e), a);
}
function Che(e) {
  return O1(e) !== null;
}
function ui(e) {
  if (!e) return "";
  for (const a of [e.name, e.display_name, e.username, e.email]) {
    const t = typeof a == "string" ? a.trim() : "";
    if (t) return t;
  }
  return "";
}
function md(e, a) {
  const t = ui(e);
  return t ? [...t][0].toLocaleUpperCase(a) : "";
}
const $3 = "apps";
function S3(e) {
  const a = `${$3}/${encodeURIComponent(e.plugin)}/${encodeURIComponent(e.view)}`;
  return e.path ? `${a}?path=${encodeURIComponent(e.path)}` : a;
}
function L1(e, a) {
  return `${String(e ?? "").replace(/\/+$/, "")}/${S3(a)}`;
}
function Rv(e) {
  return e === "page";
}
function I1(e) {
  if (!e || typeof e != "object") return !1;
  const a = e;
  return typeof a.path == "string" && a.path.trim() !== "";
}
function T3(e) {
  const a = String(e ?? "").indexOf("://");
  if (a <= 0) return "";
  const t = e.slice(0, a), s = e.slice(a + 3).replace(/^\/+/, ""), n = s.lastIndexOf("/"), o = n > 0 ? s.slice(0, n) : "";
  return o ? `${t}/${o}` : t;
}
function C3(e, a) {
  var o;
  if (!I1(e) || !a.plugin) return { href: "", newTab: !1 };
  const t = String(a.base ?? "").replace(/\/+$/, "");
  if (e.view && Rv((o = a.placementOf) == null ? void 0 : o.call(a, e.view)))
    return { href: L1(t, { plugin: a.plugin, view: e.view, path: e.path }), newTab: !0 };
  const s = [`select=${encodeURIComponent(e.path)}`, `app=${encodeURIComponent(a.plugin)}`];
  e.action ? s.push(`appAction=${encodeURIComponent(e.action)}`) : e.view && s.push(`appView=${encodeURIComponent(e.view)}`);
  const n = T3(e.path);
  return { href: `${t}/explore?${s.join("&")}${n ? `#${n}` : ""}`, newTab: !1 };
}
function Gh(e) {
  const a = Number(e);
  return Number.isFinite(a) ? (Math.round(a / 90) * 90 % 360 + 360) % 360 : 0;
}
const Bb = { w: 0.02, h: 0.01 }, yd = (e) => Math.min(1, Math.max(0, e));
function $r(e) {
  const a = Math.min(1, Math.max(Bb.w, Number(e.w) || 0)), t = Math.min(1, Math.max(Bb.h, Number(e.h) || 0)), s = Math.min(1 - a, yd(Number(e.x) || 0)), n = Math.min(1 - t, yd(Number(e.y) || 0));
  return { x: s, y: n, w: a, h: t };
}
function $c(e, a) {
  return $r({
    x: Math.min(e.x, a.x),
    y: Math.min(e.y, a.y),
    w: Math.abs(e.x - a.x),
    h: Math.abs(e.y - a.y)
  });
}
function Ehe(e, a) {
  return {
    left: e.x * a.width,
    top: e.y * a.height,
    width: e.w * a.width,
    height: e.h * a.height
  };
}
function Ahe(e, a) {
  const t = a.width || 1, s = a.height || 1;
  return { x: e.left / t, y: e.top / s, w: e.width / t, h: e.height / s };
}
function Fb(e, a) {
  return { x: yd(e.x / (a.width || 1)), y: yd(e.y / (a.height || 1)) };
}
function R1(e) {
  const a = Gh(e.rotation);
  return a === 90 || a === 270 ? { width: e.height, height: e.width } : { width: e.width, height: e.height };
}
function Ub(e, a, t) {
  const s = Gh(t.rotation), n = t.width, o = t.height;
  switch (s) {
    case 90:
      return { x: a, y: n - e };
    case 180:
      return { x: n - e, y: o - a };
    case 270:
      return { x: o - a, y: e };
    default:
      return { x: e, y: a };
  }
}
function Hb(e, a, t) {
  const s = Gh(t.rotation), n = t.width, o = t.height;
  switch (s) {
    case 90:
      return { X: n - a, Y: e };
    case 180:
      return { X: n - e, Y: o - a };
    case 270:
      return { X: a, Y: o - e };
    default:
      return { X: e, Y: a };
  }
}
function zhe(e, a) {
  const t = Ub(e.x * a.width, e.y * a.height, a), s = Ub((e.x + e.w) * a.width, (e.y + e.h) * a.height, a), { height: n } = R1(a), o = Math.min(t.x, s.x), p = Math.max(t.x, s.x), h = Math.min(t.y, s.y), v = Math.max(t.y, s.y);
  return N1({ x: o, y: n - v, w: p - o, h: v - h });
}
function Mhe(e, a) {
  const { height: t } = R1(a), s = { x: e.x, y: t - (e.y + e.h) }, n = { x: e.x + e.w, y: t - e.y }, o = Hb(s.x, s.y, a), p = Hb(n.x, n.y, a), h = a.width || 1, v = a.height || 1;
  return N1({
    x: Math.min(o.X, p.X) / h,
    y: Math.min(o.Y, p.Y) / v,
    w: Math.abs(o.X - p.X) / h,
    h: Math.abs(o.Y - p.Y) / v
  });
}
function N1(e) {
  const a = {};
  for (const [t, s] of Object.entries(e)) a[t] = Math.round(s * 1e6) / 1e6;
  return a;
}
function E3(e, a, t = 16) {
  const s = Math.max(0, e.width), n = Math.max(0, e.height) - t;
  if (!a.width || !a.height || n <= 0) return s;
  const o = n * a.width / a.height;
  return Math.max(120, Math.min(s, o));
}
const Rr = [
  { key: "caveat", name: "Caveat", kind: "hand", className: "fe-signfont--caveat", stack: "'Caveat', cursive" },
  {
    key: "dancing-script",
    name: "Dancing Script",
    kind: "hand",
    className: "fe-signfont--dancing-script",
    stack: "'Dancing Script', cursive"
  },
  {
    key: "homemade-apple",
    name: "Homemade Apple",
    kind: "hand",
    className: "fe-signfont--homemade-apple",
    stack: "'Homemade Apple', cursive"
  },
  {
    key: "inter",
    name: "Inter",
    kind: "formal",
    className: "fe-signfont--inter",
    stack: 'Inter, system-ui, -apple-system, "Segoe UI", Roboto, sans-serif'
  },
  {
    key: "source-serif",
    name: "Source Serif 4",
    kind: "formal",
    className: "fe-signfont--source-serif",
    stack: "'Source Serif 4', Georgia, 'Times New Roman', serif"
  }
], B1 = "caveat";
function F1(e) {
  const a = String(e ?? "");
  return Rr.find((t) => t.key === a) ?? Rr.find((t) => t.key === B1);
}
function su(e) {
  return typeof e == "string" && Rr.some((a) => a.key === e);
}
const Nv = ["any", "number", "email"];
function A3(e) {
  return typeof e == "string" && Nv.includes(e);
}
function z3(e) {
  if (!e || typeof e != "object") return null;
  const a = e, s = { kind: A3(a.kind) ? a.kind : "any" }, n = Math.trunc(Number(a.min)), o = Math.trunc(Number(a.max));
  return Number.isFinite(n) && n > 0 && (s.min = n), Number.isFinite(o) && o > 0 && (s.max = o), s.kind === "any" && s.min === void 0 && s.max === void 0 ? null : s;
}
function M3(e) {
  return e ? e.kind === "number" ? "numeric" : e.kind === "email" ? "email" : "text" : "text";
}
function U1(e) {
  if (e)
    return e.max && e.max > 0 ? e.max : void 0;
}
function D3(e, a) {
  let t = String(e ?? "");
  if (!a) return t;
  if (a.kind === "number") {
    const n = t.startsWith("-");
    let o = !1;
    t = t.split("").filter((p) => p >= "0" && p <= "9" ? !0 : (p === "." || p === ",") && !o ? (o = !0, !0) : !1).join(""), n && (t = `-${t}`);
  } else a.kind === "email" && (t = t.replace(/\s+/g, ""));
  const s = U1(a);
  return s && t.length > s && (t = t.slice(0, s)), t;
}
function P3(e, a) {
  const t = typeof e == "string" ? e.trim() : "";
  return !a || t === "" ? "" : a.min && t.length < a.min ? "min" : a.max && t.length > a.max ? "max" : a.kind === "number" ? /^-?\d+([.,]\d+)?$/.test(t) ? "" : "number" : a.kind === "email" ? /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(t) ? "" : "email" : "";
}
const Bc = ["signature", "initials", "date", "text", "checkbox"];
function H1(e) {
  return e === "signature" || e === "initials";
}
function K1(e, a) {
  if (!Array.isArray(e)) return [];
  const t = [], s = /* @__PURE__ */ new Set();
  for (const n of e) {
    if (!n || typeof n != "object") continue;
    const o = typeof n.id == "string" ? n.id.trim() : "";
    if (!o || s.has(o)) continue;
    s.add(o);
    const p = { id: o, label: n.label ?? o };
    a(p, n), t.push(p);
  }
  return t;
}
function O3(e) {
  return K1(e, (a, t) => {
    t.examples && typeof t.examples == "object" && !Array.isArray(t.examples) && (a.examples = t.examples), t.default === !0 && (a.default = !0);
  });
}
function L3(e, a) {
  if (Array.isArray(e.lines)) {
    const t = new Set(e.lines);
    return a.filter((s) => t.has(s.id)).map((s) => s.id);
  }
  return a.filter((t) => t.default).map((t) => t.id);
}
function I3(e, a) {
  const t = e.examples ?? {};
  return t[a || "*"] ?? t["*"] ?? "";
}
const gd = {
  signature: { w: 0.28, h: 0.06 },
  initials: { w: 0.1, h: 0.05 },
  date: { w: 0.16, h: 0.035 },
  text: { w: 0.26, h: 0.035 },
  checkbox: { w: 0.03, h: 0.022 }
}, zp = ["#2563eb", "#16a34a", "#d97706", "#9333ea", "#dc2626", "#0891b2"];
function V1(e) {
  return typeof e == "string" && Bc.includes(e);
}
function R3(e) {
  if (!Array.isArray(e)) return [...Bc];
  const a = e.filter(V1);
  return a.length ? Bc.filter((t) => a.includes(t)) : [...Bc];
}
function Fc(e) {
  if (!Array.isArray(e)) return [];
  const a = [], t = /* @__PURE__ */ new Set();
  for (const s of e) {
    if (!s || typeof s != "object") continue;
    const n = String(s.id ?? "");
    if (!n || t.has(n) || !V1(s.type)) continue;
    t.add(n);
    const o = $r({ x: Number(s.x), y: Number(s.y), w: Number(s.w), h: Number(s.h) }), p = Math.max(1, Math.trunc(Number(s.page) || 1)), h = { id: n, type: s.type, page: p, ...o };
    typeof s.label == "string" && s.label && (h.label = s.label), typeof s.assignee == "string" && s.assignee && (h.assignee = s.assignee), s.required === !0 && (h.required = !0), s.placed === !1 && (h.placed = !1), s.value !== void 0 && s.value !== null && (h.value = s.value);
    const v = z3(s.rule);
    v && (h.rule = v), typeof s.format == "string" && s.format.trim() && (h.format = s.format.trim()), su(s.font) && (h.font = s.font), H1(s.type) && (s.style === "typed" && (h.style = "typed"), Array.isArray(s.lines) && (h.lines = [...new Set(s.lines.filter((y) => typeof y == "string" && !!y))].slice(0, 16))), a.push(h);
  }
  return a;
}
function Bv(e) {
  return e.placed !== !1;
}
function N3(e) {
  return e.filter((a) => !Bv(a));
}
function B3(e, a, t = {}) {
  var o;
  const s = gd[a], n = {
    id: Xh(a, e),
    type: a,
    page: 1,
    x: 0.1,
    y: 0.1,
    w: s.w,
    h: s.h,
    placed: !1
  };
  return (o = t.label) != null && o.trim() && (n.label = t.label.trim()), t.assignee && (n.assignee = t.assignee), t.required && (n.required = !0), n;
}
function F3(e) {
  return K1(e, (a, t) => {
    typeof t.example == "string" && t.example.trim() && (a.example = t.example.trim()), typeof t.order == "string" && t.order.trim() && (a.order = t.order.trim()), t.order_label && (a.orderLabel = t.order_label), typeof t.separator == "string" && t.separator !== "" && (a.separator = t.separator), t.separator_label && (a.separatorLabel = t.separator_label);
  });
}
function U3(e) {
  if (!e || typeof e != "object" || Array.isArray(e)) return {};
  const a = e, t = {};
  for (const s of ["order", "separator", "example"]) {
    const n = a[s];
    (typeof n == "string" ? n.trim() : n && typeof n == "object") && (t[s] = n);
  }
  return t;
}
function H3(e) {
  if (!e.length) return null;
  const a = [], t = [];
  for (const s of e) {
    if (s.order === void 0 || s.separator === void 0) return null;
    a.some((n) => n.id === s.order) || a.push({ id: s.order, label: s.orderLabel ?? s.order }), t.some((n) => n.id === s.separator) || t.push({ id: s.separator, label: s.separatorLabel ?? s.separator });
  }
  return a.length && t.length ? { orders: a, separators: t } : null;
}
function Kb(e, a, t) {
  var n, o;
  const s = e.find((p) => p.order === a && p.separator === t);
  return s ? s.id : ((n = e.find((p) => p.order === a)) == null ? void 0 : n.id) ?? ((o = e[0]) == null ? void 0 : o.id) ?? "";
}
function K3(e, a) {
  const t = e.find((s) => s.id === a);
  return !t || t.order === void 0 || t.separator === void 0 ? null : { order: t.order, separator: t.separator };
}
function V3(e) {
  const a = [];
  let t = 0;
  for (; t < e.length; )
    e.startsWith("YYYY", t) ? (a.push("YYYY"), t += 4) : e.startsWith("YY", t) ? (a.push("YY"), t += 2) : e.startsWith("DD", t) ? (a.push("DD"), t += 2) : e.startsWith("MM", t) ? (a.push("MM"), t += 2) : t += 1;
  return a;
}
function q3(e, a, t) {
  return V3(e).map((n) => n === "YYYY" ? String(t.getFullYear()).padStart(4, "0") : n === "YY" ? String(t.getFullYear() % 100).padStart(2, "0") : n === "MM" ? String(t.getMonth() + 1).padStart(2, "0") : String(t.getDate()).padStart(2, "0")).join(a);
}
function j3(e) {
  return Array.isArray(e) ? e.filter((a) => a && typeof a == "object" && typeof a.id == "string" && a.id).map((a) => ({
    id: a.id,
    label: a.label ?? a.id,
    color: typeof a.color == "string" ? a.color : void 0
  })) : [];
}
function W3(e, a) {
  const t = e.findIndex((s) => s.id === a);
  return t < 0 ? zp[0] : e[t].color || zp[t % zp.length];
}
function q1(e, a) {
  return e.assignee ? !!a && e.assignee === a : !0;
}
function Fv(e) {
  const a = e.value;
  return e.type === "checkbox" ? a === !0 : typeof a == "string" ? a !== "" : a != null;
}
function j1(e, a) {
  return {
    fields: e.filter((t) => q1(t, a) && Fv(t)).map((t) => {
      const s = { id: t.id, value: t.value };
      return t.label && (s.label = t.label), t.font && (s.font = t.font), t.rule && (s.rule = t.rule), s;
    })
  };
}
function Y3(e, a) {
  const t = a == null ? void 0 : a.fields;
  if (!Array.isArray(t)) return e;
  const s = /* @__PURE__ */ new Map();
  for (const n of t)
    n && typeof n.id == "string" && s.set(n.id, { value: n.value, font: su(n.font) ? n.font : void 0 });
  return e.map((n) => {
    const o = s.get(n.id);
    return o ? { ...n, value: o.value, ...o.font ? { font: o.font } : {} } : n;
  });
}
function Dhe(e, a, t) {
  return e.map((s) => s.id === a ? { ...s, font: t } : s);
}
function G3(e, a, t) {
  return e.map((s) => {
    if (s.id !== a) return s;
    const n = { ...s };
    return t == null || t === "" || t === !1 ? delete n.value : n.value = t, n;
  });
}
function Xh(e, a) {
  const t = { signature: "sig", initials: "ini", date: "date", text: "text", checkbox: "chk" }[e], s = new Set(a.map((n) => n.id));
  for (let n = 1; ; n++) {
    const o = `${t}-${n}`;
    if (!s.has(o)) return o;
  }
}
function Vb(e, a, t, s, n = gd[a], o) {
  const p = $r({ x: s.x, y: s.y, w: n.w, h: n.h }), h = { id: Xh(a, e), type: a, page: t, ...p };
  return o && (h.assignee = o), h;
}
function X3(e, a, t) {
  const s = e.find((o) => o.id === a);
  if (!s) return e;
  const n = { ...s, id: Xh(s.type, e), page: Math.max(1, Math.trunc(t)) };
  return delete n.value, [...e, n];
}
function J3(e = /* @__PURE__ */ new Date()) {
  const a = e.getFullYear(), t = String(e.getMonth() + 1).padStart(2, "0"), s = String(e.getDate()).padStart(2, "0");
  return `${a}-${t}-${s}`;
}
function Eu(e, a) {
  var t;
  for (const s of e ?? [])
    a(s), (t = s.children) != null && t.length && Eu(s.children, a);
}
function Z3(e) {
  const a = {};
  return Eu(e, (t) => {
    var n;
    const s = t.props ?? {};
    if (t.type === "form") {
      const o = s;
      for (const p of o.fields ?? []) {
        if (!(p != null && p.key)) continue;
        const h = (n = o.values) == null ? void 0 : n[p.key];
        h !== void 0 ? a[p.key] = qb(p, h) : p.default !== void 0 ? a[p.key] = qb(p, p.default) : p.multi === !0 && p.type === "select" && (a[p.key] = []);
      }
      return;
    }
    if (t.id) {
      if (t.type === "people-picker") {
        const o = s.value;
        a[t.id] = Array.isArray(o) ? o.filter((p) => p && typeof p.email == "string") : [];
      } else if (t.type === "file-chooser") {
        const o = s.value;
        a[t.id] = typeof o == "string" ? o : "";
      } else if (t.type === "pin-input")
        a[t.id] = "";
      else if (t.type === "signature-pad")
        a[t.id] = null;
      else if (t.type === "pdf-fields") {
        const o = s, p = Fc(o.fields);
        a[t.id] = o.mode === "fill" ? j1(p, o.signer) : p;
      }
    }
  }), a;
}
function qb(e, a) {
  return e.multi !== !0 || e.type !== "select" ? a : Array.isArray(a) ? a.map((t) => String(t)) : a == null || a === "" ? [] : [String(a)];
}
const Q3 = /* @__PURE__ */ new Set(["string", "int", "bool", "password", "select"]);
function e4(e) {
  const a = String(e.style ?? "").toLowerCase();
  return a === "choice" ? !0 : a === "switch" ? !1 : (e.options ?? []).length > 0 ? !0 : e.required === !0;
}
function t4(e, a) {
  const t = e.secret ? "password" : Q3.has(String(e.type)) ? e.type : "string";
  return {
    key: e.key,
    type: t,
    label: jt(e.label, a) || e.key,
    help: jt(e.help, a) || void 0,
    i18n_key: "",
    required: e.required === !0,
    secret: e.secret === !0,
    default: e.default,
    placeholder: jt(e.placeholder, a) || void 0,
    options: (e.options ?? []).map((s) => ({ value: String(s.value), label: jt(s.label, a) || String(s.value) })),
    min: e.min,
    max: e.max,
    monospace: e.monospace === !0,
    // ⚠⚠ `text` IS the contract's long text (wire.Field: "string | password
    // | int | bool | select | text"), and the field renderer draws a textarea
    // only on `multiline`. Nothing mapped the two, so every long field a
    // plugin asked for arrived as a one-line box — including the signing
    // app's list of signers, under a help line that says "one per line".
    multiline: e.multiline === !0 || String(e.type) === "text",
    choice: t === "select" || t === "bool" && e4(e),
    multi: e.multi === !0
  };
}
function a4(e) {
  const a = Number(e);
  return Number.isFinite(a) ? Math.min(8, Math.max(4, Math.trunc(a))) : 6;
}
function n4(e) {
  const a = e.trim(), t = a.indexOf("@");
  return t > 0 && t < a.length - 1 && !/\s/.test(a) && a.indexOf("@", t + 1) === -1;
}
function Uv(e) {
  return e == null ? !1 : typeof e == "string" ? e.trim() !== "" : Array.isArray(e) ? e.length > 0 : !0;
}
function s4(e) {
  return e == null ? [] : Array.isArray(e) ? e.map((a) => String(a)) : typeof e == "boolean" ? [e ? "true" : "false"] : [String(e)];
}
function W1(e, a) {
  if (!e || !e.key) return !0;
  const t = a == null ? void 0 : a[e.key], s = e.equals ?? [];
  if (!s.length) return Uv(t);
  if (!Uv(t)) return !1;
  const n = s4(t);
  return s.some((o) => n.includes(String(o)));
}
function Jh(e, a) {
  const t = (e ?? []).filter((n) => n && n.key);
  if (!t.length) return [];
  let s = t;
  for (let n = 0; n <= t.length; n++) {
    const o = Y1(t, s, a), p = t.filter((h) => W1(h.show_when, o));
    if (p.length === s.length) return p;
    s = p;
  }
  return s;
}
function Y1(e, a, t) {
  const s = new Set(a.map((o) => o.key)), n = { ...t };
  for (const o of e) s.has(o.key) || delete n[o.key];
  return n;
}
function G1(e, a) {
  return e.required === !0 ? !0 : e.required_when ? W1(e.required_when, a) : !1;
}
function X1(e) {
  const a = [];
  return Eu(e, (t) => {
    var n;
    if (t.type !== "form") return;
    const s = (n = t.props) == null ? void 0 : n.fields;
    for (const o of s ?? []) o && o.key && a.push(o);
  }), a;
}
function o4(e, a) {
  const t = X1(e);
  if (!t.length) return [];
  const s = new Set(Jh(t, a).map((n) => n.key));
  return t.filter((n) => !s.has(n.key)).map((n) => n.key);
}
function i4(e, a) {
  const t = o4(e, a);
  if (!t.length) return { ...a };
  const s = { ...a };
  for (const n of t) delete s[n];
  return s;
}
function jb(e, a) {
  const t = X1(e);
  if (!t.length) return [];
  const s = Jh(t, a), n = Y1(t, s, a);
  return s.filter((o) => G1(o, n) && !Uv(n[o.key]));
}
const r4 = 300;
function Gd(e, a) {
  const t = b(null), s = b({}), n = b(!1), o = b(""), p = b([]), h = x(() => {
    var A;
    return ((A = t.value) == null ? void 0 : A.actions) ?? [];
  }), v = x(() => {
    var A;
    return (A = t.value) == null ? void 0 : A.errors;
  });
  function y(A, O = !1) {
    t.value = A, o.value = "", p.value = [];
    const z = Z3(A == null ? void 0 : A.nodes);
    s.value = O ? { ...z, ...s.value } : z;
  }
  function g(A) {
    var O;
    if (s.value = A, p.value.length) {
      const z = jb((O = t.value) == null ? void 0 : O.nodes, A).map((P) => P.key);
      z.length !== p.value.length && (p.value = z);
    }
  }
  let m = null;
  function k() {
    m !== null && clearTimeout(m), m = null;
  }
  function _() {
    k(), m = setTimeout(() => {
      m = null, $("change");
    }, r4);
  }
  let w = 0;
  async function $(A, O, z = {}) {
    var W, N, K, M, j, U;
    if (!t.value) return;
    const P = A !== "change";
    if (P) {
      if (k(), n.value) return;
      n.value = !0;
    }
    const I = ++w;
    o.value = "";
    const F = (W = e.paths) == null ? void 0 : W.call(e);
    try {
      const de = await e.api.pluginViewEvent(e.plugin, e.view, {
        path: (N = e.path) == null ? void 0 : N.call(e),
        ...F != null && F.length ? { paths: [...F] } : {},
        state: ((K = t.value) == null ? void 0 : K.state) ?? {},
        event: A,
        action_id: O,
        // ⚠⚠ The values a HIDDEN field holds are dropped here, not blanked
        // (v3 §2.1: "a value belonging to a hidden field is dropped before
        // the job runs — it cannot arrive as a surprise"). The plugin is
        // re-asked the same question by the host at submit; this is the
        // client half of the same promise, and it also keeps a `change`
        // event from echoing back a field the step no longer shows.
        data: { values: i4((M = t.value) == null ? void 0 : M.nodes, s.value), ...z }
      });
      if (!P && I !== w) return;
      if (de.op) {
        a.onOp(de.op), a.onDone();
        return;
      }
      const ke = de.surface;
      if (!ke) {
        o.value = e.errorText();
        return;
      }
      const ie = jt(ke.toast, e.locale());
      ie && a.onToast(ie);
      const ce = I1(ke.open) ? ke.open : null;
      if (ke.done) {
        a.onDone(), ce && ((j = a.onOpen) == null || j.call(a, ce));
        return;
      }
      y(ke, !P), ce && ((U = a.onOpen) == null || U.call(a, ce));
    } catch (de) {
      if (!P && I !== w) return;
      o.value = go(e.locale(), String((de == null ? void 0 : de.message) ?? de)) || e.errorText();
    } finally {
      P && (n.value = !1);
    }
  }
  function C(A) {
    var O;
    if (n.value || A.disabled) return Promise.resolve();
    if (A.primary) {
      const z = jb((O = t.value) == null ? void 0 : O.nodes, s.value);
      if (p.value = z.map((P) => P.key), z.length) return Promise.resolve();
    }
    return $(A.primary ? "submit" : "action", A.id);
  }
  function E(A) {
    return $("action", A.action_id, { row_id: A.row_id });
  }
  return hi() && Mt(k), {
    current: t,
    values: s,
    busy: n,
    failure: o,
    footer: h,
    errors: v,
    invalidKeys: p,
    setSurface: y,
    updateValues: g,
    scheduleChange: _,
    post: $,
    press: C,
    rowAction: E,
    dispose: k
  };
}
const Uc = ["draw", "type", "upload"], l4 = 200 * 1024, J1 = 600, Z1 = 200, u4 = 480, c4 = 160, Wb = "#111111", Hv = B1;
function Q1(e) {
  return typeof e == "string" && Uc.includes(e);
}
function d4(e) {
  if (!Array.isArray(e)) return [...Uc];
  const a = e.filter(Q1);
  return a.length ? Uc.filter((t) => a.includes(t)) : [...Uc];
}
function Nl(e) {
  const a = e;
  return !!a && typeof a == "object" && typeof a.png_b64 == "string" && a.png_b64 !== "" && Q1(a.mode);
}
function f4(e) {
  const a = e;
  return a && su(a.font) ? a.font : Hv;
}
function p4(e, a) {
  const t = Number(e), s = Number(a);
  return {
    width: Number.isFinite(t) && t > 0 ? Math.min(J1, Math.max(120, Math.round(t))) : u4,
    height: Number.isFinite(s) && s > 0 ? Math.min(Z1, Math.max(60, Math.round(s))) : c4
  };
}
function v4(e, a, t, s) {
  if (!(e > 0) || !(a > 0)) return { width: t, height: s };
  const n = Math.min(1, t / e, s / a);
  return { width: Math.max(1, Math.round(e * n)), height: Math.max(1, Math.round(a * n)) };
}
function h4(e) {
  const a = e.indexOf("base64,");
  return a >= 0 ? e.slice(a + 7) : e;
}
function m4(e) {
  return e.type !== "image/png" && e.type !== "image/jpeg" ? "bad_type" : e.size > l4 ? "too_big" : "ok";
}
function y4(e, a, t) {
  let s = Math.min(96, Math.floor(t * 0.6));
  for (; s > 12 && e(s) > a; ) s -= 2;
  return s;
}
const g4 = { class: "fe-cfield" }, b4 = {
  key: 0,
  class: "fe-cfield__empty"
}, _4 = {
  key: 0,
  class: "fe-cfield__check"
}, k4 = ["checked", "disabled", "onChange"], w4 = ["for"], x4 = {
  key: 0,
  class: "fe-cfield__req",
  "aria-hidden": "true"
}, $4 = ["id", "value", "disabled", "onChange"], S4 = ["value"], T4 = ["id", "value", "placeholder", "disabled", "onInput"], C4 = {
  key: 5,
  class: "fe-cfield__secret"
}, E4 = ["id", "type", "value", "placeholder", "disabled", "onInput"], A4 = ["title", "aria-label", "onClick"], z4 = ["innerHTML"], M4 = ["id", "type", "value", "placeholder", "min", "max", "disabled", "onInput"], D4 = {
  key: 7,
  class: "fe-cfield__help"
}, P4 = {
  key: 8,
  class: "fe-cfield__error"
}, O4 = {
  key: 1,
  class: "fe-cfield__adv"
}, L4 = {
  key: 0,
  class: "fe-cfield__advbody"
}, I4 = {
  key: 0,
  class: "fe-cfield__check"
}, R4 = ["checked", "disabled", "onChange"], N4 = ["for"], B4 = ["id", "type", "value", "placeholder", "disabled", "onInput"], F4 = {
  key: 2,
  class: "fe-cfield__help"
}, U4 = {
  key: 3,
  class: "fe-cfield__error"
}, H4 = /* @__PURE__ */ rt({
  __name: "StorageFields",
  props: {
    fields: {},
    modelValue: {},
    locale: {},
    invalid: {},
    errors: {},
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n } = gt(() => t.locale), o = b(!1), p = b({}), h = x(() => t.fields.filter((N) => !N.advanced)), v = x(() => t.fields.filter((N) => N.advanced));
    function y(N) {
      const K = n(N.i18n_key);
      return K === N.i18n_key ? N.label : K;
    }
    function g(N) {
      if (!N.help_i18n_key) return N.help ?? "";
      const K = n(N.help_i18n_key);
      return K === N.help_i18n_key ? N.help ?? "" : K;
    }
    function m(N) {
      if (!N.i18n_key) return N.label;
      const K = n(N.i18n_key);
      return K === N.i18n_key ? N.label : K;
    }
    function k(N, K) {
      s("update:modelValue", { ...t.modelValue, [N]: K });
    }
    function _(N) {
      var M, j;
      const K = (M = t.modelValue) == null ? void 0 : M[N.key];
      if (K != null) return K;
      for (const U of N.aliases ?? []) {
        const de = (j = t.modelValue) == null ? void 0 : j[U];
        if (de != null) return de;
      }
      return N.default ?? void 0;
    }
    function w(N) {
      const K = _(N);
      return K == null ? "" : String(K);
    }
    function $(N) {
      const K = _(N);
      return K === "" || K === void 0 || K === null ? "" : String(K);
    }
    function C(N) {
      return _(N) === !0;
    }
    function E(N) {
      var K;
      return (t.invalid ?? []).includes(N.key) || !!((K = t.errors) != null && K[N.key]);
    }
    function A(N) {
      var K;
      return ((K = t.errors) == null ? void 0 : K[N.key]) || (E(N) ? n("conn.form.required") : "");
    }
    function O(N) {
      if (N.type === "bool") {
        const K = (N.options ?? []).filter((U) => U.value === "true" || U.value === "false"), M = K.find((U) => U.value === "true"), j = K.find((U) => U.value === "false");
        return [
          { value: "true", label: M ? m(M) : n("conn.form.yes") },
          { value: "false", label: j ? m(j) : n("conn.form.no") }
        ];
      }
      return (N.options ?? []).map((K) => ({ value: K.value, label: m(K) }));
    }
    function z(N) {
      const K = _(N);
      return N.type === "bool" ? K === !0 || K === "true" ? "true" : K === !1 || K === "false" ? "false" : "" : N.multi ? Array.isArray(K) ? K.map((M) => String(M)) : K == null || K === "" ? [] : [String(K)] : K == null ? "" : String(K);
    }
    function P(N, K) {
      if (N.type === "bool") {
        k(N.key, K === "true");
        return;
      }
      k(N.key, K);
    }
    function I(N) {
      return N.choice === !0 && (N.type === "select" || N.type === "bool");
    }
    function F(N) {
      return N.type === "int" ? "number" : N.type === "password" && !p.value[N.key] ? "password" : "text";
    }
    function W(N) {
      p.value = { ...p.value, [N]: !p.value[N] };
    }
    return (N, K) => (u(), d("div", g4, [
      e.fields.length ? T("", !0) : (u(), d("p", b4, f(r(n)("conn.form.noFields")), 1)),
      (u(!0), d(he, null, We(h.value, (M) => (u(), d("div", {
        key: M.key,
        class: Re(["fe-cfield__row", { "is-invalid": E(M) }])
      }, [
        M.type === "bool" && !I(M) ? (u(), d("label", _4, [
          i("input", {
            type: "checkbox",
            checked: C(M),
            disabled: e.disabled,
            onChange: (j) => k(M.key, j.target.checked)
          }, null, 40, k4),
          i("span", null, f(y(M)), 1)
        ])) : (u(), d("label", {
          key: 1,
          class: "fe-cfield__label",
          for: `fe-cf-${M.key}`
        }, [
          $t(f(y(M)), 1),
          M.required ? (u(), d("span", x4, "*")) : T("", !0)
        ], 8, w4)),
        I(M) ? (u(), nt(Ls, {
          key: 2,
          options: O(M),
          "model-value": z(M),
          multi: M.multi === !0,
          disabled: e.disabled,
          invalid: E(M),
          "aria-label": y(M),
          "testid-prefix": `fe-choice-${M.key}`,
          "onUpdate:modelValue": (j) => P(M, j)
        }, null, 8, ["options", "model-value", "multi", "disabled", "invalid", "aria-label", "testid-prefix", "onUpdate:modelValue"])) : M.type === "select" ? (u(), d("select", {
          key: 3,
          id: `fe-cf-${M.key}`,
          class: "fe-cfield__input",
          value: w(M),
          disabled: e.disabled,
          onChange: (j) => k(M.key, j.target.value)
        }, [
          (u(!0), d(he, null, We(M.options ?? [], (j) => (u(), d("option", {
            key: j.value,
            value: j.value
          }, f(m(j)), 9, S4))), 128))
        ], 40, $4)) : M.multiline ? (u(), d("textarea", {
          key: 4,
          id: `fe-cf-${M.key}`,
          class: Re(["fe-cfield__input fe-cfield__input--area", { "fe-cfield__input--mono": M.monospace }]),
          rows: "4",
          value: w(M),
          placeholder: M.placeholder,
          disabled: e.disabled,
          onInput: (j) => k(M.key, j.target.value)
        }, null, 42, T4)) : M.type === "password" ? (u(), d("div", C4, [
          i("input", {
            id: `fe-cf-${M.key}`,
            class: "fe-cfield__input fe-cfield__input--mono",
            type: F(M),
            autocomplete: "new-password",
            spellcheck: "false",
            value: w(M),
            placeholder: M.placeholder,
            disabled: e.disabled,
            onInput: (j) => k(M.key, j.target.value)
          }, null, 40, E4),
          i("button", {
            type: "button",
            class: "fe-cfield__eye",
            title: p.value[M.key] ? r(n)("conn.form.hide") : r(n)("conn.form.reveal"),
            "aria-label": p.value[M.key] ? r(n)("conn.form.hide") : r(n)("conn.form.reveal"),
            onClick: (j) => W(M.key)
          }, [
            i("span", {
              "aria-hidden": "true",
              innerHTML: r(wt)(p.value[M.key] ? "toggle-hidden" : "preview")
            }, null, 8, z4)
          ], 8, A4)
        ])) : M.type !== "bool" ? (u(), d("input", {
          key: 6,
          id: `fe-cf-${M.key}`,
          class: Re(["fe-cfield__input", { "fe-cfield__input--mono": M.monospace }]),
          type: F(M),
          value: M.type === "int" ? $(M) : w(M),
          placeholder: M.placeholder,
          min: M.min,
          max: M.max,
          disabled: e.disabled,
          onInput: (j) => k(
            M.key,
            M.type === "int" ? j.target.value === "" ? null : Number(j.target.value) : j.target.value
          )
        }, null, 42, M4)) : T("", !0),
        g(M) ? (u(), d("p", D4, f(g(M)), 1)) : T("", !0),
        A(M) ? (u(), d("p", P4, f(A(M)), 1)) : T("", !0)
      ], 2))), 128)),
      v.value.length ? (u(), d("div", O4, [
        i("button", {
          type: "button",
          class: "fe-cfield__advtoggle",
          onClick: K[0] || (K[0] = (M) => o.value = !o.value)
        }, f(o.value ? "▾" : "▸") + " " + f(r(n)("conn.form.advanced")), 1),
        o.value ? (u(), d("div", L4, [
          (u(!0), d(he, null, We(v.value, (M) => (u(), d("div", {
            key: M.key,
            class: "fe-cfield__row"
          }, [
            M.type === "bool" ? (u(), d("label", I4, [
              i("input", {
                type: "checkbox",
                checked: C(M),
                disabled: e.disabled,
                onChange: (j) => k(M.key, j.target.checked)
              }, null, 40, R4),
              i("span", null, f(y(M)), 1)
            ])) : (u(), d(he, { key: 1 }, [
              i("label", {
                class: "fe-cfield__label",
                for: `fe-cfa-${M.key}`
              }, f(y(M)), 9, N4),
              i("input", {
                id: `fe-cfa-${M.key}`,
                class: Re(["fe-cfield__input", { "fe-cfield__input--mono": M.monospace }]),
                type: F(M),
                value: M.type === "int" ? $(M) : w(M),
                placeholder: M.placeholder,
                disabled: e.disabled,
                onInput: (j) => k(
                  M.key,
                  M.type === "int" ? j.target.value === "" ? null : Number(j.target.value) : j.target.value
                )
              }, null, 42, B4)
            ], 64)),
            g(M) ? (u(), d("p", F4, f(g(M)), 1)) : T("", !0),
            A(M) ? (u(), d("p", U4, f(A(M)), 1)) : T("", !0)
          ]))), 128))
        ])) : T("", !0)
      ])) : T("", !0)
    ]));
  }
}), K4 = {
  class: "fe-surface__form",
  "data-testid": "surface-form"
}, V4 = /* @__PURE__ */ rt({
  __name: "SurfaceForm",
  props: {
    fields: {},
    values: {},
    locale: {},
    errors: {},
    disabled: { type: Boolean },
    invalid: {}
  },
  emits: ["update:values"],
  setup(e, { emit: a }) {
    const t = e, s = a, n = x(() => Jh(t.fields, t.values)), o = x(
      () => n.value.map((h) => ({ ...t4(h, t.locale), required: G1(h, t.values) }))
    ), p = x(() => {
      var v;
      const h = {};
      for (const y of o.value) {
        const g = jt((v = t.errors) == null ? void 0 : v[y.key], t.locale);
        g && (h[y.key] = g);
      }
      return h;
    });
    return (h, v) => (u(), d("div", K4, [
      ot(H4, {
        fields: o.value,
        "model-value": e.values,
        locale: e.locale,
        errors: p.value,
        invalid: e.invalid,
        disabled: e.disabled,
        "onUpdate:modelValue": v[0] || (v[0] = (y) => s("update:values", y))
      }, null, 8, ["fields", "model-value", "locale", "errors", "invalid", "disabled"])
    ]));
  }
}), q4 = ["aria-label"], j4 = ["aria-current", "data-step"], W4 = {
  class: "fe-steps__marker",
  "aria-hidden": "true"
}, Y4 = {
  key: 0,
  class: "fe-ficon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  focusable: "false"
}, G4 = { class: "fe-steps__label" }, X4 = /* @__PURE__ */ rt({
  __name: "SurfaceSteps",
  props: {
    items: {},
    locale: {}
  },
  setup(e) {
    const a = e, { t } = gt(() => a.locale);
    function s(n) {
      return n === "done" || n === "active" ? n : "todo";
    }
    return (n, o) => (u(), d("ol", {
      class: "fe-steps",
      "aria-label": r(t)("plugin.steps.label"),
      "data-testid": "surface-steps"
    }, [
      (u(!0), d(he, null, We(e.items ?? [], (p, h) => (u(), d("li", {
        key: p.id || h,
        class: Re(["fe-steps__item", `is-${s(p.state)}`]),
        "aria-current": s(p.state) === "active" ? "step" : void 0,
        "data-step": p.id
      }, [
        i("span", W4, [
          s(p.state) === "done" ? (u(), d("svg", Y4, [...o[0] || (o[0] = [
            i("path", { d: "M4.8 12.6l4.7 4.7L19.2 6.9" }, null, -1)
          ])])) : (u(), d(he, { key: 1 }, [
            $t(f(h + 1), 1)
          ], 64))
        ]),
        i("span", G4, f(r(jt)(p.label, e.locale)), 1)
      ], 10, j4))), 128))
    ], 8, q4));
  }
});
let Mp = null;
function e0() {
  return Mp || (Mp = CM("t")), Mp;
}
function Zh() {
  const e = e0().get();
  return e && typeof e == "object" && !Array.isArray(e) ? e : {};
}
function t0(e, a) {
  const t = Zh(), s = { ...t[e] ?? {} };
  for (const [o, p] of Object.entries(a))
    p === void 0 ? delete s[o] : s[o] = p;
  const n = { ...t };
  Object.keys(s).length ? n[e] = s : delete n[e], e0().set(n);
}
function J4(e) {
  return {
    get: () => {
      var a;
      return (a = Zh()[e]) == null ? void 0 : a.c;
    },
    set: (a) => {
      var s;
      const t = Object.keys(a.w).length > 0 || a.hidden.length > 0 || (((s = a.o) == null ? void 0 : s.length) ?? 0) > 0;
      t0(e, { c: t ? a : void 0 });
    }
  };
}
function Z4(e) {
  var t;
  const a = (t = Zh()[e]) == null ? void 0 : t.s;
  return !a || typeof a.k != "string" || a.d !== "asc" && a.d !== "desc" ? null : { key: a.k, dir: a.d };
}
function Q4(e, a) {
  t0(e, { s: a ? { k: a.key, d: a.dir } : void 0 });
}
const e5 = ["aria-checked", "aria-label", "title"], Qh = /* @__PURE__ */ rt({
  __name: "ItemCheck",
  props: {
    on: { type: Boolean },
    label: {}
  },
  setup(e) {
    return (a, t) => (u(), d("button", {
      type: "button",
      class: Re(["fe-list__check", { "is-on": e.on }]),
      role: "checkbox",
      "aria-checked": e.on ? "true" : "false",
      "aria-label": e.label,
      title: e.label,
      onMousedown: t[0] || (t[0] = ft(() => {
      }, ["prevent"]))
    }, null, 42, e5));
  }
}), t5 = ["disabled", "data-testid"], a5 = /* @__PURE__ */ rt({
  __name: "RowActions",
  props: {
    actions: {},
    locale: { default: "en" },
    label: {},
    disabled: { type: Boolean },
    theme: {},
    testid: {}
  },
  emits: ["select"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n, dir: o } = gt(() => t.locale), p = b(
      null
    ), h = x(() => t.label || n("row.actions")), v = x(
      () => t.actions.filter((k) => !k.hidden).map((k) => ({
        ...k,
        shortcutId: k.shortcutId ?? "",
        testid: k.testid ?? (t.testid ? `${t.testid}-${k.key}` : void 0)
      }))
    ), y = x(() => v.value.some((k) => !k.divider && !k.disabled));
    function g(k) {
      var w, $;
      const _ = (w = k.currentTarget) == null ? void 0 : w.getBoundingClientRect();
      ($ = p.value) == null || $.show(
        // ⚠ RTL: the START corner (right in RTL), as ListView `onRowMenu` does.
        { clientX: _ ? Cr(_, o.value) : k.clientX, clientY: _ ? _.bottom : k.clientY },
        []
      );
    }
    function m(k) {
      s("select", k.key, k);
    }
    return (k, _) => (u(), d("div", {
      class: "tbl-rowactions",
      onClick: _[0] || (_[0] = ft(() => {
      }, ["stop"]))
    }, [
      i("button", {
        type: "button",
        class: "tbl-rowactions__btn",
        disabled: e.disabled || !y.value,
        "data-testid": e.testid,
        "data-fe-control": "",
        "aria-haspopup": "menu",
        onClick: ft(g, ["stop"])
      }, [
        i("span", null, f(h.value), 1),
        _[1] || (_[1] = i("span", {
          class: "tbl-rowactions__caret",
          "aria-hidden": "true"
        }, "▾", -1))
      ], 8, t5),
      ot(zr, {
        ref_key: "menu",
        ref: p,
        locale: e.locale,
        theme: e.theme,
        actions: v.value,
        onSelect: m
      }, null, 8, ["locale", "theme", "actions"])
    ]));
  }
}), n5 = {
  key: 0,
  class: "tbl-bar"
}, s5 = {
  key: 1,
  class: "fe-list__refreshing",
  role: "status"
}, o5 = { class: "fe-sr-only" }, i5 = ["aria-label", "aria-busy", "data-table-id"], r5 = {
  key: 0,
  class: "fe-list__col fe-list__col--check",
  role: "columnheader"
}, l5 = ["aria-sort", "data-col"], u5 = ["disabled", "title"], c5 = {
  key: 0,
  class: "fe-list__sort-arrow",
  "aria-hidden": "true"
}, d5 = {
  key: 1,
  class: "fe-list__head-label"
}, f5 = ["aria-label", "title"], p5 = ["aria-sort", "aria-label", "data-col", "onPointerdown", "onKeydown"], v5 = ["disabled", "title", "onClick"], h5 = {
  key: 0,
  class: "fe-list__sort-arrow",
  "aria-hidden": "true"
}, m5 = {
  key: 1,
  class: "fe-list__head-label"
}, y5 = ["aria-label", "title", "onPointerdown", "onDblclick", "onKeydown"], g5 = ["title", "aria-label", "aria-expanded"], b5 = {
  class: "fe-list__body",
  role: "rowgroup"
}, _5 = {
  key: 0,
  class: "fe-list__group",
  role: "presentation"
}, k5 = ["aria-selected", "onClick", "onDblclick", "onContextmenu", "onDragstart", "onDragover", "onDragleave", "onDrop", "onTouchstartPassive"], w5 = ["onClick"], x5 = ["title"], $5 = { class: "fe-list__cell-text" }, S5 = ["data-col", "title"], T5 = { class: "fe-list__cell-text" }, C5 = {
  key: 0,
  class: "fe-list__empty fe-list__empty--loading",
  role: "status"
}, E5 = {
  key: 1,
  class: "fe-list__empty"
}, A5 = {
  key: 2,
  class: "tbl-foot"
}, z5 = {
  key: 0,
  class: "tbl-pager"
}, M5 = ["disabled", "aria-label", "title"], D5 = {
  class: "tbl-pager__at",
  dir: "ltr"
}, P5 = ["disabled", "aria-label", "title"], O5 = ["dir", "data-prefers-dark"], L5 = ["aria-label", "onKeydown"], I5 = { class: "fe-colmenu__title" }, R5 = ["aria-checked", "onClick"], N5 = { class: "fe-colmenu__label" }, B5 = ["disabled", "title", "aria-label", "onClick"], F5 = { "aria-hidden": "true" }, U5 = ["disabled", "title", "aria-label", "onClick"], H5 = { "aria-hidden": "true" }, K5 = {
  key: 0,
  class: "fe-colmenu__sep",
  role: "separator"
}, V5 = { class: "fe-colmenu__label" }, Dp = 8, sr = 12, Yb = 28, q5 = 160, j5 = 160, W5 = 5, Y5 = 300, ki = /* @__PURE__ */ rt({
  inheritAttrs: !1,
  __name: "DataTable",
  props: {
    rows: {},
    columns: {},
    rowKey: { type: [String, Function], default: void 0 },
    tableId: { default: void 0 },
    columnStore: { default: void 0 },
    candidates: { default: void 0 },
    metrics: { default: void 0 },
    locale: { default: void 0 },
    theme: { default: void 0 },
    loading: { type: Boolean },
    empty: { default: void 0 },
    ariaLabel: { default: void 0 },
    selectable: { type: Boolean },
    isSelected: { type: Function, default: void 0 },
    sort: { default: void 0 },
    sortClosed: { default: void 0 },
    groups: { default: void 0 },
    rowClass: { type: Function, default: void 0 },
    rowAttrs: { type: Function, default: void 0 },
    rowActions: { type: Function, default: void 0 },
    rowActionsTestId: { type: Function, default: void 0 },
    actionsWidth: { default: void 0 },
    framed: { type: Boolean, default: !0 },
    page: { default: void 0 },
    pageSize: { default: void 0 },
    total: { default: void 0 },
    pages: { default: void 0 },
    footNote: { default: void 0 }
  },
  emits: ["sort", "row-click", "row-dblclick", "row-contextmenu", "check-click", "row-action", "row-dragstart", "row-dragover", "row-dragleave", "row-drop", "row-touchstart", "row-touchend", "row-touchmove", "page"],
  setup(e, { expose: a, emit: t }) {
    var Ie;
    const s = e, n = t, o = BM(), p = x(() => s.locale ?? (o == null ? void 0 : o.locale.value) ?? "en"), h = x(() => {
      var ee;
      return s.theme ?? ((ee = o == null ? void 0 : o.theme) == null ? void 0 : ee.value);
    }), { t: v, dir: y } = gt(() => p.value), g = x(() => {
      const ee = /* @__PURE__ */ new Map();
      for (const ge of s.columns) ee.set(ge.id, ge);
      return ee;
    }), m = x(() => {
      var ee;
      return ((ee = s.columns.find((ge) => ge.lead) ?? s.columns[0]) == null ? void 0 : ee.id) ?? "";
    }), k = x(
      () => s.columns.map((ee) => {
        const ge = ee.id === m.value, De = ee.width ?? (ge ? 240 : 140);
        return {
          id: ee.id,
          width: De,
          min: Math.min(ee.min ?? (ge ? 120 : 56), De),
          max: Math.max(ee.max ?? 900, De),
          hideable: ge ? !1 : ee.hideable !== !1,
          resizable: ee.resizable !== !1
        };
      })
    ), _ = f1(
      () => k.value,
      s.tableId ? J4(s.tableId) : dM(),
      { lead: m.value }
    ), w = x(() => s.columnStore ?? _), $ = x(
      () => (s.candidates ?? s.columns.map((ee) => ee.id)).filter((ee) => ee !== w.value.lead)
    ), C = Yb + sr, E = x(() => s.actionsWidth ?? (s.rowActions ? 92 : 28)), A = x(() => ({
      gap: Dp,
      padding: sr * 2,
      check: s.selectable ? Yb : 0,
      menu: E.value,
      ...s.metrics ?? {}
    })), O = b(null), z = b(0);
    let P = null;
    const I = b(!1);
    function F(ee) {
      const ge = ee.currentTarget, De = Math.abs((ge == null ? void 0 : ge.scrollLeft) ?? 0) > 0;
      De !== I.value && (I.value = De);
    }
    Qe(
      O,
      (ee) => {
        P == null || P.disconnect(), P = null, !(!ee || typeof ResizeObserver > "u") && (P = new ResizeObserver((ge) => {
          var lt, Ze;
          const De = ((Ze = (lt = ge[0]) == null ? void 0 : lt.contentRect) == null ? void 0 : Ze.width) ?? 0;
          Math.abs(De - z.value) >= 1 && (z.value = De);
        }), P.observe(ee));
      },
      { flush: "post" }
    );
    const W = x(() => w.value.layout(z.value, $.value, A.value)), N = x(() => W.value.visible), K = x(() => ({ width: `${W.value.total}px` })), M = x(
      () => (s.selectable ? C + Dp : sr) + (W.value.widths[w.value.lead] ?? w.value.width(w.value.lead))
    ), j = x(
      () => z.value > 0 && z.value - M.value >= q5
    ), U = x(() => E.value + sr), de = x(
      () => z.value <= 0 || z.value - M.value - U.value >= j5
    ), ke = x(() => ({
      "--fe-list-lead": s.selectable ? `${C + Dp}px` : "0px"
    }));
    function ie(ee) {
      let ge = W.value.widths[ee] ?? w.value.width(ee);
      return ee === w.value.lead && j.value && !s.selectable && (ge += sr), { flex: `0 0 ${ge}px` };
    }
    const ce = x(
      () => E.value === 28 ? void 0 : { flex: `0 0 ${E.value + sr}px` }
    );
    function X(ee) {
      const ge = g.value.get(ee), De = ["fe-list__col", "fe-list__cell"];
      return ge != null && ge.class && De.push(ge.class), ee === w.value.lead && De.push("fe-list__col--lead"), (ge == null ? void 0 : ge.align) === "right" ? De.push("is-right") : (ge == null ? void 0 : ge.align) === "center" && De.push("is-center"), De;
    }
    function Z(ee) {
      var ge;
      return ((ge = g.value.get(ee)) == null ? void 0 : ge.label) ?? ee;
    }
    const Y = x(() => s.sort !== void 0), G = b(
      s.tableId ? Z4(s.tableId) : null
    ), we = x(() => Y.value ? s.sort ?? null : G.value), R = x(
      () => (s.pages ?? 1) > 1 || s.total != null && s.total > s.rows.length
    ), pe = x(() => s.sortClosed ? s.sortClosed : !Y.value && R.value ? v("table.sort_paged") : null);
    function Q(ee) {
      var ge;
      return ((ge = g.value.get(ee)) == null ? void 0 : ge.sortable) === !0;
    }
    function q(ee) {
      if (pe.value || !Q(ee)) return;
      const ge = we.value, De = g.value.get(ee), lt = ge && ge.key === ee ? { key: ee, dir: ge.dir === "asc" ? "desc" : "asc" } : { key: ee, dir: (De == null ? void 0 : De.sortDir) ?? "asc" };
      Y.value || (G.value = lt, s.tableId && Q4(s.tableId, lt)), n("sort", lt);
    }
    function re(ee) {
      const ge = we.value;
      return pe.value || !ge || ge.key !== ee ? "" : ge.dir === "asc" ? "↑" : "↓";
    }
    function ae(ee) {
      if (!Q(ee)) return;
      const ge = we.value;
      return pe.value || !ge || ge.key !== ee ? "none" : ge.dir === "asc" ? "ascending" : "descending";
    }
    const Pe = x(() => pe.value ?? v("col.sort"));
    function be(ee, ge) {
      const De = g.value.get(ge);
      return De != null && De.sortValue ? De.sortValue(ee) : De != null && De.format ? De.format(ee) : ee == null ? void 0 : ee[ge];
    }
    function ze(ee, ge) {
      const De = ee == null || ee === "", lt = ge == null || ge === "";
      return De && lt ? 0 : De ? 1 : lt ? -1 : typeof ee == "number" && typeof ge == "number" ? ee - ge : typeof ee == "boolean" && typeof ge == "boolean" ? Number(ee) - Number(ge) : String(ee).localeCompare(String(ge), p.value, { numeric: !0, sensitivity: "base" });
    }
    const Ae = x(() => {
      const ee = we.value;
      if (Y.value || pe.value || !ee || !g.value.has(ee.key)) return s.rows;
      const ge = ee.dir === "asc" ? 1 : -1;
      return s.rows.map((De, lt) => ({ row: De, i: lt, v: be(De, ee.key) })).sort((De, lt) => {
        const Ze = De.v === null || De.v === void 0 || De.v === "", ct = lt.v === null || lt.v === void 0 || lt.v === "";
        return Ze !== ct ? Ze ? 1 : -1 : ge * ze(De.v, lt.v) || De.i - lt.i;
      }).map((De) => De.row);
    }), Ce = x(() => s.groups ?? [{ id: "all", items: Ae.value }]), He = x(() => Ce.value.reduce((ee, ge) => ee + ge.items.length, 0));
    function J(ee, ge) {
      return typeof s.rowKey == "function" ? s.rowKey(ee) : s.rowKey ? ee == null ? void 0 : ee[s.rowKey] : ge;
    }
    function me(ee) {
      return s.isSelected ? s.isSelected(ee) : !1;
    }
    function fe(ee, ge) {
      return ee == null ? void 0 : ee[ge];
    }
    function xe(ee, ge) {
      const De = g.value.get(ge), lt = De != null && De.format ? De.format(ee) : ee == null ? void 0 : ee[ge];
      return lt == null || lt === "" ? "—" : String(lt);
    }
    function ye(ee, ge) {
      const De = g.value.get(ge);
      if (De != null && De.title) return De.title(ee);
      const lt = xe(ee, ge);
      return lt === "—" ? void 0 : lt;
    }
    function qe(ee, ge) {
      var De;
      return [
        "fe-list__row",
        { "is-selected": me(ee), "is-clickable": !!ut.value },
        (De = s.rowClass) == null ? void 0 : De.call(s, ee, ge)
      ];
    }
    const ut = b(!1);
    let Ue = null;
    function Ye() {
      w.value.widthsAreAuto() && w.value.freeze(W.value.widths);
    }
    function st(ee) {
      var ge;
      return ((ge = w.value.spec(ee)) == null ? void 0 : ge.resizable) === !0;
    }
    function kt(ee, ge) {
      st(ee) && (ge.preventDefault(), ge.stopPropagation(), Ye(), Ue = { id: ee, startX: ge.clientX, startW: w.value.width(ee), sign: iv(Xo(O.value)) }, window.addEventListener("pointermove", At), window.addEventListener("pointerup", _t));
    }
    function At(ee) {
      Ue && w.value.setWidth(Ue.id, Ue.startW + Ue.sign * (ee.clientX - Ue.startX));
    }
    function _t() {
      Ue = null, window.removeEventListener("pointermove", At), window.removeEventListener("pointerup", _t);
    }
    function Le(ee, ge) {
      if (ge.ctrlKey || ge.metaKey) return;
      const De = 16 * ti(ge.key, Xo(O.value));
      De && (ge.preventDefault(), Ye(), w.value.setWidth(ee, w.value.width(ee) + De));
    }
    function tt(ee) {
      const ge = w.value.spec(ee);
      ge && (Ye(), w.value.setWidth(ee, ge.width));
    }
    let ve = null;
    const H = b(null), te = b(null);
    let Te = 0;
    function L(ee) {
      var ge;
      return ee !== w.value.lead && ((ge = w.value.spec(ee)) == null ? void 0 : ge.hideable) === !0;
    }
    function se(ee, ge) {
      ge.button !== 0 || !L(ee) || (ve = { id: ee, startX: ge.clientX, armed: !1 }, window.addEventListener("pointermove", ht), window.addEventListener("pointerup", Tt), window.addEventListener("keydown", ta, !0), window.addEventListener("pointercancel", ne), window.addEventListener("blur", ne));
    }
    function ne() {
      const ee = (ve == null ? void 0 : ve.armed) === !0;
      Rt(), ee && (Te = Date.now());
    }
    function et() {
      const ee = N.value;
      let ge = 0;
      for (; ge < ee.length && !L(ee[ge]); ) ge++;
      let De = ee.length;
      for (; De > ge && !L(ee[De - 1]); ) De--;
      return { first: ge, last: De };
    }
    function ht(ee) {
      var $o;
      if (!ve) return;
      if (!ve.armed) {
        if (Math.abs(ee.clientX - ve.startX) < W5) return;
        ve.armed = !0, H.value = ve.id;
      }
      const ge = ($o = O.value) == null ? void 0 : $o.querySelector(".fe-list__head");
      if (!ge) return;
      const De = Array.from(ge.children).filter((Rn) => Rn.classList.contains("fe-list__col")), lt = s.selectable ? 2 : 1, Ze = De.slice(lt, lt + N.value.length), ct = iv(Xo(O.value));
      let Ut = Ze.length;
      for (let Rn = 0; Rn < Ze.length; Rn++) {
        const _s = Ze[Rn].getBoundingClientRect();
        if (ct * (ee.clientX - (_s.left + _s.width / 2)) < 0) {
          Ut = Rn;
          break;
        }
      }
      const { first: Zt, last: Da } = et();
      Ut = Math.max(Zt, Math.min(Da, Ut));
      const mn = N.value.indexOf(ve.id);
      te.value = Ut === mn || Ut === mn + 1 ? null : Ut;
    }
    function Tt() {
      const ee = ve, ge = te.value;
      Rt(), ee != null && ee.armed && (Te = Date.now(), ge != null && Ft(ee.id, ge));
    }
    function Ft(ee, ge) {
      const De = N.value, lt = De.indexOf(ee);
      if (lt === -1 || ge === lt || ge === lt + 1) return;
      const ct = De.filter((Da) => Da !== ee)[ge > lt ? ge - 1 : ge], Ut = w.value.order().filter((Da) => Da !== ee), Zt = ct ? Ut.indexOf(ct) : Ut.length;
      Zt !== -1 && w.value.move(ee, Zt);
    }
    function Lt() {
      return w.value.order().filter((ee) => L(ee) && $.value.includes(ee));
    }
    function ua(ee, ge) {
      const De = Lt(), lt = De.indexOf(ee), Ze = lt + ge;
      if (lt === -1 || Ze < 0 || Ze >= De.length) return;
      const ct = De[Ze], Zt = w.value.order().filter((Da) => Da !== ee).indexOf(ct);
      Zt !== -1 && w.value.move(ee, ge === -1 ? Zt : Zt + 1);
    }
    function Ct(ee, ge) {
      const De = Lt(), lt = De.indexOf(ee);
      return lt !== -1 && lt + ge >= 0 && lt + ge < De.length;
    }
    function Qt(ee, ge) {
      if (!ge.ctrlKey && !ge.metaKey) return;
      const De = ti(ge.key, Xo(O.value));
      !De || !L(ee) || (ge.preventDefault(), ge.stopPropagation(), ua(ee, De));
    }
    function ta(ee) {
      ee.key === "Escape" && (ee.stopPropagation(), ne());
    }
    function Rt() {
      ve = null, H.value = null, te.value = null, window.removeEventListener("pointermove", ht), window.removeEventListener("pointerup", Tt), window.removeEventListener("keydown", ta, !0), window.removeEventListener("pointercancel", ne), window.removeEventListener("blur", ne);
    }
    function va(ee) {
      Date.now() - Te > Y5 || (Te = 0, ee.preventDefault(), ee.stopPropagation());
    }
    const ha = b(!1), _a = b(0), ia = b(0);
    let _e = 0;
    const Ve = b(null), Je = b(!1);
    Kt(() => {
      var ee;
      try {
        Je.value = ((ee = window.matchMedia) == null ? void 0 : ee.call(window, "(prefers-color-scheme: dark)").matches) ?? !1;
      } catch {
      }
    });
    const at = x(() => `fe-ctx-backdrop--theme-${h.value || "auto"}`), xt = x(
      () => y.value === "rtl" ? { earlier: { key: "cols.move_right", arrow: "→" }, later: { key: "cols.move_left", arrow: "←" } } : { earlier: { key: "cols.move_left", arrow: "←" }, later: { key: "cols.move_right", arrow: "→" } }
    ), Bt = x(
      () => (
        /* In the person's OWN order, so the list reads as the table on screen. */
        w.value.order().filter((ee) => L(ee) && $.value.includes(ee)).map((ee) => ({
          id: ee,
          label: Z(ee),
          on: !w.value.hidden(ee),
          canEarlier: Ct(ee, -1),
          canLater: Ct(ee, 1)
        }))
      )
    ), Ot = x(() => w.value.customised());
    async function It(ee) {
      var lt;
      ee.preventDefault(), ee.stopPropagation();
      const ge = ee.currentTarget, De = ge == null ? void 0 : ge.getBoundingClientRect();
      _e = ee.clientX || (De ? Cr(De, y.value) : 0), _a.value = _e, ia.value = ee.clientY || (De ? De.bottom : 0), ha.value = !0, await Jt(), Et(), (lt = Ve.value) == null || lt.focus();
    }
    function Et() {
      const ee = Ve.value;
      if (!ee) return;
      const ge = ee.getBoundingClientRect(), De = 8;
      _a.value = Ek(_e, ge.width, window.innerWidth, y.value, De), ge.bottom > window.innerHeight - De && (ia.value = Math.max(De, window.innerHeight - De - ge.height));
    }
    function Dt() {
      ha.value = !1;
    }
    function aa(ee) {
      ee.key === "Escape" && (ee.stopPropagation(), Dt());
    }
    Qe(ha, (ee) => {
      typeof window > "u" || (ee ? window.addEventListener("keydown", aa, !0) : window.removeEventListener("keydown", aa, !0));
    });
    function V(ee) {
      w.value.setHidden(ee, !w.value.hidden(ee));
    }
    function oe() {
      w.value.reset();
    }
    Mt(() => {
      P == null || P.disconnect(), P = null, _t(), Rt(), typeof window < "u" && window.removeEventListener("keydown", aa, !0);
    });
    const Oe = x(() => s.pages != null ? Math.max(1, s.pages) : !s.total || !s.pageSize ? 1 : Math.max(1, Math.ceil(s.total / s.pageSize))), Ne = x(() => s.page ?? 1), Ee = x(() => Oe.value > 1), Ge = x(() => {
      if (s.total != null && s.pageSize != null && s.total > 0) {
        const ee = (Ne.value - 1) * s.pageSize + 1, ge = Math.min(Ne.value * s.pageSize, s.total);
        return `${ee} – ${ge} / ${s.total}`;
      }
      return "";
    });
    function ue(ee) {
      ee < 1 || ee > Oe.value || n("page", ee);
    }
    const je = hi();
    ut.value = !!((Ie = je == null ? void 0 : je.vnode.props) != null && Ie.onRowClick);
    function vt(ee, ge) {
      n("row-click", ee, ge);
    }
    function Se(ee, ge, De) {
      n("row-action", ee, ge, De);
    }
    return a({ store: w, layout: W, pinLead: j }), (ee, ge) => (u(), d(he, null, [
      i("div", Xc(ee.$attrs, {
        class: ["fe-table", { "fe-table--framed": e.framed, "fe-table--bare": !e.framed }]
      }), [
        ee.$slots.toolbar ? (u(), d("div", n5, [
          wa(ee.$slots, "toolbar")
        ])) : T("", !0),
        e.loading && He.value > 0 ? (u(), d("div", s5, [
          i("span", o5, f(r(v)("loading")), 1)
        ])) : T("", !0),
        i("div", {
          ref_key: "listEl",
          ref: O,
          class: Re(["fe-list", {
            "is-loading": e.loading,
            "is-scrolled-x": I.value,
            "is-pin-lead": j.value,
            "is-pin-menu": de.value,
            "fe-list--nocheck": !e.selectable
          }]),
          style: Vt(ke.value),
          role: "grid",
          "aria-label": e.ariaLabel,
          "aria-busy": e.loading ? "true" : void 0,
          "data-table-id": e.tableId,
          onScrollPassive: F
        }, [
          i("div", {
            class: Re(["fe-list__head", { "is-dragging-col": !!H.value }]),
            role: "row",
            style: Vt(K.value),
            onContextmenu: It,
            onClickCapture: va
          }, [
            e.selectable ? (u(), d("div", r5)) : T("", !0),
            i("div", {
              class: Re(X(w.value.lead)),
              role: "columnheader",
              style: Vt(ie(w.value.lead)),
              "aria-sort": ae(w.value.lead),
              "data-col": w.value.lead
            }, [
              Q(w.value.lead) ? (u(), d("button", {
                key: 0,
                type: "button",
                class: "fe-list__sort",
                disabled: !!pe.value,
                title: Pe.value,
                onClick: ge[0] || (ge[0] = (De) => q(w.value.lead))
              }, [
                $t(f(Z(w.value.lead)) + " ", 1),
                re(w.value.lead) ? (u(), d("span", c5, f(re(w.value.lead)), 1)) : T("", !0)
              ], 8, u5)) : (u(), d("span", d5, f(Z(w.value.lead)), 1)),
              st(w.value.lead) ? (u(), d("span", {
                key: 2,
                class: "fe-list__resize",
                role: "separator",
                "aria-orientation": "vertical",
                tabindex: "0",
                "aria-label": r(v)("cols.resize", { col: Z(w.value.lead) }),
                title: r(v)("cols.resize", { col: Z(w.value.lead) }),
                onPointerdown: ge[1] || (ge[1] = (De) => kt(w.value.lead, De)),
                onDblclick: ge[2] || (ge[2] = ft((De) => tt(w.value.lead), ["stop"])),
                onKeydown: ge[3] || (ge[3] = (De) => Le(w.value.lead, De))
              }, null, 40, f5)) : T("", !0)
            ], 14, l5),
            (u(!0), d(he, null, We(N.value, (De, lt) => {
              var Ze, ct;
              return u(), d("div", {
                key: De,
                class: Re([
                  X(De),
                  {
                    "is-col-dragging": H.value === De,
                    "is-drop-before": te.value === lt,
                    "is-drop-after": te.value === N.value.length && lt === N.value.length - 1,
                    "is-movable": L(De)
                  }
                ]),
                role: "columnheader",
                style: Vt(ie(De)),
                "aria-sort": ae(De),
                "aria-label": ((Ze = g.value.get(De)) == null ? void 0 : Ze.headerLabel) === !1 ? Z(De) : void 0,
                "data-col": De,
                onPointerdown: (Ut) => se(De, Ut),
                onKeydown: (Ut) => Qt(De, Ut)
              }, [
                Q(De) ? (u(), d("button", {
                  key: 0,
                  type: "button",
                  class: "fe-list__sort",
                  disabled: !!pe.value,
                  title: Pe.value,
                  onClick: (Ut) => q(De)
                }, [
                  $t(f(Z(De)) + " ", 1),
                  re(De) ? (u(), d("span", h5, f(re(De)), 1)) : T("", !0)
                ], 8, v5)) : ((ct = g.value.get(De)) == null ? void 0 : ct.headerLabel) !== !1 ? (u(), d("span", m5, f(Z(De)), 1)) : T("", !0),
                st(De) ? (u(), d("span", {
                  key: 2,
                  class: "fe-list__resize",
                  role: "separator",
                  "aria-orientation": "vertical",
                  tabindex: "0",
                  "aria-label": r(v)("cols.resize", { col: Z(De) }),
                  title: r(v)("cols.resize", { col: Z(De) }),
                  onPointerdown: (Ut) => kt(De, Ut),
                  onDblclick: ft((Ut) => tt(De), ["stop"]),
                  onKeydown: (Ut) => Le(De, Ut)
                }, null, 40, y5)) : T("", !0)
              ], 46, p5);
            }), 128)),
            i("div", {
              class: Re(["fe-list__col fe-list__col--menu", { "is-wide": E.value !== 28 }]),
              style: Vt(ce.value),
              role: "columnheader"
            }, [
              i("button", {
                type: "button",
                class: "fe-list__menu fe-list__colmenu-btn",
                title: r(v)("cols.menu"),
                "aria-label": r(v)("cols.menu"),
                "aria-haspopup": "dialog",
                "aria-expanded": ha.value ? "true" : "false",
                onClick: It
              }, [...ge[12] || (ge[12] = [
                i("span", { "aria-hidden": "true" }, "⋮", -1)
              ])], 8, g5)
            ], 6)
          ], 38),
          i("div", b5, [
            (u(!0), d(he, null, We(Ce.value, (De) => (u(), d(he, {
              key: De.id
            }, [
              De.label ? (u(), d("div", _5, f(De.label), 1)) : T("", !0),
              (u(!0), d(he, null, We(De.items, (lt, Ze) => (u(), d("div", Xc({
                key: J(lt, Ze),
                class: qe(lt, Ze),
                role: "row",
                style: K.value,
                "aria-selected": e.selectable ? me(lt) ? "true" : "false" : void 0
              }, { ref_for: !0 }, e.rowAttrs ? e.rowAttrs(lt) : {}, {
                onClick: (ct) => vt(lt, ct),
                onDblclick: (ct) => n("row-dblclick", lt, ct),
                onContextmenu: (ct) => n("row-contextmenu", lt, ct),
                onDragstart: (ct) => n("row-dragstart", lt, ct),
                onDragover: (ct) => n("row-dragover", lt, ct),
                onDragleave: (ct) => n("row-dragleave", lt, ct),
                onDrop: (ct) => n("row-drop", lt, ct),
                onTouchstartPassive: (ct) => n("row-touchstart", lt, ct),
                onTouchend: ge[7] || (ge[7] = (ct) => n("row-touchend", ct)),
                onTouchmovePassive: ge[8] || (ge[8] = (ct) => n("row-touchmove", ct))
              }), [
                e.selectable ? (u(), d("div", {
                  key: 0,
                  class: "fe-list__col fe-list__col--check",
                  role: "gridcell",
                  "data-fe-control": "",
                  onClick: ft((ct) => n("check-click", lt, ct), ["stop"]),
                  onDblclick: ge[4] || (ge[4] = ft(() => {
                  }, ["stop"]))
                }, [
                  ot(Qh, {
                    on: me(lt),
                    label: xe(lt, w.value.lead)
                  }, null, 8, ["on", "label"])
                ], 40, w5)) : T("", !0),
                i("div", {
                  class: Re(X(w.value.lead)),
                  role: "gridcell",
                  style: Vt(ie(w.value.lead)),
                  title: ee.$slots[`cell-${w.value.lead}`] ? void 0 : ye(lt, w.value.lead)
                }, [
                  wa(ee.$slots, `cell-${w.value.lead}`, {
                    row: lt,
                    value: fe(lt, w.value.lead)
                  }, () => [
                    i("span", $5, [
                      i("bdi", null, f(xe(lt, w.value.lead)), 1)
                    ])
                  ])
                ], 14, x5),
                (u(!0), d(he, null, We(N.value, (ct) => (u(), d("div", {
                  key: ct,
                  class: Re(X(ct)),
                  role: "gridcell",
                  style: Vt(ie(ct)),
                  "data-col": ct,
                  title: ee.$slots[`cell-${ct}`] ? void 0 : ye(lt, ct)
                }, [
                  wa(ee.$slots, `cell-${ct}`, {
                    row: lt,
                    value: fe(lt, ct)
                  }, () => [
                    i("span", T5, [
                      i("bdi", null, f(xe(lt, ct)), 1)
                    ])
                  ])
                ], 14, S5))), 128)),
                i("div", {
                  class: Re(["fe-list__col fe-list__col--menu", { "is-wide": E.value !== 28 }]),
                  style: Vt(ce.value),
                  role: "gridcell",
                  "data-fe-control": "",
                  onClick: ge[5] || (ge[5] = ft(() => {
                  }, ["stop"])),
                  onDblclick: ge[6] || (ge[6] = ft(() => {
                  }, ["stop"]))
                }, [
                  wa(ee.$slots, "actions", { row: lt }, () => {
                    var ct;
                    return [
                      e.rowActions && e.rowActions(lt).length ? (u(), nt(a5, {
                        key: 0,
                        locale: p.value,
                        theme: h.value,
                        actions: e.rowActions(lt),
                        testid: (ct = e.rowActionsTestId) == null ? void 0 : ct.call(e, lt),
                        onSelect: (Ut, Zt) => Se(Ut, lt, Zt)
                      }, null, 8, ["locale", "theme", "actions", "testid", "onSelect"])) : T("", !0)
                    ];
                  })
                ], 38)
              ], 16, k5))), 128))
            ], 64))), 128)),
            e.loading && He.value === 0 ? (u(), d("div", C5, f(r(v)("loading")), 1)) : !e.loading && He.value === 0 ? (u(), d("div", E5, [
              wa(ee.$slots, "empty", {}, () => [
                $t(f(e.empty ?? r(v)("table.empty")), 1)
              ])
            ])) : T("", !0)
          ])
        ], 46, i5),
        Ee.value || e.footNote || ee.$slots.foot ? (u(), d("div", A5, [
          i("span", null, [
            wa(ee.$slots, "foot", {}, () => [
              $t(f(e.footNote || Ge.value), 1)
            ])
          ]),
          Ee.value ? (u(), d("div", z5, [
            i("button", {
              type: "button",
              class: "tbl-page",
              disabled: Ne.value <= 1,
              "aria-label": r(v)("table.prev"),
              title: r(v)("table.prev"),
              onClick: ge[9] || (ge[9] = (De) => ue(Ne.value - 1))
            }, "‹", 8, M5),
            i("span", D5, f(Ne.value) + " / " + f(Oe.value), 1),
            i("button", {
              type: "button",
              class: "tbl-page",
              disabled: Ne.value >= Oe.value,
              "aria-label": r(v)("table.next"),
              title: r(v)("table.next"),
              onClick: ge[10] || (ge[10] = (De) => ue(Ne.value + 1))
            }, "›", 8, P5)
          ])) : T("", !0)
        ])) : T("", !0)
      ], 16),
      (u(), nt(Hs, { to: "body" }, [
        ha.value ? (u(), d("div", {
          key: 0,
          class: Re(["fe-colmenu__backdrop", at.value]),
          dir: r(y),
          "data-prefers-dark": Je.value ? "1" : "0",
          onClick: Dt,
          onContextmenu: ft(Dt, ["prevent"])
        }, [
          i("div", {
            ref_key: "colMenuEl",
            ref: Ve,
            class: "fe-colmenu",
            role: "dialog",
            tabindex: "-1",
            "aria-label": r(v)("cols.menu"),
            style: Vt({ top: ia.value + "px", left: _a.value + "px" }),
            onClick: ge[11] || (ge[11] = ft(() => {
            }, ["stop"])),
            onKeydown: ya(ft(Dt, ["stop"]), ["esc"])
          }, [
            i("p", I5, f(r(v)("cols.title")), 1),
            (u(!0), d(he, null, We(Bt.value, (De) => (u(), d("div", {
              key: De.id,
              class: "fe-colmenu__line"
            }, [
              i("button", {
                type: "button",
                class: "fe-colmenu__row",
                role: "checkbox",
                "aria-checked": De.on ? "true" : "false",
                onClick: (lt) => V(De.id)
              }, [
                i("span", {
                  class: Re(["fe-list__check fe-colmenu__tick", { "is-on": De.on }]),
                  "aria-hidden": "true"
                }, null, 2),
                i("span", N5, f(De.label), 1)
              ], 8, R5),
              i("button", {
                type: "button",
                class: "fe-colmenu__nudge",
                disabled: !De.canEarlier,
                title: r(v)(xt.value.earlier.key, { col: De.label }),
                "aria-label": r(v)(xt.value.earlier.key, { col: De.label }),
                onClick: (lt) => ua(De.id, -1)
              }, [
                i("span", F5, f(xt.value.earlier.arrow), 1)
              ], 8, B5),
              i("button", {
                type: "button",
                class: "fe-colmenu__nudge",
                disabled: !De.canLater,
                title: r(v)(xt.value.later.key, { col: De.label }),
                "aria-label": r(v)(xt.value.later.key, { col: De.label }),
                onClick: (lt) => ua(De.id, 1)
              }, [
                i("span", H5, f(xt.value.later.arrow), 1)
              ], 8, U5)
            ]))), 128)),
            Ot.value ? (u(), d("div", K5)) : T("", !0),
            Ot.value ? (u(), d("button", {
              key: 1,
              type: "button",
              class: "fe-colmenu__row",
              onClick: oe
            }, [
              i("span", V5, f(r(v)("cols.reset")), 1)
            ])) : T("", !0),
            wa(ee.$slots, "colmenu-extra", { close: Dt })
          ], 44, L5)
        ], 42, O5)) : T("", !0)
      ]))
    ], 64));
  }
});
function G5(e, a, t, s) {
  if (!e || a !== "date" && a !== "datetime") return e;
  const n = WT(e, t);
  if (n) return n;
  const o = Date.parse(e.trim());
  return Number.isNaN(o) ? e : s(o, { time: a === "datetime" }) || e;
}
const X5 = {
  class: "fe-slist",
  "data-testid": "surface-list"
}, J5 = /* @__PURE__ */ rt({
  __name: "SurfaceList",
  props: {
    columns: {},
    rows: {},
    empty: {},
    locale: {},
    disabled: { type: Boolean },
    tableId: {}
  },
  emits: ["action"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n, formatDate: o } = gt(() => t.locale), p = x(() => t.rows ?? []), h = x(() => p.value.some((k) => (k.actions ?? []).length > 0)), v = x(() => xh(t.empty, t.locale, () => n("plugin.list.empty")));
    function y(k, _) {
      var w;
      return jt((w = k.cells) == null ? void 0 : w[_], t.locale);
    }
    const g = x(
      () => (t.columns ?? []).map((k) => {
        const _ = typeof k.width == "number" && Number.isFinite(k.width) ? Math.round(k.width) : void 0;
        return {
          id: k.key,
          label: jt(k.label, t.locale),
          width: _ === void 0 ? void 0 : Math.min(900, Math.max(60, _)),
          align: k.align,
          sortable: k.sortable !== !1,
          // A date column is printed the explorer's way, and sorted by the value.
          format: (w) => G5(y(w, k.key), k.format, t.locale, o),
          sortValue: (w) => {
            var C;
            const $ = (C = w.sort) == null ? void 0 : C[k.key];
            return typeof $ == "number" || typeof $ == "string" ? $ : y(w, k.key);
          }
        };
      })
    );
    function m(k) {
      return (k.actions ?? []).map((_) => ({
        key: _.id,
        label: jt(_.label, t.locale),
        danger: _.danger,
        disabled: t.disabled,
        testid: `surface-list-action-${k.id}-${_.id}`
      }));
    }
    return (k, _) => (u(), d("div", X5, [
      ot(ki, {
        "table-id": e.tableId,
        columns: g.value,
        rows: p.value,
        "row-key": "id",
        locale: e.locale,
        empty: v.value,
        "row-attrs": (w) => ({ "data-row": w.id }),
        "row-actions": h.value ? m : void 0,
        "row-actions-test-id": (w) => (w.actions ?? []).length ? `surface-list-actions-${w.id}` : void 0,
        onRowAction: _[0] || (_[0] = (w, $) => s("action", { action_id: w, row_id: $.id }))
      }, null, 8, ["table-id", "columns", "rows", "locale", "empty", "row-attrs", "row-actions", "row-actions-test-id"])
    ]));
  }
}), Z5 = {
  class: "fe-sprogress",
  "data-testid": "surface-progress"
}, Q5 = { class: "fe-sprogress__head" }, eD = { class: "fe-sprogress__label" }, tD = {
  key: 0,
  class: "fe-sprogress__pct"
}, aD = ["aria-label", "aria-valuenow"], nD = /* @__PURE__ */ rt({
  __name: "SurfaceProgress",
  props: {
    value: {},
    label: {},
    locale: {}
  },
  setup(e) {
    const a = e, { t } = gt(() => a.locale), s = x(() => {
      const o = a.value;
      return o == null || !Number.isFinite(Number(o)) ? null : Math.min(100, Math.max(0, Math.round(Number(o))));
    }), n = x(() => xh(a.label, a.locale, () => t("plugin.view.busy")));
    return (o, p) => (u(), d("div", Z5, [
      i("div", Q5, [
        i("span", eD, f(n.value), 1),
        s.value !== null ? (u(), d("span", tD, f(s.value) + "%", 1)) : T("", !0)
      ]),
      i("div", {
        class: Re(["fe-sprogress__track", { "is-indeterminate": s.value === null }]),
        role: "progressbar",
        "aria-label": n.value,
        "aria-valuemin": "0",
        "aria-valuemax": "100",
        "aria-valuenow": s.value === null ? void 0 : s.value
      }, [
        i("div", {
          class: "fe-sprogress__bar",
          style: Vt(s.value === null ? void 0 : { width: `${s.value}%` })
        }, null, 4)
      ], 10, aD)
    ]));
  }
}), a0 = ",،、，", sD = ";؛；", Gb = /* @__PURE__ */ new Map();
function oD(e) {
  const a = `${e.spaces ? 1 : 0}${e.semicolons ? 1 : 0}${e.newlines ? 1 : 0}`;
  let t = Gb.get(a);
  if (!t) {
    const s = a0 + (e.semicolons ? sD : "") + (e.newlines ? "\\n\\r" : "") + (e.spaces ? "\\s" : "");
    t = new RegExp(`[${s}]+`, "u"), Gb.set(a, t);
  }
  return t;
}
function Hc(e, a = {}) {
  return String(e ?? "").split(oD(a)).map((t) => t.trim()).filter((t) => t !== "");
}
function iD(e) {
  return e.length === 1 && a0.includes(e);
}
const rD = {
  key: 0,
  class: "fe-speople__chips",
  "data-testid": "surface-people-chips"
}, lD = ["title"], uD = {
  class: "fe-speople__av",
  "aria-hidden": "true"
}, cD = { class: "fe-speople__name" }, dD = ["disabled", "title", "aria-label", "data-testid", "onClick"], fD = {
  key: 1,
  class: "fe-speople__addwrap"
}, pD = ["placeholder", "disabled", "aria-invalid"], vD = ["disabled"], hD = {
  key: 1,
  class: "fe-share__suggest fe-speople__suggest",
  "data-testid": "surface-people-suggest"
}, mD = ["onMousedown"], yD = { class: "fe-share__av fe-share__av--sm" }, gD = { class: "fe-share__suggesttxt" }, bD = { class: "fe-share__suggestname" }, _D = { class: "fe-share__suggestmeta" }, kD = {
  key: 2,
  class: "fe-surface__error",
  role: "alert"
}, wD = /* @__PURE__ */ rt({
  __name: "SurfacePeoplePicker",
  props: {
    id: {},
    modelValue: {},
    multi: { type: Boolean },
    allowExternal: { type: Boolean },
    api: {},
    plugin: {},
    locale: {},
    disabled: { type: Boolean },
    invalid: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n } = gt(() => t.locale), o = b(""), p = b([]), h = b(!1), v = b(!t.api || !t.plugin), y = b("");
    let g = null, m = 0;
    const k = x(() => t.modelValue ?? []), _ = x(() => t.allowExternal === !0 || v.value), w = x(() => t.multi !== !0 && k.value.length >= 1);
    function $(F) {
      return ui({ name: F.name, email: F.email });
    }
    function C(F) {
      const W = String(F.email ?? "").trim().toLowerCase();
      if (!W) return;
      const N = t.multi === !0 ? k.value.filter((K) => K.email.toLowerCase() !== W) : [];
      s("update:modelValue", [...N, { ...F, email: W }]), o.value = "", p.value = [], h.value = !1, y.value = "";
    }
    function E(F) {
      s("update:modelValue", k.value.filter((W) => W.email !== F));
    }
    function A() {
      y.value = "";
      const F = o.value.trim();
      if (g && clearTimeout(g), !F || v.value) {
        p.value = [], h.value = !1;
        return;
      }
      g = setTimeout(() => void O(F), 180);
    }
    async function O(F) {
      if (!t.api || !t.plugin || v.value) return;
      const W = ++m;
      try {
        const N = await t.api.pluginUsers(t.plugin, F);
        if (W !== m) return;
        p.value = (N.users ?? []).filter((K) => K && typeof K.email == "string"), h.value = p.value.length > 0;
      } catch (N) {
        if (W !== m) return;
        const K = N == null ? void 0 : N.status;
        (K === 403 || K === 404) && (v.value = !0), p.value = [], h.value = !1;
      }
    }
    function z() {
      const F = o.value.trim();
      if (F) {
        if (!_.value) {
          y.value = n("plugin.people.external_off");
          return;
        }
        if (!n4(F)) {
          y.value = n("plugin.people.invalid_email");
          return;
        }
        C({ email: F });
      }
    }
    function P(F) {
      F.key === "Enter" || iD(F.key) ? (F.preventDefault(), z()) : F.key === "Backspace" && o.value === "" && k.value.length ? E(k.value[k.value.length - 1].email) : F.key === "Escape" && (h.value = !1);
    }
    function I() {
      setTimeout(() => {
        h.value = !1;
      }, 120);
    }
    return Qe(
      () => [t.api, t.plugin],
      ([F, W]) => {
        F && W && (v.value = !1);
      }
    ), Mt(() => {
      g && clearTimeout(g);
    }), (F, W) => (u(), d("div", {
      class: Re(["fe-speople", { "is-invalid": e.invalid }]),
      "data-testid": "surface-people"
    }, [
      k.value.length ? (u(), d("ul", rD, [
        (u(!0), d(he, null, We(k.value, (N) => (u(), d("li", {
          key: N.email,
          class: "fe-speople__chip",
          title: N.email
        }, [
          i("span", uD, f($(N).charAt(0).toUpperCase()), 1),
          i("span", cD, f($(N)), 1),
          i("button", {
            type: "button",
            class: "fe-speople__remove",
            disabled: e.disabled,
            title: r(n)("plugin.people.remove", { name: $(N) }),
            "aria-label": r(n)("plugin.people.remove", { name: $(N) }),
            "data-testid": `surface-people-remove-${N.email}`,
            onClick: (K) => E(N.email)
          }, [...W[1] || (W[1] = [
            i("svg", {
              class: "fe-ficon",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "aria-hidden": "true",
              focusable: "false"
            }, [
              i("path", { d: "M6 6l12 12M18 6L6 18" })
            ], -1)
          ])], 8, dD)
        ], 8, lD))), 128))
      ])) : T("", !0),
      w.value ? T("", !0) : (u(), d("div", fD, [
        dt(i("input", {
          "onUpdate:modelValue": W[0] || (W[0] = (N) => o.value = N),
          class: "fe-cfield__input fe-speople__input",
          type: "email",
          autocomplete: "off",
          spellcheck: "false",
          placeholder: v.value ? r(n)("plugin.people.placeholder_email") : r(n)("plugin.people.placeholder"),
          disabled: e.disabled,
          "aria-invalid": e.invalid ? "true" : void 0,
          "data-testid": "surface-people-input",
          onInput: A,
          onKeydown: P,
          onFocus: A,
          onBlur: I
        }, null, 40, pD), [
          [St, o.value]
        ]),
        _.value ? (u(), d("button", {
          key: 0,
          type: "button",
          class: "fe-btn fe-btn--sm",
          disabled: e.disabled || !o.value.trim(),
          "data-testid": "surface-people-add",
          onClick: z
        }, f(r(n)("plugin.people.add")), 9, vD)) : T("", !0),
        h.value ? (u(), d("ul", hD, [
          (u(!0), d(he, null, We(p.value, (N) => (u(), d("li", {
            key: N.user_id ?? N.email,
            onMousedown: ft((K) => C(N), ["prevent"])
          }, [
            i("span", yD, f($(N).charAt(0).toUpperCase()), 1),
            i("span", gD, [
              i("span", bD, f($(N)), 1),
              i("span", _D, f(N.email), 1)
            ])
          ], 40, mD))), 128))
        ])) : T("", !0)
      ])),
      y.value ? (u(), d("p", kD, f(y.value), 1)) : T("", !0)
    ], 2));
  }
}), xD = {
  class: "fe-spin",
  "data-testid": "surface-pin"
}, $D = ["for"], SD = ["id", "maxlength", "size", "value", "disabled", "aria-invalid"], TD = /* @__PURE__ */ rt({
  __name: "SurfacePinInput",
  props: {
    id: {},
    length: {},
    modelValue: {},
    locale: {},
    disabled: { type: Boolean },
    invalid: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n } = gt(() => t.locale), o = x(() => a4(t.length));
    function p(h) {
      const v = h.target.value.replace(/\s+/g, "").slice(0, o.value);
      h.target.value = v, s("update:modelValue", v);
    }
    return (h, v) => (u(), d("div", xD, [
      i("label", {
        class: "fe-cfield__label",
        for: `fe-spin-${e.id}`
      }, f(r(n)("plugin.pin.label")), 9, $D),
      i("input", {
        id: `fe-spin-${e.id}`,
        class: Re(["fe-cfield__input fe-cfield__input--mono fe-spin__input", { "is-invalid": e.invalid }]),
        type: "text",
        inputmode: "numeric",
        autocomplete: "one-time-code",
        spellcheck: "false",
        maxlength: o.value,
        size: o.value,
        value: e.modelValue,
        disabled: e.disabled,
        "aria-invalid": e.invalid ? "true" : void 0,
        style: Vt({ "--spin-len": o.value }),
        onInput: p
      }, null, 46, SD)
    ]));
  }
}), ja = "@@drives";
function ci(e) {
  const a = e.indexOf("://");
  return a < 0 ? ["", Kv(e)] : [e.slice(0, a), Kv(e.slice(a + 3))];
}
function Nr(e, a) {
  const t = Kv(a);
  return t ? `${e}://${t}` : `${e}://`;
}
function Kv(e) {
  return e.replace(/^\/+|\/+$/g, "");
}
function n0(e, a) {
  if (e === ja) return null;
  const [t, s] = ci(e);
  if (!t) return null;
  if (!s) return a ? ja : null;
  const n = s.split("/");
  return n.pop(), Nr(t, n.join("/"));
}
function Sr(e, a) {
  if (e === ja) return a;
  const [t, s] = ci(e);
  if (!s) return t || a;
  const n = s.split("/");
  return n[n.length - 1] || t;
}
function s0(e) {
  if (e === ja || !e) return [];
  const [a, t] = ci(e);
  if (!a) return [];
  const s = [{ label: a, path: Nr(a, "") }];
  if (!t) return s;
  let n = "";
  for (const o of t.split("/"))
    n = n ? `${n}/${o}` : o, s.push({ label: o, path: Nr(a, n) });
  return s;
}
function em(e) {
  return e == null || e === "" || e === "editor" || e === "owner";
}
function CD(e, a) {
  if (e === ja || a === ja) return !1;
  const [t, s] = ci(e), [n, o] = ci(a);
  return t !== n ? !1 : o === "" ? !0 : s === o || s.startsWith(o + "/");
}
function tm(e, a) {
  if (!a || a.length === 0 || e === ja) return null;
  const t = (n) => {
    const [o, p] = ci(n);
    return Nr(o, p);
  }, s = t(e);
  for (const n of a)
    if (n) {
      if (s === t(n)) return "self";
      if (CD(e, n)) return "descendant";
    }
  return null;
}
function ED(e, a, t = {}) {
  const s = [];
  for (const n of e ?? []) {
    if (n.type !== "dir") {
      t.files && n.type === "file" && s.push({ path: n.path, label: n.basename, writable: !0, blocked: null, kind: "file" });
      continue;
    }
    s.push({
      path: n.path,
      label: n.basename,
      writable: em(n.perm),
      blocked: tm(n.path, a),
      kind: "dir"
    });
  }
  return s;
}
function AD(e, a) {
  return (e ?? []).map((t) => {
    const s = Nr(t, "");
    return {
      path: s,
      label: t,
      // A storage root's own writability is not knowable from the drive list;
      // it is answered by the listing when the user opens it. Offering it as
      // writable here and letting the listing correct that is the honest
      // order — the alternative greys out every drive until each is opened.
      writable: !0,
      blocked: tm(s, a),
      kind: "dir"
    };
  });
}
function zD(e, a) {
  const t = ((a == null ? void 0 : a.length) ?? 0) > 1;
  if (e && e.includes("://")) return e;
  if (t) return ja;
  const s = a == null ? void 0 : a[0];
  return s ? Nr(s, "") : ja;
}
const ou = [];
function MD(e) {
  ou.push(e);
}
function DD(e) {
  const a = ou.lastIndexOf(e);
  a >= 0 && ou.splice(a, 1);
}
function Xb(e) {
  return ou[ou.length - 1] === e;
}
const PD = ["aria-labelledby", "aria-label", "aria-busy"], OD = {
  key: 0,
  class: "fe-modal__head"
}, LD = ["aria-label", "disabled"], ID = { class: "fe-modal__body" }, RD = {
  key: 1,
  class: "fe-modal__ask",
  role: "alert",
  "data-testid": "modal-busy-close"
}, ND = { class: "fe-modal__ask-text" }, BD = { class: "fe-modal__ask-actions" }, FD = {
  key: 2,
  class: "fe-modal__actions"
}, Pp = 'input:not([disabled]),select:not([disabled]),textarea:not([disabled]),button:not([disabled]),a[href],[tabindex]:not([tabindex="-1"])', la = /* @__PURE__ */ rt({
  __name: "Modal",
  props: {
    locale: {},
    open: { type: Boolean },
    title: {},
    size: {},
    closeOnBackdrop: { type: Boolean, default: !0 },
    chromeless: { type: Boolean },
    fullbleed: { type: Boolean },
    theme: {},
    busy: { type: Boolean },
    busyClose: { default: null },
    bare: { type: Boolean },
    labelledby: {}
  },
  emits: ["close"],
  setup(e, { emit: a }) {
    const t = e, s = hi() ? On(Yk, void 0) : void 0, { t: n } = gt(() => t.locale ?? (s == null ? void 0 : s()) ?? "en"), o = a, p = b(null);
    let h = 0;
    const v = `fe-modal-title-${++h}-${Math.random().toString(36).slice(2, 7)}`;
    let y = null, g = null;
    const m = Symbol("fe-modal");
    let k = !1, _;
    function w() {
      const N = p.value;
      if (!N) return;
      const K = N.querySelector("[data-fe-autofocus]");
      if (K) {
        K.focus();
        return;
      }
      const M = (U) => {
        var de;
        return ((de = N.querySelector(U)) == null ? void 0 : de.querySelector(Pp)) ?? null;
      }, j = M(".fe-modal__body") ?? M(".fe-modal__actions") ?? N.querySelector(Pp);
      j == null || j.focus();
    }
    function $() {
      k || (k = !0, y = document.activeElement ?? null, g = null, MD(m), document.addEventListener("keydown", P), _ = setTimeout(() => {
        var N;
        if (_ = void 0, !(typeof document > "u") && k && Xb(m) && !((N = p.value) != null && N.contains(document.activeElement))) {
          const K = document.activeElement;
          g = K && K !== document.body && K !== y ? K : null, w();
        }
      }, 30));
    }
    function C() {
      var K;
      if (!k) return;
      k = !1, _ !== void 0 && (clearTimeout(_), _ = void 0), document.removeEventListener("keydown", P), DD(m);
      const N = y != null && y.isConnected ? y : g != null && g.isConnected ? g : y;
      (K = N == null ? void 0 : N.focus) == null || K.call(N), y = null, g = null;
    }
    Qe(
      () => t.open,
      (N) => N ? $() : C(),
      { immediate: !0 }
    ), Mt(C);
    const E = b(!1), A = b(null);
    Qe(
      () => [t.busy, t.open],
      ([N, K]) => {
        (!N || !K) && (E.value = !1);
      }
    );
    function O() {
      if (!t.busy) {
        o("close");
        return;
      }
      t.busyClose && (E.value = !0, Jt(() => {
        var N;
        return (N = A.value) == null ? void 0 : N.focus();
      }));
    }
    function z() {
      E.value = !1, o("close");
    }
    function P(N) {
      if (Xb(m)) {
        if (N.key === "Escape") {
          if (t.chromeless) return;
          if (E.value) {
            E.value = !1;
            return;
          }
          if (t.busy) return;
          o("close");
          return;
        }
        if (N.key === "Tab" && p.value) {
          const K = Array.from(p.value.querySelectorAll(Pp)).filter(
            (de) => de.offsetParent !== null || de === document.activeElement
          );
          if (K.length === 0) return;
          const M = K[0], j = K[K.length - 1], U = document.activeElement;
          N.shiftKey && (U === M || !p.value.contains(U)) ? (N.preventDefault(), j.focus()) : !N.shiftKey && (U === j || !p.value.contains(U)) && (N.preventDefault(), M.focus());
        }
      }
    }
    let I = !1;
    function F(N) {
      I = N.target === N.currentTarget;
    }
    function W(N) {
      const K = I;
      I = !1, !(!t.closeOnBackdrop || t.chromeless || t.busy) && (N.target !== N.currentTarget || !K || o("close"));
    }
    return (N, K) => (u(), nt(us, { name: "fe-modal" }, {
      default: yt(() => [
        e.open ? (u(), d("div", {
          key: 0,
          class: Re(["fe fe-modal__backdrop", [
            { "fe-modal__backdrop--chromeless": e.chromeless },
            { "fe-modal__backdrop--fullbleed": e.fullbleed && !e.chromeless },
            e.theme === "light" ? "fe--theme-light" : "",
            e.theme === "dark" ? "fe--theme-dark" : ""
          ]]),
          role: "presentation",
          onPointerdown: F,
          onClick: W
        }, [
          i("div", {
            ref_key: "cardEl",
            ref: p,
            class: Re(["fe-modal__card", [
              e.bare ? "fe-modal__card--bare" : `fe-modal__card--${e.size || "md"}`,
              e.chromeless && "fe-modal__card--chromeless",
              e.fullbleed && !e.chromeless && "fe-modal__card--fullbleed"
            ]]),
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": e.labelledby || (e.title && !e.chromeless && !e.fullbleed && !e.bare ? v : void 0),
            "aria-label": e.labelledby ? void 0 : (!e.title || e.chromeless || e.fullbleed || e.bare) && e.title || void 0,
            "aria-busy": e.busy ? "true" : void 0,
            onClick: K[1] || (K[1] = ft(() => {
            }, ["stop"]))
          }, [
            e.title && !e.chromeless && !e.fullbleed && !e.bare ? (u(), d("header", OD, [
              i("h2", {
                id: v,
                class: "fe-modal__title"
              }, f(e.title), 1),
              i("button", {
                type: "button",
                class: "fe-modal__close",
                "aria-label": r(n)("modal.close"),
                disabled: e.busy && !e.busyClose,
                onClick: O
              }, "×", 8, LD)
            ])) : T("", !0),
            i("div", ID, [
              wa(N.$slots, "default")
            ]),
            E.value && e.busyClose ? (u(), d("div", RD, [
              i("p", ND, f(e.busyClose.question), 1),
              i("div", BD, [
                i("button", {
                  ref_key: "keepEl",
                  ref: A,
                  type: "button",
                  class: "fe-btn",
                  "data-testid": "modal-busy-close-keep",
                  onClick: K[0] || (K[0] = (M) => E.value = !1)
                }, f(r(n)("modal.busy_close.keep")), 513),
                i("button", {
                  type: "button",
                  class: "fe-btn fe-btn--danger",
                  "data-testid": "modal-busy-close-confirm",
                  onClick: z
                }, f(e.busyClose.confirm || r(n)("modal.busy_close.confirm")), 1)
              ])
            ])) : T("", !0),
            N.$slots.actions && !e.chromeless && !e.fullbleed && !e.bare ? (u(), d("footer", FD, [
              wa(N.$slots, "actions")
            ])) : T("", !0)
          ], 10, PD)
        ], 34)) : T("", !0)
      ]),
      _: 3
    }));
  }
}), UD = {
  class: "fe-destpick",
  "data-testid": "destpicker"
}, HD = { class: "fe-destpick__bar" }, KD = ["disabled", "title", "aria-label"], VD = ["aria-label"], qD = ["onClick"], jD = {
  key: 1,
  class: "fe-destpick__crumb is-current"
}, WD = {
  class: "fe-destpick__rows",
  "data-testid": "destpicker-rows"
}, YD = {
  key: 0,
  class: "fe-destpick__note"
}, GD = {
  key: 1,
  class: "fe-destpick__note"
}, XD = {
  key: 2,
  class: "fe-destpick__note"
}, JD = ["disabled", "title", "aria-pressed", "data-testid", "onClick"], ZD = ["innerHTML"], QD = { class: "fe-destpick__rowname" }, e8 = {
  key: 0,
  class: "fe-destpick__rowtag"
}, t8 = {
  key: 1,
  class: "fe-destpick__rowtag"
}, a8 = {
  key: 2,
  class: "fe-destpick__rowinto",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}, n8 = {
  key: 1,
  class: "fe-destpick__target",
  "data-testid": "destpicker-target"
}, s8 = ["disabled"], am = /* @__PURE__ */ rt({
  __name: "DestinationPickerModal",
  props: {
    open: { type: Boolean },
    api: {},
    locale: {},
    storages: {},
    startAt: {},
    moving: {},
    mode: {},
    pick: {},
    busy: { type: Boolean }
  },
  emits: ["close", "pick"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n } = gt(() => t.locale), o = b(ja), p = b([]), h = b(!1), v = b(void 0), y = b(!1), g = x(() => {
      var ie;
      return (((ie = t.storages) == null ? void 0 : ie.length) ?? 0) > 1;
    }), m = x(() => n("destpicker.drives")), k = x(() => t.pick === "file"), _ = b(null);
    let w = /* @__PURE__ */ new Map();
    Qe(
      () => t.open,
      (ie) => {
        ie && (w = /* @__PURE__ */ new Map(), E(zD(t.startAt, t.storages)));
      },
      { immediate: !0 }
    );
    const $ = On(Su, null);
    async function C(ie) {
      const ce = w.get(ie);
      if (ce) return ce;
      try {
        let X = await t.api.index(ie);
        if ($) {
          const Z = typeof X.e2e_root == "string" && X.e2e_root ? X.e2e_root : null;
          X = { ...X, files: await $.decorate(X.files ?? [], { root: Z }) };
        }
        return w.set(ie, X), X;
      } catch {
        return;
      }
    }
    async function E(ie) {
      if (o.value = ie, y.value = !1, _.value = null, ie === ja) {
        v.value = void 0, p.value = AD(t.storages, t.moving);
        return;
      }
      h.value = !0;
      const ce = await C(ie);
      o.value === ie && (h.value = !1, v.value = ce, y.value = !ce, p.value = ED(ce == null ? void 0 : ce.files, t.moving, { files: k.value }));
    }
    const A = x(() => n0(o.value, g.value)), O = x(
      () => s0(o.value).map((ie) => ({ ...ie, label: ($ == null ? void 0 : $.segmentLabel(ie.path)) ?? ie.label }))
    ), z = x(() => tm(o.value, t.moving)), P = x(() => o.value === ja || !v.value || v.value.read_only ? !1 : em(v.value.perm)), I = x(() => t.busy || o.value === ja ? !1 : k.value ? _.value !== null : P.value && z.value === null), F = x(() => o.value !== ja && !(k.value && !y.value)), W = x(() => o.value === ja ? n("destpicker.pick_a_drive") : k.value ? y.value ? n("destpicker.unreadable") : _.value === null ? n("destpicker.pick_a_file") : "" : z.value === "self" ? n("destpicker.blocked.self") : z.value === "descendant" ? n("destpicker.blocked.descendant") : y.value ? n("destpicker.unreadable") : v.value && !P.value ? n("destpicker.readonly_here") : ""), N = x(() => t.mode === "move" ? n("destpicker.title.move") : t.mode === "copy" ? n("destpicker.title.copy") : k.value ? n("destpicker.title.choose_file") : n("destpicker.title.choose")), K = x(() => t.mode === "move" ? n("destpicker.confirm.move") : t.mode === "copy" ? n("destpicker.confirm.copy") : k.value ? n("destpicker.confirm.choose_file") : n("destpicker.confirm.choose")), M = x(
      () => k.value && _.value !== null ? Sr(_.value, m.value) : Sr(o.value, m.value)
    );
    function j(ie) {
      return ie.kind === "file" ? sn({ type: "file", basename: ie.label }) : Sh("folder");
    }
    function U(ie) {
      return ie.kind === "file" ? ie.label : ie.blocked === "self" ? n("destpicker.blocked.self") : ie.blocked === "descendant" ? n("destpicker.blocked.descendant") : ie.writable ? ie.label : n("destpicker.readonly");
    }
    function de(ie) {
      if (ie.kind === "file") {
        _.value = ie.path;
        return;
      }
      ie.blocked || E(ie.path);
    }
    function ke() {
      I.value && s("pick", k.value && _.value !== null ? _.value : o.value);
    }
    return (ie, ce) => (u(), nt(la, {
      open: e.open,
      title: N.value,
      size: "md",
      busy: e.busy,
      onClose: ce[3] || (ce[3] = (X) => s("close"))
    }, {
      actions: yt(() => [
        i("button", {
          type: "button",
          class: "fe-btn",
          onClick: ce[2] || (ce[2] = (X) => s("close"))
        }, f(r(n)("destpicker.cancel")), 1),
        i("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: !I.value,
          "data-testid": "destpicker-confirm",
          onClick: ke
        }, f(K.value), 9, s8)
      ]),
      default: yt(() => [
        i("div", UD, [
          i("div", HD, [
            i("button", {
              type: "button",
              class: "fe-destpick__up",
              disabled: !A.value,
              title: r(n)("destpicker.up"),
              "aria-label": r(n)("destpicker.up"),
              "data-testid": "destpicker-up",
              onClick: ce[0] || (ce[0] = (X) => E(A.value))
            }, [...ce[4] || (ce[4] = [
              i("svg", {
                class: "fe-ficon",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "aria-hidden": "true",
                focusable: "false"
              }, [
                i("path", { d: "M12 19V5M5 12l7-7 7 7" })
              ], -1)
            ])], 8, KD),
            i("nav", {
              class: "fe-destpick__crumbs",
              "aria-label": r(n)("destpicker.crumbs")
            }, [
              g.value ? (u(), d("button", {
                key: 0,
                type: "button",
                class: Re(["fe-destpick__crumb", { "is-current": o.value === r(ja) }]),
                onClick: ce[1] || (ce[1] = (X) => E(r(ja)))
              }, f(m.value), 3)) : T("", !0),
              (u(!0), d(he, null, We(O.value, (X) => (u(), d(he, {
                key: X.path
              }, [
                ce[5] || (ce[5] = i("span", {
                  class: "fe-destpick__sep",
                  "aria-hidden": "true"
                }, "/", -1)),
                i("button", {
                  type: "button",
                  class: Re(["fe-destpick__crumb", { "is-current": X.path === o.value }]),
                  onClick: (Z) => E(X.path)
                }, f(X.label), 11, qD)
              ], 64))), 128)),
              !g.value && !O.value.length ? (u(), d("span", jD, f(r(Sr)(o.value, m.value)), 1)) : T("", !0)
            ], 8, VD)
          ]),
          i("ul", WD, [
            h.value ? (u(), d("li", YD, f(r(n)("destpicker.loading")), 1)) : y.value ? (u(), d("li", GD, f(r(n)("destpicker.unreadable")), 1)) : p.value.length ? T("", !0) : (u(), d("li", XD, f(k.value ? r(n)("destpicker.empty_files") : r(n)("destpicker.empty")), 1)),
            (u(!0), d(he, null, We(p.value, (X) => (u(), d("li", {
              key: X.path
            }, [
              i("button", {
                type: "button",
                class: Re(["fe-destpick__row", {
                  "is-locked": !X.writable,
                  "is-blocked": !!X.blocked,
                  "is-file": X.kind === "file",
                  "is-picked": X.kind === "file" && _.value === X.path
                }]),
                disabled: !!X.blocked,
                title: U(X),
                "aria-pressed": X.kind === "file" ? _.value === X.path : void 0,
                "data-testid": "destpicker-row-" + X.label,
                onClick: (Z) => de(X)
              }, [
                i("span", {
                  class: "fe-destpick__rowicon",
                  "aria-hidden": "true",
                  innerHTML: j(X)
                }, null, 8, ZD),
                i("span", QD, [
                  i("bdi", null, f(X.label), 1)
                ]),
                X.blocked ? (u(), d("span", e8, f(r(n)("destpicker.tag.blocked")), 1)) : X.writable ? T("", !0) : (u(), d("span", t8, f(r(n)("destpicker.readonly")), 1)),
                X.kind === "dir" ? (u(), d("svg", a8, [...ce[6] || (ce[6] = [
                  i("path", { d: "M9 5l7 7-7 7" }, null, -1)
                ])])) : T("", !0)
              ], 10, JD)
            ]))), 128))
          ]),
          W.value ? (u(), d("p", {
            key: 0,
            class: Re(["fe-destpick__reason", { "is-hint": !F.value }]),
            "data-testid": "destpicker-reason"
          }, f(W.value), 3)) : (u(), d("p", n8, f(r(n)("destpicker.target", { name: M.value })), 1))
        ])
      ]),
      _: 1
    }, 8, ["open", "title", "busy"]));
  }
}), o8 = ["title"], i8 = ["disabled"], r8 = ["disabled"], l8 = /* @__PURE__ */ rt({
  __name: "SurfaceFileChooser",
  props: {
    id: {},
    kind: {},
    modelValue: {},
    locale: {},
    theme: {},
    api: {},
    storages: {},
    startAt: {},
    disabled: { type: Boolean },
    invalid: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n } = gt(() => t.locale), o = b(!1), p = x(() => t.kind === "dir" ? "dir" : "file"), h = x(() => t.modelValue ? Sr(t.modelValue, "") || t.modelValue : ""), v = x(() => t.modelValue ? p.value === "dir" ? t.modelValue : n0(t.modelValue, !1) ?? t.modelValue : t.startAt);
    function y(g) {
      o.value = !1, s("update:modelValue", g);
    }
    return (g, m) => (u(), d("div", {
      class: Re(["fe-sfile", { "is-invalid": e.invalid }]),
      "data-testid": "surface-file-chooser"
    }, [
      i("span", {
        class: Re(["fe-sfile__value", { "fe-sfile__value--empty": !e.modelValue }]),
        title: e.modelValue || void 0,
        "data-testid": "surface-file-chooser-value"
      }, f(h.value || r(n)("plugin.file.none")), 11, o8),
      i("button", {
        type: "button",
        class: "fe-btn fe-btn--sm",
        disabled: e.disabled || !e.api,
        "data-testid": "surface-file-chooser-open",
        onClick: m[0] || (m[0] = (k) => o.value = !0)
      }, f(r(n)("plugin.file.choose")), 9, i8),
      e.modelValue ? (u(), d("button", {
        key: 0,
        type: "button",
        class: "fe-btn fe-btn--sm",
        disabled: e.disabled,
        "data-testid": "surface-file-chooser-clear",
        onClick: m[1] || (m[1] = (k) => s("update:modelValue", ""))
      }, f(r(n)("plugin.file.clear")), 9, r8)) : T("", !0),
      e.api ? (u(), nt(am, {
        key: 1,
        open: o.value,
        api: e.api,
        locale: e.locale,
        mode: "choose",
        pick: p.value,
        storages: e.storages,
        "start-at": v.value,
        onClose: m[2] || (m[2] = (k) => o.value = !1),
        onPick: y
      }, null, 8, ["open", "api", "locale", "pick", "storages", "start-at"])) : T("", !0)
    ], 2));
  }
}), u8 = ["data-state"], c8 = {
  key: 0,
  class: "fe-surface__text fe-surface__text--muted"
}, d8 = {
  key: 1,
  class: "fe-surface__text fe-surface__text--muted"
}, f8 = ["src", "alt"], p8 = ["src"], v8 = ["src"], h8 = ["src", "type"], m8 = ["innerHTML"], y8 = ["title"], g8 = /* @__PURE__ */ rt({
  __name: "SurfacePreview",
  props: {
    path: {},
    fileRef: {},
    fileUrl: { type: Function },
    locale: {},
    api: {}
  },
  setup(e) {
    const a = e, { t } = gt(() => a.locale), s = b(null), n = b(""), o = b("loading");
    let p = 0;
    const h = x(() => a.fileRef && a.fileUrl ? a.fileUrl(a.fileRef) : null), v = x(() => {
      var _;
      return ((_ = h.value) == null ? void 0 : _.name) || Sr(a.path, "") || a.path || a.fileRef || "";
    }), y = x(() => {
      const _ = n.value;
      return _.startsWith("image/") ? "image" : _.startsWith("video/") ? "video" : _.startsWith("audio/") ? "audio" : "other";
    }), g = x(() => sn({ type: "file", basename: v.value }));
    function m() {
      s.value && s.value.startsWith("blob:") && URL.revokeObjectURL(s.value), s.value = null;
    }
    async function k() {
      const _ = ++p;
      if (m(), n.value = "", a.fileRef) {
        if (!h.value) {
          o.value = "error";
          return;
        }
        s.value = h.value.url, n.value = h.value.mime || "", o.value = "ok";
        return;
      }
      if (!a.api || !a.path) {
        o.value = "error";
        return;
      }
      o.value = "loading";
      try {
        const w = await a.api.fetchBlob(a.path);
        if (_ !== p) {
          URL.revokeObjectURL(w.url);
          return;
        }
        s.value = w.url, n.value = w.mime || "", o.value = "ok";
      } catch {
        if (_ !== p) return;
        o.value = "error";
      }
    }
    return Qe([() => a.path, () => a.fileRef], () => void k(), { immediate: !0 }), Mt(() => {
      p++, m();
    }), (_, w) => (u(), d("figure", {
      class: "fe-spreview",
      "data-testid": "surface-preview",
      "data-state": o.value
    }, [
      o.value === "loading" ? (u(), d("p", c8, f(r(t)("plugin.view.loading")), 1)) : o.value === "error" ? (u(), d("p", d8, f(r(t)("plugin.view.preview_failed")), 1)) : (u(), d(he, { key: 2 }, [
        y.value === "image" && s.value ? (u(), d("img", {
          key: 0,
          class: "fe-spreview__media",
          src: s.value,
          alt: v.value
        }, null, 8, f8)) : y.value === "video" && s.value ? (u(), d("video", {
          key: 1,
          class: "fe-spreview__media",
          src: s.value,
          controls: "",
          preload: "metadata"
        }, null, 8, p8)) : y.value === "audio" && s.value ? (u(), d("audio", {
          key: 2,
          class: "fe-spreview__audio",
          src: s.value,
          controls: "",
          preload: "metadata"
        }, null, 8, v8)) : e.fileRef && s.value ? (u(), d("embed", {
          key: 3,
          class: "fe-spreview__media fe-spreview__embed",
          src: s.value,
          type: n.value || void 0
        }, null, 8, h8)) : (u(), d("span", {
          key: 4,
          class: "fe-spreview__tile",
          "aria-hidden": "true",
          innerHTML: g.value
        }, null, 8, m8))
      ], 64)),
      i("figcaption", {
        class: "fe-spreview__name",
        title: e.path
      }, f(v.value), 9, y8)
    ], 8, u8));
  }
}), b8 = ["data-mode", "role", "aria-labelledby"], _8 = ["id"], k8 = {
  key: 0,
  class: "fe-cfield__req",
  "aria-hidden": "true"
}, w8 = {
  key: 1,
  class: "fe-ssig__modes",
  role: "tablist"
}, x8 = ["aria-selected", "disabled", "data-testid", "onClick"], $8 = ["aria-label"], S8 = {
  key: 0,
  class: "fe-ssig__hint"
}, T8 = {
  key: 3,
  class: "fe-ssig__typewrap"
}, C8 = ["id", "placeholder", "disabled", "value"], E8 = ["aria-label"], A8 = ["disabled", "title", "aria-pressed", "data-testid", "onClick"], z8 = ["src"], M8 = {
  key: 4,
  class: "fe-ssig__uploadwrap"
}, D8 = { class: "fe-btn fe-btn--sm fe-ssig__pick" }, P8 = ["disabled"], O8 = { class: "fe-ssig__hint" }, L8 = {
  key: 0,
  class: "fe-surface__error",
  role: "alert"
}, I8 = ["src"], R8 = { class: "fe-ssig__foot" }, N8 = ["disabled"], B8 = {
  key: 0,
  class: "fe-ssig__signed"
}, o0 = /* @__PURE__ */ rt({
  __name: "SurfaceSignaturePad",
  props: {
    id: {},
    modes: {},
    width: {},
    height: {},
    modelValue: {},
    locale: {},
    disabled: { type: Boolean },
    invalid: { type: Boolean },
    font: {},
    fonts: {},
    label: {},
    required: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n } = gt(() => t.locale), o = x(() => d4(t.modes)), p = x(() => p4(t.width, t.height)), h = b(Nl(t.modelValue) && o.value.includes(t.modelValue.mode) ? t.modelValue.mode : o.value[0]), v = x(() => {
      const Z = Array.isArray(t.fonts) ? t.fonts.filter(su) : [];
      return Z.length ? Rr.filter((Y) => Z.includes(Y.key)) : Rr;
    });
    function y() {
      const Z = v.value.map((G) => G.key), Y = Nl(t.modelValue) ? f4(t.modelValue) : void 0;
      return Y && Z.includes(Y) ? Y : su(t.font) && Z.includes(t.font) ? t.font : Z.includes(Hv) ? Hv : Z[0];
    }
    const g = b(null), m = b(""), k = b(y()), _ = b(""), w = b(""), $ = x(() => Nl(t.modelValue)), C = x(() => Nl(t.modelValue) ? `data:image/png;base64,${t.modelValue.png_b64}` : "");
    function E(Z) {
      if (!Z) return null;
      try {
        return Z.getContext("2d");
      } catch {
        return null;
      }
    }
    function A() {
      return typeof window < "u" && window.devicePixelRatio > 0 ? Math.min(3, window.devicePixelRatio) : 1;
    }
    function O() {
      const Z = g.value;
      if (!Z) return;
      const Y = A();
      Z.width = Math.round(p.value.width * Y), Z.height = Math.round(p.value.height * Y);
      const G = E(Z);
      G && (G.setTransform(1, 0, 0, 1, 0, 0), G.clearRect(0, 0, Z.width, Z.height), G.scale(Y, Y), G.lineWidth = 2.2, G.lineCap = "round", G.lineJoin = "round", G.strokeStyle = Wb);
    }
    let z = !1, P = null;
    function I(Z) {
      const Y = g.value, G = Y == null ? void 0 : Y.getBoundingClientRect();
      if (!Y || !G || !G.width) return { x: Z.clientX, y: Z.clientY };
      const we = p.value.width / G.width, R = p.value.height / G.height;
      return { x: (Z.clientX - G.left) * we, y: (Z.clientY - G.top) * R };
    }
    function F(Z) {
      var G, we, R;
      if (t.disabled) return;
      const Y = E(g.value);
      if (Y) {
        z = !0, P = I(Z);
        try {
          (we = (G = Z.target).setPointerCapture) == null || we.call(G, Z.pointerId);
        } catch {
        }
        Y.beginPath(), Y.moveTo(P.x, P.y), Y.lineTo(P.x + 0.1, P.y + 0.1), Y.stroke(), (R = Z.preventDefault) == null || R.call(Z);
      }
    }
    function W(Z) {
      var we;
      if (!z || !P) return;
      const Y = E(g.value);
      if (!Y) return;
      const G = I(Z);
      Y.beginPath(), Y.moveTo(P.x, P.y), Y.lineTo(G.x, G.y), Y.stroke(), P = G, (we = Z.preventDefault) == null || we.call(Z);
    }
    function N() {
      z && (z = !1, P = null, K(g.value, "draw"));
    }
    function K(Z, Y) {
      if (!Z) return;
      let G = "";
      try {
        G = Z.toDataURL("image/png");
      } catch {
        G = "";
      }
      const we = h4(G);
      we && (Y !== "draw" && (w.value = G), s("update:modelValue", Y === "type" ? { png_b64: we, mode: Y, font: k.value } : { png_b64: we, mode: Y }));
    }
    async function M(Z, Y) {
      const G = document.fonts;
      if (!(!G || typeof G.load != "function"))
        try {
          await G.load(`${Z}px ${Y}`, "Aa");
        } catch {
        }
    }
    async function j() {
      const Z = m.value.trim();
      if (!Z) {
        w.value = "", s("update:modelValue", null);
        return;
      }
      const Y = F1(k.value).stack;
      if (await M(Math.round(p.value.height * 0.6), Y), m.value.trim() !== Z) return;
      const G = document.createElement("canvas"), we = 2, { width: R, height: pe } = p.value;
      G.width = R * we, G.height = pe * we;
      const Q = E(G);
      if (!Q) return;
      Q.scale(we, we), Q.fillStyle = Wb, Q.textBaseline = "middle";
      const q = y4(
        (re) => (Q.font = `${re}px ${Y}`, Q.measureText(Z).width),
        R - 24,
        pe
      );
      Q.font = `${q}px ${Y}`, Q.fillText(Z, 12, pe / 2), K(G, "type");
    }
    function U(Z) {
      t.disabled || Z === k.value || (k.value = Z, m.value.trim() && j());
    }
    const de = b(null);
    function ke(Z) {
      var Q;
      const Y = Z.target, G = (Q = Y.files) == null ? void 0 : Q[0];
      if (Y.value = "", !G) return;
      const we = m4(G);
      if (we !== "ok") {
        _.value = we;
        return;
      }
      _.value = "";
      const R = URL.createObjectURL(G), pe = new Image();
      pe.onload = () => {
        URL.revokeObjectURL(R);
        const q = v4(pe.naturalWidth, pe.naturalHeight, J1, Z1), re = document.createElement("canvas");
        re.width = q.width, re.height = q.height;
        const ae = E(re);
        ae && (ae.drawImage(pe, 0, 0, q.width, q.height), K(re, "upload"));
      }, pe.onerror = () => {
        URL.revokeObjectURL(R), _.value = "unreadable";
      }, pe.src = R;
    }
    function ie() {
      m.value = "", w.value = "", _.value = "", O(), s("update:modelValue", null);
    }
    function ce(Z) {
      Z !== h.value && (h.value = Z);
    }
    Qe(h, async (Z) => {
      Z === "draw" && (await Jt(), O());
    }), Qe(p, () => {
      h.value === "draw" && O();
    }), Kt(() => {
      h.value === "draw" && O();
    }), Mt(() => {
      z = !1;
    });
    const X = x(() => {
      switch (_.value) {
        case "too_big":
          return n("plugin.sig.upload_too_big", { kb: 200 });
        case "bad_type":
          return n("plugin.sig.upload_bad_type");
        case "unreadable":
          return n("plugin.sig.upload_unreadable");
        default:
          return "";
      }
    });
    return (Z, Y) => (u(), d("div", {
      class: Re(["fe-ssig", { "is-invalid": e.invalid, "is-disabled": e.disabled }]),
      "data-testid": "surface-signature",
      "data-mode": h.value,
      role: e.label ? "group" : void 0,
      "aria-labelledby": e.label ? `fe-ssig-${e.id}-lbl` : void 0
    }, [
      e.label ? (u(), d("span", {
        key: 0,
        id: `fe-ssig-${e.id}-lbl`,
        class: "fe-cfield__label",
        "data-testid": "surface-signature-label"
      }, [
        $t(f(e.label), 1),
        e.required ? (u(), d("span", k8, "*")) : T("", !0)
      ], 8, _8)) : T("", !0),
      o.value.length > 1 ? (u(), d("div", w8, [
        (u(!0), d(he, null, We(o.value, (G) => (u(), d("button", {
          key: G,
          type: "button",
          class: Re(["fe-btn fe-btn--sm", { "fe-btn--primary": G === h.value }]),
          role: "tab",
          "aria-selected": G === h.value ? "true" : "false",
          disabled: e.disabled,
          "data-testid": `surface-signature-mode-${G}`,
          onClick: (we) => ce(G)
        }, f(r(n)(`plugin.sig.mode_${G}`)), 11, x8))), 128))
      ])) : T("", !0),
      h.value === "draw" ? (u(), d("div", {
        key: 2,
        class: "fe-ssig__padwrap",
        style: Vt({ maxWidth: `${p.value.width}px` })
      }, [
        i("canvas", {
          ref_key: "canvas",
          ref: g,
          class: "fe-ssig__canvas",
          style: Vt({ aspectRatio: `${p.value.width} / ${p.value.height}` }),
          "aria-label": r(n)("plugin.sig.draw_hint"),
          "data-testid": "surface-signature-canvas",
          onPointerdown: F,
          onPointermove: W,
          onPointerup: N,
          onPointercancel: N,
          onPointerleave: N
        }, null, 44, $8),
        $.value ? T("", !0) : (u(), d("p", S8, f(r(n)("plugin.sig.draw_hint")), 1))
      ], 4)) : h.value === "type" ? (u(), d("div", T8, [
        i("input", {
          id: `fe-ssig-${e.id}`,
          class: "fe-cfield__input fe-ssig__typed",
          type: "text",
          placeholder: r(n)("plugin.sig.type_placeholder"),
          disabled: e.disabled,
          value: m.value,
          autocomplete: "name",
          "data-testid": "surface-signature-typed",
          onInput: Y[0] || (Y[0] = (G) => {
            m.value = G.target.value, j();
          })
        }, null, 40, C8),
        v.value.length > 1 ? (u(), d("div", {
          key: 0,
          class: "fe-signfonts",
          role: "group",
          "aria-label": r(n)("plugin.sign.font_label"),
          "data-testid": "surface-signature-fonts"
        }, [
          (u(!0), d(he, null, We(v.value, (G) => (u(), d("button", {
            key: G.key,
            type: "button",
            class: Re(["fe-signfonts__btn", [G.className, { "is-on": G.key === k.value }]]),
            disabled: e.disabled,
            title: G.name,
            "aria-pressed": G.key === k.value ? "true" : "false",
            "data-testid": `surface-signature-font-${G.key}`,
            onClick: (we) => U(G.key)
          }, f(m.value.trim() || G.name), 11, A8))), 128))
        ], 8, E8)) : T("", !0),
        i("div", {
          class: "fe-ssig__preview",
          style: Vt({ maxWidth: `${p.value.width}px`, aspectRatio: `${p.value.width} / ${p.value.height}` })
        }, [
          w.value || C.value ? (u(), d("img", {
            key: 0,
            class: "fe-ssig__img",
            src: w.value || C.value,
            alt: ""
          }, null, 8, z8)) : T("", !0)
        ], 4)
      ])) : (u(), d("div", M8, [
        i("label", D8, [
          i("input", {
            ref_key: "fileInput",
            ref: de,
            type: "file",
            accept: "image/png,image/jpeg",
            class: "fe-ssig__file",
            disabled: e.disabled,
            "data-testid": "surface-signature-file",
            onChange: ke
          }, null, 40, P8),
          $t(" " + f(r(n)("plugin.sig.upload_pick")), 1)
        ]),
        i("p", O8, f(r(n)("plugin.sig.upload_hint", { kb: 200 })), 1),
        X.value ? (u(), d("p", L8, f(X.value), 1)) : T("", !0),
        w.value || C.value ? (u(), d("div", {
          key: 1,
          class: "fe-ssig__preview",
          style: Vt({ maxWidth: `${p.value.width}px` })
        }, [
          i("img", {
            class: "fe-ssig__img",
            src: w.value || C.value,
            alt: ""
          }, null, 8, I8)
        ], 4)) : T("", !0)
      ])),
      i("div", R8, [
        i("button", {
          type: "button",
          class: "fe-btn fe-btn--sm",
          disabled: e.disabled || !$.value,
          "data-testid": "surface-signature-clear",
          onClick: ie
        }, f(r(n)("plugin.sig.clear")), 9, N8),
        $.value ? (u(), d("span", B8, f(r(n)("plugin.sig.signed")), 1)) : T("", !0)
      ])
    ], 10, b8));
  }
});
async function i0(e) {
  const a = await fetch(e.url, {
    headers: e.headers ?? {},
    credentials: e.credentials ?? "same-origin",
    signal: e.signal
  });
  if (!a.ok) {
    const t = await a.text().catch(() => "");
    throw tn(a.status, t, void 0);
  }
  return a;
}
async function F8(e) {
  return (await i0(e)).arrayBuffer();
}
async function Phe(e) {
  return (await i0(e)).text();
}
const bd = "filex", U8 = /^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;
function nm(e) {
  const a = String(e ?? "").trim();
  return U8.test(a) ? a.length === 4 ? `#${a[1]}${a[1]}${a[2]}${a[2]}${a[3]}${a[3]}`.toLowerCase() : a.toLowerCase() : "";
}
function H8(e, a) {
  const t = nm(e);
  if (!t) return "";
  const s = parseInt(t.slice(1), 16), n = (p) => Math.max(0, Math.min(255, Math.round((s >> p & 255) * a))), o = (p) => p.toString(16).padStart(2, "0");
  return `#${o(n(16))}${o(n(8))}${o(n(0))}`;
}
function r0(e) {
  const a = nm(e);
  if (!a) return "";
  const t = parseInt(a.slice(1), 16), s = (o) => {
    const p = o / 255;
    return p <= 0.04045 ? p / 12.92 : ((p + 0.055) / 1.055) ** 2.4;
  };
  return 0.2126 * s(t >> 16 & 255) + 0.7152 * s(t >> 8 & 255) + 0.0722 * s(t & 255) > 0.42 ? "#0b0f14" : "#ffffff";
}
function l0(e) {
  const a = nm(e);
  if (!a) return {};
  const t = parseInt(a.slice(1), 16), s = `${t >> 16 & 255}, ${t >> 8 & 255}, ${t & 255}`;
  return {
    "--fe-primary": a,
    "--fe-primary-hover": H8(a, 0.85),
    "--fe-text-on-primary": r0(a),
    // ⚠ The TINT and the ink on it, or the accent only half arrives: the
    // button turned orange while the round badge behind the padlock, the
    // focus ring on the PIN box and the row hover stayed the stock blue
    // (measured on the first after-shot of the restored gate). The old
    // Go-rendered page derived exactly these from the same colour
    // (`--px-accent-soft: rgba(r,g,b,0.14)`, `color: var(--px-accent)`), and
    // a translucent tint is right rather than a solid: it composites onto
    // the card in light and in dark without a second value.
    "--fe-primary-soft": `rgba(${s}, 0.14)`,
    "--fe-primary-ink": a
  };
}
function K8(e = {}) {
  const a = b(null), t = b(!1), s = x(() => {
    var k, _;
    return ((_ = (k = a.value) == null ? void 0 : k.name) == null ? void 0 : _.trim()) || bd;
  }), n = x(() => {
    var k, _;
    return !!((_ = (k = a.value) == null ? void 0 : k.name) != null && _.trim()) && s.value !== bd;
  }), o = x(() => {
    var k, _;
    return ((_ = (k = a.value) == null ? void 0 : k.logo_url) == null ? void 0 : _.trim()) || "";
  }), p = x(() => {
    var k, _;
    return ((_ = (k = a.value) == null ? void 0 : k.footer_text) == null ? void 0 : _.trim()) || "";
  }), h = x(() => {
    var k;
    return ((k = a.value) == null ? void 0 : k.hide_powered_by) === !0;
  }), v = x(() => {
    var _;
    const k = (_ = a.value) == null ? void 0 : _.theme;
    return k === "light" || k === "dark" ? k : "auto";
  }), y = x(() => {
    var k;
    return ((k = a.value) == null ? void 0 : k.locales) ?? [];
  }), g = x(() => {
    var k;
    return l0((k = a.value) == null ? void 0 : k.accent);
  });
  async function m() {
    const k = e.fetchImpl ?? (typeof fetch == "function" ? fetch : null);
    if (!k) return null;
    const _ = Ad(e.base);
    for (const w of ["/api/public/branding", "/api/branding"])
      try {
        const $ = await k(`${_}${w}`, {
          method: "GET",
          headers: { Accept: "application/json" },
          credentials: "same-origin"
        });
        if (!$.ok) continue;
        return a.value = await $.json(), t.value = !0, wk(a.value, { base: e.base, fetchImpl: e.fetchImpl }), a.value;
      } catch {
      }
    return null;
  }
  return { branding: a, loaded: t, name: s, whitelabel: n, logo: o, footerText: p, hidePoweredBy: h, themeDefault: v, locales: y, accentStyle: g, load: m };
}
let Op = null;
function V8(e) {
  return `https://cdn.jsdelivr.net/npm/pdfjs-dist@${e}/legacy/build/pdf.worker.min.mjs`;
}
function q8(e) {
  return Op || (Op = (async () => {
    try {
      const a = await import(
        /* @vite-ignore */
        "./pdf-CaPYsOUo.js"
      ), t = a.default ?? a;
      return t.GlobalWorkerOptions && !t.GlobalWorkerOptions.workerSrc && (t.GlobalWorkerOptions.workerSrc = e || V8(t.version || "5.7.284")), t;
    } catch {
      return null;
    }
  })()), Op;
}
const j8 = ["data-testid"], W8 = { class: "fe-spdf__propname" }, Y8 = { class: "fe-spdf__prop" }, G8 = ["value", "placeholder", "disabled", "data-testid"], X8 = {
  key: 0,
  class: "fe-spdf__prop"
}, J8 = ["id", "data-testid"], Z8 = ["data-testid"], Q8 = ["id"], eP = { class: "fe-spdf__prop fe-spdf__prop--check" }, tP = ["checked", "disabled", "data-testid"], aP = { class: "fe-spdf__prop" }, nP = ["id"], sP = { class: "fe-spdf__prop" }, oP = ["value", "disabled", "data-testid"], iP = { class: "fe-spdf__prop" }, rP = ["value", "disabled", "data-testid"], lP = { class: "fe-spdf__prop" }, uP = ["id"], cP = { class: "fe-spdf__prop" }, dP = ["id"], fP = ["data-testid"], pP = { class: "fe-spdf__dateex-title" }, vP = { class: "fe-spdf__dateex-value" }, hP = {
  key: 4,
  class: "fe-spdf__prop"
}, mP = ["id"], yP = ["aria-label", "data-testid"], gP = ["title", "disabled", "aria-pressed", "data-testid", "onClick"], bP = ["data-testid"], _P = ["id"], kP = ["data-testid"], wP = { class: "fe-spdf__linepreview-title" }, xP = {
  key: 1,
  class: "fe-spdf__linepreview-line is-none"
}, $P = ["disabled", "data-testid"], Lp = "*", Jb = /* @__PURE__ */ rt({
  __name: "PdfFieldEditor",
  props: {
    field: {},
    signers: {},
    formats: {},
    dateLabels: {},
    locale: {},
    disabled: { type: Boolean },
    testidPrefix: {},
    stampLines: {}
  },
  emits: ["patch", "remove"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n } = gt(() => t.locale), o = x(() => t.testidPrefix || "surface-pdf");
    function p(q) {
      return n(`plugin.pdf.type_${q}`);
    }
    function h(q) {
      const re = { ...t.field };
      q(re), s("patch", re);
    }
    function v(q) {
      h((re) => {
        q ? re.label = q : delete re.label;
      });
    }
    function y(q) {
      h((re) => {
        q ? re.assignee = q : delete re.assignee;
      });
    }
    function g(q) {
      h((re) => {
        q ? re.required = !0 : delete re.required;
      });
    }
    function m(q) {
      h((re) => {
        const ae = Nv.includes(q) ? q : "any", Pe = { ...re.rule ?? { kind: "any" }, kind: ae };
        ae === "any" && !Pe.min && !Pe.max ? delete re.rule : re.rule = Pe;
      });
    }
    function k(q, re) {
      const ae = Math.trunc(Number(String(re ?? "").trim()));
      h((Pe) => {
        const be = { ...Pe.rule ?? { kind: "any" } };
        Number.isFinite(ae) && ae > 0 ? be[q] = ae : delete be[q], be.kind === "any" && !be.min && !be.max ? delete Pe.rule : Pe.rule = be;
      });
    }
    function _(q) {
      h((re) => {
        q ? re.format = q : delete re.format;
      });
    }
    function w(q) {
      h((re) => {
        re.font = q;
      });
    }
    const $ = x(() => H1(t.field.type)), C = x(() => t.field.style ?? "drawn");
    function E(q) {
      h((re) => {
        q === "typed" ? re.style = "typed" : delete re.style;
      });
    }
    const A = x(() => [
      { value: "drawn", label: n("plugin.pdf.style_drawn") },
      { value: "typed", label: n("plugin.pdf.style_typed") }
    ]), O = x(() => t.field.type === "checkbox" ? !1 : $.value ? C.value === "typed" : !0), z = x(() => O3(t.stampLines)), P = x(() => L3(t.field, z.value)), I = x(
      () => z.value.map((q) => ({ value: q.id, label: jt(q.label, t.locale) || q.id }))
    );
    function F(q) {
      const re = (Array.isArray(q) ? q : [q]).filter(Boolean);
      h((ae) => {
        ae.lines = re;
      });
    }
    const W = x(
      () => P.value.map((q) => z.value.find((re) => re.id === q)).filter((q) => !!q).map((q) => jt(I3(q, t.field.assignee), t.locale) || jt(q.label, t.locale))
    ), N = x(() => n($.value ? "plugin.pdf.assignee" : "plugin.pdf.filled_by")), K = x(() => [
      { value: Lp, label: n("plugin.pdf.unassigned") },
      ...t.signers.map((q) => ({ value: q.id, label: jt(q.label, t.locale) || q.id }))
    ]), M = x(
      () => Nv.map((q) => ({ value: q, label: n(`plugin.pdf.rule_kind_${q}`) }))
    ), j = x(() => F3(t.formats)), U = x(
      () => j.value.map((q) => ({ value: q.id, label: jt(q.label, t.locale) || q.id, help: q.example }))
    ), de = x(() => {
      var q;
      return t.field.format ?? ((q = j.value[0]) == null ? void 0 : q.id) ?? "";
    }), ke = x(() => H3(j.value)), ie = x(() => U3(t.dateLabels));
    function ce(q, re) {
      return xh(ie.value[q], t.locale, () => n(re));
    }
    const X = x(() => K3(j.value, de.value)), Z = x(() => {
      var q, re, ae;
      return ((q = X.value) == null ? void 0 : q.order) ?? ((ae = (re = ke.value) == null ? void 0 : re.orders[0]) == null ? void 0 : ae.id) ?? "";
    }), Y = x(() => {
      var q, re, ae;
      return ((q = X.value) == null ? void 0 : q.separator) ?? ((ae = (re = ke.value) == null ? void 0 : re.separators[0]) == null ? void 0 : ae.id) ?? "";
    }), G = x(
      () => {
        var q;
        return (((q = ke.value) == null ? void 0 : q.orders) ?? []).map((re) => ({ value: re.id, label: jt(re.label, t.locale) || re.id }));
      }
    ), we = x(
      () => {
        var q;
        return (((q = ke.value) == null ? void 0 : q.separators) ?? []).map((re) => ({ value: re.id, label: jt(re.label, t.locale) || re.id }));
      }
    ), R = x(() => q3(Z.value, Y.value, /* @__PURE__ */ new Date()));
    function pe(q) {
      _(Kb(j.value, q, Y.value));
    }
    function Q(q) {
      _(Kb(j.value, Z.value, q));
    }
    return (q, re) => {
      var ae, Pe, be;
      return u(), d("div", {
        class: "fe-spdf__props",
        "data-testid": `${o.value}-editor`
      }, [
        i("span", W8, f(p(e.field.type)), 1),
        i("label", Y8, [
          i("span", null, f(r(n)("plugin.pdf.label")), 1),
          i("input", {
            class: "fe-cfield__input fe-spdf__name",
            type: "text",
            value: e.field.label ?? "",
            placeholder: p(e.field.type),
            disabled: e.disabled,
            "data-testid": `${o.value}-label`,
            onInput: re[0] || (re[0] = (ze) => v(ze.target.value))
          }, null, 40, G8)
        ]),
        e.signers.length ? (u(), d("div", X8, [
          i("span", {
            id: `${o.value}-${e.field.id}-assignee-lbl`,
            "data-testid": `${o.value}-assignee-label`
          }, f(N.value), 9, J8),
          ot(Ls, {
            options: K.value,
            "model-value": e.field.assignee || Lp,
            disabled: e.disabled,
            "aria-labelledby": `${o.value}-${e.field.id}-assignee-lbl`,
            "testid-prefix": `${o.value}-assignee`,
            "onUpdate:modelValue": re[1] || (re[1] = (ze) => y(String(ze) === Lp ? "" : String(ze)))
          }, null, 8, ["options", "model-value", "disabled", "aria-labelledby", "testid-prefix"])
        ])) : T("", !0),
        $.value ? (u(), d("div", {
          key: 1,
          class: "fe-spdf__prop",
          "data-testid": `${o.value}-style`
        }, [
          i("span", {
            id: `${o.value}-${e.field.id}-style-lbl`
          }, f(r(n)("plugin.pdf.style")), 9, Q8),
          ot(Ls, {
            options: A.value,
            "model-value": C.value,
            disabled: e.disabled,
            "aria-labelledby": `${o.value}-${e.field.id}-style-lbl`,
            "testid-prefix": `${o.value}-style`,
            "onUpdate:modelValue": re[2] || (re[2] = (ze) => E(String(ze)))
          }, null, 8, ["options", "model-value", "disabled", "aria-labelledby", "testid-prefix"])
        ], 8, Z8)) : T("", !0),
        i("label", eP, [
          i("input", {
            type: "checkbox",
            checked: e.field.required === !0,
            disabled: e.disabled,
            "data-testid": `${o.value}-required`,
            onChange: re[3] || (re[3] = (ze) => g(ze.target.checked))
          }, null, 40, tP),
          i("span", null, f(r(n)("plugin.pdf.required")), 1)
        ]),
        e.field.type === "text" ? (u(), d(he, { key: 2 }, [
          i("div", aP, [
            i("span", {
              id: `${o.value}-${e.field.id}-rule-lbl`
            }, f(r(n)("plugin.pdf.rule")), 9, nP),
            ot(Ls, {
              options: M.value,
              "model-value": ((ae = e.field.rule) == null ? void 0 : ae.kind) ?? "any",
              disabled: e.disabled,
              "aria-labelledby": `${o.value}-${e.field.id}-rule-lbl`,
              "testid-prefix": `${o.value}-rule`,
              "onUpdate:modelValue": re[4] || (re[4] = (ze) => m(String(ze)))
            }, null, 8, ["options", "model-value", "disabled", "aria-labelledby", "testid-prefix"])
          ]),
          i("label", sP, [
            i("span", null, f(r(n)("plugin.pdf.rule_min_label")), 1),
            i("input", {
              class: "fe-cfield__input fe-spdf__num",
              type: "number",
              min: "0",
              value: ((Pe = e.field.rule) == null ? void 0 : Pe.min) ?? "",
              disabled: e.disabled,
              "data-testid": `${o.value}-rule-min`,
              onInput: re[5] || (re[5] = (ze) => k("min", ze.target.value))
            }, null, 40, oP)
          ]),
          i("label", iP, [
            i("span", null, f(r(n)("plugin.pdf.rule_max_label")), 1),
            i("input", {
              class: "fe-cfield__input fe-spdf__num",
              type: "number",
              min: "0",
              value: ((be = e.field.rule) == null ? void 0 : be.max) ?? "",
              disabled: e.disabled,
              "data-testid": `${o.value}-rule-max`,
              onInput: re[6] || (re[6] = (ze) => k("max", ze.target.value))
            }, null, 40, rP)
          ])
        ], 64)) : T("", !0),
        e.field.type === "date" && ke.value ? (u(), d(he, { key: 3 }, [
          i("div", lP, [
            i("span", {
              id: `${o.value}-${e.field.id}-order-lbl`
            }, f(ce("order", "plugin.pdf.date_order")), 9, uP),
            ot(Ls, {
              options: G.value,
              "model-value": Z.value,
              disabled: e.disabled,
              "aria-labelledby": `${o.value}-${e.field.id}-order-lbl`,
              "testid-prefix": `${o.value}-order`,
              "onUpdate:modelValue": re[7] || (re[7] = (ze) => pe(String(ze)))
            }, null, 8, ["options", "model-value", "disabled", "aria-labelledby", "testid-prefix"])
          ]),
          i("div", cP, [
            i("span", {
              id: `${o.value}-${e.field.id}-sep-lbl`
            }, f(ce("separator", "plugin.pdf.date_separator")), 9, dP),
            ot(Ls, {
              options: we.value,
              "model-value": Y.value,
              disabled: e.disabled,
              "aria-labelledby": `${o.value}-${e.field.id}-sep-lbl`,
              "testid-prefix": `${o.value}-sep`,
              "onUpdate:modelValue": re[8] || (re[8] = (ze) => Q(String(ze)))
            }, null, 8, ["options", "model-value", "disabled", "aria-labelledby", "testid-prefix"])
          ]),
          i("p", {
            class: "fe-spdf__dateex",
            "data-testid": `${o.value}-date-example`
          }, [
            i("span", pP, f(ce("example", "plugin.pdf.date_example")), 1),
            i("bdi", vP, f(R.value), 1)
          ], 8, fP)
        ], 64)) : e.field.type === "date" && U.value.length ? (u(), d("div", hP, [
          i("span", {
            id: `${o.value}-${e.field.id}-format-lbl`
          }, f(r(n)("plugin.pdf.format")), 9, mP),
          ot(Ls, {
            options: U.value,
            "model-value": de.value,
            disabled: e.disabled,
            "aria-labelledby": `${o.value}-${e.field.id}-format-lbl`,
            "testid-prefix": `${o.value}-format`,
            "onUpdate:modelValue": re[9] || (re[9] = (ze) => _(String(ze)))
          }, null, 8, ["options", "model-value", "disabled", "aria-labelledby", "testid-prefix"])
        ])) : T("", !0),
        O.value ? (u(), d("div", {
          key: 5,
          class: "fe-signfonts fe-spdf__prop",
          role: "group",
          "aria-label": r(n)("plugin.pdf.font"),
          "data-testid": `${o.value}-fonts`
        }, [
          (u(!0), d(he, null, We(r(Rr), (ze) => (u(), d("button", {
            key: ze.key,
            type: "button",
            class: Re(["fe-signfonts__btn", [ze.className, { "is-on": (e.field.font ?? "caveat") === ze.key }]]),
            title: ze.name,
            disabled: e.disabled,
            "aria-pressed": (e.field.font ?? "caveat") === ze.key ? "true" : "false",
            "data-testid": `${o.value}-font-${ze.key}`,
            onClick: (Ae) => w(ze.key)
          }, " Aa ", 10, gP))), 128))
        ], 8, yP)) : T("", !0),
        $.value && I.value.length ? (u(), d("div", {
          key: 6,
          class: "fe-spdf__prop fe-spdf__lines",
          "data-testid": `${o.value}-lines`
        }, [
          i("span", {
            id: `${o.value}-${e.field.id}-lines-lbl`
          }, f(r(n)("plugin.pdf.lines")), 9, _P),
          ot(Ls, {
            options: I.value,
            "model-value": P.value,
            multi: "",
            disabled: e.disabled,
            "aria-labelledby": `${o.value}-${e.field.id}-lines-lbl`,
            "testid-prefix": `${o.value}-line`,
            "onUpdate:modelValue": F
          }, null, 8, ["options", "model-value", "disabled", "aria-labelledby", "testid-prefix"]),
          i("div", {
            class: "fe-spdf__linepreview",
            "data-testid": `${o.value}-lines-preview`
          }, [
            i("span", wP, f(r(n)("plugin.pdf.lines_preview")), 1),
            W.value.length ? (u(!0), d(he, { key: 0 }, We(W.value, (ze, Ae) => (u(), d("span", {
              key: Ae,
              class: "fe-spdf__linepreview-line"
            }, f(ze), 1))), 128)) : (u(), d("span", xP, f(r(n)("plugin.pdf.lines_none")), 1))
          ], 8, kP)
        ], 8, bP)) : T("", !0),
        wa(q.$slots, "extra"),
        i("button", {
          type: "button",
          class: "fe-btn fe-btn--sm fe-btn--danger",
          disabled: e.disabled,
          "data-testid": `${o.value}-delete`,
          onClick: re[10] || (re[10] = (ze) => s("remove"))
        }, f(r(n)("plugin.pdf.delete")), 9, $P)
      ], 8, j8);
    };
  }
}), SP = ["data-state", "data-layout"], TP = {
  key: 0,
  class: "fe-spdf__bar"
}, CP = ["aria-label"], EP = ["disabled", "aria-pressed", "data-testid", "onClick"], AP = {
  key: 0,
  class: "fe-spdf__done",
  "data-testid": "surface-pdf-all-placed"
}, zP = ["aria-label"], MP = ["disabled", "aria-pressed", "data-testid", "onClick"], DP = { class: "fe-spdf__zoom" }, PP = ["aria-label", "disabled"], OP = ["aria-label", "disabled"], LP = ["aria-label", "disabled"], IP = {
  key: 1,
  class: "fe-surface__text fe-surface__text--info fe-spdf__hint"
}, RP = {
  key: 2,
  class: "fe-spdf__define",
  "data-testid": "surface-pdf-define"
}, NP = {
  key: 0,
  class: "fe-spdf__empty",
  "data-testid": "surface-pdf-no-boxes"
}, BP = ["data-testid"], FP = {
  class: "fe-spdf__cardno",
  "aria-hidden": "true"
}, UP = ["aria-label"], HP = { class: "fe-spdf__addlbl" }, KP = ["disabled", "data-testid", "onClick"], VP = {
  key: 3,
  class: "fe-spdf__strip",
  "data-testid": "surface-pdf-strip"
}, qP = {
  key: 0,
  class: "fe-spdf__props",
  "data-testid": "surface-pdf-selected"
}, jP = {
  key: 0,
  class: "fe-spdf__propwho"
}, WP = {
  key: 1,
  class: "fe-spdf__prop"
}, YP = ["max"], GP = {
  key: 1,
  class: "fe-surface__text fe-surface__text--info fe-spdf__hint",
  "data-testid": "surface-pdf-place-hint"
}, XP = {
  key: 2,
  class: "fe-surface__text fe-surface__text--muted fe-spdf__hint",
  "data-testid": "surface-pdf-idle-hint"
}, JP = {
  key: 4,
  "data-testid": "surface-pdf-selected"
}, ZP = {
  key: 0,
  class: "fe-spdf__prop"
}, QP = ["max"], eO = {
  key: 0,
  class: "fe-surface__text fe-surface__text--muted"
}, tO = {
  key: 1,
  class: "fe-surface__unknown",
  role: "alert",
  "data-testid": "surface-pdf-error"
}, aO = {
  key: 2,
  class: "fe-spdf__pages"
}, nO = ["data-page", "onPointerdown"], sO = ["data-testid", "data-field-type", "role", "tabindex", "title", "onPointerdown", "onClick", "onKeydown"], oO = ["src"], iO = ["value", "placeholder", "aria-label", "inputmode", "maxlength", "aria-invalid", "aria-describedby", "title", "disabled", "data-testid", "onInput"], rO = ["innerHTML"], lO = {
  key: 4,
  class: "fe-spdf__label"
}, uO = {
  key: 0,
  class: "fe-spdf__who"
}, cO = {
  key: 1,
  class: "fe-spdf__who"
}, dO = ["id", "role", "data-testid"], fO = ["onPointerdown"], pO = {
  key: 6,
  class: "fe-spdf__pad",
  "data-testid": "surface-pdf-pad"
}, vO = { class: "fe-surface__text fe-surface__text--muted" }, hO = /* @__PURE__ */ rt({
  __name: "SurfacePdfFields",
  props: {
    id: {},
    src: {},
    mode: {},
    fields: {},
    signers: {},
    signer: {},
    types: {},
    formats: {},
    dateLabels: {},
    modelValue: {},
    locale: {},
    theme: {},
    disabled: { type: Boolean },
    invalid: { type: Boolean },
    api: {},
    fileUrl: { type: Function },
    pdfWorkerUrl: {},
    layout: {},
    pageHeight: {},
    stampLines: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n } = gt(() => t.locale), o = x(() => t.mode !== "fill"), p = x(() => t.mode === "define"), h = x(() => t.mode === "place"), v = x(() => j3(t.signers)), y = x(() => R3(t.types)), g = b([]);
    let m;
    function k() {
      o.value ? g.value = Array.isArray(t.modelValue) ? Fc(t.modelValue) : Fc(t.fields) : g.value = Y3(Fc(t.fields), t.modelValue);
    }
    function _() {
      const V = o.value ? g.value.map((oe) => ({ ...oe })) : j1(g.value, t.signer);
      m = V, s("update:modelValue", V);
    }
    let w = !1;
    function $() {
      if (ye) {
        w = !0;
        return;
      }
      k();
    }
    k(), Qe([() => t.fields, () => t.mode, () => t.signer], () => $()), Qe(
      () => t.modelValue,
      (V) => {
        V !== m && $();
      }
    );
    const C = x(() => {
      const V = /* @__PURE__ */ new Map();
      for (const oe of g.value) {
        if (!Bv(oe)) continue;
        const Oe = V.get(oe.page) ?? [];
        Oe.push(oe), V.set(oe.page, Oe);
      }
      return V;
    });
    function E(V) {
      return W3(v.value, V.assignee);
    }
    function A(V) {
      const oe = E(V), Oe = r0(oe);
      return Oe ? { "--spdf-color": oe, "--spdf-ink": Oe } : { "--spdf-color": oe };
    }
    function O(V) {
      const oe = v.value.find((Oe) => Oe.id === V);
      return oe ? jt(oe.label, t.locale) || oe.id : V || "";
    }
    function z(V) {
      return !o.value && q1(V, t.signer);
    }
    function P(V) {
      return n(`plugin.pdf.type_${V}`);
    }
    function I(V) {
      const oe = (V.label ?? "").trim();
      if (oe) return oe;
      const Oe = g.value.filter((Ne) => Ne.type === V.type && !(Ne.label ?? "").trim());
      return Oe.length < 2 ? P(V.type) : `${P(V.type)} ${Oe.findIndex((Ne) => Ne.id === V.id) + 1}`;
    }
    const F = b("loading"), W = b([]), N = b(1), K = b(null), M = b(640), j = b(0), U = x(() => t.layout === "page");
    let de = null, ke = 0, ie = null, ce = null;
    const X = /* @__PURE__ */ new Map(), Z = /* @__PURE__ */ new Map(), Y = /* @__PURE__ */ new Map(), G = x(() => {
      if (!U.value) return M.value;
      const V = W.value[0];
      return V ? E3({ width: M.value, height: j.value }, V) : M.value;
    }), we = x(() => Math.max(120, Math.round(G.value * N.value)));
    async function R() {
      var Oe, Ne;
      const V = t.src ?? {};
      if (V.path) {
        if (!t.api) throw new Error("no api");
        const Ee = await t.api.fetchBlob(V.path);
        return URL.revokeObjectURL(Ee.url), Ee.blob.arrayBuffer();
      }
      const oe = V.url || (V.ref ? (Ne = (Oe = t.fileUrl) == null ? void 0 : Oe.call(t, V.ref)) == null ? void 0 : Ne.url : "");
      if (!oe) throw new Error("no source");
      return F8({ url: oe, headers: {}, credentials: "same-origin" });
    }
    async function pe() {
      var oe, Oe;
      const V = ++ke;
      F.value = "loading", W.value = [], Q();
      try {
        (oe = de == null ? void 0 : de.destroy) == null || oe.call(de);
      } catch {
      }
      de = null;
      try {
        const Ne = await q8(t.pdfWorkerUrl ?? void 0);
        if (!Ne) throw new Error("pdfjs unavailable");
        const Ee = await R();
        if (V !== ke) return;
        const Ge = await Ne.getDocument({ data: Ee }).promise;
        if (V !== ke) {
          (Oe = Ge.destroy) == null || Oe.call(Ge);
          return;
        }
        de = Ge;
        const ue = [];
        for (let je = 1; je <= Ge.numPages; je++) {
          const Se = (await Ge.getPage(je)).getViewport({ scale: 1 });
          ue.push({ num: je, width: Se.width, height: Se.height, rotation: Se.rotation ?? 0 });
        }
        if (V !== ke) return;
        W.value = ue, F.value = "ok", await Jt(), re();
      } catch {
        if (V !== ke) return;
        F.value = "error";
      }
    }
    function Q() {
      ie == null || ie.disconnect(), ie = null, X.clear(), Z.clear(), Y.clear();
    }
    function q(V, oe) {
      if (!(oe instanceof HTMLDivElement)) return;
      const Oe = X.get(V);
      Oe !== oe && (Oe && (ie == null || ie.unobserve(Oe)), X.set(V, oe), de && (ie ? ie.observe(oe) : typeof IntersectionObserver > "u" && ae(V), Oe && (Z.delete(V), Y.delete(V))));
    }
    function re() {
      if (typeof IntersectionObserver > "u") {
        for (const V of X.keys()) ae(V);
        return;
      }
      ie = new IntersectionObserver(
        (V) => {
          for (const oe of V) {
            const Oe = Number(oe.target.dataset.page);
            oe.isIntersecting && ae(Oe);
          }
        },
        { rootMargin: "200px 0px" }
      );
      for (const V of X.values()) ie.observe(V);
    }
    async function ae(V) {
      if (!de || !X.get(V)) return;
      const Oe = we.value;
      if (Z.get(V) === Oe) return;
      Z.set(V, Oe);
      const Ne = W.value.find((je) => je.num === V);
      if (!Ne) return;
      const Ee = typeof window < "u" && window.devicePixelRatio > 0 ? Math.min(3, window.devicePixelRatio) : 1, Ge = Oe / Ne.width * Ee, ue = de;
      try {
        const je = await ue.getPage(V), vt = je.getViewport({ scale: Ge }), Se = document.createElement("canvas");
        Se.className = "fe-spdf__canvas", Se.width = Math.round(vt.width), Se.height = Math.round(vt.height);
        const Ie = Se.getContext("2d");
        if (!Ie || (await je.render({ canvasContext: Ie, viewport: vt }).promise, ue !== de || Z.get(V) !== Oe)) return;
        const ee = X.get(V);
        if (!ee) return;
        const ge = Y.get(V);
        ge && ge.parentNode === ee ? ee.replaceChild(Se, ge) : ee.prepend(Se), Y.set(V, Se);
      } catch {
        Z.get(V) === Oe && Z.delete(V);
      }
    }
    function Pe() {
      for (const V of X.keys())
        Z.has(V) && (Z.delete(V), ae(V));
    }
    Qe(we, () => Pe());
    function be() {
      N.value = Math.min(3, Math.round(N.value * 1.25 * 100) / 100);
    }
    function ze() {
      N.value = Math.max(0.5, Math.round(N.value / 1.25 * 100) / 100);
    }
    function Ae() {
      N.value = 1;
    }
    function Ce() {
      const V = K.value;
      V && (M.value = V.clientWidth || M.value, j.value = V.clientHeight || j.value, !(typeof ResizeObserver > "u") && (ce == null || ce.disconnect(), ce = new ResizeObserver(() => He()), ce.observe(V)));
    }
    function He() {
      var Oe, Ne;
      if (ye) {
        J = !0;
        return;
      }
      const V = ((Oe = K.value) == null ? void 0 : Oe.clientWidth) ?? 0, oe = ((Ne = K.value) == null ? void 0 : Ne.clientHeight) ?? 0;
      V > 0 && Math.abs(V - M.value) > 2 && (M.value = V), oe > 0 && Math.abs(oe - j.value) > 2 && (j.value = oe);
    }
    let J = !1;
    Qe(K, () => {
      Jt(Ce);
    }), Kt(() => {
      Ce(), pe();
    });
    const me = x(() => {
      const V = t.src ?? {};
      return [V.ref ?? "", V.path ?? "", V.url ?? ""].join("\0");
    });
    Qe(me, () => void pe()), Mt(() => {
      var V;
      ke++, Q(), ce == null || ce.disconnect();
      try {
        (V = de == null ? void 0 : de.destroy) == null || V.call(de);
      } catch {
      }
      de = null;
    });
    const fe = b(""), xe = b("");
    let ye = null;
    const qe = b(null);
    function ut(V, oe) {
      const Oe = oe.getBoundingClientRect();
      return Fb({ x: V.clientX - Oe.left, y: V.clientY - Oe.top }, { width: Oe.width, height: Oe.height });
    }
    function Ue(V) {
      const oe = X.get(V.page), Oe = oe && oe.isConnected ? oe : V.el;
      if (!Oe || !Oe.isConnected) return null;
      const Ne = Oe.getBoundingClientRect();
      return Ne.width >= 1 && Ne.height >= 1 ? Ne : null;
    }
    function Ye(V, oe) {
      return Fb({ x: V.clientX - oe.left, y: V.clientY - oe.top }, { width: oe.width, height: oe.height });
    }
    function st(V) {
      xe.value = xe.value === V ? "" : V, fe.value = "";
    }
    function kt(V) {
      const oe = B3(g.value, V, {
        assignee: Tt(),
        required: !0
      });
      g.value = [...g.value, oe], _();
    }
    function At(V) {
      g.value = g.value.map((oe) => oe.id === V.id ? V : oe), _();
    }
    function _t(V) {
      g.value = g.value.filter((oe) => oe.id !== V), fe.value === V && (fe.value = ""), _();
    }
    const Le = x(() => N3(g.value)), tt = b("");
    function ve(V) {
      tt.value = tt.value === V ? "" : V, fe.value = "";
    }
    function H(V, oe) {
      const Oe = tt.value;
      Oe && (g.value = g.value.map((Ne) => {
        if (Ne.id !== Oe) return Ne;
        const Ee = { ...Ne, page: V, ...$r(oe) };
        return delete Ee.placed, Ee;
      }), tt.value = "", fe.value = Oe, _());
    }
    function te() {
      const V = fe.value;
      V && (g.value = g.value.map((oe) => oe.id === V ? { ...oe, placed: !1 } : oe), fe.value = "", _());
    }
    function Te(V) {
      const oe = O(V.assignee), Oe = I(V);
      return oe ? `${Oe} · ${oe}` : Oe;
    }
    function L(V, oe) {
      var Ne, Ee;
      if (!o.value || t.disabled) return;
      const Oe = V.currentTarget;
      if (h.value && tt.value) {
        ye = { kind: "place", page: oe, el: Oe, start: ut(V, Oe) }, qe.value = null, Lt(), (Ne = V.preventDefault) == null || Ne.call(V);
        return;
      }
      if (xe.value) {
        ye = { kind: "place", page: oe, el: Oe, start: ut(V, Oe) }, qe.value = null, Lt(), (Ee = V.preventDefault) == null || Ee.call(V);
        return;
      }
      fe.value = "";
    }
    function se(V, oe, Oe) {
      var Ee;
      if (!o.value || t.disabled) return;
      const Ne = V.currentTarget.closest(".fe-spdf__page");
      Ne && (fe.value = oe.id, xe.value = "", ye = { kind: "move", page: Oe, el: Ne, start: ut(V, Ne), id: oe.id, orig: { ...oe } }, Lt(), V.stopPropagation(), (Ee = V.preventDefault) == null || Ee.call(V));
    }
    function ne(V, oe, Oe) {
      var Ee;
      if (!o.value || t.disabled) return;
      const Ne = V.currentTarget.closest(".fe-spdf__page");
      Ne && (fe.value = oe.id, ye = { kind: "resize", page: Oe, el: Ne, start: ut(V, Ne), id: oe.id, orig: { ...oe } }, Lt(), V.stopPropagation(), (Ee = V.preventDefault) == null || Ee.call(V));
    }
    function et(V) {
      if (!ye) return;
      const oe = Ue(ye);
      if (!oe) return;
      const Oe = Ye(V, oe);
      if (ye.kind === "place") {
        const vt = $c(ye.start, Oe);
        qe.value = { page: ye.page, ...vt };
        return;
      }
      if (!ye.id || !ye.orig) return;
      const Ne = Oe.x - ye.start.x, Ee = Oe.y - ye.start.y, Ge = ye.orig, ue = ye.kind === "move" ? $r({ x: Ge.x + Ne, y: Ge.y + Ee, w: Ge.w, h: Ge.h }) : $r({ x: Ge.x, y: Ge.y, w: Ge.w + Ne, h: Ge.h + Ee }), je = ye.id;
      g.value = g.value.map((vt) => vt.id === je ? { ...vt, ...ue } : vt);
    }
    function ht(V) {
      if (!ye) return;
      const oe = ye;
      ye = null, ua();
      const Oe = Ue(oe);
      J && (J = !1, He());
      const Ne = oe.kind === "place" || oe.kind === "move" || oe.kind === "resize";
      if (w && (w = !1, Ne || k()), !Oe) {
        qe.value = null, (oe.kind === "move" || oe.kind === "resize") && _();
        return;
      }
      if (oe.kind === "place" && h.value && tt.value) {
        const Ee = Ye(V, Oe), Ge = g.value.find((vt) => vt.id === tt.value), je = Math.abs(Ee.x - oe.start.x) > 0.01 || Math.abs(Ee.y - oe.start.y) > 0.01 ? $c(oe.start, Ee) : { x: Ee.x - ((Ge == null ? void 0 : Ge.w) ?? 0.2) / 2, y: Ee.y - ((Ge == null ? void 0 : Ge.h) ?? 0.05) / 2, w: (Ge == null ? void 0 : Ge.w) ?? 0.2, h: (Ge == null ? void 0 : Ge.h) ?? 0.05 };
        H(oe.page, je), qe.value = null;
        return;
      }
      if (oe.kind === "place" && xe.value) {
        const Ee = Ye(V, Oe), Ge = Math.abs(Ee.x - oe.start.x) > 0.01 || Math.abs(Ee.y - oe.start.y) > 0.01, ue = xe.value, je = Ge ? Vb(g.value, ue, oe.page, $c(oe.start, Ee), $c(oe.start, Ee), Tt()) : Vb(g.value, ue, oe.page, { x: Ee.x - gd[ue].w / 2, y: Ee.y - gd[ue].h / 2 }, void 0, Tt());
        g.value = [...g.value, { ...je, label: P(ue) }], fe.value = je.id, qe.value = null, _();
        return;
      }
      if (qe.value = null, oe.kind === "move" || oe.kind === "resize") {
        const Ee = g.value.find((ue) => ue.id === oe.id), Ge = oe.orig;
        (!Ee || !Ge || Ee.x !== Ge.x || Ee.y !== Ge.y || Ee.w !== Ge.w || Ee.h !== Ge.h) && _();
      }
    }
    function Tt() {
      return v.value.length === 1 ? v.value[0].id : void 0;
    }
    const Ft = b(!1);
    function Lt() {
      Ft.value = !0, window.addEventListener("pointermove", et), window.addEventListener("pointerup", ht), window.addEventListener("pointercancel", ht);
    }
    function ua() {
      Ft.value = !1, window.removeEventListener("pointermove", et), window.removeEventListener("pointerup", ht), window.removeEventListener("pointercancel", ht);
    }
    const Ct = x(() => g.value.find((V) => V.id === fe.value) ?? null), Qt = b(1);
    function ta() {
      if (!Ct.value) return;
      const V = g.value.length;
      g.value = X3(g.value, fe.value, Qt.value), g.value.length !== V && (fe.value = g.value[g.value.length - 1].id, _());
    }
    function Rt() {
      const V = K.value, oe = Ct.value;
      if (!V || !oe || ye || !Bv(oe)) return;
      const Oe = X.get(oe.page);
      if (!Oe) return;
      const Ne = Oe.getBoundingClientRect(), Ee = V.getBoundingClientRect();
      if (!Ne.height || !Ee.height) return;
      const Ge = Ne.top - Ee.top + V.scrollTop + oe.y * Ne.height, ue = Ge + oe.h * Ne.height, je = 24;
      Ge < V.scrollTop + je ? V.scrollTop = Math.max(0, Ge - je) : ue > V.scrollTop + V.clientHeight - je && (V.scrollTop = ue - V.clientHeight + je);
    }
    Qe(fe, () => void Jt(Rt));
    const va = b("");
    function ha(V, oe) {
      g.value = G3(g.value, V, oe), _();
    }
    function _a(V) {
      if (!(o.value || t.disabled || !z(V)))
        switch (V.type) {
          case "signature":
          case "initials":
            va.value = va.value === V.id ? "" : V.id;
            break;
          case "checkbox":
            ha(V.id, V.value !== !0);
            break;
          case "date":
            ha(V.id, Fv(V) ? "" : J3());
            break;
        }
    }
    function ia(V, oe) {
      const Oe = oe.target, Ne = D3(Oe.value, Ot(V));
      Ne !== Oe.value && (Oe.value = Ne), ha(V.id, Ne);
    }
    const _e = x(() => g.value.find((V) => V.id === va.value) ?? null), Ve = x(() => {
      var V;
      return ((V = _e.value) == null ? void 0 : V.style) === "typed" ? ["type"] : ["draw", "upload"];
    }), Je = x(
      () => {
        var V;
        return ((V = _e.value) == null ? void 0 : V.style) === "typed" && _e.value.font ? [_e.value.font] : void 0;
      }
    ), at = x(() => {
      var oe;
      const V = (oe = _e.value) == null ? void 0 : oe.value;
      return typeof V == "string" && V ? { png_b64: V, mode: "draw" } : null;
    });
    function xt(V) {
      _e.value && ha(_e.value.id, (V == null ? void 0 : V.png_b64) ?? "");
    }
    function Bt(V) {
      return typeof V.value == "string" && V.value ? `data:image/png;base64,${V.value}` : "";
    }
    function Ot(V) {
      return V.type === "text" ? V.rule ?? null : null;
    }
    function It(V) {
      const oe = Ot(V);
      if (!oe) return "";
      const Oe = [];
      return oe.kind === "number" ? Oe.push(n("plugin.pdf.rule_number")) : oe.kind === "email" && Oe.push(n("plugin.pdf.rule_email")), oe.min && oe.max ? Oe.push(n("plugin.pdf.rule_length", { min: oe.min, max: oe.max })) : oe.min ? Oe.push(n("plugin.pdf.rule_min", { min: oe.min })) : oe.max && Oe.push(n("plugin.pdf.rule_max", { max: oe.max })), Oe.join(" · ");
    }
    function Et(V) {
      const oe = Ot(V), Oe = P3(V.value, oe);
      return !Oe || !oe ? "" : Oe === "min" ? n("plugin.pdf.err_min", { min: oe.min ?? 0 }) : Oe === "max" ? n("plugin.pdf.err_max", { max: oe.max ?? 0 }) : n(`plugin.pdf.err_${Oe}`);
    }
    function Dt(V) {
      return F1(V.font).className;
    }
    const aa = wt("check");
    return (V, oe) => (u(), d("div", {
      class: Re(["fe-spdf", {
        "is-edit": o.value,
        "is-fill": !o.value,
        "is-invalid": e.invalid,
        "is-disabled": e.disabled,
        "is-placing": !!xe.value || !!tt.value,
        "is-define": p.value,
        "fe-spdf--page": U.value && !p.value
      }]),
      "data-testid": "surface-pdf-fields",
      style: Vt(U.value ? { "--spdf-h": e.pageHeight || "100%" } : void 0),
      "data-state": F.value,
      "data-layout": U.value ? "page" : "inline"
    }, [
      p.value ? T("", !0) : (u(), d("div", TP, [
        h.value ? (u(), d("div", {
          key: 0,
          class: "fe-spdf__palette",
          role: "toolbar",
          "aria-label": r(n)("plugin.pdf.pending")
        }, [
          (u(!0), d(he, null, We(Le.value, (Oe) => (u(), d("button", {
            key: Oe.id,
            type: "button",
            class: Re(["fe-btn fe-btn--sm", { "fe-btn--primary": tt.value === Oe.id }]),
            style: Vt({ "--spdf-color": E(Oe) }),
            disabled: e.disabled || F.value !== "ok",
            "aria-pressed": tt.value === Oe.id ? "true" : "false",
            "data-testid": `surface-pdf-pending-${Oe.id}`,
            onClick: (Ne) => ve(Oe.id)
          }, f(Te(Oe)), 15, EP))), 128)),
          Le.value.length ? T("", !0) : (u(), d("span", AP, f(r(n)("plugin.pdf.all_placed")), 1))
        ], 8, CP)) : o.value ? (u(), d("div", {
          key: 1,
          class: "fe-spdf__palette",
          role: "toolbar",
          "aria-label": r(n)("plugin.pdf.palette")
        }, [
          (u(!0), d(he, null, We(y.value, (Oe) => (u(), d("button", {
            key: Oe,
            type: "button",
            class: Re(["fe-btn fe-btn--sm", { "fe-btn--primary": xe.value === Oe }]),
            disabled: e.disabled || F.value !== "ok",
            "aria-pressed": xe.value === Oe ? "true" : "false",
            "data-testid": `surface-pdf-type-${Oe}`,
            onClick: (Ne) => st(Oe)
          }, f(P(Oe)), 11, MP))), 128))
        ], 8, zP)) : T("", !0),
        i("div", DP, [
          i("button", {
            type: "button",
            class: "fe-btn fe-btn--sm",
            "aria-label": r(n)("plugin.pdf.zoom_out"),
            disabled: F.value !== "ok",
            onClick: ze
          }, "−", 8, PP),
          i("button", {
            type: "button",
            class: "fe-btn fe-btn--sm fe-spdf__zoomval",
            "aria-label": r(n)(U.value ? "plugin.pdf.zoom_fit_page" : "plugin.pdf.zoom_fit"),
            disabled: F.value !== "ok",
            onClick: Ae
          }, f(Math.round(N.value * 100)) + "% ", 9, OP),
          i("button", {
            type: "button",
            class: "fe-btn fe-btn--sm",
            "aria-label": r(n)("plugin.pdf.zoom_in"),
            disabled: F.value !== "ok",
            onClick: be
          }, "+", 8, LP)
        ])
      ])),
      o.value && !p.value && !h.value && xe.value ? (u(), d("p", IP, f(r(n)("plugin.pdf.place_hint", { type: P(xe.value) })), 1)) : T("", !0),
      p.value ? (u(), d("div", RP, [
        g.value.length ? T("", !0) : (u(), d("div", NP, f(r(n)("plugin.pdf.no_boxes")), 1)),
        (u(!0), d(he, null, We(g.value, (Oe, Ne) => (u(), d("div", {
          key: Oe.id,
          class: "fe-spdf__card",
          style: Vt(A(Oe)),
          "data-testid": `surface-pdf-card-${Oe.id}`
        }, [
          i("span", FP, f(Ne + 1), 1),
          ot(Jb, {
            field: Oe,
            signers: v.value,
            formats: e.formats,
            "date-labels": e.dateLabels,
            "stamp-lines": e.stampLines,
            locale: e.locale,
            disabled: e.disabled,
            "testid-prefix": `surface-pdf-card-${Oe.id}`,
            onPatch: At,
            onRemove: (Ee) => _t(Oe.id)
          }, null, 8, ["field", "signers", "formats", "date-labels", "stamp-lines", "locale", "disabled", "testid-prefix", "onRemove"])
        ], 12, BP))), 128)),
        i("div", {
          class: "fe-spdf__add",
          role: "toolbar",
          "aria-label": r(n)("plugin.pdf.add_box")
        }, [
          i("span", HP, f(r(n)("plugin.pdf.add_box")), 1),
          (u(!0), d(he, null, We(y.value, (Oe) => (u(), d("button", {
            key: Oe,
            type: "button",
            class: "fe-btn fe-btn--sm",
            disabled: e.disabled,
            "data-testid": `surface-pdf-add-${Oe}`,
            onClick: (Ne) => kt(Oe)
          }, " + " + f(P(Oe)), 9, KP))), 128))
        ], 8, UP)
      ])) : h.value ? (u(), d("div", VP, [
        Ct.value ? (u(), d("div", qP, [
          i("span", {
            class: "fe-spdf__propname",
            style: Vt({ "--spdf-color": E(Ct.value) })
          }, f(I(Ct.value)), 5),
          O(Ct.value.assignee) ? (u(), d("span", jP, f(O(Ct.value.assignee)), 1)) : T("", !0),
          i("button", {
            type: "button",
            class: "fe-btn fe-btn--sm",
            "data-testid": "surface-pdf-unplace",
            onClick: te
          }, f(r(n)("plugin.pdf.unplace")), 1),
          W.value.length > 1 ? (u(), d("label", WP, [
            i("span", null, f(r(n)("plugin.pdf.copy_to_page")), 1),
            dt(i("input", {
              "onUpdate:modelValue": oe[0] || (oe[0] = (Oe) => Qt.value = Oe),
              class: "fe-cfield__input fe-spdf__num",
              type: "number",
              min: "1",
              max: W.value.length,
              "data-testid": "surface-pdf-copy-page"
            }, null, 8, YP), [
              [
                St,
                Qt.value,
                void 0,
                { number: !0 }
              ]
            ]),
            i("button", {
              type: "button",
              class: "fe-btn fe-btn--sm",
              "data-testid": "surface-pdf-copy",
              onClick: ta
            }, f(r(n)("plugin.pdf.copy")), 1)
          ])) : T("", !0),
          i("button", {
            type: "button",
            class: "fe-btn fe-btn--sm fe-btn--danger",
            "data-testid": "surface-pdf-delete",
            onClick: oe[1] || (oe[1] = (Oe) => _t(Ct.value.id))
          }, f(r(n)("plugin.pdf.delete")), 1)
        ])) : tt.value ? (u(), d("p", GP, f(r(n)("plugin.pdf.place_box_hint", { name: Te(g.value.find((Oe) => Oe.id === tt.value) ?? g.value[0]) })), 1)) : (u(), d("p", XP, f(r(n)(Le.value.length ? "plugin.pdf.place_idle" : "plugin.pdf.place_idle_done")), 1))
      ])) : o.value && Ct.value && !Ft.value ? (u(), d("div", JP, [
        ot(Jb, {
          field: Ct.value,
          signers: v.value,
          formats: e.formats,
          "date-labels": e.dateLabels,
          "stamp-lines": e.stampLines,
          locale: e.locale,
          disabled: e.disabled,
          "testid-prefix": "surface-pdf",
          onPatch: At,
          onRemove: oe[3] || (oe[3] = (Oe) => _t(Ct.value.id))
        }, {
          extra: yt(() => [
            W.value.length > 1 ? (u(), d("label", ZP, [
              i("span", null, f(r(n)("plugin.pdf.copy_to_page")), 1),
              dt(i("input", {
                "onUpdate:modelValue": oe[2] || (oe[2] = (Oe) => Qt.value = Oe),
                class: "fe-cfield__input fe-spdf__num",
                type: "number",
                min: "1",
                max: W.value.length,
                "data-testid": "surface-pdf-copy-page"
              }, null, 8, QP), [
                [
                  St,
                  Qt.value,
                  void 0,
                  { number: !0 }
                ]
              ]),
              i("button", {
                type: "button",
                class: "fe-btn fe-btn--sm",
                "data-testid": "surface-pdf-copy",
                onClick: ta
              }, f(r(n)("plugin.pdf.copy")), 1)
            ])) : T("", !0)
          ]),
          _: 1
        }, 8, ["field", "signers", "formats", "date-labels", "stamp-lines", "locale", "disabled"])
      ])) : T("", !0),
      p.value ? T("", !0) : (u(), d("div", {
        key: 5,
        ref_key: "containerEl",
        ref: K,
        class: "fe-spdf__scroll"
      }, [
        F.value === "loading" ? (u(), d("p", eO, f(r(n)("plugin.view.loading")), 1)) : F.value === "error" ? (u(), d("p", tO, f(r(n)("plugin.pdf.load_failed")), 1)) : (u(), d("div", aO, [
          (u(!0), d(he, null, We(W.value, (Oe) => (u(), d("div", {
            key: Oe.num,
            ref_for: !0,
            ref: (Ne) => q(Oe.num, Ne),
            class: "fe-spdf__page",
            "data-page": Oe.num,
            style: Vt({ width: `${we.value}px`, aspectRatio: `${Oe.width} / ${Oe.height}` }),
            onPointerdown: (Ne) => L(Ne, Oe.num)
          }, [
            (u(!0), d(he, null, We(C.value.get(Oe.num) ?? [], (Ne) => (u(), d("div", {
              key: Ne.id,
              class: Re(["fe-spdf__field", [
                `fe-spdf__field--${Ne.type}`,
                {
                  "is-selected": o.value && fe.value === Ne.id,
                  "is-mine": z(Ne),
                  "is-foreign": !o.value && !z(Ne),
                  "is-filled": r(Fv)(Ne),
                  "is-required": Ne.required === !0
                }
              ]]),
              style: Vt({ left: `${Ne.x * 100}%`, top: `${Ne.y * 100}%`, width: `${Ne.w * 100}%`, height: `${Ne.h * 100}%`, "--spdf-color": E(Ne) }),
              "data-testid": `surface-pdf-field-${Ne.id}`,
              "data-field-type": Ne.type,
              role: z(Ne) ? "button" : void 0,
              tabindex: z(Ne) ? 0 : void 0,
              title: o.value || !z(Ne) ? O(Ne.assignee) : void 0,
              onPointerdown: (Ee) => se(Ee, Ne, Oe.num),
              onClick: (Ee) => _a(Ne),
              onKeydown: ya(ft((Ee) => _a(Ne), ["prevent"]), ["enter"])
            }, [
              (Ne.type === "signature" || Ne.type === "initials") && Bt(Ne) ? (u(), d("img", {
                key: 0,
                class: "fe-spdf__sig",
                src: Bt(Ne),
                alt: ""
              }, null, 8, oO)) : Ne.type === "text" && z(Ne) ? (u(), d("input", {
                key: 1,
                class: Re(["fe-spdf__text", Dt(Ne)]),
                type: "text",
                value: typeof Ne.value == "string" ? Ne.value : "",
                placeholder: I(Ne),
                "aria-label": I(Ne),
                inputmode: r(M3)(Ot(Ne)),
                maxlength: r(U1)(Ot(Ne)),
                "aria-invalid": Et(Ne) ? "true" : void 0,
                "aria-describedby": It(Ne) ? `${e.id}-${Ne.id}-rule` : void 0,
                title: It(Ne) || void 0,
                disabled: e.disabled,
                "data-testid": `surface-pdf-text-${Ne.id}`,
                onPointerdown: oe[4] || (oe[4] = ft(() => {
                }, ["stop"])),
                onClick: oe[5] || (oe[5] = ft(() => {
                }, ["stop"])),
                onInput: (Ee) => ia(Ne, Ee)
              }, null, 42, iO)) : Ne.type === "checkbox" && Ne.value === !0 ? (u(), d("span", {
                key: 2,
                class: "fe-spdf__check",
                "aria-hidden": "true",
                innerHTML: r(aa)
              }, null, 8, rO)) : Ne.type === "date" && typeof Ne.value == "string" && Ne.value ? (u(), d("span", {
                key: 3,
                class: Re(["fe-spdf__val", Dt(Ne)])
              }, f(Ne.value), 3)) : (u(), d("span", lO, [
                $t(f(I(Ne)) + " ", 1),
                z(Ne) ? (u(), d("small", uO, f(r(n)(`plugin.pdf.tap_${Ne.type}`)), 1)) : Ne.assignee && (o.value || !z(Ne)) ? (u(), d("small", cO, f(O(Ne.assignee)), 1)) : T("", !0)
              ])),
              !o.value && z(Ne) && Ne.type === "text" && (Et(Ne) || It(Ne)) ? (u(), d("span", {
                key: 5,
                id: `${e.id}-${Ne.id}-rule`,
                class: Re(["fe-spdf__rule", { "is-bad": !!Et(Ne) }]),
                role: Et(Ne) ? "alert" : void 0,
                "data-testid": `surface-pdf-rule-${Ne.id}`
              }, f(Et(Ne) || It(Ne)), 11, dO)) : T("", !0),
              o.value ? (u(), d("span", {
                key: 6,
                class: "fe-spdf__handle",
                "data-testid": "surface-pdf-handle",
                onPointerdown: (Ee) => ne(Ee, Ne, Oe.num)
              }, null, 40, fO)) : T("", !0)
            ], 46, sO))), 128)),
            qe.value && qe.value.page === Oe.num ? (u(), d("div", {
              key: 0,
              class: "fe-spdf__field fe-spdf__field--ghost",
              style: Vt({ left: `${qe.value.x * 100}%`, top: `${qe.value.y * 100}%`, width: `${qe.value.w * 100}%`, height: `${qe.value.h * 100}%` })
            }, null, 4)) : T("", !0)
          ], 44, nO))), 128))
        ]))
      ], 512)),
      !o.value && _e.value ? (u(), d("div", pO, [
        i("p", vO, f(r(n)("plugin.pdf.pad_for", { type: I(_e.value) })), 1),
        ot(o0, {
          id: `${e.id}-${_e.value.id}`,
          "model-value": at.value,
          modes: Ve.value,
          font: _e.value.font,
          fonts: Je.value,
          locale: e.locale,
          disabled: e.disabled,
          width: _e.value.type === "initials" ? 240 : void 0,
          height: _e.value.type === "initials" ? 120 : void 0,
          "onUpdate:modelValue": xt
        }, null, 8, ["id", "model-value", "modes", "font", "fonts", "locale", "disabled", "width", "height"]),
        i("button", {
          type: "button",
          class: "fe-btn fe-btn--sm",
          "data-testid": "surface-pdf-pad-done",
          onClick: oe[6] || (oe[6] = (Oe) => va.value = "")
        }, f(r(n)("plugin.pdf.pad_done")), 1)
      ])) : T("", !0)
    ], 14, SP));
  }
}), mO = { class: "fe-surface" }, yO = ["data-node"], gO = {
  key: 1,
  class: "fe-surface__divider"
}, bO = {
  key: 2,
  class: "fe-surface__row"
}, _O = ["data-node-type"], kO = {
  key: 14,
  class: "fe-surface__error"
}, wO = /* @__PURE__ */ rt({
  __name: "SurfaceRenderer",
  props: {
    nodes: {},
    locale: {},
    theme: {},
    errors: {},
    values: {},
    api: {},
    plugin: {},
    storages: {},
    startAt: {},
    disabled: { type: Boolean },
    fileUrl: { type: Function },
    pdfWorkerUrl: {},
    invalidKeys: {},
    layout: {},
    pageHeight: {}
  },
  emits: ["update:values", "change", "action"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n } = gt(() => t.locale), o = () => t.values ?? {};
    function p($, C) {
      s("update:values", { ...o(), [$]: C });
    }
    function h($) {
      s("update:values", $), s("change");
    }
    function v($, C) {
      p($.id, C), y($).mode !== "fill" && s("change");
    }
    function y($) {
      return $.props ?? {};
    }
    function g($) {
      const C = y($);
      return jt(C.text ?? C.value ?? "", t.locale);
    }
    function m($) {
      const C = String(y($).tone ?? "");
      return C === "muted" || C === "danger" || C === "info" ? `fe-surface__text--${C}` : "";
    }
    function k($) {
      return !$.id || !t.errors ? "" : jt(t.errors[$.id], t.locale);
    }
    function _($) {
      return typeof $ == "string" ? $ : "";
    }
    function w($) {
      return Array.isArray($) ? $ : [];
    }
    return ($, C) => {
      const E = US("SurfaceRenderer", !0);
      return u(), d("div", mO, [
        (u(!0), d(he, null, We(e.nodes, (A, O) => (u(), d(he, {
          key: A.id || O
        }, [
          A.type === "text" ? (u(), d("p", {
            key: 0,
            class: Re(["fe-surface__text", [m(A), y(A).heading ? "fe-surface__text--heading" : ""]]),
            "data-node": A.id || void 0
          }, f(g(A)), 11, yO)) : A.type === "divider" ? (u(), d("hr", gO)) : A.type === "row" ? (u(), d("div", bO, [
            ot(E, {
              nodes: A.children ?? [],
              locale: e.locale,
              theme: e.theme,
              errors: e.errors,
              values: e.values,
              api: e.api,
              plugin: e.plugin,
              storages: e.storages,
              "start-at": e.startAt,
              disabled: e.disabled,
              "file-url": e.fileUrl,
              "pdf-worker-url": e.pdfWorkerUrl,
              "invalid-keys": e.invalidKeys,
              layout: e.layout,
              "page-height": e.pageHeight,
              "onUpdate:values": C[0] || (C[0] = (z) => s("update:values", z)),
              onChange: C[1] || (C[1] = (z) => s("change")),
              onAction: C[2] || (C[2] = (z) => s("action", z))
            }, null, 8, ["nodes", "locale", "theme", "errors", "values", "api", "plugin", "storages", "start-at", "disabled", "file-url", "pdf-worker-url", "invalid-keys", "layout", "page-height"])
          ])) : A.type === "form" ? (u(), nt(V4, {
            key: 3,
            fields: y(A).fields ?? [],
            values: o(),
            locale: e.locale,
            errors: e.errors,
            invalid: e.invalidKeys,
            disabled: e.disabled,
            "onUpdate:values": h
          }, null, 8, ["fields", "values", "locale", "errors", "invalid", "disabled"])) : A.type === "steps" ? (u(), nt(X4, {
            key: 4,
            items: y(A).items ?? [],
            locale: e.locale
          }, null, 8, ["items", "locale"])) : A.type === "list" ? (u(), nt(J5, {
            key: 5,
            columns: y(A).columns ?? [],
            rows: y(A).rows ?? [],
            empty: y(A).empty,
            locale: e.locale,
            disabled: e.disabled,
            "table-id": e.plugin ? `app.${e.plugin}.${A.id || "list"}` : void 0,
            onAction: C[3] || (C[3] = (z) => s("action", z))
          }, null, 8, ["columns", "rows", "empty", "locale", "disabled", "table-id"])) : A.type === "progress" ? (u(), nt(nD, {
            key: 6,
            value: y(A).value,
            label: y(A).label,
            locale: e.locale
          }, null, 8, ["value", "label", "locale"])) : A.type === "people-picker" && A.id ? (u(), nt(wD, {
            key: 7,
            id: A.id,
            "model-value": w(o()[A.id]),
            multi: y(A).multi === !0,
            "allow-external": y(A).allow_external === !0,
            api: e.api,
            plugin: e.plugin,
            locale: e.locale,
            disabled: e.disabled,
            invalid: !!k(A),
            "onUpdate:modelValue": (z) => p(A.id, z)
          }, null, 8, ["id", "model-value", "multi", "allow-external", "api", "plugin", "locale", "disabled", "invalid", "onUpdate:modelValue"])) : A.type === "pin-input" && A.id ? (u(), nt(TD, {
            key: 8,
            id: A.id,
            length: y(A).length,
            "model-value": _(o()[A.id]),
            locale: e.locale,
            disabled: e.disabled,
            invalid: !!k(A),
            "onUpdate:modelValue": (z) => p(A.id, z)
          }, null, 8, ["id", "length", "model-value", "locale", "disabled", "invalid", "onUpdate:modelValue"])) : A.type === "file-chooser" && A.id ? (u(), nt(l8, {
            key: 9,
            id: A.id,
            kind: y(A).kind,
            "model-value": _(o()[A.id]),
            api: e.api,
            storages: e.storages,
            "start-at": e.startAt,
            locale: e.locale,
            theme: e.theme,
            disabled: e.disabled,
            invalid: !!k(A),
            "onUpdate:modelValue": (z) => p(A.id, z)
          }, null, 8, ["id", "kind", "model-value", "api", "storages", "start-at", "locale", "theme", "disabled", "invalid", "onUpdate:modelValue"])) : A.type === "preview" ? (u(), nt(g8, {
            key: 10,
            path: _(y(A).path),
            "file-ref": _(y(A).ref),
            "file-url": e.fileUrl,
            api: e.api,
            locale: e.locale
          }, null, 8, ["path", "file-ref", "file-url", "api", "locale"])) : A.type === "signature-pad" && A.id ? (u(), nt(o0, {
            key: 11,
            id: A.id,
            modes: y(A).modes,
            width: y(A).width,
            height: y(A).height,
            font: y(A).font,
            fonts: y(A).fonts,
            label: r(jt)(y(A).label ?? "", e.locale),
            required: y(A).required === !0,
            "model-value": r(Nl)(o()[A.id]) ? o()[A.id] : null,
            locale: e.locale,
            disabled: e.disabled,
            invalid: !!k(A),
            "onUpdate:modelValue": (z) => p(A.id, z)
          }, null, 8, ["id", "modes", "width", "height", "font", "fonts", "label", "required", "model-value", "locale", "disabled", "invalid", "onUpdate:modelValue"])) : A.type === "pdf-fields" && A.id ? (u(), nt(hO, {
            key: 12,
            id: A.id,
            src: y(A).src,
            mode: y(A).mode,
            fields: y(A).fields,
            layout: e.layout,
            "page-height": e.pageHeight,
            signers: y(A).signers,
            signer: y(A).signer,
            types: y(A).types,
            formats: y(A).formats,
            "date-labels": y(A).date_labels,
            "stamp-lines": y(A).stamp_lines,
            "model-value": o()[A.id],
            api: e.api,
            "file-url": e.fileUrl,
            "pdf-worker-url": e.pdfWorkerUrl,
            locale: e.locale,
            theme: e.theme,
            disabled: e.disabled,
            invalid: !!k(A),
            "onUpdate:modelValue": (z) => v(A, z)
          }, null, 8, ["id", "src", "mode", "fields", "layout", "page-height", "signers", "signer", "types", "formats", "date-labels", "stamp-lines", "model-value", "api", "file-url", "pdf-worker-url", "locale", "theme", "disabled", "invalid", "onUpdate:modelValue"])) : (u(), d("p", {
            key: 13,
            class: "fe-surface__unknown",
            "data-node-type": A.type
          }, f(r(n)("plugin.view.unsupported", { type: A.type })), 9, _O)),
          k(A) && A.type !== "form" ? (u(), d("p", kO, f(k(A)), 1)) : T("", !0)
        ], 64))), 128))
      ]);
    };
  }
}), xO = {
  key: 1,
  class: "fe-surface__text fe-surface__text--info",
  role: "status"
}, $O = {
  key: 2,
  class: "fe-surface__text fe-surface__text--muted"
}, SO = {
  key: 3,
  class: "fe-surface__error",
  role: "alert"
}, Xd = /* @__PURE__ */ rt({
  __name: "SurfaceConversation",
  props: {
    conv: {},
    locale: {},
    theme: {},
    api: {},
    plugin: {},
    storages: {},
    startAt: {},
    fileUrl: { type: Function },
    toast: {},
    layout: {},
    pageHeight: {}
  },
  setup(e) {
    const a = e, { t } = gt(() => a.locale);
    return (s, n) => (u(), d(he, null, [
      e.conv.current.value ? (u(), nt(wO, {
        key: 0,
        nodes: e.conv.current.value.nodes ?? [],
        locale: e.locale,
        theme: e.theme,
        errors: e.conv.errors.value,
        values: e.conv.values.value,
        api: e.api,
        plugin: e.plugin,
        storages: e.storages,
        "start-at": e.startAt,
        "file-url": e.fileUrl,
        layout: e.layout,
        "page-height": e.pageHeight,
        "invalid-keys": e.conv.invalidKeys.value,
        disabled: e.conv.busy.value,
        "onUpdate:values": e.conv.updateValues,
        onChange: e.conv.scheduleChange,
        onAction: e.conv.rowAction
      }, null, 8, ["nodes", "locale", "theme", "errors", "values", "api", "plugin", "storages", "start-at", "file-url", "layout", "page-height", "invalid-keys", "disabled", "onUpdate:values", "onChange", "onAction"])) : T("", !0),
      e.toast ? (u(), d("p", xO, f(e.toast), 1)) : T("", !0),
      e.conv.busy.value ? (u(), d("p", $O, f(r(t)("plugin.view.busy")), 1)) : T("", !0),
      e.conv.failure.value ? (u(), d("p", SO, f(e.conv.failure.value), 1)) : T("", !0)
    ], 64));
  }
});
function TO(e) {
  let a = !1;
  return Eu(e, (t) => {
    t.type === "steps" && (a = !0);
  }), a;
}
const CO = /* @__PURE__ */ new Set(["back", "prev", "previous", "stepback", "goback", "prevstep", "previousstep"]);
function EO(e) {
  const a = String((e == null ? void 0 : e.id) ?? "").toLowerCase().replace(/[^a-z]/g, "");
  return CO.has(a);
}
function AO(e, a) {
  const t = (e ?? []).filter((p) => p && p.id);
  if (!a)
    return { back: null, others: t, primary: null };
  const s = t.find(EO) ?? null, n = t.filter((p) => p !== s), o = n.find((p) => p.primary === !0) ?? null;
  return { back: s, others: n.filter((p) => p !== o), primary: o };
}
const zO = ["disabled", "data-testid", "onClick"], Jd = /* @__PURE__ */ rt({
  __name: "SurfaceFooterButtons",
  props: {
    conv: {},
    locale: {},
    testidPrefix: {},
    small: { type: Boolean }
  },
  setup(e) {
    const a = e, t = x(() => {
      var p;
      return TO((p = a.conv.current.value) == null ? void 0 : p.nodes);
    }), s = x(() => AO(a.conv.footer.value, t.value)), n = x(() => {
      const p = s.value;
      return [...p.back ? [p.back] : [], ...p.others, ...p.primary ? [p.primary] : []];
    });
    function o(p) {
      return t.value ? p === s.value.primary : p.primary === !0;
    }
    return (p, h) => (u(!0), d(he, null, We(n.value, (v) => (u(), d("button", {
      key: v.id,
      type: "button",
      class: Re(["fe-btn", {
        "fe-btn--sm": e.small,
        "fe-btn--primary": o(v) && !v.danger,
        "fe-btn--danger": v.danger,
        "fe-surface__back": t.value && v === s.value.back
      }]),
      disabled: a.conv.busy.value || v.disabled,
      "data-testid": `${e.testidPrefix}-action-${v.id}`,
      onClick: (y) => a.conv.press(v)
    }, f(r(jt)(v.label, e.locale)), 11, zO))), 128));
  }
}), u0 = 1, MO = "filex:hello", DO = "filex:port", PO = [
  "session.get",
  "file.read",
  "file.save",
  "file.saveAs",
  "ui.dirty",
  "ui.title",
  "ui.toast",
  "ui.confirm",
  "ui.close",
  "clipboard.write",
  "ui.download",
  "engine.call",
  "job.submit",
  "state.get",
  "state.set"
], rs = {
  /** `file.read({as: 'text'})` refuses a file larger than this; read a stream. */
  maxTextBytes: 32 << 20,
  /** One `state.set` value, as JSON. */
  maxStateBytes: 8192,
  /** A `ui.toast` / `ui.title` text, in characters. */
  maxLineChars: 300,
  /** How long the SDK waits for the host's port. */
  connectTimeoutMs: 1e4,
  /** The largest file `ui.download` hands the person (streamed or not). */
  maxDownloadBytes: 256 << 20
};
function OO(e) {
  return !!e && typeof e == "object" && e.type === MO && typeof e.v == "number";
}
function LO(e) {
  return !!e && typeof e == "object" && typeof e.id == "number" && typeof e.method == "string";
}
function IO(e) {
  return PO.includes(e);
}
const Ip = { inFlight: 32, perWindow: 400, windowMs: 1e4 };
class ca extends Error {
  constructor(t, s) {
    super(s || t);
    Aa(this, "code");
    this.name = "BridgeFailure", this.code = t;
  }
}
function RO(e) {
  if (!e || typeof e != "object") return [];
  const a = [];
  for (const t of Object.values(e))
    (t instanceof ArrayBuffer || typeof ReadableStream < "u" && t instanceof ReadableStream) && a.push(t);
  return a;
}
const NO = /^[a-z][a-z0-9_]{0,39}$/;
function BO(e) {
  if (e instanceof ca) return { code: e.code, message: e.message };
  const a = e ?? {}, t = typeof a.status == "number" ? a.status : 0, s = typeof a.code == "string" && NO.test(a.code) ? a.code : "";
  let n = "failed";
  return t === 404 ? n = "not_found" : t === 413 ? n = "too_large" : t === 400 || t === 422 ? n = "invalid" : t === 409 && s === "read_only" ? n = "read_only" : t === 403 && s === "not_granted" && (n = "not_granted"), { code: n, message: s || n };
}
function FO(e) {
  const a = e.win ?? window;
  let t = null, s = !1, n = 0, o = !1, p = 0;
  const h = /* @__PURE__ */ new Map();
  function v(C) {
    var E;
    if (t) {
      t.onmessage = null;
      try {
        t.close();
      } catch {
      }
      t = null;
      for (const [, A] of h)
        clearTimeout(A.timer), A.reject(new ca("unavailable", "the interface went away"));
      h.clear(), (E = e.onDisconnect) == null || E.call(e, C);
    }
  }
  let y = 0, g = 0, m = 0;
  function k() {
    const C = Date.now();
    return C - g >= Ip.windowMs && (g = C, m = 0), m >= Ip.perWindow ? !1 : (m++, !0);
  }
  async function _(C, E, A, O) {
    let z, P = [];
    if (!k())
      z = { id: E, error: { code: "unavailable", message: "busy" } };
    else if (!IO(A))
      z = { id: E, error: { code: "unknown_method", message: A } };
    else {
      const I = e.handlers[A];
      if (!I)
        z = { id: E, error: { code: "unavailable", message: `${A} is not offered here` } };
      else if (y >= Ip.inFlight)
        z = { id: E, error: { code: "unavailable", message: "busy" } };
      else {
        y++;
        try {
          const F = await I(O);
          z = { id: E, result: F }, P = RO(F);
        } catch (F) {
          z = { id: E, error: BO(F) };
        } finally {
          y--;
        }
      }
    }
    if (C === t)
      try {
        C.postMessage(z, P);
      } catch {
        C.postMessage({ id: E, error: { code: "failed", message: "the answer cannot be sent to the interface" } });
      }
  }
  function w(C) {
    return (E) => {
      const A = E.data;
      if (!(!A || typeof A != "object")) {
        if (typeof A.hid == "number") {
          const O = h.get(A.hid);
          if (!O) return;
          if (h.delete(A.hid), clearTimeout(O.timer), A.error) {
            const z = A.error;
            O.reject(new ca(z.code ?? "failed", z.message));
          } else O.resolve(A.result);
          return;
        }
        LO(A) && _(C, A.id, A.method, A.params);
      }
    };
  }
  function $(C) {
    var z, P;
    if (o || s) return;
    const E = e.frame(), A = E == null ? void 0 : E.contentWindow;
    if (!E || !A || C.source !== A || !OO(C.data) || n > 1) return;
    s = !0;
    const O = new MessageChannel();
    t = O.port1, t.onmessage = w(t), (z = t.start) == null || z.call(t), A.postMessage({ type: DO, v: u0 }, "*", [O.port2]), (P = e.onConnect) == null || P.call(e);
  }
  return a.addEventListener("message", $), {
    connected: () => t !== null,
    emit(C, E, A = []) {
      if (t)
        try {
          t.postMessage({ event: C, data: E }, A);
        } catch {
        }
    },
    ask(C, E, A = 6e4) {
      const O = t;
      if (!O) return Promise.reject(new ca("unavailable", "the interface is not connected"));
      const z = ++p;
      return new Promise((P, I) => {
        const F = setTimeout(() => {
          h.delete(z), I(new ca("failed", `the interface did not answer "${C}"`));
        }, A);
        h.set(z, { resolve: P, reject: I, timer: F }), O.postMessage({ hid: z, request: C, params: E });
      });
    },
    frameLoaded() {
      n++, n > 1 && v("reload");
    },
    destroy() {
      o = !0, a.removeEventListener("message", $), v("destroyed");
    }
  };
}
const UO = ["theme", "palette", "density", "locale", "storageOrder", "tour", "appState", "appsSeen"], _d = ["theme", "palette", "density", "locale", "storageOrder"], iu = {
  theme: "filex.theme",
  palette: "filex.palette",
  density: "filex.density",
  locale: "filex.locale",
  // New in 0.45.2 (#57); no earlier reader to stay compatible with.
  storageOrder: "filex.storageOrder"
}, c0 = 400, Vv = "filex.session";
let Zd = !1;
function HO() {
  try {
    return localStorage.getItem(Vv) === "1";
  } catch {
    return !1;
  }
}
function Vr() {
  return Zd ? !1 : _o.sessionAware ? HO() : !0;
}
function KO(e) {
  try {
    e ? localStorage.setItem(Vv, "1") : localStorage.removeItem(Vv);
  } catch {
  }
  e && (Zd = !1);
}
function Ohe() {
  Zd = !0;
}
const d0 = new Set(Object.values(iu));
function VO(e) {
  d0.add(e);
}
function Lhe() {
  KO(!1);
  for (const e of d0)
    try {
      localStorage.removeItem(e);
    } catch {
    }
  Ns = {}, Qd = !1, fi = {}, on !== null && clearTimeout(on), on = null, qv();
}
let _o = { surface: "web" }, Ns = {}, Qd = !1, sm = !1, Au = !1;
const kd = /* @__PURE__ */ new Set(), ru = /* @__PURE__ */ new Set();
function Ihe(e) {
  _o = { ...e }, sm = !0;
}
function om() {
  return sm;
}
function qO() {
  return Au;
}
function jO(e) {
  return Au ? (e(), () => {
  }) : (ru.add(e), () => ru.delete(e));
}
function qv() {
  Au = !0;
  const e = [...ru];
  ru.clear();
  for (const a of e)
    try {
      a();
    } catch {
    }
}
function wi() {
  return { ...Ns };
}
function f0() {
  return Qd;
}
function im(e) {
  return kd.add(e), () => kd.delete(e);
}
function WO() {
  const e = wi();
  for (const a of kd)
    try {
      a(e);
    } catch {
    }
}
function wd(e) {
  try {
    return localStorage.getItem(iu[e]) ?? "";
  } catch {
    return "";
  }
}
function di(e, a) {
  try {
    a ? localStorage.setItem(iu[e], a) : localStorage.removeItem(iu[e]);
  } catch {
  }
}
function YO() {
  const e = {};
  for (const a of _d) {
    const t = wd(a);
    t && (e[a] = t);
  }
  return e;
}
function p0() {
  return `${Ad(_o.base)}/api/me/prefs?surface=${encodeURIComponent(_o.surface)}`;
}
async function v0(e) {
  const a = { Accept: "application/json" };
  e && (a["Content-Type"] = "application/json");
  const t = _o.headers ? await _o.headers() : {};
  return { ...a, ...t };
}
function GO(e) {
  const a = e && typeof e == "object" ? e : {}, t = a.prefs && typeof a.prefs == "object" ? a.prefs : a, s = {};
  for (const n of UO) {
    const o = t[n];
    typeof o == "string" && o && (s[n] = o);
  }
  return s;
}
async function Rhe() {
  const e = _o.fetchImpl ?? (typeof fetch == "function" ? fetch : null);
  if (!e)
    return qv(), null;
  Au = !1;
  try {
    const a = await e(p0(), {
      method: "GET",
      headers: await v0(!1),
      credentials: "same-origin",
      cache: "no-store"
    });
    if (!a.ok) return null;
    if (Ns = GO(await a.json()), Qd = !0, !Object.keys(Ns).length) {
      const t = YO();
      if (Object.keys(t).length) {
        Ns = t;
        for (const s of _d) t[s] && (fi[s] = t[s]);
        on !== null && clearTimeout(on), on = setTimeout(() => {
          lu = rm();
        }, c0);
      }
    }
    for (const t of _d) di(t, Ns[t] ?? "");
    return WO(), wi();
  } catch {
    return null;
  } finally {
    qv();
  }
}
let fi = {}, on = null, lu = null;
async function rm() {
  on = null;
  const e = fi;
  if (fi = {}, !Object.keys(e).length) return;
  const a = { prefs: wi() }, t = _o.fetchImpl ?? (typeof fetch == "function" ? fetch : null);
  if (t)
    try {
      await t(p0(), {
        method: "PUT",
        headers: await v0(!0),
        credentials: "same-origin",
        body: JSON.stringify(a)
      });
    } catch {
    }
}
function pi(e, a) {
  Ns = { ...Ns, [e]: a }, _d.includes(e) && di(e, a), fi = { ...fi, [e]: a }, on !== null && clearTimeout(on), on = setTimeout(() => {
    lu = rm();
  }, c0);
}
async function XO() {
  on !== null && (clearTimeout(on), lu = rm()), await lu;
}
function Nhe() {
  Ns = {}, Qd = !1, Zd = !1, fi = {}, on !== null && clearTimeout(on), on = null, lu = null, kd.clear(), Au = !1, ru.clear(), sm = !1;
}
const Zb = 16384;
function ef(e) {
  const a = wi()[e];
  if (!a) return {};
  try {
    const t = JSON.parse(a);
    return t && typeof t == "object" && !Array.isArray(t) ? t : {};
  } catch {
    return {};
  }
}
function JO(e, a) {
  const t = ef("appState")[e];
  return t && Object.prototype.hasOwnProperty.call(t, a) ? t[a] : void 0;
}
class Kc extends Error {
}
function ZO(e, a, t) {
  if (!a || a.length > 128 || a === "__proto__" || a === "constructor" || a === "prototype")
    throw new Kc("a state key is 1-128 characters");
  const s = t === void 0 ? void 0 : JSON.stringify(t);
  if (s !== void 0 && s.length > rs.maxStateBytes)
    throw new Kc(`a state value is at most ${rs.maxStateBytes} bytes as JSON`);
  const n = ef("appState"), o = { ...n[e] ?? {} };
  if (s === void 0 ? delete o[a] : o[a] = JSON.parse(s), JSON.stringify(o).length > Zb)
    throw new Kc(`an app keeps at most ${Zb} bytes`);
  const p = { ...n, [e]: o };
  Object.keys(o).length || delete p[e], pi("appState", JSON.stringify(p));
}
function QO(e) {
  const a = ef("appsSeen")[e];
  return typeof a == "string" ? a : "";
}
function Qb(e, a) {
  const t = ef("appsSeen");
  t[e] !== a && pi("appsSeen", JSON.stringify({ ...t, [e]: a }));
}
const eL = { "data-testid": "plugin-confirm-message" }, h0 = /* @__PURE__ */ rt({
  __name: "PluginConfirmModal",
  props: {
    open: { type: Boolean },
    locale: {},
    theme: {},
    title: {},
    message: {},
    danger: { type: Boolean }
  },
  emits: ["close", "confirm"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n } = gt(() => t.locale);
    return (o, p) => (u(), nt(la, {
      open: e.open,
      title: e.title || r(n)("plugin.confirm.title"),
      size: "sm",
      theme: e.theme,
      locale: e.locale,
      onClose: p[2] || (p[2] = (h) => s("close"))
    }, {
      actions: yt(() => [
        i("button", {
          type: "button",
          class: "fe-btn",
          onClick: p[0] || (p[0] = (h) => s("close"))
        }, f(r(n)("plugin.confirm.cancel")), 1),
        i("button", {
          type: "button",
          class: Re(["fe-btn", e.danger ? "fe-btn--danger" : "fe-btn--primary"]),
          "data-testid": "plugin-confirm-run",
          onClick: p[1] || (p[1] = (h) => s("confirm"))
        }, f(r(n)("plugin.confirm.run")), 3)
      ]),
      default: yt(() => [
        i("p", eL, f(e.message), 1)
      ]),
      _: 1
    }, 8, ["open", "title", "theme", "locale"]));
  }
}), tL = ["data-app", "data-connected"], aL = {
  key: 0,
  class: "fe-appframe__note",
  role: "status",
  "data-testid": "appframe-updated"
}, nL = { class: "fe-appframe__note-text" }, sL = {
  key: 1,
  class: "fe-appframe__note fe-appframe__consent",
  role: "alertdialog",
  "aria-live": "assertive",
  "data-testid": "appframe-consent"
}, oL = { class: "fe-appframe__note-text" }, iL = ["disabled"], rL = { "data-testid": "appframe-unsaved" }, lL = ["disabled"], uL = ["disabled"], cL = ["disabled"], e_ = 5e3, dL = 600, tf = /* @__PURE__ */ rt({
  __name: "AppFrame",
  props: {
    api: {},
    app: {},
    version: {},
    view: {},
    placement: {},
    ui: {},
    files: {},
    savePath: {},
    readOnly: { type: Boolean },
    locale: {},
    theme: {},
    userName: {},
    title: {},
    pickFolder: { type: Function }
  },
  emits: ["connected", "dirty", "title", "toast", "close", "saved", "saved-as", "op"],
  setup(e, { expose: a, emit: t }) {
    const s = e, n = t, { t: o } = gt(() => s.locale), p = Ld(), h = b(null);
    let v = null, y = null;
    const g = b(!1), m = b(!1), k = b(null), _ = b(!1), w = b(0), $ = b(null), C = x(() => $.value ?? s.ui), E = b(""), A = b(""), O = x(() => s.api.appUIUrl(C.value.url)), z = x(() => new Set(C.value.grants ?? [])), P = x(() => {
      var H;
      return ((H = $.value) == null ? void 0 : H.version) || s.version || s.ui.version || "";
    }), I = x(
      () => s.theme === "dark" || s.theme !== "light" && p.value ? "dark" : "light"
    ), F = [
      "--fe-bg",
      "--fe-bg-elev",
      "--fe-bg-hover",
      "--fe-bg-selected",
      "--fe-border",
      "--fe-border-soft",
      "--fe-border-strong",
      "--fe-text",
      "--fe-text-muted",
      "--fe-text-on-primary",
      "--fe-primary",
      "--fe-primary-hover",
      "--fe-primary-soft",
      "--fe-primary-ink",
      "--fe-danger",
      "--fe-danger-hover",
      "--fe-warning",
      "--fe-ok",
      "--fe-radius",
      "--fe-radius-sm",
      "--fe-radius-md",
      "--fe-radius-lg",
      "--fe-font",
      "--fe-font-mono",
      "--fe-text-xs",
      "--fe-text-sm",
      "--fe-text-md",
      "--fe-shadow",
      "--fe-shadow-sm"
    ];
    function W() {
      const H = {};
      if (h.value && typeof getComputedStyle == "function") {
        const te = getComputedStyle(h.value);
        for (const Te of F) {
          const L = te.getPropertyValue(Te).trim();
          L && (H[Te] = L);
        }
      }
      return { mode: I.value, tokens: H };
    }
    function N(H) {
      const te = H.lastIndexOf(".");
      return te > 0 ? H.slice(te + 1).toLowerCase() : "";
    }
    function K() {
      const H = z.value.has("files:write") && !s.readOnly;
      return (s.files ?? []).map((te, Te) => ({
        index: Te,
        name: te.name,
        ext: N(te.name),
        size: te.size ?? 0,
        mime: te.mime ?? "",
        readOnly: !H || !!te.readOnly
      }));
    }
    function M() {
      return {
        v: u0,
        app: { name: s.app, version: P.value },
        view: { id: s.view, placement: s.placement },
        locale: s.locale,
        dir: Tr(s.locale),
        theme: W(),
        user: { name: s.userName ?? "" },
        files: K(),
        grants: [...z.value]
      };
    }
    function j(H) {
      if (!z.value.has(H)) throw new ca("not_granted", `this app was not granted ${H}`);
    }
    function U(H) {
      const te = typeof H == "number" ? H : 0, Te = (s.files ?? [])[te];
      if (!Number.isInteger(te) || !Te) throw new ca("not_found", `no file at ${String(H)}`);
      return Te;
    }
    async function de(H, te) {
      const Te = typeof te == "string" && te.length < 200 ? te : "";
      if (typeof H == "string") return new Blob([H], { type: Te || "text/plain;charset=utf-8" });
      if (H instanceof ArrayBuffer) return new Blob([H], { type: Te });
      if (typeof ReadableStream < "u" && H instanceof ReadableStream) return H;
      throw new ca("invalid", "save takes a string, an ArrayBuffer or a ReadableStream");
    }
    const ke = b(null), ie = x(() => {
      const H = (s.title || "").trim();
      return H ? H.toLowerCase().includes(s.app.toLowerCase()) ? H : `${H} (${s.app})` : s.app;
    }), ce = b(null);
    let X = Number.NEGATIVE_INFINITY, Z = Number.NEGATIVE_INFINITY;
    function Y() {
      const H = typeof navigator < "u" ? navigator.userActivation : void 0;
      return !!(H != null && H.isActive);
    }
    function G() {
      Z = Date.now();
    }
    function we() {
      if (!Y()) return !1;
      const H = Date.now();
      return H - X < e_ || H - Z < e_ ? !1 : (X = H, !0);
    }
    async function R(H) {
      we() || await q(H);
    }
    const pe = b(!1);
    let Q = null;
    async function q(H) {
      if (ce.value) throw new ca("unavailable", "a question is already on screen");
      if (pe.value = !1, Q && clearTimeout(Q), Q = setTimeout(() => {
        pe.value = !0;
      }, dL), !await new Promise((Te) => {
        ce.value = { text: H, resolve: Te };
      })) throw new ca("cancelled");
    }
    function re() {
      return o("appframe.consent_clipboard", { app: ie.value });
    }
    function ae(H) {
      return o("appframe.consent_job", { app: ie.value, action: H });
    }
    function Pe(H) {
      return o("appframe.consent_download", { app: ie.value, name: H });
    }
    function be(H) {
      if (H && !pe.value) return;
      const te = ce.value;
      ce.value = null, Q && clearTimeout(Q), Q = null, te == null || te.resolve(H);
    }
    function ze(H) {
      const te = typeof H == "string" ? H.trim() : "";
      if (!te || te.length > 255 || te === "." || te === ".." || /[\\/\u0000-\u001f]/.test(te))
        throw new ca("invalid", "name is a file name, without a folder");
      return te;
    }
    function Ae() {
      return new ca("too_large", `at most ${rs.maxDownloadBytes >> 20} MiB`);
    }
    async function* Ce(H) {
      if (typeof H == "string") {
        yield new TextEncoder().encode(H);
        return;
      }
      if (H instanceof ArrayBuffer) {
        yield new Uint8Array(H);
        return;
      }
      const te = H.getReader();
      let Te = !1;
      try {
        for (; ; ) {
          const L = await te.read();
          if (L.done) {
            Te = !0;
            return;
          }
          L.value && (yield L.value);
        }
      } finally {
        Te || await te.cancel().catch(() => {
        });
      }
    }
    async function He(H, te, Te) {
      var Tt;
      const L = window.showSaveFilePicker;
      if (typeof L == "function") {
        let Ft = null;
        try {
          Ft = await L.call(window, { suggestedName: H });
        } catch (Lt) {
          if ((Lt == null ? void 0 : Lt.name) === "AbortError") throw new ca("cancelled");
          Ft = null;
        }
        if (Ft) {
          const Lt = await Ft.createWritable();
          let ua = 0;
          try {
            for await (const Ct of Ce(te)) {
              if (ua += Ct.byteLength, ua > rs.maxDownloadBytes) throw Ae();
              await Lt.write(Ct);
            }
          } catch (Ct) {
            throw await ((Tt = Lt.abort) == null ? void 0 : Tt.call(Lt).catch(() => {
            })), Ct;
          }
          return await Lt.close(), { saved: !0, size: ua };
        }
      }
      const se = [];
      let ne = 0;
      for await (const Ft of Ce(te)) {
        if (ne += Ft.byteLength, ne > rs.maxDownloadBytes) throw Ae();
        se.push(Ft);
      }
      const et = URL.createObjectURL(new Blob(se, { type: Te })), ht = document.createElement("a");
      ht.href = et, ht.download = H, ht.rel = "noopener", ht.style.display = "none", document.body.appendChild(ht);
      try {
        ht.click();
      } finally {
        ht.remove(), setTimeout(() => URL.revokeObjectURL(et), 6e4);
      }
      return { saved: !0, size: ne };
    }
    async function J(H) {
      try {
        const Te = (await s.api.pluginActions()).actions.find((se) => se.plugin === s.app && se.id === H), L = Te ? jt(Te.label, s.locale) : "";
        if (L) return L;
      } catch {
      }
      return H;
    }
    const me = {
      "session.get": () => M(),
      async "file.read"(H) {
        j("files:read");
        const te = H ?? {}, Te = U(te.index), L = await s.api.fetchResponse(Te.path), se = Number(L.headers.get("content-length") ?? Te.size ?? 0) || (Te.size ?? 0), ne = Te.mime || L.headers.get("content-type") || "", et = { name: Te.name, size: se, mime: ne };
        switch (te.as ?? "stream") {
          case "text": {
            if (se > rs.maxTextBytes) throw new ca("too_large", "read a file this large as a stream");
            return { ...et, text: await L.text() };
          }
          case "bytes":
            return { ...et, bytes: await L.arrayBuffer() };
          case "stream":
            return L.body ? { ...et, stream: L.body } : { ...et, bytes: await L.arrayBuffer() };
          default:
            throw new ca("invalid", "as is stream, bytes or text");
        }
      },
      async "file.save"(H) {
        j("files:write");
        const te = H ?? {}, Te = typeof te.index == "number" ? te.index : 0, L = U(Te);
        if (s.readOnly || L.readOnly) throw new ca("read_only", "this file cannot be saved over here");
        const se = await de(te.data, te.mime), ne = Te === 0 && s.savePath ? s.savePath : L.path, et = await s.api.pluginUISave(s.app, s.view, { path: ne }, se);
        return n("saved", { path: et.path || ne, size: et.size, index: Te }), m.value = !1, n("dirty", !1), { saved: !0, size: et.size };
      },
      async "file.saveAs"(H) {
        j("files:write");
        const te = H ?? {}, Te = typeof te.name == "string" ? te.name.trim() : "";
        if (!Te || Te.includes("/") || Te.includes("\\") || Te === "." || Te === ".." || Te.length > 255)
          throw new ca("invalid", "name is a file name, without a folder");
        if (!s.pickFolder) throw new ca("unavailable", "save-as is not offered here");
        const L = await de(te.data, te.mime), se = await s.pickFolder();
        if (!se) throw new ca("cancelled");
        const ne = await s.api.pluginUISave(s.app, s.view, { dir: se, name: Te }, L);
        return n("saved-as", { path: ne.path, name: ne.name, size: ne.size }), { saved: !0, name: ne.name, size: ne.size };
      },
      "ui.dirty"(H) {
        return m.value = !!(H != null && H.dirty), n("dirty", m.value), null;
      },
      "ui.title"(H) {
        const te = String((H == null ? void 0 : H.text) ?? "").slice(0, rs.maxLineChars);
        return n("title", te), null;
      },
      "ui.toast"(H) {
        const te = H ?? {}, Te = te.tone === "success" || te.tone === "warning" || te.tone === "error" ? te.tone : "info";
        return n("toast", { text: `${ie.value}: ${String(te.text ?? "").slice(0, rs.maxLineChars)}`, tone: Te }), null;
      },
      "ui.confirm"(H) {
        const te = typeof H == "object" && H ? H : {};
        if (ke.value) throw new ca("unavailable", "a question is already on screen");
        return new Promise((Te) => {
          ke.value = {
            text: String(te.text ?? "").slice(0, 1e3),
            title: te.title ? String(te.title).slice(0, rs.maxLineChars) : void 0,
            danger: !!te.danger,
            resolve: Te
          };
        });
      },
      "ui.close"() {
        return n("close"), null;
      },
      async "clipboard.write"(H) {
        var Te;
        const te = String((H == null ? void 0 : H.text) ?? "");
        if (te.length > 1 << 20) throw new ca("too_large", "at most 1 MiB of text");
        if (typeof navigator > "u" || !((Te = navigator.clipboard) != null && Te.writeText))
          throw new ca("unavailable", "this browser offers no clipboard here");
        if (we())
          try {
            return await navigator.clipboard.writeText(te), null;
          } catch (L) {
            if ((L == null ? void 0 : L.name) !== "NotAllowedError") throw L;
          }
        return await q(re()), await navigator.clipboard.writeText(te), null;
      },
      async "ui.download"(H) {
        j("ui:download");
        const te = H ?? {}, Te = ze(te.name), L = te.data, se = typeof ReadableStream < "u" && L instanceof ReadableStream;
        if (typeof L != "string" && !(L instanceof ArrayBuffer) && !se)
          throw new ca("invalid", "download takes a string, an ArrayBuffer or a ReadableStream");
        if ((typeof L == "string" ? new Blob([L]).size : L instanceof ArrayBuffer ? L.byteLength : 0) > rs.maxDownloadBytes) throw Ae();
        const et = typeof te.mime == "string" && /^[\w.+-]+\/[\w.+-]+$/.test(te.mime) ? te.mime : "application/octet-stream";
        try {
          await R(Pe(Te));
        } catch (ht) {
          throw se && await L.cancel().catch(() => {
          }), ht;
        }
        return He(Te, L, et);
      },
      async "engine.call"(H) {
        if (!C.value.engine) throw new ca("unavailable", "this app has no module");
        const te = H ?? {};
        if (typeof te.method != "string" || !te.method) throw new ca("invalid", "method is required");
        return (await s.api.pluginUICall(s.app, s.view, {
          method: te.method,
          params: te.params,
          paths: (s.files ?? []).map((L) => L.path)
        })).result;
      },
      async "job.submit"(H) {
        if (!C.value.engine) throw new ca("unavailable", "this app has no module");
        const te = H ?? {};
        if (typeof te.action != "string" || !te.action) throw new ca("invalid", "action is required");
        we() || await q(ae(await J(te.action)));
        const L = (await s.api.pluginActionRun(s.app, te.action, {
          paths: (s.files ?? []).map((se) => se.path),
          params: te.params && typeof te.params == "object" ? te.params : {}
        })).op;
        if (!L) throw new ca("failed", "nothing was queued");
        return n("op", L), { op: L };
      },
      "state.get"(H) {
        const te = String((H == null ? void 0 : H.key) ?? "");
        return JO(s.app, te) ?? null;
      },
      "state.set"(H) {
        const te = H ?? {};
        try {
          ZO(s.app, String(te.key ?? ""), te.value);
        } catch (Te) {
          throw Te instanceof Kc ? new ca("too_large", Te.message) : Te;
        }
        return null;
      }
    };
    function fe(H) {
      const te = ke.value;
      ke.value = null, te == null || te.resolve(H);
    }
    function xe() {
      const H = document.createElement("iframe");
      return H.setAttribute("sandbox", "allow-scripts"), H.setAttribute("referrerpolicy", "no-referrer"), H.setAttribute("title", s.title || s.app), H.className = "fe-appframe__frame", H.dataset.testid = "app-frame", H.setAttribute("src", O.value), H;
    }
    function ye() {
      if (qe(), !h.value) return;
      const H = xe(), te = FO({
        frame: () => H,
        handlers: me,
        onConnect: () => {
          g.value = !0, n("connected");
        },
        onDisconnect: () => {
          g.value = !1;
        }
      });
      H.addEventListener("load", () => te.frameLoaded()), v = H, y = te, h.value.appendChild(H);
    }
    function qe() {
      y == null || y.destroy(), y = null, v && (v.remove(), v = null), g.value = !1, m.value = !1, ke.value && fe(!1), ce.value && be(!1), k.value && kt("keep");
    }
    let ut = null;
    const Ue = ["pointerdown", "keydown", "touchstart"];
    Kt(() => {
      Y() && (Z = Date.now());
      for (const te of Ue) window.addEventListener(te, G, !0);
      ye(), ut = VC((te, Te) => {
        te !== s.app || !Te || Te === P.value || (E.value = Te, At(Te));
      });
      const H = P.value;
      if (H) {
        const te = QO(s.app);
        te && te !== H && (A.value = H), te !== H && Qb(s.app, H);
      }
    }), Mt(() => {
      for (const H of Ue) window.removeEventListener(H, G, !0);
      ut == null || ut(), ut = null, qe();
    }), Qe([O, w], () => ye()), Qe(
      () => s.ui,
      () => {
        $.value = null;
      }
    ), Qe(I, () => y == null ? void 0 : y.emit("theme", W())), Qe(
      () => s.locale,
      (H) => y == null ? void 0 : y.emit("locale", { locale: H, dir: Tr(H) })
    );
    async function Ye() {
      if (!y || !g.value) return !1;
      try {
        return await y.ask("save"), !0;
      } catch {
        return !1;
      }
    }
    async function st() {
      if (!m.value || !g.value)
        return _t(), !0;
      const H = await new Promise((te) => {
        k.value = te;
      });
      if (H === "keep") return !1;
      if (H === "save") {
        _.value = !0;
        try {
          if (!await Ye()) return !1;
        } finally {
          _.value = !1;
        }
      }
      return _t(), !0;
    }
    function kt(H) {
      const te = k.value;
      k.value = null, te == null || te(H);
    }
    function At(H) {
      y == null || y.emit("app.updated", { version: H });
    }
    function _t() {
      y == null || y.emit("close.request");
    }
    function Le() {
      w.value++;
    }
    async function tt() {
      var Te, L;
      if (!await st()) return;
      const H = E.value;
      let te = null;
      try {
        const se = await s.api.pluginActions();
        te = ((Te = se.views.find((ne) => ne.plugin === s.app && ne.id === s.view && ne.ui)) == null ? void 0 : Te.ui) ?? ((L = se.actions.find((ne) => ne.plugin === s.app && ne.view === s.view && ne.ui)) == null ? void 0 : L.ui) ?? null;
      } catch {
      }
      E.value = "", A.value = "", te && ($.value = te, Qb(s.app, te.version || H)), Le();
    }
    function ve() {
      E.value = "", A.value = "";
    }
    return a({ requestSave: Ye, confirmClose: st, notifyUpdated: At, notifyClosing: _t, reload: Le, reloadNewer: tt, connected: g, dirty: m }), (H, te) => (u(), d("div", {
      ref_key: "host",
      ref: h,
      class: Re(["fe-appframe", `fe-appframe--${e.placement}`]),
      "data-app": e.app,
      "data-connected": g.value ? "true" : "false"
    }, [
      E.value || A.value ? (u(), d("div", aL, [
        i("span", nL, f(E.value ? r(o)("appframe.updated_reload", { app: e.title || e.app }) : r(o)("appframe.updated", { app: e.title || e.app, version: A.value })), 1),
        E.value ? (u(), d("button", {
          key: 0,
          type: "button",
          class: "fe-btn fe-btn--primary",
          "data-testid": "appframe-reload",
          onClick: tt
        }, f(r(o)("appframe.reload")), 1)) : T("", !0),
        i("button", {
          type: "button",
          class: "fe-btn",
          "data-testid": "appframe-dismiss",
          onClick: ve
        }, f(r(o)("appframe.dismiss")), 1)
      ])) : T("", !0),
      ce.value ? (u(), d("div", sL, [
        i("span", oL, f(ce.value.text), 1),
        i("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          "data-testid": "appframe-consent-allow",
          disabled: !pe.value,
          onClick: te[0] || (te[0] = (Te) => be(!0))
        }, f(r(o)("appframe.consent_allow")), 9, iL),
        i("button", {
          type: "button",
          class: "fe-btn",
          "data-testid": "appframe-consent-deny",
          onClick: te[1] || (te[1] = (Te) => be(!1))
        }, f(r(o)("appframe.consent_deny")), 1)
      ])) : T("", !0),
      ke.value ? (u(), nt(h0, {
        key: 2,
        open: !0,
        locale: e.locale,
        theme: e.theme,
        title: `${ie.value}: ${ke.value.title || r(o)("appframe.confirm_title")}`,
        message: ke.value.text,
        danger: ke.value.danger,
        onClose: te[2] || (te[2] = (Te) => fe(!1)),
        onConfirm: te[3] || (te[3] = (Te) => fe(!0))
      }, null, 8, ["locale", "theme", "title", "message", "danger"])) : T("", !0),
      k.value ? (u(), nt(la, {
        key: 3,
        open: !0,
        size: "sm",
        locale: e.locale,
        theme: e.theme,
        busy: _.value,
        title: r(o)("appframe.unsaved_title"),
        onClose: te[7] || (te[7] = (Te) => kt("keep"))
      }, {
        actions: yt(() => [
          i("button", {
            type: "button",
            class: "fe-btn",
            "data-testid": "appframe-keep",
            disabled: _.value,
            onClick: te[4] || (te[4] = (Te) => kt("keep"))
          }, f(r(o)("appframe.keep_open")), 9, lL),
          i("button", {
            type: "button",
            class: "fe-btn fe-btn--danger",
            "data-testid": "appframe-discard",
            disabled: _.value,
            onClick: te[5] || (te[5] = (Te) => kt("discard"))
          }, f(r(o)("appframe.discard")), 9, uL),
          i("button", {
            type: "button",
            class: "fe-btn fe-btn--primary",
            "data-testid": "appframe-save-close",
            disabled: _.value,
            onClick: te[6] || (te[6] = (Te) => kt("save"))
          }, f(r(o)("appframe.save_close")), 9, cL)
        ]),
        default: yt(() => [
          i("p", rL, f(r(o)("appframe.unsaved_text", { app: e.title || e.app })), 1)
        ]),
        _: 1
      }, 8, ["locale", "theme", "busy", "title"])) : T("", !0)
    ], 10, tL));
  }
}), fL = ["data-testid"], pL = { class: "fe-inspector__heading fe-pinsp__heading" }, vL = ["aria-expanded", "aria-controls", "data-testid"], hL = ["id"], mL = ["id"], yL = {
  key: 0,
  class: "fe-inspector__empty"
}, gL = {
  key: 1,
  class: "fe-surface__error",
  role: "alert"
}, bL = {
  key: 0,
  class: "fe-pinsp__actions"
}, _L = /* @__PURE__ */ rt({
  __name: "PluginInspectorSection",
  props: {
    api: {},
    view: {},
    path: {},
    locale: {},
    theme: {},
    storages: {},
    node: {},
    writable: { type: Boolean }
  },
  emits: ["op", "toast", "open"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n } = gt(() => t.locale), o = b(!1), p = b(!1), h = b(""), v = Gd(
      {
        api: t.api,
        plugin: t.view.plugin,
        view: t.view.id,
        path: () => t.path,
        locale: () => t.locale,
        errorText: () => n("plugin.view.error")
      },
      {
        onOp: (w) => s("op", w),
        onOpen: (w) => s("open", w),
        // The conversation ended (a job was queued, or the plugin said `done`):
        // what the section shows next is the view's fresh state.
        onDone: () => void m(),
        onToast: (w) => s("toast", w)
      }
    ), y = x(() => jt(t.view.label, t.locale) || t.view.id), g = x(() => `fe-plugin-insp-${t.view.plugin}-${t.view.id}`);
    async function m() {
      var w;
      p.value = !0, h.value = "";
      try {
        const $ = await t.api.pluginView(t.view.plugin, t.view.id, t.path);
        v.setSurface(($ == null ? void 0 : $.surface) ?? null), $ != null && $.surface || (h.value = n("plugin.view.error"));
      } catch ($) {
        v.setSurface(null), h.value = ((w = n.foreign) == null ? void 0 : w.call(n, String(($ == null ? void 0 : $.message) ?? $))) || n("plugin.view.error");
      } finally {
        p.value = !1;
      }
    }
    const k = x(
      () => t.node && t.node.type === "file" ? [{
        path: t.node.path,
        name: t.node.basename,
        size: t.node.size,
        mime: t.node.mime_type,
        readOnly: t.writable === !1 || !!t.node.read_only
      }] : []
    );
    function _() {
      o.value = !o.value, !t.view.ui && o.value && !v.current.value && !p.value && m();
    }
    return Qe(
      () => t.path,
      () => {
        o.value = !1, h.value = "", v.setSurface(null);
      }
    ), (w, $) => (u(), d("section", {
      class: "fe-inspector__section fe-pinsp",
      "data-testid": `inspector-plugin-${e.view.plugin}-${e.view.id}`
    }, [
      i("h3", pL, [
        i("button", {
          type: "button",
          class: "fe-pinsp__toggle",
          "aria-expanded": o.value,
          "aria-controls": g.value,
          "data-testid": `inspector-plugin-toggle-${e.view.plugin}-${e.view.id}`,
          onClick: _
        }, [
          (u(), d("svg", {
            class: Re(["fe-ficon fe-pinsp__chev", { "is-open": o.value }]),
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true",
            focusable: "false"
          }, [...$[2] || ($[2] = [
            i("path", { d: "M9 5l7 7-7 7" }, null, -1)
          ])], 2)),
          i("span", null, f(y.value), 1)
        ], 8, vL)
      ]),
      o.value && e.view.ui ? (u(), d("div", {
        key: 0,
        id: g.value,
        class: "fe-pinsp__body"
      }, [
        (u(), nt(tf, {
          key: e.path,
          api: e.api,
          app: e.view.plugin,
          version: e.view.ui.version,
          view: e.view.id,
          placement: "inspector",
          ui: e.view.ui,
          files: k.value,
          locale: e.locale,
          theme: e.theme,
          title: y.value,
          onToast: $[0] || ($[0] = (C) => s("toast", C.text)),
          onOp: $[1] || ($[1] = (C) => s("op", C))
        }, null, 8, ["api", "app", "version", "view", "ui", "files", "locale", "theme", "title"]))
      ], 8, hL)) : o.value ? (u(), d("div", {
        key: 1,
        id: g.value,
        class: "fe-pinsp__body"
      }, [
        p.value ? (u(), d("p", yL, f(r(n)("plugin.view.loading")), 1)) : h.value ? (u(), d("p", gL, f(h.value), 1)) : r(v).current.value ? (u(), d(he, { key: 2 }, [
          ot(Xd, {
            conv: r(v),
            locale: e.locale,
            theme: e.theme,
            api: e.api,
            plugin: e.view.plugin,
            storages: e.storages,
            "start-at": e.path
          }, null, 8, ["conv", "locale", "theme", "api", "plugin", "storages", "start-at"]),
          r(v).footer.value.length ? (u(), d("div", bL, [
            ot(Jd, {
              conv: r(v),
              locale: e.locale,
              "testid-prefix": "inspector-plugin",
              small: ""
            }, null, 8, ["conv", "locale"])
          ])) : T("", !0)
        ], 64)) : T("", !0)
      ], 8, mL)) : T("", !0)
    ], 8, fL));
  }
}), kL = ["aria-label"], wL = { class: "fe-inspector__head" }, xL = ["innerHTML"], $L = { class: "fe-inspector__head-text" }, SL = ["title"], TL = { class: "fe-inspector__caption" }, CL = {
  key: 0,
  class: "fe-inspector__held",
  role: "note",
  "data-testid": "inspector-held"
}, EL = ["title", "aria-label"], AL = ["innerHTML"], zL = ["title", "aria-label"], ML = ["innerHTML"], DL = ["aria-label"], PL = ["aria-selected"], OL = ["aria-selected"], LL = { class: "fe-inspector__scroll" }, IL = {
  key: 0,
  class: "fe-inspector__section"
}, RL = { class: "fe-inspector__heading" }, NL = {
  key: 0,
  class: "fe-inspector__lock",
  role: "note",
  "data-testid": "inspector-lock"
}, BL = ["data-link-state"], FL = {
  key: 2,
  class: "fe-inspector__meta"
}, UL = { class: "fe-inspector__row" }, HL = ["title"], KL = ["src"], VL = { class: "fe-inspector__meta" }, qL = { class: "fe-inspector__row" }, jL = { class: "fe-inspector__row" }, WL = { class: "fe-inspector__pathcell" }, YL = ["title"], GL = ["title", "aria-label"], XL = ["innerHTML"], JL = {
  key: 0,
  class: "fe-inspector__row"
}, ZL = { class: "fe-inspector__row" }, QL = {
  key: 1,
  class: "fe-inspector__row"
}, e6 = { class: "fe-inspector__mime" }, t6 = {
  key: 2,
  class: "fe-inspector__row"
}, a6 = { class: "fe-inspector__pathcell" }, n6 = { class: "fe-inspector__path" }, s6 = ["title", "aria-label"], o6 = ["innerHTML"], i6 = {
  key: 3,
  class: "fe-inspector__row"
}, r6 = { class: "fe-inspector__pathcell" }, l6 = ["title"], u6 = ["title", "aria-label"], c6 = ["innerHTML"], d6 = {
  key: 4,
  class: "fe-inspector__empty"
}, f6 = {
  key: 1,
  class: "fe-inspector__section",
  "data-testid": "inspector-tags"
}, p6 = { class: "fe-inspector__heading" }, v6 = {
  key: 3,
  class: "fe-inspector__section"
}, h6 = { class: "fe-inspector__heading" }, m6 = {
  key: 0,
  class: "fe-inspector__empty"
}, y6 = {
  key: 0,
  class: "fe-inspector__empty"
}, g6 = {
  key: 1,
  class: "fe-inspector__versions"
}, b6 = { class: "fe-inspector__version-main" }, _6 = { class: "fe-inspector__version-n" }, k6 = { class: "fe-inspector__version-meta" }, w6 = {
  key: 0,
  class: "fe-inspector__confirm"
}, x6 = { class: "fe-inspector__confirm-q" }, $6 = { class: "fe-inspector__check" }, S6 = { class: "fe-inspector__confirm-actions" }, T6 = ["disabled", "aria-busy", "onClick"], C6 = ["disabled"], E6 = ["disabled", "onClick"], A6 = ["disabled", "aria-busy"], z6 = {
  key: 4,
  class: "fe-inspector__section"
}, M6 = { class: "fe-inspector__heading" }, D6 = { class: "fe-inspector__permrow" }, P6 = {
  key: 5,
  class: "fe-inspector__section",
  "data-testid": "inspector-people"
}, O6 = { class: "fe-inspector__heading" }, L6 = {
  key: 0,
  class: "fe-inspector__empty"
}, I6 = {
  key: 1,
  class: "fe-inspector__people"
}, R6 = {
  class: "fe-inspector__avatar",
  "aria-hidden": "true"
}, N6 = { class: "fe-inspector__person-main" }, B6 = ["title"], F6 = { class: "fe-inspector__person-sub" }, U6 = {
  key: 6,
  class: "fe-inspector__section",
  "data-testid": "inspector-shares"
}, H6 = { class: "fe-inspector__heading" }, K6 = {
  key: 0,
  class: "fe-inspector__linkrow"
}, V6 = ["innerHTML"], q6 = { class: "fe-inspector__linknone" }, j6 = ["disabled"], W6 = {
  key: 1,
  class: "fe-inspector__empty"
}, Y6 = {
  key: 2,
  class: "fe-inspector__shares"
}, G6 = ["title"], X6 = {
  key: 0,
  class: "fe-inspector__badge fe-inspector__badge--pin"
}, J6 = {
  key: 1,
  class: "fe-inspector__share-exp"
}, Z6 = ["title", "aria-label", "onClick"], Q6 = ["innerHTML"], eI = {
  key: 7,
  class: "fe-inspector__section"
}, tI = { class: "fe-inspector__heading" }, aI = {
  key: 0,
  class: "fe-inspector__countbadge"
}, nI = {
  key: 0,
  class: "fe-inspector__empty"
}, sI = {
  key: 0,
  class: "fe-inspector__empty"
}, oI = {
  key: 1,
  class: "fe-inspector__comments"
}, iI = { class: "fe-inspector__comment-top" }, rI = ["title"], lI = ["title"], uI = ["disabled", "title", "aria-label", "onClick"], cI = { class: "fe-inspector__comment-body" }, dI = ["placeholder", "aria-label", "disabled"], fI = ["disabled"], pI = {
  key: 8,
  class: "fe-inspector__section",
  "data-testid": "inspector-activity-empty"
}, vI = { class: "fe-inspector__empty" }, hI = {
  key: 0,
  class: "fe-inspector__hint"
}, mI = /* @__PURE__ */ rt({
  __name: "InspectorPanel",
  props: {
    api: {},
    nodes: {},
    dirLabel: {},
    dirCount: {},
    dirPerm: { default: "" },
    heldIn: {},
    locale: {},
    narrow: { type: Boolean, default: !1 },
    callerAdmin: { type: Boolean },
    sharing: {},
    thumbSrc: { type: Function, default: void 0 },
    tabs: { type: Boolean, default: !0 },
    apiBase: {},
    authHeaders: {},
    authCredentials: {},
    pluginViews: { default: () => [] },
    theme: {},
    storages: {}
  },
  emits: ["close", "share-created", "manage-permissions", "toast", "changed", "tags-changed", "open-tag", "plugin-op", "plugin-open"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n, formatSize: o, formatNodeSize: p, nodeSizeHint: h, formatDate: v, nodeDisplayName: y } = gt(
      () => t.locale
    );
    function g(L) {
      if (typeof L.e2e_display_dir != "string" || typeof L.e2e_stored != "string") return L.path;
      const se = L.path.indexOf("://");
      return `${se === -1 ? "" : L.path.slice(0, se + 3)}${L.e2e_display_dir ? `${L.e2e_display_dir}/` : ""}${L.basename}`;
    }
    const m = x(
      () => t.nodes.length === 1 ? t.nodes[0] : null
    ), k = x(() => t.nodes.length > 1), _ = x(() => li(Tu(m.value), { t: n, formatDate: v, locale: t.locale })), w = x(() => Cu(m.value, { t: n })), $ = x(() => {
      var L;
      return ((L = m.value) == null ? void 0 : L.type) === "file";
    }), C = x(
      () => {
        var L;
        return typeof ((L = m.value) == null ? void 0 : L.id) == "number" ? m.value.id : null;
      }
    ), E = x(
      () => t.nodes.reduce((L, se) => L + (typeof se.size == "number" ? se.size : 0), 0)
    ), A = x(() => ({
      size: E.value,
      size_partial: t.nodes.some((L) => L.size_partial === !0)
    })), O = x(() => {
      var se;
      const L = (se = m.value) == null ? void 0 : se.etag;
      return typeof L == "string" && L !== "" ? L : null;
    }), z = x(
      () => m.value && $.value && t.thumbSrc ? t.thumbSrc(m.value) : null
    ), P = x(() => {
      const L = m.value;
      return !L || Rd(L) || L.trashed === !0 ? [] : (t.pluginViews ?? []).filter(
        (se) => se.placement === "inspector" && wh(se.applies, [L], se.plugin)
      );
    }), I = x(() => k.value ? n("inspector.items", { n: t.nodes.length }) : m.value ? y(m.value) : t.dirLabel), F = x(() => {
      if (k.value) return p(A.value);
      const L = m.value;
      if (L) {
        const se = rd(L, n);
        if (L.type === "dir") return se;
        const ne = typeof L.size == "number" ? o(L.size) : "";
        return ne ? `${se} · ${ne}` : se;
      }
      return n("inspector.folder_items", { n: t.dirCount });
    }), W = x(
      () => {
        var L;
        return z.value && /^(image|video)[/]/.test(String(((L = m.value) == null ? void 0 : L.mime_type) ?? "")) ? z.value : null;
      }
    ), N = x(
      () => sn(m.value && !k.value ? m.value : { type: "dir" })
    ), K = x(
      () => C.value != null && t.apiBase !== void 0 && !k.value
    );
    function M(L) {
      return L.length > 12 ? `${L.slice(0, 12)}…` : L;
    }
    function j(L) {
      return v(L, { time: !0 }) || "—";
    }
    function U(L) {
      if (!L) return "—";
      const se = Date.parse(L);
      return Number.isNaN(se) ? L : j(se);
    }
    async function de(L) {
      try {
        await navigator.clipboard.writeText(L), s("toast", n("inspector.copied"));
      } catch {
        s("toast", L);
      }
    }
    const ke = x(() => {
      if (!m.value) return "";
      const L = m.value.perm;
      return typeof L == "string" && L !== "" ? L : t.dirPerm || "";
    }), ie = x(() => t.sharing ?? M1), ce = x(() => ke.value === "owner" && ie.value.users);
    function X(L) {
      return n(`inspector.perm.${L}`) === `inspector.perm.${L}` ? L : n(`inspector.perm.${L}`);
    }
    const Z = b("idle"), Y = b([]), G = b(null), we = b(!0), R = b(null), pe = x(() => R.value !== null), Q = b("idle"), q = b([]);
    let re = 0;
    async function ae() {
      const L = ++re;
      if (G.value = null, Y.value = [], q.value = [], m.value && $.value && C.value != null ? (Z.value = "loading", Pe(L)) : Z.value = "hidden", m.value) {
        Q.value = "loading";
        const se = m.value.path;
        try {
          const { shares: ne } = await t.api.listShares(se);
          if (L !== re) return;
          q.value = Array.isArray(ne) ? ne : [], Q.value = "ok";
        } catch {
          if (L !== re) return;
          Q.value = "hidden";
        }
      } else
        Q.value = "hidden";
    }
    async function Pe(L) {
      const se = C.value;
      if (se != null)
        try {
          const ne = await t.api.listVersions(se);
          if (L !== re) return;
          Y.value = ne, Z.value = "ok";
        } catch (ne) {
          if (L !== re) return;
          const et = ne.status;
          et === 401 || et === 403 || et === 404 ? Z.value = "hidden" : Z.value = "error";
        }
    }
    function be(L) {
      G.value = L.id, we.value = !0;
    }
    async function ze(L) {
      const se = C.value;
      if (!(se == null || pe.value)) {
        R.value = "restore";
        try {
          await t.api.restoreVersion(se, L.id, we.value), s("toast", n("inspector.versions.restored")), G.value = null, s("changed"), await Pe(++re);
        } catch (ne) {
          const et = Iv(ne);
          s("toast", et ? li(et, { t: n, formatDate: v, locale: t.locale }) : ne.message);
        } finally {
          R.value = null;
        }
      }
    }
    async function Ae() {
      const L = C.value;
      if (!(L == null || pe.value)) {
        R.value = "snapshot";
        try {
          await t.api.snapshotVersion(L), s("toast", n("inspector.versions.snapshotted")), await Pe(++re);
        } catch (se) {
          const ne = se.status;
          ne === 404 || ne === 405 || ne === 501 ? s("toast", n("inspector.versions.unsupported")) : s("toast", se.message);
        } finally {
          R.value = null;
        }
      }
    }
    const Ce = b("details"), He = b("hidden"), J = b([]);
    let me = 0;
    async function fe() {
      const L = ++me, se = m.value;
      if (!t.tabs || !se) {
        He.value = "hidden", J.value = [];
        return;
      }
      He.value = "loading";
      try {
        const ne = await t.api.listPermissions(se.path);
        if (L !== me) return;
        if (!ne.storage_rbac) {
          He.value = "hidden", J.value = [];
          return;
        }
        J.value = [...ne.direct ?? [], ...ne.inherited ?? []], He.value = "ok";
      } catch {
        if (L !== me) return;
        J.value = [], He.value = "hidden";
      }
    }
    function xe(L) {
      return { name: L.user_name, display_name: L.user_display_name, email: L.user_email };
    }
    function ye(L) {
      return ui(xe(L)) || `#${L.user_id}`;
    }
    function qe(L) {
      return md(xe(L), kn(t.locale)) || "?";
    }
    x(() => q.value.length ? q.value[0] : null);
    const ut = b(!1);
    async function Ue() {
      var se;
      const L = m.value;
      if (!(!L || ut.value || !ie.value.links)) {
        ut.value = !0;
        try {
          const et = ((se = (await t.api.createShare({ path: L.path })).share) == null ? void 0 : se.url) ?? "", { shares: ht } = await t.api.listShares(L.path);
          q.value = Array.isArray(ht) ? ht : [], Q.value = "ok", et && (s("share-created", { path: L.path, url: et }), await de(et));
        } catch (ne) {
          s("toast", ne.message);
        } finally {
          ut.value = !1;
        }
      }
    }
    Qe(
      () => [t.nodes.map((L) => L.path).join("|"), t.tabs],
      () => void fe(),
      { immediate: !0 }
    );
    const Ye = x(
      () => Z.value !== "hidden" || st.value !== "hidden"
    );
    Qe(
      () => t.nodes.map((L) => L.path).join("\0"),
      () => void ae(),
      { immediate: !0 }
    );
    const st = b("hidden"), kt = b([]), At = b(""), _t = b(!1), Le = x(
      () => {
        var L;
        return typeof ((L = m.value) == null ? void 0 : L.id) == "number" ? m.value.id : null;
      }
    );
    let tt = 0;
    async function ve() {
      const L = ++tt, se = Le.value;
      if (se == null) {
        st.value = "hidden", kt.value = [];
        return;
      }
      st.value = kt.value.length > 0 ? "ok" : "loading";
      try {
        const ne = await t.api.listComments(se);
        if (L !== tt) return;
        kt.value = ne, st.value = "ok";
      } catch (ne) {
        if (L !== tt) return;
        kt.value = [];
        const et = ne.status;
        st.value = et === 401 || et === 403 || et === 404 ? "hidden" : "error";
      }
    }
    async function H() {
      const L = Le.value, se = At.value.trim();
      if (!(L == null || se === "" || _t.value)) {
        _t.value = !0;
        try {
          await t.api.addComment(L, se), At.value = "", await ve();
        } catch (ne) {
          s("toast", ne.message);
        } finally {
          _t.value = !1;
        }
      }
    }
    async function te(L) {
      if (!_t.value) {
        _t.value = !0;
        try {
          await t.api.deleteComment(L.id), await ve();
        } catch (se) {
          s("toast", se.message);
        } finally {
          _t.value = !1;
        }
      }
    }
    function Te(L) {
      const se = Date.parse(L);
      if (Number.isNaN(se)) return L;
      const ne = Math.round((se - Date.now()) / 1e3), et = Math.abs(ne), ht = [
        ["year", 31536e3],
        ["month", 2592e3],
        ["day", 86400],
        ["hour", 3600],
        ["minute", 60]
      ];
      try {
        const Tt = new Intl.RelativeTimeFormat(
          kn(t.locale),
          { numeric: "auto" }
        );
        for (const [Ft, Lt] of ht)
          if (et >= Lt) return Tt.format(Math.trunc(ne / Lt), Ft);
        return Tt.format(ne, "second");
      } catch {
        return U(L);
      }
    }
    return Qe(
      () => Le.value,
      () => {
        kt.value = [], At.value = "", ve();
      },
      { immediate: !0 }
    ), (L, se) => (u(), d("aside", {
      class: Re(["fe-inspector", { "fe-inspector--overlay": e.narrow }]),
      role: "complementary",
      "aria-label": r(n)("inspector.title")
    }, [
      i("header", wL, [
        i("span", {
          class: "fe-inspector__head-icon",
          "aria-hidden": "true",
          innerHTML: N.value
        }, null, 8, xL),
        i("div", $L, [
          i("h2", {
            class: "fe-inspector__title",
            title: I.value
          }, [
            i("bdi", null, f(I.value), 1)
          ], 8, SL),
          i("p", TL, f(F.value), 1),
          e.heldIn ? (u(), d("p", CL, f(r(n)("inspector.held", { where: e.heldIn })), 1)) : T("", !0)
        ]),
        m.value ? (u(), d("button", {
          key: 0,
          type: "button",
          class: "fe-inspector__iconbtn",
          title: r(n)("inspector.copy_name"),
          "aria-label": r(n)("inspector.copy_name"),
          "data-testid": "inspector-copy-name",
          onClick: se[0] || (se[0] = (ne) => de(I.value))
        }, [
          i("span", {
            "aria-hidden": "true",
            innerHTML: r(wt)("copy")
          }, null, 8, AL)
        ], 8, EL)) : T("", !0),
        i("button", {
          type: "button",
          class: "fe-inspector__iconbtn fe-inspector__close",
          title: r(n)("inspector.close"),
          "aria-label": r(n)("inspector.close"),
          onClick: se[1] || (se[1] = (ne) => s("close"))
        }, [
          i("span", {
            "aria-hidden": "true",
            innerHTML: r(wt)("close")
          }, null, 8, ML)
        ], 8, zL)
      ]),
      e.tabs ? (u(), d("div", {
        key: 0,
        class: "fe-inspector__tabs",
        role: "tablist",
        "aria-label": r(n)("inspector.title")
      }, [
        i("button", {
          type: "button",
          class: Re(["fe-inspector__tab", { "is-active": Ce.value === "details" }]),
          role: "tab",
          "aria-selected": Ce.value === "details",
          "data-testid": "inspector-tab-details",
          onClick: se[2] || (se[2] = (ne) => Ce.value = "details")
        }, f(r(n)("inspector.tab.details")), 11, PL),
        i("button", {
          type: "button",
          class: Re(["fe-inspector__tab", { "is-active": Ce.value === "activity" }]),
          role: "tab",
          "aria-selected": Ce.value === "activity",
          "data-testid": "inspector-tab-activity",
          onClick: se[3] || (se[3] = (ne) => Ce.value = "activity")
        }, f(r(n)("inspector.tab.activity")), 11, OL)
      ], 8, DL)) : T("", !0),
      i("div", LL, [
        !e.tabs || Ce.value === "details" ? (u(), d("section", IL, [
          i("h3", RL, f(r(n)("inspector.section.general")), 1),
          _.value ? (u(), d("p", NL, [
            se[18] || (se[18] = i("span", { "aria-hidden": "true" }, "🔒", -1)),
            i("span", null, [
              i("strong", null, f(r(n)("applock.inspector")), 1),
              se[17] || (se[17] = i("br", null, null, -1)),
              $t(f(_.value), 1)
            ])
          ])) : T("", !0),
          w.value ? (u(), d("p", {
            key: 1,
            class: "fe-inspector__linknote",
            role: "note",
            "data-testid": "inspector-symlink",
            "data-link-state": w.value.state
          }, [
            se[20] || (se[20] = i("span", { "aria-hidden": "true" }, "🔗", -1)),
            i("span", null, [
              i("strong", null, f(r(n)("symlink.inspector")), 1),
              se[19] || (se[19] = i("br", null, null, -1)),
              $t(f(w.value.why), 1)
            ])
          ], 8, BL)) : T("", !0),
          k.value ? (u(), d("dl", FL, [
            i("div", UL, [
              i("dt", null, f(r(n)("inspector.size")), 1),
              i("dd", {
                title: r(h)(A.value)
              }, f(r(p)(A.value)), 9, HL)
            ])
          ])) : m.value ? (u(), d(he, { key: 3 }, [
            W.value ? (u(), d("img", {
              key: 0,
              class: "fe-inspector__preview",
              src: W.value,
              alt: "",
              "aria-hidden": "true"
            }, null, 8, KL)) : T("", !0),
            i("dl", VL, [
              i("div", qL, [
                i("dt", null, f(r(n)("inspector.type")), 1),
                i("dd", null, f(r(rd)(m.value, r(n))), 1)
              ]),
              i("div", jL, [
                i("dt", null, f(r(n)("inspector.path")), 1),
                i("dd", WL, [
                  i("span", {
                    class: "fe-inspector__path",
                    title: m.value.path
                  }, [
                    i("bdi", null, f(g(m.value)), 1)
                  ], 8, YL),
                  i("button", {
                    type: "button",
                    class: "fe-inspector__copy",
                    title: r(n)("inspector.copy"),
                    "aria-label": r(n)("inspector.copy"),
                    onClick: se[4] || (se[4] = (ne) => de(m.value.path))
                  }, [
                    i("span", {
                      "aria-hidden": "true",
                      innerHTML: r(wt)("copy")
                    }, null, 8, XL)
                  ], 8, GL)
                ])
              ]),
              $.value ? (u(), d("div", JL, [
                i("dt", null, f(r(n)("inspector.size")), 1),
                i("dd", null, f(r(o)(typeof m.value.size == "number" ? m.value.size : null)), 1)
              ])) : T("", !0),
              i("div", ZL, [
                i("dt", null, f(r(n)("inspector.modified")), 1),
                i("dd", null, f(j(m.value.last_modified)), 1)
              ]),
              $.value && m.value.mime_type ? (u(), d("div", QL, [
                i("dt", null, f(r(n)("inspector.mime")), 1),
                i("dd", e6, f(m.value.mime_type), 1)
              ])) : T("", !0),
              e.callerAdmin && typeof m.value.id == "number" ? (u(), d("div", t6, [
                i("dt", null, f(r(n)("inspector.nodeId")), 1),
                i("dd", a6, [
                  i("span", n6, f(m.value.id), 1),
                  i("button", {
                    type: "button",
                    class: "fe-inspector__copy",
                    title: r(n)("inspector.copy"),
                    "aria-label": r(n)("inspector.copy"),
                    onClick: se[5] || (se[5] = (ne) => de(String(m.value.id)))
                  }, [
                    i("span", {
                      "aria-hidden": "true",
                      innerHTML: r(wt)("copy")
                    }, null, 8, o6)
                  ], 8, s6)
                ])
              ])) : T("", !0),
              O.value ? (u(), d("div", i6, [
                i("dt", null, f(r(n)("inspector.etag")), 1),
                i("dd", r6, [
                  i("span", {
                    class: "fe-inspector__path",
                    title: O.value
                  }, f(M(O.value)), 9, l6),
                  i("button", {
                    type: "button",
                    class: "fe-inspector__copy",
                    title: r(n)("inspector.copy"),
                    "aria-label": r(n)("inspector.copy"),
                    onClick: se[6] || (se[6] = (ne) => de(O.value))
                  }, [
                    i("span", {
                      "aria-hidden": "true",
                      innerHTML: r(wt)("copy")
                    }, null, 8, c6)
                  ], 8, u6)
                ])
              ])) : T("", !0)
            ])
          ], 64)) : (u(), d("p", d6, f(r(n)("inspector.select_hint")), 1))
        ])) : T("", !0),
        K.value && (!e.tabs || Ce.value === "details") ? (u(), d("section", f6, [
          i("h3", p6, f(r(n)("inspector.section.tags")), 1),
          ot(uw, {
            "node-id": C.value,
            locale: e.locale,
            "api-base": e.apiBase,
            "auth-headers": e.authHeaders,
            "auth-credentials": e.authCredentials,
            onChange: se[7] || (se[7] = (ne) => s("tags-changed", ne)),
            onOpen: se[8] || (se[8] = (ne, et) => s("open-tag", ne, et)),
            onError: se[9] || (se[9] = () => s("toast", r(n)("inspector.error")))
          }, null, 8, ["node-id", "locale", "api-base", "auth-headers", "auth-credentials"])
        ])) : T("", !0),
        m.value && (!e.tabs || Ce.value === "details") ? (u(!0), d(he, { key: 2 }, We(P.value, (ne) => (u(), nt(_L, {
          key: `${ne.plugin}/${ne.id}`,
          api: e.api,
          view: ne,
          path: m.value.path,
          node: m.value,
          locale: e.locale,
          theme: e.theme,
          storages: e.storages,
          onOp: se[10] || (se[10] = (et) => s("plugin-op", et)),
          onToast: se[11] || (se[11] = (et) => s("toast", et)),
          onOpen: (et) => s("plugin-open", { plugin: ne.plugin, req: et })
        }, null, 8, ["api", "view", "path", "node", "locale", "theme", "storages", "onOpen"]))), 128)) : T("", !0),
        (Z.value === "ok" || Z.value === "error") && (!e.tabs || Ce.value === "activity") ? (u(), d("section", v6, [
          i("h3", h6, f(r(n)("inspector.section.versions")), 1),
          Z.value === "error" ? (u(), d("p", m6, f(r(n)("inspector.error")), 1)) : (u(), d(he, { key: 1 }, [
            Y.value.length === 0 ? (u(), d("p", y6, f(r(n)("inspector.versions.empty")), 1)) : (u(), d("ul", g6, [
              (u(!0), d(he, null, We(Y.value, (ne) => (u(), d("li", {
                key: ne.id,
                class: "fe-inspector__version"
              }, [
                i("div", b6, [
                  i("span", _6, f(r(n)("inspector.versions.v", { n: ne.version_n })), 1),
                  i("span", k6, f(U(ne.created_at)) + " · " + f(r(o)(ne.size)), 1)
                ]),
                G.value === ne.id ? (u(), d("div", w6, [
                  i("p", x6, f(r(n)("inspector.versions.restore_confirm")), 1),
                  i("label", $6, [
                    dt(i("input", {
                      "onUpdate:modelValue": se[12] || (se[12] = (et) => we.value = et),
                      type: "checkbox"
                    }, null, 512), [
                      [Ja, we.value]
                    ]),
                    $t(" " + f(r(n)("inspector.versions.snapshot_current")), 1)
                  ]),
                  i("div", S6, [
                    i("button", {
                      type: "button",
                      class: "fe-btn fe-btn--primary fe-btn--sm",
                      disabled: pe.value,
                      "aria-busy": R.value === "restore",
                      onClick: (et) => ze(ne)
                    }, f(R.value === "restore" ? r(n)("inspector.versions.restoring") : r(n)("inspector.versions.confirm")), 9, T6),
                    i("button", {
                      type: "button",
                      class: "fe-btn fe-btn--sm",
                      disabled: pe.value,
                      onClick: se[13] || (se[13] = (et) => G.value = null)
                    }, f(r(n)("inspector.versions.cancel")), 9, C6)
                  ])
                ])) : (u(), d("button", {
                  key: 1,
                  type: "button",
                  class: "fe-btn fe-btn--sm",
                  disabled: pe.value,
                  onClick: (et) => be(ne)
                }, f(r(n)("inspector.versions.restore")), 9, E6))
              ]))), 128))
            ])),
            i("button", {
              type: "button",
              class: "fe-btn fe-btn--sm fe-inspector__snapshot",
              disabled: pe.value,
              "aria-busy": R.value === "snapshot",
              onClick: Ae
            }, f(R.value === "snapshot" ? r(n)("inspector.versions.snapshotting") : r(n)("inspector.versions.take_snapshot")), 9, A6)
          ], 64))
        ])) : T("", !0),
        m.value && ke.value && (!e.tabs || Ce.value === "details") && !(e.tabs && He.value === "ok") ? (u(), d("section", z6, [
          i("h3", M6, f(r(n)("inspector.section.permissions")), 1),
          i("div", D6, [
            i("span", {
              class: Re(["fe-inspector__badge", `fe-inspector__badge--${ke.value}`])
            }, f(X(ke.value)), 3),
            ce.value ? (u(), d("button", {
              key: 0,
              type: "button",
              class: "fe-btn fe-btn--sm",
              onClick: se[14] || (se[14] = (ne) => s("manage-permissions", m.value))
            }, f(r(n)("inspector.perm.manage")), 1)) : T("", !0)
          ])
        ])) : T("", !0),
        e.tabs && Ce.value === "details" && He.value === "ok" ? (u(), d("section", P6, [
          i("h3", O6, f(r(n)("inspector.people")), 1),
          J.value.length === 0 ? (u(), d("p", L6, f(r(n)("inspector.people.empty")), 1)) : (u(), d("ul", I6, [
            (u(!0), d(he, null, We(J.value, (ne) => (u(), d("li", {
              key: `${ne.id}-${ne.user_id}`,
              class: "fe-inspector__person"
            }, [
              i("span", R6, f(qe(ne)), 1),
              i("span", N6, [
                i("span", {
                  class: "fe-inspector__person-name",
                  title: ne.user_email
                }, f(ye(ne)), 9, B6),
                i("span", F6, [
                  $t(f(X(ne.level)), 1),
                  ne.inherited ? (u(), d(he, { key: 0 }, [
                    $t(" · " + f(r(n)("inspector.people.inherited")), 1)
                  ], 64)) : T("", !0)
                ])
              ])
            ]))), 128))
          ])),
          ce.value && m.value ? (u(), d("button", {
            key: 2,
            type: "button",
            class: "fe-btn fe-btn--sm",
            onClick: se[15] || (se[15] = (ne) => s("manage-permissions", m.value))
          }, f(r(n)("inspector.people.manage")), 1)) : T("", !0)
        ])) : T("", !0),
        Q.value === "ok" && (!e.tabs || Ce.value === "details") ? (u(), d("section", U6, [
          i("h3", H6, f(e.tabs ? r(n)("inspector.link") : r(n)("inspector.section.shares")), 1),
          e.tabs && q.value.length === 0 ? (u(), d("div", K6, [
            i("span", {
              class: "fe-inspector__linkicon",
              "aria-hidden": "true",
              innerHTML: r(wt)("link")
            }, null, 8, V6),
            i("span", q6, f(r(n)("inspector.link.none")), 1),
            ie.value.links ? (u(), d("button", {
              key: 0,
              type: "button",
              class: "fe-btn fe-btn--sm",
              disabled: ut.value || !m.value,
              "data-testid": "inspector-create-link",
              onClick: Ue
            }, f(r(n)("inspector.link.create")), 9, j6)) : T("", !0)
          ])) : q.value.length === 0 ? (u(), d("p", W6, f(r(n)("inspector.shares.empty")), 1)) : (u(), d("ul", Y6, [
            (u(!0), d(he, null, We(q.value, (ne) => (u(), d("li", {
              key: ne.uuid,
              class: "fe-inspector__share"
            }, [
              i("span", {
                class: "fe-inspector__share-url",
                title: ne.url
              }, f(ne.url), 9, G6),
              ne.password_pin ? (u(), d("span", X6, "PIN")) : T("", !0),
              ne.expires_at ? (u(), d("span", J6, f(U(ne.expires_at)), 1)) : T("", !0),
              i("button", {
                type: "button",
                class: "fe-inspector__copy",
                title: r(n)("inspector.shares.copy"),
                "aria-label": r(n)("inspector.shares.copy"),
                onClick: (et) => de(ne.url)
              }, [
                i("span", {
                  "aria-hidden": "true",
                  innerHTML: r(wt)("copy")
                }, null, 8, Q6)
              ], 8, Z6)
            ]))), 128))
          ]))
        ])) : T("", !0),
        (st.value === "ok" || st.value === "error") && (!e.tabs || Ce.value === "activity") ? (u(), d("section", eI, [
          i("h3", tI, [
            $t(f(r(n)("inspector.section.comments")) + " ", 1),
            kt.value.length > 0 ? (u(), d("span", aI, f(kt.value.length), 1)) : T("", !0)
          ]),
          st.value === "error" ? (u(), d("p", nI, f(r(n)("inspector.error")), 1)) : (u(), d(he, { key: 1 }, [
            kt.value.length === 0 ? (u(), d("p", sI, f(r(n)("inspector.comments.empty")), 1)) : (u(), d("ul", oI, [
              (u(!0), d(he, null, We(kt.value, (ne) => (u(), d("li", {
                key: ne.id,
                class: "fe-inspector__comment"
              }, [
                i("div", iI, [
                  i("span", {
                    class: "fe-inspector__comment-author",
                    title: ne.author_name
                  }, f(ne.author_name || "—"), 9, rI),
                  i("span", {
                    class: "fe-inspector__comment-time",
                    title: U(ne.created_at)
                  }, f(Te(ne.created_at)), 9, lI),
                  ne.can_delete ? (u(), d("button", {
                    key: 0,
                    type: "button",
                    class: "fe-inspector__comment-del",
                    disabled: _t.value,
                    title: r(n)("inspector.comments.delete"),
                    "aria-label": r(n)("inspector.comments.delete"),
                    onClick: (et) => te(ne)
                  }, "×", 8, uI)) : T("", !0)
                ]),
                i("p", cI, f(ne.body), 1)
              ]))), 128))
            ])),
            i("form", {
              class: "fe-inspector__comment-form",
              onSubmit: ft(H, ["prevent"])
            }, [
              dt(i("input", {
                "onUpdate:modelValue": se[16] || (se[16] = (ne) => At.value = ne),
                type: "text",
                class: "fe-inspector__comment-input",
                maxlength: "5000",
                placeholder: r(n)("inspector.comments.placeholder"),
                "aria-label": r(n)("inspector.comments.placeholder"),
                disabled: _t.value
              }, null, 8, dI), [
                [St, At.value]
              ]),
              i("button", {
                type: "submit",
                class: "fe-btn fe-btn--primary fe-btn--sm",
                disabled: _t.value || At.value.trim() === ""
              }, f(r(n)("inspector.comments.send")), 9, fI)
            ], 32)
          ], 64))
        ])) : T("", !0),
        e.tabs && Ce.value === "activity" && !Ye.value ? (u(), d("section", pI, [
          i("p", vI, f(m.value ? r(n)("inspector.activity.empty") : r(n)("inspector.activity.select")), 1),
          m.value ? (u(), d("p", hI, f(r(n)("inspector.activity.hint")), 1)) : T("", !0)
        ])) : T("", !0)
      ])
    ], 10, kL));
  }
}), jv = 500, yI = 800, t_ = 10, gI = 'button, a, input, select, textarea, label, [role="checkbox"], [data-fe-control]';
function lm(e, a) {
  return { ctrl: e.ctrlKey || e.metaKey, shift: e.shiftKey, touch: a };
}
function um(e) {
  return { ctrl: !0, shift: e.shiftKey, check: !0 };
}
function bI(e) {
  const a = e.target;
  if (typeof (a == null ? void 0 : a.closest) != "function") return !1;
  const t = a.closest(gI), s = e.currentTarget;
  return t !== null && (s === null || typeof s.contains != "function" || s.contains(t));
}
function cm(e, a = {}) {
  let t, s = null, n = { clientX: 0, clientY: 0 }, o = !1, p = 0, h = !1;
  function v() {
    t && clearTimeout(t), t = void 0;
  }
  function y(_, w) {
    const $ = w.touches[0];
    $ && (v(), s = _, o = !1, n = { clientX: $.clientX, clientY: $.clientY }, h = !bI(w), t = setTimeout(() => {
      t = void 0, s !== null && (o = !0, e(s, n));
    }, jv));
  }
  function g(_) {
    const w = _.touches[0];
    (!w || Math.abs(w.clientX - n.clientX) > t_ || Math.abs(w.clientY - n.clientY) > t_) && (v(), s = null);
  }
  function m(_) {
    v();
    const w = s, $ = w !== null && !o;
    $ && (p = Date.now()), s = null, $ && h && a.onTap && (_ != null && _.cancelable && _.preventDefault(), a.onTap(w)), h = !1;
  }
  function k(_) {
    const w = _.pointerType;
    return w ? w === "touch" : Date.now() - p < yI;
  }
  return Mt(v), { onTouchStart: y, onTouchMove: g, onTouchEnd: m, isTap: k };
}
const a_ = 5, n_ = 10, _I = 300, s_ = 28;
function kI(e) {
  const a = b(null), t = b(null), s = b(!1);
  let n = null, o = 0;
  function p(C) {
    const E = e.keys();
    for (let A = 0; A < E.length; A++) {
      const O = e.rowEl(E[A]);
      if (!O) continue;
      const z = O.getBoundingClientRect();
      if (C < z.top + z.height / 2) return A;
    }
    return E.length;
  }
  function h(C, E) {
    const A = E.pointerType === "touch";
    if (!A && E.button !== 0) return;
    w();
    const O = e.touchDelayMs ?? jv, z = {
      key: C,
      pointerId: E.pointerId,
      touch: A,
      startX: E.clientX,
      startY: E.clientY,
      pressed: !A || O <= 0,
      armed: !1
    };
    A && O > 0 && (z.timer = setTimeout(() => {
      n === z && (z.pressed = !0, a.value = C);
    }, O)), n = z, window.addEventListener("pointermove", y), window.addEventListener("pointerup", m), window.addEventListener("pointercancel", _), window.addEventListener("blur", _), window.addEventListener("keydown", k, !0), A && window.addEventListener("touchmove", v, { passive: !1 });
  }
  function v(C) {
    n != null && n.pressed && C.cancelable && C.preventDefault();
  }
  function y(C) {
    var F;
    const E = n;
    if (!E || C.pointerId !== E.pointerId) return;
    const A = C.clientX - E.startX, O = C.clientY - E.startY;
    if (!E.armed) {
      if (!E.pressed) {
        (Math.abs(A) > n_ || Math.abs(O) > n_) && w();
        return;
      }
      if (Math.abs(A) < a_ && Math.abs(O) < a_) return;
      E.armed = !0, a.value = E.key, s.value = !0;
    }
    const z = p(C.clientY), P = e.keys().indexOf(E.key);
    t.value = z === P || z === P + 1 ? null : z;
    const I = (F = e.scroller) == null ? void 0 : F.call(e);
    if (I) {
      const W = I.getBoundingClientRect();
      C.clientY < W.top + s_ ? I.scrollTop -= 12 : C.clientY > W.bottom - s_ && (I.scrollTop += 12);
    }
  }
  function g() {
    const C = (O) => {
      O.cancelable && O.preventDefault(), A();
    }, E = setTimeout(() => A(), 600);
    function A() {
      clearTimeout(E), window.removeEventListener("touchend", C, !0);
    }
    window.addEventListener("touchend", C, { capture: !0, passive: !1 });
  }
  function m(C) {
    var O;
    const E = n;
    if (!E || C.pointerId !== E.pointerId) return;
    const A = t.value;
    if (w(), E.touch && E.pressed && g(), E.armed) {
      o = Date.now(), A !== null && e.onDrop(E.key, A);
      return;
    }
    E.touch && E.pressed && (e.touchDelayMs ?? jv) > 0 && (o = Date.now(), (O = e.onHold) == null || O.call(e, E.key));
  }
  function k(C) {
    C.key !== "Escape" || !n || (C.preventDefault(), C.stopPropagation(), _());
  }
  function _() {
    const C = (n == null ? void 0 : n.armed) === !0;
    w(), C && (o = Date.now());
  }
  function w() {
    n != null && n.timer && clearTimeout(n.timer), n = null, a.value = null, t.value = null, s.value = !1, window.removeEventListener("pointermove", y), window.removeEventListener("pointerup", m), window.removeEventListener("pointercancel", _), window.removeEventListener("blur", _), window.removeEventListener("keydown", k, !0), window.removeEventListener("touchmove", v);
  }
  function $(C) {
    Date.now() - o < _I && (C.preventDefault(), C.stopPropagation());
  }
  return Mt(w), {
    dragKey: a,
    dropGap: t,
    reordering: s,
    touchActive: () => (n == null ? void 0 : n.touch) === !0,
    onPointerDown: h,
    onClickCapture: $
  };
}
function An(e) {
  return e.uid || e.name;
}
function m0(e) {
  return e.map(An);
}
function af(e) {
  if (typeof e != "string" || !e) return [];
  let a;
  try {
    a = JSON.parse(e);
  } catch {
    return [];
  }
  if (!Array.isArray(a)) return [];
  const t = [], s = /* @__PURE__ */ new Set();
  for (const n of a)
    typeof n != "string" || !n || s.has(n) || (s.add(n), t.push(n));
  return t;
}
function wI(e) {
  return e.length ? JSON.stringify(e) : "";
}
function xI(e) {
  return typeof e == "number" && Number.isFinite(e) ? e : null;
}
function $I(e) {
  return e.map((a, t) => ({ s: a, i: t, p: xI(a.sortOrder) })).sort((a, t) => a.p === null || t.p === null ? a.p === t.p ? a.i - t.i : a.p === null ? 1 : -1 : a.p - t.p || a.i - t.i).map((a) => a.s);
}
function SI(e, a) {
  const t = $I(e);
  if (!a.length || t.length < 2) return t;
  const s = /* @__PURE__ */ new Map();
  a.forEach((h, v) => {
    s.has(h) || s.set(h, v);
  });
  const n = (h) => (h.uid ? s.get(h.uid) : void 0) ?? s.get(h.name), o = t.filter((h) => n(h) !== void 0).sort((h, v) => (n(h) ?? 0) - (n(v) ?? 0));
  let p = 0;
  return t.map((h) => n(h) === void 0 ? h : o[p++]);
}
function o_(e, a, t) {
  const s = m0(e), n = s.indexOf(a), o = n + t;
  return n < 0 || t === 0 || o < 0 || o >= s.length ? null : (s.splice(n, 1), s.splice(o, 0, a), s);
}
function TI(e, a, t) {
  const s = m0(e), n = s.indexOf(a);
  if (n < 0) return null;
  const o = Math.max(0, Math.min(s.length, Math.trunc(t)));
  return o === n || o === n + 1 ? null : (s.splice(n, 1), s.splice(o > n ? o - 1 : o, 0, a), s);
}
function i_(e) {
  return e.map((a, t) => ({ s: a, i: t })).sort((a, t) => S1(a.s.label || a.s.name, t.s.label || t.s.name) || a.i - t.i).map((a) => An(a.s));
}
function CI(e, a, t) {
  const s = [...e];
  if (!t.length) return s;
  const n = /* @__PURE__ */ new Map();
  for (const p of a)
    n.set(p.name, An(p)), p.uid && n.set(p.uid, An(p));
  let o = null;
  for (const p of t) {
    const h = n.get(p);
    if (h !== void 0) {
      o = h;
      continue;
    }
    if (s.includes(p)) continue;
    const v = o === null ? 0 : s.indexOf(o) + 1;
    s.splice(v, 0, p), o = p;
  }
  return s;
}
const mo = b([]);
let or = null, Rp = "";
function EI() {
  return Vr() ? af(wd("storageOrder")) : [];
}
function AI(e, a) {
  const t = e.length ? CI(e, a, mo.value) : [];
  mo.value = t;
  const s = wI(t);
  if (!om()) {
    di("storageOrder", s);
    return;
  }
  if (f0()) {
    r_(s);
    return;
  }
  di("storageOrder", s), Rp = s, !or && (or = im(() => {
    or == null || or(), or = null, r_(Rp), mo.value = af(Rp);
  }));
}
function r_(e) {
  pi("storageOrder", e), XO();
}
function zI() {
  mo.value = EI();
  const e = im(() => {
    mo.value = af(wi().storageOrder);
  });
  return hi() && Mt(e), { saved: mo, custom: x(() => mo.value.length > 0) };
}
if (typeof window < "u")
  try {
    window.addEventListener("storage", (e) => {
      e.key !== iu.storageOrder || !Vr() || (mo.value = af(e.newValue));
    });
  } catch {
  }
const MI = {
  class: "fe-stags",
  "data-testid": "storage-tags"
}, DI = ["title"], PI = {
  key: 1,
  class: "fe-stag fe-stag--warn",
  "data-testid": "storage-tag-readonly"
}, OI = {
  key: 2,
  class: "fe-stag",
  "data-testid": "storage-tag-disabled"
}, y0 = /* @__PURE__ */ rt({
  __name: "StorageTags",
  props: {
    driver: {},
    readOnly: { type: Boolean },
    enabled: { type: Boolean, default: void 0 },
    locale: {}
  },
  setup(e) {
    const a = e, { t } = gt(() => a.locale ?? "en"), s = x(() => {
      if (!a.driver) return "";
      const n = `storages.driver.${a.driver}`, o = t(n);
      return o === n ? a.driver : o;
    });
    return (n, o) => (u(), d("span", MI, [
      e.driver ? (u(), d("span", {
        key: 0,
        class: "fe-stag",
        title: e.driver,
        "data-testid": "storage-tag-driver"
      }, f(s.value), 9, DI)) : T("", !0),
      e.readOnly ? (u(), d("span", PI, f(r(t)("sidenav.storage.readOnly")), 1)) : T("", !0),
      e.enabled === !1 ? (u(), d("span", OI, f(r(t)("conn.list.disabled")), 1)) : T("", !0)
    ]));
  }
}), LI = ["aria-label"], II = {
  key: 0,
  class: "fe-sidenav__head"
}, RI = ["aria-expanded", "title", "aria-label"], NI = { class: "fe-sidenav__primary" }, BI = ["title", "aria-label"], FI = { class: "fe-sidenav__new-main" }, UI = {
  key: 0,
  class: "fe-sidenav__text"
}, HI = {
  key: 0,
  class: "fe-sidenav__new-rule",
  "aria-hidden": "true"
}, KI = {
  key: 1,
  class: "fe-sidenav__new-caret",
  "aria-hidden": "true"
}, VI = { class: "fe-sidenav__scroll" }, qI = ["aria-label"], jI = ["aria-current", "title", "aria-label", "data-testid", "onClick"], WI = {
  class: "fe-ficon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}, YI = {
  key: 1,
  d: "M3.5 7.5A1.5 1.5 0 0 1 5 6h4l2 2.5h8A1.5 1.5 0 0 1 20.5 10v7.5A1.5 1.5 0 0 1 19 19H5a1.5 1.5 0 0 1-1.5-1.5z"
}, GI = {
  key: 3,
  d: "M12 4l2.4 4.9 5.4.8-3.9 3.8.9 5.4-4.8-2.5-4.8 2.5.9-5.4-3.9-3.8 5.4-.8z"
}, XI = {
  key: 0,
  class: "fe-sidenav__text"
}, JI = { key: 0 }, ZI = ["title", "aria-label"], QI = {
  key: 0,
  class: "fe-sidenav__text"
}, eR = {
  key: 0,
  class: "fe-sidenav__section"
}, tR = { class: "fe-sidenav__heading" }, aR = ["data-testid"], nR = ["aria-label"], sR = ["aria-current", "title", "aria-label", "data-testid", "data-tag-kind", "onClick"], oR = { class: "fe-sidenav__text" }, iR = ["aria-label"], rR = { key: 0 }, lR = { class: "fe-sidenav__hint" }, uR = { key: 1 }, cR = { key: 2 }, dR = ["aria-label"], fR = ["title", "aria-label"], pR = {
  key: 1,
  class: "fe-sidenav__section"
}, vR = {
  key: 0,
  class: "fe-sidenav__heading"
}, hR = {
  key: 1,
  class: "fe-sidenav__rule",
  "aria-hidden": "true"
}, mR = ["aria-label"], yR = ["title", "aria-label", "data-testid", "onClick", "onContextmenu", "onKeydown", "onPointerdown"], gR = {
  class: "fe-ficon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}, bR = {
  key: 0,
  class: "fe-sidenav__text"
}, _R = ["aria-label"], kR = {
  key: 2,
  class: "fe-sidenav__section",
  "data-testid": "sidenav-apps"
}, wR = {
  key: 0,
  class: "fe-sidenav__heading"
}, xR = {
  key: 1,
  class: "fe-sidenav__rule",
  "aria-hidden": "true"
}, $R = ["aria-label"], SR = ["title", "aria-label", "data-testid", "onClick"], TR = ["innerHTML"], CR = {
  key: 0,
  class: "fe-sidenav__text"
}, ER = {
  key: 3,
  class: "fe-sidenav__section"
}, AR = {
  key: 0,
  class: "fe-sidenav__heading"
}, zR = {
  key: 1,
  class: "fe-sidenav__rule",
  "aria-hidden": "true"
}, MR = ["aria-label"], DR = ["title", "aria-label"], PR = {
  key: 0,
  class: "fe-sidenav__text"
}, OR = { key: 0 }, LR = ["title", "aria-label"], IR = {
  key: 0,
  class: "fe-sidenav__text"
}, RR = {
  key: 1,
  class: "fe-sidenav__quota",
  "data-testid": "sidenav-quota"
}, NR = {
  key: 0,
  class: "fe-sidenav__quota-label"
}, BR = ["aria-valuenow", "aria-label", "title"], FR = {
  key: 1,
  class: "fe-sidenav__quota-text"
}, l_ = 8, UR = /* @__PURE__ */ rt({
  __name: "SideNav",
  props: {
    expanded: { type: Boolean },
    narrow: { type: Boolean },
    activeView: {},
    activeStorage: {},
    storages: {},
    storageOrderCustom: { type: Boolean },
    sharedStorages: {},
    trashVisible: { type: Boolean },
    draftsVisible: { type: Boolean },
    draftCount: {},
    tags: {},
    tagsLoaded: { type: Boolean },
    activeTag: {},
    activeTagKind: {},
    showConnections: { type: Boolean },
    showMyShares: { type: Boolean },
    showIdentitySurfaces: { type: Boolean },
    canWrite: { type: Boolean },
    locale: {},
    canRequestFiles: { type: Boolean },
    requestFilesAllowed: { type: Boolean, default: !0 },
    canNewDocument: { type: Boolean },
    quota: {},
    theme: {},
    apps: {}
  },
  emits: ["toggle", "open-view", "open-tag", "open-storage", "open-root", "upload", "new-folder", "new-document", "open-connections", "open-tokens", "open-my-shares", "open-app", "request-files", "reorder-storages", "close"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n, formatSize: o, dir: p } = gt(() => t.locale), h = x(() => t.expanded || !!t.narrow), v = x(() => new Set(t.sharedStorages ?? [])), y = /* @__PURE__ */ new Set(["recent", "starred", "shared", "drafts"]), g = x(() => {
      const xe = [
        { key: "home", label: n("sidenav.home") },
        ...t.storages.length <= 1 ? [{ key: "myfiles", label: n("sidenav.myfiles") }] : [],
        { key: "shared", label: n("sidenav.shared") },
        { key: "recent", label: n("sidenav.recent") },
        { key: "starred", label: n("sidenav.starred") }
      ];
      return t.draftsVisible && xe.push({ key: "drafts", label: n("sidenav.drafts") }), t.trashVisible !== !1 && xe.push({ key: "trash", label: n("sidenav.trash") }), t.showIdentitySurfaces === !1 ? xe.filter((ye) => !y.has(ye.key)) : xe;
    }), m = x(() => t.canWrite !== !1), k = x(
      () => (t.apps ?? []).map((xe) => ({
        ...xe,
        svg: wt(xe.icon && wt(xe.icon) !== "" ? xe.icon : "plugin")
      }))
    ), _ = x(
      () => !!t.activeStorage && t.storages.some((xe) => xe.name === t.activeStorage && xe.readOnly === !0)
    ), w = x(() => !_.value && t.activeView !== "trash");
    function $(xe) {
      const ye = t.draftCount ?? 0;
      return xe.key !== "drafts" || ye <= 0 ? xe.label : `${xe.label}, ${n("sidenav.drafts.count", { n: ye })}`;
    }
    function C(xe) {
      return xe === "myfiles" ? !t.activeView && !t.activeStorage : t.activeView === xe;
    }
    const E = b(!1), A = x(() => t.tags ?? []), O = x(
      () => ["personal", "team"].map((xe) => {
        const ye = A.value.filter((qe) => qe.kind === xe);
        return { kind: xe, list: ye, visible: E.value ? ye : ye.slice(0, l_) };
      }).filter((xe) => xe.list.length > 0)
    ), z = x(
      () => O.value.reduce((xe, ye) => xe + ye.list.length - ye.visible.length, 0)
    ), P = x(() => O.value.some((xe) => xe.list.length > l_));
    function I(xe) {
      return t.activeView !== "tag" || t.activeTag !== xe.name ? !1 : !t.activeTagKind || t.activeTagKind === xe.kind;
    }
    const F = x(() => !!t.tagsLoaded || A.value.length > 0), W = b(null), N = b(null), K = x(() => {
      const xe = [
        /* ⚠ NO `icon:` on any of these three, and that is the fix rather than an
           omission. `ContextMenu.iconFor` resolves `actionIconSvg(a.icon || a.key)`,
           so an `icon` string is an OVERRIDE — and `'⬆'` / `'📁'` / `'🔗'` are not
           keys, so the lookup missed, the component fell through to its literal
           branch and printed the emoji. Meanwhile `new-document`, which carries no
           override, resolved by key and drew a proper glyph: one menu, two icon
           systems, three rows apart. All three keys have had stroked glyphs in
           `lib/actionIcons.ts` the whole time (`upload`, `new-folder`,
           `request-files`); dropping the override is what reaches them.
           ⚠ Emoji in markup is forbidden here for a reason that is visible in this
           very menu: they are rendered by whatever font the OS ships, so the row
           came out flat-grey on one machine and full-colour on another, at a weight
           that matched nothing beside it. */
        { key: "upload", label: n("drive.new.upload"), disabled: !m.value },
        { key: "new-folder", label: n("drive.new.folder"), disabled: !m.value }
      ];
      return t.canNewDocument && xe.push({ key: "new-document", label: n("drive.new.document"), disabled: !m.value }), t.requestFilesAllowed !== !1 && (xe.push({ divider: !0, key: "new-sep", label: "" }), xe.push({
        key: "request-files",
        label: n("drive.new.request"),
        disabled: !t.canRequestFiles
      })), xe;
    });
    function M() {
      var ye, qe;
      const xe = (ye = W.value) == null ? void 0 : ye.getBoundingClientRect();
      (qe = N.value) == null || qe.show(
        // ⚠ RTL: hangs from the pill's START edge (its right side in RTL).
        { clientX: xe ? Cr(xe, p.value) : 0, clientY: xe ? xe.bottom + 6 : 0 },
        []
      );
    }
    function j(xe) {
      xe.key === "upload" ? s("upload") : xe.key === "new-document" ? s("new-document") : xe.key === "new-folder" ? s("new-folder") : xe.key === "request-files" && s("request-files");
    }
    const U = x(() => {
      const xe = t.quota;
      return !xe || xe.unlimited || xe.total <= 0 ? 0 : Math.max(0, Math.min(100, Math.round(xe.used / xe.total * 100)));
    }), de = x(() => {
      const xe = t.quota;
      return xe ? xe.unlimited || xe.total <= 0 ? xe.partial ? n("drive.storage.used_partial", { used: o(xe.used) }) : n("drive.storage.used_unlimited", { used: o(xe.used) }) : n("drive.storage.used", { used: o(xe.used), total: o(xe.total) }) : "";
    }), ke = x(() => n("sidenav.close")), ie = x(() => t.storages.length > 1), ce = /* @__PURE__ */ new Map();
    function X(xe, ye) {
      ye instanceof HTMLElement ? ce.set(xe, ye) : ce.delete(xe);
    }
    const Z = b(null), Y = b(null), G = b(""), we = b(!1);
    function R(xe) {
      return t.storages.findIndex((ye) => An(ye) === xe);
    }
    const pe = x(() => {
      const xe = R(G.value), ye = t.storages.length, qe = t.storages.map(An), Ue = i_(t.storages).every((Ye, st) => Ye === qe[st]);
      return [
        {
          key: "storage-move-up",
          icon: "move-up",
          label: n("sidenav.storage.moveUp"),
          disabled: xe <= 0,
          testid: "sidenav-storage-move-up"
        },
        {
          key: "storage-move-down",
          icon: "move-down",
          label: n("sidenav.storage.moveDown"),
          disabled: xe < 0 || xe >= ye - 1,
          testid: "sidenav-storage-move-down"
        },
        { divider: !0, key: "storage-order-sep", label: "" },
        {
          key: "storage-sort-name",
          icon: "sort-name",
          label: n("sidenav.storage.sortName"),
          disabled: Ue,
          // ⚠ A greyed row says why, or it reads as broken (ContextAction.title).
          title: Ue ? n("sidenav.storage.sortName.done") : void 0,
          testid: "sidenav-storage-sort-name"
        },
        {
          // "Use default order": drop the person's own order and fall back to the
          // administrator's (or, with none, the host's). Not "Reset": nothing of
          // the default is being reset, the person's order is being let go.
          key: "storage-default-order",
          icon: "reset-order",
          label: n("sidenav.storage.defaultOrder"),
          disabled: !t.storageOrderCustom,
          title: t.storageOrderCustom ? void 0 : n("sidenav.storage.defaultOrder.none"),
          testid: "sidenav-storage-default-order"
        }
      ];
    });
    function Q(xe, ye, qe = !1) {
      var Ye, st;
      if (!ie.value) return;
      const ut = An(xe);
      G.value = ut, we.value = qe;
      let Ue = ye;
      if (!Ue) {
        const kt = (Ye = ce.get(ut)) == null ? void 0 : Ye.getBoundingClientRect();
        Ue = kt ? { clientX: Cr(kt, p.value), clientY: kt.bottom + 4 } : { clientX: 0, clientY: 0 };
      }
      (st = Y.value) == null || st.show(Ue, []);
    }
    function q(xe, ye) {
      ie.value && (ye.preventDefault(), ye.stopPropagation(), !Ae.touchActive() && Q(xe, { clientX: ye.clientX, clientY: ye.clientY }));
    }
    let re = null;
    function ae(xe = !1) {
      re == null || re();
      const ye = (Ue) => {
        const Ye = Ue.target, st = typeof (Ye == null ? void 0 : Ye.closest) == "function" && !!Ye.closest(".fe-ctx-backdrop");
        !xe && !st || (Ue.preventDefault(), Ue.stopPropagation(), ut());
      }, qe = setTimeout(() => ut(), 1e3);
      function ut() {
        clearTimeout(qe), window.removeEventListener("contextmenu", ye, !0), re = null;
      }
      window.addEventListener("contextmenu", ye, !0), re = ut;
    }
    Mt(() => re == null ? void 0 : re());
    function Pe(xe, ye) {
      ye.key !== "ContextMenu" && !(ye.key === "F10" && ye.shiftKey) || ie.value && (ye.preventDefault(), ye.stopPropagation(), ae(), Q(xe, null));
    }
    async function be(xe, ye) {
      var qe;
      xe !== null && (s("reorder-storages", xe), await Jt(), (qe = ce.get(ye)) == null || qe.focus());
    }
    function ze(xe) {
      const ye = G.value;
      xe.key === "storage-move-up" ? be(o_(t.storages, ye, -1), ye) : xe.key === "storage-move-down" ? be(o_(t.storages, ye, 1), ye) : xe.key === "storage-sort-name" ? be(i_(t.storages), ye) : xe.key === "storage-default-order" && be([], ye);
    }
    const Ae = kI({
      keys: () => t.storages.map(An),
      rowEl: (xe) => ce.get(xe),
      scroller: () => {
        var xe;
        return (xe = Z.value) == null ? void 0 : xe.querySelector(".fe-sidenav__scroll");
      },
      onDrop: (xe, ye) => void be(TI(t.storages, xe, ye), xe),
      onHold: (xe) => {
        const ye = t.storages.find((qe) => An(qe) === xe);
        ye && (ae(!0), Q(ye, null, !0));
      }
    }), { dragKey: Ce, dropGap: He, reordering: J, onClickCapture: me } = Ae;
    function fe(xe, ye) {
      ie.value && Ae.onPointerDown(An(xe), ye);
    }
    return (xe, ye) => (u(), d("nav", {
      ref_key: "navEl",
      ref: Z,
      class: Re(["fe-sidenav", {
        "fe-sidenav--rail": !e.expanded && !e.narrow,
        "fe-sidenav--drawer": e.narrow,
        "fe-sidenav--reordering": r(J)
      }]),
      role: "navigation",
      "aria-label": r(n)("sidenav.title"),
      "data-testid": "sidenav"
    }, [
      e.narrow ? (u(), d("div", II, [
        i("button", {
          type: "button",
          class: "fe-sidenav__toggle",
          "aria-expanded": h.value,
          title: ke.value,
          "aria-label": ke.value,
          "data-testid": "sidenav-toggle",
          onClick: ye[0] || (ye[0] = (qe) => s("close"))
        }, [...ye[8] || (ye[8] = [
          i("svg", {
            class: "fe-ficon",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "1.8",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true",
            focusable: "false"
          }, [
            i("path", { d: "M6 6l12 12M18 6L6 18" })
          ], -1)
        ])], 8, RI)
      ])) : T("", !0),
      i("div", NI, [
        w.value ? (u(), d("button", {
          key: 0,
          ref_key: "newBtnEl",
          ref: W,
          type: "button",
          class: "fe-sidenav__new",
          "aria-haspopup": "menu",
          title: r(n)("drive.new"),
          "aria-label": r(n)("drive.new"),
          "data-testid": "sidenav-new",
          onClick: M
        }, [
          i("span", FI, [
            ye[9] || (ye[9] = i("svg", {
              class: "fe-ficon",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "aria-hidden": "true",
              focusable: "false"
            }, [
              i("path", { d: "M12 5v14M5 12h14" })
            ], -1)),
            h.value ? (u(), d("span", UI, f(r(n)("drive.new")), 1)) : T("", !0)
          ]),
          h.value ? (u(), d("span", HI)) : T("", !0),
          h.value ? (u(), d("span", KI, [...ye[10] || (ye[10] = [
            i("svg", {
              class: "fe-ficon",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "aria-hidden": "true",
              focusable: "false"
            }, [
              i("path", { d: "M7 10l5 5 5-5" })
            ], -1)
          ])])) : T("", !0)
        ], 8, BI)) : T("", !0)
      ]),
      i("div", VI, [
        i("ul", {
          class: "fe-sidenav__group",
          "aria-label": r(n)("sidenav.views")
        }, [
          (u(!0), d(he, null, We(g.value, (qe) => (u(), d(he, {
            key: qe.key
          }, [
            i("li", null, [
              i("button", {
                type: "button",
                class: Re(["fe-sidenav__item", { "is-active": C(qe.key) }]),
                "aria-current": C(qe.key) ? "page" : void 0,
                title: $(qe),
                "aria-label": $(qe),
                "data-testid": `sidenav-view-${qe.key}`,
                onClick: (ut) => s("open-view", qe.key)
              }, [
                (u(), d("svg", WI, [
                  qe.key === "home" ? (u(), d(he, { key: 0 }, [
                    ye[11] || (ye[11] = i("path", { d: "M4 10.5L12 4l8 6.5" }, null, -1)),
                    ye[12] || (ye[12] = i("path", { d: "M6 9.8V19a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9.8" }, null, -1)),
                    ye[13] || (ye[13] = i("path", { d: "M10 20v-5.5h4V20" }, null, -1))
                  ], 64)) : qe.key === "myfiles" ? (u(), d("path", YI)) : qe.key === "recent" ? (u(), d(he, { key: 2 }, [
                    ye[14] || (ye[14] = i("circle", {
                      cx: "12",
                      cy: "12",
                      r: "8.5"
                    }, null, -1)),
                    ye[15] || (ye[15] = i("path", { d: "M12 7.5V12l3 2" }, null, -1))
                  ], 64)) : qe.key === "starred" ? (u(), d("path", GI)) : qe.key === "shared" ? (u(), d(he, { key: 4 }, [
                    ye[16] || (ye[16] = i("circle", {
                      cx: "17.5",
                      cy: "6.5",
                      r: "2.5"
                    }, null, -1)),
                    ye[17] || (ye[17] = i("circle", {
                      cx: "6.5",
                      cy: "12",
                      r: "2.5"
                    }, null, -1)),
                    ye[18] || (ye[18] = i("circle", {
                      cx: "17.5",
                      cy: "17.5",
                      r: "2.5"
                    }, null, -1)),
                    ye[19] || (ye[19] = i("path", { d: "M8.8 10.8l6.4-3.2M8.8 13.2l6.4 3.2" }, null, -1))
                  ], 64)) : qe.key === "drafts" ? (u(), d(he, { key: 5 }, [
                    ye[20] || (ye[20] = i("path", { d: "M13.5 4H7a1.5 1.5 0 0 0-1.5 1.5v13A1.5 1.5 0 0 0 7 20h10a1.5 1.5 0 0 0 1.5-1.5V9z" }, null, -1)),
                    ye[21] || (ye[21] = i("path", { d: "M13.5 4v5h5" }, null, -1)),
                    ye[22] || (ye[22] = i("path", { d: "M9 15.5l4.8-4.8 1.7 1.7-4.8 4.8H9z" }, null, -1))
                  ], 64)) : (u(), d(he, { key: 6 }, [
                    ye[23] || (ye[23] = i("path", { d: "M4.5 7h15" }, null, -1)),
                    ye[24] || (ye[24] = i("path", { d: "M9.5 7V5.2A1.2 1.2 0 0 1 10.7 4h2.6a1.2 1.2 0 0 1 1.2 1.2V7" }, null, -1)),
                    ye[25] || (ye[25] = i("path", { d: "M6.5 7l.9 11.1A1.4 1.4 0 0 0 8.8 19.4h6.4a1.4 1.4 0 0 0 1.4-1.3L17.5 7" }, null, -1))
                  ], 64))
                ])),
                h.value ? (u(), d("span", XI, f(qe.label), 1)) : T("", !0),
                qe.key === "drafts" && (e.draftCount ?? 0) > 0 ? (u(), d("span", {
                  key: 1,
                  class: Re(["fe-sidenav__count", { "fe-sidenav__count--rail": !h.value }]),
                  "aria-hidden": "true",
                  "data-testid": "sidenav-drafts-count"
                }, f(e.draftCount), 3)) : T("", !0)
              ], 10, jI)
            ]),
            qe.key === "shared" && e.showMyShares ? (u(), d("li", JI, [
              i("button", {
                type: "button",
                class: "fe-sidenav__item",
                title: r(n)("sidenav.myshares"),
                "aria-label": r(n)("sidenav.myshares"),
                "data-testid": "sidenav-my-shares",
                onClick: ye[1] || (ye[1] = (ut) => s("open-my-shares"))
              }, [
                ye[26] || (ye[26] = i("svg", {
                  class: "fe-ficon",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "1.8",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "aria-hidden": "true",
                  focusable: "false"
                }, [
                  i("path", { d: "M10 13.5a4.5 4.5 0 0 0 6.8.5l2.7-2.7a4.5 4.5 0 0 0-6.36-6.36L11.6 6.5" }),
                  i("path", { d: "M14 10.5a4.5 4.5 0 0 0-6.8-.5l-2.7 2.7a4.5 4.5 0 0 0 6.36 6.36l1.53-1.53" })
                ], -1)),
                h.value ? (u(), d("span", QI, f(r(n)("sidenav.myshares")), 1)) : T("", !0)
              ], 8, ZI)
            ])) : T("", !0)
          ], 64))), 128))
        ], 8, qI),
        F.value ? (u(), d("div", eR, [
          h.value ? (u(), d(he, { key: 0 }, [
            i("p", tR, f(r(n)("sidenav.tags")), 1),
            (u(!0), d(he, null, We(O.value, (qe) => (u(), d(he, {
              key: qe.kind
            }, [
              i("p", {
                class: "fe-sidenav__subheading",
                "data-testid": `sidenav-tags-${qe.kind}`
              }, [
                ot(Xl, {
                  kind: qe.kind,
                  size: 12
                }, null, 8, ["kind"]),
                i("span", null, f(r(n)(`sidenav.tags.${qe.kind}`)), 1)
              ], 8, aR),
              i("ul", {
                class: "fe-sidenav__group",
                "aria-label": `${r(n)("sidenav.tags")} — ${r(n)(`sidenav.tags.${qe.kind}`)}`
              }, [
                (u(!0), d(he, null, We(qe.visible, (ut) => (u(), d("li", {
                  key: `${ut.kind}:${ut.name}`
                }, [
                  i("button", {
                    type: "button",
                    class: Re(["fe-sidenav__item fe-sidenav__item--tag", { "is-active": I(ut) }]),
                    "aria-current": I(ut) ? "page" : void 0,
                    title: r(n)(`tags.chip.${ut.kind}`, { tag: ut.name }),
                    "aria-label": r(n)(`tags.chip.${ut.kind}`, { tag: ut.name }),
                    "data-testid": `sidenav-tag-${ut.name}`,
                    "data-tag-kind": ut.kind,
                    onClick: (Ue) => s("open-tag", ut.name, ut.kind)
                  }, [
                    ot(Xl, {
                      class: "fe-ficon",
                      kind: ut.kind,
                      size: 16
                    }, null, 8, ["kind"]),
                    i("span", oR, f(ut.name), 1)
                  ], 10, sR)
                ]))), 128))
              ], 8, nR)
            ], 64))), 128)),
            i("ul", {
              class: "fe-sidenav__group",
              "aria-label": r(n)("sidenav.tags")
            }, [
              A.value.length === 0 ? (u(), d("li", rR, [
                i("p", lR, f(r(n)("sidenav.tags.empty")), 1)
              ])) : T("", !0),
              z.value > 0 ? (u(), d("li", uR, [
                i("button", {
                  type: "button",
                  class: "fe-sidenav__more",
                  "data-testid": "sidenav-tags-more",
                  onClick: ye[2] || (ye[2] = (qe) => E.value = !0)
                }, f(r(n)("sidenav.tags.more", { count: z.value })), 1)
              ])) : E.value && P.value ? (u(), d("li", cR, [
                i("button", {
                  type: "button",
                  class: "fe-sidenav__more",
                  "data-testid": "sidenav-tags-less",
                  onClick: ye[3] || (ye[3] = (qe) => E.value = !1)
                }, f(r(n)("sidenav.tags.less")), 1)
              ])) : T("", !0)
            ], 8, iR)
          ], 64)) : (u(), d(he, { key: 1 }, [
            ye[28] || (ye[28] = i("hr", {
              class: "fe-sidenav__rule",
              "aria-hidden": "true"
            }, null, -1)),
            i("ul", {
              class: "fe-sidenav__group",
              "aria-label": r(n)("sidenav.tags")
            }, [
              i("li", null, [
                i("button", {
                  type: "button",
                  class: Re(["fe-sidenav__item", { "is-active": e.activeView === "tag" }]),
                  title: r(n)("sidenav.tags"),
                  "aria-label": r(n)("sidenav.tags"),
                  "data-testid": "sidenav-tags-rail",
                  onClick: ye[4] || (ye[4] = (qe) => s("toggle"))
                }, [...ye[27] || (ye[27] = [
                  i("svg", {
                    class: "fe-ficon",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "1.8",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "aria-hidden": "true",
                    focusable: "false"
                  }, [
                    i("path", { d: "M4 4.5h7l9 9-6.5 6.5-9-9z" }),
                    i("circle", {
                      cx: "8",
                      cy: "8.5",
                      r: "1.4"
                    })
                  ], -1)
                ])], 10, fR)
              ])
            ], 8, dR)
          ], 64))
        ])) : T("", !0),
        e.storages.length ? (u(), d("div", pR, [
          h.value ? (u(), d("p", vR, f(r(n)("sidenav.storages")), 1)) : (u(), d("hr", hR)),
          i("ul", {
            class: "fe-sidenav__group",
            "aria-label": r(n)("sidenav.storages"),
            "data-testid": "sidenav-storages",
            onClickCapture: ye[5] || (ye[5] = //@ts-ignore
            (...qe) => r(me) && r(me)(...qe))
          }, [
            (u(!0), d(he, null, We(e.storages, (qe, ut) => (u(), d("li", {
              key: qe.name,
              class: Re({
                "is-drop-before": r(He) === ut,
                "is-drop-after": r(He) === e.storages.length && ut === e.storages.length - 1
              })
            }, [
              i("button", {
                ref_for: !0,
                ref: (Ue) => X(r(An)(qe), Ue),
                type: "button",
                class: Re(["fe-sidenav__item fe-sidenav__item--storage", {
                  "is-active": !e.activeView && e.activeStorage === qe.name,
                  "is-dragging": r(Ce) === r(An)(qe)
                }]),
                title: v.value.has(qe.name) ? `${qe.label || qe.name} — ${r(n)("sidenav.storage.shared")}` : qe.label || qe.name,
                "aria-label": v.value.has(qe.name) ? `${qe.label || qe.name} — ${r(n)("sidenav.storage.shared")}` : qe.label || qe.name,
                "data-testid": `sidenav-storage-${qe.name}`,
                onClick: (Ue) => s("open-storage", qe.name),
                onContextmenu: (Ue) => q(qe, Ue),
                onKeydown: (Ue) => Pe(qe, Ue),
                onPointerdown: (Ue) => fe(qe, Ue)
              }, [
                (u(), d("svg", gR, [
                  v.value.has(qe.name) ? (u(), d(he, { key: 0 }, [
                    ye[29] || (ye[29] = i("path", { d: "M3 8.5A1.5 1.5 0 0 1 4.5 7h5L11 9h8.5A1.5 1.5 0 0 1 21 10.5v7A1.5 1.5 0 0 1 19.5 19h-15A1.5 1.5 0 0 1 3 17.5z" }, null, -1)),
                    ye[30] || (ye[30] = i("circle", {
                      cx: "15.6",
                      cy: "13.6",
                      r: "1.6"
                    }, null, -1)),
                    ye[31] || (ye[31] = i("circle", {
                      cx: "9.4",
                      cy: "15.4",
                      r: "1.6"
                    }, null, -1)),
                    ye[32] || (ye[32] = i("path", { d: "M10.9 14.7l3.3-.9" }, null, -1))
                  ], 64)) : (u(), d(he, { key: 1 }, [
                    ye[33] || (ye[33] = i("rect", {
                      x: "3",
                      y: "5",
                      width: "18",
                      height: "6",
                      rx: "1.6"
                    }, null, -1)),
                    ye[34] || (ye[34] = i("rect", {
                      x: "3",
                      y: "13",
                      width: "18",
                      height: "6",
                      rx: "1.6"
                    }, null, -1)),
                    ye[35] || (ye[35] = i("path", { d: "M6.5 8h.01M6.5 16h.01" }, null, -1))
                  ], 64))
                ])),
                h.value ? (u(), d("span", bR, f(qe.label || qe.name), 1)) : T("", !0),
                h.value && v.value.has(qe.name) ? (u(), d("span", {
                  key: 1,
                  class: "fe-sidenav__tag",
                  role: "img",
                  "aria-label": r(n)("sidenav.storage.shared")
                }, f(r(n)("sidenav.storage.shared")), 9, _R)) : T("", !0),
                h.value && qe.readOnly ? (u(), nt(y0, {
                  key: 2,
                  "read-only": "",
                  locale: e.locale,
                  class: "fe-sidenav__stags",
                  "data-testid": "sidenav-storage-readonly"
                }, null, 8, ["locale"])) : T("", !0)
              ], 42, yR)
            ], 2))), 128))
          ], 40, mR)
        ])) : T("", !0),
        k.value.length ? (u(), d("div", kR, [
          h.value ? (u(), d("p", wR, f(r(n)("sidenav.apps")), 1)) : (u(), d("hr", xR)),
          i("ul", {
            class: "fe-sidenav__group",
            "aria-label": r(n)("sidenav.apps")
          }, [
            (u(!0), d(he, null, We(k.value, (qe) => (u(), d("li", {
              key: qe.key
            }, [
              i("button", {
                type: "button",
                class: "fe-sidenav__item",
                title: qe.label,
                "aria-label": qe.label,
                "data-testid": `sidenav-app-${qe.key}`,
                onClick: (ut) => s("open-app", qe.key)
              }, [
                i("span", {
                  class: "fe-sidenav__appicon",
                  "aria-hidden": "true",
                  innerHTML: qe.svg
                }, null, 8, TR),
                h.value ? (u(), d("span", CR, f(qe.label), 1)) : T("", !0)
              ], 8, SR)
            ]))), 128))
          ], 8, $R)
        ])) : T("", !0),
        e.showConnections ? (u(), d("div", ER, [
          h.value ? (u(), d("p", AR, f(r(n)("sidenav.connections")), 1)) : (u(), d("hr", zR)),
          i("ul", {
            class: "fe-sidenav__group",
            "aria-label": r(n)("sidenav.connections")
          }, [
            i("li", null, [
              i("button", {
                type: "button",
                class: "fe-sidenav__item",
                title: r(n)("sidenav.connect"),
                "aria-label": r(n)("sidenav.connect"),
                "data-testid": "sidenav-connect",
                onClick: ye[6] || (ye[6] = (qe) => s("open-connections"))
              }, [
                ye[36] || (ye[36] = i("svg", {
                  class: "fe-ficon",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "1.8",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "aria-hidden": "true",
                  focusable: "false"
                }, [
                  i("path", { d: "M9.5 14.5l-2.6 2.6a3.7 3.7 0 0 1-5.2-5.2l2.6-2.6" }),
                  i("path", { d: "M14.5 9.5l2.6-2.6a3.7 3.7 0 0 1 5.2 5.2l-2.6 2.6" }),
                  i("path", { d: "M9 15l6-6" })
                ], -1)),
                h.value ? (u(), d("span", PR, f(r(n)("sidenav.connect")), 1)) : T("", !0)
              ], 8, DR)
            ]),
            e.showIdentitySurfaces !== !1 ? (u(), d("li", OR, [
              i("button", {
                type: "button",
                class: "fe-sidenav__item",
                title: r(n)("sidenav.apikeys"),
                "aria-label": r(n)("sidenav.apikeys"),
                "data-testid": "sidenav-apikeys",
                onClick: ye[7] || (ye[7] = (qe) => s("open-tokens"))
              }, [
                ye[37] || (ye[37] = i("svg", {
                  class: "fe-ficon",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "1.8",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "aria-hidden": "true",
                  focusable: "false"
                }, [
                  i("circle", {
                    cx: "8",
                    cy: "12",
                    r: "3.5"
                  }),
                  i("path", { d: "M11.5 12H21" }),
                  i("path", { d: "M17.5 12v3.2M20 12v2.2" })
                ], -1)),
                h.value ? (u(), d("span", IR, f(r(n)("sidenav.apikeys")), 1)) : T("", !0)
              ], 8, LR)
            ])) : T("", !0)
          ], 8, MR)
        ])) : T("", !0)
      ]),
      e.quota ? (u(), d("div", RR, [
        h.value ? (u(), d("p", NR, f(r(n)("drive.storage.label")), 1)) : T("", !0),
        i("div", {
          class: "fe-sidenav__quota-bar",
          role: "progressbar",
          "aria-valuenow": U.value,
          "aria-valuemin": "0",
          "aria-valuemax": "100",
          "aria-label": de.value,
          title: de.value
        }, [
          i("span", {
            class: "fe-sidenav__quota-fill",
            style: Vt({ width: U.value + "%" })
          }, null, 4)
        ], 8, BR),
        h.value ? (u(), d("p", FR, f(de.value), 1)) : T("", !0)
      ])) : T("", !0),
      ot(zr, {
        ref_key: "newMenuRef",
        ref: N,
        locale: e.locale,
        theme: e.theme,
        actions: K.value,
        onSelect: j
      }, null, 8, ["locale", "theme", "actions"]),
      ot(zr, {
        ref_key: "storageMenuRef",
        ref: Y,
        locale: e.locale,
        theme: e.theme,
        sheet: we.value,
        actions: pe.value,
        onSelect: ze
      }, null, 8, ["locale", "theme", "sheet", "actions"])
    ], 10, LI));
  }
}), g0 = "application/x-brf-files", HR = "application/x-brf-files-src";
let hr = null;
const KR = 5 * 6e4;
function VR(e, a) {
  hr = { items: e.slice(), origin: a, startedAt: Date.now() };
}
function Wo() {
  hr = null;
}
function uu() {
  return hr ? Date.now() - hr.startedAt > KR ? (hr = null, null) : hr : null;
}
function Pn(e) {
  var a;
  return (a = e.dataTransfer) != null && a.types.includes(g0) ? !0 : uu() !== null;
}
function Vc(e) {
  var s;
  const a = (s = e.dataTransfer) == null ? void 0 : s.getData(g0);
  if (a)
    try {
      const n = JSON.parse(a);
      return Array.isArray(n) && n.length > 0 ? n : null;
    } catch {
      return null;
    }
  const t = uu();
  return t && t.items.length > 0 ? t.items : null;
}
function Wv(e) {
  var t, s;
  const a = (t = e.dataTransfer) == null ? void 0 : t.getData(HR);
  return a || ((s = uu()) == null ? void 0 : s.origin) || void 0;
}
function Np(e) {
  const a = qR(e);
  return a === void 0 || a === "none" || a === "csrf";
}
function qR(e) {
  if (!e || typeof e != "object") return;
  const a = e;
  return typeof a.kind == "string" ? a.kind : typeof a.type == "string" ? a.type : void 0;
}
function jR(e, a, t) {
  if (e.type !== "file") return null;
  let s = a;
  try {
    s = new URL(a, typeof location < "u" ? location.href : void 0).toString();
  } catch {
    return null;
  }
  if (!/^https?:/i.test(s)) return null;
  const n = e.basename.replace(/[:\r\n]/g, "_");
  return `${t && t.trim() ? t : "application/octet-stream"}:${n}:${s}`;
}
function WR(e) {
  return e.map((a) => a.path).sort().join("\0");
}
function YR(e, a = {}) {
  const t = a.now ?? (() => Date.now()), s = a.refreshBelowMs ?? 3e4, n = a.usableAboveMs ?? 5e3, o = a.failPauseMs ?? 3e4, p = a.max ?? 32, h = /* @__PURE__ */ new Map(), v = /* @__PURE__ */ new Map();
  let y = null, g = null, m = !0;
  function k(C) {
    const E = h.get(C);
    return E ? E.expiresAt - t() : -1 / 0;
  }
  function _(C) {
    y = C;
    let E;
    try {
      E = e(C);
    } catch (A) {
      E = Promise.reject(A);
    }
    E.then((A) => {
      var O;
      if (A === null) {
        m && (m = !1, h.clear(), (O = a.onUnsupported) == null || O.call(a));
        return;
      }
      for (h.delete(C), h.set(C, { url: A.url, expiresAt: t() + A.ttlMs }); h.size > p; ) {
        const z = h.keys().next().value;
        if (z === void 0) break;
        h.delete(z);
      }
    }).catch(() => {
      v.set(C, t() + o);
    }).finally(() => {
      y = null;
      const A = g;
      g = null, A && w(A);
    });
  }
  function w(C) {
    if (!m || !C || k(C) > s) return;
    const E = v.get(C);
    if (E !== void 0) {
      if (E > t()) return;
      v.delete(C);
    }
    if (y !== C) {
      if (y !== null) {
        g = C;
        return;
      }
      _(C);
    }
  }
  function $(C) {
    const E = h.get(C);
    return E ? (h.delete(C), E.expiresAt - t() > n ? E.url : null) : null;
  }
  return {
    warm: w,
    take: $,
    get supported() {
      return m;
    }
  };
}
function GR(e, a) {
  const { t } = a, s = !!e.dropped;
  return e.error === "drop_not_found" ? { kind: "flash", message: t("dragout.not_found") } : e.error === "cancelled" ? { kind: "flash", message: t("dragout.stopped") } : e.error ? s || !a.quiet ? { kind: "flash", message: e.error } : null : s ? e.finished ? { kind: "flash", message: t("dragout.done") } : {
    kind: "hold",
    message: e.files ? t("dragout.downloading_n", { n: e.files }) : t("dragout.downloading"),
    stoppable: a.stoppable
  } : a.quiet ? null : !e.finished && e.done === 0 ? { kind: "flash", message: t("dragout.preparing") } : null;
}
const ir = 8 * 1024, XR = 4 * 1024 * 1024, JR = 3, ZR = 24, u_ = 120, QR = 16, eN = 8, tN = 400, aN = /* @__PURE__ */ new Set(["csv", "tsv"]);
function nN(e) {
  if (e.trashed) return !0;
  const a = e.extra_metadata;
  return !!a && typeof a == "object" && "deleted_at" in a;
}
function Yv(e) {
  if (e.type !== "file" || e.basename === ".trash" || e.mime_type === "inode/storage" || nN(e)) return null;
  const a = e.size ?? 0;
  if (a <= 0 || a > XR) return null;
  const t = (e.extension || "").trim().toLowerCase();
  if (aN.has(t)) return "table";
  const s = Ks(e);
  return s === "code" ? "code" : s === "text" ? "text" : null;
}
function dm(e) {
  if (e.type !== "file") return !1;
  switch (Ks(e)) {
    case "pdf":
    case "doc":
    case "sheet":
    case "slides":
      return !0;
    default:
      return !1;
  }
}
function b0(e) {
  return e.type === "file" && Ks(e) === "video";
}
const sN = /* @__PURE__ */ new Set([
  "import",
  "export",
  "from",
  "require",
  "include",
  "use",
  "using",
  "package",
  "module",
  "namespace",
  "const",
  "let",
  "var",
  "function",
  "func",
  "fn",
  "def",
  "class",
  "struct",
  "enum",
  "interface",
  "type",
  "impl",
  "trait",
  "public",
  "private",
  "protected",
  "static",
  "async",
  "await",
  "return",
  "if",
  "else",
  "for",
  "while",
  "switch",
  "case",
  "try",
  "catch",
  "select",
  "insert",
  "update",
  "delete",
  "create",
  "alter",
  "drop"
]), oN = /^(#{1,6}|[-*+]|>|\d+\.)$/;
function iN(e) {
  return e.replace(/[(){}[\];:,.]+$/, "").toLowerCase();
}
function rN(e, a) {
  const t = e.length > u_ ? e.slice(0, u_) : e, s = /^(\s*)(\S+)([\s\S]*)$/.exec(t);
  if (!s) return { indent: "", tint: "", text: t };
  const [, n, o, p] = s;
  return (a === "code" ? sN.has(iN(o)) : oN.test(o)) ? { indent: n, tint: o, text: p } : { indent: "", tint: "", text: t };
}
function lN(e, a) {
  const t = [];
  let s = "", n = !1;
  for (let o = 0; o < e.length; o++) {
    const p = e[o];
    n ? p === '"' ? e[o + 1] === '"' ? (s += '"', o++) : n = !1 : s += p : p === '"' ? n = !0 : p === a ? (t.push(s), s = "") : s += p;
  }
  return t.push(s), t;
}
function uN(e, a) {
  return e === "tsv" ? "	" : !a.includes(",") && a.includes(";") ? ";" : ",";
}
function cN(e, a, t, s) {
  for (let h = 0; h < e.length; h++)
    if (e[h] === 0) return null;
  const n = new TextDecoder("utf-8", { fatal: !1 }).decode(e);
  let o = 0;
  for (const h of n) h === "�" && o++;
  if (n.length > 0 && o / n.length > 0.1) return null;
  const p = n.split(/\r\n|\r|\n/);
  for (s && p.length > 1 && p.pop(); p.length && p[0].trim() === ""; ) p.shift();
  for (; p.length && p[p.length - 1].trim() === ""; ) p.pop();
  if (p.length === 0) return null;
  if (a === "table") {
    const h = uN(t, p[0]), v = p.filter((g) => g.trim() !== "").slice(0, QR).map((g) => lN(g, h).slice(0, eN).map((m) => m.trim().slice(0, 24)));
    if (v.length === 0) return null;
    const y = v.reduce((g, m) => Math.max(g, m.length), 0);
    for (const g of v) for (; g.length < y; ) g.push("");
    return { kind: a, lines: [], rows: v, cols: y };
  }
  return {
    kind: a,
    lines: p.slice(0, ZR).map((h) => rN(h, a)),
    rows: [],
    cols: 0
  };
}
const dN = "\0";
function zl(e) {
  const t = (typeof e.etag == "string" ? e.etag : "") || String(e.last_modified ?? "") || String(e.size ?? "");
  return `${e.path}${dN}${t}`;
}
function _0(e) {
  const a = e.apiBase !== void 0 && typeof e.authHeaders == "function" && typeof IntersectionObserver < "u" && typeof fetch == "function", t = b({}), s = [], n = /* @__PURE__ */ new Set(), o = /* @__PURE__ */ new Set(), p = [], h = /* @__PURE__ */ new Set(), v = /* @__PURE__ */ new WeakMap();
  let y = 0, g = null;
  const m = /* @__PURE__ */ new Map();
  function k(z) {
    const P = Xk({ apiBase: e.apiBase }).manager, I = P.includes("?") ? "&" : "?", F = new URLSearchParams({ q: "preview", action: "preview", path: z });
    return `${P}${I}${F.toString()}`;
  }
  function _(z, P) {
    if (s.length >= tN) {
      const I = s.shift();
      if (I) {
        const F = { ...t.value };
        delete F[I], t.value = F;
      }
    }
    s.push(z), t.value = { ...t.value, [z]: P };
  }
  async function w(z) {
    const P = z.body;
    if (!P) {
      const M = new Uint8Array(await z.arrayBuffer());
      return { bytes: M.slice(0, ir), truncated: M.length > ir };
    }
    const I = P.getReader(), F = [];
    let W = 0;
    try {
      for (; W < ir; ) {
        const { done: M, value: j } = await I.read();
        if (M) break;
        j && j.length && (F.push(j), W += j.length);
      }
    } finally {
      try {
        await I.cancel();
      } catch {
      }
    }
    const N = new Uint8Array(Math.min(W, ir));
    let K = 0;
    for (const M of F) {
      if (K >= N.length) break;
      N.set(M.subarray(0, N.length - K), K), K += M.length;
    }
    return { bytes: N, truncated: W >= ir };
  }
  async function $(z, P) {
    const I = zl(z), F = new AbortController();
    h.add(F);
    try {
      const W = e.authHeaders ? await e.authHeaders() : {}, N = await fetch(k(z.path), {
        headers: { ...W, Accept: "*/*", Range: `bytes=0-${ir - 1}` },
        credentials: e.credentials,
        signal: F.signal
      });
      if (!N.ok && N.status !== 206) throw new Error(String(N.status));
      const { bytes: K, truncated: M } = await w(N);
      F.abort();
      const j = (z.extension || "").trim().toLowerCase(), U = cN(K, P, j, M);
      if (!U) {
        n.add(I);
        return;
      }
      _(I, U);
    } catch {
      n.add(I);
    } finally {
      h.delete(F);
    }
  }
  function C() {
    for (; y < JR && p.length > 0; ) {
      const z = p.shift(), P = Yv(z);
      o.delete(zl(z)), P && (y++, $(z, P).finally(() => {
        y--, C();
      }));
    }
  }
  function E(z) {
    const P = zl(z);
    t.value[P] || n.has(P) || o.has(P) || (o.add(P), p.push(z), C());
  }
  function A() {
    return a ? (g || (g = new IntersectionObserver(
      (z) => {
        for (const P of z) {
          if (!P.isIntersecting) continue;
          const I = m.get(P.target);
          g == null || g.unobserve(P.target), m.delete(P.target), I && E(I);
        }
      },
      { rootMargin: "150px" }
    )), g) : null;
  }
  function O(z) {
    var P;
    return !a || (P = e.disabled) != null && P.call(e) ? null : Yv(z);
  }
  return {
    enabled: a,
    kindFor: O,
    get(z) {
      return a ? t.value[zl(z)] ?? null : null;
    },
    bind(z, P) {
      if (!z || !O(P)) return;
      const I = zl(P);
      if (v.get(z) === I || (v.set(z, I), t.value[I] || n.has(I))) return;
      const F = A();
      F && (m.set(z, P), F.observe(z));
    },
    stats: () => ({
      loaded: s.length,
      inflight: y,
      queued: p.length,
      failed: n.size
    }),
    dispose() {
      g == null || g.disconnect(), g = null, m.clear();
      for (const z of h) z.abort();
      h.clear(), p.length = 0, o.clear();
    }
  };
}
function fN(e, a) {
  if (!e) return { id: "none", label: a.t("group.no_date") };
  const t = /* @__PURE__ */ new Date(), s = Lg(t), n = Lg(e);
  if (n >= s) return { id: "today", label: a.t("group.today") };
  if (n === s - 1) return { id: "yesterday", label: a.t("group.yesterday") };
  if (n > s - 7) return { id: "week", label: a.t("group.this_week") };
  const o = a.zonedYearMonth(e);
  return o === a.zonedYearMonth(t) ? { id: "month", label: a.t("group.this_month") } : { id: `m-${o}`, label: a.formatMonthYear(e) };
}
function fm(e, a) {
  return a !== "relevance" && e === "modified";
}
function pm(e, a) {
  var n;
  const t = [];
  if (!a.active)
    t.push({ id: "all", label: null, items: [...e] });
  else {
    let o = null;
    for (const p of e) {
      const h = ((n = a.aside) == null ? void 0 : n.call(a, p)) ?? null, v = h ? { id: h.id, label: h.label ?? null } : fN(a.dateOf(p), a.labels);
      (!o || o.id !== v.id) && (o = { id: v.id, label: v.label, items: [] }, t.push(o)), o.items.push(p);
    }
  }
  const s = /* @__PURE__ */ new Map();
  for (const o of t)
    o.label && o.items.length && s.set(o.items[0], o.label);
  return {
    active: a.active,
    runs: t,
    headingBefore: (o) => s.get(o) ?? null
  };
}
async function k0(e, a, t = {}) {
  const s = {
    "Content-Type": "application/json",
    ...await (t.authHeaders ?? (() => ({})))()
  }, n = t.apiBase ?? "", o = await fetch(`${n}/api/files/manager/star`, {
    method: "POST",
    headers: s,
    credentials: t.authCredentials ?? "same-origin",
    body: JSON.stringify({ node_id: e, starred: a })
  });
  if (!o.ok) throw tn(o.status, await o.text().catch(() => ""), t.locale);
}
const pN = ["aria-pressed", "title", "aria-label"], vN = {
  viewBox: "0 0 24 24",
  width: "16",
  height: "16",
  "aria-hidden": "true"
}, hN = ["fill"], mN = {
  key: 0,
  class: "filex-star-label"
}, nf = /* @__PURE__ */ rt({
  __name: "StarButton",
  props: {
    starred: { type: Boolean },
    nodeId: {},
    apiBase: {},
    authHeaders: { type: Function },
    authCredentials: {},
    compact: { type: Boolean },
    card: { type: Boolean },
    locale: {}
  },
  emits: ["change", "error"],
  setup(e, { emit: a }) {
    const t = e, s = a, n = b(t.starred);
    Qe(() => t.starred, (v) => {
      n.value = v;
    });
    const { t: o } = gt(() => Ha(t.locale)), p = x(() => o(n.value ? "ctx.unstar" : "ctx.star"));
    async function h() {
      const v = !n.value;
      n.value = v;
      try {
        await k0(t.nodeId, v, {
          apiBase: t.apiBase,
          authHeaders: t.authHeaders,
          authCredentials: t.authCredentials,
          locale: Ha(t.locale)
        }), s("change", v);
      } catch (y) {
        n.value = !v, s("error", y instanceof Error ? y.message : String(y));
      }
    }
    return (v, y) => (u(), d("button", {
      type: "button",
      class: Re(["filex-star-btn", { "is-starred": n.value, "is-compact": e.compact, "is-card": e.card }]),
      "aria-pressed": n.value,
      title: p.value,
      "aria-label": p.value,
      "data-testid": "star-toggle",
      onClick: ft(h, ["stop"])
    }, [
      (u(), d("svg", vN, [
        i("path", {
          fill: n.value ? "currentColor" : "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linejoin": "round",
          d: "M12 2.5l3.09 6.26 6.91 1-5 4.87 1.18 6.87L12 18.27l-6.18 3.23L7 14.63 2 9.76l6.91-1z"
        }, null, 8, hN)
      ])),
      e.compact ? T("", !0) : (u(), d("span", mN, f(p.value), 1))
    ], 10, pN));
  }
}), c_ = "300px";
let Rs = null;
const mr = /* @__PURE__ */ new Map();
function yN() {
  return Rs || (Rs = new IntersectionObserver(
    (e) => {
      for (const a of e) {
        if (!a.isIntersecting) continue;
        const t = mr.get(a.target);
        t && (mr.delete(a.target), Rs == null || Rs.unobserve(a.target), t.forEach((s) => s()));
      }
    },
    // `rootMargin` widens the viewport only: a tile in the pane's own scroll
    // box is still cut off at that box's edge. `scrollMargin` widens the
    // scroll boxes too (Chromium 120+; an engine that does not know it
    // ignores it, and the picture is asked for as the tile scrolls in).
    { rootMargin: c_, scrollMargin: c_ }
  )), Rs;
}
function gN(e, a) {
  if (!e || typeof IntersectionObserver > "u")
    return a(), () => {
    };
  let t = mr.get(e);
  return t || (t = /* @__PURE__ */ new Set(), mr.set(e, t), yN().observe(e)), t.add(a), () => {
    const s = mr.get(e);
    s && (s.delete(a), s.size === 0 && (mr.delete(e), Rs == null || Rs.unobserve(e)));
  };
}
const bN = ["src"], _N = {
  key: 2,
  class: "fe-thumb__play",
  "aria-hidden": "true"
}, vm = /* @__PURE__ */ rt({
  inheritAttrs: !1,
  __name: "ThumbTile",
  props: {
    node: {},
    srcOf: { type: Function },
    videoBadge: { type: Boolean }
  },
  setup(e) {
    const a = e, t = b(!1);
    let s = null;
    Kt(() => {
      var p;
      const o = (p = hi()) == null ? void 0 : p.subTree.el;
      s = gN(o == null ? void 0 : o.parentElement, () => {
        t.value = !0;
      });
    }), Mt(() => s == null ? void 0 : s());
    const n = x(() => t.value ? a.srcOf(a.node) : null);
    return (o, p) => (u(), d(he, null, [
      n.value ? (u(), d("img", Xc({ key: 0 }, o.$attrs, {
        src: n.value,
        draggable: "false"
      }), null, 16, bN)) : wa(o.$slots, "default", { key: 1 }),
      n.value && e.videoBadge ? (u(), d("span", _N)) : T("", !0)
    ], 64));
  }
});
function xd(e) {
  const a = [];
  if (!e) return a;
  const t = /«([^«»]*)»/g;
  let s = 0, n;
  for (; (n = t.exec(e)) !== null; )
    n.index > s && a.push({ text: e.slice(s, n.index), match: !1 }), n[1] && a.push({ text: n[1], match: !0 }), s = n.index + n[0].length;
  return s < e.length && a.push({ text: e.slice(s), match: !1 }), a;
}
function w0(e) {
  return e === "content" || e === "both";
}
function hm(e, a, t) {
  const s = e.dataTransfer;
  if (!(!s || typeof document > "u" || typeof s.setDragImage != "function"))
    try {
      const n = document.createElement("div");
      n.className = "fe-dragghost";
      const o = document.createElement("span");
      if (o.className = "fe-dragghost__name", o.dir = "auto", o.textContent = a, n.appendChild(o), t > 1) {
        const p = document.createElement("span");
        p.className = "fe-dragghost__badge", p.textContent = String(t), n.appendChild(p);
      }
      n.style.position = "fixed", n.style.top = "-1000px", n.style.left = "-1000px", document.body.appendChild(n), s.setDragImage(n, 14, 14), setTimeout(() => n.remove(), 0);
    } catch {
    }
}
const kN = { class: "fe-gridbox" }, wN = {
  key: 0,
  class: "fe-grid__refreshing",
  role: "status"
}, xN = { class: "fe-sr-only" }, $N = ["aria-label", "aria-busy"], SN = {
  key: 0,
  class: "fe-grid__heading",
  "aria-hidden": "true"
}, TN = ["aria-selected", "aria-label", "data-fe-path", "onClick", "onDblclick", "onContextmenu", "onDragstart", "onDragover", "onDragleave", "onDrop", "onTouchstartPassive"], CN = ["dir"], EN = {
  key: 0,
  class: "fe-fprev__tint"
}, AN = ["innerHTML"], zN = ["aria-label", "innerHTML"], MN = ["innerHTML"], DN = { class: "fe-grid__foot" }, PN = ["aria-label", "innerHTML"], ON = ["innerHTML"], LN = ["onClick"], IN = { class: "fe-grid__main" }, RN = ["title"], NN = ["title", "aria-label"], BN = ["title"], FN = ["title", "aria-label"], UN = ["title", "aria-label", "data-link-state"], HN = ["title"], KN = ["title"], VN = {
  key: 0,
  class: "fe-grid__mark"
}, qN = ["aria-label", "title", "onClick"], jN = {
  key: 0,
  class: "fe-grid__empty"
}, Gv = /* @__PURE__ */ rt({
  __name: "GridView",
  props: {
    files: {},
    selected: {},
    clipped: {},
    showParentPath: { type: Boolean },
    locale: {},
    loading: { type: Boolean },
    thumbSrc: {},
    keepBadgeFor: {},
    starredIds: {},
    starEnabled: { type: Boolean },
    apiBase: {},
    authHeaders: {},
    authCredentials: {},
    sections: { type: Boolean },
    order: {},
    e2eActive: { type: Boolean },
    selectable: { type: Boolean, default: !0 }
  },
  emits: ["click-card", "dbl-card", "context-card", "item-drag-start", "item-drop-into", "star-change", "display-order"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n, formatSize: o, nodeDisplayName: p, formatDate: h, formatMonthYear: v, zonedYearMonth: y, toDate: g } = gt(() => t.locale);
    function m(q) {
      return li(Tu(q), { t: n, formatDate: h, locale: t.locale });
    }
    function k(q) {
      return Cu(q, { t: n });
    }
    const _ = x(() => [...t.files].sort(zv));
    Qe(
      _,
      (q) => s("display-order", q),
      { immediate: !0 }
    );
    const w = x(() => {
      var q;
      return ((q = _.value.find((re) => re.type === "dir")) == null ? void 0 : q.path) ?? null;
    }), $ = x(() => {
      var q;
      return ((q = _.value.find((re) => re.type !== "dir")) == null ? void 0 : q.path) ?? null;
    }), C = $u(), E = x(
      () => pm(_.value, {
        active: fm(C.key.value, t.order),
        dateOf: (q) => g(q.last_modified),
        /* Folders keep their own run at the top — the same rule the list follows,
         * and the reason "folders before files" survives a date sort. Here the run
         * is the one that already had a name. */
        aside: (q) => q.type === "dir" ? { id: "dirs", label: t.sections ? n("drive.section.folders") : null } : null,
        labels: { t: n, formatMonthYear: v, zonedYearMonth: y }
      })
    );
    function A(q) {
      return E.value.active ? E.value.headingBefore(q) : t.sections ? q.path === w.value ? n("drive.section.folders") : q.path === $.value ? n("drive.section.files") : null : null;
    }
    function O(q) {
      return t.thumbSrc ? t.thumbSrc(q) : q.thumb_url ?? null;
    }
    const z = _0({
      // Read once: the explorer's `config.apiBase` is fixed for the life of a
      // mounted panel, and `enabled` has to be answerable at construction.
      apiBase: t.apiBase,
      // Wrapped rather than passed, so a parent that re-creates its arrow on each
      // render is still called through the CURRENT prop. ⚠ The builder is async;
      // `createFilePreviews` awaits it (see the note there — a Promise spread into
      // a headers object sends no Authorization and 401s in silence).
      authHeaders: t.authHeaders ? () => t.authHeaders() : void 0,
      credentials: t.authCredentials,
      disabled: () => t.e2eActive === !0
    });
    Mt(() => z.dispose());
    function P(q) {
      return z.kindFor(q);
    }
    function I(q) {
      const re = z.get(q);
      return re ? [re] : [];
    }
    function F(q, re) {
      z.bind(q instanceof Element ? q : null, re);
    }
    function W(q) {
      return t.starEnabled === !1 ? !1 : t.apiBase !== void 0 && typeof q.id == "number" && q.type === "file";
    }
    function N(q) {
      return t.selected.has(q.path);
    }
    function K(q, re) {
      s("click-card", q, um(re));
    }
    function M(q, re) {
      s("click-card", q, lm(re, Y.isTap(re)));
    }
    function j(q) {
      s("dbl-card", q);
    }
    function U(q, re) {
      re.preventDefault(), re.stopPropagation(), s("context-card", q, re);
    }
    function de(q, re) {
      U(q, re);
    }
    function ke(q, re) {
      hm(
        re,
        p(q),
        t.selected.has(q.path) ? t.selected.size : 1
      ), s("item-drag-start", q, re);
    }
    const ie = b(null);
    function ce(q, re) {
      q.type === "dir" && Pn(re) && (re.preventDefault(), re.stopPropagation(), re.dataTransfer && (re.dataTransfer.dropEffect = "move"), ie.value = q.path);
    }
    function X(q) {
      ie.value === q.path && (ie.value = null);
    }
    function Z(q, re) {
      ie.value = null, q.type === "dir" && Pn(re) && (re.preventDefault(), re.stopPropagation(), s("item-drop-into", q, re));
    }
    const Y = cm(
      (q, re) => s("context-card", q, { ...re, preventDefault: () => {
      }, stopPropagation: () => {
      } }),
      {
        // A finger lifted on the item, off its controls, opens at touchend — see useRowTouch.
        onTap: (q) => s("click-card", q, { ctrl: !1, shift: !1, touch: !0 })
      }
    );
    function G(q) {
      return h(q);
    }
    function we(q) {
      if (q.type === "dir") return n("node.folder");
      const re = G(q.last_modified), ae = o(q.size);
      return re ? `${ae} • ${re}` : ae;
    }
    function R(q) {
      return q === "kept" ? "✓" : q === "syncing" ? "⟳" : q === "partial" ? "◐" : "☁";
    }
    function pe(q) {
      const re = q.snippet;
      return typeof re == "string" ? re : "";
    }
    function Q(q) {
      return xd(q).map((re) => re.text).join("");
    }
    return (q, re) => (u(), d("div", kN, [
      e.loading && _.value.length > 0 ? (u(), d("div", wN, [
        i("span", xN, f(r(n)("loading")), 1)
      ])) : T("", !0),
      i("div", {
        class: Re(["fe-grid", { "is-loading": e.loading, "has-selection": e.selectable && e.selected.size > 0 }]),
        role: "listbox",
        "aria-multiselectable": "true",
        "aria-label": r(n)("grid.aria"),
        "aria-busy": e.loading ? "true" : void 0
      }, [
        (u(!0), d(he, null, We(_.value, (ae) => {
          var Pe, be;
          return u(), d(he, {
            key: ae.path
          }, [
            A(ae) ? (u(), d("p", SN, f(A(ae)), 1)) : T("", !0),
            i("div", {
              class: Re(["fe-grid__card", {
                "fe-grid__card--folder": ae.type === "dir",
                "fe-grid__card--file": ae.type !== "dir",
                "is-selected": N(ae),
                "is-dir": ae.type === "dir",
                "is-trash": ae.trashed,
                "is-clipped": (Pe = e.clipped) == null ? void 0 : Pe.has(ae.path),
                "is-droptarget": ie.value === ae.path
              }]),
              tabindex: "0",
              role: "option",
              "aria-selected": N(ae) ? "true" : "false",
              "aria-label": r(p)(ae),
              "data-fe-path": ae.path,
              draggable: "true",
              onClick: (ze) => M(ae, ze),
              onDblclick: (ze) => j(ae),
              onContextmenu: (ze) => U(ae, ze),
              onDragstart: (ze) => ke(ae, ze),
              onDragover: (ze) => ce(ae, ze),
              onDragleave: (ze) => X(ae),
              onDrop: (ze) => Z(ae, ze),
              onTouchstartPassive: (ze) => r(Y).onTouchStart(ae, ze),
              onTouchend: re[4] || (re[4] = //@ts-ignore
              (...ze) => r(Y).onTouchEnd && r(Y).onTouchEnd(...ze)),
              onTouchmovePassive: re[5] || (re[5] = //@ts-ignore
              (...ze) => r(Y).onTouchMove && r(Y).onTouchMove(...ze))
            }, [
              ae.type !== "dir" ? (u(), d("div", {
                key: 0,
                class: "fe-grid__thumb",
                ref_for: !0,
                ref: (ze) => F(ze, ae)
              }, [
                P(ae) ? (u(), d(he, { key: 0 }, [
                  (u(!0), d(he, null, We(I(ae), (ze) => (u(), d("div", {
                    key: "fprev",
                    class: Re(["fe-fprev", "fe-fprev--" + ze.kind]),
                    dir: r(zk)(ze.kind),
                    style: Vt(ze.kind === "table" ? { "--fprev-cols": String(ze.cols) } : void 0),
                    "aria-hidden": "true"
                  }, [
                    ze.kind === "table" ? (u(!0), d(he, { key: 0 }, We(ze.rows, (Ae, Ce) => (u(), d(he, { key: Ce }, [
                      (u(!0), d(he, null, We(Ae, (He, J) => (u(), d("span", {
                        key: J,
                        class: Re(["fe-fprev__cell", { "is-head": Ce === 0 }])
                      }, f(He), 3))), 128))
                    ], 64))), 128)) : (u(!0), d(he, { key: 1 }, We(ze.lines, (Ae, Ce) => (u(), d("div", {
                      key: Ce,
                      class: "fe-fprev__line"
                    }, [
                      Ae.tint ? (u(), d("span", EN, f(Ae.indent) + f(Ae.tint), 1)) : T("", !0),
                      $t(f(Ae.text), 1)
                    ]))), 128))
                  ], 14, CN))), 128)),
                  I(ae).length === 0 ? (u(), d("span", {
                    key: 0,
                    class: "fe-grid__icon fe-grid__icon--svg",
                    innerHTML: r(sn)(ae)
                  }, null, 8, AN)) : T("", !0)
                ], 64)) : (u(), nt(vm, {
                  key: 1,
                  node: ae,
                  "src-of": O,
                  "video-badge": r(b0)(ae),
                  alt: ae.basename,
                  class: Re({
                    "fe-thumb--page": r(dm)(ae)
                    /* gorunum:v1-preview — crop a page from its TOP */
                  })
                }, {
                  default: yt(() => [
                    r(od)(ae) ? (u(), d("span", {
                      key: 0,
                      class: "fe-grid__icon fe-grid__icon--svg",
                      role: "img",
                      "aria-label": r(n)("e2e.badge"),
                      innerHTML: r(id)()
                    }, null, 8, zN)) : (u(), d("span", {
                      key: 1,
                      class: "fe-grid__icon fe-grid__icon--svg",
                      innerHTML: r(sn)(ae)
                    }, null, 8, MN))
                  ]),
                  _: 2
                }, 1032, ["node", "video-badge", "alt", "class"])),
                W(ae) ? (u(), d("div", {
                  key: 2,
                  class: "fe-grid__star",
                  onClick: re[0] || (re[0] = ft(() => {
                  }, ["stop"])),
                  onDblclick: re[1] || (re[1] = ft(() => {
                  }, ["stop"]))
                }, [
                  ot(nf, {
                    starred: !!((be = e.starredIds) != null && be.has(ae.id)),
                    "node-id": ae.id,
                    "api-base": e.apiBase,
                    "auth-headers": e.authHeaders,
                    "auth-credentials": e.authCredentials,
                    locale: e.locale,
                    compact: "",
                    card: "",
                    onChange: (ze) => s("star-change", ae, ze)
                  }, null, 8, ["starred", "node-id", "api-base", "auth-headers", "auth-credentials", "locale", "onChange"])
                ], 32)) : T("", !0)
              ], 512)) : T("", !0),
              i("div", DN, [
                i("span", {
                  class: Re(["fe-grid__lead", { "fe-grid__lead--pick": e.selectable }])
                }, [
                  r(od)(ae) ? (u(), d("span", {
                    key: 0,
                    class: "fe-grid__tile fe-grid__tile--svg",
                    role: "img",
                    "aria-label": r(n)("e2e.badge"),
                    innerHTML: r(id)()
                  }, null, 8, PN)) : (u(), d("span", {
                    key: 1,
                    class: "fe-grid__tile fe-grid__tile--svg",
                    innerHTML: r(sn)(ae)
                  }, null, 8, ON)),
                  e.selectable ? (u(), d("span", {
                    key: 2,
                    class: "fe-item-check",
                    "data-fe-control": "",
                    onClick: ft((ze) => K(ae, ze), ["stop"]),
                    onDblclick: re[2] || (re[2] = ft(() => {
                    }, ["stop"]))
                  }, [
                    ot(Qh, {
                      on: N(ae),
                      label: r(p)(ae)
                    }, null, 8, ["on", "label"])
                  ], 40, LN)) : T("", !0)
                ], 2),
                i("div", IN, [
                  i("div", {
                    class: "fe-grid__label",
                    title: ae.basename
                  }, [
                    i("bdi", null, f(r(p)(ae)), 1),
                    e.keepBadgeFor && e.keepBadgeFor(ae) ? (u(), d("span", {
                      key: 0,
                      class: Re(["fe-keepbadge", "fe-keepbadge--" + e.keepBadgeFor(ae)]),
                      title: r(n)("keep.badge_" + e.keepBadgeFor(ae)),
                      role: "img",
                      "aria-label": r(n)("keep.badge_" + e.keepBadgeFor(ae))
                    }, f(R(e.keepBadgeFor(ae))), 11, NN)) : T("", !0)
                  ], 8, RN),
                  i("div", {
                    class: "fe-grid__meta",
                    title: we(ae)
                  }, [
                    m(ae) ? (u(), d("span", {
                      key: 0,
                      class: "fe-applock",
                      role: "img",
                      title: m(ae),
                      "aria-label": m(ae),
                      "data-testid": "lock-badge"
                    }, [
                      re[6] || (re[6] = i("span", {
                        class: "fe-applock__glyph",
                        "aria-hidden": "true"
                      }, "🔒", -1)),
                      $t(f(r(n)("applock.badge")), 1)
                    ], 8, FN)) : T("", !0),
                    k(ae) ? (u(), d("span", {
                      key: 1,
                      class: Re(["fe-symlink", "fe-symlink--" + k(ae).state]),
                      role: "img",
                      title: k(ae).why,
                      "aria-label": k(ae).why,
                      "data-testid": "symlink-badge",
                      "data-link-state": k(ae).state
                    }, [
                      re[7] || (re[7] = i("span", {
                        class: "fe-symlink__glyph",
                        "aria-hidden": "true"
                      }, "🔗", -1)),
                      $t(f(k(ae).badge), 1)
                    ], 10, UN)) : T("", !0),
                    $t(" " + f(we(ae)), 1)
                  ], 8, BN),
                  e.showParentPath && r(Zo)(ae) ? (u(), d("div", {
                    key: 0,
                    class: "fe-grid__parent",
                    title: r(Zo)(ae)
                  }, [
                    i("bdi", null, f(r(Zo)(ae)), 1)
                  ], 8, HN)) : T("", !0),
                  pe(ae) ? (u(), d("div", {
                    key: 1,
                    class: "fe-grid__snippet",
                    title: Q(pe(ae))
                  }, [
                    (u(!0), d(he, null, We(r(xd)(pe(ae)), (ze, Ae) => (u(), d(he, { key: Ae }, [
                      ze.match ? (u(), d("mark", VN, f(ze.text), 1)) : (u(), d(he, { key: 1 }, [
                        $t(f(ze.text), 1)
                      ], 64))
                    ], 64))), 128))
                  ], 8, KN)) : T("", !0)
                ]),
                i("button", {
                  type: "button",
                  class: "fe-grid__menu",
                  "aria-label": r(n)("toolbar.more"),
                  title: r(n)("toolbar.more"),
                  onClick: ft((ze) => de(ae, ze), ["stop"]),
                  onDblclick: re[3] || (re[3] = ft(() => {
                  }, ["stop"]))
                }, "⋮", 40, qN)
              ])
            ], 42, TN)
          ], 64);
        }), 128)),
        !e.loading && e.files.length === 0 ? (u(), d("div", jN, f(r(n)("empty.folder")), 1)) : T("", !0)
      ], 10, $N)
    ]));
  }
}), WN = {
  class: "fe-home",
  "data-testid": "home-view"
}, YN = {
  class: "fe-home__section",
  "data-testid": "home-storages"
}, GN = { class: "fe-home__heading" }, XN = {
  key: 0,
  class: "fe-home__storages"
}, JN = ["data-storage", "title", "onClick"], ZN = ["innerHTML"], QN = { class: "fe-home__storage-main" }, eB = { class: "fe-home__storage-label" }, tB = ["data-partial"], aB = {
  key: 1,
  class: "fe-home__nomatch",
  "data-testid": "home-storages-nomatch"
}, nB = {
  key: 2,
  class: "fe-state fe-home__state",
  "data-testid": "home-storages-empty"
}, sB = { class: "fe-state__title" }, oB = { class: "fe-state__hint" }, iB = {
  class: "fe-home__section",
  "data-testid": "home-recent"
}, rB = { class: "fe-home__heading" }, lB = {
  key: 1,
  class: "fe-home__loading"
}, uB = {
  key: 2,
  class: "fe-home__nomatch",
  "data-testid": "home-recent-nomatch"
}, cB = {
  key: 3,
  class: "fe-state fe-home__state",
  "data-testid": "home-recent-empty"
}, dB = { class: "fe-state__title" }, fB = { class: "fe-state__hint" }, pB = {
  class: "fe-home__section",
  "data-testid": "home-starred"
}, vB = { class: "fe-home__heading" }, hB = {
  key: 1,
  class: "fe-home__loading"
}, mB = {
  key: 2,
  class: "fe-home__nomatch",
  "data-testid": "home-starred-nomatch"
}, yB = {
  key: 3,
  class: "fe-state fe-home__state",
  "data-testid": "home-starred-empty"
}, gB = { class: "fe-state__title" }, bB = { class: "fe-state__hint" }, _B = /* @__PURE__ */ rt({
  __name: "HomeView",
  props: {
    storages: {},
    recent: {},
    starred: {},
    loading: { type: Boolean },
    locale: {},
    nameFilter: {},
    thumbSrc: { type: Function }
  },
  emits: ["open-storage", "open-node", "context-node"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n, formatSize: o } = gt(() => t.locale), p = x(() => (t.nameFilter ?? "").trim()), h = x(() => p.value !== ""), v = x(
      () => t.storages.filter((E) => xr(E.label || E.name, p.value))
    ), y = x(
      () => t.recent.filter((E) => xr(E.basename || "", p.value))
    ), g = x(
      () => t.starred.filter((E) => xr(E.basename || "", p.value))
    );
    function m(E, A) {
      return h.value && E > 0 && A === 0;
    }
    const k = /* @__PURE__ */ new Set(), _ = sn({ type: "dir", mime_type: "inode/storage" });
    function w(E) {
      return typeof E.usedBytes != "number" || E.usedBytes < 0 ? n("conn.guide.storage") : E.usedPartial ? n("drive.storage.used_partial", { used: o(E.usedBytes) }) : n("drive.storage.used_unlimited", { used: o(E.usedBytes) });
    }
    const $ = b({ path: "", at: 0 });
    function C(E) {
      const A = Date.now();
      E.path === $.value.path && A - $.value.at < 700 || ($.value = { path: E.path, at: A }, s("open-node", E));
    }
    return (E, A) => (u(), d("div", WN, [
      i("section", YN, [
        i("h2", GN, f(r(n)("sidenav.storages")), 1),
        v.value.length ? (u(), d("div", XN, [
          (u(!0), d(he, null, We(v.value, (O) => (u(), d("button", {
            key: O.name,
            type: "button",
            class: "fe-home__storage",
            "data-testid": "home-storage-card",
            "data-storage": O.name,
            title: O.label || O.name,
            onClick: (z) => s("open-storage", O.name)
          }, [
            i("span", {
              class: "fe-home__storage-tile",
              "aria-hidden": "true",
              innerHTML: r(_)
            }, null, 8, ZN),
            i("span", QN, [
              i("span", eB, f(O.label || O.name), 1),
              i("span", {
                class: "fe-home__storage-meta",
                "data-testid": "home-storage-used",
                "data-partial": O.usedPartial ? "true" : void 0
              }, f(w(O)), 9, tB),
              O.readOnly ? (u(), nt(y0, {
                key: 0,
                "read-only": "",
                locale: e.locale,
                class: "fe-home__storage-ro",
                "data-testid": "home-storage-readonly"
              }, null, 8, ["locale"])) : T("", !0)
            ])
          ], 8, JN))), 128))
        ])) : m(e.storages.length, v.value.length) ? (u(), d("p", aB, f(r(n)("filter.empty.title")), 1)) : (u(), d("div", nB, [
          A[2] || (A[2] = i("svg", {
            class: "fe-state__art",
            viewBox: "0 0 120 100",
            width: "96",
            height: "80",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true"
          }, [
            i("rect", {
              x: "26",
              y: "30",
              width: "68",
              height: "18",
              rx: "5"
            }),
            i("rect", {
              x: "26",
              y: "54",
              width: "68",
              height: "18",
              rx: "5"
            }),
            i("path", { d: "M38 39h.01M38 63h.01" })
          ], -1)),
          i("p", sB, f(r(n)("home.storages.empty")), 1),
          i("p", oB, f(r(n)("home.storages.hint")), 1)
        ]))
      ]),
      i("section", iB, [
        i("h2", rB, f(r(n)("sidenav.recent")), 1),
        y.value.length ? (u(), nt(Gv, {
          key: 0,
          files: y.value,
          selected: r(k),
          selectable: !1,
          locale: e.locale,
          "thumb-src": e.thumbSrc,
          onClickCard: C,
          onDblCard: C,
          onContextCard: A[0] || (A[0] = (O, z) => s("context-node", O, z))
        }, null, 8, ["files", "selected", "locale", "thumb-src"])) : e.loading ? (u(), d("p", lB, f(r(n)("loading")), 1)) : m(e.recent.length, y.value.length) ? (u(), d("p", uB, f(r(n)("filter.empty.title")), 1)) : (u(), d("div", cB, [
          A[3] || (A[3] = i("svg", {
            class: "fe-state__art",
            viewBox: "0 0 120 100",
            width: "96",
            height: "80",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true"
          }, [
            i("circle", {
              cx: "60",
              cy: "50",
              r: "28"
            }),
            i("path", { d: "M60 32v18l12 8" })
          ], -1)),
          i("p", dB, f(r(n)("empty.recent.title")), 1),
          i("p", fB, f(r(n)("empty.recent.hint")), 1)
        ]))
      ]),
      i("section", pB, [
        i("h2", vB, f(r(n)("sidenav.starred")), 1),
        g.value.length ? (u(), nt(Gv, {
          key: 0,
          files: g.value,
          selected: r(k),
          selectable: !1,
          locale: e.locale,
          "thumb-src": e.thumbSrc,
          onClickCard: C,
          onDblCard: C,
          onContextCard: A[1] || (A[1] = (O, z) => s("context-node", O, z))
        }, null, 8, ["files", "selected", "locale", "thumb-src"])) : e.loading ? (u(), d("p", hB, f(r(n)("loading")), 1)) : m(e.starred.length, g.value.length) ? (u(), d("p", mB, f(r(n)("filter.empty.title")), 1)) : (u(), d("div", yB, [
          A[4] || (A[4] = i("svg", {
            class: "fe-state__art",
            viewBox: "0 0 120 100",
            width: "96",
            height: "80",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true"
          }, [
            i("path", { d: "M60 26l9 18.6 20.4 3-14.8 14.4 3.5 20.4L60 72.8 41.9 82.4l3.5-20.4L30.6 47.6l20.4-3z" })
          ], -1)),
          i("p", gB, f(r(n)("empty.starred.title")), 1),
          i("p", bB, f(r(n)("empty.starred.hint")), 1)
        ]))
      ])
    ]));
  }
}), kB = {
  class: "fe-drafts",
  "data-testid": "drafts-view"
}, wB = { class: "fe-drafts__head" }, xB = { class: "fe-drafts__lead" }, $B = {
  key: 0,
  class: "fe-drafts__count",
  "data-testid": "drafts-count-line"
}, SB = {
  key: 0,
  class: "fe-state",
  "data-testid": "empty-drafts"
}, TB = { class: "fe-state__title" }, CB = { class: "fe-state__hint" }, EB = { class: "fe-drafts__name" }, AB = ["innerHTML"], zB = ["title", "data-testid", "onClick"], MB = { class: "fe-drafts__target" }, DB = /* @__PURE__ */ rt({
  __name: "DraftsView",
  props: {
    drafts: {},
    loading: { type: Boolean },
    limit: {},
    locale: {},
    nameFilter: {},
    busyKey: {}
  },
  emits: ["open", "save", "delete"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n, formatDate: o } = gt(() => t.locale), p = x(() => t.drafts.filter(($) => xr($.name, t.nameFilter ?? "")));
    function h($) {
      const C = $.lastIndexOf(".");
      return C > 0 ? $.slice(C + 1).toLowerCase() : "";
    }
    function v($) {
      return sn({ type: "file", basename: $.name, extension: h($.name) || $.type });
    }
    function y($) {
      const C = $.target_dir.indexOf("://"), E = (C >= 0 ? $.target_dir.slice(C + 3) : $.target_dir).replace(/^\/+|\/+$/g, "");
      return E ? E.split("/").filter(Boolean).join(" / ") : "/";
    }
    function g($) {
      return Date.parse($.modified_at || $.created_at) || 0;
    }
    const m = x(() => [
      {
        id: "name",
        label: n("col.name"),
        lead: !0,
        sortable: !0,
        width: 280,
        min: 160,
        format: ($) => $.name
      },
      {
        id: "target",
        label: n("drafts.col.target"),
        sortable: !0,
        width: 240,
        format: y,
        title: ($) => $.target
      },
      {
        id: "storage",
        label: n("drafts.col.storage"),
        sortable: !0,
        width: 140,
        format: ($) => $.storage
      },
      {
        id: "modified",
        label: n("col.modified"),
        sortable: !0,
        sortDir: "desc",
        width: 170,
        format: ($) => o(g($)),
        sortValue: ($) => g($)
      }
    ]);
    function k($) {
      const C = t.busyKey === $.key;
      return [
        { key: "open", label: n("ctx.open"), icon: "open", disabled: C },
        { key: "save", label: n("drafts.action.save"), icon: "check", disabled: C },
        { key: "delete", label: n("ctx.delete"), icon: "delete", danger: !0, disabled: C }
      ];
    }
    function _($, C) {
      $ === "open" ? s("open", C) : $ === "save" ? s("save", C) : $ === "delete" && s("delete", C);
    }
    const w = x(
      () => t.limit && t.limit > 0 ? n("drafts.count_of", { n: t.drafts.length, limit: t.limit }) : ""
    );
    return ($, C) => (u(), d("section", kB, [
      i("header", wB, [
        i("p", xB, f(r(n)("drafts.lead")), 1),
        w.value && e.drafts.length ? (u(), d("p", $B, f(w.value), 1)) : T("", !0)
      ]),
      !e.loading && e.drafts.length === 0 ? (u(), d("div", SB, [
        C[2] || (C[2] = i("svg", {
          class: "fe-state__art",
          viewBox: "0 0 120 100",
          width: "110",
          height: "92",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "aria-hidden": "true"
        }, [
          i("path", { d: "M66 18H38a6 6 0 0 0-6 6v52a6 6 0 0 0 6 6h44a6 6 0 0 0 6-6V40z" }),
          i("path", { d: "M66 18v22h22" }),
          i("path", { d: "M50 66l18-18 6 6-18 18H50z" })
        ], -1)),
        i("p", TB, f(r(n)("empty.drafts.title")), 1),
        i("p", CB, f(r(n)("empty.drafts.hint")), 1)
      ])) : (u(), nt(ki, {
        key: 1,
        "table-id": "explorer.drafts",
        columns: m.value,
        rows: p.value,
        "row-key": "key",
        locale: e.locale,
        loading: e.loading,
        framed: !1,
        empty: r(n)("drafts.no_match"),
        "aria-label": r(n)("node.drafts"),
        "row-attrs": (E) => ({ "data-testid": `draft-row-${E.key}`, "data-draft-name": E.name }),
        "row-actions": k,
        "row-actions-test-id": (E) => `draft-actions-${E.key}`,
        onRowAction: C[0] || (C[0] = (E, A) => _(E, A)),
        onRowDblclick: C[1] || (C[1] = (E) => s("open", E))
      }, {
        "cell-name": yt(({ row: E }) => [
          i("span", EB, [
            i("span", {
              class: "fe-drafts__tile",
              "aria-hidden": "true",
              innerHTML: v(E)
            }, null, 8, AB),
            i("button", {
              type: "button",
              class: "fe-drafts__open",
              title: r(n)("drafts.open_hint", { name: E.name }),
              "data-testid": `draft-open-${E.key}`,
              onClick: ft((A) => s("open", E), ["stop"])
            }, [
              i("bdi", null, f(E.name), 1)
            ], 8, zB)
          ])
        ]),
        "cell-target": yt(({ row: E }) => [
          i("bdi", MB, f(y(E)), 1)
        ]),
        _: 1
      }, 8, ["columns", "rows", "locale", "loading", "empty", "aria-label", "row-attrs", "row-actions-test-id"]))
    ]));
  }
});
function Mn(e) {
  if (e.apiBase != null) return e.apiBase.replace(/\/+$/, "");
  const a = e.endpoint ?? "", t = a.indexOf("/api/");
  return t >= 0 ? a.slice(0, t) : "";
}
function PB(e, a) {
  const t = String(a ?? "").trim();
  if (/^https?:\/\/[^/]/i.test(t)) return t.replace(/\/+$/, "");
  const s = Mn(e);
  if (/^https?:\/\//i.test(s))
    try {
      const n = new URL(s);
      return n.origin + n.pathname.replace(/\/+$/, "");
    } catch {
      return s;
    }
  return typeof window < "u" && window.location ? window.location.origin + (s.startsWith("/") ? s : "") : s;
}
function OB(e) {
  const a = Fr(e), t = Mn(e), s = (K) => `${t}${K}`, n = Dn([]), o = Dn([]), p = Dn([]), h = b(null), v = b(null), y = b(!1), g = b(!1), m = b(null), k = b(null), _ = b(null);
  function w(K) {
    return K == null ? void 0 : K.status;
  }
  function $(K) {
    return hu(K, e.locale);
  }
  async function C() {
    y.value = !0, m.value = null;
    try {
      const K = a.capabilities().then((M) => {
        const j = M == null ? void 0 : M.public_url;
        v.value = typeof j == "string" && j ? j : null;
      }).catch(() => {
        v.value = null;
      });
      try {
        const M = await a.jsonFetch(s("/api/auth/me"));
        h.value = (M == null ? void 0 : M.user) ?? null;
      } catch (M) {
        w(M) === 401 && (k.value = !1, _.value = "anonymous"), h.value = null;
      }
      try {
        n.value = await a.jsonFetch(
          s("/api/admin/storage-drivers")
        ), k.value = !0, _.value = null;
      } catch (M) {
        n.value = [], k.value = !1;
        const j = w(M);
        j === 403 ? _.value = "none" : j === 401 ? _.value = "anonymous" : (_.value = "unreachable", m.value = $(M));
      }
      if (k.value)
        try {
          const M = await a.jsonFetch(s("/api/admin/storages"));
          o.value = Array.isArray(M) ? M : [], p.value = o.value.map((j) => j.name);
        } catch (M) {
          m.value = $(M);
        }
      else
        try {
          const M = await a.index("");
          p.value = Array.isArray(M == null ? void 0 : M.storages) ? M.storages : [];
        } catch {
          p.value = [];
        }
      await K, g.value = !0;
    } finally {
      y.value = !1;
    }
  }
  async function E(K) {
    const M = await a.jsonFetch(s("/api/admin/storages"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(K)
    });
    return await C(), M;
  }
  async function A(K, M) {
    const j = await a.jsonFetch(s(`/api/admin/storages/${K}`), {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(M)
    });
    return await C(), j;
  }
  async function O(K) {
    await a.jsonFetch(s(`/api/admin/storages/${K}`), { method: "DELETE" }), await C();
  }
  async function z(K) {
    try {
      return await a.jsonFetch(s("/api/admin/storages/test"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(K)
      });
    } catch (M) {
      return { ok: !1, error: $(M) };
    }
  }
  function P(K) {
    return n.value.find((M) => M.driver === K);
  }
  function I(K) {
    var M;
    return ((M = P(K)) == null ? void 0 : M.fields) ?? [];
  }
  function F(K) {
    const M = {};
    for (const j of I(K))
      j.default !== void 0 && j.default !== null && (M[j.key] = j.default);
    return M;
  }
  function W(K, M) {
    return I(K).filter((j) => {
      if (!j.required || j.default !== void 0) return !1;
      for (const U of [j.key, ...j.aliases ?? []]) {
        const de = M[U];
        if (de != null && !(typeof de == "string" && de.trim() === ""))
          return !1;
      }
      return !0;
    });
  }
  const N = x(() => n.value.map((K) => K.driver));
  return {
    // state
    drivers: n,
    driverNames: N,
    storages: o,
    visible: p,
    me: h,
    publicUrl: v,
    loading: y,
    loaded: g,
    error: m,
    canManage: k,
    denial: _,
    // actions
    load: C,
    createStorage: E,
    updateStorage: A,
    deleteStorage: O,
    testStorage: z,
    // descriptor helpers
    descriptor: P,
    fields: I,
    defaults: F,
    missingRequired: W
  };
}
function x0(e) {
  return /^http:\/\//i.test(e);
}
function LB(e, a) {
  const t = e.replace(/\/+$/, "");
  return a ? `${t}/dav/${a}/` : `${t}/dav/`;
}
function IB(e, a) {
  let t;
  try {
    t = new URL(e);
  } catch {
    return e.replace(/^https:/i, "davs:").replace(/^http:/i, "dav:");
  }
  return `${t.protocol === "http:" ? "dav" : "davs"}://${t.host}${t.pathname}`;
}
function RB(e) {
  return ["use", e.letter, e.url, `/user:${e.user}`, e.password, "/persistent:yes"];
}
function NB(e) {
  const [a, t, s, ...n] = RB(e);
  return ["net", a, t, `"${s}"`, ...n].join(" ");
}
const d_ = "HKLM\\SYSTEM\\CurrentControlSet\\Services\\WebClient\\Parameters", BB = 4294967295, FB = 2e7, UB = [
  `reg add "${d_}" /v FileSizeLimitInBytes /t REG_DWORD /d ${BB} /f`,
  `reg add "${d_}" /v FileAttributesLimitInBytes /t REG_DWORD /d ${FB} /f`,
  "net stop webclient && net start webclient"
];
function vi(e) {
  try {
    return new URL(e).host;
  } catch {
    return e.replace(/^https?:\/\//i, "").replace(/\/+$/, "");
  }
}
function HB(e) {
  try {
    return new URL(e).pathname.replace(/\/+$/, "");
  } catch {
    return "";
  }
}
function mm(e, a) {
  return e.user || a("conn.guide.userPlaceholder");
}
const KB = (e, a) => {
  const t = e.origin.replace(/\/+$/, ""), s = LB(t, e.storage), n = mm(e, a), o = a("conn.guide.secretPlaceholder"), p = [
    { label: a("conn.guide.fact.url"), value: s, hint: e.storage ? a("conn.guide.fact.urlStorageHint", { storage: e.storage }) : a("conn.guide.fact.urlRootHint") },
    { label: a("conn.guide.fact.user"), value: n, hint: a("conn.guide.webdav.userHint") },
    { label: a("conn.guide.fact.password"), value: o, hint: a("conn.guide.webdav.passwordHint"), placeholderOnly: !0 }
  ], h = [
    {
      id: "windows",
      name: "Windows Explorer",
      platform: "windows",
      blocks: [
        {
          kind: "steps",
          steps: [
            a("conn.guide.webdav.win.s1"),
            a("conn.guide.webdav.win.s2", { url: s }),
            a("conn.guide.webdav.win.s3")
          ]
        },
        {
          kind: "code",
          caption: a("conn.guide.webdav.win.cmdCaption"),
          code: NB({ letter: "Z:", url: s, user: n, password: o })
        },
        {
          kind: "warn",
          text: a("conn.guide.webdav.win.limits")
        },
        {
          kind: "code",
          caption: a("conn.guide.webdav.win.regCaption"),
          code: UB.join(`
`)
        },
        { kind: "note", text: a("conn.guide.webdav.win.https") },
        { kind: "note", text: a("conn.guide.webdav.win.persist") },
        { kind: "note", text: a("conn.guide.webdav.win.service") }
      ]
    },
    {
      id: "macos",
      name: "macOS Finder",
      platform: "macos",
      blocks: [
        {
          kind: "steps",
          steps: [
            a("conn.guide.webdav.mac.s1"),
            a("conn.guide.webdav.mac.s2", { url: s }),
            a("conn.guide.webdav.mac.s3")
          ]
        },
        { kind: "note", text: a("conn.guide.webdav.mac.note") }
      ]
    },
    {
      id: "linux",
      name: "Linux (davfs2 / GNOME / KDE)",
      platform: "linux",
      blocks: [
        {
          kind: "code",
          caption: a("conn.guide.webdav.linux.mountCaption"),
          code: [
            `sudo mount -t davfs ${s} /mnt/filex`,
            "",
            `# ${a("conn.guide.webdav.linux.gvfsComment")}`,
            `gio mount ${IB(s)}`
          ].join(`
`)
        },
        {
          kind: "warn",
          text: a("conn.guide.webdav.linux.locks")
        },
        {
          kind: "code",
          caption: "/etc/davfs2/davfs2.conf",
          code: "use_locks 0"
        }
      ]
    },
    {
      id: "rclone",
      name: "rclone",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: a("conn.guide.webdav.rclone.obscureCaption"),
          code: `rclone obscure "${o}"`
        },
        {
          kind: "code",
          caption: "~/.config/rclone/rclone.conf",
          code: [
            "[filex]",
            "type = webdav",
            `url = ${t}/dav`,
            "vendor = other",
            `user = ${n}`,
            `pass = ${a("conn.guide.webdav.rclone.passPlaceholder")}`
          ].join(`
`)
        },
        {
          kind: "code",
          caption: a("conn.guide.webdav.rclone.useCaption"),
          code: [
            "rclone lsd filex:",
            e.storage ? `rclone lsl filex:${e.storage}` : "rclone lsl filex:<storage>",
            e.storage ? `rclone copy ./local filex:${e.storage}/backup` : "rclone copy ./local filex:<storage>/backup",
            "rclone mount filex: /mnt/filex"
          ].join(`
`)
        }
      ]
    },
    {
      id: "cyberduck",
      name: "Cyberduck / Mountain Duck",
      platform: "any",
      blocks: [
        {
          kind: "steps",
          steps: [
            a("conn.guide.webdav.duck.s1"),
            a("conn.guide.webdav.duck.s2", { host: vi(t) }),
            a("conn.guide.webdav.duck.s3", { path: HB(t) + (e.storage ? `/dav/${e.storage}/` : "/dav/") }),
            a("conn.guide.webdav.duck.s4", { user: n })
          ]
        }
      ]
    }
  ], v = [
    { kind: "note", text: a("conn.guide.webdav.note.delete") },
    { kind: "note", text: a("conn.guide.webdav.note.locks") },
    { kind: "note", text: a("conn.guide.webdav.note.permissions") }
  ];
  return x0(t) && v.unshift({ kind: "warn", text: a("conn.guide.webdav.note.http") }), {
    id: "webdav",
    name: "WebDAV",
    summary: a("conn.guide.webdav.summary"),
    facts: p,
    clients: h,
    notes: v
  };
}, VB = (e, a) => {
  const t = (e.s3Endpoint || `${e.origin.replace(/\/+$/, "")}/s3`).replace(/\/+$/, ""), s = e.storage || e.storages[0] || "<bucket>", n = e.s3AccessKeyID || a("conn.guide.s3.keyPlaceholder"), o = e.s3Secret || a("conn.guide.s3.secretPlaceholder"), p = e.s3PathStyle !== !1, h = vi(t), v = [
    { label: a("conn.guide.s3.fact.endpoint"), value: t, hint: a("conn.guide.s3.fact.endpointHint") },
    { label: a("conn.guide.s3.fact.bucket"), value: s, hint: a("conn.guide.s3.fact.bucketHint") },
    { label: a("conn.guide.s3.fact.key"), value: n, hint: a("conn.guide.s3.fact.keyHint") },
    {
      label: a("conn.guide.s3.fact.secret"),
      value: o,
      hint: a("conn.guide.s3.fact.secretHint"),
      // ⚠ Only real right after minting. filex stores the secret sealed and
      // cannot show it again, and a guide that printed something secret-shaped
      // would be teaching a value that authenticates as nothing.
      placeholderOnly: !e.s3Secret
    },
    { label: a("conn.guide.s3.fact.region"), value: "us-east-1", hint: a("conn.guide.s3.fact.regionHint") },
    {
      label: a("conn.guide.s3.fact.addressing"),
      value: a(p ? "conn.guide.s3.fact.pathStyle" : "conn.guide.s3.fact.virtualHosted"),
      hint: a(p ? "conn.guide.s3.fact.pathStyleHint" : "conn.guide.s3.fact.virtualHostedHint")
    }
  ], y = [
    {
      id: "rclone",
      name: "rclone",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: "~/.config/rclone/rclone.conf",
          code: [
            "[filex]",
            "type = s3",
            "provider = Other",
            `endpoint = ${t}`,
            `access_key_id = ${n}`,
            `secret_access_key = ${o}`,
            "region = us-east-1",
            ...p ? ["force_path_style = true"] : []
          ].join(`
`)
        },
        {
          kind: "code",
          caption: a("conn.guide.s3.rclone.useCaption"),
          code: [
            "rclone lsd filex:",
            `rclone copy ./local filex:${s}/backup -P`,
            `rclone sync ./local filex:${s}/backup`,
            `rclone mount filex:${s} /mnt/filex`
          ].join(`
`)
        },
        { kind: "note", text: a("conn.guide.s3.rclone.mtime") }
      ]
    },
    {
      id: "awscli",
      name: "AWS CLI",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: a("conn.guide.s3.aws.configureCaption"),
          code: [
            "aws configure set aws_access_key_id " + n,
            "aws configure set aws_secret_access_key " + o,
            "aws configure set region us-east-1"
          ].join(`
`)
        },
        {
          kind: "code",
          caption: a("conn.guide.s3.aws.useCaption"),
          code: [
            `aws --endpoint-url ${t} s3 ls`,
            `aws --endpoint-url ${t} s3 cp ./file.pdf s3://${s}/file.pdf`,
            `aws --endpoint-url ${t} s3 sync ./local s3://${s}/backup`,
            `aws --endpoint-url ${t} s3 presign s3://${s}/file.pdf --expires-in 300`
          ].join(`
`)
        },
        ...p ? [
          {
            kind: "note",
            text: a("conn.guide.s3.aws.pathStyle")
          },
          {
            kind: "code",
            caption: "~/.aws/config",
            code: ["[default]", "s3 =", "    addressing_style = path"].join(`
`)
          }
        ] : []
      ]
    },
    {
      id: "restic",
      name: "restic",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: a("conn.guide.s3.restic.envCaption"),
          code: [
            `export AWS_ACCESS_KEY_ID=${n}`,
            `export AWS_SECRET_ACCESS_KEY=${o}`,
            `export RESTIC_REPOSITORY="s3:${t}/${s}/restic"`,
            "export RESTIC_PASSWORD=…"
          ].join(`
`)
        },
        {
          kind: "code",
          caption: a("conn.guide.s3.restic.useCaption"),
          code: [
            `restic init${p ? " -o s3.bucket-lookup=path" : ""}`,
            `restic backup ~/Documents${p ? " -o s3.bucket-lookup=path" : ""}`,
            `restic check --read-data${p ? " -o s3.bucket-lookup=path" : ""}`,
            `restic forget --keep-daily 7 --prune${p ? " -o s3.bucket-lookup=path" : ""}`
          ].join(`
`)
        },
        { kind: "note", text: a("conn.guide.s3.restic.verified") }
      ]
    },
    {
      id: "mc",
      name: "MinIO Client (mc)",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: a("conn.guide.s3.mc.aliasCaption"),
          code: `mc alias set filex ${t} ${n} ${o} --api S3v4${p ? " --path on" : ""}`
        },
        {
          kind: "code",
          caption: a("conn.guide.s3.mc.useCaption"),
          code: [
            "mc ls filex",
            `mc cp ./file.pdf filex/${s}/file.pdf`,
            `mc mirror ./local filex/${s}/backup`,
            `mc du filex/${s}`
          ].join(`
`)
        }
      ]
    },
    {
      id: "s3fs",
      name: "s3fs (Linux / macOS)",
      platform: "linux",
      blocks: [
        {
          kind: "code",
          caption: a("conn.guide.s3.s3fs.credsCaption"),
          code: [
            `echo "${n}:${o}" > ~/.passwd-s3fs`,
            "chmod 600 ~/.passwd-s3fs"
          ].join(`
`)
        },
        {
          kind: "code",
          caption: a("conn.guide.s3.s3fs.mountCaption"),
          code: [
            `s3fs ${s} /mnt/filex \\`,
            "  -o passwd_file=~/.passwd-s3fs \\",
            `  -o url=${t} \\`,
            ...p ? ["  -o use_path_request_style"] : []
          ].join(`
`)
        },
        { kind: "note", text: a("conn.guide.s3.s3fs.note") }
      ]
    },
    {
      id: "cyberduck",
      name: "Cyberduck / Mountain Duck",
      platform: "any",
      blocks: [
        {
          kind: "steps",
          steps: [
            a("conn.guide.s3.duck.s1"),
            a("conn.guide.s3.duck.s2", { host: h }),
            a("conn.guide.s3.duck.s3", { key: n }),
            a("conn.guide.s3.duck.s4")
          ]
        },
        ...p ? [{ kind: "warn", text: a("conn.guide.s3.duck.pathStyle") }] : []
      ]
    },
    {
      id: "sdk",
      name: "SDK (Go / Python / JS)",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: "boto3",
          code: [
            "import boto3",
            "s3 = boto3.client(",
            '    "s3",',
            `    endpoint_url="${t}",`,
            `    aws_access_key_id="${n}",`,
            `    aws_secret_access_key="${o}",`,
            '    region_name="us-east-1",',
            ...p ? [
              '    config=boto3.session.Config(s3={"addressing_style": "path"}),'
            ] : [],
            ")",
            `print([o["Key"] for o in s3.list_objects_v2(Bucket="${s}").get("Contents", [])])`
          ].join(`
`)
        },
        { kind: "note", text: a("conn.guide.s3.sdk.note") }
      ]
    }
  ], g = [
    { kind: "note", text: a("conn.guide.s3.note.buckets") },
    { kind: "note", text: a("conn.guide.s3.note.permissions") },
    { kind: "note", text: a("conn.guide.s3.note.trash") },
    { kind: "note", text: a("conn.guide.s3.note.mtime") }
  ];
  return p && g.unshift({ kind: "warn", text: a("conn.guide.s3.note.pathStyle") }), x0(t) && g.unshift({ kind: "warn", text: a("conn.guide.s3.note.http") }), {
    id: "s3",
    name: "S3",
    summary: a("conn.guide.s3.summary"),
    facts: v,
    clients: y,
    notes: g
  };
}, qB = (e, a) => {
  const t = e.sftpHost || vi(e.origin), s = e.sftpPort || 2022, n = e.sftpLogin || mm(e, a), o = e.storage ? `/${e.storage}` : "/<storage>", p = s === 22 ? "" : ` -P ${s}`, h = [
    { label: a("conn.guide.sftp.fact.host"), value: t, hint: a("conn.guide.sftp.fact.hostHint") },
    { label: a("conn.guide.sftp.fact.port"), value: String(s), hint: a("conn.guide.sftp.fact.portHint") },
    { label: a("conn.guide.fact.user"), value: n, hint: a("conn.guide.sftp.fact.userHint") },
    {
      label: a("conn.guide.sftp.fact.auth"),
      value: e.sftpHasKey ? a("conn.guide.sftp.fact.authKey") : a("conn.guide.sftp.fact.authPassword"),
      hint: a("conn.guide.sftp.fact.authHint"),
      placeholderOnly: !0
    },
    { label: a("conn.guide.sftp.fact.path"), value: o, hint: a("conn.guide.sftp.fact.pathHint") }
  ], v = [
    {
      id: "openssh",
      name: "OpenSSH (sftp / scp)",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: a("conn.guide.sftp.openssh.connectCaption"),
          code: [
            `sftp${p} ${n}@${t}`,
            `scp${p} ./report.pdf ${n}@${t}:${o}/report.pdf`,
            `scp${p} ${n}@${t}:${o}/report.pdf ./`
          ].join(`
`)
        },
        {
          kind: "code",
          caption: "~/.ssh/config",
          code: [
            "Host filex",
            `  HostName ${t}`,
            `  Port ${s}`,
            `  User ${n}`,
            "  # IdentityFile ~/.ssh/id_ed25519"
          ].join(`
`)
        },
        { kind: "note", text: a("conn.guide.sftp.openssh.noShell") }
      ]
    },
    {
      id: "key",
      name: a("conn.guide.sftp.key.tab"),
      platform: "any",
      blocks: [
        {
          kind: "steps",
          steps: [
            a("conn.guide.sftp.key.s1"),
            a("conn.guide.sftp.key.s2"),
            a("conn.guide.sftp.key.s3")
          ]
        },
        {
          kind: "code",
          caption: a("conn.guide.sftp.key.genCaption"),
          code: ['ssh-keygen -t ed25519 -C "filex"', "cat ~/.ssh/id_ed25519.pub"].join(`
`)
        },
        // ⚠ The one command people reach for, and the one that cannot work.
        { kind: "warn", text: a("conn.guide.sftp.key.noCopyId") }
      ]
    },
    {
      id: "winscp",
      name: "WinSCP",
      platform: "windows",
      blocks: [
        {
          kind: "steps",
          steps: [
            a("conn.guide.sftp.winscp.s1"),
            a("conn.guide.sftp.winscp.s2", { host: t, port: String(s) }),
            a("conn.guide.sftp.winscp.s3", { user: n }),
            a("conn.guide.sftp.winscp.s4")
          ]
        }
      ]
    },
    {
      id: "filezilla",
      name: "FileZilla",
      platform: "any",
      blocks: [
        {
          kind: "steps",
          steps: [
            a("conn.guide.sftp.filezilla.s1"),
            a("conn.guide.sftp.filezilla.s2", { host: `sftp://${t}`, port: String(s) }),
            a("conn.guide.sftp.filezilla.s3", { user: n })
          ]
        }
      ]
    },
    {
      id: "rclone",
      name: "rclone",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: "~/.config/rclone/rclone.conf",
          code: [
            "[filex-sftp]",
            "type = sftp",
            `host = ${t}`,
            `port = ${s}`,
            `user = ${n}`,
            "key_file = ~/.ssh/id_ed25519",
            "# filex has no shell, so tell rclone not to look for one:",
            "shell_type = none",
            "md5sum_command = none",
            "sha1sum_command = none"
          ].join(`
`)
        },
        {
          kind: "code",
          caption: a("conn.guide.sftp.rclone.useCaption"),
          code: [
            "rclone lsd filex-sftp:",
            `rclone copy ./local filex-sftp:${o}/backup -P`,
            `rclone sync ./local filex-sftp:${o}/backup`
          ].join(`
`)
        }
      ]
    },
    {
      id: "sshfs",
      name: "sshfs (Linux / macOS)",
      platform: "linux",
      blocks: [
        {
          kind: "code",
          caption: a("conn.guide.sftp.sshfs.mountCaption"),
          code: [
            `sshfs -p ${s} ${n}@${t}:${o} /mnt/filex`,
            "fusermount -u /mnt/filex"
          ].join(`
`)
        },
        { kind: "note", text: a("conn.guide.sftp.sshfs.note") }
      ]
    }
  ], y = [
    { kind: "note", text: a("conn.guide.sftp.note.storages") },
    { kind: "note", text: a("conn.guide.sftp.note.permissions") },
    { kind: "note", text: a("conn.guide.sftp.note.trash") },
    { kind: "note", text: a("conn.guide.sftp.note.totp") }
  ];
  return e.sftpEnabled === !1 && y.unshift({ kind: "warn", text: a("conn.guide.sftp.note.disabled") }), {
    id: "sftp",
    name: "SFTP",
    summary: a("conn.guide.sftp.summary"),
    facts: h,
    clients: v,
    notes: y
  };
}, jB = (e, a) => {
  const t = e.ftpsHost || vi(e.origin), s = e.ftpsPort || 2121, n = e.sftpLogin || mm(e, a), o = a("conn.guide.secretPlaceholder"), p = e.storage ? `/${e.storage}` : "/<storage>", h = e.ftpsPasvMin && e.ftpsPasvMax ? `${e.ftpsPasvMin}-${e.ftpsPasvMax}` : "30000-30100", v = [
    { label: a("conn.guide.ftps.fact.host"), value: t, hint: a("conn.guide.ftps.fact.hostHint") },
    { label: a("conn.guide.ftps.fact.port"), value: String(s), hint: a("conn.guide.ftps.fact.portHint") },
    { label: a("conn.guide.ftps.fact.mode"), value: a("conn.guide.ftps.fact.modeValue"), hint: a("conn.guide.ftps.fact.modeHint") },
    { label: a("conn.guide.fact.user"), value: n, hint: a("conn.guide.ftps.fact.userHint") },
    { label: a("conn.guide.fact.password"), value: o, hint: a("conn.guide.ftps.fact.passwordHint"), placeholderOnly: !0 },
    { label: a("conn.guide.ftps.fact.pasv"), value: h, hint: a("conn.guide.ftps.fact.pasvHint") }
  ], y = [
    {
      id: "filezilla",
      name: "FileZilla",
      platform: "any",
      blocks: [
        {
          kind: "steps",
          steps: [
            a("conn.guide.ftps.filezilla.s1"),
            a("conn.guide.ftps.filezilla.s2", { host: t, port: String(s) }),
            a("conn.guide.ftps.filezilla.s3", { user: n }),
            a("conn.guide.ftps.filezilla.s4")
          ]
        }
      ]
    },
    {
      id: "winscp",
      name: "WinSCP",
      platform: "windows",
      blocks: [
        {
          kind: "steps",
          steps: [
            a("conn.guide.ftps.winscp.s1"),
            a("conn.guide.ftps.winscp.s2", { host: t, port: String(s) }),
            a("conn.guide.ftps.winscp.s3", { user: n })
          ]
        }
      ]
    },
    {
      id: "curl",
      name: "curl",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: a("conn.guide.ftps.curl.caption"),
          code: [
            `curl --ssl-reqd --ftp-pasv --user ${n} \\`,
            `  -T ./report.pdf "ftp://${t}:${s}${p}/report.pdf"`,
            "",
            `curl --ssl-reqd --ftp-pasv --user ${n} \\`,
            `  -o ./report.pdf "ftp://${t}:${s}${p}/report.pdf"`
          ].join(`
`)
        },
        // ⚠ The flag that matters. Without it curl will happily fall back to
        // plaintext against a server that allows it — this one does not, but
        // the habit is what protects you against the ones that do.
        { kind: "note", text: a("conn.guide.ftps.curl.sslReqd") }
      ]
    },
    {
      id: "lftp",
      name: "lftp",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: "~/.lftprc",
          code: [
            "set ftp:ssl-force true",
            "set ftp:ssl-protect-data true",
            "set ftp:passive-mode true"
          ].join(`
`)
        },
        {
          kind: "code",
          caption: a("conn.guide.ftps.lftp.caption"),
          code: [
            `lftp -u ${n} ftp://${t}:${s}`,
            `# then: cd ${p}; put ./report.pdf; ls`
          ].join(`
`)
        },
        { kind: "note", text: a("conn.guide.ftps.lftp.protectData") }
      ]
    },
    {
      id: "rclone",
      name: "rclone",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: "~/.config/rclone/rclone.conf",
          code: [
            "[filex-ftp]",
            "type = ftp",
            `host = ${t}`,
            `port = ${s}`,
            `user = ${n}`,
            '# rclone obscure "<your password>"',
            "pass = …",
            "explicit_tls = true"
          ].join(`
`)
        },
        {
          kind: "code",
          caption: a("conn.guide.ftps.rclone.useCaption"),
          code: [
            "rclone lsd filex-ftp:",
            `rclone copy ./local filex-ftp:${p}/backup -P`
          ].join(`
`)
        }
      ]
    },
    {
      id: "printer",
      name: a("conn.guide.ftps.printer.tab"),
      platform: "any",
      blocks: [
        {
          kind: "steps",
          steps: [
            a("conn.guide.ftps.printer.s1", { host: t, port: String(s) }),
            a("conn.guide.ftps.printer.s2", { user: n }),
            a("conn.guide.ftps.printer.s3", { path: p }),
            a("conn.guide.ftps.printer.s4")
          ]
        },
        // ⚠ The honest warning: plenty of scan-to-FTP firmware cannot do TLS
        // at all, and this endpoint will not talk to it. Saying so beats an
        // afternoon spent debugging a device that was never going to connect.
        { kind: "warn", text: a("conn.guide.ftps.printer.noTLS") }
      ]
    }
  ], g = [
    { kind: "warn", text: a("conn.guide.ftps.note.tls") },
    { kind: "note", text: a("conn.guide.ftps.note.passive") },
    { kind: "note", text: a("conn.guide.ftps.note.storages") },
    { kind: "note", text: a("conn.guide.ftps.note.trash") },
    { kind: "note", text: a("conn.guide.ftps.note.prefer") }
  ];
  return e.ftpsSelfSigned && g.push({ kind: "warn", text: a("conn.guide.ftps.note.selfSigned") }), e.ftpsEnabled === !1 && g.unshift({ kind: "warn", text: a("conn.guide.ftps.note.disabled") }), {
    id: "ftps",
    name: "FTPS",
    summary: a("conn.guide.ftps.summary"),
    facts: v,
    clients: y,
    notes: g
  };
}, WB = (e, a) => {
  const t = e.nfsHost || vi(e.origin), s = e.nfsPort || 2049, n = e.nfsPath || a("conn.guide.nfs.pathPlaceholder"), o = e.nfsReadOnly ? ",ro" : "", p = `nfsvers=3,tcp,port=${s},mountport=${s},nolock${o}`, h = [
    { label: a("conn.guide.nfs.fact.host"), value: t, hint: a("conn.guide.nfs.fact.hostHint") },
    { label: a("conn.guide.nfs.fact.port"), value: String(s), hint: a("conn.guide.nfs.fact.portHint") },
    {
      label: a("conn.guide.nfs.fact.export"),
      value: n,
      hint: a("conn.guide.nfs.fact.exportHint"),
      // ⚠ Only real right after minting: the path is stored hashed and cannot
      // be shown again, and printing something path-shaped would produce a
      // mount line that fails with no clue why.
      placeholderOnly: !e.nfsPath
    },
    { label: a("conn.guide.nfs.fact.options"), value: p, hint: a("conn.guide.nfs.fact.optionsHint") }
  ], v = [
    {
      id: "linux",
      name: "Linux",
      platform: "linux",
      blocks: [
        {
          kind: "code",
          caption: a("conn.guide.nfs.linux.mountCaption"),
          code: [
            "sudo mkdir -p /mnt/filex",
            `sudo mount -t nfs -o ${p} ${t}:${n} /mnt/filex`,
            "",
            "# and to unmount:",
            "sudo umount /mnt/filex"
          ].join(`
`)
        },
        {
          kind: "code",
          caption: "/etc/fstab",
          code: `${t}:${n}  /mnt/filex  nfs  ${p},_netdev,noauto,x-systemd.automount  0  0`
        },
        // ⚠ The warning that belongs next to the fstab line rather than in a
        // document: that file is world-readable on most systems.
        { kind: "warn", text: a("conn.guide.nfs.linux.fstabSecret") }
      ]
    },
    {
      id: "macos",
      name: "macOS",
      platform: "macos",
      blocks: [
        {
          kind: "code",
          caption: a("conn.guide.nfs.mac.mountCaption"),
          code: [
            "sudo mkdir -p /Volumes/filex",
            `sudo mount -t nfs -o vers=3,tcp,port=${s},mountport=${s},nolock${o},resvport ${t}:${n} /Volumes/filex`
          ].join(`
`)
        },
        { kind: "note", text: a("conn.guide.nfs.mac.resvport") }
      ]
    },
    {
      id: "windows",
      name: "Windows (Client for NFS)",
      platform: "windows",
      blocks: [
        {
          kind: "steps",
          steps: [
            a("conn.guide.nfs.win.s1"),
            a("conn.guide.nfs.win.s2"),
            a("conn.guide.nfs.win.s3")
          ]
        },
        {
          kind: "code",
          caption: a("conn.guide.nfs.win.cmdCaption"),
          code: `mount -o anon nolock ${t}:${n} Z:`
        },
        // ⚠ Windows' client has no way to say "the mount service is on this
        // port", so it only works when filex is on 2049.
        { kind: "warn", text: a("conn.guide.nfs.win.port") }
      ]
    },
    {
      id: "synology",
      name: a("conn.guide.nfs.nas.tab"),
      platform: "any",
      blocks: [
        {
          kind: "steps",
          steps: [
            a("conn.guide.nfs.nas.s1", { host: t, port: String(s) }),
            a("conn.guide.nfs.nas.s2"),
            a("conn.guide.nfs.nas.s3")
          ]
        }
      ]
    }
  ], y = [
    { kind: "warn", text: a("conn.guide.nfs.note.unencrypted") },
    { kind: "warn", text: a("conn.guide.nfs.note.pathIsSecret") },
    { kind: "note", text: a("conn.guide.nfs.note.noPortmapper") },
    { kind: "note", text: a("conn.guide.nfs.note.uid") },
    { kind: "note", text: a("conn.guide.nfs.note.trash") },
    { kind: "note", text: a("conn.guide.nfs.note.revoke") }
  ];
  return e.nfsEnabled === !1 && y.unshift({ kind: "warn", text: a("conn.guide.nfs.note.disabled") }), {
    id: "nfs",
    name: "NFS",
    summary: a("conn.guide.nfs.summary"),
    facts: h,
    clients: v,
    notes: y
  };
}, YB = (e, a) => {
  const t = e.origin.replace(/\/+$/, ""), s = e.storage || e.storages[0] || "main", n = [
    { label: a("conn.guide.mount.fact.url"), value: t, hint: a("conn.guide.mount.fact.urlHint") },
    {
      label: a("conn.guide.mount.fact.token"),
      value: a("conn.guide.mount.fact.tokenPlaceholder"),
      hint: a("conn.guide.mount.fact.tokenHint"),
      // filex never has the plaintext of a token after it is minted, and a
      // fact row that looked like one would be a lie the user pastes.
      placeholderOnly: !0
    },
    { label: a("conn.guide.mount.fact.remote"), value: `${s}://`, hint: a("conn.guide.mount.fact.remoteHint") }
  ], o = [
    {
      id: "linux",
      name: "Linux",
      platform: "linux",
      blocks: [
        {
          kind: "code",
          caption: a("conn.guide.mount.linux.mountCaption"),
          code: [
            `export FILEX_URL=${t}`,
            "export FILEX_TOKEN=<token>",
            "",
            "mkdir -p ~/filex",
            "filex mount ~/filex",
            "",
            "# one storage only, or a subfolder of it:",
            `filex mount --remote '${s}://' ~/filex`,
            `filex mount --remote '${s}://projects/acme' --read-only ~/acme`
          ].join(`
`)
        },
        {
          kind: "code",
          caption: a("conn.guide.mount.linux.umountCaption"),
          code: "fusermount -u ~/filex"
        },
        // ⚠ The one that costs an afternoon if it is not said: killing the
        // process leaves a directory where every `ls` hangs.
        { kind: "warn", text: a("conn.guide.mount.linux.umountWarn") },
        {
          kind: "code",
          caption: a("conn.guide.mount.linux.systemdCaption"),
          code: [
            "# ~/.config/systemd/user/filex-mount.service",
            "[Unit]",
            "Description=filex mount",
            "After=network-online.target",
            "",
            "[Service]",
            `Environment=FILEX_URL=${t}`,
            "Environment=FILEX_TOKEN=<token>",
            "ExecStart=%h/.local/bin/filex mount %h/filex",
            "ExecStop=/bin/fusermount -u %h/filex",
            "Restart=on-failure",
            "",
            "[Install]",
            "WantedBy=default.target"
          ].join(`
`)
        }
      ]
    },
    {
      id: "windows",
      name: "Windows",
      platform: "windows",
      blocks: [
        { kind: "note", text: a("conn.guide.mount.win.winfsp") },
        {
          kind: "code",
          caption: a("conn.guide.mount.win.mountCaption"),
          code: [
            `$env:FILEX_URL   = "${t}"`,
            '$env:FILEX_TOKEN = "<token>"',
            "",
            "filex mount Z:"
          ].join(`
`)
        },
        // ⚠ The drive letter is CREATED, not reused — pointing it at one that
        // already exists is the commonest way this fails, and the message the
        // driver gives for it says nothing useful.
        { kind: "warn", text: a("conn.guide.mount.win.freeLetter") },
        { kind: "note", text: a("conn.guide.mount.win.stop") }
      ]
    },
    {
      id: "macos",
      name: "macOS",
      platform: "macos",
      blocks: [
        // ⚠⚠ A refusal stated up front rather than discovered. macFUSE's Go
        // binding needs a C toolchain filex deliberately does not use, and its
        // licence forbids a commercial program from installing it. Pretending
        // otherwise would mean a command that appears to work and does nothing.
        { kind: "warn", text: a("conn.guide.mount.mac.unsupported") },
        { kind: "note", text: a("conn.guide.mount.mac.alternatives") }
      ]
    }
  ], p = [
    { kind: "note", text: a("conn.guide.mount.note.notASync") },
    { kind: "note", text: a("conn.guide.mount.note.reachable") },
    { kind: "note", text: a("conn.guide.mount.note.wholeFileWrites") },
    { kind: "note", text: a("conn.guide.mount.note.trash") },
    { kind: "note", text: a("conn.guide.mount.note.revoke") }
  ];
  return {
    id: "mount",
    name: "filex mount",
    summary: a("conn.guide.mount.summary"),
    facts: n,
    clients: o,
    notes: p
  };
}, $0 = {
  webdav: KB,
  s3: VB,
  sftp: qB,
  ftps: jB,
  nfs: WB,
  mount: YB
}, GB = {
  webdav: "WebDAV",
  s3: "S3",
  sftp: "SFTP",
  ftps: "FTPS",
  nfs: "NFS",
  mount: "filex mount"
};
function XB(e) {
  return GB[e] || e.toUpperCase();
}
function JB() {
  return Object.keys($0);
}
function ZB(e, a, t) {
  const s = $0[e];
  return s ? s(a, t) : null;
}
const QB = { class: "fe-guide" }, eF = { class: "fe-guide__summary" }, tF = {
  class: "fe-guide__facts",
  "data-testid": "guide-facts"
}, aF = { class: "fe-guide__factlabel" }, nF = { class: "fe-guide__factvalue" }, sF = ["data-testid", "onClick"], oF = {
  key: 0,
  class: "fe-guide__facthint"
}, iF = {
  class: "fe-guide__tabs",
  role: "tablist"
}, rF = ["aria-selected", "data-testid", "onClick"], lF = {
  key: 0,
  class: "fe-guide__body",
  role: "tabpanel"
}, uF = {
  key: 0,
  class: "fe-guide__steps"
}, cF = {
  key: 1,
  class: "fe-guide__codewrap"
}, dF = { class: "fe-guide__codehead" }, fF = { class: "fe-guide__caption" }, pF = ["data-testid", "onClick"], vF = { class: "fe-guide__code" }, hF = {
  key: 2,
  class: "fe-guide__warn"
}, mF = {
  key: 3,
  class: "fe-guide__note"
}, yF = {
  key: 4,
  class: "fe-guide__text"
}, gF = {
  key: 1,
  class: "fe-guide__notes"
}, bF = { class: "fe-guide__notestitle" }, _F = /* @__PURE__ */ rt({
  __name: "ConnectionGuideView",
  props: {
    guide: {},
    locale: {}
  },
  setup(e) {
    var g;
    const a = e, { t } = gt(() => a.locale), s = b(((g = a.guide.clients[0]) == null ? void 0 : g.id) ?? ""), n = b(null);
    let o = null;
    const p = x(
      () => a.guide.clients.find((m) => m.id === s.value) ?? a.guide.clients[0]
    );
    async function h(m, k) {
      let _ = !1;
      try {
        await navigator.clipboard.writeText(m), _ = !0;
      } catch {
        try {
          const w = document.createElement("textarea");
          w.value = m, w.setAttribute("readonly", ""), w.style.position = "fixed", w.style.opacity = "0", document.body.appendChild(w), w.select(), _ = document.execCommand("copy"), document.body.removeChild(w);
        } catch {
          _ = !1;
        }
      }
      n.value = _ ? k : null, o && clearTimeout(o), o = setTimeout(() => {
        n.value = null;
      }, 1600);
    }
    function v(m, k) {
      return `${m}-${k}`;
    }
    function y(m) {
      return m.kind === "code";
    }
    return (m, k) => (u(), d("div", QB, [
      i("p", eF, f(e.guide.summary), 1),
      i("section", tF, [
        (u(!0), d(he, null, We(e.guide.facts, (_, w) => (u(), d("div", {
          key: _.label,
          class: "fe-guide__fact"
        }, [
          i("span", aF, f(_.label), 1),
          i("span", nF, [
            i("code", {
              class: Re({ "fe-guide__ph": _.placeholderOnly })
            }, f(_.value), 3),
            _.placeholderOnly ? T("", !0) : (u(), d("button", {
              key: 0,
              type: "button",
              class: "fe-guide__copy",
              "data-testid": `copy-fact-${w}`,
              onClick: ($) => h(_.value, v("fact", w))
            }, f(n.value === v("fact", w) ? r(t)("conn.guide.copied") : r(t)("conn.guide.copy")), 9, sF))
          ]),
          _.hint ? (u(), d("span", oF, f(_.hint), 1)) : T("", !0)
        ]))), 128))
      ]),
      i("nav", iF, [
        (u(!0), d(he, null, We(e.guide.clients, (_) => (u(), d("button", {
          key: _.id,
          type: "button",
          role: "tab",
          class: Re(["fe-guide__tab", { "is-active": p.value && _.id === p.value.id }]),
          "aria-selected": p.value && _.id === p.value.id,
          "data-testid": `guide-tab-${_.id}`,
          onClick: (w) => s.value = _.id
        }, f(_.name), 11, rF))), 128))
      ]),
      p.value ? (u(), d("div", lF, [
        (u(!0), d(he, null, We(p.value.blocks, (_, w) => (u(), d(he, { key: w }, [
          _.kind === "steps" ? (u(), d("ol", uF, [
            (u(!0), d(he, null, We(_.steps ?? [], ($, C) => (u(), d("li", { key: C }, f($), 1))), 128))
          ])) : y(_) ? (u(), d("div", cF, [
            i("div", dF, [
              i("span", fF, f(_.caption), 1),
              i("button", {
                type: "button",
                class: "fe-guide__copy",
                "data-testid": `copy-code-${w}`,
                onClick: ($) => h(_.code ?? "", v(p.value.id, w))
              }, f(n.value === v(p.value.id, w) ? r(t)("conn.guide.copied") : r(t)("conn.guide.copy")), 9, pF)
            ]),
            i("pre", vF, [
              i("code", null, f(_.code), 1)
            ])
          ])) : _.kind === "warn" ? (u(), d("p", hF, f(_.text), 1)) : _.kind === "note" ? (u(), d("p", mF, f(_.text), 1)) : (u(), d("p", yF, f(_.text), 1))
        ], 64))), 128))
      ])) : T("", !0),
      e.guide.notes.length ? (u(), d("section", gF, [
        i("h4", bF, f(r(t)("conn.guide.goodToKnow")), 1),
        (u(!0), d(he, null, We(e.guide.notes, (_, w) => (u(), d("p", {
          key: w,
          class: Re(_.kind === "warn" ? "fe-guide__warn" : "fe-guide__note")
        }, f(_.text), 3))), 128))
      ])) : T("", !0)
    ]));
  }
});
function kF(e) {
  const a = Fr(e), t = Mn(e), s = (z) => `${t}${z}`, n = Dn([]), o = b(null), p = b(!1), h = b(!1), v = b(null), y = b(null), g = b(null), m = b(null);
  function k(z) {
    return y.value = (z == null ? void 0 : z.hint) ?? null, hu(z, e.locale);
  }
  function _(z) {
    return z == null ? void 0 : z.status;
  }
  async function w() {
    p.value = !0, v.value = null, y.value = null;
    try {
      const z = await a.jsonFetch(
        s("/api/auth/s3-keys")
      );
      n.value = Array.isArray(z == null ? void 0 : z.keys) ? z.keys : [], o.value = {
        endpoint: (z == null ? void 0 : z.endpoint) ?? "",
        enabled: (z == null ? void 0 : z.enabled) !== !1,
        path_style: (z == null ? void 0 : z.path_style) !== !1
      }, g.value = !0;
    } catch (z) {
      n.value = [];
      const P = _(z);
      P === 401 || P === 403 ? g.value = !1 : (g.value = !1, v.value = k(z));
    } finally {
      p.value = !1, h.value = !0;
    }
  }
  async function $(z) {
    v.value = null, y.value = null;
    try {
      const P = await a.jsonFetch(s("/api/auth/s3-keys"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(z)
      });
      return m.value = P, P != null && P.endpoint && (o.value = {
        endpoint: P.endpoint,
        enabled: P.enabled !== !1,
        path_style: P.path_style !== !1
      }), await w(), P;
    } catch (P) {
      return v.value = k(P), null;
    }
  }
  async function C(z, P) {
    v.value = null, y.value = null;
    try {
      await a.jsonFetch(s(`/api/auth/s3-keys/${z}/state`), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ disabled: P })
      }), await w();
    } catch (I) {
      v.value = k(I);
    }
  }
  async function E(z) {
    var P, I;
    v.value = null, y.value = null;
    try {
      await a.jsonFetch(s(`/api/auth/s3-keys/${z}`), { method: "DELETE" }), ((I = (P = m.value) == null ? void 0 : P.key) == null ? void 0 : I.id) === z && (m.value = null), await w();
    } catch (F) {
      v.value = k(F);
    }
  }
  function A() {
    m.value = null;
  }
  const O = x(() => {
    var P;
    if ((P = m.value) != null && P.key) return m.value.key;
    const z = n.value.filter((I) => !I.disabled_at);
    return z.length ? z.reduce((I, F) => I.created_at >= F.created_at ? I : F) : null;
  });
  return {
    keys: n,
    connection: o,
    loading: p,
    loaded: h,
    error: v,
    errorHint: y,
    canMint: g,
    revealed: m,
    guideKey: O,
    load: w,
    create: $,
    setDisabled: C,
    remove: E,
    dismissSecret: A
  };
}
const wF = {
  class: "fe-s3keys",
  "data-testid": "s3-keys"
}, xF = { class: "fe-s3keys__head" }, $F = { class: "fe-s3keys__title" }, SF = { class: "fe-s3keys__lead" }, TF = {
  key: 0,
  class: "fe-s3keys__warn"
}, CF = {
  key: 1,
  class: "fe-s3keys__muted"
}, EF = {
  key: 2,
  class: "fe-s3keys__warn"
}, AF = {
  key: 3,
  class: "fe-s3keys__hint",
  "data-testid": "s3keys-admin-hint"
}, zF = {
  key: 4,
  class: "fe-s3keys__form"
}, MF = ["placeholder"], DF = { value: "" }, PF = ["value"], OF = ["placeholder", "disabled"], LF = ["disabled"], IF = {
  key: 5,
  class: "fe-s3keys__hint"
}, RF = {
  key: 6,
  class: "fe-s3keys__secret",
  "data-testid": "s3-key-secret"
}, NF = { class: "fe-s3keys__once" }, BF = { class: "fe-s3keys__pair" }, FF = { class: "fe-s3keys__k" }, UF = { class: "fe-s3keys__pair" }, HF = { class: "fe-s3keys__k" }, KF = {
  key: 7,
  class: "fe-s3keys__muted"
}, VF = { class: "tbl-mono" }, qF = /* @__PURE__ */ rt({
  __name: "S3KeysPanel",
  props: {
    config: {},
    storages: {}
  },
  emits: ["active"],
  setup(e, { emit: a }) {
    const t = e, s = a, n = x(() => Ha(t.config.locale)), { t: o, formatDate: p } = gt(n), {
      keys: h,
      connection: v,
      loading: y,
      error: g,
      errorHint: m,
      canMint: k,
      revealed: _,
      guideKey: w,
      load: $,
      create: C,
      setDisabled: E,
      remove: A,
      dismissSecret: O
    } = kF(t.config), z = b(""), P = b(""), I = b(""), F = b(!1), W = b(null), N = b(null);
    let K = null;
    function M() {
      var we, R, pe, Q, q;
      const G = v.value;
      G && s("active", {
        accessKeyID: ((we = w.value) == null ? void 0 : we.access_key_id) ?? "",
        // Only the freshly minted one. Re-emitting a stale secret would put a
        // dead credential into the commands.
        secret: ((pe = (R = _.value) == null ? void 0 : R.key) == null ? void 0 : pe.id) === ((Q = w.value) == null ? void 0 : Q.id) ? (q = _.value) == null ? void 0 : q.secret : void 0,
        endpoint: G.endpoint,
        pathStyle: G.path_style
      });
    }
    Kt(async () => {
      await $(), M();
    });
    async function j() {
      F.value = !0;
      try {
        await C({
          label: z.value.trim() || o("conn.s3keys.defaultLabel"),
          bucket: P.value.trim() || void 0,
          prefix: I.value.trim() || void 0
        }), z.value = "", M();
      } finally {
        F.value = !1;
      }
    }
    function U(G) {
      return [
        {
          key: "toggle",
          label: G.disabled_at ? o("conn.s3keys.enable") : o("conn.s3keys.disable"),
          icon: G.disabled_at ? "check" : "lock",
          disabled: F.value
        },
        {
          key: "revoke",
          label: W.value === G.id ? o("conn.s3keys.confirm") : o("conn.s3keys.revoke"),
          icon: "delete",
          danger: !0,
          disabled: F.value
        }
      ];
    }
    const de = x(() => [
      {
        id: "label",
        label: o("conn.s3keys.col.label"),
        sortable: !0,
        width: 180,
        format: (G) => G.label || o("conn.s3keys.noLabel")
      },
      {
        id: "key",
        label: o("conn.s3keys.col.key"),
        sortable: !0,
        width: 200,
        sortValue: (G) => G.access_key_id,
        title: (G) => G.access_key_id
      },
      { id: "scope", label: o("conn.s3keys.col.scope"), sortable: !0, width: 160, format: Y },
      {
        id: "lastUsed",
        label: o("conn.s3keys.col.lastUsed"),
        sortable: !0,
        sortDir: "desc",
        width: 140,
        format: (G) => G.last_used_at ? Z(G.last_used_at) : o("conn.s3keys.neverUsed"),
        sortValue: (G) => G.last_used_at ? new Date(G.last_used_at).getTime() : null
      }
    ]);
    function ke(G, we) {
      G === "toggle" ? ie(we) : G === "revoke" && ce(we);
    }
    async function ie(G) {
      F.value = !0;
      try {
        await E(G.id, !G.disabled_at), M();
      } finally {
        F.value = !1;
      }
    }
    async function ce(G) {
      if (W.value !== G.id) {
        W.value = G.id;
        return;
      }
      W.value = null, F.value = !0;
      try {
        await A(G.id), M();
      } finally {
        F.value = !1;
      }
    }
    async function X(G, we) {
      let R = !1;
      try {
        await navigator.clipboard.writeText(G), R = !0;
      } catch {
        try {
          const pe = document.createElement("textarea");
          pe.value = G, pe.setAttribute("readonly", ""), pe.style.position = "fixed", pe.style.opacity = "0", document.body.appendChild(pe), pe.select(), R = document.execCommand("copy"), document.body.removeChild(pe);
        } catch {
          R = !1;
        }
      }
      R && (N.value = we, K && clearTimeout(K), K = setTimeout(() => N.value = null, 1600));
    }
    function Z(G) {
      const we = new Date(G ?? "").getTime();
      return Number.isNaN(we) ? "" : p(we);
    }
    function Y(G) {
      return G.bucket ? G.prefix ? `${G.bucket}/${G.prefix}` : G.bucket : o("conn.s3keys.scopeAll");
    }
    return (G, we) => (u(), d("section", wF, [
      i("header", xF, [
        i("h4", $F, f(r(o)("conn.s3keys.title")), 1),
        i("p", SF, f(r(o)("conn.s3keys.lead")), 1)
      ]),
      r(v) && !r(v).enabled ? (u(), d("p", TF, f(r(o)("conn.s3keys.disabled")), 1)) : T("", !0),
      r(k) === !1 ? (u(), d("p", CF, f(r(o)("conn.s3keys.cannotMint")), 1)) : T("", !0),
      r(g) ? (u(), d("p", EF, f(r(g)), 1)) : T("", !0),
      r(g) && r(m) ? (u(), d("p", AF, f(r(m)), 1)) : T("", !0),
      r(k) ? (u(), d("div", zF, [
        dt(i("input", {
          "onUpdate:modelValue": we[0] || (we[0] = (R) => z.value = R),
          class: "fe-cfield__input",
          placeholder: r(o)("conn.s3keys.label"),
          "data-testid": "s3-key-label"
        }, null, 8, MF), [
          [St, z.value]
        ]),
        dt(i("select", {
          "onUpdate:modelValue": we[1] || (we[1] = (R) => P.value = R),
          class: "fe-cfield__input",
          "data-testid": "s3-key-bucket"
        }, [
          i("option", DF, f(r(o)("conn.s3keys.everyBucket")), 1),
          (u(!0), d(he, null, We(e.storages, (R) => (u(), d("option", {
            key: R,
            value: R
          }, f(R), 9, PF))), 128))
        ], 512), [
          [Xa, P.value]
        ]),
        dt(i("input", {
          "onUpdate:modelValue": we[2] || (we[2] = (R) => I.value = R),
          class: "fe-cfield__input",
          placeholder: r(o)("conn.s3keys.prefix"),
          disabled: !P.value,
          "data-testid": "s3-key-prefix"
        }, null, 8, OF), [
          [St, I.value]
        ]),
        i("button", {
          class: "fe-s3keys__btn",
          disabled: F.value,
          "data-testid": "s3-key-mint",
          onClick: j
        }, f(r(o)("conn.s3keys.mint")), 9, LF)
      ])) : T("", !0),
      r(k) ? (u(), d("p", IF, f(r(o)("conn.s3keys.inheritNote")), 1)) : T("", !0),
      r(_) ? (u(), d("div", RF, [
        i("p", NF, f(r(o)("conn.s3keys.once")), 1),
        i("div", BF, [
          i("span", FF, f(r(o)("conn.s3keys.accessKeyID")), 1),
          i("code", null, f(r(_).key.access_key_id), 1),
          i("button", {
            class: "fe-s3keys__copy",
            onClick: we[3] || (we[3] = (R) => X(r(_).key.access_key_id, "akid"))
          }, f(N.value === "akid" ? r(o)("conn.guide.copied") : r(o)("conn.guide.copy")), 1)
        ]),
        i("div", UF, [
          i("span", HF, f(r(o)("conn.s3keys.secret")), 1),
          i("code", null, f(r(_).secret), 1),
          i("button", {
            class: "fe-s3keys__copy",
            onClick: we[4] || (we[4] = (R) => X(r(_).secret, "secret"))
          }, f(N.value === "secret" ? r(o)("conn.guide.copied") : r(o)("conn.guide.copy")), 1)
        ]),
        i("button", {
          class: "fe-s3keys__dismiss",
          onClick: we[5] || (we[5] = //@ts-ignore
          (...R) => r(O) && r(O)(...R))
        }, f(r(o)("conn.s3keys.dismiss")), 1)
      ])) : T("", !0),
      r(y) ? (u(), d("p", KF, "…")) : (u(), nt(ki, {
        key: 8,
        "table-id": "conn.s3keys",
        columns: de.value,
        rows: r(h),
        "row-key": "id",
        locale: n.value,
        empty: r(o)("conn.s3keys.empty"),
        "row-class": (R) => R.disabled_at ? "is-muted" : void 0,
        "row-actions": U,
        "row-actions-test-id": (R) => `s3-key-actions-${R.id}`,
        onRowAction: we[6] || (we[6] = (R, pe) => ke(R, pe))
      }, {
        "cell-key": yt(({ row: R }) => [
          i("code", VF, f(R.access_key_id), 1)
        ]),
        _: 1
      }, 8, ["columns", "rows", "locale", "empty", "row-class", "row-actions-test-id"]))
    ]));
  }
});
function jF(e) {
  const a = Fr(e), t = Mn(e), s = (E) => `${t}${E}`, n = Dn([]), o = b(null), p = b(!1), h = b(!1), v = b(null), y = b(null);
  function g(E) {
    return hu(E, e.locale);
  }
  function m(E) {
    return E == null ? void 0 : E.status;
  }
  async function k() {
    p.value = !0, v.value = null;
    try {
      const E = await a.jsonFetch(
        s("/api/auth/ssh-keys")
      );
      n.value = Array.isArray(E == null ? void 0 : E.keys) ? E.keys : [], o.value = {
        enabled: (E == null ? void 0 : E.enabled) !== !1,
        host: (E == null ? void 0 : E.host) ?? "",
        port: (E == null ? void 0 : E.port) ?? 2022,
        login: (E == null ? void 0 : E.login) ?? "",
        ftps: E == null ? void 0 : E.ftps
      }, y.value = !0;
    } catch (E) {
      n.value = [], y.value = !1, m(E) !== 401 && m(E) !== 403 && (v.value = g(E));
    } finally {
      p.value = !1, h.value = !0;
    }
  }
  async function _(E, A) {
    v.value = null;
    try {
      return await a.jsonFetch(s("/api/auth/ssh-keys"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ key: E, name: A })
      }), await k(), !0;
    } catch (O) {
      return v.value = g(O), !1;
    }
  }
  async function w(E, A) {
    v.value = null;
    try {
      await a.jsonFetch(s(`/api/auth/ssh-keys/${E}/state`), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ disabled: A })
      }), await k();
    } catch (O) {
      v.value = g(O);
    }
  }
  async function $(E) {
    v.value = null;
    try {
      await a.jsonFetch(s(`/api/auth/ssh-keys/${E}`), { method: "DELETE" }), await k();
    } catch (A) {
      v.value = g(A);
    }
  }
  const C = x(() => n.value.some((E) => !E.disabled_at));
  return { keys: n, connection: o, loading: p, loaded: h, error: v, canAdd: y, hasUsableKey: C, load: k, add: _, setDisabled: w, remove: $ };
}
const WF = {
  key: 0,
  class: "fe-s3keys",
  "data-testid": "ssh-keys"
}, YF = { class: "fe-s3keys__head" }, GF = { class: "fe-s3keys__title" }, XF = { class: "fe-s3keys__lead" }, JF = {
  key: 0,
  class: "fe-s3keys__warn"
}, ZF = {
  key: 1,
  class: "fe-s3keys__muted"
}, QF = {
  key: 2,
  class: "fe-s3keys__warn"
}, eU = {
  key: 3,
  class: "fe-sshkeys__form"
}, tU = ["placeholder"], aU = { class: "fe-sshkeys__row" }, nU = ["placeholder"], sU = ["disabled"], oU = { class: "fe-s3keys__hint" }, iU = {
  key: 4,
  class: "fe-s3keys__muted"
}, rU = { class: "tbl-mono" }, lU = /* @__PURE__ */ rt({
  __name: "SSHKeysPanel",
  props: {
    config: {},
    keysVisible: { type: Boolean }
  },
  emits: ["active"],
  setup(e, { emit: a }) {
    const t = e, s = x(() => t.keysVisible !== !1), n = a, o = x(() => Ha(t.config.locale)), { t: p, formatDate: h } = gt(o), { keys: v, connection: y, loading: g, error: m, canAdd: k, hasUsableKey: _, load: w, add: $, setDisabled: C, remove: E } = jF(t.config), A = b(""), O = b(""), z = b(!1), P = b(null);
    function I() {
      const ke = y.value;
      ke && n("active", {
        host: ke.host,
        port: ke.port,
        login: ke.login,
        enabled: ke.enabled,
        hasKey: _.value,
        // The FTPS endpoint travels with the SSH facts: for the user this is one
        // question ("how do I reach this from a program?"), and two calls to
        // answer it would be two chances to disagree.
        ftps: ke.ftps
      });
    }
    Kt(async () => {
      await w(), I();
    });
    async function F() {
      if (A.value.trim()) {
        z.value = !0;
        try {
          await $(A.value.trim(), O.value.trim() || void 0) && (A.value = "", O.value = ""), I();
        } finally {
          z.value = !1;
        }
      }
    }
    function W(ke) {
      return [
        {
          key: "toggle",
          label: ke.disabled_at ? p("conn.sshkeys.enable") : p("conn.sshkeys.disable"),
          icon: ke.disabled_at ? "check" : "lock",
          disabled: z.value
        },
        {
          key: "remove",
          label: P.value === ke.id ? p("conn.sshkeys.confirm") : p("conn.sshkeys.remove"),
          icon: "delete",
          danger: !0,
          disabled: z.value
        }
      ];
    }
    const N = x(() => [
      {
        id: "name",
        label: p("conn.sshkeys.col.name"),
        sortable: !0,
        width: 180,
        format: (ke) => ke.name || p("conn.sshkeys.noName")
      },
      {
        id: "fingerprint",
        label: p("conn.sshkeys.col.fingerprint"),
        sortable: !0,
        width: 240,
        sortValue: (ke) => de(ke),
        title: (ke) => de(ke)
      },
      {
        id: "lastUsed",
        label: p("conn.sshkeys.col.lastUsed"),
        sortable: !0,
        sortDir: "desc",
        width: 140,
        format: (ke) => ke.last_used_at ? U(ke.last_used_at) : p("conn.sshkeys.neverUsed"),
        sortValue: (ke) => ke.last_used_at ? new Date(ke.last_used_at).getTime() : null
      }
    ]);
    function K(ke, ie) {
      ke === "toggle" ? M(ie) : ke === "remove" && j(ie);
    }
    async function M(ke) {
      z.value = !0;
      try {
        await C(ke.id, !ke.disabled_at), I();
      } finally {
        z.value = !1;
      }
    }
    async function j(ke) {
      if (P.value !== ke.id) {
        P.value = ke.id;
        return;
      }
      P.value = null, z.value = !0;
      try {
        await E(ke.id), I();
      } finally {
        z.value = !1;
      }
    }
    function U(ke) {
      const ie = new Date(ke ?? "").getTime();
      return Number.isNaN(ie) ? "" : h(ie);
    }
    function de(ke) {
      return "SHA256:" + ke.fingerprint;
    }
    return (ke, ie) => s.value ? (u(), d("section", WF, [
      i("header", YF, [
        i("h4", GF, f(r(p)("conn.sshkeys.title")), 1),
        i("p", XF, f(r(p)("conn.sshkeys.lead")), 1)
      ]),
      r(y) && !r(y).enabled ? (u(), d("p", JF, f(r(p)("conn.sshkeys.disabled")), 1)) : T("", !0),
      r(k) === !1 ? (u(), d("p", ZF, f(r(p)("conn.sshkeys.cannotAdd")), 1)) : T("", !0),
      r(m) ? (u(), d("p", QF, f(r(m)), 1)) : T("", !0),
      r(k) ? (u(), d("div", eU, [
        dt(i("textarea", {
          "onUpdate:modelValue": ie[0] || (ie[0] = (ce) => A.value = ce),
          class: "fe-cfield__input fe-sshkeys__paste",
          rows: "2",
          spellcheck: "false",
          placeholder: r(p)("conn.sshkeys.paste"),
          "data-testid": "ssh-key-input"
        }, null, 8, tU), [
          [St, A.value]
        ]),
        i("div", aU, [
          dt(i("input", {
            "onUpdate:modelValue": ie[1] || (ie[1] = (ce) => O.value = ce),
            class: "fe-cfield__input",
            placeholder: r(p)("conn.sshkeys.name"),
            "data-testid": "ssh-key-name"
          }, null, 8, nU), [
            [St, O.value]
          ]),
          i("button", {
            class: "fe-s3keys__btn",
            disabled: z.value,
            "data-testid": "ssh-key-add",
            onClick: F
          }, f(r(p)("conn.sshkeys.add")), 9, sU)
        ]),
        i("p", oU, f(r(p)("conn.sshkeys.noCopyId")), 1)
      ])) : T("", !0),
      r(g) ? (u(), d("p", iU, "…")) : (u(), nt(ki, {
        key: 5,
        "table-id": "conn.sshkeys",
        columns: N.value,
        rows: r(v),
        "row-key": "id",
        locale: o.value,
        empty: r(p)("conn.sshkeys.empty"),
        "row-class": (ce) => ce.disabled_at ? "is-muted" : void 0,
        "row-actions": W,
        "row-actions-test-id": (ce) => `ssh-key-actions-${ce.id}`,
        onRowAction: ie[2] || (ie[2] = (ce, X) => K(ce, X))
      }, {
        "cell-fingerprint": yt(({ row: ce }) => [
          i("code", rU, f(de(ce)), 1)
        ]),
        _: 1
      }, 8, ["columns", "rows", "locale", "empty", "row-class", "row-actions-test-id"]))
    ])) : T("", !0);
  }
});
function uU(e) {
  const a = Fr(e), t = Mn(e), s = (O) => `${t}${O}`, n = Dn([]), o = b(null), p = b(!1), h = b(!1), v = b(null), y = b(null), g = b(null);
  function m(O) {
    return hu(O, e.locale);
  }
  function k(O) {
    return O == null ? void 0 : O.status;
  }
  async function _() {
    p.value = !0, v.value = null;
    try {
      const O = await a.jsonFetch(
        s("/api/auth/nfs-exports")
      );
      n.value = Array.isArray(O == null ? void 0 : O.exports) ? O.exports : [], o.value = {
        enabled: (O == null ? void 0 : O.enabled) !== !1,
        host: (O == null ? void 0 : O.host) ?? "",
        port: (O == null ? void 0 : O.port) ?? 2049
      }, y.value = !0;
    } catch (O) {
      n.value = [], y.value = !1, k(O) !== 401 && k(O) !== 403 && (v.value = m(O));
    } finally {
      p.value = !1, h.value = !0;
    }
  }
  async function w(O) {
    v.value = null;
    try {
      const z = await a.jsonFetch(s("/api/auth/nfs-exports"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(O)
      });
      return g.value = z, z != null && z.host && (o.value = { enabled: z.enabled !== !1, host: z.host, port: z.port }), await _(), z;
    } catch (z) {
      return v.value = m(z), null;
    }
  }
  async function $(O, z) {
    v.value = null;
    try {
      await a.jsonFetch(s(`/api/auth/nfs-exports/${O}/state`), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ disabled: z })
      }), await _();
    } catch (P) {
      v.value = m(P);
    }
  }
  async function C(O) {
    var z, P;
    v.value = null;
    try {
      await a.jsonFetch(s(`/api/auth/nfs-exports/${O}`), { method: "DELETE" }), ((P = (z = g.value) == null ? void 0 : z.export) == null ? void 0 : P.id) === O && (g.value = null), await _();
    } catch (I) {
      v.value = m(I);
    }
  }
  function E() {
    g.value = null;
  }
  const A = x(() => {
    var z;
    if ((z = g.value) != null && z.export) return g.value.export;
    const O = n.value.filter((P) => !P.disabled_at);
    return O.length ? O.reduce((P, I) => P.created_at >= I.created_at ? P : I) : null;
  });
  return {
    exports: n,
    connection: o,
    loading: p,
    loaded: h,
    error: v,
    canMint: y,
    revealed: g,
    guideExport: A,
    load: _,
    create: w,
    setDisabled: $,
    remove: C,
    dismissPath: E
  };
}
const cU = {
  class: "fe-s3keys",
  "data-testid": "nfs-exports"
}, dU = { class: "fe-s3keys__head" }, fU = { class: "fe-s3keys__title" }, pU = { class: "fe-s3keys__lead" }, vU = { class: "fe-s3keys__warn" }, hU = {
  key: 0,
  class: "fe-s3keys__warn"
}, mU = {
  key: 1,
  class: "fe-s3keys__muted"
}, yU = {
  key: 2,
  class: "fe-s3keys__warn"
}, gU = {
  key: 3,
  class: "fe-s3keys__form fe-nfs__form"
}, bU = ["placeholder"], _U = { value: "" }, kU = ["value"], wU = ["placeholder", "disabled"], xU = ["placeholder"], $U = { class: "fe-nfs__ro" }, SU = ["disabled"], TU = {
  key: 4,
  class: "fe-s3keys__hint"
}, CU = {
  key: 5,
  class: "fe-s3keys__secret",
  "data-testid": "nfs-path"
}, EU = { class: "fe-s3keys__once" }, AU = { class: "fe-s3keys__pair" }, zU = {
  key: 6,
  class: "fe-s3keys__muted"
}, MU = /* @__PURE__ */ rt({
  __name: "NFSExportsPanel",
  props: {
    config: {},
    storages: {}
  },
  emits: ["active"],
  setup(e, { emit: a }) {
    const t = e, s = a, n = x(() => Ha(t.config.locale)), { t: o, formatDate: p } = gt(n), {
      exports: h,
      connection: v,
      loading: y,
      error: g,
      canMint: m,
      revealed: k,
      guideExport: _,
      load: w,
      create: $,
      setDisabled: C,
      remove: E,
      dismissPath: A
    } = uU(t.config), O = b(""), z = b(""), P = b(""), I = b(!0), F = b(""), W = b(!1), N = b(null), K = b(!1);
    let M = null;
    function j() {
      var pe, Q;
      const R = v.value;
      R && s("active", {
        host: R.host,
        port: R.port,
        enabled: R.enabled,
        // Only the freshly minted path — the stored ones cannot be recovered, and
        // printing a placeholder in a mount line somebody copies would produce a
        // command that fails with no clue why.
        path: (pe = k.value) == null ? void 0 : pe.path,
        readOnly: ((Q = _.value) == null ? void 0 : Q.read_only) ?? I.value
      });
    }
    Kt(async () => {
      await w(), j();
    });
    async function U() {
      W.value = !0;
      try {
        await $({
          label: O.value.trim() || o("conn.nfs.defaultLabel"),
          storage: z.value.trim() || void 0,
          prefix: P.value.trim() || void 0,
          read_only: I.value,
          allow_cidrs: F.value.trim() || void 0
        }), O.value = "", j();
      } finally {
        W.value = !1;
      }
    }
    function de(R) {
      return [
        {
          key: "toggle",
          label: R.disabled_at ? o("conn.nfs.enable") : o("conn.nfs.disable"),
          icon: R.disabled_at ? "check" : "lock",
          disabled: W.value
        },
        {
          key: "revoke",
          label: N.value === R.id ? o("conn.nfs.confirm") : o("conn.nfs.revoke"),
          icon: "delete",
          danger: !0,
          disabled: W.value
        }
      ];
    }
    const ke = x(() => [
      {
        id: "label",
        label: o("conn.nfs.col.label"),
        sortable: !0,
        width: 180,
        format: (R) => R.label || o("conn.nfs.noLabel")
      },
      { id: "scope", label: o("conn.nfs.col.scope"), sortable: !0, width: 180, format: we },
      {
        id: "mode",
        label: o("conn.nfs.col.mode"),
        sortable: !0,
        width: 120,
        format: (R) => R.read_only ? o("conn.nfs.modeRead") : o("conn.nfs.modeWrite")
      },
      {
        id: "lastUsed",
        label: o("conn.nfs.col.lastUsed"),
        sortable: !0,
        sortDir: "desc",
        width: 140,
        format: (R) => R.last_used_at ? G(R.last_used_at) : o("conn.nfs.neverUsed"),
        sortValue: (R) => R.last_used_at ? new Date(R.last_used_at).getTime() : null
      }
    ]);
    function ie(R, pe) {
      R === "toggle" ? ce(pe) : R === "revoke" && X(pe);
    }
    async function ce(R) {
      W.value = !0;
      try {
        await C(R.id, !R.disabled_at), j();
      } finally {
        W.value = !1;
      }
    }
    async function X(R) {
      if (N.value !== R.id) {
        N.value = R.id;
        return;
      }
      N.value = null, W.value = !0;
      try {
        await E(R.id), j();
      } finally {
        W.value = !1;
      }
    }
    const Z = x(() => {
      var q, re, ae;
      const R = v.value, pe = (q = k.value) == null ? void 0 : q.path;
      if (!R || !pe) return "";
      const Q = (ae = (re = k.value) == null ? void 0 : re.export) != null && ae.read_only ? ",ro" : "";
      return `sudo mount -t nfs -o nfsvers=3,tcp,port=${R.port},mountport=${R.port},nolock${Q} ${R.host}:${pe} /mnt/filex`;
    });
    async function Y() {
      const R = Z.value;
      if (!R) return;
      let pe = !1;
      try {
        await navigator.clipboard.writeText(R), pe = !0;
      } catch {
        try {
          const Q = document.createElement("textarea");
          Q.value = R, Q.setAttribute("readonly", ""), Q.style.position = "fixed", Q.style.opacity = "0", document.body.appendChild(Q), Q.select(), pe = document.execCommand("copy"), document.body.removeChild(Q);
        } catch {
          pe = !1;
        }
      }
      pe && (K.value = !0, M && clearTimeout(M), M = setTimeout(() => K.value = !1, 1600));
    }
    function G(R) {
      const pe = new Date(R ?? "").getTime();
      return Number.isNaN(pe) ? "" : p(pe);
    }
    function we(R) {
      return R.storage_name ? R.prefix ? `${R.storage_name}/${R.prefix}` : R.storage_name : o("conn.nfs.scopeAll");
    }
    return (R, pe) => (u(), d("section", cU, [
      i("header", dU, [
        i("h4", fU, f(r(o)("conn.nfs.title")), 1),
        i("p", pU, f(r(o)("conn.nfs.lead")), 1)
      ]),
      i("p", vU, f(r(o)("conn.nfs.pathIsSecret")), 1),
      r(v) && !r(v).enabled ? (u(), d("p", hU, f(r(o)("conn.nfs.disabled")), 1)) : T("", !0),
      r(m) === !1 ? (u(), d("p", mU, f(r(o)("conn.nfs.cannotMint")), 1)) : T("", !0),
      r(g) ? (u(), d("p", yU, f(r(g)), 1)) : T("", !0),
      r(m) ? (u(), d("div", gU, [
        dt(i("input", {
          "onUpdate:modelValue": pe[0] || (pe[0] = (Q) => O.value = Q),
          class: "fe-cfield__input",
          placeholder: r(o)("conn.nfs.label"),
          "data-testid": "nfs-label"
        }, null, 8, bU), [
          [St, O.value]
        ]),
        dt(i("select", {
          "onUpdate:modelValue": pe[1] || (pe[1] = (Q) => z.value = Q),
          class: "fe-cfield__input",
          "data-testid": "nfs-storage"
        }, [
          i("option", _U, f(r(o)("conn.nfs.everyStorage")), 1),
          (u(!0), d(he, null, We(e.storages, (Q) => (u(), d("option", {
            key: Q,
            value: Q
          }, f(Q), 9, kU))), 128))
        ], 512), [
          [Xa, z.value]
        ]),
        dt(i("input", {
          "onUpdate:modelValue": pe[2] || (pe[2] = (Q) => P.value = Q),
          class: "fe-cfield__input",
          placeholder: r(o)("conn.nfs.prefix"),
          disabled: !z.value,
          "data-testid": "nfs-prefix"
        }, null, 8, wU), [
          [St, P.value]
        ]),
        dt(i("input", {
          "onUpdate:modelValue": pe[3] || (pe[3] = (Q) => F.value = Q),
          class: "fe-cfield__input",
          placeholder: r(o)("conn.nfs.allowCidrs"),
          "data-testid": "nfs-cidrs"
        }, null, 8, xU), [
          [St, F.value]
        ]),
        i("label", $U, [
          dt(i("input", {
            type: "checkbox",
            "onUpdate:modelValue": pe[4] || (pe[4] = (Q) => I.value = Q),
            "data-testid": "nfs-readonly"
          }, null, 512), [
            [Ja, I.value]
          ]),
          $t(" " + f(r(o)("conn.nfs.readOnly")), 1)
        ]),
        i("button", {
          class: "fe-s3keys__btn",
          disabled: W.value,
          "data-testid": "nfs-mint",
          onClick: U
        }, f(r(o)("conn.nfs.mint")), 9, SU)
      ])) : T("", !0),
      r(m) ? (u(), d("p", TU, f(r(o)("conn.nfs.readOnlyHint")), 1)) : T("", !0),
      r(k) ? (u(), d("div", CU, [
        i("p", EU, f(r(o)("conn.nfs.once")), 1),
        i("div", AU, [
          i("code", null, f(Z.value), 1),
          i("button", {
            class: "fe-s3keys__copy",
            onClick: Y
          }, f(K.value ? r(o)("conn.guide.copied") : r(o)("conn.guide.copy")), 1)
        ]),
        i("button", {
          class: "fe-s3keys__dismiss",
          onClick: pe[5] || (pe[5] = //@ts-ignore
          (...Q) => r(A) && r(A)(...Q))
        }, f(r(o)("conn.nfs.dismiss")), 1)
      ])) : T("", !0),
      r(y) ? (u(), d("p", zU, "…")) : (u(), nt(ki, {
        key: 7,
        "table-id": "conn.nfs",
        columns: ke.value,
        rows: r(h),
        "row-key": "id",
        locale: n.value,
        empty: r(o)("conn.nfs.empty"),
        "row-class": (Q) => Q.disabled_at ? "is-muted" : void 0,
        "row-actions": de,
        "row-actions-test-id": (Q) => `nfs-export-actions-${Q.id}`,
        onRowAction: pe[6] || (pe[6] = (Q, q) => ie(Q, q))
      }, null, 8, ["columns", "rows", "locale", "empty", "row-class", "row-actions-test-id"]))
    ]));
  }
});
function DU(e) {
  const a = Fr(e), t = Mn(e), s = (C) => `${t}${C}`, n = Dn([]), o = b(!1), p = b(!1), h = b(null), v = b(null), y = b(null);
  function g(C) {
    return hu(C, e.locale);
  }
  function m(C) {
    return C == null ? void 0 : C.status;
  }
  async function k() {
    o.value = !0, h.value = null;
    try {
      const C = await a.jsonFetch(s("/api/tokens"));
      n.value = Array.isArray(C == null ? void 0 : C.tokens) ? C.tokens : [], v.value = !0;
    } catch (C) {
      n.value = [];
      const E = m(C);
      v.value = !1, E !== 401 && E !== 403 && (h.value = g(C));
    } finally {
      o.value = !1, p.value = !0;
    }
  }
  async function _(C) {
    h.value = null;
    try {
      const E = await a.jsonFetch(s("/api/tokens"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(C)
      });
      return y.value = E, await k(), E;
    } catch (E) {
      return h.value = g(E), null;
    }
  }
  async function w(C) {
    var E, A;
    h.value = null;
    try {
      await a.jsonFetch(s(`/api/tokens/${C}`), { method: "DELETE" }), ((A = (E = y.value) == null ? void 0 : E.row) == null ? void 0 : A.id) === C && (y.value = null), await k();
    } catch (O) {
      h.value = g(O);
    }
  }
  function $() {
    y.value = null;
  }
  return { tokens: n, loading: o, loaded: p, error: h, canMint: v, revealed: y, load: k, create: _, remove: w, dismiss: $ };
}
const PU = {
  class: "fe-s3keys",
  "data-testid": "api-tokens"
}, OU = { class: "fe-s3keys__head" }, LU = { class: "fe-s3keys__title" }, IU = { class: "fe-s3keys__lead" }, RU = {
  key: 0,
  class: "fe-s3keys__muted"
}, NU = {
  key: 1,
  class: "fe-s3keys__warn"
}, BU = {
  key: 2,
  class: "fe-s3keys__form"
}, FU = ["placeholder"], UU = ["disabled"], HU = {
  key: 3,
  class: "fe-tokform",
  "data-testid": "token-form-full"
}, KU = ["placeholder"], VU = { class: "fe-tokform__scopes" }, qU = { class: "fe-tokform__legend" }, jU = ["onUpdate:modelValue", "data-testid"], WU = {
  key: 0,
  class: "fe-s3keys__hint fe-tokform__required",
  role: "alert",
  "data-testid": "token-scopes-required"
}, YU = { class: "fe-tokform__field" }, GU = { class: "fe-tokform__label" }, XU = ["placeholder"], JU = { class: "fe-tokform__row" }, ZU = { class: "fe-tokform__field fe-tokform__field--narrow" }, QU = { class: "fe-tokform__label" }, eH = ["placeholder"], tH = ["disabled"], aH = { class: "fe-s3keys__hint" }, nH = {
  key: 4,
  class: "fe-s3keys__secret",
  "data-testid": "token-secret"
}, sH = { class: "fe-s3keys__once" }, oH = { class: "fe-s3keys__pair" }, iH = {
  key: 5,
  class: "fe-s3keys__muted"
}, rH = { class: "tbl-mono" }, lH = {
  key: 7,
  class: "fe-s3keys__hint"
}, S0 = /* @__PURE__ */ rt({
  __name: "TokensPanel",
  props: {
    config: {},
    full: { type: Boolean },
    protocol: {},
    host: {}
  },
  emits: ["active"],
  setup(e, { emit: a }) {
    const t = e, s = a, n = x(() => Ha(t.config.locale)), { t: o, formatDate: p } = gt(n), { tokens: h, loading: v, error: y, canMint: g, revealed: m, load: k, create: _, remove: w, dismiss: $ } = DU(
      t.config
    ), C = b(""), E = b(!1), A = b(!1), O = b(null), z = ["read", "write", "delete", "mcp"], P = b({
      read: !0,
      write: !1,
      delete: !1,
      mcp: !1
    }), I = b(""), F = b(null), W = x(() => !z.some((Y) => P.value[Y]));
    function N() {
      const Y = z.filter((we) => P.value[we]), G = I.value.trim();
      return G && Y.push("root:" + G), Y.join(",");
    }
    Kt(async () => {
      await k(), s("active", { hasToken: h.value.length > 0 });
    });
    function K() {
      const Y = (t.protocol || "").toUpperCase();
      return Y ? t.host ? `${Y} — ${t.host}` : Y : o("conn.tokens.defaultName", { date: (/* @__PURE__ */ new Date()).toISOString().slice(0, 10) });
    }
    function M() {
      return t.protocol ? K() : o("conn.tokens.namePlaceholder");
    }
    async function j() {
      if (!E.value) {
        E.value = !0, A.value = !1;
        try {
          if (t.full) {
            if (W.value) return;
            const Y = N();
            await _({
              label: C.value.trim() || K(),
              scopes: Y,
              expires_in_days: F.value && F.value > 0 ? F.value : void 0
            }), await k(), s("active", { hasToken: h.value.length > 0 }), C.value = "", I.value = "";
            return;
          }
          await _({ label: C.value.trim() || K(), scopes: "read,write,delete" }), await k(), s("active", { hasToken: h.value.length > 0 }), C.value = "";
        } finally {
          E.value = !1;
        }
      }
    }
    const U = x(() => [
      {
        id: "label",
        label: o("conn.tokens.col.label"),
        sortable: !0,
        width: 200,
        format: (Y) => Y.label || "—"
      },
      { id: "scopes", label: o("conn.tokens.col.scopes"), sortable: !0, width: 200 },
      {
        id: "used",
        label: o("conn.tokens.col.used"),
        sortable: !0,
        sortDir: "desc",
        width: 140,
        format: Z,
        sortValue: (Y) => Y.last_used_at ? new Date(Y.last_used_at).getTime() : null
      }
    ]);
    function de(Y) {
      return [
        {
          key: "revoke",
          label: O.value === Y.id ? o("conn.tokens.confirm") : o("conn.tokens.revoke"),
          icon: "delete",
          danger: !0,
          /* The whole control used to be `:disabled="busy"`; the table draws the
             control, so the verb carries it — RowActions greys a button with
             nothing usable behind it. */
          disabled: E.value
        }
      ];
    }
    function ke(Y, G) {
      Y === "revoke" && ie(G);
    }
    async function ie(Y) {
      if (O.value !== Y.id) {
        O.value = Y.id;
        return;
      }
      O.value = null, E.value = !0;
      try {
        await w(Y.id), s("active", { hasToken: h.value.length > 0 });
      } finally {
        E.value = !1;
      }
    }
    async function ce() {
      var Y;
      if ((Y = m.value) != null && Y.token)
        try {
          await navigator.clipboard.writeText(m.value.token), A.value = !0, window.setTimeout(() => A.value = !1, 1600);
        } catch {
        }
    }
    function X(Y) {
      const G = new Date(Y ?? "").getTime();
      return Number.isNaN(G) ? "" : p(G);
    }
    function Z(Y) {
      return Y.last_used_at ? X(Y.last_used_at) : o("conn.tokens.neverUsed");
    }
    return (Y, G) => (u(), d("section", PU, [
      i("header", OU, [
        i("h4", LU, f(r(o)("conn.tokens.title")), 1),
        i("p", IU, f(r(o)("conn.tokens.lead")), 1)
      ]),
      r(g) === !1 ? (u(), d("p", RU, f(r(o)("conn.tokens.cannotMint")), 1)) : T("", !0),
      r(y) ? (u(), d("p", NU, f(r(y)), 1)) : T("", !0),
      r(g) && !e.full ? (u(), d("div", BU, [
        dt(i("input", {
          "onUpdate:modelValue": G[0] || (G[0] = (we) => C.value = we),
          class: "fe-cfield__input",
          placeholder: M(),
          "data-testid": "token-label"
        }, null, 8, FU), [
          [St, C.value]
        ]),
        i("button", {
          class: "fe-s3keys__btn",
          disabled: E.value,
          "data-testid": "token-mint",
          onClick: j
        }, f(r(o)("conn.tokens.mint")), 9, UU)
      ])) : r(g) ? (u(), d("div", HU, [
        dt(i("input", {
          "onUpdate:modelValue": G[1] || (G[1] = (we) => C.value = we),
          class: "fe-cfield__input",
          placeholder: M(),
          "data-testid": "token-label"
        }, null, 8, KU), [
          [St, C.value]
        ]),
        i("fieldset", VU, [
          i("legend", qU, f(r(o)("conn.tokens.scopes")), 1),
          (u(), d(he, null, We(z, (we) => i("label", {
            key: we,
            class: "fe-tokform__scope"
          }, [
            dt(i("input", {
              "onUpdate:modelValue": (R) => P.value[we] = R,
              type: "checkbox",
              "data-testid": `token-scope-${we}`
            }, null, 8, jU), [
              [Ja, P.value[we]]
            ]),
            i("span", null, f(we), 1)
          ])), 64)),
          W.value ? (u(), d("p", WU, f(r(o)("conn.tokens.scopesRequired")), 1)) : T("", !0)
        ]),
        i("label", YU, [
          i("span", GU, f(r(o)("conn.tokens.root")), 1),
          dt(i("input", {
            "onUpdate:modelValue": G[2] || (G[2] = (we) => I.value = we),
            class: "fe-cfield__input",
            placeholder: r(o)("conn.tokens.rootPlaceholder"),
            "data-testid": "token-root"
          }, null, 8, XU), [
            [St, I.value]
          ])
        ]),
        i("div", JU, [
          i("label", ZU, [
            i("span", QU, f(r(o)("conn.tokens.expiry")), 1),
            dt(i("input", {
              "onUpdate:modelValue": G[3] || (G[3] = (we) => F.value = we),
              type: "number",
              min: "0",
              class: "fe-cfield__input",
              placeholder: r(o)("conn.tokens.expiryNever"),
              "data-testid": "token-expiry"
            }, null, 8, eH), [
              [
                St,
                F.value,
                void 0,
                { number: !0 }
              ]
            ])
          ]),
          i("button", {
            class: "fe-s3keys__btn",
            disabled: E.value || W.value,
            "data-testid": "token-mint",
            onClick: j
          }, f(r(o)("conn.tokens.mint")), 9, tH)
        ]),
        i("p", aH, f(r(o)("conn.tokens.capNote")), 1)
      ])) : T("", !0),
      r(m) ? (u(), d("div", nH, [
        i("p", sH, f(r(o)("conn.tokens.once")), 1),
        i("div", oH, [
          i("code", null, f(r(m).token), 1),
          i("button", {
            class: "fe-s3keys__copy",
            onClick: ce
          }, f(A.value ? r(o)("conn.guide.copied") : r(o)("conn.guide.copy")), 1)
        ]),
        i("button", {
          class: "fe-s3keys__dismiss",
          onClick: G[4] || (G[4] = //@ts-ignore
          (...we) => r($) && r($)(...we))
        }, f(r(o)("conn.tokens.dismiss")), 1)
      ])) : T("", !0),
      r(v) ? (u(), d("p", iH, "…")) : (u(), nt(ki, {
        key: 6,
        "table-id": "conn.tokens",
        columns: U.value,
        rows: r(h),
        "row-key": "id",
        locale: n.value,
        empty: r(o)("conn.tokens.empty"),
        "row-actions": de,
        "row-actions-test-id": (we) => `api-token-actions-${we.id}`,
        onRowAction: G[5] || (G[5] = (we, R) => ke(we, R))
      }, {
        "cell-scopes": yt(({ row: we }) => [
          i("code", rH, f(we.scopes), 1)
        ]),
        _: 1
      }, 8, ["columns", "rows", "locale", "empty", "row-actions-test-id"])),
      r(g) ? (u(), d("p", lH, f(r(o)("conn.tokens.revokeHint")), 1)) : T("", !0)
    ]));
  }
}), uH = { class: "fe-conn__head" }, cH = { class: "fe-conn__title" }, dH = { class: "fe-conn__sub" }, fH = ["aria-label"], pH = ["innerHTML"], vH = {
  key: 0,
  class: "fe-conn__error",
  "data-testid": "conn-error"
}, hH = { class: "fe-conn__body" }, mH = { class: "fe-conn__guidebar" }, yH = {
  key: 0,
  class: "fe-conn__pick"
}, gH = { class: "fe-cfield__label" }, bH = ["value"], _H = { class: "fe-conn__pick" }, kH = { class: "fe-cfield__label" }, wH = { value: "" }, xH = ["value"], $H = /* @__PURE__ */ rt({
  __name: "ConnectionsPanel",
  props: {
    config: {},
    closable: { type: Boolean }
  },
  emits: ["close", "error"],
  setup(e, { emit: a }) {
    const t = e, s = a, n = x(() => Ha(t.config.locale)), { t: o } = gt(n), { visible: p, me: h, publicUrl: v, error: y, load: g } = OB(t.config), m = Ld(), k = x(() => {
      const P = t.config.theme ?? "auto";
      return P === "light" || P === "dark" ? P : m.value ? "dark" : "light";
    }), _ = JB(), w = b(_[0] ?? "webdav"), $ = b(""), C = b(
      null
    ), E = x(() => PB(t.config, v.value)), A = b(
      null
    ), O = b(null), z = x(
      () => {
        var P, I, F, W, N, K, M, j, U, de, ke, ie, ce, X, Z, Y, G, we, R, pe, Q, q, re, ae, Pe, be, ze;
        return ZB(
          w.value,
          {
            origin: E.value,
            user: ((P = h.value) == null ? void 0 : P.email) ?? "",
            storages: p.value,
            storage: $.value || void 0,
            s3Endpoint: (I = A.value) == null ? void 0 : I.endpoint,
            s3PathStyle: (F = A.value) == null ? void 0 : F.pathStyle,
            s3AccessKeyID: ((W = A.value) == null ? void 0 : W.accessKeyID) || void 0,
            s3Secret: (N = A.value) == null ? void 0 : N.secret,
            sftpHost: ((K = O.value) == null ? void 0 : K.host) || void 0,
            sftpPort: (M = O.value) == null ? void 0 : M.port,
            sftpEnabled: (j = O.value) == null ? void 0 : j.enabled,
            sftpLogin: ((U = O.value) == null ? void 0 : U.login) || void 0,
            sftpHasKey: (de = O.value) == null ? void 0 : de.hasKey,
            ftpsHost: ((ie = (ke = O.value) == null ? void 0 : ke.ftps) == null ? void 0 : ie.host) || void 0,
            ftpsPort: (X = (ce = O.value) == null ? void 0 : ce.ftps) == null ? void 0 : X.port,
            ftpsEnabled: (Y = (Z = O.value) == null ? void 0 : Z.ftps) == null ? void 0 : Y.enabled,
            ftpsPasvMin: (we = (G = O.value) == null ? void 0 : G.ftps) == null ? void 0 : we.pasv_min,
            ftpsPasvMax: (pe = (R = O.value) == null ? void 0 : R.ftps) == null ? void 0 : pe.pasv_max,
            ftpsSelfSigned: (q = (Q = O.value) == null ? void 0 : Q.ftps) == null ? void 0 : q.self_signed,
            nfsHost: ((re = C.value) == null ? void 0 : re.host) || void 0,
            nfsPort: (ae = C.value) == null ? void 0 : ae.port,
            nfsEnabled: (Pe = C.value) == null ? void 0 : Pe.enabled,
            nfsPath: (be = C.value) == null ? void 0 : be.path,
            nfsReadOnly: (ze = C.value) == null ? void 0 : ze.readOnly
          },
          o
        );
      }
    );
    return Qe(
      () => p.value,
      (P) => {
        !$.value && P.length === 1 && ($.value = P[0]);
      }
    ), Kt(() => {
      g();
    }), Qe(
      () => [t.config.apiBase, t.config.endpoint],
      () => {
        g();
      }
    ), (P, I) => (u(), d("div", {
      class: Re(["fe-conn", {
        "fe--theme-dark": k.value === "dark",
        "fe--theme-light": k.value === "light"
      }]),
      "data-testid": "connections-panel"
    }, [
      i("header", uH, [
        i("div", null, [
          i("h2", cH, f(r(o)("conn.title")), 1),
          i("p", dH, f(r(o)("conn.subtitle", { host: r(vi)(E.value) })), 1)
        ]),
        e.closable ? (u(), d("button", {
          key: 0,
          type: "button",
          class: "fe-conn__btn",
          "data-testid": "connections-close",
          "aria-label": r(o)("conn.close"),
          onClick: I[0] || (I[0] = (F) => s("close"))
        }, [
          i("span", {
            "aria-hidden": "true",
            innerHTML: r(wt)("close")
          }, null, 8, pH)
        ], 8, fH)) : T("", !0)
      ]),
      r(y) ? (u(), d("p", vH, f(r(y)), 1)) : T("", !0),
      i("section", hH, [
        i("div", mH, [
          r(_).length > 1 ? (u(), d("label", yH, [
            i("span", gH, f(r(o)("conn.guide.protocol")), 1),
            dt(i("select", {
              "onUpdate:modelValue": I[1] || (I[1] = (F) => w.value = F),
              class: "fe-cfield__input",
              "data-testid": "guide-protocol"
            }, [
              (u(!0), d(he, null, We(r(_), (F) => (u(), d("option", {
                key: F,
                value: F
              }, f(r(XB)(F)), 9, bH))), 128))
            ], 512), [
              [Xa, w.value]
            ])
          ])) : T("", !0),
          i("label", _H, [
            i("span", kH, f(r(o)("conn.guide.storage")), 1),
            dt(i("select", {
              "onUpdate:modelValue": I[2] || (I[2] = (F) => $.value = F),
              class: "fe-cfield__input",
              "data-testid": "guide-storage"
            }, [
              i("option", wH, f(r(o)("conn.guide.allStorages")), 1),
              (u(!0), d(he, null, We(r(p), (F) => (u(), d("option", {
                key: F,
                value: F
              }, f(F), 9, xH))), 128))
            ], 512), [
              [Xa, $.value]
            ])
          ])
        ]),
        w.value === "s3" ? (u(), nt(qF, {
          key: 0,
          config: e.config,
          storages: r(p),
          onActive: I[3] || (I[3] = (F) => A.value = F)
        }, null, 8, ["config", "storages"])) : T("", !0),
        w.value === "sftp" || w.value === "ftps" ? (u(), nt(lU, {
          key: 1,
          config: e.config,
          "keys-visible": w.value === "sftp",
          onActive: I[4] || (I[4] = (F) => O.value = F)
        }, null, 8, ["config", "keys-visible"])) : T("", !0),
        w.value === "nfs" ? (u(), nt(MU, {
          key: 2,
          config: e.config,
          storages: r(p),
          onActive: I[5] || (I[5] = (F) => C.value = F)
        }, null, 8, ["config", "storages"])) : T("", !0),
        w.value === "ftps" || w.value === "webdav" || w.value === "mount" ? (u(), nt(S0, {
          key: 3,
          config: e.config,
          protocol: w.value,
          host: r(vi)(E.value)
        }, null, 8, ["config", "protocol", "host"])) : T("", !0),
        z.value ? (u(), nt(_F, {
          key: 4,
          guide: z.value,
          locale: n.value
        }, null, 8, ["guide", "locale"])) : T("", !0)
      ])
    ], 2));
  }
});
function T0(e) {
  return String(e.path ?? "").replace(/^\/+|\/+$/g, "");
}
function Xv(e, a) {
  return typeof e.storage == "string" && e.storage ? e.storage : typeof e.storage_name == "string" && e.storage_name ? e.storage_name : a.configured.length === 1 && a.configured[0] ? a.configured[0] : a.current || "";
}
function qc(e, a) {
  const t = String(e.path ?? "").replace(/^\/+/, ""), s = typeof e.storage == "string" && e.storage ? e.storage : a, n = String(e.name ?? t.split("/").pop() ?? ""), o = n.lastIndexOf("."), p = typeof e.backend_mtime == "string" ? e.backend_mtime : e.updated_at, h = typeof p == "string" ? Date.parse(p) : NaN;
  return {
    id: typeof e.id == "number" ? e.id : void 0,
    path: s ? `${s}://${t}` : t,
    basename: n,
    relativePath: t,
    type: e.type === "dir" ? "dir" : "file",
    extension: o > 0 ? n.slice(o + 1).toLowerCase() : "",
    size: typeof e.size == "number" ? e.size : 0,
    // ⚠ Left UNSET when the row carries no parseable timestamp rather than
    // defaulted to 0 or to now: `matchesModified` treats a missing timestamp
    // as "unknown" and drops the row from a date filter, which is the honest
    // answer. Stamping it with `Date.now()` would file every such file under
    // "Today".
    last_modified: Number.isNaN(h) ? void 0 : h,
    mime_type: typeof e.mime == "string" ? e.mime : "",
    /* The content snippet the hit came with, so a content match can show why
       it matched. Undefined on name-only hits, exactly as the backend sends. */
    snippet: typeof e.snippet == "string" && e.snippet ? e.snippet : void 0,
    /* Owner, so the People filter and the Owner column mean the same thing in a
       content result as they do in a folder listing. Undefined rather than
       guessed when the backend does not send it. */
    owner_id: typeof e.owner_id == "number" ? e.owner_id : void 0,
    owner_name: typeof e.owner_name == "string" ? e.owner_name : void 0,
    owner_self: e.owner_self === !0 ? !0 : void 0,
    /* wiring:e2 names — the encrypted folder the hit sits in (the server
       answers it); the explorer's name view reads it. */
    ...typeof e.e2e_root == "string" && e.e2e_root ? { e2e_root: e.e2e_root } : {}
  };
}
function SH(e, a) {
  const t = Xv(e, a);
  if (!T0(e) || !t) return null;
  const s = qc(e, t);
  return { path: s.path, basename: s.basename, type: s.type };
}
function TH(e, a) {
  var n;
  const t = [], s = /* @__PURE__ */ new Map();
  for (const o of e) {
    const p = ((n = o.account) == null ? void 0 : n.id) ?? "";
    let h = s.get(p);
    h || (h = { account: o.account, hits: [] }, s.set(p, h), t.push(h)), h.hits.length < a && h.hits.push(o);
  }
  return t;
}
const CH = ["aria-label"], EH = { class: "fe-cmdp__inputwrap" }, AH = ["placeholder"], zH = ["aria-selected", "onMouseenter", "onClick"], MH = ["innerHTML"], DH = { class: "fe-cmdp__label" }, PH = { class: "fe-cmdp__group" }, OH = ["aria-selected", "onMouseenter", "onClick"], LH = ["innerHTML"], IH = { class: "fe-cmdp__label" }, RH = { class: "fe-cmdp__group" }, NH = {
  key: 0,
  class: "fe-cmdp__loading"
}, BH = {
  key: 1,
  class: "fe-cmdp__loading",
  role: "alert",
  "data-testid": "palette-everywhere-failed"
}, FH = ["data-account"], UH = { class: "fe-cmdp__acct-label" }, HH = {
  key: 0,
  class: "fe-cmdp__acct-detail"
}, KH = ["aria-selected", "data-account", "draggable", "onMouseenter", "onPointerdown", "onClick", "onKeydown", "onDragstart"], VH = ["innerHTML"], qH = { class: "fe-cmdp__hitbody" }, jH = { class: "fe-cmdp__hitline" }, WH = { class: "fe-cmdp__label" }, YH = {
  key: 0,
  class: "fe-cmdp__badge"
}, GH = ["title"], XH = {
  key: 1,
  class: "fe-cmdp__snippet"
}, JH = {
  key: 0,
  class: "fe-cmdp__mark"
}, ZH = ["title", "aria-label", "onClick"], QH = ["innerHTML"], e9 = { class: "fe-cmdp__group" }, t9 = ["aria-selected", "onMouseenter", "onClick", "onKeydown"], a9 = ["innerHTML"], n9 = { class: "fe-cmdp__label" }, s9 = ["title", "aria-label", "onClick"], o9 = ["innerHTML"], i9 = { class: "fe-cmdp__group" }, r9 = ["aria-selected", "onMouseenter", "onClick"], l9 = ["innerHTML"], u9 = { class: "fe-cmdp__label" }, c9 = {
  key: 4,
  class: "fe-cmdp__empty"
}, d9 = { class: "fe-cmdp__hint" }, f9 = 3, p9 = 8, v9 = 250, f_ = "filex.saved-searches", p_ = 10, h9 = /* @__PURE__ */ rt({
  __name: "CommandPalette",
  props: {
    open: { type: Boolean },
    locale: {},
    files: {},
    viewMode: {},
    canWrite: { type: Boolean },
    canGoUp: { type: Boolean },
    globalSearch: { type: Function },
    splitEnabled: { type: Boolean },
    initialQuery: {},
    hitCan: { type: Function }
  },
  emits: ["close", "open-node", "navigate", "new-folder", "upload", "toggle-view", "open-trash", "refresh", "go-up", "open-hit", "download-hit", "drag-hit", "drop-inside", "warm-hit", "open-theme", "open-shortcut-settings", "start-tour", "tab-new", "split-toggle"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n, nodeDisplayName: o } = gt(() => t.locale), p = b(""), h = b(0), v = b(null), y = b(null);
    function g(ae) {
      const Pe = ae.lastIndexOf(".");
      return Pe > 0 ? ae.slice(Pe + 1) : "";
    }
    function m(ae) {
      if (ae.kind === "file") return sn(ae.node);
      if (ae.kind === "hit") {
        const Pe = String(ae.hit.name ?? "");
        return sn({
          type: ae.hit.type === "dir" ? "dir" : "file",
          extension: g(Pe),
          basename: Pe
        });
      }
      return wt(ae.icon);
    }
    function k(ae, Pe) {
      if (!Pe) return 0;
      const be = ae.toLocaleLowerCase(), ze = Pe.toLocaleLowerCase(), Ae = be.indexOf(ze);
      if (Ae === -1) return -1;
      let Ce = 100 - Math.min(Ae, 50);
      return Ae === 0 && (Ce += 40), Ce -= Math.min(be.length, 40) / 4, Ce;
    }
    const _ = x(() => {
      const ae = p.value.trim();
      if (!ae.includes("/")) return [];
      const Pe = ae.replace(/^\/+|\/+$/g, "");
      return Pe ? [
        { kind: "goto", id: `goto:${Pe}`, label: `${n("palette.goto")}: ${Pe}`, icon: "goto", path: Pe }
      ] : [];
    }), w = x(() => {
      const ae = p.value.trim(), Pe = t.files.map((be) => ({ f: be, name: o(be), s: k(o(be), ae) })).filter((be) => be.s >= 0);
      return ae && Pe.sort((be, ze) => ze.s - be.s), Pe.slice(0, 8).map((be) => ({
        kind: "file",
        id: `file:${be.f.path}`,
        label: be.name,
        icon: "",
        // file rows draw their real tile — see iconHtml()
        node: be.f
      }));
    }), $ = x(() => {
      const ae = p.value.trim();
      return [
        { command: "new-folder", label: n("toolbar.new_folder"), icon: "new-folder", enabled: t.canWrite !== !1 },
        { command: "upload", label: n("toolbar.upload"), icon: "upload", enabled: t.canWrite !== !1 },
        /* wiring:d2 — the mark is the NEXT mode (list→grid→gallery→list), which is
           what pressing the row gets you; the three keys are the ViewSwitcher's own. */
        { command: "toggle-view", label: n("cmd.view_toggle"), icon: t.viewMode === "list" ? "view-grid" : t.viewMode === "grid" ? "view-gallery" : "view-list", enabled: !0 },
        { command: "open-trash", label: n("cmd.trash"), icon: "open-trash", enabled: !0 },
        { command: "refresh", label: n("toolbar.refresh"), icon: "refresh", enabled: !0 },
        { command: "go-up", label: n("toolbar.go_up"), icon: "go-up", enabled: t.canGoUp !== !1 },
        /* wiring:int */
        { command: "open-theme", label: n("theme.menu"), icon: "theme", enabled: !0 },
        { command: "open-shortcut-settings", label: n("shortcuts.settings.menu"), icon: "shortcut-settings", enabled: !0 },
        { command: "start-tour", label: n("tour.restart"), icon: "tour", enabled: !0 },
        /* wiring:d1 — tabs + split */
        { command: "tab-new", label: n("cmd.tab_new"), icon: "tab-new", enabled: !0 },
        { command: "split-toggle", label: n("cmd.split_toggle"), icon: "split", enabled: t.splitEnabled !== !1 }
      ].filter((be) => be.enabled && k(be.label, ae) >= 0).map((be) => ({ kind: "command", id: `cmd:${be.command}`, label: be.label, icon: be.icon, command: be.command }));
    }), C = b([]), E = b(!1), A = b(!1), O = b("");
    let z, P = 0;
    function I(ae) {
      z && clearTimeout(z);
      const Pe = t.globalSearch;
      if (!Pe || ae.length < f9) {
        C.value = [], E.value = !1, A.value = !1;
        return;
      }
      E.value = !0, z = setTimeout(async () => {
        const be = ++P;
        try {
          const ze = await Pe(ae);
          if (be !== P) return;
          C.value = Array.isArray(ze) ? ze : [], A.value = !1;
        } catch (ze) {
          be === P && (C.value = [], A.value = !0, O.value = ch(ze, n("palette.everywhere_failed"), { t: n }).text);
        } finally {
          be === P && (E.value = !1);
        }
      }, v9);
    }
    function F(ae) {
      if (typeof ae.e2e_display_dir == "string")
        return [typeof ae.storage == "string" && ae.storage || "", ae.e2e_display_dir].filter(Boolean).join("/") || "/";
      const Pe = String(ae.path ?? "").replace(/^\/+|\/+$/g, ""), be = Pe.lastIndexOf("/"), ze = be === -1 ? "" : Pe.slice(0, be), Ae = typeof ae.storage == "string" && ae.storage || typeof ae.storage_name == "string" && ae.storage_name || "";
      return Ae && ze ? `${Ae}/${ze}` : Ae || ze || "/";
    }
    const W = x(() => {
      const ae = t.hitCan, Pe = [];
      for (const be of TH(C.value, p9))
        be.hits.forEach((ze, Ae) => {
          var Ce;
          Pe.push({
            kind: "hit",
            // The account is part of the key: two accounts can both hold node 7
            // at `a.txt` on storage 1.
            id: `hit:${((Ce = ze.account) == null ? void 0 : Ce.id) ?? ""}:${ze.storage_id ?? ""}:${ze.path ?? ""}:${ze.id ?? ""}`,
            label: String(ze.name ?? ze.path ?? ""),
            icon: "",
            // hit rows draw their real tile — see iconHtml()
            hit: ze,
            crumb: F(ze),
            inContent: w0(ze.matched),
            snippet: typeof ze.snippet == "string" ? ze.snippet : "",
            groupHead: Ae === 0 ? be.account : void 0,
            canDownload: ae ? ae(ze, "download") : !0,
            canDrag: ae ? ae(ze, "drag") : !0
          });
        });
      return Pe;
    });
    function N(ae) {
      ae.canDownload && s("download-hit", ae.hit);
    }
    function K(ae) {
      ae.canDrag && s("warm-hit", ae.hit);
    }
    function M(ae, Pe) {
      if (!ae.canDrag) {
        Pe.preventDefault();
        return;
      }
      s("drag-hit", ae.hit, Pe);
    }
    function j(ae) {
      ae.preventDefault();
    }
    function U(ae) {
      ae.preventDefault(), s("drop-inside");
    }
    const de = b([]);
    function ke() {
      try {
        const ae = localStorage.getItem(f_);
        if (!ae) return [];
        const Pe = JSON.parse(ae);
        return Array.isArray(Pe) ? Pe.filter((be) => typeof be == "string" && be.trim() !== "").slice(0, p_) : [];
      } catch {
        return [];
      }
    }
    function ie(ae) {
      de.value = ae.slice(0, p_);
      try {
        localStorage.setItem(f_, JSON.stringify(de.value));
      } catch {
      }
    }
    function ce(ae) {
      const Pe = ae.trim();
      if (!Pe) return;
      const be = de.value.filter((ze) => ze !== Pe);
      be.unshift(Pe), ie(be);
    }
    function X(ae) {
      ie(de.value.filter((Pe) => Pe !== ae)), h.value >= Y.value.length && (h.value = Math.max(0, Y.value.length - 1));
    }
    const Z = x(() => {
      const ae = p.value.trim(), Pe = [];
      ae && !de.value.includes(ae) && Pe.push({ kind: "save", id: `save:${ae}`, label: `${n("palette.save")}: ${ae}`, icon: "save-search", query: ae });
      const be = de.value.map((ze) => ({ s: ze, sc: k(ze, ae) })).filter((ze) => ze.sc >= 0 || !ae);
      for (const ze of be)
        Pe.push({ kind: "saved", id: `saved:${ze.s}`, label: ze.s, icon: "bookmark", query: ze.s });
      return Pe;
    }), Y = x(() => [
      ..._.value,
      ...w.value,
      ...W.value,
      ...Z.value,
      ...$.value
    ]), G = x(() => _.value.length), we = x(() => G.value + w.value.length), R = x(() => we.value + W.value.length), pe = x(() => R.value + Z.value.length);
    Qe(p, (ae) => {
      h.value = 0, I(ae.trim());
    });
    function Q(ae) {
      const Pe = Y.value.length;
      Pe && (h.value = (h.value + ae + Pe) % Pe, Jt(() => {
        var be, ze;
        (ze = (be = y.value) == null ? void 0 : be.querySelector(".is-active")) == null || ze.scrollIntoView({ block: "nearest" });
      }));
    }
    function q(ae) {
      const Pe = ae ?? Y.value[h.value];
      if (Pe) {
        if (Pe.kind === "saved") {
          p.value = Pe.query, Jt(() => {
            var be;
            return (be = v.value) == null ? void 0 : be.focus();
          });
          return;
        }
        if (Pe.kind === "save") {
          ce(Pe.query), Jt(() => {
            var be;
            return (be = v.value) == null ? void 0 : be.focus();
          });
          return;
        }
        if (s("close"), Pe.kind === "hit") {
          s("open-hit", Pe.hit);
          return;
        }
        if (Pe.kind === "file")
          s("open-node", Pe.node);
        else if (Pe.kind === "goto")
          s("navigate", Pe.path);
        else
          switch (Pe.command) {
            case "new-folder":
              s("new-folder");
              break;
            case "upload":
              s("upload");
              break;
            case "toggle-view":
              s("toggle-view");
              break;
            case "open-trash":
              s("open-trash");
              break;
            case "refresh":
              s("refresh");
              break;
            case "go-up":
              s("go-up");
              break;
            case "open-theme":
              s("open-theme");
              break;
            case "open-shortcut-settings":
              s("open-shortcut-settings");
              break;
            case "start-tour":
              s("start-tour");
              break;
            case "tab-new":
              s("tab-new");
              break;
            case "split-toggle":
              s("split-toggle");
              break;
          }
      }
    }
    function re(ae) {
      if (t.open)
        switch (ae.key) {
          case "ArrowDown":
            ae.preventDefault(), ae.stopPropagation(), Q(1);
            break;
          case "ArrowUp":
            ae.preventDefault(), ae.stopPropagation(), Q(-1);
            break;
          case "Enter":
            ae.preventDefault(), ae.stopPropagation(), q();
            break;
          case "Escape":
            ae.preventDefault(), ae.stopPropagation(), s("close");
            break;
        }
    }
    return Qe(
      () => t.open,
      (ae) => {
        ae ? (p.value = t.initialQuery ?? "", h.value = 0, C.value = [], E.value = !1, de.value = ke(), document.addEventListener("keydown", re, !0), Jt(() => {
          var Pe, be;
          (Pe = v.value) == null || Pe.focus(), (be = v.value) == null || be.select();
        })) : (z && clearTimeout(z), document.removeEventListener("keydown", re, !0));
      }
    ), Mt(() => {
      z && clearTimeout(z), document.removeEventListener("keydown", re, !0);
    }), (ae, Pe) => (u(), nt(us, { name: "fe-modal" }, {
      default: yt(() => [
        e.open ? (u(), d("div", {
          key: 0,
          class: "fe-modal__backdrop fe-cmdp__backdrop",
          role: "presentation",
          onClick: Pe[2] || (Pe[2] = (be) => s("close")),
          onDragenter: ft(j, ["stop"]),
          onDragover: ft(j, ["stop"]),
          onDragleave: Pe[3] || (Pe[3] = ft(() => {
          }, ["stop"])),
          onDrop: ft(U, ["stop"])
        }, [
          i("div", {
            class: "fe-cmdp",
            role: "dialog",
            "aria-modal": "true",
            "aria-label": r(n)("palette.placeholder"),
            onClick: Pe[1] || (Pe[1] = ft(() => {
            }, ["stop"]))
          }, [
            i("div", EH, [
              Pe[4] || (Pe[4] = i("svg", {
                class: "fe-cmdp__glyph",
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "1.5",
                "stroke-linecap": "round",
                "aria-hidden": "true"
              }, [
                i("circle", {
                  cx: "7",
                  cy: "7",
                  r: "4.5"
                }),
                i("path", { d: "m10.5 10.5 3.5 3.5" })
              ], -1)),
              dt(i("input", {
                ref_key: "inputEl",
                ref: v,
                "onUpdate:modelValue": Pe[0] || (Pe[0] = (be) => p.value = be),
                type: "text",
                class: "fe-cmdp__input",
                placeholder: r(n)("palette.placeholder"),
                autocomplete: "off",
                spellcheck: "false"
              }, null, 8, AH), [
                [St, p.value]
              ])
            ]),
            i("div", {
              ref_key: "listEl",
              ref: y,
              class: "fe-cmdp__list",
              role: "listbox"
            }, [
              (u(!0), d(he, null, We(_.value, (be, ze) => (u(), d("button", {
                key: be.id,
                type: "button",
                class: Re(["fe-cmdp__item", { "is-active": ze === h.value }]),
                role: "option",
                "aria-selected": ze === h.value,
                onMouseenter: (Ae) => h.value = ze,
                onClick: (Ae) => q(be)
              }, [
                i("span", {
                  class: "fe-cmdp__icon",
                  "aria-hidden": "true",
                  innerHTML: m(be)
                }, null, 8, MH),
                i("span", DH, [
                  i("bdi", null, f(be.label), 1)
                ])
              ], 42, zH))), 128)),
              w.value.length ? (u(), d(he, { key: 0 }, [
                i("div", PH, f(r(n)("palette.files")), 1),
                (u(!0), d(he, null, We(w.value, (be, ze) => (u(), d("button", {
                  key: be.id,
                  type: "button",
                  class: Re(["fe-cmdp__item", { "is-active": G.value + ze === h.value }]),
                  role: "option",
                  "aria-selected": G.value + ze === h.value,
                  onMouseenter: (Ae) => h.value = G.value + ze,
                  onClick: (Ae) => q(be)
                }, [
                  i("span", {
                    class: "fe-cmdp__icon",
                    "aria-hidden": "true",
                    innerHTML: m(be)
                  }, null, 8, LH),
                  i("span", IH, [
                    i("bdi", null, f(be.label), 1)
                  ])
                ], 42, OH))), 128))
              ], 64)) : T("", !0),
              W.value.length || E.value || A.value ? (u(), d(he, { key: 1 }, [
                i("div", RH, f(r(n)("palette.everywhere")), 1),
                E.value && !W.value.length ? (u(), d("div", NH, f(r(n)("palette.searching")), 1)) : A.value && !W.value.length ? (u(), d("div", BH, f(O.value || r(n)("palette.everywhere_failed")), 1)) : T("", !0),
                (u(!0), d(he, null, We(W.value, (be, ze) => {
                  var Ae;
                  return u(), d(he, {
                    key: be.id
                  }, [
                    be.groupHead ? (u(), d("div", {
                      key: 0,
                      class: "fe-cmdp__acct",
                      "data-testid": "palette-account-group",
                      "data-account": be.groupHead.id
                    }, [
                      i("span", {
                        class: "fe-cmdp__acct-dot",
                        "aria-hidden": "true",
                        style: Vt(be.groupHead.color ? { background: be.groupHead.color } : void 0)
                      }, null, 4),
                      i("span", UH, [
                        i("bdi", null, f(be.groupHead.label), 1)
                      ]),
                      be.groupHead.detail ? (u(), d("span", HH, [
                        i("bdi", null, f(be.groupHead.detail), 1)
                      ])) : T("", !0)
                    ], 8, FH)) : T("", !0),
                    i("div", {
                      class: Re(["fe-cmdp__item fe-cmdp__item--hit", { "is-active": we.value + ze === h.value }]),
                      role: "option",
                      tabindex: "-1",
                      "aria-selected": we.value + ze === h.value,
                      "data-account": (Ae = be.hit.account) == null ? void 0 : Ae.id,
                      draggable: be.canDrag ? "true" : "false",
                      onMouseenter: (Ce) => {
                        h.value = we.value + ze, K(be);
                      },
                      onPointerdown: (Ce) => K(be),
                      onClick: (Ce) => q(be),
                      onKeydown: ya(ft((Ce) => q(be), ["prevent"]), ["enter"]),
                      onDragstart: (Ce) => M(be, Ce)
                    }, [
                      i("span", {
                        class: "fe-cmdp__icon",
                        "aria-hidden": "true",
                        innerHTML: m(be)
                      }, null, 8, VH),
                      i("span", qH, [
                        i("span", jH, [
                          i("span", WH, [
                            i("bdi", null, f(be.label), 1)
                          ]),
                          be.inContent ? (u(), d("span", YH, f(r(n)("search.in_content")), 1)) : T("", !0)
                        ]),
                        be.crumb ? (u(), d("span", {
                          key: 0,
                          class: "fe-cmdp__crumb",
                          title: be.crumb
                        }, f(be.crumb), 9, GH)) : T("", !0),
                        be.snippet ? (u(), d("span", XH, [
                          (u(!0), d(he, null, We(r(xd)(be.snippet), (Ce, He) => (u(), d(he, { key: He }, [
                            Ce.match ? (u(), d("mark", JH, f(Ce.text), 1)) : (u(), d(he, { key: 1 }, [
                              $t(f(Ce.text), 1)
                            ], 64))
                          ], 64))), 128))
                        ])) : T("", !0)
                      ]),
                      be.canDownload ? (u(), d("button", {
                        key: 0,
                        type: "button",
                        class: "fe-cmdp__hitact",
                        "data-testid": "palette-hit-download",
                        title: r(n)("ctx.download"),
                        "aria-label": r(n)("ctx.download"),
                        draggable: "false",
                        onClick: ft((Ce) => N(be), ["stop"])
                      }, [
                        i("span", {
                          "aria-hidden": "true",
                          innerHTML: r(wt)("download")
                        }, null, 8, QH)
                      ], 8, ZH)) : T("", !0)
                    ], 42, KH)
                  ], 64);
                }), 128))
              ], 64)) : T("", !0),
              Z.value.length ? (u(), d(he, { key: 2 }, [
                i("div", e9, f(r(n)("palette.saved")), 1),
                (u(!0), d(he, null, We(Z.value, (be, ze) => (u(), d("div", {
                  key: be.id,
                  class: Re(["fe-cmdp__item fe-cmdp__item--saved", { "is-active": R.value + ze === h.value }]),
                  role: "option",
                  "aria-selected": R.value + ze === h.value,
                  tabindex: "-1",
                  onMouseenter: (Ae) => h.value = R.value + ze,
                  onClick: (Ae) => q(be),
                  onKeydown: ya(ft((Ae) => q(be), ["prevent"]), ["enter"])
                }, [
                  i("span", {
                    class: "fe-cmdp__icon",
                    "aria-hidden": "true",
                    innerHTML: m(be)
                  }, null, 8, a9),
                  i("span", n9, [
                    i("bdi", null, f(be.label), 1)
                  ]),
                  be.kind === "saved" ? (u(), d("button", {
                    key: 0,
                    type: "button",
                    class: "fe-cmdp__del",
                    title: r(n)("palette.saved.delete"),
                    "aria-label": r(n)("palette.saved.delete"),
                    onClick: ft((Ae) => X(be.query), ["stop"])
                  }, [
                    i("span", {
                      "aria-hidden": "true",
                      innerHTML: r(wt)("delete")
                    }, null, 8, o9)
                  ], 8, s9)) : T("", !0)
                ], 42, t9))), 128))
              ], 64)) : T("", !0),
              $.value.length ? (u(), d(he, { key: 3 }, [
                i("div", i9, f(r(n)("palette.commands")), 1),
                (u(!0), d(he, null, We($.value, (be, ze) => (u(), d("button", {
                  key: be.id,
                  type: "button",
                  class: Re(["fe-cmdp__item", { "is-active": pe.value + ze === h.value }]),
                  role: "option",
                  "aria-selected": pe.value + ze === h.value,
                  onMouseenter: (Ae) => h.value = pe.value + ze,
                  onClick: (Ae) => q(be)
                }, [
                  i("span", {
                    class: "fe-cmdp__icon",
                    "aria-hidden": "true",
                    innerHTML: m(be)
                  }, null, 8, l9),
                  i("span", u9, [
                    i("bdi", null, f(be.label), 1)
                  ])
                ], 42, r9))), 128))
              ], 64)) : T("", !0),
              Y.value.length === 0 && !E.value && !A.value ? (u(), d("div", c9, f(r(n)("palette.empty")), 1)) : T("", !0)
            ], 512),
            i("div", d9, f(r(n)("palette.hint")), 1)
          ], 8, CH)
        ], 32)) : T("", !0)
      ]),
      _: 1
    }));
  }
});
function m9(e = "") {
  return {
    text: "",
    tags: [],
    excludeTags: [],
    scope: "name",
    filters: { ...ho, pathBase: e }
  };
}
function v_(e, a) {
  const t = e.trim();
  if (!t) return "";
  const s = /\s/.test(t) ? `"${t}"` : t;
  return `${a ? "-" : ""}tag:${s}`;
}
function $d(e) {
  const a = [], t = e.text.trim();
  t && a.push(t);
  for (const s of e.tags) {
    const n = v_(s, !1);
    n && a.push(n);
  }
  for (const s of e.excludeTags) {
    const n = v_(s, !0);
    n && a.push(n);
  }
  return a.join(" ");
}
function y9(e) {
  return $d(e) === "";
}
function Bp(e) {
  return Hc(e, { newlines: !0 });
}
function Fp(e, a, t) {
  return typeof t == "boolean" ? t : e >= a;
}
const g9 = { class: "fe-advsearch__head" }, b9 = ["innerHTML"], _9 = { class: "fe-advsearch__head-text" }, k9 = { class: "fe-advsearch__head-title" }, w9 = { class: "fe-advsearch__head-sub" }, x9 = ["title", "aria-label"], $9 = ["innerHTML"], S9 = { class: "fe-advsearch__box" }, T9 = ["innerHTML"], C9 = ["placeholder", "aria-label"], E9 = ["aria-label"], A9 = ["aria-selected", "data-testid", "onClick"], z9 = ["innerHTML"], M9 = { class: "fe-advsearch__cols" }, D9 = { class: "fe-advsearch__col" }, P9 = { class: "fe-advsearch__group" }, O9 = { class: "fe-advsearch__field" }, L9 = { class: "fe-advsearch__label" }, I9 = ["value"], R9 = {
  key: 0,
  class: "fe-advsearch__field"
}, N9 = { class: "fe-advsearch__sublabel" }, B9 = { class: "fe-advsearch__pair" }, F9 = ["aria-label"], U9 = ["aria-label"], H9 = ["aria-pressed", "onClick"], K9 = { class: "fe-advsearch__field" }, V9 = { class: "fe-advsearch__label" }, q9 = ["value"], j9 = { class: "fe-advsearch__group" }, W9 = { class: "fe-advsearch__field" }, Y9 = { class: "fe-advsearch__label" }, G9 = ["disabled"], X9 = ["value"], J9 = {
  key: 0,
  class: "fe-advsearch__hint fe-advsearch__hint--block"
}, Z9 = { class: "fe-advsearch__group" }, Q9 = { class: "fe-advsearch__field" }, eK = { class: "fe-advsearch__label" }, tK = ["placeholder"], aK = { class: "fe-advsearch__field" }, nK = { class: "fe-advsearch__label" }, sK = ["placeholder"], oK = { class: "fe-advsearch__hint fe-advsearch__hint--block" }, iK = {
  key: 0,
  class: "fe-advsearch__tagpicks",
  "data-testid": "advsearch-known-tags"
}, rK = { class: "fe-advsearch__tagkind" }, lK = ["data-tag-kind", "title", "aria-label", "onClick"], uK = { class: "fe-advsearch__col" }, cK = { class: "fe-advsearch__group" }, dK = { class: "fe-advsearch__field" }, fK = { class: "fe-advsearch__label" }, pK = ["value"], vK = {
  key: 0,
  class: "fe-advsearch__field"
}, hK = { class: "fe-advsearch__sublabel" }, mK = { class: "fe-advsearch__pair" }, yK = ["placeholder", "aria-label"], gK = ["placeholder", "aria-label"], bK = ["aria-label"], _K = { value: "kb" }, kK = { value: "mb" }, wK = { value: "gb" }, xK = { class: "fe-advsearch__group" }, $K = { class: "fe-advsearch__label" }, SK = ["aria-label"], TK = ["aria-pressed", "data-testid", "onClick"], CK = { class: "fe-advsearch__hint" }, EK = { class: "fe-advsearch__group" }, AK = { class: "fe-advsearch__grouphead" }, zK = ["innerHTML"], MK = { class: "fe-advsearch__hint fe-advsearch__hint--block" }, DK = {
  class: "fe-advsearch__count",
  "data-testid": "advsearch-count"
}, PK = { class: "fe-advsearch__count-top" }, OK = { class: "fe-advsearch__count-line" }, LK = { key: 0 }, IK = { key: 1 }, RK = { key: 2 }, NK = { key: 3 }, BK = { class: "fe-advsearch__hint fe-advsearch__hint--block" }, FK = {
  key: 0,
  class: "fe-advsearch__wire"
}, UK = ["innerHTML"], HK = ["disabled"], KK = ["innerHTML"], VK = /* @__PURE__ */ rt({
  __name: "AdvancedSearch",
  props: {
    open: { type: Boolean },
    locale: {},
    theme: {},
    initialQuery: {},
    folderLabel: {},
    pathBase: {},
    contentSearch: { type: Boolean },
    count: { type: Function },
    knownTags: {}
  },
  emits: ["close", "submit"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n } = gt(() => t.locale), o = b(null), p = b(""), h = b("name"), v = b(""), y = x(
      () => ["personal", "team"].map((J) => ({ kind: J, list: (t.knownTags ?? []).filter((me) => me.kind === J) })).filter((J) => J.list.length > 0)
    );
    function g(J) {
      const me = Bp(v.value);
      me.some((fe) => sd(fe) === sd(J)) || (v.value = [...me, J].join(", "));
    }
    const m = b(""), k = b("any"), _ = b("any"), w = b(""), $ = b("d1"), C = b("any"), E = b("any"), A = b(""), O = b(""), z = b("mb"), P = b("any"), I = [
      "any",
      "folder",
      "document",
      "spreadsheet",
      "presentation",
      "pdf",
      "image",
      "video",
      "audio",
      "archive",
      "code"
    ], F = ["any", "today", "7d", "30d", "year", "around"], W = ["any", "lt1", "1to10", "10to100", "gt100", "range"], N = ["h1", "d1", "w1"], K = {
      kb: 1024,
      mb: 1024 ** 2,
      gb: 1024 ** 3
    }, M = x(
      () => t.contentSearch ? ["all", "content", "name"] : ["name"]
    ), j = {
      all: "search",
      content: "preview",
      name: "copy-path"
    }, U = ["any", "here", "skip"], de = ["any", "me", "system"], ke = x(() => h.value === "name");
    Qe(ke, (J) => {
      J || (C.value = "any");
    });
    function ie() {
      p.value = "", h.value = "name", v.value = "", m.value = "", k.value = "any", _.value = "any", w.value = "", $.value = "d1", E.value = "any", A.value = "", O.value = "", z.value = "mb", P.value = "any", C.value = "any";
    }
    function ce() {
      return {
        text: p.value,
        scope: h.value,
        tagsRaw: v.value,
        excludeRaw: m.value,
        type: k.value,
        modified: _.value,
        aroundDate: w.value,
        aroundSpan: $.value,
        size: E.value,
        sizeFrom: A.value,
        sizeTo: O.value,
        sizeUnit: z.value,
        pathMode: P.value,
        people: C.value
      };
    }
    function X(J) {
      p.value = J.text, h.value = J.scope, v.value = J.tagsRaw, m.value = J.excludeRaw, k.value = J.type, _.value = J.modified, w.value = J.aroundDate, $.value = J.aroundSpan, E.value = J.size, A.value = J.sizeFrom, O.value = J.sizeTo, z.value = J.sizeUnit, P.value = J.pathMode, C.value = J.people;
    }
    let Z = null;
    Qe(
      () => t.open,
      (J) => {
        if (!J) return;
        const me = t.initialQuery ?? "";
        Z && Z.query !== "" && Z.query === me ? X(Z.form) : (ie(), p.value = me), pe.value = null, q.value = !1, setTimeout(() => {
          var fe;
          return (fe = o.value) == null ? void 0 : fe.focus();
        }, 60);
      }
    );
    function Y(J) {
      const me = String(J ?? "").trim();
      if (!me) return null;
      const fe = Number(me);
      return !Number.isFinite(fe) || fe < 0 ? null : Math.round(fe * K[z.value]);
    }
    const G = x(() => ({
      ...m9(t.pathBase ?? ""),
      text: p.value,
      tags: Bp(v.value),
      excludeTags: Bp(m.value),
      scope: h.value,
      filters: {
        ...ho,
        type: k.value,
        modified: _.value,
        aroundDate: w.value,
        aroundSpan: $.value,
        size: E.value,
        sizeMin: E.value === "range" ? Y(A.value) : null,
        sizeMax: E.value === "range" ? Y(O.value) : null,
        pathMode: P.value,
        pathBase: t.pathBase ?? "",
        /* ⚠ Read through the guard, not off the ref. The `ownerFilterable` watch
           below already clears the choice when the scope leaves `name`, so this is
           the SECOND lock, not the first: a disabled select cannot be changed but
           it can still hold a value chosen before the scope moved, and a filter
           that outlives its own control narrows a search nobody asked it to. The
           two are worth keeping apart — one is what the user sees change, the
           other is what actually reaches the predicate. */
        people: ke.value ? C.value : "any"
      }
    })), we = x(() => y9(G.value)), R = x(() => $d(G.value)), pe = b(null), Q = b(!1), q = b(!1), re = x(() => {
      var J;
      return [
        ...de.map((me) => ({ value: me })),
        ...((J = pe.value) == null ? void 0 : J.people) ?? []
      ];
    });
    function ae(J) {
      return J.value === "any" || J.value === "me" || J.value === "system" ? n(`filter.people.${J.value}`) : J.name || n("filter.people.someone");
    }
    Qe(re, (J) => {
      J.some((me) => me.value === C.value) || (C.value = "any");
    });
    let Pe = null, be = 0;
    function ze() {
      if (Pe && clearTimeout(Pe), q.value = !1, we.value) {
        pe.value = null, Q.value = !1;
        return;
      }
      Q.value = !0, Pe = setTimeout(Ae, 450);
    }
    async function Ae() {
      const J = ++be, me = G.value;
      try {
        const fe = await t.count(me);
        if (J !== be) return;
        pe.value = fe;
      } catch {
        if (J !== be) return;
        pe.value = null, q.value = !0;
      } finally {
        J === be && (Q.value = !1);
      }
    }
    Qe(
      () => {
        if (!t.open) return "";
        try {
          return JSON.stringify(G.value);
        } catch {
          return "ERR";
        }
      },
      (J) => {
        if (J) {
          if (J === "ERR") {
            Pe && clearTimeout(Pe), be++, pe.value = null, Q.value = !1, q.value = !0;
            return;
          }
          ze();
        }
      }
    ), Mt(() => {
      Pe && clearTimeout(Pe);
    });
    const Ce = x(() => {
      const J = pe.value;
      return J ? n(J.capped ? "advsearch.count.capped" : "advsearch.count.result", { n: String(J.count) }) : "";
    });
    function He() {
      we.value || (Z = { query: R.value, form: ce() }, s("submit", G.value));
    }
    return (J, me) => (u(), nt(la, {
      open: e.open,
      title: r(n)("advsearch.title"),
      size: "lg",
      theme: e.theme,
      onClose: me[13] || (me[13] = (fe) => s("close"))
    }, {
      actions: yt(() => [
        i("button", {
          type: "button",
          class: "fe-btn fe-advsearch__reset",
          onClick: ie
        }, [
          i("span", {
            class: "fe-advsearch__btn-icon",
            "aria-hidden": "true",
            innerHTML: r(wt)("refresh")
          }, null, 8, UK),
          $t(" " + f(r(n)("advsearch.reset")), 1)
        ]),
        i("button", {
          type: "button",
          class: "fe-btn",
          onClick: me[12] || (me[12] = (fe) => s("close"))
        }, f(r(n)("advsearch.cancel")), 1),
        i("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: we.value,
          "data-testid": "advsearch-submit",
          onClick: He
        }, [
          i("span", {
            class: "fe-advsearch__btn-icon",
            "aria-hidden": "true",
            innerHTML: r(wt)("search")
          }, null, 8, KK),
          $t(" " + f(r(n)("advsearch.submit")), 1)
        ], 8, HK)
      ]),
      default: yt(() => [
        i("form", {
          class: "fe-advsearch",
          onSubmit: ft(He, ["prevent"])
        }, [
          i("header", g9, [
            i("span", {
              class: "fe-advsearch__head-icon",
              "aria-hidden": "true",
              innerHTML: r(wt)("search")
            }, null, 8, b9),
            i("div", _9, [
              i("p", k9, f(r(n)("advsearch.title")), 1),
              i("p", w9, f(r(n)("advsearch.subtitle")), 1)
            ]),
            i("button", {
              type: "button",
              class: "fe-advsearch__head-close",
              title: r(n)("advsearch.close"),
              "aria-label": r(n)("advsearch.close"),
              onClick: me[0] || (me[0] = (fe) => s("close"))
            }, [
              i("span", {
                "aria-hidden": "true",
                innerHTML: r(wt)("close")
              }, null, 8, $9)
            ], 8, x9)
          ]),
          i("label", S9, [
            i("span", {
              class: "fe-advsearch__glass",
              "aria-hidden": "true",
              innerHTML: r(wt)("search")
            }, null, 8, T9),
            dt(i("input", {
              ref_key: "queryEl",
              ref: o,
              "onUpdate:modelValue": me[1] || (me[1] = (fe) => p.value = fe),
              type: "search",
              class: "fe-advsearch__input",
              placeholder: r(n)("advsearch.query.placeholder"),
              "aria-label": r(n)("advsearch.query.label"),
              "data-testid": "advsearch-query"
            }, null, 8, C9), [
              [St, p.value]
            ])
          ]),
          i("div", {
            class: "fe-advsearch__seg fe-advsearch__seg--tabs",
            role: "tablist",
            "aria-label": r(n)("advsearch.scope.label")
          }, [
            (u(!0), d(he, null, We(M.value, (fe) => (u(), d("button", {
              key: fe,
              type: "button",
              role: "tab",
              class: Re(["fe-advsearch__seg-btn", { "is-active": h.value === fe }]),
              "aria-selected": h.value === fe,
              "data-testid": `advsearch-scope-${fe}`,
              onClick: (xe) => h.value = fe
            }, [
              i("span", {
                class: "fe-advsearch__seg-icon",
                "aria-hidden": "true",
                innerHTML: r(wt)(j[fe])
              }, null, 8, z9),
              $t(" " + f(r(n)(`advsearch.scope.${fe}`)), 1)
            ], 10, A9))), 128))
          ], 8, E9),
          i("div", M9, [
            i("div", D9, [
              i("div", P9, [
                i("label", O9, [
                  i("span", L9, f(r(n)("filter.modified")), 1),
                  dt(i("select", {
                    "onUpdate:modelValue": me[2] || (me[2] = (fe) => _.value = fe),
                    class: "fe-input",
                    "data-testid": "advsearch-modified"
                  }, [
                    (u(), d(he, null, We(F, (fe) => i("option", {
                      key: fe,
                      value: fe
                    }, f(r(n)(`filter.modified.${fe}`)), 9, I9)), 64))
                  ], 512), [
                    [Xa, _.value]
                  ])
                ]),
                _.value === "around" ? (u(), d("div", R9, [
                  i("span", N9, f(r(n)("advsearch.around.label")), 1),
                  i("div", B9, [
                    dt(i("input", {
                      "onUpdate:modelValue": me[3] || (me[3] = (fe) => w.value = fe),
                      type: "datetime-local",
                      class: "fe-input",
                      "aria-label": r(n)("advsearch.around.date"),
                      "data-testid": "advsearch-around-date"
                    }, null, 8, F9), [
                      [St, w.value]
                    ]),
                    i("div", {
                      class: "fe-advsearch__seg",
                      role: "group",
                      "aria-label": r(n)("advsearch.around.label")
                    }, [
                      (u(), d(he, null, We(N, (fe) => i("button", {
                        key: fe,
                        type: "button",
                        class: Re(["fe-advsearch__seg-btn", { "is-active": $.value === fe }]),
                        "aria-pressed": $.value === fe,
                        onClick: (xe) => $.value = fe
                      }, f(r(n)(`advsearch.around.${fe}`)), 11, H9)), 64))
                    ], 8, U9)
                  ])
                ])) : T("", !0)
              ]),
              i("label", K9, [
                i("span", V9, f(r(n)("filter.type")), 1),
                dt(i("select", {
                  "onUpdate:modelValue": me[4] || (me[4] = (fe) => k.value = fe),
                  class: "fe-input",
                  "data-testid": "advsearch-type"
                }, [
                  (u(), d(he, null, We(I, (fe) => i("option", {
                    key: fe,
                    value: fe
                  }, f(r(n)(`filter.type.${fe}`)), 9, q9)), 64))
                ], 512), [
                  [Xa, k.value]
                ])
              ]),
              i("div", j9, [
                i("label", W9, [
                  i("span", Y9, f(r(n)("filter.people")), 1),
                  dt(i("select", {
                    "onUpdate:modelValue": me[5] || (me[5] = (fe) => C.value = fe),
                    class: "fe-input",
                    disabled: !ke.value,
                    "data-testid": "advsearch-people"
                  }, [
                    (u(!0), d(he, null, We(re.value, (fe) => (u(), d("option", {
                      key: fe.value,
                      value: fe.value
                    }, f(ae(fe)), 9, X9))), 128))
                  ], 8, G9), [
                    [Xa, C.value]
                  ])
                ]),
                ke.value ? T("", !0) : (u(), d("p", J9, f(r(n)("advsearch.people.name_only")), 1))
              ]),
              i("div", Z9, [
                i("label", Q9, [
                  i("span", eK, f(r(n)("advsearch.tags.label")), 1),
                  dt(i("input", {
                    "onUpdate:modelValue": me[6] || (me[6] = (fe) => v.value = fe),
                    type: "text",
                    class: "fe-input",
                    placeholder: r(n)("advsearch.tags.placeholder"),
                    "data-testid": "advsearch-tags"
                  }, null, 8, tK), [
                    [St, v.value]
                  ])
                ]),
                i("label", aK, [
                  i("span", nK, f(r(n)("advsearch.tags.exclude")), 1),
                  dt(i("input", {
                    "onUpdate:modelValue": me[7] || (me[7] = (fe) => m.value = fe),
                    type: "text",
                    class: "fe-input",
                    placeholder: r(n)("advsearch.tags.exclude_placeholder"),
                    "data-testid": "advsearch-extags"
                  }, null, 8, sK), [
                    [St, m.value]
                  ])
                ]),
                i("p", oK, f(r(n)("advsearch.tags.hint")), 1),
                y.value.length ? (u(), d("div", iK, [
                  (u(!0), d(he, null, We(y.value, (fe) => (u(), d(he, {
                    key: fe.kind
                  }, [
                    i("span", rK, [
                      ot(Xl, {
                        kind: fe.kind
                      }, null, 8, ["kind"]),
                      $t(" " + f(r(n)(`tags.kind.${fe.kind}`)), 1)
                    ]),
                    (u(!0), d(he, null, We(fe.list, (xe) => (u(), d("button", {
                      key: `${fe.kind}:${xe.name}`,
                      type: "button",
                      class: "fe-advsearch__tagpick",
                      "data-tag-kind": fe.kind,
                      title: r(n)(`tags.chip.${fe.kind}`, { tag: xe.name }),
                      "aria-label": r(n)(`tags.chip.${fe.kind}`, { tag: xe.name }),
                      onClick: (ye) => g(xe.name)
                    }, [
                      ot(Xl, {
                        kind: fe.kind
                      }, null, 8, ["kind"]),
                      $t(" " + f(xe.name), 1)
                    ], 8, lK))), 128))
                  ], 64))), 128))
                ])) : T("", !0)
              ])
            ]),
            i("div", uK, [
              i("div", cK, [
                i("label", dK, [
                  i("span", fK, f(r(n)("filter.size")), 1),
                  dt(i("select", {
                    "onUpdate:modelValue": me[8] || (me[8] = (fe) => E.value = fe),
                    class: "fe-input",
                    "data-testid": "advsearch-size"
                  }, [
                    (u(), d(he, null, We(W, (fe) => i("option", {
                      key: fe,
                      value: fe
                    }, f(r(n)(`filter.size.${fe}`)), 9, pK)), 64))
                  ], 512), [
                    [Xa, E.value]
                  ])
                ]),
                E.value === "range" ? (u(), d("div", vK, [
                  i("span", hK, f(r(n)("advsearch.size.range_label")), 1),
                  i("div", mK, [
                    dt(i("input", {
                      "onUpdate:modelValue": me[9] || (me[9] = (fe) => A.value = fe),
                      type: "number",
                      min: "0",
                      class: "fe-input fe-advsearch__num",
                      placeholder: r(n)("advsearch.size.from"),
                      "aria-label": r(n)("advsearch.size.from"),
                      "data-testid": "advsearch-size-from"
                    }, null, 8, yK), [
                      [St, A.value]
                    ]),
                    me[14] || (me[14] = i("span", {
                      class: "fe-advsearch__dash",
                      "aria-hidden": "true"
                    }, "–", -1)),
                    dt(i("input", {
                      "onUpdate:modelValue": me[10] || (me[10] = (fe) => O.value = fe),
                      type: "number",
                      min: "0",
                      class: "fe-input fe-advsearch__num",
                      placeholder: r(n)("advsearch.size.to"),
                      "aria-label": r(n)("advsearch.size.to"),
                      "data-testid": "advsearch-size-to"
                    }, null, 8, gK), [
                      [St, O.value]
                    ]),
                    dt(i("select", {
                      "onUpdate:modelValue": me[11] || (me[11] = (fe) => z.value = fe),
                      class: "fe-input fe-advsearch__unit",
                      "aria-label": r(n)("filter.size")
                    }, [
                      i("option", _K, f(r(n)("unit.kb")), 1),
                      i("option", kK, f(r(n)("unit.mb")), 1),
                      i("option", wK, f(r(n)("unit.gb")), 1)
                    ], 8, bK), [
                      [Xa, z.value]
                    ])
                  ])
                ])) : T("", !0)
              ]),
              i("div", xK, [
                i("span", $K, f(r(n)("advsearch.where.label")), 1),
                i("div", {
                  class: "fe-advsearch__seg fe-advsearch__seg--wide",
                  role: "group",
                  "aria-label": r(n)("advsearch.where.label"),
                  "data-testid": "advsearch-where"
                }, [
                  (u(), d(he, null, We(U, (fe) => i("button", {
                    key: fe,
                    type: "button",
                    class: Re(["fe-advsearch__seg-btn", { "is-active": P.value === fe }]),
                    "aria-pressed": P.value === fe,
                    "data-testid": `advsearch-where-${fe}`,
                    onClick: (xe) => P.value = fe
                  }, f(r(n)(`advsearch.where.${fe}_short`)), 11, TK)), 64))
                ], 8, SK),
                i("span", CK, f(r(n)(`advsearch.where.${P.value}`, { folder: e.folderLabel || "" })), 1)
              ]),
              i("div", EK, [
                i("p", AK, [
                  i("span", {
                    class: "fe-advsearch__grouphead-icon",
                    "aria-hidden": "true",
                    innerHTML: r(wt)("preview")
                  }, null, 8, zK),
                  $t(" " + f(r(n)("advsearch.content.heading")), 1)
                ]),
                i("p", MK, f(e.contentSearch ? r(n)("advsearch.scope.hint") : r(n)("advsearch.scope.name_only")), 1)
              ])
            ])
          ]),
          i("div", DK, [
            i("div", PK, [
              i("p", OK, [
                we.value ? (u(), d("span", LK, f(r(n)("advsearch.count.idle")), 1)) : Q.value ? (u(), d("span", IK, f(r(n)("advsearch.count.counting")), 1)) : q.value ? (u(), d("span", RK, f(r(n)("advsearch.count.error")), 1)) : pe.value ? (u(), d("strong", NK, f(Ce.value), 1)) : T("", !0)
              ]),
              we.value ? T("", !0) : (u(), d("button", {
                key: 0,
                type: "button",
                class: "fe-advsearch__viewall",
                "data-testid": "advsearch-viewall",
                onClick: He
              }, f(r(n)("advsearch.viewall")), 1))
            ]),
            i("p", BK, f(r(n)("advsearch.count.cost")), 1),
            R.value ? (u(), d("p", FK, [
              $t(f(r(n)("advsearch.wire")) + " ", 1),
              i("code", null, f(R.value), 1)
            ])) : T("", !0)
          ])
        ], 32)
      ]),
      _: 1
    }, 8, ["open", "title", "theme"]));
  }
}), qK = { class: "fe-shortcuts" }, jK = { class: "fe-shortcuts__heading" }, WK = { class: "fe-shortcuts__table" }, YK = { class: "fe-shortcuts__keys" }, GK = {
  key: 0,
  class: "fe-shortcuts__unbound"
}, XK = { class: "fe-kbd" }, JK = {
  key: 0,
  class: "fe-shortcuts__or",
  "aria-hidden": "true"
}, ZK = { class: "fe-shortcuts__desc" }, QK = ["title"], e7 = ["innerHTML"], t7 = /* @__PURE__ */ rt({
  __name: "ShortcutsHelp",
  props: {
    open: { type: Boolean },
    locale: {}
  },
  emits: ["close", "customize"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n } = gt(() => t.locale), o = Qk(), p = x(() => {
      const h = [], v = /* @__PURE__ */ new Map();
      for (const y of o.value)
        v.has(y.groupKey) || (v.set(y.groupKey, []), h.push(y.groupKey)), v.get(y.groupKey).push(y);
      return h.map((y) => ({ key: y, items: v.get(y) }));
    });
    return (h, v) => (u(), nt(la, {
      open: e.open,
      title: r(n)("shortcuts.title"),
      size: "md",
      onClose: v[2] || (v[2] = (y) => s("close"))
    }, {
      actions: yt(() => [
        i("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          onClick: v[0] || (v[0] = (y) => s("customize"))
        }, [
          i("span", {
            class: "fe-icon",
            "aria-hidden": "true",
            innerHTML: r(wt)("shortcut-settings")
          }, null, 8, e7),
          $t(" " + f(r(n)("shortcuts.customize")), 1)
        ]),
        i("button", {
          type: "button",
          class: "fe-btn",
          onClick: v[1] || (v[1] = (y) => s("close"))
        }, f(r(n)("viewer.close")), 1)
      ]),
      default: yt(() => [
        i("div", qK, [
          (u(!0), d(he, null, We(p.value, (y) => (u(), d("section", {
            key: y.key,
            class: "fe-shortcuts__group"
          }, [
            i("h3", jK, f(r(n)(y.key)), 1),
            i("div", WK, [
              (u(!0), d(he, null, We(y.items, (g) => (u(), d("div", {
                key: g.id,
                class: "fe-shortcuts__row"
              }, [
                i("span", YK, [
                  g.keys.length === 0 ? (u(), d("span", GK, f(r(n)("shortcuts.settings.unbound")), 1)) : (u(!0), d(he, { key: 1 }, We(g.keys, (m, k) => (u(), d(he, { key: m }, [
                    i("kbd", XK, f(m), 1),
                    k < g.keys.length - 1 ? (u(), d("span", JK, "/")) : T("", !0)
                  ], 64))), 128))
                ]),
                i("span", ZK, [
                  $t(f(r(n)(g.labelKey)) + " ", 1),
                  g.overridden ? (u(), d("span", {
                    key: 0,
                    class: "fe-shortcuts__custom",
                    title: r(n)("shortcuts.settings.customized")
                  }, "●", 8, QK)) : T("", !0)
                ])
              ]))), 128))
            ])
          ]))), 128))
        ])
      ]),
      _: 1
    }, 8, ["open", "title"]));
  }
});
function C0(e) {
  return !e || typeof e != "object" || e.complete === !0 ? null : e;
}
function a7(e) {
  const a = Math.max(0, e.catalogued_folders ?? 0), t = Math.max(0, e.pending_folders ?? 0);
  if (a + t === 0) return 0;
  const s = Math.floor(a * 100 / (a + t));
  return t > 0 ? Math.min(s, 99) : s;
}
function n7(e) {
  switch (e.reason) {
    case "lazy_on_open":
      return { key: "coverage.lazy_on_open", vars: {} };
    case "lazy_filling":
      return { key: "coverage.lazy_filling", vars: { pct: a7(e) } };
    default:
      return { key: "coverage.first_scan", vars: {} };
  }
}
function s7(e) {
  const a = {};
  if (!Array.isArray(e)) return a;
  for (const t of e)
    !t || typeof t.name != "string" || t.name === "" || (a[t.name] = C0(t.coverage ?? null));
  return a;
}
function o7(e) {
  const { map: a, adapter: t, searching: s, crossStorage: n, admin: o } = e;
  if (s && n) {
    const h = Object.keys(a).filter((v) => a[v] !== null).sort((v, y) => v.localeCompare(y));
    return h.length === 0 ? null : h.length === 1 ? h_(h[0], a[h[0]], o) : { key: "coverage.search_some", vars: { names: h.join(", ") }, offerCatalogAll: !1 };
  }
  const p = a[t];
  return p ? h_(t, p, o) : null;
}
function h_(e, a, t) {
  const s = n7(a);
  return { key: s.key, vars: s.vars, storage: e, offerCatalogAll: t && a.reason === "lazy_on_open" };
}
function jc(e) {
  return typeof e == "number" && Number.isFinite(e) && e >= 0 ? e : null;
}
function E0(e) {
  return !!e && !e.unlimited && e.quota_bytes > 0;
}
function i7(e, a) {
  return !e || E0(e) ? !1 : a.length === 0 || a.some((t) => jc(t.usedBytes) === null);
}
function r7(e, a, t) {
  if (!e) return null;
  if (E0(e))
    return { used: jc(e.used_bytes) ?? 0, total: e.quota_bytes, unlimited: !1, partial: !1 };
  const s = /* @__PURE__ */ new Map();
  for (const y of t ?? []) y && typeof y.name == "string" && s.set(y.name, y);
  const n = a.length ? a : [...s.keys()].map((y) => ({ name: y }));
  let o = 0, p = 0, h = !1;
  const v = /* @__PURE__ */ new Set();
  for (const y of n) {
    if (v.has(y.name)) continue;
    v.add(y.name);
    const g = jc(y.usedBytes), m = g === null ? s.get(y.name) : void 0, k = g ?? jc(m == null ? void 0 : m.used_bytes);
    if (k === null) {
      h = !0;
      continue;
    }
    o += k, p++, (g !== null ? y.usedPartial === !0 : C0(m == null ? void 0 : m.coverage) !== null) && (h = !0);
  }
  return !p || o <= 0 ? null : { used: o, total: 0, unlimited: !0, partial: h };
}
const l7 = "custom:", Sd = "filex.palette", m_ = "filex.theme", _n = "default", A0 = [
  {
    // Stock palette — the maps duplicate variables.css ONLY for the
    // gallery preview; applying this theme clears all overrides.
    id: _n,
    nameKey: "theme.name.default",
    light: {
      /* ⚠ Mirrors styles/variables.css exactly — web/tests/api/themeContrast.test.ts
       * fails on any drift. It has drifted before: the stock primary was
       * darkened for contrast and this preview map kept the old blue, so the
       * gallery card advertised a colour the product no longer used. */
      "--fe-bg": "#ffffff",
      "--fe-bg-elev": "#f7f8fb",
      "--fe-bg-hover": "#f3f4f6",
      "--fe-bg-selected": "#eef3ff",
      "--fe-border": "#e5e7eb",
      "--fe-border-soft": "#eef0f4",
      "--fe-border-strong": "#d1d5db",
      "--fe-text": "#1f2937",
      "--fe-text-muted": "#6b7280",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#2f6ceb",
      "--fe-primary-hover": "#2559c9",
      "--fe-primary-soft": "#e6ecfa",
      "--fe-primary-ink": "#2559c9",
      "--fe-danger": "#dc2626",
      "--fe-danger-hover": "#b91c1c"
    },
    dark: {
      "--fe-bg": "#15171c",
      "--fe-bg-elev": "#1a1d23",
      "--fe-bg-hover": "#1f232a",
      "--fe-bg-selected": "#1c2740",
      "--fe-border": "#2e333c",
      "--fe-border-soft": "#262a32",
      "--fe-border-strong": "#3d444f",
      "--fe-text": "#e6e8ec",
      "--fe-text-muted": "#888f9b",
      /* Dark ink, not white: white on the button measures 3.16 against the 4.5
       * this file claims. Mirrors styles/variables.css. */
      "--fe-text-on-primary": "#15171c",
      "--fe-primary": "#5b8cff",
      "--fe-primary-hover": "#7ba3ff",
      "--fe-primary-soft": "#1c2740",
      "--fe-primary-ink": "#7ba3ff",
      "--fe-danger": "#f87171",
      "--fe-danger-hover": "#ef4444"
    }
  },
  {
    // Night Blue — deep indigo/navy.
    id: "night",
    nameKey: "theme.name.night",
    light: {
      "--fe-bg": "#f6f8fd",
      "--fe-bg-elev": "#edf1fa",
      "--fe-bg-hover": "#e2e9f7",
      "--fe-bg-selected": "#d2ddf4",
      "--fe-border": "#d6deee",
      "--fe-border-soft": "#e3e8f4",
      "--fe-border-strong": "#aebfda",
      "--fe-text": "#151f38",
      "--fe-text-muted": "#49587a",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#2c4a9e",
      "--fe-primary-hover": "#213a80",
      "--fe-primary-soft": "#e0e6f4",
      "--fe-primary-ink": "#213a80",
      "--fe-danger": "#c62828",
      "--fe-danger-hover": "#a51f1f"
    },
    dark: {
      "--fe-bg": "#0a1024",
      "--fe-bg-elev": "#111a35",
      "--fe-bg-hover": "#1a2547",
      "--fe-bg-selected": "#243665",
      "--fe-border": "#26335a",
      "--fe-border-soft": "#1d2748",
      "--fe-border-strong": "#3c4e84",
      "--fe-text": "#dfe6f7",
      "--fe-text-muted": "#96a5cc",
      "--fe-text-on-primary": "#050b26",
      "--fe-primary": "#6d8dfc",
      "--fe-primary-hover": "#5273f2",
      "--fe-primary-soft": "#182243",
      "--fe-primary-ink": "#6d8dfc",
      "--fe-danger": "#f87171",
      "--fe-danger-hover": "#ef4444"
    }
  },
  {
    // Forest — calm greens.
    id: "forest",
    nameKey: "theme.name.forest",
    light: {
      "--fe-bg": "#f5faf5",
      "--fe-bg-elev": "#eaf3eb",
      "--fe-bg-hover": "#dcecdf",
      "--fe-bg-selected": "#c8e2ce",
      "--fe-border": "#d2e2d4",
      "--fe-border-soft": "#e0ece1",
      "--fe-border-strong": "#a2c3a8",
      "--fe-text": "#182b1d",
      "--fe-text-muted": "#42604a",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#2b7a41",
      "--fe-primary-hover": "#226334",
      "--fe-primary-soft": "#dbe9dc",
      "--fe-primary-ink": "#226334",
      "--fe-danger": "#c62828",
      "--fe-danger-hover": "#a51f1f"
    },
    dark: {
      "--fe-bg": "#0d1611",
      "--fe-bg-elev": "#132019",
      "--fe-bg-hover": "#1b2d23",
      "--fe-bg-selected": "#264532",
      "--fe-border": "#28402f",
      "--fe-border-soft": "#1f3225",
      "--fe-border-strong": "#3e5f49",
      "--fe-text": "#dcebe0",
      "--fe-text-muted": "#93b09b",
      "--fe-text-on-primary": "#04180b",
      "--fe-primary": "#54c17a",
      "--fe-primary-hover": "#3fae66",
      "--fe-primary-soft": "#16291d",
      "--fe-primary-ink": "#54c17a",
      "--fe-danger": "#f87171",
      "--fe-danger-hover": "#ef4444"
    }
  },
  {
    // Amber — warm amber/bronze.
    id: "amber",
    nameKey: "theme.name.amber",
    light: {
      "--fe-bg": "#fdf9f0",
      "--fe-bg-elev": "#f7efdd",
      "--fe-bg-hover": "#f0e3c8",
      "--fe-bg-selected": "#ead6ab",
      "--fe-border": "#e6dabf",
      "--fe-border-soft": "#efe6d3",
      "--fe-border-strong": "#c6b184",
      "--fe-text": "#33270f",
      "--fe-text-muted": "#655631",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#9a4b00",
      "--fe-primary-hover": "#7c3c00",
      "--fe-primary-soft": "#f3e5d7",
      "--fe-primary-ink": "#7c3c00",
      "--fe-danger": "#c62828",
      "--fe-danger-hover": "#a51f1f"
    },
    dark: {
      "--fe-bg": "#191307",
      "--fe-bg-elev": "#231a0c",
      "--fe-bg-hover": "#2f2312",
      "--fe-bg-selected": "#44331b",
      "--fe-border": "#3b2e17",
      "--fe-border-soft": "#302512",
      "--fe-border-strong": "#5b4a29",
      "--fe-text": "#f2e7d4",
      "--fe-text-muted": "#bda887",
      "--fe-text-on-primary": "#2a1c02",
      "--fe-primary": "#f5a524",
      "--fe-primary-hover": "#ffb84d",
      "--fe-primary-soft": "#31230c",
      "--fe-primary-ink": "#ffb84d",
      "--fe-danger": "#f87171",
      "--fe-danger-hover": "#ef4444"
    }
  },
  {
    // Lilac — soft purple.
    id: "lilac",
    nameKey: "theme.name.lilac",
    light: {
      "--fe-bg": "#faf7fd",
      "--fe-bg-elev": "#f2ecfa",
      "--fe-bg-hover": "#e8ddf5",
      "--fe-bg-selected": "#dccaf0",
      "--fe-border": "#e1d6ee",
      "--fe-border-soft": "#ebe3f4",
      "--fe-border-strong": "#bda6d9",
      "--fe-text": "#241a33",
      "--fe-text-muted": "#584871",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#7231e0",
      "--fe-primary-hover": "#5f21c4",
      "--fe-primary-soft": "#e9e3fc",
      "--fe-primary-ink": "#5f21c4",
      "--fe-danger": "#c62828",
      "--fe-danger-hover": "#a51f1f"
    },
    dark: {
      "--fe-bg": "#130f1c",
      "--fe-bg-elev": "#1b1527",
      "--fe-bg-hover": "#261d37",
      "--fe-bg-selected": "#37294f",
      "--fe-border": "#302546",
      "--fe-border-soft": "#261e38",
      "--fe-border-strong": "#4b3a6d",
      "--fe-text": "#e9e2f5",
      "--fe-text-muted": "#a999c5",
      "--fe-text-on-primary": "#180d33",
      "--fe-primary": "#b197fa",
      "--fe-primary-hover": "#9c7cf4",
      "--fe-primary-soft": "#272038",
      "--fe-primary-ink": "#b197fa",
      "--fe-danger": "#f87171",
      "--fe-danger-hover": "#ef4444"
    }
  },
  {
    // High Contrast — black/white with strong borders, saturated accents.
    id: "contrast",
    nameKey: "theme.name.contrast",
    light: {
      "--fe-bg": "#ffffff",
      "--fe-bg-elev": "#f2f2f2",
      "--fe-bg-hover": "#e0e0e0",
      "--fe-bg-selected": "#c9dcff",
      "--fe-border": "#5c5c5c",
      "--fe-border-soft": "#5c5c5c",
      "--fe-border-strong": "#000000",
      "--fe-text": "#000000",
      "--fe-text-muted": "#3d3d3d",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#003d99",
      "--fe-primary-hover": "#002a6b",
      "--fe-primary-soft": "#e7edf7",
      "--fe-primary-ink": "#002a6b",
      "--fe-danger": "#a80000",
      "--fe-danger-hover": "#7d0000",
      "--fe-shadow": "0 0 0 1px #000000, 0 10px 32px rgba(0, 0, 0, 0.25)",
      "--fe-shadow-sm": "0 0 0 1px #000000"
    },
    dark: {
      "--fe-bg": "#000000",
      "--fe-bg-elev": "#0d0d0d",
      "--fe-bg-hover": "#212121",
      "--fe-bg-selected": "#003d80",
      "--fe-border": "#8f8f8f",
      "--fe-border-soft": "#8f8f8f",
      "--fe-border-strong": "#ffffff",
      "--fe-text": "#ffffff",
      "--fe-text-muted": "#d6d6d6",
      "--fe-text-on-primary": "#001430",
      "--fe-primary": "#7ab8ff",
      "--fe-primary-hover": "#9ccaff",
      "--fe-primary-soft": "#0e1a29",
      "--fe-primary-ink": "#9ccaff",
      "--fe-danger": "#ff7575",
      "--fe-danger-hover": "#ff9999",
      "--fe-shadow": "0 0 0 1px #ffffff, 0 12px 32px rgba(0, 0, 0, 0.65)",
      "--fe-shadow-sm": "0 0 0 1px #ffffff"
    }
  },
  {
    // Soft Gray — desaturated, quiet neutral.
    id: "gray",
    nameKey: "theme.name.gray",
    light: {
      "--fe-bg": "#f7f7f8",
      "--fe-bg-elev": "#efeff1",
      "--fe-bg-hover": "#e4e4e7",
      "--fe-bg-selected": "#d6d7db",
      "--fe-border": "#dfdfe2",
      "--fe-border-soft": "#e9e9eb",
      "--fe-border-strong": "#b9b9c0",
      "--fe-text": "#26272b",
      "--fe-text-muted": "#585a63",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#4b4b54",
      "--fe-primary-hover": "#38383f",
      "--fe-primary-soft": "#e4e4e6",
      "--fe-primary-ink": "#38383f",
      "--fe-danger": "#c62828",
      "--fe-danger-hover": "#a51f1f"
    },
    dark: {
      "--fe-bg": "#131316",
      "--fe-bg-elev": "#1b1b1f",
      "--fe-bg-hover": "#26262b",
      "--fe-bg-selected": "#35353c",
      "--fe-border": "#2d2d33",
      "--fe-border-soft": "#242429",
      "--fe-border-strong": "#4a4a52",
      "--fe-text": "#e6e6e9",
      "--fe-text-muted": "#a4a4ad",
      "--fe-text-on-primary": "#17171b",
      "--fe-primary": "#b0b0ba",
      "--fe-primary-hover": "#c4c4cd",
      "--fe-primary-soft": "#242428",
      "--fe-primary-ink": "#c4c4cd",
      "--fe-danger": "#f87171",
      "--fe-danger-hover": "#ef4444"
    }
  },
  {
    // Terminal Green — phosphor green, monospace face for the full CRT vibe.
    id: "terminal",
    nameKey: "theme.name.terminal",
    light: {
      "--fe-bg": "#f3f9f4",
      "--fe-bg-elev": "#e5f2e8",
      "--fe-bg-hover": "#d5ead9",
      "--fe-bg-selected": "#bce3c6",
      "--fe-border": "#cbe2d1",
      "--fe-border-soft": "#dbebdf",
      "--fe-border-strong": "#94c2a0",
      "--fe-text": "#0c2913",
      "--fe-text-muted": "#31573c",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#116b33",
      "--fe-primary-hover": "#0c5427",
      "--fe-primary-soft": "#dbe9dd",
      "--fe-primary-ink": "#0c5427",
      "--fe-danger": "#c62828",
      "--fe-danger-hover": "#a51f1f",
      "--fe-font": 'ui-monospace, "SF Mono", Consolas, Menlo, monospace'
    },
    dark: {
      "--fe-bg": "#050d07",
      "--fe-bg-elev": "#0a1710",
      "--fe-bg-hover": "#112418",
      "--fe-bg-selected": "#1a3a26",
      "--fe-border": "#1c3a2a",
      "--fe-border-soft": "#142b1e",
      "--fe-border-strong": "#316144",
      "--fe-text": "#4fdd8b",
      "--fe-text-muted": "#38a668",
      "--fe-text-on-primary": "#03180a",
      "--fe-primary": "#25c95e",
      "--fe-primary-hover": "#4fdd8b",
      "--fe-primary-soft": "#0c2412",
      "--fe-primary-ink": "#4fdd8b",
      "--fe-danger": "#ff6b62",
      "--fe-danger-hover": "#ff8d86",
      "--fe-font": 'ui-monospace, "SF Mono", Consolas, Menlo, monospace'
    }
  }
], sf = b([]);
function Bhe(e) {
  sf.value = Array.isArray(e) ? e : [], ko.value !== _n && !zu(ko.value) && d7(_n);
}
function Fhe() {
  return { customThemes: sf };
}
function z0() {
  return [...A0, ...sf.value];
}
function zu(e) {
  if (e)
    return A0.find((a) => a.id === e) ?? sf.value.find((a) => a.id === e);
}
function u7(e, a) {
  return e.name ?? (e.nameKey ? a(e.nameKey) : e.id);
}
function c7() {
  return Array.from(
    new Set(z0().flatMap((e) => [...Object.keys(e.light), ...Object.keys(e.dark)]))
  );
}
function Mu(e) {
  return !!e && (!!zu(e) || e.startsWith(l7));
}
function M0() {
  if (!Vr()) return _n;
  try {
    const e = localStorage.getItem(Sd);
    if (Mu(e)) return e;
    const a = localStorage.getItem(m_);
    return a && zu(a) ? (localStorage.setItem(Sd, a), localStorage.removeItem(m_), a) : _n;
  } catch {
    return _n;
  }
}
const ko = b(
  typeof window > "u" ? _n : M0()
);
function D0(e) {
  const a = Mu(e) ? e : _n;
  ko.value = a;
  try {
    localStorage.setItem(Sd, a);
  } catch {
  }
  pi("palette", a);
}
function d7(e) {
  if (!e) return;
  const a = Mu(e) ? e : _n;
  ko.value = a, di("palette", a);
}
function Uhe(e) {
  e && Mu(e) && (ko.value = e);
}
function P0() {
  return { themeId: ko, setTheme: D0 };
}
const cu = "filex.thememode";
VO(cu);
const ym = ["host", "auto", "light", "dark"];
function O0() {
  if (!Vr()) return "host";
  try {
    const e = localStorage.getItem(cu);
    return e && ym.includes(e) ? e : "host";
  } catch {
    return "host";
  }
}
const of = b(
  typeof window > "u" ? "host" : O0()
);
function f7(e) {
  const a = ym.includes(e) ? e : "host";
  of.value = a;
  try {
    a === "host" ? localStorage.removeItem(cu) : localStorage.setItem(cu, a);
  } catch {
  }
}
function Hhe() {
  ko.value = M0(), of.value = O0();
}
function p7() {
  return { themeMode: of, setThemeMode: f7 };
}
if (typeof window < "u")
  try {
    window.addEventListener("storage", (e) => {
      if (e.key !== cu || !Vr()) return;
      const a = e.newValue;
      of.value = a && ym.includes(a) ? a : "host";
    });
  } catch {
  }
if (typeof window < "u")
  try {
    window.addEventListener("storage", (e) => {
      e.key !== Sd || !Vr() || (ko.value = Mu(e.newValue) ? e.newValue : _n);
    });
  } catch {
  }
function v7(e, a, t) {
  for (const o of c7()) e.style.removeProperty(o);
  if (a === _n) return;
  const s = zu(a);
  if (!s) return;
  const n = t ? s.dark : s.light;
  for (const [o, p] of Object.entries(n)) e.style.setProperty(o, p);
}
const y_ = "data-filex-theme";
function g_(e) {
  return Object.entries(e).map(([a, t]) => `${a}:${t};`).join("");
}
function h7(e) {
  const a = g_(e.light), t = g_(e.dark), s = [
    ".fe--theme-dark",
    ":root[data-theme='dark'] .fe",
    ".fe.fe--theme-dark",
    ":root.dark",
    ".dark",
    ":root.dark .fe",
    ".dark .fe",
    ".fe-ctx-backdrop--theme-dark",
    ".fe-ctx-backdrop--theme-auto[data-prefers-dark='1']"
  ].join(","), n = [
    ".fe:not(.fe--theme-light)",
    ".fe-ctx-backdrop--theme-auto:not(.fe-ctx-backdrop--theme-light)"
  ].join(",");
  return `/* filex theme: ${e.id} */:root,.fe{${a}}${s}{${t}}@media (prefers-color-scheme: dark){${n}{${t}}}`;
}
function m7(e) {
  if (typeof document > "u") return;
  let a = document.head.querySelector(`style[${y_}]`);
  const t = e === _n ? void 0 : zu(e);
  if (!t) {
    a && (a.textContent = "");
    return;
  }
  a ? a !== document.head.lastElementChild && document.head.appendChild(a) : (a = document.createElement("style"), a.setAttribute(y_, ""), document.head.appendChild(a));
  const s = h7(t);
  a.textContent !== s && (a.textContent = s);
}
const y7 = {
  key: 0,
  class: "fe-themes__hint"
}, g7 = ["aria-label"], b7 = ["aria-selected", "data-theme-id", "onClick"], _7 = { class: "fe-themecard__name" }, k7 = ["title"], L0 = /* @__PURE__ */ rt({
  __name: "ThemePalette",
  props: {
    locale: {},
    dark: { type: Boolean },
    current: {},
    hint: { type: Boolean }
  },
  emits: ["select"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n } = gt(() => t.locale);
    function o(p) {
      return t.dark ? p.dark : p.light;
    }
    return (p, h) => (u(), d(he, null, [
      e.hint !== !1 ? (u(), d("p", y7, f(r(n)("theme.hint")), 1)) : T("", !0),
      i("div", {
        class: "fe-themes",
        role: "listbox",
        "aria-label": r(n)("theme.title")
      }, [
        (u(!0), d(he, null, We(r(z0)(), (v) => (u(), d("button", {
          key: v.id,
          type: "button",
          class: Re(["fe-themecard", { "is-selected": v.id === e.current }]),
          role: "option",
          "aria-selected": v.id === e.current,
          "data-theme-id": v.id,
          style: Vt(o(v)),
          onClick: (y) => s("select", v.id)
        }, [
          h[0] || (h[0] = vk('<span class="fe-themecard__preview" aria-hidden="true"><span class="fe-themecard__topbar"><span class="fe-themecard__chip fe-themecard__chip--primary"></span><span class="fe-themecard__chip"></span><span class="fe-themecard__chip fe-themecard__chip--ghost"></span></span><span class="fe-themecard__row"><span class="fe-themecard__dot"></span><span class="fe-themecard__line" style="width:62%;"></span></span><span class="fe-themecard__row fe-themecard__row--selected"><span class="fe-themecard__dot fe-themecard__dot--primary"></span><span class="fe-themecard__line" style="width:44%;"></span></span><span class="fe-themecard__row"><span class="fe-themecard__dot fe-themecard__dot--muted"></span><span class="fe-themecard__line fe-themecard__line--muted" style="width:74%;"></span></span></span>', 1)),
          i("span", _7, [
            $t(f(r(u7)(v, r(n))) + " ", 1),
            v.id === e.current ? (u(), d("span", {
              key: 0,
              class: "fe-themecard__check",
              title: r(n)("theme.selected")
            }, "✓", 8, k7)) : T("", !0)
          ])
        ], 14, b7))), 128))
      ], 8, g7)
    ], 64));
  }
}), w7 = ["aria-label"], x7 = { class: "fe-thememode__label" }, $7 = { class: "fe-thememode__seg" }, S7 = ["aria-pressed", "onClick"], T7 = {
  class: "fe-ficon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}, C7 = {
  key: 1,
  d: "M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"
}, E7 = ["disabled"], A7 = /* @__PURE__ */ rt({
  __name: "ThemeGallery",
  props: {
    open: { type: Boolean },
    locale: {},
    theme: {},
    dark: { type: Boolean },
    current: {},
    mode: {},
    hostMode: {}
  },
  emits: ["close", "select", "mode"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n } = gt(() => t.locale), o = [
      { id: "light", labelKey: "theme.mode.light" },
      { id: "dark", labelKey: "theme.mode.dark" },
      { id: "auto", labelKey: "theme.mode.auto" }
    ], p = x(() => t.mode === "host" ? t.hostMode : t.mode), h = _n;
    return (v, y) => (u(), nt(la, {
      open: e.open,
      title: r(n)("theme.title"),
      size: "lg",
      theme: e.theme,
      onClose: y[3] || (y[3] = (g) => s("close"))
    }, {
      actions: yt(() => [
        i("button", {
          type: "button",
          class: "fe-btn",
          disabled: e.current === r(h),
          onClick: y[1] || (y[1] = (g) => s("select", r(h)))
        }, f(r(n)("theme.reset")), 9, E7),
        i("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          onClick: y[2] || (y[2] = (g) => s("close"))
        }, f(r(n)("theme.close")), 1)
      ]),
      default: yt(() => [
        i("div", {
          class: "fe-thememode",
          role: "group",
          "aria-label": r(n)("theme.mode.label")
        }, [
          i("span", x7, f(r(n)("theme.mode.label")), 1),
          i("div", $7, [
            (u(), d(he, null, We(o, (g) => i("button", {
              key: g.id,
              type: "button",
              class: Re(["fe-thememode__opt", { "is-active": p.value === g.id }]),
              "aria-pressed": p.value === g.id,
              onClick: (m) => s("mode", g.id)
            }, [
              (u(), d("svg", T7, [
                g.id === "light" ? (u(), d(he, { key: 0 }, [
                  y[4] || (y[4] = i("circle", {
                    cx: "12",
                    cy: "12",
                    r: "4"
                  }, null, -1)),
                  y[5] || (y[5] = i("path", { d: "M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" }, null, -1))
                ], 64)) : g.id === "dark" ? (u(), d("path", C7)) : (u(), d(he, { key: 2 }, [
                  y[6] || (y[6] = i("circle", {
                    cx: "12",
                    cy: "12",
                    r: "9"
                  }, null, -1)),
                  y[7] || (y[7] = i("path", {
                    d: "M12 3a9 9 0 0 1 0 18z",
                    fill: "currentColor",
                    stroke: "none"
                  }, null, -1))
                ], 64))
              ])),
              i("span", null, f(r(n)(g.labelKey)), 1)
            ], 10, S7)), 64))
          ])
        ], 8, w7),
        ot(L0, {
          locale: e.locale,
          dark: e.dark,
          current: e.current,
          onSelect: y[0] || (y[0] = (g) => s("select", g))
        }, null, 8, ["locale", "dark", "current"])
      ]),
      _: 1
    }, 8, ["open", "title", "theme"]));
  }
}), z7 = { class: "fe-tzpick" }, M7 = ["id", "aria-expanded", "aria-activedescendant", "disabled", "data-testid", "placeholder", "value"], D7 = ["aria-label", "data-testid"], P7 = ["id", "data-tz-active", "data-testid", "aria-selected", "title", "onMousedown", "onMousemove"], O7 = { class: "fe-tzpick__main" }, L7 = { class: "fe-tzpick__city" }, I7 = {
  key: 0,
  class: "fe-tzpick__region"
}, R7 = { class: "fe-tzpick__meta" }, N7 = {
  key: 0,
  class: "fe-tzpick__time"
}, B7 = { class: "fe-tzpick__offset" }, F7 = {
  key: 0,
  class: "fe-tzpick__empty",
  role: "presentation"
}, U7 = {
  key: 1,
  class: "fe-tzpick__empty",
  role: "presentation"
}, H7 = 50, I0 = /* @__PURE__ */ rt({
  __name: "TimeZonePicker",
  props: {
    locale: {},
    modelValue: {},
    fallback: {},
    disabled: { type: Boolean },
    inputId: {},
    label: {},
    testid: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n } = gt(() => t.locale), o = x(() => kn(t.locale)), p = x(() => t.testid || "fe-tz");
    let h = 0;
    const v = `fe-tz-${++h}-${Math.random().toString(36).slice(2, 7)}`, y = x(() => t.inputId || `${v}-input`), g = `${v}-list`;
    function m(Ae) {
      return Ae.replace(/[\u0130\u0131]/g, "i").replace(/[\u015e\u015f]/g, "s").replace(/[\u011e\u011f]/g, "g").replace(/[\u00dc\u00fc]/g, "u").replace(/[\u00d6\u00f6]/g, "o").replace(/[\u00c7\u00e7]/g, "c").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[_/\-.]+/g, " ").replace(/\s+/g, " ").trim();
    }
    const k = {
      UTC: "utc gmt zulu z greenwich universal",
      "Etc/UTC": "utc gmt zulu greenwich universal",
      "Etc/GMT": "utc gmt greenwich",
      "Europe/Istanbul": "turkey turkiye ist constantinople",
      "Europe/London": "uk britain england gmt bst",
      "America/New_York": "usa united states eastern est edt nyc",
      "America/Los_Angeles": "usa united states pacific pst pdt la",
      "Asia/Kolkata": "india calcutta ist"
    };
    function _(Ae) {
      const Ce = /^GMT(?:([+-])(\d{1,2})(?::(\d{2}))?)?$/.exec($(Ae, "en-US", "shortOffset").trim());
      if (!Ce) return null;
      if (!Ce[1]) return 0;
      const He = Number(Ce[2]) * 60 + Number(Ce[3] ?? 0);
      return Ce[1] === "-" ? -He : He;
    }
    function w(Ae) {
      if (Ae === null) return "";
      if (Ae === 0) return "gmt utc";
      const Ce = Ae < 0 ? "-" : "+", He = Math.abs(Ae), J = String(Math.floor(He / 60)), me = J.padStart(2, "0"), fe = String(He % 60).padStart(2, "0"), xe = [`${Ce}${J}`, `${Ce}${me}`, `${Ce}${me}:${fe}`, `${Ce}${me}${fe}`];
      return [...xe.map((ye) => `gmt${ye}`), ...xe.map((ye) => `utc${ye}`), ...xe].join(" ");
    }
    function $(Ae, Ce, He) {
      var J;
      try {
        return ((J = new Intl.DateTimeFormat(Ce, {
          timeZone: Ae,
          timeZoneName: He
        }).formatToParts(/* @__PURE__ */ new Date()).find((fe) => fe.type === "timeZoneName")) == null ? void 0 : J.value) ?? "";
      } catch {
        return "";
      }
    }
    function C(Ae) {
      try {
        return new Intl.DateTimeFormat(o.value, { timeZone: Ae, hour: "2-digit", minute: "2-digit" });
      } catch {
        return null;
      }
    }
    const E = x(() => t.fallback.zone ?? mu()), A = x(() => {
      const Ae = E.value;
      return t.fallback.tier === "host" ? n("tz.default.host", { zone: Ae }) : t.fallback.tier === "account" ? n("tz.default.account", { zone: Ae }) : n("tz.default.device", { zone: Ae });
    }), O = b(null);
    let z = "";
    function P() {
      const Ae = o.value, Ce = E.value, He = m(
        `${Ce} ${A.value} default automatic device local system account site`
      ), J = [
        {
          value: "",
          label: A.value,
          region: "",
          offset: $(Ce, Ae, "shortOffset"),
          haystack: He,
          cityFold: m(Ce.split("/").pop() ?? ""),
          words: He.split(" ").filter(Boolean),
          fmt: C(Ce)
        }
      ], me = OT();
      t.modelValue && !me.includes(t.modelValue) && me.unshift(t.modelValue);
      for (const fe of me) {
        const xe = fe.split("/"), ye = (xe[xe.length - 1] ?? fe).replace(/_/g, " "), qe = xe.length > 1 ? xe[0].replace(/_/g, " ") : "", ut = $(fe, Ae, "shortOffset"), Ue = $(fe, Ae, "longGeneric"), Ye = Ae === "en-US" ? "" : $(fe, "en-US", "longGeneric"), st = m(
          [fe, ye, qe, Ue, Ye, k[fe] ?? "", ut, w(_(fe))].filter(Boolean).join(" ")
        );
        J.push({
          value: fe,
          label: ye,
          region: qe,
          offset: ut,
          haystack: st,
          cityFold: m(ye),
          words: st.split(" ").filter(Boolean),
          fmt: C(fe)
        });
      }
      return J;
    }
    function I() {
      const Ae = `${t.locale}|${t.fallback.tier}|${E.value}|${t.modelValue}`;
      O.value && z === Ae || (z = Ae, O.value = P());
    }
    const F = b(!1), W = b(""), N = b(0), K = b(null), M = b(null), j = b(/* @__PURE__ */ new Date());
    let U;
    function de() {
      j.value = /* @__PURE__ */ new Date(), U || (U = setInterval(() => j.value = /* @__PURE__ */ new Date(), 1e3));
    }
    function ke() {
      U && clearInterval(U), U = void 0;
    }
    Mt(ke);
    const ie = b({ maxHeight: "264px", above: !1 });
    function ce(Ae) {
      let Ce = Ae.parentElement;
      for (; Ce; ) {
        const He = getComputedStyle(Ce).overflowY;
        if (He === "auto" || He === "scroll") {
          const J = Ce.getBoundingClientRect();
          return { top: J.top, bottom: J.bottom };
        }
        Ce = Ce.parentElement;
      }
      return { top: 0, bottom: window.innerHeight };
    }
    function X() {
      const Ae = K.value;
      if (!Ae) return;
      const Ce = Ae.getBoundingClientRect(), He = ce(Ae), J = 12, me = He.bottom - Ce.bottom - J, fe = Ce.top - He.top - J, xe = 132, ye = 264, qe = me < xe && fe > me, ut = qe ? fe : me;
      ie.value = {
        maxHeight: `${Math.round(Math.max(xe, Math.min(ye, ut)))}px`,
        above: qe
      };
    }
    function Z(Ae, Ce) {
      let He = 0;
      for (const J of Ce) {
        let me = 0;
        if (Ae.cityFold === J ? me = 120 : Ae.cityFold.startsWith(J) ? me = 100 : Ae.words.some((fe) => fe.startsWith(J)) ? me = 70 : Ae.haystack.includes(J) && (me = 30), me === 0) return -1;
        He += me;
      }
      return He;
    }
    const Y = x(() => {
      const Ae = O.value ?? [], Ce = m(W.value);
      if (!Ce) {
        const me = Ae.find((fe) => fe.value === t.modelValue);
        return !me || me === Ae[0] ? Ae : [Ae[0], me, ...Ae.slice(1).filter((fe) => fe !== me)];
      }
      const He = Ce.split(" ").filter(Boolean), J = [];
      return Ae.forEach((me, fe) => {
        const xe = Z(me, He);
        xe >= 0 && J.push({ row: me, score: xe, i: fe });
      }), J.sort((me, fe) => fe.score - me.score || me.i - fe.i), J.map((me) => me.row);
    }), G = x(() => Y.value.slice(0, H7)), we = x(() => Math.max(0, Y.value.length - G.value.length)), R = x(() => {
      if (!t.modelValue) return A.value;
      const Ae = t.modelValue, Ce = (Ae.split("/").pop() ?? Ae).replace(/_/g, " "), He = $(Ae, o.value, "shortOffset");
      return He ? `${Ce} — ${He}` : Ce;
    });
    function pe(Ae) {
      try {
        return Ae.fmt ? Ae.fmt.format(j.value) : "";
      } catch {
        return "";
      }
    }
    function Q() {
      I(), F.value = !0, W.value = "", de();
      const Ae = G.value.findIndex((Ce) => Ce.value === t.modelValue);
      N.value = Ae >= 0 ? Ae : 0, Jt(() => {
        X(), Pe();
      });
    }
    function q() {
      F.value = !1, W.value = "", N.value = 0, ke();
    }
    function re(Ae) {
      I(), F.value || de(), F.value = !0, W.value = Ae.target.value, N.value = 0;
    }
    function ae(Ae) {
      var Ce;
      q(), (Ce = K.value) == null || Ce.blur(), Ae.value !== t.modelValue && s("update:modelValue", Ae.value);
    }
    function Pe() {
      var Ce;
      const Ae = (Ce = M.value) == null ? void 0 : Ce.querySelector('[data-tz-active="1"]');
      Ae == null || Ae.scrollIntoView({ block: "nearest" });
    }
    function be(Ae) {
      const Ce = G.value.length;
      if (Ce === 0) return;
      const He = Math.min(N.value, Ce - 1);
      N.value = (He + Ae + Ce) % Ce, Jt(() => Pe());
    }
    function ze(Ae) {
      switch (Ae.key) {
        case "ArrowDown":
          Ae.preventDefault(), F.value ? be(1) : Q();
          break;
        case "ArrowUp":
          Ae.preventDefault(), F.value ? be(-1) : Q();
          break;
        case "Home":
          if (!F.value) return;
          Ae.preventDefault(), N.value = 0, Jt(() => Pe());
          break;
        case "End":
          if (!F.value) return;
          Ae.preventDefault(), N.value = Math.max(0, G.value.length - 1), Jt(() => Pe());
          break;
        case "Enter": {
          if (!F.value) return;
          Ae.preventDefault();
          const Ce = G.value[N.value];
          Ce && ae(Ce);
          break;
        }
        case "Escape":
          if (!F.value) return;
          Ae.preventDefault(), Ae.stopPropagation(), q();
          break;
        case "Tab":
          q();
          break;
      }
    }
    return (Ae, Ce) => (u(), d("div", z7, [
      i("input", {
        id: y.value,
        ref_key: "inputEl",
        ref: K,
        class: "fe-tzpick__input",
        type: "text",
        role: "combobox",
        autocomplete: "off",
        spellcheck: "false",
        "aria-autocomplete": "list",
        "aria-expanded": F.value,
        "aria-controls": g,
        "aria-activedescendant": F.value && G.value.length ? `${g}-opt-${N.value}` : void 0,
        disabled: e.disabled,
        "data-testid": `${p.value}-filter`,
        placeholder: r(n)("tz.search"),
        value: F.value ? W.value : R.value,
        onFocus: Q,
        onInput: re,
        onKeydown: ze,
        onBlur: q
      }, null, 40, M7),
      F.value ? (u(), d("ul", {
        key: 0,
        id: g,
        ref_key: "listEl",
        ref: M,
        class: Re(["fe-tzpick__list", { "is-above": ie.value.above }]),
        style: Vt({ maxHeight: ie.value.maxHeight }),
        role: "listbox",
        "aria-label": e.label || r(n)("tz.title"),
        "data-testid": `${p.value}-list`
      }, [
        (u(!0), d(he, null, We(G.value, (He, J) => (u(), d("li", {
          id: `${g}-opt-${J}`,
          key: He.value || "__default",
          class: Re(["fe-tzpick__opt", { "is-active": J === N.value, "is-current": He.value === e.modelValue }]),
          "data-tz-active": J === N.value ? "1" : "0",
          "data-testid": `${p.value}-opt-${He.value || "device"}`,
          role: "option",
          "aria-selected": He.value === e.modelValue,
          title: He.value || E.value,
          onMousedown: ft((me) => ae(He), ["prevent"]),
          onMousemove: (me) => N.value = J
        }, [
          i("span", O7, [
            i("span", L7, f(He.label), 1),
            He.region ? (u(), d("span", I7, f(He.region), 1)) : T("", !0)
          ]),
          i("span", R7, [
            pe(He) ? (u(), d("span", N7, f(pe(He)), 1)) : T("", !0),
            i("span", B7, f(He.offset), 1)
          ])
        ], 42, P7))), 128)),
        G.value.length === 0 ? (u(), d("li", F7, f(r(n)("tz.no_match", { query: W.value })), 1)) : we.value > 0 ? (u(), d("li", U7, f(r(n)("tz.more", { n: we.value })), 1)) : T("", !0)
      ], 14, D7)) : T("", !0)
    ]));
  }
}), K7 = {
  class: "fe-tzdialog",
  "data-testid": "fe-tz-dialog"
}, V7 = { class: "fe-tzdialog__hint" }, q7 = ["data-tier"], j7 = /* @__PURE__ */ rt({
  __name: "TimeZoneDialog",
  props: {
    open: { type: Boolean },
    locale: {},
    theme: {}
  },
  emits: ["close"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n } = gt(() => t.locale), o = `fe-tzdialog-${Math.random().toString(36).slice(2, 9)}`, p = On(Od, void 0), h = x(() => dh({ ...Hk(p), viewer: "" })), v = x(() => Kk(p)), y = x(() => v.value.zone ?? mu()), g = b("");
    let m;
    function k() {
      g.value = Er(
        /* @__PURE__ */ new Date(),
        t.locale,
        {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit"
        },
        p
      );
    }
    return Qe(
      () => t.open,
      (_) => {
        m && clearInterval(m), m = void 0, _ && (k(), m = setInterval(k, 1e3));
      },
      { immediate: !0 }
    ), Qe(v, k), Mt(() => {
      m && clearInterval(m);
    }), (_, w) => (u(), nt(la, {
      open: e.open,
      title: r(n)("tz.title"),
      size: "md",
      theme: e.theme,
      onClose: w[0] || (w[0] = ($) => s("close"))
    }, {
      default: yt(() => [
        i("div", K7, [
          i("label", {
            class: "fe-tzdialog__label",
            for: o
          }, f(r(n)("tz.label")), 1),
          ot(I0, {
            "input-id": o,
            locale: e.locale,
            "model-value": r(NT)(),
            fallback: h.value,
            label: r(n)("tz.label"),
            testid: "fe-tz",
            "onUpdate:modelValue": r(qk)
          }, null, 8, ["locale", "model-value", "fallback", "label", "onUpdate:modelValue"]),
          i("p", V7, f(r(n)("tz.hint")), 1),
          i("p", {
            class: "fe-tzdialog__now",
            "data-testid": "fe-tz-now",
            "data-tier": v.value.tier
          }, f(r(n)("tz.now", { zone: y.value, time: g.value })), 9, q7)
        ])
      ]),
      _: 1
    }, 8, ["open", "title", "theme"]));
  }
});
function W7(e) {
  const a = Symbol("filex-explorer");
  yr(Od, a), Qe(
    () => e.config().timeZone,
    (n) => BT(a, n),
    { immediate: !0 }
  );
  const t = () => {
    var n;
    return e.config().callerKind ?? ((n = e.capabilities.value) == null ? void 0 : n.caller_kind);
  };
  let s = !1;
  return Qe(
    t,
    (n) => {
      if (n !== "user") {
        zc(a, null);
        return;
      }
      s || (s = !0, e.fetchMe().then((o) => {
        var h;
        if (t() !== "user") return;
        const p = (h = o == null ? void 0 : o.user) == null ? void 0 : h.timezone;
        zc(a, typeof p == "string" ? p : null);
      }).catch(() => zc(a, null)));
    },
    { immediate: !0 }
  ), Mt(() => HT(a)), a;
}
const Y7 = { class: "fe-shortset" }, G7 = { class: "fe-shortset__topbar" }, X7 = { class: "fe-shortset__hint" }, J7 = ["disabled"], Z7 = ["innerHTML"], Q7 = { class: "fe-shortcuts__heading" }, eV = { class: "fe-shortset__row" }, tV = { class: "fe-shortset__label" }, aV = ["title"], nV = { class: "fe-shortset__keys" }, sV = {
  key: 0,
  class: "fe-shortset__capture",
  role: "status"
}, oV = {
  key: 0,
  class: "fe-shortcuts__unbound"
}, iV = { class: "fe-kbd" }, rV = ["title"], lV = {
  key: 1,
  class: "fe-shortcuts__or",
  "aria-hidden": "true"
}, uV = { class: "fe-shortset__actions" }, cV = ["onClick"], dV = ["title", "aria-label", "onClick"], fV = ["innerHTML"], pV = {
  key: 1,
  class: "fe-shortset__fixed"
}, vV = {
  key: 0,
  class: "fe-shortset__conflict",
  role: "alert"
}, hV = { class: "fe-shortset__conflict-msg" }, mV = { class: "fe-kbd" }, yV = { class: "fe-shortset__conflict-actions" }, gV = {
  key: 1,
  class: "fe-shortset__conflict",
  role: "alert"
}, bV = { class: "fe-shortset__conflict-msg" }, _V = { class: "fe-kbd" }, kV = { class: "fe-shortset__conflict-actions" }, wV = /* @__PURE__ */ rt({
  __name: "ShortcutSettings",
  props: {
    open: { type: Boolean },
    locale: {},
    theme: {}
  },
  emits: ["close"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n } = gt(() => t.locale), o = Qk(), p = x(() => {
      const I = [], F = /* @__PURE__ */ new Map();
      for (const W of o.value)
        F.has(W.groupKey) || (F.set(W.groupKey, []), I.push(W.groupKey)), F.get(W.groupKey).push(W);
      return I.map((W) => ({ key: W, items: F.get(W) }));
    }), h = x(() => o.value.some((I) => I.overridden)), v = b(null), y = b(null), g = b(null);
    function m(I) {
      const F = wo.find((W) => W.id === I);
      return F ? n(F.labelKey) : I;
    }
    function k(I) {
      y.value = null, g.value = null, v.value = I;
    }
    function _() {
      v.value = null;
    }
    function w(I, F) {
      if (v.value = null, F === Ur(I)) return;
      if (Yg(F)) {
        g.value = { id: I, combo: F };
        return;
      }
      const W = hC(F, I);
      if (W) {
        y.value = { id: I, combo: F, conflictId: W.id, fixed: W.fixed };
        return;
      }
      bp(I, F);
    }
    function $() {
      const I = y.value;
      !I || I.fixed || (bp(I.conflictId, ""), bp(I.id, I.combo), y.value = null);
    }
    function C() {
      y.value = null;
    }
    function E() {
      g.value = null;
    }
    function A(I) {
      y.value = null, g.value = null, pC(I);
    }
    function O() {
      y.value = null, g.value = null, v.value = null, vC();
    }
    function z(I) {
      if (v.value) {
        if (I.preventDefault(), I.stopPropagation(), I.key === "Escape") {
          _();
          return;
        }
        const F = kh(I);
        if (!F) return;
        w(v.value, F);
        return;
      }
      I.key === "Escape" || I.key === "Tab" || I.stopPropagation();
    }
    Qe(
      () => t.open,
      (I) => {
        I ? window.addEventListener("keydown", z, !0) : (window.removeEventListener("keydown", z, !0), v.value = null, y.value = null, g.value = null);
      }
    ), Mt(() => window.removeEventListener("keydown", z, !0));
    function P() {
      if (v.value) {
        _();
        return;
      }
      s("close");
    }
    return (I, F) => (u(), nt(la, {
      open: e.open,
      title: r(n)("shortcuts.settings.title"),
      size: "lg",
      theme: e.theme,
      onClose: P
    }, {
      actions: yt(() => [
        i("button", {
          type: "button",
          class: "fe-btn",
          onClick: P
        }, f(r(n)("viewer.close")), 1)
      ]),
      default: yt(() => [
        i("div", Y7, [
          i("div", G7, [
            i("p", X7, f(r(n)("shortcuts.settings.hint")), 1),
            i("button", {
              type: "button",
              class: "fe-btn fe-shortset__reset-all",
              disabled: !h.value,
              onClick: O
            }, [
              i("span", {
                class: "fe-icon",
                "aria-hidden": "true",
                innerHTML: r(wt)("restore")
              }, null, 8, Z7),
              $t(" " + f(r(n)("shortcuts.settings.reset_all")), 1)
            ], 8, J7)
          ]),
          (u(!0), d(he, null, We(p.value, (W) => (u(), d("section", {
            key: W.key,
            class: "fe-shortset__group"
          }, [
            i("h3", Q7, f(r(n)(W.key)), 1),
            (u(!0), d(he, null, We(W.items, (N) => {
              var K;
              return u(), d("div", {
                key: N.id,
                class: Re(["fe-shortset__item", {
                  "is-capturing": v.value === N.id,
                  "is-conflict": ((K = y.value) == null ? void 0 : K.id) === N.id
                }])
              }, [
                i("div", eV, [
                  i("span", tV, [
                    $t(f(r(n)(N.labelKey)) + " ", 1),
                    N.overridden ? (u(), d("span", {
                      key: 0,
                      class: "fe-shortcuts__custom",
                      title: r(n)("shortcuts.settings.customized")
                    }, "●", 8, aV)) : T("", !0)
                  ]),
                  i("span", nV, [
                    v.value === N.id ? (u(), d("span", sV, f(r(n)("shortcuts.settings.capture")), 1)) : (u(), d(he, { key: 1 }, [
                      N.keys.length === 0 ? (u(), d("span", oV, f(r(n)("shortcuts.settings.unbound")), 1)) : (u(!0), d(he, { key: 1 }, We(N.keys, (M, j) => (u(), d(he, { key: M }, [
                        i("kbd", iV, f(M), 1),
                        r(Yg)(M) ? (u(), d("span", {
                          key: 0,
                          class: "fe-shortset__reserved",
                          title: r(n)("shortcuts.settings.reserved_title")
                        }, f(r(n)("shortcuts.settings.reserved_badge")), 9, rV)) : T("", !0),
                        j < N.keys.length - 1 ? (u(), d("span", lV, "/")) : T("", !0)
                      ], 64))), 128))
                    ], 64))
                  ]),
                  i("span", uV, [
                    N.customizable ? (u(), d(he, { key: 0 }, [
                      v.value !== N.id ? (u(), d("button", {
                        key: 0,
                        type: "button",
                        class: "fe-btn fe-shortset__btn",
                        onClick: (M) => k(N.id)
                      }, f(r(n)("shortcuts.settings.change")), 9, cV)) : (u(), d("button", {
                        key: 1,
                        type: "button",
                        class: "fe-btn fe-shortset__btn",
                        onClick: _
                      }, f(r(n)("shortcuts.settings.conflict_cancel")), 1)),
                      N.overridden ? (u(), d("button", {
                        key: 2,
                        type: "button",
                        class: "fe-btn fe-btn--icon-only fe-shortset__btn",
                        title: r(n)("shortcuts.settings.reset"),
                        "aria-label": r(n)("shortcuts.settings.reset"),
                        onClick: (M) => A(N.id)
                      }, [
                        i("span", {
                          class: "fe-icon",
                          "aria-hidden": "true",
                          innerHTML: r(wt)("restore")
                        }, null, 8, fV)
                      ], 8, dV)) : T("", !0)
                    ], 64)) : (u(), d("span", pV, f(r(n)("shortcuts.settings.fixed")), 1))
                  ])
                ]),
                y.value && y.value.id === N.id ? (u(), d("div", vV, [
                  i("span", hV, [
                    i("kbd", mV, f(y.value.combo), 1),
                    $t(" " + f(y.value.fixed ? r(n)("shortcuts.settings.conflict_fixed", { name: m(y.value.conflictId) }) : r(n)("shortcuts.settings.conflict", { name: m(y.value.conflictId) })), 1)
                  ]),
                  i("span", yV, [
                    y.value.fixed ? T("", !0) : (u(), d("button", {
                      key: 0,
                      type: "button",
                      class: "fe-btn fe-btn--danger fe-shortset__btn",
                      onClick: $
                    }, f(r(n)("shortcuts.settings.conflict_take")), 1)),
                    i("button", {
                      type: "button",
                      class: "fe-btn fe-shortset__btn",
                      onClick: C
                    }, f(r(n)("shortcuts.settings.conflict_cancel")), 1)
                  ])
                ])) : T("", !0),
                g.value && g.value.id === N.id ? (u(), d("div", gV, [
                  i("span", bV, [
                    i("kbd", _V, f(g.value.combo), 1),
                    $t(" " + f(r(n)("shortcuts.settings.reserved")), 1)
                  ]),
                  i("span", kV, [
                    i("button", {
                      type: "button",
                      class: "fe-btn fe-shortset__btn",
                      onClick: E
                    }, f(r(n)("shortcuts.settings.conflict_cancel")), 1)
                  ])
                ])) : T("", !0)
              ], 2);
            }), 128))
          ]))), 128))
        ])
      ]),
      _: 1
    }, 8, ["open", "title", "theme"]));
  }
});
/*! @license DOMPurify 3.4.2 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.4.2/LICENSE */
const {
  entries: R0,
  setPrototypeOf: b_,
  isFrozen: xV,
  getPrototypeOf: $V,
  getOwnPropertyDescriptor: SV
} = Object;
let {
  freeze: ln,
  seal: Ln,
  create: ur
} = Object, {
  apply: Jv,
  construct: Zv
} = typeof Reflect < "u" && Reflect;
ln || (ln = function(a) {
  return a;
});
Ln || (Ln = function(a) {
  return a;
});
Jv || (Jv = function(a, t) {
  for (var s = arguments.length, n = new Array(s > 2 ? s - 2 : 0), o = 2; o < s; o++)
    n[o - 2] = arguments[o];
  return a.apply(t, n);
});
Zv || (Zv = function(a) {
  for (var t = arguments.length, s = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    s[n - 1] = arguments[n];
  return new a(...s);
});
const Ml = La(Array.prototype.forEach), TV = La(Array.prototype.lastIndexOf), __ = La(Array.prototype.pop), Dl = La(Array.prototype.push), CV = La(Array.prototype.splice), Qa = Array.isArray, Bl = La(String.prototype.toLowerCase), Up = La(String.prototype.toString), k_ = La(String.prototype.match), rr = La(String.prototype.replace), w_ = La(String.prototype.indexOf), EV = La(String.prototype.trim), AV = La(Number.prototype.toString), zV = La(Boolean.prototype.toString), x_ = typeof BigInt > "u" ? null : La(BigInt.prototype.toString), $_ = typeof Symbol > "u" ? null : La(Symbol.prototype.toString), Ea = La(Object.prototype.hasOwnProperty), Pl = La(Object.prototype.toString), qa = La(RegExp.prototype.test), Sc = MV(TypeError);
function La(e) {
  return function(a) {
    a instanceof RegExp && (a.lastIndex = 0);
    for (var t = arguments.length, s = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
      s[n - 1] = arguments[n];
    return Jv(e, a, s);
  };
}
function MV(e) {
  return function() {
    for (var a = arguments.length, t = new Array(a), s = 0; s < a; s++)
      t[s] = arguments[s];
    return Zv(e, t);
  };
}
function Wt(e, a) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Bl;
  if (b_ && b_(e, null), !Qa(a))
    return e;
  let s = a.length;
  for (; s--; ) {
    let n = a[s];
    if (typeof n == "string") {
      const o = t(n);
      o !== n && (xV(a) || (a[s] = o), n = o);
    }
    e[n] = !0;
  }
  return e;
}
function DV(e) {
  for (let a = 0; a < e.length; a++)
    Ea(e, a) || (e[a] = null);
  return e;
}
function vn(e) {
  const a = ur(null);
  for (const [t, s] of R0(e))
    Ea(e, t) && (Qa(s) ? a[t] = DV(s) : s && typeof s == "object" && s.constructor === Object ? a[t] = vn(s) : a[t] = s);
  return a;
}
function PV(e) {
  switch (typeof e) {
    case "string":
      return e;
    case "number":
      return AV(e);
    case "boolean":
      return zV(e);
    case "bigint":
      return x_ ? x_(e) : "0";
    case "symbol":
      return $_ ? $_(e) : "Symbol()";
    case "undefined":
      return Pl(e);
    case "function":
    case "object": {
      if (e === null)
        return Pl(e);
      const a = e, t = cr(a, "toString");
      if (typeof t == "function") {
        const s = t(a);
        return typeof s == "string" ? s : Pl(s);
      }
      return Pl(e);
    }
    default:
      return Pl(e);
  }
}
function cr(e, a) {
  for (; e !== null; ) {
    const s = SV(e, a);
    if (s) {
      if (s.get)
        return La(s.get);
      if (typeof s.value == "function")
        return La(s.value);
    }
    e = $V(e);
  }
  function t() {
    return null;
  }
  return t;
}
function OV(e) {
  try {
    return qa(e, ""), !0;
  } catch {
    return !1;
  }
}
const S_ = ln(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), Hp = ln(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "enterkeyhint", "exportparts", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "inputmode", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "part", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), Kp = ln(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), LV = ln(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), Vp = ln(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), IV = ln(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), T_ = ln(["#text"]), C_ = ln(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "exportparts", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inert", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "part", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "slot", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns"]), qp = ln(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "mask-type", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), E_ = ln(["accent", "accentunder", "align", "bevelled", "close", "columnalign", "columnlines", "columnspacing", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lquote", "lspace", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), Tc = ln(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), RV = Ln(/\{\{[\w\W]*|[\w\W]*\}\}/gm), NV = Ln(/<%[\w\W]*|[\w\W]*%>/gm), BV = Ln(/\$\{[\w\W]*/gm), FV = Ln(/^data-[\-\w.\u00B7-\uFFFF]+$/), UV = Ln(/^aria-[\-\w]+$/), N0 = Ln(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), HV = Ln(/^(?:\w+script|data):/i), KV = Ln(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), B0 = Ln(/^html$/i), VV = Ln(/^[a-z][.\w]*(-[.\w]+)+$/i);
var A_ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: UV,
  ATTR_WHITESPACE: KV,
  CUSTOM_ELEMENT: VV,
  DATA_ATTR: FV,
  DOCTYPE_NAME: B0,
  ERB_EXPR: NV,
  IS_ALLOWED_URI: N0,
  IS_SCRIPT_OR_DATA: HV,
  MUSTACHE_EXPR: RV,
  TMPLIT_EXPR: BV
});
const Ol = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, qV = function() {
  return typeof window > "u" ? null : window;
}, jV = function(a, t) {
  if (typeof a != "object" || typeof a.createPolicy != "function")
    return null;
  let s = null;
  const n = "data-tt-policy-suffix";
  t && t.hasAttribute(n) && (s = t.getAttribute(n));
  const o = "dompurify" + (s ? "#" + s : "");
  try {
    return a.createPolicy(o, {
      createHTML(p) {
        return p;
      },
      createScriptURL(p) {
        return p;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + o + " could not be created."), null;
  }
}, z_ = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function F0() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : qV();
  const a = (Ge) => F0(Ge);
  if (a.version = "3.4.2", a.removed = [], !e || !e.document || e.document.nodeType !== Ol.document || !e.Element)
    return a.isSupported = !1, a;
  let {
    document: t
  } = e;
  const s = t, n = s.currentScript, {
    DocumentFragment: o,
    HTMLTemplateElement: p,
    Node: h,
    Element: v,
    NodeFilter: y,
    NamedNodeMap: g = e.NamedNodeMap || e.MozNamedAttrMap,
    HTMLFormElement: m,
    DOMParser: k,
    trustedTypes: _
  } = e, w = v.prototype, $ = cr(w, "cloneNode"), C = cr(w, "remove"), E = cr(w, "nextSibling"), A = cr(w, "childNodes"), O = cr(w, "parentNode");
  if (typeof p == "function") {
    const Ge = t.createElement("template");
    Ge.content && Ge.content.ownerDocument && (t = Ge.content.ownerDocument);
  }
  let z, P = "";
  const {
    implementation: I,
    createNodeIterator: F,
    createDocumentFragment: W,
    getElementsByTagName: N
  } = t, {
    importNode: K
  } = s;
  let M = z_();
  a.isSupported = typeof R0 == "function" && typeof O == "function" && I && I.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: j,
    ERB_EXPR: U,
    TMPLIT_EXPR: de,
    DATA_ATTR: ke,
    ARIA_ATTR: ie,
    IS_SCRIPT_OR_DATA: ce,
    ATTR_WHITESPACE: X,
    CUSTOM_ELEMENT: Z
  } = A_;
  let {
    IS_ALLOWED_URI: Y
  } = A_, G = null;
  const we = Wt({}, [...S_, ...Hp, ...Kp, ...Vp, ...T_]);
  let R = null;
  const pe = Wt({}, [...C_, ...qp, ...E_, ...Tc]);
  let Q = Object.seal(ur(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), q = null, re = null;
  const ae = Object.seal(ur(null, {
    tagCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    }
  }));
  let Pe = !0, be = !0, ze = !1, Ae = !0, Ce = !1, He = !0, J = !1, me = !1, fe = !1, xe = !1, ye = !1, qe = !1, ut = !0, Ue = !1;
  const Ye = "user-content-";
  let st = !0, kt = !1, At = {}, _t = null;
  const Le = Wt({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let tt = null;
  const ve = Wt({}, ["audio", "video", "img", "source", "image", "track"]);
  let H = null;
  const te = Wt({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), Te = "http://www.w3.org/1998/Math/MathML", L = "http://www.w3.org/2000/svg", se = "http://www.w3.org/1999/xhtml";
  let ne = se, et = !1, ht = null;
  const Tt = Wt({}, [Te, L, se], Up);
  let Ft = Wt({}, ["mi", "mo", "mn", "ms", "mtext"]), Lt = Wt({}, ["annotation-xml"]);
  const ua = Wt({}, ["title", "style", "font", "a", "script"]);
  let Ct = null;
  const Qt = ["application/xhtml+xml", "text/html"], ta = "text/html";
  let Rt = null, va = null;
  const ha = t.createElement("form"), _a = function(ue) {
    return ue instanceof RegExp || ue instanceof Function;
  }, ia = function() {
    let ue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (va && va === ue)
      return;
    (!ue || typeof ue != "object") && (ue = {}), ue = vn(ue), Ct = // eslint-disable-next-line unicorn/prefer-includes
    Qt.indexOf(ue.PARSER_MEDIA_TYPE) === -1 ? ta : ue.PARSER_MEDIA_TYPE, Rt = Ct === "application/xhtml+xml" ? Up : Bl, G = Ea(ue, "ALLOWED_TAGS") && Qa(ue.ALLOWED_TAGS) ? Wt({}, ue.ALLOWED_TAGS, Rt) : we, R = Ea(ue, "ALLOWED_ATTR") && Qa(ue.ALLOWED_ATTR) ? Wt({}, ue.ALLOWED_ATTR, Rt) : pe, ht = Ea(ue, "ALLOWED_NAMESPACES") && Qa(ue.ALLOWED_NAMESPACES) ? Wt({}, ue.ALLOWED_NAMESPACES, Up) : Tt, H = Ea(ue, "ADD_URI_SAFE_ATTR") && Qa(ue.ADD_URI_SAFE_ATTR) ? Wt(vn(te), ue.ADD_URI_SAFE_ATTR, Rt) : te, tt = Ea(ue, "ADD_DATA_URI_TAGS") && Qa(ue.ADD_DATA_URI_TAGS) ? Wt(vn(ve), ue.ADD_DATA_URI_TAGS, Rt) : ve, _t = Ea(ue, "FORBID_CONTENTS") && Qa(ue.FORBID_CONTENTS) ? Wt({}, ue.FORBID_CONTENTS, Rt) : Le, q = Ea(ue, "FORBID_TAGS") && Qa(ue.FORBID_TAGS) ? Wt({}, ue.FORBID_TAGS, Rt) : vn({}), re = Ea(ue, "FORBID_ATTR") && Qa(ue.FORBID_ATTR) ? Wt({}, ue.FORBID_ATTR, Rt) : vn({}), At = Ea(ue, "USE_PROFILES") ? ue.USE_PROFILES && typeof ue.USE_PROFILES == "object" ? vn(ue.USE_PROFILES) : ue.USE_PROFILES : !1, Pe = ue.ALLOW_ARIA_ATTR !== !1, be = ue.ALLOW_DATA_ATTR !== !1, ze = ue.ALLOW_UNKNOWN_PROTOCOLS || !1, Ae = ue.ALLOW_SELF_CLOSE_IN_ATTR !== !1, Ce = ue.SAFE_FOR_TEMPLATES || !1, He = ue.SAFE_FOR_XML !== !1, J = ue.WHOLE_DOCUMENT || !1, xe = ue.RETURN_DOM || !1, ye = ue.RETURN_DOM_FRAGMENT || !1, qe = ue.RETURN_TRUSTED_TYPE || !1, fe = ue.FORCE_BODY || !1, ut = ue.SANITIZE_DOM !== !1, Ue = ue.SANITIZE_NAMED_PROPS || !1, st = ue.KEEP_CONTENT !== !1, kt = ue.IN_PLACE || !1, Y = OV(ue.ALLOWED_URI_REGEXP) ? ue.ALLOWED_URI_REGEXP : N0, ne = typeof ue.NAMESPACE == "string" ? ue.NAMESPACE : se, Ft = Ea(ue, "MATHML_TEXT_INTEGRATION_POINTS") && ue.MATHML_TEXT_INTEGRATION_POINTS && typeof ue.MATHML_TEXT_INTEGRATION_POINTS == "object" ? vn(ue.MATHML_TEXT_INTEGRATION_POINTS) : Wt({}, ["mi", "mo", "mn", "ms", "mtext"]), Lt = Ea(ue, "HTML_INTEGRATION_POINTS") && ue.HTML_INTEGRATION_POINTS && typeof ue.HTML_INTEGRATION_POINTS == "object" ? vn(ue.HTML_INTEGRATION_POINTS) : Wt({}, ["annotation-xml"]);
    const je = Ea(ue, "CUSTOM_ELEMENT_HANDLING") && ue.CUSTOM_ELEMENT_HANDLING && typeof ue.CUSTOM_ELEMENT_HANDLING == "object" ? vn(ue.CUSTOM_ELEMENT_HANDLING) : ur(null);
    if (Q = ur(null), Ea(je, "tagNameCheck") && _a(je.tagNameCheck) && (Q.tagNameCheck = je.tagNameCheck), Ea(je, "attributeNameCheck") && _a(je.attributeNameCheck) && (Q.attributeNameCheck = je.attributeNameCheck), Ea(je, "allowCustomizedBuiltInElements") && typeof je.allowCustomizedBuiltInElements == "boolean" && (Q.allowCustomizedBuiltInElements = je.allowCustomizedBuiltInElements), Ce && (be = !1), ye && (xe = !0), At && (G = Wt({}, T_), R = ur(null), At.html === !0 && (Wt(G, S_), Wt(R, C_)), At.svg === !0 && (Wt(G, Hp), Wt(R, qp), Wt(R, Tc)), At.svgFilters === !0 && (Wt(G, Kp), Wt(R, qp), Wt(R, Tc)), At.mathMl === !0 && (Wt(G, Vp), Wt(R, E_), Wt(R, Tc))), ae.tagCheck = null, ae.attributeCheck = null, Ea(ue, "ADD_TAGS") && (typeof ue.ADD_TAGS == "function" ? ae.tagCheck = ue.ADD_TAGS : Qa(ue.ADD_TAGS) && (G === we && (G = vn(G)), Wt(G, ue.ADD_TAGS, Rt))), Ea(ue, "ADD_ATTR") && (typeof ue.ADD_ATTR == "function" ? ae.attributeCheck = ue.ADD_ATTR : Qa(ue.ADD_ATTR) && (R === pe && (R = vn(R)), Wt(R, ue.ADD_ATTR, Rt))), Ea(ue, "ADD_URI_SAFE_ATTR") && Qa(ue.ADD_URI_SAFE_ATTR) && Wt(H, ue.ADD_URI_SAFE_ATTR, Rt), Ea(ue, "FORBID_CONTENTS") && Qa(ue.FORBID_CONTENTS) && (_t === Le && (_t = vn(_t)), Wt(_t, ue.FORBID_CONTENTS, Rt)), Ea(ue, "ADD_FORBID_CONTENTS") && Qa(ue.ADD_FORBID_CONTENTS) && (_t === Le && (_t = vn(_t)), Wt(_t, ue.ADD_FORBID_CONTENTS, Rt)), st && (G["#text"] = !0), J && Wt(G, ["html", "head", "body"]), G.table && (Wt(G, ["tbody"]), delete q.tbody), ue.TRUSTED_TYPES_POLICY) {
      if (typeof ue.TRUSTED_TYPES_POLICY.createHTML != "function")
        throw Sc('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
      if (typeof ue.TRUSTED_TYPES_POLICY.createScriptURL != "function")
        throw Sc('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
      z = ue.TRUSTED_TYPES_POLICY, P = z.createHTML("");
    } else
      z === void 0 && (z = jV(_, n)), z !== null && typeof P == "string" && (P = z.createHTML(""));
    ln && ln(ue), va = ue;
  }, _e = Wt({}, [...Hp, ...Kp, ...LV]), Ve = Wt({}, [...Vp, ...IV]), Je = function(ue) {
    let je = O(ue);
    (!je || !je.tagName) && (je = {
      namespaceURI: ne,
      tagName: "template"
    });
    const vt = Bl(ue.tagName), Se = Bl(je.tagName);
    return ht[ue.namespaceURI] ? ue.namespaceURI === L ? je.namespaceURI === se ? vt === "svg" : je.namespaceURI === Te ? vt === "svg" && (Se === "annotation-xml" || Ft[Se]) : !!_e[vt] : ue.namespaceURI === Te ? je.namespaceURI === se ? vt === "math" : je.namespaceURI === L ? vt === "math" && Lt[Se] : !!Ve[vt] : ue.namespaceURI === se ? je.namespaceURI === L && !Lt[Se] || je.namespaceURI === Te && !Ft[Se] ? !1 : !Ve[vt] && (ua[vt] || !_e[vt]) : !!(Ct === "application/xhtml+xml" && ht[ue.namespaceURI]) : !1;
  }, at = function(ue) {
    Dl(a.removed, {
      element: ue
    });
    try {
      O(ue).removeChild(ue);
    } catch {
      C(ue);
    }
  }, xt = function(ue, je) {
    try {
      Dl(a.removed, {
        attribute: je.getAttributeNode(ue),
        from: je
      });
    } catch {
      Dl(a.removed, {
        attribute: null,
        from: je
      });
    }
    if (je.removeAttribute(ue), ue === "is")
      if (xe || ye)
        try {
          at(je);
        } catch {
        }
      else
        try {
          je.setAttribute(ue, "");
        } catch {
        }
  }, Bt = function(ue) {
    let je = null, vt = null;
    if (fe)
      ue = "<remove></remove>" + ue;
    else {
      const ee = k_(ue, /^[\r\n\t ]+/);
      vt = ee && ee[0];
    }
    Ct === "application/xhtml+xml" && ne === se && (ue = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + ue + "</body></html>");
    const Se = z ? z.createHTML(ue) : ue;
    if (ne === se)
      try {
        je = new k().parseFromString(Se, Ct);
      } catch {
      }
    if (!je || !je.documentElement) {
      je = I.createDocument(ne, "template", null);
      try {
        je.documentElement.innerHTML = et ? P : Se;
      } catch {
      }
    }
    const Ie = je.body || je.documentElement;
    return ue && vt && Ie.insertBefore(t.createTextNode(vt), Ie.childNodes[0] || null), ne === se ? N.call(je, J ? "html" : "body")[0] : J ? je.documentElement : Ie;
  }, Ot = function(ue) {
    return F.call(
      ue.ownerDocument || ue,
      ue,
      // eslint-disable-next-line no-bitwise
      y.SHOW_ELEMENT | y.SHOW_COMMENT | y.SHOW_TEXT | y.SHOW_PROCESSING_INSTRUCTION | y.SHOW_CDATA_SECTION,
      null
    );
  }, It = function(ue) {
    return ue instanceof m && (typeof ue.nodeName != "string" || typeof ue.textContent != "string" || typeof ue.removeChild != "function" || !(ue.attributes instanceof g) || typeof ue.removeAttribute != "function" || typeof ue.setAttribute != "function" || typeof ue.namespaceURI != "string" || typeof ue.insertBefore != "function" || typeof ue.hasChildNodes != "function");
  }, Et = function(ue) {
    return typeof h == "function" && ue instanceof h;
  };
  function Dt(Ge, ue, je) {
    Ml(Ge, (vt) => {
      vt.call(a, ue, je, va);
    });
  }
  const aa = function(ue) {
    let je = null;
    if (Dt(M.beforeSanitizeElements, ue, null), It(ue))
      return at(ue), !0;
    const vt = Rt(ue.nodeName);
    if (Dt(M.uponSanitizeElement, ue, {
      tagName: vt,
      allowedTags: G
    }), He && ue.hasChildNodes() && !Et(ue.firstElementChild) && qa(/<[/\w!]/g, ue.innerHTML) && qa(/<[/\w!]/g, ue.textContent) || He && ue.namespaceURI === se && vt === "style" && Et(ue.firstElementChild) || ue.nodeType === Ol.progressingInstruction || He && ue.nodeType === Ol.comment && qa(/<[/\w]/g, ue.data))
      return at(ue), !0;
    if (q[vt] || !(ae.tagCheck instanceof Function && ae.tagCheck(vt)) && !G[vt]) {
      if (!q[vt] && Oe(vt) && (Q.tagNameCheck instanceof RegExp && qa(Q.tagNameCheck, vt) || Q.tagNameCheck instanceof Function && Q.tagNameCheck(vt)))
        return !1;
      if (st && !_t[vt]) {
        const Se = O(ue) || ue.parentNode, Ie = A(ue) || ue.childNodes;
        if (Ie && Se) {
          const ee = Ie.length;
          for (let ge = ee - 1; ge >= 0; --ge) {
            const De = $(Ie[ge], !0);
            Se.insertBefore(De, E(ue));
          }
        }
      }
      return at(ue), !0;
    }
    return ue instanceof v && !Je(ue) || (vt === "noscript" || vt === "noembed" || vt === "noframes") && qa(/<\/no(script|embed|frames)/i, ue.innerHTML) ? (at(ue), !0) : (Ce && ue.nodeType === Ol.text && (je = ue.textContent, Ml([j, U, de], (Se) => {
      je = rr(je, Se, " ");
    }), ue.textContent !== je && (Dl(a.removed, {
      element: ue.cloneNode()
    }), ue.textContent = je)), Dt(M.afterSanitizeElements, ue, null), !1);
  }, V = function(ue, je, vt) {
    if (re[je] || ut && (je === "id" || je === "name") && (vt in t || vt in ha))
      return !1;
    const Se = R[je] || ae.attributeCheck instanceof Function && ae.attributeCheck(je, ue);
    if (!(be && !re[je] && qa(ke, je))) {
      if (!(Pe && qa(ie, je))) {
        if (!Se || re[je]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !(Oe(ue) && (Q.tagNameCheck instanceof RegExp && qa(Q.tagNameCheck, ue) || Q.tagNameCheck instanceof Function && Q.tagNameCheck(ue)) && (Q.attributeNameCheck instanceof RegExp && qa(Q.attributeNameCheck, je) || Q.attributeNameCheck instanceof Function && Q.attributeNameCheck(je, ue)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            je === "is" && Q.allowCustomizedBuiltInElements && (Q.tagNameCheck instanceof RegExp && qa(Q.tagNameCheck, vt) || Q.tagNameCheck instanceof Function && Q.tagNameCheck(vt)))
          ) return !1;
        } else if (!H[je]) {
          if (!qa(Y, rr(vt, X, ""))) {
            if (!((je === "src" || je === "xlink:href" || je === "href") && ue !== "script" && w_(vt, "data:") === 0 && tt[ue])) {
              if (!(ze && !qa(ce, rr(vt, X, "")))) {
                if (vt)
                  return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, oe = Wt({}, ["annotation-xml", "color-profile", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "missing-glyph"]), Oe = function(ue) {
    return !oe[Bl(ue)] && qa(Z, ue);
  }, Ne = function(ue) {
    Dt(M.beforeSanitizeAttributes, ue, null);
    const {
      attributes: je
    } = ue;
    if (!je || It(ue))
      return;
    const vt = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: R,
      forceKeepAttr: void 0
    };
    let Se = je.length;
    for (; Se--; ) {
      const Ie = je[Se], {
        name: ee,
        namespaceURI: ge,
        value: De
      } = Ie, lt = Rt(ee), Ze = De;
      let ct = ee === "value" ? Ze : EV(Ze);
      if (vt.attrName = lt, vt.attrValue = ct, vt.keepAttr = !0, vt.forceKeepAttr = void 0, Dt(M.uponSanitizeAttribute, ue, vt), ct = vt.attrValue, Ue && (lt === "id" || lt === "name") && w_(ct, Ye) !== 0 && (xt(ee, ue), ct = Ye + ct), He && qa(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, ct)) {
        xt(ee, ue);
        continue;
      }
      if (lt === "attributename" && k_(ct, "href")) {
        xt(ee, ue);
        continue;
      }
      if (vt.forceKeepAttr)
        continue;
      if (!vt.keepAttr) {
        xt(ee, ue);
        continue;
      }
      if (!Ae && qa(/\/>/i, ct)) {
        xt(ee, ue);
        continue;
      }
      Ce && Ml([j, U, de], (Zt) => {
        ct = rr(ct, Zt, " ");
      });
      const Ut = Rt(ue.nodeName);
      if (!V(Ut, lt, ct)) {
        xt(ee, ue);
        continue;
      }
      if (z && typeof _ == "object" && typeof _.getAttributeType == "function" && !ge)
        switch (_.getAttributeType(Ut, lt)) {
          case "TrustedHTML": {
            ct = z.createHTML(ct);
            break;
          }
          case "TrustedScriptURL": {
            ct = z.createScriptURL(ct);
            break;
          }
        }
      if (ct !== Ze)
        try {
          ge ? ue.setAttributeNS(ge, ee, ct) : ue.setAttribute(ee, ct), It(ue) ? at(ue) : __(a.removed);
        } catch {
          xt(ee, ue);
        }
    }
    Dt(M.afterSanitizeAttributes, ue, null);
  }, Ee = function(ue) {
    let je = null;
    const vt = Ot(ue);
    for (Dt(M.beforeSanitizeShadowDOM, ue, null); je = vt.nextNode(); )
      Dt(M.uponSanitizeShadowNode, je, null), aa(je), Ne(je), je.content instanceof o && Ee(je.content);
    Dt(M.afterSanitizeShadowDOM, ue, null);
  };
  return a.sanitize = function(Ge) {
    let ue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, je = null, vt = null, Se = null, Ie = null;
    if (et = !Ge, et && (Ge = "<!-->"), typeof Ge != "string" && !Et(Ge) && (Ge = PV(Ge), typeof Ge != "string"))
      throw Sc("dirty is not a string, aborting");
    if (!a.isSupported)
      return Ge;
    if (me || ia(ue), a.removed = [], typeof Ge == "string" && (kt = !1), kt) {
      const De = Ge.nodeName;
      if (typeof De == "string") {
        const lt = Rt(De);
        if (!G[lt] || q[lt])
          throw Sc("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (Ge instanceof h)
      je = Bt("<!---->"), vt = je.ownerDocument.importNode(Ge, !0), vt.nodeType === Ol.element && vt.nodeName === "BODY" || vt.nodeName === "HTML" ? je = vt : je.appendChild(vt);
    else {
      if (!xe && !Ce && !J && // eslint-disable-next-line unicorn/prefer-includes
      Ge.indexOf("<") === -1)
        return z && qe ? z.createHTML(Ge) : Ge;
      if (je = Bt(Ge), !je)
        return xe ? null : qe ? P : "";
    }
    je && fe && at(je.firstChild);
    const ee = Ot(kt ? Ge : je);
    for (; Se = ee.nextNode(); )
      aa(Se), Ne(Se), Se.content instanceof o && Ee(Se.content);
    if (kt)
      return Ge;
    if (xe) {
      if (Ce) {
        je.normalize();
        let De = je.innerHTML;
        Ml([j, U, de], (lt) => {
          De = rr(De, lt, " ");
        }), je.innerHTML = De;
      }
      if (ye)
        for (Ie = W.call(je.ownerDocument); je.firstChild; )
          Ie.appendChild(je.firstChild);
      else
        Ie = je;
      return (R.shadowroot || R.shadowrootmode) && (Ie = K.call(s, Ie, !0)), Ie;
    }
    let ge = J ? je.outerHTML : je.innerHTML;
    return J && G["!doctype"] && je.ownerDocument && je.ownerDocument.doctype && je.ownerDocument.doctype.name && qa(B0, je.ownerDocument.doctype.name) && (ge = "<!DOCTYPE " + je.ownerDocument.doctype.name + `>
` + ge), Ce && Ml([j, U, de], (De) => {
      ge = rr(ge, De, " ");
    }), z && qe ? z.createHTML(ge) : ge;
  }, a.setConfig = function() {
    let Ge = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    ia(Ge), me = !0;
  }, a.clearConfig = function() {
    va = null, me = !1;
  }, a.isValidAttribute = function(Ge, ue, je) {
    va || ia({});
    const vt = Rt(Ge), Se = Rt(ue);
    return V(vt, Se, je);
  }, a.addHook = function(Ge, ue) {
    typeof ue == "function" && Dl(M[Ge], ue);
  }, a.removeHook = function(Ge, ue) {
    if (ue !== void 0) {
      const je = TV(M[Ge], ue);
      return je === -1 ? void 0 : CV(M[Ge], je, 1)[0];
    }
    return __(M[Ge]);
  }, a.removeHooks = function(Ge) {
    M[Ge] = [];
  }, a.removeAllHooks = function() {
    M = z_();
  }, a;
}
var WV = F0();
const YV = [
  "a",
  "abbr",
  "b",
  "bdi",
  "bdo",
  "blockquote",
  "br",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "dd",
  "del",
  "details",
  "dfn",
  "div",
  "dl",
  "dt",
  "em",
  "figcaption",
  "figure",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "hr",
  "i",
  "img",
  "ins",
  "kbd",
  "li",
  "mark",
  "ol",
  "p",
  "picture",
  "pre",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "small",
  "source",
  "span",
  "strike",
  "strong",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "time",
  "tr",
  "tt",
  "u",
  "ul",
  "var",
  "wbr"
], GV = [
  "abbr",
  "align",
  "alt",
  "cite",
  "class",
  "colspan",
  "datetime",
  "dir",
  "height",
  "href",
  "id",
  "lang",
  "loading",
  "media",
  "open",
  "rel",
  "reversed",
  "rowspan",
  "scope",
  "span",
  "src",
  "srcset",
  "start",
  "style",
  "target",
  "title",
  "valign",
  "width"
], XV = [
  "script",
  "iframe",
  "frame",
  "frameset",
  "object",
  "embed",
  "applet",
  "form",
  "input",
  "button",
  "select",
  "option",
  "textarea",
  "base",
  "meta",
  "link",
  "noscript",
  "template",
  "portal",
  "dialog"
], JV = ["action", "formaction", "srcdoc", "ping", "background", "poster"], ZV = {
  document: {
    ALLOWED_TAGS: YV,
    ALLOWED_ATTR: GV,
    // Ids a document brings are prefixed (`user-content-…`) so they can never
    // shadow a global the page reads (DOM clobbering).
    SANITIZE_NAMED_PROPS: !0
  },
  code: {
    ALLOWED_TAGS: ["span", "br"],
    ALLOWED_ATTR: ["class"]
  },
  diagram: {
    USE_PROFILES: { svg: !0, svgFilters: !0, html: !0 },
    // What Mermaid itself keeps when it sanitizes its output: HTML labels
    // live in <foreignObject> (an HTML integration point for them), and text
    // anchoring needs dominant-baseline.
    ADD_TAGS: ["foreignobject"],
    ADD_ATTR: ["dominant-baseline"],
    HTML_INTEGRATION_POINTS: { foreignobject: !0 }
  },
  math: {
    USE_PROFILES: { html: !0, mathMl: !0 }
  }
};
let jp = null;
function QV() {
  if (jp) return jp;
  if (typeof window > "u") return null;
  const e = WV(window);
  return e.isSupported ? (e.addHook("uponSanitizeAttribute", (a, t) => {
    if (t.attrName === "style") {
      const s = eq(t.attrValue);
      s === "" ? t.keepAttr = !1 : t.attrValue = s;
    }
  }), e.addHook("uponSanitizeElement", (a, t) => {
    t.tagName === "style" && a.textContent && (a.textContent = tq(a.textContent));
  }), e.addHook("afterSanitizeAttributes", (a) => {
    if (a.tagName === "A") {
      const t = a.getAttribute("target");
      t && t !== "_blank" && a.removeAttribute("target"), a.getAttribute("target") === "_blank" && a.setAttribute("rel", "noopener noreferrer");
    }
  }), jp = e, e) : null;
}
function eq(e) {
  return e.split(";").map((a) => a.trim()).filter((a) => a !== "" && !aq(a)).join("; ");
}
function tq(e) {
  return /\\/.test(e) ? "" : e.replace(/@import[^;]*;?/gi, "").replace(/url\s*\(\s*(['"]?)(?!#)[^)]*\)/gi, "none").replace(/image-set\s*\([^)]*\)/gi, "none").replace(/expression\s*\(/gi, "x(");
}
function aq(e) {
  return /\\/.test(e) || /expression\s*\(|@import|behavior\s*:|-moz-binding|image-set\s*\(|javascript:/i.test(e) ? !0 : (e.match(/url\s*\(\s*(['"]?)([^)'"]*)/gi) ?? []).some((t) => !/url\s*\(\s*['"]?#/i.test(t));
}
function nq(e) {
  return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}
function Ll(e, a = "document") {
  const t = QV();
  if (!t) return nq(e);
  const s = {
    ...ZV[a],
    FORBID_TAGS: XV,
    FORBID_ATTR: JV,
    ALLOW_UNKNOWN_PROTOCOLS: !1,
    RETURN_TRUSTED_TYPE: !1
  };
  return String(t.sanitize(e, s));
}
const sq = "/web-apps/apps/api/documents/api.js", oq = "/?embed=1&proto=json", iq = 1e4;
function rq(e) {
  return e.trim().replace(/\/+$/, "");
}
function lq(e, a) {
  return new Promise((t) => {
    const s = document.createElement("script");
    let n = !1;
    const o = (h) => {
      n || (n = !0, clearTimeout(p), s.remove(), t(h));
    }, p = setTimeout(() => o("timeout"), a);
    s.async = !0, s.src = e, s.onload = () => o("load"), s.onerror = () => o("error"), document.head.appendChild(s);
  });
}
function uq(e, a) {
  return new Promise((t) => {
    let s = null;
    try {
      s = new URL(e, window.location.href).origin;
    } catch {
      s = null;
    }
    const n = document.createElement("iframe");
    n.setAttribute("aria-hidden", "true"), n.style.cssText = "position:absolute;inset-inline-start:-9999px;width:1px;height:1px;border:0";
    let o = !1;
    const p = (y) => {
      o || (o = !0, clearTimeout(v), window.removeEventListener("message", h), n.remove(), t(y));
    }, h = (y) => {
      if (s && y.origin !== s) return;
      let g = y.data;
      if (typeof g == "string")
        try {
          g = JSON.parse(g);
        } catch {
          return;
        }
      g && typeof g == "object" && g.event === "init" && p("ready");
    };
    window.addEventListener("message", h);
    const v = setTimeout(() => p("timeout"), a);
    n.src = e, document.body.appendChild(n);
  });
}
async function cq(e) {
  try {
    return await fetch(e, { mode: "no-cors", cache: "no-store" }), !0;
  } catch {
    return !1;
  }
}
const dq = {
  loadScript: lq,
  loadFramed: uq,
  reachable: cq,
  hasDocsAPI: () => {
    var e;
    return !!((e = window.DocsAPI) != null && e.DocEditor);
  },
  pageProtocol: () => window.location.protocol,
  now: () => typeof performance < "u" ? performance.now() : Date.now()
};
function U0(e, a) {
  const t = rq(a);
  return t ? e === "onlyoffice" ? t + sq : e === "drawio" ? t + oq : "" : "";
}
async function Khe(e, a, t = {}) {
  const s = { ...dq, ...t.deps ?? {} }, n = t.timeoutMs ?? iq, o = U0(e, a ?? ""), p = e === "onlyoffice" ? "script" : e === "drawio" ? "iframe" : "none";
  if (!o)
    return { service: e, state: "skipped", url: "", ms: 0, mechanism: p };
  if (s.pageProtocol() === "https:" && o.startsWith("http://"))
    return { service: e, state: "blocked-mixed-content", url: o, ms: 0, mechanism: p };
  const h = s.now(), v = () => Math.round(s.now() - h);
  if (p === "script") {
    const y = await s.loadScript(o, n);
    if (y === "timeout") return { service: e, state: "timeout", url: o, ms: v(), mechanism: p };
    if (y === "load")
      return {
        service: e,
        state: s.hasDocsAPI() ? "ok" : "wrong-content",
        url: o,
        ms: v(),
        mechanism: p
      };
    const g = await s.reachable(o);
    return {
      service: e,
      state: g ? "wrong-content" : "unreachable",
      url: o,
      ms: v(),
      mechanism: p
    };
  }
  if (p === "iframe") {
    if (await s.loadFramed(o, n) === "ready") return { service: e, state: "ok", url: o, ms: v(), mechanism: p };
    const g = await s.reachable(o);
    return {
      service: e,
      state: g ? "wrong-content" : "unreachable",
      url: o,
      ms: v(),
      mechanism: p
    };
  }
  return { service: e, state: "skipped", url: "", ms: 0, mechanism: p };
}
const fq = 2 * 60 * 1e3;
function pq(e = fq, a = Date.now) {
  const t = /* @__PURE__ */ new Map();
  function s(n) {
    const o = t.get(n);
    o && clearTimeout(o.timer), t.delete(n);
  }
  return {
    recall(n) {
      const o = t.get(n);
      if (o) {
        if (o.expiresAt <= a()) {
          s(n);
          return;
        }
        return o.entries.map((p) => ({ ...p }));
      }
    },
    remember(n, o) {
      s(n);
      const p = {
        entries: o.map((h) => ({ ...h })),
        expiresAt: a() + e,
        timer: setTimeout(() => {
          t.get(n) === p && t.delete(n);
        }, e)
      };
      t.set(n, p);
    },
    forget: s,
    clear() {
      for (const n of t.values()) clearTimeout(n.timer);
      t.clear();
    }
  };
}
function H0(e, a) {
  const t = b(!1), s = b(null), n = b(null);
  let o = null;
  function p(g) {
    n.value = null, s.value = null;
    const m = o;
    o = null, m == null || m(g);
  }
  async function h(g) {
    const m = e();
    if (!m) return null;
    t.value = !0;
    try {
      const k = await m.save(g.key);
      if (k.saved) return { path: k.path, name: k.name, targetDir: k.targetDir };
      n.value = {
        key: g.key,
        name: k.name,
        suggested: k.suggested,
        folder: ed(k.targetDir)
      }, s.value = null;
    } finally {
      t.value = !1;
    }
    return new Promise((k) => {
      o = k;
    });
  }
  async function v() {
    const g = n.value, m = e();
    if (!(!g || !m || t.value)) {
      t.value = !0, s.value = null;
      try {
        const k = await m.save(g.key, g.suggested);
        if (k.saved) {
          p({ path: k.path, name: k.name, targetDir: k.targetDir });
          return;
        }
        n.value = { ...g, name: k.name || g.name, suggested: k.suggested };
      } catch (k) {
        s.value = a(k);
      } finally {
        t.value = !1;
      }
    }
  }
  function y() {
    t.value || p(null);
  }
  return { busy: t, error: s, question: n, save: h, confirm: v, cancel: y };
}
const vq = {
  class: "fe-draftq",
  "data-testid": "draft-close-dialog"
}, hq = { class: "fe-draftq__body" }, mq = { class: "fe-draftq__hint" }, yq = {
  key: 0,
  class: "fe-form__error",
  role: "alert"
}, gq = { class: "fe-draftq__actions" }, bq = ["disabled"], _q = ["disabled"], kq = ["disabled"], wq = /* @__PURE__ */ rt({
  __name: "DraftCloseModal",
  props: {
    open: { type: Boolean },
    locale: {},
    theme: {},
    name: {},
    folder: {},
    busy: { type: Boolean },
    error: {}
  },
  emits: ["cancel", "save", "keep", "discard"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n } = gt(() => t.locale), o = b(null);
    return Qe(
      () => t.open,
      (p) => {
        p && Jt(() => {
          var h;
          return (h = o.value) == null ? void 0 : h.focus();
        });
      },
      { immediate: !0 }
    ), (p, h) => (u(), nt(la, {
      open: e.open,
      locale: e.locale,
      theme: e.theme,
      title: r(n)("draft.close.title"),
      size: "sm",
      busy: e.busy,
      onClose: h[3] || (h[3] = (v) => s("cancel"))
    }, {
      actions: yt(() => [
        i("div", gq, [
          i("button", {
            type: "button",
            class: "fe-btn fe-btn--danger-quiet",
            disabled: e.busy,
            "data-testid": "draft-close-discard",
            onClick: h[0] || (h[0] = (v) => s("discard"))
          }, f(r(n)("draft.close.discard")), 9, bq),
          h[4] || (h[4] = i("span", {
            class: "fe-draftq__gap",
            "aria-hidden": "true"
          }, null, -1)),
          i("button", {
            type: "button",
            class: "fe-btn",
            disabled: e.busy,
            "data-testid": "draft-close-save",
            onClick: h[1] || (h[1] = (v) => s("save"))
          }, f(r(n)("draft.close.save")), 9, _q),
          i("button", {
            ref_key: "keepBtn",
            ref: o,
            type: "button",
            class: "fe-btn fe-btn--primary",
            disabled: e.busy,
            "data-fe-autofocus": "",
            "data-testid": "draft-close-keep",
            onClick: h[2] || (h[2] = (v) => s("keep"))
          }, f(r(n)("draft.close.keep")), 9, kq)
        ])
      ]),
      default: yt(() => [
        i("div", vq, [
          i("p", hq, f(r(n)("draft.close.body", { name: e.name, folder: e.folder })), 1),
          i("p", mq, f(r(n)("draft.close.hint")), 1),
          e.error ? (u(), d("p", yq, f(e.error), 1)) : T("", !0)
        ])
      ]),
      _: 1
    }, 8, ["open", "locale", "theme", "title", "busy"]));
  }
}), xq = {
  class: "fe-draftq",
  "data-testid": "draft-taken-dialog"
}, $q = { class: "fe-draftq__body" }, Sq = {
  key: 0,
  class: "fe-form__error",
  role: "alert"
}, Tq = ["disabled"], Cq = ["disabled", "aria-busy"], K0 = /* @__PURE__ */ rt({
  __name: "DraftConflictModal",
  props: {
    open: { type: Boolean },
    locale: {},
    theme: {},
    name: {},
    suggested: {},
    folder: {},
    busy: { type: Boolean },
    error: {}
  },
  emits: ["cancel", "confirm"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n } = gt(() => t.locale);
    return (o, p) => (u(), nt(la, {
      open: e.open,
      locale: e.locale,
      theme: e.theme,
      title: r(n)("draft.taken.title"),
      size: "sm",
      busy: e.busy,
      onClose: p[2] || (p[2] = (h) => s("cancel"))
    }, {
      actions: yt(() => [
        i("button", {
          type: "button",
          class: "fe-btn",
          disabled: e.busy,
          "data-testid": "draft-taken-cancel",
          onClick: p[0] || (p[0] = (h) => s("cancel"))
        }, f(r(n)("modal.rename.cancel")), 9, Tq),
        i("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: e.busy,
          "aria-busy": e.busy ? "true" : void 0,
          "data-testid": "draft-taken-confirm",
          onClick: p[1] || (p[1] = (h) => s("confirm"))
        }, f(r(n)("draft.taken.confirm", { name: e.suggested })), 9, Cq)
      ]),
      default: yt(() => [
        i("div", xq, [
          i("p", $q, f(r(n)("draft.taken.body", { name: e.name, folder: e.folder, suggested: e.suggested })), 1),
          e.error ? (u(), d("p", Sq, f(e.error), 1)) : T("", !0)
        ])
      ]),
      _: 1
    }, 8, ["open", "locale", "theme", "title", "busy"]));
  }
}), Eq = {
  key: 0,
  class: "fe-viewer__bar"
}, Aq = { class: "fe-viewer__ident" }, zq = ["innerHTML"], Mq = { class: "fe-viewer__idcol" }, Dq = ["title"], Pq = {
  key: 0,
  class: "fe-viewer__meta"
}, Oq = { class: "fe-viewer__acts" }, Lq = ["href", "title", "aria-label"], Iq = ["innerHTML"], Rq = ["title", "aria-label"], Nq = ["innerHTML"], Bq = ["disabled", "title", "aria-label"], Fq = ["innerHTML"], Uq = ["title", "aria-label"], Hq = ["innerHTML"], Kq = { class: "fe-viewer__tail" }, Vq = ["title", "aria-label"], qq = ["innerHTML"], jq = ["aria-label"], Wq = { class: "fe-draftbar__pill" }, Yq = { class: "fe-draftbar__text" }, Gq = {
  class: "fe-draftbar__target",
  "data-testid": "draft-bar-target"
}, Xq = {
  key: 0,
  class: "fe-draftbar__error",
  role: "alert",
  "data-testid": "draft-bar-error"
}, Jq = ["disabled", "aria-busy"], Zq = ["disabled"], Qq = {
  key: 1,
  class: "fe-draftbar__done",
  role: "status",
  "data-testid": "draft-saved-note"
}, ej = ["innerHTML"], tj = ["src", "alt"], aj = ["src"], nj = ["src"], sj = ["data"], oj = { class: "fe-preview__fallback" }, ij = ["innerHTML"], rj = ["href"], lj = {
  key: 0,
  class: "fe-preview__fallback"
}, uj = {
  key: 1,
  class: "fe-preview__fallback"
}, cj = ["href"], dj = {
  key: 2,
  class: "fe-preview__md-split"
}, fj = { class: "fe-preview__md-split-bar" }, pj = {
  key: 0,
  class: "fe-preview__md-split-error"
}, vj = {
  key: 1,
  class: "fe-preview__code-status",
  "data-testid": "draft-autosave"
}, hj = ["disabled"], mj = { class: "fe-preview__md-split-body" }, yj = ["onKeydown", "placeholder"], gj = {
  key: 0,
  class: "fe-preview__md-split-output fe-preview__md"
}, bj = ["innerHTML"], _j = {
  key: 3,
  class: "fe-preview__fallback"
}, kj = {
  key: 0,
  class: "fe-preview__error-detail",
  "data-testid": "preview-error-detail"
}, wj = ["href"], xj = ["innerHTML"], $j = {
  key: 5,
  class: "fe-preview__pre"
}, Sj = {
  key: 0,
  class: "fe-preview__fallback"
}, Tj = ["innerHTML"], Cj = ["href"], Ej = {
  key: 1,
  class: "fe-preview__fallback"
}, Aj = ["innerHTML"], zj = {
  key: 0,
  class: "fe-preview__fallback"
}, Mj = {
  key: 1,
  class: "fe-preview__fallback"
}, Dj = ["href"], Pj = {
  key: 2,
  class: "fe-preview__fallback"
}, Oj = {
  key: 0,
  class: "fe-preview__error-detail",
  "data-testid": "preview-error-detail"
}, Lj = ["href"], Ij = {
  key: 3,
  class: "fe-preview__code-wrap"
}, Rj = { class: "fe-preview__code-toolbar" }, Nj = {
  class: "fe-preview__code-lang",
  lang: "en"
}, Bj = {
  key: 0,
  class: "fe-preview__code-status"
}, Fj = {
  key: 1,
  class: "fe-preview__code-status fe-preview__code-status--ok"
}, Uj = ["innerHTML"], Hj = ["title"], Kj = ["innerHTML"], Vj = {
  key: 3,
  class: "fe-preview__code-status"
}, qj = ["disabled"], jj = {
  key: 0,
  class: "fe-preview__pre fe-preview__code hljs"
}, Wj = ["innerHTML"], Yj = ["data-lang"], Gj = {
  key: 0,
  class: "fe-preview__fallback",
  "data-testid": "office-fallback"
}, Xj = ["innerHTML"], Jj = ["href"], Zj = {
  key: 9,
  class: "fe-preview__fallback"
}, Qj = ["innerHTML"], eW = ["href"], tW = ["title", "aria-label"], aW = ["title", "aria-label"], nW = {
  key: 4,
  class: "fe-viewer__zoom"
}, sW = ["disabled", "title", "aria-label"], oW = ["title", "aria-label"], iW = ["disabled", "title", "aria-label"], rW = ["title", "aria-label"], lW = {
  viewBox: "0 0 24 24",
  width: "16",
  height: "16",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}, Wp = 1e6, M_ = "fe-onlyoffice-api-js", V0 = /* @__PURE__ */ rt({
  __name: "PreviewModal",
  props: {
    open: { type: Boolean },
    locale: {},
    file: {},
    previewUrl: { type: Function },
    downloadUrl: { type: Function },
    onlyOfficeBase: {},
    onlyOfficeConfigEndpoint: {},
    canConfigure: { type: Boolean },
    saveTextEndpoint: {},
    archiveListEndpoint: {},
    openMode: {},
    authHeaders: { type: Function },
    authCredentials: {},
    drawioUrl: {},
    pdfWorkerUrl: {},
    pdfSaveUrl: {},
    viewerBaseUrl: {},
    newTabEnabled: { type: Boolean },
    chromeless: { type: Boolean },
    theme: {},
    index: {},
    total: {},
    navEnabled: { type: Boolean },
    apiBase: {},
    shareEnabled: { type: Boolean },
    openAs: {},
    draftsEndpoint: {},
    appViewer: {},
    api: {},
    userName: {}
  },
  emits: ["close", "nav", "share", "starred", "draft-saved", "draft-discarded", "toast", "op"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n, formatSize: o, formatDate: p, nodeDisplayName: h } = gt(() => t.locale), v = pq();
    function y(Ke) {
      if (!Ke) return "";
      if (t.openAs && Ke === t.file) return t.openAs.toLowerCase();
      const Me = (Ke.extension || "").toLowerCase();
      return !E(Me) && cw(Ke.mime_type) ? "txt" : Me;
    }
    const g = ["jpg", "jpeg", "png", "webp", "gif", "bmp", "avif", "svg", "heic"], m = ["mp4", "webm", "mov", "mkv", "m4v", "ogv"], k = ["mp3", "wav", "ogg", "flac", "m4a", "aac", "opus"], _ = {
      md: "markdown",
      markdown: "markdown",
      txt: "plaintext",
      log: "plaintext",
      js: "javascript",
      mjs: "javascript",
      cjs: "javascript",
      ts: "typescript",
      tsx: "typescript",
      jsx: "javascript",
      vue: "xml",
      svelte: "xml",
      html: "xml",
      htm: "xml",
      xml: "xml",
      svg: "xml",
      css: "css",
      scss: "scss",
      sass: "scss",
      less: "less",
      json: "json",
      jsonc: "json",
      yml: "yaml",
      yaml: "yaml",
      php: "php",
      py: "python",
      rb: "ruby",
      go: "go",
      rs: "rust",
      java: "java",
      kt: "kotlin",
      swift: "swift",
      cpp: "cpp",
      c: "c",
      h: "cpp",
      hpp: "cpp",
      cs: "csharp",
      dart: "dart",
      sh: "bash",
      bash: "bash",
      zsh: "bash",
      fish: "bash",
      sql: "sql",
      toml: "ini",
      ini: "ini",
      conf: "ini",
      env: "bash",
      cfg: "ini",
      dockerfile: "dockerfile",
      graphql: "graphql",
      gql: "graphql",
      diff: "diff",
      patch: "diff"
    }, w = ["txt", "log"], $ = z1, C = {
      glb: () => import("./Viewer3D-B9X-r_ba.js"),
      gltf: () => import("./Viewer3D-B9X-r_ba.js"),
      obj: () => import("./Viewer3D-B9X-r_ba.js"),
      stl: () => import("./Viewer3D-B9X-r_ba.js"),
      fbx: () => import("./Viewer3D-B9X-r_ba.js"),
      "3ds": () => import("./Viewer3D-B9X-r_ba.js"),
      epub: () => import("./EpubViewer-CXQ0o275.js"),
      mmd: () => import("./MermaidViewer-BaRdZgG6.js"),
      mermaid: () => import("./MermaidViewer-BaRdZgG6.js"),
      drawio: () => import("./DrawioViewer-C2OB1y-B.js"),
      dio: () => import("./DrawioViewer-C2OB1y-B.js"),
      tif: () => import("./TiffViewer-DTOaDmN4.js"),
      tiff: () => import("./TiffViewer-DTOaDmN4.js"),
      psd: () => import("./PsdViewer-BTQM_EUr.js"),
      // PDF deliberately uses the native browser viewer (`kind === 'pdf'`
      // branch in the template). PdfViewer.vue still exists for callers
      // that want the rich custom UI but the SFC default keeps things
      // minimal — the browser already paints search/zoom/page UI for free.
      ipynb: () => import("./IpynbViewer-ByWZJJH6.js"),
      csv: () => import("./CsvViewer-BJO5GRk2.js"),
      tsv: () => import("./CsvViewer-BJO5GRk2.js"),
      zip: () => import("./ArchiveViewer-CLtGPxii.js"),
      "7z": () => import("./ArchiveViewer-CLtGPxii.js"),
      rar: () => import("./ArchiveViewer-CLtGPxii.js"),
      tar: () => import("./ArchiveViewer-CLtGPxii.js"),
      gz: () => import("./ArchiveViewer-CLtGPxii.js"),
      tgz: () => import("./ArchiveViewer-CLtGPxii.js"),
      bz2: () => import("./ArchiveViewer-CLtGPxii.js"),
      tbz2: () => import("./ArchiveViewer-CLtGPxii.js"),
      xz: () => import("./ArchiveViewer-CLtGPxii.js"),
      txz: () => import("./ArchiveViewer-CLtGPxii.js")
    };
    function E(Ke) {
      return Ke ? g.includes(Ke) || m.includes(Ke) || k.includes(Ke) || Ke === "pdf" || Ke === "md" || Ke === "markdown" || Ke in _ || Ke in C || $.includes(Ke) || w.includes(Ke) : !1;
    }
    const A = x(() => {
      var Ke;
      return (Ke = t.appViewer) != null && Ke.ui && t.api ? t.appViewer : null;
    }), O = b(null), z = b(!1), P = x(() => A.value ? jt(A.value.label, t.locale) || A.value.plugin : ""), I = x(
      () => t.file ? [{
        path: t.file.path,
        name: t.file.basename,
        size: t.file.size ?? void 0,
        mime: t.file.mime_type ?? void 0,
        // The storage takes no writes, or this person may only look: the
        // interface is told it cannot save, and a save is refused here too.
        readOnly: !!t.file.read_only || t.file.perm === "viewer" || t.file.perm === "none"
      }] : []
    );
    function F(Ke) {
      z.value = Ke, Ke && (Da.value = !0);
    }
    const W = x(() => {
      if (A.value) return "app";
      const Ke = y(t.file);
      if (!Ke) return "other";
      if (g.includes(Ke)) return "image";
      if (m.includes(Ke)) return "video";
      if (k.includes(Ke)) return "audio";
      if (Ke === "pdf") return "pdf";
      const Me = t.openMode !== "view";
      return Ke === "md" || Ke === "markdown" ? "markdown" : Ke in _ ? "code" : Ke in C ? "viewer" : $.includes(Ke) ? "office" : w.includes(Ke) ? Me ? "code" : "text" : "other";
    }), N = Dn(null), K = b(null), M = b(!1);
    async function j(Ke) {
      N.value = null, K.value = null;
      const Me = C[Ke];
      if (Me)
        try {
          const pt = await Me();
          N.value = pt.default ?? pt;
        } catch (pt) {
          K.value = L(pt, "err.viewer_failed").text, Ke === "pdf" && (M.value = !0);
        }
    }
    function U() {
      M.value = !0;
    }
    const de = x(() => {
      var pt;
      const Ke = y(t.file), Me = {
        url: we.value,
        ext: Ke,
        mime: (pt = t.file) == null ? void 0 : pt.mime_type,
        t: n,
        /* The viewer's language as a code, for the one thing `t` cannot give it:
           how a NUMBER is written (a size in the archive list). */
        locale: t.locale,
        authHeaders: t.authHeaders,
        authCredentials: t.authCredentials
      };
      return t.file && (Me.filePath = pe(t.file.path), ["zip", "rar", "7z", "tar", "gz", "tgz", "bz2", "tbz2", "xz", "txz"].includes(Ke) && (Me.filePath = t.file.path, t.archiveListEndpoint && (Me.archiveListUrl = t.archiveListEndpoint), Me.archivePreviewCache = v)), (Ke === "drawio" || Ke === "dio") && (Me.filePath = ks.value, Me.drawioUrl = t.drawioUrl ?? void 0, Me.canConfigure = t.canConfigure === !0, Me.saveUrl = t.saveTextEndpoint ?? void 0, Me.readOnly = t.openMode === "view"), Ke === "pdf" && (Me.pdfWorkerUrl = t.pdfWorkerUrl ?? void 0, Me.pdfSaveUrl = t.pdfSaveUrl ?? void 0), Me;
    });
    function ke() {
      ce(t.openMode || "edit");
    }
    function ie() {
      ce("edit");
    }
    function ce(Ke) {
      if (!t.file) return;
      const Me = y(t.file), pt = t.viewerBaseUrl || rT("/files/edit"), Nt = pt.includes("?") ? "&" : "?", Gt = A.value ? `&app=${encodeURIComponent(`${A.value.plugin}/${A.value.id}`)}` : "", $a = `${pt}${Nt}path=${encodeURIComponent(t.file.path)}&type=${encodeURIComponent(Me)}&mode=${encodeURIComponent(Ke)}` + Gt;
      window.open($a, "_blank", "noopener");
    }
    const X = /* @__PURE__ */ new Set([
      // OnlyOffice — open the in-page office editor (or new tab) with
      // edit permissions.
      "docx",
      "doc",
      "xlsx",
      "xls",
      "pptx",
      "ppt",
      "odt",
      "ods",
      "odp",
      "rtf",
      // Drawio / mermaid round-trip via the new-tab route.
      "drawio",
      "dio",
      "mmd",
      "mermaid",
      // Code / text / markdown — Monaco / split editor.
      "md",
      "markdown",
      "txt",
      "log",
      "json",
      "jsonc",
      "yaml",
      "yml",
      "xml",
      "svg",
      "html",
      "htm",
      "js",
      "mjs",
      "cjs",
      "ts",
      "tsx",
      "jsx",
      "vue",
      "svelte",
      "css",
      "scss",
      "sass",
      "less",
      "php",
      "py",
      "rb",
      "go",
      "rs",
      "java",
      "kt",
      "swift",
      "cpp",
      "c",
      "h",
      "hpp",
      "cs",
      "dart",
      "sh",
      "bash",
      "sql",
      "toml",
      "ini",
      "conf",
      "cfg",
      "env",
      "dockerfile",
      "graphql",
      "gql"
    ]), Z = x(
      () => !!t.file && X.has(y(t.file))
    ), Y = x(() => {
      const Ke = y(t.file);
      return $.includes(Ke) && !t.onlyOfficeBase ? "onlyoffice" : (Ke === "drawio" || Ke === "dio") && !t.drawioUrl ? "drawio" : "";
    }), G = x(
      () => Y.value === "onlyoffice" ? n("ctx.needs_onlyoffice") : Y.value === "drawio" ? n("ctx.needs_drawio") : n("viewer.edit")
    ), we = x(() => t.file ? t.previewUrl(t.file.path) : ""), R = x(() => t.file ? t.downloadUrl(ks.value) : "");
    function pe(Ke) {
      const Me = Ke.indexOf("://");
      return Me === -1 ? Ke : Ke.slice(Me + 3);
    }
    const Q = x(() => !t.chromeless), q = b(null), re = x(() => t.file ? sn(t.file) : ""), ae = x(() => t.file ? h(t.file) : ""), Pe = x(() => {
      const Ke = t.index, Me = t.total;
      return !Ke || !Me || Me < 1 || Ke < 1 ? "" : n("viewer.counter", { i: Ke, n: Me });
    }), be = x(() => {
      const Ke = t.file;
      if (!Ke) return "";
      const Me = [];
      typeof Ke.size == "number" && Ke.type === "file" && Me.push(o(Ke.size));
      const pt = p(Ke.last_modified);
      return pt && Me.push(pt), Pe.value && Me.push(Pe.value), Me.join(" • ");
    }), ze = x(
      () => Q.value && (t.navEnabled === !0 || (t.total ?? 0) > 1)
    ), Ae = x(
      () => {
        var Ke;
        return typeof ((Ke = t.file) == null ? void 0 : Ke.id) == "number" ? t.file.id : null;
      }
    ), Ce = /* @__PURE__ */ new Set(["pdf", "markdown", "code", "text", "office", "viewer"]), He = x(
      () => Ce.has(W.value) ? "fe-preview--fill" : "fe-preview--center"
    ), J = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 2, 3, 4], me = b(1), fe = b(null), xe = b(0), ye = x(() => Q.value && W.value === "image");
    function qe() {
      if (me.value !== 1 || !fe.value) return;
      const Ke = fe.value.getBoundingClientRect().width;
      Ke > 0 && (xe.value = Ke);
    }
    const ut = x(() => {
      if (!(me.value === 1 || !xe.value))
        return {
          width: `${Math.round(xe.value * me.value)}px`,
          height: "auto",
          maxWidth: "none",
          maxHeight: "none"
        };
    });
    function Ue(Ke) {
      const Me = me.value;
      if (Ke > 0)
        me.value = J.find((pt) => pt > Me + 1e-6) ?? J[J.length - 1];
      else {
        const pt = J.filter((Nt) => Nt < Me - 1e-6);
        me.value = pt.length ? pt[pt.length - 1] : J[0];
      }
    }
    function Ye() {
      me.value = 1, Jt(qe);
    }
    const st = x(() => `${Math.round(me.value * 100)}%`), kt = x(() => me.value < J[J.length - 1] - 1e-6), At = x(() => me.value > J[0] + 1e-6), _t = b(!1);
    function Le() {
      _t.value = !!document.fullscreenElement;
    }
    function tt() {
      var Ke, Me, pt;
      try {
        document.fullscreenElement ? (Ke = document.exitFullscreen) == null || Ke.call(document) : (pt = (Me = q.value) == null ? void 0 : Me.requestFullscreen) == null || pt.call(Me);
      } catch {
      }
    }
    function ve() {
      Q.value && Ws();
    }
    const H = b(!1), te = b(null), Te = b(null);
    function L(Ke, Me) {
      return ch(Ke, n(Me), { callerAdmin: t.canConfigure === !0 });
    }
    function se(Ke) {
      te.value = Ke.text, Te.value = Ke.detail ?? null;
    }
    const ne = b(""), et = b(!1), ht = b(!1), Tt = b(!1);
    let Ft, Lt;
    function ua() {
      ht.value = !0, Da.value = !0, Ft && clearTimeout(Ft), Ft = setTimeout(() => {
        ha(ne.value);
      }, 250), Lt && clearTimeout(Lt), Lt = setTimeout(() => {
        Ct();
      }, 1500);
    }
    async function Ct() {
      if (!t.saveTextEndpoint || !t.file || Tt.value) return;
      Tt.value = !0;
      const Ke = ne.value;
      te.value = null, Te.value = null;
      try {
        const Me = {
          "Content-Type": "application/json",
          ...await (t.authHeaders ?? (() => ({})))()
        }, pt = await fetch(t.saveTextEndpoint, {
          method: "POST",
          headers: Me,
          credentials: t.authCredentials || "same-origin",
          // ⚠ The adapter-qualified path. It was sent stripped since v0.1, and
          // save-text then resolved the bare path against the FIRST storage — an
          // edit to a file on any other storage was written to the first one
          // (found with drafts, issue #71, which live on every storage).
          body: JSON.stringify({ path: ks.value, content: ne.value })
        });
        if (!pt.ok)
          throw tn(pt.status, await pt.text().catch(() => ""), t.locale);
        Ke === ne.value && (ht.value = !1);
      } catch (Me) {
        se(L(Me, "err.save_failed"));
      } finally {
        Tt.value = !1;
      }
    }
    async function Qt(Ke) {
      H.value = !0, te.value = null, Te.value = null, ne.value = "", et.value = !1;
      try {
        const Me = {};
        t.authHeaders && Object.assign(Me, await t.authHeaders());
        const pt = await fetch(Ke, {
          credentials: t.authCredentials || "same-origin",
          headers: Me
        });
        if (!pt.ok)
          throw tn(pt.status, await pt.text().catch(() => ""), t.locale);
        if (Number(pt.headers.get("content-length") || "0") > Wp) {
          et.value = !0;
          return;
        }
        const Gt = await pt.text();
        Gt.length > Wp ? (et.value = !0, ne.value = Gt.slice(0, Wp)) : ne.value = Gt;
      } catch (Me) {
        se(L(Me, "err.load_failed"));
      } finally {
        H.value = !1;
      }
    }
    const ta = b(""), Rt = b(null), va = b(!1);
    async function ha(Ke) {
      try {
        const Me = await import(
          /* @vite-ignore */
          "markdown-it"
        ).catch(() => null);
        if (!Me) {
          ta.value = "", va.value = !0;
          return;
        }
        va.value = !1;
        const pt = Me.default ?? Me, Gt = new pt({
          html: !0,
          linkify: !0,
          breaks: !0,
          typographer: !0
        }).render(Ke);
        ta.value = Ll(Gt, "document"), await new Promise(($a) => setTimeout($a, 0)), await _a();
      } catch (Me) {
        ta.value = "", se(L(Me, "err.load_failed"));
      }
    }
    async function _a() {
      var Gt, $a, Ka;
      if (!Rt.value) return;
      const Ke = Rt.value, Me = Array.from(Ke.querySelectorAll("pre > code"));
      if (Me.length === 0) return;
      let pt, Nt;
      for (const Nn of Me) {
        const Ca = Nn.className || "", rf = /\blanguage-mermaid\b/.test(Ca) || /\blanguage-mmd\b/.test(Ca), Ys = /\blanguage-math\b/.test(Ca) || /\blanguage-latex\b/.test(Ca) || /\blanguage-tex\b/.test(Ca);
        if (rf) {
          if (pt === void 0)
            try {
              const Sa = await import(
                /* @vite-ignore */
                "mermaid"
              );
              pt = Sa.default ?? Sa, (Gt = pt.initialize) == null || Gt.call(pt, {
                startOnLoad: !1,
                securityLevel: "strict"
              });
            } catch {
              pt = null;
            }
          if (!pt) continue;
          try {
            const Sa = `filex-md-mermaid-${Math.random().toString(36).slice(2)}`, { svg: Yn } = await pt.render(Sa, Nn.textContent || ""), xi = document.createElement("div");
            xi.className = "fe-preview__md-mermaid", xi.innerHTML = Ll(Yn, "diagram"), ($a = Nn.parentElement) == null || $a.replaceWith(xi);
          } catch {
          }
        } else if (Ys) {
          if (Nt === void 0)
            try {
              const Sa = await import(
                /* @vite-ignore */
                "./katex-yuB6V-q6.js"
              );
              Nt = Sa.default ?? Sa;
            } catch {
              Nt = null;
            }
          if (!Nt) continue;
          try {
            const Sa = Nt.renderToString(Nn.textContent || "", {
              displayMode: !0,
              throwOnError: !1
            }), Yn = document.createElement("div");
            Yn.className = "fe-preview__md-math", Yn.innerHTML = Ll(Sa, "math"), (Ka = Nn.parentElement) == null || Ka.replaceWith(Yn);
          } catch {
          }
        }
      }
    }
    const ia = b("");
    async function _e(Ke, Me) {
      try {
        const pt = await ow();
        if (!pt) {
          ia.value = "";
          return;
        }
        const Nt = pt.default ?? pt;
        if (Nt.getLanguage(Me)) {
          const Gt = Nt.highlight(Ke, { language: Me, ignoreIllegals: !0 });
          ia.value = Ll(Gt.value, "code");
        } else {
          const Gt = Nt.highlightAuto(Ke);
          ia.value = Ll(Gt.value, "code");
        }
      } catch (pt) {
        ia.value = "", se(L(pt, "err.load_failed"));
      }
    }
    const Ve = b(null);
    let Je = null, at;
    const xt = b(!1), Bt = b(!1), Ot = b(!1), It = b(!1), Et = b(null), Dt = b(!1);
    function aa() {
      if (Je) {
        try {
          Je.dispose();
        } catch {
        }
        Je = null;
      }
      xt.value = !1, It.value = !1, Et.value = null;
    }
    function V(Ke) {
      return {
        js: "javascript",
        mjs: "javascript",
        cjs: "javascript",
        ts: "typescript",
        tsx: "typescript",
        jsx: "javascript",
        json: "json",
        jsonc: "json",
        css: "css",
        scss: "scss",
        sass: "scss",
        less: "less",
        html: "html",
        htm: "html",
        vue: "html",
        svelte: "html",
        xml: "xml",
        svg: "xml",
        md: "markdown",
        markdown: "markdown",
        php: "php",
        py: "python",
        yml: "yaml",
        yaml: "yaml",
        go: "go",
        rs: "rust",
        sql: "sql",
        cpp: "cpp",
        c: "c",
        h: "cpp",
        hpp: "cpp",
        sh: "shell",
        bash: "shell",
        dockerfile: "dockerfile",
        toml: "ini",
        ini: "ini",
        conf: "ini",
        cfg: "ini"
      }[Ke] ?? "plaintext";
    }
    async function oe(Ke, Me) {
      var Nt;
      const pt = await hv();
      if (pt || (Bt.value = !0), !pt || !Ve.value) return !1;
      try {
        aa();
        const Gt = !!t.saveTextEndpoint && t.openMode !== "view", $a = t.theme === "dark" ? !0 : t.theme === "light" ? !1 : (Nt = window.matchMedia) == null ? void 0 : Nt.call(window, "(prefers-color-scheme: dark)").matches;
        return Je = pt.editor.create(Ve.value, {
          value: Ke,
          language: V(Me),
          readOnly: !Gt,
          theme: $a ? "vs-dark" : "vs",
          automaticLayout: !0,
          minimap: { enabled: !1 },
          fontSize: 13
        }), Gt && (Je.addCommand(
          pt.KeyMod.CtrlCmd | pt.KeyCode.KeyS,
          () => void Oe()
        ), Je.onDidChangeModelContent(() => {
          Dt.value = !0, Da.value = !0, at && clearTimeout(at), at = setTimeout(() => {
            Oe();
          }, 1500);
        })), xt.value = !0, !0;
      } catch (Gt) {
        return se(L(Gt, "err.viewer_failed")), !1;
      }
    }
    async function Oe() {
      if (!(!t.saveTextEndpoint || !t.file) && t.openMode !== "view" && !Ot.value) {
        Ot.value = !0, It.value = !1, Et.value = null;
        try {
          const Ke = Je ? Je.getValue() : "", Me = { "Content-Type": "application/json" };
          t.authHeaders && Object.assign(Me, await t.authHeaders());
          const pt = await fetch(t.saveTextEndpoint, {
            method: "POST",
            headers: Me,
            credentials: t.authCredentials || "same-origin",
            // ⚠ Adapter-qualified — see saveMarkdown.
            body: JSON.stringify({
              path: ks.value,
              content: Ke
            })
          });
          if (!pt.ok)
            throw tn(pt.status, await pt.text().catch(() => ""), t.locale);
          (!Je || Je.getValue() === Ke) && (Dt.value = !1), It.value = !0, setTimeout(() => {
            It.value = !1;
          }, 2500);
        } catch (Ke) {
          const Me = L(Ke, "err.save_failed");
          Et.value = Me.detail ? `${Me.text}
${Me.detail}` : Me.text;
        } finally {
          Ot.value = !1;
        }
      }
    }
    async function Ne(Ke, Me, pt) {
      if (ne.value = "", ta.value = "", ia.value = "", te.value = null, Te.value = null, ue.value = null, N.value = null, K.value = null, M.value = !1, me.value = 1, xe.value = 0, ee(), aa(), !(!Ke || !Me)) {
        if (pt === "viewer") {
          await j(y(t.file));
          return;
        }
        if (pt === "markdown" || pt === "code" || pt === "text") {
          if (await Qt(Me), et.value) return;
          if (pt === "markdown") {
            await ha(ne.value);
            return;
          }
          const Nt = _[y(t.file)] || "";
          iw() ? (await new Promise((Ka) => setTimeout(Ka, 0)), await oe(ne.value, y(t.file)) || await _e(ne.value, Nt)) : (pt === "code" && await _e(ne.value, Nt), hv().then(async ($a) => {
            if (!$a) {
              Bt.value = !0;
              return;
            }
            t.open && (await new Promise((Ka) => setTimeout(Ka, 0)), await oe(ne.value, y(t.file)));
          }));
        } else pt === "office" && (await new Promise((Nt) => setTimeout(Nt, 0)), await Ie());
      }
    }
    Qe(
      () => [t.open, we.value, W.value, t.openMode],
      ([Ke, Me, pt]) => {
        Ne(Ke, Me, pt);
      }
    ), Kt(() => {
      document.addEventListener("fullscreenchange", Le), Jt(() => {
        t.open && Ne(t.open, we.value, W.value);
      });
    });
    const Ee = x(() => _[y(t.file)] || "plaintext"), Ge = b(null), ue = b(null);
    let je = null;
    function vt() {
      return n(t.canConfigure ? "viewer.office_unconfigured_admin" : "viewer.office_unconfigured");
    }
    async function Se(Ke) {
      let Me = "";
      try {
        Me = (await Ke.text()).slice(0, 200);
      } catch {
      }
      return console.warn("[filex] ONLYOFFICE config request failed", Ke.status, Me), Ke.status === 503 && /not configured/i.test(Me) ? vt() : Ke.status === 403 ? n("viewer.office_forbidden") : n("viewer.office_failed");
    }
    async function Ie() {
      if (ue.value = null, !(!t.file || W.value !== "office")) {
        if (!t.onlyOfficeConfigEndpoint || !t.onlyOfficeBase) {
          ue.value = vt();
          return;
        }
        if (Ge.value)
          try {
            const Ke = { "Content-Type": "application/json" };
            t.authHeaders && Object.assign(Ke, await t.authHeaders());
            const Me = await fetch(t.onlyOfficeConfigEndpoint, {
              method: "POST",
              headers: Ke,
              credentials: t.authCredentials || "same-origin",
              body: JSON.stringify({
                // Send the FULL adapter-qualified path. The backend resolves
                // `<adapter>://<rel>` against ListEnabledStorages; passing the
                // bare relative path falls back to storages[0] which 404s for
                // anything sitting on a non-primary storage (e.g. s3-test).
                path: t.file.path,
                mode: t.openMode || "edit"
              })
            });
            if (!Me.ok) {
              ue.value = await Se(Me);
              return;
            }
            const { config: pt, documentServerUrl: Nt } = await Me.json();
            await De(Nt), ee();
            const Gt = "fe-onlyoffice-mount";
            Ge.value.id = Gt, pt.events = {
              onError: (Ka) => {
                ue.value = ge(Ka);
              },
              // Drafts: the document server keeps the edits until the session ends
              // and then saves them into the draft itself; this only tells the page
              // there ARE edits (the leave-page question).
              onDocumentStateChange: (Ka) => {
                Ka != null && Ka.data && (Da.value = !0);
              }
            };
            const $a = window;
            if (!$a.DocsAPI || !$a.DocsAPI.DocEditor)
              throw new Error("DocsAPI not available after script load");
            je = new $a.DocsAPI.DocEditor(Gt, pt);
          } catch (Ke) {
            console.warn("[filex] ONLYOFFICE did not start", Ke), ue.value = n(t.canConfigure ? "viewer.office_unreachable_admin" : "viewer.office_unreachable");
          }
      }
    }
    function ee() {
      var Ke;
      try {
        (Ke = je == null ? void 0 : je.destroyEditor) == null || Ke.call(je);
      } catch {
      }
      je = null;
    }
    Mt(() => {
      document.removeEventListener("fullscreenchange", Le), ee(), aa(), v.clear();
    });
    function ge(Ke) {
      if (typeof Ke == "string") return Ke;
      const Me = Ke;
      if (Me != null && Me.data && typeof Me.data == "object") {
        const pt = Me.data;
        if (typeof pt.errorDescription == "string") return pt.errorDescription;
        if (typeof pt.message == "string") return pt.message;
        if (pt.errorCode !== void 0) return `OnlyOffice error ${pt.errorCode}`;
      }
      if (typeof (Me == null ? void 0 : Me.data) == "string") return Me.data;
      if (typeof (Me == null ? void 0 : Me.errorDescription) == "string") return Me.errorDescription;
      if (typeof (Me == null ? void 0 : Me.message) == "string") return Me.message;
      try {
        return JSON.stringify(Ke);
      } catch {
        return "OnlyOffice error";
      }
    }
    function De(Ke) {
      return new Promise((Me, pt) => {
        var $a;
        if (($a = window.DocsAPI) != null && $a.DocEditor) {
          Me();
          return;
        }
        const Nt = document.getElementById(M_);
        if (Nt) {
          Nt.addEventListener("load", () => Me()), Nt.addEventListener("error", () => pt(new Error("OnlyOffice api.js load failed")));
          return;
        }
        const Gt = document.createElement("script");
        Gt.id = M_, Gt.src = U0("onlyoffice", Ke), Gt.async = !0, Gt.onload = () => Me(), Gt.onerror = () => pt(new Error("OnlyOffice api.js load failed")), document.head.appendChild(Gt);
      });
    }
    async function lt(Ke, Me = {}) {
      const pt = { ...Me.headers ?? {} };
      return t.authHeaders && Object.assign(pt, await t.authHeaders()), fetch(Ke, { ...Me, headers: pt, credentials: t.authCredentials || "same-origin" });
    }
    const Ze = x(
      () => t.draftsEndpoint ? Rk(t.draftsEndpoint, { request: lt, locale: t.locale }) : null
    ), ct = x(() => t.draftsEndpoint && t.file ? ov(t.file.path) : ""), Ut = b(null), Zt = b(null), Da = b(!1), mn = x(() => !!Ut.value && !Zt.value), $o = x(() => Ut.value ? ed(Ut.value.target_dir) : ""), Rn = x(() => Zt.value ? ed(Zt.value.targetDir) : ""), _s = b(!1);
    let js;
    const Ua = b(!1), un = b(null), xa = b(!1), ks = x(() => {
      var Ke, Me;
      return ((Ke = Zt.value) == null ? void 0 : Ke.path) ?? ((Me = t.file) == null ? void 0 : Me.path) ?? "";
    });
    function ws(Ke) {
      return L(Ke, "err.save_failed").text;
    }
    const cn = H0(() => Ze.value, ws);
    Qe(
      () => [t.open, ct.value],
      async ([Ke, Me]) => {
        if (Ut.value = null, Zt.value = null, Da.value = !1, _s.value = !1, un.value = null, xa.value = !1, !(!Ke || !Me || !Ze.value))
          try {
            const pt = await Ze.value.get(Me);
            ct.value === Me && t.open && (Ut.value = pt);
          } catch {
            Ut.value = null;
          }
      },
      { immediate: !0 }
    );
    async function qr() {
      Lt && (clearTimeout(Lt), Lt = void 0), at && (clearTimeout(at), at = void 0);
      for (let Ke = 0; Ke < 100 && (Ot.value || Tt.value); Ke++)
        await new Promise((Me) => setTimeout(Me, 50));
      ht.value && W.value === "markdown" && await Ct(), Dt.value && Je && await Oe(), z.value && O.value && await O.value.requestSave();
    }
    async function Ws() {
      if (mn.value) {
        un.value = null, xa.value = !0;
        return;
      }
      W.value === "app" && O.value && !await O.value.confirmClose() || s("close");
    }
    function xn(Ke) {
      Zt.value = Ke, _s.value = !0, js && clearTimeout(js), js = setTimeout(() => {
        _s.value = !1;
      }, 5e3), s("draft-saved", Ke);
    }
    async function xs() {
      const Ke = Ut.value;
      if (!Ke || Ua.value) return !1;
      Ua.value = !0, un.value = null;
      try {
        await qr();
        const Me = await cn.save(Ke);
        return Me ? (xn(Me), !0) : !1;
      } catch (Me) {
        return un.value = ws(Me), !1;
      } finally {
        Ua.value = !1;
      }
    }
    async function So() {
      await xs() && (xa.value = !1, s("close"));
    }
    async function To() {
      Ua.value = !0;
      try {
        await qr();
      } finally {
        Ua.value = !1;
      }
      xa.value = !1, s("close");
    }
    async function Du() {
      const Ke = Ut.value, Me = Ze.value;
      if (!(!Ke || !Me || Ua.value)) {
        Ua.value = !0, un.value = null, Lt && clearTimeout(Lt), at && clearTimeout(at);
        try {
          await Me.discard(Ke.key), xa.value = !1, Ut.value = null, s("draft-discarded"), s("close");
        } catch (pt) {
          un.value = ws(pt);
        } finally {
          Ua.value = !1;
        }
      }
    }
    function Pu(Ke) {
      if (!t.open) return;
      if (z.value && W.value === "app") {
        Ke.preventDefault(), Ke.returnValue = "";
        return;
      }
      !mn.value || !(Da.value || ht.value || Dt.value || Ot.value || Tt.value || z.value) || (Ke.preventDefault(), Ke.returnValue = "");
    }
    function jr() {
      if (!t.open || !t.saveTextEndpoint || !t.file) return;
      let Ke = null;
      if (Dt.value && Je ? Ke = Je.getValue() : ht.value && W.value === "markdown" && (Ke = ne.value), Ke === null) return;
      const Me = t.saveTextEndpoint, pt = JSON.stringify({ path: ks.value, content: Ke }), Nt = (Gt) => {
        try {
          fetch(Me, {
            method: "POST",
            keepalive: !0,
            credentials: t.authCredentials || "same-origin",
            headers: { "Content-Type": "application/json", ...Gt },
            body: pt
          });
        } catch {
        }
      };
      (async () => Nt(t.authHeaders ? await t.authHeaders() : {}))();
    }
    return Kt(() => {
      window.addEventListener("beforeunload", Pu), window.addEventListener("pagehide", jr);
    }), Mt(() => {
      window.removeEventListener("beforeunload", Pu), window.removeEventListener("pagehide", jr), js && clearTimeout(js);
    }), (Ke, Me) => {
      var pt, Nt, Gt, $a, Ka;
      return u(), d(he, null, [
        ot(la, {
          open: e.open,
          size: "xl",
          title: ((pt = e.file) == null ? void 0 : pt.basename) || "",
          chromeless: e.chromeless,
          fullbleed: !e.chromeless,
          theme: e.theme,
          onClose: Ws
        }, {
          default: yt(() => {
            var Nn;
            return [
              i("div", {
                ref_key: "viewerEl",
                ref: q,
                class: Re(["fe-viewer", { "fe-viewer--bare": e.chromeless }])
              }, [
                Q.value && e.file ? (u(), d("header", Eq, [
                  i("div", Aq, [
                    i("span", {
                      class: "fe-viewer__tile",
                      "aria-hidden": "true",
                      innerHTML: re.value
                    }, null, 8, zq),
                    i("span", Mq, [
                      i("span", {
                        class: "fe-viewer__name",
                        title: e.file.path
                      }, f(ae.value), 9, Dq),
                      be.value ? (u(), d("span", Pq, f(be.value), 1)) : T("", !0)
                    ])
                  ]),
                  i("div", Oq, [
                    i("a", {
                      href: R.value,
                      class: "fe-viewer__act",
                      title: r(n)("viewer.download"),
                      "aria-label": r(n)("viewer.download")
                    }, [
                      i("span", {
                        class: "fe-icon",
                        "aria-hidden": "true",
                        innerHTML: r(wt)("download")
                      }, null, 8, Iq)
                    ], 8, Lq),
                    e.shareEnabled && !ct.value ? (u(), d("button", {
                      key: 0,
                      type: "button",
                      class: "fe-viewer__act",
                      title: r(n)("viewer.share"),
                      "aria-label": r(n)("viewer.share"),
                      onClick: Me[0] || (Me[0] = (Ca) => s("share"))
                    }, [
                      i("span", {
                        class: "fe-icon",
                        "aria-hidden": "true",
                        innerHTML: r(wt)("access")
                      }, null, 8, Nq)
                    ], 8, Rq)) : T("", !0),
                    Ae.value !== null && !ct.value ? (u(), nt(nf, {
                      key: 1,
                      class: "fe-viewer__act fe-viewer__act--star",
                      starred: e.file.starred === !0,
                      "node-id": Ae.value,
                      "api-base": e.apiBase,
                      "auth-headers": e.authHeaders,
                      "auth-credentials": e.authCredentials,
                      locale: e.locale,
                      compact: "",
                      onChange: Me[1] || (Me[1] = (Ca) => s("starred", Ca))
                    }, null, 8, ["starred", "node-id", "api-base", "auth-headers", "auth-credentials", "locale"])) : T("", !0),
                    e.openMode === "view" && Z.value && e.newTabEnabled !== !1 && (!Y.value || e.canConfigure) ? (u(), d("button", {
                      key: 2,
                      type: "button",
                      class: "fe-viewer__act",
                      disabled: !!Y.value,
                      title: G.value,
                      "aria-label": G.value,
                      onClick: ie
                    }, [
                      i("span", {
                        class: "fe-icon",
                        "aria-hidden": "true",
                        innerHTML: r(wt)("rename")
                      }, null, 8, Fq)
                    ], 8, Bq)) : T("", !0),
                    e.newTabEnabled !== !1 ? (u(), d("button", {
                      key: 3,
                      type: "button",
                      class: "fe-viewer__act",
                      title: r(n)("viewer.open_in_new_tab"),
                      "aria-label": r(n)("viewer.open_in_new_tab"),
                      onClick: ke
                    }, [
                      i("span", {
                        class: "fe-icon",
                        "aria-hidden": "true",
                        innerHTML: r(wt)("open-tab")
                      }, null, 8, Hq)
                    ], 8, Uq)) : T("", !0)
                  ]),
                  i("div", Kq, [
                    i("button", {
                      type: "button",
                      class: "fe-viewer__act fe-viewer__close",
                      title: r(n)("viewer.close"),
                      "aria-label": r(n)("viewer.close"),
                      "data-testid": "viewer-close",
                      onClick: Ws
                    }, [
                      i("span", {
                        class: "fe-icon",
                        "aria-hidden": "true",
                        innerHTML: r(wt)("close")
                      }, null, 8, qq)
                    ], 8, Vq)
                  ])
                ])) : T("", !0),
                e.file && (mn.value || _s.value) ? (u(), d("div", {
                  key: 1,
                  class: Re(["fe-draftbar", { "fe-draftbar--saved": !mn.value }]),
                  role: "region",
                  "aria-label": r(n)("draft.badge"),
                  "data-testid": "draft-bar"
                }, [
                  mn.value && Ut.value ? (u(), d(he, { key: 0 }, [
                    i("span", Wq, f(r(n)("draft.badge")), 1),
                    i("span", Yq, [
                      i("bdi", null, f(Ut.value.name), 1),
                      i("span", Gq, f(r(n)("draft.bar.target", { folder: $o.value })), 1)
                    ]),
                    un.value ? (u(), d("span", Xq, f(un.value), 1)) : T("", !0),
                    Me[12] || (Me[12] = i("span", {
                      class: "fe-draftbar__gap",
                      "aria-hidden": "true"
                    }, null, -1)),
                    i("button", {
                      type: "button",
                      class: "fe-btn fe-btn--primary fe-btn--sm",
                      disabled: Ua.value,
                      "aria-busy": Ua.value ? "true" : void 0,
                      "data-testid": "draft-save",
                      onClick: xs
                    }, f(r(n)("draft.save")), 9, Jq),
                    e.chromeless ? (u(), d("button", {
                      key: 1,
                      type: "button",
                      class: "fe-btn fe-btn--sm",
                      disabled: Ua.value,
                      "data-testid": "draft-close",
                      onClick: Ws
                    }, f(r(n)("viewer.close")), 9, Zq)) : T("", !0)
                  ], 64)) : (u(), d("span", Qq, [
                    i("span", {
                      class: "fe-icon",
                      "aria-hidden": "true",
                      innerHTML: r(wt)("check")
                    }, null, 8, ej),
                    $t(" " + f(r(n)("draft.saved_to", { name: ((Nn = Zt.value) == null ? void 0 : Nn.name) ?? "", folder: Rn.value })), 1)
                  ]))
                ], 10, jq)) : T("", !0),
                i("div", {
                  class: "fe-viewer__stage",
                  onClick: ft(ve, ["self"])
                }, [
                  e.file ? (u(), d("div", {
                    key: 0,
                    class: Re(["fe-preview", He.value]),
                    onClick: ft(ve, ["self"])
                  }, [
                    W.value === "image" ? (u(), d("img", {
                      key: 0,
                      ref_key: "imgEl",
                      ref: fe,
                      src: we.value,
                      alt: e.file.basename,
                      class: "fe-preview__image",
                      style: Vt(ut.value),
                      onLoad: qe
                    }, null, 44, tj)) : W.value === "video" ? (u(), d("video", {
                      key: 1,
                      src: we.value,
                      controls: "",
                      preload: "metadata",
                      class: "fe-preview__video"
                    }, null, 8, aj)) : W.value === "audio" ? (u(), d("audio", {
                      key: 2,
                      src: we.value,
                      controls: "",
                      class: "fe-preview__audio"
                    }, null, 8, nj)) : W.value === "pdf" ? (u(), d("object", {
                      key: 3,
                      data: we.value,
                      type: "application/pdf",
                      class: "fe-preview__iframe"
                    }, [
                      i("div", oj, [
                        i("span", {
                          class: "fe-preview__fallback-icon",
                          "aria-hidden": "true",
                          innerHTML: re.value
                        }, null, 8, ij),
                        i("p", null, f(r(n)("viewer.pdf_inline_failed")), 1),
                        i("a", {
                          href: R.value,
                          class: "fe-btn fe-btn--primary",
                          target: "_blank",
                          rel: "noopener"
                        }, f(r(n)("viewer.open_in_new_tab")), 9, rj)
                      ])
                    ], 8, sj)) : W.value === "markdown" ? (u(), d(he, { key: 4 }, [
                      H.value ? (u(), d("div", lj, f(r(n)("viewer.loading")), 1)) : et.value ? (u(), d("div", uj, [
                        $t(f(r(n)("viewer.too_large")) + " ", 1),
                        i("a", {
                          href: R.value,
                          class: "fe-btn"
                        }, f(r(n)("viewer.download")), 9, cj)
                      ])) : e.openMode === "edit" && e.saveTextEndpoint ? (u(), d("div", dj, [
                        i("div", fj, [
                          Me[13] || (Me[13] = i("span", { class: "fe-preview__md-split-label" }, "MARKDOWN", -1)),
                          te.value ? (u(), d("span", pj, f(te.value), 1)) : T("", !0),
                          mn.value ? (u(), d("span", vj, f(Tt.value ? r(n)("viewer.saving") : ht.value ? r(n)("draft.editing") : r(n)("draft.kept")), 1)) : (u(), d("button", {
                            key: 2,
                            type: "button",
                            class: "fe-btn fe-btn--primary",
                            disabled: !ht.value || Tt.value,
                            onClick: Ct
                          }, f(Tt.value ? r(n)("viewer.saving") : ht.value ? r(n)("viewer.save") : r(n)("viewer.saved")), 9, hj))
                        ]),
                        i("div", mj, [
                          dt(i("textarea", {
                            class: "fe-preview__md-split-input",
                            "onUpdate:modelValue": Me[2] || (Me[2] = (Ca) => ne.value = Ca),
                            onInput: ua,
                            onKeydown: [
                              ya(ft(Ct, ["ctrl", "prevent"]), ["s"]),
                              ya(ft(Ct, ["meta", "prevent"]), ["s"])
                            ],
                            spellcheck: "false",
                            placeholder: r(n)("viewer.md_placeholder")
                          }, null, 40, yj), [
                            [St, ne.value]
                          ]),
                          va.value ? (u(), d("div", gj, f(r(n)("viewer.peer_not_installed")), 1)) : (u(), d("div", {
                            key: 1,
                            ref_key: "markdownEl",
                            ref: Rt,
                            class: "fe-preview__md-split-output fe-preview__md",
                            dir: "auto",
                            innerHTML: ta.value
                          }, null, 8, bj))
                        ])
                      ])) : te.value ? (u(), d("div", _j, [
                        i("p", null, f(te.value), 1),
                        Te.value ? (u(), d("p", kj, f(Te.value), 1)) : T("", !0),
                        i("a", {
                          href: R.value,
                          class: "fe-btn fe-btn--primary"
                        }, f(r(n)("viewer.download")), 9, wj)
                      ])) : ta.value ? (u(), d("div", {
                        key: 4,
                        ref_key: "markdownEl",
                        ref: Rt,
                        class: "fe-preview__md",
                        dir: "auto",
                        innerHTML: ta.value
                      }, null, 8, xj)) : (u(), d("pre", $j, f(ne.value), 1))
                    ], 64)) : W.value === "app" && A.value && A.value.ui && e.api ? (u(), nt(tf, {
                      ref_key: "appFrameRef",
                      ref: O,
                      key: `${A.value.plugin}/${A.value.id}/${e.file.path}`,
                      class: "fe-preview__viewer",
                      api: e.api,
                      app: A.value.plugin,
                      version: A.value.ui.version,
                      view: A.value.id,
                      placement: "viewer",
                      ui: A.value.ui,
                      files: I.value,
                      "save-path": ks.value,
                      "read-only": e.openMode === "view",
                      locale: e.locale,
                      theme: e.theme,
                      "user-name": e.userName,
                      title: P.value,
                      onDirty: F,
                      onSaved: Me[3] || (Me[3] = (Ca) => Da.value = !0),
                      onToast: Me[4] || (Me[4] = (Ca) => s("toast", Ca.text)),
                      onOp: Me[5] || (Me[5] = (Ca) => s("op", Ca)),
                      onClose: Ws
                    }, null, 8, ["api", "app", "version", "view", "ui", "files", "save-path", "read-only", "locale", "theme", "user-name", "title"])) : W.value === "viewer" ? (u(), d(he, { key: 6 }, [
                      K.value && !M.value ? (u(), d("div", Sj, [
                        i("span", {
                          class: "fe-preview__fallback-icon fe-preview__fallback-icon--alert",
                          "aria-hidden": "true",
                          innerHTML: r(wt)("alert")
                        }, null, 8, Tj),
                        i("p", null, f(K.value), 1),
                        i("a", {
                          href: R.value,
                          class: "fe-btn fe-btn--primary"
                        }, f(r(n)("viewer.download")), 9, Cj)
                      ])) : N.value ? (u(), nt(oh(N.value), Xc({ key: 2 }, de.value, {
                        class: "fe-preview__viewer",
                        onFallback: U,
                        onChange: Me[6] || (Me[6] = (Ca) => Da.value = !0),
                        onClose: Ws
                      }), null, 16)) : (u(), d("div", Ej, [
                        i("span", {
                          class: "fe-preview__fallback-icon fe-preview__fallback-icon--spin",
                          "aria-hidden": "true",
                          innerHTML: r(wt)("progress")
                        }, null, 8, Aj),
                        i("p", null, f(r(n)("viewer.loading")), 1)
                      ]))
                    ], 64)) : W.value === "code" || W.value === "text" ? (u(), d(he, { key: 7 }, [
                      H.value ? (u(), d("div", zj, f(r(n)("viewer.loading")), 1)) : et.value ? (u(), d("div", Mj, [
                        $t(f(r(n)("viewer.too_large")) + " ", 1),
                        i("a", {
                          href: R.value,
                          class: "fe-btn"
                        }, f(r(n)("viewer.download")), 9, Dj)
                      ])) : te.value ? (u(), d("div", Pj, [
                        i("p", null, f(te.value), 1),
                        Te.value ? (u(), d("p", Oj, f(Te.value), 1)) : T("", !0),
                        i("a", {
                          href: R.value,
                          class: "fe-btn fe-btn--primary"
                        }, f(r(n)("viewer.download")), 9, Lj)
                      ])) : (u(), d("div", Ij, [
                        i("div", Rj, [
                          i("span", Nj, f(Ee.value), 1),
                          !xt.value && ia.value ? (u(), d("span", Bj, f(e.saveTextEndpoint && !Bt.value ? r(n)("viewer.editor_loading") : r(n)("viewer.read_only")), 1)) : T("", !0),
                          It.value ? (u(), d("span", Fj, [
                            i("span", {
                              class: "fe-icon",
                              "aria-hidden": "true",
                              innerHTML: r(wt)("check")
                            }, null, 8, Uj),
                            $t(" " + f(mn.value ? r(n)("draft.kept") : r(n)("viewer.saved")), 1)
                          ])) : T("", !0),
                          Et.value ? (u(), d("span", {
                            key: 2,
                            class: "fe-preview__code-status fe-preview__code-status--err",
                            title: Et.value
                          }, [
                            i("span", {
                              class: "fe-icon",
                              "aria-hidden": "true",
                              innerHTML: r(wt)("close")
                            }, null, 8, Kj),
                            $t(" " + f(r(n)("viewer.save_error")), 1)
                          ], 8, Hj)) : T("", !0),
                          e.openMode === "view" ? (u(), d("span", Vj, f(r(n)("viewer.read_only")), 1)) : e.saveTextEndpoint && xt.value && !mn.value ? (u(), d("button", {
                            key: 4,
                            type: "button",
                            class: "fe-btn fe-btn--primary",
                            disabled: Ot.value,
                            onClick: Oe
                          }, f(Ot.value ? r(n)("viewer.saving") : r(n)("viewer.save")), 9, qj)) : T("", !0)
                        ]),
                        i("div", {
                          ref_key: "monacoEl",
                          ref: Ve,
                          class: Re(["fe-preview__code-editor", { "is-hidden": !xt.value }])
                        }, null, 2),
                        !xt.value && ia.value ? (u(), d("pre", jj, [
                          i("code", {
                            class: Re(`language-${Ee.value}`),
                            innerHTML: ia.value
                          }, null, 10, Wj)
                        ])) : !xt.value && !ia.value ? (u(), d("pre", {
                          key: 1,
                          class: "fe-preview__pre",
                          "data-lang": Ee.value
                        }, f(ne.value), 9, Yj)) : T("", !0)
                      ]))
                    ], 64)) : W.value === "office" ? (u(), d(he, { key: 8 }, [
                      ue.value ? (u(), d("div", Gj, [
                        i("span", {
                          class: "fe-preview__fallback-icon",
                          "aria-hidden": "true",
                          innerHTML: re.value
                        }, null, 8, Xj),
                        i("p", null, f(ue.value), 1),
                        i("a", {
                          href: R.value,
                          class: "fe-btn fe-btn--primary"
                        }, f(r(n)("viewer.download")), 9, Jj)
                      ])) : (u(), d("div", {
                        key: 1,
                        ref_key: "officeEl",
                        ref: Ge,
                        class: "fe-preview__office"
                      }, null, 512))
                    ], 64)) : (u(), d("div", Zj, [
                      i("span", {
                        class: "fe-preview__fallback-icon",
                        "aria-hidden": "true",
                        innerHTML: re.value
                      }, null, 8, Qj),
                      i("p", null, f(r(n)("viewer.no_preview")), 1),
                      i("a", {
                        href: R.value,
                        class: "fe-btn fe-btn--primary"
                      }, f(r(n)("viewer.download")), 9, eW)
                    ]))
                  ], 2)) : T("", !0)
                ]),
                ze.value ? (u(), d("button", {
                  key: 2,
                  type: "button",
                  class: "fe-viewer__chev fe-viewer__chev--prev",
                  title: r(n)("viewer.nav_prev"),
                  "aria-label": r(n)("viewer.nav_prev"),
                  onClick: Me[7] || (Me[7] = (Ca) => s("nav", -1))
                }, [...Me[14] || (Me[14] = [
                  i("svg", {
                    viewBox: "0 0 24 24",
                    width: "22",
                    height: "22",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "1.8",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "aria-hidden": "true",
                    focusable: "false"
                  }, [
                    i("path", { d: "M15 4.5L7.5 12 15 19.5" })
                  ], -1)
                ])], 8, tW)) : T("", !0),
                ze.value ? (u(), d("button", {
                  key: 3,
                  type: "button",
                  class: "fe-viewer__chev fe-viewer__chev--next",
                  title: r(n)("viewer.nav_next"),
                  "aria-label": r(n)("viewer.nav_next"),
                  onClick: Me[8] || (Me[8] = (Ca) => s("nav", 1))
                }, [...Me[15] || (Me[15] = [
                  i("svg", {
                    viewBox: "0 0 24 24",
                    width: "22",
                    height: "22",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "1.8",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "aria-hidden": "true",
                    focusable: "false"
                  }, [
                    i("path", { d: "M9 4.5L16.5 12 9 19.5" })
                  ], -1)
                ])], 8, aW)) : T("", !0),
                ye.value ? (u(), d("div", nW, [
                  i("button", {
                    type: "button",
                    class: "fe-viewer__zoom-btn",
                    disabled: !At.value,
                    title: r(n)("viewer.zoom_out"),
                    "aria-label": r(n)("viewer.zoom_out"),
                    onClick: Me[9] || (Me[9] = (Ca) => Ue(-1))
                  }, "−", 8, sW),
                  i("button", {
                    type: "button",
                    class: "fe-viewer__zoom-level",
                    title: r(n)("viewer.zoom_reset"),
                    "aria-label": r(n)("viewer.zoom_reset"),
                    onClick: Ye
                  }, f(st.value), 9, oW),
                  i("button", {
                    type: "button",
                    class: "fe-viewer__zoom-btn",
                    disabled: !kt.value,
                    title: r(n)("viewer.zoom_in"),
                    "aria-label": r(n)("viewer.zoom_in"),
                    onClick: Me[10] || (Me[10] = (Ca) => Ue(1))
                  }, "+", 8, iW),
                  Me[24] || (Me[24] = i("span", {
                    class: "fe-viewer__zoom-sep",
                    "aria-hidden": "true"
                  }, null, -1)),
                  i("button", {
                    type: "button",
                    class: "fe-viewer__zoom-btn",
                    title: _t.value ? r(n)("viewer.exit_fullscreen") : r(n)("viewer.fullscreen"),
                    "aria-label": _t.value ? r(n)("viewer.exit_fullscreen") : r(n)("viewer.fullscreen"),
                    onClick: tt
                  }, [
                    (u(), d("svg", lW, [
                      _t.value ? (u(), d(he, { key: 0 }, [
                        Me[16] || (Me[16] = i("path", { d: "M9.5 4.5v5h-5" }, null, -1)),
                        Me[17] || (Me[17] = i("path", { d: "M14.5 4.5v5h5" }, null, -1)),
                        Me[18] || (Me[18] = i("path", { d: "M9.5 19.5v-5h-5" }, null, -1)),
                        Me[19] || (Me[19] = i("path", { d: "M14.5 19.5v-5h5" }, null, -1))
                      ], 64)) : (u(), d(he, { key: 1 }, [
                        Me[20] || (Me[20] = i("path", { d: "M4.5 9.5v-5h5" }, null, -1)),
                        Me[21] || (Me[21] = i("path", { d: "M19.5 9.5v-5h-5" }, null, -1)),
                        Me[22] || (Me[22] = i("path", { d: "M4.5 14.5v5h5" }, null, -1)),
                        Me[23] || (Me[23] = i("path", { d: "M19.5 14.5v5h-5" }, null, -1))
                      ], 64))
                    ]))
                  ], 8, rW)
                ])) : T("", !0)
              ], 2)
            ];
          }),
          _: 1
        }, 8, ["open", "title", "chromeless", "fullbleed", "theme"]),
        ot(wq, {
          open: xa.value,
          locale: e.locale,
          theme: e.theme,
          name: ((Nt = Ut.value) == null ? void 0 : Nt.name) ?? "",
          folder: $o.value,
          busy: Ua.value && !r(cn).question.value,
          error: un.value,
          onCancel: Me[11] || (Me[11] = (Nn) => xa.value = !1),
          onSave: So,
          onKeep: To,
          onDiscard: Du
        }, null, 8, ["open", "locale", "theme", "name", "folder", "busy", "error"]),
        ot(K0, {
          open: !!r(cn).question.value,
          locale: e.locale,
          theme: e.theme,
          name: ((Gt = r(cn).question.value) == null ? void 0 : Gt.name) ?? "",
          suggested: (($a = r(cn).question.value) == null ? void 0 : $a.suggested) ?? "",
          folder: ((Ka = r(cn).question.value) == null ? void 0 : Ka.folder) ?? "",
          busy: r(cn).busy.value,
          error: r(cn).error.value,
          onCancel: r(cn).cancel,
          onConfirm: r(cn).confirm
        }, null, 8, ["open", "locale", "theme", "name", "suggested", "folder", "busy", "error", "onCancel", "onConfirm"])
      ], 64);
    };
  }
}), uW = ["dir"], cW = {
  key: 0,
  class: "fe-ql-hint__sep"
}, dW = { class: "fe-ql-hint__seg" }, fW = /* @__PURE__ */ rt({
  __name: "QuickLook",
  props: {
    open: { type: Boolean },
    locale: {},
    file: {},
    previewUrl: { type: Function },
    downloadUrl: { type: Function },
    onlyOfficeBase: {},
    onlyOfficeConfigEndpoint: {},
    authHeaders: { type: Function },
    authCredentials: {},
    drawioUrl: {},
    pdfWorkerUrl: {},
    viewerBaseUrl: {},
    theme: {},
    index: {},
    total: {},
    apiBase: {},
    shareEnabled: { type: Boolean }
  },
  emits: ["close", "nav", "open-full", "share", "starred"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n, dir: o } = gt(() => t.locale), p = ["↑", "↓"];
    function h(y) {
      if (!t.open || Zk(y.target)) return;
      if (fv(y, "quicklook")) {
        y.preventDefault(), y.stopPropagation(), s("close");
        return;
      }
      if (fv(y, "open")) {
        y.preventDefault(), y.stopPropagation(), s("open-full");
        return;
      }
      if (y.ctrlKey || y.metaKey || y.altKey) return;
      const g = y.key === "ArrowDown" ? 1 : y.key === "ArrowUp" ? -1 : ti(y.key, o.value);
      g && (y.preventDefault(), y.stopPropagation(), s("nav", g));
    }
    const v = x(() => {
      const y = [], g = Ar("quicklook");
      g && y.push({ id: "quicklook", keys: [g], label: n("quicklook.hint_close") }), y.push({ id: "nav", keys: [...p], label: n("quicklook.hint_nav") });
      const m = Ar("open");
      return m && y.push({ id: "open", keys: [m], label: n("quicklook.hint_open") }), y;
    });
    return Qe(
      () => t.open,
      (y) => {
        y ? window.addEventListener("keydown", h, !0) : window.removeEventListener("keydown", h, !0);
      },
      { immediate: !0 }
    ), Mt(() => window.removeEventListener("keydown", h, !0)), (y, g) => (u(), d(he, null, [
      ot(V0, {
        class: "fe-quicklook",
        open: e.open,
        locale: e.locale,
        file: e.file,
        theme: e.theme,
        "preview-url": e.previewUrl,
        "download-url": e.downloadUrl,
        "only-office-base": e.onlyOfficeBase,
        "only-office-config-endpoint": e.onlyOfficeConfigEndpoint,
        "open-mode": "view",
        "auth-headers": e.authHeaders,
        "auth-credentials": e.authCredentials,
        "drawio-url": e.drawioUrl,
        "pdf-worker-url": e.pdfWorkerUrl,
        "viewer-base-url": e.viewerBaseUrl,
        index: e.index,
        total: e.total,
        "api-base": e.apiBase,
        "share-enabled": e.shareEnabled,
        "nav-enabled": !0,
        onClose: g[0] || (g[0] = (m) => s("close")),
        onNav: g[1] || (g[1] = (m) => s("nav", m)),
        onShare: g[2] || (g[2] = (m) => s("share")),
        onStarred: g[3] || (g[3] = (m) => s("starred", m))
      }, null, 8, ["open", "locale", "file", "theme", "preview-url", "download-url", "only-office-base", "only-office-config-endpoint", "auth-headers", "auth-credentials", "drawio-url", "pdf-worker-url", "viewer-base-url", "index", "total", "api-base", "share-enabled"]),
      (u(), nt(Hs, { to: "body" }, [
        ot(us, { name: "fe-toast" }, {
          default: yt(() => [
            e.open ? (u(), d("div", {
              key: 0,
              class: Re(["fe fe-ql-hint", {
                "fe--theme-light": e.theme === "light",
                "fe--theme-dark": e.theme === "dark"
              }]),
              dir: r(o),
              "aria-hidden": "true"
            }, [
              (u(!0), d(he, null, We(v.value, (m, k) => (u(), d(he, {
                key: m.id
              }, [
                k > 0 ? (u(), d("span", cW, "·")) : T("", !0),
                i("span", dW, [
                  (u(!0), d(he, null, We(m.keys, (_) => (u(), d("kbd", {
                    key: _,
                    class: "fe-kbd"
                  }, f(_), 1))), 128)),
                  $t(" " + f(m.label), 1)
                ])
              ], 64))), 128))
            ], 10, uW)) : T("", !0)
          ]),
          _: 1
        })
      ]))
    ], 64));
  }
}), pW = ["aria-label"], vW = { class: "fe-opc__head" }, hW = ["aria-label"], mW = { class: "fe-opc__body" }, yW = {
  key: 0,
  class: "fe-opc__section",
  "aria-live": "polite"
}, gW = { class: "fe-opc__section-title" }, bW = { class: "fe-opc__list" }, _W = {
  class: "fe-opc__kicon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}, kW = ["d"], wW = { class: "fe-opc__mid" }, xW = ["title"], $W = { class: "fe-opc__sub" }, SW = { class: "fe-opc__kind" }, TW = ["title"], CW = { class: "fe-opc__state" }, EW = {
  key: 0,
  class: "fe-opc__sub fe-opc__sub--detail",
  "data-testid": "opc-error-detail"
}, AW = ["aria-valuenow"], zW = {
  key: 0,
  class: "fe-opc__spin",
  "aria-hidden": "true"
}, MW = { class: "fe-opc__acts" }, DW = ["onClick"], PW = ["onClick"], OW = ["onClick"], LW = ["aria-label", "onClick"], IW = {
  key: 1,
  class: "fe-opc__section"
}, RW = { class: "fe-opc__section-title" }, NW = { class: "fe-opc__list fe-opc__list--history" }, BW = {
  class: "fe-opc__kicon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}, FW = ["d"], UW = { class: "fe-opc__mid" }, HW = ["title"], KW = {
  key: 0,
  class: "fe-opc__sub"
}, VW = ["title"], qW = {
  key: 1,
  class: "fe-opc__sub fe-opc__sub--err"
}, jW = {
  key: 2,
  class: "fe-opc__sub fe-opc__sub--detail",
  "data-testid": "opc-error-detail"
}, WW = ["onClick"], YW = {
  key: 2,
  class: "fe-opc__empty"
}, GW = ["aria-expanded", "aria-label"], XW = ["stroke-dashoffset"], JW = { class: "fe-opc__count" }, ZW = {
  key: 0,
  class: "fe-opc__pct"
}, Yp = 8.5, QW = /* @__PURE__ */ rt({
  __name: "OperationsCenter",
  props: {
    center: {},
    locale: {},
    narrow: { type: Boolean }
  },
  setup(e) {
    const a = e, { t, formatSize: s } = gt(() => a.locale), n = b(!1), o = b(null), p = x(() => a.center.active.value), h = x(() => a.center.history.value), v = x(() => a.center.hasError.value), y = x(() => a.center.overallPercent.value), g = x(() => a.center.runningCount.value), m = x(() => p.value.length > 0 || n.value && h.value.length > 0);
    Qe(m, (M) => {
      M || (n.value = !1);
    }), Qe(
      () => {
        var M;
        return ((M = a.center.revealRequests) == null ? void 0 : M.value) ?? 0;
      },
      (M, j) => {
        M > j && (n.value = !0);
      }
    );
    const k = 2 * Math.PI * Yp, _ = x(() => {
      const M = y.value;
      return M === null ? k * 0.72 : k * (1 - Math.min(100, Math.max(0, M)) / 100);
    }), w = x(() => y.value === null && g.value > 0), $ = x(() => g.value === 0 || y.value === null ? "" : t("opc.percent", { n: y.value })), C = x(() => t("opc.aria_badge", { n: p.value.length })), E = {
      upload: "M12 16V5M7 9.5 12 5l5 4.5M5 19h14",
      copy: "M9 9h11v11H9zM5 15V4h11",
      move: "M4 12h13M12 6l6 6-6 6",
      delete: "M5 7h14M9 7V5h6v2M8 7l1 13h6l1-13",
      /* A folder given a new name, and one brought back from the trash. */
      rename: "M4 20h4L18.5 9.5l-4-4L4 16zM13 7l4 4",
      restore: "M9 14 4 9l5-5M4 9h10.5a5.5 5.5 0 0 1 0 11H11",
      /* A trash entry taken out for good: the bin, crossed. */
      purge: "M5 7h14M9 7V5h6v2M8 7l1 13h6l1-13M10 11l4 5M14 11l-4 5",
      convert: "M20 8A8 8 0 0 0 6 6L4 8M4 16a8 8 0 0 0 14 2l2-2M20 3v5h-5M4 21v-5h5",
      archive: "M4 8V5h16v3zM5 8h14v12H5zM10 12h4",
      /* "Empty the trash" — the bin, with the lines of what is going. */
      trash: "M5 7h14M9 7V5h6v2M8 7l1 13h6l1-13M10.5 11v5M13.5 11v5",
      /* An app-plugin job — the puzzle piece its menu row wears (lib/actionIcons). */
      plugin: "M9.5 4.5a2 2 0 1 1 4 0h3a1.5 1.5 0 0 1 1.5 1.5v3a2 2 0 1 1 0 4v3a1.5 1.5 0 0 1-1.5 1.5h-3a2 2 0 1 1-4 0h-3A1.5 1.5 0 0 1 5 16v-3a2 2 0 1 1 0-4V6a1.5 1.5 0 0 1 1.5-1.5z",
      "archive-create": "M4 8V5h16v3zM5 8h14v12H5zM10 12h4",
      "archive-extract": "M4 8V5h16v3zM5 8h14v12H5zM10 12h4"
    };
    function A(M) {
      return t(`opc.kind.${M.kind}`);
    }
    function O(M) {
      return M.name || A(M);
    }
    function z(M) {
      return M.outputMode === "sibling" ? t("plugin.output.sibling") : M.outputMode === "version" ? t("plugin.output.version") : "";
    }
    function P(M) {
      return M.outputMode === "sibling" ? t("plugin.output.sibling_title") : M.outputMode === "version" ? t("plugin.output.version_title") : "";
    }
    function I(M) {
      return M.status === "running" ? M.cancelling ? t("opc.cancelling") : M.queued ? t("opc.queued") : M.message ? M.message : M.totalBytes && M.totalBytes > 0 ? `${s(M.uploadedBytes ?? 0)} / ${s(M.totalBytes)}` : (M.kind === "archive-create" || M.kind === "archive-extract") && M.percent !== null ? t("opc.percent", { n: M.percent }) : M.itemsTotal && M.itemsTotal > 0 ? t("opc.items", { done: M.itemsDone ?? 0, total: M.itemsTotal }) : M.percent !== null && M.totalCount && M.totalCount > 1 ? `${M.doneCount ?? 0}/${M.totalCount}` : t("opc.status.running") : M.status === "done" ? M.message || t("opc.status.done") : M.status === "aborted" ? t("opc.status.aborted") : M.error || t("opc.status.error");
    }
    function F(M) {
      return M.status === "done" && M.outputs.length > 0;
    }
    function W(M) {
      return t(`opc.status.${M.status === "running" ? "running" : M.status}`);
    }
    function N(M) {
      if (!n.value) return;
      const j = o.value;
      j && M.target instanceof Node && !j.contains(M.target) && (n.value = !1);
    }
    function K(M) {
      n.value && M.key === "Escape" && (n.value = !1);
    }
    return Kt(() => {
      document.addEventListener("mousedown", N), document.addEventListener("keydown", K);
    }), Mt(() => {
      document.removeEventListener("mousedown", N), document.removeEventListener("keydown", K);
    }), (M, j) => m.value ? (u(), d("div", {
      key: 0,
      ref_key: "rootEl",
      ref: o,
      class: Re(["fe-opc", { "fe-opc--narrow": e.narrow, "fe-opc--open": n.value }])
    }, [
      ot(us, { name: "fe-opc-pop" }, {
        default: yt(() => [
          n.value ? (u(), d("section", {
            key: 0,
            class: "fe-opc__panel",
            role: "dialog",
            "aria-label": r(t)("opc.title")
          }, [
            i("header", vW, [
              i("strong", null, f(r(t)("opc.title")), 1),
              i("button", {
                type: "button",
                class: "fe-opc__x",
                "aria-label": r(t)("opc.close"),
                onClick: j[0] || (j[0] = (U) => n.value = !1)
              }, "×", 8, hW)
            ]),
            i("div", mW, [
              p.value.length > 0 ? (u(), d("div", yW, [
                i("h3", gW, f(r(t)("opc.active")), 1),
                i("ul", bW, [
                  (u(!0), d(he, null, We(p.value, (U) => (u(), d("li", {
                    key: U.key,
                    class: Re(["fe-opc__item", `is-${U.status}`])
                  }, [
                    (u(), d("svg", _W, [
                      i("path", {
                        d: E[U.kind]
                      }, null, 8, kW)
                    ])),
                    i("div", wW, [
                      i("div", {
                        class: "fe-opc__name",
                        title: O(U)
                      }, f(O(U)), 9, xW),
                      i("div", $W, [
                        i("span", SW, f(A(U)), 1),
                        z(U) ? (u(), d(he, { key: 0 }, [
                          j[3] || (j[3] = i("span", {
                            class: "fe-opc__dot",
                            "aria-hidden": "true"
                          }, "·", -1)),
                          i("span", {
                            class: "fe-opc__outmode",
                            title: P(U),
                            "data-testid": "opc-output-mode"
                          }, f(z(U)), 9, TW)
                        ], 64)) : T("", !0),
                        j[4] || (j[4] = i("span", {
                          class: "fe-opc__dot",
                          "aria-hidden": "true"
                        }, "·", -1)),
                        i("span", CW, f(I(U)), 1)
                      ]),
                      U.status === "error" && U.errorDetail ? (u(), d("div", EW, f(U.errorDetail), 1)) : T("", !0),
                      U.status === "running" && U.percent !== null ? (u(), d("div", {
                        key: 1,
                        class: "fe-opc__bar",
                        role: "progressbar",
                        "aria-valuenow": U.percent,
                        "aria-valuemin": "0",
                        "aria-valuemax": "100"
                      }, [
                        i("div", {
                          class: "fe-opc__bar-fill",
                          style: Vt({ width: U.percent + "%" })
                        }, null, 4)
                      ], 8, AW)) : T("", !0)
                    ]),
                    U.status === "running" && U.percent === null && !U.queued ? (u(), d("span", zW)) : T("", !0),
                    i("div", MW, [
                      U.status === "running" && U.cancellable ? (u(), d("button", {
                        key: 0,
                        type: "button",
                        class: "fe-opc__act",
                        onClick: (de) => e.center.cancel(U.key)
                      }, f(r(t)("opc.cancel")), 9, DW)) : T("", !0),
                      F(U) ? (u(), d("button", {
                        key: 1,
                        type: "button",
                        class: "fe-opc__act",
                        "data-testid": "opc-open",
                        onClick: (de) => e.center.open(U.key)
                      }, f(r(t)("opc.open")), 9, PW)) : T("", !0),
                      U.status === "error" && U.retryable ? (u(), d("button", {
                        key: 2,
                        type: "button",
                        class: "fe-opc__act fe-opc__act--retry",
                        onClick: (de) => e.center.retry(U.key)
                      }, f(r(t)("opc.retry")), 9, OW)) : T("", !0),
                      U.status !== "running" ? (u(), d("button", {
                        key: 3,
                        type: "button",
                        class: "fe-opc__x",
                        "aria-label": r(t)("opc.dismiss"),
                        onClick: (de) => e.center.dismiss(U.key)
                      }, "×", 8, LW)) : T("", !0)
                    ])
                  ], 2))), 128))
                ])
              ])) : T("", !0),
              h.value.length > 0 ? (u(), d("div", IW, [
                i("h3", RW, [
                  $t(f(r(t)("opc.history")) + " ", 1),
                  i("button", {
                    type: "button",
                    class: "fe-opc__act",
                    onClick: j[1] || (j[1] = (U) => e.center.clearHistory())
                  }, f(r(t)("opc.clear")), 1)
                ]),
                i("ul", NW, [
                  (u(!0), d(he, null, We(h.value, (U) => (u(), d("li", {
                    key: "h-" + U.key,
                    class: Re(["fe-opc__item fe-opc__item--history", `is-${U.status}`])
                  }, [
                    (u(), d("svg", BW, [
                      i("path", {
                        d: E[U.kind]
                      }, null, 8, FW)
                    ])),
                    i("div", UW, [
                      i("div", {
                        class: "fe-opc__name",
                        title: O(U)
                      }, f(O(U)), 9, HW),
                      z(U) ? (u(), d("div", KW, [
                        i("span", {
                          class: "fe-opc__outmode",
                          title: P(U),
                          "data-testid": "opc-output-mode"
                        }, f(z(U)), 9, VW)
                      ])) : T("", !0),
                      U.status === "error" && U.error ? (u(), d("div", qW, f(U.error), 1)) : T("", !0),
                      U.status === "error" && U.errorDetail ? (u(), d("div", jW, f(U.errorDetail), 1)) : T("", !0)
                    ]),
                    F(U) ? (u(), d("button", {
                      key: 0,
                      type: "button",
                      class: "fe-opc__act",
                      onClick: (de) => e.center.open(U.key)
                    }, f(r(t)("opc.open")), 9, WW)) : T("", !0),
                    i("span", {
                      class: Re(["fe-opc__chip", `is-${U.status}`])
                    }, f(W(U)), 3)
                  ], 2))), 128))
                ])
              ])) : T("", !0),
              p.value.length === 0 && h.value.length === 0 ? (u(), d("p", YW, f(r(t)("opc.empty")), 1)) : T("", !0)
            ])
          ], 8, pW)) : T("", !0)
        ]),
        _: 1
      }),
      i("button", {
        type: "button",
        class: Re(["fe-opc__badge", { "is-error": v.value }]),
        "aria-expanded": n.value,
        "aria-label": C.value,
        onClick: j[2] || (j[2] = (U) => n.value = !n.value)
      }, [
        (u(), d("svg", {
          class: Re(["fe-opc__ring", { "fe-opc__ring--spin": w.value }]),
          viewBox: "0 0 22 22",
          "aria-hidden": "true",
          focusable: "false"
        }, [
          i("circle", {
            class: "fe-opc__ring-track",
            cx: "11",
            cy: "11",
            r: Yp,
            fill: "none",
            "stroke-width": "2.5"
          }),
          i("circle", {
            class: "fe-opc__ring-fill",
            cx: "11",
            cy: "11",
            r: Yp,
            fill: "none",
            "stroke-width": "2.5",
            "stroke-linecap": "round",
            "stroke-dasharray": k,
            "stroke-dashoffset": _.value,
            transform: "rotate(-90 11 11)"
          }, null, 8, XW)
        ], 2)),
        i("span", JW, f(p.value.length), 1),
        $.value ? (u(), d("span", ZW, f($.value), 1)) : T("", !0)
      ], 10, GW)
    ], 2)) : T("", !0);
  }
}), eY = 4e3, D_ = 50;
function tY(e, a, t) {
  const s = a.status !== "running";
  return {
    key: e,
    kind: a.kind,
    name: a.name,
    percent: a.percent,
    status: a.status,
    error: a.error ?? null,
    errorDetail: a.errorDetail ?? null,
    queued: a.queued ?? !1,
    cancelling: a.cancelling ?? !1,
    doneCount: a.doneCount ?? null,
    totalCount: a.totalCount ?? null,
    itemsDone: a.itemsDone ?? null,
    itemsTotal: a.itemsTotal ?? null,
    uploadedBytes: a.uploadedBytes ?? null,
    totalBytes: a.totalBytes ?? null,
    cancellable: a.cancellable ?? !1,
    retryable: a.retryable ?? !1,
    message: a.message ?? null,
    outputs: a.outputs ?? [],
    outputMode: a.outputMode ?? null,
    startedAt: (t == null ? void 0 : t.startedAt) ?? Date.now(),
    settledAt: (t == null ? void 0 : t.settledAt) ?? (s ? Date.now() : null)
  };
}
function aY() {
  const e = b([]), a = b([]), t = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Map();
  function o(z) {
    const P = n.get(z);
    P !== void 0 && (clearTimeout(P), n.delete(z));
  }
  function p(z, P = {}) {
    o(z);
    const I = e.value.findIndex((W) => W.key === z);
    if (I === -1) return;
    const [F] = e.value.splice(I, 1);
    e.value = [...e.value], s.add(z), P.toHistory !== !1 && (a.value = [{ ...F, settledAt: F.settledAt ?? Date.now() }, ...a.value].slice(
      0,
      D_
    ));
  }
  function h(z) {
    n.has(z) || n.set(
      z,
      setTimeout(() => {
        var I;
        n.delete(z);
        const P = t.get(z);
        p(z), (I = P == null ? void 0 : P.dismiss) == null || I.call(P);
      }, eY)
    );
  }
  function v(z, P) {
    const I = `${z}:`, F = /* @__PURE__ */ new Set();
    let W = [...e.value], N = !1;
    for (const K of P) {
      const M = `${z}:${K.input.id}`;
      if (F.add(M), K.actions && t.set(M, K.actions), s.has(M)) continue;
      const j = W.findIndex((de) => de.key === M), U = tY(M, K.input, j === -1 ? void 0 : W[j]);
      j === -1 ? (W = [U, ...W], N = !0) : JSON.stringify(W[j]) !== JSON.stringify(U) && (W[j] = U, N = !0), (U.status === "done" || U.status === "aborted") && h(M);
    }
    for (const K of [...W])
      !K.key.startsWith(I) || F.has(K.key) || K.status !== "error" && (o(K.key), W = W.filter((M) => M.key !== K.key), N = !0, K.status !== "running" && (s.add(K.key), a.value = [{ ...K, settledAt: K.settledAt ?? Date.now() }, ...a.value].slice(
        0,
        D_
      )));
    for (const K of [...s])
      K.startsWith(I) && !F.has(K) && s.delete(K);
    for (const K of [...t.keys()])
      if (K.startsWith(I) && !F.has(K) && !e.value.some((M) => M.key === K)) {
        if (W.some((M) => M.key === K) || a.value.some((M) => M.key === K && M.outputs.length > 0)) continue;
        t.delete(K);
      }
    N && (e.value = W);
  }
  function y(z) {
    var P, I;
    (I = (P = t.get(z)) == null ? void 0 : P.cancel) == null || I.call(P);
  }
  function g(z) {
    var I, F;
    const P = t.get(z);
    p(z), (I = P == null ? void 0 : P.dismiss) == null || I.call(P), (F = P == null ? void 0 : P.retry) == null || F.call(P);
  }
  function m(z) {
    var I;
    const P = t.get(z);
    p(z), (I = P == null ? void 0 : P.dismiss) == null || I.call(P);
  }
  function k(z, P) {
    var W, N;
    const I = e.value.find((K) => K.key === z) ?? a.value.find((K) => K.key === z), F = P ?? (I == null ? void 0 : I.outputs[0]);
    F && ((N = (W = t.get(z)) == null ? void 0 : W.open) == null || N.call(W, F));
  }
  function _() {
    a.value = [];
  }
  const w = b(0);
  function $() {
    w.value += 1;
  }
  const C = x(
    () => e.value.filter((z) => z.status === "running").length
  ), E = x(() => e.value.filter((z) => z.status === "error").length), A = x(() => E.value > 0), O = x(() => {
    const z = e.value.filter((F) => F.status === "running");
    let P = 0, I = 0;
    for (const F of z)
      F.percent !== null && (P += Math.min(1, Math.max(0, F.percent / 100)), I += 1);
    return I === 0 ? null : Math.round(P / I * 100);
  });
  return HS() && hk(() => {
    for (const z of n.values()) clearTimeout(z);
    n.clear();
  }), {
    active: e,
    history: a,
    runningCount: C,
    errorCount: E,
    hasError: A,
    overallPercent: O,
    sync: v,
    cancel: y,
    retry: g,
    dismiss: m,
    open: k,
    clearHistory: _,
    revealRequests: w,
    reveal: $
  };
}
const nY = ["dir", "data-prefers-dark", "aria-label"], sY = {
  key: 1,
  class: "fe-tour__dim",
  "aria-hidden": "true"
}, oY = {
  class: "fe-tour__progress",
  "aria-hidden": "true"
}, iY = { class: "fe-tour__title" }, rY = { class: "fe-tour__desc" }, lY = {
  class: "fe-tour__dots",
  "aria-hidden": "true"
}, uY = { class: "fe-tour__actions" }, po = 6, Os = 12, cY = /* @__PURE__ */ rt({
  __name: "OnboardingTour",
  props: {
    open: { type: Boolean },
    locale: {},
    root: {},
    theme: {}
  },
  emits: ["close"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n, dir: o } = gt(() => t.locale), p = x(() => ({
      palette: Ar("palette"),
      help: Ar("help")
    })), h = [
      {
        // The navigation panel: the standard views, then STORAGES, then
        // CONNECTIONS. At 390px it is a drawer that starts closed, so there is
        // nothing to spotlight and the button that opens it is the target.
        id: "nav",
        titleKey: "tour.step.nav.title",
        descKey: (U) => (U == null ? void 0 : U.dataset.testid) === "sidenav" ? "tour.step.nav.desc" : "tour.step.nav.desc_closed",
        target: (U) => U.querySelector('[data-testid="sidenav"]') || U.querySelector('[data-testid="toolbar-nav"]')
      },
      {
        // "+ New" — the menu that replaced the Upload / New folder pair. The
        // narrow shell has no panel on screen and draws the upload FAB instead,
        // which does ONE of the three things the menu offers, so it gets a
        // sentence that promises only that one.
        id: "new",
        titleKey: "tour.step.new.title",
        descKey: (U) => (U == null ? void 0 : U.dataset.testid) === "sidenav-new" ? "tour.step.new.desc" : "tour.step.new.desc_fab",
        target: (U) => U.querySelector('[data-testid="sidenav-new"]') || U.querySelector(".fe-fab")
      },
      {
        // ⚠ The FIELD, not `.fe-search__input`. The wide header's input carries
        // both class names and the narrow one carries only `fe-drivesearch__input`
        // — so the old selector resolved at 1440px and matched nothing at 390px,
        // where the field is the widest thing on the row. The testid is on the
        // wrapper in both layouts, and spotlighting the wrapper also takes in the
        // advanced-search and palette buttons the copy now names.
        id: "search",
        titleKey: "tour.step.search.title",
        descKey: "tour.step.search.desc",
        target: (U) => U.querySelector('[data-testid="drive-search"]')
      },
      {
        // The breadcrumb — this was the old first step's target while its title
        // said "Storages & folders", which is the panel. Now it has its own step
        // and its own title. Absent on Home, which has no address; the step drops
        // itself there rather than pointing at the heading that takes its place.
        id: "crumb",
        titleKey: "tour.step.crumb.title",
        descKey: "tour.step.crumb.desc",
        target: (U) => U.querySelector(".fe-breadcrumb")
      },
      {
        // The filter row. Unconditional in the shell now, but only drawn where
        // there is a listing to filter — not at the multi-storage virtual root,
        // which is where a first run usually starts, so this step is often the
        // one that drops itself.
        id: "filters",
        titleKey: "tour.step.filters.title",
        descKey: "tour.step.filters.desc",
        target: (U) => U.querySelector('[data-testid="filterbar"]')
      },
      {
        id: "view",
        titleKey: "tour.step.view.title",
        descKey: "tour.step.view.desc",
        // Still `.fe-toolbar__view`: ViewSwitcher kept its class when it moved
        // from the header to the breadcrumb row.
        target: (U) => U.querySelector(".fe-toolbar__view")
      },
      {
        // Sharing used to spotlight `.fe__body` — the whole listing, which is to
        // say nothing in particular — while talking about a context menu. The
        // details panel is where a share link is actually minted, so the step
        // points at the control that opens it and names the context menu too.
        id: "details",
        titleKey: "tour.step.details.title",
        descKey: "tour.step.details.desc",
        target: (U) => U.querySelector('[data-testid="subhead-inspector"]')
      },
      {
        id: "help",
        titleKey: "tour.step.help.title",
        descKey: "tour.step.help.desc",
        target: () => null
      }
    ], v = b([]), y = b(0), g = x(() => v.value[y.value] ?? null), m = x(() => v.value.length);
    function k() {
      const U = t.root;
      v.value = h.filter((de) => {
        if (de.id === "help") return !0;
        if (!U) return !1;
        const ke = de.target(U);
        if (!ke) return !1;
        const ie = ke.getBoundingClientRect();
        return ie.width > 0 && ie.height > 0;
      });
    }
    const _ = b(null), w = b({}), $ = b(null), C = b(null), E = x(() => {
      const U = g.value;
      if (!U) return "";
      const de = typeof U.descKey == "function" ? U.descKey(C.value) : U.descKey;
      return n(de, p.value);
    });
    async function A() {
      var He;
      const U = g.value, de = t.root;
      if (!U) return;
      const ke = de ? U.target(de) : null;
      if (C.value = ke, !ke) {
        _.value = null, w.value = {};
        return;
      }
      const ie = ke.getBoundingClientRect();
      if (ie.width <= 0 && ie.height <= 0) {
        _.value = null, w.value = {};
        return;
      }
      _.value = {
        top: ie.top - po,
        left: ie.left - po,
        width: ie.width + po * 2,
        height: ie.height + po * 2
      }, await Jt();
      const ce = window.innerWidth, X = window.innerHeight, Z = Math.min(340, ce - 24), Y = ((He = $.value) == null ? void 0 : He.offsetHeight) ?? 160, G = ie.top - po, we = ie.bottom + po, R = ie.left - po, pe = ie.right + po, Q = (J) => Math.min(Math.max(12, J), Math.max(12, ce - Z - 12)), q = (J) => Math.min(Math.max(12, J), Math.max(12, X - Y - 12)), re = Q(ie.left + ie.width / 2 - Z / 2), ae = q(ie.top + ie.height / 2 - Y / 2), Pe = { fits: pe + Os + Z <= ce - 12, left: pe + Os }, be = { fits: R - Os - Z >= 12, left: R - Os - Z }, ze = o.value === "rtl" ? [be, Pe] : [Pe, be];
      let Ae, Ce;
      we + Os + Y <= X - 12 ? (Ae = we + Os, Ce = re) : G - Os - Y >= 12 ? (Ae = G - Os - Y, Ce = re) : ze[0].fits ? (Ce = ze[0].left, Ae = ae) : ze[1].fits ? (Ce = ze[1].left, Ae = ae) : (Ae = q(we + Os), Ce = re), w.value = {
        top: `${Math.round(Ae)}px`,
        left: `${Math.round(Ce)}px`,
        width: `${Z}px`
      };
    }
    let O = 0;
    function z() {
      t.open && (O && cancelAnimationFrame(O), O = requestAnimationFrame(() => {
        O = requestAnimationFrame(() => {
          O = 0, Jt().then(A);
        });
      }));
    }
    function P() {
      if (y.value >= m.value - 1) {
        s("close");
        return;
      }
      y.value += 1;
    }
    function I() {
      y.value > 0 && (y.value -= 1);
    }
    function F() {
      s("close");
    }
    function W(U) {
      t.open && (U.key === "Escape" ? (U.stopPropagation(), F()) : U.key === "Enter" || ti(U.key, o.value) === 1 ? (U.preventDefault(), P()) : ti(U.key, o.value) === -1 && (U.preventDefault(), I()));
    }
    Qe(
      () => t.open,
      async (U) => {
        var de;
        U && (y.value = 0, k(), await Jt(), await A(), (de = $.value) == null || de.focus());
      }
    ), Qe(y, async () => {
      var U;
      await A(), (U = $.value) == null || U.focus();
    }), Kt(() => {
      window.addEventListener("resize", z), window.addEventListener("scroll", z, !0);
    }), Mt(() => {
      window.removeEventListener("resize", z), window.removeEventListener("scroll", z, !0), O && cancelAnimationFrame(O);
    });
    const N = b(!1);
    let K;
    function M(U) {
      N.value = !!(U && "matches" in U && U.matches);
    }
    Kt(() => {
      var U;
      typeof window > "u" || (K = window.matchMedia("(prefers-color-scheme: dark)"), M(K), (U = K.addEventListener) == null || U.call(K, "change", M));
    }), Mt(() => {
      var U;
      (U = K == null ? void 0 : K.removeEventListener) == null || U.call(K, "change", M);
    });
    const j = x(() => `fe-ctx-backdrop--theme-${t.theme || "auto"}`);
    return (U, de) => (u(), nt(Hs, { to: "body" }, [
      ot(us, { name: "fe-tour" }, {
        default: yt(() => [
          e.open && g.value ? (u(), d("div", {
            key: 0,
            class: Re(["fe-tour", j.value]),
            dir: r(o),
            "data-prefers-dark": N.value ? "1" : "0",
            role: "dialog",
            "aria-modal": "true",
            "aria-label": r(n)("tour.aria"),
            onKeydown: W
          }, [
            _.value ? (u(), d("div", {
              key: 0,
              class: "fe-tour__spot",
              style: Vt({
                top: _.value.top + "px",
                left: _.value.left + "px",
                width: _.value.width + "px",
                height: _.value.height + "px"
              }),
              "aria-hidden": "true"
            }, null, 4)) : (u(), d("div", sY)),
            i("div", {
              ref_key: "cardEl",
              ref: $,
              class: Re(["fe-tour__card", { "fe-tour__card--center": !_.value }]),
              style: Vt(_.value ? w.value : {}),
              tabindex: "-1"
            }, [
              i("p", oY, f(r(n)("tour.progress", { n: y.value + 1, m: m.value })), 1),
              i("h3", iY, f(r(n)(g.value.titleKey)), 1),
              i("p", rY, f(E.value), 1),
              i("div", lY, [
                (u(!0), d(he, null, We(v.value, (ke, ie) => (u(), d("span", {
                  key: ke.id,
                  class: Re(["fe-tour__dot", { "is-active": ie === y.value }])
                }, null, 2))), 128))
              ]),
              i("div", uY, [
                i("button", {
                  type: "button",
                  class: "fe-btn fe-tour__skip",
                  onClick: F
                }, f(r(n)("tour.skip")), 1),
                de[0] || (de[0] = i("span", { class: "fe-tour__actions-spacer" }, null, -1)),
                y.value > 0 ? (u(), d("button", {
                  key: 0,
                  type: "button",
                  class: "fe-btn",
                  onClick: I
                }, f(r(n)("tour.back")), 1)) : T("", !0),
                i("button", {
                  type: "button",
                  class: "fe-btn fe-btn--primary",
                  onClick: P
                }, f(y.value >= m.value - 1 ? r(n)("tour.done") : r(n)("tour.next")), 1)
              ])
            ], 6)
          ], 42, nY)) : T("", !0)
        ]),
        _: 1
      })
    ]));
  }
}), q0 = "filex.tourDone", P_ = "done", dY = 900, fY = 5e3;
function pY() {
  try {
    return !!localStorage.getItem(q0);
  } catch {
    return !0;
  }
}
function Gp() {
  return pY() || !!wi().tour;
}
let Jo = null;
function j0() {
  try {
    localStorage.setItem(q0, "1");
  } catch {
  }
  if (!om()) return;
  if (f0()) {
    wi().tour || pi("tour", P_);
    return;
  }
  if (Jo) return;
  const e = im((a) => {
    e(), Jo = null, a.tour || pi("tour", P_);
  });
  Jo = e;
}
function vY(e, a = {}) {
  const t = a.delayMs ?? dY, s = a.accountWaitMs ?? fY;
  let n = !1, o, p, h;
  const v = () => {
    n = !0, o && clearTimeout(o), p && clearTimeout(p), h == null || h();
  };
  if (Gp()) return v;
  const y = () => {
    p && clearTimeout(p), h == null || h(), !(n || Gp()) && (j0(), e());
  };
  return o = setTimeout(() => {
    if (!(n || Gp())) {
      if (!om() || qO()) {
        y();
        return;
      }
      p = setTimeout(y, s), h = jO(y);
    }
  }, t), v;
}
function Vhe() {
  Jo == null || Jo(), Jo = null;
}
const hY = ["aria-label"], mY = {
  key: 0,
  class: "fe-tabs__scroll"
}, yY = ["aria-selected", "title", "onClick", "onKeydown", "onAuxclick", "onDragstart", "onDragover", "onDragleave", "onDrop"], gY = {
  key: 0,
  class: "fe-tabs__splitdot",
  "aria-hidden": "true"
}, bY = { class: "fe-tabs__label" }, _Y = ["aria-label", "title", "onClick"], kY = ["aria-label", "title"], wY = ["aria-label", "title", "aria-pressed"], xY = ["aria-pressed", "title", "aria-label"], $Y = /* @__PURE__ */ rt({
  __name: "TabBar",
  props: {
    tabs: {},
    activeId: {},
    locale: {},
    splitEnabled: { type: Boolean },
    splitActive: { type: Boolean },
    inspectorEnabled: { type: Boolean },
    inspectorOpen: { type: Boolean },
    hideTabs: { type: Boolean }
  },
  emits: ["select", "close", "new", "reorder", "toggle-split", "toggle-inspector"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n } = gt(() => t.locale), o = b(null), p = b(null);
    function h(w, $) {
      var C;
      o.value = w, $.dataTransfer && ($.dataTransfer.effectAllowed = "move", $.dataTransfer.setData("text/plain", ((C = t.tabs[w]) == null ? void 0 : C.id) ?? ""));
    }
    function v(w, $) {
      o.value !== null && ($.preventDefault(), $.stopPropagation(), $.dataTransfer && ($.dataTransfer.dropEffect = "move"), p.value = w);
    }
    function y(w) {
      p.value === w && (p.value = null);
    }
    function g(w, $) {
      o.value !== null && ($.preventDefault(), $.stopPropagation(), o.value !== w && s("reorder", o.value, w), o.value = null, p.value = null);
    }
    function m() {
      o.value = null, p.value = null;
    }
    function k(w) {
      w.button === 1 && w.preventDefault();
    }
    function _(w, $) {
      $.button === 1 && ($.preventDefault(), $.stopPropagation(), !(t.tabs.length <= 1) && s("close", w));
    }
    return (w, $) => (u(), d("div", {
      class: "fe-tabs",
      role: "tablist",
      "aria-label": r(n)("tabs.strip")
    }, [
      e.hideTabs ? T("", !0) : (u(), d("div", mY, [
        (u(!0), d(he, null, We(e.tabs, (C, E) => (u(), d("div", {
          key: C.id,
          class: Re(["fe-tabs__tab", {
            "is-active": C.id === e.activeId,
            "is-dragover": p.value === E && o.value !== null && o.value !== E
          }]),
          role: "tab",
          "aria-selected": C.id === e.activeId ? "true" : "false",
          tabindex: "0",
          draggable: "true",
          title: C.label,
          onClick: (A) => s("select", C.id),
          onKeydown: ya(ft((A) => s("select", C.id), ["prevent"]), ["enter"]),
          onMousedown: $[0] || ($[0] = (A) => k(A)),
          onAuxclick: (A) => _(C.id, A),
          onDragstart: (A) => h(E, A),
          onDragover: (A) => v(E, A),
          onDragleave: (A) => y(E),
          onDrop: (A) => g(E, A),
          onDragend: m
        }, [
          C.split ? (u(), d("span", gY)) : T("", !0),
          i("span", bY, [
            i("bdi", null, f(C.label), 1)
          ]),
          e.tabs.length > 1 ? (u(), d("button", {
            key: 1,
            type: "button",
            class: "fe-tabs__close",
            "aria-label": r(n)("tabs.close"),
            title: r(n)("tabs.close"),
            onClick: ft((A) => s("close", C.id), ["stop"])
          }, "×", 8, _Y)) : T("", !0)
        ], 42, yY))), 128))
      ])),
      e.hideTabs ? T("", !0) : (u(), d("button", {
        key: 1,
        type: "button",
        class: "fe-tabs__new",
        "aria-label": r(n)("tabs.new"),
        title: r(n)("tabs.new"),
        onClick: $[1] || ($[1] = (C) => s("new"))
      }, "+", 8, kY)),
      e.splitEnabled !== !1 ? (u(), d("button", {
        key: 2,
        type: "button",
        class: Re(["fe-tabs__split", { "is-active": e.splitActive }]),
        "aria-label": e.splitActive ? r(n)("tabs.split_off") : r(n)("tabs.split"),
        title: e.splitActive ? r(n)("tabs.split_off") : r(n)("tabs.split"),
        "aria-pressed": e.splitActive ? "true" : "false",
        "data-testid": "tabs-split",
        onClick: $[2] || ($[2] = (C) => s("toggle-split"))
      }, [...$[4] || ($[4] = [
        i("svg", {
          class: "fe-ficon",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "1.8",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "aria-hidden": "true",
          focusable: "false"
        }, [
          i("rect", {
            x: "3",
            y: "4",
            width: "18",
            height: "16",
            rx: "2"
          }),
          i("path", { d: "M12 4v16" })
        ], -1)
      ])], 10, wY)) : T("", !0),
      e.inspectorEnabled ? (u(), d("button", {
        key: 3,
        type: "button",
        class: Re(["fe-tabs__inspector", { "is-active": e.inspectorOpen }]),
        "aria-pressed": e.inspectorOpen ? "true" : "false",
        title: r(n)("toolbar.inspector"),
        "aria-label": r(n)("toolbar.inspector"),
        "data-testid": "tabs-inspector",
        onClick: $[3] || ($[3] = (C) => s("toggle-inspector"))
      }, [...$[5] || ($[5] = [
        i("svg", {
          class: "fe-ficon",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "1.8",
          "stroke-linecap": "round",
          "aria-hidden": "true",
          focusable: "false"
        }, [
          i("circle", {
            cx: "12",
            cy: "12",
            r: "9"
          }),
          i("path", { d: "M12 11v5" }),
          i("circle", {
            cx: "12",
            cy: "7.6",
            r: "1",
            fill: "currentColor",
            stroke: "none"
          })
        ], -1)
      ])], 10, xY)) : T("", !0)
    ], 8, hY));
  }
}), W0 = Symbol("filex.e2eLock"), SY = ["width", "height"], TY = { class: "fe-state__title" }, CY = { class: "fe-state__hint" }, EY = ["placeholder", "aria-label", "disabled"], AY = ["disabled"], zY = {
  key: 0,
  class: "fe-form__error",
  role: "alert"
}, Y0 = /* @__PURE__ */ rt({
  __name: "E2eLockScreen",
  props: {
    locale: {},
    busy: { type: Boolean, default: !1 },
    error: { default: "" },
    showRecovery: { type: Boolean, default: !0 },
    compact: { type: Boolean, default: !1 }
  },
  emits: ["unlock", "recovery"],
  setup(e, { expose: a, emit: t }) {
    const s = e, n = t, { t: o } = gt(() => s.locale), p = b("");
    function h() {
      !p.value || s.busy || n("unlock", p.value);
    }
    return a({ clear: () => p.value = "" }), (v, y) => (u(), d("div", {
      class: Re(["fe-state fe-e2e-lock", { "fe-e2e-lock--compact": e.compact }]),
      "data-testid": "e2e-lock"
    }, [
      (u(), d("svg", {
        class: "fe-state__art",
        viewBox: "0 0 120 100",
        width: e.compact ? 80 : 110,
        height: e.compact ? 67 : 92,
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "aria-hidden": "true"
      }, [...y[2] || (y[2] = [
        i("rect", {
          x: "38",
          y: "44",
          width: "44",
          height: "34",
          rx: "6"
        }, null, -1),
        i("path", { d: "M46 44v-8a14 14 0 0 1 28 0v8" }, null, -1),
        i("circle", {
          cx: "60",
          cy: "59",
          r: "3",
          fill: "currentColor",
          stroke: "none"
        }, null, -1),
        i("path", { d: "M60 62v7" }, null, -1)
      ])], 8, SY)),
      i("p", TY, f(r(o)("e2e.locked.title")), 1),
      i("p", CY, f(r(o)("e2e.locked.hint")), 1),
      i("form", {
        class: "fe-e2e-lock__form",
        onSubmit: ft(h, ["prevent"])
      }, [
        dt(i("input", {
          "onUpdate:modelValue": y[0] || (y[0] = (g) => p.value = g),
          type: "password",
          class: "fe-input fe-e2e-lock__input",
          placeholder: r(o)("e2e.locked.pw_placeholder"),
          "aria-label": r(o)("e2e.locked.pw_placeholder"),
          autocomplete: "current-password",
          disabled: e.busy
        }, null, 8, EY), [
          [St, p.value]
        ]),
        i("button", {
          type: "submit",
          class: "fe-btn fe-btn--primary",
          disabled: e.busy || !p.value
        }, f(e.busy ? r(o)("e2e.locked.busy") : r(o)("e2e.locked.unlock")), 9, AY)
      ], 32),
      e.error ? (u(), d("p", zY, f(e.error), 1)) : T("", !0),
      e.showRecovery ? (u(), d("button", {
        key: 1,
        type: "button",
        class: "fe-e2e-optlink",
        onClick: y[1] || (y[1] = (g) => n("recovery"))
      }, f(r(o)("e2e.locked.use_recovery")), 1)) : T("", !0)
    ], 2));
  }
}), MY = ["aria-label"], DY = ["aria-current", "title", "aria-label"], PY = ["innerHTML"], OY = {
  key: 0,
  class: "fe-breadcrumb__sep",
  "aria-hidden": "true"
}, LY = ["aria-current", "onClick", "onContextmenu", "onDrop"], IY = {
  key: 0,
  class: "fe-breadcrumb__sep",
  "aria-hidden": "true"
}, RY = ["aria-expanded", "aria-label", "title"], NY = {
  key: 0,
  class: "fe-breadcrumb__menu",
  role: "menu"
}, BY = ["onClick"], FY = ["aria-current", "onClick", "onContextmenu", "onDrop"], UY = {
  key: 0,
  class: "fe-breadcrumb__sep",
  "aria-hidden": "true"
}, HY = ["aria-expanded", "title", "aria-label"], KY = ["innerHTML"], VY = {
  key: 0,
  class: "fe-breadcrumb__menu",
  role: "menu"
}, qY = ["onClick"], jY = {
  key: 0,
  class: "fe-breadcrumb__menu-empty"
}, WY = ["title", "aria-label"], YY = ["innerHTML"], GY = ["placeholder", "onKeydown"], XY = 4, JY = /* @__PURE__ */ rt({
  __name: "Breadcrumb",
  props: {
    dirname: {},
    adapter: {},
    rootLabel: {},
    locale: {},
    multiStorageRoot: { type: Boolean },
    rootPath: {},
    subfolders: {}
  },
  emits: ["navigate", "copy-path", "crumb-context", "crumb-drop"],
  setup(e, { emit: a }) {
    const t = e, s = x(() => {
      if (!t.rootPath) return "";
      const R = t.rootPath, pe = R.indexOf("://");
      return (pe >= 0 ? R.slice(pe + 3) : R).replace(/^\/+|\/+$/g, "");
    }), n = x(() => {
      const R = s.value;
      if (!R) return t.rootLabel || t.adapter;
      const pe = R.split("/");
      return pe[pe.length - 1] || t.rootLabel || t.adapter;
    }), { t: o } = gt(() => t.locale), p = On(Su, null), h = a, v = x(() => {
      const R = t.adapter ? `${t.adapter}://` : "", pe = R && t.dirname.startsWith(R) ? t.dirname.slice(R.length) : t.dirname, Q = pe.split("/").filter(Boolean), q = (Pe) => (p == null ? void 0 : p.segmentLabel(Pe)) ?? null, re = [];
      if (t.rootPath) {
        const Pe = s.value, be = pe.replace(/^\/+|\/+$/g, ""), ze = Pe && (be === Pe || be.startsWith(Pe + "/")) ? be.slice(Pe.length).replace(/^\/+/, "") : "";
        re.push({ label: n.value, adapterPath: t.rootPath });
        let Ae = Pe;
        for (const Ce of ze.split("/").filter(Boolean))
          Ae = Ae ? `${Ae}/${Ce}` : Ce, re.push({
            label: pd(Ce, o) || q(`${R}${Ae}`) || Ce,
            adapterPath: `${R}${Ae}`
          });
        return re;
      }
      t.multiStorageRoot ? (re.push({ label: "/", adapterPath: "" }), t.adapter && re.push({ label: t.rootLabel || t.adapter, adapterPath: R })) : (t.adapter || t.rootLabel) && re.push({
        label: t.rootLabel || t.adapter,
        adapterPath: R
      });
      let ae = "";
      for (const Pe of Q) {
        ae = ae ? `${ae}/${Pe}` : Pe;
        const be = pd(Pe, o) || q(`${R}${ae}`) || Pe;
        re.push({ label: be, adapterPath: `${R}${ae}` });
      }
      return re;
    }), y = x(() => {
      const R = v.value[0];
      return R && t.multiStorageRoot && R.adapterPath === "" ? R : null;
    }), g = x(
      () => y.value ? v.value.slice(1) : v.value
    ), m = x(() => !!y.value && g.value.length === 0), k = x(() => g.value.length > XY), _ = x(
      () => k.value ? g.value.slice(0, 1) : g.value
    ), w = x(
      () => k.value ? g.value.slice(1, -2) : []
    ), $ = x(
      () => k.value ? g.value.slice(-2) : []
    ), C = b(!1), E = b(null), A = b(!1), O = b(null), z = x(() => C.value || A.value);
    function P() {
      C.value = !1, A.value = !1;
    }
    function I(R) {
      P(), h("navigate", R.adapterPath);
    }
    function F() {
      C.value = !1, A.value = !A.value;
    }
    function W(R) {
      var Q, q;
      const pe = R.target;
      if (!(pe instanceof Node)) {
        P();
        return;
      }
      (Q = E.value) != null && Q.contains(pe) || (q = O.value) != null && q.contains(pe) || P();
    }
    function N(R) {
      R.key === "Escape" && (R.stopPropagation(), P());
    }
    Qe(z, (R) => {
      R ? (document.addEventListener("click", W, !0), document.addEventListener("keydown", N, !0)) : (document.removeEventListener("click", W, !0), document.removeEventListener("keydown", N, !0));
    }), Qe(v, P), Mt(() => {
      document.removeEventListener("click", W, !0), document.removeEventListener("keydown", N, !0);
    });
    function K(R) {
      h("navigate", R.adapterPath);
    }
    function M() {
      y.value && K(y.value);
    }
    function j(R) {
      y.value && de(R, y.value);
    }
    function U(R) {
      y.value && ie(R, y.value);
    }
    function de(R, pe) {
      R.preventDefault(), R.stopPropagation(), h("crumb-context", {
        x: R.clientX,
        y: R.clientY,
        adapterPath: pe.adapterPath,
        label: pe.label
      });
    }
    function ke(R) {
      Pn(R) && (R.preventDefault(), R.stopPropagation(), R.dataTransfer && (R.dataTransfer.dropEffect = "move"));
    }
    function ie(R, pe) {
      Pn(R) && (R.preventDefault(), R.stopPropagation(), h("crumb-drop", pe.adapterPath, R));
    }
    const ce = b(!1), X = b(""), Z = b(null);
    function Y() {
      const R = `${t.adapter}://`, pe = t.dirname.startsWith(R) ? t.dirname.slice(R.length) : t.dirname;
      if (t.rootPath) {
        const Q = s.value, q = pe.replace(/^\/+|\/+$/g, ""), re = Q && (q === Q || q.startsWith(Q + "/")) ? q.slice(Q.length).replace(/^\/+/, "") : "";
        X.value = re ? `/${re}` : "/", ce.value = !0, Jt(() => {
          var ae, Pe;
          (ae = Z.value) == null || ae.focus(), (Pe = Z.value) == null || Pe.select();
        });
        return;
      }
      if (t.multiStorageRoot)
        if (!t.adapter)
          X.value = "/";
        else {
          const Q = pe.replace(/^\/+|\/+$/g, "");
          X.value = Q ? `/${t.adapter}/${Q}` : `/${t.adapter}`;
        }
      else
        X.value = pe;
      ce.value = !0, Jt(() => {
        var Q, q;
        (Q = Z.value) == null || Q.focus(), (q = Z.value) == null || q.select();
      });
    }
    function G() {
      const R = X.value.trim();
      if (ce.value = !1, t.rootPath) {
        const Q = R.replace(/^\/+|\/+$/g, ""), q = s.value, re = Q ? q ? `${q}/${Q}` : Q : q;
        h("navigate", re ? `${t.adapter}://${re}` : `${t.adapter}://`);
        return;
      }
      if (t.multiStorageRoot) {
        const Q = R.replace(/^\/+|\/+$/g, "");
        if (!Q) {
          h("navigate", "");
          return;
        }
        const q = Q.indexOf("/"), re = q === -1 ? Q : Q.slice(0, q), ae = q === -1 ? "" : Q.slice(q + 1);
        h("navigate", ae ? `${re}://${ae}` : `${re}://`);
        return;
      }
      const pe = R.replace(/^\/+|\/+$/g, "");
      pe && h("navigate", `${t.adapter}://${pe}`);
    }
    function we() {
      ce.value = !1;
    }
    return (R, pe) => (u(), d("nav", {
      class: "fe-breadcrumb",
      "aria-label": r(o)("breadcrumb.aria")
    }, [
      ce.value ? dt((u(), d("input", {
        key: 1,
        ref_key: "pathInput",
        ref: Z,
        "onUpdate:modelValue": pe[1] || (pe[1] = (Q) => X.value = Q),
        type: "text",
        class: "fe-breadcrumb__input",
        placeholder: r(o)("breadcrumb.path_placeholder"),
        spellcheck: "false",
        autocomplete: "off",
        onKeydown: [
          ya(ft(G, ["prevent"]), ["enter"]),
          ya(ft(we, ["prevent"]), ["escape"])
        ],
        onBlur: we
      }, null, 40, GY)), [
        [St, X.value]
      ]) : (u(), d(he, { key: 0 }, [
        y.value ? (u(), d("button", {
          key: 0,
          type: "button",
          class: Re(["fe-breadcrumb__crumb fe-breadcrumb__home", { "is-last": m.value }]),
          "aria-current": m.value ? "page" : void 0,
          title: r(o)("breadcrumb.root"),
          "aria-label": r(o)("breadcrumb.root"),
          "data-testid": "breadcrumb-home",
          onClick: M,
          onContextmenu: j,
          onDragover: ke,
          onDrop: U
        }, [
          i("span", {
            class: "fe-icon",
            "aria-hidden": "true",
            innerHTML: r(wt)("home")
          }, null, 8, PY),
          m.value ? T("", !0) : (u(), d("span", OY, "›"))
        ], 42, DY)) : T("", !0),
        (u(!0), d(he, null, We(_.value, (Q, q) => (u(), d("button", {
          key: Q.adapterPath,
          class: Re(["fe-breadcrumb__crumb", { "is-last": !k.value && q === _.value.length - 1 }]),
          type: "button",
          "aria-current": !k.value && q === _.value.length - 1 ? "page" : void 0,
          onClick: (re) => K(Q),
          onContextmenu: (re) => de(re, Q),
          onDragover: ke,
          onDrop: (re) => ie(re, Q)
        }, [
          i("span", null, [
            i("bdi", null, f(Q.label), 1)
          ]),
          k.value || q < _.value.length - 1 ? (u(), d("span", IY, "›")) : T("", !0)
        ], 42, LY))), 128)),
        w.value.length ? (u(), d("span", {
          key: 1,
          ref_key: "moreWrapEl",
          ref: E,
          class: "fe-breadcrumb__more-wrap"
        }, [
          i("button", {
            type: "button",
            class: "fe-breadcrumb__more",
            "aria-haspopup": "menu",
            "aria-expanded": C.value,
            "aria-label": r(o)("breadcrumb.more"),
            title: r(o)("breadcrumb.more"),
            onClick: pe[0] || (pe[0] = (Q) => C.value = !C.value)
          }, "…", 8, RY),
          pe[2] || (pe[2] = i("span", {
            class: "fe-breadcrumb__sep",
            "aria-hidden": "true"
          }, "›", -1)),
          C.value ? (u(), d("div", NY, [
            (u(!0), d(he, null, We(w.value, (Q) => (u(), d("button", {
              key: Q.adapterPath,
              type: "button",
              class: "fe-breadcrumb__menu-item",
              role: "menuitem",
              onClick: (q) => I(Q)
            }, [
              i("bdi", null, f(Q.label), 1)
            ], 8, BY))), 128))
          ])) : T("", !0)
        ], 512)) : T("", !0),
        (u(!0), d(he, null, We($.value, (Q, q) => (u(), d("button", {
          key: Q.adapterPath,
          class: Re(["fe-breadcrumb__crumb", { "is-last": q === $.value.length - 1 }]),
          type: "button",
          "aria-current": q === $.value.length - 1 ? "page" : void 0,
          onClick: (re) => K(Q),
          onContextmenu: (re) => de(re, Q),
          onDragover: ke,
          onDrop: (re) => ie(re, Q)
        }, [
          i("span", null, [
            i("bdi", null, f(Q.label), 1)
          ]),
          q < $.value.length - 1 ? (u(), d("span", UY, "›")) : T("", !0)
        ], 42, FY))), 128)),
        e.subfolders ? (u(), d("span", {
          key: 2,
          ref_key: "subWrapEl",
          ref: O,
          class: "fe-breadcrumb__sub-wrap"
        }, [
          i("button", {
            type: "button",
            class: "fe-breadcrumb__sub",
            "aria-haspopup": "menu",
            "aria-expanded": A.value,
            title: r(o)("breadcrumb.subfolders"),
            "aria-label": r(o)("breadcrumb.subfolders"),
            "data-testid": "breadcrumb-subfolders",
            onClick: F
          }, [
            i("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: r(wt)("subfolders")
            }, null, 8, KY)
          ], 8, HY),
          A.value ? (u(), d("div", VY, [
            (u(!0), d(he, null, We(e.subfolders, (Q) => (u(), d("button", {
              key: Q.adapterPath,
              type: "button",
              class: "fe-breadcrumb__menu-item",
              role: "menuitem",
              onClick: (q) => I(Q)
            }, [
              i("bdi", null, f(Q.label), 1)
            ], 8, qY))), 128)),
            e.subfolders.length ? T("", !0) : (u(), d("p", jY, f(r(o)("breadcrumb.subfolders.empty")), 1))
          ])) : T("", !0)
        ], 512)) : T("", !0),
        i("button", {
          type: "button",
          class: "fe-breadcrumb__edit",
          title: r(o)("breadcrumb.go_to_path"),
          "aria-label": r(o)("breadcrumb.go_to_path"),
          "data-testid": "breadcrumb-edit-path",
          onClick: Y
        }, [
          i("span", {
            class: "fe-icon",
            "aria-hidden": "true",
            innerHTML: r(wt)("edit-path")
          }, null, 8, YY)
        ], 8, WY)
      ], 64))
    ], 8, MY));
  }
}), ZY = ["data-mode"], QY = ["aria-label"], eG = ["aria-expanded", "data-testid", "onClick"], tG = { class: "fe-filterbar__label" }, aG = { class: "fe-filterbar__find" }, nG = ["placeholder", "aria-label", "value", "onKeydown"], sG = {
  key: 2,
  class: "fe-filterbar__count",
  role: "status",
  "data-testid": "filter-count"
}, oG = {
  key: 3,
  class: "fe-filterbar__sort"
}, iG = ["disabled", "title"], rG = { class: "fe-sr-only" }, lG = {
  key: 0,
  class: "fe-ficon fe-filterbar__sortarrow",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}, uG = ["aria-label", "title", "disabled", "aria-expanded"], cG = ["aria-label", "title", "aria-expanded"], dG = ["dir", "role", "aria-label"], fG = {
  key: 0,
  class: "fe-filterpop__rule",
  "aria-hidden": "true"
}, pG = ["disabled", "aria-disabled", "data-testid", "onClick"], vG = ["data-active", "data-testid", "onClick"], hG = ["aria-selected", "data-checked", "data-active", "data-testid", "onClick"], mG = {
  class: "fe-filterpop__tick",
  "aria-hidden": "true"
}, yG = /* @__PURE__ */ rt({
  __name: "FilterBar",
  props: {
    value: {},
    locale: {},
    theme: {},
    shown: {},
    total: {},
    files: {},
    canPaste: { type: Boolean },
    canWrite: { type: Boolean },
    order: {},
    mode: {},
    findLabel: {}
  },
  emits: ["update:value", "new-folder", "upload", "paste", "select-all"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n, dir: o } = gt(() => t.locale), p = x(() => (t.mode ?? "full") === "full"), h = x(() => t.findLabel || n("filter.find")), v = ["type", "people", "modified", "size"], y = [
      "any",
      "folder",
      "document",
      "spreadsheet",
      "presentation",
      "pdf",
      "image",
      "video",
      "audio",
      "archive",
      "code"
    ], g = ["any", "today", "7d", "30d", "year"], m = ["any", "lt1", "1to10", "10to100", "gt100"], k = x(() => h3(t.files ?? []));
    function _(He) {
      return He === "people" ? k.value.map((J) => J.value) : He === "type" ? y : He === "modified" ? g : m;
    }
    function w(He, J) {
      var me;
      return He === "people" && J.startsWith("u:") ? ((me = k.value.find((fe) => fe.value === J)) == null ? void 0 : me.name) || J.slice(2) : n(`filter.${He}.${J}`);
    }
    function $(He) {
      const J = He === "people" ? t.value.people ?? "any" : t.value[He];
      return J === "any" ? n(`filter.${He}`) : w(He, J);
    }
    function C(He) {
      return He === "people" ? t.value.people ?? "any" : t.value[He];
    }
    const E = x(() => n3(t.value)), A = $u(), O = x(() => A.key.value), z = x(() => A.dir.value === "asc"), P = x(() => t.order === "relevance"), I = x(() => P.value ? n("sort.relevance") : n(`col.${O.value}`)), F = x(
      () => P.value ? n("sort.relevance_why") : n(z.value ? "sort.asc" : "sort.desc")
    );
    Qe(() => t.locale, (He) => Vh(He), { immediate: !0 });
    function W(He) {
      A.setSort(He), Q(!0);
    }
    function N() {
      P.value || A.toggleSortDir();
    }
    function K() {
      P.value || pe("sort");
    }
    const M = x(() => [
      { key: "new-folder", label: n("toolbar.new_folder"), disabled: t.canWrite === !1 },
      { key: "upload", label: n("toolbar.upload"), disabled: t.canWrite === !1 },
      { key: "paste", label: n("ctx.paste"), disabled: !t.canPaste || t.canWrite === !1 },
      { key: "sep", label: "", divider: !0, disabled: !0 },
      { key: "select-all", label: n("shortcuts.select_all"), disabled: !1 }
    ]);
    function j(He) {
      Q(!0), He === "new-folder" ? s("new-folder") : He === "upload" ? s("upload") : He === "paste" ? s("paste") : He === "select-all" && s("select-all");
    }
    const U = b(null), de = b({ x: 0, y: 0 }), ke = b(null), ie = b({});
    function ce(He, J) {
      ie.value[He] = J ?? null;
    }
    const X = x(
      () => U.value && U.value !== "sort" && U.value !== "actions" ? U.value : null
    ), Z = x(() => X.value ? _(X.value) : []), Y = x(
      () => X.value ? n(`filter.${X.value}`) : U.value === "actions" ? n("filter.actions") : n("sort.by")
    );
    function G(He) {
      return !!X.value && C(X.value) === He;
    }
    function we(He) {
      return X.value ? w(X.value, He) : He;
    }
    function R(He) {
      X.value && q(X.value, He);
    }
    async function pe(He) {
      var xe, ye, qe;
      if (U.value === He) {
        Q();
        return;
      }
      const J = (xe = ie.value[He]) == null ? void 0 : xe.getBoundingClientRect(), me = J ? Cr(J, o.value) : 8;
      de.value = { x: me, y: J ? J.bottom + 6 : 8 }, U.value = He, await Jt();
      const fe = ke.value;
      if (fe) {
        const ut = fe.getBoundingClientRect();
        if (de.value = { ...de.value, x: Ek(me, ut.width, window.innerWidth, o.value) }, ut.bottom > window.innerHeight - 8) {
          const Ue = (ye = ie.value[He]) == null ? void 0 : ye.getBoundingClientRect();
          de.value = { ...de.value, y: Math.max(8, (Ue ? Ue.top : 0) - ut.height - 6) };
        }
        (qe = fe.querySelector('[data-active="true"]')) == null || qe.focus();
      }
    }
    function Q(He = !1) {
      var me;
      const J = U.value;
      U.value = null, He && J && ((me = ie.value[J]) == null || me.focus());
    }
    Qe(
      () => t.order,
      (He) => {
        He === "relevance" && U.value === "sort" && Q();
      }
    );
    function q(He, J) {
      s("update:value", { ...t.value, [He]: J }), Q(!0);
    }
    function re() {
      ae.value = "", s("update:value", {
        ...t.value,
        type: "any",
        modified: "any",
        size: "any",
        name: "",
        people: "any"
      });
    }
    const ae = b(t.value.name ?? "");
    Qe(
      () => t.value.name ?? "",
      (He) => {
        He !== ae.value.trim() && (ae.value = He);
      }
    );
    let Pe;
    function be(He) {
      ae.value = He.target.value, Pe && clearTimeout(Pe), Pe = setTimeout(() => {
        s("update:value", { ...t.value, name: ae.value.trim() });
      }, 140);
    }
    function ze() {
      Pe && clearTimeout(Pe), ae.value = "", s("update:value", { ...t.value, name: "" });
    }
    Mt(() => {
      Pe && clearTimeout(Pe);
    });
    function Ae(He) {
      var me;
      if (!U.value) return;
      const J = He.target;
      (me = ke.value) != null && me.contains(J) || Object.values(ie.value).some((fe) => fe == null ? void 0 : fe.contains(J)) || Q();
    }
    function Ce(He) {
      He.key === "Escape" && U.value && (He.stopPropagation(), Q(!0));
    }
    return Kt(() => {
      document.addEventListener("pointerdown", Ae, !0), document.addEventListener("keydown", Ce, !0);
    }), Mt(() => {
      document.removeEventListener("pointerdown", Ae, !0), document.removeEventListener("keydown", Ce, !0);
    }), (He, J) => (u(), d("div", {
      class: "fe-filterbar",
      "data-mode": p.value ? "full" : "find",
      "data-testid": "filterbar"
    }, [
      p.value ? (u(), d("div", {
        key: 0,
        class: "fe-filterbar__chips",
        role: "group",
        "aria-label": r(n)("filter.aria")
      }, [
        (u(), d(he, null, We(v, (me) => i("button", {
          key: me,
          ref_for: !0,
          ref: (fe) => ce(me, fe),
          type: "button",
          class: Re(["fe-filterbar__chip", { "is-set": C(me) !== "any", "is-open": U.value === me }]),
          "aria-expanded": U.value === me,
          "aria-haspopup": "listbox",
          "data-testid": `filter-${me}`,
          onClick: (fe) => pe(me)
        }, [
          i("span", tG, f($(me)), 1),
          J[3] || (J[3] = i("svg", {
            class: "fe-ficon fe-filterbar__caret",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true",
            focusable: "false"
          }, [
            i("path", { d: "M7 10l5 5 5-5" })
          ], -1))
        ], 10, eG)), 64))
      ], 8, QY)) : T("", !0),
      i("div", aG, [
        J[4] || (J[4] = i("svg", {
          class: "fe-ficon fe-filterbar__find-glass",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "1.9",
          "stroke-linecap": "round",
          "aria-hidden": "true",
          focusable: "false"
        }, [
          i("circle", {
            cx: "11",
            cy: "11",
            r: "6.5"
          }),
          i("path", { d: "M16 16l4.5 4.5" })
        ], -1)),
        i("input", {
          type: "search",
          class: "fe-filterbar__find-input",
          placeholder: h.value,
          "aria-label": h.value,
          value: ae.value,
          "data-testid": "filter-find",
          onInput: be,
          onKeydown: ya(ft(ze, ["stop", "prevent"]), ["esc"])
        }, null, 40, nG)
      ]),
      p.value && E.value > 0 ? (u(), d("button", {
        key: 1,
        type: "button",
        class: "fe-filterbar__clear",
        "data-testid": "filter-clear",
        onClick: re
      }, f(r(n)("filter.clear")), 1)) : T("", !0),
      p.value && E.value > 0 && typeof e.shown == "number" && typeof e.total == "number" ? (u(), d("span", sG, f(r(n)("filter.count", { shown: String(e.shown), total: String(e.total) })), 1)) : T("", !0),
      p.value ? (u(), d("div", oG, [
        i("button", {
          ref: (me) => ce("sort", me),
          type: "button",
          class: Re(["fe-filterbar__sortdir", { "is-ranked": P.value }]),
          disabled: P.value,
          title: P.value ? F.value : void 0,
          "data-testid": "sort-dir",
          onClick: J[0] || (J[0] = (me) => N())
        }, [
          i("span", null, f(I.value), 1),
          i("span", rG, ", " + f(F.value), 1),
          P.value ? T("", !0) : (u(), d("svg", lG, [
            z.value ? (u(), d(he, { key: 0 }, [
              J[5] || (J[5] = i("path", { d: "M12 19V5" }, null, -1)),
              J[6] || (J[6] = i("path", { d: "M5 12l7-7 7 7" }, null, -1))
            ], 64)) : (u(), d(he, { key: 1 }, [
              J[7] || (J[7] = i("path", { d: "M12 5v14" }, null, -1)),
              J[8] || (J[8] = i("path", { d: "M19 12l-7 7-7-7" }, null, -1))
            ], 64))
          ]))
        ], 10, iG),
        i("button", {
          type: "button",
          class: "fe-filterbar__sortpick",
          "aria-label": P.value ? F.value : r(n)("sort.by"),
          title: P.value ? F.value : r(n)("sort.by"),
          disabled: P.value,
          "aria-haspopup": "menu",
          "aria-expanded": U.value === "sort",
          "data-testid": "sort-menu",
          onClick: J[1] || (J[1] = (me) => K())
        }, [...J[9] || (J[9] = [
          i("svg", {
            class: "fe-ficon fe-filterbar__caret",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true",
            focusable: "false"
          }, [
            i("path", { d: "M7 10l5 5 5-5" })
          ], -1)
        ])], 8, uG)
      ])) : T("", !0),
      p.value ? (u(), d("button", {
        key: 4,
        ref: (me) => ce("actions", me),
        type: "button",
        class: "fe-filterbar__actions",
        "aria-label": r(n)("filter.actions"),
        title: r(n)("filter.actions"),
        "aria-haspopup": "menu",
        "aria-expanded": U.value === "actions",
        "data-testid": "listing-actions",
        onClick: J[2] || (J[2] = (me) => pe("actions"))
      }, [...J[10] || (J[10] = [
        i("svg", {
          class: "fe-ficon",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "aria-hidden": "true",
          focusable: "false"
        }, [
          i("circle", {
            cx: "12",
            cy: "5.5",
            r: "1.2",
            fill: "currentColor",
            stroke: "none"
          }),
          i("circle", {
            cx: "12",
            cy: "12",
            r: "1.2",
            fill: "currentColor",
            stroke: "none"
          }),
          i("circle", {
            cx: "12",
            cy: "18.5",
            r: "1.2",
            fill: "currentColor",
            stroke: "none"
          })
        ], -1)
      ])], 8, cG)) : T("", !0),
      (u(), nt(Hs, { to: "body" }, [
        U.value ? (u(), d("div", {
          key: 0,
          ref_key: "panelEl",
          ref: ke,
          class: Re(["fe-filterpop", {
            "fe--theme-light": e.theme === "light",
            "fe--theme-dark": e.theme === "dark",
            "fe-filterpop--sort": U.value === "sort",
            "fe-filterpop--actions": U.value === "actions"
          }]),
          dir: r(o),
          role: U.value === "sort" || U.value === "actions" ? "menu" : "listbox",
          "aria-label": Y.value,
          style: Vt({ left: de.value.x + "px", top: de.value.y + "px" })
        }, [
          U.value === "actions" ? (u(!0), d(he, { key: 0 }, We(M.value, (me) => (u(), d(he, {
            key: me.key
          }, [
            me.divider ? (u(), d("hr", fG)) : (u(), d("button", {
              key: 1,
              type: "button",
              class: "fe-filterpop__item",
              role: "menuitem",
              disabled: me.disabled,
              "aria-disabled": me.disabled,
              "data-active": "false",
              "data-testid": `listing-action-${me.key}`,
              onClick: (fe) => j(me.key)
            }, [
              i("span", null, f(me.label), 1)
            ], 8, pG))
          ], 64))), 128)) : U.value === "sort" ? (u(!0), d(he, { key: 1 }, We(r(Kh), (me) => (u(), d("button", {
            key: me,
            type: "button",
            class: "fe-filterpop__item",
            role: "menuitem",
            "data-active": O.value === me ? "true" : "false",
            "data-testid": `sort-opt-${me}`,
            onClick: (fe) => W(me)
          }, [
            i("span", null, f(r(n)(`col.${me}`)), 1)
          ], 8, vG))), 128)) : (u(!0), d(he, { key: 2 }, We(Z.value, (me) => (u(), d("button", {
            key: me,
            type: "button",
            class: "fe-filterpop__item",
            role: "option",
            "aria-selected": G(me),
            "data-checked": G(me) ? "true" : "false",
            "data-active": G(me) ? "true" : "false",
            "data-testid": `filter-opt-${me}`,
            onClick: (fe) => R(me)
          }, [
            i("span", mG, f(G(me) ? "✓" : ""), 1),
            i("span", null, f(we(me)), 1)
          ], 8, hG))), 128))
        ], 14, dG)) : T("", !0)
      ]))
    ], 8, ZY));
  }
}), gG = ["aria-label"], bG = ["aria-selected", "title", "aria-label"], _G = ["innerHTML"], kG = ["aria-selected", "title", "aria-label"], wG = ["innerHTML"], xG = ["aria-selected", "title", "aria-label"], $G = ["innerHTML"], SG = /* @__PURE__ */ rt({
  __name: "ViewSwitcher",
  props: {
    viewMode: {},
    locale: {},
    modes: {}
  },
  emits: ["update:viewMode"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n } = gt(() => t.locale);
    function o(p) {
      return !t.modes || t.modes.includes(p);
    }
    return (p, h) => (u(), d("div", {
      class: "fe-toolbar__view",
      role: "tablist",
      "aria-label": r(n)("toolbar.view_label")
    }, [
      o("list") ? (u(), d("button", {
        key: 0,
        type: "button",
        class: Re(["fe-btn fe-btn--icon-only", { "is-active": e.viewMode === "list" }]),
        role: "tab",
        "aria-selected": e.viewMode === "list",
        title: r(n)("toolbar.view.list"),
        "aria-label": r(n)("toolbar.view.list"),
        "data-testid": "view-list",
        onClick: h[0] || (h[0] = (v) => s("update:viewMode", "list"))
      }, [
        i("span", {
          class: "fe-icon",
          "aria-hidden": "true",
          innerHTML: r(wt)("view-list")
        }, null, 8, _G)
      ], 10, bG)) : T("", !0),
      o("grid") ? (u(), d("button", {
        key: 1,
        type: "button",
        class: Re(["fe-btn fe-btn--icon-only", { "is-active": e.viewMode === "grid" }]),
        role: "tab",
        "aria-selected": e.viewMode === "grid",
        title: r(n)("toolbar.view.grid"),
        "aria-label": r(n)("toolbar.view.grid"),
        "data-testid": "view-grid",
        onClick: h[1] || (h[1] = (v) => s("update:viewMode", "grid"))
      }, [
        i("span", {
          class: "fe-icon",
          "aria-hidden": "true",
          innerHTML: r(wt)("view-grid")
        }, null, 8, wG)
      ], 10, kG)) : T("", !0),
      o("gallery") ? (u(), d("button", {
        key: 2,
        type: "button",
        class: Re(["fe-btn fe-btn--icon-only", { "is-active": e.viewMode === "gallery" }]),
        role: "tab",
        "aria-selected": e.viewMode === "gallery",
        title: r(n)("toolbar.view.gallery"),
        "aria-label": r(n)("toolbar.view.gallery"),
        "data-testid": "view-gallery",
        onClick: h[2] || (h[2] = (v) => s("update:viewMode", "gallery"))
      }, [
        i("span", {
          class: "fe-icon",
          "aria-hidden": "true",
          innerHTML: r(wt)("view-gallery")
        }, null, 8, $G)
      ], 10, xG)) : T("", !0)
    ], 8, gG));
  }
});
function TG(e, a) {
  return typeof e != "number" || !Number.isFinite(e) ? "—" : e <= 0 ? a("trash.days_remaining_due") : a("trash.days_remaining", { n: e });
}
const CG = ["aria-label", "innerHTML"], EG = ["innerHTML"], AG = { class: "fe-list__name-wrap" }, zG = ["title"], MG = {
  key: 0,
  class: "fe-list__badge"
}, DG = ["title", "aria-label"], PG = {
  key: 0,
  class: "fe-list__snippet"
}, OG = {
  key: 0,
  class: "fe-list__mark"
}, LG = ["title", "aria-label"], IG = ["title", "aria-label", "data-link-state"], RG = {
  key: 4,
  class: "fe-list__kind"
}, NG = ["title", "aria-label", "onClick"], BG = {
  key: 0,
  class: "fe-colmenu__sep",
  role: "separator"
}, FG = {
  key: 1,
  class: "fe-colmenu__title"
}, UG = {
  key: 2,
  class: "fe-colmenu__hint"
}, HG = ["onClick"], KG = { class: "fe-colmenu__label" }, VG = ["onClick"], qG = { class: "fe-colmenu__label" }, jG = /* @__PURE__ */ rt({
  __name: "ListView",
  props: {
    files: {},
    selected: {},
    clipped: {},
    showParentPath: { type: Boolean },
    locale: {},
    loading: { type: Boolean },
    starredIds: {},
    starEnabled: { type: Boolean },
    apiBase: {},
    authHeaders: { type: Function },
    authCredentials: {},
    keepBadgeFor: { type: Function },
    order: {},
    folderKey: {},
    theme: {},
    thumbSrc: { type: Function },
    trash: { type: Boolean }
  },
  emits: ["click-row", "dbl-row", "context-row", "item-drag-start", "item-drop-into", "star-change", "display-order"],
  setup(e, { emit: a }) {
    const t = e, s = a, {
      t: n,
      formatNodeSize: o,
      nodeSizeHint: p,
      formatDate: h,
      formatDateFull: v,
      formatMonthYear: y,
      zonedYearMonth: g,
      toDate: m,
      nodeDisplayName: k,
      dir: _
    } = gt(() => t.locale);
    function w(Le) {
      return li(Tu(Le), { t: n, formatDate: h, locale: t.locale });
    }
    function $(Le) {
      return Cu(Le, { t: n });
    }
    function C(Le) {
      return t.selected.has(Le.path);
    }
    function E(Le, tt) {
      s("click-row", Le, lm(tt, M.isTap(tt)));
    }
    function A(Le) {
      s("dbl-row", Le);
    }
    function O(Le, tt) {
      tt.preventDefault(), tt.stopPropagation(), s("context-row", Le, tt);
    }
    function z(Le, tt) {
      const ve = tt.currentTarget, H = ve == null ? void 0 : ve.getBoundingClientRect();
      s("context-row", Le, {
        // ⚠ RTL: the button's START corner — its right one in RTL — so the menu
        // hangs from the control and opens the way the line reads.
        clientX: H ? Cr(H, _.value) : tt.clientX,
        clientY: H ? H.bottom : tt.clientY,
        preventDefault: () => {
        },
        stopPropagation: () => {
        }
      });
    }
    function P(Le, tt) {
      s("click-row", Le, um(tt));
    }
    function I(Le, tt) {
      hm(
        tt,
        k(Le),
        t.selected.has(Le.path) ? t.selected.size : 1
      ), s("item-drag-start", Le, tt);
    }
    const F = b(null);
    function W(Le, tt) {
      Le.type === "dir" && Pn(tt) && (tt.preventDefault(), tt.stopPropagation(), tt.dataTransfer && (tt.dataTransfer.dropEffect = "move"), F.value = Le.path);
    }
    function N(Le) {
      F.value === Le.path && (F.value = null);
    }
    function K(Le, tt) {
      F.value = null, Le.type === "dir" && Pn(tt) && (tt.preventDefault(), tt.stopPropagation(), s("item-drop-into", Le, tt));
    }
    const M = cm(
      (Le, tt) => s("context-row", Le, { ...tt, preventDefault: () => {
      }, stopPropagation: () => {
      } }),
      {
        // A finger lifted on the item, off its controls, opens at touchend — see useRowTouch.
        onTap: (Le) => s("click-row", Le, { ctrl: !1, shift: !1, touch: !0 })
      }
    );
    function j(Le) {
      return Le === "kept" ? "✓" : Le === "syncing" ? "⟳" : Le === "partial" ? "◐" : "☁";
    }
    function U(Le) {
      return Le.basename === ".trash" || Rd(Le);
    }
    function de(Le) {
      return h(Le, { time: !0 }) || "—";
    }
    function ke(Le) {
      return v(Le);
    }
    function ie(Le) {
      return U(Le) ? "—" : rd(Le, n);
    }
    function ce(Le) {
      return Le.type === "dir" || Yv(Le) ? null : t.thumbSrc ? t.thumbSrc(Le) : Le.thumb_url ?? null;
    }
    const X = x(() => ze.value.includes("type"));
    function Z(Le) {
      return Le.type === "dir" && !U(Le);
    }
    function Y(Le) {
      var H;
      if ((H = Le.extra_metadata) != null && H.draft)
        return n("node.drafts");
      const tt = Zo(Le);
      return [String(Le.storage ?? "").trim(), tt].filter(Boolean).join("/");
    }
    function G(Le) {
      const tt = Le.extra_metadata;
      if (tt != null && tt.purging) return n("trash.purging");
      const ve = tt == null ? void 0 : tt.ttl_days;
      return TG(ve, n);
    }
    function we(Le) {
      const tt = Le.snippet;
      return typeof tt == "string" ? tt : "";
    }
    function R(Le) {
      return w0(Le.matched);
    }
    const pe = $u(), Q = x(() => pe.key.value), q = x(() => t.order === "relevance");
    Qe(() => t.locale, (Le) => Vh(Le), { immediate: !0 });
    const re = x(
      () => q.value ? null : { key: Q.value, dir: pe.dir.value }
    );
    function ae(Le) {
      q.value || Kh.includes(Le.key) && pe.chooseSortKey(Le.key);
    }
    const Pe = x(() => {
      if (t.trash) return ["type", "location", "owner", "modified", "remaining", "size"];
      const Le = ["type"];
      return t.showParentPath && Le.push("location"), Le.push("owner", "modified", "size"), t.starEnabled !== !1 && (t.apiBase || t.apiBase === "") && Le.push("star"), Le;
    }), be = b1(() => t.folderKey ?? ""), ze = x(
      () => be.order().filter((Le) => Le !== "name" && Pe.value.includes(Le) && !be.hidden(Le))
    ), Ae = x(() => [
      { id: "name", label: n("col.name"), lead: !0, sortable: !0, class: "fe-list__col--name" },
      { id: "type", label: n("col.type"), sortable: !0, class: "fe-list__col--type", format: ie },
      {
        id: "location",
        label: t.trash ? n("col.deleted_from") : n("col.location"),
        class: "fe-list__col--location",
        format: Y,
        title: (Le) => Y(Le) || void 0
      },
      {
        id: "owner",
        label: t.trash ? n("col.deleted_by") : n("col.owner"),
        class: "fe-list__col--owner",
        format: t.trash ? st : Ue,
        title: t.trash ? kt : Ye
      },
      {
        id: "modified",
        label: t.trash ? n("col.deleted") : n("col.modified"),
        sortable: !0,
        sortDir: "desc",
        class: "fe-list__col--mod",
        format: (Le) => de(Le.last_modified),
        title: (Le) => ke(Le.last_modified)
      },
      {
        id: "remaining",
        label: n("col.remaining"),
        class: "fe-list__col--remaining",
        format: G
      },
      {
        id: "size",
        label: n("col.size"),
        sortable: !0,
        class: "fe-list__col--size",
        // A folder the catalog does not cover in full says so: "≥ 1.2 GB", or
        // "—" when nothing below it is known (useLocale formatNodeSize).
        format: (Le) => o(Le),
        title: (Le) => p(Le)
      },
      { id: "star", label: n("col.star"), class: "fe-list__col--star", headerLabel: !1 }
    ]);
    function Ce(Le) {
      if (!t.showParentPath || ze.value.includes("location")) return Le.basename;
      const tt = Y(Le);
      return tt ? `${Le.basename} · ${tt}` : Le.basename;
    }
    function He(Le) {
      return {
        tabindex: 0,
        "aria-label": k(Le),
        "data-fe-path": Le.path,
        draggable: "true"
      };
    }
    function J(Le) {
      var tt;
      return {
        "is-dir": Le.type === "dir",
        "is-trash": !!Le.trashed,
        "is-clipped": !!((tt = t.clipped) != null && tt.has(Le.path)),
        "is-droptarget": F.value === Le.path
      };
    }
    const me = x(() => h1()), fe = x(() => !!t.folderKey && v1(t.folderKey));
    function xe(Le) {
      _M({
        v: "list",
        ...q.value ? {} : { k: pe.key.value, d: pe.dir.value },
        c: be.state()
      }), Le();
    }
    function ye(Le) {
      t.folderKey && y1(t.folderKey), Le();
    }
    const qe = x(() => {
      const Le = [], tt = [];
      for (const ve of t.files) (U(ve) ? Le : tt).push(ve);
      return [...Le, ...tt.sort(pe.compareInOrder(t.order ?? "sort"))];
    }), ut = x(() => ({ t: n, formatMonthYear: y, zonedYearMonth: g }));
    Qe(
      qe,
      (Le) => s("display-order", Le),
      { immediate: !0 }
    );
    function Ue(Le) {
      return Yd(Le) ? n("owner.you") : nu(Le) === null ? n("owner.system") : Yh(Le) || n("owner.unknown");
    }
    function Ye(Le) {
      const tt = [Ue(Le)];
      v3(Le) && tt.push(n("owner.external"));
      const ve = Le.last_actor_name, H = Le.last_actor_self === !0, te = Le.last_actor_id;
      if (H || typeof ve == "string" && ve) {
        const Te = H ? n("owner.you") : String(ve);
        Te !== tt[0] && tt.push(n("owner.last_actor", { who: Te }));
      } else te === void 0 && nu(Le) !== null && tt.push(n("owner.last_actor", { who: n("owner.system") }));
      return tt.join(" · ");
    }
    function st(Le) {
      return Nb(Le) ? n("owner.you") : Rb(Le) === null ? "—" : p3(Le) || n("owner.unknown");
    }
    function kt(Le) {
      return Rb(Le) === null && !Nb(Le) ? n("trash.deleted_by_nobody") : st(Le);
    }
    const At = x(
      () => pm(qe.value, {
        /* ⚠ `ranked` is half of this and not a detail: over a search's ranked
         * answer the key is still `modified` (nothing cleared it), the listing
         * just is not obeying it — see `lib/dateGroups.groupingActive`. */
        active: fm(Q.value, t.order),
        dateOf: (Le) => m(Le.last_modified),
        /* ⚠ Folders are their OWN run, above the first date heading, and that is
         * what lets "folders before files" hold while sorted by date. The rule
         * used to be softened instead — rows sorted by date, folders floating to
         * the top of each bucket — because hoisting them all would have split a
         * bucket in two and drawn "Today" twice, once over the folders and once
         * over the files. A run of their own removes that reason, and a folder has
         * no meaningful modification date to file under anyway. */
        aside: (Le) => U(Le) ? { id: "pinned" } : Le.type === "dir" ? { id: "dirs" } : null,
        labels: ut.value
      }).runs
    ), _t = x(
      () => At.value.map((Le) => ({ id: Le.id, label: Le.label ?? void 0, items: Le.items }))
    );
    return (Le, tt) => (u(), nt(ki, {
      rows: qe.value,
      groups: _t.value,
      columns: Ae.value,
      "column-store": r(be),
      candidates: Pe.value,
      metrics: r(g1),
      "row-key": (ve) => ve.path,
      locale: e.locale,
      theme: e.theme,
      loading: e.loading,
      empty: r(n)("empty.folder"),
      "aria-label": r(n)("list.aria"),
      framed: !1,
      selectable: "",
      "is-selected": C,
      sort: re.value,
      "sort-closed": q.value ? r(n)("sort.relevance_why") : null,
      "row-class": J,
      "row-attrs": He,
      onSort: ae,
      onRowClick: E,
      onRowDblclick: A,
      onRowContextmenu: O,
      onCheckClick: P,
      onRowDragstart: I,
      onRowDragover: W,
      onRowDragleave: N,
      onRowDrop: K,
      onRowTouchstart: tt[2] || (tt[2] = (ve, H) => r(M).onTouchStart(ve, H)),
      onRowTouchend: tt[3] || (tt[3] = (ve) => r(M).onTouchEnd(ve)),
      onRowTouchmove: tt[4] || (tt[4] = (ve) => r(M).onTouchMove(ve))
    }, {
      "cell-name": yt(({ row: ve }) => [
        r(od)(ve) ? (u(), d("span", {
          key: 0,
          class: "fe-list__icon fe-list__icon--svg",
          role: "img",
          "aria-label": r(n)("e2e.badge"),
          innerHTML: r(id)()
        }, null, 8, CG)) : (u(), nt(vm, {
          key: 1,
          node: ve,
          "src-of": ce,
          class: Re(["fe-list__icon fe-list__icon--img", { "fe-thumb--page": r(dm)(ve) }]),
          alt: "",
          "aria-hidden": "true"
        }, {
          default: yt(() => [
            i("span", {
              class: "fe-list__icon fe-list__icon--svg",
              "aria-hidden": "true",
              innerHTML: r(sn)(ve)
            }, null, 8, EG)
          ]),
          _: 2
        }, 1032, ["node", "class"])),
        i("div", AG, [
          i("span", {
            class: "fe-list__name",
            title: Ce(ve)
          }, [
            i("bdi", null, f(r(k)(ve)), 1),
            R(ve) ? (u(), d("span", MG, f(r(n)("search.in_content")), 1)) : T("", !0),
            e.keepBadgeFor && e.keepBadgeFor(ve) ? (u(), d("span", {
              key: 1,
              class: Re(["fe-keepbadge", "fe-keepbadge--" + e.keepBadgeFor(ve)]),
              title: r(n)("keep.badge_" + e.keepBadgeFor(ve)),
              role: "img",
              "aria-label": r(n)("keep.badge_" + e.keepBadgeFor(ve))
            }, f(j(e.keepBadgeFor(ve))), 11, DG)) : T("", !0)
          ], 8, zG),
          we(ve) ? (u(), d("span", PG, [
            (u(!0), d(he, null, We(r(xd)(we(ve)), (H, te) => (u(), d(he, { key: te }, [
              H.match ? (u(), d("mark", OG, f(H.text), 1)) : (u(), d(he, { key: 1 }, [
                $t(f(H.text), 1)
              ], 64))
            ], 64))), 128))
          ])) : T("", !0)
        ]),
        w(ve) ? (u(), d("span", {
          key: 2,
          class: "fe-applock",
          role: "img",
          title: w(ve),
          "aria-label": w(ve),
          "data-testid": "lock-badge"
        }, [
          tt[5] || (tt[5] = i("span", {
            class: "fe-applock__glyph",
            "aria-hidden": "true"
          }, "🔒", -1)),
          $t(f(r(n)("applock.badge")), 1)
        ], 8, LG)) : T("", !0),
        $(ve) ? (u(), d("span", {
          key: 3,
          class: Re(["fe-symlink", "fe-symlink--" + $(ve).state]),
          role: "img",
          title: $(ve).why,
          "aria-label": $(ve).why,
          "data-testid": "symlink-badge",
          "data-link-state": $(ve).state
        }, [
          tt[6] || (tt[6] = i("span", {
            class: "fe-symlink__glyph",
            "aria-hidden": "true"
          }, "🔗", -1)),
          $t(f($(ve).badge), 1)
        ], 10, IG)) : T("", !0),
        Z(ve) && !X.value ? (u(), d("span", RG, f(r(n)("node.folder")), 1)) : T("", !0)
      ]),
      "cell-star": yt(({ row: ve }) => {
        var H;
        return [
          e.starEnabled !== !1 && typeof ve.id == "number" && ve.type === "file" ? (u(), d("span", {
            key: 0,
            class: "fe-list__star-hit",
            "data-fe-control": "",
            onClick: tt[0] || (tt[0] = ft(() => {
            }, ["stop"])),
            onDblclick: tt[1] || (tt[1] = ft(() => {
            }, ["stop"]))
          }, [
            ot(nf, {
              starred: !!((H = e.starredIds) != null && H.has(ve.id)),
              "node-id": ve.id,
              "api-base": e.apiBase,
              "auth-headers": e.authHeaders,
              "auth-credentials": e.authCredentials,
              locale: e.locale,
              compact: "",
              onChange: (te) => s("star-change", ve, te)
            }, null, 8, ["starred", "node-id", "api-base", "auth-headers", "auth-credentials", "locale", "onChange"])
          ], 32)) : T("", !0)
        ];
      }),
      actions: yt(({ row: ve }) => [
        i("button", {
          type: "button",
          class: "fe-list__menu",
          title: r(n)("toolbar.more"),
          "aria-label": r(n)("toolbar.more"),
          onClick: (H) => z(ve, H)
        }, [...tt[7] || (tt[7] = [
          i("span", { "aria-hidden": "true" }, "⋮", -1)
        ])], 8, NG)
      ]),
      "colmenu-extra": yt(({ close: ve }) => [
        fe.value || me.value > 0 ? (u(), d("div", BG)) : T("", !0),
        fe.value || me.value > 0 ? (u(), d("p", FG, f(r(n)("cols.folder_title")), 1)) : T("", !0),
        fe.value || me.value > 0 ? (u(), d("p", UG, f(r(n)("cols.folder_hint")), 1)) : T("", !0),
        fe.value ? (u(), d("button", {
          key: 3,
          type: "button",
          class: "fe-colmenu__row",
          onClick: (H) => ye(ve)
        }, [
          i("span", KG, f(r(n)("cols.forget_folder")), 1)
        ], 8, HG)) : T("", !0),
        me.value > 0 || fe.value ? (u(), d("button", {
          key: 4,
          type: "button",
          class: "fe-colmenu__row",
          onClick: (H) => xe(ve)
        }, [
          i("span", qG, f(r(n)("cols.apply_all", { count: me.value })), 1)
        ], 8, VG)) : T("", !0)
      ]),
      _: 1
    }, 8, ["rows", "groups", "columns", "column-store", "candidates", "metrics", "row-key", "locale", "theme", "loading", "empty", "aria-label", "sort", "sort-closed"]));
  }
}), WG = ["aria-label", "aria-busy"], YG = {
  key: 0,
  class: "fe-gal__heading",
  "aria-hidden": "true"
}, GG = ["aria-selected", "aria-label", "data-fe-path", "onClick", "onDblclick", "onContextmenu", "onDragstart", "onDragover", "onDragleave", "onDrop", "onTouchstartPassive"], XG = ["dir"], JG = {
  key: 0,
  class: "fe-fprev__tint"
}, ZG = ["innerHTML"], QG = ["aria-label", "innerHTML"], eX = ["innerHTML"], tX = ["onClick"], aX = {
  class: "fe-gal__meta",
  "aria-hidden": "true"
}, nX = {
  key: 0,
  class: "fe-gal__meta-line"
}, sX = ["title"], oX = ["title"], iX = {
  key: 0,
  class: "fe-gal__meta-line"
}, rX = ["title", "aria-label", "data-link-state"], lX = {
  key: 1,
  class: "fe-gal__meta-line"
}, uX = ["title", "aria-label"], cX = {
  key: 0,
  class: "fe-gal__empty"
}, dX = /* @__PURE__ */ rt({
  __name: "GalleryView",
  props: {
    files: {},
    selected: {},
    clipped: {},
    showParentPath: { type: Boolean },
    locale: {},
    loading: { type: Boolean },
    thumbSrc: {},
    starredIds: {},
    starEnabled: { type: Boolean },
    apiBase: {},
    authHeaders: {},
    authCredentials: {},
    e2eActive: { type: Boolean },
    order: {},
    selectable: { type: Boolean, default: !0 }
  },
  emits: ["click-card", "dbl-card", "context-card", "item-drag-start", "item-drop-into", "star-change"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n, formatSize: o, nodeDisplayName: p, formatDate: h, formatMonthYear: v, zonedYearMonth: y, toDate: g } = gt(() => t.locale);
    function m(X) {
      return li(Tu(X), { t: n, formatDate: h, locale: t.locale });
    }
    function k(X) {
      return Cu(X, { t: n });
    }
    const _ = $u(), w = x(
      () => pm(t.files, {
        active: fm(_.key.value, t.order),
        dateOf: (X) => g(X.last_modified),
        aside: (X) => X.type === "dir" ? { id: "dirs" } : null,
        labels: { t: n, formatMonthYear: v, zonedYearMonth: y }
      })
    );
    function $(X) {
      return t.thumbSrc ? t.thumbSrc(X) : X.thumb_url ?? null;
    }
    const C = _0({
      apiBase: t.apiBase,
      authHeaders: t.authHeaders ? () => t.authHeaders() : void 0,
      credentials: t.authCredentials,
      disabled: () => t.e2eActive === !0
    });
    Mt(() => C.dispose());
    function E(X) {
      return C.kindFor(X);
    }
    function A(X) {
      const Z = C.get(X);
      return Z ? [Z] : [];
    }
    function O(X, Z) {
      C.bind(X instanceof Element ? X : null, Z);
    }
    function z(X) {
      return t.starEnabled === !1 ? !1 : t.apiBase !== void 0 && typeof X.id == "number" && X.type === "file";
    }
    function P(X) {
      return t.selected.has(X.path);
    }
    function I(X, Z) {
      s("click-card", X, um(Z));
    }
    function F(X, Z) {
      s("click-card", X, lm(Z, ke.isTap(Z)));
    }
    function W(X) {
      s("dbl-card", X);
    }
    function N(X, Z) {
      Z.preventDefault(), Z.stopPropagation(), s("context-card", X, Z);
    }
    function K(X, Z) {
      hm(
        Z,
        p(X),
        t.selected.has(X.path) ? t.selected.size : 1
      ), s("item-drag-start", X, Z);
    }
    const M = b(null);
    function j(X, Z) {
      X.type === "dir" && Pn(Z) && (Z.preventDefault(), Z.stopPropagation(), Z.dataTransfer && (Z.dataTransfer.dropEffect = "move"), M.value = X.path);
    }
    function U(X) {
      M.value === X.path && (M.value = null);
    }
    function de(X, Z) {
      M.value = null, X.type === "dir" && Pn(Z) && (Z.preventDefault(), Z.stopPropagation(), s("item-drop-into", X, Z));
    }
    const ke = cm(
      (X, Z) => s("context-card", X, { ...Z, preventDefault: () => {
      }, stopPropagation: () => {
      } }),
      {
        // A finger lifted on the item, off its controls, opens at touchend — see useRowTouch.
        onTap: (X) => s("click-card", X, { ctrl: !1, shift: !1, touch: !0 })
      }
    );
    function ie(X) {
      return h(X, { time: !0 });
    }
    function ce(X) {
      const Z = ie(X.last_modified);
      return [X.type === "dir" ? "" : o(X.size), Z].filter((G) => !!G).join(" · ");
    }
    return (X, Z) => (u(), d("div", {
      class: Re(["fe-gal", { "is-loading": e.loading, "has-selection": e.selectable && e.selected.size > 0 }]),
      role: "listbox",
      "aria-multiselectable": "true",
      "aria-label": r(n)("gallery.aria"),
      "aria-busy": e.loading ? "true" : void 0
    }, [
      (u(!0), d(he, null, We(e.files, (Y) => {
        var G, we;
        return u(), d(he, {
          key: Y.path
        }, [
          w.value.headingBefore(Y) ? (u(), d("p", YG, f(w.value.headingBefore(Y)), 1)) : T("", !0),
          i("div", {
            class: Re(["fe-gal__card", {
              "is-selected": P(Y),
              "is-dir": Y.type === "dir",
              "is-trash": Y.trashed,
              "is-clipped": (G = e.clipped) == null ? void 0 : G.has(Y.path),
              "is-droptarget": M.value === Y.path
            }]),
            tabindex: "0",
            role: "option",
            "aria-selected": P(Y) ? "true" : "false",
            "aria-label": r(p)(Y),
            "data-fe-path": Y.path,
            draggable: "true",
            onClick: (R) => F(Y, R),
            onDblclick: (R) => W(Y),
            onContextmenu: (R) => N(Y, R),
            onDragstart: (R) => K(Y, R),
            onDragover: (R) => j(Y, R),
            onDragleave: (R) => U(Y),
            onDrop: (R) => de(Y, R),
            onTouchstartPassive: (R) => r(ke).onTouchStart(Y, R),
            onTouchend: Z[3] || (Z[3] = //@ts-ignore
            (...R) => r(ke).onTouchEnd && r(ke).onTouchEnd(...R)),
            onTouchmovePassive: Z[4] || (Z[4] = //@ts-ignore
            (...R) => r(ke).onTouchMove && r(ke).onTouchMove(...R))
          }, [
            i("div", {
              class: "fe-gal__thumb",
              ref_for: !0,
              ref: (R) => O(R, Y)
            }, [
              E(Y) ? (u(), d(he, { key: 0 }, [
                (u(!0), d(he, null, We(A(Y), (R) => (u(), d("div", {
                  key: "fprev",
                  class: Re(["fe-fprev", "fe-fprev--" + R.kind]),
                  dir: r(zk)(R.kind),
                  style: Vt(R.kind === "table" ? { "--fprev-cols": String(R.cols) } : void 0),
                  "aria-hidden": "true"
                }, [
                  R.kind === "table" ? (u(!0), d(he, { key: 0 }, We(R.rows, (pe, Q) => (u(), d(he, { key: Q }, [
                    (u(!0), d(he, null, We(pe, (q, re) => (u(), d("span", {
                      key: re,
                      class: Re(["fe-fprev__cell", { "is-head": Q === 0 }])
                    }, f(q), 3))), 128))
                  ], 64))), 128)) : (u(!0), d(he, { key: 1 }, We(R.lines, (pe, Q) => (u(), d("div", {
                    key: Q,
                    class: "fe-fprev__line"
                  }, [
                    pe.tint ? (u(), d("span", JG, f(pe.indent) + f(pe.tint), 1)) : T("", !0),
                    $t(f(pe.text), 1)
                  ]))), 128))
                ], 14, XG))), 128)),
                A(Y).length === 0 ? (u(), d("span", {
                  key: 0,
                  class: "fe-gal__icon fe-gal__icon--svg",
                  innerHTML: r(sn)(Y)
                }, null, 8, ZG)) : T("", !0)
              ], 64)) : (u(), nt(vm, {
                key: 1,
                node: Y,
                "src-of": $,
                "video-badge": r(b0)(Y),
                alt: Y.basename,
                class: Re({
                  "fe-thumb--page": r(dm)(Y)
                  /* gorunum:v1-preview — crop a page from its TOP */
                })
              }, {
                default: yt(() => [
                  r(od)(Y) ? (u(), d("span", {
                    key: 0,
                    class: "fe-gal__icon fe-gal__icon--svg",
                    role: "img",
                    "aria-label": r(n)("e2e.badge"),
                    innerHTML: r(id)()
                  }, null, 8, QG)) : (u(), d("span", {
                    key: 1,
                    class: "fe-gal__icon fe-gal__icon--svg",
                    innerHTML: r(sn)(Y)
                  }, null, 8, eX))
                ]),
                _: 2
              }, 1032, ["node", "video-badge", "alt", "class"])),
              e.selectable ? (u(), d("span", {
                key: 2,
                class: "fe-item-check fe-gal__check",
                "data-fe-control": "",
                onClick: ft((R) => I(Y, R), ["stop"]),
                onDblclick: Z[0] || (Z[0] = ft(() => {
                }, ["stop"]))
              }, [
                ot(Qh, {
                  on: P(Y),
                  label: r(p)(Y)
                }, null, 8, ["on", "label"])
              ], 40, tX)) : T("", !0),
              z(Y) ? (u(), d("div", {
                key: 3,
                class: "fe-gal__star",
                onClick: Z[1] || (Z[1] = ft(() => {
                }, ["stop"])),
                onDblclick: Z[2] || (Z[2] = ft(() => {
                }, ["stop"]))
              }, [
                ot(nf, {
                  starred: !!((we = e.starredIds) != null && we.has(Y.id)),
                  "node-id": Y.id,
                  "api-base": e.apiBase,
                  "auth-headers": e.authHeaders,
                  "auth-credentials": e.authCredentials,
                  locale: e.locale,
                  compact: "",
                  card: "",
                  onChange: (R) => s("star-change", Y, R)
                }, null, 8, ["starred", "node-id", "api-base", "auth-headers", "auth-credentials", "locale", "onChange"])
              ], 32)) : T("", !0),
              i("div", aX, [
                ce(Y) ? (u(), d("span", nX, f(ce(Y)), 1)) : T("", !0),
                e.showParentPath && r(Zo)(Y) ? (u(), d("span", {
                  key: 1,
                  class: "fe-gal__meta-line fe-gal__meta-line--path",
                  title: r(Zo)(Y)
                }, [
                  i("bdi", null, f(r(Zo)(Y)), 1)
                ], 8, sX)) : T("", !0)
              ])
            ], 512),
            i("div", {
              class: "fe-gal__label",
              title: Y.basename
            }, [
              i("bdi", null, f(r(p)(Y)), 1)
            ], 8, oX),
            k(Y) ? (u(), d("div", iX, [
              i("span", {
                class: Re(["fe-symlink", "fe-symlink--" + k(Y).state]),
                role: "img",
                title: k(Y).why,
                "aria-label": k(Y).why,
                "data-testid": "symlink-badge",
                "data-link-state": k(Y).state
              }, [
                Z[5] || (Z[5] = i("span", {
                  class: "fe-symlink__glyph",
                  "aria-hidden": "true"
                }, "🔗", -1)),
                $t(f(k(Y).badge), 1)
              ], 10, rX)
            ])) : T("", !0),
            m(Y) ? (u(), d("div", lX, [
              m(Y) ? (u(), d("span", {
                key: 0,
                class: "fe-applock",
                role: "img",
                title: m(Y),
                "aria-label": m(Y),
                "data-testid": "lock-badge"
              }, [
                Z[6] || (Z[6] = i("span", {
                  class: "fe-applock__glyph",
                  "aria-hidden": "true"
                }, "🔒", -1)),
                $t(f(r(n)("applock.badge")), 1)
              ], 8, uX)) : T("", !0)
            ])) : T("", !0)
          ], 42, GG)
        ], 64);
      }), 128)),
      !e.loading && e.files.length === 0 ? (u(), d("div", cX, f(r(n)("empty.folder")), 1)) : T("", !0)
    ], 10, WG));
  }
}), fX = ["data-pane", "data-testid", "aria-label"], pX = {
  key: 0,
  class: "fe-subhead"
}, vX = { class: "fe-subhead__actions" }, hX = ["title", "aria-label"], mX = {
  key: 2,
  class: "fe__skeleton",
  role: "status"
}, yX = { class: "fe-sr-only" }, gX = {
  key: 0,
  class: "fe-skel-grid",
  "aria-hidden": "true"
}, bX = {
  key: 1,
  class: "fe-skel-list",
  "aria-hidden": "true"
}, _X = {
  key: 3,
  class: "fe-state"
}, kX = { class: "fe-state__title" }, wX = { class: "fe-state__hint" }, xX = { class: "fe-state__actions" }, $X = { class: "fe-state__details" }, SX = { class: "fe-state__details-summary" }, TX = { class: "fe-state__details-pre" }, CX = {
  key: 4,
  class: "fe-state",
  "data-testid": "empty-filtered"
}, EX = { class: "fe-state__title" }, AX = { class: "fe-state__hint" }, zX = { class: "fe-state__actions" }, MX = { class: "fe-state" }, DX = { class: "fe-state__title" }, PX = "application/x-brf-files", OX = "application/x-brf-files-src", LX = 500, O_ = /* @__PURE__ */ rt({
  __name: "FilePane",
  props: {
    paneId: {},
    api: {},
    locale: {},
    theme: {},
    focused: { type: Boolean },
    closable: { type: Boolean },
    path: {},
    selfDriven: { type: Boolean },
    qualify: {},
    toUser: {},
    clamp: {},
    rootLabel: {},
    rootPath: {},
    floor: {},
    multiRoot: { type: Boolean },
    virtualRows: {},
    trashVisible: { type: Boolean, default: !0 },
    navOffersTrash: { type: Boolean },
    rows: {},
    loading: { type: Boolean },
    error: {},
    order: {},
    viewMode: {},
    viewModes: {},
    showCrumbs: { type: Boolean, default: !0 },
    showFilterBar: { type: Boolean, default: !0 },
    filterMode: {},
    findLabel: {},
    showViewSwitcher: { type: Boolean, default: !0 },
    crumbSubfolders: {},
    folderKey: {},
    showParentPath: { type: Boolean },
    trash: { type: Boolean },
    clipped: {},
    extraFilters: {},
    canWrite: { type: Boolean },
    canPaste: { type: Boolean },
    selected: {},
    filters: {},
    thumbSrc: {},
    keepBadgeFor: {},
    starredIds: {},
    starEnabled: { type: Boolean },
    apiBase: {},
    authHeaders: {},
    authCredentials: {},
    e2eActive: { type: Boolean },
    bodyOverride: { type: Boolean },
    openTrigger: { default: "double" }
  },
  emits: ["activate", "close", "navigate", "open", "open-trash", "click-row", "context", "clear-selection", "display-order", "item-drag-start", "item-drop-into", "transfer", "update:viewMode", "update:filters", "crumb-context", "copy-path", "crumb-drop", "new-folder", "upload", "paste", "select-all", "clear-filters", "star-change", "retry"],
  setup(e, { expose: a, emit: t }) {
    const s = e, n = t, { t: o } = gt(() => s.locale), p = s.paneId === "main" ? $u() : C1();
    yr(E1, p);
    const h = b(""), v = b([]), y = b(!1), g = b(""), m = b("");
    function k(Ue) {
      return Ks(Ue) === "storage";
    }
    const _ = On(Su, null), w = On(W0, null), $ = b(""), C = b(!1), E = b(""), A = x(
      () => s.selfDriven && !!w && !!$.value && w.locked($.value)
    );
    async function O(Ue) {
      if (!(!w || !$.value || C.value)) {
        C.value = !0, E.value = "";
        try {
          const Ye = await w.unlock($.value, Ue);
          Ye ? E.value = Ye : await N(h.value);
        } finally {
          C.value = !1;
        }
      }
    }
    const z = x(() => s.selfDriven ? h.value : s.path ?? ""), P = x(
      () => s.selfDriven ? v.value : s.rows ?? []
    ), I = x(() => s.selfDriven ? y.value : !!s.loading), F = x(() => s.selfDriven ? g.value : s.error ?? ""), W = x(
      () => !!s.multiRoot && !(z.value ?? "").replace(/^\/+|\/+$/g, "")
    );
    async function N(Ue) {
      const Ye = s.clamp(Ue ?? h.value ?? "");
      y.value = !0, g.value = "";
      try {
        if (s.multiRoot && !Ye) {
          v.value = s.virtualRows ? s.virtualRows() : [], m.value = "", $.value = "", h.value = "", n("navigate", "");
          return;
        }
        const st = await s.api.index(s.qualify(Ye));
        m.value = st.perm || "";
        const kt = typeof st.e2e_root == "string" ? st.e2e_root : "";
        kt !== $.value && (E.value = ""), $.value = kt;
        const At = _ ? await _.decorate(st.files, { root: kt || null }) : st.files;
        v.value = Rl(At), n1(v.value, st.adapter, st.dirname, s.trashVisible !== !1, {
          navOffersTrash: s.navOffersTrash
        }) && s1(v.value, st.adapter, s.api), h.value = s.toUser(st.dirname), n("navigate", h.value);
      } catch (st) {
        g.value = st instanceof Error ? st.message : String(st);
      } finally {
        y.value = !1;
      }
    }
    s.selfDriven && N(s.path ?? "");
    function K(Ue) {
      n("activate"), s.selfDriven ? N(Ue) : n("navigate", Ue);
    }
    const M = x(
      () => u1(z.value) ? z.value : s.qualify(z.value)
    ), j = x(() => {
      const Ue = M.value, Ye = Ue.indexOf("://");
      return Ye === -1 ? "" : Ue.slice(0, Ye);
    });
    function U(Ue) {
      if (n("activate"), !s.selfDriven) {
        n("navigate", Ue);
        return;
      }
      if (s.multiRoot && !Ue) {
        N("");
        return;
      }
      N(s.toUser(Ue));
    }
    const de = x(() => {
      const Ue = Lv(P.value, s.filters);
      return p.sortListing(
        s.extraFilters ? Lv(Ue, s.extraFilters) : Ue,
        s.order ?? "sort"
      );
    }), ke = x(() => Wl(s.filters) || !!s.extraFilters), ie = x(
      () => W.value ? "find" : s.filterMode ?? "full"
    ), ce = x(
      () => W.value ? o("filter.find.storages") : s.findLabel ?? ""
    ), X = x(
      () => P.value.filter((Ue) => Ue.type === "dir").map((Ue) => ({ label: Ue.basename, adapterPath: Ue.path }))
    );
    let Z = 0;
    function Y() {
      return Date.now() - Z < LX;
    }
    function G(Ue, Ye) {
      if (!Y()) {
        if (Ye.check) {
          n("activate"), n("click-row", Ue, { ctrl: !0, shift: Ye.shift });
          return;
        }
        if (Ye.touch || s.openTrigger === "single") {
          Z = Date.now(), q(Ue);
          return;
        }
        n("activate"), n("click-row", Ue, { ctrl: Ye.ctrl, shift: Ye.shift });
      }
    }
    function we(Ue) {
      Y() || (Z = Date.now(), q(Ue));
    }
    function R(Ue, Ye) {
      Ye.preventDefault(), Ye.stopPropagation(), n("activate"), n("context", Ue, Ye);
    }
    function pe(Ue) {
      Ue.preventDefault(), Ue.stopPropagation(), n("activate"), n("clear-selection"), n("context", null, Ue);
    }
    function Q() {
      n("clear-selection");
    }
    function q(Ue) {
      if (n("activate"), Ue.basename === ".trash") {
        n("open-trash");
        return;
      }
      if (Ue.type === "dir" && s.selfDriven) {
        N(k(Ue) ? Ue.path : s.toUser(Ue.path));
        return;
      }
      n("open", Ue);
    }
    function re(Ue, Ye) {
      if (!Ye.dataTransfer) return;
      if (k(Ue) || W.value || Ue.basename === ".trash") {
        Ye.preventDefault();
        return;
      }
      const st = P.value.filter((At) => s.selected.has(At.path) && !k(At)).filter((At) => {
        var _t;
        return !((_t = s.clipped) != null && _t.has(At.path));
      }).map((At) => ({ path: At.path, basename: At.basename, type: At.type })), kt = st.length > 0 ? st : [{ path: Ue.path, basename: Ue.basename, type: Ue.type }];
      Ye.dataTransfer.setData(PX, JSON.stringify(kt)), Ye.dataTransfer.setData(OX, M.value), Ye.dataTransfer.setData("text/plain", kt.map((At) => At.path).join(`
`)), Ye.dataTransfer.effectAllowed = "move", n("item-drag-start", Ue, Ye);
    }
    const ae = b(!1);
    function Pe(Ue) {
      return Pn(Ue);
    }
    function be(Ue, Ye) {
      const st = Vc(Ue);
      if (!st || !Ye) return;
      const kt = Wv(Ue), At = st.map((_t) => _t.path).filter((_t) => _t && _t !== Ye && !Ye.startsWith(_t + "/"));
      At.length !== 0 && (Ue.preventDefault(), Ue.stopPropagation(), n("transfer", { sources: At, targetWire: Ye, originWire: kt }));
    }
    function ze(Ue, Ye) {
      ae.value = !1, !(Ue.type !== "dir" || k(Ue)) && Pe(Ye) && n("item-drop-into", Ue, Ye);
    }
    function Ae(Ue) {
      !Pe(Ue) || W.value || (Ue.preventDefault(), Ue.stopPropagation(), Ue.dataTransfer && (Ue.dataTransfer.dropEffect = "move"), ae.value = !0);
    }
    function Ce() {
      ae.value = !1;
    }
    function He(Ue) {
      ae.value = !1, !(!Pe(Ue) || W.value) && be(Ue, M.value);
    }
    function J() {
      return s.selfDriven ? N() : Promise.resolve();
    }
    function me() {
      const Ue = (z.value ?? "").replace(/^\/+|\/+$/g, ""), Ye = (s.floor || "").replace(/^\/+|\/+$/g, "");
      if (!Ue || Ue === Ye) return;
      const st = Ue.lastIndexOf("/");
      K(st === -1 ? "" : Ue.slice(0, st));
    }
    function fe() {
      return z.value;
    }
    function xe() {
      return de.value.filter((Ue) => !k(Ue));
    }
    function ye() {
      return P.value.length;
    }
    function qe() {
      return P.value.map((Ue) => Ue.path);
    }
    function ut() {
      return s.selfDriven ? m.value : "";
    }
    return a({ reload: J, goUp: me, getPath: fe, visibleNodes: xe, loadFolder: N, rowCount: ye, rowPaths: qe, dirPerm: ut }), Qe(z, () => {
      ae.value = !1;
    }), (Ue, Ye) => (u(), d("section", {
      class: Re(["fe__primary fe-pane", {
        "fe-pane--focus": e.focused,
        "fe-pane--split": e.paneId === "split",
        "fe-pane--dropover": ae.value
      }]),
      "data-pane": e.paneId,
      "data-testid": `pane-${e.paneId}`,
      role: "region",
      "aria-label": e.paneId === "split" ? r(o)("split.pane") : r(o)("toolbar.view_label"),
      onPointerdownCapture: Ye[18] || (Ye[18] = (st) => n("activate"))
    }, [
      e.showCrumbs || Ue.$slots.heading || e.showViewSwitcher || e.closable ? (u(), d("div", pX, [
        wa(Ue.$slots, "heading", {}, () => [
          e.showCrumbs ? (u(), nt(JY, {
            key: 0,
            dirname: M.value,
            adapter: j.value,
            "root-label": e.rootLabel || j.value,
            locale: e.locale,
            "multi-storage-root": e.multiRoot,
            "root-path": e.rootPath,
            subfolders: e.crumbSubfolders ?? X.value,
            onNavigate: U,
            onCopyPath: Ye[0] || (Ye[0] = (st) => n("copy-path", st)),
            onCrumbContext: Ye[1] || (Ye[1] = (st) => n("crumb-context", st)),
            onCrumbDrop: Ye[2] || (Ye[2] = (st, kt) => n("crumb-drop", st, kt))
          }, null, 8, ["dirname", "adapter", "root-label", "locale", "multi-storage-root", "root-path", "subfolders"])) : T("", !0)
        ]),
        i("div", vX, [
          e.showViewSwitcher ? (u(), nt(SG, {
            key: 0,
            "view-mode": e.viewMode,
            locale: e.locale,
            modes: e.viewModes,
            "onUpdate:viewMode": Ye[3] || (Ye[3] = (st) => {
              n("activate"), n("update:viewMode", st);
            })
          }, null, 8, ["view-mode", "locale", "modes"])) : T("", !0),
          e.closable ? (u(), d("button", {
            key: 1,
            type: "button",
            class: "fe-btn fe-btn--icon-only fe-pane__close",
            title: r(o)("split.close"),
            "aria-label": r(o)("split.close"),
            "data-testid": "pane-close",
            onClick: Ye[4] || (Ye[4] = (st) => n("close"))
          }, [...Ye[19] || (Ye[19] = [
            i("svg", {
              class: "fe-ficon",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "1.8",
              "stroke-linecap": "round",
              "aria-hidden": "true",
              focusable: "false"
            }, [
              i("path", { d: "M6 6l12 12M18 6L6 18" })
            ], -1)
          ])], 8, hX)) : T("", !0)
        ])
      ])) : T("", !0),
      Ye[25] || (Ye[25] = i("div", { class: "fe-selbar-slot" }, null, -1)),
      e.showFilterBar ? (u(), nt(yG, {
        key: 1,
        value: e.filters,
        locale: e.locale,
        theme: e.theme,
        mode: ie.value,
        "find-label": ce.value,
        order: e.order,
        shown: de.value.length,
        total: P.value.length,
        files: P.value,
        "can-paste": e.canPaste,
        "can-write": e.canWrite,
        "onUpdate:value": Ye[5] || (Ye[5] = (st) => {
          n("activate"), n("update:filters", st);
        }),
        onNewFolder: Ye[6] || (Ye[6] = (st) => {
          n("activate"), n("new-folder");
        }),
        onUpload: Ye[7] || (Ye[7] = (st) => {
          n("activate"), n("upload");
        }),
        onPaste: Ye[8] || (Ye[8] = (st) => {
          n("activate"), n("paste");
        }),
        onSelectAll: Ye[9] || (Ye[9] = (st) => {
          n("activate"), n("select-all");
        })
      }, null, 8, ["value", "locale", "theme", "mode", "find-label", "order", "shown", "total", "files", "can-paste", "can-write"])) : T("", !0),
      wa(Ue.$slots, "banners"),
      i("div", {
        class: Re(["fe__body", { "is-dropover": ae.value }]),
        onClick: ft(Q, ["self"]),
        onContextmenu: pe,
        onDragover: Ae,
        onDragleave: Ce,
        onDrop: He
      }, [
        e.bodyOverride ? wa(Ue.$slots, "body", { key: 0 }) : A.value ? (u(), nt(Y0, {
          key: 1,
          compact: "",
          locale: e.locale,
          busy: C.value,
          error: E.value,
          onUnlock: O,
          onRecovery: Ye[10] || (Ye[10] = (st) => {
            var kt;
            return (kt = r(w)) == null ? void 0 : kt.recovery($.value);
          })
        }, null, 8, ["locale", "busy", "error"])) : I.value && P.value.length === 0 ? (u(), d("div", mX, [
          i("span", yX, f(r(o)("loading")), 1),
          e.viewMode !== "list" ? (u(), d("div", gX, [
            (u(), d(he, null, We(8, (st) => i("div", {
              key: st,
              class: "fe-skel-card"
            }, [...Ye[20] || (Ye[20] = [
              i("div", { class: "fe-skel fe-skel--thumb" }, null, -1),
              i("div", { class: "fe-skel fe-skel--label" }, null, -1)
            ])])), 64))
          ])) : (u(), d("div", bX, [
            (u(), d(he, null, We(8, (st) => i("div", {
              key: st,
              class: "fe-skel-row"
            }, [...Ye[21] || (Ye[21] = [
              i("div", { class: "fe-skel fe-skel--icon" }, null, -1),
              i("div", { class: "fe-skel fe-skel--name" }, null, -1),
              i("div", { class: "fe-skel fe-skel--size" }, null, -1),
              i("div", { class: "fe-skel fe-skel--date" }, null, -1)
            ])])), 64))
          ]))
        ])) : F.value && P.value.length === 0 ? (u(), d("div", _X, [
          Ye[22] || (Ye[22] = vk('<svg class="fe-state__art" viewBox="0 0 120 100" width="110" height="92" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="60" cy="50" r="28"></circle><path d="M60 36v18"></path><circle cx="60" cy="63" r="1.8" fill="currentColor" stroke="none"></circle><path d="M24 88h72" stroke-dasharray="3 5"></path></svg>', 1)),
          i("p", kX, f(r(o)("error.title")), 1),
          i("p", wX, f(r(o)("error.hint")), 1),
          i("div", xX, [
            i("button", {
              type: "button",
              class: "fe-btn fe-btn--primary",
              onClick: Ye[11] || (Ye[11] = (st) => e.selfDriven ? N() : n("retry"))
            }, f(r(o)("error.retry")), 1)
          ]),
          i("details", $X, [
            i("summary", SX, f(r(o)("error.details")), 1),
            i("pre", TX, f(F.value), 1)
          ])
        ])) : !I.value && ke.value && de.value.length === 0 && P.value.length > 0 ? (u(), d("div", CX, [
          Ye[23] || (Ye[23] = i("svg", {
            class: "fe-state__art",
            viewBox: "0 0 120 100",
            width: "110",
            height: "92",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true"
          }, [
            i("path", { d: "M26 28h68L68 58v24l-16 8V58z" })
          ], -1)),
          i("p", EX, f(r(o)("filter.empty.title")), 1),
          i("p", AX, f(r(o)("filter.empty.hint")), 1),
          i("div", zX, [
            i("button", {
              type: "button",
              class: "fe-btn",
              onClick: Ye[12] || (Ye[12] = (st) => n("clear-filters"))
            }, f(r(o)("filter.clear")), 1)
          ])
        ])) : !I.value && P.value.length === 0 ? wa(Ue.$slots, "empty", { key: 5 }, () => [
          i("div", MX, [
            Ye[24] || (Ye[24] = i("svg", {
              class: "fe-state__art",
              viewBox: "0 0 120 100",
              width: "110",
              height: "92",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "aria-hidden": "true"
            }, [
              i("path", { d: "M18 36v42a6 6 0 0 0 6 6h72a6 6 0 0 0 6-6V44a6 6 0 0 0-6-6H62l-9-10H24a6 6 0 0 0-6 6z" })
            ], -1)),
            i("p", DX, f(r(o)("empty.folder")), 1)
          ])
        ]) : e.viewMode === "list" ? (u(), nt(jG, {
          key: 6,
          files: de.value,
          order: e.order,
          selected: e.selected,
          clipped: e.clipped,
          "show-parent-path": e.showParentPath,
          trash: e.trash,
          locale: e.locale,
          loading: I.value,
          "folder-key": e.folderKey,
          theme: e.theme,
          "thumb-src": e.thumbSrc,
          "keep-badge-for": e.keepBadgeFor,
          "starred-ids": e.starredIds,
          "star-enabled": e.starEnabled,
          "api-base": e.apiBase,
          "auth-headers": e.authHeaders,
          "auth-credentials": e.authCredentials,
          onClickRow: G,
          onDisplayOrder: Ye[13] || (Ye[13] = (st) => n("display-order", st)),
          onDblRow: we,
          onContextRow: R,
          onItemDragStart: re,
          onItemDropInto: ze,
          onStarChange: Ye[14] || (Ye[14] = (st, kt) => n("star-change", st, kt))
        }, null, 8, ["files", "order", "selected", "clipped", "show-parent-path", "trash", "locale", "loading", "folder-key", "theme", "thumb-src", "keep-badge-for", "starred-ids", "star-enabled", "api-base", "auth-headers", "auth-credentials"])) : e.viewMode === "grid" ? (u(), nt(Gv, {
          key: 7,
          files: de.value,
          order: e.order,
          sections: !0,
          selected: e.selected,
          clipped: e.clipped,
          "show-parent-path": e.showParentPath,
          locale: e.locale,
          loading: I.value,
          "keep-badge-for": e.keepBadgeFor,
          "thumb-src": e.thumbSrc,
          "e2e-active": e.e2eActive,
          "starred-ids": e.starredIds,
          "star-enabled": e.starEnabled,
          "api-base": e.apiBase,
          "auth-headers": e.authHeaders,
          "auth-credentials": e.authCredentials,
          onClickCard: G,
          onDisplayOrder: Ye[15] || (Ye[15] = (st) => n("display-order", st)),
          onDblCard: we,
          onContextCard: R,
          onItemDragStart: re,
          onItemDropInto: ze,
          onStarChange: Ye[16] || (Ye[16] = (st, kt) => n("star-change", st, kt))
        }, null, 8, ["files", "order", "selected", "clipped", "show-parent-path", "locale", "loading", "keep-badge-for", "thumb-src", "e2e-active", "starred-ids", "star-enabled", "api-base", "auth-headers", "auth-credentials"])) : (u(), nt(dX, {
          key: 8,
          files: de.value,
          order: e.order,
          selected: e.selected,
          clipped: e.clipped,
          "show-parent-path": e.showParentPath,
          locale: e.locale,
          loading: I.value,
          "thumb-src": e.thumbSrc,
          "e2e-active": e.e2eActive,
          "starred-ids": e.starredIds,
          "star-enabled": e.starEnabled,
          "api-base": e.apiBase,
          "auth-headers": e.authHeaders,
          "auth-credentials": e.authCredentials,
          onClickCard: G,
          onDblCard: we,
          onContextCard: R,
          onItemDragStart: re,
          onItemDropInto: ze,
          onStarChange: Ye[17] || (Ye[17] = (st, kt) => n("star-change", st, kt))
        }, null, 8, ["files", "order", "selected", "clipped", "show-parent-path", "locale", "loading", "thumb-src", "e2e-active", "starred-ids", "star-enabled", "api-base", "auth-headers", "auth-credentials"]))
      ], 34)
    ], 42, fX));
  }
});
function IX(e) {
  const a = b([]), t = b(""), s = x(
    () => a.value.find((C) => C.id === t.value) ?? null
  ), n = x(() => a.value.findIndex((C) => C.id === t.value)), o = x(() => a.value.length > 1);
  function p() {
    if (!e.storageKey) return !1;
    try {
      const C = localStorage.getItem(e.storageKey);
      if (!C) return !1;
      const E = JSON.parse(C);
      if (!E || !Array.isArray(E.tabs) || E.tabs.length === 0) return !1;
      const A = [];
      for (const O of E.tabs) {
        if (!O || typeof O.path != "string") continue;
        const z = typeof O.viewMode == "string" && O.viewMode ? O.viewMode : "list", P = O.split, I = P && typeof P == "object" && typeof P.path == "string" ? {
          path: P.path,
          viewMode: typeof P.viewMode == "string" && P.viewMode ? P.viewMode : void 0
        } : null;
        A.push({
          id: typeof O.id == "string" && O.id ? O.id : gr(),
          path: O.path,
          viewMode: z,
          split: I
        });
      }
      return A.length === 0 ? !1 : (a.value = A, t.value = A.some((O) => O.id === E.active) ? String(E.active) : A[0].id, !0);
    } catch {
      return !1;
    }
  }
  function h() {
    if (e.storageKey)
      try {
        localStorage.setItem(
          e.storageKey,
          JSON.stringify({ v: 1, active: t.value, tabs: a.value })
        );
      } catch {
      }
  }
  Qe([a, t], h, { deep: !0 });
  function v(C, E) {
    if (a.value.length > 0) return;
    const A = { id: gr(), path: C, viewMode: E, split: null };
    a.value = [A], t.value = A.id;
  }
  function y(C) {
    const E = s.value;
    E && (C.path !== void 0 && (E.path = C.path), C.viewMode !== void 0 && (E.viewMode = C.viewMode));
  }
  function g(C, E) {
    const A = { id: gr(), path: C, viewMode: E.viewMode, split: E.split ?? null }, O = n.value;
    return a.value.splice(O === -1 ? a.value.length : O + 1, 0, A), E.background || (t.value = A.id), A;
  }
  function m(C) {
    if (a.value.length <= 1) return null;
    const E = a.value.findIndex((z) => z.id === C);
    if (E === -1) return null;
    const A = a.value[E].id === t.value;
    if (a.value.splice(E, 1), !A) return null;
    const O = a.value[Math.min(E, a.value.length - 1)];
    return t.value = O.id, O;
  }
  function k(C) {
    const E = a.value.find((A) => A.id === C);
    return !E || E.id === t.value ? null : (t.value = E.id, E);
  }
  function _(C) {
    if (a.value.length < 2) return null;
    const E = n.value === -1 ? 0 : n.value, A = a.value[(E + C + a.value.length) % a.value.length];
    return k(A.id);
  }
  function w(C, E) {
    if (C === E || C < 0 || E < 0 || C >= a.value.length || E >= a.value.length) return;
    const A = [...a.value], [O] = A.splice(C, 1);
    A.splice(E, 0, O), a.value = A;
  }
  function $(C) {
    const E = s.value;
    E && (E.split = C);
  }
  return {
    tabs: a,
    activeId: t,
    activeTab: s,
    activeIndex: n,
    hasMultiple: o,
    restore: p,
    seed: v,
    syncActive: y,
    openTab: g,
    closeTab: m,
    activate: k,
    step: _,
    move: w,
    setSplit: $
  };
}
const RX = ["disabled"], NX = { class: "fe-field__label" }, BX = ["value", "checked", "data-testid", "onChange"], FX = { class: "fe-e2e-level__text" }, UX = { class: "fe-e2e-level__name" }, HX = { class: "fe-e2e-level__hint" }, KX = /* @__PURE__ */ rt({
  __name: "E2eLevelPicker",
  props: {
    locale: {},
    modelValue: {},
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n } = gt(() => t.locale), o = { content: "e2e.level.content", names: "e2e.level.names" }, p = { content: "e2e.level.content_hint", names: "e2e.level.names_hint" };
    return (h, v) => (u(), d("fieldset", {
      class: "fe-e2e-levels",
      "data-testid": "e2e-level-picker",
      disabled: e.disabled
    }, [
      i("legend", NX, f(r(n)("e2e.settings.level")), 1),
      (u(!0), d(he, null, We(r(Vz), (y, g) => (u(), d("label", {
        key: y,
        class: Re(["fe-e2e-level", { "fe-e2e-level--on": e.modelValue === y }])
      }, [
        i("input", {
          type: "radio",
          name: "fe-e2e-level",
          value: y,
          checked: e.modelValue === y,
          "data-testid": `e2e-level-${y}`,
          onChange: (m) => s("update:modelValue", y)
        }, null, 40, BX),
        i("span", FX, [
          i("span", UX, f(g + 1) + " · " + f(r(n)(o[y])), 1),
          i("span", HX, f(r(n)(p[y])), 1)
        ])
      ], 2))), 128))
    ], 8, RX));
  }
}), VX = {
  key: 0,
  class: "fe-field"
}, qX = { class: "fe-field__label" }, jX = ["disabled"], WX = {
  key: 1,
  class: "fe-e2e-names__hint",
  "data-testid": "e2e-convert-lead"
}, YX = { class: "fe-field" }, GX = { class: "fe-field__label" }, XX = ["placeholder", "disabled"], JX = { class: "fe-field" }, ZX = { class: "fe-field__label" }, QX = ["disabled", "onKeydown"], eJ = {
  class: "fe-e2e-names",
  "data-testid": "e2e-create-names"
}, tJ = { class: "fe-e2e-names__hint" }, aJ = {
  key: 2,
  class: "fe-e2e-convert-past",
  "data-testid": "e2e-convert-past"
}, nJ = { class: "fe-e2e-ack" }, sJ = ["disabled"], oJ = { class: "fe-e2e-ack" }, iJ = ["disabled"], rJ = { class: "fe-e2e-names__hint" }, lJ = {
  class: "fe-e2e-warn",
  role: "alert"
}, uJ = {
  key: 3,
  class: "fe-e2e-rk__escrow",
  role: "note"
}, cJ = { class: "fe-e2e-ack" }, dJ = ["disabled"], fJ = {
  key: 4,
  class: "fe-form__error"
}, pJ = ["disabled"], vJ = ["disabled"], hJ = /* @__PURE__ */ rt({
  __name: "EncryptedFolderModal",
  props: {
    open: { type: Boolean },
    locale: {},
    busy: { type: Boolean },
    escrowKid: {},
    existing: {}
  },
  emits: ["close", "submit"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n } = gt(() => t.locale), o = b(""), p = b(""), h = b(""), v = b(!1), y = b(gb), g = b(null), m = b(!0), k = b(!0);
    Qe(
      () => t.open,
      (w) => {
        w && (o.value = "", p.value = "", h.value = "", v.value = !1, y.value = gb, m.value = !0, k.value = !0, g.value = null);
      }
    );
    function _() {
      if (t.busy) return;
      const w = t.existing ? t.existing : o.value.trim();
      if (!w) {
        g.value = n("modal.newfolder.placeholder");
        return;
      }
      if (!t.existing && (/[\\/]/.test(w) || w === "." || w === ".." || w.startsWith(".filex"))) {
        g.value = n("e2e.create.bad_name");
        return;
      }
      if (p.value.length < oi) {
        g.value = n("e2e.create.pw_short");
        return;
      }
      if (p.value !== h.value) {
        g.value = n("e2e.create.pw_mismatch");
        return;
      }
      if (!v.value) {
        g.value = n("e2e.create.ack_required");
        return;
      }
      g.value = null, s("submit", {
        name: w,
        password: p.value,
        level: y.value,
        ...t.existing ? { cleanup: { versions: m.value, trash: k.value } } : {}
      });
    }
    return (w, $) => (u(), nt(la, {
      open: e.open,
      title: e.existing ? r(n)("e2e.convert.title", { name: e.existing }) : r(n)("e2e.create.title"),
      size: "sm",
      onClose: $[8] || ($[8] = (C) => s("close"))
    }, {
      actions: yt(() => [
        i("button", {
          type: "button",
          class: "fe-btn",
          disabled: e.busy,
          onClick: $[7] || ($[7] = (C) => s("close"))
        }, f(r(n)("modal.newfolder.cancel")), 9, pJ),
        i("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: e.busy,
          onClick: _
        }, f(e.busy ? r(n)("e2e.create.busy") : e.existing ? r(n)("e2e.convert.submit") : r(n)("e2e.create.create")), 9, vJ)
      ]),
      default: yt(() => [
        i("form", {
          class: "fe-e2e-form",
          onSubmit: ft(_, ["prevent"])
        }, [
          e.existing ? (u(), d("p", WX, f(r(n)("e2e.convert.lead")), 1)) : (u(), d("label", VX, [
            i("span", qX, f(r(n)("modal.newfolder.placeholder")), 1),
            dt(i("input", {
              "onUpdate:modelValue": $[0] || ($[0] = (C) => o.value = C),
              type: "text",
              class: "fe-input",
              autocomplete: "off",
              disabled: e.busy
            }, null, 8, jX), [
              [St, o.value]
            ])
          ])),
          i("label", YX, [
            i("span", GX, f(r(n)("e2e.create.pw_label")), 1),
            dt(i("input", {
              "onUpdate:modelValue": $[1] || ($[1] = (C) => p.value = C),
              type: "password",
              class: "fe-input",
              placeholder: r(n)("e2e.create.pw_placeholder"),
              autocomplete: "new-password",
              disabled: e.busy
            }, null, 8, XX), [
              [St, p.value]
            ])
          ]),
          i("label", JX, [
            i("span", ZX, f(r(n)("e2e.create.pw2_label")), 1),
            dt(i("input", {
              "onUpdate:modelValue": $[2] || ($[2] = (C) => h.value = C),
              type: "password",
              class: "fe-input",
              autocomplete: "new-password",
              disabled: e.busy,
              onKeydown: ya(ft(_, ["prevent"]), ["enter"])
            }, null, 40, QX), [
              [St, h.value]
            ])
          ]),
          i("div", eJ, [
            ot(KX, {
              modelValue: y.value,
              "onUpdate:modelValue": $[3] || ($[3] = (C) => y.value = C),
              locale: e.locale,
              disabled: e.busy
            }, null, 8, ["modelValue", "locale", "disabled"]),
            i("p", tJ, f(r(n)("e2e.create.names_root_hint")), 1)
          ]),
          e.existing ? (u(), d("div", aJ, [
            i("strong", null, f(r(n)("e2e.convert.past_title")), 1),
            i("p", null, f(r(n)("e2e.convert.past_body")), 1),
            i("label", nJ, [
              dt(i("input", {
                "onUpdate:modelValue": $[4] || ($[4] = (C) => m.value = C),
                type: "checkbox",
                disabled: e.busy,
                "data-testid": "e2e-convert-versions"
              }, null, 8, sJ), [
                [Ja, m.value]
              ]),
              i("span", null, f(r(n)("e2e.convert.drop_versions")), 1)
            ]),
            i("label", oJ, [
              dt(i("input", {
                "onUpdate:modelValue": $[5] || ($[5] = (C) => k.value = C),
                type: "checkbox",
                disabled: e.busy,
                "data-testid": "e2e-convert-trash"
              }, null, 8, iJ), [
                [Ja, k.value]
              ]),
              i("span", null, f(r(n)("e2e.convert.drop_trash")), 1)
            ]),
            i("p", rJ, f(r(n)("e2e.convert.past_outside")), 1)
          ])) : T("", !0),
          i("div", lJ, [
            i("strong", null, f(r(n)("e2e.create.warn_title")), 1),
            i("p", null, f(r(n)("e2e.create.warn_body")), 1)
          ]),
          e.escrowKid ? (u(), d("div", uJ, [
            i("strong", null, f(r(n)("e2e.create.escrow_title")), 1),
            i("p", null, f(r(n)("e2e.create.escrow_body")), 1)
          ])) : T("", !0),
          i("label", cJ, [
            dt(i("input", {
              "onUpdate:modelValue": $[6] || ($[6] = (C) => v.value = C),
              type: "checkbox",
              disabled: e.busy,
              "data-testid": "e2e-create-ack"
            }, null, 8, dJ), [
              [Ja, v.value]
            ]),
            i("span", null, f(r(n)("e2e.create.ack")), 1)
          ]),
          g.value ? (u(), d("p", fJ, f(g.value), 1)) : T("", !0)
        ], 32)
      ]),
      _: 1
    }, 8, ["open", "title"]));
  }
}), mJ = { class: "fe-e2e-rk" }, yJ = { class: "fe-e2e-rk__lead" }, gJ = ["aria-label"], bJ = { class: "fe-e2e-rk__actions" }, _J = {
  class: "fe-e2e-warn",
  role: "alert"
}, kJ = {
  key: 0,
  class: "fe-e2e-rk__escrow",
  role: "note"
}, wJ = { class: "fe-e2e-rk__kid" }, xJ = { class: "fe-e2e-ack" }, $J = ["disabled"], SJ = /* @__PURE__ */ rt({
  __name: "RecoveryKeyModal",
  props: {
    open: { type: Boolean },
    locale: {},
    recoveryKey: {},
    folderName: {},
    escrowKid: {},
    variant: {}
  },
  emits: ["close"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n } = gt(() => t.locale), o = b(!1), p = b(!1);
    Qe(
      () => t.open,
      (k) => {
        k && (o.value = !1, p.value = !1);
      }
    );
    const h = x(
      () => t.variant === "upgraded" || t.variant === "replaced" ? n("e2e.recovery.title_upgraded") : n("e2e.recovery.title")
    ), v = x(
      () => t.variant === "upgraded" ? n("e2e.recovery.lead_upgraded") : t.variant === "replaced" ? n("e2e.recovery.lead_replaced") : t.variant === "file" ? n("e2e.recovery.lead_file") : n("e2e.recovery.lead")
    );
    async function y() {
      try {
        await navigator.clipboard.writeText(t.recoveryKey), p.value = !0, window.setTimeout(() => p.value = !1, 2e3);
      } catch {
        p.value = !1;
      }
    }
    function g() {
      const k = t.variant === "file" ? "file" : "folder", _ = t.folderName || k, w = `filex recovery key
${k}: ${_}

${t.recoveryKey}

This key opens the encrypted ${k} without its password.
Anyone holding it can read the ${k}. Store it like a password.
filex does not keep a copy and cannot show it again.
`, $ = URL.createObjectURL(new Blob([w], { type: "text/plain" })), C = document.createElement("a");
      C.href = $, C.download = `filex-recovery-${_}.txt`, document.body.appendChild(C), C.click(), C.remove(), window.setTimeout(() => URL.revokeObjectURL($), 3e4);
    }
    function m() {
      o.value && s("close");
    }
    return (k, _) => (u(), nt(la, {
      open: e.open,
      title: h.value,
      size: "sm",
      "close-on-backdrop": !1,
      onClose: m
    }, {
      actions: yt(() => [
        i("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: !o.value,
          onClick: m
        }, f(r(n)("e2e.recovery.done")), 9, $J)
      ]),
      default: yt(() => [
        i("div", mJ, [
          i("p", yJ, f(v.value), 1),
          i("output", {
            class: "fe-e2e-rk__key",
            "aria-label": r(n)("e2e.recovery_key_aria")
          }, f(e.recoveryKey), 9, gJ),
          i("div", bJ, [
            i("button", {
              type: "button",
              class: "fe-btn",
              onClick: y
            }, f(p.value ? r(n)("e2e.recovery.copied") : r(n)("e2e.recovery.copy")), 1),
            i("button", {
              type: "button",
              class: "fe-btn",
              onClick: g
            }, f(r(n)("e2e.recovery.download")), 1)
          ]),
          i("div", _J, [
            i("strong", null, f(r(n)("e2e.recovery.warn_title")), 1),
            i("p", null, f(e.variant === "file" ? r(n)("e2e.recovery.warn_body_file") : r(n)("e2e.recovery.warn_body")), 1)
          ]),
          e.escrowKid ? (u(), d("div", kJ, [
            i("strong", null, f(r(n)("e2e.recovery.escrow_title")), 1),
            i("p", null, f(e.variant === "file" ? r(n)("e2e.fxe.escrow_body") : r(n)("e2e.recovery.escrow_body")), 1),
            i("p", wJ, [
              $t(f(r(n)("e2e.recovery.escrow_kid")) + ": ", 1),
              i("code", null, f(e.escrowKid), 1)
            ])
          ])) : T("", !0),
          i("label", xJ, [
            dt(i("input", {
              "onUpdate:modelValue": _[0] || (_[0] = (w) => o.value = w),
              type: "checkbox"
            }, null, 512), [
              [Ja, o.value]
            ]),
            i("span", null, f(r(n)("e2e.recovery.ack")), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["open", "title"]));
  }
}), TJ = { class: "fe-e2e-recover" }, CJ = {
  key: 0,
  class: "fe-e2e-recover__none"
}, EJ = {
  key: 0,
  class: "fe-e2e-recover__tabs",
  role: "tablist"
}, AJ = ["aria-selected"], zJ = ["aria-selected"], MJ = { class: "fe-e2e-recover__hint" }, DJ = ["placeholder", "disabled"], PJ = {
  class: "fe-e2e-warn",
  role: "alert"
}, OJ = {
  key: 0,
  class: "fe-e2e-recover__hint"
}, LJ = ["placeholder", "disabled"], IJ = {
  key: 2,
  class: "fe-e2e-recover__note"
}, RJ = {
  key: 3,
  class: "fe-form__error"
}, NJ = ["disabled"], BJ = ["disabled"], FJ = /* @__PURE__ */ rt({
  __name: "E2eRecoveryUnlockModal",
  props: {
    open: { type: Boolean },
    locale: {},
    hasRecovery: { type: Boolean },
    escrowState: {},
    escrowKid: {},
    busy: { type: Boolean },
    error: {}
  },
  emits: ["close", "submit"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n } = gt(() => t.locale), o = x(() => t.escrowState === "available"), p = x(() => t.escrowState === "predates" ? n("e2e.recover.escrow_predates") : t.escrowState === "other-key" ? n("e2e.recover.escrow_other_key") : null), h = b("recovery"), v = b(""), y = b(""), g = b(null);
    Qe(
      () => t.open,
      (w) => {
        w && (h.value = t.hasRecovery ? "recovery" : "escrow", v.value = "", y.value = "", g.value = null);
      }
    );
    const m = x(() => !t.hasRecovery && !o.value), k = x(() => g.value || t.error || null);
    function _() {
      if (!(t.busy || m.value)) {
        if (g.value = null, h.value === "recovery") {
          if (!Kr(v.value)) {
            g.value = n("e2e.recover.bad_format");
            return;
          }
          s("submit", { mode: "recovery", value: v.value });
          return;
        }
        if (!y.value.trim()) {
          g.value = n("e2e.recover.escrow_required");
          return;
        }
        s("submit", { mode: "escrow", value: y.value });
      }
    }
    return (w, $) => (u(), nt(la, {
      open: e.open,
      title: r(n)("e2e.recover.title"),
      size: "sm",
      onClose: $[5] || ($[5] = (C) => s("close"))
    }, {
      actions: yt(() => [
        i("button", {
          type: "button",
          class: "fe-btn",
          disabled: e.busy,
          onClick: $[4] || ($[4] = (C) => s("close"))
        }, f(r(n)("modal.newfolder.cancel")), 9, NJ),
        i("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: e.busy || m.value,
          onClick: _
        }, f(e.busy ? r(n)("e2e.recover.busy") : r(n)("e2e.recover.unlock")), 9, BJ)
      ]),
      default: yt(() => [
        i("div", TJ, [
          m.value ? (u(), d("p", CJ, f(r(n)("e2e.recover.none")), 1)) : (u(), d(he, { key: 1 }, [
            e.hasRecovery && o.value ? (u(), d("div", EJ, [
              i("button", {
                type: "button",
                role: "tab",
                class: Re(["fe-e2e-recover__tab", { "fe-e2e-recover__tab--on": h.value === "recovery" }]),
                "aria-selected": h.value === "recovery",
                onClick: $[0] || ($[0] = (C) => h.value = "recovery")
              }, f(r(n)("e2e.recover.tab_recovery")), 11, AJ),
              i("button", {
                type: "button",
                role: "tab",
                class: Re(["fe-e2e-recover__tab", { "fe-e2e-recover__tab--on": h.value === "escrow" }]),
                "aria-selected": h.value === "escrow",
                onClick: $[1] || ($[1] = (C) => h.value = "escrow")
              }, f(r(n)("e2e.recover.tab_escrow")), 11, zJ)
            ])) : T("", !0),
            h.value === "recovery" ? (u(), d("form", {
              key: 1,
              class: "fe-e2e-form",
              onSubmit: ft(_, ["prevent"])
            }, [
              i("p", MJ, f(r(n)("e2e.recover.recovery_hint")), 1),
              dt(i("input", {
                "onUpdate:modelValue": $[2] || ($[2] = (C) => v.value = C),
                type: "text",
                class: "fe-input fe-e2e-recover__key",
                placeholder: r(n)("e2e.recover.recovery_placeholder"),
                autocomplete: "off",
                spellcheck: "false",
                disabled: e.busy
              }, null, 8, DJ), [
                [St, v.value]
              ])
            ], 32)) : (u(), d("form", {
              key: 2,
              class: "fe-e2e-form",
              onSubmit: ft(_, ["prevent"])
            }, [
              i("div", PJ, [
                i("strong", null, f(r(n)("e2e.recover.escrow_warn_title")), 1),
                i("p", null, f(r(n)("e2e.recover.escrow_warn_body")), 1)
              ]),
              e.escrowKid ? (u(), d("p", OJ, [
                $t(f(r(n)("e2e.recover.escrow_kid")) + ": ", 1),
                i("code", null, f(e.escrowKid), 1)
              ])) : T("", !0),
              dt(i("textarea", {
                "onUpdate:modelValue": $[3] || ($[3] = (C) => y.value = C),
                class: "fe-input fe-e2e-recover__escrow",
                rows: "5",
                placeholder: r(n)("e2e.recover.escrow_placeholder"),
                autocomplete: "off",
                spellcheck: "false",
                disabled: e.busy
              }, null, 8, LJ), [
                [St, y.value]
              ])
            ], 32))
          ], 64)),
          p.value ? (u(), d("p", IJ, f(p.value), 1)) : T("", !0),
          k.value ? (u(), d("p", RJ, f(k.value), 1)) : T("", !0)
        ])
      ]),
      _: 1
    }, 8, ["open", "title"]));
  }
}), UJ = {
  key: 0,
  class: "fe-e2e-pw__lead"
}, HJ = {
  key: 0,
  class: "fe-field"
}, KJ = { class: "fe-field__label" }, VJ = ["disabled"], qJ = {
  key: 1,
  class: "fe-field"
}, jJ = { class: "fe-field__label" }, WJ = ["placeholder", "disabled"], YJ = ["disabled"], GJ = { class: "fe-field" }, XJ = { class: "fe-field__label" }, JJ = ["placeholder", "disabled"], ZJ = { class: "fe-field" }, QJ = { class: "fe-field__label" }, eZ = ["disabled", "onKeydown"], tZ = {
  key: 2,
  class: "fe-e2e-pw__note",
  "data-testid": "e2e-password-cost"
}, aZ = {
  key: 3,
  class: "fe-e2e-warn",
  role: "note",
  "data-testid": "e2e-password-cost"
}, nZ = { key: 0 }, sZ = {
  key: 4,
  class: "fe-e2e-ack"
}, oZ = ["disabled"], iZ = {
  key: 5,
  class: "fe-e2e-ack"
}, rZ = ["disabled"], lZ = {
  key: 6,
  class: "fe-e2e-pw__note"
}, uZ = {
  key: 7,
  class: "fe-e2e-upgrade__progress",
  role: "status",
  "data-testid": "e2e-password-progress"
}, cZ = {
  key: 8,
  class: "fe-form__error",
  role: "alert",
  "data-testid": "e2e-password-error"
}, dZ = ["disabled"], fZ = ["disabled"], L_ = /* @__PURE__ */ rt({
  __name: "E2eChangePasswordModal",
  props: {
    open: { type: Boolean },
    locale: {},
    mode: {},
    needsRekey: { type: Boolean },
    hasRecovery: { type: Boolean },
    hasEscrow: { type: Boolean },
    busy: { type: Boolean },
    error: {},
    progress: {},
    subject: {}
  },
  emits: ["close", "submit"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n } = gt(() => t.locale), o = b(!1), p = b(""), h = b(""), v = b(""), y = b(""), g = b(!1), m = b(!1), k = b(null);
    Qe(
      () => t.open,
      (A) => {
        A && (o.value = !1, p.value = "", h.value = "", v.value = "", y.value = "", g.value = !1, m.value = !1, k.value = null);
      }
    );
    const _ = x(() => t.subject === "file"), w = x(() => !_.value && (t.needsRekey || g.value)), $ = x(
      () => t.mode === "reset" ? n("e2e.password.reset_title") : _.value ? n("e2e.fxe.password_title") : n("e2e.password.title")
    ), C = x(() => k.value ?? t.error ?? null);
    function E() {
      if (t.busy) return;
      let A = null;
      if (t.mode === "change")
        if (o.value) {
          if (!Kr(h.value)) {
            k.value = n("e2e.password.bad_recovery");
            return;
          }
          A = { recoveryKey: h.value };
        } else {
          if (!p.value) {
            k.value = n("e2e.password.current_required");
            return;
          }
          A = { password: p.value };
        }
      if (v.value.length < oi) {
        k.value = n("e2e.create.pw_short");
        return;
      }
      if (v.value !== y.value) {
        k.value = n("e2e.create.pw_mismatch");
        return;
      }
      if (A && "password" in A && A.password === v.value) {
        k.value = n("e2e.password.same");
        return;
      }
      if (w.value && !m.value) {
        k.value = n("e2e.create.ack_required");
        return;
      }
      k.value = null, s("submit", { proof: A, newPassword: v.value, rotate: w.value });
    }
    return (A, O) => (u(), nt(la, {
      open: e.open,
      title: $.value,
      size: "sm",
      busy: e.busy,
      "close-on-backdrop": e.mode !== "reset",
      onClose: O[8] || (O[8] = (z) => s("close"))
    }, {
      actions: yt(() => [
        i("button", {
          type: "button",
          class: "fe-btn",
          disabled: e.busy,
          onClick: O[7] || (O[7] = (z) => s("close"))
        }, f(e.mode === "reset" ? r(n)("e2e.password.lock_instead") : r(n)("modal.newfolder.cancel")), 9, dZ),
        i("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: e.busy,
          "data-testid": "e2e-password-submit",
          onClick: E
        }, f(e.busy ? r(n)("e2e.password.busy") : r(n)("e2e.password.submit")), 9, fZ)
      ]),
      default: yt(() => [
        i("form", {
          class: "fe-e2e-form",
          "data-testid": "e2e-password-form",
          onSubmit: ft(E, ["prevent"])
        }, [
          e.mode === "reset" ? (u(), d("p", UJ, f(r(n)("e2e.password.reset_lead")), 1)) : T("", !0),
          e.mode === "change" ? (u(), d(he, { key: 1 }, [
            o.value ? (u(), d("label", qJ, [
              i("span", jJ, f(r(n)("e2e.password.recovery")), 1),
              dt(i("input", {
                "onUpdate:modelValue": O[1] || (O[1] = (z) => h.value = z),
                type: "text",
                class: "fe-input fe-e2e-recover__key",
                autocomplete: "off",
                spellcheck: "false",
                placeholder: r(n)("e2e.recover.recovery_placeholder"),
                "data-testid": "e2e-password-recovery",
                disabled: e.busy
              }, null, 8, WJ), [
                [St, h.value]
              ])
            ])) : (u(), d("label", HJ, [
              i("span", KJ, f(r(n)("e2e.password.current")), 1),
              dt(i("input", {
                "onUpdate:modelValue": O[0] || (O[0] = (z) => p.value = z),
                type: "password",
                class: "fe-input",
                autocomplete: "current-password",
                "data-testid": "e2e-password-current",
                disabled: e.busy
              }, null, 8, VJ), [
                [St, p.value]
              ])
            ])),
            e.hasRecovery ? (u(), d("button", {
              key: 2,
              type: "button",
              class: "fe-e2e-optlink",
              disabled: e.busy,
              onClick: O[2] || (O[2] = (z) => o.value = !o.value)
            }, f(o.value ? r(n)("e2e.password.use_current") : r(n)("e2e.password.use_recovery")), 9, YJ)) : T("", !0)
          ], 64)) : T("", !0),
          i("label", GJ, [
            i("span", XJ, f(r(n)("e2e.password.new")), 1),
            dt(i("input", {
              "onUpdate:modelValue": O[3] || (O[3] = (z) => v.value = z),
              type: "password",
              class: "fe-input",
              autocomplete: "new-password",
              placeholder: r(n)("e2e.create.pw_placeholder"),
              "data-testid": "e2e-password-new",
              disabled: e.busy
            }, null, 8, JJ), [
              [St, v.value]
            ])
          ]),
          i("label", ZJ, [
            i("span", QJ, f(r(n)("e2e.create.pw2_label")), 1),
            dt(i("input", {
              "onUpdate:modelValue": O[4] || (O[4] = (z) => y.value = z),
              type: "password",
              class: "fe-input",
              autocomplete: "new-password",
              "data-testid": "e2e-password-new2",
              disabled: e.busy,
              onKeydown: ya(ft(E, ["prevent"]), ["enter"])
            }, null, 40, eZ), [
              [St, y.value]
            ])
          ]),
          w.value ? (u(), d("div", aZ, [
            i("strong", null, f(e.needsRekey ? r(n)("e2e.password.rekey_title") : r(n)("e2e.password.rotate_title")), 1),
            i("p", null, f(e.needsRekey ? r(n)("e2e.password.rekey_body") : r(n)("e2e.password.rotate_body")), 1),
            i("p", null, f(e.mode === "reset" || o.value ? r(n)("e2e.password.rekey_rk_kept") : r(n)("e2e.password.rekey_rk_new")), 1),
            e.hasEscrow ? (u(), d("p", nZ, f(r(n)("e2e.password.rekey_escrow")), 1)) : T("", !0)
          ])) : (u(), d("p", tZ, f(_.value ? r(n)("e2e.fxe.password_cost") : r(n)("e2e.password.cheap_note")), 1)),
          !e.needsRekey && !_.value ? (u(), d("label", sZ, [
            dt(i("input", {
              "onUpdate:modelValue": O[5] || (O[5] = (z) => g.value = z),
              type: "checkbox",
              "data-testid": "e2e-password-rotate",
              disabled: e.busy
            }, null, 8, oZ), [
              [Ja, g.value]
            ]),
            i("span", null, f(r(n)("e2e.password.rotate_label")), 1)
          ])) : T("", !0),
          w.value ? (u(), d("label", iZ, [
            dt(i("input", {
              "onUpdate:modelValue": O[6] || (O[6] = (z) => m.value = z),
              type: "checkbox",
              "data-testid": "e2e-password-ack",
              disabled: e.busy
            }, null, 8, rZ), [
              [Ja, m.value]
            ]),
            i("span", null, f(r(n)("e2e.password.rekey_ack")), 1)
          ])) : T("", !0),
          w.value ? T("", !0) : (u(), d("p", lZ, f(_.value ? r(n)("e2e.fxe.password_old_copies") : r(n)("e2e.password.old_copies")), 1)),
          e.progress ? (u(), d("p", uZ, f(r(n)("e2e.password.progress", { n: e.progress.done, failed: e.progress.failed })), 1)) : T("", !0),
          C.value ? (u(), d("p", cZ, f(C.value), 1)) : T("", !0)
        ], 32)
      ]),
      _: 1
    }, 8, ["open", "title", "busy", "close-on-backdrop"]));
  }
}), pZ = {
  class: "fe-e2e-settings",
  "data-testid": "e2e-settings"
}, vZ = { class: "fe-e2e-settings__section" }, hZ = { class: "fe-e2e-settings__head" }, mZ = {
  class: "fe-e2e-settings__value",
  "data-testid": "e2e-settings-level"
}, yZ = { key: 0 }, gZ = { class: "fe-e2e-settings__hint" }, bZ = ["disabled"], _Z = {
  key: 1,
  class: "fe-e2e-warn",
  role: "note",
  "data-testid": "e2e-settings-raise-confirm"
}, kZ = { class: "fe-e2e-ack" }, wZ = ["disabled"], xZ = { class: "fe-e2e-settings__row" }, $Z = ["disabled"], SZ = ["disabled"], TZ = ["disabled"], CZ = { class: "fe-e2e-settings__section" }, EZ = { class: "fe-e2e-settings__head" }, AZ = ["disabled"], zZ = {
  key: 0,
  class: "fe-e2e-settings__section"
}, MZ = { class: "fe-e2e-settings__head" }, DZ = ["disabled"], PZ = ["disabled"], OZ = /* @__PURE__ */ rt({
  __name: "E2eSettingsModal",
  props: {
    open: { type: Boolean },
    locale: {},
    level: {},
    canRaise: { type: Boolean },
    plainNamed: {},
    escrowState: {},
    busy: { type: Boolean }
  },
  emits: ["close", "raise-level", "fix-names", "change-password", "escrow"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n } = gt(() => t.locale), o = b(!1), p = b(!1);
    Qe(
      () => t.open,
      (g) => {
        g && (o.value = !1, p.value = !1);
      }
    );
    const h = x(
      () => t.level === "content" ? n("e2e.level.content") : n("e2e.level.names")
    ), v = x(
      () => t.level === "content" ? n("e2e.level.content_hint") : n("e2e.level.names_hint")
    );
    function y() {
      !p.value || t.busy || s("raise-level");
    }
    return (g, m) => (u(), nt(la, {
      open: e.open,
      title: r(n)("e2e.settings.title"),
      size: "sm",
      busy: e.busy,
      onClose: m[7] || (m[7] = (k) => s("close"))
    }, {
      actions: yt(() => [
        i("button", {
          type: "button",
          class: "fe-btn",
          disabled: e.busy,
          onClick: m[6] || (m[6] = (k) => s("close"))
        }, f(r(n)("e2e.settings.close")), 9, PZ)
      ]),
      default: yt(() => [
        i("div", pZ, [
          i("section", vZ, [
            i("h3", hZ, f(r(n)("e2e.settings.level")), 1),
            i("p", mZ, [
              $t(f(h.value), 1),
              e.level === "pending" ? (u(), d("span", yZ, " — " + f(r(n)("e2e.level.pending")), 1)) : T("", !0)
            ]),
            i("p", gZ, f(v.value), 1),
            e.canRaise ? (u(), d(he, { key: 0 }, [
              o.value ? (u(), d("div", _Z, [
                i("strong", null, f(r(n)("e2e.level.raise_title")), 1),
                i("p", null, f(r(n)("e2e.level.raise_body")), 1),
                i("p", null, f(r(n)("e2e.names.offer_cost")), 1),
                i("label", kZ, [
                  dt(i("input", {
                    "onUpdate:modelValue": m[1] || (m[1] = (k) => p.value = k),
                    type: "checkbox",
                    "data-testid": "e2e-settings-raise-ack",
                    disabled: e.busy
                  }, null, 8, wZ), [
                    [Ja, p.value]
                  ]),
                  i("span", null, f(r(n)("e2e.level.raise_ack")), 1)
                ]),
                i("div", xZ, [
                  i("button", {
                    type: "button",
                    class: "fe-btn",
                    disabled: e.busy,
                    onClick: m[2] || (m[2] = (k) => o.value = !1)
                  }, f(r(n)("modal.newfolder.cancel")), 9, $Z),
                  i("button", {
                    type: "button",
                    class: "fe-btn fe-btn--primary",
                    "data-testid": "e2e-settings-raise-go",
                    disabled: !p.value || e.busy,
                    onClick: y
                  }, f(r(n)("e2e.level.raise_go")), 9, SZ)
                ])
              ])) : (u(), d("button", {
                key: 0,
                type: "button",
                class: "fe-btn",
                "data-testid": "e2e-settings-raise",
                disabled: e.busy,
                onClick: m[0] || (m[0] = (k) => o.value = !0)
              }, f(r(n)("e2e.level.change")), 9, bZ))
            ], 64)) : T("", !0),
            e.level !== "content" && e.plainNamed > 0 ? (u(), d("button", {
              key: 1,
              type: "button",
              class: "fe-btn",
              "data-testid": "e2e-settings-fix-names",
              disabled: e.busy,
              onClick: m[3] || (m[3] = (k) => s("fix-names"))
            }, f(r(n)("e2e.names.strip_fix", { n: e.plainNamed })), 9, TZ)) : T("", !0)
          ]),
          i("section", CZ, [
            i("h3", EZ, f(r(n)("e2e.settings.password")), 1),
            i("button", {
              type: "button",
              class: "fe-btn",
              "data-testid": "e2e-password-open",
              disabled: e.busy,
              onClick: m[4] || (m[4] = (k) => s("change-password"))
            }, f(r(n)("e2e.password.strip_action")), 9, AZ)
          ]),
          e.escrowState !== "n/a" ? (u(), d("section", zZ, [
            i("h3", MZ, f(r(n)("e2e.settings.escrow")), 1),
            i("button", {
              type: "button",
              class: "fe-btn",
              disabled: e.busy,
              onClick: m[5] || (m[5] = (k) => s("escrow"))
            }, f(r(n)("e2e.escrowoffer.strip_action")), 9, DZ)
          ])) : T("", !0)
        ])
      ]),
      _: 1
    }, 8, ["open", "title", "busy"]));
  }
});
function G0(e, a) {
  const t = e.lastIndexOf(".");
  return t <= 0 ? `${e} (${a})` : `${e.slice(0, t)} (${a})${e.slice(t)}`;
}
function LZ(e, a) {
  if (e.length !== a.length) return !1;
  for (let t = 0; t < e.length; t++) if (e[t] !== a[t]) return !1;
  return !0;
}
async function IZ(e, a, t, s) {
  if (!a) return null;
  for (const n of s) {
    if (LZ(n, t)) continue;
    const o = await $w(e, a, n);
    if (o !== null) return vs(o) ? null : o;
  }
  return null;
}
async function RZ(e, a, t) {
  var o;
  const s = Hr(e);
  return s.kind === "file" || s.kind === "dir" ? s.encoded ?? null : s.kind !== "long" && s.kind !== "longdir" ? null : (((o = await t.readSidecar(a, `${s.hash}.fxl.name`)) == null ? void 0 : o.trim()) ?? "") || null;
}
async function NZ(e, a, t, s) {
  const n = [], o = [{ wire: a, id: e.rootId }];
  for (; o.length; ) {
    if (t.stopped()) return;
    const h = o.shift();
    let v;
    try {
      v = await t.list(h.wire);
    } catch {
      s.failed++;
      continue;
    }
    n.push({ ...h, rows: v });
    for (const y of v)
      y.type === "dir" && o.push({ wire: y.path, id: await _v(e, h.id, y.basename) });
  }
  const p = n.map((h) => h.id);
  for (const h of n.reverse()) {
    const v = new Set(h.rows.map((y) => y.basename));
    for (const y of h.rows) {
      if (t.stopped()) return;
      const g = y.basename;
      if (g === en) continue;
      const m = await Sw(e, g, h.id, (C) => t.readSidecar(h.wire, C));
      if (m.state === "enc" || m.state === "sidecar") continue;
      s.seen++;
      const k = await IZ(e, await RZ(g, h.wire, t), h.id, p), _ = k ?? (m.state === "plain" ? g : null);
      if (_ === null || vs(_)) {
        s.failed++;
        continue;
      }
      const w = y.type === "dir" ? { dirId: await _v(e, h.id, g) } : {};
      let $ = await kv(e, _, h.id, w);
      for (let C = 2; v.has($.stored) && C < 100; C++)
        $ = await kv(e, G0(_, C), h.id, w);
      if (v.has($.stored)) {
        s.failed++;
        continue;
      }
      try {
        $.sidecar && await t.writeSidecar(h.wire, $.sidecar.name, $.sidecar.content), await t.rename(h.wire, y, $.stored), v.delete(g), v.add($.stored), s.renamed++, k !== null && (s.repaired = (s.repaired ?? 0) + 1);
      } catch {
        s.failed++;
      }
    }
  }
}
function BZ(e) {
  return typeof e.size != "number" || typeof e.last_modified != "number" ? null : `${e.size}:${e.last_modified}`;
}
async function FZ(e, a, t, s) {
  const n = [], o = [e], p = (h) => h.replace(/\/+$/, "") === e.replace(/\/+$/, "");
  for (; o.length; ) {
    if (a.stopped()) return;
    const h = o.shift();
    let v;
    try {
      v = await a.list(h);
    } catch {
      t.failed++;
      continue;
    }
    for (const y of v) {
      if (y.type === "dir") {
        o.push(y.path);
        continue;
      }
      p(h) && y.basename === en || Hr(y.basename).kind !== "sidecar" && n.push({ dir: h, row: y });
    }
  }
  t.total = n.length;
  for (const { dir: h, row: v } of n) {
    if (a.stopped()) return;
    try {
      if (Or(await a.head(v.path))) {
        t.skipped++;
        continue;
      }
      if (typeof v.size == "number" && v.size > s.maxBytes) {
        t.tooBig++;
        continue;
      }
      const y = await a.read(v.path);
      if (y.byteLength > s.maxBytes) {
        t.tooBig++;
        continue;
      }
      const g = await a.encrypt(y);
      await a.write(h, v, new Blob([g], { type: "application/octet-stream" }), BZ(v)), t.done++;
    } catch {
      t.failed++;
    }
  }
}
const Qv = /* @__PURE__ */ new Set(), eh = b(0);
function UZ(e) {
  return Qv.add(e), eh.value++, () => {
    Qv.delete(e) && eh.value++;
  };
}
function HZ(e, a) {
  eh.value;
  for (const t of Qv) {
    const s = t(e, a);
    if (s) return s;
  }
  return null;
}
const KZ = { class: "fe-e2e-rk__lead" }, VZ = { class: "fe-field" }, qZ = { class: "fe-field__label" }, jZ = ["placeholder", "disabled"], WZ = { class: "fe-field" }, YZ = { class: "fe-field__label" }, GZ = ["disabled", "onKeydown"], XZ = { class: "fe-e2e-names" }, JZ = { class: "fe-e2e-ack" }, ZZ = ["disabled"], QZ = {
  class: "fe-e2e-names__hint",
  "data-testid": "fxe-encrypt-hide-hint"
}, eQ = {
  class: "fe-e2e-seen",
  role: "note",
  "data-testid": "fxe-encrypt-seen"
}, tQ = {
  key: 0,
  class: "fe-e2e-names",
  "data-testid": "fxe-encrypt-purge-box"
}, aQ = { class: "fe-e2e-ack" }, nQ = ["disabled"], sQ = { class: "fe-e2e-names__hint" }, oQ = {
  key: 0,
  class: "fe-e2e-ack fe-e2e-warn",
  "data-testid": "fxe-encrypt-purge-others"
}, iQ = ["disabled"], rQ = {
  class: "fe-e2e-warn",
  role: "alert"
}, lQ = {
  key: 1,
  class: "fe-e2e-rk__escrow",
  role: "note",
  "data-testid": "fxe-encrypt-escrow"
}, uQ = { class: "fe-e2e-ack" }, cQ = ["disabled"], dQ = {
  key: 2,
  class: "fe-e2e-upgrade__progress",
  role: "status"
}, fQ = {
  key: 3,
  class: "fe-form__error",
  role: "alert",
  "data-testid": "fxe-encrypt-error"
}, pQ = ["disabled"], vQ = ["disabled"], hQ = /* @__PURE__ */ rt({
  __name: "E2eFileEncryptModal",
  props: {
    open: { type: Boolean },
    locale: {},
    fileName: {},
    busy: { type: Boolean },
    error: {},
    progress: {},
    escrowKid: {},
    canPurge: { type: Boolean },
    notOwner: { type: Boolean },
    ownerName: {}
  },
  emits: ["close", "submit"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n } = gt(() => t.locale), o = b(""), p = b(""), h = b(!1), v = b(!1), y = b(!1), g = b(!1), m = b(null);
    Qe(
      () => t.open,
      ($) => {
        $ && (o.value = "", p.value = "", h.value = !1, v.value = !1, y.value = !1, g.value = !1, m.value = null);
      }
    );
    const k = x(() => h.value ? "encrypted-xxxxxxxx.fxe" : `${t.fileName}.fxe`), _ = x(() => m.value ?? t.error ?? null);
    function w() {
      if (t.busy) return;
      if (o.value.length < oi) {
        m.value = n("e2e.create.pw_short");
        return;
      }
      if (o.value !== p.value) {
        m.value = n("e2e.create.pw_mismatch");
        return;
      }
      if (!v.value) {
        m.value = n("e2e.create.ack_required");
        return;
      }
      const $ = !!t.canPurge && y.value;
      if ($ && t.notOwner && !g.value) {
        m.value = n("e2e.fxe.purge_others_required");
        return;
      }
      m.value = null, s("submit", { password: o.value, hideName: h.value, purge: $ });
    }
    return ($, C) => (u(), nt(la, {
      open: e.open,
      title: r(n)("e2e.fxe.encrypt_title"),
      size: "sm",
      busy: e.busy,
      onClose: C[7] || (C[7] = (E) => s("close"))
    }, {
      actions: yt(() => [
        i("button", {
          type: "button",
          class: "fe-btn",
          disabled: e.busy,
          onClick: C[6] || (C[6] = (E) => s("close"))
        }, f(r(n)("modal.newfolder.cancel")), 9, pQ),
        i("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: e.busy,
          "data-testid": "fxe-encrypt-submit",
          onClick: w
        }, f(e.busy ? r(n)("e2e.fxe.unlock_busy") : r(n)("e2e.fxe.encrypt_submit")), 9, vQ)
      ]),
      default: yt(() => [
        i("form", {
          class: "fe-e2e-form",
          "data-testid": "fxe-encrypt-form",
          onSubmit: ft(w, ["prevent"])
        }, [
          i("p", KZ, f(r(n)("e2e.fxe.encrypt_lead", { name: e.fileName })), 1),
          i("label", VZ, [
            i("span", qZ, f(r(n)("e2e.fxe.pw_label")), 1),
            dt(i("input", {
              "onUpdate:modelValue": C[0] || (C[0] = (E) => o.value = E),
              type: "password",
              class: "fe-input",
              placeholder: r(n)("e2e.create.pw_placeholder"),
              autocomplete: "new-password",
              "data-testid": "fxe-encrypt-pw",
              disabled: e.busy
            }, null, 8, jZ), [
              [St, o.value]
            ])
          ]),
          i("label", WZ, [
            i("span", YZ, f(r(n)("e2e.create.pw2_label")), 1),
            dt(i("input", {
              "onUpdate:modelValue": C[1] || (C[1] = (E) => p.value = E),
              type: "password",
              class: "fe-input",
              autocomplete: "new-password",
              "data-testid": "fxe-encrypt-pw2",
              disabled: e.busy,
              onKeydown: ya(ft(w, ["prevent"]), ["enter"])
            }, null, 40, GZ), [
              [St, p.value]
            ])
          ]),
          i("div", XZ, [
            i("label", JZ, [
              dt(i("input", {
                "onUpdate:modelValue": C[2] || (C[2] = (E) => h.value = E),
                type: "checkbox",
                disabled: e.busy,
                "data-testid": "fxe-encrypt-hide"
              }, null, 8, ZZ), [
                [Ja, h.value]
              ]),
              i("span", null, f(r(n)("e2e.fxe.hide_label")), 1)
            ]),
            i("p", QZ, f(h.value ? r(n)("e2e.fxe.hide_on_hint", { stored: k.value }) : r(n)("e2e.fxe.hide_off_hint", { stored: k.value })), 1)
          ]),
          i("div", eQ, [
            i("strong", null, f(r(n)("e2e.fxe.seen_title")), 1),
            i("p", null, f(r(n)("e2e.fxe.seen_lead")), 1),
            i("ul", null, [
              i("li", null, f(e.canPurge ? r(n)("e2e.fxe.seen_trash_admin") : r(n)("e2e.fxe.seen_trash")), 1),
              i("li", null, f(e.canPurge ? r(n)("e2e.fxe.seen_versions_admin") : r(n)("e2e.fxe.seen_versions")), 1),
              i("li", null, f(r(n)("e2e.fxe.seen_thumb")), 1),
              i("li", null, f(r(n)("e2e.fxe.seen_backups")), 1)
            ])
          ]),
          e.canPurge ? (u(), d("div", tQ, [
            i("label", aQ, [
              dt(i("input", {
                "onUpdate:modelValue": C[3] || (C[3] = (E) => y.value = E),
                type: "checkbox",
                disabled: e.busy,
                "data-testid": "fxe-encrypt-purge"
              }, null, 8, nQ), [
                [Ja, y.value]
              ]),
              i("span", null, f(r(n)("e2e.fxe.purge_label")), 1)
            ]),
            i("p", sQ, f(r(n)("e2e.fxe.purge_hint")), 1),
            y.value && e.notOwner ? (u(), d("label", oQ, [
              dt(i("input", {
                "onUpdate:modelValue": C[4] || (C[4] = (E) => g.value = E),
                type: "checkbox",
                disabled: e.busy,
                "data-testid": "fxe-encrypt-purge-others-ack"
              }, null, 8, iQ), [
                [Ja, g.value]
              ]),
              i("span", null, f(e.ownerName ? r(n)("e2e.fxe.purge_others", { owner: e.ownerName }) : r(n)("e2e.fxe.purge_others_unknown")), 1)
            ])) : T("", !0)
          ])) : T("", !0),
          i("div", rQ, [
            i("strong", null, f(r(n)("e2e.create.warn_title")), 1),
            i("p", null, f(r(n)("e2e.fxe.warn_body")), 1)
          ]),
          e.escrowKid ? (u(), d("div", lQ, [
            i("strong", null, f(r(n)("e2e.create.escrow_title")), 1),
            i("p", null, f(r(n)("e2e.fxe.escrow_body")), 1)
          ])) : T("", !0),
          i("label", uQ, [
            dt(i("input", {
              "onUpdate:modelValue": C[5] || (C[5] = (E) => v.value = E),
              type: "checkbox",
              disabled: e.busy,
              "data-testid": "fxe-encrypt-ack"
            }, null, 8, cQ), [
              [Ja, v.value]
            ]),
            i("span", null, f(r(n)("e2e.create.ack")), 1)
          ]),
          e.busy && e.progress !== null && e.progress !== void 0 ? (u(), d("p", dQ, f(r(n)("e2e.fxe.encrypt_busy", { percent: e.progress })), 1)) : T("", !0),
          _.value ? (u(), d("p", fQ, f(_.value), 1)) : T("", !0)
        ], 32)
      ]),
      _: 1
    }, 8, ["open", "title", "busy"]));
  }
}), mQ = ["data-intent"], yQ = { class: "fe-e2e-rk__lead" }, gQ = {
  key: 0,
  class: "fe-e2e-warn",
  role: "alert",
  "data-testid": "fxe-remove-warn"
}, bQ = {
  key: 1,
  class: "fe-e2e-pw__note",
  role: "status",
  "data-testid": "fxe-unlock-save-again"
}, _Q = {
  key: 2,
  class: "fe-e2e-pw__note"
}, kQ = {
  key: 0,
  class: "fe-field"
}, wQ = { class: "fe-field__label" }, xQ = ["disabled", "onKeydown"], $Q = {
  key: 1,
  class: "fe-field"
}, SQ = { class: "fe-field__label" }, TQ = ["placeholder", "disabled", "onKeydown"], CQ = {
  class: "fe-e2e-warn",
  role: "alert",
  "data-testid": "fxe-unlock-escrow-warn"
}, EQ = { key: 0 }, AQ = ["placeholder", "disabled"], zQ = ["disabled"], MQ = ["disabled"], DQ = {
  key: 5,
  class: "fe-e2e-recover__note",
  "data-testid": "fxe-unlock-escrow-note"
}, PQ = {
  key: 4,
  class: "fe-e2e-upgrade__progress",
  role: "status"
}, OQ = {
  key: 5,
  class: "fe-form__error",
  role: "alert",
  "data-testid": "fxe-unlock-error"
}, LQ = ["disabled"], IQ = ["disabled"], RQ = /* @__PURE__ */ rt({
  __name: "E2eFileUnlockModal",
  props: {
    open: { type: Boolean },
    locale: {},
    intent: {},
    fileName: {},
    known: { type: Boolean },
    hasRecovery: { type: Boolean },
    busy: { type: Boolean },
    error: {},
    progress: {},
    needsSave: { type: Boolean },
    escrowState: {},
    escrowKid: {}
  },
  emits: ["close", "submit"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n } = gt(() => t.locale), o = b("password"), p = b(""), h = b(""), v = b(""), y = b(null);
    Qe(
      () => t.open,
      (C) => {
        C && (o.value = "password", p.value = "", h.value = "", v.value = "", y.value = null);
      }
    );
    const g = x(() => t.escrowState === "available"), m = x(
      () => t.escrowState === "predates" ? n("e2e.fxe.escrow_predates") : t.escrowState === "other-key" ? n("e2e.fxe.escrow_other_key") : null
    ), k = x(
      () => t.intent === "remove" ? n("e2e.fxe.unlock_title_remove") : t.intent === "download" ? n("e2e.fxe.unlock_title_download") : n("e2e.fxe.unlock_title_open")
    ), _ = x(
      () => t.needsSave ? n("e2e.fxe.save_button") : t.intent === "remove" ? n("e2e.fxe.unlock_remove") : t.intent === "download" ? n("e2e.fxe.unlock_download") : n("e2e.fxe.unlock_open")
    ), w = x(() => y.value ?? t.error ?? null);
    function $() {
      if (!t.busy) {
        if (y.value = null, t.known || t.needsSave) {
          s("submit", {});
          return;
        }
        if (o.value === "escrow") {
          if (!v.value.trim()) {
            y.value = n("e2e.recover.escrow_required");
            return;
          }
          s("submit", { escrowKey: v.value });
          return;
        }
        if (o.value === "recovery") {
          if (!Kr(h.value)) {
            y.value = n("e2e.password.bad_recovery");
            return;
          }
          s("submit", { recoveryKey: h.value });
          return;
        }
        if (!p.value) {
          y.value = n("e2e.password.current_required");
          return;
        }
        s("submit", { password: p.value });
      }
    }
    return (C, E) => (u(), nt(la, {
      open: e.open,
      title: k.value,
      size: "sm",
      busy: e.busy,
      onClose: E[6] || (E[6] = (A) => s("close"))
    }, {
      actions: yt(() => [
        i("button", {
          type: "button",
          class: "fe-btn",
          disabled: e.busy,
          onClick: E[5] || (E[5] = (A) => s("close"))
        }, f(r(n)("modal.newfolder.cancel")), 9, LQ),
        i("button", {
          type: "button",
          class: Re(["fe-btn fe-btn--primary", { "fe-btn--danger": e.intent === "remove" && !e.needsSave }]),
          disabled: e.busy,
          "data-testid": "fxe-unlock-submit",
          onClick: $
        }, f(e.busy ? r(n)("e2e.fxe.unlock_busy") : _.value), 11, IQ)
      ]),
      default: yt(() => [
        i("form", {
          class: "fe-e2e-form",
          "data-testid": "fxe-unlock-form",
          "data-intent": e.intent,
          onSubmit: ft($, ["prevent"])
        }, [
          i("p", yQ, f(r(n)("e2e.fxe.unlock_lead", { name: e.fileName })), 1),
          e.intent === "remove" ? (u(), d("div", gQ, [
            i("strong", null, f(r(n)("e2e.fxe.remove_warn_title")), 1),
            i("p", null, f(r(n)("e2e.fxe.remove_warn_body")), 1)
          ])) : T("", !0),
          e.needsSave ? (u(), d("p", bQ, f(r(n)("e2e.fxe.save_again")), 1)) : e.known ? (u(), d("p", _Q, f(r(n)("e2e.fxe.known_note")), 1)) : (u(), d(he, { key: 3 }, [
            o.value === "password" ? (u(), d("label", kQ, [
              i("span", wQ, f(r(n)("e2e.fxe.pw_label")), 1),
              dt(i("input", {
                "onUpdate:modelValue": E[0] || (E[0] = (A) => p.value = A),
                type: "password",
                class: "fe-input",
                autocomplete: "current-password",
                "data-testid": "fxe-unlock-pw",
                disabled: e.busy,
                onKeydown: ya(ft($, ["prevent"]), ["enter"])
              }, null, 40, xQ), [
                [St, p.value]
              ])
            ])) : o.value === "recovery" ? (u(), d("label", $Q, [
              i("span", SQ, f(r(n)("e2e.password.recovery")), 1),
              dt(i("input", {
                "onUpdate:modelValue": E[1] || (E[1] = (A) => h.value = A),
                type: "text",
                class: "fe-input fe-e2e-recover__key",
                autocomplete: "off",
                spellcheck: "false",
                placeholder: r(n)("e2e.recover.recovery_placeholder"),
                "data-testid": "fxe-unlock-recovery",
                disabled: e.busy,
                onKeydown: ya(ft($, ["prevent"]), ["enter"])
              }, null, 40, TQ), [
                [St, h.value]
              ])
            ])) : (u(), d(he, { key: 2 }, [
              i("div", CQ, [
                i("strong", null, f(r(n)("e2e.fxe.escrow_warn_title")), 1),
                i("p", null, f(r(n)("e2e.fxe.escrow_warn_body")), 1),
                e.escrowKid ? (u(), d("p", EQ, [
                  $t(f(r(n)("e2e.recover.escrow_kid")) + ": ", 1),
                  i("code", null, f(e.escrowKid), 1)
                ])) : T("", !0)
              ]),
              dt(i("textarea", {
                "onUpdate:modelValue": E[2] || (E[2] = (A) => v.value = A),
                class: "fe-input fe-e2e-recover__escrow",
                rows: "5",
                placeholder: r(n)("e2e.recover.escrow_placeholder"),
                autocomplete: "off",
                spellcheck: "false",
                "data-testid": "fxe-unlock-escrow",
                disabled: e.busy
              }, null, 8, AQ), [
                [St, v.value]
              ])
            ], 64)),
            o.value !== "password" || e.hasRecovery !== !1 ? (u(), d("button", {
              key: 3,
              type: "button",
              class: "fe-e2e-optlink",
              "data-testid": "fxe-unlock-toggle",
              disabled: e.busy,
              onClick: E[3] || (E[3] = (A) => o.value = o.value === "password" ? "recovery" : "password")
            }, f(o.value === "password" ? r(n)("e2e.password.use_recovery") : r(n)("e2e.fxe.use_password")), 9, zQ)) : T("", !0),
            g.value && o.value !== "escrow" ? (u(), d("button", {
              key: 4,
              type: "button",
              class: "fe-e2e-optlink",
              "data-testid": "fxe-unlock-escrow-toggle",
              disabled: e.busy,
              onClick: E[4] || (E[4] = (A) => o.value = "escrow")
            }, f(r(n)("e2e.fxe.use_escrow")), 9, MQ)) : T("", !0),
            m.value && o.value === "recovery" ? (u(), d("p", DQ, f(m.value), 1)) : T("", !0)
          ], 64)),
          e.busy && e.progress !== null && e.progress !== void 0 ? (u(), d("p", PQ, f(r(n)("e2e.fxe.progress", { percent: e.progress })), 1)) : T("", !0),
          w.value ? (u(), d("p", OQ, f(w.value), 1)) : T("", !0)
        ], 40, mQ)
      ]),
      _: 1
    }, 8, ["open", "title", "busy"]));
  }
}), NQ = {
  key: 0,
  class: "fe-e2e-form",
  "data-testid": "e2e-too-big"
}, BQ = { class: "fe-e2e-rk__lead" }, FQ = { class: "fe-e2e-big__steps" }, UQ = { class: "fe-e2e-big__cmd" }, HQ = { "data-testid": "e2e-too-big-command" }, KQ = { class: "fe-e2e-names__hint" }, VQ = /* @__PURE__ */ rt({
  __name: "E2eTooBigModal",
  props: {
    open: { type: Boolean },
    locale: {},
    info: {}
  },
  emits: ["close", "download"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n, formatSize: o } = gt(() => t.locale), p = b(!1);
    Qe(
      () => t.open,
      (y) => {
        y && (p.value = !1);
      }
    );
    const h = x(() => {
      const y = t.info;
      if (!y) return "";
      const g = o(y.limit);
      return y.size !== null ? n("e2e.big.lead", { name: y.name, size: o(y.size), limit: g }) : n("e2e.big.lead_grew", { name: y.name, limit: g });
    });
    async function v() {
      var g;
      const y = (g = t.info) == null ? void 0 : g.command;
      if (y)
        try {
          await navigator.clipboard.writeText(y), p.value = !0;
        } catch {
        }
    }
    return (y, g) => (u(), nt(la, {
      open: e.open,
      title: r(n)("e2e.big.title"),
      size: "sm",
      onClose: g[2] || (g[2] = (m) => s("close"))
    }, {
      actions: yt(() => {
        var m;
        return [
          i("button", {
            type: "button",
            class: "fe-btn",
            onClick: g[0] || (g[0] = (k) => s("close"))
          }, f(r(n)("e2e.big.close")), 1),
          i("button", {
            type: "button",
            class: "fe-btn fe-btn--primary",
            "data-testid": "e2e-too-big-download",
            onClick: g[1] || (g[1] = (k) => s("download"))
          }, f(((m = e.info) == null ? void 0 : m.encrypted.kind) === "folder" ? r(n)("e2e.big.download_folder") : r(n)("e2e.big.download_file")), 1)
        ];
      }),
      default: yt(() => [
        e.info ? (u(), d("div", NQ, [
          i("p", BQ, f(h.value), 1),
          i("p", null, f(r(n)("e2e.big.instead")), 1),
          i("ol", FQ, [
            i("li", null, f(e.info.encrypted.kind === "file" ? r(n)("e2e.big.step_file") : r(n)("e2e.big.step_folder")), 1),
            i("li", null, [
              $t(f(r(n)("e2e.big.step_run")) + " ", 1),
              i("span", UQ, [
                i("code", HQ, f(e.info.command), 1),
                i("button", {
                  type: "button",
                  class: "fe-e2e-optlink",
                  "data-testid": "e2e-too-big-copy",
                  onClick: v
                }, f(p.value ? r(n)("e2e.big.copied") : r(n)("e2e.big.copy")), 1)
              ])
            ])
          ]),
          i("p", KQ, f(r(n)("e2e.big.other_ways")), 1)
        ])) : T("", !0)
      ]),
      _: 1
    }, 8, ["open", "title"]));
  }
}), qQ = "filexfxe", X0 = 1, Td = ".fxe", J0 = 64 * 1024, jQ = [], Wc = new TextEncoder().encode(qQ), du = 13, WQ = 32;
function Z0(e) {
  return typeof e == "string" && e.length > Td.length && e.toLowerCase().endsWith(Td);
}
function YQ() {
  const e = crypto.getRandomValues(new Uint8Array(4));
  return `encrypted-${Array.from(e, (a) => a.toString(16).padStart(2, "0")).join("")}${Td}`;
}
function GQ(e) {
  return /^encrypted-[0-9a-f]{8}\.fxe$/i.test(e);
}
function I_(e, a) {
  return a ? YQ() : `${e}${Td}`;
}
function gm(e) {
  const a = { v: 2, salt: e.salt, iter: e.iter, verify: e.verify, fmk: "wrapped", fmk_pw: e.fmk_pw };
  return e.rk && (a.rk = e.rk), e.esc && (a.esc = e.esc), a;
}
function R_(e) {
  return !!e.rk && typeof e.rk.salt == "string" && typeof e.rk.blob == "string";
}
function Q0(e) {
  const a = new TextEncoder().encode(JSON.stringify(e));
  if (a.length === 0 || a.length > J0) throw new Error("e2e: the .fxe header is too large");
  const t = new Uint8Array(du + a.length);
  return t.set(Wc, 0), t[8] = X0, new DataView(t.buffer).setUint32(9, a.length, !1), t.set(a, du), t;
}
function XQ(e) {
  if (e.length < Wc.length) return !1;
  for (let a = 0; a < Wc.length; a++) if (e[a] !== Wc[a]) return !1;
  return !0;
}
class Qo extends Error {
  constructor(a) {
    super(a), this.name = "FxeFormatError";
  }
}
function JQ(e) {
  if (e.length < du || !XQ(e)) throw new Qo("e2e: not a filex encrypted file (.fxe)");
  if (e[8] !== X0) throw new Qo(`e2e: unsupported .fxe version ${e[8]} — a newer filex wrote it`);
  const a = new DataView(e.buffer, e.byteOffset, e.byteLength).getUint32(9, !1);
  if (a === 0 || a > J0) throw new Qo("e2e: the .fxe header length is out of range");
  return a;
}
function N_(e, a) {
  if (typeof e != "string" || e.length === 0) return !1;
  try {
    const t = rn(e);
    return a === void 0 || t.length === a;
  } catch {
    return !1;
  }
}
function ZQ(e, a) {
  var o, p, h, v, y;
  let t;
  try {
    t = JSON.parse(new TextDecoder("utf-8", { fatal: !0 }).decode(e));
  } catch {
    throw new Qo("e2e: the .fxe header is not readable");
  }
  const s = (g) => new Qo(`e2e: the .fxe header is damaged (${g})`);
  if (!t || typeof t != "object" || Array.isArray(t)) throw s("not an object");
  if (!N_(t.salt)) throw s("salt");
  if (typeof t.iter != "number" || !Number.isInteger(t.iter) || t.iter < 1 || t.iter > Rw) throw s("iter");
  if (typeof t.verify != "string") throw s("verify");
  if (t.fmk !== "wrapped" || typeof t.fmk_pw != "string") throw s("fmk");
  if (t.rk !== void 0 && (typeof t.rk != "object" || typeof ((o = t.rk) == null ? void 0 : o.salt) != "string" || typeof ((p = t.rk) == null ? void 0 : p.blob) != "string"))
    throw s("rk");
  if (t.esc !== void 0 && (typeof t.esc != "object" || typeof ((h = t.esc) == null ? void 0 : h.kid) != "string" || typeof ((v = t.esc) == null ? void 0 : v.alg) != "string" || typeof ((y = t.esc) == null ? void 0 : y.blob) != "string"))
    throw s("esc");
  if (typeof t.dek != "string" || typeof t.name != "string") throw s("dek/name");
  if (!bu(t.chunk)) throw s("chunk");
  if (!N_(t.nonce, si)) throw s("nonce");
  if (typeof t.size != "number" || !Number.isSafeInteger(t.size) || t.size < 0) throw s("size");
  const n = [];
  if (t.req !== void 0) {
    if (!Array.isArray(t.req) || t.req.some((g) => typeof g != "string")) throw s("req");
    for (const g of t.req) jQ.includes(g) || n.push(g);
  }
  return { header: t, unsupported: n, prefixLength: a };
}
async function QQ(e) {
  const a = new Fd(e);
  try {
    const t = await a.read(du), s = JQ(t), n = await a.read(s);
    if (n.length < s) throw new Qo("e2e: the .fxe file is truncated");
    return { parsed: ZQ(n, du + s), body: a.rest() };
  } catch (t) {
    throw await a.cancel().catch(() => {
    }), t;
  }
}
async function eee(e, a) {
  const t = await hb(a, e.dek);
  if (!t || t.length !== WQ) return null;
  let s;
  try {
    s = await Ud(new Uint8Array(t));
  } finally {
    t.fill(0);
  }
  const n = await hb(a, e.name);
  if (!n) return null;
  let o;
  try {
    o = new TextDecoder("utf-8", { fatal: !0 }).decode(n);
  } catch {
    return null;
  }
  return vs(o) ? null : { header: e, fmk: a, dek: s, name: o.normalize("NFC") };
}
async function tee(e, a) {
  const t = gm(e);
  let s;
  if ("password" in a) {
    const o = await Ww(t, a.password);
    if ("error" in o) return { error: o.error };
    s = o.fmk;
  } else if ("recoveryKey" in a) {
    if (s = await Yw(t, a.recoveryKey), !s) return { error: "wrong" };
  } else if (s = await Gw(t, a.escrowKey), !s) return { error: "wrong" };
  const n = await eee(e, s);
  return n ? { key: n } : { error: "damaged" };
}
function aee(e, a) {
  return { ...e, header: a };
}
async function nee(e, a, t, s, n = {}) {
  const o = (e ?? "").normalize("NFC"), p = vs(o);
  if (p) throw new Error(`e2e: invalid name (${p})`);
  if ((s ?? "").length < oi)
    throw new Error(`e2e: the password must be at least ${oi} characters`);
  if (!Number.isSafeInteger(a) || a < 0) throw new Error("e2e: bad file size");
  const h = n.chunkLog2 ?? Vs;
  if (!bu(h)) throw new Error("e2e: bad chunk size");
  const v = await Av(s, {
    escrowPublicKey: n.escrowPublicKey ?? null,
    iterations: n.iterations
  }), y = Ow();
  let g, m;
  try {
    g = await vb(v.fmk, y), m = await Ud(y);
  } finally {
    y.fill(0);
  }
  const k = Mw(), _ = v.marker, w = {
    salt: _.salt,
    iter: _.iter,
    verify: _.verify,
    fmk: "wrapped",
    fmk_pw: _.fmk_pw,
    ..._.rk ? { rk: _.rk } : {},
    ..._.esc ? { esc: _.esc } : {},
    dek: g,
    name: await vb(v.fmk, new TextEncoder().encode(o)),
    chunk: h,
    nonce: qs(k),
    size: a
  }, $ = Q0(w), C = t.pipeThrough(
    Dw(m, k, h, { expectSize: a, onProgress: n.onProgress })
  );
  return {
    header: w,
    stream: ku($, C),
    size: $.length + Ah(a, h),
    recoveryKey: v.recoveryKey,
    key: { header: w, fmk: v.fmk, dek: m, name: o }
  };
}
function Xp(e, a) {
  const t = e.header;
  return a.pipeThrough(Pw(e.dek, rn(t.nonce), t.chunk, { expectSize: t.size }));
}
async function see(e, a, t) {
  const s = await Qw(gm(e), a, t);
  if (s.fmk !== "wrapped" || !s.fmk_pw) throw new ea("e2e: the password slot did not re-seal");
  return { ...e, salt: s.salt, iter: s.iter, verify: s.verify, fmk: "wrapped", fmk_pw: s.fmk_pw };
}
function oee(e, a) {
  const t = Q0(e);
  return { stream: ku(t, a), size: t.length + Ah(e.size, e.chunk) };
}
const iee = {
  txt: "text/plain",
  md: "text/markdown",
  log: "text/plain",
  csv: "text/csv",
  json: "application/json",
  xml: "application/xml",
  html: "text/html",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  png: "image/png",
  gif: "image/gif",
  webp: "image/webp",
  bmp: "image/bmp",
  avif: "image/avif",
  svg: "image/svg+xml",
  pdf: "application/pdf",
  mp4: "video/mp4",
  webm: "video/webm",
  mov: "video/quicktime",
  m4v: "video/mp4",
  mp3: "audio/mpeg",
  wav: "audio/wav",
  ogg: "audio/ogg",
  flac: "audio/flac",
  m4a: "audio/mp4",
  aac: "audio/aac",
  opus: "audio/opus"
};
function Fl(e) {
  return iee[(e || "").toLowerCase()] || "application/octet-stream";
}
const jn = 1024 * 1024 * 1024;
function e2() {
  if (typeof window > "u") return null;
  const e = window;
  return typeof e.showSaveFilePicker == "function" && e.isSecureContext !== !1 ? e.showSaveFilePicker.bind(window) : null;
}
function ree() {
  return e2() !== null;
}
class dr extends Error {
  constructor() {
    super("save cancelled"), this.name = "SaveCancelled";
  }
}
class Yc extends Error {
  constructor() {
    super("the save dialog needs a click"), this.name = "SaveNeedsGesture";
  }
}
class qn extends Error {
  constructor(a, t) {
    super(`e2e: ${a} bytes is more than this browser can save from memory (${t})`), this.size = a, this.limit = t, this.name = "SaveTooLarge";
  }
}
async function Jp(e, a) {
  const t = e2();
  if (t) {
    let s;
    try {
      s = await t({ suggestedName: e });
    } catch (n) {
      const o = n == null ? void 0 : n.name;
      throw o === "AbortError" ? new dr() : o === "SecurityError" || o === "NotAllowedError" ? new Yc() : n;
    }
    return lee(e, s);
  }
  if (a !== void 0 && a > jn) throw new qn(a, jn);
  return uee(e);
}
function lee(e, a) {
  let t = null;
  return {
    kind: "fsa",
    name: e,
    async write(s) {
      var p;
      t = await a.createWritable();
      const n = t, o = s.getReader();
      try {
        for (; ; ) {
          const { done: h, value: v } = await o.read();
          if (h) break;
          await n.write(v);
        }
        await n.close();
      } catch (h) {
        throw await n.abort(h).catch(() => {
        }), await o.cancel(h).catch(() => {
        }), await ((p = a.remove) == null ? void 0 : p.call(a).catch(() => {
        })), h;
      }
    },
    async discard() {
      var s;
      t && await t.abort().catch(() => {
      }), await ((s = a.remove) == null ? void 0 : s.call(a).catch(() => {
      }));
    }
  };
}
function uee(e) {
  return {
    kind: "blob",
    name: e,
    async write(a, t) {
      const s = [];
      let n = 0;
      const o = a.getReader();
      try {
        for (; ; ) {
          const { done: y, value: g } = await o.read();
          if (y) break;
          if (n += g.length, n > jn) throw new qn(n, jn);
          s.push(new Blob([g]));
        }
      } catch (y) {
        throw await o.cancel(y).catch(() => {
        }), y;
      }
      const p = new Blob(s, { type: (t == null ? void 0 : t.mime) || "application/octet-stream" }), h = URL.createObjectURL(p), v = document.createElement("a");
      v.href = h, v.download = e, v.rel = "noopener", document.body.appendChild(v), v.click(), v.remove(), setTimeout(() => URL.revokeObjectURL(h), 6e4);
    },
    async discard() {
    }
  };
}
const an = 4294967295, Gc = 65535, cee = new TextEncoder();
let Zp = null;
function dee() {
  if (Zp) return Zp;
  const e = new Uint32Array(256);
  for (let a = 0; a < 256; a++) {
    let t = a;
    for (let s = 0; s < 8; s++) t = t & 1 ? 3988292384 ^ t >>> 1 : t >>> 1;
    e[a] = t >>> 0;
  }
  return Zp = e, e;
}
function fee(e, a = 0) {
  const t = dee();
  let s = (a ^ an) >>> 0;
  for (let n = 0; n < e.length; n++) s = t[(s ^ e[n]) & 255] ^ s >>> 8;
  return (s ^ an) >>> 0;
}
class ei {
  constructor(a) {
    Aa(this, "buf");
    Aa(this, "dv");
    Aa(this, "o", 0);
    this.buf = new Uint8Array(a), this.dv = new DataView(this.buf.buffer);
  }
  u16(a) {
    return this.dv.setUint16(this.o, a, !0), this.o += 2, this;
  }
  u32(a) {
    return this.dv.setUint32(this.o, a >>> 0, !0), this.o += 4, this;
  }
  u64(a) {
    return this.dv.setUint32(this.o, a % 2 ** 32, !0), this.dv.setUint32(this.o + 4, Math.floor(a / 2 ** 32), !0), this.o += 8, this;
  }
  bytes(a) {
    return this.buf.set(a, this.o), this.o += a.length, this;
  }
  done() {
    if (this.o !== this.buf.length) throw new Error(`zip: record size ${this.o} != ${this.buf.length}`);
    return this.buf;
  }
}
function pee(e) {
  const a = e.getFullYear();
  return a < 1980 ? { time: 0, date: 33 } : {
    time: e.getHours() << 11 | e.getMinutes() << 5 | Math.floor(e.getSeconds() / 2),
    date: Math.min(a, 2107) - 1980 << 9 | e.getMonth() + 1 << 5 | e.getDate()
  };
}
const t2 = 2048, a2 = 8, n2 = 813, vee = 33188, hee = 16877;
function mee(e) {
  const a = e.zip64Local ? 20 : 0, t = new ei(30 + e.name.length + a).u32(67324752).u16(e.zip64Local ? 45 : 20).u16(t2 | (e.dir ? 0 : a2)).u16(0).u16(e.time).u16(e.date).u32(0).u32(e.zip64Local ? an : 0).u32(e.zip64Local ? an : 0).u16(e.name.length).u16(a).bytes(e.name);
  return e.zip64Local && t.u16(1).u16(16).u64(0).u64(0), t.done();
}
function yee(e) {
  return e.zip64Local ? new ei(24).u32(134695760).u32(e.crc).u64(e.size).u64(e.size).done() : new ei(16).u32(134695760).u32(e.crc).u32(e.size).u32(e.size).done();
}
function gee(e, a) {
  const t = a || e.size >= an, s = a || e.offset >= an, n = t || s ? 4 + (t ? 16 : 0) + (s ? 8 : 0) : 0, o = new ei(46 + e.name.length + n).u32(33639248).u16(n2).u16(t || s || e.zip64Local ? 45 : 20).u16(t2 | (e.dir ? 0 : a2)).u16(0).u16(e.time).u16(e.date).u32(e.crc).u32(t ? an : e.size).u32(t ? an : e.size).u16(e.name.length).u16(n).u16(0).u16(0).u16(0).u32((e.dir ? hee : vee) * 65536 + (e.dir ? 16 : 0) >>> 0).u32(s ? an : e.offset).bytes(e.name);
  return n && (o.u16(1).u16(n - 4), t && o.u64(e.size).u64(e.size), s && o.u64(e.offset)), o.done();
}
function bee(e, a, t, s) {
  const n = [], o = s || e >= Gc || a >= an || t >= an;
  if (o) {
    const p = a + t;
    n.push(
      new ei(56).u32(101075792).u64(44).u16(n2).u16(45).u32(0).u32(0).u64(e).u64(e).u64(t).u64(a).done()
    ), n.push(new ei(20).u32(117853008).u32(0).u64(p).u32(1).done());
  }
  return n.push(
    new ei(22).u32(101010256).u16(0).u16(0).u16(o ? Gc : e).u16(o ? Gc : e).u32(o ? an : t).u32(o ? an : a).u16(0).done()
  ), n;
}
function _ee(e, a) {
  const t = e.replace(/\\/g, "/").split("/").filter((s) => s !== "" && s !== ".");
  if (t.length === 0 || t.some((s) => s === "..")) throw new Error(`zip: unsafe entry name ${JSON.stringify(e)}`);
  return t.join("/") + (a ? "/" : "");
}
async function* kee(e, a) {
  const t = !!a.forceZip64, s = [];
  let n = 0;
  const o = (v) => {
    var y;
    return n += v.length, (y = a.onProgress) == null || y.call(a, n), v;
  };
  for await (const v of e) {
    const y = v.name.endsWith("/") && !v.data, g = cee.encode(_ee(v.name, y));
    if (g.length > Gc) throw new Error("zip: entry name too long");
    const { time: m, date: k } = pee(v.mtime ?? /* @__PURE__ */ new Date()), _ = {
      name: g,
      dir: y,
      zip64Local: !y && (t || v.sizeHint === void 0 || v.sizeHint >= an),
      crc: 0,
      size: 0,
      offset: n,
      time: m,
      date: k
    };
    if (yield o(mee(_)), !y && v.data) {
      const $ = (typeof v.data == "function" ? await v.data() : v.data).getReader();
      try {
        for (; ; ) {
          const { done: C, value: E } = await $.read();
          if (C) break;
          !E || E.length === 0 || (_.crc = fee(E, _.crc), _.size += E.length, yield o(E));
        }
      } catch (C) {
        throw await $.cancel(C).catch(() => {
        }), C;
      } finally {
        $.releaseLock();
      }
      if (!_.zip64Local && _.size >= an) throw new Error(`zip: ${v.name} grew past its size hint and 4 GiB`);
      yield o(yee(_));
    }
    s.push(_);
  }
  const p = n;
  for (const v of s) yield o(gee(v, t));
  const h = n - p;
  for (const v of bee(s.length, p, h, t)) yield o(v);
}
function wee(e, a = {}) {
  const t = kee(e, a);
  return new ReadableStream({
    async pull(s) {
      const { value: n, done: o } = await t.next();
      o ? s.close() : s.enqueue(n);
    },
    async cancel() {
      await t.return(void 0);
    }
  });
}
function B_(e, a) {
  let t = null;
  const s = () => t ?? (t = new Fd(e));
  let n = 0, o = new Uint8Array(0), p = 0, h = !1;
  return {
    size: a,
    async read(v, y) {
      if (h) throw new Error("upload source cancelled");
      if (v < n || v > p || y < v || y > a)
        throw new Error(`upload source: cannot read [${v}, ${y}) after [${n}, ${p})`);
      const g = o.subarray(v - n);
      if (y > p) {
        const m = await s().read(y - p);
        if (m.length < y - p) throw new Error("upload source: the stream ended early");
        const k = new Uint8Array(g.length + m.length);
        k.set(g, 0), k.set(m, g.length), o = k, p = y;
      } else
        o = g.slice();
      return n = v, new Blob([o.subarray(0, y - v)]);
    },
    cancel() {
      h || (h = !0, (t ? t.cancel() : e.cancel()).catch(() => {
      }));
    }
  };
}
async function F_(e, a, t = "application/octet-stream") {
  const s = [], n = e.getReader();
  for (; ; ) {
    const { done: o, value: p } = await n.read();
    if (o) break;
    s.push(new Blob([p]));
  }
  return new File(s, a, { type: t });
}
const xee = [
  "fxe-encrypt",
  "fxe-download-raw",
  "fxe-remove",
  "fxe-password",
  "e2e-download-encrypted"
];
function $ee(e) {
  return xee.includes(e);
}
function Yo(e) {
  return !!e && e.type === "file" && Z0(typeof e.e2e_stored == "string" ? e.e2e_stored : e.basename);
}
function See(e, a) {
  const t = e.lastIndexOf(".");
  return t <= 0 ? `${e} (${a})` : `${e.slice(0, t)} (${a})${e.slice(t)}`;
}
function Tee(e) {
  const { api: a, t } = e, s = /* @__PURE__ */ new Map(), n = b(0), o = /* @__PURE__ */ new Map();
  function p() {
    for (const ve of o.values()) URL.revokeObjectURL(ve);
    o.clear();
  }
  Mt(() => {
    p(), s.clear();
  });
  const h = b(null), v = b(!1), y = b(null), g = b(null), m = b(null), k = b("open"), _ = b(!1), w = b(null), $ = b(null), C = b(!1), E = b(!0), A = b("off"), O = b(null), z = b(null), P = b(!1), I = b(null), F = b(null);
  async function W(ve) {
    const H = await a.authHeaders(), te = await fetch(a.previewUrl(ve), {
      headers: H,
      credentials: a.credentialsMode(),
      cache: "no-store"
    });
    if (!te.ok) {
      const Te = await te.text().catch(() => "");
      throw tn(te.status, Te, e.locale());
    }
    if (!te.body) throw new Error("e2e: this browser cannot read a download as a stream");
    return te.body;
  }
  async function N(ve) {
    const H = await a.index(ve);
    return new Set((H.files ?? []).map((te) => te.basename));
  }
  function K(ve, H) {
    if (!H.has(ve)) return ve;
    for (let te = 2; te < 1e3; te++) {
      const Te = See(ve, te);
      if (!H.has(Te)) return Te;
    }
    throw new Error("e2e: no free name");
  }
  async function M(ve, H, te, Te, L) {
    const se = new File([], H, { type: "application/octet-stream" });
    if (Te > e.chunked.threshold()) {
      const et = B_(te, Te);
      try {
        await e.chunked.uploadFile({
          path: ve,
          file: se,
          source: et,
          onProgress: (ht) => L == null ? void 0 : L(ht.uploadedBytes)
        });
        return;
      } catch (ht) {
        if (!gh(ht)) throw ht;
        if (Te > jn) throw new qn(Te, jn);
      }
    }
    const ne = await F_(te, H);
    if (ne.size !== Te) throw new Error("e2e: the upload came out a different size than it should");
    await a.uploadMultipart(ve, [ne], (et) => L == null ? void 0 : L(Math.round(et / 100 * Te)));
  }
  async function j(ve) {
    const H = zn(ve);
    if (a.endpoints.deleteAsync) {
      const { op: te } = await a.deleteAsync([ve], H);
      e.registerOp(te);
      return;
    }
    await a.deleteItems(H, [ve]);
  }
  function U(ve) {
    return ve instanceof Error && ve.message ? ve.message : String(ve);
  }
  function de(ve) {
    return ve instanceof Qo ? t("e2e.fxe.not_readable") : ve instanceof ea ? t("e2e.fxe.damaged") : U(ve);
  }
  async function ke(ve) {
    const { parsed: H, body: te } = await QQ(await W(ve));
    return { header: H.header, unsupported: H.unsupported, body: te };
  }
  function ie(ve, H) {
    return ve.header.dek === H.dek && ve.header.nonce === H.nonce && ve.header.size === H.size;
  }
  function ce(ve) {
    var H;
    return n.value, (H = s.get(ve)) == null ? void 0 : H.name;
  }
  function X(ve, H) {
    const te = ve.length === 1 ? ve[0] : null, Te = !!te && Yo(te), L = !!te && te.type === "file" && !Te && !H.inEncrypted && !te.e2e_root;
    return [
      {
        key: "fxe-encrypt",
        label: t("e2e.fxe.ctx_encrypt"),
        icon: "lock",
        hidden: !L || !H.canWrite
      },
      { key: "fxe-download-raw", label: t("e2e.fxe.ctx_download_raw"), icon: "download", hidden: !Te },
      {
        key: "e2e-download-encrypted",
        label: t("e2e.dl.ctx_encrypted_copy"),
        icon: "download",
        hidden: Te || ve.length === 0 || !H.unlockedEncryptedCopy
      },
      { key: "fxe-password", label: t("e2e.fxe.ctx_password"), icon: "lock", hidden: !Te || !H.canWrite },
      { key: "fxe-remove", label: t("e2e.fxe.ctx_remove"), icon: "restore", hidden: !Te || !H.canWrite }
    ];
  }
  function Z(ve) {
    h.value = ve, y.value = null, g.value = null;
  }
  function Y() {
    v.value || (h.value = null);
  }
  async function G(ve, H) {
    for (const te of await a.listVersions(H)) await a.purgeVersion(te.id);
    await a.deleteItems(zn(ve.path), [ve.path]);
    try {
      await a.purgeTrash(H);
    } catch (te) {
      if (te.status !== 404) throw te;
    }
  }
  async function we(ve) {
    const H = h.value;
    if (!(!H || v.value)) {
      v.value = !0, y.value = null, g.value = 0;
      try {
        const te = zn(H.path), Te = typeof H.size == "number" ? H.size : NaN;
        if (!Number.isSafeInteger(Te) || Te < 0) throw new Error(t("e2e.fxe.size_unknown"));
        const L = ve.purge === !0;
        if (L && typeof H.id != "number") throw new Error(t("e2e.fxe.purge_no_id"));
        if (vs(H.basename)) throw new Error(t("e2e.fxe.bad_name"));
        const se = await N(te);
        let ne = I_(H.basename, ve.hideName);
        if (ve.hideName)
          for (let Tt = 0; se.has(ne) && Tt < 20; Tt++) ne = I_(H.basename, !0);
        else
          ne = `${K(H.basename, new Set([...se].filter(Z0).map((Tt) => Tt.slice(0, -4))))}.fxe`;
        if (vs(ne)) throw new Error(t("e2e.fxe.name_too_long"));
        const et = await nee(H.basename, Te, await W(H.path), ve.password, {
          escrowPublicKey: e.escrowPublicKey()
        });
        await M(te, ne, et.stream, et.size, (Tt) => {
          g.value = et.size > 0 ? Math.min(100, Math.round(Tt / et.size * 100)) : 100;
        });
        const ht = vr(te, ne);
        if (s.set(ht, et.key), n.value++, L) {
          try {
            await G(H, H.id);
          } catch (Tt) {
            h.value = null, e.emitError(U(Tt), "fxe-purge-original"), e.toast(t("e2e.fxe.purge_failed", { name: H.basename, reason: U(Tt) }), !0), e.showRecoveryKey(et.recoveryKey, H.basename), await e.reload();
            return;
          }
          h.value = null, e.showRecoveryKey(et.recoveryKey, H.basename), e.toast(t("e2e.fxe.purged", { name: H.basename })), await e.reload();
          return;
        }
        try {
          await j(H.path);
        } catch (Tt) {
          h.value = null, e.emitError(U(Tt), "fxe-trash-original"), e.toast(t("e2e.fxe.original_kept", { name: H.basename }), !0), e.showRecoveryKey(et.recoveryKey, H.basename), await e.reload();
          return;
        }
        h.value = null, e.showRecoveryKey(et.recoveryKey, H.basename), e.toast(t("e2e.fxe.encrypted", { name: H.basename })), await e.reload();
      } catch (te) {
        y.value = te instanceof qn ? t("e2e.fxe.upload_too_big") : U(te), e.emitError(U(te), "fxe-encrypt");
      } finally {
        v.value = !1, g.value = null;
      }
    }
  }
  function R(ve, H) {
    m.value = ve, k.value = H, w.value = null, C.value = !1, $.value = null, E.value = !0, A.value = "off", O.value = null, s.has(ve.path) || pe(ve);
  }
  async function pe(ve) {
    var H, te, Te;
    try {
      const { header: L, body: se } = await ke(ve.path);
      if (await se.cancel().catch(() => {
      }), ((H = m.value) == null ? void 0 : H.path) !== ve.path) return;
      E.value = R_(L), A.value = Vw(gm(L), ((te = e.escrowKid) == null ? void 0 : te.call(e)) ?? null), O.value = ((Te = L.esc) == null ? void 0 : Te.kid) ?? null;
    } catch {
    }
  }
  async function Q(ve, H) {
    const te = await a.e2eEscrowChallenge(ve), Te = new Uint8Array(
      await crypto.subtle.decrypt({ name: "RSA-OAEP" }, H, rn(te.challenge).buffer)
    );
    await a.e2eEscrowUsed({ path: ve, id: te.id, nonce: qs(Te) });
  }
  function q() {
    _.value || (m.value = null, C.value = !1);
  }
  async function re(ve) {
    const H = s.get(ve.path);
    if (!H) {
      R(ve, "open");
      return;
    }
    try {
      await me(ve, H);
    } catch (te) {
      J(ve, te, "fxe-open");
    }
  }
  async function ae(ve) {
    if (await He(ve)) return;
    const H = s.get(ve.path);
    if (!H) {
      R(ve, "download");
      return;
    }
    try {
      await fe(ve, H);
    } catch (te) {
      if (te instanceof Yc) {
        R(ve, "download"), C.value = !0;
        return;
      }
      J(ve, te, "fxe-download");
    }
  }
  function Pe(ve) {
    R(ve, "remove");
  }
  function be(ve) {
    return `"${ve.replace(/(["\\$`])/g, "\\$1")}"`;
  }
  function ze(ve, H, te) {
    var L;
    const Te = wr(ve.path);
    F.value = {
      name: ((L = s.get(ve.path)) == null ? void 0 : L.name) ?? ve.basename,
      size: H,
      limit: te,
      encrypted: { kind: "file", path: ve.path },
      command: `filex decrypt ${be(Te)}`
    };
  }
  function Ae(ve, H, te, Te) {
    const L = wr(H) || "filex";
    F.value = {
      name: ve,
      size: te,
      limit: Te,
      encrypted: { kind: "folder", path: H },
      command: `filex decrypt ${be(`${L}.zip`)}`
    };
  }
  function Ce() {
    F.value = null;
  }
  async function He(ve) {
    var Te;
    if (ree()) return !1;
    const H = (Te = s.get(ve.path)) == null ? void 0 : Te.header.size;
    let te = typeof H == "number" ? H : null;
    if (te === null) {
      if (typeof ve.size != "number" || ve.size <= jn) return !1;
      try {
        const { header: L, body: se } = await ke(ve.path);
        await se.cancel().catch(() => {
        }), te = L.size;
      } catch {
        return !1;
      }
    }
    return te <= jn ? !1 : (ze(ve, te, jn), !0);
  }
  function J(ve, H, te) {
    if (!(H instanceof dr)) {
      if (H instanceof qn) {
        ze(ve, H.size, H.limit);
        return;
      }
      H instanceof ea && (s.delete(ve.path), n.value++), e.emitError(U(H), te), e.toast(de(H), !0);
    }
  }
  async function me(ve, H) {
    const { header: te, body: Te } = await ke(ve.path);
    if (!ie(H, te))
      throw await Te.cancel().catch(() => {
      }), new ea("e2e: the file changed since it was opened");
    if (te.size > jn)
      throw await Te.cancel().catch(() => {
      }), new qn(te.size, jn);
    const L = wv(H.name), se = await F_(Xp(H, Te), H.name, Fl(L)), ne = o.get(ve.path);
    ne && URL.revokeObjectURL(ne);
    const et = URL.createObjectURL(se);
    o.set(ve.path, et), e.openPreview(
      { ...ve, basename: H.name, extension: L, mime_type: Fl(L), size: te.size, fxe_name: H.name },
      et
    );
  }
  async function fe(ve, H, te) {
    const Te = await Jp(H.name, H.header.size);
    let L = !1;
    try {
      const { header: se, body: ne } = await ke(ve.path);
      if (!ie(H, se))
        throw await ne.cancel().catch(() => {
        }), new ea("e2e: the file changed since it was opened");
      L = !0, await Te.write(Xp(H, ne), { mime: Fl(wv(H.name)) }), e.toast(t("e2e.fxe.downloaded", { name: H.name }));
    } catch (se) {
      throw L || await Te.discard(), se;
    }
  }
  async function xe(ve, H) {
    const te = zn(ve.path), { header: Te, body: L } = await ke(ve.path);
    if (!ie(H, Te))
      throw await L.cancel().catch(() => {
      }), new ea("e2e: the file changed since it was opened");
    const se = K(H.name, await N(te));
    $.value = 0, await M(te, se, Xp(H, L), Te.size, (ne) => {
      $.value = Te.size > 0 ? Math.min(100, Math.round(ne / Te.size * 100)) : 100;
    }), await j(ve.path), s.delete(ve.path), n.value++, e.toast(t("e2e.fxe.removed", { name: se })), await e.reload();
  }
  async function ye(ve = {}) {
    const H = m.value;
    if (!(!H || _.value)) {
      _.value = !0, w.value = null;
      try {
        let te = s.get(H.path);
        if (!te || ve.password || ve.recoveryKey || ve.escrowKey) {
          let Te;
          if (ve.escrowKey)
            try {
              Te = { escrowKey: await Fw(ve.escrowKey) };
            } catch {
              w.value = t("e2e.recover.bad_escrow_key");
              return;
            }
          else ve.recoveryKey ? Te = { recoveryKey: ve.recoveryKey } : Te = { password: ve.password ?? "" };
          const { header: L, unsupported: se, body: ne } = await ke(H.path);
          if (await ne.cancel().catch(() => {
          }), E.value = R_(L), se.length > 0) {
            w.value = t("e2e.fxe.unsupported", { features: se.join(", ") });
            return;
          }
          const et = await tee(L, Te);
          if ("error" in et) {
            w.value = et.error === "damaged" ? t("e2e.fxe.damaged") : "escrowKey" in Te ? t("e2e.fxe.wrong_escrow") : "recoveryKey" in Te ? t("e2e.fxe.wrong_recovery") : t("e2e.fxe.wrong_password");
            return;
          }
          if ("escrowKey" in Te) {
            try {
              await Q(H.path, Te.escrowKey);
            } catch (ht) {
              w.value = t("e2e.fxe.escrow_notify_failed"), e.emitError(U(ht), "fxe-escrow-notify");
              return;
            }
            e.toast(t("e2e.fxe.escrow_done"));
          }
          te = et.key, s.set(H.path, te), n.value++;
        }
        if (k.value === "open")
          await me(H, te), m.value = null;
        else if (k.value === "download") {
          try {
            await fe(H, te);
          } catch (Te) {
            if (Te instanceof Yc) {
              C.value = !0;
              return;
            }
            throw Te;
          }
          m.value = null, C.value = !1;
        } else
          await xe(H, te), m.value = null;
      } catch (te) {
        if (te instanceof dr) return;
        if (te instanceof qn && k.value === "download") {
          m.value = null, ze(H, te.size, te.limit);
          return;
        }
        w.value = te instanceof qn ? t("e2e.dl.too_big", { size: Le(te.size), limit: Le(te.limit) }) : de(te), te instanceof ea && (s.delete(H.path), n.value++), e.emitError(U(te), `fxe-${k.value}`);
      } finally {
        _.value = !1, $.value = null;
      }
    }
  }
  function qe(ve) {
    z.value = ve, I.value = null;
  }
  function ut() {
    P.value || (z.value = null);
  }
  async function Ue(ve, H) {
    if (a.endpoints.e2ePasswordChanged)
      try {
        await a.e2ePasswordChanged({ path: ve, via: H, rekey: !1 });
      } catch (te) {
        e.emitError(U(te), "fxe-password-announce"), e.toast(t("e2e.password.announce_failed"), !0);
      }
  }
  async function Ye(ve) {
    const H = z.value;
    if (!H || P.value) return;
    if (!ve.proof) {
      I.value = t("e2e.password.current_required");
      return;
    }
    P.value = !0, I.value = null;
    const te = "recoveryKey" in ve.proof ? "recovery_key" : "password";
    try {
      const { header: Te, unsupported: L, body: se } = await ke(H.path);
      if (L.length > 0) {
        await se.cancel().catch(() => {
        }), I.value = t("e2e.fxe.unsupported", { features: L.join(", ") });
        return;
      }
      let ne;
      try {
        ne = await see(Te, ve.proof, ve.newPassword);
      } catch (Tt) {
        if (await se.cancel().catch(() => {
        }), Tt instanceof ea) {
          I.value = t(te === "recovery_key" ? "e2e.password.wrong_recovery" : "e2e.password.wrong_current");
          return;
        }
        throw Tt;
      }
      const et = oee(ne, se);
      await M(zn(H.path), wr(H.path), et.stream, et.size);
      const ht = s.get(H.path);
      ht && s.set(H.path, aee(ht, ne)), n.value++, z.value = null, e.toast(t("e2e.fxe.password_done")), await Ue(H.path, te), await e.reload();
    } catch (Te) {
      I.value = t("e2e.password.failed"), e.emitError(U(Te), "fxe-password");
    } finally {
      P.value = !1;
    }
  }
  async function st(ve, H, te, Te) {
    const L = (ne) => {
      Te ? Ae(ve.basename, Te, ne.size, ne.limit) : e.toast(t("e2e.dl.too_big", { size: Le(ne.size), limit: Le(ne.limit) }), !0);
    };
    let se;
    try {
      se = await Jp(ve.basename, ve.size);
    } catch (ne) {
      ne instanceof qn ? L(ne) : J(ve, ne, "e2e-download");
      return;
    }
    try {
      const ne = pb(H, te, await W(ve.path), { passPlain: !0 });
      await se.write(ne, { mime: Fl(ve.extension) });
    } catch (ne) {
      if (await se.discard(), ne instanceof dr) return;
      if (ne instanceof qn) {
        L(ne);
        return;
      }
      e.emitError(U(ne), "e2e-download"), e.toast(t("e2e.download.failed"), !0);
    }
  }
  async function kt(ve, H) {
    let te;
    try {
      te = await Jp(H.zipName);
    } catch (ht) {
      if (ht instanceof dr) return;
      if (ht instanceof Yc) {
        e.toast(t("e2e.dl.click_again"), !0);
        return;
      }
      throw ht;
    }
    let Te = 0;
    const L = (ht, Tt) => ({
      name: Tt,
      sizeHint: typeof ht.size == "number" ? ht.size : void 0,
      mtime: typeof ht.last_modified == "number" ? new Date(ht.last_modified) : void 0,
      data: async () => pb(H.fmk, H.previous, await W(ht.path), {
        passPlain: !0,
        onPlain: () => Te++
      })
    }), se = (ht) => (ht.e2e_name_state === "locked" || ht.e2e_name_state === "unreadable") && typeof ht.e2e_stored == "string" ? ht.e2e_stored : ht.basename;
    async function* ne(ht, Tt) {
      yield { name: `${Tt}/` };
      const Ft = await a.index(ht.path), Lt = await H.decorate(Ft.files ?? [], { root: H.root }), ua = /* @__PURE__ */ new Set();
      for (const Ct of Lt) {
        if (Ct.basename === en || typeof Ct.e2e_stored != "string" && Ct.basename === en) continue;
        const Qt = K(se(Ct), ua);
        ua.add(Qt), Ct.type === "dir" ? yield* ne(Ct, `${Tt}/${Qt}`) : yield L(Ct, `${Tt}/${Qt}`);
      }
    }
    async function* et() {
      const ht = /* @__PURE__ */ new Set();
      for (const Tt of ve) {
        const Ft = K(se(Tt), ht);
        ht.add(Ft), Tt.type === "dir" ? yield* ne(Tt, Ft) : yield L(Tt, Ft);
      }
    }
    e.toast(t("e2e.dl.zip_started", { name: H.zipName }));
    try {
      await te.write(wee(et()), { mime: "application/zip" }), e.toast(
        Te > 0 ? t("e2e.dl.zip_done_plain", { name: H.zipName, n: Te }) : t("e2e.dl.zip_done", { name: H.zipName })
      );
    } catch (ht) {
      if (await te.discard(), ht instanceof dr) return;
      if (ht instanceof qn) {
        Ae(H.zipName, H.root, null, ht.limit);
        return;
      }
      e.emitError(U(ht), "e2e-download-zip"), e.toast(ht instanceof ea ? t("e2e.dl.zip_damaged") : t("e2e.download.failed"), !0);
    }
  }
  async function At(ve, H) {
    const te = await Cz(H, ve.size, ve.stream());
    return B_(te.stream, te.size);
  }
  async function _t(ve, H, te) {
    const Te = new Fd(await W(ve.path)), L = await Te.read(zz);
    if (!Or(L))
      return await Te.cancel().catch(() => {
      }), !1;
    const se = await t1(L.buffer, H, te);
    if (!se)
      return await Te.cancel().catch(() => {
      }), !0;
    const ne = typeof ve.size == "number" ? ve.size : NaN;
    if (!Number.isSafeInteger(ne))
      throw await Te.cancel().catch(() => {
      }), new Error("e2e: unknown file size");
    const et = typeof ve.e2e_stored == "string" ? ve.e2e_stored : ve.basename;
    return await M(zn(ve.path), et, ku(new Uint8Array(se), Te.rest()), ne), !0;
  }
  const { formatSize: Le } = gt(() => e.locale() ?? "en");
  async function tt(ve, H, te) {
    const Te = H[0];
    switch (ve) {
      case "fxe-encrypt":
        return Te && Z(Te), !0;
      case "fxe-download-raw":
        return Te && window.open(a.downloadUrl(Te.path), "_blank"), !0;
      case "fxe-password":
        return Te && qe(Te), !0;
      case "fxe-remove":
        return Te && Pe(Te), !0;
      case "e2e-download-encrypted":
        return await te(H), !0;
    }
    return !1;
  }
  return {
    ringVer: n,
    realName: ce,
    isHiddenFxeName: GQ,
    menuRows: X,
    dispatch: tt,
    // encrypt
    encryptTarget: h,
    encryptBusy: v,
    encryptError: y,
    encryptProgress: g,
    startEncrypt: Z,
    closeEncrypt: Y,
    submitEncrypt: we,
    // open / download / remove
    unlockTarget: m,
    unlockIntent: k,
    unlockBusy: _,
    unlockError: w,
    unlockProgress: $,
    unlockNeedsSave: C,
    unlockHasRecovery: E,
    unlockEscrow: A,
    unlockEscrowKid: O,
    open: re,
    download: ae,
    startRemove: Pe,
    closeUnlock: q,
    submitUnlock: ye,
    // password
    pwTarget: z,
    pwBusy: P,
    pwError: I,
    // too big for this browser
    tooBig: F,
    closeTooBig: Ce,
    startPassword: qe,
    closePassword: ut,
    submitPassword: Ye,
    // encrypted folders
    downloadFolderFile: st,
    downloadDecryptedZip: kt,
    folderUploadSource: At,
    rewrapLarge: _t,
    revokeAll: p
  };
}
const Cee = /* @__PURE__ */ new Set(["none", "viewer", "editor", "owner"]);
function U_(e) {
  if (typeof e != "string" || !e) return;
  const a = Date.parse(e);
  return Number.isFinite(a) ? a : void 0;
}
function Eee(e, a) {
  var _;
  const t = String((e == null ? void 0 : e.path) ?? "").replace(/^\/+/, "");
  if (!t) return null;
  const s = a.storages ?? [], n = typeof e.storage == "string" && e.storage ? e.storage : s.length === 1 ? s[0].name : "";
  if (a.multiStorageRoot && !n) return null;
  const o = String(e.name ?? t.split("/").pop() ?? ""), p = e.type === "dir", h = e.type === "symlink", v = typeof e.size == "number" ? e.size : 0, y = typeof e.id == "number" ? e.id : void 0, g = typeof e.perm == "string" && Cee.has(e.perm) ? e.perm : void 0, m = ((_ = s.find((w) => w.name === n)) == null ? void 0 : _.readOnly) === !0, k = typeof e.read_only == "boolean" ? e.read_only : m;
  return {
    type: p ? "dir" : "file",
    id: y,
    /* tablo:t1 — ⚠⚠ THE DATE. A node row carries `backend_mtime` (what the
       storage says) and `db_mtime` (what our last scan recorded) as RFC3339
       strings; `FileNode.last_modified` is unix MILLISECONDS. Nothing mapped
       between the two, so every row from Recent, Starred and a tag view
       arrived with no date at all — measured on Recent: eleven rows, eleven em
       dashes in the Modified column, and a Modified column header you could
       click that then sorted nothing. It also made the date grouping this view
       is supposed to show impossible, because every row fell in the "No date"
       bucket. Storage first: `backend_mtime` is the file's own truth and
       `db_mtime` only says when we last looked at it. */
    last_modified: U_(e.backend_mtime) ?? U_(e.db_mtime),
    path: n ? `${n}://${t}` : t,
    basename: o,
    extension: p ? "" : o.includes(".") ? (o.split(".").pop() || "").toLowerCase() : "",
    storage: n,
    visibility: "private",
    size: v,
    file_size: v,
    mime_type: typeof e.mime == "string" ? e.mime : "",
    ...g ? { perm: g } : {},
    read_only: k,
    ...h ? { symlink: !0 } : {},
    // ⚠⚠ The SERVER's `thumb_url`, never one built here. It used to be
    // `/api/files/thumb/<id>` for every file, and the endpoint answers
    // `404 "not ready"` for everything it has not rendered — a docx, a
    // markdown note, a diagram: opening Recent with ten such files fired ten
    // requests and all ten 404'd (2026-09-21). The rows now carry the URL
    // exactly when there is an image behind it (handlers/meta.go, the folder
    // listing's rule), so a file with none is never asked about.
    thumb_url: !p && typeof e.thumb_url == "string" && e.thumb_url ? e.thumb_url : void 0,
    /* wiring:e2 names — the encrypted folder the row sits in (the server
       answers it for rows outside a folder listing). The explorer's name view
       reads it to name the row, and openNode to open it in its folder. */
    ...typeof e.e2e_root == "string" && e.e2e_root ? { e2e_root: e.e2e_root } : {},
    extra_metadata: {}
  };
}
function Qp(e, a) {
  return e.openInHost && a.type === "file" ? "host" : "page";
}
class s2 extends Error {
}
const Aee = 1500;
async function H_(e) {
  try {
    const a = await e.json();
    return a && typeof a == "object" ? a : {};
  } catch {
    return {};
  }
}
async function zee(e, a = Aee) {
  var p, h, v, y;
  const t = e.sleep ?? ((g) => new Promise((m) => setTimeout(m, g))), s = await e.start(), n = await H_(s);
  let o;
  if (s.status === 409 && n.code === "BUSY") {
    const g = n.job;
    if (!(g != null && g.running)) throw new s2(String(n.error ?? "busy"));
    (p = e.onBusy) == null || p.call(e), o = g;
  } else if (s.ok)
    o = n;
  else
    throw new Error(typeof n.error == "string" && n.error ? n.error : String(s.status));
  for ((h = e.onStart) == null || h.call(e, o); o.running; ) {
    if ((v = e.onProgress) == null || v.call(e, o), await t(a), (y = e.stopped) != null && y.call(e)) return null;
    try {
      const g = await e.status(), m = g.ok ? await H_(g) : {};
      typeof m.running == "boolean" && (o = m);
    } catch {
    }
  }
  return o;
}
function K_(e) {
  const a = String(e ?? "").indexOf("://");
  return a === -1 ? "" : e.slice(0, a);
}
function V_(e, a, t = "auto") {
  const s = K_(a), n = e.some((o) => {
    const p = K_(o);
    return p !== "" && s !== "" && p !== s;
  });
  return t === "copy" ? { kind: "copy", cross: n } : t === "move" ? { kind: "move", cross: n } : { kind: n ? "copy" : "move", cross: n };
}
function o2(e) {
  return e.split("?")[0].replace(/\/manager$/, "/archive/download");
}
const q_ = "/api/files/manager";
function i2(e, a) {
  if (/^https?:\/\//i.test(a)) return a;
  const t = e.split("?")[0];
  if (t.endsWith(q_)) return rh(t.slice(0, -q_.length), a);
  const s = /^(https?:\/\/[^/]+)/i.exec(t);
  return s ? s[1] + a : a;
}
async function Mee(e, a, t) {
  const s = o2(e.endpoints.manager);
  return e.jsonFetch(s, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(t ? { paths: a, name: t } : { paths: a })
  });
}
async function Dee(e, a) {
  const t = await e.jsonFetch(
    o2(e.endpoints.manager),
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ paths: [a], mode: "file" })
    }
  );
  if (!t || t.mode !== "file" || typeof t.url != "string") return null;
  const s = Number(t.ttl_seconds);
  return {
    url: i2(e.endpoints.manager, t.url),
    ttlMs: Number.isFinite(s) && s > 0 ? s * 1e3 : 6e4
  };
}
const Pee = 6e4;
function Oee(e, a = document) {
  const t = a.createElement("iframe");
  t.hidden = !0, t.setAttribute("aria-hidden", "true"), t.style.display = "none", t.src = e, a.body.appendChild(t), setTimeout(() => t.remove(), Pee);
}
async function Lee(e, a, t = {}) {
  const s = await Mee(e, a, t.name);
  return Oee(
    i2(e.endpoints.manager, s.url),
    t.doc ?? document
  ), s;
}
const Iee = { class: "fe-field" }, Ree = { class: "fe-field__label" }, Nee = ["onKeydown"], Bee = {
  key: 0,
  class: "fe-form__error",
  role: "alert"
}, Fee = ["innerHTML"], Uee = ["disabled"], Hee = ["disabled", "aria-busy"], Kee = /* @__PURE__ */ rt({
  __name: "NewFolderModal",
  props: {
    open: { type: Boolean },
    locale: {},
    encryptedOption: { type: Boolean },
    error: {},
    busy: { type: Boolean }
  },
  emits: ["close", "submit", "encrypted"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n } = gt(() => t.locale), o = b(""), p = b(null);
    Qe(() => t.open, (v) => {
      v && (o.value = "", p.value = null);
    }), Qe(
      () => t.error,
      (v) => {
        v && (p.value = v);
      }
    );
    function h() {
      if (t.busy) return;
      const v = o.value.trim();
      if (!v) {
        p.value = n("modal.newfolder.placeholder");
        return;
      }
      if (/[\\/]/.test(v) || v === "." || v === "..") {
        p.value = n("modal.newfolder.invalid");
        return;
      }
      if (pu(v)) {
        p.value = n("names.reserved", { name: v });
        return;
      }
      s("submit", v);
    }
    return (v, y) => (u(), nt(la, {
      open: e.open,
      title: r(n)("modal.newfolder.title"),
      size: "sm",
      busy: e.busy,
      onClose: y[3] || (y[3] = (g) => s("close"))
    }, {
      actions: yt(() => [
        i("button", {
          type: "button",
          class: "fe-btn",
          disabled: e.busy,
          onClick: y[2] || (y[2] = (g) => s("close"))
        }, f(r(n)("modal.newfolder.cancel")), 9, Uee),
        i("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: e.busy,
          "aria-busy": e.busy ? "true" : void 0,
          onClick: h
        }, f(e.busy ? r(n)("modal.newfolder.creating") : r(n)("modal.newfolder.create")), 9, Hee)
      ]),
      default: yt(() => [
        i("form", {
          onSubmit: ft(h, ["prevent"])
        }, [
          i("label", Iee, [
            i("span", Ree, f(r(n)("modal.newfolder.placeholder")), 1),
            dt(i("input", {
              "onUpdate:modelValue": y[0] || (y[0] = (g) => o.value = g),
              type: "text",
              class: "fe-input",
              autocomplete: "off",
              onKeydown: ya(ft(h, ["prevent"]), ["enter"])
            }, null, 40, Nee), [
              [St, o.value]
            ])
          ]),
          p.value ? (u(), d("p", Bee, f(p.value), 1)) : T("", !0),
          e.encryptedOption !== !1 ? (u(), d("button", {
            key: 1,
            type: "button",
            class: "fe-e2e-optlink",
            onClick: y[1] || (y[1] = (g) => s("encrypted"))
          }, [
            i("span", {
              class: "fe-e2e-optlink__icon",
              "aria-hidden": "true",
              innerHTML: r(wt)("lock")
            }, null, 8, Fee),
            $t(" " + f(r(n)("e2e.create.option")), 1)
          ])) : T("", !0)
        ], 32)
      ]),
      _: 1
    }, 8, ["open", "title", "busy"]));
  }
});
function Vee(e) {
  const a = e.trim().toLowerCase();
  return a === "7z" ? "7z" : a.toUpperCase();
}
const qee = { class: "fe-field__hint" }, jee = { class: "fe-field" }, Wee = { class: "fe-field__label" }, Yee = { class: "fe-field" }, Gee = { class: "fe-field__label" }, Xee = ["value"], Jee = {
  key: 0,
  class: "fe-field"
}, Zee = { class: "fe-field__label" }, Qee = {
  key: 1,
  class: "fe-field"
}, ete = { class: "fe-field__label" }, tte = {
  key: 2,
  class: "fe-checkbox"
}, ate = {
  key: 3,
  class: "fe-field"
}, nte = { class: "fe-field__label" }, ste = { class: "fe-checkbox" }, ote = { class: "fe-field" }, ite = { class: "fe-field__label" }, rte = ["value"], lte = { class: "fe-field__hint" }, ute = {
  key: 5,
  class: "fe-form__error"
}, cte = ["disabled"], dte = ["disabled", "aria-busy"], fte = /* @__PURE__ */ rt({
  __name: "ArchiveCreateModal",
  props: {
    open: { type: Boolean },
    locale: {},
    count: {},
    suggestedName: {},
    defaultFormat: {},
    allowedFormats: {},
    busy: { type: Boolean },
    requestError: {},
    encryption: { type: Boolean, default: !0 }
  },
  emits: ["close", "submit"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n } = gt(() => t.locale), o = b("archive.zip"), p = b("7z"), h = b(""), v = b(""), y = b(!1), g = b(5), m = b(!0), k = b(64), _ = b(""), w = ["zip", "7z", "tar", "tar.gz", "tar.bz2", "tar.xz"], $ = x(() => {
      const z = (t.allowedFormats ?? w).filter(
        (P, I, F) => w.includes(P) && F.indexOf(P) === I
      );
      return z.length ? z : w;
    }), C = x(() => t.encryption !== !1 && (p.value === "zip" || p.value === "7z"));
    function E(z) {
      const P = z.trim().toLowerCase();
      return w.find((I) => P.endsWith(`.${I}`)) ?? null;
    }
    function A(z) {
      const P = E(z);
      return P ? z.slice(0, -(P.length + 1)) : z;
    }
    Qe(() => t.open, (z) => {
      if (!z) return;
      const P = t.defaultFormat && $.value.includes(t.defaultFormat) ? t.defaultFormat : $.value.includes("7z") ? "7z" : $.value[0];
      p.value = P, o.value = `${A(t.suggestedName || "archive")}.${P}`, h.value = "", v.value = "", y.value = !1, g.value = 5, m.value = !0, k.value = 64, _.value = "";
    }), Qe(p, (z) => {
      if (!t.open) return;
      const P = A(o.value.trim()) || "archive";
      o.value = `${P}.${z}`, z !== "zip" && z !== "7z" && (h.value = "", v.value = "", y.value = !1);
    }), Qe(o, (z) => {
      const P = E(z);
      P && $.value.includes(P) && (p.value = P);
    });
    function O() {
      if (t.busy) return;
      if (!o.value.trim() || /[\\/]/.test(o.value)) {
        _.value = n("archive.invalid_name");
        return;
      }
      const z = E(o.value);
      if (!z || !$.value.includes(z)) {
        _.value = n("archive.invalid_extension");
        return;
      }
      if (C.value && h.value !== v.value) {
        _.value = n("archive.password_mismatch");
        return;
      }
      if (z === "zip" && h.value && !/^[\x20-\x7e]*$/.test(h.value)) {
        _.value = n("archive.password_charset");
        return;
      }
      s("submit", {
        name: o.value.trim(),
        format: z,
        password: C.value && h.value || void 0,
        encrypt_filenames: !!h.value && z === "7z" && y.value,
        compression: g.value,
        solid: z === "7z" ? m.value : void 0,
        dictionary_size_mb: z === "7z" ? k.value : void 0
      });
    }
    return (z, P) => (u(), nt(la, {
      open: e.open,
      title: r(n)("archive.create_title"),
      size: "sm",
      busy: e.busy,
      onClose: P[9] || (P[9] = (I) => s("close"))
    }, {
      actions: yt(() => [
        i("button", {
          type: "button",
          class: "fe-btn",
          disabled: e.busy,
          onClick: P[8] || (P[8] = (I) => s("close"))
        }, f(r(n)("archive.cancel")), 9, cte),
        i("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: e.busy,
          "aria-busy": e.busy ? "true" : void 0,
          onClick: O
        }, f(e.busy ? r(n)("archive.creating") : r(n)("archive.create")), 9, dte)
      ]),
      default: yt(() => [
        i("form", {
          class: "fe-form",
          onSubmit: ft(O, ["prevent"])
        }, [
          i("p", qee, f(r(n)("archive.create_count", { count: e.count })), 1),
          i("label", jee, [
            i("span", Wee, f(r(n)("archive.filename")), 1),
            dt(i("input", {
              "onUpdate:modelValue": P[0] || (P[0] = (I) => o.value = I),
              class: "fe-input",
              autocomplete: "off"
            }, null, 512), [
              [St, o.value]
            ])
          ]),
          i("label", Yee, [
            i("span", Gee, f(r(n)("archive.format")), 1),
            dt(i("select", {
              "onUpdate:modelValue": P[1] || (P[1] = (I) => p.value = I),
              class: "fe-input"
            }, [
              (u(!0), d(he, null, We($.value, (I) => (u(), d("option", {
                key: I,
                value: I
              }, f(r(Vee)(I)), 9, Xee))), 128))
            ], 512), [
              [Xa, p.value]
            ])
          ]),
          C.value ? (u(), d("label", Jee, [
            i("span", Zee, f(r(n)("archive.password_optional")), 1),
            dt(i("input", {
              "onUpdate:modelValue": P[2] || (P[2] = (I) => h.value = I),
              class: "fe-input",
              type: "password",
              autocomplete: "off",
              "data-1p-ignore": "",
              "data-bwignore": "true",
              "data-lpignore": "true"
            }, null, 512), [
              [St, h.value]
            ])
          ])) : T("", !0),
          C.value ? (u(), d("label", Qee, [
            i("span", ete, f(r(n)("archive.password_confirm")), 1),
            dt(i("input", {
              "onUpdate:modelValue": P[3] || (P[3] = (I) => v.value = I),
              class: "fe-input",
              type: "password",
              autocomplete: "off",
              "data-1p-ignore": "",
              "data-bwignore": "true",
              "data-lpignore": "true"
            }, null, 512), [
              [St, v.value]
            ])
          ])) : T("", !0),
          p.value === "7z" && h.value ? (u(), d("label", tte, [
            dt(i("input", {
              "onUpdate:modelValue": P[4] || (P[4] = (I) => y.value = I),
              type: "checkbox"
            }, null, 512), [
              [Ja, y.value]
            ]),
            i("span", null, f(r(n)("archive.encrypt_names")), 1)
          ])) : T("", !0),
          p.value !== "tar" ? (u(), d("label", ate, [
            i("span", nte, f(r(n)("archive.compression")) + ": " + f(g.value), 1),
            dt(i("input", {
              "onUpdate:modelValue": P[5] || (P[5] = (I) => g.value = I),
              type: "range",
              min: "0",
              max: "9"
            }, null, 512), [
              [
                St,
                g.value,
                void 0,
                { number: !0 }
              ]
            ])
          ])) : T("", !0),
          p.value === "7z" ? (u(), d(he, { key: 4 }, [
            i("label", ste, [
              dt(i("input", {
                "onUpdate:modelValue": P[6] || (P[6] = (I) => m.value = I),
                type: "checkbox"
              }, null, 512), [
                [Ja, m.value]
              ]),
              i("span", null, f(r(n)("archive.solid")), 1)
            ]),
            i("label", ote, [
              i("span", ite, f(r(n)("archive.dictionary_size")), 1),
              dt(i("select", {
                "onUpdate:modelValue": P[7] || (P[7] = (I) => k.value = I),
                class: "fe-input"
              }, [
                (u(), d(he, null, We([4, 8, 16, 32, 64, 128, 256], (I) => i("option", {
                  key: I,
                  value: I
                }, f(r(n)("archive.dictionary_size_value", { n: I })), 9, rte)), 64))
              ], 512), [
                [
                  Xa,
                  k.value,
                  void 0,
                  { number: !0 }
                ]
              ]),
              i("span", lte, f(r(n)("archive.dictionary_hint")), 1)
            ])
          ], 64)) : T("", !0),
          _.value || e.requestError ? (u(), d("p", ute, f(_.value || e.requestError), 1)) : T("", !0)
        ], 32)
      ]),
      _: 1
    }, 8, ["open", "title", "busy"]));
  }
}), pte = { class: "fe-field__hint" }, vte = { class: "fe-field" }, hte = { class: "fe-field__label" }, mte = ["disabled"], yte = {
  key: 0,
  class: "fe-form__error"
}, gte = ["disabled"], bte = ["disabled", "aria-busy"], _te = /* @__PURE__ */ rt({
  __name: "ArchiveExtractModal",
  props: {
    open: { type: Boolean },
    locale: {},
    archiveName: {},
    suggestedFolder: {},
    busy: { type: Boolean },
    error: {}
  },
  emits: ["close", "submit"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n } = gt(() => t.locale), o = b(""), p = b("");
    Qe(() => t.open, (v) => {
      v && (o.value = t.suggestedFolder, p.value = "");
    });
    function h() {
      if (!t.busy) {
        if (!o.value.trim() || /[\\/]/.test(o.value)) {
          p.value = n("archive.invalid_folder");
          return;
        }
        s("submit", { folder: o.value.trim() });
      }
    }
    return (v, y) => (u(), nt(la, {
      open: e.open,
      title: r(n)("archive.extract_title"),
      size: "sm",
      busy: e.busy,
      onClose: y[2] || (y[2] = (g) => s("close"))
    }, {
      actions: yt(() => [
        i("button", {
          type: "button",
          class: "fe-btn",
          disabled: e.busy,
          onClick: y[1] || (y[1] = (g) => s("close"))
        }, f(r(n)("archive.cancel")), 9, gte),
        i("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: e.busy,
          "aria-busy": e.busy ? "true" : void 0,
          onClick: h
        }, f(e.busy ? r(n)("archive.extracting") : r(n)("archive.extract_to_folder")), 9, bte)
      ]),
      default: yt(() => [
        i("form", {
          class: "fe-form",
          onSubmit: ft(h, ["prevent"])
        }, [
          i("p", pte, f(e.archiveName), 1),
          i("label", vte, [
            i("span", hte, f(r(n)("archive.destination_folder")), 1),
            dt(i("input", {
              "onUpdate:modelValue": y[0] || (y[0] = (g) => o.value = g),
              class: "fe-input",
              autocomplete: "off",
              disabled: e.busy
            }, null, 8, mte), [
              [St, o.value]
            ])
          ]),
          p.value || e.error ? (u(), d("p", yte, f(p.value || e.error), 1)) : T("", !0)
        ], 32)
      ]),
      _: 1
    }, 8, ["open", "title", "busy"]));
  }
}), kte = { class: "fe-field__hint" }, wte = { class: "fe-field" }, xte = { class: "fe-field__label" }, $te = ["disabled"], Ste = {
  key: 0,
  class: "fe-form__error",
  role: "alert"
}, Tte = ["disabled"], Cte = ["disabled", "aria-busy"], Ete = /* @__PURE__ */ rt({
  __name: "ArchivePasswordModal",
  props: {
    open: { type: Boolean },
    locale: {},
    archiveName: {},
    busy: { type: Boolean },
    error: {}
  },
  emits: ["close", "submit"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n } = gt(() => t.locale), o = b("");
    Qe(() => t.open, (h) => {
      h && (o.value = "");
    });
    function p() {
      !o.value || t.busy || s("submit", o.value);
    }
    return (h, v) => (u(), nt(la, {
      open: e.open,
      title: r(n)("archive.password_title"),
      size: "sm",
      busy: e.busy,
      onClose: v[2] || (v[2] = (y) => s("close"))
    }, {
      actions: yt(() => [
        i("button", {
          type: "button",
          class: "fe-btn",
          disabled: e.busy,
          onClick: v[1] || (v[1] = (y) => s("close"))
        }, f(r(n)("archive.cancel")), 9, Tte),
        i("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: e.busy || !o.value,
          "aria-busy": e.busy ? "true" : void 0,
          onClick: p
        }, f(e.busy ? r(n)("archive.opening") : r(n)("archive.continue")), 9, Cte)
      ]),
      default: yt(() => [
        i("form", {
          class: "fe-form",
          onSubmit: ft(p, ["prevent"])
        }, [
          i("p", kte, f(e.archiveName), 1),
          i("label", wte, [
            i("span", xte, f(r(n)("archive.password_required")), 1),
            dt(i("input", {
              "onUpdate:modelValue": v[0] || (v[0] = (y) => o.value = y),
              class: "fe-input",
              type: "password",
              autocomplete: "off",
              "data-1p-ignore": "",
              "data-bwignore": "true",
              "data-lpignore": "true",
              autofocus: "",
              disabled: e.busy
            }, null, 8, $te), [
              [St, o.value]
            ])
          ]),
          e.error ? (u(), d("p", Ste, f(e.error), 1)) : T("", !0)
        ], 32)
      ]),
      _: 1
    }, 8, ["open", "title", "busy"]));
  }
});
function fu(e) {
  return e.ext_required !== !1;
}
function Ate(e) {
  const a = e.lastIndexOf(".");
  return a >= 0 ? e.slice(a + 1).toLowerCase() : "";
}
function th(e, a) {
  return e.toLowerCase().endsWith("." + a.toLowerCase());
}
function zte(e) {
  const a = e.lastIndexOf(".");
  return a > 0 ? a : e.length;
}
function Mte(e, a, t) {
  const s = `${e}.${a}`;
  if (!t.has(s.toLowerCase())) return s;
  for (let n = 2; n < 100; n++) {
    const o = `${e} (${n}).${a}`;
    if (!t.has(o.toLowerCase())) return o;
  }
  return s;
}
function Dte(e, a, t) {
  return e.trim() ? a && th(e, a.ext) && e.length > a.ext.length + 1 ? e.slice(0, e.length - a.ext.length - 1) + "." + t.ext : fu(t) && !th(e, t.ext) ? `${e}.${t.ext}` : e : e;
}
function r2(e, a) {
  const t = e.trim();
  return !t || !fu(a) || th(t, a.ext) ? t : `${t}.${a.ext}`;
}
function Pte(e, a, t) {
  const s = e.trim();
  if (!s) return null;
  if (/[\\/]/.test(s)) return { kind: "slash" };
  if (/^\.+$/.test(s)) return { kind: "dots" };
  const n = r2(s, a);
  if (n.toLowerCase() === "." + a.ext.toLowerCase()) return { kind: "bare_ext" };
  if (pu(n)) return { kind: "reserved", name: n };
  if (!fu(a)) {
    const o = Ate(s);
    if (o && o !== a.ext && t.some((p) => p.ext === o && fu(p)))
      return { kind: "ext_needs_type", ext: o };
  }
  return null;
}
const Ote = {
  class: "fe-newdoc",
  "data-testid": "newdoc-modal"
}, Lte = {
  key: 0,
  class: "fe-newdoc__empty",
  "data-testid": "newdoc-empty"
}, Ite = { class: "fe-newdoc__empty-title" }, Rte = { class: "fe-newdoc__empty-body" }, Nte = ["aria-label"], Bte = { class: "fe-newdoc__grouplabel" }, Fte = { class: "fe-newdoc__grid" }, Ute = ["aria-checked", "tabindex", "data-newdoc-ext", "data-newdoc-key", "data-testid", "onClick", "onKeydown"], Hte = ["innerHTML"], Kte = { class: "fe-newdoc__ext" }, Vte = { class: "fe-newdoc__kind" }, qte = {
  key: 0,
  class: "fe-newdoc__withheld",
  "data-testid": "newdoc-withheld"
}, jte = { class: "fe-newdoc__field" }, Wte = {
  class: "fe-newdoc__label",
  for: "fe-newdoc-name"
}, Yte = ["placeholder", "aria-describedby", "onKeydown"], Gte = {
  key: 0,
  id: "fe-newdoc-name-note",
  class: "fe-form__error",
  "data-testid": "newdoc-name-error"
}, Xte = {
  key: 1,
  class: "fe-form__error",
  "data-testid": "newdoc-collision"
}, Jte = {
  key: 2,
  id: "fe-newdoc-name-note",
  class: "fe-newdoc__hint",
  "data-testid": "newdoc-ext-hint"
}, Zte = { class: "fe-newdoc__field" }, Qte = { class: "fe-newdoc__label" }, eae = { class: "fe-newdoc__dest" }, tae = {
  class: "fe-newdoc__destpath",
  "data-testid": "newdoc-dest"
}, aae = {
  key: 0,
  class: "fe-form__error",
  "data-testid": "newdoc-noaccess"
}, nae = {
  key: 0,
  class: "fe-newdoc__hint",
  "data-testid": "newdoc-draft-hint"
}, sae = {
  key: 1,
  class: "fe-newdoc__limit",
  role: "alert",
  "data-testid": "newdoc-draft-limit"
}, oae = { class: "fe-form__error" }, iae = {
  key: 2,
  class: "fe-form__error",
  "data-testid": "newdoc-failure"
}, rae = ["disabled"], lae = /* @__PURE__ */ rt({
  __name: "NewDocumentModal",
  props: {
    open: { type: Boolean },
    locale: {},
    theme: {},
    api: {},
    types: {},
    currentPath: {},
    storages: {},
    onlyOfficeReady: { type: Boolean },
    drawioReady: { type: Boolean },
    canConfigure: { type: Boolean },
    drafts: { type: Boolean }
  },
  emits: ["close", "created", "error", "open-drafts"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n, dir: o } = gt(() => t.locale);
    function p(J) {
      return J.key || J.ext;
    }
    function h(J) {
      return J.requires === "onlyoffice" ? !!t.onlyOfficeReady : J.requires === "drawio" ? !!t.drawioReady : !0;
    }
    const v = x(() => (t.types ?? []).filter(h)), y = x(() => {
      const J = new Set(v.value.filter((fe) => fe.app).map((fe) => fe.ext)), me = [];
      for (const fe of t.types ?? [])
        h(fe) || !fe.requires || fe.requires === "app" || J.has(fe.ext) || me.includes(fe.requires) || me.push(fe.requires);
      return me;
    }), g = x(() => {
      const J = y.value.map((me) => n("newdoc.withheld." + me));
      return J.length && t.canConfigure && J.push(n("newdoc.withheld_admin")), J.join(" ");
    }), m = x(() => {
      const J = [], me = /* @__PURE__ */ new Map();
      for (const fe of v.value)
        me.has(fe.group) || (me.set(fe.group, []), J.push(fe.group)), me.get(fe.group).push(fe);
      return J.map((fe) => ({ group: fe, types: me.get(fe) }));
    }), k = b(""), _ = x(() => v.value.find((J) => p(J) === k.value) ?? null);
    function w(J) {
      return J.app ? jt(J.app.label, t.locale) || J.ext : rd({ type: "file", extension: J.ext }, n);
    }
    function $(J) {
      return Sh(Ks({ type: "file", extension: J, basename: "x." + J }));
    }
    const C = b(""), E = b(!1), A = /* @__PURE__ */ new Map();
    function O(J) {
      return !J || J.read_only ? !1 : em(J.perm);
    }
    async function z(J) {
      if (A.has(J)) return A.get(J);
      try {
        const me = await t.api.index(J);
        return A.set(J, me), me;
      } catch {
        return;
      }
    }
    const P = x(
      () => C.value ? s0(C.value).map((J) => J.label).join(" / ") : ""
    ), I = b(!0), F = b(!1), W = b(""), N = b(!1), K = b(!1), M = b(!1), j = b(null), U = b(null), de = x(
      () => _.value ? r2(W.value, _.value) : W.value.trim()
    ), ke = x(
      () => _.value ? Pte(W.value, _.value, t.types ?? []) : null
    ), ie = x(() => {
      const J = ke.value;
      if (!J) return "";
      switch (J.kind) {
        case "slash":
          return n("newdoc.err.slash");
        case "dots":
          return n("modal.newfolder.invalid");
        case "bare_ext":
          return n("newdoc.err.bare_ext");
        case "reserved":
          return n("names.reserved", { name: J.name });
        case "ext_needs_type":
          return n("newdoc.err.ext_needs_type", { ext: J.ext });
      }
      return "";
    }), ce = x(() => {
      const J = _.value, me = W.value.trim();
      return !J || !me || ke.value || !fu(J) || de.value === me ? "" : n("newdoc.hint.ext_added", { name: de.value });
    });
    function X(J) {
      const me = /* @__PURE__ */ new Set();
      for (const fe of (J == null ? void 0 : J.files) ?? []) me.add(fe.basename.toLowerCase());
      return me;
    }
    let Z = 0, Y = null;
    async function G(J = {}) {
      var ut;
      const me = ++Z, fe = C.value;
      if (!fe) {
        F.value = !1, K.value = !1;
        return;
      }
      const xe = await z(fe);
      if (me !== Z || fe !== C.value) return;
      I.value = O(xe), F.value = !0;
      const ye = X(xe), qe = ((ut = _.value) == null ? void 0 : ut.ext) ?? "";
      J.suggest && !N.value && qe && (W.value = Mte(n("newdoc.untitled"), qe, ye)), K.value = !!de.value && ye.has(de.value.toLowerCase());
    }
    function we() {
      Y && clearTimeout(Y), Y = setTimeout(() => void G(), 220);
    }
    function R() {
      const J = (t.currentPath || "").trim(), [me] = ci(J);
      if (me) return J;
      const fe = t.storages ?? [];
      return fe.length === 1 ? fe[0] + "://" : "";
    }
    Qe(
      () => t.open,
      async (J) => {
        J && (A.clear(), j.value = null, U.value = null, K.value = !1, N.value = !1, M.value = !1, W.value = "", k.value = v.value[0] ? p(v.value[0]) : "", C.value = R(), F.value = !1, I.value = !0, E.value = !C.value, await G({ suggest: !0 }));
      }
    ), Qe(k, (J, me) => {
      const fe = v.value.find((ye) => p(ye) === J), xe = v.value.find((ye) => p(ye) === me) ?? null;
      fe && W.value && (W.value = Dte(W.value, xe, fe)), G({ suggest: !0 });
    }), Qe(W, () => {
      K.value = !1, we();
    }), Qe(C, () => {
      G({ suggest: !0 });
    });
    function pe(J) {
      k.value = J;
    }
    function Q(J, me) {
      const fe = v.value.map(p), xe = fe.indexOf(me);
      let ye = -1;
      const qe = J.key === "ArrowDown" ? 1 : J.key === "ArrowUp" ? -1 : ti(J.key, o.value);
      qe ? ye = (xe + qe + fe.length) % fe.length : J.key === "Home" ? ye = 0 : J.key === "End" && (ye = fe.length - 1), !(ye < 0) && (J.preventDefault(), k.value = fe[ye], Jt(() => {
        const ut = document.querySelector(`[data-newdoc-key="${fe[ye]}"]`);
        ut == null || ut.focus();
      }));
    }
    function q(J) {
      C.value = J, E.value = !1;
    }
    function re() {
      if (E.value) {
        E.value = !1;
        return;
      }
      s("close");
    }
    const ae = x(
      () => !M.value && !!_.value && !!C.value && !E.value && !!W.value.trim() && !ke.value && !K.value && (!F.value || I.value)
    );
    let Pe = !1;
    function be(J) {
      try {
        J.setSelectionRange(0, zte(J.value));
      } catch {
      }
    }
    function ze(J) {
      be(J.target);
    }
    function Ae(J) {
      Pe = document.activeElement !== J.target;
    }
    function Ce(J) {
      Pe && (Pe = !1, J.preventDefault(), be(J.target));
    }
    async function He() {
      if (!(!ae.value || !_.value)) {
        M.value = !0, j.value = null, U.value = null;
        try {
          const J = _.value, me = t.drafts ? await t.api.drafts.create(C.value, W.value.trim(), p(J), { exactName: !0 }) : await t.api.newFile(C.value, W.value.trim(), p(J), {
            exactName: !0
          });
          s("created", J.app ? { ...me, app: { plugin: J.app.plugin, view: J.app.view } } : me);
        } catch (J) {
          const me = J;
          CT(me) ? U.value = ET(me) ?? 0 : me.status === 409 ? K.value = !0 : (j.value = me.message || String(J), s("error", { message: j.value }));
        } finally {
          M.value = !1;
        }
      }
    }
    return (J, me) => (u(), d(he, null, [
      ot(la, {
        open: e.open,
        title: r(n)("newdoc.title"),
        size: "lg",
        theme: e.theme,
        onClose: re
      }, {
        actions: yt(() => [
          i("button", {
            type: "button",
            class: "fe-btn",
            onClick: re
          }, f(r(n)("newdoc.cancel")), 1),
          v.value.length ? (u(), d("button", {
            key: 0,
            type: "button",
            class: "fe-btn fe-btn--primary",
            disabled: !ae.value,
            "data-testid": "newdoc-create",
            onClick: He
          }, f(M.value ? r(n)("newdoc.creating") : r(n)("newdoc.create")), 9, rae)) : T("", !0)
        ]),
        default: yt(() => [
          i("div", Ote, [
            v.value.length ? (u(), d(he, { key: 1 }, [
              i("div", {
                class: "fe-newdoc__types",
                role: "radiogroup",
                "aria-label": r(n)("newdoc.type.label")
              }, [
                (u(!0), d(he, null, We(m.value, (fe) => (u(), d("section", {
                  key: fe.group,
                  class: "fe-newdoc__group"
                }, [
                  i("h3", Bte, f(r(n)("newdoc.group." + fe.group)), 1),
                  i("div", Fte, [
                    (u(!0), d(he, null, We(fe.types, (xe) => (u(), d("button", {
                      key: p(xe),
                      type: "button",
                      role: "radio",
                      class: Re(["fe-newdoc__type", { "is-selected": k.value === p(xe) }]),
                      "aria-checked": k.value === p(xe),
                      tabindex: k.value === p(xe) ? 0 : -1,
                      "data-newdoc-ext": xe.ext,
                      "data-newdoc-key": p(xe),
                      "data-testid": `newdoc-type-${p(xe)}`,
                      onClick: (ye) => pe(p(xe)),
                      onKeydown: (ye) => Q(ye, p(xe))
                    }, [
                      i("span", {
                        class: "fe-newdoc__tile",
                        "aria-hidden": "true",
                        innerHTML: $(xe.ext)
                      }, null, 8, Hte),
                      i("span", Kte, "." + f(xe.ext), 1),
                      i("span", Vte, f(w(xe)), 1)
                    ], 42, Ute))), 128))
                  ])
                ]))), 128)),
                g.value ? (u(), d("p", qte, f(g.value), 1)) : T("", !0)
              ], 8, Nte),
              i("div", jte, [
                i("label", Wte, f(r(n)("newdoc.name")), 1),
                dt(i("input", {
                  id: "fe-newdoc-name",
                  "onUpdate:modelValue": me[0] || (me[0] = (fe) => W.value = fe),
                  type: "text",
                  class: "fe-input fe-newdoc__name",
                  autocomplete: "off",
                  spellcheck: "false",
                  "data-testid": "newdoc-name",
                  placeholder: r(n)("newdoc.name.placeholder"),
                  "aria-describedby": ie.value || ce.value ? "fe-newdoc-name-note" : void 0,
                  onInput: me[1] || (me[1] = (fe) => N.value = !0),
                  onFocus: ze,
                  onMousedown: Ae,
                  onMouseup: Ce,
                  onKeydown: ya(ft(He, ["prevent"]), ["enter"])
                }, null, 40, Yte), [
                  [St, W.value]
                ]),
                ie.value ? (u(), d("p", Gte, f(ie.value), 1)) : K.value ? (u(), d("p", Xte, f(r(n)("newdoc.err.exists", { name: de.value })), 1)) : ce.value ? (u(), d("p", Jte, f(ce.value), 1)) : T("", !0)
              ]),
              i("div", Zte, [
                i("span", Qte, f(r(n)("newdoc.location")), 1),
                i("div", eae, [
                  i("span", tae, f(C.value ? P.value : r(n)("newdoc.location.none")), 1),
                  i("button", {
                    type: "button",
                    class: "fe-newdoc__changebtn",
                    "data-testid": "newdoc-change",
                    onClick: me[2] || (me[2] = (fe) => E.value = !0)
                  }, f(r(n)("newdoc.location.change")), 1)
                ]),
                F.value && !I.value ? (u(), d("p", aae, f(r(n)("newdoc.location.noaccess")), 1)) : T("", !0)
              ]),
              e.drafts && !U.value ? (u(), d("p", nae, f(r(n)("newdoc.hint.draft")), 1)) : T("", !0),
              U.value !== null ? (u(), d("div", sae, [
                i("p", oae, f(U.value ? r(n)("newdoc.err.draft_limit", { limit: U.value }) : r(n)("newdoc.err.draft_limit_any")), 1),
                i("button", {
                  type: "button",
                  class: "fe-btn fe-btn--sm",
                  "data-testid": "newdoc-open-drafts",
                  onClick: me[3] || (me[3] = (fe) => s("open-drafts"))
                }, f(r(n)("newdoc.open_drafts")), 1)
              ])) : T("", !0),
              j.value ? (u(), d("p", iae, f(j.value), 1)) : T("", !0)
            ], 64)) : (u(), d("div", Lte, [
              i("p", Ite, f(r(n)("newdoc.empty.title")), 1),
              i("p", Rte, f(y.value.length ? r(n)("newdoc.empty.blocked") : r(n)("newdoc.empty.body")), 1)
            ]))
          ])
        ]),
        _: 1
      }, 8, ["open", "title", "theme"]),
      ot(am, {
        open: E.value,
        api: e.api,
        locale: e.locale,
        mode: "choose",
        storages: e.storages,
        "start-at": C.value || e.currentPath,
        onClose: me[4] || (me[4] = (fe) => E.value = !1),
        onPick: q
      }, null, 8, ["open", "api", "locale", "storages", "start-at"])
    ], 64));
  }
}), uae = ["onKeydown"], cae = {
  key: 0,
  class: "fe-form__error",
  role: "alert",
  "data-testid": "rename-error"
}, dae = ["disabled"], fae = ["disabled", "aria-busy"], pae = /* @__PURE__ */ rt({
  __name: "RenameModal",
  props: {
    open: { type: Boolean },
    locale: {},
    currentName: {},
    error: {},
    busy: { type: Boolean }
  },
  emits: ["close", "submit"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n } = gt(() => t.locale), o = b(""), p = b(null);
    Qe(
      () => [t.open, t.currentName],
      ([y, g]) => {
        y && (o.value = g, p.value = t.error ?? null);
      }
    ), Qe(
      () => t.error,
      (y) => {
        p.value = y ?? null;
      },
      { immediate: !0 }
    );
    function h() {
      p.value = null;
    }
    function v() {
      if (t.busy) return;
      const y = o.value.trim();
      if (y) {
        if (/[\\/]/.test(y) || y === "." || y === "..") {
          p.value = n("modal.newfolder.invalid");
          return;
        }
        if (pu(y)) {
          p.value = n("names.reserved", { name: y });
          return;
        }
        s("submit", y);
      }
    }
    return (y, g) => (u(), nt(la, {
      open: e.open,
      title: r(n)("modal.rename.title"),
      size: "sm",
      busy: e.busy,
      onClose: g[2] || (g[2] = (m) => s("close"))
    }, {
      actions: yt(() => [
        i("button", {
          type: "button",
          class: "fe-btn",
          disabled: e.busy,
          onClick: g[1] || (g[1] = (m) => s("close"))
        }, f(r(n)("modal.rename.cancel")), 9, dae),
        i("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: e.busy,
          "aria-busy": e.busy ? "true" : void 0,
          onClick: v
        }, f(e.busy ? r(n)("modal.rename.saving") : r(n)("modal.rename.save")), 9, fae)
      ]),
      default: yt(() => [
        i("form", {
          onSubmit: ft(v, ["prevent"])
        }, [
          dt(i("input", {
            "onUpdate:modelValue": g[0] || (g[0] = (m) => o.value = m),
            type: "text",
            class: "fe-input",
            autocomplete: "off",
            onInput: h,
            onKeydown: ya(ft(v, ["prevent"]), ["enter"])
          }, null, 40, uae), [
            [St, o.value]
          ]),
          p.value ? (u(), d("p", cae, f(p.value), 1)) : T("", !0)
        ], 32)
      ]),
      _: 1
    }, 8, ["open", "title", "busy"]));
  }
}), vae = {
  key: 0,
  class: "fe-form__error",
  role: "alert"
}, hae = ["disabled"], mae = ["disabled", "aria-busy"], yae = /* @__PURE__ */ rt({
  __name: "DeleteConfirmModal",
  props: {
    open: { type: Boolean },
    locale: {},
    count: {},
    error: {},
    busy: { type: Boolean },
    permanent: { type: Boolean }
  },
  emits: ["close", "confirm"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n } = gt(() => t.locale);
    function o() {
      t.busy || s("confirm");
    }
    return (p, h) => (u(), nt(la, {
      open: e.open,
      title: e.permanent ? r(n)("modal.delete.permanent_title") : r(n)("modal.delete.title"),
      size: "sm",
      busy: e.busy,
      onClose: h[1] || (h[1] = (v) => s("close"))
    }, {
      actions: yt(() => [
        i("button", {
          type: "button",
          class: "fe-btn",
          disabled: e.busy,
          onClick: h[0] || (h[0] = (v) => s("close"))
        }, f(r(n)("modal.delete.cancel")), 9, hae),
        i("button", {
          type: "button",
          class: "fe-btn fe-btn--danger",
          disabled: e.busy,
          "aria-busy": e.busy ? "true" : void 0,
          onClick: o
        }, f(e.busy ? r(n)(e.permanent ? "modal.delete.permanent_working" : "modal.delete.working") : r(n)(e.permanent ? "modal.delete.permanent_confirm" : "modal.delete.confirm")), 9, mae)
      ]),
      default: yt(() => [
        i("p", null, f(e.permanent ? r(n)("modal.delete.permanent_message", { count: e.count }) : r(n)("modal.delete.message", { count: e.count })), 1),
        e.error ? (u(), d("p", vae, f(e.error), 1)) : T("", !0)
      ]),
      _: 1
    }, 8, ["open", "title", "busy"]));
  }
});
function gae(e, a) {
  return e && e.queued ? a("toast.undo_queued") : e && typeof e.done == "number" && typeof e.total == "number" && e.done < e.total ? a("toast.undo_partial", { done: e.done, total: e.total }) : a("toast.undone");
}
function j_(e, a, t) {
  return !e || e.source === a ? !0 : e.source === "drag-out-stopping" ? t === "end" : !1;
}
function W_(e, a, t, s) {
  return (e == null ? void 0 : e.kind) === "plain" ? a === "running" ? e.running : e.done : a === "running" ? s("toast.undoing") : gae(t, s);
}
function ev(e, a = {}) {
  const t = b(!1), s = b(null);
  let n = 0;
  Qe(e, (p, h) => {
    !p || h || (n++, t.value = !1, s.value = null);
  });
  function o(p) {
    return p === n && e.value;
  }
  return {
    busy: t,
    error: s,
    begin() {
      return t.value ? null : (t.value = !0, s.value = null, n);
    },
    end(p) {
      p === n && (t.value = !1);
    },
    refuse(p, h) {
      var v;
      return o(p) ? (s.value = h, !0) : ((v = a.say) == null || v.call(a, h), !1);
    },
    inDialog: o
  };
}
function Y_(e, a) {
  if (e.purged === 0) return e.reason || a("toast.failed");
  const t = e.reason || a("toast.failed");
  return e.queued ? e.failed ? a("toast.purging_partly", { n: e.purged, failed: e.failed, reason: t }) : a("toast.purging", { n: e.purged }) : e.failed ? a("toast.purged_partly", { n: e.purged, failed: e.failed, reason: t }) : a("toast.purged", { n: e.purged });
}
function bae() {
  const e = /* @__PURE__ */ new Set();
  function a(t) {
    for (const s of e) if (s.jobs.has(t)) return s;
  }
  return {
    /** A batch: its queue jobs, and what the server refused at once. */
    start(t, s) {
      t.length !== 0 && e.add({ jobs: new Set(t), purged: 0, failed: s.refused, reason: s.reason });
    },
    /** Is this job one of a batch's? */
    owns(t) {
      return a(t) !== void 0;
    },
    /**
     * A job ended: the batch's summary when it was the last, null while the
     * batch goes on, undefined for a job that is no batch's.
     */
    settle(t) {
      const s = a(t.id);
      if (s)
        return s.jobs.delete(t.id), t.ok ? s.purged++ : (s.failed++, !s.reason && t.reason && (s.reason = t.reason)), s.jobs.size > 0 ? null : (e.delete(s), s.reason === void 0 ? { purged: s.purged, failed: s.failed } : { purged: s.purged, failed: s.failed, reason: s.reason });
    }
  };
}
function _ae(e, a) {
  const t = [];
  return e.failed > 0 && t.push(a("toast.restore_partial", { n: e.restored, failed: e.failed, reason: e.reason || a("toast.failed") })), e.taken.length && t.push(a("toast.restore_taken", { n: e.taken.length, name: e.taken[0] })), t.length ? { message: t.join(" — "), failure: !0 } : { message: a("toast.restored", { n: e.restored }), failure: !1 };
}
const kae = 3e3, wae = 20;
function xae(e) {
  const a = e.last_sync_error || void 0;
  switch (e.last_sync_state) {
    case "ok":
      return { status: "ok" };
    case "failed":
    case "error":
      return a ? { status: "failed", error: a } : { status: "failed" };
    case "aborted":
      return { status: "aborted" };
    default:
      return { status: "unknown" };
  }
}
function $ae(e) {
  const a = e.pollMs ?? kae, t = e.giveUpAfter ?? wae, s = /* @__PURE__ */ new Map(), n = b(0);
  let o, p = !1, h = !1, v = 0;
  const y = /* @__PURE__ */ new Set();
  function g() {
    h || o !== void 0 || p || s.size === 0 || (o = setTimeout(() => {
      o = void 0, m();
    }, a));
  }
  async function m() {
    if (h || s.size === 0) return;
    p = !0;
    let _ = null;
    try {
      _ = await e.list(), v = 0;
    } catch {
      v++;
    } finally {
      p = !1;
    }
    if (h) return;
    const w = _ === null && v >= t;
    if (_ !== null || w) {
      for (const [$, C] of s) {
        const E = _ == null ? void 0 : _.find((O) => O.id === C.id), A = C.settle.filter((O) => !O(E, w));
        A.length === 0 ? s.delete($) : C.settle = A;
      }
      n.value++;
    }
    g();
  }
  function k(_, w, $) {
    return h ? Promise.resolve(null) : new Promise((C) => {
      const E = (P) => {
        y.delete(E), C(P);
      };
      y.add(E);
      const A = `${w}:${_}`, O = (P, I) => {
        const F = $(P, I);
        return F === void 0 ? !1 : (E(F), !0);
      }, z = s.get(A);
      z ? z.settle.push(O) : s.set(A, { id: _, kind: w, settle: [O] }), n.value++, g();
    });
  }
  return {
    scan: (_) => k(_, "scan", (w, $) => $ ? { status: "unknown" } : w ? w.running ? void 0 : xae(w) : { status: "gone" }),
    deletion: (_) => k(_, "deletion", (w, $) => $ ? !1 : w ? void 0 : !0),
    watching(_) {
      return n.value, s.has(`deletion:${_}`) ? "deletion" : s.has(`scan:${_}`) ? "scan" : null;
    },
    stop() {
      h = !0, o !== void 0 && clearTimeout(o), o = void 0, s.clear(), n.value++;
      for (const _ of [...y]) _(null);
    }
  };
}
const Sae = ["aria-label"], Tae = ["aria-selected", "tabindex", "disabled", "data-testid", "data-section", "onClick", "onKeydown"], Cae = { class: "fe-sections__label" }, Eae = ["data-testid"], l2 = /* @__PURE__ */ rt({
  __name: "SurfaceSections",
  props: {
    sections: {},
    active: {},
    locale: {},
    label: {},
    disabled: { type: Boolean }
  },
  emits: ["select"],
  setup(e, { emit: a }) {
    const t = e, s = a, n = x(
      () => t.sections.filter((h) => h && typeof h.id == "string" && h.id).map((h) => ({
        id: h.id,
        label: jt(h.label, t.locale) || h.id,
        count: typeof h.count == "number" && Number.isFinite(h.count) ? h.count : null
      }))
    );
    function o(h) {
      t.disabled || h === t.active || s("select", h);
    }
    function p(h, v) {
      var _, w;
      if (!["ArrowRight", "ArrowLeft", "Home", "End"].includes(h.key)) return;
      h.preventDefault();
      const g = n.value.length;
      if (!g) return;
      let m = v;
      h.key === "ArrowRight" ? m = (v + 1) % g : h.key === "ArrowLeft" ? m = (v - 1 + g) % g : h.key === "Home" ? m = 0 : h.key === "End" && (m = g - 1);
      const k = (_ = h.currentTarget.parentElement) == null ? void 0 : _.querySelectorAll('[role="tab"]');
      (w = k == null ? void 0 : k[m]) == null || w.focus(), o(n.value[m].id);
    }
    return (h, v) => (u(), d("nav", {
      class: "fe-sections",
      role: "tablist",
      "aria-label": e.label,
      "data-testid": "surface-sections"
    }, [
      (u(!0), d(he, null, We(n.value, (y, g) => (u(), d("button", {
        key: y.id,
        type: "button",
        role: "tab",
        class: Re(["fe-sections__tab", { "is-active": y.id === e.active }]),
        "aria-selected": y.id === e.active ? "true" : "false",
        tabindex: y.id === e.active || !e.active && g === 0 ? 0 : -1,
        disabled: e.disabled,
        "data-testid": `surface-section-${y.id}`,
        "data-section": y.id,
        onClick: (m) => o(y.id),
        onKeydown: (m) => p(m, g)
      }, [
        i("span", Cae, f(y.label), 1),
        y.count !== null ? (u(), d("span", {
          key: 0,
          class: "fe-sections__count",
          "data-testid": `surface-section-count-${y.id}`
        }, f(y.count), 9, Eae)) : T("", !0)
      ], 42, Tae))), 128))
    ], 8, Sae));
  }
}), Aae = {
  class: "fe-plugin-view",
  "data-testid": "plugin-view"
}, zae = {
  key: 0,
  class: "fe-surface__text fe-surface__text--muted",
  role: "status",
  "data-testid": "plugin-view-opening"
}, Mae = ["disabled"], Dae = /* @__PURE__ */ rt({
  __name: "PluginViewModal",
  props: {
    open: { type: Boolean },
    locale: {},
    theme: {},
    api: {},
    plugin: {},
    view: {},
    surface: {},
    path: {},
    paths: {},
    storages: {},
    startAt: {},
    size: {},
    label: {}
  },
  emits: ["close", "op", "toast", "open"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n } = gt(() => t.locale), o = Gd(
      {
        api: t.api,
        plugin: t.plugin,
        view: t.view,
        path: () => t.path,
        paths: () => t.paths,
        locale: () => t.locale,
        errorText: () => n("plugin.view.error")
      },
      {
        onOp: (m) => s("op", m),
        onDone: () => s("close"),
        onToast: (m) => s("toast", m),
        onOpen: (m) => s("open", m)
      }
    );
    Qe(
      () => t.surface,
      (m) => o.setSurface(m),
      { immediate: !0 }
    );
    const p = o.current, h = x(() => {
      var m;
      return jt((m = p.value) == null ? void 0 : m.title, t.locale) || t.label || t.view;
    }), v = x(() => {
      var m;
      return ((m = p.value) == null ? void 0 : m.sections) ?? [];
    });
    async function y(m) {
      var k, _;
      if (!(!m || m === ((k = p.value) == null ? void 0 : k.section)))
        try {
          const w = await t.api.pluginView(t.plugin, t.view, t.path, m);
          w != null && w.surface && o.setSurface(w.surface);
        } catch (w) {
          s("toast", ((_ = n.foreign) == null ? void 0 : _.call(n, String((w == null ? void 0 : w.message) ?? ""))) || n("plugin.view.error"));
        }
    }
    const g = x(() => {
      var k;
      if (t.size) return t.size;
      const m = (k = p.value) == null ? void 0 : k.size;
      return m === "sm" || m === "lg" || m === "xl" ? m : "md";
    });
    return (m, k) => (u(), nt(la, {
      open: e.open,
      title: h.value,
      size: g.value,
      theme: e.theme,
      locale: e.locale,
      busy: r(o).busy.value,
      onClose: k[1] || (k[1] = (_) => s("close"))
    }, {
      actions: yt(() => [
        r(o).footer.value.length ? T("", !0) : (u(), d("button", {
          key: 0,
          type: "button",
          class: "fe-btn",
          disabled: r(o).busy.value,
          "data-testid": "plugin-view-close",
          onClick: k[0] || (k[0] = (_) => s("close"))
        }, f(r(n)("plugin.view.close")), 9, Mae)),
        ot(Jd, {
          conv: r(o),
          locale: e.locale,
          "testid-prefix": "plugin-view"
        }, null, 8, ["conv", "locale"])
      ]),
      default: yt(() => {
        var _;
        return [
          i("div", Aae, [
            r(p) ? T("", !0) : (u(), d("p", zae, f(r(n)("plugin.view.loading")), 1)),
            v.value.length ? (u(), nt(l2, {
              key: 1,
              sections: v.value,
              active: (_ = r(p)) == null ? void 0 : _.section,
              locale: e.locale,
              label: h.value,
              disabled: r(o).busy.value,
              onSelect: y
            }, null, 8, ["sections", "active", "locale", "label", "disabled"])) : T("", !0),
            ot(Xd, {
              conv: r(o),
              locale: e.locale,
              theme: e.theme,
              api: e.api,
              plugin: e.plugin,
              storages: e.storages,
              "start-at": e.startAt
            }, null, 8, ["conv", "locale", "theme", "api", "plugin", "storages", "start-at"])
          ])
        ];
      }),
      _: 1
    }, 8, ["open", "title", "size", "theme", "locale", "busy"]));
  }
}), Pae = { class: "fe-appframe-modal__body" }, Oae = /* @__PURE__ */ rt({
  __name: "AppFrameModal",
  props: {
    api: {},
    locale: {},
    theme: {},
    plugin: {},
    view: {},
    placement: {},
    ui: {},
    label: {},
    files: {},
    userName: {}
  },
  emits: ["close", "toast", "op"],
  setup(e, { emit: a }) {
    const t = a, s = b(null), n = b("");
    async function o() {
      s.value && !await s.value.confirmClose() || t("close");
    }
    return (p, h) => (u(), nt(la, {
      open: !0,
      size: e.placement === "home" ? "xl" : "lg",
      title: n.value ? `${e.label} — ${n.value}` : e.label,
      locale: e.locale,
      theme: e.theme,
      "close-on-backdrop": !1,
      "data-testid": "app-frame-modal",
      onClose: o
    }, {
      default: yt(() => [
        i("div", Pae, [
          ot(tf, {
            ref_key: "frame",
            ref: s,
            api: e.api,
            app: e.plugin,
            version: e.ui.version,
            view: e.view,
            placement: e.placement,
            ui: e.ui,
            files: e.files,
            locale: e.locale,
            theme: e.theme,
            "user-name": e.userName,
            title: e.label,
            onTitle: h[0] || (h[0] = (v) => n.value = v),
            onToast: h[1] || (h[1] = (v) => t("toast", v.text)),
            onOp: h[2] || (h[2] = (v) => t("op", v)),
            onClose: o
          }, null, 8, ["api", "app", "version", "view", "placement", "ui", "files", "locale", "theme", "user-name", "title"])
        ])
      ]),
      _: 1
    }, 8, ["size", "title", "locale", "theme"]));
  }
}), Lae = "builtin";
function Iae(e) {
  return e.filter((a) => a.placement === "viewer" && !!a.ui);
}
function u2(e, a) {
  return !a || a.type !== "file" ? [] : Iae(e).filter((t) => aw(t.applies ?? {}, [tw(a, t.plugin)]));
}
function Rae(e, a, t) {
  const s = u2(e, a);
  return t === Lae ? null : t ? s.find((n) => `${n.plugin}/${n.id}` === t) ?? null : s[0] ?? null;
}
function G_(e) {
  return `'${e.replace(/'/g, "'\\''")}'`;
}
function Nae(e) {
  if (!(e != null && e.url)) return "";
  let a = e.url;
  const t = [];
  e.isDir && t.push("zip=wait"), e.pin && t.push("pin=" + encodeURIComponent(e.pin)), t.length && (a += (a.includes("?") ? "&" : "?") + t.join("&"));
  let s = "-OJ ";
  return e.filename && (s = `-o ${G_(e.isDir ? `${e.filename}.zip` : e.filename)} `), `curl -fSL ${s}${G_(a)}`;
}
function ah(e, a, t = {}) {
  return QT(e, a, t);
}
const Bae = [0, 1, 7, 30];
function Fae(e, a, t) {
  const s = a && a > 0 ? Math.floor(a) : 0;
  let n = s ? e.filter((o) => o > 0 && o <= s) : e.slice();
  return s && !n.includes(s) && n.push(s), n = Array.from(new Set(n)).sort((o, p) => o === 0 ? -1 : p === 0 ? 1 : o - p), n.map((o) => ({ v: o, l: t(o) }));
}
function Cc(e) {
  return e && e > 0 ? Math.floor(e) : 0;
}
function Uae(e, a, t) {
  if (!e) return ah(a, "share.ttl.never");
  const s = new Date(e), n = Number.isNaN(s.getTime()) ? e : vh(s, a, { time: !0 }, t);
  return ah(a, "share.ttl.until", { when: n });
}
function Hae(e, a) {
  const t = e && e > 0 ? Math.floor(e) : 0;
  return t ? ah(a, "share.ttl.ceiling", { days: t }) : "";
}
function Kae(e) {
  const a = e.filter((t) => !!t);
  return a.map((t, s) => s < a.length - 1 ? t.replace(/\.\s*$/, "") : t).join(" · ");
}
const Vae = ["aria-label"], qae = { class: "fe-share__head" }, jae = ["innerHTML"], Wae = { class: "fe-share__headtext" }, Yae = { class: "fe-share__title" }, Gae = ["title"], Xae = ["aria-label", "title"], Jae = ["innerHTML"], Zae = { class: "fe-share__body" }, Qae = {
  key: 0,
  class: "fe-share__lead",
  "data-testid": "share-lead"
}, ene = { class: "fe-share__switchrow" }, tne = ["innerHTML"], ane = { class: "fe-share__leadlabel" }, nne = ["aria-checked", "aria-label", "disabled"], sne = {
  class: "fe-share__who",
  "data-testid": "share-who"
}, one = { class: "fe-share__linkrow" }, ine = ["href", "title"], rne = ["innerHTML"], lne = {
  key: 0,
  class: "fe-share__detail",
  "data-testid": "share-valid-until"
}, une = {
  key: 1,
  class: "fe-share__pinrow"
}, cne = { class: "fe-share__pin" }, dne = ["innerHTML"], fne = {
  key: 1,
  class: "fe-share__warn"
}, pne = { class: "fe-share__sections" }, vne = {
  key: 0,
  class: "fe-share__section",
  "data-testid": "share-link-section"
}, hne = ["aria-expanded"], mne = { class: "fe-share__seclabel" }, yne = { class: "fe-share__secmeta" }, gne = {
  key: 0,
  class: "fe-share__panel"
}, bne = { class: "fe-share__opts" }, _ne = { class: "fe-share__togglerow" }, kne = { class: "fe-share__togglelabel" }, wne = ["aria-checked"], xne = { class: "fe-share__field" }, $ne = { class: "fe-share__fieldlabel" }, Sne = ["value"], Tne = { class: "fe-share__field" }, Cne = { class: "fe-share__fieldlabel" }, Ene = ["value"], Ane = {
  key: 0,
  class: "fe-share__hint",
  "data-testid": "share-ttl-hint"
}, zne = ["disabled"], Mne = {
  key: 1,
  class: "fe-share__hint",
  "data-testid": "share-replace-hint"
}, Dne = {
  key: 2,
  class: "fe-share__hint"
}, Pne = { class: "fx-perm-cli fe-share__cli" }, One = { class: "fe-share__fieldlabel" }, Lne = { class: "fe-share__clirow" }, Ine = ["title"], Rne = ["innerHTML"], Nne = {
  key: 0,
  class: "fe-share__mailrow",
  "data-testid": "share-mail-row"
}, Bne = ["disabled", "placeholder"], Fne = ["disabled"], Une = {
  key: 1,
  class: "fe-share__notice",
  "data-testid": "share-mail-unavailable"
}, Hne = {
  key: 2,
  class: "fe-share__notice"
}, Kne = ["innerHTML"], Vne = {
  key: 4,
  class: "fe-share__list",
  "data-testid": "share-other-links"
}, qne = { class: "fe-share__listhead" }, jne = ["title"], Wne = ["onClick"], Yne = ["innerHTML"], Gne = ["disabled", "title", "aria-label", "onClick"], Xne = ["innerHTML"], Jne = {
  key: 1,
  class: "fe-share__section",
  "data-testid": "share-people"
}, Zne = ["aria-expanded"], Qne = { class: "fe-share__seclabel" }, ese = { class: "fe-share__secmeta" }, tse = {
  key: 0,
  class: "fe-share__panel"
}, ase = {
  key: 0,
  class: "fe-share__warn",
  "data-testid": "share-rbac-off"
}, nse = {
  key: 1,
  class: "fe-share__warn"
}, sse = {
  key: 2,
  class: "fe-share__hint"
}, ose = {
  class: "fe-share__add",
  "data-testid": "share-add-person"
}, ise = { class: "fe-share__emailwrap" }, rse = ["disabled", "placeholder"], lse = {
  key: 0,
  class: "fe-share__suggest"
}, use = ["onMousedown"], cse = { class: "fe-share__av fe-share__av--sm" }, dse = { class: "fe-share__suggesttxt" }, fse = { class: "fe-share__suggestname" }, pse = { class: "fe-share__suggestmeta" }, vse = ["disabled", "title"], hse = ["value"], mse = ["disabled"], yse = {
  key: 0,
  class: "fe-share__invite"
}, gse = { class: "fe-share__hint" }, bse = { class: "fe-share__inviterow" }, _se = { value: "user" }, kse = { value: "viewer" }, wse = ["disabled"], xse = ["disabled"], $se = {
  key: 1,
  class: "fe-share__notice"
}, Sse = {
  key: 2,
  class: "fe-share__notice"
}, Tse = { class: "fe-share__pin" }, Cse = { class: "fe-share__list" }, Ese = { class: "fe-share__listhead" }, Ase = {
  key: 0,
  class: "fe-share__empty"
}, zse = { class: "fe-share__av" }, Mse = ["title"], Dse = ["value", "onChange"], Pse = ["value"], Ose = ["disabled", "title", "aria-label", "onClick"], Lse = ["innerHTML"], Ise = { class: "fe-share__av fe-share__av--dim" }, Rse = ["title"], Nse = { class: "fe-share__badge" }, Bse = ["title"], Fse = {
  key: 2,
  class: "fe-share__section",
  "data-testid": "share-drop"
}, Use = ["aria-expanded"], Hse = { class: "fe-share__seclabel" }, Kse = { class: "fe-share__secmeta" }, Vse = {
  key: 0,
  class: "fe-share__panel"
}, qse = { class: "fe-share__hint" }, jse = { class: "fe-share__opts" }, Wse = { class: "fe-share__togglerow" }, Yse = { class: "fe-share__togglelabel" }, Gse = ["aria-checked"], Xse = { class: "fe-share__field" }, Jse = { class: "fe-share__fieldlabel" }, Zse = ["value"], Qse = {
  key: 0,
  class: "fe-share__hint"
}, eoe = ["disabled"], toe = ["aria-expanded"], aoe = {
  key: 1,
  class: "fe-share__adv"
}, noe = { class: "fe-share__advrow" }, soe = { class: "fe-share__fieldlabel" }, ooe = { class: "fe-share__advrow" }, ioe = { class: "fe-share__fieldlabel" }, roe = { class: "fe-share__advrow" }, loe = { class: "fe-share__fieldlabel" }, uoe = ["placeholder"], coe = { class: "fe-share__togglerow" }, doe = { class: "fe-share__togglelabel" }, foe = ["aria-checked"], poe = {
  key: 2,
  class: "fe-share__warn"
}, voe = { class: "fe-share__linkrow" }, hoe = ["href", "title"], moe = ["innerHTML"], yoe = { class: "fe-share__detail" }, goe = { key: 0 }, boe = {
  key: 0,
  class: "fe-share__pinrow"
}, _oe = { class: "fe-share__pin" }, koe = ["innerHTML"], woe = {
  key: 1,
  class: "fe-share__mailrow"
}, xoe = ["disabled", "placeholder"], $oe = ["disabled"], Soe = {
  key: 2,
  class: "fe-share__notice"
}, Toe = {
  key: 3,
  class: "fe-share__notice"
}, Coe = ["innerHTML"], Eoe = {
  key: 4,
  class: "fe-share__list",
  "data-testid": "drop-other-links"
}, Aoe = { class: "fe-share__listhead" }, zoe = ["title"], Moe = ["onClick"], Doe = ["innerHTML"], Poe = ["disabled", "title", "aria-label", "onClick"], Ooe = ["innerHTML"], Loe = { class: "fe-share__foot" }, Ioe = /* @__PURE__ */ rt({
  __name: "PermissionsModal",
  props: {
    api: {},
    path: {},
    isDir: { type: Boolean },
    size: {},
    locale: {},
    shareMaxTtlDays: {},
    initialTab: {},
    mailReady: { type: Boolean },
    canConfigure: { type: Boolean },
    perm: {},
    sharing: {}
  },
  emits: ["close"],
  setup(e, { emit: a }) {
    const t = e, s = a, n = x(() => t.sharing ?? M1), o = x(() => t.mailReady === !1), p = x(() => !o.value || t.canConfigure === !0), h = x(() => Ha(t.locale)), { t: v, formatSize: y } = gt(() => h.value), g = x(() => {
      const Se = /^([^:]+):\/\/(.*)$/.exec(t.path), Ie = Se ? Se[1] : "", ee = Se ? Se[2] : t.path, ge = ee.split("/").filter(Boolean);
      return { adapter: Ie, name: ge.length ? ge[ge.length - 1] : Ie, rel: ee };
    }), m = x(() => {
      const Se = g.value.name, Ie = Se.lastIndexOf(".");
      return sn({
        type: t.isDir ? "dir" : "file",
        extension: !t.isDir && Ie > 0 ? Se.slice(Ie + 1) : ""
      });
    }), k = b({ link: !1, people: !1, drop: !1 });
    function _(Se) {
      k.value = { ...k.value, [Se]: !k.value[Se] };
    }
    const w = b(!1), $ = b(!0), C = b(""), E = b([]), A = b([]), O = b(!0), z = b(""), P = b("viewer"), I = b(!1), F = b(""), W = b(!1), N = b("user"), K = b(null), M = b([]), j = b(!1);
    let U;
    const de = x(() => [
      { v: "viewer", l: v("access.ui.level_viewer"), d: v("access.ui.level_viewer_desc") },
      { v: "editor", l: v("access.ui.level_editor"), d: v("access.ui.level_editor_desc") },
      { v: "owner", l: v("access.ui.level_owner"), d: v("access.ui.level_owner_desc") }
    ]);
    function ke(Se) {
      var Ie;
      return ((Ie = de.value.find((ee) => ee.v === Se)) == null ? void 0 : Ie.l) ?? Se;
    }
    const ie = x(
      () => O.value ? {} : hd(!1, t.canConfigure === !0, v("access.ui.rbac_off_here"))
    ), ce = x(() => n.value.users && w.value && ie.value.hidden !== !0), X = x(() => ie.value.disabled === !0), Z = b([]), Y = b(!1), G = b(!1), we = b(Cc(t.shareMaxTtlDays)), R = b(null), pe = b(""), Q = b(""), q = b(""), re = b(!1), ae = b("");
    function Pe(Se) {
      return Se.kind ?? "download";
    }
    const be = x(() => Z.value.filter((Se) => Pe(Se) !== "drop")), ze = x(() => Z.value.filter((Se) => Pe(Se) === "drop"));
    function Ae(Se) {
      return Se === 0 ? v("access.ui.never") : v("access.ui.days", { days: Se });
    }
    const Ce = x(() => Fae(Bae, t.shareMaxTtlDays, Ae)), He = x(() => Hae(t.shareMaxTtlDays, h.value));
    Qe(
      () => t.shareMaxTtlDays,
      () => {
        const Se = Ce.value.map((Ie) => Ie.v);
        Se.includes(we.value) || (we.value = Cc(t.shareMaxTtlDays)), Se.includes(ye.value) || (ye.value = Cc(t.shareMaxTtlDays));
      }
    );
    const J = b(0), me = x(() => [
      { v: 0, l: v("access.ui.unlimited") },
      ...[1, 3, 5, 10, 25].map((Se) => ({ v: Se, l: v("access.ui.downloads", { count: Se }) }))
    ]), fe = x(
      () => Nae(
        R.value ? {
          url: R.value.url,
          pin: R.value.pin,
          filename: g.value.name,
          isDir: !!t.isDir
        } : null
      )
    ), xe = b(!1), ye = b(Cc(t.shareMaxTtlDays)), qe = b(!1), ut = b(""), Ue = b(""), Ye = b(""), st = b(!0), kt = b(!1), At = b(""), _t = b(null), Le = b(""), tt = b(!1), ve = b("");
    function H(Se) {
      const Ie = /* @__PURE__ */ new Set(), ee = [];
      for (const ge of Hc(Se, { spaces: !0, semicolons: !0 })) {
        const De = ge.trim().toLowerCase();
        De && De.includes("@") && !Ie.has(De) && (Ie.add(De), ee.push(De));
      }
      return ee;
    }
    function te(Se) {
      var ge, De;
      const Ie = ((ge = Se.sent) == null ? void 0 : ge.length) ?? 0, ee = ((De = Se.failed) == null ? void 0 : De.length) ?? 0;
      return ee === 0 ? v("access.ui.mail_sent", { sent: Ie }) : v("access.ui.mail_partial", { sent: Ie, failed: ee });
    }
    async function Te() {
      if ($.value = !0, C.value = "", t.perm && t.perm !== "owner" || !n.value.users) {
        w.value = !1, k.value = { ...k.value, people: !1 }, $.value = !1;
        return;
      }
      try {
        const Se = await t.api.listPermissions(t.path);
        E.value = Se.direct ?? [], A.value = Se.inherited ?? [], O.value = Se.storage_rbac, w.value = !0;
      } catch (Se) {
        Se.status === 403 ? (w.value = !1, k.value = { ...k.value, people: !1 }) : C.value = Se instanceof Error ? Se.message : String(Se);
      } finally {
        $.value = !1;
      }
    }
    async function L() {
      try {
        const Se = await t.api.listShares(t.path);
        Z.value = Se.shares ?? [];
      } catch {
        Z.value = [];
      }
    }
    function se(Se) {
      Se.key === "Escape" && s("close");
    }
    Kt(async () => {
      t.initialTab === "drop" ? k.value = { ...k.value, drop: !0 } : t.initialTab === "perms" && (k.value = { ...k.value, people: !0 }), document.addEventListener("keydown", se), await Te(), await L();
    }), Mt(() => {
      U && clearTimeout(U), document.removeEventListener("keydown", se);
    });
    function ne() {
      W.value = !1, K.value = null, F.value = "";
      const Se = z.value.trim();
      if (U && clearTimeout(U), Se.length < 1) {
        M.value = [], j.value = !1;
        return;
      }
      U = setTimeout(async () => {
        try {
          const Ie = await t.api.searchUsers(Se);
          M.value = Ie.users ?? [], j.value = M.value.length > 0;
        } catch {
          j.value = !1;
        }
      }, 180);
    }
    async function et(Se) {
      if (X.value) return;
      j.value = !1, z.value = Se.email;
      let Ie = P.value;
      Se.role === "viewer" && Ie !== "viewer" && (Ie = "viewer"), I.value = !0, F.value = "";
      try {
        await t.api.addPermission({ path: t.path, user_id: Se.id, level: Ie, is_dir: !!t.isDir }), z.value = "", M.value = [], await Te(), F.value = v("access.ui.access_granted");
      } catch (ee) {
        F.value = ee instanceof Error ? ee.message : String(ee);
      } finally {
        I.value = !1;
      }
    }
    async function ht() {
      if (X.value) return;
      const Se = z.value.trim().toLowerCase();
      if (!Se || !Se.includes("@")) {
        F.value = v("access.ui.enter_a_valid_email");
        return;
      }
      j.value = !1, I.value = !0, F.value = "", K.value = null;
      try {
        const Ie = await t.api.resolveEmail(Se);
        if (Ie.found && Ie.user) {
          let ee = P.value;
          Ie.user.role === "viewer" && ee !== "viewer" && (ee = "viewer"), await t.api.addPermission({ path: t.path, user_id: Ie.user.id, level: ee, is_dir: !!t.isDir }), z.value = "", await Te(), F.value = v("access.ui.access_granted");
        } else
          W.value = !0;
      } catch (Ie) {
        F.value = Ie instanceof Error ? Ie.message : String(Ie);
      } finally {
        I.value = !1;
      }
    }
    async function Tt() {
      I.value = !0, F.value = "";
      try {
        const Se = await t.api.invitePermission({
          path: t.path,
          email: z.value.trim().toLowerCase(),
          level: P.value,
          create_user: !0,
          role: N.value,
          is_dir: !!t.isDir,
          locale: Ha(t.locale)
        });
        K.value = { tempPassword: Se.temp_password }, F.value = Se.emailed ? v("access.ui.user_created_invite_emailed") : v("access.ui.user_created_share_the_temp_password"), W.value = !1, z.value = "", await Te();
      } catch (Se) {
        F.value = Se instanceof Error ? Se.message : String(Se);
      } finally {
        I.value = !1;
      }
    }
    function Ft() {
      q.value = z.value.trim().toLowerCase(), W.value = !1, F.value = "", k.value = { ...k.value, link: !0 };
    }
    async function Lt(Se, Ie) {
      if (Ie !== Se.level) {
        I.value = !0;
        try {
          await t.api.updatePermission(Se.id, Ie), await Te();
        } catch (ee) {
          F.value = ee instanceof Error ? ee.message : String(ee);
        } finally {
          I.value = !1;
        }
      }
    }
    async function ua(Se) {
      I.value = !0;
      try {
        await t.api.deletePermission(Se.id), await Te();
      } catch (Ie) {
        F.value = Ie instanceof Error ? Ie.message : String(Ie);
      } finally {
        I.value = !1;
      }
    }
    function Ct(Se) {
      return ui({ name: Se.user_name, display_name: Se.user_display_name, email: Se.user_email }) || `#${Se.user_id}`;
    }
    function Qt(Se) {
      return md({ name: Se.user_name, display_name: Se.user_display_name, email: Se.user_email }, kn(h.value)) || "?";
    }
    function ta() {
      return we.value ? new Date(Date.now() + we.value * 864e5).toISOString() : null;
    }
    async function Rt() {
      if (n.value.links) {
        Y.value = !0, pe.value = "", ae.value = "";
        try {
          for (const Ie of be.value) await t.api.revokeShare(Ie.uuid);
          R.value = null;
          const Se = await t.api.createShare({
            path: t.path,
            password: G.value,
            expires_at: ta(),
            // null, not 0 — the server reads 0 as "no cap given" either way, but a
            // null says it explicitly and keeps the payload honest.
            max_downloads: J.value || null
          });
          R.value = {
            url: Se.share.url,
            pin: Se.share.password_pin ?? null,
            expiresAt: Se.share.expires_at ?? null,
            clamped: !!Se.share.expiry_clamped
          }, await L();
        } catch (Se) {
          pe.value = Se instanceof Error ? Se.message : String(Se);
        } finally {
          Y.value = !1;
        }
      }
    }
    async function va() {
      if (!(Y.value || !n.value.links)) {
        if (Dt.value) {
          Y.value = !0, pe.value = "";
          try {
            for (const Se of be.value) await t.api.revokeShare(Se.uuid);
            R.value = null, await L();
          } catch (Se) {
            pe.value = Se instanceof Error ? Se.message : String(Se);
          } finally {
            Y.value = !1;
          }
          return;
        }
        await Rt();
      }
    }
    async function ha() {
      var Ie;
      if (re.value) return;
      const Se = H(q.value);
      if (!Se.length) {
        ae.value = v("access.ui.enter_a_valid_email");
        return;
      }
      if ((Ie = R.value) != null && Ie.url) {
        re.value = !0, ae.value = "";
        try {
          const ee = await t.api.shareMail({
            path: t.path,
            emails: Se,
            url: R.value.url,
            pin: R.value.pin ?? void 0,
            expires_days: we.value || void 0,
            locale: Ha(t.locale),
            is_dir: !!t.isDir,
            size: t.size
          });
          ae.value = te(ee);
        } catch (ee) {
          const ge = ee.detail ?? "";
          ge.includes("not_configured") ? ae.value = v("access.ui.smtp_not_set_up_verified_share_the_link") : ge.includes("send_failed") ? ae.value = v("access.ui.send_failed_temporary_please_retry") : ae.value = ee instanceof Error ? ee.message : String(ee);
        } finally {
          re.value = !1;
        }
      }
    }
    function _a() {
      return ye.value ? new Date(Date.now() + ye.value * 864e5).toISOString() : null;
    }
    async function ia() {
      if (n.value.uploadLinks) {
        kt.value = !0, At.value = "", _t.value = null, ve.value = "";
        try {
          const Se = { ask_name: st.value };
          ut.value && (Se.max_files = Number(ut.value)), Ue.value && (Se.max_file_size_mb = Number(Ue.value));
          const Ie = Hc(Ye.value, { spaces: !0 }).map((ge) => ge.replace(/^\./, "")).filter(Boolean);
          Ie.length && (Se.allowed_ext = Ie);
          const ee = await t.api.createShare({
            path: t.path,
            kind: "drop",
            password: xe.value,
            expires_at: _a(),
            drop_settings: Se
          });
          _t.value = {
            url: ee.share.url,
            pin: ee.share.password_pin ?? null,
            expiresAt: ee.share.expires_at ?? null,
            clamped: !!ee.share.expiry_clamped
          }, await L();
        } catch (Se) {
          At.value = Se instanceof Error ? Se.message : String(Se);
        } finally {
          kt.value = !1;
        }
      }
    }
    async function _e() {
      var Ie;
      if (tt.value) return;
      const Se = H(Le.value);
      if (!Se.length) {
        ve.value = v("access.ui.enter_a_valid_email");
        return;
      }
      if ((Ie = _t.value) != null && Ie.url) {
        tt.value = !0, ve.value = "";
        try {
          const ee = await t.api.shareMail({
            path: t.path,
            emails: Se,
            url: _t.value.url,
            pin: _t.value.pin ?? void 0,
            expires_days: ye.value || void 0,
            locale: Ha(t.locale),
            is_dir: !0,
            mode: "drop"
          });
          ve.value = te(ee);
        } catch (ee) {
          (ee.detail ?? "").includes("not_configured") ? ve.value = v("access.ui.smtp_not_set_up_verified_share_the_link") : ve.value = ee instanceof Error ? ee.message : String(ee);
        } finally {
          tt.value = !1;
        }
      }
    }
    async function Ve(Se) {
      Y.value = !0;
      try {
        await t.api.revokeShare(Se.uuid), R.value && R.value.url === Se.url && (R.value = null), await L();
      } catch (Ie) {
        pe.value = Ie instanceof Error ? Ie.message : String(Ie);
      } finally {
        Y.value = !1;
      }
    }
    function Je(Se, Ie = "url") {
      var ee;
      (ee = navigator.clipboard) == null || ee.writeText(Se), Q.value = Ie, setTimeout(() => {
        Q.value === Ie && (Q.value = "");
      }, 1400);
    }
    const at = x(() => typeof navigator < "u" && typeof navigator.share == "function");
    function xt(Se) {
      return !Se || Se <= 0 ? "" : y(Se);
    }
    function Bt(Se) {
      return Se > 0 ? v("access.ui.valid_for", { days: Se }) : v("share.ttl.never");
    }
    const Ot = On(Od, void 0);
    function It(Se) {
      return Uae((Se == null ? void 0 : Se.expiresAt) ?? null, h.value, Ot);
    }
    const Et = x(() => {
      var Se, Ie;
      return ((Se = R.value) == null ? void 0 : Se.url) ?? ((Ie = be.value[0]) == null ? void 0 : Ie.url) ?? "";
    }), Dt = x(() => !!Et.value), aa = x(() => be.value.filter((Se) => Se.url !== Et.value)), V = x(() => ze.value.filter((Se) => {
      var Ie;
      return Se.url !== ((Ie = _t.value) == null ? void 0 : Ie.url);
    })), oe = x(() => Dt.value ? R.value ? R.value.pin ? v("access.who.pin") : v("access.who.link") : v("access.who.existing", { n: be.value.length }) : v("access.who.private")), Oe = x(() => {
      var Ie, ee;
      const Se = [];
      if (R.value)
        Se.push(It(R.value)), R.value.clamped && Se.push(v("access.ui.server_limit_applied")), J.value && Se.push(((Ie = me.value.find((ge) => ge.v === J.value)) == null ? void 0 : Ie.l) ?? "");
      else if (be.value[0]) {
        const ge = be.value[0];
        Se.push(It({ expiresAt: ge.expires_at ?? null })), ge.max_downloads && Se.push(((ee = me.value.find((De) => De.v === ge.max_downloads)) == null ? void 0 : ee.l) ?? String(ge.max_downloads));
      }
      return Kae(Se);
    }), Ne = x(() => {
      var Ie;
      const Se = [];
      return Se.push(G.value ? v("access.sum.pin_on") : v("access.sum.pin_off")), Se.push(Ae(we.value)), J.value && Se.push(((Ie = me.value.find((ee) => ee.v === J.value)) == null ? void 0 : Ie.l) ?? ""), Se.filter(Boolean).join(" · ");
    }), Ee = x(() => {
      const Se = E.value.length + A.value.length;
      return Se ? v("access.sum.people", { n: Se }) : v("access.sum.people_none");
    }), Ge = x(
      () => ze.value.length ? v("access.sum.drop", { n: ze.value.length }) : v("access.sum.drop_none")
    );
    function ue() {
      var lt, Ze;
      const Se = g.value.name, Ie = ((lt = R.value) == null ? void 0 : lt.url) ?? "", ee = ((Ze = R.value) == null ? void 0 : Ze.pin) ?? "", ge = v(t.isDir ? "access.ui.mail_title_folder" : "access.ui.mail_title_file", { name: Se }), De = [];
      if (De.push(v("access.ui.mail_hello"), ""), De.push(v(t.isDir ? "access.ui.mail_shared_folder" : "access.ui.mail_shared_file"), ""), t.isDir)
        De.push(v("access.ui.mail_folder", { name: Se }));
      else {
        De.push(v("access.ui.mail_file", { name: Se }));
        const ct = xt(t.size);
        ct && De.push(v("access.ui.mail_size", { size: ct }));
      }
      return De.push("", v("access.ui.mail_download_here"), Ie), ee && De.push("", v("access.ui.mail_pin", { pin: ee })), De.push("", Bt(we.value)), { title: ge, text: De.join(`
`) };
    }
    function je() {
      var Ut, Zt;
      const Se = g.value.name, Ie = ((Ut = _t.value) == null ? void 0 : Ut.url) ?? "", ee = ((Zt = _t.value) == null ? void 0 : Zt.pin) ?? "", ge = Number(ut.value) || 20, De = Number(Ue.value) || 500, lt = Hc(Ye.value, { spaces: !0 }).map((Da) => Da.replace(/^\./, "")).filter(Boolean), Ze = v("access.ui.drop_title", { folder: Se }), ct = [];
      return ct.push(v("access.ui.mail_hello"), ""), ct.push(v("access.ui.drop_invited"), ""), ct.push(v("access.ui.mail_folder", { name: Se })), ct.push(v("access.ui.drop_limit", { files: ge, mb: De })), ct.push(lt.length ? v("access.ui.drop_types", { types: lt.join(", ") }) : v("access.ui.drop_types_all")), ct.push("", v("access.ui.drop_upload_here"), Ie), ee && ct.push("", v("access.ui.mail_pin", { pin: ee })), ct.push("", Bt(ye.value)), { title: Ze, text: ct.join(`
`) };
    }
    async function vt(Se) {
      if (at.value)
        try {
          await navigator.share(Se);
        } catch {
        }
    }
    return (Se, Ie) => {
      var ee, ge, De, lt;
      return u(), d("div", {
        class: "fx-perm-overlay fe-share__scrim",
        onClick: Ie[27] || (Ie[27] = ft((Ze) => s("close"), ["self"]))
      }, [
        i("div", {
          class: "fx-perm-modal fe-share",
          role: "dialog",
          "aria-modal": "true",
          "aria-label": r(v)("access.title", { name: g.value.name })
        }, [
          i("header", qae, [
            i("span", {
              class: "fe-share__tile",
              "aria-hidden": "true",
              innerHTML: m.value
            }, null, 8, jae),
            i("div", Wae, [
              i("h3", Yae, f(r(v)("access.title", { name: g.value.name })), 1),
              i("span", {
                class: "fe-share__path",
                title: e.path
              }, [
                i("bdi", null, f(g.value.adapter), 1)
              ], 8, Gae)
            ]),
            i("button", {
              type: "button",
              class: "fe-share__close",
              "aria-label": r(v)("access.close"),
              title: r(v)("access.close"),
              onClick: Ie[0] || (Ie[0] = (Ze) => s("close"))
            }, [
              i("span", {
                "aria-hidden": "true",
                innerHTML: r(wt)("close")
              }, null, 8, Jae)
            ], 8, Xae)
          ]),
          i("div", Zae, [
            n.value.links ? (u(), d("div", Qae, [
              i("div", ene, [
                i("span", {
                  class: "fe-share__leadicon",
                  "aria-hidden": "true",
                  innerHTML: r(wt)("access")
                }, null, 8, tne),
                i("span", ane, f(r(v)("access.link.switch")), 1),
                i("button", {
                  type: "button",
                  class: "fe-share__switch",
                  role: "switch",
                  "aria-checked": Dt.value ? "true" : "false",
                  "aria-label": r(v)("access.link.switch"),
                  "data-testid": "share-switch",
                  disabled: Y.value,
                  onClick: va
                }, [...Ie[28] || (Ie[28] = [
                  i("span", { class: "fe-share__knob" }, null, -1)
                ])], 8, nne)
              ]),
              i("p", sne, f(oe.value), 1),
              Dt.value ? (u(), d(he, { key: 0 }, [
                i("div", one, [
                  i("a", {
                    href: Et.value,
                    target: "_blank",
                    rel: "noopener",
                    class: "fe-share__url",
                    title: Et.value
                  }, f(Et.value), 9, ine),
                  i("button", {
                    type: "button",
                    class: "fe-share__copy",
                    "data-testid": "share-copy",
                    onClick: Ie[1] || (Ie[1] = (Ze) => Je(Et.value, "new"))
                  }, [
                    i("span", {
                      "aria-hidden": "true",
                      innerHTML: r(wt)("copy")
                    }, null, 8, rne),
                    i("span", null, f(Q.value === "new" ? r(v)("access.copied") : r(v)("access.copy")), 1)
                  ])
                ]),
                Oe.value ? (u(), d("p", lne, f(Oe.value), 1)) : T("", !0),
                (ee = R.value) != null && ee.pin ? (u(), d("div", une, [
                  Ie[29] || (Ie[29] = i("span", { class: "fe-share__pinlabel" }, "PIN", -1)),
                  i("code", cne, f((ge = R.value) == null ? void 0 : ge.pin), 1),
                  i("button", {
                    type: "button",
                    class: "fe-share__copy",
                    onClick: Ie[2] || (Ie[2] = (Ze) => {
                      var ct;
                      return Je(((ct = R.value) == null ? void 0 : ct.pin) ?? "", "sharepin");
                    })
                  }, [
                    i("span", {
                      "aria-hidden": "true",
                      innerHTML: r(wt)("copy")
                    }, null, 8, dne),
                    i("span", null, f(Q.value === "sharepin" ? r(v)("access.copied") : r(v)("access.copy")), 1)
                  ])
                ])) : T("", !0)
              ], 64)) : T("", !0),
              pe.value ? (u(), d("div", fne, f(pe.value), 1)) : T("", !0)
            ])) : T("", !0),
            i("div", pne, [
              n.value.links ? (u(), d("section", vne, [
                i("button", {
                  type: "button",
                  class: "fe-share__sechead",
                  "aria-expanded": k.value.link ? "true" : "false",
                  "data-testid": "share-options-toggle",
                  onClick: Ie[3] || (Ie[3] = (Ze) => _("link"))
                }, [
                  (u(), d("svg", {
                    class: Re(["fe-share__caret", { "is-open": k.value.link }]),
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "1.8",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "aria-hidden": "true",
                    focusable: "false"
                  }, [...Ie[30] || (Ie[30] = [
                    i("path", { d: "M9 6l6 6-6 6" }, null, -1)
                  ])], 2)),
                  i("span", mne, f(r(v)("access.section.link")), 1),
                  i("span", yne, f(Ne.value), 1)
                ], 8, hne),
                k.value.link ? (u(), d("div", gne, [
                  i("div", bne, [
                    i("label", _ne, [
                      i("span", kne, f(r(v)("access.ui.protect_with_a_pin")), 1),
                      i("button", {
                        type: "button",
                        class: "fe-share__switch",
                        role: "switch",
                        "aria-checked": G.value ? "true" : "false",
                        "data-testid": "share-pin-switch",
                        onClick: Ie[4] || (Ie[4] = (Ze) => G.value = !G.value)
                      }, [...Ie[31] || (Ie[31] = [
                        i("span", { class: "fe-share__knob" }, null, -1)
                      ])], 8, wne)
                    ]),
                    i("label", xne, [
                      i("span", $ne, f(r(v)("access.ui.expiry")), 1),
                      dt(i("select", {
                        "onUpdate:modelValue": Ie[5] || (Ie[5] = (Ze) => we.value = Ze),
                        class: "fe-share__select",
                        "data-testid": "share-expiry"
                      }, [
                        (u(!0), d(he, null, We(Ce.value, (Ze) => (u(), d("option", {
                          key: Ze.v,
                          value: Ze.v
                        }, f(Ze.l), 9, Sne))), 128))
                      ], 512), [
                        [
                          Xa,
                          we.value,
                          void 0,
                          { number: !0 }
                        ]
                      ])
                    ]),
                    i("label", Tne, [
                      i("span", Cne, f(r(v)("access.ui.download_limit")), 1),
                      dt(i("select", {
                        "onUpdate:modelValue": Ie[6] || (Ie[6] = (Ze) => J.value = Ze),
                        class: "fe-share__select"
                      }, [
                        (u(!0), d(he, null, We(me.value, (Ze) => (u(), d("option", {
                          key: Ze.v,
                          value: Ze.v
                        }, f(Ze.l), 9, Ene))), 128))
                      ], 512), [
                        [
                          Xa,
                          J.value,
                          void 0,
                          { number: !0 }
                        ]
                      ])
                    ])
                  ]),
                  He.value ? (u(), d("p", Ane, f(He.value), 1)) : T("", !0),
                  i("button", {
                    type: "button",
                    class: "fx-perm-create fe-share__btn fe-share__btn--primary fe-share__btn--wide",
                    "data-testid": "share-create",
                    disabled: Y.value,
                    onClick: Rt
                  }, f(Dt.value ? r(v)("access.ui.replace_link") : r(v)("access.ui.create_link")), 9, zne),
                  Dt.value ? (u(), d("p", Mne, f(r(v)("access.ui.replace_link_hint")), 1)) : T("", !0),
                  !R.value && q.value ? (u(), d("p", Dne, f(r(v)("access.ui.create_then_send", { email: q.value })), 1)) : T("", !0),
                  R.value ? (u(), d(he, { key: 3 }, [
                    i("div", Pne, [
                      i("span", One, f(r(v)("access.ui.command_line")), 1),
                      i("div", Lne, [
                        i("code", {
                          class: "fe-share__clicmd",
                          title: fe.value
                        }, f(fe.value), 9, Ine),
                        i("button", {
                          type: "button",
                          class: "fe-share__copy",
                          onClick: Ie[7] || (Ie[7] = (Ze) => Je(fe.value, "sharecli"))
                        }, [
                          i("span", {
                            "aria-hidden": "true",
                            innerHTML: r(wt)("copy")
                          }, null, 8, Rne),
                          i("span", null, f(Q.value === "sharecli" ? r(v)("access.copied") : r(v)("access.copy")), 1)
                        ])
                      ])
                    ]),
                    p.value ? (u(), d("div", Nne, [
                      dt(i("input", {
                        "onUpdate:modelValue": Ie[8] || (Ie[8] = (Ze) => q.value = Ze),
                        type: "text",
                        class: "fe-share__input",
                        autocomplete: "off",
                        disabled: o.value,
                        placeholder: r(v)("access.ui.emails_comma_separated"),
                        onKeyup: ya(ha, ["enter"])
                      }, null, 40, Bne), [
                        [St, q.value]
                      ]),
                      i("button", {
                        type: "button",
                        class: "fe-share__btn",
                        disabled: re.value || o.value,
                        onClick: ha
                      }, f(r(v)("access.ui.send")), 9, Fne)
                    ])) : T("", !0),
                    p.value && o.value ? (u(), d("div", Une, f(r(v)("access.ui.mail_not_set_up")), 1)) : T("", !0),
                    ae.value ? (u(), d("div", Hne, f(ae.value), 1)) : T("", !0),
                    at.value ? (u(), d("button", {
                      key: 3,
                      type: "button",
                      class: "fe-share__btn fe-share__btn--wide",
                      onClick: Ie[9] || (Ie[9] = (Ze) => vt(ue()))
                    }, [
                      i("span", {
                        "aria-hidden": "true",
                        innerHTML: r(wt)("access")
                      }, null, 8, Kne),
                      i("span", null, f(r(v)("access.ui.share")), 1)
                    ])) : T("", !0)
                  ], 64)) : T("", !0),
                  aa.value.length ? (u(), d("div", Vne, [
                    i("h4", qne, f(r(v)("access.ui.other_links")), 1),
                    (u(!0), d(he, null, We(aa.value, (Ze) => (u(), d("div", {
                      key: Ze.uuid,
                      class: "fe-share__row"
                    }, [
                      i("span", {
                        class: "fe-share__url",
                        title: Ze.url
                      }, f(Ze.url), 9, jne),
                      i("button", {
                        type: "button",
                        class: "fe-share__copy",
                        onClick: (ct) => Je(Ze.url, Ze.uuid)
                      }, [
                        i("span", {
                          "aria-hidden": "true",
                          innerHTML: r(wt)("copy")
                        }, null, 8, Yne),
                        i("span", null, f(Q.value === Ze.uuid ? r(v)("access.copied") : r(v)("access.copy")), 1)
                      ], 8, Wne),
                      i("button", {
                        type: "button",
                        class: "fe-share__del",
                        disabled: Y.value,
                        title: r(v)("access.ui.revoke"),
                        "aria-label": r(v)("access.ui.revoke"),
                        onClick: (ct) => Ve(Ze)
                      }, [
                        i("span", {
                          "aria-hidden": "true",
                          innerHTML: r(wt)("close")
                        }, null, 8, Xne)
                      ], 8, Gne)
                    ]))), 128))
                  ])) : T("", !0)
                ])) : T("", !0)
              ])) : T("", !0),
              ce.value ? (u(), d("section", Jne, [
                i("button", {
                  type: "button",
                  class: "fe-share__sechead",
                  "aria-expanded": k.value.people ? "true" : "false",
                  "data-testid": "share-people-toggle",
                  onClick: Ie[10] || (Ie[10] = (Ze) => _("people"))
                }, [
                  (u(), d("svg", {
                    class: Re(["fe-share__caret", { "is-open": k.value.people }]),
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "1.8",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "aria-hidden": "true",
                    focusable: "false"
                  }, [...Ie[32] || (Ie[32] = [
                    i("path", { d: "M9 6l6 6-6 6" }, null, -1)
                  ])], 2)),
                  i("span", Qne, f(r(v)("access.section.people")), 1),
                  i("span", ese, f(Ee.value), 1)
                ], 8, Zne),
                k.value.people ? (u(), d("div", tse, [
                  X.value ? (u(), d("div", ase, f(r(v)("access.ui.rbac_off_here")), 1)) : T("", !0),
                  C.value ? (u(), d("div", nse, f(C.value), 1)) : T("", !0),
                  $.value ? (u(), d("p", sse, f(r(v)("access.ui.loading")), 1)) : (u(), d(he, { key: 3 }, [
                    i("div", ose, [
                      i("div", ise, [
                        dt(i("input", {
                          "onUpdate:modelValue": Ie[11] || (Ie[11] = (Ze) => z.value = Ze),
                          type: "email",
                          class: "fe-share__input",
                          autocomplete: "off",
                          disabled: X.value,
                          placeholder: r(v)("access.ui.name_or_email"),
                          onInput: ne,
                          onKeyup: ya(ht, ["enter"]),
                          onFocus: ne
                        }, null, 40, rse), [
                          [St, z.value]
                        ]),
                        j.value ? (u(), d("ul", lse, [
                          (u(!0), d(he, null, We(M.value, (Ze) => (u(), d("li", {
                            key: Ze.id,
                            onMousedown: ft((ct) => et(Ze), ["prevent"])
                          }, [
                            i("span", cse, f(r(md)(Ze, r(kn)(h.value))), 1),
                            i("span", dse, [
                              i("span", fse, f(r(ui)(Ze)), 1),
                              i("span", pse, [
                                i("bdi", null, f(Ze.email), 1),
                                $t(" · " + f(Ze.role), 1)
                              ])
                            ])
                          ], 40, use))), 128))
                        ])) : T("", !0)
                      ]),
                      dt(i("select", {
                        "onUpdate:modelValue": Ie[12] || (Ie[12] = (Ze) => P.value = Ze),
                        class: "fe-share__select",
                        disabled: X.value,
                        title: (De = de.value.find((Ze) => Ze.v === P.value)) == null ? void 0 : De.d
                      }, [
                        (u(!0), d(he, null, We(de.value, (Ze) => (u(), d("option", {
                          key: Ze.v,
                          value: Ze.v
                        }, f(Ze.l), 9, hse))), 128))
                      ], 8, vse), [
                        [Xa, P.value]
                      ]),
                      i("button", {
                        type: "button",
                        class: "fe-share__btn fe-share__btn--primary",
                        disabled: I.value || X.value,
                        onClick: ht
                      }, f(r(v)("access.ui.add")), 9, mse)
                    ]),
                    W.value ? (u(), d("div", yse, [
                      i("p", gse, f(r(v)("access.ui.no_account_for_this_email_what_next")), 1),
                      i("div", bse, [
                        dt(i("select", {
                          "onUpdate:modelValue": Ie[13] || (Ie[13] = (Ze) => N.value = Ze),
                          class: "fe-share__select"
                        }, [
                          i("option", _se, f(r(v)("access.ui.user")), 1),
                          i("option", kse, f(r(v)("access.ui.viewer")), 1)
                        ], 512), [
                          [Xa, N.value]
                        ]),
                        i("button", {
                          type: "button",
                          class: "fe-share__btn fe-share__btn--primary",
                          disabled: I.value,
                          onClick: Tt
                        }, f(r(v)("access.ui.create_user_grant")), 9, wse)
                      ]),
                      n.value.links ? (u(), d("button", {
                        key: 0,
                        type: "button",
                        class: "fe-share__linkbtn",
                        "data-testid": "share-send-link-instead",
                        disabled: I.value,
                        onClick: Ft
                      }, f(r(v)("access.ui.just_send_a_share_link")), 9, xse)) : T("", !0)
                    ])) : T("", !0),
                    F.value ? (u(), d("div", $se, f(F.value), 1)) : T("", !0),
                    (lt = K.value) != null && lt.tempPassword ? (u(), d("div", Sse, [
                      $t(f(r(v)("access.ui.temp_password")) + " ", 1),
                      i("code", Tse, f(K.value.tempPassword), 1)
                    ])) : T("", !0),
                    i("div", Cse, [
                      i("h4", Ese, f(r(v)("access.ui.people_with_access")), 1),
                      !E.value.length && !A.value.length ? (u(), d("p", Ase, f(r(v)("access.ui.not_shared_with_anyone_yet")), 1)) : T("", !0),
                      (u(!0), d(he, null, We(E.value, (Ze) => (u(), d("div", {
                        key: "d" + Ze.id,
                        class: "fe-share__row"
                      }, [
                        i("span", zse, f(Qt(Ze)), 1),
                        i("span", {
                          class: "fe-share__person",
                          title: Ze.user_email
                        }, f(Ct(Ze)), 9, Mse),
                        i("select", {
                          class: "fe-share__select fe-share__select--sm",
                          value: Ze.level,
                          onChange: (ct) => Lt(Ze, ct.target.value)
                        }, [
                          (u(!0), d(he, null, We(de.value, (ct) => (u(), d("option", {
                            key: ct.v,
                            value: ct.v
                          }, f(ct.l), 9, Pse))), 128))
                        ], 40, Dse),
                        i("button", {
                          type: "button",
                          class: "fe-share__del",
                          disabled: I.value,
                          title: r(v)("access.ui.remove"),
                          "aria-label": r(v)("access.ui.remove"),
                          onClick: (ct) => ua(Ze)
                        }, [
                          i("span", {
                            "aria-hidden": "true",
                            innerHTML: r(wt)("close")
                          }, null, 8, Lse)
                        ], 8, Ose)
                      ]))), 128)),
                      (u(!0), d(he, null, We(A.value, (Ze) => (u(), d("div", {
                        key: "i" + Ze.id,
                        class: "fe-share__row fe-share__row--dim"
                      }, [
                        i("span", Ise, f(Qt(Ze)), 1),
                        i("span", {
                          class: "fe-share__person",
                          title: Ze.user_email
                        }, f(Ct(Ze)), 9, Rse),
                        i("span", Nse, f(ke(Ze.level)), 1),
                        i("span", {
                          class: "fe-share__from",
                          title: r(v)("access.ui.inherited_from") + ": " + (Ze.path_prefix || "/")
                        }, f(Ze.path_prefix || "/"), 9, Bse)
                      ]))), 128))
                    ])
                  ], 64))
                ])) : T("", !0)
              ])) : T("", !0),
              e.isDir && n.value.uploadLinks ? (u(), d("section", Fse, [
                i("button", {
                  type: "button",
                  class: "fe-share__sechead",
                  "aria-expanded": k.value.drop ? "true" : "false",
                  "data-testid": "share-drop-toggle",
                  onClick: Ie[14] || (Ie[14] = (Ze) => _("drop"))
                }, [
                  (u(), d("svg", {
                    class: Re(["fe-share__caret", { "is-open": k.value.drop }]),
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "1.8",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "aria-hidden": "true",
                    focusable: "false"
                  }, [...Ie[33] || (Ie[33] = [
                    i("path", { d: "M9 6l6 6-6 6" }, null, -1)
                  ])], 2)),
                  i("span", Hse, f(r(v)("access.section.drop")), 1),
                  i("span", Kse, f(Ge.value), 1)
                ], 8, Use),
                k.value.drop ? (u(), d("div", Vse, [
                  i("p", qse, f(r(v)("access.ui.a_public_link_that_lets_anyone_upload_fi")), 1),
                  i("div", jse, [
                    i("label", Wse, [
                      i("span", Yse, f(r(v)("access.ui.protect_with_a_pin")), 1),
                      i("button", {
                        type: "button",
                        class: "fe-share__switch",
                        role: "switch",
                        "aria-checked": xe.value ? "true" : "false",
                        "data-testid": "drop-pin-switch",
                        onClick: Ie[15] || (Ie[15] = (Ze) => xe.value = !xe.value)
                      }, [...Ie[34] || (Ie[34] = [
                        i("span", { class: "fe-share__knob" }, null, -1)
                      ])], 8, Gse)
                    ]),
                    i("label", Xse, [
                      i("span", Jse, f(r(v)("access.ui.expiry")), 1),
                      dt(i("select", {
                        "onUpdate:modelValue": Ie[16] || (Ie[16] = (Ze) => ye.value = Ze),
                        class: "fe-share__select",
                        "data-testid": "drop-expiry"
                      }, [
                        (u(!0), d(he, null, We(Ce.value, (Ze) => (u(), d("option", {
                          key: Ze.v,
                          value: Ze.v
                        }, f(Ze.l), 9, Zse))), 128))
                      ], 512), [
                        [
                          Xa,
                          ye.value,
                          void 0,
                          { number: !0 }
                        ]
                      ])
                    ])
                  ]),
                  He.value ? (u(), d("p", Qse, f(He.value), 1)) : T("", !0),
                  i("button", {
                    type: "button",
                    class: "fe-share__btn fe-share__btn--primary fe-share__btn--wide",
                    "data-testid": "drop-create",
                    disabled: kt.value,
                    onClick: ia
                  }, f(r(v)("access.ui.create_link")), 9, eoe),
                  i("button", {
                    type: "button",
                    class: "fe-share__linkbtn",
                    "aria-expanded": qe.value ? "true" : "false",
                    onClick: Ie[17] || (Ie[17] = (Ze) => qe.value = !qe.value)
                  }, f(qe.value ? r(v)("access.ui.hide_upload_limits") : r(v)("access.ui.upload_limits")), 9, toe),
                  qe.value ? (u(), d("div", aoe, [
                    i("label", noe, [
                      i("span", soe, f(r(v)("access.ui.max_files")), 1),
                      dt(i("input", {
                        "onUpdate:modelValue": Ie[18] || (Ie[18] = (Ze) => ut.value = Ze),
                        type: "number",
                        min: "1",
                        class: "fe-share__input fe-share__input--sm",
                        placeholder: "20"
                      }, null, 512), [
                        [St, ut.value]
                      ])
                    ]),
                    i("label", ooe, [
                      i("span", ioe, f(r(v)("access.ui.mb_file")), 1),
                      dt(i("input", {
                        "onUpdate:modelValue": Ie[19] || (Ie[19] = (Ze) => Ue.value = Ze),
                        type: "number",
                        min: "1",
                        class: "fe-share__input fe-share__input--sm",
                        placeholder: "500"
                      }, null, 512), [
                        [St, Ue.value]
                      ])
                    ]),
                    i("label", roe, [
                      i("span", loe, f(r(v)("access.ui.allowed_types")), 1),
                      dt(i("input", {
                        "onUpdate:modelValue": Ie[20] || (Ie[20] = (Ze) => Ye.value = Ze),
                        type: "text",
                        class: "fe-share__input fe-share__input--sm",
                        placeholder: r(v)("access.ui.all_e_g_pdf_jpg")
                      }, null, 8, uoe), [
                        [St, Ye.value]
                      ])
                    ]),
                    i("label", coe, [
                      i("span", doe, f(r(v)("access.ui.ask_uploader_name")), 1),
                      i("button", {
                        type: "button",
                        class: "fe-share__switch",
                        role: "switch",
                        "aria-checked": st.value ? "true" : "false",
                        "data-testid": "drop-askname-switch",
                        onClick: Ie[21] || (Ie[21] = (Ze) => st.value = !st.value)
                      }, [...Ie[35] || (Ie[35] = [
                        i("span", { class: "fe-share__knob" }, null, -1)
                      ])], 8, foe)
                    ])
                  ])) : T("", !0),
                  At.value ? (u(), d("div", poe, f(At.value), 1)) : T("", !0),
                  _t.value ? (u(), d(he, { key: 3 }, [
                    i("div", voe, [
                      i("a", {
                        href: _t.value.url,
                        target: "_blank",
                        rel: "noopener",
                        class: "fe-share__url",
                        title: _t.value.url
                      }, f(_t.value.url), 9, hoe),
                      i("button", {
                        type: "button",
                        class: "fe-share__copy",
                        "data-testid": "drop-copy",
                        onClick: Ie[22] || (Ie[22] = (Ze) => Je(_t.value.url, "drop"))
                      }, [
                        i("span", {
                          "aria-hidden": "true",
                          innerHTML: r(wt)("copy")
                        }, null, 8, moe),
                        i("span", null, f(Q.value === "drop" ? r(v)("access.copied") : r(v)("access.copy")), 1)
                      ])
                    ]),
                    i("p", yoe, [
                      $t(f(It(_t.value)) + " ", 1),
                      _t.value.clamped ? (u(), d("span", goe, f(r(v)("access.ui.server_limit_applied")), 1)) : T("", !0)
                    ]),
                    _t.value.pin ? (u(), d("div", boe, [
                      Ie[36] || (Ie[36] = i("span", { class: "fe-share__pinlabel" }, "PIN", -1)),
                      i("code", _oe, f(_t.value.pin), 1),
                      i("button", {
                        type: "button",
                        class: "fe-share__copy",
                        onClick: Ie[23] || (Ie[23] = (Ze) => Je(_t.value.pin, "droppin"))
                      }, [
                        i("span", {
                          "aria-hidden": "true",
                          innerHTML: r(wt)("copy")
                        }, null, 8, koe),
                        i("span", null, f(Q.value === "droppin" ? r(v)("access.copied") : r(v)("access.copy")), 1)
                      ])
                    ])) : T("", !0),
                    p.value ? (u(), d("div", woe, [
                      dt(i("input", {
                        "onUpdate:modelValue": Ie[24] || (Ie[24] = (Ze) => Le.value = Ze),
                        type: "text",
                        class: "fe-share__input",
                        autocomplete: "off",
                        disabled: o.value,
                        placeholder: r(v)("access.ui.emails_comma_separated"),
                        onKeyup: ya(_e, ["enter"])
                      }, null, 40, xoe), [
                        [St, Le.value]
                      ]),
                      i("button", {
                        type: "button",
                        class: "fe-share__btn",
                        disabled: tt.value || o.value,
                        onClick: _e
                      }, f(r(v)("access.ui.send")), 9, $oe)
                    ])) : T("", !0),
                    p.value && o.value ? (u(), d("div", Soe, f(r(v)("access.ui.mail_not_set_up")), 1)) : T("", !0),
                    ve.value ? (u(), d("div", Toe, f(ve.value), 1)) : T("", !0),
                    at.value ? (u(), d("button", {
                      key: 4,
                      type: "button",
                      class: "fe-share__btn fe-share__btn--wide",
                      onClick: Ie[25] || (Ie[25] = (Ze) => vt(je()))
                    }, [
                      i("span", {
                        "aria-hidden": "true",
                        innerHTML: r(wt)("access")
                      }, null, 8, Coe),
                      i("span", null, f(r(v)("access.ui.share")), 1)
                    ])) : T("", !0)
                  ], 64)) : T("", !0),
                  V.value.length ? (u(), d("div", Eoe, [
                    i("h4", Aoe, f(_t.value ? r(v)("access.ui.other_links") : r(v)("access.ui.existing_links")), 1),
                    (u(!0), d(he, null, We(V.value, (Ze) => (u(), d("div", {
                      key: Ze.uuid,
                      class: "fe-share__row"
                    }, [
                      i("span", {
                        class: "fe-share__url",
                        title: Ze.url
                      }, f(Ze.url), 9, zoe),
                      i("button", {
                        type: "button",
                        class: "fe-share__copy",
                        onClick: (ct) => Je(Ze.url, Ze.uuid)
                      }, [
                        i("span", {
                          "aria-hidden": "true",
                          innerHTML: r(wt)("copy")
                        }, null, 8, Doe),
                        i("span", null, f(Q.value === Ze.uuid ? r(v)("access.copied") : r(v)("access.copy")), 1)
                      ], 8, Moe),
                      i("button", {
                        type: "button",
                        class: "fe-share__del",
                        disabled: Y.value,
                        title: r(v)("access.ui.revoke"),
                        "aria-label": r(v)("access.ui.revoke"),
                        onClick: (ct) => Ve(Ze)
                      }, [
                        i("span", {
                          "aria-hidden": "true",
                          innerHTML: r(wt)("close")
                        }, null, 8, Ooe)
                      ], 8, Poe)
                    ]))), 128))
                  ])) : T("", !0)
                ])) : T("", !0)
              ])) : T("", !0)
            ])
          ]),
          i("footer", Loe, [
            i("button", {
              type: "button",
              class: "fe-share__btn fe-share__btn--primary",
              "data-testid": "share-done",
              onClick: Ie[26] || (Ie[26] = (Ze) => s("close"))
            }, f(r(v)("access.done")), 1)
          ])
        ], 8, Vae)
      ]);
    };
  }
});
function c2(e) {
  if (!e) return null;
  if (typeof HTMLElement < "u" && e instanceof HTMLElement) return e;
  const a = e.$el;
  return typeof HTMLElement < "u" && a instanceof HTMLElement ? a : null;
}
function d2(e, a, t = {}) {
  const s = t.dir === "rtl", n = s ? "left" : "right", o = t.gutter ?? 8, p = Math.round(e.bottom + (t.gap ?? 6)), h = Math.round(s ? e.left ?? 0 : a.width - e.right), v = Math.max(200, a.height - p - o), y = `${t.maxHeight ? Math.min(t.maxHeight, v) : v}px`;
  if (!t.width) return { top: `${p}px`, [n]: `${h}px`, maxHeight: y };
  const g = Math.max(0, Math.min(t.width, a.width - o * 2)), m = Math.min(Math.max(h, o), a.width - g - o);
  return { top: `${p}px`, [n]: `${Math.round(m)}px`, width: `${Math.round(g)}px`, maxHeight: y };
}
const Roe = {
  // writehook: meta.node.{name,path,size}, meta.origin
  "file.uploaded": {
    en: { title: "New file: {name}", body: "{path}" },
    tr: { title: "Yeni dosya: {name}", body: "{path}" }
  },
  "file.updated": {
    en: { title: "File changed: {name}", body: "{path}" },
    tr: { title: "Dosya değişti: {name}", body: "{path}" }
  },
  // meta.reason is the driver's error text — the only thing that says WHY.
  "file.upload_failed": {
    en: { title: "Upload failed: {name}", body: "{reason}" },
    tr: { title: "Yükleme başarısız: {name}", body: "{reason}" }
  },
  // meta.signature is the ClamAV signature name; the path is the ORIGINAL one.
  "file.infected": {
    en: { title: "Virus found in {name}", body: "{signature} — {path}" },
    tr: { title: "{name} dosyasında virüs bulundu", body: "{signature} — {path}" }
  },
  "file.deleted": {
    en: { title: "File deleted: {name}", body: "{path}" },
    tr: { title: "Dosya silindi: {name}", body: "{path}" }
  },
  "file.trashed": {
    en: { title: "Moved to trash: {name}", body: "{path}" },
    tr: { title: "Çöp kutusuna taşındı: {name}", body: "{path}" }
  },
  // meta.from / meta.to are both set by OnFileMoved — the one event where the
  // body can show the actual change rather than repeat the title.
  "file.moved": {
    en: { title: "Moved: {name}", body: "{from} → {to}" },
    tr: { title: "Taşındı: {name}", body: "{from} → {to}" }
  },
  // archive handlers: meta.node for create; meta.{path,count} for extract
  "archive.created": {
    en: { title: "Archive created: {name}", body: "{path}" },
    tr: { title: "Arşiv oluşturuldu: {name}", body: "{path}" }
  },
  "archive.extracted": {
    en: {
      title: "Extraction completed",
      body: "{count} files extracted to {path}",
      one: { body: "{count} file extracted to {path}" }
    },
    tr: { title: "Arşiv çıkarma tamamlandı", body: "{count} dosya {path} konumuna çıkarıldı" }
  },
  // ⚠ node is OPTIONAL here (share.go sets it only when the row resolved), so
  // the title must stand on its own with an empty body.
  "share.created": {
    en: { title: "Share link created", body: "{path}" },
    tr: { title: "Paylaşım bağlantısı oluşturuldu", body: "{path}" }
  },
  // meta.{folder,count,uploader}; uploader is "" when the visitor typed no name.
  "drop.received": {
    en: {
      title: "{count} files received",
      body: "{uploader} → {folder}",
      one: { title: "{count} file received" }
    },
    tr: { title: "{count} dosya geldi", body: "{uploader} → {folder}" }
  },
  // meta.body is the comment, truncated to 200 chars by the emitter.
  "comment.added": {
    en: { title: "New comment on {name}", body: "{body}" },
    tr: { title: "{name} için yeni yorum", body: "{body}" }
  },
  // ⚠⚠ The ESCROW key, never "the recovery key". They are two different keys
  // with opposite meanings for the person reading this: a recovery key is the
  // one the OWNER was handed when the folder was made, and escrow is the
  // OPERATOR's key being used on their folder. This read "recovery" for a
  // release, in both languages, while the server's own title said escrow —
  // telling someone the reverse of what happened to their data. The words are
  // the explorer's own (`e2e.recover.tab_escrow`: "Escrow key" / "Emanet
  // anahtarı"); web/tests/lib/notificationText.test.ts holds them together.
  "e2e.escrow_used": {
    en: {
      title: "Encrypted folder opened with the escrow key",
      body: "{folder}",
      file: { title: "Encrypted file opened with the escrow key", body: "{file}" }
    },
    tr: {
      title: "Şifreli klasör emanet anahtarıyla açıldı",
      body: "{folder}",
      file: { title: "Şifreli dosya emanet anahtarıyla açıldı", body: "{file}" }
    }
  },
  // A folder password changed in the browser (meta.via says whether with the
  // current password or the recovery key). One title for both: the body names
  // the folder, and the row's severity already marks a reset as a warning.
  "e2e.password_changed": {
    en: {
      title: "Encrypted folder password changed",
      body: "{folder}",
      file: { title: "Encrypted file password changed", body: "{file}" }
    },
    tr: {
      title: "Şifreli klasörün parolası değişti",
      body: "{folder}",
      file: { title: "Şifreli dosyanın parolası değişti", body: "{file}" }
    }
  },
  // An installed app speaking through notify_send. The plugin phrased the
  // text itself, per language: meta.title_en/title_tr + body_en/body_tr
  // (the row's own title is the English one). `{plugin}` is the app's LABEL
  // in the reader's language (meta.plugin_label_en/_tr), not its install id.
  "plugin.notice": {
    en: { title: "{notice_title}", body: "{plugin}: {notice_body}" },
    tr: { title: "{notice_title}", body: "{plugin}: {notice_body}" }
  },
  // ── Operational alarms ──────────────────────────────────────────────────
  // Not in the subscribable catalogue, and the server writes their title in
  // English (`filex 0.42.0 available`), so a Turkish panel showed English
  // until they were phrased here too. Each placeholder is a Meta field of the
  // one emit site named beside it.
  //
  // server.go OnNewRelease: meta.{version,current}
  update_available: {
    en: { title: "filex {version} is available", body: "This server runs {current}." },
    tr: { title: "filex {version} yayınlandı", body: "Bu sunucu {current} sürümünde çalışıyor." }
  },
  // wasmplugin/updates.go announce + versions.go afterUpgrade: meta.{
  // plugin_label_<lang>, version, from, added}. `{plugin}` is the app's label
  // in the reader's language, as for plugin.notice. ⚠ Since 0.48 nothing
  // updates itself: `app_updated` is an administrator's approved change (an
  // upgrade, or going back).
  app_updated: {
    en: { title: "{plugin} is now {version}", body: "An administrator approved it; it was {from}." },
    tr: { title: "{plugin} artık {version} sürümünde", body: "Bir yönetici onayladı; önceki sürüm {from}." }
  },
  app_update_available: {
    en: { title: "{plugin} {version} is available", body: "It waits for you under Apps." },
    tr: { title: "{plugin} {version} yayında", body: "Uygulamalar altında sizi bekliyor." }
  },
  app_update_needs_approval: {
    en: { title: "{plugin} {version} needs your approval", body: "{added}" },
    tr: { title: "{plugin} {version} onayınızı bekliyor", body: "{added}" }
  },
  app_update_failed: {
    en: { title: "{plugin} {version} could not be installed", body: "The version it had, {from}, keeps running." },
    tr: { title: "{plugin} {version} kurulamadı", body: "Önceki sürüm {from} çalışmaya devam ediyor." }
  },
  // plugin/updates.go checkOne (server.go Announce): meta.{plugin, version}.
  // A storage plugin's name is its own (no label table).
  plugin_update_available: {
    en: { title: "Storage plugin {plugin} {version} is available", body: "It waits for you under Plugins → Storage." },
    tr: { title: "{plugin} depo eklentisinin {version} sürümü yayında", body: "Eklentiler → Depolama altında sizi bekliyor." }
  },
  // pluginreq/service.go announce: meta.{plugin_label_<lang>, version,
  // requester, reason, kind, op}. An API key asked for a plugin; it waits on
  // the Plugins page. One phrasing for an install and an upgrade.
  plugin_requested: {
    en: { title: "Plugin request: {plugin} {version}", body: "{requester}: {reason}" },
    tr: { title: "Eklenti isteği: {plugin} {version}", body: "{requester}: {reason}" }
  },
  // replica/recorder.go NotifyReplicaFail: meta.{path,op,error}
  replica_fail: {
    en: { title: "Replica {op} failed: {name}", body: "{error}" },
    tr: { title: "Kopyada {op} başarısız: {name}", body: "{error}" }
  },
  // replica/recorder.go NotifyPrimaryReadFail: meta.{path,primary_error}
  primary_read_fail: {
    en: { title: "{name} was served from the replica", body: "The primary storage failed: {error}" },
    tr: { title: "{name} kopyadan sunuldu", body: "Birincil depo hata verdi: {error}" }
  },
  // replica/reconcile.go: meta.queued
  replica_reconcile_done: {
    en: {
      title: "{count} replica retries queued",
      body: "Progress is on the queue page.",
      one: { title: "{count} replica retry queued" }
    },
    tr: { title: "{count} kopya yeniden denemesi kuyruğa alındı", body: "İlerleme kuyruk sayfasında." }
  },
  // replica/reconcile.go cron report: meta.{failed_count,repaired_count}
  replica_status_report: {
    en: { title: "Replica report: {failed} unresolved, {repaired} repaired", body: "Last 24 hours" },
    tr: { title: "Kopya raporu: {failed} çözülmemiş, {repaired} onarıldı", body: "Son 24 saat" }
  }
}, Noe = {
  en: {
    someone: "Someone",
    unnamed: "a file",
    appNotice: "App notification",
    openWith: "Opened with the filex desktop app",
    locked: "🔒 Encrypted item"
  },
  tr: {
    someone: "Birisi",
    unnamed: "bir dosya",
    appNotice: "Uygulama bildirimi",
    openWith: "filex masaüstü uygulamasıyla açıldı",
    locked: "🔒 Şifreli öğe"
  }
}, X_ = /^(?:[A-Za-z0-9_-]{23,}|[A-Za-z0-9_-]{43}\.fxl)(?:\.[A-Za-z0-9_-]{22})?$/;
function Boe(e, a, t) {
  const s = e.indexOf("://"), n = s >= 0 ? e.slice(0, s) : "", o = (s >= 0 ? e.slice(s + 3) : e).replace(/^\/+|\/+$/g, ""), p = (m) => {
    const k = m.replace(/^\/+|\/+$/g, "");
    return !o || k === o || !k.startsWith(`${o}/`) ? null : k.slice(o.length + 1).split("/");
  }, h = (m) => !!m && m.some((k) => X_.test(k)), v = (m) => m.startsWith("/") ? "/" : "", y = (m) => t ? t(`${n}://${m.replace(/^\/+/, "")}`, e) : null, g = (m) => {
    const k = p(m);
    if (!h(k)) return m;
    const _ = y(m);
    return _ ? v(m) + _.path : `${v(m)}${o}/${k.length > 1 ? "…/" : ""}${a}`;
  };
  return {
    path: g,
    item(m, k) {
      const _ = p(m);
      if (!h(_)) return { path: m, name: k };
      const w = y(m);
      return w ? { path: v(m) + w.path, name: w.name } : { path: g(m), name: X_.test(_[_.length - 1]) ? a : k };
    }
  };
}
function Ul(e) {
  return e && typeof e == "object" && !Array.isArray(e) ? e : {};
}
function sa(e) {
  return typeof e == "string" ? e : "";
}
function tv(e) {
  const a = e.replace(/[\\/]+$/, ""), t = Math.max(a.lastIndexOf("/"), a.lastIndexOf("\\"));
  return t >= 0 ? a.slice(t + 1) : a;
}
function Foe(e, a, t, s, n) {
  const o = Ul(e.meta), p = Ul(o.node), h = e.target ?? Ul(o.target), v = Uoe(Noe[a], t);
  let y = o.open_with === !0 ? v.openWith : sa(p.path) || sa(o.path) || sa(h == null ? void 0 : h.path) || sa(e.body), g = sa(p.name) || tv(y) || v.unnamed, m = sa(o.from), k = sa(o.to);
  const _ = sa(o.e2e_root);
  if (_) {
    const E = Boe(_, v.locked, n);
    ({ path: y, name: g } = E.item(y, g)), m = E.path(m), k = E.path(k);
  }
  const w = sa(o.uploader).trim() || v.someone, $ = (E) => typeof E == "number" ? String(E) : "", C = $(o.count) || $(o.queued);
  return {
    name: g,
    path: y,
    count: C,
    uploader: w,
    folder: sa(o.folder) || tv(y) || y,
    // A single encrypted file's own events (meta.kind === 'file').
    file: sa(o.file) || tv(y) || y,
    storage: sa(o.storage) || sa(h == null ? void 0 : h.storage),
    reason: sa(o.reason) || sa(e.body),
    signature: sa(o.signature),
    from: m,
    to: k || y,
    // The comment excerpt. Collapsed to one line: a bell row and an OS toast
    // both clip, and a newline inside a toast body renders as a gap.
    body: sa(o.body).replace(/\s+/g, " ").trim(),
    actor: sa(Ul(o.actor).email),
    version: sa(o.version),
    current: sa(o.current),
    // app_update_needs_approval: the permissions the new version adds.
    added: sa(o.added),
    // plugin_requested: who asked (named as the account was when it asked).
    requester: sa(o.requester) || v.someone,
    op: sa(o.op),
    error: sa(o.error) || sa(o.primary_error),
    failed: $(o.failed_count),
    repaired: $(o.repaired_count),
    // plugin.notice: the app's own wording in the reader's language, falling
    // back to the English the server stored in the row itself.
    //
    // ⚠ `plugin` is the app's LABEL in the reader's language, never
    // `meta.plugin` — that is the install id, and it was printed: "sign:
    // “sözleşme.pdf” imzanızı bekliyor…" in a bell whose side panel calls the
    // app "İmzalar" (release-candidate sweep, 2026-09-21). A row from before
    // the server sent labels has none, and then the prefix is left out
    // (fillTemplate drops the dangling ':') rather than showing the id.
    plugin: av(o, "plugin_label_", s, a),
    notice_title: av(o, "title_", s, a) || (sa(e.title) !== e.event ? sa(e.title) : "") || v.appNotice,
    notice_body: av(o, "body_", s, a) || sa(e.body)
  };
}
function av(e, a, t, s) {
  const n = [], o = (t ?? "").trim().toLowerCase();
  if (o) {
    n.push(o);
    const p = o.indexOf("-");
    p > 0 && n.push(o.slice(0, p));
  }
  n.push(s, "en");
  for (const p of n) {
    const h = sa(e[a + p]);
    if (h) return h;
  }
  return "";
}
function J_(e, a) {
  return e.replace(/\{(\w+)\}/g, (s, n) => a[n] ?? "").replace(/\s*(—|→|:)\s*$/g, "").replace(/^\s*(—|→|:)\s*/g, "").replace(/\s{2,}/g, " ").trim();
}
const bm = "server.notify.";
function Cd(e, a) {
  const t = e == null ? void 0 : e[a];
  return typeof t == "string" && t.trim() ? t : void 0;
}
function Uoe(e, a) {
  if (!a) return e;
  const t = { ...e };
  for (const s of Object.keys(e)) {
    const n = Cd(a, `${bm}word.${s}`);
    n && (t[s] = n);
  }
  return t;
}
function Hoe(e, a) {
  if (a === "") return "other";
  try {
    return new Intl.PluralRules(e || "en").select(Number(a));
  } catch {
    return a === "1" ? "one" : "other";
  }
}
function Z_(e, a, t) {
  return Cd(e.strings, `${bm}${a}.${t}_file`);
}
function Q_(e, a, t, s) {
  if (!e.strings) return;
  const n = `${bm}${a}.${t}`, o = Hoe(e.lang, s);
  return o !== "other" && Cd(e.strings, `${n}_${o}`) || Cd(e.strings, n);
}
function Koe(e, a, t = {}) {
  var k;
  const s = Foe(e, a, t.strings, t.lang, t.e2eName), n = (k = Roe[e.event]) == null ? void 0 : k[a], o = sa(Ul(e.meta).kind) === "file" ? n == null ? void 0 : n.file : void 0, p = o ? Z_(t, e.event, "title") : Q_(t, e.event, "title", s.count), h = o ? Z_(t, e.event, "body") : Q_(t, e.event, "body", s.count), v = (_) => typeof t.foreign == "function" ? t.foreign(_) : _, y = (_, w) => ({ title: v(_), body: v(w) });
  if (n || p) {
    const _ = s.count === "1" ? n == null ? void 0 : n.one : void 0, w = J_(p ?? (o == null ? void 0 : o.title) ?? (_ == null ? void 0 : _.title) ?? (n == null ? void 0 : n.title) ?? "", s), $ = J_(h ?? (o == null ? void 0 : o.body) ?? (_ == null ? void 0 : _.body) ?? (n == null ? void 0 : n.body) ?? "", s);
    if (w) return y(w, $);
  }
  const g = sa(e.title).trim(), m = s.path || sa(e.body);
  return t.fallbackLabel && t.fallbackLabel.trim() ? y(t.fallbackLabel.trim(), m) : g && g !== e.event ? y(g, sa(e.body) || m) : y(e.event, m);
}
const Voe = Symbol("filex-notification-event-label");
function qoe(e, a) {
  const t = a ?? (hi() ? On(Voe, void 0) : void 0), s = x(() => {
    wn.value;
    const o = pT(e()), p = {};
    for (const [h, v] of Object.entries(o)) h.startsWith("server.notify.") && (p[h] = v);
    return Object.keys(p).length ? p : void 0;
  });
  function n(o) {
    const p = String(e() || "en");
    return Koe(o, p === "tr" ? "tr" : "en", {
      fallbackLabel: t == null ? void 0 : t(o.event),
      strings: s.value,
      lang: p,
      // ⚠⚠ The reader's direction. A notification is composed out of a
      // phrase and a ROW, never through a catalogue, so no post-translation
      // hook ever sees it — and nearly every body is machine text (a path, a
      // reason, an app's own words). Every surface this composable serves gets
      // it, because they describe one row.
      foreign: (v) => go(p, v),
      // wiring:e2 names — an item inside an encrypted folder is named only
      // where an explorer in this tab has the folder unlocked; otherwise the
      // renderer says "🔒 Encrypted item" (never the ciphertext).
      e2eName: HZ
    });
  }
  return { notificationText: n };
}
const Ed = ".trash";
function ek(e, a) {
  const t = (s) => {
    const n = String(s ?? ""), o = n.indexOf("://");
    return o < 0 ? n : `${n.slice(0, o + 3)}${n.slice(o + 3).replace(/^\/+/, "")}`;
  };
  return t(e) === t(a);
}
function joe(e) {
  let a = String(e ?? "").trim().replace(/\\/g, "/");
  const t = a.indexOf("://");
  return t >= 0 && (a = a.slice(t + 3)), a.replace(/^\/+/, "").replace(/\/+$/, "");
}
function Woe(e) {
  const a = e.lastIndexOf("/");
  return a < 0 ? "" : e.slice(0, a);
}
function f2(e) {
  var n, o, p;
  if (!e || !e.kind || e.kind === "none") return { kind: "none" };
  if (e.kind === "share") {
    const h = String(e.id ?? "").trim();
    return h ? { kind: "share", token: h } : { kind: "none" };
  }
  if (e.kind === "app") {
    const h = String(((n = e.open) == null ? void 0 : n.plugin) ?? "").trim(), v = String(((o = e.open) == null ? void 0 : o.view) ?? "").trim(), y = String(((p = e.open) == null ? void 0 : p.section) ?? "").trim();
    return !h || !v ? { kind: "none" } : { kind: "app", plugin: h, view: v, ...y ? { section: y } : {} };
  }
  const a = String(e.storage ?? "").trim(), t = joe(e.path);
  if (e.kind === "trash")
    return a && t ? { kind: "trash", select: `${a}://${t}` } : { kind: "trash" };
  if (!a) return { kind: "none" };
  const s = Yoe(e);
  return e.kind === "dir" ? { kind: "folder", storage: a, folder: t, ...s ? { open: s } : {} } : e.kind === "file" ? t ? {
    kind: "folder",
    storage: a,
    folder: Woe(t),
    select: `${a}://${t}`,
    ...s ? { open: s } : {}
  } : { kind: "folder", storage: a, folder: "", ...s ? { open: s } : {} } : { kind: "none" };
}
function Yoe(e) {
  const a = e.open;
  if (!a || typeof a != "object") return;
  const t = String(a.plugin ?? "").trim(), s = String(a.action ?? "").trim(), n = String(a.view ?? "").trim();
  if (!(!t || !s && !n))
    return { plugin: t, ...s ? { action: s } : {}, ...n ? { view: n } : {} };
}
function Goe(e) {
  return f2(e).kind !== "none";
}
function nh(e) {
  return e.kind === "trash" ? Ed : e.kind !== "folder" ? "" : e.folder ? `${e.storage}/${e.folder}` : e.storage;
}
function Xoe(e) {
  return e.kind === "trash" ? Ed : e.kind !== "folder" ? "" : `${e.storage}://${e.folder}`;
}
function qhe(e) {
  const a = String(e ?? "").replace(/^#/, "").replace(/^\/+/, "");
  if (!a) return "";
  let t = a;
  try {
    t = decodeURI(a);
  } catch {
  }
  const s = t.indexOf("/");
  return s < 0 ? `${t}://` : `${t.slice(0, s)}://${t.slice(s + 1)}`;
}
function jhe(e) {
  if (e.kind === "app")
    return {
      name: "app-home",
      params: { plugin: e.plugin, view: e.view },
      query: e.section ? { section: e.section } : {},
      hash: ""
    };
  if (e.kind === "folder") {
    const a = e.select ? { select: e.select } : {};
    return e.open && (a.app = e.open.plugin, e.open.action ? a.appAction = e.open.action : e.open.view && (a.appView = e.open.view)), {
      name: "explore",
      query: a,
      // vue-router wants the '#'; the explorer encodes segment-by-segment, so
      // we hand over the readable form and let the browser escape it.
      hash: `#${nh(e)}`
    };
  }
  return e.kind === "trash" ? {
    name: "explore",
    query: e.select ? { select: e.select } : {},
    hash: `#${nh(e)}`
  } : null;
}
function p2(e, a = "") {
  return `${a.replace(/\/+$/, "")}/s/${encodeURIComponent(e)}`;
}
function Whe(e, a = "/", t = "") {
  if (e.kind === "share") return p2(e.token, t);
  const s = `${String(a || "/").replace(/\/+$/, "")}/`;
  if (e.kind === "app") {
    const p = `${s}app/${encodeURIComponent(e.plugin)}/${encodeURIComponent(e.view)}`;
    return e.section ? `${p}?section=${encodeURIComponent(e.section)}` : p;
  }
  if (e.kind !== "folder" && e.kind !== "trash") return "";
  const n = [];
  e.select && n.push(`select=${encodeURIComponent(e.select)}`), e.kind === "folder" && e.open && (n.push(`app=${encodeURIComponent(e.open.plugin)}`), e.open.action ? n.push(`appAction=${encodeURIComponent(e.open.action)}`) : e.open.view && n.push(`appView=${encodeURIComponent(e.open.view)}`));
  const o = nh(e);
  return `${s}explore${n.length ? `?${n.join("&")}` : ""}${o ? `#${o}` : ""}`;
}
const Joe = { class: "fx-nrow__body" }, Zoe = { class: "fx-nrow__meta" }, Qoe = { class: "fx-nrow__when" }, eie = { class: "fx-nrow__title" }, tie = {
  key: 0,
  class: "fx-nrow__body-text"
}, v2 = /* @__PURE__ */ rt({
  __name: "NotificationRow",
  props: {
    item: {},
    locale: {}
  },
  emits: ["open"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n } = gt(() => t.locale), { notificationText: o } = qoe(() => t.locale), p = x(() => o(t.item)), h = x(() => Goe(t.item.target)), v = x(() => !t.item.read_at), y = x(() => vh(t.item.created_at, t.locale, { time: !0 }) || "—");
    function g(k) {
      const _ = `notifications.severity.${k}`, w = n(_);
      return w === _ ? k : w;
    }
    function m(k) {
      return k === "critical" || k === "error" ? "danger" : k === "warning" ? "warning" : "info";
    }
    return (k, _) => (u(), nt(oh(h.value ? "button" : "div"), {
      type: h.value ? "button" : void 0,
      class: Re(["fx-nrow", { "is-unread": v.value, "has-target": h.value, "is-static": !h.value }]),
      title: h.value ? r(n)("notifications.openTarget") : void 0,
      "data-testid": "notification-row",
      "data-clickable": h.value ? "yes" : "no",
      "data-notification-id": e.item.id,
      onClick: _[0] || (_[0] = (w) => h.value ? s("open", e.item) : void 0)
    }, {
      default: yt(() => [
        _[1] || (_[1] = i("span", {
          class: "fx-nrow__dot",
          "aria-hidden": "true"
        }, null, -1)),
        i("span", Joe, [
          i("span", Zoe, [
            i("span", {
              class: Re(["fx-nrow__sev", `is-${m(e.item.severity)}`])
            }, f(g(e.item.severity)), 3),
            i("span", Qoe, f(y.value), 1)
          ]),
          i("span", eie, f(p.value.title), 1),
          p.value.body ? (u(), d("span", tie, f(p.value.body), 1)) : T("", !0)
        ])
      ]),
      _: 1
    }, 8, ["type", "class", "title", "data-clickable", "data-notification-id"]));
  }
}), tk = 99;
function aie(e) {
  const a = Math.floor(Number(e ?? 0));
  return !Number.isFinite(a) || a <= 0 ? "" : a > tk ? `${tk}+` : String(a);
}
function Yhe(e) {
  const a = Math.floor(Number(e ?? 0));
  return Number.isFinite(a) && a > 0 ? a : 0;
}
const nie = {
  key: 0,
  class: "fx-badge",
  "aria-hidden": "true",
  "data-testid": "unread-badge"
}, h2 = /* @__PURE__ */ rt({
  __name: "UnreadBadge",
  props: {
    count: {}
  },
  setup(e) {
    const a = e, t = x(() => aie(a.count));
    return (s, n) => t.value ? (u(), d("span", nie, f(t.value), 1)) : T("", !0);
  }
}), sie = ["innerHTML"], oie = { class: "fx-bell__heading" }, iie = ["innerHTML"], rie = {
  key: 0,
  class: "fx-bell__empty"
}, lie = { class: "fx-bell__foot" }, uie = ["onClick"], cie = ["href", "onClick"], nv = 360, die = /* @__PURE__ */ rt({
  __name: "NotificationBell",
  props: {
    feed: {},
    locale: {},
    manageHref: {}
  },
  emits: ["open", "manage"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n } = gt(() => t.locale), o = x(() => Math.max(0, t.feed.unreadCount || 0)), p = x(
      () => o.value > 0 ? `${n("notifications.bell")} — ${n("notifications.unreadCount", { n: o.value })}` : n("notifications.bell")
    ), h = b(null), v = b({
      top: "0px",
      right: "0px",
      width: `${nv}px`,
      maxHeight: "420px"
    });
    function y() {
      const $ = c2(h.value), C = $ == null ? void 0 : $.getBoundingClientRect();
      if (!C) return;
      const E = d2(
        C,
        { width: window.innerWidth, height: window.innerHeight },
        // The list scrolls inside the panel; 520 keeps ~6 rows on a laptop and
        // the head + foot visible on a phone. ⚠ RTL: flush with the bell's END
        // edge — its left one in a right-to-left header.
        { width: nv, maxHeight: 520, dir: Xo($) }
      );
      v.value = { top: E.top, right: E.right, left: E.left, width: E.width ?? `${nv}px`, maxHeight: E.maxHeight };
    }
    function g() {
      y(), t.feed.refreshFeed();
    }
    async function m($, C) {
      C(), $.read_at || await t.feed.markRead($.id).catch(() => {
      }), s("open", $);
    }
    function k($) {
      $(), t.feed.openPanel();
    }
    function _($) {
      $(), s("manage");
    }
    const w = x(() => t.feed.feed.slice(0, 15));
    return ($, C) => (u(), nt(r(jS), { class: "fx-bell" }, {
      default: yt(({ open: E, close: A }) => [
        ot(r(WS), {
          ref_key: "btnEl",
          ref: h,
          class: Re(["fx-bell__btn", { "is-open": E }]),
          title: p.value,
          "aria-label": p.value,
          "data-testid": "notification-bell",
          onClick: y,
          onKeydown: y
        }, {
          default: yt(() => [
            i("span", {
              class: "fx-bell__icon",
              "aria-hidden": "true",
              innerHTML: r(wt)("bell")
            }, null, 8, sie),
            ot(h2, { count: o.value }, null, 8, ["count"])
          ]),
          _: 1
        }, 8, ["class", "title", "aria-label"]),
        (u(), nt(Hs, { to: "body" }, [
          ot(r(YS), {
            class: "fx-bell__panel",
            style: Vt({ top: v.value.top, right: v.value.right, left: v.value.left, width: v.value.width }),
            "data-testid": "notification-panel"
          }, {
            default: yt(() => [
              i("div", {
                class: "fx-bell__head",
                onVnodeMounted: g
              }, [
                i("span", oie, f(r(n)("notifications.title")), 1),
                e.feed.hasUnread ? (u(), d("button", {
                  key: 0,
                  type: "button",
                  class: "fx-bell__markall",
                  "data-testid": "notification-mark-all",
                  onClick: C[0] || (C[0] = (O) => e.feed.markAllRead())
                }, [
                  i("span", {
                    class: "fx-bell__markall-icon",
                    "aria-hidden": "true",
                    innerHTML: r(wt)("check")
                  }, null, 8, iie),
                  $t(" " + f(r(n)("notifications.markAllRead")), 1)
                ])) : T("", !0)
              ], 512),
              i("ul", {
                class: "fx-bell__list",
                style: Vt({ maxHeight: v.value.maxHeight }),
                "data-testid": "notification-list"
              }, [
                !w.value.length && !e.feed.feedLoading ? (u(), d("li", rie, f(r(n)("notifications.empty")), 1)) : T("", !0),
                (u(!0), d(he, null, We(w.value, (O) => (u(), d("li", {
                  key: O.id
                }, [
                  ot(v2, {
                    item: O,
                    locale: e.locale,
                    onOpen: (z) => m(z, A)
                  }, null, 8, ["item", "locale", "onOpen"])
                ]))), 128))
              ], 4),
              i("div", lie, [
                i("button", {
                  type: "button",
                  class: "fx-bell__all",
                  "data-testid": "notification-view-all",
                  onClick: (O) => k(A)
                }, f(r(n)("notifications.viewAll")), 9, uie),
                e.manageHref ? (u(), d("a", {
                  key: 0,
                  href: e.manageHref,
                  class: "fx-bell__manage",
                  "data-testid": "notification-manage",
                  onClick: ft((O) => _(A), ["prevent"])
                }, f(r(n)("notifications.manageAdmin")), 9, cie)) : T("", !0)
              ])
            ]),
            _: 2
          }, 1032, ["style"])
        ]))
      ]),
      _: 1
    }));
  }
}), fie = ["aria-label"], pie = { class: "fx-nall__sheet" }, vie = { class: "fx-nall__head" }, hie = { class: "fx-nall__title" }, mie = {
  class: "fx-nall__title-icon",
  "aria-hidden": "true"
}, yie = ["innerHTML"], gie = { class: "fx-nall__tools" }, bie = ["aria-pressed"], _ie = ["aria-label"], kie = ["innerHTML"], wie = {
  key: 0,
  class: "fx-nall__error",
  "data-testid": "notifications-screen-error"
}, xie = {
  class: "fx-nall__list",
  "data-testid": "notifications-screen-list"
}, $ie = {
  key: 0,
  class: "fx-nall__empty"
}, Sie = ["title", "aria-label", "onClick"], Tie = ["innerHTML"], Cie = {
  key: 1,
  class: "fx-nall__foot",
  "data-testid": "notifications-screen-pager"
}, Eie = ["disabled"], Aie = { class: "fx-nall__count" }, zie = ["disabled"], Mie = /* @__PURE__ */ rt({
  __name: "NotificationsPanel",
  props: {
    feed: {},
    locale: {}
  },
  emits: ["open"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n } = gt(() => t.locale), o = x(() => Math.floor(t.feed.mineOffset / t.feed.mineLimit) + 1), p = x(() => Math.max(1, Math.ceil(t.feed.mineTotal / t.feed.mineLimit)));
    function h(k) {
      k < 1 || k > p.value || (t.feed.setMinePage(k), t.feed.fetchMine());
    }
    function v() {
      t.feed.setMineUnreadFilter(!t.feed.mineUnreadOnly), t.feed.fetchMine();
    }
    async function y(k) {
      t.feed.closePanel(), k.read_at || await t.feed.markRead(k.id).catch(() => {
      }), s("open", k);
    }
    async function g(k) {
      k.read_at || await t.feed.markRead(k.id).catch(() => {
      });
    }
    function m(k) {
      k.key === "Escape" && t.feed.closePanel();
    }
    return Qe(
      () => t.feed.panelOpen,
      (k) => {
        k ? window.addEventListener("keydown", m) : window.removeEventListener("keydown", m);
      },
      { immediate: !0 }
    ), Mt(() => window.removeEventListener("keydown", m)), (k, _) => (u(), nt(Hs, { to: "body" }, [
      e.feed.panelOpen ? (u(), d("div", {
        key: 0,
        class: "fx-nall",
        role: "dialog",
        "aria-modal": "true",
        "aria-label": r(n)("notifications.title"),
        "data-testid": "notifications-screen"
      }, [
        i("div", {
          class: "fx-nall__scrim",
          onClick: _[0] || (_[0] = ft((w) => e.feed.closePanel(), ["self"]))
        }),
        i("section", pie, [
          i("header", vie, [
            i("span", hie, [
              i("span", mie, [
                i("span", {
                  innerHTML: r(wt)("bell")
                }, null, 8, yie),
                ot(h2, {
                  count: e.feed.unreadCount
                }, null, 8, ["count"])
              ]),
              $t(" " + f(r(n)("notifications.title")), 1)
            ]),
            i("div", gie, [
              i("button", {
                type: "button",
                class: Re(["fx-nall__tool", { "is-on": e.feed.mineUnreadOnly }]),
                "aria-pressed": e.feed.mineUnreadOnly,
                "data-testid": "notifications-screen-unread",
                onClick: v
              }, f(r(n)("notifications.unreadOnly")), 11, bie),
              e.feed.hasUnread ? (u(), d("button", {
                key: 0,
                type: "button",
                class: "fx-nall__tool",
                "data-testid": "notifications-screen-mark-all",
                onClick: _[1] || (_[1] = (w) => e.feed.markAllRead())
              }, f(r(n)("notifications.markAllRead")), 1)) : T("", !0),
              i("button", {
                type: "button",
                class: "fx-nall__close",
                "aria-label": r(n)("modal.close"),
                "data-testid": "notifications-screen-close",
                onClick: _[2] || (_[2] = (w) => e.feed.closePanel())
              }, [
                i("span", {
                  "aria-hidden": "true",
                  innerHTML: r(wt)("close")
                }, null, 8, kie)
              ], 8, _ie)
            ])
          ]),
          e.feed.mineError ? (u(), d("p", wie, f(e.feed.mineError), 1)) : T("", !0),
          i("ul", xie, [
            !e.feed.mine.length && !e.feed.mineLoading ? (u(), d("li", $ie, f(r(n)("notifications.empty")), 1)) : T("", !0),
            (u(!0), d(he, null, We(e.feed.mine, (w) => (u(), d("li", {
              key: w.id,
              class: "fx-nall__item"
            }, [
              ot(v2, {
                item: w,
                locale: e.locale,
                onOpen: y
              }, null, 8, ["item", "locale"]),
              w.read_at ? T("", !0) : (u(), d("button", {
                key: 0,
                type: "button",
                class: "fx-nall__read",
                title: r(n)("notifications.markRead"),
                "aria-label": r(n)("notifications.markRead"),
                "data-testid": "notifications-screen-mark-one",
                onClick: ($) => g(w)
              }, [
                i("span", {
                  "aria-hidden": "true",
                  innerHTML: r(wt)("check")
                }, null, 8, Tie)
              ], 8, Sie))
            ]))), 128))
          ]),
          p.value > 1 ? (u(), d("footer", Cie, [
            i("button", {
              type: "button",
              class: "fx-nall__page",
              disabled: o.value <= 1,
              onClick: _[3] || (_[3] = (w) => h(o.value - 1))
            }, f(r(n)("common.prev")), 9, Eie),
            i("span", Aie, f(r(n)("notifications.pageOf", { page: o.value, pages: p.value, total: e.feed.mineTotal })), 1),
            i("button", {
              type: "button",
              class: "fx-nall__page",
              disabled: o.value >= p.value,
              onClick: _[4] || (_[4] = (w) => h(o.value + 1))
            }, f(r(n)("common.next")), 9, zie)
          ])) : T("", !0)
        ])
      ], 8, fie)) : T("", !0)
    ]));
  }
}), Die = "filex", Pie = "0.0.0";
function Oie(e) {
  const a = String(e ?? "").trim(), t = /^(\S+)\s*\(([^)]*)\)$/.exec(a);
  if (!t) return { release: a, commit: "", built: "" };
  let s = "", n = "";
  for (const o of t[2].split(",").map((p) => p.trim()))
    /^\d{4}-\d{2}-\d{2}/.test(o) ? n = o : o && !s && (s = o);
  return { release: t[1], commit: s, built: n };
}
function Ghe(e) {
  return /^[0-9a-f]{8,}$/i.test(e) ? e.slice(0, 7) : e;
}
function m2(e) {
  const { release: a } = Oie(e);
  return !a || a === Pie ? "" : `${Die} ${a}`;
}
const Lie = {
  key: 0,
  class: "fe-version",
  "data-testid": "product-version"
}, y2 = /* @__PURE__ */ rt({
  __name: "ProductVersion",
  props: {
    version: {}
  },
  setup(e) {
    const a = e, t = x(() => m2(a.version));
    return (s, n) => t.value ? (u(), d("p", Lie, [
      i("bdi", null, f(t.value), 1)
    ])) : T("", !0);
  }
}), Iie = {
  class: "fx-account__face",
  "aria-hidden": "true"
}, Rie = ["src"], Nie = {
  key: 1,
  class: "fx-account__initial"
}, Bie = {
  key: 2,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  focusable: "false"
}, Fie = { class: "fx-acctmenu__who" }, Uie = ["data-testid", "onClick"], Hie = ["innerHTML"], Kie = { class: "fx-acctmenu__label" }, Vie = /* @__PURE__ */ rt({
  __name: "AccountMenu",
  props: {
    actions: {},
    user: {},
    version: {},
    locale: {},
    fallbackLabel: {}
  },
  emits: ["select"],
  setup(e, { emit: a }) {
    const t = e, s = a, n = x(() => ui(t.user ?? null)), o = x(() => {
      var m;
      return (((m = t.user) == null ? void 0 : m.avatar_url) || "").trim();
    }), p = x(() => {
      const m = n.value;
      return m ? [...m][0].toLocaleUpperCase(kn(t.locale)) : "";
    }), h = x(() => n.value || t.fallbackLabel), v = b(null), y = b({ top: "0px", right: "0px" });
    function g() {
      const m = c2(v.value), k = m == null ? void 0 : m.getBoundingClientRect();
      if (!k) return;
      const { top: _, right: w, left: $ } = d2(
        k,
        { width: window.innerWidth, height: window.innerHeight },
        { dir: Xo(m) }
      );
      y.value = { top: _, right: w, left: $ };
    }
    return (m, k) => (u(), nt(r(GS), {
      as: "div",
      class: "fx-account"
    }, {
      default: yt(({ open: _ }) => [
        ot(r(XS), {
          ref_key: "btnEl",
          ref: v,
          class: Re(["fx-account__btn", { "is-open": _ }]),
          title: h.value,
          "aria-label": h.value,
          "data-testid": "explore-account",
          onClick: g,
          onKeydown: g
        }, {
          default: yt(() => [
            i("span", Iie, [
              o.value ? (u(), d("img", {
                key: 0,
                class: "fx-account__img",
                src: o.value,
                alt: ""
              }, null, 8, Rie)) : p.value ? (u(), d("span", Nie, f(p.value), 1)) : (u(), d("svg", Bie, [...k[0] || (k[0] = [
                i("circle", {
                  cx: "12",
                  cy: "8.5",
                  r: "3.5"
                }, null, -1),
                i("path", { d: "M5.5 19.5a6.5 6.5 0 0 1 13 0" }, null, -1)
              ])]))
            ]),
            k[1] || (k[1] = i("svg", {
              class: "fx-account__chev",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "aria-hidden": "true",
              focusable: "false"
            }, [
              i("path", { d: "M7 10l5 5 5-5" })
            ], -1))
          ]),
          _: 1
        }, 8, ["class", "title", "aria-label"]),
        (u(), nt(Hs, { to: "body" }, [
          ot(us, {
            "enter-active-class": "fx-acct-in",
            "leave-active-class": "fx-acct-out"
          }, {
            default: yt(() => [
              ot(r(JS), {
                class: "fx-acctmenu",
                style: Vt({ top: y.value.top, right: y.value.right, left: y.value.left }),
                "data-testid": "explore-account-menu"
              }, {
                default: yt(() => [
                  i("p", Fie, f(h.value), 1),
                  (u(!0), d(he, null, We(e.actions, (w) => (u(), nt(r(ZS), {
                    key: w.key
                  }, {
                    default: yt(({ active: $ }) => [
                      i("button", {
                        type: "button",
                        class: Re(["fx-acctmenu__item", { "is-active": $, "is-separated": w.separated }]),
                        "data-testid": `explore-${w.key}`,
                        onClick: (C) => s("select", w.key)
                      }, [
                        i("span", {
                          class: "fx-acctmenu__icon",
                          "aria-hidden": "true",
                          innerHTML: r(wt)(w.icon || w.key)
                        }, null, 8, Hie),
                        i("span", Kie, f(w.label), 1)
                      ], 10, Uie)
                    ]),
                    _: 2
                  }, 1024))), 128)),
                  r(m2)(e.version) ? (u(), nt(y2, {
                    key: 0,
                    version: e.version,
                    class: "fx-acctmenu__version"
                  }, null, 8, ["version"])) : T("", !0)
                ]),
                _: 1
              }, 8, ["style"])
            ]),
            _: 1
          })
        ]))
      ]),
      _: 1
    }));
  }
}), ak = 3, nk = 32, qie = /* @__PURE__ */ new Set([
  "admin",
  "administrator",
  "root",
  "filex",
  "api",
  "www",
  "ftp",
  "sftp",
  "webdav",
  "dav",
  "s3",
  "nfs",
  "smb",
  "system",
  "support",
  "help",
  "null",
  "undefined",
  "anonymous",
  "guest",
  "nobody"
]);
function sk(e) {
  return e.trim().toLowerCase();
}
function jie(e) {
  return e >= "a" && e <= "z" || e >= "0" && e <= "9" || e === "." || e === "-" || e === "_";
}
function Wie(e, a) {
  const t = sk(e);
  if (a && t === sk(a)) return null;
  if (t === "") return { key: "usernameEmpty" };
  if (t.includes("@")) return { key: "usernameAt" };
  const s = new TextEncoder().encode(t).length;
  if (s < ak) return { key: "usernameShort", params: { min: ak } };
  if (s > nk) return { key: "usernameLong", params: { max: nk } };
  if (t[0] >= "0" && t[0] <= "9") return { key: "usernameDigit" };
  for (const n of t)
    if (!jie(n))
      return n === " " ? { key: "usernameSpace" } : { key: "usernameChar", params: { char: n } };
  return qie.has(t) ? { key: "usernameReserved", params: { name: t } } : null;
}
function Yie(e) {
  const a = e.trim();
  if (a === "") return { key: "emailRequired" };
  if (/[\s<>]/.test(a)) return { key: "emailInvalid" };
  const t = a.lastIndexOf("@");
  return t <= 0 || t === a.length - 1 || a.indexOf("@") !== t ? { key: "emailInvalid" } : null;
}
function Gie(e) {
  var t;
  let a = (t = e == null ? void 0 : e.response) == null ? void 0 : t.data;
  if (!a) {
    const s = e == null ? void 0 : e.detail;
    if (typeof s == "string" && s.trim().startsWith("{"))
      try {
        a = JSON.parse(s);
      } catch {
        a = void 0;
      }
  }
  return !a || typeof a.field != "string" || typeof a.message != "string" ? null : { field: a.field, message: a.message };
}
const Xie = /* @__PURE__ */ new Set(["emailInvalid", "usernameAt"]);
function ok(e) {
  return Xie.has(e) ? `account.problem.${e}` : `account.errors.${e}`;
}
const g2 = "filex.density";
function Xhe(e) {
  if (!(e !== "comfortable" && e !== "compact")) {
    di("density", e);
    try {
      window.dispatchEvent(new CustomEvent("filex:density", { detail: e }));
    } catch {
    }
  }
}
function Jie() {
  try {
    return localStorage.getItem(g2) === "compact" ? "compact" : "comfortable";
  } catch {
    return "comfortable";
  }
}
function Zie(e) {
  try {
    localStorage.setItem(g2, e);
  } catch {
  }
  pi("density", e);
  try {
    window.dispatchEvent(new CustomEvent("filex:density", { detail: e }));
  } catch {
  }
}
async function b2(e, { maxPx: a, maxBytes: t }) {
  const s = await Qie(e), n = Math.min(s.width, s.height), o = Math.min(a, n), p = document.createElement("canvas");
  p.width = o, p.height = o;
  const h = p.getContext("2d");
  if (!h) throw new Error("canvas unavailable");
  h.fillStyle = "#ffffff", h.fillRect(0, 0, o, o), h.drawImage(
    s,
    (s.width - n) / 2,
    (s.height - n) / 2,
    n,
    n,
    0,
    0,
    o,
    o
  );
  for (const v of [0.85, 0.7, 0.55, 0.4]) {
    const y = p.toDataURL("image/jpeg", v);
    if (y.length <= t) return y;
  }
  if (o > 64)
    return b2(e, { maxPx: Math.floor(o / 2), maxBytes: t });
  throw new Error("image too large");
}
async function Qie(e) {
  if (typeof createImageBitmap == "function")
    return createImageBitmap(e);
  const a = URL.createObjectURL(e);
  try {
    return await new Promise((t, s) => {
      const n = new Image();
      n.onload = () => t(n), n.onerror = () => s(new Error("decode failed")), n.src = a;
    });
  } finally {
    URL.revokeObjectURL(a);
  }
}
const ere = [
  "file.uploaded",
  "file.updated",
  "file.upload_failed",
  "file.infected",
  "file.deleted",
  "file.trashed",
  "file.moved",
  "archive.created",
  "archive.extracted",
  "share.created",
  "drop.received",
  "comment.added",
  "e2e.escrow_used",
  "e2e.password_changed",
  "plugin.notice"
];
function _2(e) {
  return e.replace(/\./g, "_");
}
function Jhe(e) {
  return `webhooks.events.${_2(e)}`;
}
function tre(e) {
  return `userSettings.notifications.events.${_2(e)}`;
}
function Zhe(e, a) {
  return k2(e, a) === null;
}
function k2(e, a) {
  var t, s;
  switch (e) {
    case "file.infected":
      return a.antivirus === !0 ? null : "webhooks.offReason.antivirus";
    case "e2e.escrow_used":
      return ((t = a.e2e_escrow) == null ? void 0 : t.enabled) === !0 ? null : "webhooks.offReason.escrow";
    case "plugin.notice":
      return ((s = a.app_plugins) == null ? void 0 : s.enabled) === !0 ? null : "webhooks.offReason.appPlugins";
    default:
      return null;
  }
}
const are = {
  class: "fe fx-us",
  role: "document",
  "data-testid": "user-settings-dialog"
}, nre = { class: "fx-us__head" }, sre = ["src"], ore = {
  key: 1,
  class: "fx-us__head-avatar fx-us__head-avatar--initial",
  "aria-hidden": "true"
}, ire = { class: "fx-us__head-text" }, rre = { class: "fx-us__subtitle" }, lre = ["aria-label"], ure = ["aria-label"], cre = ["aria-current", "data-testid", "onClick"], dre = { class: "fx-us__rail-label" }, fre = {
  key: 0,
  class: "fx-us__rail-soon"
}, pre = { class: "fx-us__main" }, vre = { class: "fx-us__body" }, hre = { class: "fx-us__panehead" }, mre = { class: "fx-us__panetitle" }, yre = { class: "fx-us__subtitle" }, gre = {
  key: 0,
  class: "fx-us__pane",
  "data-testid": "user-settings-profile"
}, bre = { class: "fx-us__identity" }, _re = ["src", "alt"], kre = {
  key: 1,
  class: "fx-us__avatar fx-us__avatar--initial",
  "aria-hidden": "true"
}, wre = { class: "fx-us__identity-text" }, xre = { class: "fx-us__identity-name" }, $re = { class: "fx-us__identity-who" }, Sre = {
  key: 0,
  class: "fx-us__badge"
}, Tre = { class: "fx-us__identity-sub" }, Cre = ["disabled"], Ere = ["disabled"], Are = { class: "fx-us__hint" }, zre = {
  key: 0,
  class: "fx-us__hint fx-us__hint--bad"
}, Mre = { class: "fx-us__grid" }, Dre = { class: "fx-us__field" }, Pre = { class: "fx-us__label" }, Ore = ["disabled"], Lre = { class: "fx-us__field" }, Ire = { class: "fx-us__label" }, Rre = ["aria-invalid", "disabled"], Nre = {
  key: 0,
  class: "fx-us__hint fx-us__hint--bad",
  role: "alert",
  "data-testid": "profile-email-error"
}, Bre = { class: "fx-us__field" }, Fre = { class: "fx-us__label" }, Ure = ["aria-invalid", "disabled"], Hre = {
  key: 0,
  class: "fx-us__hint fx-us__hint--bad",
  role: "alert",
  "data-testid": "profile-username-error"
}, Kre = {
  key: 1,
  class: "fx-us__hint"
}, Vre = {
  key: 1,
  class: "fx-us__note"
}, qre = {
  key: 1,
  class: "fx-us__pane",
  "data-testid": "user-settings-preferences"
}, jre = {
  key: 0,
  class: "fx-us__field"
}, Wre = { class: "fx-us__label" }, Yre = ["aria-label"], Gre = ["aria-pressed", "data-testid", "onClick"], Xre = { class: "fx-us__hint" }, Jre = { class: "fx-us__field" }, Zre = { class: "fx-us__hint" }, Qre = {
  class: "fx-us__readout",
  "data-testid": "user-settings-tz-now"
}, ele = {
  key: 1,
  class: "fx-us__field"
}, tle = { class: "fx-us__label" }, ale = ["aria-label"], nle = ["aria-pressed", "data-testid", "onClick"], sle = { class: "fx-us__hint" }, ole = {
  class: "fx-us__group",
  "data-testid": "user-settings-appearance"
}, ile = { class: "fx-us__group-title" }, rle = { class: "fx-us__field" }, lle = { class: "fx-us__label" }, ule = ["aria-label"], cle = ["aria-pressed", "data-testid", "onClick"], dle = { class: "fx-us__hint" }, fle = { class: "fx-us__field" }, ple = { class: "fx-us__label" }, vle = { class: "fx-us__hint" }, hle = { class: "fx-us__switch-row" }, mle = ["aria-checked"], yle = { class: "fx-us__switch-text" }, gle = { class: "fx-us__label" }, ble = { class: "fx-us__hint" }, _le = {
  class: "fx-us__field",
  "data-testid": "user-settings-folder-view"
}, kle = { class: "fx-us__label" }, wle = { class: "fx-us__hint" }, xle = { class: "fx-us__label fx-us__label--sub" }, $le = ["aria-label"], Sle = ["aria-pressed"], Tle = ["aria-pressed", "data-testid", "onClick"], Cle = { class: "fx-us__label fx-us__label--sub" }, Ele = ["aria-label"], Ale = ["aria-pressed"], zle = ["aria-pressed", "data-testid", "onClick"], Mle = ["aria-label"], Dle = ["aria-pressed", "data-testid", "onClick"], Ple = {
  key: 1,
  class: "fx-us__hint"
}, Ole = {
  key: 2,
  class: "fx-us__hint"
}, Lle = {
  key: 2,
  class: "fx-us__field"
}, Ile = { class: "fx-us__label" }, Rle = ["aria-label"], Nle = ["aria-pressed", "data-testid", "onClick"], Ble = { class: "fx-us__hint" }, Fle = {
  key: 3,
  class: "fx-us__group",
  "data-testid": "user-settings-desktop-app"
}, Ule = { class: "fx-us__group-title" }, Hle = { class: "fx-us__readout" }, Kle = { class: "fx-us__dl-list" }, Vle = ["href"], qle = { class: "fx-us__dl-text" }, jle = { class: "fx-us__label" }, Wle = { class: "fx-us__hint" }, Yle = ["href"], Gle = { class: "fx-us__hint" }, Xle = { class: "fx-us__field" }, Jle = { class: "fx-us__label" }, Zle = {
  class: "fx-us__readout",
  "data-testid": "user-settings-quota"
}, Qle = {
  key: 2,
  class: "fx-us__pane",
  "data-testid": "user-settings-notifications"
}, eue = { class: "fx-us__switch-row" }, tue = ["aria-checked", "disabled"], aue = { class: "fx-us__switch-text" }, nue = { class: "fx-us__label" }, sue = { class: "fx-us__hint" }, oue = {
  key: 0,
  class: "fx-us__switch-row"
}, iue = ["aria-checked", "disabled"], rue = { class: "fx-us__switch-text" }, lue = { class: "fx-us__label" }, uue = { class: "fx-us__hint" }, cue = { class: "fx-us__chips" }, due = {
  key: 0,
  class: "fx-us__chip"
}, fue = {
  key: 0,
  class: "fx-us__chip fx-us__chip--ok"
}, pue = {
  key: 1,
  class: "fx-us__chip fx-us__chip--bad"
}, vue = {
  key: 2,
  class: "fx-us__chip"
}, hue = {
  key: 3,
  class: "fx-us__chip"
}, mue = {
  key: 5,
  class: "fx-us__hint"
}, yue = { class: "fx-us__field" }, gue = { class: "fx-us__label" }, bue = { class: "fx-us__hint" }, _ue = { class: "fx-us__events" }, kue = ["title"], wue = ["aria-checked", "disabled", "data-testid", "onClick"], xue = { class: "fx-us__event-label" }, $ue = ["data-testid"], Sue = {
  key: 3,
  class: "fx-us__pane",
  "data-testid": "user-settings-security"
}, Tue = {
  key: 0,
  class: "fx-us__note"
}, Cue = { class: "fx-us__label" }, Eue = { class: "fx-us__field" }, Aue = { class: "fx-us__label" }, zue = { class: "fx-us__grid" }, Mue = { class: "fx-us__field" }, Due = { class: "fx-us__label" }, Pue = { class: "fx-us__field" }, Oue = { class: "fx-us__label" }, Lue = { class: "fx-us__actions" }, Iue = ["disabled"], Rue = {
  key: 2,
  class: "fx-us__field"
}, Nue = { class: "fx-us__label" }, Bue = {
  key: 0,
  class: "fx-us__switch-row"
}, Fue = ["disabled"], Uue = {
  key: 1,
  class: "fx-us__pane"
}, Hue = { class: "fx-us__hint" }, Kue = ["innerHTML"], Vue = {
  key: 1,
  class: "fx-us__code"
}, que = {
  key: 2,
  class: "fx-us__recovery"
}, jue = { class: "fx-us__label" }, Wue = { class: "fx-us__hint" }, Yue = { class: "fx-us__recovery-list" }, Gue = { class: "fx-us__field" }, Xue = { class: "fx-us__label" }, Jue = { class: "fx-us__actions" }, Zue = ["disabled"], Que = {
  key: 2,
  class: "fx-us__pane"
}, ece = { class: "fx-us__field" }, tce = { class: "fx-us__label" }, ace = { class: "fx-us__actions" }, nce = ["disabled"], sce = {
  key: 4,
  class: "fx-us__pane",
  "data-testid": "user-settings-ai"
}, oce = { class: "fx-us__soon" }, ice = { class: "fx-us__soon-title" }, rce = { class: "fx-us__soon-body" }, lce = { class: "fx-us__foot" }, uce = {
  key: 0,
  class: "fx-us__foot-note"
}, cce = ["disabled"], dce = 48 * 1024, fce = 160, pce = /* @__PURE__ */ rt({
  __name: "UserSettingsDialog",
  props: {
    modelValue: { type: Boolean },
    host: {},
    initialSection: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, s = a, n = x(() => t.host.locale), { t: o, formatSize: p } = gt(() => t.host.locale), h = b(t.initialSection ?? "profile"), v = [
      { key: "profile", icon: eT },
      { key: "preferences", icon: tT },
      { key: "notifications", icon: aT },
      { key: "security", icon: nT },
      { key: "ai", icon: $g, soon: !0 }
    ], y = `fx-us-title-${Math.random().toString(36).slice(2, 9)}`;
    function g() {
      s("update:modelValue", !1);
    }
    const m = b(""), k = b(""), _ = b(""), w = b(""), $ = b(""), C = b(null), E = b(!1), A = b(null);
    Qe([m, k], () => {
      A.value = null;
    });
    const O = x(() => {
      var oe, Oe;
      if (((oe = A.value) == null ? void 0 : oe.field) === "email") return A.value.message;
      if (!m.value.trim() && !(((Oe = t.host.user) == null ? void 0 : Oe.email) ?? "")) return "";
      const V = Yie(m.value);
      return V ? o(ok(V.key), V.params ?? {}) : "";
    }), z = x(() => {
      var oe, Oe;
      if (((oe = A.value) == null ? void 0 : oe.field) === "username") return A.value.message;
      const V = Wie(k.value, ((Oe = t.host.user) == null ? void 0 : Oe.username) ?? "");
      return V ? o(ok(V.key), V.params ?? {}) : "";
    }), P = x(() => !!O.value || !!z.value), I = x(
      () => md(
        { display_name: _.value, username: k.value, email: m.value },
        kn(n.value)
      ) || "?"
    );
    function F() {
      const V = t.host.user;
      V && (m.value = V.email ?? "", k.value = V.username ?? "", _.value = V.display_name ?? "", w.value = V.avatar_url ?? "");
    }
    async function W(V) {
      var Oe;
      const oe = (Oe = V.target.files) == null ? void 0 : Oe[0];
      if (oe) {
        if ($.value = "", !oe.type.startsWith("image/")) {
          $.value = o("profile.avatar.notImage");
          return;
        }
        try {
          w.value = await b2(oe, {
            maxPx: fce,
            maxBytes: dce
          });
        } catch {
          $.value = o("profile.avatar.failed");
        } finally {
          C.value && (C.value.value = "");
        }
      }
    }
    async function N() {
      if (!P.value) {
        E.value = !0;
        try {
          const V = await t.host.api.updateProfile({
            email: m.value.trim(),
            username: k.value.trim().toLowerCase(),
            display_name: _.value.trim(),
            avatar_url: w.value
          });
          t.host.setUser(V), t.host.toast("success", o("profile.saved"));
        } catch (V) {
          const oe = Gie(V);
          oe ? A.value = oe : t.host.toast("error", t.host.errorText(V, o("errors.generic")));
        } finally {
          E.value = !1;
        }
      }
    }
    const K = x(
      () => yo().map((V) => ({ value: V.code, label: V.label || V.code }))
    );
    async function M(V) {
      const oe = t.host.language;
      if (oe && (oe.pick(V), !t.host.demoReadOnly))
        try {
          t.host.setUser(await t.host.api.updateProfile({ locale: V }));
        } catch {
        }
    }
    const j = b("auto"), U = [
      { value: "light", label: "nav.themeLight" },
      { value: "auto", label: "nav.themeAuto" },
      { value: "dark", label: "nav.themeDark" }
    ], de = [
      { value: "double", label: "userSettings.prefs.openTriggerDouble" },
      { value: "single", label: "userSettings.prefs.openTriggerSingle" }
    ], ke = b(!1);
    let ie = null;
    const ce = (V) => ke.value = V.matches, X = x(
      () => j.value === "auto" ? ke.value : j.value === "dark"
    );
    function Z(V) {
      j.value = V, t.host.mode.set(V);
    }
    const { themeId: Y } = P0();
    function G(V) {
      D0(V);
    }
    const we = b(""), R = b(!1), pe = x(() => mu()), Q = `fx-us-tz-${Math.random().toString(36).slice(2, 9)}`, q = { zone: void 0, tier: "device" }, re = x(() => IT().zone ?? pe.value), ae = b("");
    let Pe;
    function be() {
      ae.value = Er(/* @__PURE__ */ new Date(), n.value, {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit"
      });
    }
    async function ze(V) {
      if (we.value = V, t.host.zone.set(V), be(), !t.host.demoReadOnly) {
        R.value = !0;
        try {
          t.host.setUser(await t.host.api.updateProfile({ timezone: V }));
        } catch (oe) {
          t.host.toast("error", t.host.errorText(oe, o("errors.generic")));
        } finally {
          R.value = !1;
        }
      }
    }
    const Ae = b("comfortable"), Ce = ["list", "grid", "gallery"], He = ["name", "type", "modified", "size"], J = x(() => bM()), me = x(() => kM()), fe = x(() => h1()), xe = x(() => me.value.v ?? "list"), ye = x(() => {
      const V = me.value.k ?? "name", oe = me.value.d ?? (V === "modified" ? "desc" : "asc");
      return `${o(`userSettings.prefs.fvSort_${V}`)} ${oe === "asc" ? "↑" : "↓"}`;
    });
    function qe(V) {
      pr({ v: V || void 0 });
    }
    function ut(V) {
      pr({ k: V || void 0, d: V ? V === "modified" ? "desc" : "asc" : void 0 });
    }
    function Ue(V) {
      J.value.k && pr({ d: V });
    }
    function Ye() {
      pr({ c: void 0 });
    }
    function st(V) {
      Ae.value = V ? "compact" : "comfortable", Zie(Ae.value);
    }
    const kt = b("double");
    function At(V) {
      var oe;
      kt.value = V, (oe = t.host.openTrigger) == null || oe.set(V);
    }
    const _t = b(null), Le = x(() => {
      const V = _t.value;
      if (!V) return "";
      const oe = p(V.used_bytes);
      return V.unlimited || !V.quota_bytes ? o("quota.unlimitedTooltip", { used: oe }) : o("quota.tooltip", {
        used: oe,
        limit: p(V.quota_bytes),
        percent: `${Math.round(V.percent_used)}%`
      });
    }), tt = b(null);
    function ve(V) {
      var oe;
      tt.value = V, (oe = t.host.startPage) == null || oe.set(V);
    }
    const H = b("unsupported"), te = b(!0), Te = b(!1), L = b(null), se = x(() => {
      var V;
      return ((V = L.value) == null ? void 0 : V.in_app_enabled) !== !1;
    }), ne = x(() => {
      var V;
      return ((V = L.value) == null ? void 0 : V.muted_events) ?? [];
    }), et = x(() => {
      const V = t.host.capabilities ?? {};
      return ere.map((oe) => {
        const Oe = k2(oe, V), Ne = hd(Oe === null, V.caller_admin === !0, Oe ? o(Oe) : "");
        return { ev: oe, off: Oe, gate: Ne };
      }).filter((oe) => !oe.gate.hidden);
    });
    async function ht(V, oe) {
      Te.value = !0;
      try {
        const Oe = await t.host.api.updateNotificationSettings({ in_app_enabled: V, muted_events: oe });
        L.value = Oe ?? { in_app_enabled: V, muted_events: oe }, t.host.toast("success", o("notifications.prefs.saved"));
      } catch (Oe) {
        t.host.toast("error", t.host.errorText(Oe, o("errors.generic")));
      } finally {
        Te.value = !1;
      }
    }
    function Tt(V) {
      ht(V, ne.value);
    }
    function Ft(V, oe) {
      const Oe = new Set(ne.value);
      oe ? Oe.delete(V) : Oe.add(V), ht(se.value, [...Oe]);
    }
    function Lt(V) {
      var oe;
      te.value = V, (oe = t.host.browserNotifications) == null || oe.setEnabled(V);
    }
    async function ua() {
      const V = t.host.browserNotifications;
      V && (H.value = await V.ask(), H.value === "granted" && Lt(!0));
    }
    const Ct = b(""), Qt = b(""), ta = b(""), Rt = b(!1);
    async function va() {
      if (Qt.value !== ta.value) {
        t.host.toast("warn", o("errors.validationFailed"));
        return;
      }
      Rt.value = !0;
      try {
        await t.host.api.changePassword(Ct.value, Qt.value), Ct.value = "", Qt.value = "", ta.value = "", t.host.toast("success", o("profile.passwordChanged"));
      } catch (V) {
        t.host.toast("error", t.host.errorText(V, o("errors.generic")));
      } finally {
        Rt.value = !1;
      }
    }
    const ha = x(() => {
      var V;
      return ((V = t.host.user) == null ? void 0 : V.totp_enabled) ?? !1;
    }), _a = b("idle"), ia = b(""), _e = b(""), Ve = b([]), Je = b(""), at = b(!1);
    function xt(V) {
      const oe = t.host.user;
      oe && t.host.setUser({ ...oe, totp_enabled: V });
    }
    async function Bt() {
      at.value = !0;
      try {
        const V = await t.host.api.enrollTotp();
        _e.value = V.secret, ia.value = V.qr_svg, Ve.value = V.recovery_codes ?? [], _a.value = "enroll";
      } catch (V) {
        t.host.toast("error", t.host.errorText(V, o("errors.generic")));
      } finally {
        at.value = !1;
      }
    }
    async function Ot() {
      at.value = !0;
      try {
        await t.host.api.verifyTotp(Je.value), xt(!0), Et(), t.host.toast("success", o("userSettings.security.totpEnabled"));
      } catch (V) {
        t.host.toast("error", t.host.errorText(V, o("errors.generic")));
      } finally {
        at.value = !1;
      }
    }
    async function It() {
      at.value = !0;
      try {
        await t.host.api.disableTotp(Je.value), xt(!1), Et(), t.host.toast("success", o("userSettings.security.totpDisabled"));
      } catch (V) {
        t.host.toast("error", t.host.errorText(V, o("errors.generic")));
      } finally {
        at.value = !1;
      }
    }
    function Et() {
      _a.value = "idle", ia.value = "", _e.value = "", Ve.value = [], Je.value = "";
    }
    function Dt(V) {
      var oe, Oe, Ne, Ee;
      if (V) {
        const Ge = t.host;
        F(), j.value = Ge.mode.get(), Ae.value = Jie(), kt.value = ((oe = Ge.openTrigger) == null ? void 0 : oe.get()) ?? "double", we.value = Ge.zone.get(), tt.value = ((Oe = Ge.startPage) == null ? void 0 : Oe.get()) ?? null, be(), H.value = ((Ne = Ge.browserNotifications) == null ? void 0 : Ne.permission()) ?? "unsupported", te.value = ((Ee = Ge.browserNotifications) == null ? void 0 : Ee.enabled()) ?? !1, Et(), Ge.api.notificationSettings().then((ue) => L.value = ue).catch(() => {
        }), Ge.api.quota().then((ue) => _t.value = ue).catch(() => _t.value = null);
      }
    }
    Kt(() => {
      Dt(t.modelValue), be(), Pe = setInterval(be, 1e3);
      try {
        ie = window.matchMedia("(prefers-color-scheme: dark)"), ke.value = ie.matches, ie.addEventListener("change", ce);
      } catch {
      }
    }), Qe(() => t.modelValue, Dt, { flush: "post" }), Mt(() => {
      Pe && clearInterval(Pe), ie == null || ie.removeEventListener("change", ce);
    });
    const aa = x(() => h.value === "profile" && !t.host.demoReadOnly);
    return (V, oe) => (u(), nt(la, {
      open: e.modelValue,
      bare: "",
      labelledby: y,
      locale: e.host.locale,
      onClose: g
    }, {
      default: yt(() => {
        var Oe, Ne;
        return [
          i("div", are, [
            i("header", nre, [
              w.value ? (u(), d("img", {
                key: 0,
                src: w.value,
                alt: "",
                class: "fx-us__head-avatar"
              }, null, 8, sre)) : (u(), d("span", ore, f(I.value), 1)),
              i("div", ire, [
                i("h2", {
                  id: y,
                  class: "fx-us__title"
                }, f(r(o)("userSettings.heading")), 1),
                i("p", rre, f(r(o)("userSettings.headingSub")), 1)
              ]),
              ot(y2, {
                version: (Oe = e.host.capabilities) == null ? void 0 : Oe.version,
                class: "fx-us__version"
              }, null, 8, ["version"]),
              i("button", {
                type: "button",
                class: "fx-us__icon-btn",
                "aria-label": r(o)("common.close"),
                "data-testid": "user-settings-close",
                onClick: g
              }, [
                ot(r(QS), {
                  class: "fx-us__rail-icon",
                  "aria-hidden": "true"
                })
              ], 8, lre)
            ]),
            i("nav", {
              class: "fx-us__rail",
              "aria-label": r(o)("userSettings.title")
            }, [
              (u(), d(he, null, We(v, (Ee) => i("button", {
                key: Ee.key,
                type: "button",
                class: Re(["fx-us__rail-item", { "is-active": h.value === Ee.key }]),
                "aria-current": h.value === Ee.key ? "page" : void 0,
                "data-testid": `user-settings-tab-${Ee.key}`,
                onClick: (Ge) => h.value = Ee.key
              }, [
                (u(), nt(oh(Ee.icon), {
                  class: "fx-us__rail-icon",
                  "aria-hidden": "true"
                })),
                i("span", dre, f(r(o)(`userSettings.tabs.${Ee.key}`)), 1),
                Ee.soon ? (u(), d("span", fre, f(r(o)("userSettings.ai.soon")), 1)) : T("", !0)
              ], 10, cre)), 64))
            ], 8, ure),
            i("div", pre, [
              i("div", vre, [
                i("div", hre, [
                  i("h3", mre, f(r(o)(`userSettings.tabs.${h.value}`)), 1),
                  i("p", yre, f(r(o)(`userSettings.subtitle.${h.value}`)), 1)
                ]),
                h.value === "profile" ? (u(), d("section", gre, [
                  i("div", bre, [
                    w.value ? (u(), d("img", {
                      key: 0,
                      src: w.value,
                      alt: r(o)("profile.avatar.label"),
                      class: "fx-us__avatar"
                    }, null, 8, _re)) : (u(), d("span", kre, f(I.value), 1)),
                    i("div", wre, [
                      i("p", xre, [
                        i("span", $re, f(r(ui)({ display_name: _.value, username: k.value, email: m.value })), 1),
                        e.host.isAdmin ? (u(), d("span", Sre, f(r(o)("userSettings.adminBadge")), 1)) : T("", !0)
                      ]),
                      i("p", Tre, f(m.value), 1)
                    ]),
                    i("button", {
                      type: "button",
                      class: "fx-us__btn fx-us__identity-change",
                      disabled: e.host.demoReadOnly,
                      onClick: oe[0] || (oe[0] = (Ee) => {
                        var Ge;
                        return (Ge = C.value) == null ? void 0 : Ge.click();
                      })
                    }, f(r(o)("profile.avatar.change")), 9, Cre),
                    w.value ? (u(), d("button", {
                      key: 2,
                      type: "button",
                      class: "fx-us__btn fx-us__btn--quiet",
                      disabled: e.host.demoReadOnly,
                      onClick: oe[1] || (oe[1] = (Ee) => w.value = "")
                    }, f(r(o)("common.remove")), 9, Ere)) : T("", !0),
                    i("input", {
                      ref_key: "avatarInput",
                      ref: C,
                      type: "file",
                      accept: "image/*",
                      class: "fx-us__file",
                      onChange: W
                    }, null, 544)
                  ]),
                  i("p", Are, f(r(o)("profile.avatar.help")), 1),
                  $.value ? (u(), d("p", zre, f($.value), 1)) : T("", !0),
                  i("div", Mre, [
                    i("label", Dre, [
                      i("span", Pre, f(r(o)("users.fields.displayName")), 1),
                      dt(i("input", {
                        "onUpdate:modelValue": oe[2] || (oe[2] = (Ee) => _.value = Ee),
                        class: "fx-us__input",
                        disabled: e.host.demoReadOnly
                      }, null, 8, Ore), [
                        [St, _.value]
                      ])
                    ]),
                    i("label", Lre, [
                      i("span", Ire, [
                        $t(f(r(o)("common.email")) + " ", 1),
                        oe[17] || (oe[17] = i("span", {
                          class: "fx-us__required",
                          "aria-hidden": "true"
                        }, "*", -1))
                      ]),
                      dt(i("input", {
                        "onUpdate:modelValue": oe[3] || (oe[3] = (Ee) => m.value = Ee),
                        type: "email",
                        class: Re(["fx-us__input", { "is-invalid": O.value }]),
                        autocomplete: "email",
                        required: "",
                        "aria-invalid": O.value ? "true" : void 0,
                        disabled: e.host.demoReadOnly,
                        "data-testid": "profile-email"
                      }, null, 10, Rre), [
                        [St, m.value]
                      ]),
                      O.value ? (u(), d("span", Nre, f(O.value), 1)) : T("", !0)
                    ])
                  ]),
                  i("label", Bre, [
                    i("span", Fre, [
                      $t(f(r(o)("profile.username.label")) + " ", 1),
                      oe[18] || (oe[18] = i("span", {
                        class: "fx-us__required",
                        "aria-hidden": "true"
                      }, "*", -1))
                    ]),
                    dt(i("input", {
                      "onUpdate:modelValue": oe[4] || (oe[4] = (Ee) => k.value = Ee),
                      class: Re(["fx-us__input", { "is-invalid": z.value }]),
                      autocomplete: "username",
                      required: "",
                      "aria-invalid": z.value ? "true" : void 0,
                      disabled: e.host.demoReadOnly,
                      "data-testid": "profile-username"
                    }, null, 10, Ure), [
                      [St, k.value]
                    ]),
                    z.value ? (u(), d("span", Hre, f(z.value), 1)) : (u(), d("span", Kre, f(r(o)("profile.username.helpText")), 1))
                  ]),
                  e.host.demoReadOnly ? (u(), d("p", Vre, f(r(o)("userSettings.demoReadOnly")), 1)) : T("", !0)
                ])) : h.value === "preferences" ? (u(), d("section", qre, [
                  e.host.language ? (u(), d("div", jre, [
                    i("span", Wre, f(r(o)("profile.locale")), 1),
                    i("div", {
                      class: "fx-us__segmented",
                      role: "group",
                      "aria-label": r(o)("profile.locale"),
                      "data-testid": "user-settings-locale"
                    }, [
                      (u(!0), d(he, null, We(K.value, (Ee) => (u(), d("button", {
                        key: Ee.value,
                        type: "button",
                        class: Re(["fx-us__seg", { "is-active": n.value === Ee.value }]),
                        "aria-pressed": n.value === Ee.value,
                        "data-testid": `user-settings-locale-${Ee.value}`,
                        onClick: (Ge) => M(Ee.value)
                      }, f(Ee.label), 11, Gre))), 128))
                    ], 8, Yre),
                    i("span", Xre, f(r(o)("userSettings.prefs.languageHint")), 1)
                  ])) : T("", !0),
                  i("div", Jre, [
                    i("label", {
                      class: "fx-us__label",
                      for: Q
                    }, f(r(o)("userSettings.prefs.timezone")), 1),
                    ot(I0, {
                      "data-testid": "user-settings-timezone",
                      testid: "user-settings-tz",
                      "input-id": Q,
                      locale: n.value,
                      "model-value": we.value,
                      fallback: q,
                      label: r(o)("userSettings.prefs.timezone"),
                      disabled: R.value,
                      "onUpdate:modelValue": ze
                    }, null, 8, ["locale", "model-value", "label", "disabled"]),
                    i("span", Zre, f(r(o)("userSettings.prefs.timezoneHint")), 1),
                    i("span", Qre, f(r(o)("userSettings.prefs.timezoneNow", { zone: re.value, time: ae.value })), 1)
                  ]),
                  e.host.startPage ? (u(), d("div", ele, [
                    i("span", tle, f(r(o)("userSettings.prefs.startPage")), 1),
                    i("div", {
                      class: "fx-us__segmented",
                      role: "group",
                      "aria-label": r(o)("userSettings.prefs.startPage")
                    }, [
                      (u(!0), d(he, null, We(e.host.startPage.options, (Ee) => (u(), d("button", {
                        key: Ee,
                        type: "button",
                        class: Re(["fx-us__seg", { "is-active": tt.value === Ee }]),
                        "aria-pressed": tt.value === Ee,
                        "data-testid": `user-settings-start-${Ee}`,
                        onClick: (Ge) => ve(Ee)
                      }, f(r(o)(`userSettings.prefs.startPage_${Ee}`)), 11, nle))), 128))
                    ], 8, ale),
                    i("span", sle, f(r(o)("userSettings.prefs.startPageHint")), 1)
                  ])) : T("", !0),
                  i("div", ole, [
                    i("span", ile, f(r(o)("userSettings.prefs.appearance")), 1),
                    i("div", rle, [
                      i("span", lle, f(r(o)("userSettings.prefs.mode")), 1),
                      i("div", {
                        class: "fx-us__segmented",
                        role: "group",
                        "aria-label": r(o)("userSettings.prefs.mode")
                      }, [
                        (u(), d(he, null, We(U, (Ee) => i("button", {
                          key: Ee.value,
                          type: "button",
                          class: Re(["fx-us__seg", { "is-active": j.value === Ee.value }]),
                          "aria-pressed": j.value === Ee.value,
                          "data-testid": `user-settings-theme-${Ee.value}`,
                          onClick: (Ge) => Z(Ee.value)
                        }, f(r(o)(Ee.label)), 11, cle)), 64))
                      ], 8, ule),
                      i("span", dle, f(r(o)("userSettings.prefs.modeHint")), 1)
                    ]),
                    i("div", fle, [
                      i("span", ple, f(r(o)("userSettings.prefs.palette")), 1),
                      ot(L0, {
                        locale: n.value,
                        dark: X.value,
                        current: r(Y),
                        hint: !1,
                        onSelect: G
                      }, null, 8, ["locale", "dark", "current"]),
                      i("span", vle, f(r(o)("userSettings.prefs.paletteHint")), 1)
                    ])
                  ]),
                  i("div", hle, [
                    i("button", {
                      type: "button",
                      role: "switch",
                      class: Re(["fx-us__switch", { "is-on": Ae.value === "compact" }]),
                      "aria-checked": Ae.value === "compact",
                      "data-testid": "user-settings-density",
                      onClick: oe[5] || (oe[5] = (Ee) => st(Ae.value !== "compact"))
                    }, [...oe[19] || (oe[19] = [
                      i("span", { class: "fx-us__switch-knob" }, null, -1)
                    ])], 10, mle),
                    i("div", yle, [
                      i("span", gle, f(r(o)("userSettings.prefs.compact")), 1),
                      i("span", ble, f(r(o)("userSettings.prefs.compactHint")), 1)
                    ])
                  ]),
                  i("div", _le, [
                    i("span", kle, f(r(o)("userSettings.prefs.folderView")), 1),
                    i("span", wle, f(r(o)("userSettings.prefs.folderViewHint")), 1),
                    i("span", xle, f(r(o)("userSettings.prefs.fvMode")), 1),
                    i("div", {
                      class: "fx-us__segmented",
                      role: "group",
                      "aria-label": r(o)("userSettings.prefs.fvMode")
                    }, [
                      i("button", {
                        type: "button",
                        class: Re(["fx-us__seg", { "is-active": !J.value.v }]),
                        "aria-pressed": !J.value.v,
                        "data-testid": "user-settings-fv-view-inherit",
                        onClick: oe[6] || (oe[6] = (Ee) => qe(""))
                      }, f(r(o)("userSettings.prefs.fvInherit", { value: r(o)(`userSettings.prefs.fvView_${xe.value}`) })), 11, Sle),
                      (u(), d(he, null, We(Ce, (Ee) => i("button", {
                        key: Ee,
                        type: "button",
                        class: Re(["fx-us__seg", { "is-active": J.value.v === Ee }]),
                        "aria-pressed": J.value.v === Ee,
                        "data-testid": `user-settings-fv-view-${Ee}`,
                        onClick: (Ge) => qe(Ee)
                      }, f(r(o)(`userSettings.prefs.fvView_${Ee}`)), 11, Tle)), 64))
                    ], 8, $le),
                    i("span", Cle, f(r(o)("userSettings.prefs.fvSort")), 1),
                    i("div", {
                      class: "fx-us__segmented",
                      role: "group",
                      "aria-label": r(o)("userSettings.prefs.fvSort")
                    }, [
                      i("button", {
                        type: "button",
                        class: Re(["fx-us__seg", { "is-active": !J.value.k }]),
                        "aria-pressed": !J.value.k,
                        "data-testid": "user-settings-fv-sort-inherit",
                        onClick: oe[7] || (oe[7] = (Ee) => ut(""))
                      }, f(r(o)("userSettings.prefs.fvInherit", { value: ye.value })), 11, Ale),
                      (u(), d(he, null, We(He, (Ee) => i("button", {
                        key: Ee,
                        type: "button",
                        class: Re(["fx-us__seg", { "is-active": J.value.k === Ee }]),
                        "aria-pressed": J.value.k === Ee,
                        "data-testid": `user-settings-fv-sort-${Ee}`,
                        onClick: (Ge) => ut(Ee)
                      }, f(r(o)(`userSettings.prefs.fvSort_${Ee}`)), 11, zle)), 64))
                    ], 8, Ele),
                    J.value.k ? (u(), d("div", {
                      key: 0,
                      class: "fx-us__segmented",
                      role: "group",
                      "aria-label": r(o)("userSettings.prefs.fvDir")
                    }, [
                      (u(), d(he, null, We(["asc", "desc"], (Ee) => i("button", {
                        key: Ee,
                        type: "button",
                        class: Re(["fx-us__seg", { "is-active": (J.value.d ?? (J.value.k === "modified" ? "desc" : "asc")) === Ee }]),
                        "aria-pressed": (J.value.d ?? (J.value.k === "modified" ? "desc" : "asc")) === Ee,
                        "data-testid": `user-settings-fv-dir-${Ee}`,
                        onClick: (Ge) => Ue(Ee)
                      }, f(r(o)(`userSettings.prefs.fvDir_${Ee}`)), 11, Dle)), 64))
                    ], 8, Mle)) : T("", !0),
                    J.value.c ? (u(), d("span", Ple, [
                      $t(f(r(o)("userSettings.prefs.fvColumns")) + " ", 1),
                      i("button", {
                        type: "button",
                        class: "fx-us__link",
                        "data-testid": "user-settings-fv-columns-reset",
                        onClick: Ye
                      }, f(r(o)("userSettings.prefs.fvColumnsReset")), 1)
                    ])) : T("", !0),
                    fe.value > 0 ? (u(), d("span", Ole, [
                      $t(f(r(o)("userSettings.prefs.fvKeptCount", { count: fe.value })) + " ", 1),
                      i("button", {
                        type: "button",
                        class: "fx-us__link",
                        "data-testid": "user-settings-fv-forget",
                        onClick: oe[8] || (oe[8] = (Ee) => r(yM)())
                      }, f(r(o)("userSettings.prefs.fvForget")), 1)
                    ])) : T("", !0)
                  ]),
                  e.host.openTrigger ? (u(), d("div", Lle, [
                    i("span", Ile, f(r(o)("userSettings.prefs.openTrigger")), 1),
                    i("div", {
                      class: "fx-us__segmented",
                      role: "group",
                      "aria-label": r(o)("userSettings.prefs.openTrigger")
                    }, [
                      (u(), d(he, null, We(de, (Ee) => i("button", {
                        key: Ee.value,
                        type: "button",
                        class: Re(["fx-us__seg", { "is-active": kt.value === Ee.value }]),
                        "aria-pressed": kt.value === Ee.value,
                        "data-testid": `user-settings-opentrigger-${Ee.value}`,
                        onClick: (Ge) => At(Ee.value)
                      }, f(r(o)(Ee.label)), 11, Nle)), 64))
                    ], 8, Rle),
                    i("span", Ble, f(r(o)("userSettings.prefs.openTriggerHint")), 1)
                  ])) : T("", !0),
                  (Ne = e.host.desktopApp) != null && Ne.platform ? (u(), d("div", Fle, [
                    i("span", Ule, f(r(o)("userSettings.prefs.desktopApp")), 1),
                    i("p", Hle, f(r(o)("install.desktopSubtitle", { platform: e.host.desktopApp.platformLabel })), 1),
                    i("div", Kle, [
                      (u(!0), d(he, null, We(e.host.desktopApp.downloads, (Ee) => (u(), d("a", {
                        key: Ee.href,
                        href: Ee.href,
                        class: "fx-us__dl",
                        "data-testid": "user-settings-desktop-download"
                      }, [
                        i("span", qle, [
                          i("span", jle, f(Ee.label), 1),
                          i("span", Wle, f(Ee.hint), 1)
                        ]),
                        oe[20] || (oe[20] = i("span", {
                          "aria-hidden": "true",
                          class: "fx-us__dl-arrow"
                        }, "↓", -1))
                      ], 8, Vle))), 128))
                    ]),
                    i("a", {
                      href: e.host.desktopApp.releasesUrl,
                      target: "_blank",
                      rel: "noopener noreferrer",
                      class: "fx-us__dl-all"
                    }, f(r(o)("install.desktopAllDownloads")), 9, Yle),
                    i("span", Gle, f(r(o)("userSettings.prefs.desktopAppHint")), 1)
                  ])) : T("", !0),
                  i("div", Xle, [
                    i("span", Jle, f(r(o)("quota.title")), 1),
                    i("p", Zle, f(Le.value || r(o)("common.loading")), 1)
                  ])
                ])) : h.value === "notifications" ? (u(), d("section", Qle, [
                  i("div", eue, [
                    i("button", {
                      type: "button",
                      role: "switch",
                      class: Re(["fx-us__switch", { "is-on": se.value }]),
                      "aria-checked": se.value,
                      disabled: Te.value,
                      "data-testid": "user-settings-inapp",
                      onClick: oe[9] || (oe[9] = (Ee) => Tt(!se.value))
                    }, [...oe[21] || (oe[21] = [
                      i("span", { class: "fx-us__switch-knob" }, null, -1)
                    ])], 10, tue),
                    i("div", aue, [
                      i("span", nue, f(r(o)("notifications.prefs.inApp")), 1),
                      i("span", sue, f(r(o)("notifications.prefs.inAppHint")), 1)
                    ])
                  ]),
                  e.host.browserNotifications ? (u(), d("div", oue, [
                    i("button", {
                      type: "button",
                      role: "switch",
                      class: Re(["fx-us__switch", { "is-on": te.value }]),
                      "aria-checked": te.value,
                      disabled: e.host.browserNotifications.desktopShell || H.value === "unsupported",
                      "data-testid": "user-settings-browser",
                      onClick: oe[10] || (oe[10] = (Ee) => Lt(!te.value))
                    }, [...oe[22] || (oe[22] = [
                      i("span", { class: "fx-us__switch-knob" }, null, -1)
                    ])], 10, iue),
                    i("div", rue, [
                      i("span", lue, f(r(o)("notifications.prefs.browser")), 1),
                      i("span", uue, f(r(o)("notifications.prefs.browserHint")), 1),
                      i("div", cue, [
                        e.host.browserNotifications.desktopShell ? (u(), d("span", due, f(r(o)("notifications.prefs.desktopHandled")), 1)) : (u(), d(he, { key: 1 }, [
                          H.value === "granted" ? (u(), d("span", fue, f(r(o)("notifications.prefs.permGranted")), 1)) : H.value === "denied" ? (u(), d("span", pue, f(r(o)("notifications.prefs.permDenied")), 1)) : H.value === "unsupported" ? (u(), d("span", vue, f(r(o)("notifications.prefs.permUnsupported")), 1)) : (u(), d("span", hue, f(r(o)("notifications.prefs.permDefault")), 1)),
                          H.value === "default" ? (u(), d("button", {
                            key: 4,
                            type: "button",
                            class: "fx-us__btn fx-us__btn--sm",
                            "data-testid": "user-settings-browser-ask",
                            onClick: ua
                          }, f(r(o)("notifications.prefs.enableBrowser")), 1)) : T("", !0),
                          H.value === "denied" ? (u(), d("span", mue, f(r(o)("notifications.prefs.permDeniedHint")), 1)) : T("", !0)
                        ], 64))
                      ])
                    ])
                  ])) : T("", !0),
                  i("div", yue, [
                    i("span", gue, f(r(o)("userSettings.notifications.eventsTitle")), 1),
                    i("span", bue, f(r(o)("userSettings.notifications.eventsHint")), 1),
                    i("div", _ue, [
                      (u(!0), d(he, null, We(et.value, (Ee) => (u(), d("div", {
                        key: Ee.ev,
                        class: Re(["fx-us__switch-row", { "is-off": Ee.gate.disabled }]),
                        title: Ee.gate.title
                      }, [
                        i("button", {
                          type: "button",
                          role: "switch",
                          class: Re(["fx-us__switch", { "is-on": !Ee.gate.disabled && !ne.value.includes(Ee.ev) }]),
                          "aria-checked": !Ee.gate.disabled && !ne.value.includes(Ee.ev),
                          disabled: Te.value || Ee.gate.disabled,
                          "data-testid": `user-settings-event-${Ee.ev}`,
                          onClick: (Ge) => Ft(Ee.ev, ne.value.includes(Ee.ev))
                        }, [...oe[23] || (oe[23] = [
                          i("span", { class: "fx-us__switch-knob" }, null, -1)
                        ])], 10, wue),
                        i("span", xue, [
                          $t(f(r(o)(r(tre)(Ee.ev))) + " ", 1),
                          Ee.gate.disabled ? (u(), d("span", {
                            key: 0,
                            class: "fx-us__event-off",
                            "data-testid": `user-settings-event-off-${Ee.ev}`
                          }, f(Ee.gate.title), 9, $ue)) : T("", !0)
                        ])
                      ], 10, kue))), 128))
                    ])
                  ])
                ])) : h.value === "security" ? (u(), d("section", Sue, [
                  e.host.demoReadOnly ? (u(), d("p", Tue, f(r(o)("userSettings.demoReadOnly")), 1)) : (u(), d("form", {
                    key: 1,
                    class: "fx-us__pane",
                    onSubmit: ft(va, ["prevent"])
                  }, [
                    i("span", Cue, f(r(o)("userSettings.security.passwordTitle")), 1),
                    i("label", Eue, [
                      i("span", Aue, f(r(o)("common.currentPassword")), 1),
                      dt(i("input", {
                        "onUpdate:modelValue": oe[11] || (oe[11] = (Ee) => Ct.value = Ee),
                        type: "password",
                        class: "fx-us__input",
                        autocomplete: "current-password",
                        required: ""
                      }, null, 512), [
                        [St, Ct.value]
                      ])
                    ]),
                    i("div", zue, [
                      i("label", Mue, [
                        i("span", Due, f(r(o)("common.newPassword")), 1),
                        dt(i("input", {
                          "onUpdate:modelValue": oe[12] || (oe[12] = (Ee) => Qt.value = Ee),
                          type: "password",
                          class: "fx-us__input",
                          autocomplete: "new-password",
                          required: ""
                        }, null, 512), [
                          [St, Qt.value]
                        ])
                      ]),
                      i("label", Pue, [
                        i("span", Oue, f(r(o)("common.confirm")), 1),
                        dt(i("input", {
                          "onUpdate:modelValue": oe[13] || (oe[13] = (Ee) => ta.value = Ee),
                          type: "password",
                          class: "fx-us__input",
                          autocomplete: "new-password",
                          required: ""
                        }, null, 512), [
                          [St, ta.value]
                        ])
                      ])
                    ]),
                    i("div", Lue, [
                      i("button", {
                        type: "submit",
                        class: "fx-us__btn fx-us__btn--primary",
                        disabled: Rt.value
                      }, f(Rt.value ? r(o)("common.saving") : r(o)("common.save")), 9, Iue)
                    ])
                  ], 32)),
                  e.host.demoReadOnly ? T("", !0) : (u(), d("div", Rue, [
                    i("span", Nue, f(r(o)("profile.totp.title")), 1),
                    _a.value === "idle" ? (u(), d("div", Bue, [
                      i("span", {
                        class: Re(["fx-us__chip", ha.value ? "fx-us__chip--ok" : ""])
                      }, f(ha.value ? r(o)("profile.totp.enabled") : r(o)("profile.totp.disabled")), 3),
                      ha.value ? (u(), d("button", {
                        key: 1,
                        type: "button",
                        class: "fx-us__btn",
                        "data-testid": "user-settings-totp-disable",
                        onClick: oe[14] || (oe[14] = (Ee) => _a.value = "disable")
                      }, f(r(o)("profile.totp.disable")), 1)) : (u(), d("button", {
                        key: 0,
                        type: "button",
                        class: "fx-us__btn",
                        disabled: at.value,
                        "data-testid": "user-settings-totp-enable",
                        onClick: Bt
                      }, f(r(o)("profile.totp.enable")), 9, Fue))
                    ])) : _a.value === "enroll" ? (u(), d("div", Uue, [
                      i("p", Hue, f(r(o)("profile.totp.scanHint")), 1),
                      ia.value ? (u(), d("div", {
                        key: 0,
                        class: "fx-us__qr",
                        "data-testid": "user-settings-totp-qr",
                        innerHTML: ia.value
                      }, null, 8, Kue)) : T("", !0),
                      _e.value ? (u(), d("code", Vue, f(_e.value), 1)) : T("", !0),
                      Ve.value.length ? (u(), d("div", que, [
                        i("p", jue, f(r(o)("profile.totp.recoveryTitle")), 1),
                        i("p", Wue, f(r(o)("profile.totp.recoveryHint")), 1),
                        i("ul", Yue, [
                          (u(!0), d(he, null, We(Ve.value, (Ee) => (u(), d("li", { key: Ee }, f(Ee), 1))), 128))
                        ])
                      ])) : T("", !0),
                      i("label", Gue, [
                        i("span", Xue, f(r(o)("profile.totp.code")), 1),
                        dt(i("input", {
                          "onUpdate:modelValue": oe[15] || (oe[15] = (Ee) => Je.value = Ee),
                          class: "fx-us__input",
                          inputmode: "numeric",
                          autocomplete: "one-time-code"
                        }, null, 512), [
                          [St, Je.value]
                        ])
                      ]),
                      i("div", Jue, [
                        i("button", {
                          type: "button",
                          class: "fx-us__btn fx-us__btn--quiet",
                          onClick: Et
                        }, f(r(o)("common.cancel")), 1),
                        i("button", {
                          type: "button",
                          class: "fx-us__btn fx-us__btn--primary",
                          disabled: at.value,
                          onClick: Ot
                        }, f(r(o)("common.confirm")), 9, Zue)
                      ])
                    ])) : (u(), d("div", Que, [
                      i("label", ece, [
                        i("span", tce, f(r(o)("profile.totp.code")), 1),
                        dt(i("input", {
                          "onUpdate:modelValue": oe[16] || (oe[16] = (Ee) => Je.value = Ee),
                          class: "fx-us__input",
                          inputmode: "numeric",
                          autocomplete: "one-time-code"
                        }, null, 512), [
                          [St, Je.value]
                        ])
                      ]),
                      i("div", ace, [
                        i("button", {
                          type: "button",
                          class: "fx-us__btn fx-us__btn--quiet",
                          onClick: Et
                        }, f(r(o)("common.cancel")), 1),
                        i("button", {
                          type: "button",
                          class: "fx-us__btn fx-us__btn--danger",
                          disabled: at.value,
                          onClick: It
                        }, f(r(o)("common.confirm")), 9, nce)
                      ])
                    ]))
                  ]))
                ])) : (u(), d("section", sce, [
                  i("div", oce, [
                    ot(r($g), {
                      class: "fx-us__soon-icon",
                      "aria-hidden": "true"
                    }),
                    i("p", ice, f(r(o)("userSettings.ai.soon")), 1),
                    i("p", rce, f(r(o)("userSettings.ai.body")), 1)
                  ])
                ]))
              ]),
              i("footer", lce, [
                aa.value ? T("", !0) : (u(), d("span", uce, f(r(o)(`userSettings.footNote.${h.value}`)), 1)),
                i("button", {
                  type: "button",
                  class: "fx-us__btn fx-us__btn--quiet",
                  onClick: g
                }, f(aa.value ? r(o)("common.cancel") : r(o)("common.close")), 1),
                aa.value ? (u(), d("button", {
                  key: 1,
                  type: "button",
                  class: "fx-us__btn fx-us__btn--primary",
                  disabled: E.value || P.value,
                  "data-testid": "user-settings-save-profile",
                  onClick: N
                }, f(E.value ? r(o)("common.saving") : r(o)("userSettings.saveChanges")), 9, cce)) : T("", !0)
              ])
            ])
          ])
        ];
      }),
      _: 1
    }, 8, ["open", "locale"]));
  }
});
function vce(e, a) {
  const t = a.replace(/\/+$/, ""), s = (n, o) => ({
    method: n,
    headers: { "Content-Type": "application/json" },
    ...o === void 0 ? {} : { body: JSON.stringify(o) }
  });
  return {
    updateProfile: (n) => e(`${t}/api/auth/profile`, s("PATCH", n)),
    changePassword: async (n, o) => {
      await e(`${t}/api/auth/password`, s("POST", { current_password: n, new_password: o }));
    },
    enrollTotp: () => e(`${t}/api/auth/totp/enroll`, s("POST")),
    verifyTotp: async (n) => {
      await e(`${t}/api/auth/totp/verify`, s("POST", { code: n }));
    },
    disableTotp: async (n) => {
      await e(`${t}/api/auth/totp/disable`, s("POST", { code: n }));
    },
    quota: () => e(`${t}/api/files/quota/me`),
    notificationSettings: () => e(`${t}/api/notifications/settings`),
    updateNotificationSettings: (n) => e(`${t}/api/notifications/settings`, s("PATCH", n))
  };
}
const hce = 50, mce = 15e3;
function yce(e) {
  const a = e.transport, t = e.errorText ?? ((de) => de instanceof Error ? de.message : String(de)), s = () => {
    var de;
    return ((de = e.alsoStamp) == null ? void 0 : de.call(e)) ?? [];
  }, n = b([]), o = b(!1), p = b([]), h = b(0), v = b(25), y = b(0), g = b(!1), m = b(!1), k = b(null);
  let _ = 0;
  const w = b(!1);
  let $ = null, C = 0;
  const E = b(0), A = x(() => E.value > 0);
  async function O() {
    const de = ++C;
    o.value = !0;
    try {
      const [ke, ie] = await Promise.all([
        a.list({ unread: !1, limit: hce, offset: 0 }),
        a.unreadCount()
      ]);
      return de !== C || (n.value = ke.items ?? [], E.value = ie, $ = ie), !0;
    } catch {
      return !1;
    } finally {
      de === C && (o.value = !1);
    }
  }
  async function z() {
    try {
      E.value = await a.unreadCount();
    } catch {
    }
  }
  async function P() {
    await z(), $ !== E.value && await O();
  }
  async function I(de) {
    const ke = Math.max(0, Math.floor(Number(de) || 0));
    E.value = ke, $ !== ke && await O();
  }
  async function F() {
    const de = ++_;
    m.value = !0, k.value = null;
    try {
      const ke = await a.list({
        unread: g.value,
        limit: v.value,
        offset: y.value
      });
      if (de !== _) return;
      p.value = ke.items ?? [], h.value = ke.total ?? 0;
    } catch (ke) {
      if (de !== _) return;
      k.value = t(ke);
    } finally {
      de === _ && (m.value = !1);
    }
  }
  function W(de) {
    y.value = Math.max(0, (de - 1) * v.value);
  }
  function N(de) {
    g.value = de, y.value = 0;
  }
  function K() {
    w.value = !0, y.value = 0, F();
  }
  function M() {
    w.value = !1;
  }
  async function j(de) {
    var Z;
    await a.markRead(de);
    const ke = (/* @__PURE__ */ new Date()).toISOString(), ie = (Y) => Y.id === de && !Y.read_at ? { ...Y, read_at: ke } : Y, ce = [n, p, ...s()], X = ce.some((Y) => Y.value.some((G) => G.id === de && !G.read_at));
    for (const Y of ce) Y.value = Y.value.map(ie);
    X && E.value > 0 && (E.value -= 1, $ !== null && $ > 0 && ($ -= 1)), (Z = e.onRead) == null || Z.call(e);
  }
  async function U() {
    var ie;
    await a.markAllRead();
    const de = (/* @__PURE__ */ new Date()).toISOString(), ke = (ce) => ({ ...ce, read_at: ce.read_at ?? de });
    for (const ce of [n, p, ...s()]) ce.value = ce.value.map(ke);
    E.value = 0, $ !== null && ($ = 0), (ie = e.onRead) == null || ie.call(e), w.value && g.value && (y.value = 0, F());
  }
  return {
    feed: n,
    feedLoading: o,
    unreadCount: E,
    hasUnread: A,
    mine: p,
    mineTotal: h,
    mineLimit: v,
    mineOffset: y,
    mineUnreadOnly: g,
    mineLoading: m,
    mineError: k,
    panelOpen: w,
    refreshFeed: O,
    fetchUnread: z,
    syncUnread: P,
    acceptCount: I,
    fetchMine: F,
    setMinePage: W,
    setMineUnreadFilter: N,
    openPanel: K,
    closePanel: M,
    markRead: j,
    markAllRead: U
  };
}
function gce(e, a) {
  const t = `${a.replace(/\/+$/, "")}/api/notifications`;
  return {
    async list(s) {
      const n = [];
      return s.unread && n.push("unread=true"), s.limit != null && n.push(`limit=${encodeURIComponent(String(s.limit))}`), s.offset != null && n.push(`offset=${encodeURIComponent(String(s.offset))}`), await e(
        n.length ? `${t}?${n.join("&")}` : t
      ) ?? { items: [], total: 0 };
    },
    async unreadCount() {
      const s = await e(`${t}/unread-count`);
      return Math.max(0, Number((s == null ? void 0 : s.count) ?? 0) || 0);
    },
    async markRead(s) {
      await e(`${t}/${encodeURIComponent(String(s))}/read`, { method: "POST" });
    },
    async markAllRead() {
      await e(`${t}/read-all`, { method: "POST" });
    }
  };
}
const bce = ["view-list", "view-grid", "view-gallery", "inspector", "nav"], sh = "fe:";
function _ce(e, a, t = {}) {
  const s = new Set(t.omit ?? []), n = [...e];
  a.filter((o) => !o.divider && !s.has(o.key)).forEach(
    (o, p) => n.push({
      key: `${sh}${o.key}`,
      label: o.label,
      icon: o.icon || o.key,
      separated: p === 0
    })
  );
  for (const o of t.tail ?? []) n.push({ ...o, separated: o.separated ?? !0 });
  return n;
}
function kce(e) {
  return e.startsWith(sh) ? e.slice(sh.length) : null;
}
const wce = ["dir"], xce = ["title", "aria-label"], $ce = { class: "fe__stack" }, Sce = { class: "fe__panes" }, Tce = {
  key: 0,
  class: "fe-search-cut",
  role: "status"
}, Cce = {
  key: 1,
  class: "fe-coverage",
  role: "status",
  "data-testid": "catalog-coverage"
}, Ece = { class: "fe-coverage__text" }, Ace = ["disabled", "aria-busy"], zce = {
  key: 2,
  class: "fe__presence"
}, Mce = ["title"], Dce = {
  key: 3,
  class: "fe-e2e-upgrade",
  role: "alert"
}, Pce = { class: "fe-e2e-upgrade__text" }, Oce = {
  key: 0,
  class: "fe-e2e-upgrade__escrow"
}, Lce = { class: "fe-e2e-upgrade__actions" }, Ice = ["disabled"], Rce = ["disabled"], Nce = {
  key: 4,
  class: "fe-e2e-upgrade fe-e2e-upgrade--escrow",
  role: "alert"
}, Bce = { class: "fe-e2e-upgrade__text" }, Fce = { class: "fe-e2e-upgrade__escrow" }, Uce = {
  key: 0,
  class: "fe-e2e-upgrade__escrow"
}, Hce = {
  key: 1,
  class: "fe-e2e-upgrade__pw"
}, Kce = ["disabled"], Vce = {
  key: 2,
  class: "fe-form__error",
  role: "alert"
}, qce = { class: "fe-e2e-upgrade__actions" }, jce = ["disabled"], Wce = ["disabled"], Yce = {
  key: 5,
  class: "fe-e2e-upgrade fe-e2e-upgrade--names",
  role: "status",
  "data-testid": "e2e-convert-strip"
}, Gce = { class: "fe-e2e-upgrade__text" }, Xce = { key: 0 }, Jce = {
  key: 1,
  class: "fe-e2e-upgrade__progress",
  "data-testid": "e2e-convert-progress"
}, Zce = {
  key: 2,
  class: "fe-form__error",
  role: "alert"
}, Qce = { class: "fe-e2e-upgrade__actions" }, ede = {
  key: 6,
  class: "fe-e2e-upgrade fe-e2e-upgrade--names",
  role: "status",
  "data-testid": "e2e-names-progress-strip"
}, tde = { class: "fe-e2e-upgrade__text" }, ade = { key: 0 }, nde = {
  key: 1,
  class: "fe-e2e-upgrade__progress",
  "data-testid": "e2e-names-progress"
}, sde = {
  key: 2,
  class: "fe-form__error",
  role: "alert"
}, ode = { class: "fe-e2e-upgrade__actions" }, ide = {
  key: 7,
  class: "fe-e2e-upgrade fe-e2e-upgrade--rekey",
  role: "status",
  "data-testid": "e2e-rekey-offer"
}, rde = { class: "fe-e2e-upgrade__text" }, lde = {
  key: 0,
  class: "fe-e2e-upgrade__progress",
  "data-testid": "e2e-rekey-progress"
}, ude = {
  key: 1,
  class: "fe-form__error",
  role: "alert"
}, cde = { class: "fe-e2e-upgrade__actions" }, dde = ["disabled"], fde = {
  key: 8,
  class: "fe-e2e-strip",
  role: "status"
}, pde = ["innerHTML"], vde = { class: "fe-e2e-strip__label" }, hde = {
  class: "fe-e2e-strip__names",
  "data-testid": "e2e-names-status"
}, mde = ["disabled"], yde = {
  key: 9,
  class: "fe-trashbar"
}, gde = { class: "fe-trashbar__text" }, bde = {
  key: 0,
  class: "fe-trashbar__progress",
  role: "status",
  "aria-live": "polite"
}, _de = ["disabled"], kde = {
  key: 2,
  class: "fe-state"
}, wde = { class: "fe-state__title" }, xde = { class: "fe-state__path" }, $de = { class: "fe-state__hint" }, Sde = { class: "fe-state__actions" }, Tde = {
  key: 0,
  class: "fe-state"
}, Cde = { class: "fe-state__title" }, Ede = { class: "fe-state__hint" }, Ade = ["data-testid"], zde = {
  class: "fe-state__art",
  viewBox: "0 0 120 100",
  width: "110",
  height: "92",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}, Mde = {
  key: 1,
  d: "M60 26l9 18.6 20.4 3-14.8 14.4 3.5 20.4L60 72.8 41.9 82.4l3.5-20.4L30.6 47.6l20.4-3z"
}, Dde = { class: "fe-state__title" }, Pde = { class: "fe-state__hint" }, Ode = {
  key: 2,
  class: "fe-state"
}, Lde = { class: "fe-state__title" }, Ide = { class: "fe-state__hint" }, Rde = {
  key: 3,
  class: "fe-state"
}, Nde = {
  class: "fe-state__art",
  viewBox: "0 0 120 100",
  width: "110",
  height: "92",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}, Bde = { key: 0 }, Fde = { class: "fe-state__title" }, Ude = {
  key: 0,
  class: "fe-state__hint"
}, Hde = {
  key: 1,
  class: "fe-state__actions"
}, Kde = { class: "fe-overlay__head" }, Vde = { class: "fe-overlay__title" }, qde = ["title", "aria-label"], jde = {
  key: 1,
  class: "fe__dragover"
}, Wde = { class: "fe__dragover-card" }, Yde = ["innerHTML"], Gde = ["title", "aria-label"], Xde = {
  key: 3,
  class: "fe-keep-strip",
  role: "status",
  "aria-live": "polite"
}, Jde = { class: "fe-keep-strip__label" }, Zde = {
  key: 0,
  class: "fe-keep-strip__bar",
  "aria-hidden": "true"
}, Qde = { class: "fe-recents__header" }, efe = ["aria-label"], tfe = { class: "fe-modal__head" }, afe = { class: "fe-modal__title" }, nfe = ["aria-label"], sfe = { class: "fe-modal__body" }, ofe = { class: "fe-toast__msg" }, ik = "brf-file-explorer:view-mode", Ec = 250, rk = 3, lk = "user-settings", ife = 800, uk = "filex.inspector", ck = "filex.sidenav", dk = 250, vo = 2500, Oa = 6e3, Il = 10 * 60 * 1e3, sv = "brf-file-explorer:path", rfe = "application/x-brf-files", lfe = 8 * 1024 * 1024, ufe = 10, cfe = "/files/edit", fk = "filex.tabs", dfe = "https://docs.filex.sh/E2E-ENCRYPTION#what-escrow-can-and-cannot-do", ffe = 2e3, Qhe = /* @__PURE__ */ rt({
  __name: "FileExplorer",
  props: {
    config: {}
  },
  emits: ["share-created", "file-opened", "error", "upload-progress", "selection-change", "navigate", "refresh", "open-my-shares", "open-app-home"],
  setup(e, { expose: a, emit: t }) {
    var wg;
    const s = e, n = t, o = Fr(s.config), p = b(null), h = x(
      () => {
        var l;
        return s.config.permissions ?? ((l = p.value) == null ? void 0 : l.permissions);
      }
    ), v = x(
      () => {
        var l;
        return s.config.permissions ? s.config.permissionsByFolder : (l = p.value) == null ? void 0 : l.byFolder;
      }
    );
    function y() {
      s.config.permissions || o.myPermissions().then(
        (l) => {
          p.value = l && !l.admin ? { permissions: l.permissions, byFolder: l.byFolder } : null;
        },
        () => {
          p.value = null;
        }
      );
    }
    Kt(y);
    const g = x(() => Ha(s.config.locale));
    yr(Yk, () => g.value), Qe(g, (l) => Vh(l), { immediate: !0 });
    const { t: m, formatSize: k, formatDate: _, dir: w } = gt(g), $ = YC(o, { reload: () => zt() }), C = $.presenceUsers, E = $.degraded;
    function A(l) {
      const c = (l || "").replace(/^\/+|\/+$/g, "");
      if (c === ".trash" || c.startsWith(".trash/")) return null;
      const S = qt(c);
      return !S || !S.includes("://") || S.startsWith("://") ? null : S;
    }
    Kt(() => {
      $.start(), $.subscribe(A(M.value));
    }), Mt(() => $.stop());
    const O = JC(s.config.apiBase, o), z = lC(s.config, o), P = /* @__PURE__ */ new Map(), I = SC(s.config, o, {
      onSettled: (l) => {
        var S;
        const c = P.get(l.id);
        if (P.delete(l.id), l.op_type === "trash-empty") {
          zt();
          return;
        }
        if (Jf.owns(l.id)) {
          const D = Xf.get(l.id);
          Xf.delete(l.id), D !== void 0 && nc([D], !1);
          const B = Jf.settle({
            id: l.id,
            ok: l.status === "done",
            ...l.status === "done" ? {} : { reason: Ac(l, m).text }
          });
          B && (ra(
            { message: Y_({ queued: !1, ...B }, m) },
            B.failed ? Oa : vo
          ), be.value && ts());
          return;
        }
        if (l.status === "cancelled") {
          const D = l.op_type === "archive-extract" ? m("archive.extraction_cancelled", { count: l.progress_done }) : m("opc.status.aborted");
          it(D);
        } else if (l.status === "error" && l.op_type === "restore" && l.progress_done > 0)
          it(
            m("toast.restore_partial", {
              n: l.progress_done,
              failed: l.progress_total - l.progress_done,
              reason: Ac(l, m).text
            })
          );
        else if (l.status === "error")
          it(Ac(l, m).text);
        else if (c)
          ju(l.op_type === "rename" ? c.message : `${c.message} (${l.progress_total})`, c.fn);
        else if (l.op_type === "plugin")
          it(l.message || m("plugin.done", { label: mn(l) }));
        else if (l.op_type === "rename")
          it(m("toast.renamed"));
        else if (l.op_type === "restore")
          it(m("toast.restored", { n: l.progress_done }));
        else {
          const D = l.op_type === "archive-create" ? m("archive.created") : l.op_type === "archive-extract" ? m("archive.extraction_completed") : l.op_type === "copy" ? m("toast.copied") : l.op_type === "move" ? m("toast.moved") : m("toast.deleted");
          it(l.op_type.startsWith("archive-") ? D : `${D} (${l.progress_total})`);
        }
        zt(), (S = na.value) == null || S.reload();
      }
    }), F = b(!1), W = (s.config.rootPath || "").trim(), N = W.replace("://", "/").replace(/^\/+|\/+$/g, ""), K = N || s.config.initialPath || "", M = b(K), j = b(s.config.defaultAdapter || "brf"), U = b(K), de = b([]), ke = b(""), ie = b(!1), ce = b(""), X = b("");
    let Z;
    function Y() {
      zt(Z);
    }
    const G = b(
      (() => {
        try {
          const l = localStorage.getItem(ik);
          if (l === "list" || l === "grid" || l === "gallery") return l;
        } catch {
        }
        return s.config.viewMode ?? "list";
      })()
    ), we = b("comfortable"), R = b(""), pe = b(!1), Q = b({}), q = b({});
    let re = null;
    function ae() {
      if (!re) {
        const l = Mn(s.config);
        re = $ae({
          list: async () => {
            const c = await o.jsonFetch(`${l}/api/admin/storages`);
            return Array.isArray(c) ? c : [];
          }
        });
      }
      return re;
    }
    function Pe(l) {
      return !!l && l in q.value;
    }
    const be = b(!1), ze = b(""), Ae = x(() => be.value), Ce = b(""), He = b(""), J = x(
      () => Ce.value !== "" && Ce.value !== "trash" && Ce.value !== "home"
    ), me = x(() => s.config.rememberFolderView !== !1), fe = x(() => {
      if (!me.value) return "";
      const l = String(M.value ?? "").replace(/^\/+|\/+$/g, "");
      if (!l) return vM;
      const [c, ...S] = l.split("/"), D = (s.config.storages ?? []).find((B) => B.name === c);
      return xb((D == null ? void 0 : D.uid) || c, S.join("/"));
    });
    function xe() {
      const l = jd().v;
      if (l) return l;
      if (!lr())
        try {
          const c = localStorage.getItem(ik);
          if (c === "list" || c === "grid" || c === "gallery") return c;
        } catch {
        }
      return s.config.viewMode ?? "list";
    }
    hk(
      k1(() => {
        lr() && qe(fe.value);
      })
    );
    let ye = null;
    function qe(l) {
      if (!l && me.value) return;
      mM(l);
      const c = l ? xM(l) : {}, S = c.v ?? xe();
      if (S !== G.value && (G.value = S), c.k) Ob(c.k, c.d ?? Ir(c.k));
      else {
        const D = qh();
        Ob(D.key, D.dir);
      }
      ye = { key: l, v: G.value, k: Db(), d: Pb() };
    }
    Kt(() => {
      RM({
        apiBase: s.config.apiBase ?? "",
        headers: Na,
        credentials: o.credentialsMode()
      });
    }), Qe(
      [fe, () => lr()],
      ([l, c]) => {
        c && qe(l);
      },
      { immediate: !0, flush: "post" }
    ), Qe(
      () => [fe.value, G.value, Db(), Pb()],
      ([l, c, S, D]) => {
        if (!lr() || !ye || ye.key !== l) return;
        const B = {};
        c !== ye.v && (B.v = c), (S !== ye.k || D !== ye.d) && (B.k = S, B.d = D), ye = { key: l, v: c, k: S, d: D }, Object.keys(B).length && (l ? m1(l, B) : me.value || pr(B));
      },
      /* ⚠⚠ `post`, and registered AFTER the applier: a navigation changes
       * `currentFolderKey`, which both watchers depend on. Pre-flush this would
       * run first, while the view state is still the folder you LEFT, and record
       * that folder's setup against the one you arrived in. */
      { flush: "post" }
    ), Qe(
      () => v1(fe.value),
      (l, c) => {
        c && !l && lr() && qe(fe.value);
      }
    );
    const ut = b(""), Ue = b(""), Ye = {
      home: ".home",
      recent: ".recent",
      starred: ".starred",
      shared: ".shared",
      drafts: ".drafts"
    };
    function st(l) {
      if (!u1(l)) return null;
      const c = String(l ?? "").replace(/^\/+|\/+$/g, ""), S = cM(c);
      return S ? { kind: "tag", tag: S, tagKind: uM(c) } : { kind: c.slice(1), tag: "", tagKind: "" };
    }
    const kt = x(() => {
      if (!ma.value) return "";
      const l = s.config.storages ?? [];
      return l.length === 1 ? l[0].name : "";
    }), At = x(() => {
      const l = (M.value ?? "").replace(/^\/+|\/+$/g, "");
      return N && l === N || kt.value && l === kt.value ? !1 : l.length > 0;
    }), _t = x(() => Ce.value && Ce.value !== "trash" ? !0 : ma.value ? !(M.value ?? "").replace(/^\/+|\/+$/g, "") : !1), Le = x(
      () => Ce.value === "home" ? "find" : "full"
    );
    function tt() {
      if (be.value) {
        zt(ze.value);
        return;
      }
      if (Ce.value) {
        zt(He.value);
        return;
      }
      const l = (M.value ?? "").replace(/^\/+|\/+$/g, "");
      if (!l || l === N || kt.value && l === kt.value) return;
      const c = l.lastIndexOf("/");
      let S = c === -1 ? "" : l.slice(0, c);
      N && !(S === N || S.startsWith(N + "/")) && (S = N), zt(S);
    }
    const ve = b([]), H = x(
      () => (ve.value.length ? ve.value : de.value).filter((l) => l.type !== "dir")
    ), te = x(() => {
      var D;
      const l = H.value, c = (D = Ra.value) == null ? void 0 : D.path, S = c ? l.findIndex((B) => B.path === c) : -1;
      return { index: S === -1 ? 0 : S + 1, total: S === -1 ? 0 : l.length };
    });
    async function Te(l) {
      const c = H.value, S = c.findIndex((B) => {
        var le;
        return B.path === ((le = Ra.value) == null ? void 0 : le.path);
      });
      if (S === -1) return;
      const D = c[S + l];
      if (D) {
        if (Yo(D) && !oa.value && !D.e2e_root) {
          Bn.value = !1, Pt.open(D);
          return;
        }
        if (Wa.value && D.type === "file")
          try {
            await mc(D);
          } catch {
            it(m("e2e.decrypt_failed"));
            return;
          }
        Ra.value = D;
      }
    }
    const L = Wg(() => ve.value.length ? ve.value : de.value);
    Qe(
      () => [...L.selected.value],
      () => {
        n(
          "selection-change",
          /* wiring:e2 names — `basename` stays what the server calls the item
             (hosts pass it back to the API); an encrypted-names row adds its
             plaintext as `display_name` for a host that draws it. */
          L.nodes.value.map((c) => ({
            path: c.path,
            basename: Nc(c),
            type: c.type,
            ...c.e2e_stored ? { display_name: c.basename } : {}
          }))
        );
        const l = L.nodes.value.filter((c) => c.type === "file");
        $.setFocus(l.length === 1 ? Nc(l[0]) : null);
      }
    );
    const se = b({ mode: null, items: [], sourcePath: null }), ne = b(null);
    let et = null;
    function ht() {
      return et || (o.endpoints.capabilities ? (et = (async () => {
        for (let l = 1; l <= rk; l++)
          try {
            ne.value = await o.capabilities();
            return;
          } catch (c) {
            if (l === rk) {
              n("error", {
                message: `capabilities: ${(c == null ? void 0 : c.message) ?? String(c)}`,
                context: { what: "capabilities", attempts: l }
              });
              return;
            }
            await new Promise((S) => setTimeout(S, 200 * l));
          }
      })(), et) : (et = Promise.resolve(), et));
    }
    const Tt = b(!1);
    let Ft = null;
    function Lt() {
      return Ft || (Ft = o.jsonFetch(`${Mn(s.config)}/api/auth/me`), Ft.catch(() => {
        Ft = null;
      })), Ft;
    }
    const ua = W7({
      config: () => s.config,
      capabilities: ne,
      fetchMe: () => Lt()
    }), Ct = s.config.notifications ? KS(
      yce({
        transport: gce(o.jsonFetch, Mn(s.config)),
        errorText: (l) => (l == null ? void 0 : l.message) || m("inspector.error"),
        onRead: () => {
          var l, c;
          return (c = (l = s.config.notifications) == null ? void 0 : l.onRead) == null ? void 0 : c.call(l);
        }
      })
    ) : null;
    let Qt = null;
    Kt(() => {
      var c;
      const l = s.config.notifications;
      !Ct || !l || (Ct.refreshFeed(), l.poll !== !1 && (Qt = setInterval(() => void Ct.syncUnread(), mce)), (c = l.onUnread) == null || c.call(l, (S) => void Ct.acceptCount(S)));
    }), Mt(() => {
      Qt && clearInterval(Qt), Qt = null;
    });
    const ta = x(() => {
      var S, D, B;
      const l = (D = (S = s.config.notifications) == null ? void 0 : S.manage) == null ? void 0 : D.href;
      return l && (Sa.value || ((B = _e.value) == null ? void 0 : B.role) === "admin") ? l : void 0;
    });
    function Rt() {
      var l, c;
      (c = (l = s.config.notifications) == null ? void 0 : l.manage) == null || c.open();
    }
    let va = () => {
    };
    const ha = new Promise((l) => {
      va = l;
    });
    async function _a(l) {
      var D;
      if (await ha, l.kind === "none") return !1;
      if (l.kind === "share")
        return window.open(p2(l.token, Mn(s.config)), "_blank", "noopener"), !0;
      if (l.kind === "app")
        return await ht(), await V.refresh(), await Ut(`${l.plugin}/${l.view}`), !0;
      const c = Xoe(l);
      if (!c) return !1;
      c === Ed ? await zt(Ed) : await zt(ma.value ? Qs(c) : Tn(c));
      const S = l.select;
      if (S) {
        const B = de.value.find((le) => ek(le.path, S));
        if (B) {
          L.click(B.path), await Jt();
          const le = Array.from(((D = ga.value) == null ? void 0 : D.querySelectorAll("[data-fe-path]")) ?? []).find(
            ($e) => ek($e.getAttribute("data-fe-path"), S)
          );
          le == null || le.scrollIntoView({ block: "center" });
        }
      }
      if (l.kind === "folder" && l.open) {
        const B = l.select || c;
        await cn({ plugin: l.open.plugin, action: l.open.action, view: l.open.view, path: B });
      }
      return !0;
    }
    function ia(l) {
      _a(f2(l.target));
    }
    const _e = b(((wg = s.config.account) == null ? void 0 : wg.person) ?? null);
    Kt(() => {
      !s.config.account || s.config.account.person || Lt().then((l) => {
        _e.value = (l == null ? void 0 : l.user) ?? null;
      }).catch(() => {
      });
    });
    const Ve = b([]);
    let Je = null;
    function at(l) {
      if (!s.config.account) return;
      const c = l.detail;
      !c || !Array.isArray(c.items) || (c.claimed = !0, l.stopPropagation(), Ve.value = c.items, Je = typeof c.run == "function" ? c.run : null);
    }
    Kt(() => {
      var l;
      return (l = ga.value) == null ? void 0 : l.addEventListener("fe:header-menu", at);
    }), Mt(() => {
      var l;
      return (l = ga.value) == null ? void 0 : l.removeEventListener("fe:header-menu", at);
    });
    const xt = x(() => {
      const l = s.config.account;
      if (!l) return [];
      const c = _e.value, S = typeof l.actions == "function" ? l.actions(c) : l.actions ?? [], D = l.settings ? [{ key: lk, label: m("userSettings.open"), icon: "account" }, ...S] : S, B = typeof l.tail == "function" ? l.tail(c) : l.tail ?? [], le = bce.filter((Be) => Be !== "inspector" || s.config.showInfoPanel !== !1), $e = l.settings ? Ot : [];
      return _ce(D, Ve.value, {
        omit: [...le, ...$e, ...l.omit ?? []],
        tail: B
      });
    });
    function Bt(l) {
      var S, D;
      const c = kce(l);
      if (c !== null) {
        Je == null || Je(c);
        return;
      }
      if (l === lk && ((S = s.config.account) != null && S.settings)) {
        It.value = !0;
        return;
      }
      (D = s.config.account) == null || D.select(l, _e.value);
    }
    const Ot = ["theme", "density", "timezone"], It = b(!1), Et = {
      get locale() {
        return String(g.value);
      },
      get user() {
        return _e.value;
      },
      get isAdmin() {
        var l;
        return ((l = _e.value) == null ? void 0 : l.role) === "admin";
      },
      get demoReadOnly() {
        var l;
        return ((l = ne.value) == null ? void 0 : l.demo_mode) === !0;
      },
      get capabilities() {
        return ne.value;
      },
      api: vce(o.jsonFetch, Mn(s.config)),
      setUser(l) {
        _e.value = { ..._e.value ?? {}, ...l };
      },
      toast(l, c) {
        ra({ message: c }, l === "success" ? vo : Oa);
      },
      errorText: (l, c) => (l == null ? void 0 : l.message) || c,
      zone: UT(ua),
      mode: {
        get: () => {
          const l = hl.value === "host" ? s.config.theme || "auto" : hl.value;
          return l === "light" || l === "dark" ? l : "auto";
        },
        set: (l) => Iy(l)
      }
    }, Dt = x(() => {
      var l;
      return ((l = ne.value) == null ? void 0 : l.share_max_ttl_days) ?? 0;
    }), aa = x(() => {
      var l, c;
      return typeof s.config.plugins == "boolean" ? s.config.plugins : ((c = (l = ne.value) == null ? void 0 : l.app_plugins) == null ? void 0 : c.enabled) === !0;
    }), V = RC(o, () => aa.value), oe = b(null);
    let Oe = 0;
    const Ne = b(!1);
    let Ee;
    Mt(() => clearTimeout(Ee));
    function Ge(l) {
      const c = ++Oe;
      return oe.value = { ...l, surface: null, ticket: c }, Ne.value = !1, clearTimeout(Ee), Ee = setTimeout(() => {
        je(c) && (Ne.value = !0);
      }, ife), c;
    }
    const ue = x(
      () => !!oe.value && (oe.value.surface !== null || Ne.value)
    );
    function je(l) {
      var c;
      return l > 0 && ((c = oe.value) == null ? void 0 : c.ticket) === l;
    }
    const vt = b(null);
    function Se(l) {
      return l.filter((c) => c.type === "file").map((c) => ({
        path: c.path,
        name: c.basename,
        size: c.size,
        mime: c.mime_type,
        readOnly: !!c.read_only || !ll(c)
      }));
    }
    const Ie = x(() => aa.value ? V.views.value : []);
    function ee(l) {
      return oa.value ? [] : u2(Ie.value, l);
    }
    const ge = b(null), De = x(
      () => oa.value ? null : Rae(Ie.value, Ra.value, ge.value)
    );
    function lt(l) {
      return l.length !== 1 ? [] : ee(l[0]).map((c) => ({
        key: `open-with:${c.plugin}/${c.id}`,
        label: m("ctx.open_with", { app: jt(c.label, g.value) || c.plugin }),
        icon: "open"
      }));
    }
    const Ze = x(
      () => aa.value ? V.views.value.filter((l) => l.placement === "inspector") : []
    ), ct = x(
      () => aa.value ? V.views.value.filter((l) => l.placement === "home").map((l) => ({ key: `${l.plugin}/${l.id}`, label: jt(l.label, g.value) || l.id, icon: l.icon })) : []
    );
    async function Ut(l) {
      const c = V.views.value.find((S) => `${S.plugin}/${S.id}` === l);
      if (c) {
        if (Zs(), s.config.appHomePage === !0) {
          n("open-app-home", { plugin: c.plugin, view: c.id });
          return;
        }
        if (c.ui) {
          vt.value = {
            plugin: c.plugin,
            view: c.id,
            placement: "home",
            ui: c.ui,
            label: jt(c.label, g.value) || c.plugin,
            files: []
          };
          return;
        }
        try {
          const S = await o.pluginView(c.plugin, c.id);
          if (!(S != null && S.surface)) {
            it(m("plugin.view.error"));
            return;
          }
          oe.value = { plugin: c.plugin, view: c.id, surface: S.surface, size: "xl" };
        } catch (S) {
          it((S == null ? void 0 : S.message) || m("plugin.view.error"));
        }
      }
    }
    const Zt = b(null);
    function Da(l) {
      return aa.value ? PC(V.actions.value, l, {
        locale: g.value,
        trash: Ae.value,
        e2e: oa.value,
        readOnly: ie.value || Gm(l),
        // The level each row answers with — the same one the built-in verbs
        // read — so an app's row a viewer could only be refused is not offered.
        permOf: (c) => Cf(c),
        hasIcon: (c) => wt(c) !== "",
        // Greyed rows with the reason are an ADMINISTRATOR's (the server sends
        // `gated` to them only; asked here too, so no other caller draws one).
        needWords: Sa.value ? (c) => c.kind === "engine" ? m("plugin.needs_engine", { name: c.name }) : m("plugin.needs_other", { name: c.name }) : void 0
      }) : [];
    }
    function mn(l) {
      return l.label || l.action || m("opc.kind.plugin");
    }
    function $o(l) {
      var c;
      if (!(!l.plugin || !l.action))
        return (c = V.actions.value.find((S) => S.plugin === l.plugin && S.id === l.action)) == null ? void 0 : c.output_mode;
    }
    async function Rn(l, c) {
      const S = V.byKey(l);
      if (!S || c.length === 0) return;
      if (jt(S.confirm, g.value)) {
        Zt.value = { action: S, targets: c };
        return;
      }
      await ks(S, c);
    }
    async function _s() {
      const l = Zt.value;
      Zt.value = null, l && await ks(l.action, l.targets);
    }
    function js(l, c) {
      var Be, Xe, mt;
      const S = l.view, D = s.config.pluginPageBase;
      if (!S || D === void 0) return !1;
      const B = { plugin: l.plugin, view: S, path: (Be = c[0]) == null ? void 0 : Be.path }, le = L1(D, B);
      if (((mt = (Xe = s.config).openPluginPage) == null ? void 0 : mt.call(Xe, { ...B, url: le })) === !0) return !0;
      const $e = window.open(le, "_blank");
      if (!$e)
        return it(m("plugin.page_view.blocked")), !1;
      try {
        $e.opener = null;
      } catch {
      }
      return !0;
    }
    function Ua(l, c, S = {}) {
      const D = s.config.refusalToasts !== !1, B = Iv(l);
      B ? D && it(li(B, { t: m, formatDate: _, locale: g.value })) : !S.inDialog && D && ra({ message: S.words ?? xa(l) }, Oa), n("error", { message: (l == null ? void 0 : l.message) ?? String(l), context: c });
    }
    function un(l, c, S, D, B = xa(S)) {
      Ua(S, D, { inDialog: l.refuse(c, B), words: B });
    }
    function xa(l, c = m("toast.failed")) {
      return ch(l, c, { t: m, callerAdmin: Sa.value }).text;
    }
    async function ks(l, c) {
      var le;
      const S = jt(l.label, g.value);
      if (Rv(l.view_placement) && js(l, c)) return;
      if (l.ui) {
        vt.value = {
          plugin: l.plugin,
          view: l.view || l.id,
          placement: "modal",
          ui: l.ui,
          label: S || l.plugin,
          files: Se(c)
        };
        return;
      }
      const D = {
        plugin: l.plugin,
        view: l.view || l.id,
        path: (le = c[0]) == null ? void 0 : le.path,
        paths: c.map(($e) => $e.path),
        label: S
      }, B = l.view ? Ge(D) : 0;
      try {
        const $e = await V.run(l, c);
        if ($e.surface) {
          if (l.view && !je(B)) return;
          oe.value = { ...D, surface: $e.surface, ticket: B || ++Oe };
          return;
        }
        je(B) && (oe.value = null), $e.op && ws($e.op, S);
      } catch ($e) {
        je(B) && (oe.value = null);
        const Be = $e, Xe = String((Be == null ? void 0 : Be.detail) ?? ""), mt = Iv(Be);
        mt ? it(li(mt, { t: m, formatDate: _, locale: g.value })) : (Be == null ? void 0 : Be.status) === 422 && Xe.includes("not_applicable") ? it(m("plugin.not_applicable")) : (Be == null ? void 0 : Be.status) === 409 && Xe.includes("read_only") ? it(m("plugin.read_only")) : ra({ message: xa(Be, m("plugin.failed", { label: S })) }, Oa);
      }
    }
    function ws(l, c) {
      I.register(l);
      const S = c || (typeof l.label == "string" ? l.label : "") || m("opc.kind.plugin");
      it(m("plugin.queued", { label: S }));
    }
    async function cn(l) {
      if (!l.plugin || !l.path) return !1;
      if (await ht(), !aa.value)
        return n("error", {
          message: "app plugins are off on this instance — deep link ignored",
          context: { what: "openAppTarget", plugin: l.plugin, path: l.path }
        }), !1;
      await V.refresh();
      const c = de.value.find((D) => D.path === l.path) ?? { path: l.path, basename: l.path.split("/").pop() ?? l.path, type: "file" };
      if (l.action) {
        const D = V.byKey(`plugin:${l.plugin}/${l.action}`);
        return D ? (await Rn($h(D), [c]), !0) : (it(m("plugin.not_applicable")), n("error", {
          message: `no such plugin action: ${l.plugin}/${l.action}`,
          context: { what: "openAppTarget", path: l.path }
        }), !1);
      }
      if (!l.view) return !1;
      const S = V.actions.value.find((D) => D.plugin === l.plugin && D.view === l.view);
      if (S && Rv(S.view_placement))
        return js(S, [c]);
      try {
        const D = await o.pluginView(l.plugin, l.view, l.path);
        return D != null && D.surface ? (oe.value = { plugin: l.plugin, view: l.view, surface: D.surface, path: l.path }, !0) : (it(m("plugin.view.error")), !1);
      } catch (D) {
        return it((D == null ? void 0 : D.message) || m("plugin.view.error")), !1;
      }
    }
    async function qr(l, c) {
      if (!l || !(c != null && c.path)) return;
      oe.value = null;
      const S = c.path.indexOf("://"), D = S === -1 ? "" : c.path.slice(0, S), B = Tn(c.path).replace(/^\/+|\/+$/g, ""), le = B.lastIndexOf("/"), $e = le === -1 ? "" : B.slice(0, le), Be = ma.value && D ? $e ? `${D}/${$e}` : D : $e;
      try {
        await zt(Be);
      } catch {
      }
      await cn({ plugin: l, action: c.action, view: c.view, path: c.path });
    }
    async function Ws(l, c) {
      const S = c.indexOf("://"), D = S === -1 ? "" : c.slice(0, S), B = Tn(c).replace(/^\/+|\/+$/g, ""), le = B.lastIndexOf("/"), $e = le === -1 ? "" : B.slice(0, le), Be = ma.value && D ? $e ? `${D}/${$e}` : D : $e;
      await zt(Be);
      const Xe = de.value.find((mt) => mt.path === c);
      if (Xe) {
        L.click(Xe.path);
        return;
      }
      it(m("plugin.output_missing"));
    }
    const xn = b(/* @__PURE__ */ new Set()), xs = b(!1), So = b(!1), To = b(null), Du = b(0);
    async function Pu() {
      try {
        const l = await Na(), c = s.config.apiBase ?? "", S = await fetch(`${c}/api/files/manager/star/list?limit=500`, {
          headers: l,
          // ⚠ NOT 'include'. With a bearer token the request is cross-origin for
          // every embedder that serves the UI from a different origin to the API
          // (the desktop app is one), and a credentialed request may not be
          // answered with `Access-Control-Allow-Origin: *` — which is what filex
          // sends. This one line made starred files fail silently in every such
          // install while the rest of the explorer worked.
          credentials: o.credentialsMode()
        });
        if (!S.ok) return;
        const D = await S.json(), B = Array.isArray(D) ? D : Array.isArray(D == null ? void 0 : D.entries) ? D.entries : Array.isArray(D == null ? void 0 : D.nodes) ? D.nodes : [];
        xn.value = new Set(B.map((le) => le.id).filter((le) => typeof le == "number"));
      } catch {
      }
    }
    function jr(l, c) {
      if (typeof l.id != "number") return;
      const S = new Set(xn.value);
      c ? S.add(l.id) : S.delete(l.id), xn.value = S;
    }
    function Ke(l) {
      return Di.value ? l.filter((c) => typeof c.id == "number" && c.type === "file") : [];
    }
    function Me(l) {
      const c = Ke(l);
      return c.length > 0 && c.every((S) => xn.value.has(S.id));
    }
    async function pt(l) {
      const c = Ke(l);
      if (c.length === 0) return;
      const S = !Me(c), D = {
        apiBase: s.config.apiBase ?? "",
        authHeaders: () => Na(),
        authCredentials: o.credentialsMode()
      }, B = new Set(xn.value);
      for (const $e of c)
        S ? B.add($e.id) : B.delete($e.id);
      xn.value = B;
      let le = 0;
      await Promise.all(
        c.map(async ($e) => {
          try {
            await k0($e.id, S, D);
          } catch {
            le += 1;
            const Be = new Set(xn.value);
            S ? Be.delete($e.id) : Be.add($e.id), xn.value = Be;
          }
        })
      ), le > 0 && it(m("star.failed")), Ce.value === "starred" && await Uu("starred");
    }
    async function Nt(l) {
      if (typeof l.id == "number")
        try {
          const c = s.config.apiBase ?? "";
          await fetch(`${c}/api/files/manager/recent`, {
            method: "POST",
            headers: await Na({ "Content-Type": "application/json" }),
            credentials: o.credentialsMode(),
            body: JSON.stringify({ node_id: l.id })
          }), Du.value += 1;
        } catch {
        }
    }
    function Gt(l) {
      typeof l.id == "number" && (To.value = l, So.value = !0);
    }
    function $a(l, c = "") {
      So.value = !1, rl(l, c);
    }
    function Ka() {
      Tf(), Ce.value === "tag" && ut.value && rl(ut.value, Ue.value);
    }
    const Nn = LA(Ka);
    Mt(Nn);
    function Ca(l) {
      const c = Fu(l) ?? {
        type: "file",
        path: l.path,
        basename: l.name,
        extension: (l.name.split(".").pop() || "").toLowerCase(),
        id: l.id
      };
      xs.value = !1, Cn(c);
    }
    function rf(l, c) {
      const S = Fu(l);
      S && (xs.value = !1, Vf(S, c));
    }
    const Ys = x(() => {
      var c, S, D;
      if (s.config.onlyOfficeBase) return s.config.onlyOfficeBase;
      const l = (S = (c = ne.value) == null ? void 0 : c.external) == null ? void 0 : S.onlyoffice;
      return l && !Sg(l) ? null : ((D = ne.value) == null ? void 0 : D.onlyoffice_url) || null;
    }), Sa = x(() => {
      var l;
      return ((l = ne.value) == null ? void 0 : l.caller_admin) === !0;
    });
    function Yn(l) {
      var c, S;
      return ((S = (c = ne.value) == null ? void 0 : c.queued) == null ? void 0 : S.includes(l)) === !0;
    }
    const xi = x(() => Ys.value && o.endpoints.onlyOfficeConfig || null), Wr = x(() => {
      var S, D, B;
      const l = s.config.drawioUrl || s.config.drawioBase;
      if (l) return l;
      const c = (D = (S = ne.value) == null ? void 0 : S.external) == null ? void 0 : D.drawio;
      return c && !Sg(c) ? null : ((B = ne.value) == null ? void 0 : B.drawio_url) || null;
    }), xm = x(() => {
      var l;
      return ((l = ne.value) == null ? void 0 : l.newdoc_types) ?? null;
    }), T2 = x(() => {
      const l = xm.value;
      return !l || l.length === 0 ? !1 : l.some(
        (c) => c.requires === "onlyoffice" ? !!Ys.value : c.requires === "drawio" ? !!Wr.value : !0
      );
    }), Co = x(() => {
      var l;
      return !!((l = ne.value) != null && l.drafts);
    }), $i = b(0), lf = b([]), uf = b(0), cf = b(!1), Eo = b(null);
    async function df() {
      if (!Co.value) {
        $i.value = 0;
        return;
      }
      try {
        const { count: l, limit: c } = await o.drafts.count();
        $i.value = l, uf.value = c;
      } catch {
      }
    }
    async function $m() {
      cf.value = !0;
      try {
        const l = await o.drafts.list();
        lf.value = l.drafts, uf.value = l.limit, $i.value = l.count;
      } catch (l) {
        lf.value = [];
        const c = xa(l);
        n("error", { message: c, context: { op: "nav-view:drafts" } }), it(c);
      } finally {
        cf.value = !1;
      }
    }
    async function Yr() {
      Ce.value === "drafts" ? await $m() : await df();
    }
    Qe(Co, (l) => void (l ? df() : $i.value = 0), { immediate: !0 });
    function C2(l) {
      const c = l.lastIndexOf(".");
      return c > 0 ? l.slice(c + 1).toLowerCase() : "";
    }
    function Sm(l, c = null) {
      const S = {
        type: "file",
        path: l.path,
        basename: l.name,
        extension: C2(l.name),
        storage: l.storage,
        size: l.size,
        file_size: l.size,
        mime_type: l.mime ?? "",
        visibility: "private",
        extra_metadata: {}
      };
      if (Qp(s.config, S) === "host") {
        n("file-opened", { path: S.path, basename: S.basename });
        return;
      }
      zi.value = l.type ? { path: S.path, ext: l.type } : null, ge.value = c, Ra.value = S, Js.value = "edit", Bn.value = !0;
    }
    function Tm(l) {
      it(m("draft.saved_to", { name: l.name, folder: ed(l.targetDir) }));
    }
    const $s = H0(() => Co.value ? o.drafts : null, (l) => xa(l));
    async function E2(l) {
      if (!Eo.value) {
        Eo.value = l.key;
        try {
          const c = await $s.save(l);
          c && (Tm(c), await Yr());
        } catch (c) {
          ra({ message: xa(c) }, Oa);
        } finally {
          Eo.value = null;
        }
      }
    }
    async function A2(l) {
      if (!Eo.value) {
        Eo.value = l.key;
        try {
          await o.drafts.discard(l.key), it(m("draft.discarded", { name: l.name })), await Yr();
        } catch (c) {
          ra({ message: xa(c) }, Oa);
        } finally {
          Eo.value = null;
        }
      }
    }
    function z2(l) {
      Tm(l), Yr(), !Ce.value && !be.value && zt();
    }
    function M2() {
      var c;
      const l = ((c = Ra.value) == null ? void 0 : c.basename) ?? "";
      it(m("draft.discarded", { name: l })), Yr();
    }
    function D2() {
      Gr.value = !1, Uu("drafts");
    }
    const Ia = b([]), Cm = b(null), yn = b(!1), Gr = b(!1), Gs = b(!1), dn = b(!1), Bn = b(!1), Ou = b(!1), Ao = b(!1), Si = b(!1), Xr = b([]), Xs = b(null), Ti = b(""), ff = b(!1), zo = b(/* @__PURE__ */ new Set()), Gn = b(""), Ci = b(!1), Ei = b(""), Mo = b(null), P2 = x(() => {
      var l;
      return Xr.value.length !== 1 ? "archive" : ((l = Xr.value[0]) == null ? void 0 : l.basename.replace(/\.[^.]+$/, "")) || "archive";
    }), O2 = ["zip", "7z", "tar", "tar.gz", "tar.bz2", "tar.xz"], Jr = x(() => {
      var c, S;
      return (((S = (c = ne.value) == null ? void 0 : c.archive) == null ? void 0 : S.allowed_formats) ?? []).filter((D) => O2.includes(D));
    }), L2 = x(() => {
      var c, S;
      const l = (S = (c = ne.value) == null ? void 0 : c.archive) == null ? void 0 : S.default_format;
      return l && Jr.value.includes(l) ? l : Jr.value.includes("7z") ? "7z" : Jr.value[0] ?? "zip";
    }), I2 = x(() => {
      var l, c;
      return ((c = (l = ne.value) == null ? void 0 : l.archive) == null ? void 0 : c.encryption) !== !1;
    }), R2 = x(
      () => {
        var l;
        return (((l = Xs.value) == null ? void 0 : l.basename) || "archive").replace(/\.(tar\.(gz|bz2|xz)|zip|7z|rar|tgz|gz|bz2|xz)$/i, "") || "archive";
      }
    ), Ai = b(null), Zr = ev(Gs), Qr = ev(yn), Xn = ev(dn), { busy: N2, error: B2 } = Zr, { busy: F2, error: U2 } = Qr, { busy: H2, error: K2 } = Xn, Jn = b(!1), Ra = b(null), Js = b("edit"), zi = b(null), V2 = x(
      () => {
        var l;
        return zi.value && ((l = Ra.value) == null ? void 0 : l.path) === zi.value.path ? zi.value.ext : null;
      }
    );
    Qe(Bn, (l) => {
      l || (zi.value = null), !l && Co.value && Ra.value && ov(Ra.value.path) && Yr();
    });
    const Mi = b(!1), $n = b(null), el = b(!1), Lu = b("move"), pf = b([]), Iu = b(!1), Zn = b(
      (() => {
        try {
          return localStorage.getItem(uk) === "1";
        } catch {
          return !1;
        }
      })()
    );
    function vf(l) {
      try {
        localStorage.setItem(uk, l ? "1" : "0");
      } catch {
      }
    }
    function hf() {
      Zn.value = !Zn.value, vf(Zn.value);
    }
    function q2() {
      Zn.value || (Zn.value = !0, vf(!0));
    }
    function Em() {
      Zn.value && (Zn.value = !1, vf(!1));
    }
    const j2 = x(() => VM(s.config.uiProfile)), tl = x(() => j2.value === "simple"), Am = x(() => s.config.showInfoPanel !== !1), al = b(
      (() => {
        try {
          const l = localStorage.getItem(ck);
          if (l === "1") return !0;
          if (l === "0") return !1;
        } catch {
        }
        return !0;
      })()
    );
    function W2(l) {
      try {
        localStorage.setItem(ck, l ? "1" : "0");
      } catch {
      }
    }
    const Do = b(!1), nl = x(() => s.config.sideNav ?? !W), mf = x(
      () => nl.value && (gn.value ? Do.value : !0)
    ), zm = x(
      () => nl.value && s.config.trashVisible !== !1
    ), Y2 = x(
      () => gn.value ? Do.value : al.value
    );
    function Mm() {
      if (nl.value) {
        if (gn.value) {
          Do.value = !Do.value;
          return;
        }
        al.value = !al.value, W2(al.value);
      }
    }
    function Zs() {
      Do.value = !1;
    }
    const yf = b([]), G2 = x(() => s.config.connections ?? !tl.value), X2 = x(() => s.config.mySharesVisible === !0), Dm = x(
      () => {
        var l;
        return (s.config.callerKind ?? ((l = ne.value) == null ? void 0 : l.caller_kind)) === "app";
      }
    ), Di = x(() => !Dm.value), Pi = b(!1), sl = b(!1);
    function J2() {
      sl.value = !1, Pi.value = !0;
    }
    function Z2() {
      Dm.value || (Pi.value = !1, sl.value = !0);
    }
    function Ru() {
      Pi.value = !1, sl.value = !1;
    }
    const Q2 = x(() => Pi.value || sl.value);
    function ex(l) {
      const c = l instanceof Error ? l.message : String(l);
      n("error", { message: c, context: { op: "connections" } }), it(c);
    }
    const gf = x(
      () => tl.value ? ["list", "grid"] : void 0
    );
    VS(() => {
      tl.value && G.value === "gallery" && (G.value = "grid");
    });
    const Oi = b({ ...ho }), ol = b(null), Nu = b("name"), tx = x(() => R.value ? "relevance" : "sort");
    function ax() {
      ol.value = null, Pm({ ...ho });
    }
    function Pm(l) {
      Oi.value = l, L.clear();
    }
    Qe(
      () => `${M.value}|${Ce.value}`,
      () => {
        Wl(Oi.value) && (Oi.value = { ...ho }), R.value || (ol.value = null);
      }
    );
    const il = b(!1), Om = b([]);
    Qe(il, async (l) => {
      l && (Om.value = await sb({
        apiBase: s.config.apiBase ?? "",
        authHeaders: () => Na(),
        authCredentials: o.credentialsMode()
      }));
    });
    const Lm = b(""), nx = x(() => !0);
    async function Im(l, c, S) {
      var le;
      if (l === "name") {
        const $e = await pg(S, c) ?? await o.search(S, c);
        return {
          rows: Rl(await Yt.decorate($e.files, { root: $e.e2e_root || null })),
          truncated: Fp($e.files.length, Ec, $e.truncated)
        };
      }
      const D = await o.globalSearch(c, { limit: dk, scope: l }), B = j.value || ((le = (s.config.storages ?? [])[0]) == null ? void 0 : le.name) || "";
      return {
        rows: Rl(await Yt.decorate(D.map(($e) => qc($e, B)))),
        truncated: Fp(D.length, dk)
      };
    }
    function sx() {
      const l = M.value ?? "";
      return ma.value ? Wu(l) : qt(l);
    }
    async function ox(l) {
      const c = $d(l), { rows: S, truncated: D } = await Im(l.scope, c, sx());
      return {
        count: Lv(S, l.filters).length,
        capped: D
      };
    }
    function ix(l) {
      Lm.value = qt(M.value ?? "") || "", Rm.value = l, il.value = !0;
    }
    const Rm = b("");
    function rx(l) {
      il.value = !1, Nu.value = l.scope, ol.value = Wl(l.filters) ? { ...l.filters } : null;
      const c = $d(l);
      c === R.value ? zt() : R.value = c;
    }
    function lx(l) {
      ol.value = null, Nu.value = "name", Ce.value !== "home" && (R.value = l);
    }
    const Nm = x(() => {
      if (Ce.value || _t.value) return "";
      const l = j.value;
      if (!l) return "";
      const c = (s.config.storages ?? []).find((S) => S.name === l);
      return (c == null ? void 0 : c.label) || l;
    }), bf = b("");
    function ux(l) {
      bf.value = l, Ju.value = !0;
    }
    const Bu = b(void 0);
    function cx() {
      const l = qt(M.value);
      if (!l || !Xm.value) return;
      const c = M.value.split("/").filter(Boolean);
      $n.value = {
        path: l,
        basename: c.length ? c[c.length - 1] : j.value,
        type: "dir"
      }, Bu.value = "drop", Mi.value = !0;
    }
    function dx(l) {
      n("share-created", { path: l.path, url: l.url, pin: null }), it(m("inspector.copied"));
    }
    const _f = b(null), Bm = b(null), fx = x(() => r7(_f.value, $f.value, Bm.value));
    async function Fm() {
      if (!Di.value) {
        _f.value = null;
        return;
      }
      const l = await o.quotaMe();
      _f.value = l, Bm.value = i7(l, $f.value) ? await o.storageUsage() : null;
    }
    function Fu(l) {
      return Eee(l, {
        storages: s.config.storages ?? [],
        multiStorageRoot: ma.value
      });
    }
    async function kf(l) {
      const c = s.config.apiBase ?? "", S = l === "shared" ? `${c}/api/files/manager/shared-with-me?limit=200` : l === "starred" ? `${c}/api/files/manager/star/list?limit=200` : `${c}/api/files/manager/recent?limit=50`, D = await fetch(S, {
        headers: await Na(),
        // ⚠ NOT 'include' — same reason as loadStarred: a credentialed
        // cross-origin request cannot be answered with `ACAO: *`.
        credentials: o.credentialsMode()
      });
      if (!D.ok) throw new Error(String(D.status));
      const B = await D.json();
      if (l === "shared")
        return yf.value = Array.isArray(B == null ? void 0 : B.storages) ? B.storages : [], Yt.decorate(Array.isArray(B == null ? void 0 : B.files) ? B.files : []);
      const le = Array.isArray(B == null ? void 0 : B.nodes) ? B.nodes : [];
      return Yt.decorate(le.map(Fu).filter(($e) => $e !== null));
    }
    const Um = b([]), Hm = b([]), wf = b(!1), Km = zI(), xf = x(() => SI(s.config.storages ?? [], Km.saved.value));
    function px(l) {
      AI(l, xf.value);
    }
    const $f = x(
      () => xf.value.map(
        (l) => l.usedPartial !== void 0 || !(l.name in Q.value) ? l : { ...l, usedPartial: Q.value[l.name] !== null }
      )
    );
    async function vx() {
      wf.value = !0;
      try {
        const [l, c] = await Promise.all([
          kf("recent").catch(() => []),
          kf("starred").catch(() => [])
        ]);
        Um.value = l, Hm.value = c;
      } finally {
        wf.value = !1;
      }
    }
    async function Uu(l) {
      if (Zs(), l === "home") {
        Ce.value || (He.value = M.value ?? ""), Ce.value = "home", ut.value = "", Ue.value = "", be.value = !1, Ht.value = "", Ku(), L.clear(), de.value = [], U.value = Ye.home, M.value = Ye.home, j.value = "", await vx();
        return;
      }
      if (l === "tag") {
        ut.value && await rl(ut.value, Ue.value);
        return;
      }
      if (l === "drafts") {
        Ce.value || (He.value = M.value ?? ""), Ce.value = "drafts", ut.value = "", Ue.value = "", be.value = !1, Ht.value = "", Ku(), L.clear(), de.value = [], U.value = Ye.drafts, M.value = Ye.drafts, j.value = "", await $m();
        return;
      }
      if (l === "trash") {
        Tx(), await ts(), Ce.value = "trash", ut.value = "", Ue.value = "";
        return;
      }
      F.value = !0, Ce.value || (He.value = M.value ?? ""), Ce.value = l, ut.value = "", Ue.value = "", be.value = !1, Ht.value = "", Ku(), L.clear(), U.value = Ye[l], M.value = Ye[l];
      try {
        de.value = await kf(l), j.value = "";
      } catch (c) {
        const S = c instanceof Error ? c.message : String(c);
        de.value = [], n("error", { message: S, context: { op: `nav-view:${l}` } }), it(S);
      } finally {
        F.value = !1;
      }
    }
    async function rl(l, c = "") {
      Zs();
      const S = String(l ?? "").trim();
      if (!S) return;
      F.value = !0, Ce.value || (He.value = M.value ?? ""), Ce.value = "tag", ut.value = S, Ue.value = c, be.value = !1, Ht.value = "", Ku(), L.clear();
      const D = lM(S, c);
      U.value = D, M.value = D;
      try {
        const B = await RA(
          S,
          {
            apiBase: s.config.apiBase ?? "",
            authHeaders: () => Na(),
            authCredentials: o.credentialsMode()
          },
          200,
          c
        );
        de.value = await Yt.decorate(
          B.map(Fu).filter((le) => le !== null)
        ), j.value = "";
      } catch (B) {
        const le = B instanceof Error ? B.message : String(B);
        de.value = [], n("error", { message: le, context: { op: `nav-view:tag:${c ? `${c}:` : ""}${S}` } }), it(le);
      } finally {
        F.value = !1;
      }
    }
    const Vm = b([]), Sf = b(!1);
    async function Tf(l = !1) {
      mf.value && (Vm.value = await sb({
        apiBase: s.config.apiBase ?? "",
        authHeaders: () => Na(),
        authCredentials: o.credentialsMode(),
        force: l
      }), Sf.value = !0);
    }
    function hx(l) {
      if (l === "myfiles") {
        Zs(), zt("");
        return;
      }
      Uu(l);
    }
    function qm(l) {
      Zs(), zt(ma.value ? l : "");
    }
    async function mx() {
      try {
        const l = s.config.apiBase ?? "", c = await fetch(`${l}/api/files/manager/shared-with-me?limit=1`, {
          headers: await Na(),
          credentials: o.credentialsMode()
        });
        if (!c.ok) return;
        const S = await c.json();
        yf.value = Array.isArray(S == null ? void 0 : S.storages) ? S.storages : [];
      } catch {
      }
    }
    function jm(l) {
      const c = (l ?? "").replace(/^\/+|\/+$/g, "");
      if (!c) return ma.value ? m("breadcrumb.root") : j.value || m("breadcrumb.root");
      const S = c.split("/").pop() || c, D = pd(S, m);
      return D || (Yt.segmentLabel(qt(c)) ?? S);
    }
    function yx(l) {
      $n.value = l, Mi.value = !0;
    }
    function Hu(l) {
      return ie.value ? !1 : l === void 0 || l === "editor" || l === "owner";
    }
    function Ku() {
      ke.value = "", ie.value = !1;
    }
    const gx = x(() => !!Ce.value && Ce.value !== "trash");
    function Cf(l) {
      return typeof l.perm == "string" ? l.perm : gx.value ? void 0 : ke.value;
    }
    function Wm(l) {
      if (l.read_only === !0) return !0;
      const c = typeof l.storage == "string" ? l.storage : "";
      return c ? (s.config.storages ?? []).some((S) => S.name === c && S.readOnly === !0) : !1;
    }
    function ll(l) {
      return Hu(Cf(l)) && !Wm(l);
    }
    const Ym = { none: 0, viewer: 1, editor: 2, owner: 3 };
    function bx(l) {
      if (l.length === 0) return ke.value;
      let c, S = !1;
      for (const D of l) {
        const B = Cf(D);
        if (B === void 0) {
          S = !0;
          continue;
        }
        (c === void 0 || (Ym[B] ?? 0) < (Ym[c] ?? 0)) && (c = B);
      }
      return c ?? (S ? void 0 : ke.value);
    }
    function Gm(l) {
      return l.some(Wm);
    }
    const ul = b({}), Vu = /* @__PURE__ */ new Set();
    let Ef = 0;
    Qe(
      () => [h.value, v.value],
      () => {
        Ef++, Vu.clear(), ul.value = {};
      }
    );
    function _x(l) {
      const c = v.value;
      if (!(c != null && c.length)) return;
      const S = l.filter(($e) => !($e in ul.value) && !Vu.has($e));
      if (!S.length) return;
      S.forEach(($e) => Vu.add($e));
      const D = [...c], B = Ef, le = ($e) => {
        if (B !== Ef) return;
        const Be = { ...ul.value };
        S.forEach((Xe, mt) => {
          Be[Xe] = $e[mt] ?? [], Vu.delete(Xe);
        }), ul.value = Be;
      };
      o.allowedAt(S, D).then(le, () => le(S.map(() => D)));
    }
    function Af(l, c) {
      var S;
      return !h.value || !c.length || !((S = v.value) != null && S.includes(l)) ? pl(l) : (_x(c), c.every((D) => {
        var B;
        return ((B = ul.value[D]) == null ? void 0 : B.includes(l)) ?? !1;
      }));
    }
    const Qn = x(
      () => Hu(ke.value) && Af("files.create", M.value ? [qt(M.value)] : [])
    ), qu = x(
      () => Qn.value && !_t.value && !be.value
    ), Xm = x(
      () => tc(M.value ? [qt(M.value)] : []).uploadLinks
    ), kx = x(
      () => $n.value && h.value ? tc([$n.value.path]) : void 0
    ), Po = b(null), ga = b(null), Jm = b(null), gn = b(!1), Zm = b(!1);
    let Li, Fn;
    function zf(l) {
      Zm.value = !!(l && "matches" in l && l.matches);
    }
    Kt(() => {
      var l;
      typeof ResizeObserver < "u" && ga.value && (Li = new ResizeObserver((c) => {
        var D, B, le;
        const S = ((B = (D = c[0]) == null ? void 0 : D.contentRect) == null ? void 0 : B.width) ?? ((le = ga.value) == null ? void 0 : le.clientWidth) ?? 0;
        gn.value = S > 0 && S < 560;
      }), Li.observe(ga.value)), typeof window < "u" && window.matchMedia && (Fn = window.matchMedia("(pointer: coarse)"), zf(Fn), (l = Fn.addEventListener) == null || l.call(Fn, "change", zf));
    }), Mt(() => {
      var l;
      Li == null || Li.disconnect(), Li = void 0, (l = Fn == null ? void 0 : Fn.removeEventListener) == null || l.call(Fn, "change", zf), Fn = void 0;
    });
    const fn = b(null);
    let Sn, Ii = null;
    function ra(l, c) {
      fn.value = l, Sn && clearTimeout(Sn), Sn = setTimeout(Qm, c);
    }
    function it(l) {
      ra({ message: l }, vo);
    }
    function Qm() {
      Sn = void 0, fn.value = null;
      const l = Ii;
      Ii = null, l && ra({ message: l.message, source: "drag-out" }, l.ms);
    }
    Mt(() => {
      Sn && clearTimeout(Sn), Sn = void 0, Ii = null;
    });
    const es = x(() => {
      if (Ce.value || Ae.value || ce.value) return null;
      const l = !!R.value, c = Tn(U.value).replace(/^\/+|\/+$/g, "") === "";
      return o7({
        map: Q.value,
        adapter: j.value,
        searching: l,
        crossStorage: l && c && Object.keys(Q.value).length > 1,
        admin: Sa.value
      });
    });
    async function wx(l) {
      if (!l || Pe(l)) return;
      q.value = { ...q.value, [l]: 0 };
      const c = () => {
        const { [l]: B, ...le } = q.value;
        q.value = le;
      };
      let S;
      try {
        const B = Mn(s.config), le = await o.jsonFetch(`${B}/api/admin/storages`), $e = Array.isArray(le) ? le.find((Xe) => Xe.name === l) : void 0;
        if (!$e) throw new Error("no such storage");
        const Be = await o.jsonFetch(`${B}/api/admin/storages/${$e.id}/sync`, { method: "POST" });
        S = $e.id, q.value = { ...q.value, [l]: S }, it((Be == null ? void 0 : Be.status) === "running" ? m("coverage.catalog_joined", { storage: l }) : m("coverage.catalog_started"));
      } catch (B) {
        c(), ra({ message: xa(B) }, Oa);
        return;
      }
      const D = await ae().scan(S);
      c(), D !== null && (D.status === "ok" ? (it(m("coverage.catalog_done", { storage: l })), await zt()) : D.status === "failed" ? ra({ message: m("coverage.catalog_failed", { storage: l }) }, Oa) : D.status === "aborted" ? ra({ message: m("coverage.catalog_stopped", { storage: l }) }, Oa) : D.status === "gone" ? ra({ message: m("coverage.catalog_gone", { storage: l }) }, Oa) : ra({ message: m("coverage.catalog_unfollowed", { storage: l }) }, Oa));
    }
    function ju(l, c) {
      ra({ message: l, actionLabel: m("toast.undo"), action: c, after: { kind: "undo" } }, 8e3);
    }
    function ey() {
      Sn && clearTimeout(Sn), Qm();
    }
    async function xx() {
      const l = fn.value, c = l == null ? void 0 : l.action;
      if (Sn && clearTimeout(Sn), Sn = void 0, fn.value = null, !l || !c) return;
      const S = l.after ?? { kind: "undo" }, D = S.kind === "plain", B = D && l.source ? "drag-out-stopping" : void 0;
      ra({ message: W_(S, "running", void 0, m), source: B }, Il);
      try {
        const le = await c();
        ra({ message: W_(S, "done", le, m), source: B }, vo), D || await zt();
      } catch (le) {
        D ? ra({ message: xa(le) }, Oa) : it(m("toast.undo_failed"));
      }
    }
    const ma = x(() => s.config.multiStorageRoot === !0);
    function $x(l) {
      const c = l.replace(/^\/+|\/+$/g, "");
      if (!c) return { adapter: "", rel: "" };
      const S = c.indexOf("/");
      return S === -1 ? { adapter: c, rel: "" } : { adapter: c.slice(0, S), rel: c.slice(S + 1) };
    }
    function Wu(l) {
      if (l.includes("://")) return l;
      const { adapter: c, rel: S } = $x(l);
      return c ? S ? `${c}://${S}` : `${c}://` : "";
    }
    function Qs(l) {
      const c = l.indexOf("://");
      if (c === -1) return l.replace(/^\/+|\/+$/g, "");
      const S = l.slice(0, c), D = l.slice(c + 3).replace(/^\/+|\/+$/g, "");
      return D ? `${S}/${D}` : S;
    }
    function ty() {
      return (s.config.storages ?? []).map((c) => ({
        type: "dir",
        path: c.name,
        // virtual path (no adapter prefix)
        basename: c.label || c.name,
        extension: "",
        storage: c.name,
        visibility: "private",
        file_size: 0,
        mime_type: "inode/storage",
        extra_metadata: { driver: c.driver, readOnly: c.readOnly }
      }));
    }
    function ay() {
      var l;
      nM(!fd.value), zt(), (l = na.value) == null || l.reload();
    }
    function ny() {
      zt(), Fm(), n("refresh");
    }
    async function zt(l) {
      pe.value = !1;
      const c = st(l ?? M.value ?? "");
      if (c) {
        if (!(c.kind === "trash" ? s.config.trashVisible !== !1 : nl.value))
          return Pf(""), await zt("");
        c.kind === "tag" ? await rl(c.tag, c.tagKind) : await Uu(c.kind);
        return;
      }
      const S = String(M.value ?? "").replace(/^\/+|\/+$/g, ""), D = (le) => {
        String(le ?? "").replace(/^\/+|\/+$/g, "") !== S && (L.clear(), ve.value = []);
      };
      F.value = !0, be.value = !1, Ce.value = "", ut.value = "", Ue.value = "";
      let B = l ?? M.value ?? "";
      try {
        if (ce.value = "", X.value = "", N) {
          const bt = String(B).replace(/^\/+|\/+$/g, "");
          (!bt || !(bt === N || bt.startsWith(N + "/"))) && (B = N);
        }
        if (ma.value && !Wu(B)) {
          if (kt.value) return await zt(kt.value);
          D(""), M.value = "", j.value = "", U.value = "", Ht.value = "", de.value = ty();
          return;
        }
        const le = ma.value ? Wu(B) : qt(B), Be = !!R.value && Nu.value !== "name" ? await Im(Nu.value, R.value, le) : null, Xe = Be ? {
          adapter: j.value,
          storages: (s.config.storages ?? []).map((bt) => bt.name),
          dirname: U.value,
          read_only: !1,
          files: Be.rows,
          truncated: Be.truncated
        } : R.value ? await pg(le, R.value) ?? await o.search(le, R.value) : await o.index(le);
        Xe.files = await Yt.decorate(Xe.files, {
          root: typeof Xe.e2e_root == "string" && Xe.e2e_root ? Xe.e2e_root : null
        }), pe.value = !!R.value && Fp(Xe.files.length, Ec, Xe.truncated), Array.isArray(Xe.storage_info) && (Q.value = s7(Xe.storage_info)), j.value = Xe.adapter, U.value = Xe.dirname, ke.value = Xe.perm || "", ie.value = Xe.read_only === !0, Ht.value = typeof Xe.e2e_root == "string" ? Xe.e2e_root : "";
        const mt = ma.value ? Qs(Xe.dirname) : Tn(Xe.dirname);
        D(mt), de.value = Rl(Xe.files), n1(de.value, Xe.adapter, Xe.dirname, s.config.trashVisible !== !1, {
          isSearchResult: !!R.value,
          navOffersTrash: zm.value
        }) && s1(de.value, Xe.adapter, o), M.value = mt;
      } catch (le) {
        const $e = le instanceof Error ? le.message : String(le), Be = le.status;
        if (Be === 404 || Be === 403) {
          ce.value = String(B), D(String(B)), Ht.value = "", de.value = [], n("error", { message: $e, context: { path: l } });
          return;
        }
        X.value = $e, Z = typeof B == "string" ? B : void 0, n("error", { message: $e, context: { path: l } }), de.value.length > 0 && it($e);
      } finally {
        F.value = !1;
      }
    }
    function Tn(l) {
      const c = l.indexOf("://");
      return c === -1 ? l : l.slice(c + 3);
    }
    function Sx() {
      ce.value = "", Pf(""), zt("");
    }
    const Yu = b(null), eo = b(!1), Gu = b(!1), cl = b(!1), Mf = b(null);
    let sy = !1;
    Mt(() => {
      sy = !0, re == null || re.stop();
    });
    async function Tx() {
      try {
        const l = await fetch(`${s.config.apiBase ?? ""}/api/admin/protection`, {
          headers: await Na(),
          credentials: o.credentialsMode()
        });
        if (!l.ok) {
          Yu.value = null, eo.value = !1;
          return;
        }
        const c = await l.json(), S = c == null ? void 0 : c.trash_retention_days;
        Yu.value = typeof S == "number" && S > 0 ? S : null, eo.value = !0;
      } catch {
      }
    }
    const Cx = x(
      () => Yu.value !== null ? m("trash.retention", { days: Yu.value }) : m("trash.retention_unknown")
    ), oy = x(
      () => de.value.reduce((l, c) => {
        const S = typeof c.size == "number" ? c.size : c.file_size;
        return l + (typeof S == "number" ? S : 0);
      }, 0)
    ), Ex = x(() => oy.value > 0), Ax = x(
      () => Ex.value ? "trash.empty_confirm_body" : "trash.empty_confirm_body_nosize"
    ), iy = x(() => {
      const l = Mf.value;
      if (!(l != null && l.running)) return "";
      if (l.queued) return m("trash.emptying_queued");
      const c = new Intl.NumberFormat(kn(g.value));
      return m("trash.emptying", { done: c.format(l.scanned ?? 0), total: c.format(l.total ?? 0) });
    });
    async function zx() {
      if (cl.value = !1, !eo.value || Gu.value) return;
      Gu.value = !0;
      const l = `${s.config.apiBase ?? ""}/api/admin/trash/empty`;
      try {
        const c = await zee({
          start: async () => fetch(l, { method: "POST", headers: await Na(), credentials: o.credentialsMode() }),
          status: async () => fetch(l, { headers: await Na(), credentials: o.credentialsMode() }),
          /* The run is an ops row: it goes into the operations centre (progress,
           * Cancel) the moment the server names it — a run done within the wait
           * as well, like any other operation the person started. */
          onStart: (S) => {
            S.op_id && I.register({
              id: S.op_id,
              kind: "trash-empty",
              status: S.running ? S.queued ? "pending" : "running" : S.cancelled ? "cancelled" : "ok",
              total: S.total ?? 0,
              done: S.scanned ?? 0
            });
          },
          onProgress: (S) => {
            Mf.value = S;
          },
          onBusy: () => it(m("trash.empty_busy")),
          stopped: () => sy
        });
        if (c === null) return;
        if (c.error) throw new Error(m("trash.empty_stopped", { error: c.error }));
        if (be.value && await ts(), !c.started_at) return;
        if (c.cancelled) {
          it(m("trash.empty_cancelled", { count: c.purged ?? 0 }));
          return;
        }
        it(c.failed ? m("trash.emptied_partly", { count: c.failed }) : m("trash.emptied"));
      } catch (c) {
        if (c instanceof s2) {
          it(m("trash.empty_busy"));
          return;
        }
        const S = c instanceof Error ? c.message : String(c);
        n("error", { message: S, context: { op: "trash:empty" } }), it(S);
      } finally {
        Mf.value = null, Gu.value = !1;
      }
    }
    async function ts() {
      F.value = !0, ze.value = j.value || "", be.value = !0, Ht.value = "", L.clear();
      try {
        const { entries: l } = await o.listTrash(), c = l.map(
          (S) => ({
            type: "file",
            id: S.id,
            /* ⚠ The ORIGINAL path, which the server sends with its leading
               slash: `depo:///x.txt` put an empty segment in the Location
               column ("depo/"), so it is dropped here. */
            path: S.storage_name ? `${S.storage_name}://${S.path.replace(/^\/+/, "")}` : S.path,
            basename: S.name,
            extension: S.name.includes(".") && S.name.split(".").pop() || "",
            storage: S.storage_name || "",
            visibility: "private",
            /* tablo:t1 — ⚠ BOTH. Every view reads `size` (the Size column, the
               info panel, the empty-trash confirmation); only the upload code
               reads `file_size`. Setting one of the two left every trashed row
               with a blank Size cell and made "this permanently deletes 2 items
               (0 B)" a false statement about two real files. */
            size: S.size,
            file_size: S.size,
            mime_type: S.mime || "",
            /* The date the Trash's date column prints and sorts by — WHEN it was
               deleted. A trashed row has no modification date to show, and the
               column read "—" for every row. */
            last_modified: Date.parse(S.deleted_at) || void 0,
            extra_metadata: {
              deleted_at: S.deleted_at,
              ttl_days: S.ttl_days ?? null,
              /* A permanent delete is on its way for it (purgeSelection). */
              purging: Fi.value.has(S.id),
              /* #71 — a discarded draft of the asker's: its Location reads
                 "Drafts" (ListView), which is where Restore puts it back. */
              ...S.draft ? { draft: !0 } : {}
            },
            /* Who put it here — the Trash draws it where a folder draws the
               owner. Keys absent when nobody is named, as the listing sends. */
            ...S.deleted_by_id !== void 0 ? { deleted_by_id: S.deleted_by_id } : {},
            ...S.deleted_by_name ? { deleted_by_name: S.deleted_by_name } : {},
            ...S.deleted_by_self ? { deleted_by_self: !0 } : {},
            /* wiring:e2 names — the encrypted folder it was deleted from. */
            ...S.e2e_root ? { e2e_root: S.e2e_root } : {}
          })
        );
        de.value = await Yt.decorate(c), U.value = ".trash", M.value = ".trash";
      } catch (l) {
        const c = l instanceof Error ? l.message : String(l);
        n("error", { message: c, context: { op: "trash-list" } }), it(c);
      } finally {
        F.value = !1;
      }
    }
    function qt(l) {
      if (l && l.includes("://")) return l;
      if (ma.value) {
        const c = Wu(l ?? "");
        return c || (j.value ? `${j.value}://` : "");
      }
      return l ? `${j.value}://${l.replace(/^\/+/, "")}` : `${j.value}://`;
    }
    function Ss(l) {
      const c = l.indexOf("://"), S = (c === -1 ? l : l.slice(c + 3)).replace(/\/+$/, ""), D = S.lastIndexOf("/");
      return D === -1 ? S : S.slice(D + 1);
    }
    function Ts(l) {
      const c = l.indexOf("://"), S = c === -1 ? "" : l.slice(0, c + 3), D = (c === -1 ? l : l.slice(c + 3)).replace(/\/+$/, ""), B = D.lastIndexOf("/");
      return B === -1 ? S : S + D.slice(0, B);
    }
    function Df(l, c) {
      const S = (D) => {
        const B = D.indexOf("://"), le = B === -1 ? "" : D.slice(0, B + 3), $e = (B === -1 ? D : D.slice(B + 3)).replace(/\/+$/, "");
        return le + $e;
      };
      return S(l) === S(c);
    }
    function Cs(l, c) {
      return l ? l.endsWith("://") || l.endsWith("/") ? l + c : `${l}/${c}` : c;
    }
    async function ry(l, c) {
      try {
        const S = await o.index(c), D = new Set((S.files ?? []).map((B) => String(B.basename ?? "").toLowerCase()));
        return l.some((B) => D.has(Ss(B).toLowerCase()));
      } catch {
        return !0;
      }
    }
    function ly(l, c, S, D, B) {
      if (!D || !S || B) return;
      const le = c.map(($e) => Cs(S, Ss($e)));
      le.length !== 0 && P.set(l, {
        message: m("toast.moved"),
        fn: async () => {
          const { op: $e } = await o.moveAsync(le, D, S);
          return I.register($e), { queued: !0 };
        }
      });
    }
    Qe(
      () => R.value,
      () => void zt()
    );
    function Xu() {
      return s.config.pathPersist ?? "hash";
    }
    function uy() {
      const l = Xu();
      return l === "hash" || l === "hash+localStorage";
    }
    function Mx(l) {
      try {
        return decodeURIComponent(l);
      } catch {
        return l;
      }
    }
    function cy() {
      try {
        return localStorage.getItem(sv) || "";
      } catch {
        return "";
      }
    }
    function dy() {
      const l = window.location.hash || "";
      return l.startsWith("#") ? Mx(l.slice(1)).replace(/^\/+|\/+$/g, "") : "";
    }
    function Dx() {
      if (typeof window > "u") return "";
      const l = Xu();
      if (l === "none") return "";
      if (l === "localStorage") return cy();
      const c = dy();
      return c || l === "hash" ? c : K ? "" : cy();
    }
    function Pf(l) {
      if (typeof window > "u") return;
      const c = Xu();
      if (c === "none") return;
      if (c === "localStorage" || c === "hash+localStorage") {
        try {
          l ? localStorage.setItem(sv, l) : localStorage.removeItem(sv);
        } catch {
        }
        if (c === "localStorage") return;
      }
      const S = l ? l.split("/").map(encodeURIComponent).join("/") : "", D = S ? `#${S}` : "";
      (window.location.hash || "") !== D && history.replaceState(
        history.state,
        "",
        D || window.location.pathname + window.location.search
      );
    }
    function fy() {
      if (!uy()) return;
      const l = dy();
      l && l !== M.value && zt(l);
    }
    Qe(M, (l) => {
      Pf(l), n("navigate", { path: l }), $.subscribe(A(l));
    }), a({
      reload: () => zt(),
      /* App plugins — a notification's `target.open` lands here (see the
         function's own note for why this is a method and not a prop). */
      openAppTarget: cn,
      /* A notification's destination, carried out in this explorer — the desktop
         app hands a clicked OS notification here (see the function's note). */
      revealNotification: _a
    }), Kt(async () => {
      var c;
      Id();
      const l = Dx();
      try {
        await zt(l || void 0);
      } finally {
        va();
      }
      await Jt(), (c = ga.value) == null || c.focus(), Pu(), mx(), Tf(), Fm(), Qe(mf, (S) => {
        S && !Sf.value && Tf();
      }), uy() && window.addEventListener("hashchange", fy), o.endpoints.opsList && I.startPolling(), ht();
    });
    const Ju = b(!1), Zu = b(!1);
    function Of() {
      return { configured: (s.config.storages ?? []).map((l) => l.name), current: j.value };
    }
    function Ri(l) {
      const c = s.config.accountSearch, S = l.account;
      return !c || !S || S.id === c.self.id ? null : S;
    }
    function dl(l) {
      return SH(l, Ri(l) ? { configured: [], current: "" } : Of());
    }
    async function Px(l) {
      var B;
      if (!l.some((le) => typeof le.e2e_root == "string" && le.e2e_root)) return l;
      const c = j.value || ((B = (s.config.storages ?? [])[0]) == null ? void 0 : B.name) || "", S = await Promise.all(
        l.map((le) => Yt.decorate([qc(le, c)]).then(($e) => $e[0] ?? null))
      ), D = [];
      return l.forEach((le, $e) => {
        const Be = S[$e];
        Be && D.push(Be.e2e_stored ? { ...le, name: Be.basename, e2e_display_dir: Be.e2e_display_dir } : le);
      }), D;
    }
    async function Ox(l) {
      const c = o.globalSearch(l, { limit: 8, scope: "all" }).then(Px), S = s.config.accountSearch;
      if (!S) return c;
      let D = [];
      try {
        D = await S.others() ?? [];
      } catch {
        D = [];
      }
      if (D.length === 0) return c;
      const B = [S.self, ...D], le = await Promise.allSettled([
        c,
        ...D.map((Be) => S.search(Be.id, l, { limit: 8, scope: "all" }))
      ]), $e = [];
      return le.forEach((Be, Xe) => {
        if (!(Be.status !== "fulfilled" || !Array.isArray(Be.value)))
          for (const mt of Be.value) $e.push({ ...mt, account: B[Xe] });
      }), $e;
    }
    async function Lx(l) {
      const c = T0(l);
      if (!c) return;
      const S = l.type === "dir", D = c.lastIndexOf("/"), B = S ? c : D === -1 ? "" : c.slice(0, D);
      let le = B;
      if (ma.value) {
        const Xe = Xv(l, Of());
        if (!Xe) return;
        le = B ? `${Xe}/${B}` : Xe;
      }
      if (await zt(le), S) return;
      const $e = String(l.name ?? c.slice(D + 1)), Be = de.value.find((Xe) => Xe.type === "file" && Xe.basename === $e);
      Be && (L.click(Be.path), Cn(Be));
    }
    function Lf(l) {
      return (c) => n("error", { message: (c == null ? void 0 : c.message) ?? String(c), context: { op: l } });
    }
    function Ix(l) {
      const c = Ri(l), S = s.config.accountSearch;
      if (c && S) {
        const D = dl(l);
        D && Promise.resolve(S.open(c.id, D)).catch(Lf("search-open"));
        return;
      }
      Lx(l);
    }
    function Rx(l, c) {
      const S = dl(l);
      if (!S) return !1;
      if (Ri(l)) {
        const D = s.config.accountSearch;
        return c === "download" ? !!(D != null && D.download) : !!(D != null && D.dragStart);
      }
      return c === "download" ? !0 : !!Kn.value || S.type === "file" && (Np(s.config.auth) || Sy.value);
    }
    function Nx(l) {
      if (Ri(l)) return;
      const c = dl(l);
      c && c.type === "file" && Ey(c.path);
    }
    function Bx(l) {
      const c = dl(l);
      if (!c) return;
      const S = Ri(l);
      if (S) {
        const D = s.config.accountSearch;
        D != null && D.download && Promise.resolve(D.download(S.id, c)).catch(Lf("search-download"));
        return;
      }
      ac([qc(l, Xv(l, Of()))]);
    }
    function Fx(l, c) {
      const S = dl(l);
      if (!S || !c.dataTransfer) {
        c.preventDefault();
        return;
      }
      c.dataTransfer.effectAllowed = "copy";
      const D = Ri(l);
      if (D) {
        const B = s.config.accountSearch;
        c.preventDefault(), B != null && B.dragStart && Promise.resolve(B.dragStart(D.id, [S])).catch(Lf("drag-out"));
        return;
      }
      $y(c, [S], null, typeof l.mime == "string" ? l.mime : void 0);
    }
    function Ux() {
      Wo(), Ui();
    }
    wC(ga, {
      onDelete: () => {
        if (be.value && !Ta.value && !eo.value) {
          L.isEmpty.value || it(m("toast.trash_retention"));
          return;
        }
        if (Ta.value) {
          const l = Ba.nodes.value;
          l.length && (Oo.value = l, Jn.value = !0, dn.value = !0);
        } else L.isEmpty.value || (Jn.value = !1, dn.value = !0);
      },
      onRename: () => {
        if (Ta.value) {
          const l = Ba.nodes.value;
          l.length === 1 && (Ai.value = l[0], Jn.value = !0, Gs.value = !0);
        } else L.nodes.value.length === 1 && (Ai.value = L.nodes.value[0], Jn.value = !1, Gs.value = !0);
      },
      onSelectAll: () => Ta.value ? Ba.selectAll() : L.selectAll(),
      onOpen: () => {
        if (Ta.value) {
          const c = Ba.nodes.value[0];
          c && X$("split", c);
          return;
        }
        const l = L.nodes.value[0];
        l && Cn(l);
      },
      onClose: () => {
        var l;
        if (yn.value = !1, Gs.value = !1, dn.value = !1, Ra.value && ov(Ra.value.path) || (Bn.value = !1), (l = Po.value) == null || l.hide(), ey(), Q2.value) {
          Ru();
          return;
        }
        if (Do.value) {
          Zs();
          return;
        }
        gn.value && Em();
      },
      onFocusSearch: () => {
        var l;
        return (l = Jm.value) == null ? void 0 : l.focusSearch();
      },
      onCut: () => Ta.value ? Zy() : r$(),
      onCopy: () => Ta.value ? Qy() : l$(),
      onPaste: () => Ta.value ? void eg() : void yy(),
      onGoUp: () => {
        var l;
        return Ta.value ? (l = na.value) == null ? void 0 : l.goUp() : tt();
      },
      /* cila:c wiring */
      onPathJump: () => {
        bf.value = "", Ju.value = !0;
      },
      onShowHelp: () => {
        Zu.value = !0;
      },
      /* /cila:c wiring */
      onQuickLook: () => O$(),
      onToggleHidden: () => ay(),
      onStar: () => void pt(L.nodes.value),
      onToggleInspector: () => hf(),
      /* wiring:d1 — tab actions (registry: tab-new/close/next/prev) */
      onTabNew: () => ip(),
      onTabClose: () => Fy(op.value),
      onTabNext: () => K$(),
      onTabPrev: () => V$(),
      /* /wiring:d1 */
      /* tus:t1 — the menu verbs, routed through the SAME dispatcher the right-click
       * menu and the toolbar use (dispatchItemAction), so a key and a click cannot
       * drift apart. The ones that act on a selection do nothing without one, which
       * is what the menu does too. */
      onNewFolder: () => {
        yn.value = !0;
      },
      onUpload: () => to(),
      onRefresh: () => void zt(),
      onDownload: () => void ns("download", Za()),
      onPreview: () => void ns("preview", Za()),
      /* The share dialog is a door that makes links: the key opens it only where
         the menu offers Share (a role without any sharing permission gets
         nothing from the key either). */
      onShare: () => {
        const l = Za();
        a$("access", l) && ns("access", l);
      },
      onTags: () => void ns("tags", Za()),
      onOpenTab: () => void ns("open-tab", Za()),
      onCopyPath: () => {
        const l = Za()[0];
        l && ic(l.path);
      },
      onCopyId: () => void ns("copy-id", Za()),
      onRestore: () => void ns("restore", Za()),
      /* /tus:t1 */
      hasSelection: () => !L.isEmpty.value
    });
    function Za() {
      return Ta.value ? Ba.nodes.value : L.nodes.value;
    }
    const Hx = /* @__PURE__ */ new Set([
      "docx",
      "xlsx",
      "pptx",
      "doc",
      "xls",
      "ppt",
      "odt",
      "ods",
      "odp"
    ]);
    function Cn(l) {
      if (l.basename === ".trash") {
        ts();
        return;
      }
      const c = Cu(l, { t: m });
      if (c) {
        ra({ message: c.why }, 8e3);
        return;
      }
      if (l.type === "dir") {
        const D = ma.value ? Qs(l.path) : Tn(l.path);
        zt(D);
        return;
      }
      if (Yo(l) && !oa.value && !l.e2e_root) {
        Pt.open(l);
        return;
      }
      if (l.type === "file" && !oa.value && typeof l.e2e_root == "string" && l.e2e_root) {
        const D = zn(l.path);
        zt(ma.value ? Qs(D) : Tn(D));
        return;
      }
      if (Wa.value && l.type === "file") {
        pp(l);
        return;
      }
      if (pc.value && l.type === "file") return;
      if (Qp(s.config, l) === "host") {
        n("file-opened", { path: l.path, basename: l.basename }), Nt(l);
        return;
      }
      const S = (l.extension || "").toLowerCase();
      Js.value = ll(l) ? Vx(S) : "view", ge.value = null, ee(l).length && ll(l) && (Js.value = "edit"), Ra.value = l, Bn.value = !0, n("file-opened", { path: l.path, basename: l.basename }), Nt(l);
    }
    const Kx = /* @__PURE__ */ new Set([
      ...Hx,
      "drawio",
      "dio",
      "pdf",
      "epub",
      "ipynb",
      "tiff",
      "tif",
      "psd",
      "mmd",
      "mermaid",
      "glb",
      "gltf",
      "obj",
      "stl",
      "fbx",
      "3ds",
      "zip",
      "rar",
      "7z",
      "tar",
      "gz",
      "tgz",
      "jpg",
      "jpeg",
      "png",
      "webp",
      "gif",
      "bmp",
      "avif",
      "svg",
      "heic",
      "mp4",
      "webm",
      "mov",
      "mkv",
      "m4v",
      "ogv",
      "mp3",
      "wav",
      "ogg",
      "flac",
      "m4a",
      "aac",
      "opus"
    ]);
    function Vx(l) {
      return Kx.has(l) ? "view" : "edit";
    }
    const If = b(!1);
    async function qx(l) {
      if (If.value) return;
      const c = l ?? L.nodes.value;
      if (c.length !== 0) {
        If.value = !0;
        try {
          if (be.value) {
            const B = c.map((bt) => bt.id).filter((bt) => typeof bt == "number");
            if (Yn("restore")) {
              const { ops: bt } = await o.restoreQueued(B);
              for (const pa of bt) I.register(pa);
              it(m("toast.restoring", { n: B.length })), L.clear();
              return;
            }
            ra({ message: m("toast.restoring", { n: B.length }) }, Il);
            const { restored: le, taken: $e, failed: Be, failure: Xe } = await o.restoreIds(B), mt = _ae({ restored: le, taken: $e, failed: Be, reason: Xe === void 0 ? void 0 : xa(Xe) }, m);
            ra({ message: mt.message }, mt.failure ? Oa : vo), L.clear(), await ts();
            return;
          }
          if (!o.endpoints.restore) return;
          const S = c.map((B) => B.path), { restored: D } = await o.restore(S);
          it(m("toast.restored", { n: D })), L.clear(), await zt();
        } catch (S) {
          ra({ message: xa(S) }, Oa), n("error", { message: S.message, context: { op: "restore" } });
        } finally {
          If.value = !1;
        }
      }
    }
    function Rf(l) {
      if (Yo(l) && !oa.value && !l.e2e_root) {
        Pt.open(l);
        return;
      }
      if (Wa.value && l.type === "file") {
        pp(l);
        return;
      }
      Js.value = "view", ge.value = null, Ra.value = l, Bn.value = !0, Nt(l);
    }
    function jx(l) {
      if (l.type === "dir") {
        const $e = ma.value ? Qs(l.path) : Tn(l.path);
        zt($e);
        return;
      }
      if (Yo(l) && !oa.value && !l.e2e_root) {
        Pt.open(l);
        return;
      }
      if (oa.value) {
        Wa.value && pp(l);
        return;
      }
      if (s.config.openInHost) {
        Cn(l);
        return;
      }
      if (!ll(l)) {
        Rf(l);
        return;
      }
      const c = (l.extension || "").toLowerCase(), S = s.config.openPageBase;
      if (!S) {
        Cn(l);
        return;
      }
      const D = Oy(S), B = D.includes("?") ? "&" : "?", le = `${D}${B}path=${encodeURIComponent(l.path)}&type=${encodeURIComponent(c)}&mode=edit`;
      window.open(le, "_blank", "noopener"), n("file-opened", { path: l.path, basename: l.basename }), Nt(l);
    }
    const as = b("selection"), Nf = b(""), Oo = b([]), Wx = b(""), Yx = x(() => {
      const l = Za();
      return l.length === 0 ? "none" : l.length === 1 ? l[0].type === "dir" ? "single-dir" : "single-file" : "multi";
    });
    async function Bf(l) {
      const c = Za();
      if (l === "open") {
        c[0] && Cn(c[0]);
        return;
      }
      await ns(l, c);
    }
    const Un = x(() => s.config.desktopSync ?? null), Qu = b([]);
    async function Lo() {
      if (Un.value)
        try {
          Qu.value = await Un.value.kept();
        } catch {
        }
    }
    const Ni = b(null);
    async function py() {
      const l = Un.value;
      if (l != null && l.status)
        try {
          Ni.value = (await l.status()).active ?? null;
        } catch {
          Ni.value = null;
        }
    }
    let Bi = null, Ff = !0;
    function Gx() {
      Bi || !Ff || (Bi = setTimeout(() => {
        Bi = null, Ff && (py(), Lo());
      }, 300));
    }
    Kt(() => {
      var l, c;
      Lo(), py(), (c = (l = Un.value) == null ? void 0 : l.onChange) == null || c.call(l, Gx);
    }), Mt(() => {
      Ff = !1, Bi && (clearTimeout(Bi), Bi = null);
    });
    function fl(l) {
      const c = String(l.path ?? "");
      return c.includes("://") ? c.replace(/\/+$/, "") : `${c}://`;
    }
    function ec(l, c) {
      return c.endsWith("://") ? l.startsWith(c) && l !== c : l === c ? !1 : l.startsWith(c + "/");
    }
    function Uf(l) {
      return Qu.value.some((c) => c.remote === l) ? "kept" : Qu.value.some((c) => ec(l, c.remote)) ? "inherited" : Qu.value.some((c) => ec(c.remote, l)) ? "partial" : "none";
    }
    function vy(l) {
      if (!Un.value || Ae.value || l.basename === ".trash") return null;
      const c = fl(l), S = Ni.value;
      if (S && (c === S.remote || ec(c, S.remote) || ec(S.remote, c)))
        return "syncing";
      const D = Uf(c);
      return D === "kept" || D === "inherited" ? "kept" : D === "partial" ? "partial" : "cloud";
    }
    const Xx = x(() => {
      const l = Ni.value;
      if (!l) return "";
      const c = l.remote.endsWith("://") ? l.remote.slice(0, -3) : l.remote.slice(l.remote.lastIndexOf("/") + 1);
      return l.phase === "transfer" && l.total > 0 ? m("keep.strip_transfer", {
        name: c,
        done: String(l.done),
        total: String(l.total),
        pct: String(Math.min(100, Math.round(l.done * 100 / l.total)))
      }) : l.phase === "settling" ? m("keep.strip_settling", { name: c }) : m("keep.strip_inventory", { name: c });
    }), hy = x(() => {
      const l = Ni.value;
      return !l || l.phase !== "transfer" || l.total <= 0 ? null : Math.min(100, Math.round(l.done * 100 / l.total));
    });
    function Hf(l) {
      var B, le, $e;
      const c = Un.value, S = l.length === 1 && (((B = l[0]) == null ? void 0 : B.type) === "dir" || ((le = l[0]) == null ? void 0 : le.type) === "file");
      if (!c || !S || Ae.value || oa.value || (($e = l[0]) == null ? void 0 : $e.e2e) === !0) return [];
      const D = Uf(fl(l[0]));
      return [
        { divider: !0, key: "sep-keep", label: "" },
        { key: "keep-local", label: m("ctx.keep_local"), hidden: D === "kept" || D === "inherited" },
        { key: "keep-online", label: m("ctx.keep_online"), hidden: D !== "kept" },
        { key: "keep-inherited", label: m("ctx.keep_inherited"), disabled: !0, hidden: D !== "inherited" },
        { key: "keep-reveal", label: m("ctx.keep_reveal"), hidden: D !== "kept" && D !== "inherited" }
      ];
    }
    const Kf = b([]);
    async function Vf(l, c) {
      var D;
      as.value = "selection", Lo(), L.has(l.path) || (L.click(l.path), await Jt()), Kf.value = L.nodes.value.length ? [] : [l];
      const S = L.nodes.value.length ? L.nodes.value : [l];
      (D = Po.value) == null || D.show({ clientX: c.clientX, clientY: c.clientY }, S);
    }
    function Jx(l) {
      var c;
      l.preventDefault(), as.value = "selection", L.clear(), Kf.value = [], (c = Po.value) == null || c.show({ clientX: l.clientX, clientY: l.clientY }, []);
    }
    function Zx(l) {
      var c;
      as.value = "breadcrumb", Nf.value = l.adapterPath, Wx.value = l.label, (c = Po.value) == null || c.show({ clientX: l.x, clientY: l.y }, []);
    }
    async function my(l, c, S) {
      var D, B;
      if (Lo(), l === "split") {
        Vn.value = "split";
        const le = Ba.nodes.value;
        c && !Ba.has(c.path) && (Ba.click(c.path), await Jt());
        const $e = Ba.nodes.value;
        Oo.value = c ? $e.length > 0 ? $e : le.length > 0 ? le : [c] : [], as.value = "pane", (D = Po.value) == null || D.show({ clientX: S.clientX, clientY: S.clientY }, Oo.value);
        return;
      }
      if (Vn.value = "main", as.value = "selection", !c) {
        L.clear(), (B = Po.value) == null || B.show({ clientX: S.clientX, clientY: S.clientY }, []);
        return;
      }
      await Vf(c, S);
    }
    const Qx = x(() => {
      if (as.value === "breadcrumb")
        return [
          { key: "open", label: m("ctx.open") },
          { key: "copy-path", label: m("breadcrumb.copy_path") }
        ];
      if (as.value === "pane") {
        const le = Oo.value;
        return le.length === 0 ? [
          { key: "new-folder", label: m("toolbar.new_folder") },
          { key: "paste", label: m("ctx.paste"), disabled: !se.value.mode }
        ] : vl(le);
      }
      const l = L.nodes.value.length ? L.nodes.value : Kf.value, c = l.length > 0, S = l.length === 1;
      if (Ae.value)
        return c ? [
          { key: "restore", label: m("ctx.restore"), hidden: !pl("files.create") },
          ...eo.value ? [
            { divider: !0, key: "sep1", label: "" },
            { key: "delete", label: m("ctx.delete_perm"), danger: !0, hidden: !pl("files.purge") }
          ] : []
        ] : [];
      const D = (M.value ?? "").replace(/^\/+|\/+$/g, "");
      if (ma.value && D === "")
        return c ? S ? [
          { key: "open", label: m("ctx.open") },
          { key: "open-tab", label: m("ctx.open_new_tab") },
          // A whole storage can be kept too — that IS the "sync everything"
          // shape, and it is one pair, not one per subfolder.
          ...Hf(l)
        ] : [] : [];
      if (!c) {
        const le = [
          {
            key: "toggle-hidden",
            label: fd.value ? m("ctx.hide_hidden") : m("ctx.show_hidden")
          }
        ];
        return Hu(ke.value) ? [
          { key: "new-folder", label: m("toolbar.new_folder") },
          { key: "paste", label: m("ctx.paste"), disabled: !se.value.mode },
          ...le
        ] : le;
      }
      return vl(l);
    });
    function pl(l) {
      const c = h.value;
      return !c || c.includes(l);
    }
    const e$ = {
      rename: ["files.rename"],
      cut: ["files.move"],
      "move-to": ["files.move"],
      delete: ["files.delete"],
      download: ["files.download"],
      convert: ["files.create"],
      "copy-to": ["files.create"],
      paste: ["files.create", "files.move"],
      tags: ["files.tag"]
    };
    function tc(l) {
      return UM((c) => Af(c, l));
    }
    function t$(l, c) {
      if (!h.value) return l;
      const S = c.map((D) => D.path);
      return l.map((D) => {
        if (D.key === "access") {
          const le = c.length > 0 && c.every(($e) => $e.type === "dir");
          return HM(tc(S), le) ? D : { ...D, hidden: !0 };
        }
        const B = e$[D.key];
        return B && !B.some((le) => Af(le, S)) ? { ...D, hidden: !0 } : D;
      });
    }
    function a$(l, c) {
      return vl(c).some((S) => S.key === l && !S.hidden && !S.disabled);
    }
    function vl(l) {
      return t$(n$(l), l);
    }
    function n$(l) {
      var Ps, uo, Ya, co;
      const c = l.length > 0, S = l.length === 1;
      if (l.some(Rd))
        return S ? [
          { key: "open", label: m("ctx.open") },
          { key: "open-tab", label: m("ctx.open_new_tab") },
          ...Hf(l)
        ] : [];
      const D = S && ((Ps = l[0]) == null ? void 0 : Ps.type) === "file", B = m("ctx.tags_menu"), le = S && qf(l[0]), $e = S && typeof ((uo = l[0]) == null ? void 0 : uo.id) == "number", Be = Ke(l).length > 0, Xe = Me(l), mt = bx(l), bt = Hu(mt) && !Gm(l), pa = m("shortcuts.share"), Fa = String(((Ya = l[0]) == null ? void 0 : Ya.extension) ?? "").toLowerCase(), Va = D ? FM(Fa) ? hd(!!Ys.value, Sa.value, m("ctx.needs_onlyoffice")) : Fa === "drawio" || Fa === "dio" ? hd(!!Wr.value, Sa.value, m("ctx.needs_drawio")) : {} : {};
      return [
        { key: "open", label: m("ctx.open"), ...Va, hidden: !S || Va.hidden === !0 },
        { key: "open-tab", label: m("ctx.open_new_tab"), hidden: !S || ((co = l[0]) == null ? void 0 : co.type) !== "dir" },
        { key: "preview", label: m("ctx.preview"), hidden: !S, disabled: !D },
        /* tasi:m1 — Download works on ANY selection now. It used to disappear the
           moment a second row was ticked, because the only implementation was one
           `window.open` per node and the browser blocks the second popup; there is
           one streaming archive behind it now (lib/downloadSelection), and the
           server expands a selected folder itself, so a lone folder is a zip too.
           Inside an encrypted folder the server has no plaintext to zip: the zip
           is made in this tab (below), and a LOCKED folder downloads one row at
           a time. */
        /* wiring:e2 fxe — inside an unlocked encrypted folder a selection of any
           size downloads DECRYPTED now (a zip made in this tab); the ciphertext is
           "Download encrypted copy" below. */
        { key: "download", label: m("ctx.download"), hidden: !c || pc.value && !S, disabled: !c },
        /* wiring:e2 fxe — single encrypted files, and the ciphertext copy. */
        ...Pt.menuRows(l, {
          canWrite: bt,
          inEncrypted: oa.value,
          unlockedEncryptedCopy: Wa.value || S && kg(l[0]) !== null
        }),
        { key: "archive-create", label: m("ctx.archive_create"), hidden: !c || S && le || !bt || oa.value || Jr.value.length === 0, disabled: !c },
        { key: "archive-extract", label: m("ctx.archive_extract"), hidden: !le || !bt || oa.value, disabled: !le },
        { key: "archive-extract-here", icon: "archive-extract", label: m("archive.extract_here"), hidden: !le || !bt || oa.value, disabled: !le },
        /* tasi:m1 — VISIBLE and grey above a multi-selection, not gone. Sharing
           really is one item at a time (a share link addresses one node), and the
           row now says so in its tooltip; vanishing taught the reader that filex
           cannot share the thing they are looking at. */
        {
          key: "access",
          label: pa,
          hidden: !c || !bt || oa.value,
          disabled: !S,
          title: S ? void 0 : m("ctx.access.one_only")
        },
        { key: "details", label: m("ctx.details"), hidden: !c },
        /* wiring:e2 convert — encrypt a folder that already exists, in place. */
        { key: "e2e-convert", label: m("e2e.convert.ctx"), icon: "lock", hidden: !xS(l, bt) },
        /* ⚠ "Copy node id" is NOT here any more (owner's call, 2026-09-13): it is a
           developer's handle on a support ticket, not an everyday verb, and this
           list is rendered by BOTH the right-click menu and the selection bar — so
           one row put it in front of everyone, twice. It lives in the details
           panel now, beside Path and ETag, which is where the other technical
           facts about a file already are. The `copy-id` case below stays: the
           panel dispatches it. */
        { divider: !0, key: "sep1", label: "", hidden: !bt },
        { key: "rename", label: m("ctx.rename"), hidden: !S || !bt, disabled: !S },
        { key: "cut", label: m("ctx.cut"), hidden: !c || !bt, disabled: !c },
        { key: "copy", label: m("ctx.copy"), hidden: !c, disabled: !c },
        /* tasi:m1 — "somewhere else", without the clipboard. Cut+paste has always
           been able to do this, but only by navigating away from the rows you had
           just picked; these two ask WHERE in a dialog and leave the listing where
           it is.
           ⚠ `icon:` is not decoration here — `actionIconSvg` answers '' for a key
           it does not know, and a bar button with no glyph is an empty 28px box.
           They borrow the clipboard verbs' marks, which is what they are. */
        { key: "move-to", label: m("ctx.move_to"), icon: "cut", hidden: !c || !bt, disabled: !c },
        { key: "copy-to", label: m("ctx.copy_to"), icon: "copy", hidden: !c, disabled: !c },
        /* Paste needs a destination folder; a virtual view (Recent / Starred /
           Shared / a tag / Home) has none, so it is the one write verb the row
           menu does not carry there — every per-row verb above and below does. */
        { key: "paste", label: m("ctx.paste"), hidden: !bt || _t.value, disabled: !se.value.mode },
        { divider: !0, key: "sep-meta", label: "", hidden: !$e && !Be },
        /* yildiz:s1 — "star must be an action, like a tag" (owner, v0.30.0).
           Beside Tags on purpose: they are the same kind of verb, and this is the
           ONLY star a grid/gallery user reaches with the keyboard. Works on a
           multi-selection; the label follows the selection's state. */
        {
          key: "star",
          label: m(Xe ? "ctx.unstar" : "ctx.star"),
          icon: Xe ? "unstar" : "star",
          hidden: !Be
        },
        { key: "tags", label: B, hidden: !$e, disabled: !$e },
        /* App plugins — one row per action whose `applies` rule accepts the
           selection, under its own `sep-plugins` divider; `[]` when the feature
           is off, in the trash, or inside an encrypted folder (lib/pluginMenu). */
        ...lt(l),
        ...Da(l),
        ...Hf(l),
        { divider: !0, key: "sep2", label: "", hidden: !bt },
        { key: "delete", label: m("ctx.delete"), danger: !0, hidden: !c || !bt, disabled: !c }
      ];
    }
    const s$ = /* @__PURE__ */ new Set(["zip", "7z", "rar", "tar", "gz", "tgz", "bz2", "tbz2", "xz", "txz"]);
    function qf(l) {
      return !!l && l.type === "file" && s$.has((l.extension || "").toLowerCase());
    }
    const o$ = x(() => {
      const l = Za();
      if (Ta.value) return l.length ? vl(l).filter((S) => S.key !== "archive-extract-here") : [];
      if (Ae.value)
        return l.length === 0 ? [] : [
          { key: "restore", label: m("ctx.restore"), hidden: !pl("files.create") },
          ...eo.value ? [{ key: "delete", label: m("ctx.delete_perm"), danger: !0, hidden: !pl("files.purge") }] : []
        ];
      const c = (M.value ?? "").replace(/^\/+|\/+$/g, "");
      return ma.value && c === "" ? l.length === 1 ? [{ key: "open", label: m("ctx.open") }] : [] : l.length === 0 ? [] : vl(l).filter((S) => S.key !== "archive-extract-here");
    });
    async function i$(l, c) {
      if (as.value === "breadcrumb") {
        l.key === "open" ? zt(Tn(Nf.value)) : l.key === "copy-path" && await ic(Nf.value);
        return;
      }
      if (as.value === "pane") {
        await ns(l.key, Oo.value);
        return;
      }
      await ns(l.key, c);
    }
    function Hn() {
      return as.value === "pane" || Ta.value;
    }
    async function ns(l, c) {
      var S, D;
      if (AC(l)) {
        await Rn(l, c);
        return;
      }
      if (l.startsWith("open-with:")) {
        c[0] && (Rf(c[0]), ge.value = l.slice(10));
        return;
      }
      if ($ee(l)) {
        await Pt.dispatch(l, c, (B) => ac(B, { encrypted: !0 }));
        return;
      }
      switch (l) {
        case "clear-selection":
          Ta.value ? Ba.clear() : L.clear();
          return;
        case "open":
          c[0] && jx(c[0]);
          break;
        case "preview":
          c[0] && Rf(c[0]);
          break;
        case "e2e-convert":
          c[0] && $S(c[0]);
          break;
        case "download":
          await ac(c);
          break;
        case "archive-create":
          if (c.length === 0) break;
          Xr.value = c, Ci.value = Hn(), Ti.value = Ci.value ? qt(((S = na.value) == null ? void 0 : S.getPath()) ?? "") : qt(M.value), Gn.value = "", Ou.value = !0;
          break;
        case "archive-extract":
          if (!c[0] || !qf(c[0])) break;
          Xs.value = c[0], Ci.value = Hn(), Ti.value = Ts(c[0].path), Gn.value = "", Ao.value = !0;
          break;
        case "archive-extract-here":
          if (!c[0] || !qf(c[0])) break;
          Xs.value = c[0], Ci.value = Hn(), Ti.value = Ts(c[0].path), Gn.value = "", await Gf(c[0], Ti.value, Ci.value);
          break;
        case "move-to":
        case "copy-to":
          if (c.length === 0) break;
          Lu.value = l === "move-to" ? "move" : "copy", pf.value = c, Iu.value = !1, el.value = !0;
          break;
        case "keep-local": {
          const B = Un.value;
          if (!B || !c[0]) break;
          const le = fl(c[0]);
          try {
            await B.keep(le, c[0].type === "file" ? "file" : "dir"), await Lo(), Uf(le) !== "none" && it(m("keep.started"));
          } catch ($e) {
            await Lo(), it(`${m("keep.failed")}: ${String(($e == null ? void 0 : $e.message) ?? $e)}`);
          }
          break;
        }
        case "keep-online": {
          const B = Un.value;
          if (!B || !c[0]) break;
          try {
            await B.unkeep(fl(c[0]));
          } catch {
          }
          await Lo();
          break;
        }
        case "keep-reveal": {
          const B = Un.value;
          B && c[0] && B.reveal(fl(c[0]));
          break;
        }
        case "access":
          c[0] && ($n.value = c[0], Mi.value = !0);
          break;
        case "details":
          q2();
          break;
        case "copy-id":
          if (c[0] && typeof c[0].id == "number") {
            const B = c[0].id;
            (D = navigator.clipboard) == null || D.writeText(String(B)).then(
              () => it(m("toast.node_id_copied", { id: B })),
              () => it(`#${B}`)
            );
          }
          break;
        case "star":
          await pt(c);
          break;
        case "tags":
          c[0] && Gt(c[0]);
          break;
        case "rename":
          c[0] && (Ai.value = c[0], Jn.value = Hn(), Gs.value = !0);
          break;
        case "cut":
          Hn() ? Zy() : (se.value = { mode: "cut", items: c, sourcePath: M.value }, it(m("toast.cut_ready")));
          break;
        case "copy":
          Hn() ? Qy() : (se.value = { mode: "copy", items: c, sourcePath: M.value }, it(m("toast.copy_ready")));
          break;
        case "paste":
          Hn() ? await eg() : await yy();
          break;
        case "delete": {
          const B = Hn();
          B && (Oo.value = c), Jn.value = B, dn.value = !0;
          break;
        }
        case "restore":
          c.length > 0 && await qx(c);
          break;
        case "toggle-hidden":
          ay();
          break;
        case "new-folder":
          Jn.value = Hn(), yn.value = !0;
          break;
        case "duplicate":
          c[0] && await u$(c[0]);
          break;
        case "open-tab":
          c[0] && Uy(c[0]);
          break;
      }
    }
    function r$() {
      L.isEmpty.value || (se.value = { mode: "cut", items: L.nodes.value, sourcePath: M.value }, it(m("toast.cut")));
    }
    function l$() {
      L.isEmpty.value || (se.value = { mode: "copy", items: L.nodes.value, sourcePath: M.value }, it(m("toast.copied")));
    }
    let jf = !1;
    async function yy() {
      const l = se.value;
      if (!(!l.mode || l.items.length === 0 || jf)) {
        jf = !0;
        try {
          const c = l.items.map((Be) => Be.path), S = l.sourcePath || "";
          if (l.mode === "cut" && S === M.value) {
            it(m("toast.same_folder_cut"));
            return;
          }
          const B = qt(M.value), le = V_(c, B, l.mode === "cut" ? "move" : "copy"), $e = await hp(l.mode === "cut" ? "move" : "copy", c, B, qt(S) || void 0);
          if ($e) {
            $e.undo && $e.ops.length && P.set($e.ops[$e.ops.length - 1].id, { message: m("toast.moved"), fn: $e.undo }), $e.ops.length && it(l.mode === "cut" ? m("split.move_queued") : m("split.copy_queued")), se.value = { mode: null, items: [], sourcePath: null };
            return;
          }
          if (l.mode === "cut") {
            const Be = qt(S) || void 0, Xe = await ry(c, B), { op: mt } = await o.moveAsync(c, B, Be);
            ly(mt.id, c, B, Be, Xe), I.register(mt), it(
              Xe ? m("toast.move_kept_both") : le.cross ? m("split.cross_move") : m("split.move_queued")
            );
          } else {
            const { op: Be } = await o.copy(c, B);
            I.register(Be), it(le.cross ? m("split.cross_copy") : m("split.copy_queued"));
          }
          se.value = { mode: null, items: [], sourcePath: null };
        } catch (c) {
          Ua(c, { op: "paste" });
        } finally {
          jf = !1;
        }
      }
    }
    async function u$(l) {
      try {
        const { op: c } = await o.copy([l.path], qt(M.value));
        I.register(c);
      } catch (c) {
        Ua(c, { op: "duplicate" });
      }
    }
    function c$(l) {
      if (Wa.value) {
        dS(l);
        return;
      }
      const c = o.downloadUrl(l.path);
      window.open(c, "_blank");
    }
    const Wf = b(!1);
    async function ac(l, c = {}) {
      if (l.length !== 0 && !(!c.encrypted && await OS(l))) {
        if (l.length === 1 && l[0].type === "file") {
          if (c.encrypted) {
            window.open(o.downloadUrl(l[0].path), "_blank");
            return;
          }
          c$(l[0]);
          return;
        }
        if (!Wf.value) {
          Wf.value = !0, ra({ message: m("toast.archive.preparing") }, Il);
          try {
            const S = await Lee(o, l.map((B) => B.path)), D = l.length === 1 && l[0].e2e_stored ? `${l[0].basename}.zip` : S.name;
            it(m("toast.archive.started", { name: D, count: String(S.files) }));
          } catch (S) {
            const D = S;
            ra({ message: D.status === 409 ? m("toast.archive.empty") : xa(S) }, Oa), n("error", { message: D.message, context: { op: "archive-download" } });
          } finally {
            Wf.value = !1;
          }
        }
      }
    }
    async function d$(l) {
      var B;
      const c = pf.value;
      if (!l || c.length === 0) {
        el.value = !1;
        return;
      }
      const S = Lu.value === "move", D = Hn() ? qt(((B = na.value) == null ? void 0 : B.getPath()) ?? "") : qt(M.value);
      Iu.value = !0;
      try {
        const le = await Ki(c.map((Be) => Be.path), l, D || void 0, S ? "move" : "copy"), $e = Yt.segmentLabel(l) ?? Sr(l, l);
        le === "queued" ? it(S ? m("toast.moved_to", { name: $e }) : m("toast.copied_to", { name: $e })) : le === "nothing" && it(m("toast.already_there", { name: $e })), S && (le === "queued" || le === "done") && (Hn() ? Ba.clear() : L.clear());
      } finally {
        Iu.value = !1, el.value = !1;
      }
    }
    async function f$(l) {
      Gr.value = !1;
      const c = l.app ? `${l.app.plugin}/${l.app.view}` : null;
      if (l.draft) {
        $i.value += 1, Sm(l.draft, c), df();
        return;
      }
      const S = l.path.slice(0, l.path.lastIndexOf("/"));
      S && S !== qt(M.value) ? await zt(S) : await zt();
      const D = l.name.lastIndexOf("."), B = de.value.find((le) => le.path === l.path) ?? {
        type: "file",
        path: l.path,
        basename: l.name,
        extension: D > 0 ? l.name.slice(D + 1).toLowerCase() : ""
      };
      if (Qp(s.config, B) === "host") {
        n("file-opened", { path: B.path, basename: B.basename }), Nt(B);
        return;
      }
      zi.value = l.ext ? { path: B.path, ext: l.ext } : null, ge.value = c, Ra.value = B, Js.value = ll(B) ? "edit" : "view", Bn.value = !0, n("file-opened", { path: B.path, basename: B.basename }), Nt(B);
    }
    function p$(l) {
      const c = l == null ? void 0 : l.detail;
      if (c)
        try {
          return JSON.parse(c).code;
        } catch {
          return;
        }
    }
    function Yf(l) {
      const c = l == null ? void 0 : l.detail;
      if (c)
        try {
          const S = JSON.parse(c), D = {
            PASSWORD_REQUIRED: "archive.password_required",
            BAD_PASSWORD: "archive.bad_password",
            TARGET_EXISTS: "archive.target_exists",
            PASSWORD_CHARSET: "archive.password_charset",
            UNSUPPORTED_FORMAT: "archive.error_unsupported",
            ARCHIVE_LIMIT_EXCEEDED: "archive.error_limit",
            PROVIDER_UNAVAILABLE: "archive.error_unavailable"
          };
          if (S.code && D[S.code]) return m(D[S.code]);
          if (S.error) return S.error;
        } catch {
        }
      return (l == null ? void 0 : l.message) || m("toast.failed");
    }
    async function v$(l) {
      ff.value = !0, Gn.value = "";
      try {
        const { op: c } = await o.archiveCreate({
          dest: Cs(Ti.value, l.name),
          sources: Xr.value.map((S) => S.path),
          format: l.format,
          password: l.password,
          encrypt_filenames: l.encrypt_filenames,
          compression: l.compression,
          solid: l.solid,
          dictionary_size_mb: l.dictionary_size_mb
        });
        I.register(c), Ou.value = !1, yl.reveal(), it(m("archive.queued"));
      } catch (c) {
        Gn.value = Yf(c), n("error", { message: Gn.value, context: { op: "archive-create" } });
      } finally {
        ff.value = !1;
      }
    }
    async function Gf(l, c, S, D) {
      var $e, Be;
      if (zo.value.has(l.path)) {
        it(m("archive.already_preparing", { name: l.basename }));
        return;
      }
      zo.value = new Set(zo.value).add(l.path), Gn.value = "";
      const B = m("archive.preparing_extract", { name: l.basename }), le = setTimeout(() => {
        !Ao.value && !Si.value && ra({ message: B }, Il);
      }, 600);
      try {
        const Xe = await o.archiveExtract(l.path, {
          dest: c,
          password: D
        });
        if (Ao.value = !1, Si.value = !1, Mo.value = null, Ei.value = "", Xe.op) {
          I.register(Xe.op), yl.reveal(), it(m("archive.extraction_queued"));
          return;
        }
        S ? await (($e = na.value) == null ? void 0 : $e.reload()) : await zt(), it(m("archive.extracted", { count: Xe.count ?? 0 }));
      } catch (Xe) {
        const mt = p$(Xe);
        if (mt === "PASSWORD_REQUIRED" || mt === "BAD_PASSWORD") {
          Mo.value = { target: l, dest: c, inPane: S }, Ei.value = mt === "BAD_PASSWORD" ? m("archive.bad_password") : "", Ao.value = !1, Si.value = !0;
          return;
        }
        const bt = Yf(Xe);
        Si.value ? Ei.value = bt : Ao.value ? Gn.value = bt : ra({ message: bt }, 6e3);
      } finally {
        clearTimeout(le), ((Be = fn.value) == null ? void 0 : Be.message) === B && (fn.value = null);
        const Xe = new Set(zo.value);
        Xe.delete(l.path), zo.value = Xe;
      }
    }
    async function h$(l) {
      const c = Xs.value;
      c && await Gf(
        c,
        Cs(Ti.value, l.folder),
        Ci.value
      );
    }
    async function m$(l) {
      const c = Mo.value;
      c && (Ei.value = "", await Gf(c.target, c.dest, c.inPane, l));
    }
    function y$() {
      Si.value = !1, Mo.value = null, Ei.value = "";
    }
    async function g$(l) {
      try {
        await o.opsCancel(l), await I.poll();
      } catch (c) {
        const S = I.ops.value.find((B) => B.id === l), D = (S == null ? void 0 : S.op_type) === "archive-create" || (S == null ? void 0 : S.op_type) === "archive-extract";
        ra({ message: D ? Yf(c) : xa(c, m("plugin.cancel_failed")) }, Oa);
      }
    }
    async function b$(l) {
      var D, B;
      const c = Qr.begin();
      if (c === null) return;
      const S = Jn.value;
      try {
        const le = qt(S ? ((D = na.value) == null ? void 0 : D.getPath()) ?? "" : M.value), $e = await fg(le, l, { isDir: !0 });
        await o.newFolder(le, $e), yn.value = !1, Qr.end(c), S ? await ((B = na.value) == null ? void 0 : B.reload()) : await zt();
      } catch (le) {
        un(Qr, c, le, { op: "newfolder" });
      } finally {
        Qr.end(c);
      }
    }
    async function _$(l) {
      var B, le;
      const c = Ai.value;
      if (!c) return;
      const S = Zr.begin();
      if (S === null) return;
      const D = Jn.value;
      try {
        const $e = qt(D ? ((B = na.value) == null ? void 0 : B.getPath()) ?? "" : M.value), Be = c.path, Xe = Nc(c), mt = await fg(
          Ts(Be),
          l,
          c.type === "dir" ? { keepIdOf: Be } : {}
        ), bt = c.type === "dir" && Yn("rename");
        let pa;
        bt ? pa = (await o.renameQueued($e, Be, mt)).op : await o.rename($e, Be, mt), Gs.value = !1, Ai.value = null, Zr.end(S);
        const Fa = Cs(Ts(Be), mt), Va = mt && mt !== Xe ? async () => {
          if (!bt) {
            await o.rename($e, Fa, Xe);
            return;
          }
          const Ps = (await o.renameQueued($e, Fa, Xe)).op;
          return Ps && I.register(Ps), { queued: !0 };
        } : null;
        if (pa) {
          Va && P.set(pa.id, { message: m("toast.renamed"), fn: Va }), I.register(pa), it(m("toast.rename_queued", { name: l }));
          return;
        }
        D ? await ((le = na.value) == null ? void 0 : le.reload()) : await zt(), Va && ju(m("toast.renamed"), Va);
      } catch ($e) {
        const Be = $e, Xe = $e instanceof dg ? m("e2e.names.bad_name", { name: l }) : Be.status === 409 ? m("newdoc.err.exists", { name: l }) : xa($e);
        un(Zr, S, $e, { op: "rename" }, Xe);
      } finally {
        Zr.end(S);
      }
    }
    const Fi = b(/* @__PURE__ */ new Set()), Xf = /* @__PURE__ */ new Map(), Jf = bae();
    function nc(l, c) {
      const S = new Set(Fi.value);
      for (const D of l)
        c ? S.add(D) : S.delete(D);
      Fi.value = S;
      for (const D of de.value) {
        const B = D.id, le = D.extra_metadata;
        typeof B == "number" && l.includes(B) && le && (le.purging = c);
      }
    }
    async function k$() {
      const l = L.nodes.value.map((mt) => mt.id).filter((mt) => typeof mt == "number");
      if (l.length === 0) {
        dn.value = !1;
        return;
      }
      const c = l.filter((mt) => !Fi.value.has(mt));
      if (c.length === 0) {
        dn.value = !1, it(m("trash.row_busy"));
        return;
      }
      const S = Xn.begin();
      if (S === null) return;
      const D = Yn("purge");
      nc(c, !0);
      let B = 0, le = 0, $e, Be;
      const Xe = [];
      for (const mt of c)
        try {
          const { op: bt } = await o.purgeTrash(mt, { queued: D });
          bt ? (I.register(bt), Xe.push(bt.id), Xf.set(bt.id, mt)) : nc([mt], !1), B++;
        } catch (bt) {
          le++, $e === void 0 && ($e = xa(bt), Be = bt), nc([mt], !1);
        }
      if (Xn.end(S), B === 0) {
        un(Xn, S, Be, { op: "purge" }, $e ?? m("toast.failed"));
        return;
      }
      dn.value = !1, L.clear(), ra(
        { message: Y_({ queued: Xe.length > 0, purged: B, failed: le, reason: $e }, m) },
        le ? Oa : vo
      ), Xe.length ? Jf.start(Xe, { refused: le, reason: $e }) : be.value && await ts();
    }
    async function w$() {
      var Be, Xe, mt;
      if (Xn.busy.value) return;
      if (be.value) {
        if (!eo.value) {
          dn.value = !1, it(m("toast.trash_retention"));
          return;
        }
        await k$();
        return;
      }
      const l = Jn.value, c = l ? Oo.value : L.nodes.value, S = qt(l ? ((Be = na.value) == null ? void 0 : Be.getPath()) ?? "" : M.value), D = c.map((bt) => bt.path);
      if (D.length === 0) {
        dn.value = !1;
        return;
      }
      const B = c.map((bt) => bt.id).filter((bt) => typeof bt == "number"), le = o.endpoints.trashRestore && B.length === c.length ? async () => {
        const { restored: bt } = await o.restoreIds(B);
        if (bt === 0) throw new Error("restore failed");
        return { done: bt, total: B.length };
      } : null, $e = Xn.begin();
      if ($e !== null)
        try {
          if (o.endpoints.deleteAsync) {
            const { op: bt } = await o.deleteAsync(D, S);
            le && P.set(bt.id, { message: m("toast.trashed"), fn: le }), I.register(bt), it(m("toast.delete_queued")), dn.value = !1, Xn.end($e);
          } else
            await o.deleteItems(S, D), dn.value = !1, Xn.end($e), l ? await ((Xe = na.value) == null ? void 0 : Xe.reload()) : await zt(), le && ju(m("toast.trashed"), le);
          l ? (mt = na.value) == null || mt.reload() : L.clear();
        } catch (bt) {
          un(Xn, $e, bt, { op: "delete" });
        } finally {
          Xn.end($e);
        }
    }
    function to() {
      var l;
      if (!Qn.value) {
        it(m("toast.read_only_here"));
        return;
      }
      (l = Cm.value) == null || l.click();
    }
    function x$(l) {
      const c = l.target, S = c.files ? Array.from(c.files) : [];
      c.value = "", gy(S);
    }
    async function gy(l) {
      if (l.length === 0) return;
      const c = qt(M.value);
      if (pc.value) {
        it(m("e2e.upload.locked"));
        return;
      }
      if (Wa.value) {
        const S = await fS(l, c);
        if (l = S.files, l.length === 0) return;
        if (S.sidecars.length > 0)
          try {
            await o.uploadMultipart(c, S.sidecars);
          } catch (D) {
            n("error", { message: D.message, context: { op: "e2e-name-sidecar" } }), it(m("e2e.names.write_failed"));
            return;
          }
      }
      for (const S of l) {
        const D = ng.get(S);
        if (D) {
          await Zf(S, c, D) || it(m("e2e.upload.streaming_unsupported"));
          continue;
        }
        if (z.shouldChunk(S)) {
          const B = z.resumableFor(c, S);
          if (B && it(
            m("upload.resuming", {
              name: Io.get(S) ?? S.name,
              percent: S.size > 0 ? Math.round(B.offset / S.size * 100) : 0
            })
          ), await Zf(S, c)) continue;
        }
        await by(S, c);
      }
      await zt();
    }
    async function by(l, c) {
      const S = gr(), D = c ?? qt(M.value);
      Ia.value = [
        ...Ia.value,
        { id: S, file: l, displayName: Io.get(l), path: D, totalBytes: l.size, uploadedBytes: 0, percent: 0, status: "uploading", cancel() {
        } }
      ];
      const B = (le) => {
        const $e = Ia.value.findIndex((Xe) => Xe.id === S);
        if ($e === -1) return;
        const Be = [...Ia.value];
        Be[$e] = { ...Be[$e], ...le }, Ia.value = Be;
      };
      try {
        await o.uploadMultipart(D, [l], (le) => {
          B({ percent: le, uploadedBytes: Math.round(le / 100 * l.size) }), n("upload-progress", { uploadId: S, percent: le, done: le >= 100 });
        }), B({ percent: 100, uploadedBytes: l.size, status: "done" }), n("upload-progress", { uploadId: S, percent: 100, done: !0 });
      } catch (le) {
        const $e = le.message;
        B({ status: "error", error: $e }), it(m("upload.failed", { name: l.name })), n("error", {
          message: $e,
          context: { op: "upload", file: l.name }
        });
      }
    }
    async function Zf(l, c, S) {
      const D = gr();
      let B = !1;
      const le = (Be) => {
        if (!B) {
          Ia.value = [...Ia.value, { ...Be, id: D, displayName: Io.get(l) }], B = !0;
          return;
        }
        const Xe = Ia.value.findIndex((mt) => mt.id === D);
        if (Xe !== -1) {
          const mt = [...Ia.value];
          mt[Xe] = { ...Be, id: D, displayName: Io.get(l) }, Ia.value = mt;
        }
      }, $e = c ?? qt(M.value);
      try {
        return await z.uploadFile({
          path: $e,
          file: l,
          source: S,
          onProgress: (Be) => {
            !B && Be.status !== "uploading" && Be.uploadedBytes <= 0 || (le(Be), n("upload-progress", {
              uploadId: Be.uploadId ?? D,
              percent: Be.percent,
              done: Be.status === "done"
            }));
          }
        }), !0;
      } catch (Be) {
        if (gh(Be))
          return B && (Ia.value = Ia.value.filter((mt) => mt.id !== D)), !1;
        const Xe = Be.message;
        return B || (Ia.value = [
          ...Ia.value,
          {
            id: D,
            file: l,
            displayName: Io.get(l),
            path: $e,
            totalBytes: l.size,
            uploadedBytes: 0,
            percent: 0,
            status: "error",
            error: Xe,
            cancel() {
            }
          }
        ], B = !0), it(m("upload.failed", { name: Io.get(l) ?? l.name })), n("error", { message: Xe, context: { op: "upload", file: l.name } }), !0;
      }
    }
    const ao = b(0), no = b(!1);
    function Qf(l) {
      const c = l.dataTransfer;
      if (!c || c.types && c.types.includes(rfe) || uu()) return !1;
      if (c.items && c.items.length > 0) {
        let S = !1;
        for (const D of Array.from(c.items))
          if (D.kind === "file") {
            S = !0;
            break;
          }
        return S;
      }
      return c.types ? c.types.includes("Files") : !1;
    }
    function $$(l) {
      Qf(l) && (l.preventDefault(), ao.value++, no.value = !0);
    }
    function S$() {
      ao.value = Math.max(0, ao.value - 1), ao.value === 0 && (no.value = !1);
    }
    function T$(l) {
      if (Pn(l)) {
        l.preventDefault();
        return;
      }
      Qf(l) && l.preventDefault();
    }
    function C$(l) {
      var S;
      if (Pn(l)) {
        const D = Wv(l) || "", B = qt(M.value), le = Vc(l);
        if (le && D && B && D !== B && !be.value && Qn.value) {
          l.preventDefault(), ao.value = 0, no.value = !1, Wo(), Ui(), Ki(le.map(($e) => $e.path), B, D);
          return;
        }
      }
      if (Pn(l)) {
        ao.value = 0, no.value = !1, Wo(), Ui();
        return;
      }
      if (!Qf(l)) {
        ao.value = 0, no.value = !1;
        return;
      }
      if (l.preventDefault(), ao.value = 0, no.value = !1, !Qn.value) {
        it(m("toast.read_only_here"));
        return;
      }
      const c = (S = l.dataTransfer) != null && S.files ? Array.from(l.dataTransfer.files) : [];
      c.length !== 0 && gy(c);
    }
    function _y(l) {
      var c;
      (c = l.dataTransfer) != null && c.types.includes("Files") && l.preventDefault();
    }
    function ky(l) {
      const c = ga.value, S = l.target;
      c && S && !c.contains(S) && l.preventDefault();
    }
    Kt(() => {
      var l, c;
      window.addEventListener("dragover", _y), window.addEventListener("drop", ky), window.addEventListener("pointerup", sc), window.addEventListener("blur", sc), (c = (l = Kn.value) == null ? void 0 : l.onProgress) == null || c.call(l, (S) => {
        var B;
        if (!S) return;
        const D = GR(S, { quiet: ap, stoppable: !!((B = Kn.value) != null && B.stop), t: m });
        if (D) {
          if (D.kind === "flash") {
            const le = S.error && S.error !== "cancelled" ? Oa : vo;
            j_(fn.value, "drag-out", "end") ? (Ii = null, ra({ message: D.message, source: "drag-out" }, le)) : Ii = { message: D.message, ms: le };
            return;
          }
          j_(fn.value, "drag-out", "hold") && (Ii = null, ra(
            D.stoppable ? {
              message: D.message,
              actionLabel: m("dragout.stop"),
              action: () => {
                var le, $e;
                return ($e = (le = Kn.value) == null ? void 0 : le.stop) == null ? void 0 : $e.call(le);
              },
              after: { kind: "plain", running: m("dragout.stopping"), done: m("dragout.stopped") },
              source: "drag-out"
            } : { message: D.message, source: "drag-out" },
            Il
          ));
        }
      });
    });
    function sc() {
      uu() && Wo();
    }
    function Ui() {
      var l;
      (l = Kn.value) != null && l.cancel && Promise.resolve(Kn.value.cancel()).catch(() => {
      });
    }
    Mt(() => {
      window.removeEventListener("dragover", _y), window.removeEventListener("drop", ky), window.removeEventListener("hashchange", fy), window.removeEventListener("pointerup", sc), window.removeEventListener("blur", sc);
    });
    const ep = x(() => {
      const l = new Set(se.value.mode === "cut" ? se.value.items.map((c) => c.path) : []);
      if (be.value && Fi.value.size)
        for (const c of de.value) {
          const S = c.id;
          typeof S == "number" && Fi.value.has(S) && l.add(c.path);
        }
      return l;
    });
    function wy(l, c, S) {
      (l === "split" ? Ba : L).click(c.path, S);
    }
    function xy(l, c, S) {
      var Be;
      if (!S.dataTransfer) return;
      if (c.basename === ".trash") {
        S.preventDefault();
        return;
      }
      const D = l === "split" ? Ba.nodes.value : L.nodes.value, B = qt(l === "split" ? ((Be = na.value) == null ? void 0 : Be.getPath()) ?? "" : M.value), $e = (D.some((Xe) => Xe.path === c.path) ? D : [c]).filter((Xe) => !ep.value.has(Xe.path)).filter((Xe) => Xe.basename !== ".trash").map((Xe) => ({ path: Xe.path, basename: Xe.basename, type: Xe.type }));
      $e.length !== 0 && $y(S, $e, B, c.mime_type);
    }
    function $y(l, c, S, D) {
      if (!(oa.value || c.some((B) => !!B.e2e_root))) {
        if (Kn.value) {
          l.preventDefault(), S !== null && VR(c, S), Promise.resolve(Kn.value.start(c)).catch((B) => {
            Wo(), Ui(), n("error", { message: B.message, context: { op: "drag-out" } });
          }), My(c);
          return;
        }
        if (c.length === 1 && c[0] && l.dataTransfer) {
          const B = c[0], le = Np(s.config.auth) ? o.downloadUrl(B.path) : Ty.take(B.path), $e = le ? jR(B, le, D) : null;
          $e && l.dataTransfer.setData("DownloadURL", $e);
        }
      }
    }
    const Sy = b(!0), Ty = YR((l) => Dee(o, l), {
      onUnsupported: () => {
        Sy.value = !1;
      }
    }), Cy = x(() => !Kn.value && !Np(s.config.auth));
    function Ey(l) {
      !l || !Cy.value || Ae.value || Ty.warm(l);
    }
    function oc(l) {
      if (l.pointerType === "touch" || !Cy.value) return;
      const c = l.target, S = c && typeof c.closest == "function" ? c.closest("[data-fe-path]") : null, D = S == null ? void 0 : S.getAttribute("data-fe-path");
      if (!D) return;
      const B = de.value.find((le) => le.path === D) ?? gl.value.find((le) => le.path === D);
      B && B.type === "file" && B.basename !== ".trash" && Ey(B.path);
    }
    Kt(() => {
      var l, c;
      (l = ga.value) == null || l.addEventListener("pointerover", oc, { passive: !0 }), (c = ga.value) == null || c.addEventListener("pointerdown", oc, { capture: !0, passive: !0 });
    }), Mt(() => {
      var l, c;
      (l = ga.value) == null || l.removeEventListener("pointerover", oc), (c = ga.value) == null || c.removeEventListener("pointerdown", oc, { capture: !0 });
    });
    const Kn = x(() => s.config.dragOut ?? null), Ay = b(""), tp = b(!1);
    let ap = !1, zy;
    Qe(
      () => L.selected.value,
      () => {
        if (!Kn.value) return;
        clearTimeout(zy);
        const l = L.nodes.value;
        if (l.length === 0 || l.length > ufe || l.some((D) => D.type !== "file") || l.reduce((D, B) => D + (B.size ?? 0), 0) > lfe) return;
        const S = l.map((D) => ({ path: D.path, basename: D.basename, type: D.type }));
        zy = setTimeout(() => void My(S, !0), 400);
      },
      { deep: !0 }
    );
    async function My(l, c = !1) {
      const S = Kn.value;
      if (!S || tp.value) return;
      const D = WR(l);
      if (D !== Ay.value) {
        tp.value = !0, ap = c;
        try {
          const B = await S.prepare(l);
          B != null && B.ready ? (Ay.value = D, c || it(m("dragout.ready"))) : B != null && B.error && !c && it(B.error);
        } catch (B) {
          n("error", { message: B.message, context: { op: "drag-out-prepare" } });
        } finally {
          tp.value = !1, ap = !1;
        }
      }
    }
    async function E$(l, c, S, D) {
      try {
        const B = D ?? qt(M.value), le = await hp("move", l, c, B);
        if (le)
          return le.undo && le.ops.length && P.set(le.ops[le.ops.length - 1].id, { message: m("toast.moved"), fn: le.undo }), le.ops.length && it(m("split.move_queued")), L.clear(), "queued";
        const $e = await ry(l, c);
        if (o.endpoints.moveAsync) {
          const { op: Be } = await o.moveAsync(l, c, B);
          ly(Be.id, l, c, B, $e), I.register(Be), it(m($e ? "toast.move_kept_both" : "split.move_queued"));
        } else if (await o.move(B, l, c), await zt(), $e)
          it(m("toast.move_kept_both"));
        else {
          const Be = l.map((Xe) => Cs(c, Ss(Xe)));
          ju(m("toast.moved"), async () => {
            await o.move(c, Be, B);
          });
        }
        return L.clear(), o.endpoints.moveAsync ? "queued" : "done";
      } catch (B) {
        return Ua(B, { op: S, targetDir: c }), "refused";
      }
    }
    async function Dy(l, c) {
      if (l.type !== "dir") return;
      const S = Vc(c);
      if (!S || S.length === 0) return;
      Wo(), Ui();
      const D = l.path, B = S.map((le) => le.path).filter((le) => le && le !== D && !D.startsWith(le + "/") && !Df(Ts(le), D));
      B.length !== 0 && await Ki(B, D, tg(c));
    }
    async function Py(l, c) {
      const S = Vc(c);
      if (!S || S.length === 0) return;
      Wo(), Ui();
      const D = l, B = S.map((le) => le.path).filter((le) => le && le !== D && !D.startsWith(le + "/") && !Df(Ts(le), D));
      B.length !== 0 && await Ki(B, D, tg(c));
    }
    function A$(l) {
      l.cancel();
    }
    function z$(l) {
      Ia.value = Ia.value.filter((c) => c.id !== l.id);
    }
    function M$(l) {
      if (ma.value && !l) {
        zt("");
        return;
      }
      if (ma.value) {
        zt(Qs(l));
        return;
      }
      zt(Tn(l));
    }
    async function ic(l) {
      try {
        await navigator.clipboard.writeText(l), it(m("breadcrumb.copy_path"));
      } catch {
      }
    }
    function Na(l = {}) {
      return o.authHeaders({ ...l });
    }
    function Oy(l) {
      if (/^[a-z][a-z0-9+.-]*:\/\//i.test(l)) return l;
      const c = s.config.apiBase;
      if (!c) return l;
      try {
        return new URL(l, c.endsWith("/") ? c : `${c}/`).toString();
      } catch {
        return l;
      }
    }
    const Ly = x(
      () => s.config.viewerBaseUrl ? Oy(s.config.viewerBaseUrl) : rh(s.config.apiBase, cfe)
    ), rc = b(!1), { themeId: lc, setTheme: D$ } = P0(), { themeMode: hl, setThemeMode: Iy } = p7(), ba = x(
      () => hl.value === "host" ? s.config.theme || "auto" : hl.value
    );
    NM({ locale: g, theme: ba });
    const P$ = Ld(), np = x(
      () => ba.value === "dark" || ba.value !== "light" && P$.value
    );
    Qe(
      [lc, np, ga],
      () => {
        m7(lc.value), ga.value && v7(ga.value, lc.value, np.value);
      },
      { immediate: !0 }
    );
    const ml = b(!1), so = b(!1), Es = b(null);
    function O$() {
      if (so.value) {
        so.value = !1;
        return;
      }
      const l = L.nodes.value, c = l.length === 1 ? l[0] : null;
      if (!(!c || c.type !== "file" || c.basename === ".trash")) {
        if (Yo(c) && !oa.value && !c.e2e_root) {
          Pt.open(c);
          return;
        }
        if (oa.value) {
          if (!Wa.value) return;
          (async () => {
            try {
              await mc(c);
            } catch {
              it(m("e2e.decrypt_failed"));
              return;
            }
            Es.value = c, so.value = !0, Nt(c);
          })();
          return;
        }
        Es.value = c, so.value = !0, Nt(c);
      }
    }
    function L$(l) {
      const c = de.value.filter((le) => le.type === "file");
      if (c.length === 0) return;
      const S = Es.value;
      let D = S ? c.findIndex((le) => le.path === S.path) : -1;
      D = D === -1 ? l > 0 ? 0 : c.length - 1 : (D + l + c.length) % c.length;
      const B = c[D];
      !B || B.path === (S == null ? void 0 : S.path) || L.click(B.path);
    }
    function I$() {
      const l = Es.value;
      so.value = !1, l && Cn(l);
    }
    Qe(
      () => L.nodes.value,
      (l) => {
        var S, D;
        if (!so.value) return;
        const c = l.length === 1 && l[0].type === "file" ? l[0] : null;
        if (c && c.path !== ((S = Es.value) == null ? void 0 : S.path) && Wa.value) {
          (async () => {
            try {
              await mc(c);
            } catch {
            }
            Es.value = c, Nt(c);
          })();
          return;
        }
        c && c.path !== ((D = Es.value) == null ? void 0 : D.path) && (Es.value = c, Nt(c));
      }
    );
    const yl = aY();
    function R$(l) {
      Ia.value = Ia.value.filter((D) => D.id !== l.id);
      const c = l.file, S = l.path || qt(M.value);
      (async () => {
        if (z.shouldChunk(c) && await Zf(c, S)) {
          await zt();
          return;
        }
        await by(c, S), await zt();
      })();
    }
    const uc = b(!1);
    let cc;
    function sp() {
      uc.value = !0;
    }
    function N$() {
      var l;
      uc.value = !1, j0(), (l = ga.value) == null || l.focus();
    }
    function Ry() {
      sp();
    }
    Kt(() => {
      var l;
      (l = ga.value) == null || l.addEventListener("fe:tour-restart", Ry), cc = vY(() => {
        uc.value || sp();
      });
    }), Mt(() => {
      var l;
      cc == null || cc(), (l = ga.value) == null || l.removeEventListener("fe:tour-restart", Ry);
    });
    function B$() {
      return Xu() === "none" ? null : W ? `${fk}:${W}` : fk;
    }
    const Pa = IX({ storageKey: B$() }), F$ = Pa.restore(), op = Pa.activeId, As = x(() => {
      var l;
      return ((l = Pa.activeTab.value) == null ? void 0 : l.split) ?? null;
    });
    function U$(l) {
      const c = (l || "").replace(/^\/+|\/+$/g, ""), S = pd(c.split("/").pop() || c, m);
      if (S) return S;
      if (!c) return ma.value ? m("breadcrumb.root") : j.value || m("breadcrumb.root");
      const D = Yt.segmentLabel(qt(c));
      return D !== null ? D : c.split("/").pop() || c;
    }
    const Ny = x(
      () => Pa.tabs.value.map((l) => ({ id: l.id, label: U$(l.path), split: !!l.split }))
    ), By = x(
      () => (
        /* gezinti:g1 — the simple profile has no tab strip at all, not even once a
           second tab exists: tabs were the first thing #14 named as power-user
           chrome. The tab STATE is untouched, so switching the profile back brings
           the strip and its tabs straight back. */
        !tl.value && (Pa.hasMultiple.value || s.config.tabStrip !== "auto" && Ny.value.length > 0)
      )
    );
    Qe(M, (l) => Pa.syncActive({ path: l })), Qe(G, (l) => Pa.syncActive({ viewMode: l })), Kt(() => {
      F$ || Pa.seed(M.value ?? "", G.value);
    });
    function dc(l) {
      !me.value && l.viewMode && l.viewMode !== G.value && (G.value = l.viewMode);
      const c = () => qe(fe.value);
      if (l.path === ".trash") {
        ts().then(c, c);
        return;
      }
      zt(l.path).then(c, c);
    }
    function H$(l) {
      const c = Pa.activate(l);
      c && dc(c);
    }
    function ip() {
      Pa.openTab(M.value ?? "", { viewMode: G.value, background: !1 });
    }
    function Fy(l) {
      const c = Pa.closeTab(l);
      c && dc(c);
    }
    function K$() {
      const l = Pa.step(1);
      l && dc(l);
    }
    function V$() {
      const l = Pa.step(-1);
      l && dc(l);
    }
    function Uy(l) {
      if (l.type !== "dir" || l.basename === ".trash") return;
      const c = ma.value ? Qs(l.path) : Tn(l.path);
      Pa.openTab(c, { viewMode: G.value, background: !0 });
    }
    function Hy(l) {
      if (l.button !== 1) return;
      const c = l.target, S = c && typeof c.closest == "function" ? c.closest("[data-fe-path]") : null, D = S == null ? void 0 : S.getAttribute("data-fe-path");
      if (!D) return;
      const B = de.value.find((le) => le.path === D);
      !B || B.type !== "dir" || B.basename === ".trash" || (l.preventDefault(), Uy(B));
    }
    function Ky(l) {
      if (l.button !== 1) return;
      const c = l.target;
      c && typeof c.closest == "function" && c.closest("[data-fe-path]") && l.preventDefault();
    }
    Kt(() => {
      var l, c;
      (l = ga.value) == null || l.addEventListener("auxclick", Hy), (c = ga.value) == null || c.addEventListener("mousedown", Ky);
    }), Mt(() => {
      var l, c;
      (l = ga.value) == null || l.removeEventListener("auxclick", Hy), (c = ga.value) == null || c.removeEventListener("mousedown", Ky);
    });
    const q$ = b(null), na = b(null), gl = b([]), Ba = Wg(
      () => {
        var l;
        return gl.value.length ? gl.value : ((l = na.value) == null ? void 0 : l.visibleNodes()) ?? [];
      }
    ), bl = b({ ...ho }), j$ = x(() => {
      var B;
      if (!me.value) return "";
      const l = String(((B = na.value) == null ? void 0 : B.getPath()) ?? "").replace(/^\/+|\/+$/g, "");
      if (!l) return "";
      const [c, ...S] = l.split("/"), D = (s.config.storages ?? []).find((le) => le.name === c);
      return xb((D == null ? void 0 : D.uid) || c, S.join("/"));
    }), W$ = x(
      () => By.value || Am.value || _l.value
    ), fc = x(() => Ce.value === "home" ? "home" : Ce.value === "drafts" ? "drafts" : F.value && de.value.length === 0 ? "" : ce.value ? "notfound" : X.value && de.value.length === 0 ? "" : pc.value ? "locked" : ""), _l = x(() => !gn.value && !tl.value), Hi = x(
      () => !!As.value && _l.value
      /* gezinti:g1 */
    );
    function Vy() {
      if (As.value) {
        Pa.setSplit(null), Vn.value = "main";
        return;
      }
      _l.value && Pa.setSplit({ path: M.value ?? "", viewMode: G.value });
    }
    function Y$() {
      Pa.setSplit(null), Vn.value = "main";
    }
    function G$(l) {
      Pa.setSplit({ ...As.value ?? {}, path: l }), Wl(bl.value) && (bl.value = { ...ho }), Ba.clear(), gl.value = [];
    }
    function X$(l, c) {
      var S;
      if (c.type === "dir" && c.basename !== ".trash") {
        (S = na.value) == null || S.loadFolder(
          /* A multi-storage drive row's path is already the wire form for that
             storage's root; a real row needs converting. The predicate comes from
             `lib/fileIcons`, which is that concept's one home. */
          Ks(c) === "storage" ? c.path : wl(c.path)
        );
        return;
      }
      Cn(c);
    }
    function J$() {
      Vn.value = "main", ts();
    }
    const qy = x(() => {
      var l;
      return ((l = As.value) == null ? void 0 : l.viewMode) ?? G.value;
    });
    function jy(l) {
      As.value && Pa.setSplit({ ...As.value, viewMode: l });
    }
    const rp = x(
      () => Ta.value ? qy.value : G.value
    );
    function Wy(l) {
      Ta.value ? jy(l) : G.value = l;
    }
    const Vn = b("main");
    function Z$() {
      Vn.value = "main";
    }
    Qe(Hi, (l) => {
      l || (Vn.value = "main");
    });
    const Ta = x(() => Vn.value === "split" && Hi.value), Q$ = x(() => Hi.value && Vn.value === "main"), Yy = x(() => Ta.value ? "split" : "main"), kl = b(null), Gy = x(
      () => {
        var l;
        return Ta.value ? ((l = na.value) == null ? void 0 : l.getPath()) ?? "" : M.value ?? "";
      }
    );
    function eS(l) {
      var c;
      return l === "split" ? ((c = na.value) == null ? void 0 : c.getPath()) ?? "" : M.value ?? "";
    }
    function tS(l) {
      var c;
      return l === "split" ? ((c = na.value) == null ? void 0 : c.rowPaths()) ?? [] : de.value.map((S) => S.path);
    }
    Qe(
      () => Za(),
      (l) => {
        l.length && (kl.value = {
          nodes: l,
          pane: Yy.value,
          path: Gy.value
        });
      },
      { deep: !1 }
    );
    const lp = x(() => {
      const l = kl.value;
      if (!l || !l.nodes.length || l.pane === "split" && !Hi.value) return !1;
      if (eS(l.pane) !== l.path) return !0;
      const c = new Set(tS(l.pane));
      return l.nodes.some((S) => c.has(S.path));
    });
    Qe(lp, (l) => {
      l || (kl.value = null);
    });
    const aS = x(() => Za().length === 0 && lp.value), Xy = x(() => {
      var c;
      const l = Za();
      return l.length ? l : lp.value ? ((c = kl.value) == null ? void 0 : c.nodes) ?? [] : [];
    }), nS = x(() => {
      const l = Xy.value;
      return l.length === 1 && h.value ? tc([l[0].path]) : void 0;
    }), sS = x(
      () => {
        var l;
        return aS.value ? jm(((l = kl.value) == null ? void 0 : l.path) ?? "") : "";
      }
    ), oS = x(() => jm(Gy.value)), iS = x(
      () => {
        var l;
        return Ta.value ? ((l = na.value) == null ? void 0 : l.rowCount()) ?? 0 : de.value.length;
      }
    ), rS = x(
      () => {
        var l;
        return Ta.value ? ((l = na.value) == null ? void 0 : l.dirPerm()) ?? "" : ke.value;
      }
    );
    function wl(l) {
      return ma.value ? Qs(l) : Tn(l);
    }
    function Jy(l) {
      const c = String(l ?? "").replace(/^\/+|\/+$/g, "");
      return N && (!c || !(c === N || c.startsWith(N + "/"))) ? N : c;
    }
    function Zy() {
      var c;
      const l = Ba.nodes.value;
      l.length !== 0 && (se.value = { mode: "cut", items: l, sourcePath: ((c = na.value) == null ? void 0 : c.getPath()) ?? "" }, it(m("toast.cut")));
    }
    function Qy() {
      var c;
      const l = Ba.nodes.value;
      l.length !== 0 && (se.value = { mode: "copy", items: l, sourcePath: ((c = na.value) == null ? void 0 : c.getPath()) ?? "" }, it(m("toast.copied")));
    }
    async function eg() {
      const l = se.value, c = na.value;
      if (!l.mode || l.items.length === 0 || !c) return;
      const S = qt(c.getPath() ?? ""), D = qt(l.sourcePath || "") || void 0;
      if (l.mode === "cut" && D === S) {
        it(m("toast.same_folder_cut"));
        return;
      }
      await Ki(l.items.map((B) => B.path), S, D, l.mode === "copy" ? "copy" : "move"), se.value = { mode: null, items: [], sourcePath: null };
    }
    function tg(l) {
      return Wv(l);
    }
    async function Ki(l, c, S, D = "auto") {
      var Be, Xe;
      const B = l.filter(
        (mt) => mt && mt !== c && !c.startsWith(mt + "/") && !Df(Ts(mt), c)
      );
      if (B.length === 0 || !c) return "nothing";
      const le = V_(B, c, D);
      let $e;
      if (le.kind === "copy")
        try {
          if (await hp("copy", B, c))
            return it(m("split.copy_queued")), (Be = na.value) == null || Be.reload(), "queued";
          const { op: bt } = await o.copy(B, c);
          I.register(bt), it(le.cross ? m("split.cross_copy") : m("split.copy_queued")), $e = "queued";
        } catch (mt) {
          return Ua(mt, { op: "transfer", targetWire: c }), "refused";
        }
      else
        le.cross && it(m("split.cross_move")), $e = await E$(B, c, "move-transfer", S);
      return (Xe = na.value) == null || Xe.reload(), $e;
    }
    function ag(l) {
      Ki(l.sources, l.targetWire, l.originWire);
    }
    const fa = Qz(), pn = b(0), ng = /* @__PURE__ */ new WeakMap(), Pt = Tee({
      api: o,
      chunked: z,
      locale: () => g.value,
      t: (l, c) => m(l, c),
      toast: (l, c) => ra({ message: l }, c ? Oa : vo),
      emitError: (l, c) => n("error", { message: l, context: { op: c } }),
      escrowPublicKey: () => Yi.value,
      escrowKid: () => En.value,
      registerOp: (l) => I.register(l),
      reload: () => zt(),
      openPreview: (l, c) => {
        Vi.set(l.path, c), Js.value = "view", Ra.value = l, Bn.value = !0, n("file-opened", { path: l.path, basename: l.basename }), l.fxe_name && (de.value = de.value.map((S) => S.path === l.path ? { ...S, fxe_name: l.fxe_name } : S));
      },
      showRecoveryKey: (l, c) => {
        No.value = l, Bo.value = c, ji.value = "file", Ro.value = !0;
      }
    }), xl = x(() => {
      var l;
      return !!((l = Ra.value) != null && l.fxe_name);
    }), Yt = qM({
      api: o,
      ring: fa,
      lockedLabel: () => m("e2e.names.locked_item"),
      unreadableLabel: () => m("e2e.names.unreadable_item"),
      fileName: (l) => Pt.realName(l)
    });
    yr(Su, Yt);
    const lS = UZ((l, c) => {
      Yt.version.value;
      const S = Yt.rootOf(l, c);
      if (!S || !fa.names(S)) return null;
      const D = Yt.segmentLabel(l);
      return !D || D === "…" ? null : { name: D, path: Yt.displayPath(l) };
    });
    Mt(lS);
    const Io = /* @__PURE__ */ new WeakMap(), sg = b([]), Ht = b(""), Vi = /* @__PURE__ */ new Map(), oa = x(() => !!Ht.value && !be.value), Wa = x(() => (pn.value, oa.value && fa.has(Ht.value))), pc = x(() => (pn.value, oa.value && !fa.has(Ht.value))), vc = b(!1), up = b(""), qi = b(!1), $l = b(!1), Xt = b(null), hc = b(!1), cp = b(!1), zs = b(null), Ro = b(!1), No = b(""), ji = b("created"), Bo = b(""), Wi = b(!1), Fo = b(""), Sl = b(!1), oo = b(!1), Tl = b("unlock"), ss = b(""), os = b(!1), is = b(""), Yi = x(
      () => {
        var l, c;
        return ((c = (l = ne.value) == null ? void 0 : l.e2e_escrow) == null ? void 0 : c.public_key) || null;
      }
    ), En = x(
      () => {
        var l, c;
        return ((c = (l = ne.value) == null ? void 0 : l.e2e_escrow) == null ? void 0 : c.kid) || null;
      }
    );
    function dp() {
      return fa.get(Ht.value) ?? null;
    }
    function fp() {
      for (const l of Vi.values()) URL.revokeObjectURL(l);
      Vi.clear();
    }
    Mt(fp);
    async function og(l, c) {
      var Be;
      let S = "";
      try {
        const { blob: Xe, url: mt } = await o.fetchBlob(Cs(l, en), { fresh: !0 });
        URL.revokeObjectURL(mt), S = await Xe.text();
      } catch {
        return m("e2e.unlock.marker_missing");
      }
      const D = cd(S);
      if (!D) return m("e2e.unlock.marker_missing");
      const B = l === Ht.value;
      if (D.unsupported.length > 0)
        return B && (sg.value = D.unsupported), m("e2e.unlock.unsupported", { features: D.unsupported.join(", ") });
      const le = D.marker;
      B && (Xt.value = le);
      const $e = await Ww(le, c);
      return "error" in $e ? $e.error === "damaged" ? m("e2e.unlock.damaged") : m("e2e.unlock.wrong") : await ig(l, le, $e.fmk) ? (B && (le.v === 1 ? (Fo.value = c, Wi.value = !0) : mb(le, En.value) === "offer" && (ss.value = c, Tl.value = "unlock", is.value = "", oo.value = !0)), B && await zt(), (Be = na.value) == null || Be.reload(), null) : m("e2e.names.key_failed");
    }
    async function uS(l) {
      if (!(!l || vc.value || !Ht.value)) {
        vc.value = !0, up.value = "";
        try {
          const c = await og(Ht.value, l);
          c && (up.value = c);
        } finally {
          vc.value = !1;
        }
      }
    }
    yr(W0, {
      locked: (l) => (pn.value, !fa.has(l)),
      unlock: og,
      recovery: (l) => {
        Vn.value = "main", zt(wl(l)).then(() => {
          Ht.value === l && lg();
        });
      }
    });
    async function ig(l, c, S) {
      let D = null;
      if (fs(c) && (D = await Hz(c, S), !D))
        return !1;
      let B = null;
      return kr(c) && (B = await Yz(c, S), !B) ? !1 : (fa.set(l, S, D, B), Yt.setMarker(l, c), pn.value++, !0);
    }
    function rg() {
      if (!Ht.value) return;
      const l = Ht.value;
      fa.lock(l), Yt.forget(l), pn.value++, fp(), ro.value = !1, Qi = null, Zi.value = !1, it(m("e2e.locked_toast")), zt();
    }
    function cS(l) {
      return Fl(l.extension);
    }
    async function mc(l) {
      const c = Vi.get(l.path);
      if (c) return c;
      const S = dp();
      if (!S) return null;
      const D = await o.fetchArrayBuffer(l.path);
      if (!Or(D)) return null;
      const B = await Zz(S, fa.previous(Ht.value), D), le = URL.createObjectURL(new Blob([B], { type: cS(l) }));
      return Vi.set(l.path, le), le;
    }
    function yc(l) {
      return Vi.get(l) ?? o.previewUrl(l);
    }
    async function pp(l) {
      try {
        await mc(l);
      } catch {
        it(m("e2e.decrypt_failed"));
        return;
      }
      Js.value = "view", Ra.value = l, Bn.value = !0, n("file-opened", { path: l.path, basename: l.basename }), Nt(l);
    }
    async function dS(l) {
      const c = dp();
      if (!c) {
        it(m("e2e.download.failed"));
        return;
      }
      await Pt.downloadFolderFile(l, c, fa.previous(Ht.value), Ht.value);
    }
    async function fS(l, c) {
      const S = dp();
      if (!S) return { files: [], sidecars: [] };
      const D = [], B = [];
      await vp(c);
      const le = !!Yt.writesEncrypted(c);
      for (const $e of l)
        if ($e.name !== en) {
          if (le && vs($e.name)) {
            it(m("e2e.names.bad_name", { name: $e.name }));
            continue;
          }
          try {
            const Be = $e.size > Lc ? await Pt.folderUploadSource($e, S) : null, Xe = Be ? null : await _b(S, await $e.arrayBuffer());
            let mt = $e.name;
            if (le) {
              const pa = await Yt.nameForWrite(c, $e.name);
              if (!pa) throw new Error("e2e: the folder name key is missing");
              mt = pa.stored, pa.sidecar && B.push(new File([pa.sidecar.content], pa.sidecar.name, { type: "text/plain" }));
            }
            const bt = new File(Xe ? [Xe] : [], mt, { type: "application/octet-stream" });
            Be && ng.set(bt, Be), le && Io.set(bt, $e.name), D.push(bt);
          } catch (Be) {
            n("error", { message: Be.message, context: { op: "e2e-encrypt" } });
          }
        }
      return { files: D, sidecars: B };
    }
    async function pS(l) {
      if (oa.value) {
        it(m("e2e.create.nested"));
        return;
      }
      $l.value = !0;
      try {
        const c = qt(M.value);
        await o.newFolder(c, l.name);
        const { marker: S, fmk: D, recoveryKey: B, names: le } = await Av(l.password, {
          escrowPublicKey: Yi.value,
          encryptNames: l.level === "names"
        }), $e = new File([JSON.stringify(S)], en, {
          type: "application/json"
        }), Be = Cs(c, l.name);
        await o.uploadMultipart(Be, [$e]), fa.set(Be, D, le ?? null), Yt.setMarker(Be, S), pn.value++, qi.value = !1, No.value = B, Bo.value = l.name, ji.value = "created", Ro.value = !0, await zt();
      } catch (c) {
        n("error", { message: c.message, context: { op: "e2e-create" } }), it(m("e2e.create.failed"));
      } finally {
        $l.value = !1;
      }
    }
    async function vS(l) {
      if (!(!Xt.value || !Ht.value)) {
        cp.value = !0, zs.value = null;
        try {
          let c = null;
          if (l.mode === "recovery") {
            if (c = await Yw(Xt.value, l.value), !c) {
              zs.value = m("e2e.recover.wrong_recovery");
              return;
            }
          } else {
            let S;
            try {
              S = await Fw(l.value);
            } catch {
              zs.value = m("e2e.recover.bad_escrow_key");
              return;
            }
            if (c = await Gw(Xt.value, S), !c) {
              zs.value = m("e2e.recover.wrong_escrow");
              return;
            }
            try {
              const D = await o.e2eEscrowChallenge(Ht.value), B = new Uint8Array(
                await crypto.subtle.decrypt(
                  { name: "RSA-OAEP" },
                  S,
                  rn(D.challenge).buffer
                )
              );
              await o.e2eEscrowUsed({
                path: Ht.value,
                id: D.id,
                nonce: qs(B)
              });
            } catch (D) {
              zs.value = m("e2e.recover.notify_failed"), n("error", {
                message: D.message,
                context: { op: "e2e-escrow-notify" }
              });
              return;
            }
          }
          if (!await ig(Ht.value, Xt.value, c)) {
            zs.value = m("e2e.names.key_failed");
            return;
          }
          hc.value = !1, it(
            l.mode === "escrow" ? m("e2e.recover.escrow_done") : m("e2e.recover.recovery_done")
          ), await zt(), l.mode === "recovery" && (Qi = l.value, yg("reset"));
        } catch (c) {
          zs.value = c.message;
        } finally {
          cp.value = !1;
        }
      }
    }
    async function lg() {
      if (!Xt.value && Ht.value)
        try {
          const { blob: l, url: c } = await o.fetchBlob(Cs(Ht.value, en), { fresh: !0 });
          URL.revokeObjectURL(c);
          const S = cd(await l.text());
          Xt.value = S && S.unsupported.length === 0 ? S.marker : null;
        } catch {
          Xt.value = null;
        }
      zs.value = null, hc.value = !0;
    }
    async function hS() {
      if (!(!Xt.value || !Ht.value || !Fo.value)) {
        Sl.value = !0;
        try {
          const l = await Nz(Xt.value, Fo.value, {
            escrowPublicKey: Yi.value
          }), c = new File([JSON.stringify(l.marker)], en, {
            type: "application/json"
          });
          await o.uploadMultipart(Ht.value, [c]), Xt.value = l.marker, Yt.setMarker(Ht.value, l.marker), Wi.value = !1, Fo.value = "", No.value = l.recoveryKey, Bo.value = Ss(Ht.value), ji.value = "upgraded", Ro.value = !0;
        } catch (l) {
          n("error", { message: l.message, context: { op: "e2e-upgrade" } }), it(m("e2e.upgrade.failed"));
        } finally {
          Sl.value = !1;
        }
      }
    }
    const ug = x(() => mb(Xt.value, En.value));
    function mS() {
      Tl.value = "manual", ss.value = "", is.value = "", oo.value = !0;
    }
    async function io(l) {
      const c = new File([JSON.stringify(l)], en, { type: "application/json" });
      await o.uploadMultipart(Ht.value, [c]), Xt.value = l, Yt.setMarker(Ht.value, l);
    }
    async function cg() {
      const l = Xt.value, c = Yi.value;
      if (!(!l || !c || !Ht.value || os.value)) {
        if (!ss.value) {
          is.value = m("e2e.escrowoffer.password_required");
          return;
        }
        os.value = !0, is.value = "";
        try {
          const S = await Bz(l, ss.value, c);
          await io(S), oo.value = !1, ss.value = "", it(m("e2e.escrowoffer.done"));
        } catch (S) {
          (S == null ? void 0 : S.name) === "E2eDecryptError" ? is.value = m("e2e.escrowoffer.wrong_password") : (is.value = m("e2e.escrowoffer.failed"), n("error", { message: S.message, context: { op: "e2e-escrow-offer" } }));
        } finally {
          os.value = !1;
        }
      }
    }
    async function yS() {
      const l = Xt.value;
      if (!(!l || !Ht.value || os.value)) {
        os.value = !0;
        try {
          await io(Fz(l, (/* @__PURE__ */ new Date()).toISOString())), oo.value = !1, ss.value = "", it(m("e2e.escrowoffer.declined_toast"));
        } catch (c) {
          is.value = m("e2e.escrowoffer.decline_failed"), n("error", { message: c.message, context: { op: "e2e-escrow-decline" } });
        } finally {
          os.value = !1;
        }
      }
    }
    function gS() {
      oo.value = !1, ss.value = "", is.value = "";
    }
    function bS() {
      Wi.value = !1, Fo.value = "";
    }
    class dg extends Error {
      constructor(c) {
        super(`e2e: invalid name (${c})`), this.problem = c, this.name = "E2eNameRefused";
      }
    }
    async function fg(l, c, S = {}) {
      if (await vp(l), !Yt.writesEncrypted(l)) return c;
      const D = vs(c);
      if (D) throw new dg(D);
      const B = await Yt.nameForWrite(l, c, S);
      return B ? (B.sidecar && await o.uploadMultipart(l, [
        new File([B.sidecar.content], B.sidecar.name, { type: "text/plain" })
      ]), B.stored) : c;
    }
    async function vp(l) {
      const c = Ht.value;
      if (!c) return;
      const S = l.replace(/\/+$/, ""), D = c.replace(/\/+$/, "");
      (S === D || S.startsWith(D.endsWith("://") ? D : `${D}/`)) && await Yt.markerFor(c);
    }
    async function hp(l, c, S, D) {
      await vp(S);
      const B = Yt.writesEncrypted(S);
      if (!B || !fa.names(B) || !c.every((bt) => Yt.rootOf(bt) === B)) return null;
      const le = [], $e = [], Be = (bt, pa) => bt.replace(/\/+$/, "") === pa.replace(/\/+$/, "");
      let Xe = /* @__PURE__ */ new Set();
      try {
        Xe = new Set(((await o.index(S)).files ?? []).map((bt) => bt.basename));
      } catch {
      }
      for (const bt of c) {
        const pa = Ts(bt);
        if (l === "move" && Be(pa, S)) continue;
        const Fa = Ss(bt), Va = await Yt.plainNameOf(bt);
        if (!Va || Va.state === "unreadable" || Va.name === null)
          throw new Error(m("e2e.names.move_unreadable"));
        const uo = await _S(bt) ? { keepIdOf: bt } : {};
        let Ya = await Yt.nameForWrite(S, Va.name, uo);
        if (!Ya) return null;
        for (let tr = 2; l === "copy" && Xe.has(Ya.stored) && tr < 100; tr++)
          Ya = await Yt.nameForWrite(S, G0(Va.name, tr), uo);
        if (Xe.has(Ya.stored)) throw new Error(m("e2e.names.move_taken", { name: Va.name }));
        Xe.add(Ya.stored), Ya.sidecar && await o.uploadMultipart(S, [
          new File([Ya.sidecar.content], Ya.sidecar.name, { type: "text/plain" })
        ]);
        const { op: co } = await o.transferNamed(l, bt, S, Ya.stored, D);
        I.register(co), le.push(co), $e.push({ moved: Cs(S, Ya.stored), origin: pa, name: Fa });
      }
      return { ops: le, undo: l === "move" ? async () => {
        for (const bt of $e) {
          const { op: pa } = await o.transferNamed("move", bt.moved, bt.origin, bt.name);
          I.register(pa);
        }
        return { queued: !0 };
      } : null };
    }
    async function _S(l) {
      var D;
      const c = de.value.find((B) => B.path === l) ?? (((D = na.value) == null ? void 0 : D.visibleNodes()) ?? []).find((B) => B.path === l);
      if (c) return c.type === "dir";
      const S = Hr(Ss(l)).kind;
      if (S === "dir" || S === "longdir") return !0;
      if (S === "file" || S === "long") return !1;
      try {
        return ((await o.index(Ts(l))).files ?? []).some((le) => le.path === l && le.type === "dir");
      } catch {
        return !1;
      }
    }
    async function pg(l, c) {
      const S = Yt.writesEncrypted(l);
      if (!S) return null;
      const D = l.indexOf("://"), le = {
        adapter: D === -1 ? j.value : l.slice(0, D),
        storages: (s.config.storages ?? []).map((mt) => mt.name),
        dirname: l,
        read_only: !1,
        files: [],
        e2e_root: S
      };
      if (!fa.names(S)) return le;
      const $e = [], Be = [l];
      let Xe = 0;
      for (; Be.length > 0 && $e.length < Ec && Xe < ffe; ) {
        const mt = Be.shift();
        Xe++;
        let bt;
        try {
          bt = await o.index(mt);
        } catch {
          continue;
        }
        const pa = Rl(await Yt.decorate(bt.files ?? [], { root: S }));
        for (const Fa of pa)
          if (Fa.type === "dir" && Be.push(Fa.path), xr(Fa.basename, c) && $e.push(Fa), $e.length >= Ec) break;
      }
      return { ...le, files: $e, truncated: Be.length > 0 };
    }
    const ro = b(!1);
    Qe(Ht, async (l, c) => {
      if (l === c) return;
      if (Wi.value = !1, Fo.value = "", oo.value = !1, ss.value = "", ro.value = !1, Uo.value = "", Ho.value = null, sg.value = [], !l) {
        Xt.value = null;
        return;
      }
      const S = Yt.markerCached(l);
      if (Xt.value = S === void 0 ? null : S, S === void 0) {
        const D = await Yt.markerFor(l);
        Ht.value === l && (Xt.value = D);
      }
    });
    const Ms = b(!1), Uo = b(""), Ho = b(null);
    let Gi = !1;
    const mp = x(() => (pn.value, qz(Xt.value))), vg = x(() => mp.value !== "content"), kS = x(() => (pn.value, jz(Xt.value))), wS = x(
      () => vg.value ? de.value.filter((l) => l.e2e_name_state === "plain" || l.e2e_name_state === "unreadable").length : 0
    );
    async function gc() {
      var D;
      const l = Ht.value, c = l ? fa.get(l) : void 0;
      let S = Xt.value;
      if (!l || !c || !S || Ms.value) return !1;
      ro.value = !1, Ms.value = !0, Uo.value = "", Gi = !1;
      try {
        if (!fs(S)) {
          const Be = await yb(S, c);
          await io(Be.marker), fa.setNames(l, Be.names), pn.value++, S = Be.marker;
        }
        const B = fa.names(l);
        if (!B) throw new Error("e2e: the folder name key is missing");
        Ho.value = { renamed: 0, failed: 0, seen: 0 };
        const le = Ho.value;
        if (await NZ(B, l, {
          list: async (Be) => (await o.index(Be)).files ?? [],
          readSidecar: async (Be, Xe) => {
            try {
              return new TextDecoder().decode(await o.fetchArrayBuffer(vr(Be, Xe)));
            } catch {
              return null;
            }
          },
          writeSidecar: async (Be, Xe, mt) => {
            await o.uploadMultipart(Be, [new File([mt], Xe, { type: "text/plain" })]);
          },
          // A folder rename is a job of the queue where the server has one: the
          // queue keeps order, so a folder is renamed after its contents.
          rename: async (Be, Xe, mt) => {
            if (Xe.type === "dir" && Yn("rename")) {
              const bt = (await o.renameQueued(Be, Xe.path, mt)).op;
              bt && I.register(bt);
            } else
              await o.rename(Be, Xe.path, mt);
          },
          stopped: () => Gi
        }, le), Gi)
          return it(m("e2e.names.stopped", { n: le.renamed })), !1;
        if (le.failed > 0)
          return Uo.value = m("e2e.names.partial", { n: le.failed }), !1;
        const $e = Xt.value ?? S;
        return (D = $e.names) != null && D.pending && await io(Kz($e)), Ho.value = null, it(m("e2e.names.done", { n: le.renamed })), !0;
      } catch (B) {
        return Uo.value = m("e2e.names.failed"), n("error", { message: B.message, context: { op: "e2e-names" } }), !1;
      } finally {
        Ms.value = !1, await zt();
      }
    }
    const Ko = b(null), lo = b(!1), Xi = b(""), Ds = b(null);
    let Ji = !1;
    const hg = x(() => (pn.value, kb(Xt.value)));
    function xS(l, c) {
      const S = l.length === 1 ? l[0] : null;
      return !!S && S.type === "dir" && c && !oa.value && !S.e2e && !S.e2e_root && !Ae.value && typeof crypto < "u" && !!crypto.subtle;
    }
    function $S(l) {
      Ko.value = l, qi.value = !0;
    }
    async function SS(l) {
      const c = [l];
      for (; c.length; ) {
        const S = c.shift(), D = await o.index(S);
        if (S !== l && typeof D.e2e_root == "string" && D.e2e_root) return !0;
        for (const B of D.files ?? [])
          if (B.type === "dir") {
            if (B.e2e) return !0;
            c.push(B.path);
          }
      }
      return !1;
    }
    async function TS(l) {
      const c = Ko.value;
      if (!c) return;
      const S = c.path;
      $l.value = !0;
      try {
        if (await SS(S)) {
          it(m("e2e.convert.nested"));
          return;
        }
        const D = await Av(l.password, { escrowPublicKey: Yi.value });
        let B = D.marker, le = null;
        if (l.level === "names") {
          const $e = await yb(B, D.fmk);
          B = $e.marker, le = $e.names;
        }
        B = Gz(B, void 0, l.cleanup ?? { versions: !1, trash: !1 }), await o.uploadMultipart(S, [
          new File([JSON.stringify(B)], en, { type: "application/json" })
        ]), fa.set(S, D.fmk, le), Yt.setMarker(S, B), pn.value++, qi.value = !1, Ko.value = null, No.value = D.recoveryKey, Bo.value = l.name, ji.value = "created", Ro.value = !0, await zt(wl(S)), await Jt(), Ht.value === S && (Xt.value = B, mg());
      } catch (D) {
        n("error", { message: D.message, context: { op: "e2e-convert" } }), it(m("e2e.convert.failed"));
      } finally {
        $l.value = !1;
      }
    }
    async function mg() {
      var B, le, $e;
      const l = Ht.value, c = l ? fa.get(l) : void 0, S = Xt.value;
      if (!l || !c || !S || !kb(S) || lo.value) return;
      lo.value = !0, Xi.value = "", Ji = !1, Ds.value = { total: 0, done: 0, skipped: 0, tooBig: 0, failed: 0 };
      const D = Ds.value;
      try {
        if (await FZ(
          l,
          {
            list: async (mt) => (await o.index(mt)).files ?? [],
            head: (mt) => o.fetchHead(mt, 16),
            read: (mt) => o.fetchArrayBuffer(mt),
            write: async (mt, bt, pa, Fa) => {
              await o.uploadMultipart(
                mt,
                [new File([pa], bt.basename, { type: "application/octet-stream" })],
                void 0,
                { e2e_convert: "1", ...Fa ? { expect: Fa } : {} }
              );
            },
            encrypt: (mt) => _b(c, mt),
            stopped: () => Ji
          },
          D,
          { maxBytes: Lc }
        ), Ji) {
          it(m("e2e.convert.stopped", { n: D.done }));
          return;
        }
        if (D.failed + D.tooBig > 0) {
          Xi.value = m("e2e.convert.partial", { n: D.failed + D.tooBig });
          return;
        }
        if ((le = (B = Xt.value) == null ? void 0 : B.names) != null && le.pending && !await gc()) return;
        const Be = Xt.value ?? S, Xe = ($e = Be.conv) == null ? void 0 : $e.cleanup;
        await io(Xz(Be)), Ds.value = null;
        try {
          const mt = await o.e2eCleanup({ path: l, versions: !!(Xe != null && Xe.versions), trash: !!(Xe != null && Xe.trash) });
          it(
            m("e2e.convert.done", {
              n: D.done + D.skipped,
              versions: mt.versions_deleted,
              trash: mt.trash_purged
            })
          );
        } catch (mt) {
          it(m("e2e.convert.cleanup_failed")), n("error", { message: mt.message, context: { op: "e2e-convert-cleanup" } });
        }
      } catch (Be) {
        Xi.value = m("e2e.convert.failed"), n("error", { message: Be.message, context: { op: "e2e-convert" } });
      } finally {
        lo.value = !1, await zt();
      }
    }
    function CS() {
      ro.value = !1, yg("change");
    }
    function ES() {
      ro.value = !1, mS();
    }
    const Zi = b(!1), yp = b("change"), Cl = b(!1), Vo = b(null);
    let Qi = null;
    const qo = b(!1), El = b(""), er = b(null), AS = x(() => (pn.value, kr(Xt.value))), zS = x(() => !!Xt.value && Zw(Xt.value));
    function yg(l) {
      yp.value = l, Vo.value = null, Zi.value = !0;
    }
    function MS() {
      if (!Cl.value) {
        if (yp.value === "reset") {
          rg();
          return;
        }
        Zi.value = !1;
      }
    }
    async function gg(l, c, S) {
      try {
        await o.e2ePasswordChanged({ path: l, via: c, rekey: S });
      } catch (D) {
        n("error", { message: D.message, context: { op: "e2e-password-announce" } }), ra({ message: m("e2e.password.announce_failed") }, Oa);
      }
    }
    async function DS(l) {
      const c = Ht.value, S = Xt.value;
      if (!c || !S || Cl.value) return;
      const D = l.proof ?? (Qi ? { recoveryKey: Qi } : null);
      if (!D) {
        Vo.value = m("e2e.password.current_required");
        return;
      }
      const B = "recoveryKey" in D ? "recovery_key" : "password";
      Cl.value = !0, Vo.value = null;
      try {
        if (!l.rotate) {
          const $e = await Qw(S, D, l.newPassword);
          await io($e), Qi = null, Zi.value = !1, await gg(c, B, !1), it(m("e2e.password.done"));
          return;
        }
        const le = await Wz(S, D, l.newPassword, {
          escrowPublicKey: Yi.value
        });
        await io(le.marker), Wi.value = !1, Fo.value = "", fa.set(c, le.fmk, le.names ?? fa.names(c) ?? null, le.previous), pn.value++, fp(), Qi = null, Zi.value = !1, le.recoveryKeyIsNew && (No.value = le.recoveryKey, Bo.value = Ss(c), ji.value = "replaced", Ro.value = !0), await gg(c, B, !0), await _g();
      } catch (le) {
        le instanceof ea ? Vo.value = m(B === "recovery_key" ? "e2e.password.wrong_recovery" : "e2e.password.wrong_current") : le instanceof e1 ? Vo.value = m("e2e.password.escrow_blocked") : (Vo.value = m("e2e.password.failed"), n("error", { message: le.message, context: { op: "e2e-password" } }));
      } finally {
        Cl.value = !1;
      }
    }
    async function PS(l, c, S) {
      const D = new File([S], c, { type: "application/octet-stream" });
      if (z.shouldChunk(D)) {
        await z.uploadFile({ path: l, file: D });
        return;
      }
      await o.uploadMultipart(l, [D]);
    }
    async function bg(l, c, S) {
      const D = er.value;
      let B;
      try {
        B = await o.index(l);
      } catch {
        D.failed++;
        return;
      }
      for (const le of B.files ?? [])
        if (le.basename !== en) {
          if (le.type === "dir") {
            await bg(le.path, c, S);
            continue;
          }
          try {
            if ((le.size ?? 0) > Lc) {
              await Pt.rewrapLarge(le, c, S) && D.done++;
              continue;
            }
            const $e = await o.fetchArrayBuffer(le.path);
            if (!Or($e)) continue;
            const Be = await t1($e, c, S);
            Be && await PS(l, le.basename, Be), D.done++;
          } catch {
            D.failed++;
          }
        }
    }
    async function _g() {
      const l = Ht.value, c = l ? fa.get(l) : void 0, S = l ? fa.previous(l) : void 0;
      if (!(!l || !c || !S || qo.value)) {
        qo.value = !0, El.value = "", er.value = { done: 0, failed: 0 };
        try {
          await bg(l, S, c);
          const D = er.value;
          if (D.failed > 0) {
            El.value = m("e2e.password.rekey_partial", { n: D.failed });
            return;
          }
          const B = Xt.value;
          B && kr(B) && await io(Jz(B)), fa.dropPrevious(l), pn.value++, it(m("e2e.password.rekey_done", { n: D.done }));
        } catch (D) {
          El.value = m("e2e.password.failed"), n("error", { message: D.message, context: { op: "e2e-rekey" } });
        } finally {
          qo.value = !1, await zt();
        }
      }
    }
    function bc(l) {
      return l.replace(/\/+$/, "");
    }
    function kg(l) {
      if (!l || l.type !== "dir" || l.e2e !== !0) return null;
      const c = bc(l.path);
      return fa.roots().find((S) => bc(S) === c) ?? null;
    }
    async function OS(l) {
      const c = l.length === 1 ? l[0] : null;
      if (c && Yo(c) && !oa.value && !c.e2e_root)
        return await Pt.download(c), !0;
      let S = null;
      if (Wa.value ? S = Ht.value : c && (S = kg(c)), !S && l.length > 0) {
        const $e = l.map((Xe) => Yt.rootOf(Xe.path, Xe.e2e_root ?? null)), Be = $e[0];
        Be && $e.every((Xe) => Xe === Be) && (S = fa.roots().find((Xe) => bc(Xe) === bc(Be)) ?? null);
      }
      if (!S) return !1;
      const D = fa.get(S);
      if (!D) return !1;
      if (c && c.type === "file")
        return await Pt.downloadFolderFile(c, D, fa.previous(S), S), !0;
      const B = Yt.segmentLabel(qt(M.value)) ?? Ss(qt(M.value)), le = `${c ? c.basename : B || "filex"}.zip`;
      return await Pt.downloadDecryptedZip(l, {
        root: S,
        fmk: D,
        previous: fa.previous(S),
        decorate: ($e, Be) => Yt.decorate($e, Be),
        zipName: le
      }), !0;
    }
    function LS() {
      const l = Pt.tooBig.value;
      if (Pt.closeTooBig(), !l) return;
      if (l.encrypted.kind === "file") {
        window.open(o.downloadUrl(l.encrypted.path), "_blank");
        return;
      }
      const c = { path: l.encrypted.path, basename: Ss(l.encrypted.path), type: "dir" };
      ac([c], { encrypted: !0 });
    }
    function IS() {
      Ro.value = !1, No.value = "", Bo.value = "";
    }
    return (l, c) => {
      var S, D, B, le, $e, Be, Xe, mt, bt, pa, Fa, Va, Ps, uo, Ya, co, tr;
      return u(), d("div", {
        ref_key: "rootEl",
        ref: ga,
        class: Re(["fe", {
          "fe--theme-light": ba.value === "light",
          "fe--theme-dark": ba.value === "dark",
          "fe--is-dragover": no.value,
          "fe--density-compact": we.value === "compact",
          "fe--narrow": gn.value
        }]),
        dir: r(w),
        tabindex: "-1",
        onDragenter: $$,
        onDragover: T$,
        onDragleave: S$,
        onDrop: C$,
        onContextmenu: Jx
      }, [
        ot(MA, {
          ref_key: "toolbarRef",
          ref: Jm,
          "view-mode": rp.value,
          "search-query": R.value,
          "trash-active": Ae.value,
          actions: o$.value,
          "selection-mode": Yx.value,
          "selection-count": Za().length,
          "selection-pane": Yy.value,
          "paste-enabled": !!se.value.mode,
          "can-go-up": At.value,
          "at-virtual-root": _t.value,
          "can-write": Qn.value,
          locale: g.value,
          narrow: gn.value,
          theme: ba.value,
          "inspector-open": Zn.value,
          "nav-open": Y2.value,
          "nav-enabled": nl.value,
          "view-modes": gf.value,
          "scope-label": Nm.value,
          "brand-name": (S = e.config.brand) == null ? void 0 : S.name,
          "brand-mark-url": (D = e.config.brand) == null ? void 0 : D.markUrl,
          "search-escalates": Ce.value === "home",
          onOpenPalette: ux,
          onToggleInspector: hf,
          onToggleNav: Mm,
          onOpenTheme: c[0] || (c[0] = (Fe) => rc.value = !0),
          "onUpdate:viewMode": c[1] || (c[1] = (Fe) => Wy(Fe)),
          "onUpdate:searchQuery": lx,
          onOpenAdvancedSearch: ix,
          "onUpdate:density": c[2] || (c[2] = (Fe) => we.value = Fe),
          onOpenShortcutSettings: c[3] || (c[3] = (Fe) => ml.value = !0),
          onOpenTimezone: c[4] || (c[4] = (Fe) => Tt.value = !0),
          onNewFolder: c[5] || (c[5] = (Fe) => yn.value = !0),
          onUpload: to,
          onRefresh: ny,
          onGoUp: tt,
          onAction: Bf,
          onOpenRecents: c[6] || (c[6] = (Fe) => xs.value = !0)
        }, qS({
          "header-actions": yt(() => {
            var Fe;
            return [
              r(Ct) ? (u(), nt(die, {
                key: 0,
                feed: r(Ct),
                locale: g.value,
                "manage-href": ta.value,
                onOpen: ia,
                onManage: Rt
              }, null, 8, ["feed", "locale", "manage-href"])) : T("", !0),
              e.config.account ? (u(), nt(Vie, {
                key: 1,
                actions: xt.value,
                user: _e.value,
                version: (Fe = ne.value) == null ? void 0 : Fe.version,
                locale: g.value,
                "fallback-label": r(m)("explore.account"),
                onSelect: Bt
              }, null, 8, ["actions", "user", "version", "locale", "fallback-label"])) : T("", !0),
              wa(l.$slots, "header-actions")
            ];
          }),
          _: 2
        }, [
          l.$slots.brand ? {
            name: "brand",
            fn: yt(() => [
              wa(l.$slots, "brand")
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["view-mode", "search-query", "trash-active", "actions", "selection-mode", "selection-count", "selection-pane", "paste-enabled", "can-go-up", "at-virtual-root", "can-write", "locale", "narrow", "theme", "inspector-open", "nav-open", "nav-enabled", "view-modes", "scope-label", "brand-name", "brand-mark-url", "search-escalates", "onOpenPalette", "onToggleInspector", "onToggleNav", "onUpdate:searchQuery", "onOpenAdvancedSearch", "onRefresh"]),
        i("div", {
          class: Re([
            "fe__main",
            { "fe__main--split": Hi.value }
            /* wiring:d1 */
          ])
        }, [
          mf.value ? (u(), nt(UR, {
            key: 0,
            expanded: al.value,
            narrow: gn.value,
            "active-view": Ce.value,
            "active-tag": ut.value,
            "active-tag-kind": Ue.value,
            tags: Vm.value,
            "tags-loaded": Sf.value,
            "active-storage": j.value,
            storages: xf.value,
            "storage-order-custom": r(Km).custom.value,
            onReorderStorages: px,
            "shared-storages": yf.value,
            "trash-visible": e.config.trashVisible !== !1,
            "drafts-visible": Co.value && Di.value,
            "draft-count": $i.value,
            "show-connections": G2.value,
            "show-my-shares": X2.value,
            "show-identity-surfaces": Di.value,
            "can-write": Qn.value && !_t.value && !Ae.value,
            locale: g.value,
            "can-request-files": Qn.value && !_t.value && !Ae.value && !Ce.value && !oa.value,
            "request-files-allowed": Xm.value,
            "can-new-document": T2.value && !Ae.value && !Ce.value && !oa.value,
            onNewDocument: c[7] || (c[7] = (Fe) => Gr.value = !0),
            quota: fx.value,
            theme: ba.value,
            onRequestFiles: cx,
            onToggle: Mm,
            onClose: Zs,
            onOpenView: hx,
            onOpenTag: rl,
            onOpenStorage: qm,
            onUpload: to,
            onNewFolder: c[8] || (c[8] = (Fe) => yn.value = !0),
            onOpenConnections: J2,
            onOpenTokens: Z2,
            onOpenMyShares: c[9] || (c[9] = (Fe) => n("open-my-shares")),
            apps: ct.value,
            onOpenApp: Ut
          }, null, 8, ["expanded", "narrow", "active-view", "active-tag", "active-tag-kind", "tags", "tags-loaded", "active-storage", "storages", "storage-order-custom", "shared-storages", "trash-visible", "drafts-visible", "draft-count", "show-connections", "show-my-shares", "show-identity-surfaces", "can-write", "locale", "can-request-files", "request-files-allowed", "can-new-document", "quota", "theme", "onRequestFiles", "onOpenView", "apps"])) : T("", !0),
          gn.value && Do.value ? (u(), d("button", {
            key: 1,
            type: "button",
            class: "fe-sidenav__scrim",
            title: r(m)("sidenav.close"),
            "aria-label": r(m)("sidenav.close"),
            onClick: Zs
          }, null, 8, xce)) : T("", !0),
          i("div", $ce, [
            W$.value ? (u(), nt($Y, {
              key: 0,
              tabs: Ny.value,
              "active-id": r(op),
              locale: g.value,
              "hide-tabs": !By.value,
              "split-enabled": _l.value,
              "split-active": !!As.value,
              "inspector-enabled": Am.value,
              "inspector-open": Zn.value,
              onSelect: H$,
              onClose: Fy,
              onNew: ip,
              onReorder: c[10] || (c[10] = (Fe, Ga) => r(Pa).move(Fe, Ga)),
              onToggleSplit: Vy,
              onToggleInspector: hf
            }, null, 8, ["tabs", "active-id", "locale", "hide-tabs", "split-enabled", "split-active", "inspector-enabled", "inspector-open"])) : T("", !0),
            i("div", Sce, [
              ot(O_, {
                "pane-id": "main",
                ref_key: "mainPaneRef",
                ref: q$,
                api: r(o),
                locale: g.value,
                theme: ba.value,
                focused: Q$.value,
                path: M.value,
                qualify: qt,
                "to-user": wl,
                clamp: Jy,
                "root-path": r(W),
                floor: r(N),
                "multi-root": ma.value,
                rows: de.value,
                loading: F.value,
                error: X.value,
                order: tx.value,
                "view-mode": G.value,
                "view-modes": gf.value,
                "open-trigger": s.config.openTrigger,
                "show-crumbs": Ce.value !== "home",
                "filter-mode": Le.value,
                "find-label": Ce.value === "home" ? r(m)("filter.find.home") : "",
                "show-view-switcher": Ce.value !== "home",
                "folder-key": fe.value,
                "show-parent-path": !!R.value || J.value,
                trash: Ae.value,
                clipped: ep.value,
                "extra-filters": ol.value,
                "can-write": Qn.value && !Ae.value,
                "can-paste": !!se.value.mode,
                selected: r(L).selected.value,
                filters: Oi.value,
                "thumb-src": r(O).src,
                "keep-badge-for": Un.value ? vy : void 0,
                "starred-ids": xn.value,
                "star-enabled": Di.value,
                "api-base": s.config.apiBase ?? "",
                "auth-headers": () => Na(),
                "auth-credentials": r(o).credentialsMode(),
                "e2e-active": oa.value,
                "body-override": fc.value !== "",
                onActivate: Z$,
                onNavigate: M$,
                onOpen: Cn,
                onOpenTrash: c[19] || (c[19] = () => ts()),
                onClickRow: c[20] || (c[20] = (Fe, Ga) => wy("main", Fe, Ga)),
                onContext: c[21] || (c[21] = (Fe, Ga) => my("main", Fe, Ga)),
                onClearSelection: c[22] || (c[22] = (Fe) => r(L).clear()),
                onDisplayOrder: c[23] || (c[23] = (Fe) => ve.value = Fe),
                onItemDragStart: c[24] || (c[24] = (Fe, Ga) => xy("main", Fe, Ga)),
                onItemDropInto: Dy,
                onTransfer: ag,
                "onUpdate:viewMode": c[25] || (c[25] = (Fe) => G.value = Fe),
                "onUpdate:filters": Pm,
                onCrumbContext: Zx,
                onCopyPath: ic,
                onCrumbDrop: Py,
                onNewFolder: c[26] || (c[26] = (Fe) => yn.value = !0),
                onUpload: to,
                onPaste: c[27] || (c[27] = (Fe) => Bf("paste")),
                onSelectAll: c[28] || (c[28] = (Fe) => r(L).selectAll()),
                onClearFilters: ax,
                onStarChange: jr,
                onRetry: Y
              }, {
                banners: yt(() => [
                  R.value && pe.value && !Ce.value && !Ae.value ? (u(), d("div", Tce, f(r(m)("search.truncated")), 1)) : T("", !0),
                  es.value ? (u(), d("div", Cce, [
                    i("span", Ece, f(Pe(es.value.storage) ? r(m)("coverage.cataloging", { storage: es.value.storage ?? "" }) : r(m)(es.value.key, es.value.vars)), 1),
                    es.value.offerCatalogAll ? (u(), d("button", {
                      key: 0,
                      type: "button",
                      class: "fe-coverage__action",
                      "data-testid": "catalog-coverage-all",
                      disabled: Pe(es.value.storage),
                      "aria-busy": Pe(es.value.storage) ? "true" : void 0,
                      onClick: c[11] || (c[11] = (Fe) => wx(es.value.storage))
                    }, f(Pe(es.value.storage) ? r(m)("coverage.catalog_running") : r(m)("coverage.catalog_all")), 9, Ace)) : T("", !0)
                  ])) : T("", !0),
                  r(C).length || r(E) ? (u(), d("div", zce, [
                    r(C).length ? (u(), nt(dE, {
                      key: 0,
                      users: r(C),
                      locale: g.value
                    }, null, 8, ["users", "locale"])) : T("", !0),
                    r(E) ? (u(), d("span", {
                      key: 1,
                      class: "fe-connbadge",
                      role: "status",
                      title: r(m)("conn.tooltip")
                    }, [
                      c[104] || (c[104] = i("span", {
                        class: "fe-connbadge__dot",
                        "aria-hidden": "true"
                      }, null, -1)),
                      $t(" " + f(r(m)("conn.offline")), 1)
                    ], 8, Mce)) : T("", !0)
                  ])) : T("", !0),
                  Wi.value ? (u(), d("div", Dce, [
                    i("div", Pce, [
                      i("strong", null, f(r(m)("e2e.upgrade.title")), 1),
                      i("p", null, f(r(m)("e2e.upgrade.body")), 1),
                      En.value ? (u(), d("p", Oce, f(r(m)("e2e.upgrade.escrow_note")), 1)) : T("", !0)
                    ]),
                    i("div", Lce, [
                      i("button", {
                        type: "button",
                        class: "fe-btn",
                        disabled: Sl.value,
                        onClick: bS
                      }, f(r(m)("e2e.upgrade.decline")), 9, Ice),
                      i("button", {
                        type: "button",
                        class: "fe-btn fe-btn--primary",
                        disabled: Sl.value,
                        onClick: hS
                      }, f(Sl.value ? r(m)("e2e.upgrade.busy") : r(m)("e2e.upgrade.accept")), 9, Rce)
                    ])
                  ])) : T("", !0),
                  oo.value ? (u(), d("div", Nce, [
                    i("div", Bce, [
                      i("strong", null, f(r(m)("e2e.escrowoffer.title")), 1),
                      i("p", null, f(r(m)("e2e.escrowoffer.body")), 1),
                      i("p", Fce, [
                        $t(f(r(m)("e2e.escrowoffer.consequence")) + " ", 1),
                        i("a", {
                          href: dfe,
                          target: "_blank",
                          rel: "noopener noreferrer"
                        }, f(r(m)("e2e.escrowoffer.learn_more")), 1)
                      ]),
                      En.value ? (u(), d("p", Uce, [
                        $t(f(r(m)("e2e.recover.escrow_kid")) + ": ", 1),
                        i("code", null, f(En.value), 1)
                      ])) : T("", !0),
                      Tl.value === "manual" ? (u(), d("label", Hce, [
                        i("span", null, f(r(m)("e2e.escrowoffer.password_label")), 1),
                        dt(i("input", {
                          "onUpdate:modelValue": c[12] || (c[12] = (Fe) => ss.value = Fe),
                          type: "password",
                          class: "fe-input",
                          autocomplete: "current-password",
                          disabled: os.value,
                          onKeyup: ya(cg, ["enter"])
                        }, null, 40, Kce), [
                          [St, ss.value]
                        ])
                      ])) : T("", !0),
                      is.value ? (u(), d("p", Vce, f(is.value), 1)) : T("", !0)
                    ]),
                    i("div", qce, [
                      i("button", {
                        type: "button",
                        class: "fe-btn",
                        disabled: os.value,
                        onClick: c[13] || (c[13] = (Fe) => Tl.value === "manual" ? gS() : yS())
                      }, f(Tl.value === "manual" ? r(m)("e2e.escrowoffer.cancel") : r(m)("e2e.escrowoffer.decline")), 9, jce),
                      i("button", {
                        type: "button",
                        class: "fe-btn fe-btn--primary",
                        disabled: os.value,
                        onClick: cg
                      }, f(os.value ? r(m)("e2e.escrowoffer.busy") : r(m)("e2e.escrowoffer.accept")), 9, Wce)
                    ])
                  ])) : T("", !0),
                  Wa.value && (hg.value || lo.value || Xi.value) ? (u(), d("div", Yce, [
                    i("div", Gce, [
                      i("strong", null, f(lo.value ? r(m)("e2e.convert.busy") : r(m)("e2e.convert.resume_title")), 1),
                      lo.value ? T("", !0) : (u(), d("p", Xce, f(r(m)("e2e.convert.resume_body")), 1)),
                      Ds.value ? (u(), d("p", Jce, f(r(m)("e2e.convert.progress", {
                        n: Ds.value.done + Ds.value.skipped,
                        total: Ds.value.total,
                        failed: Ds.value.failed + Ds.value.tooBig
                      })), 1)) : T("", !0),
                      Xi.value ? (u(), d("p", Zce, f(Xi.value), 1)) : T("", !0)
                    ]),
                    i("div", Qce, [
                      lo.value ? (u(), d("button", {
                        key: 0,
                        type: "button",
                        class: "fe-btn",
                        "data-testid": "e2e-convert-stop",
                        onClick: c[14] || (c[14] = (Fe) => xg(Ji) ? Ji.value = !0 : Ji = !0)
                      }, f(r(m)("e2e.names.stop")), 1)) : (u(), d("button", {
                        key: 1,
                        type: "button",
                        class: "fe-btn fe-btn--primary",
                        "data-testid": "e2e-convert-resume",
                        onClick: mg
                      }, f(r(m)("e2e.names.resume")), 1))
                    ])
                  ])) : T("", !0),
                  Wa.value && !hg.value && !lo.value && (mp.value === "pending" || Ms.value || Uo.value) ? (u(), d("div", ede, [
                    i("div", tde, [
                      i("strong", null, f(Ms.value ? r(m)("e2e.names.busy") : r(m)("e2e.names.resume_title")), 1),
                      Ms.value ? T("", !0) : (u(), d("p", ade, f(r(m)("e2e.names.resume_body")), 1)),
                      Ho.value ? (u(), d("p", nde, f(r(m)("e2e.names.progress", { n: Ho.value.renamed, failed: Ho.value.failed })), 1)) : T("", !0),
                      Uo.value ? (u(), d("p", sde, f(Uo.value), 1)) : T("", !0)
                    ]),
                    i("div", ode, [
                      Ms.value ? (u(), d("button", {
                        key: 0,
                        type: "button",
                        class: "fe-btn",
                        "data-testid": "e2e-names-stop",
                        onClick: c[15] || (c[15] = (Fe) => xg(Gi) ? Gi.value = !0 : Gi = !0)
                      }, f(r(m)("e2e.names.stop")), 1)) : (u(), d("button", {
                        key: 1,
                        type: "button",
                        class: "fe-btn fe-btn--primary",
                        "data-testid": "e2e-names-resume",
                        onClick: gc
                      }, f(r(m)("e2e.names.resume")), 1))
                    ])
                  ])) : T("", !0),
                  Wa.value && (AS.value || qo.value) ? (u(), d("div", ide, [
                    i("div", rde, [
                      i("strong", null, f(r(m)("e2e.password.resume_title")), 1),
                      i("p", null, f(r(m)("e2e.password.resume_body")), 1),
                      er.value ? (u(), d("p", lde, f(r(m)("e2e.password.progress", { n: er.value.done, failed: er.value.failed })), 1)) : T("", !0),
                      El.value ? (u(), d("p", ude, f(El.value), 1)) : T("", !0)
                    ]),
                    i("div", cde, [
                      i("button", {
                        type: "button",
                        class: "fe-btn fe-btn--primary",
                        "data-testid": "e2e-rekey-resume",
                        disabled: qo.value,
                        onClick: _g
                      }, f(qo.value ? r(m)("e2e.password.busy") : r(m)("e2e.names.resume")), 9, dde)
                    ])
                  ])) : T("", !0),
                  Wa.value ? (u(), d("div", fde, [
                    i("span", {
                      class: "fe-e2e-strip__icon",
                      "aria-hidden": "true",
                      innerHTML: r(wt)("lock")
                    }, null, 8, pde),
                    i("span", vde, f(r(m)("e2e.strip.label")), 1),
                    i("span", hde, f(vg.value ? r(m)("e2e.level.names") : r(m)("e2e.level.content")), 1),
                    i("button", {
                      type: "button",
                      class: "fe-btn fe-e2e-strip__btn",
                      "data-testid": "e2e-settings-open",
                      disabled: qo.value || Ms.value,
                      onClick: c[16] || (c[16] = (Fe) => ro.value = !0)
                    }, f(r(m)("e2e.settings.open")), 9, mde),
                    i("button", {
                      type: "button",
                      class: "fe-btn fe-e2e-strip__btn",
                      onClick: rg
                    }, f(r(m)("e2e.strip.lock")), 1)
                  ])) : T("", !0),
                  be.value && !F.value ? (u(), d("div", yde, [
                    i("p", gde, f(Cx.value), 1),
                    iy.value ? (u(), d("p", bde, f(iy.value), 1)) : T("", !0),
                    eo.value ? (u(), d("button", {
                      key: 1,
                      type: "button",
                      class: "fe-btn fe-btn--danger fe-trashbar__action",
                      disabled: de.value.length === 0 || Gu.value,
                      "data-testid": "trash-empty",
                      onClick: c[17] || (c[17] = (Fe) => cl.value = !0)
                    }, f(r(m)("trash.empty_action")), 9, _de)) : T("", !0)
                  ])) : T("", !0)
                ]),
                body: yt(() => [
                  fc.value === "home" ? (u(), nt(_B, {
                    key: 0,
                    storages: $f.value,
                    recent: Um.value,
                    starred: Hm.value,
                    loading: wf.value,
                    locale: g.value,
                    "name-filter": Oi.value.name ?? "",
                    "thumb-src": r(O).src,
                    onOpenStorage: qm,
                    onOpenNode: Cn,
                    onContextNode: Vf
                  }, null, 8, ["storages", "recent", "starred", "loading", "locale", "name-filter", "thumb-src"])) : fc.value === "drafts" ? (u(), nt(DB, {
                    key: 1,
                    drafts: lf.value,
                    loading: cf.value,
                    limit: uf.value,
                    locale: g.value,
                    "name-filter": Oi.value.name ?? "",
                    "busy-key": Eo.value,
                    onOpen: c[18] || (c[18] = (Fe) => Sm(Fe)),
                    onSave: E2,
                    onDelete: A2
                  }, null, 8, ["drafts", "loading", "limit", "locale", "name-filter", "busy-key"])) : fc.value === "notfound" ? (u(), d("div", kde, [
                    c[105] || (c[105] = i("svg", {
                      class: "fe-state__art",
                      viewBox: "0 0 120 100",
                      width: "110",
                      height: "92",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "aria-hidden": "true"
                    }, [
                      i("path", { d: "M18 36v42a6 6 0 0 0 6 6h72a6 6 0 0 0 6-6V44a6 6 0 0 0-6-6H62l-9-10H24a6 6 0 0 0-6 6z" }),
                      i("path", { d: "M52 55c0-4.6 3.6-8 8-8s8 3.4 8 8c0 5.5-8 4.8-8 11" }),
                      i("circle", {
                        cx: "60",
                        cy: "73",
                        r: "1.6",
                        fill: "currentColor",
                        stroke: "none"
                      })
                    ], -1)),
                    i("p", wde, f(r(m)("notFound.title")), 1),
                    i("p", xde, f(ce.value), 1),
                    i("p", $de, f(r(m)("notFound.desc")), 1),
                    i("div", Sde, [
                      i("button", {
                        type: "button",
                        class: "fe-btn",
                        onClick: Sx
                      }, f(r(m)("notFound.goRoot")), 1)
                    ])
                  ])) : (u(), nt(Y0, {
                    key: 3,
                    locale: g.value,
                    busy: vc.value,
                    error: up.value,
                    onUnlock: uS,
                    onRecovery: lg
                  }, null, 8, ["locale", "busy", "error"]))
                ]),
                empty: yt(() => [
                  R.value ? (u(), d("div", Tde, [
                    c[106] || (c[106] = i("svg", {
                      class: "fe-state__art",
                      viewBox: "0 0 120 100",
                      width: "110",
                      height: "92",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "aria-hidden": "true"
                    }, [
                      i("circle", {
                        cx: "52",
                        cy: "44",
                        r: "22"
                      }),
                      i("path", { d: "M68 61l20 20" }),
                      i("path", { d: "M46 38l12 12M58 38l-12 12" })
                    ], -1)),
                    i("p", Cde, f(r(m)("empty.search.title")), 1),
                    i("p", Ede, f(r(m)("empty.search.hint")), 1)
                  ])) : Ce.value && Ce.value !== "trash" ? (u(), d("div", {
                    key: 1,
                    class: "fe-state",
                    "data-testid": `empty-${Ce.value}`
                  }, [
                    (u(), d("svg", zde, [
                      Ce.value === "recent" ? (u(), d(he, { key: 0 }, [
                        c[107] || (c[107] = i("circle", {
                          cx: "60",
                          cy: "50",
                          r: "28"
                        }, null, -1)),
                        c[108] || (c[108] = i("path", { d: "M60 32v18l12 8" }, null, -1))
                      ], 64)) : Ce.value === "starred" ? (u(), d("path", Mde)) : Ce.value === "tag" ? (u(), d(he, { key: 2 }, [
                        c[109] || (c[109] = i("path", { d: "M30 30h24l32 32-24 24-32-32z" }, null, -1)),
                        c[110] || (c[110] = i("circle", {
                          cx: "43",
                          cy: "43",
                          r: "4.5"
                        }, null, -1))
                      ], 64)) : (u(), d(he, { key: 3 }, [
                        c[111] || (c[111] = i("circle", {
                          cx: "84",
                          cy: "34",
                          r: "9"
                        }, null, -1)),
                        c[112] || (c[112] = i("circle", {
                          cx: "36",
                          cy: "52",
                          r: "9"
                        }, null, -1)),
                        c[113] || (c[113] = i("circle", {
                          cx: "84",
                          cy: "70",
                          r: "9"
                        }, null, -1)),
                        c[114] || (c[114] = i("path", { d: "M44.5 47.5l31-9M44.5 56.5l31 9" }, null, -1))
                      ], 64))
                    ])),
                    i("p", Dde, f(Ce.value === "tag" ? r(m)("empty.tag.title", { tag: ut.value }) : r(m)(`empty.${Ce.value}.title`)), 1),
                    i("p", Pde, f(Ce.value === "tag" ? r(m)("empty.tag.hint") : r(m)(`empty.${Ce.value}.hint`)), 1)
                  ], 8, Ade)) : be.value ? (u(), d("div", Ode, [
                    c[115] || (c[115] = i("svg", {
                      class: "fe-state__art",
                      viewBox: "0 0 120 100",
                      width: "110",
                      height: "92",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "aria-hidden": "true"
                    }, [
                      i("path", { d: "M38 34l4 48a6 6 0 0 0 6 5.6h24a6 6 0 0 0 6-5.6l4-48" }),
                      i("path", { d: "M32 34h56" }),
                      i("path", { d: "M50 34v-6a6 6 0 0 1 6-6h8a6 6 0 0 1 6 6v6" }),
                      i("path", {
                        d: "M52 44v32M60 44v32M68 44v32",
                        opacity: "0.5"
                      })
                    ], -1)),
                    i("p", Lde, f(r(m)("empty.trash.title")), 1),
                    i("p", Ide, f(r(m)("empty.trash.hint")), 1)
                  ])) : (u(), d("div", Rde, [
                    (u(), d("svg", Nde, [
                      c[117] || (c[117] = i("path", { d: "M18 36v42a6 6 0 0 0 6 6h72a6 6 0 0 0 6-6V44a6 6 0 0 0-6-6H62l-9-10H24a6 6 0 0 0-6 6z" }, null, -1)),
                      qu.value ? (u(), d("g", Bde, [...c[116] || (c[116] = [
                        i("path", {
                          d: "M60 50v14",
                          "stroke-dasharray": "3 4"
                        }, null, -1),
                        i("path", { d: "M53 59l7 8 7-8" }, null, -1)
                      ])])) : T("", !0)
                    ])),
                    i("p", Fde, f(r(m)("empty.folder")), 1),
                    qu.value ? (u(), d("p", Ude, f(r(m)("empty.hint")), 1)) : T("", !0),
                    qu.value ? (u(), d("div", Hde, [
                      i("button", {
                        type: "button",
                        class: "fe-btn fe-btn--primary",
                        onClick: to
                      }, f(r(m)("empty.upload")), 1)
                    ])) : T("", !0)
                  ]))
                ]),
                _: 1
              }, 8, ["api", "locale", "theme", "focused", "path", "root-path", "floor", "multi-root", "rows", "loading", "error", "order", "view-mode", "view-modes", "open-trigger", "show-crumbs", "filter-mode", "find-label", "show-view-switcher", "folder-key", "show-parent-path", "trash", "clipped", "extra-filters", "can-write", "can-paste", "selected", "filters", "thumb-src", "keep-badge-for", "starred-ids", "star-enabled", "api-base", "auth-headers", "auth-credentials", "e2e-active", "body-override"]),
              Hi.value && As.value ? (u(), nt(O_, {
                ref_key: "splitPaneRef",
                ref: na,
                key: "split-" + r(op),
                "pane-id": "split",
                "self-driven": "",
                closable: "",
                api: r(o),
                locale: g.value,
                theme: ba.value,
                focused: Ta.value,
                path: As.value.path,
                qualify: qt,
                "to-user": wl,
                clamp: Jy,
                "root-path": r(W),
                floor: r(N),
                "multi-root": ma.value,
                "virtual-rows": ty,
                "trash-visible": e.config.trashVisible !== !1,
                "nav-offers-trash": zm.value,
                "view-mode": qy.value,
                "view-modes": gf.value,
                "open-trigger": s.config.openTrigger,
                clipped: ep.value,
                "can-write": Qn.value,
                "can-paste": !!se.value.mode,
                selected: r(Ba).selected.value,
                filters: bl.value,
                "folder-key": j$.value,
                "thumb-src": r(O).src,
                "keep-badge-for": Un.value ? vy : void 0,
                "starred-ids": xn.value,
                "star-enabled": Di.value,
                "api-base": s.config.apiBase ?? "",
                "auth-headers": () => Na(),
                "auth-credentials": r(o).credentialsMode(),
                onActivate: c[29] || (c[29] = (Fe) => Vn.value = "split"),
                onClose: Y$,
                onNavigate: G$,
                onOpen: Cn,
                onOpenTrash: J$,
                onClickRow: c[30] || (c[30] = (Fe, Ga) => wy("split", Fe, Ga)),
                onContext: c[31] || (c[31] = (Fe, Ga) => my("split", Fe, Ga)),
                onClearSelection: c[32] || (c[32] = (Fe) => r(Ba).clear()),
                onDisplayOrder: c[33] || (c[33] = (Fe) => gl.value = Fe),
                onItemDragStart: c[34] || (c[34] = (Fe, Ga) => xy("split", Fe, Ga)),
                onItemDropInto: Dy,
                onTransfer: ag,
                "onUpdate:viewMode": jy,
                "onUpdate:filters": c[35] || (c[35] = (Fe) => bl.value = Fe),
                onCopyPath: ic,
                onCrumbDrop: Py,
                onNewFolder: c[36] || (c[36] = (Fe) => yn.value = !0),
                onUpload: to,
                onPaste: c[37] || (c[37] = (Fe) => Bf("paste")),
                onSelectAll: c[38] || (c[38] = (Fe) => r(Ba).selectAll()),
                onClearFilters: c[39] || (c[39] = (Fe) => bl.value = { ...r(ho) }),
                onStarChange: jr
              }, null, 8, ["api", "locale", "theme", "focused", "path", "root-path", "floor", "multi-root", "trash-visible", "nav-offers-trash", "view-mode", "view-modes", "open-trigger", "clipped", "can-write", "can-paste", "selected", "filters", "folder-key", "thumb-src", "keep-badge-for", "starred-ids", "star-enabled", "api-base", "auth-headers", "auth-credentials"])) : T("", !0)
            ])
          ]),
          Zn.value ? (u(), nt(mI, {
            key: 2,
            api: r(o),
            nodes: Xy.value,
            "dir-label": oS.value,
            "dir-count": iS.value,
            "dir-perm": rS.value,
            "held-in": sS.value,
            locale: g.value,
            narrow: gn.value,
            "caller-admin": Sa.value,
            sharing: nS.value,
            "thumb-src": r(O).src,
            "api-base": s.config.apiBase ?? "",
            "auth-headers": () => Na(),
            "auth-credentials": r(o).credentialsMode(),
            "plugin-views": Ze.value,
            theme: ba.value,
            storages: (s.config.storages ?? []).map((Fe) => Fe.name),
            onPluginOp: c[40] || (c[40] = (Fe) => ws(Fe)),
            onPluginOpen: c[41] || (c[41] = (Fe) => qr(Fe.plugin, Fe.req)),
            onOpenTag: $a,
            onClose: Em,
            onShareCreated: dx,
            onManagePermissions: yx,
            onToast: it,
            onChanged: c[42] || (c[42] = () => {
              var Fe;
              return Ta.value ? void ((Fe = na.value) == null ? void 0 : Fe.reload()) : void zt();
            })
          }, null, 8, ["api", "nodes", "dir-label", "dir-count", "dir-perm", "held-in", "locale", "narrow", "caller-admin", "sharing", "thumb-src", "api-base", "auth-headers", "auth-credentials", "plugin-views", "theme", "storages", "onOpenTag", "onShareCreated"])) : T("", !0)
        ], 2),
        Pi.value || sl.value ? (u(), d("div", {
          key: 0,
          class: "fe-overlay",
          "data-testid": "explorer-overlay",
          onClick: ft(Ru, ["self"])
        }, [
          i("div", {
            class: "fe-overlay__card",
            onClick: c[43] || (c[43] = ft(() => {
            }, ["stop"]))
          }, [
            Pi.value ? (u(), nt($H, {
              key: 0,
              config: e.config,
              closable: "",
              onClose: Ru,
              onError: ex
            }, null, 8, ["config"])) : (u(), d(he, { key: 1 }, [
              i("header", Kde, [
                i("h2", Vde, f(r(m)("sidenav.apikeys")), 1),
                i("button", {
                  type: "button",
                  class: "fe-overlay__close",
                  title: r(m)("overlay.close"),
                  "aria-label": r(m)("overlay.close"),
                  onClick: Ru
                }, " × ", 8, qde)
              ]),
              ot(S0, {
                config: e.config,
                full: ""
              }, null, 8, ["config"])
            ], 64))
          ])
        ])) : T("", !0),
        no.value ? (u(), d("div", jde, [
          i("div", Wde, [
            i("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: r(wt)("upload")
            }, null, 8, Yde),
            i("p", null, f(r(m)("dropzone.hint")), 1)
          ])
        ])) : T("", !0),
        ot(y3, {
          jobs: Ia.value,
          locale: g.value,
          center: r(yl),
          onCancel: A$,
          onDismiss: z$,
          onRetry: R$
        }, null, 8, ["jobs", "locale", "center"]),
        ot(b3, {
          ops: r(I).ops.value,
          locale: g.value,
          center: r(yl),
          "output-mode-of": $o,
          "caller-admin": Sa.value,
          onCancel: g$,
          onDismiss: c[44] || (c[44] = (Fe) => r(I).dismiss(Fe)),
          onOpen: Ws
        }, null, 8, ["ops", "locale", "center", "caller-admin"]),
        ot(QW, {
          center: r(yl),
          locale: g.value,
          narrow: gn.value
        }, null, 8, ["center", "locale", "narrow"]),
        gn.value && qu.value ? (u(), d("button", {
          key: 2,
          type: "button",
          class: "fe-fab",
          title: r(m)("toolbar.upload"),
          "aria-label": r(m)("toolbar.upload"),
          onClick: to
        }, [...c[118] || (c[118] = [
          i("svg", {
            class: "fe-ficon",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2.2",
            "stroke-linecap": "round",
            "aria-hidden": "true",
            focusable: "false"
          }, [
            i("path", { d: "M12 5v14M5 12h14" })
          ], -1)
        ])], 8, Gde)) : T("", !0),
        Ni.value ? (u(), d("div", Xde, [
          c[119] || (c[119] = i("span", {
            class: "fe-keep-strip__icon",
            "aria-hidden": "true"
          }, "⟳", -1)),
          i("span", Jde, f(Xx.value), 1),
          hy.value !== null ? (u(), d("div", Zde, [
            i("div", {
              class: "fe-keep-strip__fill",
              style: Vt({ width: hy.value + "%" })
            }, null, 4)
          ])) : T("", !0)
        ])) : T("", !0),
        ot(zr, {
          ref_key: "ctxRef",
          ref: Po,
          locale: g.value,
          theme: ba.value,
          sheet: Zm.value,
          actions: Qx.value,
          onSelect: i$
        }, null, 8, ["locale", "theme", "sheet", "actions"]),
        ot(lae, {
          open: Gr.value,
          locale: g.value,
          theme: ba.value,
          api: r(o),
          types: xm.value,
          "current-path": qt(M.value),
          storages: (s.config.storages ?? []).map((Fe) => Fe.name),
          "only-office-ready": !!Ys.value,
          "drawio-ready": !!Wr.value,
          "can-configure": Sa.value,
          drafts: Co.value,
          onClose: c[45] || (c[45] = (Fe) => Gr.value = !1),
          onOpenDrafts: D2,
          onCreated: f$,
          onError: c[46] || (c[46] = (Fe) => n("error", { message: Fe.message, context: { op: "newdoc" } }))
        }, null, 8, ["open", "locale", "theme", "api", "types", "current-path", "storages", "only-office-ready", "drawio-ready", "can-configure", "drafts"]),
        ot(Kee, {
          open: yn.value,
          locale: g.value,
          "encrypted-option": !oa.value,
          busy: r(F2),
          error: r(U2),
          onClose: c[47] || (c[47] = (Fe) => yn.value = !1),
          onSubmit: b$,
          onEncrypted: c[48] || (c[48] = (Fe) => {
            yn.value = !1, qi.value = !0;
          })
        }, null, 8, ["open", "locale", "encrypted-option", "busy", "error"]),
        ot(fte, {
          open: Ou.value,
          locale: g.value,
          count: Xr.value.length,
          "suggested-name": P2.value,
          "default-format": L2.value,
          "allowed-formats": Jr.value,
          encryption: I2.value,
          busy: ff.value,
          "request-error": Gn.value,
          onClose: c[49] || (c[49] = (Fe) => Ou.value = !1),
          onSubmit: v$
        }, null, 8, ["open", "locale", "count", "suggested-name", "default-format", "allowed-formats", "encryption", "busy", "request-error"]),
        ot(_te, {
          open: Ao.value,
          locale: g.value,
          "archive-name": ((B = Xs.value) == null ? void 0 : B.basename) || "",
          "suggested-folder": R2.value,
          busy: !!Xs.value && zo.value.has(Xs.value.path),
          error: Gn.value,
          onClose: c[50] || (c[50] = (Fe) => Ao.value = !1),
          onSubmit: h$
        }, null, 8, ["open", "locale", "archive-name", "suggested-folder", "busy", "error"]),
        ot(Ete, {
          open: Si.value,
          locale: g.value,
          "archive-name": ((le = Mo.value) == null ? void 0 : le.target.basename) || (($e = Xs.value) == null ? void 0 : $e.basename) || "",
          busy: !!Mo.value && zo.value.has(Mo.value.target.path),
          error: Ei.value,
          onClose: y$,
          onSubmit: m$
        }, null, 8, ["open", "locale", "archive-name", "busy", "error"]),
        ot(am, {
          open: el.value,
          api: r(o),
          locale: g.value,
          mode: Lu.value,
          busy: Iu.value,
          storages: (s.config.storages ?? []).map((Fe) => Fe.name),
          "start-at": qt(Ta.value ? ((Be = na.value) == null ? void 0 : Be.getPath()) ?? "" : M.value),
          moving: Lu.value === "move" ? pf.value.filter((Fe) => Fe.type === "dir").map((Fe) => Fe.path) : [],
          onClose: c[51] || (c[51] = (Fe) => el.value = !1),
          onPick: d$
        }, null, 8, ["open", "api", "locale", "mode", "busy", "storages", "start-at", "moving"]),
        ot(hJ, {
          open: qi.value,
          locale: g.value,
          busy: $l.value,
          "escrow-kid": En.value,
          existing: Ko.value ? Ko.value.basename : null,
          onClose: c[52] || (c[52] = (Fe) => {
            qi.value = !1, Ko.value = null;
          }),
          onSubmit: c[53] || (c[53] = (Fe) => Ko.value ? TS(Fe) : pS(Fe))
        }, null, 8, ["open", "locale", "busy", "escrow-kid", "existing"]),
        ot(SJ, {
          open: Ro.value,
          locale: g.value,
          "recovery-key": No.value,
          "folder-name": Bo.value,
          "escrow-kid": En.value,
          variant: ji.value,
          onClose: IS
        }, null, 8, ["open", "locale", "recovery-key", "folder-name", "escrow-kid", "variant"]),
        ot(OZ, {
          open: ro.value,
          locale: g.value,
          level: mp.value,
          "can-raise": kS.value,
          "plain-named": wS.value,
          "escrow-state": ug.value === "n/a" || oo.value ? "n/a" : ug.value,
          busy: Ms.value,
          onClose: c[54] || (c[54] = (Fe) => ro.value = !1),
          onRaiseLevel: gc,
          onFixNames: gc,
          onChangePassword: CS,
          onEscrow: ES
        }, null, 8, ["open", "locale", "level", "can-raise", "plain-named", "escrow-state", "busy"]),
        ot(L_, {
          open: Zi.value,
          locale: g.value,
          mode: yp.value,
          "needs-rekey": zS.value,
          "has-recovery": r(bb)(Xt.value),
          "has-escrow": r(Kw)(Xt.value),
          busy: Cl.value,
          error: Vo.value,
          onClose: MS,
          onSubmit: DS
        }, null, 8, ["open", "locale", "mode", "needs-rekey", "has-recovery", "has-escrow", "busy", "error"]),
        ot(FJ, {
          open: hc.value,
          locale: g.value,
          "has-recovery": r(bb)(Xt.value),
          "escrow-state": r(Vw)(Xt.value, En.value),
          "escrow-kid": ((mt = (Xe = Xt.value) == null ? void 0 : Xe.esc) == null ? void 0 : mt.kid) || En.value,
          busy: cp.value,
          error: zs.value,
          onClose: c[55] || (c[55] = (Fe) => hc.value = !1),
          onSubmit: vS
        }, null, 8, ["open", "locale", "has-recovery", "escrow-state", "escrow-kid", "busy", "error"]),
        ot(hQ, {
          open: !!r(Pt).encryptTarget.value,
          locale: g.value,
          "file-name": ((bt = r(Pt).encryptTarget.value) == null ? void 0 : bt.basename) ?? "",
          busy: r(Pt).encryptBusy.value,
          error: r(Pt).encryptError.value,
          progress: r(Pt).encryptProgress.value,
          "escrow-kid": En.value,
          "can-purge": Sa.value,
          "not-owner": !!r(Pt).encryptTarget.value && !r(Yd)(r(Pt).encryptTarget.value),
          "owner-name": r(Pt).encryptTarget.value ? r(Yh)(r(Pt).encryptTarget.value) : "",
          onClose: c[56] || (c[56] = (Fe) => r(Pt).closeEncrypt()),
          onSubmit: c[57] || (c[57] = (Fe) => r(Pt).submitEncrypt(Fe))
        }, null, 8, ["open", "locale", "file-name", "busy", "error", "progress", "escrow-kid", "can-purge", "not-owner", "owner-name"]),
        ot(RQ, {
          open: !!r(Pt).unlockTarget.value,
          locale: g.value,
          intent: r(Pt).unlockIntent.value,
          "file-name": r(Pt).unlockTarget.value ? r(Pt).realName(r(Pt).unlockTarget.value.path) ?? r(Pt).unlockTarget.value.basename : "",
          known: !!r(Pt).unlockTarget.value && !!r(Pt).realName(r(Pt).unlockTarget.value.path),
          "has-recovery": r(Pt).unlockHasRecovery.value,
          busy: r(Pt).unlockBusy.value,
          error: r(Pt).unlockError.value,
          progress: r(Pt).unlockProgress.value,
          "needs-save": r(Pt).unlockNeedsSave.value,
          "escrow-state": r(Pt).unlockEscrow.value,
          "escrow-kid": r(Pt).unlockEscrowKid.value || En.value,
          onClose: c[58] || (c[58] = (Fe) => r(Pt).closeUnlock()),
          onSubmit: c[59] || (c[59] = (Fe) => r(Pt).submitUnlock(Fe))
        }, null, 8, ["open", "locale", "intent", "file-name", "known", "has-recovery", "busy", "error", "progress", "needs-save", "escrow-state", "escrow-kid"]),
        ot(VQ, {
          open: !!r(Pt).tooBig.value,
          locale: g.value,
          info: r(Pt).tooBig.value,
          onClose: c[60] || (c[60] = (Fe) => r(Pt).closeTooBig()),
          onDownload: LS
        }, null, 8, ["open", "locale", "info"]),
        ot(L_, {
          open: !!r(Pt).pwTarget.value,
          locale: g.value,
          mode: "change",
          subject: "file",
          "needs-rekey": !1,
          "has-recovery": !0,
          "has-escrow": !1,
          busy: r(Pt).pwBusy.value,
          error: r(Pt).pwError.value,
          onClose: c[61] || (c[61] = (Fe) => r(Pt).closePassword()),
          onSubmit: c[62] || (c[62] = (Fe) => r(Pt).submitPassword(Fe))
        }, null, 8, ["open", "locale", "busy", "error"]),
        ot(pae, {
          open: Gs.value,
          locale: g.value,
          "current-name": ((pa = Ai.value) == null ? void 0 : pa.basename) || "",
          error: r(B2),
          busy: r(N2),
          onClose: c[63] || (c[63] = (Fe) => Gs.value = !1),
          onSubmit: _$
        }, null, 8, ["open", "locale", "current-name", "error", "busy"]),
        ot(la, {
          open: cl.value,
          title: r(m)("trash.empty_confirm_title"),
          size: "sm",
          onClose: c[65] || (c[65] = (Fe) => cl.value = !1)
        }, {
          actions: yt(() => [
            i("button", {
              type: "button",
              class: "fe-btn",
              onClick: c[64] || (c[64] = (Fe) => cl.value = !1)
            }, f(r(m)("modal.delete.cancel")), 1),
            i("button", {
              type: "button",
              class: "fe-btn fe-btn--danger",
              "data-testid": "trash-empty-confirm",
              onClick: zx
            }, f(r(m)("trash.empty_action")), 1)
          ]),
          default: yt(() => [
            i("p", null, f(r(m)(Ax.value, { count: de.value.length, size: r(k)(oy.value) })), 1)
          ]),
          _: 1
        }, 8, ["open", "title"]),
        ot(yae, {
          open: dn.value,
          locale: g.value,
          count: r(L).size.value,
          permanent: be.value,
          busy: r(H2),
          error: r(K2),
          onClose: c[66] || (c[66] = (Fe) => dn.value = !1),
          onConfirm: w$
        }, null, 8, ["open", "locale", "count", "permanent", "busy", "error"]),
        ot(V0, {
          open: Bn.value,
          locale: g.value,
          file: Ra.value,
          theme: ba.value,
          "preview-url": (Fe) => yc(Fe),
          "download-url": (Fe) => Wa.value || xl.value ? yc(Fe) : r(o).downloadUrl(Fe),
          "only-office-base": oa.value || xl.value ? null : Ys.value,
          "only-office-config-endpoint": xi.value,
          "can-configure": Sa.value,
          "new-tab-enabled": !oa.value && !xl.value,
          "save-text-endpoint": oa.value || xl.value ? null : r(o).endpoints.saveText || null,
          "archive-list-endpoint": r(o).endpoints.archiveList || null,
          "open-mode": Js.value,
          "open-as": V2.value,
          "auth-headers": () => Na({ "Content-Type": "application/json" }),
          "auth-credentials": r(o).credentialsMode(),
          "drawio-url": Wr.value,
          "pdf-worker-url": s.config.pdfWorkerUrl || null,
          "pdf-save-url": s.config.pdfSaveUrl || null,
          "viewer-base-url": Ly.value,
          index: te.value.index,
          total: te.value.total,
          "nav-enabled": te.value.total > 1,
          "share-enabled": !oa.value && !xl.value,
          onShare: c[67] || (c[67] = () => {
            const Fe = Ra.value;
            Fe && ($n.value = Fe, Bu.value = void 0, Mi.value = !0);
          }),
          "api-base": s.config.apiBase ?? "",
          "drafts-endpoint": Co.value ? r(o).draftsBase : null,
          "app-viewer": De.value,
          api: r(o),
          "user-name": s.config.userName || "",
          onToast: it,
          onOp: c[68] || (c[68] = (Fe) => ws(Fe)),
          onNav: Te,
          onDraftSaved: z2,
          onDraftDiscarded: M2,
          onClose: c[69] || (c[69] = (Fe) => Bn.value = !1)
        }, null, 8, ["open", "locale", "file", "theme", "preview-url", "download-url", "only-office-base", "only-office-config-endpoint", "can-configure", "new-tab-enabled", "save-text-endpoint", "archive-list-endpoint", "open-mode", "open-as", "auth-headers", "auth-credentials", "drawio-url", "pdf-worker-url", "pdf-save-url", "viewer-base-url", "index", "total", "nav-enabled", "share-enabled", "api-base", "drafts-endpoint", "app-viewer", "api", "user-name"]),
        ot(K0, {
          open: !!r($s).question.value,
          locale: g.value,
          theme: ba.value,
          name: ((Fa = r($s).question.value) == null ? void 0 : Fa.name) ?? "",
          suggested: ((Va = r($s).question.value) == null ? void 0 : Va.suggested) ?? "",
          folder: ((Ps = r($s).question.value) == null ? void 0 : Ps.folder) ?? "",
          busy: r($s).busy.value,
          error: r($s).error.value,
          onCancel: r($s).cancel,
          onConfirm: r($s).confirm
        }, null, 8, ["open", "locale", "theme", "name", "suggested", "folder", "busy", "error", "onCancel", "onConfirm"]),
        vt.value ? (u(), nt(Oae, {
          key: `${vt.value.plugin}/${vt.value.view}`,
          api: r(o),
          locale: g.value,
          theme: ba.value,
          plugin: vt.value.plugin,
          view: vt.value.view,
          placement: vt.value.placement,
          ui: vt.value.ui,
          label: vt.value.label,
          files: vt.value.files,
          "user-name": s.config.userName || "",
          onClose: c[70] || (c[70] = (Fe) => vt.value = null),
          onToast: it,
          onOp: c[71] || (c[71] = (Fe) => ws(Fe))
        }, null, 8, ["api", "locale", "theme", "plugin", "view", "placement", "ui", "label", "files", "user-name"])) : T("", !0),
        oe.value ? (u(), nt(Dae, {
          key: 5,
          open: ue.value,
          api: r(o),
          locale: g.value,
          theme: ba.value,
          plugin: oe.value.plugin,
          view: oe.value.view,
          surface: oe.value.surface,
          path: oe.value.path,
          paths: oe.value.paths,
          size: oe.value.size,
          label: oe.value.label,
          storages: (s.config.storages ?? []).map((Fe) => Fe.name),
          "start-at": qt(Ta.value ? ((uo = na.value) == null ? void 0 : uo.getPath()) ?? "" : M.value),
          onClose: c[72] || (c[72] = (Fe) => oe.value = null),
          onOp: c[73] || (c[73] = (Fe) => ws(Fe)),
          onToast: it,
          onOpen: c[74] || (c[74] = (Fe) => {
            var Ga;
            return qr(((Ga = oe.value) == null ? void 0 : Ga.plugin) ?? "", Fe);
          })
        }, null, 8, ["open", "api", "locale", "theme", "plugin", "view", "surface", "path", "paths", "size", "label", "storages", "start-at"])) : T("", !0),
        ot(h0, {
          open: !!Zt.value,
          locale: g.value,
          theme: ba.value,
          title: Zt.value ? r(jt)(Zt.value.action.label, g.value) : "",
          message: Zt.value ? r(jt)(Zt.value.action.confirm, g.value) : "",
          danger: ((Ya = Zt.value) == null ? void 0 : Ya.action.danger) === !0,
          onClose: c[75] || (c[75] = (Fe) => Zt.value = null),
          onConfirm: _s
        }, null, 8, ["open", "locale", "theme", "title", "message", "danger"]),
        Mi.value && $n.value ? (u(), nt(Ioe, {
          key: 6,
          api: r(o),
          path: $n.value.path,
          "is-dir": $n.value.type === "dir",
          size: typeof $n.value.size == "number" ? $n.value.size : void 0,
          locale: g.value,
          "share-max-ttl-days": Dt.value,
          "initial-tab": Bu.value,
          "mail-ready": (tr = (co = ne.value) == null ? void 0 : co.mail) == null ? void 0 : tr.ready,
          "can-configure": Sa.value,
          perm: $n.value.perm || ke.value,
          sharing: kx.value,
          onClose: c[76] || (c[76] = (Fe) => {
            Mi.value = !1, Bu.value = void 0;
          })
        }, null, 8, ["api", "path", "is-dir", "size", "locale", "share-max-ttl-days", "initial-tab", "mail-ready", "can-configure", "perm", "sharing"])) : T("", !0),
        ot(us, { name: "fe-modal" }, {
          default: yt(() => [
            xs.value ? (u(), d("div", {
              key: 0,
              class: Re(["fe fe-modal__backdrop fe-recents__backdrop", {
                "fe--theme-light": ba.value === "light",
                "fe--theme-dark": ba.value === "dark"
              }]),
              onClick: c[80] || (c[80] = (Fe) => xs.value = !1)
            }, [
              i("div", {
                class: "fe-recents__panel",
                onClick: c[79] || (c[79] = ft(() => {
                }, ["stop"]))
              }, [
                i("div", Qde, [
                  i("strong", null, f(r(m)("recents.title")), 1),
                  i("button", {
                    class: "fe-recents__close",
                    "aria-label": r(m)("recents.close"),
                    onClick: c[77] || (c[77] = (Fe) => xs.value = !1)
                  }, "×", 8, efe)
                ]),
                ot(a3, {
                  locale: g.value,
                  "api-base": s.config.apiBase ?? "",
                  "auth-headers": () => Na(),
                  "auth-credentials": r(o).credentialsMode(),
                  limit: 20,
                  "refresh-key": Du.value,
                  onOpen: Ca,
                  onContext: rf,
                  onError: c[78] || (c[78] = (Fe) => n("error", { message: Fe, context: { op: "recents" } }))
                }, null, 8, ["locale", "api-base", "auth-headers", "auth-credentials", "refresh-key"])
              ])
            ], 2)) : T("", !0)
          ]),
          _: 1
        }),
        ot(us, { name: "fe-modal" }, {
          default: yt(() => [
            So.value && To.value && typeof To.value.id == "number" ? (u(), d("div", {
              key: 0,
              class: "fe-modal__backdrop",
              onClick: c[85] || (c[85] = (Fe) => So.value = !1)
            }, [
              i("div", {
                class: "fe-modal__card fe-modal__card--md",
                onClick: c[84] || (c[84] = ft(() => {
                }, ["stop"]))
              }, [
                i("header", tfe, [
                  i("h2", afe, f(r(m)("tags.title")) + " — " + f(To.value.basename), 1),
                  i("button", {
                    class: "fe-modal__close",
                    "aria-label": r(m)("tags.close"),
                    onClick: c[81] || (c[81] = (Fe) => So.value = !1)
                  }, "×", 8, nfe)
                ]),
                i("div", sfe, [
                  ot(uw, {
                    "node-id": To.value.id,
                    locale: g.value,
                    "api-base": s.config.apiBase ?? "",
                    "auth-headers": () => Na(),
                    "auth-credentials": r(o).credentialsMode(),
                    onOpen: c[82] || (c[82] = (Fe) => {
                    }),
                    onError: c[83] || (c[83] = (Fe) => n("error", { message: Fe, context: { op: "tags" } }))
                  }, null, 8, ["node-id", "locale", "api-base", "auth-headers", "auth-credentials"])
                ])
              ])
            ])) : T("", !0)
          ]),
          _: 1
        }),
        ot(VK, {
          open: il.value,
          locale: g.value,
          theme: ba.value,
          "initial-query": Rm.value,
          "folder-label": Nm.value,
          "path-base": Lm.value,
          "content-search": nx.value,
          count: ox,
          "known-tags": Om.value,
          onClose: c[86] || (c[86] = (Fe) => il.value = !1),
          onSubmit: rx
        }, null, 8, ["open", "locale", "theme", "initial-query", "folder-label", "path-base", "content-search", "known-tags"]),
        ot(h9, {
          "initial-query": bf.value,
          open: Ju.value,
          locale: g.value,
          files: de.value,
          "view-mode": G.value,
          "can-write": Qn.value && !_t.value && !Ae.value,
          "can-go-up": At.value,
          "global-search": Ox,
          "hit-can": Rx,
          onClose: c[87] || (c[87] = (Fe) => Ju.value = !1),
          onOpenHit: Ix,
          onDownloadHit: Bx,
          onDragHit: Fx,
          onWarmHit: Nx,
          onDropInside: Ux,
          onOpenNode: Cn,
          onNavigate: c[88] || (c[88] = (Fe) => zt(Fe)),
          onNewFolder: c[89] || (c[89] = (Fe) => yn.value = !0),
          onUpload: to,
          onToggleView: c[90] || (c[90] = (Fe) => Wy(rp.value === "list" ? "grid" : rp.value === "grid" ? "gallery" : "list")),
          onOpenTrash: ts,
          onRefresh: ny,
          onGoUp: tt,
          onOpenTheme: c[91] || (c[91] = (Fe) => rc.value = !0),
          onOpenShortcutSettings: c[92] || (c[92] = (Fe) => ml.value = !0),
          onStartTour: c[93] || (c[93] = (Fe) => sp()),
          "split-enabled": _l.value,
          onTabNew: c[94] || (c[94] = (Fe) => ip()),
          onSplitToggle: c[95] || (c[95] = (Fe) => Vy())
        }, null, 8, ["initial-query", "open", "locale", "files", "view-mode", "can-write", "can-go-up", "hit-can", "onOpenHit", "onDownloadHit", "onDragHit", "onWarmHit", "onDropInside", "onRefresh", "split-enabled"]),
        ot(t7, {
          open: Zu.value,
          locale: g.value,
          onClose: c[96] || (c[96] = (Fe) => Zu.value = !1),
          onCustomize: c[97] || (c[97] = (Fe) => {
            Zu.value = !1, ml.value = !0;
          })
        }, null, 8, ["open", "locale"]),
        It.value ? (u(), nt(pce, {
          key: 7,
          modelValue: It.value,
          "onUpdate:modelValue": c[98] || (c[98] = (Fe) => It.value = Fe),
          host: Et
        }, null, 8, ["modelValue"])) : T("", !0),
        r(Ct) ? (u(), nt(Mie, {
          key: 8,
          feed: r(Ct),
          locale: g.value,
          onOpen: ia
        }, null, 8, ["feed", "locale"])) : T("", !0),
        ot(A7, {
          open: rc.value,
          locale: g.value,
          theme: ba.value,
          dark: np.value,
          current: r(lc),
          mode: r(hl),
          "host-mode": e.config.theme || "auto",
          onClose: c[99] || (c[99] = (Fe) => rc.value = !1),
          onSelect: r(D$),
          onMode: c[100] || (c[100] = (Fe) => r(Iy)(Fe))
        }, null, 8, ["open", "locale", "theme", "dark", "current", "mode", "host-mode", "onSelect"]),
        i("input", {
          ref_key: "fileInputEl",
          ref: Cm,
          type: "file",
          multiple: "",
          class: "fe__file-input",
          onChange: x$
        }, null, 544),
        ot(us, { name: "fe-toast" }, {
          default: yt(() => [
            fn.value ? (u(), d("div", {
              key: 0,
              class: Re(["fe-toast", { "fe-toast--action": !!fn.value.actionLabel }]),
              role: "status",
              onClick: ey
            }, [
              i("span", ofe, f(fn.value.message), 1),
              fn.value.actionLabel && fn.value.action ? (u(), d("button", {
                key: 0,
                type: "button",
                class: "fe-toast__action",
                onClick: ft(xx, ["stop"])
              }, f(fn.value.actionLabel), 1)) : T("", !0)
            ], 2)) : T("", !0)
          ]),
          _: 1
        }),
        ot(j7, {
          open: Tt.value,
          locale: g.value,
          theme: ba.value,
          onClose: c[101] || (c[101] = (Fe) => Tt.value = !1)
        }, null, 8, ["open", "locale", "theme"]),
        ot(wV, {
          open: ml.value,
          locale: g.value,
          theme: ba.value,
          onClose: c[102] || (c[102] = (Fe) => ml.value = !1)
        }, null, 8, ["open", "locale", "theme"]),
        ot(fW, {
          open: so.value,
          locale: g.value,
          file: Es.value,
          theme: ba.value,
          "preview-url": (Fe) => yc(Fe),
          "download-url": (Fe) => Wa.value ? yc(Fe) : r(o).downloadUrl(Fe),
          "only-office-base": oa.value ? null : Ys.value,
          "only-office-config-endpoint": xi.value,
          "can-configure": Sa.value,
          "auth-headers": () => Na({ "Content-Type": "application/json" }),
          "auth-credentials": r(o).credentialsMode(),
          "drawio-url": Wr.value,
          "pdf-worker-url": s.config.pdfWorkerUrl || null,
          "viewer-base-url": Ly.value,
          onClose: c[103] || (c[103] = (Fe) => so.value = !1),
          onNav: L$,
          onOpenFull: I$
        }, null, 8, ["open", "locale", "file", "theme", "preview-url", "download-url", "only-office-base", "only-office-config-endpoint", "can-configure", "auth-headers", "auth-credentials", "drawio-url", "pdf-worker-url", "viewer-base-url"]),
        ot(cY, {
          open: uc.value,
          locale: g.value,
          root: ga.value,
          theme: ba.value,
          onClose: N$
        }, null, 8, ["open", "locale", "root", "theme"])
      ], 42, wce);
    };
  }
}), pfe = {
  viewBox: "0 0 32 32",
  "aria-hidden": "true"
}, pk = /* @__PURE__ */ rt({
  __name: "LogoMark",
  setup(e) {
    return (a, t) => (u(), d("svg", pfe, [...t[0] || (t[0] = [
      i("rect", {
        width: "32",
        height: "32",
        rx: "7",
        fill: "var(--fe-primary, #2f6ceb)"
      }, null, -1),
      i("path", {
        d: "M7 11a2 2 0 0 1 2-2h5l2 2h7a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V11z",
        fill: "none",
        stroke: "#fff",
        "stroke-width": "1.8",
        "stroke-linejoin": "round"
      }, null, -1),
      i("path", {
        d: "M11.5 17.5l3 2.5 5.5-6",
        fill: "none",
        stroke: "#fff",
        "stroke-width": "1.8",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)
    ])]));
  }
});
function w2(e, a = {}) {
  return e === "app" ? "wide" : e === "folder" ? a.list ? "wide" : "form" : e === "drop" ? "form" : "gate";
}
function vfe(e, a) {
  const t = (a ?? []).map((o) => o.trim().replace(/^\./, "").toLowerCase()).filter(Boolean);
  if (!t.length) return !0;
  const s = e.lastIndexOf("."), n = s > 0 || s === 0 && e.length > 1 ? e.slice(s + 1).toLowerCase() : "";
  return t.includes(n);
}
function hfe(e, a, t) {
  const s = { accepted: [], refused: [] }, n = (a == null ? void 0 : a.max_file_size_mb) ?? 0;
  let o = a != null && a.max_files && a.max_files > 0 ? a.max_files : 1 / 0;
  typeof t == "number" && Number.isFinite(t) && (o = Math.min(o, Math.max(0, t)));
  for (const p of e)
    vfe(p.name, a == null ? void 0 : a.allowed_ext) ? n > 0 && p.size > n * 1024 * 1024 ? s.refused.push({ file: p, reason: { code: "too_large", name: p.name, mb: n } }) : s.accepted.length >= o ? s.refused.push({ file: p, reason: { code: "too_many", count: o } }) : s.accepted.push(p) : s.refused.push({ file: p, reason: { code: "ext", name: p.name } });
  return s;
}
class mfe extends Error {
  constructor(a, t, s) {
    super(s || t || String(a)), this.status = a, this.code = t, this.name = "PublicLinkError";
  }
}
function _m(e, a, t) {
  const s = (e ?? "").replace(/\/+$/, "");
  return (n = "") => `${s}${a}${encodeURIComponent(t)}${n}`;
}
function yfe(e, a) {
  return _m(e, "/api/public/s/", a);
}
function gfe(e, a) {
  return _m(e, "/api/public/d/", a);
}
function km(e, a) {
  return _m(e, "/api/p/", a);
}
function x2(e, a) {
  const t = (...n) => (a.fetchImpl ?? fetch)(...n);
  async function s(n, o = {}) {
    const p = { Accept: "application/json", "Accept-Language": a.locale() };
    o.body !== void 0 && (p["Content-Type"] = "application/json");
    const h = await t(e(n), {
      method: o.method ?? "GET",
      headers: p,
      credentials: "same-origin",
      cache: "no-store",
      body: o.body !== void 0 ? JSON.stringify(o.body) : void 0
    });
    let v = null;
    try {
      v = await h.json();
    } catch {
      v = null;
    }
    if (!h.ok) {
      const y = v ?? {};
      throw new mfe(h.status, y.error ?? "", y.message);
    }
    return { status: h.status, body: v };
  }
  return {
    /** What the link is and what the visitor may see of it. */
    info: (n = "") => s(n).then((o) => o.body),
    pin: (n) => s("/pin", { method: "POST", body: { pin: n } }).then((o) => o.body),
    /**
     * The app's opening screen.
     *
     * ⚠ There is no `/view` route: an open is `POST /event
     * {"event":"open"}`, because the opening surface and every later one are
     * the same call to the app. One endpoint, one code path in the plugin.
     */
    open: () => s("/event", { method: "POST", body: { event: "open", state: {}, data: {} } }).then(
      (n) => n.body
    ),
    /** `{surface}`, or `{op}` when the server queued a job (202). */
    event: async (n) => {
      var p, h, v;
      const o = await s("/event", {
        method: "POST",
        body: n
      });
      return o.status === 202 || (p = o.body) != null && p.accepted ? { op: { accepted: !0, job_id: (h = o.body) == null ? void 0 : h.job_id }, job_id: (v = o.body) == null ? void 0 : v.job_id } : { surface: o.body.surface };
    },
    /** Where the browser loads an exposed copy from (`pub:N`). */
    fileUrl: (n) => e(`/file/${encodeURIComponent(n)}`),
    /**
     * The same copy, asked for as a DOWNLOAD — the Download button's link.
     * ⚠ Kept apart from `fileUrl` because only this one counts as a download
     * (handlers/public_api.go serveExposed): the page's own viewer loads the
     * document to SHOW it, and the owner ruled on 2026-09-21 that looking at
     * a signing link is not downloading it.
     */
    fileDownloadUrl: (n) => e(`/file/${encodeURIComponent(n)}?download=1`),
    url: e
  };
}
function wm(e, a) {
  const t = x2(e, a), s = b("loading"), n = b(null), o = b(""), p = b(""), h = b(""), v = b(""), y = b(""), g = b(""), m = Gd(
    {
      api: { pluginViewEvent: (A, O, z) => t.event(z) },
      plugin: "",
      view: "",
      locale: a.locale,
      errorText: a.errorText
    },
    {
      onOp: (A) => {
        h.value = String(A.job_id ?? ""), s.value = "accepted";
      },
      onDone: () => {
        s.value !== "accepted" && (s.value = "done");
      },
      onToast: (A) => {
        v.value = A;
      }
    }
  );
  function k(A) {
    const O = A;
    (O == null ? void 0 : O.status) === 404 ? (s.value = "not_found", g.value = "not_found") : (O == null ? void 0 : O.status) === 410 ? (s.value = "gone", g.value = "gone") : (s.value = "error", g.value = "error", y.value = go(a.locale(), String((A == null ? void 0 : A.message) ?? A)) || a.errorText());
  }
  async function _() {
    try {
      const A = await t.open(), O = A == null ? void 0 : A.surface;
      if (!O) {
        s.value = "error", y.value = a.errorText();
        return;
      }
      m.setSurface(O), s.value = O.done ? "done" : "ready";
    } catch (A) {
      if ((A == null ? void 0 : A.status) === 401) {
        s.value = "pin";
        return;
      }
      k(A);
    }
  }
  function w(A) {
    return (A == null ? void 0 : A.expired) === !0 || (A == null ? void 0 : A.revoked) === !0;
  }
  async function $(A = "") {
    var O, z, P, I;
    s.value = "loading", y.value = "", g.value = "";
    try {
      n.value = await t.info(A);
    } catch (F) {
      k(F);
      return;
    }
    if (w(n.value)) {
      s.value = "gone", g.value = "gone";
      return;
    }
    if ((O = n.value) != null && O.needs_pin && !((z = n.value) != null && z.unlocked)) {
      s.value = "pin", o.value = ((P = n.value) == null ? void 0 : P.locked) === !0 ? "locked" : "";
      return;
    }
    if ((I = a.hasSurface) != null && I.call(a, n.value)) {
      await _();
      return;
    }
    s.value = "ready";
  }
  const C = b(!1);
  async function E(A) {
    var O;
    if (!C.value) {
      o.value = "", p.value = "", C.value = !0;
      try {
        n.value = await t.pin(A.trim()), w(n.value) ? (s.value = "gone", g.value = "gone") : (O = a.hasSurface) != null && O.call(a, n.value) ? await _() : s.value = "ready";
      } catch (z) {
        const P = z;
        (P == null ? void 0 : P.status) === 429 ? (o.value = "locked", p.value = go(a.locale(), P.message ?? "")) : (P == null ? void 0 : P.status) === 401 || (P == null ? void 0 : P.status) === 403 ? o.value = "wrong" : k(z);
      } finally {
        C.value = !1;
      }
    }
  }
  return {
    status: s,
    info: n,
    reason: g,
    pinFailure: o,
    lockMessage: p,
    pinBusy: C,
    failure: y,
    toast: v,
    jobId: h,
    conv: m,
    load: $,
    submitPin: E,
    fileUrl: t.fileUrl,
    fileDownloadUrl: t.fileDownloadUrl,
    /**
     * A `FileRefResolver` for the surface renderer: the URL, plus the name
     * and type the link's own `files[]` already told us.
     *
     * ⚠ The renderer needs the mime to decide how to draw the thing (a
     * picture, an embedded PDF, a link). Handing it a bare URL makes every
     * exposed copy render as "something to download", which is what a
     * `preview` node is specifically not for.
     */
    resolveFile: (A) => {
      var P, I;
      const O = (I = (P = n.value) == null ? void 0 : P.app) == null ? void 0 : I.files, z = O == null ? void 0 : O.find((F) => F.ref === A);
      return { url: t.fileUrl(A), name: z == null ? void 0 : z.name, mime: z == null ? void 0 : z.mime };
    },
    url: t.url
  };
}
function bfe(e, a, t = {}) {
  const s = (e ?? "").replace(/\/+$/, ""), n = encodeURIComponent(a);
  return t.path ? `${s}/s/${n}/f/${t.path.split("/").map(encodeURIComponent).join("/")}?download=1` : `${s}/s/${n}?${t.zip ? "zip=1" : "download=1"}`;
}
function _fe(e, a) {
  return `${(e ?? "").replace(/\/+$/, "")}/s/${encodeURIComponent(a)}?nojs=1`;
}
function kfe(e, a) {
  return {
    ...wm(yfe(a.base, e), {
      ...a,
      hasSurface: (s) => (s == null ? void 0 : s.kind) === "app"
    }),
    downloadUrl: (s = {}) => bfe(a.base, e, s),
    noJsUrl: () => _fe(a.base, e)
  };
}
const wfe = /* @__PURE__ */ new Set([504, 524]);
function xfe(e, a) {
  const t = wm(gfe(a.base, e), a), s = b([]);
  function n(h, v, y) {
    s.value = s.value.map((g, m) => m >= h && m < v ? { ...g, ...y } : g);
  }
  function o(h, v, y) {
    const g = v + h.length;
    return new Promise((m) => {
      let k;
      try {
        k = new XMLHttpRequest();
      } catch {
        n(v, g, { state: "failed", error: a.errorText() }), m();
        return;
      }
      k.open("POST", t.url("/upload")), k.withCredentials = !0, k.setRequestHeader("Accept", "application/json"), k.setRequestHeader("Accept-Language", a.locale()), k.upload.onprogress = (C) => {
        C.lengthComputable && C.total > 0 && n(v, g, { percent: Math.round(C.loaded / C.total * 100) });
      };
      let _ = !1;
      k.upload.onload = () => {
        _ = !0, n(v, g, { state: "saving", percent: 100 });
      };
      const w = () => n(v, g, { state: "unconfirmed", error: (a.unansweredText ?? a.errorText)() });
      k.onload = () => {
        var C;
        if (k.status >= 200 && k.status < 300)
          n(v, g, { state: "done", percent: 100 });
        else {
          let E = "";
          try {
            E = String(((C = JSON.parse(k.responseText)) == null ? void 0 : C.message) ?? "");
          } catch {
            E = "";
          }
          !E && _ && wfe.has(k.status) ? w() : n(v, g, { state: "failed", error: E || a.errorText() });
        }
        m();
      }, k.onerror = () => {
        _ ? w() : n(v, g, { state: "failed", error: a.errorText() }), m();
      };
      const $ = new FormData();
      for (const C of h) $.append("file", C, C.name);
      y && $.append("uploader_name", y), k.send($);
    });
  }
  async function p(h, v = {}) {
    const y = t.info.value, { accepted: g, refused: m } = hfe(Array.from(h), y == null ? void 0 : y.limits, (y == null ? void 0 : y.uploads_left) ?? null), k = v.refusedText ?? (() => a.errorText());
    if (s.value = [
      ...s.value,
      ...m.map(({ file: w, reason: $ }) => ({
        name: w.name,
        size: w.size,
        percent: -1,
        state: "refused",
        error: k($)
      }))
    ], !g.length) return;
    const _ = s.value.length;
    s.value = [
      ...s.value,
      ...g.map((w) => ({ name: w.name, size: w.size, percent: -1, state: "sending" }))
    ], await o(g, _, (v.name ?? "").trim()), await t.load();
  }
  return { ...t, uploads: s, upload: p };
}
function eme(e, a, t = "") {
  return km(e, a)(t);
}
function tme(e, a) {
  return x2(km(a.base, e), a);
}
function ame(e, a) {
  return wm(km(a.base, e), { ...a, hasSurface: () => !0 });
}
const $fe = { class: "fe-ppage__state" }, Sfe = { class: "fe-ppage__state-title" }, Tfe = { class: "fe-surface__text fe-surface__text--muted" }, Cfe = {
  class: "fe-ppage__srlabel",
  for: "fe-ppage-pin"
}, Efe = ["disabled", "aria-invalid"], Afe = {
  key: 0,
  class: "fe-ppage__error",
  role: "alert",
  "data-testid": "public-page-pin-error"
}, zfe = ["disabled"], Mfe = /* @__PURE__ */ rt({
  __name: "PublicPinGate",
  props: {
    locale: {},
    busy: { type: Boolean },
    failure: {},
    lockMessage: {}
  },
  emits: ["submit"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n } = gt(() => t.locale), o = b(""), p = b(null), h = () => t.failure === "wrong" ? n("plugin.page.pin_wrong") : t.failure === "locked" ? n("plugin.page.pin_locked") : "";
    Qe(
      () => t.failure,
      async (y) => {
        var g;
        y === "wrong" && (o.value = "", await Jt(), (g = p.value) == null || g.focus());
      }
    ), Kt(() => {
      var y;
      return (y = p.value) == null ? void 0 : y.focus();
    });
    function v() {
      var y;
      if (!(t.busy || t.failure === "locked")) {
        if (!o.value.trim()) {
          (y = p.value) == null || y.focus();
          return;
        }
        s("submit", o.value);
      }
    }
    return (y, g) => (u(), d("form", {
      class: "fe-ppage__pin",
      "data-testid": "public-page-pin",
      onSubmit: ft(v, ["prevent"])
    }, [
      i("div", $fe, [
        i("h2", Sfe, f(r(n)("plugin.page.pin_title")), 1),
        i("p", Tfe, f(r(n)("plugin.page.pin_hint")), 1)
      ]),
      i("label", Cfe, f(r(n)("plugin.pin.label")), 1),
      dt(i("input", {
        id: "fe-ppage-pin",
        ref_key: "input",
        ref: p,
        "onUpdate:modelValue": g[0] || (g[0] = (m) => o.value = m),
        class: Re(["fe-cfield__input fe-ppage__pinput", { "is-invalid": !!h() }]),
        type: "text",
        inputmode: "numeric",
        autocomplete: "one-time-code",
        spellcheck: "false",
        maxlength: "12",
        disabled: e.busy || e.failure === "locked",
        "aria-invalid": h() ? "true" : void 0,
        "data-testid": "public-page-pin-input"
      }, null, 10, Efe), [
        [St, o.value]
      ]),
      h() ? (u(), d("p", Afe, [
        $t(f(h()), 1),
        e.lockMessage ? (u(), d(he, { key: 0 }, [
          $t(" (" + f(e.lockMessage) + ")", 1)
        ], 64)) : T("", !0)
      ])) : T("", !0),
      i("button", {
        type: "submit",
        class: "fe-btn fe-btn--primary",
        disabled: e.busy || e.failure === "locked",
        "data-testid": "public-page-pin-submit"
      }, f(r(n)("plugin.page.pin_submit")), 9, zfe)
    ], 32));
  }
}), Dfe = {
  key: 0,
  class: "fe-plang",
  role: "group",
  "data-testid": "public-language"
}, Pfe = ["lang", "aria-pressed", "title", "data-testid", "onClick"], Ofe = {
  key: 0,
  class: "fe-plang__src"
}, Lfe = /* @__PURE__ */ rt({
  __name: "PublicLanguagePicker",
  props: {
    modelValue: {},
    pluginNote: { type: Function }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, s = a, n = x(() => (wn.value, yo())), o = x(() => n.value.length > 1);
    return (p, h) => o.value ? (u(), d("div", Dfe, [
      (u(!0), d(he, null, We(n.value, (v) => (u(), d("button", {
        key: v.code,
        type: "button",
        class: Re(["fe-plang__btn", { "is-on": v.code === t.modelValue }]),
        lang: v.code,
        "aria-pressed": v.code === t.modelValue ? "true" : "false",
        title: v.source === "plugin" && v.plugin && e.pluginNote ? e.pluginNote(v.plugin) : void 0,
        "data-testid": `public-language-${v.code}`,
        onClick: (y) => s("update:modelValue", v.code)
      }, [
        $t(f(v.label) + " ", 1),
        v.source === "plugin" && v.plugin ? (u(), d("small", Ofe, f(v.plugin), 1)) : T("", !0)
      ], 10, Pfe))), 128))
    ])) : T("", !0);
  }
}), Ife = ["dir", "data-state", "data-layout"], Rfe = {
  class: "fe-ppage__brand",
  "data-testid": "public-brand"
}, Nfe = ["src", "alt"], Bfe = { class: "fe-ppage__brandname" }, Ffe = { class: "fe-ppage__card" }, Ufe = ["data-badge"], Hfe = {
  key: 0,
  class: "fe-ppage__spinner"
}, Kfe = ["stroke-width"], Vfe = {
  key: 1,
  d: "M4.5 12.5l5 5 10-11"
}, qfe = {
  key: 1,
  class: "fe-ppage__head"
}, jfe = {
  key: 0,
  class: "fe-ppage__title",
  "data-testid": "public-page-title"
}, Wfe = {
  key: 1,
  class: "fe-ppage__subject",
  "data-testid": "public-page-subject"
}, Yfe = {
  key: 2,
  class: "fe-ppage__meta",
  "data-testid": "public-page-meta"
}, Gfe = { key: 0 }, Xfe = {
  key: 1,
  "aria-hidden": "true"
}, Jfe = { key: 2 }, Zfe = {
  key: 3,
  class: "fe-surface__text fe-surface__text--muted",
  "data-testid": "public-page-loading"
}, Qfe = {
  key: 6,
  class: "fe-ppage__state fe-ppage__state--ok",
  "data-testid": "public-page-accepted"
}, epe = { class: "fe-ppage__state-title" }, tpe = { class: "fe-surface__text" }, ape = {
  key: 7,
  class: "fe-ppage__state fe-ppage__state--ok",
  "data-testid": "public-page-done"
}, npe = { class: "fe-ppage__state-title" }, spe = { class: "fe-surface__text" }, ope = {
  key: 8,
  class: "fe-ppage__state",
  "data-testid": "public-page-error"
}, ipe = { class: "fe-ppage__state-title" }, rpe = {
  key: 0,
  class: "fe-ppage__error"
}, lpe = {
  key: 9,
  class: "fe-ppage__state",
  "data-testid": "public-page-unavailable"
}, upe = { class: "fe-ppage__state-title" }, cpe = { class: "fe-surface__text fe-surface__text--muted" }, dpe = { class: "fe-ppage__foot" }, fpe = {
  key: 0,
  class: "fe-ppage__footline",
  "data-testid": "public-footer-text"
}, ppe = {
  key: 1,
  class: "fe-ppage__footmark",
  "data-testid": "public-footer-powered"
}, vpe = ["src"], $2 = /* @__PURE__ */ rt({
  __name: "PublicShell",
  props: {
    status: {},
    locale: {},
    theme: {},
    brandName: {},
    logoUrl: {},
    accentStyle: {},
    footerText: {},
    hidePoweredBy: { type: Boolean },
    layout: {},
    badge: {},
    title: {},
    subject: {},
    expiresAt: {},
    visitsLeft: {},
    pinBusy: { type: Boolean },
    pinFailure: {},
    lockMessage: {},
    failure: {}
  },
  emits: ["pin", "retry", "update:locale"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n, formatDate: o, dir: p } = gt(() => t.locale), h = x(() => t.status === "ready"), v = x(() => h.value ? t.layout ?? "form" : "gate"), y = x(
      () => t.theme === "dark" ? "fe--theme-dark" : t.theme === "light" ? "fe--theme-light" : ""
    ), g = x(() => {
      if (!t.expiresAt) return "";
      const C = Date.parse(t.expiresAt);
      return Number.isFinite(C) ? n("public.expires", { when: o(C, { time: !0 }) }) : "";
    }), m = x(() => {
      const C = t.visitsLeft;
      return C == null || !Number.isFinite(C) ? "" : n("public.visits_left", { n: C });
    }), k = x(() => t.status === "pin" ? "lock" : t.status === "accepted" || t.status === "done" ? "check" : t.status === "loading" ? "loading" : h.value ? t.badge ?? "" : "alert"), _ = x(
      () => k.value === "check" ? "fe-ppage__badge--ok" : k.value === "alert" ? "fe-ppage__badge--err" : ""
    ), w = x(() => !t.logoUrl && t.brandName === bd);
    function $(C) {
      return n("public.language_from", { app: C });
    }
    return (C, E) => (u(), d("div", {
      class: Re(["fe fe-ppage", [y.value, `fe-ppage--${v.value}`]]),
      dir: r(p),
      style: Vt(e.accentStyle),
      "data-testid": "public-page",
      "data-state": e.status,
      "data-layout": v.value
    }, [
      i("header", Rfe, [
        e.logoUrl ? (u(), d("img", {
          key: 0,
          class: "fe-ppage__logo",
          src: e.logoUrl,
          alt: e.brandName
        }, null, 8, Nfe)) : w.value ? (u(), nt(pk, {
          key: 1,
          class: "fe-ppage__logo"
        })) : T("", !0),
        i("span", Bfe, f(e.brandName), 1)
      ]),
      i("main", Ffe, [
        k.value ? (u(), d("div", {
          key: 0,
          class: Re(["fe-ppage__badge", _.value]),
          "data-testid": "public-page-badge",
          "data-badge": k.value,
          "aria-hidden": "true"
        }, [
          k.value === "loading" ? (u(), d("span", Hfe)) : (u(), d("svg", {
            key: 1,
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": k.value === "check" ? 2 : 1.8,
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, [
            k.value === "lock" ? (u(), d(he, { key: 0 }, [
              E[3] || (E[3] = i("rect", {
                x: "4.5",
                y: "10.5",
                width: "15",
                height: "9.5",
                rx: "2"
              }, null, -1)),
              E[4] || (E[4] = i("path", { d: "M8 10.5V7a4 4 0 0 1 8 0v3.5" }, null, -1)),
              E[5] || (E[5] = i("path", { d: "M12 14.5v2" }, null, -1))
            ], 64)) : k.value === "check" ? (u(), d("path", Vfe)) : k.value === "alert" ? (u(), d(he, { key: 2 }, [
              E[6] || (E[6] = i("path", { d: "M10.3 4.2 2.6 17.9a2 2 0 0 0 1.7 3h15.4a2 2 0 0 0 1.7-3L13.7 4.2a2 2 0 0 0-3.4 0z" }, null, -1)),
              E[7] || (E[7] = i("path", { d: "M12 9.5v4.5" }, null, -1)),
              E[8] || (E[8] = i("path", { d: "M12 17.4h.01" }, null, -1))
            ], 64)) : k.value === "folder" ? (u(), d(he, { key: 3 }, [
              E[9] || (E[9] = i("path", { d: "M3.5 7a2 2 0 0 1 2-2h4l2 2h7a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2V7z" }, null, -1)),
              E[10] || (E[10] = i("path", { d: "M12 10.5V16" }, null, -1)),
              E[11] || (E[11] = i("path", { d: "M9.5 13.5 12 16l2.5-2.5" }, null, -1))
            ], 64)) : (u(), d(he, { key: 4 }, [
              E[12] || (E[12] = i("path", { d: "M7 3.5h7l4 4V20a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 6 20V5A1.5 1.5 0 0 1 7.5 3.5z" }, null, -1)),
              E[13] || (E[13] = i("path", { d: "M13.5 3.5V8H18" }, null, -1)),
              E[14] || (E[14] = i("path", { d: "M12 11.5V17" }, null, -1)),
              E[15] || (E[15] = i("path", { d: "M9.5 14.5 12 17l2.5-2.5" }, null, -1))
            ], 64))
          ], 8, Kfe))
        ], 10, Ufe)) : T("", !0),
        (e.title || e.subject) && h.value ? (u(), d("header", qfe, [
          e.title ? (u(), d("h1", jfe, [
            i("bdi", null, f(e.title), 1)
          ])) : T("", !0),
          e.subject ? (u(), d("p", Wfe, f(e.subject), 1)) : T("", !0)
        ])) : T("", !0),
        (g.value || m.value) && h.value ? (u(), d("p", Yfe, [
          g.value ? (u(), d("span", Gfe, f(g.value), 1)) : T("", !0),
          g.value && m.value ? (u(), d("span", Xfe, "·")) : T("", !0),
          m.value ? (u(), d("span", Jfe, f(m.value), 1)) : T("", !0)
        ])) : T("", !0),
        e.status === "loading" ? (u(), d("p", Zfe, f(r(n)("plugin.page.loading")), 1)) : e.status === "pin" ? (u(), nt(Mfe, {
          key: 4,
          locale: e.locale,
          busy: e.pinBusy,
          failure: e.pinFailure,
          "lock-message": e.lockMessage,
          onSubmit: E[0] || (E[0] = (A) => s("pin", A))
        }, null, 8, ["locale", "busy", "failure", "lock-message"])) : h.value ? wa(C.$slots, "default", { key: 5 }) : e.status === "accepted" ? (u(), d("div", Qfe, [
          wa(C.$slots, "accepted", {}, () => [
            i("h2", epe, f(r(n)("plugin.page.accepted_title")), 1),
            i("p", tpe, f(r(n)("plugin.page.accepted_text")), 1)
          ])
        ])) : e.status === "done" ? (u(), d("div", ape, [
          wa(C.$slots, "done", {}, () => [
            i("h2", npe, f(r(n)("plugin.page.done_title")), 1),
            i("p", spe, f(r(n)("plugin.page.done_text")), 1)
          ])
        ])) : e.status === "error" ? (u(), d("div", ope, [
          i("h2", ipe, f(r(n)("plugin.page.error_title")), 1),
          e.failure ? (u(), d("p", rpe, f(e.failure), 1)) : T("", !0),
          i("button", {
            type: "button",
            class: "fe-btn fe-btn--primary",
            onClick: E[1] || (E[1] = (A) => s("retry"))
          }, f(r(n)("plugin.page.retry")), 1)
        ])) : (u(), d("div", lpe, [
          i("h2", upe, f(r(n)("plugin.page.unavailable_title")), 1),
          i("p", cpe, f(r(n)("plugin.page.unavailable_text")), 1)
        ])),
        wa(C.$slots, "extra")
      ]),
      i("footer", dpe, [
        ot(Lfe, {
          "model-value": String(e.locale),
          "plugin-note": $,
          "onUpdate:modelValue": E[2] || (E[2] = (A) => s("update:locale", A))
        }, null, 8, ["model-value"]),
        e.footerText ? (u(), d("p", fpe, f(e.footerText), 1)) : T("", !0),
        e.hidePoweredBy ? T("", !0) : (u(), d("span", ppe, [
          e.logoUrl ? (u(), d("img", {
            key: 0,
            src: e.logoUrl,
            alt: ""
          }, null, 8, vpe)) : w.value ? (u(), nt(pk, { key: 1 })) : T("", !0),
          $t(" " + f(r(n)("public.served_by", { name: e.brandName })), 1)
        ]))
      ])
    ], 14, Ife));
  }
}), hpe = {
  key: 0,
  class: "fe-ppage__actions"
}, mpe = {
  key: 1,
  class: "fe-ppage__appfiles",
  "data-testid": "public-page-files"
}, ype = { class: "fe-surface__text" }, gpe = {
  key: 0,
  class: "fe-ppage__filesize"
}, bpe = ["href", "title", "data-testid"], _pe = {
  key: 1,
  class: "fe-ppage__file-one",
  "data-testid": "public-share-folder"
}, kpe = {
  key: 0,
  class: "fe-surface__text"
}, wpe = {
  key: 1,
  class: "fe-ppage__crumbs",
  "data-testid": "public-share-crumbs"
}, xpe = { class: "fe-ppage__crumb" }, $pe = {
  key: 2,
  class: "fe-ppage__files",
  "data-testid": "public-share-entries"
}, Spe = ["data-dir"], Tpe = ["data-testid", "onClick"], Cpe = ["href", "data-testid"], Epe = {
  key: 2,
  class: "fe-ppage__filesize"
}, Ape = {
  key: 3,
  class: "fe-ppage__filesize"
}, zpe = { class: "fe-ppage__actions" }, Mpe = ["href"], Dpe = ["href"], Ppe = {
  key: 2,
  class: "fe-ppage__file-one",
  "data-testid": "public-share-file"
}, Ope = ["src", "alt"], Lpe = {
  class: "fe-surface__text fe-surface__text--muted",
  "data-testid": "public-share-fileline"
}, Ipe = { key: 0 }, Rpe = {
  key: 1,
  class: "fe-ppage__filesize"
}, Npe = ["href"], S2 = /* @__PURE__ */ rt({
  __name: "PublicShareBody",
  props: {
    link: {},
    locale: {},
    theme: {}
  },
  emits: ["navigate"],
  setup(e, { emit: a }) {
    const t = e, s = a, { t: n, formatSize: o, formatDate: p } = gt(() => t.locale), h = x(() => t.link.info.value), v = x(() => {
      var w;
      return ((w = h.value) == null ? void 0 : w.kind) ?? "file";
    }), y = x(() => {
      var w;
      return ((w = h.value) == null ? void 0 : w.node) ?? null;
    }), g = x(() => {
      var w;
      return ((w = h.value) == null ? void 0 : w.app) ?? null;
    }), m = x(() => {
      var w;
      return ((w = h.value) == null ? void 0 : w.entries) ?? [];
    }), k = x(() => {
      var w;
      return (((w = y.value) == null ? void 0 : w.mime) ?? "").startsWith("image/");
    }), _ = x(() => {
      var C;
      const w = (((C = h.value) == null ? void 0 : C.path) ?? "").replace(/\/+$/, "");
      if (!w) return null;
      const $ = w.lastIndexOf("/");
      return $ <= 0 ? "" : w.slice(0, $);
    });
    return (w, $) => {
      var C, E, A, O, z, P, I, F, W, N, K, M;
      return v.value === "app" ? (u(), d(he, { key: 0 }, [
        ot(Xd, {
          conv: e.link.conv,
          locale: e.locale,
          theme: e.theme,
          "file-url": e.link.resolveFile,
          toast: e.link.toast.value,
          layout: "page",
          "page-height": "min(80vh, 1000px)"
        }, null, 8, ["conv", "locale", "theme", "file-url", "toast"]),
        e.link.conv.footer.value.length ? (u(), d("div", hpe, [
          ot(Jd, {
            conv: e.link.conv,
            locale: e.locale,
            "testid-prefix": "public-page"
          }, null, 8, ["conv", "locale"])
        ])) : T("", !0),
        (E = (C = g.value) == null ? void 0 : C.files) != null && E.length ? (u(), d("section", mpe, [
          (u(!0), d(he, null, We(((A = g.value) == null ? void 0 : A.files) ?? [], (j) => (u(), d("div", {
            key: j.ref,
            class: "fe-ppage__file-one fe-ppage__appfile"
          }, [
            i("p", ype, [
              i("strong", null, f(j.name), 1),
              j.size ? (u(), d("span", gpe, " · " + f(r(o)(j.size)), 1)) : T("", !0)
            ]),
            i("a", {
              class: "fe-btn",
              href: e.link.fileDownloadUrl(j.ref),
              download: "",
              title: r(n)("plugin.page.open_file", { name: j.name }),
              "data-testid": `public-page-file-${j.ref}`
            }, f(r(n)("ctx.download")), 9, bpe)
          ]))), 128))
        ])) : T("", !0)
      ], 64)) : v.value === "folder" ? (u(), d("div", _pe, [
        (O = y.value) != null && O.name ? T("", !0) : (u(), d("p", kpe, [
          i("strong", null, f((z = h.value) == null ? void 0 : z.subject), 1)
        ])),
        (P = h.value) != null && P.path ? (u(), d("nav", wpe, [
          i("button", {
            type: "button",
            class: "fe-btn fe-btn--sm",
            onClick: $[0] || ($[0] = (j) => s("navigate", _.value ?? ""))
          }, f(r(n)("public.up")), 1),
          i("span", xpe, f((I = h.value) == null ? void 0 : I.path), 1)
        ])) : T("", !0),
        m.value.length ? (u(), d("ul", $pe, [
          (u(!0), d(he, null, We(m.value, (j) => (u(), d("li", {
            key: j.path,
            class: "fe-ppage__file",
            "data-dir": j.is_dir ? "1" : void 0
          }, [
            j.is_dir ? (u(), d("button", {
              key: 0,
              type: "button",
              class: "fe-ppage__entry",
              "data-testid": `public-entry-${j.name}`,
              onClick: (U) => s("navigate", j.path)
            }, [
              i("bdi", null, f(j.name), 1)
            ], 8, Tpe)) : (u(), d("a", {
              key: 1,
              href: j.url || e.link.downloadUrl({ path: j.path }),
              class: "fe-ppage__entry",
              "data-testid": `public-entry-${j.name}`,
              download: ""
            }, [
              i("bdi", null, f(j.name), 1)
            ], 8, Cpe)),
            !j.is_dir && j.size !== void 0 ? (u(), d("span", Epe, f(r(o)(j.size)), 1)) : T("", !0),
            j.modified ? (u(), d("span", Ape, f(r(p)(j.modified)), 1)) : T("", !0)
          ], 8, Spe))), 128))
        ])) : T("", !0),
        i("div", zpe, [
          i("a", {
            class: "fe-btn fe-btn--primary",
            href: e.link.downloadUrl({ zip: !0 }),
            "data-testid": "public-share-zip"
          }, f(r(n)("public.download_all")), 9, Mpe),
          m.value.length ? T("", !0) : (u(), d("a", {
            key: 0,
            class: "fe-btn",
            href: e.link.noJsUrl(),
            "data-testid": "public-share-browse"
          }, f(r(n)("public.browse")), 9, Dpe))
        ])
      ])) : (u(), d("div", Ppe, [
        k.value ? (u(), d("img", {
          key: 0,
          class: "fe-ppage__shot",
          src: e.link.downloadUrl(),
          alt: ((F = y.value) == null ? void 0 : F.name) ?? ""
        }, null, 8, Ope)) : T("", !0),
        i("p", Lpe, [
          (W = y.value) != null && W.name ? T("", !0) : (u(), d("strong", Ipe, f((N = h.value) == null ? void 0 : N.subject), 1)),
          ((K = y.value) == null ? void 0 : K.size) !== void 0 ? (u(), d("span", Rpe, f(r(o)((M = y.value) == null ? void 0 : M.size)), 1)) : T("", !0)
        ]),
        i("a", {
          class: "fe-btn fe-btn--primary",
          href: e.link.downloadUrl(),
          "data-testid": "public-share-download"
        }, f(r(n)("ctx.download")), 9, Npe)
      ]));
    };
  }
}), Bpe = {
  class: "fe-pdrop",
  "data-testid": "public-request"
}, Fpe = {
  key: 0,
  class: "fe-surface__text",
  "data-testid": "public-request-folder"
}, Upe = {
  class: "fe-surface__text fe-surface__text--muted",
  "data-testid": "public-request-lead"
}, Hpe = {
  key: 1,
  class: "fe-pdrop__who",
  "data-testid": "public-request-name"
}, Kpe = { class: "fe-pdrop__wholabel" }, Vpe = ["placeholder", "disabled"], qpe = ["onKeydown"], jpe = { class: "fe-pdrop__lead" }, Wpe = {
  key: 0,
  class: "fe-surface__text fe-surface__text--muted"
}, Ype = ["accept", "disabled"], Gpe = {
  key: 2,
  class: "fe-ppage__meta",
  "data-testid": "public-request-limits"
}, Xpe = {
  key: 0,
  "aria-hidden": "true"
}, Jpe = {
  key: 3,
  class: "fe-pdrop__list",
  "data-testid": "public-request-uploads"
}, Zpe = ["data-state"], Qpe = { class: "fe-pdrop__name" }, eve = { class: "fe-ppage__filesize" }, tve = ["value"], ave = {
  class: "fe-pdrop__saving",
  role: "status"
}, nve = {
  key: 2,
  class: "fe-pdrop__ok"
}, sve = {
  key: 3,
  class: "fe-pdrop__unconfirmed",
  role: "status"
}, ove = {
  key: 4,
  class: "fe-surface__error"
}, ive = /* @__PURE__ */ rt({
  __name: "PublicRequestBody",
  props: {
    info: {},
    uploads: {},
    locale: {},
    disabled: { type: Boolean },
    hideFolder: { type: Boolean }
  },
  emits: ["files"],
  setup(e, { emit: a }) {
    const t = e, s = a, n = b(""), o = x(() => {
      var A, O;
      return ((O = (A = t.info) == null ? void 0 : A.limits) == null ? void 0 : O.ask_name) === !0;
    });
    function p(A) {
      s("files", A, o.value ? n.value.trim() : "");
    }
    const { t: h, formatSize: v } = gt(() => t.locale), y = b(null), g = b(!1), m = x(() => {
      var A;
      return ((A = t.info) == null ? void 0 : A.limits) ?? {};
    }), k = x(() => {
      const A = m.value.allowed_ext ?? [];
      return A.length ? A.map((O) => `.${O.replace(/^\./, "")}`).join(",") : void 0;
    }), _ = x(() => {
      var I;
      const A = [], O = m.value.max_file_size_mb;
      O && O > 0 && A.push(h("public.max_size", { size: v(O * 1e6) }));
      const z = m.value.allowed_ext ?? [];
      z.length && A.push(h("public.accepts", { list: z.map((F) => F.toUpperCase()).join(", ") }));
      const P = (I = t.info) == null ? void 0 : I.uploads_left;
      return P != null && Number.isFinite(P) && A.push(h("public.files_left", { n: P })), A;
    }), w = x(() => {
      var O;
      const A = (O = t.info) == null ? void 0 : O.uploads_left;
      return A != null && Number.isFinite(A) && A <= 0;
    });
    function $() {
      var A;
      t.disabled || w.value || (A = y.value) == null || A.click();
    }
    function C(A) {
      const O = A.target, z = Array.from(O.files ?? []);
      z.length && p(z), O.value = "";
    }
    function E(A) {
      var z;
      if (g.value = !1, t.disabled || w.value) return;
      const O = Array.from(((z = A.dataTransfer) == null ? void 0 : z.files) ?? []);
      O.length && p(O);
    }
    return (A, O) => {
      var z, P;
      return u(), d("div", Bpe, [
        (z = e.info) != null && z.folder && !e.hideFolder ? (u(), d("p", Fpe, [
          i("strong", null, f((P = e.info) == null ? void 0 : P.folder), 1)
        ])) : T("", !0),
        i("p", Upe, f(r(h)("public.drop_sub")), 1),
        o.value && !w.value ? (u(), d("label", Hpe, [
          i("span", Kpe, f(r(h)("public.your_name")), 1),
          dt(i("input", {
            "onUpdate:modelValue": O[0] || (O[0] = (I) => n.value = I),
            class: "fe-pdrop__whoinput",
            type: "text",
            maxlength: "60",
            autocomplete: "name",
            placeholder: r(h)("public.your_name_ph"),
            disabled: e.disabled,
            "data-testid": "public-request-name-input"
          }, null, 8, Vpe), [
            [St, n.value]
          ])
        ])) : T("", !0),
        i("div", {
          class: Re(["fe-pdrop__zone", { "is-over": g.value, "is-disabled": e.disabled || w.value }]),
          role: "button",
          tabindex: "0",
          "data-testid": "public-request-drop",
          onClick: $,
          onKeydown: [
            ya(ft($, ["prevent"]), ["enter"]),
            ya(ft($, ["prevent"]), ["space"])
          ],
          onDragover: O[1] || (O[1] = ft((I) => g.value = !0, ["prevent"])),
          onDragleave: O[2] || (O[2] = (I) => g.value = !1),
          onDrop: ft(E, ["prevent"])
        }, [
          O[3] || (O[3] = i("svg", {
            class: "fe-pdrop__icon",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "1.7",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true"
          }, [
            i("path", { d: "M4 14.9A7 7 0 1 1 15.7 8h1.8a4.5 4.5 0 0 1 2.5 8.2" }),
            i("path", { d: "M12 12v9" }),
            i("path", { d: "m16 16-4-4-4 4" })
          ], -1)),
          i("p", jpe, f(w.value ? r(h)("public.request_full") : r(h)("public.drop_here")), 1),
          w.value ? T("", !0) : (u(), d("p", Wpe, f(r(h)("public.or_choose")), 1)),
          i("input", {
            ref_key: "input",
            ref: y,
            class: "fe-pdrop__input",
            type: "file",
            multiple: "",
            accept: k.value,
            disabled: e.disabled || w.value,
            "data-testid": "public-request-input",
            onChange: C
          }, null, 40, Ype)
        ], 42, qpe),
        _.value.length ? (u(), d("p", Gpe, [
          (u(!0), d(he, null, We(_.value, (I, F) => (u(), d(he, { key: F }, [
            F ? (u(), d("span", Xpe, "·")) : T("", !0),
            i("span", null, f(I), 1)
          ], 64))), 128))
        ])) : T("", !0),
        e.uploads.length ? (u(), d("ul", Jpe, [
          (u(!0), d(he, null, We(e.uploads, (I, F) => (u(), d("li", {
            key: `${I.name}-${F}`,
            class: "fe-pdrop__item",
            "data-state": I.state
          }, [
            i("span", Qpe, [
              i("bdi", null, f(I.name), 1)
            ]),
            i("span", eve, f(r(v)(I.size)), 1),
            I.state === "sending" ? (u(), d("progress", {
              key: 0,
              class: "fe-pdrop__bar",
              max: 100,
              value: I.percent >= 0 ? I.percent : void 0
            }, null, 8, tve)) : I.state === "saving" ? (u(), d(he, { key: 1 }, [
              O[4] || (O[4] = i("progress", {
                class: "fe-pdrop__bar",
                max: 100
              }, null, -1)),
              i("span", ave, f(r(h)("public.upload_saving")), 1)
            ], 64)) : I.state === "done" ? (u(), d("span", nve, f(r(h)("public.upload_done")), 1)) : I.state === "unconfirmed" ? (u(), d("span", sve, f(I.error || r(h)("public.upload_unanswered")), 1)) : (u(), d("span", ove, f(I.error || r(h)("public.upload_failed")), 1))
          ], 8, Zpe))), 128))
        ])) : T("", !0)
      ]);
    };
  }
}), nme = /* @__PURE__ */ rt({
  __name: "PublicLinkPage",
  props: {
    kind: {},
    token: {},
    base: {},
    locale: {},
    theme: {}
  },
  setup(e) {
    const a = e, t = b(""), s = x(() => {
      if (a.locale) return String(a.locale);
      if (t.value) return t.value;
      const F = ps(wd("locale"));
      return F && Jc(F) ? F : xk();
    });
    function n(F) {
      const W = ps(F);
      !W || !Jc(W) || (t.value = W, di("locale", W));
    }
    const { t: o, formatSize: p } = gt(() => s.value), h = a.base ?? ih(), v = K8({ base: h }), y = Ld(), g = x(() => {
      const F = a.theme && a.theme !== "auto" ? a.theme : wd("theme") || v.themeDefault.value;
      return F === "light" || F === "dark" ? F : y.value ? "dark" : "light";
    }), m = {
      base: h,
      locale: () => s.value,
      errorText: () => o("plugin.view.error")
    }, k = a.kind === "share" ? kfe(a.token ?? "", m) : null, _ = a.kind === "request" ? xfe(a.token ?? "", {
      ...m,
      errorText: () => o("public.upload_failed"),
      unansweredText: () => o("public.upload_unanswered")
    }) : null;
    function w(F) {
      return F.code === "ext" ? o("public.refused_ext", { name: F.name }) : F.code === "too_large" ? o("public.refused_too_large", { size: p(F.mb * 1e6) }) : F.count <= 0 ? o("public.request_full") : o("public.refused_too_many", { count: F.count });
    }
    const $ = k ?? _, C = x(() => (k == null ? void 0 : k.info.value) ?? null), E = x(() => (_ == null ? void 0 : _.info.value) ?? null), A = x(() => {
      var N, K, M, j, U;
      const F = (N = C.value) == null ? void 0 : N.app, W = jt((K = k == null ? void 0 : k.conv.current.value) == null ? void 0 : K.title, s.value);
      return F ? W || jt(F.title, s.value) || "" : ((j = (M = C.value) == null ? void 0 : M.node) == null ? void 0 : j.name) || ((U = E.value) == null ? void 0 : U.folder) || "";
    }), O = x(() => {
      var W;
      const F = ((W = $.info.value) == null ? void 0 : W.subject) ?? "";
      return F && F !== A.value ? F : "";
    }), z = x(
      () => {
        var F, W, N;
        return w2(((F = C.value) == null ? void 0 : F.kind) ?? (_ ? "drop" : ""), {
          list: (((N = (W = C.value) == null ? void 0 : W.entries) == null ? void 0 : N.length) ?? 0) > 0
        });
      }
    ), P = x(() => {
      var W;
      if (_) return "";
      const F = (W = C.value) == null ? void 0 : W.kind;
      return F === "folder" ? "folder" : F === "app" ? "" : "file";
    });
    function I(F) {
      $.load(F ? `?path=${encodeURIComponent(F)}` : "");
    }
    return Qe(A, (F) => {
      F && typeof document < "u" && (document.title = F);
    }), Qe(
      s,
      (F) => {
        typeof document < "u" && (document.documentElement.lang = F);
      },
      { immediate: !0 }
    ), Qe(s, () => {
      var F;
      $.status.value === "ready" && ((F = C.value) == null ? void 0 : F.kind) === "app" && ($.conv.current.value ? $.conv.post("change") : $.load());
    }), Kt(() => {
      if (v.load(), !a.token) {
        $.status.value = "not_found";
        return;
      }
      $.load();
    }), (F, W) => {
      var N, K, M;
      return u(), nt($2, {
        status: r($).status.value,
        locale: s.value,
        theme: g.value,
        "brand-name": r(v).name.value,
        "logo-url": r(v).logo.value,
        "accent-style": r(v).accentStyle.value,
        "footer-text": r(v).footerText.value,
        "hide-powered-by": r(v).hidePoweredBy.value,
        layout: z.value,
        badge: P.value,
        title: A.value,
        subject: O.value,
        "expires-at": ((N = r($).info.value) == null ? void 0 : N.expires_at) ?? null,
        "visits-left": ((K = C.value) == null ? void 0 : K.visits_left) ?? ((M = E.value) == null ? void 0 : M.uploads_left) ?? null,
        "pin-busy": r($).pinBusy.value,
        "pin-failure": r($).pinFailure.value,
        "lock-message": r($).lockMessage.value,
        failure: r($).failure.value,
        onPin: W[1] || (W[1] = (j) => r($).submitPin(j)),
        onRetry: W[2] || (W[2] = () => r($).load()),
        "onUpdate:locale": n
      }, {
        default: yt(() => [
          r(k) ? (u(), nt(S2, {
            key: 0,
            link: r(k),
            locale: s.value,
            theme: g.value,
            onNavigate: I
          }, null, 8, ["link", "locale", "theme"])) : r(_) ? (u(), nt(ive, {
            key: 1,
            info: E.value,
            uploads: r(_).uploads.value,
            locale: s.value,
            "hide-folder": "",
            onFiles: W[0] || (W[0] = (j, U) => r(_).upload(j, { name: U, refusedText: w }))
          }, null, 8, ["info", "uploads", "locale"])) : T("", !0)
        ]),
        _: 1
      }, 8, ["status", "locale", "theme", "brand-name", "logo-url", "accent-style", "footer-text", "hide-powered-by", "layout", "badge", "title", "subject", "expires-at", "visits-left", "pin-busy", "pin-failure", "lock-message", "failure"]);
    };
  }
}), rve = {
  class: "fe-ppreview",
  inert: "",
  "data-testid": "public-link-preview"
}, sme = /* @__PURE__ */ rt({
  __name: "PublicLinkPreview",
  props: {
    brandName: {},
    logoUrl: {},
    accent: {},
    footerText: {},
    hidePoweredBy: { type: Boolean },
    locale: {},
    theme: {},
    sample: {}
  },
  setup(e) {
    const a = e, t = x(() => a.sample ?? { name: "report-2026.pdf", size: 124e4, mime: "application/pdf" }), s = x(() => ({
      kind: "file",
      node: { name: t.value.name, size: t.value.size, mime: t.value.mime ?? "application/pdf" }
    })), n = x(
      () => ({
        info: b(s.value),
        downloadUrl: () => "#",
        noJsUrl: () => "#"
      })
    ), o = x(() => {
      var p;
      return ((p = a.brandName) == null ? void 0 : p.trim()) || bd;
    });
    return (p, h) => {
      var v, y;
      return u(), d("div", rve, [
        ot($2, {
          status: "ready",
          locale: e.locale,
          theme: e.theme ?? "light",
          "brand-name": o.value,
          "logo-url": ((v = e.logoUrl) == null ? void 0 : v.trim()) || "",
          "accent-style": r(l0)(e.accent),
          "footer-text": ((y = e.footerText) == null ? void 0 : y.trim()) || "",
          "hide-powered-by": e.hidePoweredBy === !0,
          layout: r(w2)("file"),
          badge: "file",
          title: t.value.name
        }, {
          default: yt(() => [
            ot(S2, {
              link: n.value,
              locale: e.locale,
              theme: e.theme ?? "light"
            }, null, 8, ["link", "locale", "theme"])
          ]),
          _: 1
        }, 8, ["locale", "theme", "brand-name", "logo-url", "accent-style", "footer-text", "hide-powered-by", "layout", "title"])
      ]);
    };
  }
}), lve = {
  key: 0,
  class: "fe-apppage__bar"
}, uve = {
  class: "fe-apppage__title",
  "data-testid": "plugin-page-title"
}, cve = ["title"], dve = ["href"], fve = {
  key: 1,
  class: "fe-apppage__body fe-apppage__body--ui"
}, pve = {
  key: 0,
  class: "fe-surface__text",
  role: "status"
}, vve = {
  key: 2,
  class: "fe-apppage__body"
}, hve = {
  class: "fe-surface__text fe-surface__text--muted",
  "data-testid": "plugin-page-loading"
}, mve = {
  key: 3,
  class: "fe-apppage__body"
}, yve = {
  key: 1,
  class: "fe-surface__text fe-surface__text--muted",
  "data-testid": "plugin-page-loading"
}, gve = {
  key: 3,
  class: "fe-apppage__state",
  "data-testid": "plugin-page-queued"
}, bve = { class: "fe-apppage__state-title" }, _ve = { class: "fe-surface__text" }, kve = { class: "fe-apppage__state-actions" }, wve = ["href"], xve = ["href"], $ve = {
  key: 4,
  class: "fe-apppage__state",
  "data-testid": "plugin-page-done"
}, Sve = { class: "fe-apppage__state-title" }, Tve = { class: "fe-surface__text" }, Cve = { class: "fe-apppage__state-actions" }, Eve = ["href"], Ave = {
  key: 5,
  class: "fe-apppage__state",
  "data-testid": "plugin-page-error"
}, zve = { class: "fe-apppage__state-title" }, Mve = {
  key: 0,
  class: "fe-surface__error"
}, Dve = { class: "fe-apppage__state-actions" }, Pve = ["href"], Ove = {
  key: 4,
  class: "fe-apppage__foot"
}, ome = /* @__PURE__ */ rt({
  __name: "PluginPageView",
  props: {
    locale: {},
    theme: {},
    api: {},
    plugin: {},
    view: {},
    path: {},
    storages: {},
    startAt: {},
    backHref: {},
    opsHref: {},
    mountBase: {},
    frame: {},
    section: {}
  },
  emits: ["op", "section"],
  setup(e, { expose: a, emit: t }) {
    const s = e, n = t, { t: o } = gt(() => s.locale), p = x(() => s.frame === "embedded"), h = b("loading"), v = b(""), y = b(""), g = Gd(
      {
        api: s.api,
        plugin: s.plugin,
        view: s.view,
        path: () => s.path,
        locale: () => s.locale,
        errorText: () => o("plugin.view.error")
      },
      {
        // ⚠ `onOp` fires BEFORE `onDone` (usePluginSurface posts them in that
        // order), so the queued state has to be set after both — otherwise
        // `onDone` would overwrite it with "finished" and the person would never
        // see that a job is running.
        /**
         * v3 §3.0 — "go to this file, and start that screen on it".
         *
         * ⚠ A real navigation, not a tab: this IS a whole page, and the person
         * asked to be taken to a document. The address is the explorer deep link
         * a notification already uses, so the placement question is answered
         * where it is answerable — the explorer knows which of the plugin's
         * views is a `page` and opens that one in its own tab.
         */
        onOpen: (W) => {
          const N = C3(W, { plugin: s.plugin, base: s.mountBase });
          if (N.href)
            try {
              if (N.newTab) {
                const K = window.open(N.href, "_blank");
                K ? K.opener = null : window.location.assign(N.href);
              } else
                window.location.assign(N.href);
            } catch {
            }
        },
        onOp: (W) => {
          n("op", W), h.value = "queued";
        },
        onDone: () => {
          h.value !== "queued" && (h.value = "done");
        },
        onToast: (W) => y.value = W
      }
    ), m = g.current, k = x(() => {
      var W;
      return jt((W = m.value) == null ? void 0 : W.title, s.locale) || s.view;
    }), _ = b(s.section ?? ""), w = x(() => {
      var W;
      return ((W = m.value) == null ? void 0 : W.sections) ?? [];
    }), $ = x(() => {
      var W;
      return ((W = m.value) == null ? void 0 : W.section) || _.value;
    });
    function C(W) {
      !W || W === $.value || (_.value = W, n("section", W), E());
    }
    Qe(
      () => s.section,
      (W) => {
        const N = W ?? "";
        N !== _.value && (_.value = N, E());
      }
    );
    async function E() {
      var W;
      m.value || (h.value = "loading"), v.value = "";
      try {
        const N = _.value ? await s.api.pluginView(s.plugin, s.view, s.path, _.value) : await s.api.pluginView(s.plugin, s.view, s.path);
        if (!(N != null && N.surface)) {
          v.value = o("plugin.view.error"), h.value = "error";
          return;
        }
        g.setSurface(N.surface), h.value = "surface";
        const K = N.surface.section ?? "";
        !_.value && K && (_.value = K, n("section", K, { replace: !0 }));
      } catch (N) {
        v.value = ((W = o.foreign) == null ? void 0 : W.call(o, String((N == null ? void 0 : N.message) ?? ""))) || o("plugin.view.error"), h.value = "error";
      }
    }
    const A = b(null), O = b("page"), z = b(!1), P = x(
      () => s.path ? [{ path: s.path, name: s.path.split("/").pop() || s.path }] : []
    );
    async function I() {
      try {
        const W = await s.api.pluginActions(), N = W.views.find((M) => M.plugin === s.plugin && M.id === s.view && M.ui);
        if (N != null && N.ui) {
          A.value = N.ui, O.value = N.placement === "home" ? "home" : "page";
          return;
        }
        const K = W.actions.find((M) => M.plugin === s.plugin && M.view === s.view && M.ui);
        K != null && K.ui && (A.value = K.ui);
      } catch {
      } finally {
        z.value = !0;
      }
    }
    Kt(async () => {
      await I(), A.value || E();
    }), a({ reload: E });
    const F = x(() => {
      var N;
      let W = !1;
      return Eu((N = g.current.value) == null ? void 0 : N.nodes, (K) => {
        var M;
        K.type === "pdf-fields" && ((M = K.props) == null ? void 0 : M.mode) !== "define" && (W = !0);
      }), W;
    });
    return (W, N) => (u(), d("div", {
      class: Re(["fe fe-apppage", [
        e.theme === "dark" ? "fe--theme-dark" : e.theme === "light" ? "fe--theme-light" : "",
        { "is-doc": F.value && !p.value, "fe-apppage--embedded": p.value }
      ]]),
      "data-testid": "plugin-page"
    }, [
      p.value ? T("", !0) : (u(), d("header", lve, [
        i("h1", uve, f(k.value), 1),
        e.path ? (u(), d("p", {
          key: 0,
          class: "fe-apppage__path",
          title: e.path
        }, f(e.path), 9, cve)) : T("", !0),
        e.backHref ? (u(), d("a", {
          key: 1,
          class: "fe-btn fe-apppage__back",
          href: e.backHref,
          "data-testid": "plugin-page-back"
        }, f(r(o)("plugin.page_view.back")), 9, dve)) : T("", !0)
      ])),
      A.value ? (u(), d("main", fve, [
        ot(tf, {
          api: e.api,
          app: e.plugin,
          version: A.value.version,
          view: e.view,
          placement: O.value,
          ui: A.value,
          files: P.value,
          locale: e.locale,
          theme: e.theme,
          title: k.value,
          onToast: N[0] || (N[0] = (K) => y.value = K.text),
          onOp: N[1] || (N[1] = (K) => n("op", K))
        }, null, 8, ["api", "app", "version", "view", "placement", "ui", "files", "locale", "theme", "title"]),
        y.value ? (u(), d("p", pve, f(y.value), 1)) : T("", !0)
      ])) : z.value ? (u(), d("main", mve, [
        h.value === "surface" && w.value.length ? (u(), nt(l2, {
          key: 0,
          sections: w.value,
          active: $.value,
          locale: e.locale,
          label: k.value,
          disabled: r(g).busy.value,
          onSelect: C
        }, null, 8, ["sections", "active", "locale", "label", "disabled"])) : T("", !0),
        h.value === "loading" ? (u(), d("p", yve, f(r(o)("plugin.view.loading")), 1)) : h.value === "surface" ? (u(), nt(Xd, {
          key: 2,
          conv: r(g),
          locale: e.locale,
          theme: e.theme,
          api: e.api,
          plugin: e.plugin,
          storages: e.storages,
          "start-at": e.startAt,
          toast: y.value,
          layout: p.value ? "inline" : "page"
        }, null, 8, ["conv", "locale", "theme", "api", "plugin", "storages", "start-at", "toast", "layout"])) : h.value === "queued" ? (u(), d("div", gve, [
          i("h2", bve, f(r(o)("plugin.page_view.queued_title")), 1),
          i("p", _ve, f(r(o)("plugin.page_view.queued_text")), 1),
          i("div", kve, [
            e.opsHref ? (u(), d("a", {
              key: 0,
              class: "fe-btn fe-btn--primary",
              href: e.opsHref,
              "data-testid": "plugin-page-ops"
            }, f(r(o)("plugin.page_view.open_ops")), 9, wve)) : T("", !0),
            e.backHref ? (u(), d("a", {
              key: 1,
              class: "fe-btn",
              href: e.backHref
            }, f(r(o)("plugin.page_view.back")), 9, xve)) : T("", !0)
          ])
        ])) : h.value === "done" ? (u(), d("div", $ve, [
          i("h2", Sve, f(r(o)("plugin.page_view.done_title")), 1),
          i("p", Tve, f(r(o)("plugin.page_view.done_text")), 1),
          i("div", Cve, [
            e.backHref ? (u(), d("a", {
              key: 0,
              class: "fe-btn fe-btn--primary",
              href: e.backHref
            }, f(r(o)("plugin.page_view.back")), 9, Eve)) : T("", !0)
          ])
        ])) : (u(), d("div", Ave, [
          i("h2", zve, f(r(o)("plugin.page_view.error_title")), 1),
          v.value ? (u(), d("p", Mve, f(v.value), 1)) : T("", !0),
          i("div", Dve, [
            i("button", {
              type: "button",
              class: "fe-btn",
              onClick: N[2] || (N[2] = (K) => E())
            }, f(r(o)("plugin.page_view.retry")), 1),
            e.backHref ? (u(), d("a", {
              key: 0,
              class: "fe-btn",
              href: e.backHref
            }, f(r(o)("plugin.page_view.back")), 9, Pve)) : T("", !0)
          ])
        ]))
      ])) : (u(), d("main", vve, [
        i("p", hve, f(r(o)("plugin.view.loading")), 1)
      ])),
      h.value === "surface" && r(g).footer.value.length ? (u(), d("footer", Ove, [
        ot(Jd, {
          conv: r(g),
          locale: e.locale,
          "testid-prefix": "plugin-page"
        }, null, 8, ["conv", "locale"])
      ])) : T("", !0)
    ], 2));
  }
}), Lve = {
  key: 0,
  class: "fe-connlost",
  role: "status",
  "aria-live": "polite",
  "data-testid": "connection-notice"
}, Ive = { class: "fe-connlost__text" }, ime = /* @__PURE__ */ rt({
  __name: "ConnectionNotice",
  props: {
    locale: {}
  },
  setup(e) {
    const a = e, { t } = gt(() => a.locale ?? "en");
    return (s, n) => r(eC) ? (u(), d("div", Lve, [
      n[0] || (n[0] = i("span", {
        class: "fe-connlost__dot",
        "aria-hidden": "true"
      }, null, -1)),
      i("span", Ive, f(r(t)("err.network")), 1)
    ])) : T("", !0);
  }
});
export {
  pk as $,
  sT as A,
  yk as B,
  AT as C,
  bd as D,
  am as E,
  Mh as F,
  Nw as G,
  Mz as H,
  en as I,
  Hd as J,
  Lc as K,
  oi as L,
  Ic as M,
  zh as N,
  ea as O,
  FJ as P,
  bce as Q,
  g1 as R,
  sh as S,
  hJ as T,
  hce as U,
  wb as V,
  Qhe as W,
  O_ as X,
  $0 as Y,
  _d as Z,
  ki as _,
  wt as a,
  Ed as a$,
  kC as a0,
  $M as a1,
  ihe as a2,
  MU as a3,
  Voe as a4,
  Roe as a5,
  mce as a6,
  lae as a7,
  die as a8,
  v2 as a9,
  SJ as aA,
  a5 as aB,
  qF as aC,
  Vv as aD,
  wo as aE,
  l4 as aF,
  Rr as aG,
  lU as aH,
  kae as aI,
  r4 as aJ,
  wV as aK,
  nf as aL,
  H4 as aM,
  y0 as aN,
  Xd as aO,
  Jd as aP,
  hO as aQ,
  wO as aR,
  o0 as aS,
  A1 as aT,
  A0 as aU,
  Sd as aV,
  cu as aW,
  td as aX,
  Vl as aY,
  DT as aZ,
  q0 as a_,
  Mie as aa,
  QW as ab,
  Bc as ac,
  Nv as ad,
  OC as ae,
  $3 as af,
  c0 as ag,
  UO as ah,
  iu as ai,
  Die as aj,
  ome as ak,
  V0 as al,
  y2 as am,
  Lfe as an,
  mfe as ao,
  nme as ap,
  sme as aq,
  Mfe as ar,
  ive as as,
  S2 as at,
  $2 as au,
  fW as av,
  qie as aw,
  sC as ax,
  vM as ay,
  a3 as az,
  Phe as b,
  bhe as b$,
  $Y as b0,
  Xl as b1,
  uw as b2,
  A7 as b3,
  L0 as b4,
  I0 as b5,
  S0 as b6,
  KM as b7,
  tk as b8,
  nk as b9,
  Uhe as bA,
  D3 as bB,
  d7 as bC,
  v7 as bD,
  _M as bE,
  Vee as bF,
  o2 as bG,
  RM as bH,
  AM as bI,
  yo as bJ,
  tm as bK,
  U0 as bL,
  jB as bM,
  ZB as bN,
  WB as bO,
  VB as bP,
  qB as bQ,
  KB as bR,
  dhe as bS,
  Ek as bT,
  $r as bU,
  Al as bV,
  Wve as bW,
  lhe as bX,
  mhe as bY,
  Mv as bZ,
  fhe as b_,
  ak as ba,
  h2 as bb,
  pce as bc,
  ere as bd,
  $he as be,
  She as bf,
  xhe as bg,
  i2 as bh,
  l0 as bi,
  dT as bj,
  _ce as bk,
  ok as bl,
  FT as bm,
  UT as bn,
  ehe as bo,
  LT as bp,
  Bz as bq,
  z0 as br,
  d2 as bs,
  The as bt,
  ih as bu,
  u2 as bv,
  tw as bw,
  aw as bx,
  wh as by,
  Xhe as bz,
  Ll as c,
  E3 as c$,
  kh as c0,
  _C as c1,
  W1 as c2,
  Ihe as c3,
  eC as c4,
  Xve as c5,
  Jve as c6,
  Mn as c7,
  PB as c8,
  s7 as c9,
  mu as cA,
  Xo as cB,
  Lee as cC,
  b2 as cD,
  AD as cE,
  TI as cF,
  Ur as cG,
  Yie as cH,
  Vd as cI,
  fr as cJ,
  _b as cK,
  kk as cL,
  hv as cM,
  Vw as cN,
  Uw as cO,
  mb as cP,
  fv as cQ,
  k2 as cR,
  Zhe as cS,
  _2 as cT,
  nh as cU,
  Xoe as cV,
  kce as cW,
  G1 as cX,
  J_ as cY,
  j1 as cZ,
  hC as c_,
  C0 as ca,
  n7 as cb,
  o7 as cc,
  a7 as cd,
  f1 as ce,
  Av as cf,
  nee as cg,
  Qz as ch,
  the as ci,
  yce as cj,
  $ae as ck,
  s0 as cl,
  wi as cm,
  fN as cn,
  Fz as co,
  dd as cp,
  Xp as cq,
  jd as cr,
  V8 as cs,
  oC as ct,
  $I as cu,
  B3 as cv,
  bi as cw,
  ED as cx,
  khe as cy,
  xk as cz,
  F8 as d,
  x0 as d$,
  XO as d0,
  b1 as d1,
  v1 as d2,
  xb as d3,
  she as d4,
  hM as d5,
  go as d6,
  yM as d7,
  y1 as d8,
  Lhe as d9,
  o4 as dA,
  SH as dB,
  Xv as dC,
  qc as dD,
  vi as dE,
  Rhe as dF,
  Fw as dG,
  Rz as dH,
  zD as dI,
  r0 as dJ,
  Ag as dK,
  ti as dL,
  iv as dM,
  Cr as dN,
  kM as dO,
  LC as dP,
  CD as dQ,
  EO as dR,
  Br as dS,
  Sg as dT,
  q1 as dU,
  iD as dV,
  bC as dW,
  Goe as dX,
  I1 as dY,
  Rv as dZ,
  Bv as d_,
  X1 as da,
  VT as db,
  Er as dc,
  Iz as dd,
  vh as de,
  XT as df,
  zhe as dg,
  Ehe as dh,
  hhe as di,
  hd as dj,
  Oh as dk,
  h7 as dl,
  Jie as dm,
  ZC as dn,
  iw as dp,
  pm as dq,
  TH as dr,
  fm as ds,
  JB as dt,
  Uv as du,
  E0 as dv,
  Jc as dw,
  Or as dx,
  Vr as dy,
  TO as dz,
  ow as e,
  im as e$,
  AC as e0,
  Yg as e1,
  su as e2,
  Nl as e3,
  gh as e4,
  PA as e5,
  Che as e6,
  mi as e7,
  Ak as e8,
  $T as e9,
  uh as eA,
  j0 as eB,
  Kw as eC,
  bb as eD,
  w0 as eE,
  dM as eF,
  ew as eG,
  ob as eH,
  uhe as eI,
  che as eJ,
  o_ as eK,
  i7 as eL,
  lv as eM,
  Gh as eN,
  nm as eO,
  Fc as eP,
  ps as eQ,
  Gg as eR,
  z3 as eS,
  sk as eT,
  uv as eU,
  cv as eV,
  Whe as eW,
  jhe as eX,
  Foe as eY,
  gce as eZ,
  vY as e_,
  Nr as ea,
  tC as eb,
  Sr as ec,
  O1 as ed,
  x3 as ee,
  Cu as ef,
  iC as eg,
  Kve as eh,
  q8 as ei,
  Hg as ej,
  wd as ek,
  YO as el,
  Tr as em,
  gk as en,
  _k as eo,
  pT as ep,
  fT as eq,
  kn as er,
  zd as es,
  wn as et,
  Tu as eu,
  _3 as ev,
  k3 as ew,
  li as ex,
  Iv as ey,
  n4 as ez,
  sn as f,
  h1 as f$,
  jO as f0,
  k1 as f1,
  P1 as f2,
  g3 as f3,
  zg as f4,
  T3 as f5,
  C3 as f6,
  SI as f7,
  km as f8,
  n0 as f9,
  qO as fA,
  Id as fB,
  Khe as fC,
  m2 as fD,
  NM as fE,
  Jk as fF,
  w2 as fG,
  x2 as fH,
  tme as fI,
  eme as fJ,
  qhe as fK,
  iT as fL,
  qd as fM,
  QQ as fN,
  gM as fO,
  c2 as fP,
  Eb as fQ,
  Ok as fR,
  Gie as fS,
  wT as fT,
  UZ as fU,
  uT as fV,
  VO as fW,
  HT as fX,
  m1 as fY,
  KO as fZ,
  Gve as f_,
  ahe as fa,
  Kr as fb,
  Oie as fc,
  af as fd,
  Mhe as fe,
  em as ff,
  bM as fg,
  md as fh,
  ui as fi,
  Rae as fj,
  a4 as fk,
  Ahe as fl,
  lT as fm,
  $h as fn,
  sw as fo,
  EC as fp,
  jt as fq,
  PC as fr,
  S3 as fs,
  L1 as ft,
  xh as fu,
  MT as fv,
  Bk as fw,
  Yve as fx,
  om as fy,
  f0 as fz,
  Ete as g,
  i4 as g$,
  Koe as g0,
  rhe as g1,
  Mee as g2,
  gfe as g3,
  vC as g4,
  ghe as g5,
  Zve as g6,
  Hve as g7,
  Nhe as g8,
  pC as g9,
  di as gA,
  cT as gB,
  wk as gC,
  pr as gD,
  bp as gE,
  Q4 as gF,
  D0 as gG,
  f7 as gH,
  qk as gI,
  H8 as gJ,
  bfe as gK,
  p2 as gL,
  _fe as gM,
  yfe as gN,
  Ghe as gO,
  Ar as gP,
  F1 as gQ,
  d4 as gR,
  xd as gS,
  Hc as gT,
  ci as gU,
  jve as gV,
  qve as gW,
  AO as gX,
  t4 as gY,
  r7 as gZ,
  An as g_,
  Vhe as ga,
  HZ as gb,
  Xk as gc,
  xM as gd,
  Ha as ge,
  f2 as gf,
  Hhe as gg,
  dh as gh,
  VM as gi,
  IT as gj,
  P3 as gk,
  M3 as gl,
  U1 as gm,
  ek as gn,
  pi as go,
  AI as gp,
  Ohe as gq,
  hu as gr,
  zc as gs,
  yhe as gt,
  phe as gu,
  Bhe as gv,
  Zie as gw,
  ohe as gx,
  BT as gy,
  wM as gz,
  Vie as h,
  qw as h$,
  OT as h0,
  Z3 as h1,
  jb as h2,
  Vve as h3,
  m7 as h4,
  J4 as h5,
  d1 as h6,
  _he as h7,
  Z4 as h8,
  mv as h9,
  Qve as hA,
  uU as hB,
  qoe as hC,
  aY as hD,
  SC as hE,
  RC as hF,
  Gd as hG,
  K8 as hH,
  wm as hI,
  ame as hJ,
  xfe as hK,
  kfe as hL,
  kI as hM,
  kF as hN,
  jF as hO,
  Wg as hP,
  Qk as hQ,
  zI as hR,
  BM as hS,
  IX as hT,
  p7 as hU,
  P0 as hV,
  DU as hW,
  lC as hX,
  tre as hY,
  vce as hZ,
  Wie as h_,
  sd as ha,
  zu as hb,
  u7 as hc,
  RT as hd,
  J3 as he,
  mM as hf,
  Gp as hg,
  mk as hh,
  QT as hi,
  TG as hj,
  Oee as hk,
  rh as hl,
  tee as hm,
  Gw as hn,
  nhe as ho,
  Yw as hp,
  N3 as hq,
  Yhe as hr,
  aie as hs,
  Uve as ht,
  Nz as hu,
  gp as hv,
  OB as hw,
  Fhe as hx,
  Fr as hy,
  wC as hz,
  Lae as i,
  whe as i0,
  IM as i1,
  lr as i2,
  CM as i3,
  NT as i4,
  Iae as i5,
  Jh as i6,
  Jhe as i7,
  vhe as i8,
  Dhe as i9,
  Lg as ia,
  xo as j,
  l7 as k,
  Ls as l,
  _F as m,
  ime as n,
  $H as o,
  iq as p,
  B1 as q,
  tn as r,
  ch as s,
  _n as t,
  gt as u,
  Cp as v,
  rT as w,
  g2 as x,
  Pee as y,
  ja as z
};
//# sourceMappingURL=index-ODp0LTVD.js.map
